// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/simple-line-icons/css/simple-line-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/font-awesome-old/css/font-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/material-design-iconic-font/css/materialdesignicons.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/themify-icons/css/themify-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/line-awesome/css/line-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/avasta/css/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/flaticon/flaticon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../vendor/animate/animate.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../vendor/aos/css/aos.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../vendor/perfect-scrollbar/css/perfect-scrollbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../vendor/metismenu/css/metisMenu.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%232BC155%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23F94687%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23F94687%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27><path fill=%27#343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/profile/cover.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./../images/1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/dots.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/like.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/login_bg/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/login_bg/handShake.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    Table of Contents

    Name                 : Qerza
    Author               : DexignZone
    Author Portfolio     : https://themeforest.net/user/dexignzone/portfolio
    


    Table of Sass Contents

    1. Abstracts
        _bs-custom
        _inheritance
        _maps
        _mixin
        _variable

    2. bootstrap 
        -Here goes all official bootstrap scss files

    3. Global/Base
        _color
        _custom-grid
        _fonts
        _helper
        _reset

    4. layout
        +footer
        +header
        +rtl
        +sidebar
        +tables
        +theme
        +version-dark

    5. Conponents
        +app
        +charts
        +forms
        +map
        +uc
        +ui
        +widget

    6. Page
        _index-1
        _page-error
        _page-register
        _page-signin
        _page-user-lock
        _page-user-lock

*/
/*\$primary  : #7356f1 !default;*/

.gradient_one {
  background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);
}

.gradient-1 {
  background: #f0a907;
  background: linear-gradient(to bottom, #f0a907 0%, #f53c79 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f0a907', endColorstr='#f53c79', GradientType=0);
}

.gradient-2 {
  background: #4dedf5;
  background: linear-gradient(to bottom, #4dedf5 0%, #480ceb 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#4dedf5', endColorstr='#480ceb', GradientType=0);
}

.gradient-3 {
  background: #51f5ae;
  background: linear-gradient(to bottom, #51f5ae 0%, #3fbcda 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#51f5ae', endColorstr='#3fbcda', GradientType=0);
}

.gradient-4 {
  background: #f25521;
  background: linear-gradient(to right, #f25521 0%, #f9c70a 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f25521', endColorstr='#f9c70a', GradientType=1);
}

.gradient-5 {
  background: #f53c79;
  background: linear-gradient(to right, #f53c79 0%, #f0a907 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f53c79', endColorstr='#f0a907', GradientType=1);
}

.gradient-6 {
  background: #36b9d8;
  background: linear-gradient(to right, #36b9d8 0%, #4bffa2 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#36b9d8', endColorstr='#4bffa2', GradientType=1);
}

.gradient-7 {
  background: #4400eb;
  background: linear-gradient(to right, #4400eb 0%, #44e7f5 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#4400eb', endColorstr='#44e7f5', GradientType=1);
}

.gradient-8 {
  background: #F7B00F;
  background: linear-gradient(to bottom, #F7B00F 0%, #F25521 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F7B00F', endColorstr='#F25521', GradientType=1);
}

.gradient-9,
.datepicker.datepicker-dropdown td.day:hover,
.datepicker.datepicker-dropdown th.next:hover,
.datepicker.datepicker-dropdown th.prev:hover,
.datepicker table tr td.selected,
.datepicker table tr td.active,
.datepicker table tr td.today,
.datepicker table tr td.today:hover,
.datepicker table tr td.today.disabled,
.datepicker table tr td.today.disabled:hover {
  background: #f31e7a !important;
  background: linear-gradient(to right, #f31e7a 0%, #fd712c 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f31e7a', endColorstr='#fd712c', GradientType=1);
}

.gradient-10 {
  background: #f25521 !important;
  background: linear-gradient(to top, #f25521 0%, #f9c70a 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f25521', endColorstr='#f9c70a', GradientType=1);
}

.gradient-11 {
  background: #3398fb;
  background: linear-gradient(to right, #3398fb 0%, #8553ee 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3398fb', endColorstr='#8553ee', GradientType=1);
}

.gradient-12 {
  background: #36e1b4;
  background: linear-gradient(to right, #36e1b4 0%, #11cae7 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#36e1b4', endColorstr='#11cae7', GradientType=1);
}

.gradient-13 {
  background: #ffbf31;
  background: linear-gradient(to right, #ffbf31 0%, #ff890e 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffbf31', endColorstr='#ff890e', GradientType=1);
}

.gradient-14 {
  background: #23bdb8;
  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#23bdb8', endColorstr='#43e794', GradientType=1);
}

.gradient-15 {
  background: #9a56ff;
  background: linear-gradient(135deg, #9a56ff 0%, #e36cd9 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#9a56ff', endColorstr='#e36cd9', GradientType=1);
}

.gradient-16 {
  background: #f48665;
  background: linear-gradient(135deg, #f48665 0%, #fda23f 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f48665', endColorstr='#fda23f', GradientType=1);
}

.gradient-17 {
  background: #e36cd9;
  background: linear-gradient(135deg, #e36cd9 0%, #fe60ae 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e36cd9', endColorstr='#fe60ae', GradientType=1);
}

.gradient-18 {
  background: #a15cff;
  background: linear-gradient(to right, #a15cff 0%, #ce82fd 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#a15cff', endColorstr='#ce82fd', GradientType=1);
}

/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
/*!
 * Bootstrap v4.5.3 (https://getbootstrap.com/)
 * Copyright 2011-2020 The Bootstrap Authors
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #5e72e4;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #EE3232;
  --orange: #ff9900;
  --yellow: #FFFA6F;
  --green: #297F00;
  --teal: #20c997;
  --cyan: #3065D0;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #00ADEE;
  --secondary: #3F9AE0;
  --success: #2BC155;
  --info: #2D28FF;
  --warning: #FF9B52;
  --danger: #F94687;
  --light: #F4F5F9;
  --dark: #B1B1B1;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --breakpoint-xxl: 1440;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #7e7e7e;
  text-align: left;
  background-color: #E5E6E7;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: .5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

a {
  color: #00ADEE;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: #611fb6;
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #89879f;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role="button"] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: #3d4465;
}

h1,
.h1 {
  font-size: 2.25rem;
}

h2,
.h2 {
  font-size: 1.875rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.125rem;
}

h5,
.h5 {
  font-size: 1rem;
}

h6,
.h6 {
  font-size: 0.938rem;
}

.lead {
  font-size: 1.09375rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.09375rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "\\2014\\00A0";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #E5E6E7;
  border: 1px solid #dee2e6;
  border-radius: 0.75rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}

a>code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}

kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {

  .container,
  .container-sm {
    max-width: 540px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 992px) {

  .container,
  .container-sm,
  .container-md,
  .container-lg {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {

  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1140px;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters>.col,
.no-gutters>[class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col,
.col-auto,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm,
.col-sm-auto,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md,
.col-md-auto,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg,
.col-lg-auto,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl,
.col-xl-auto,
.col-xxl-1,
.col-xxl-2,
.col-xxl-3,
.col-xxl-4,
.col-xxl-5,
.col-xxl-6,
.col-xxl-7,
.col-xxl-8,
.col-xxl-9,
.col-xxl-10,
.col-xxl-11,
.col-xxl-12,
.col-xxl,
.col-xxl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1>* {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2>* {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3>* {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4>* {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5>* {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6>* {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.3333333333%;
}

.offset-2 {
  margin-left: 16.6666666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.3333333333%;
}

.offset-5 {
  margin-left: 41.6666666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.3333333333%;
}

.offset-8 {
  margin-left: 66.6666666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.3333333333%;
}

.offset-11 {
  margin-left: 91.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-sm-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-sm-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-sm-3>* {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-sm-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-sm-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-sm-6>* {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-sm-first {
    order: -1;
  }

  .order-sm-last {
    order: 13;
  }

  .order-sm-0 {
    order: 0;
  }

  .order-sm-1 {
    order: 1;
  }

  .order-sm-2 {
    order: 2;
  }

  .order-sm-3 {
    order: 3;
  }

  .order-sm-4 {
    order: 4;
  }

  .order-sm-5 {
    order: 5;
  }

  .order-sm-6 {
    order: 6;
  }

  .order-sm-7 {
    order: 7;
  }

  .order-sm-8 {
    order: 8;
  }

  .order-sm-9 {
    order: 9;
  }

  .order-sm-10 {
    order: 10;
  }

  .order-sm-11 {
    order: 11;
  }

  .order-sm-12 {
    order: 12;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.3333333333%;
  }

  .offset-sm-2 {
    margin-left: 16.6666666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.3333333333%;
  }

  .offset-sm-5 {
    margin-left: 41.6666666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.3333333333%;
  }

  .offset-sm-8 {
    margin-left: 66.6666666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.3333333333%;
  }

  .offset-sm-11 {
    margin-left: 91.6666666667%;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-md-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-md-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-md-3>* {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-md-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-md-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-md-6>* {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-md-first {
    order: -1;
  }

  .order-md-last {
    order: 13;
  }

  .order-md-0 {
    order: 0;
  }

  .order-md-1 {
    order: 1;
  }

  .order-md-2 {
    order: 2;
  }

  .order-md-3 {
    order: 3;
  }

  .order-md-4 {
    order: 4;
  }

  .order-md-5 {
    order: 5;
  }

  .order-md-6 {
    order: 6;
  }

  .order-md-7 {
    order: 7;
  }

  .order-md-8 {
    order: 8;
  }

  .order-md-9 {
    order: 9;
  }

  .order-md-10 {
    order: 10;
  }

  .order-md-11 {
    order: 11;
  }

  .order-md-12 {
    order: 12;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.3333333333%;
  }

  .offset-md-2 {
    margin-left: 16.6666666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.3333333333%;
  }

  .offset-md-5 {
    margin-left: 41.6666666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.3333333333%;
  }

  .offset-md-8 {
    margin-left: 66.6666666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.3333333333%;
  }

  .offset-md-11 {
    margin-left: 91.6666666667%;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-lg-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-lg-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-lg-3>* {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-lg-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-lg-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-lg-6>* {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-lg-first {
    order: -1;
  }

  .order-lg-last {
    order: 13;
  }

  .order-lg-0 {
    order: 0;
  }

  .order-lg-1 {
    order: 1;
  }

  .order-lg-2 {
    order: 2;
  }

  .order-lg-3 {
    order: 3;
  }

  .order-lg-4 {
    order: 4;
  }

  .order-lg-5 {
    order: 5;
  }

  .order-lg-6 {
    order: 6;
  }

  .order-lg-7 {
    order: 7;
  }

  .order-lg-8 {
    order: 8;
  }

  .order-lg-9 {
    order: 9;
  }

  .order-lg-10 {
    order: 10;
  }

  .order-lg-11 {
    order: 11;
  }

  .order-lg-12 {
    order: 12;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.3333333333%;
  }

  .offset-lg-2 {
    margin-left: 16.6666666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.3333333333%;
  }

  .offset-lg-5 {
    margin-left: 41.6666666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.3333333333%;
  }

  .offset-lg-8 {
    margin-left: 66.6666666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.3333333333%;
  }

  .offset-lg-11 {
    margin-left: 91.6666666667%;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-xl-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-xl-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-xl-3>* {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-xl-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-xl-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-xl-6>* {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xl-first {
    order: -1;
  }

  .order-xl-last {
    order: 13;
  }

  .order-xl-0 {
    order: 0;
  }

  .order-xl-1 {
    order: 1;
  }

  .order-xl-2 {
    order: 2;
  }

  .order-xl-3 {
    order: 3;
  }

  .order-xl-4 {
    order: 4;
  }

  .order-xl-5 {
    order: 5;
  }

  .order-xl-6 {
    order: 6;
  }

  .order-xl-7 {
    order: 7;
  }

  .order-xl-8 {
    order: 8;
  }

  .order-xl-9 {
    order: 9;
  }

  .order-xl-10 {
    order: 10;
  }

  .order-xl-11 {
    order: 11;
  }

  .order-xl-12 {
    order: 12;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.3333333333%;
  }

  .offset-xl-2 {
    margin-left: 16.6666666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.3333333333%;
  }

  .offset-xl-5 {
    margin-left: 41.6666666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.3333333333%;
  }

  .offset-xl-8 {
    margin-left: 66.6666666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.3333333333%;
  }

  .offset-xl-11 {
    margin-left: 91.6666666667%;
  }
}

@media (min-width: 1440) {
  .col-xxl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-xxl-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-xxl-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-xxl-3>* {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-xxl-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-xxl-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-xxl-6>* {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xxl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-xxl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-xxl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-xxl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-xxl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-xxl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-xxl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-xxl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-xxl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xxl-first {
    order: -1;
  }

  .order-xxl-last {
    order: 13;
  }

  .order-xxl-0 {
    order: 0;
  }

  .order-xxl-1 {
    order: 1;
  }

  .order-xxl-2 {
    order: 2;
  }

  .order-xxl-3 {
    order: 3;
  }

  .order-xxl-4 {
    order: 4;
  }

  .order-xxl-5 {
    order: 5;
  }

  .order-xxl-6 {
    order: 6;
  }

  .order-xxl-7 {
    order: 7;
  }

  .order-xxl-8 {
    order: 8;
  }

  .order-xxl-9 {
    order: 9;
  }

  .order-xxl-10 {
    order: 10;
  }

  .order-xxl-11 {
    order: 11;
  }

  .order-xxl-12 {
    order: 12;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.3333333333%;
  }

  .offset-xxl-2 {
    margin-left: 16.6666666667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.3333333333%;
  }

  .offset-xxl-5 {
    margin-left: 41.6666666667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.3333333333%;
  }

  .offset-xxl-8 {
    margin-left: 66.6666666667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.3333333333%;
  }

  .offset-xxl-11 {
    margin-left: 91.6666666667%;
  }
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #7e7e7e;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #EEEEEE;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #EEEEEE;
}

.table tbody+tbody {
  border-top: 2px solid #EEEEEE;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #EEEEEE;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #EEEEEE;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody+tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #7e7e7e;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary>th,
.table-primary>td {
  background-color: #ddcaf6;
}

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody+tbody {
  border-color: #c19dee;
}

.table-hover .table-primary:hover {
  background-color: #cfb4f2;
}

.table-hover .table-primary:hover>td,
.table-hover .table-primary:hover>th {
  background-color: #cfb4f2;
}

.table-secondary,
.table-secondary>th,
.table-secondary>td {
  background-color: #c9e3f6;
}

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody+tbody {
  border-color: #9bcaef;
}

.table-hover .table-secondary:hover {
  background-color: #b3d8f2;
}

.table-hover .table-secondary:hover>td,
.table-hover .table-secondary:hover>th {
  background-color: #b3d8f2;
}

.table-success,
.table-success>th,
.table-success>td {
  background-color: #c4eecf;
}

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody+tbody {
  border-color: #91dfa7;
}

.table-hover .table-success:hover {
  background-color: #b0e8bf;
}

.table-hover .table-success:hover>td,
.table-hover .table-success:hover>th {
  background-color: #b0e8bf;
}

.table-info,
.table-info>th,
.table-info>td {
  background-color: #c4c3ff;
}

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody+tbody {
  border-color: #928fff;
}

.table-hover .table-info:hover {
  background-color: #abaaff;
}

.table-hover .table-info:hover>td,
.table-hover .table-info:hover>th {
  background-color: #abaaff;
}

.table-warning,
.table-warning>th,
.table-warning>td {
  background-color: #ffe3cf;
}

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody+tbody {
  border-color: #ffcba5;
}

.table-hover .table-warning:hover {
  background-color: #ffd4b6;
}

.table-hover .table-warning:hover>td,
.table-hover .table-warning:hover>th {
  background-color: #ffd4b6;
}

.table-danger,
.table-danger>th,
.table-danger>td {
  background-color: #fdcbdd;
}

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody+tbody {
  border-color: #fc9fc1;
}

.table-hover .table-danger:hover {
  background-color: #fcb2cd;
}

.table-hover .table-danger:hover>td,
.table-hover .table-danger:hover>th {
  background-color: #fcb2cd;
}

.table-light,
.table-light>th,
.table-light>td {
  background-color: #fcfcfd;
}

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody+tbody {
  border-color: #f9fafc;
}

.table-hover .table-light:hover {
  background-color: #ededf3;
}

.table-hover .table-light:hover>td,
.table-hover .table-light:hover>th {
  background-color: #ededf3;
}

.table-dark,
.table-dark>th,
.table-dark>td {
  background-color: #e9e9e9;
}

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody+tbody {
  border-color: #d6d6d6;
}

.table-hover .table-dark:hover {
  background-color: gainsboro;
}

.table-hover .table-dark:hover>td,
.table-hover .table-dark:hover>th {
  background-color: gainsboro;
}

.table-active,
.table-active>th,
.table-active>td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover>td,
.table-hover .table-active:hover>th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #EEEEEE;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}

.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #454d55;
}

.table-dark.table-bordered {
  border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-sm>.table-bordered {
    border: 0;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-md>.table-bordered {
    border: 0;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-lg>.table-bordered {
    border: 0;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xl>.table-bordered {
    border: 0;
  }
}

@media (max-width: 1439.98) {
  .table-responsive-xxl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xxl>.table-bordered {
    border: 0;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive>.table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #f0f1f5;
  border-radius: 0.75rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.rpt-container {
  width: 0px !important;
  overflow: hidden !important;
}

.hover-toltip:hover .rpt-container {
  width: auto !important;
  overflow: visible !important;
}

.rpt-hover>span {
  padding: 8px 14px !important;
  font-size: 12px !important;
}

.rpt-arrow {
  margin-top: -70%;
}

.rpt-textbox-container {
  max-width: 87px !important;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #cdb0f2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  appearance: none;
}

select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.09375rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.765625rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #7e7e7e;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size],
select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row>.col,
.form-row>[class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
  color: #89879f;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #2BC155;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(43, 193, 85, 0.9);
  border-radius: 0.75rem;
}

.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip,
.is-valid~.valid-feedback,
.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: #2BC155;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: #2BC155;
  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #2BC155;
  padding-right: calc(0.75em + 2.3125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #2BC155;
  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label {
  color: #2BC155;
}

.was-validated .form-check-input:valid~.valid-feedback,
.was-validated .form-check-input:valid~.valid-tooltip,
.form-check-input.is-valid~.valid-feedback,
.form-check-input.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid~.custom-control-label,
.custom-control-input.is-valid~.custom-control-label {
  color: #2BC155;
}

.was-validated .custom-control-input:valid~.custom-control-label::before,
.custom-control-input.is-valid~.custom-control-label::before {
  border-color: #2BC155;
}

.was-validated .custom-control-input:valid:checked~.custom-control-label::before,
.custom-control-input.is-valid:checked~.custom-control-label::before {
  border-color: #49d670;
  background-color: #49d670;
}

.was-validated .custom-control-input:valid:focus~.custom-control-label::before,
.custom-control-input.is-valid:focus~.custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);
}

.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before,
.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before {
  border-color: #2BC155;
}

.was-validated .custom-file-input:valid~.custom-file-label,
.custom-file-input.is-valid~.custom-file-label {
  border-color: #2BC155;
}

.was-validated .custom-file-input:valid:focus~.custom-file-label,
.custom-file-input.is-valid:focus~.custom-file-label {
  border-color: #2BC155;
  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #F94687;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(249, 70, 135, 0.9);
  border-radius: 0.75rem;
}

.was-validated :invalid~.invalid-feedback,
.was-validated :invalid~.invalid-tooltip,
.is-invalid~.invalid-feedback,
.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #F94687;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: #F94687;
  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #F94687;
  padding-right: calc(0.75em + 2.3125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #F94687;
  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);
}

.was-validated .form-check-input:invalid~.form-check-label,
.form-check-input.is-invalid~.form-check-label {
  color: #F94687;
}

.was-validated .form-check-input:invalid~.invalid-feedback,
.was-validated .form-check-input:invalid~.invalid-tooltip,
.form-check-input.is-invalid~.invalid-feedback,
.form-check-input.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid~.custom-control-label,
.custom-control-input.is-invalid~.custom-control-label {
  color: #F94687;
}

.was-validated .custom-control-input:invalid~.custom-control-label::before,
.custom-control-input.is-invalid~.custom-control-label::before {
  border-color: #F94687;
}

.was-validated .custom-control-input:invalid:checked~.custom-control-label::before,
.custom-control-input.is-invalid:checked~.custom-control-label::before {
  border-color: #fb77a7;
  background-color: #fb77a7;
}

.was-validated .custom-control-input:invalid:focus~.custom-control-label::before,
.custom-control-input.is-invalid:focus~.custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);
}

.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before,
.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before {
  border-color: #F94687;
}

.was-validated .custom-file-input:invalid~.custom-file-label,
.custom-file-input.is-invalid~.custom-file-label {
  border-color: #F94687;
}

.was-validated .custom-file-input:invalid:focus~.custom-file-label,
.custom-file-input.is-invalid:focus~.custom-file-label {
  border-color: #F94687;
  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.form-inline .form-check {
  width: 100%;
}

@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }

  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }

  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }

  .form-inline .form-control-plaintext {
    display: inline-block;
  }

  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }

  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }

  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }

  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }

  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #7e7e7e;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.5rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: #7e7e7e;
  text-decoration: none;
}

.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.btn.disabled,
.btn:disabled {
  opacity: 0.65;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #3C4B67;
  border-color: #3C4B67;
}

.btn-primary:hover {
  color: #fff;
  background-color: #3C4B67;
  border-color: #3C4B67;
}

.btn-primary:focus,
.btn-primary.focus {
  color: #fff;
  background-color: #3C4B67;
  border-color: #3C4B67;
  box-shadow: 0 0 0 0.2rem rgba(153, 95, 228, 0.5);
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #00ADEE;
  border-color: #00ADEE;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #3C4B67;
  border-color: #3C4B67;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 95, 228, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #3F9AE0;
  border-color: #3F9AE0;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #2388d6;
  border-color: #2181cb;
}

.btn-secondary:focus,
.btn-secondary.focus {
  color: #fff;
  background-color: #2388d6;
  border-color: #2181cb;
  box-shadow: 0 0 0 0.2rem rgba(92, 169, 229, 0.5);
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff;
  background-color: #3F9AE0;
  border-color: #3F9AE0;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show>.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #2181cb;
  border-color: #1f7ac0;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show>.btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(92, 169, 229, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #2BC155;
  border-color: #2BC155;
}

.btn-success:hover {
  color: #fff;
  background-color: #24a247;
  border-color: #229743;
}

.btn-success:focus,
.btn-success.focus {
  color: #fff;
  background-color: #24a247;
  border-color: #229743;
  box-shadow: 0 0 0 0.2rem rgba(75, 202, 111, 0.5);
}

.btn-success.disabled,
.btn-success:disabled {
  color: #fff;
  background-color: #2BC155;
  border-color: #2BC155;
}

.btn-success:not(:disabled):not(.disabled):active,
.btn-success:not(:disabled):not(.disabled).active,
.show>.btn-success.dropdown-toggle {
  color: #fff;
  background-color: #229743;
  border-color: #1f8d3e;
}

.btn-success:not(:disabled):not(.disabled):active:focus,
.btn-success:not(:disabled):not(.disabled).active:focus,
.show>.btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(75, 202, 111, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #2D28FF;
  border-color: #2D28FF;
}

.btn-info:hover {
  color: #fff;
  background-color: #0802ff;
  border-color: #0600f4;
}

.btn-info:focus,
.btn-info.focus {
  color: #fff;
  background-color: #0802ff;
  border-color: #0600f4;
  box-shadow: 0 0 0 0.2rem rgba(77, 72, 255, 0.5);
}

.btn-info.disabled,
.btn-info:disabled {
  color: #fff;
  background-color: #2D28FF;
  border-color: #2D28FF;
}

.btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show>.btn-info.dropdown-toggle {
  color: #fff;
  background-color: #0600f4;
  border-color: #0500e7;
}

.btn-info:not(:disabled):not(.disabled):active:focus,
.btn-info:not(:disabled):not(.disabled).active:focus,
.show>.btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(77, 72, 255, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #FF9B52;
  border-color: #FF9B52;
}

.btn-warning:hover {
  color: #212529;
  background-color: #ff852c;
  border-color: #ff7e1f;
}

.btn-warning:focus,
.btn-warning.focus {
  color: #212529;
  background-color: #ff852c;
  border-color: #ff7e1f;
  box-shadow: 0 0 0 0.2rem rgba(222, 137, 76, 0.5);
}

.btn-warning.disabled,
.btn-warning:disabled {
  color: #212529;
  background-color: #FF9B52;
  border-color: #FF9B52;
}

.btn-warning:not(:disabled):not(.disabled):active,
.btn-warning:not(:disabled):not(.disabled).active,
.show>.btn-warning.dropdown-toggle {
  color: #212529;
  background-color: #ff7e1f;
  border-color: #ff7612;
}

.btn-warning:not(:disabled):not(.disabled):active:focus,
.btn-warning:not(:disabled):not(.disabled).active:focus,
.show>.btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 137, 76, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #F94687;
  border-color: #F94687;
}

.btn-danger:hover {
  color: #fff;
  background-color: #f8216f;
  border-color: #f71567;
}

.btn-danger:focus,
.btn-danger.focus {
  color: #fff;
  background-color: #f8216f;
  border-color: #f71567;
  box-shadow: 0 0 0 0.2rem rgba(250, 98, 153, 0.5);
}

.btn-danger.disabled,
.btn-danger:disabled {
  color: #fff;
  background-color: #F94687;
  border-color: #F94687;
}

.btn-danger:not(:disabled):not(.disabled):active,
.btn-danger:not(:disabled):not(.disabled).active,
.show>.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #f71567;
  border-color: #f7085f;
}

.btn-danger:not(:disabled):not(.disabled):active:focus,
.btn-danger:not(:disabled):not(.disabled).active:focus,
.show>.btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(250, 98, 153, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #F4F5F9;
  border-color: #F4F5F9;
}

.btn-light:hover {
  color: #212529;
  background-color: #dbdfec;
  border-color: #d3d7e7;
}

.btn-light:focus,
.btn-light.focus {
  color: #212529;
  background-color: #dbdfec;
  border-color: #d3d7e7;
  box-shadow: 0 0 0 0.2rem rgba(212, 214, 218, 0.5);
}

.btn-light.disabled,
.btn-light:disabled {
  color: #212529;
  background-color: #F4F5F9;
  border-color: #F4F5F9;
}

.btn-light:not(:disabled):not(.disabled):active,
.btn-light:not(:disabled):not(.disabled).active,
.show>.btn-light.dropdown-toggle {
  color: #212529;
  background-color: #d3d7e7;
  border-color: #cbd0e3;
}

.btn-light:not(:disabled):not(.disabled):active:focus,
.btn-light:not(:disabled):not(.disabled).active:focus,
.show>.btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(212, 214, 218, 0.5);
}

.btn-dark {
  color: #212529;
  background-color: #B1B1B1;
  border-color: #B1B1B1;
}

.btn-dark:hover {
  color: #212529;
  background-color: #9e9e9e;
  border-color: #989898;
}

.btn-dark:focus,
.btn-dark.focus {
  color: #212529;
  background-color: #9e9e9e;
  border-color: #989898;
  box-shadow: 0 0 0 0.2rem rgba(155, 156, 157, 0.5);
}

.btn-dark.disabled,
.btn-dark:disabled {
  color: #212529;
  background-color: #B1B1B1;
  border-color: #B1B1B1;
}

.btn-dark:not(:disabled):not(.disabled):active,
.btn-dark:not(:disabled):not(.disabled).active,
.show>.btn-dark.dropdown-toggle {
  color: #212529;
  background-color: #989898;
  border-color: #919191;
}

.btn-dark:not(:disabled):not(.disabled):active:focus,
.btn-dark:not(:disabled):not(.disabled).active:focus,
.show>.btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(155, 156, 157, 0.5);
}

.btn-outline-primary {
  color: #00ADEE;
  border-color: #00ADEE;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #00ADEE;
  border-color: #00ADEE;
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.5);
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #00ADEE;
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show>.btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #00ADEE;
  border-color: #00ADEE;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.5);
}

.btn-outline-secondary {
  color: #3F9AE0;
  border-color: #3F9AE0;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #3F9AE0;
  border-color: #3F9AE0;
}

.btn-outline-secondary:focus,
.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(63, 154, 224, 0.5);
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
  color: #3F9AE0;
  background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #3F9AE0;
  border-color: #3F9AE0;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(63, 154, 224, 0.5);
}

.btn-outline-success {
  color: #2BC155;
  border-color: #2BC155;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #2BC155;
  border-color: #2BC155;
}

.btn-outline-success:focus,
.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.5);
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: #2BC155;
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled):active,
.btn-outline-success:not(:disabled):not(.disabled).active,
.show>.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #2BC155;
  border-color: #2BC155;
}

.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.5);
}

.btn-outline-info {
  color: #2D28FF;
  border-color: #2D28FF;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #2D28FF;
  border-color: #2D28FF;
}

.btn-outline-info:focus,
.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(45, 40, 255, 0.5);
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
  color: #2D28FF;
  background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled):active,
.btn-outline-info:not(:disabled):not(.disabled).active,
.show>.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #2D28FF;
  border-color: #2D28FF;
}

.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(45, 40, 255, 0.5);
}

.btn-outline-warning {
  color: #FF9B52;
  border-color: #FF9B52;
}

.btn-outline-warning:hover {
  color: #212529;
  background-color: #FF9B52;
  border-color: #FF9B52;
}

.btn-outline-warning:focus,
.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 155, 82, 0.5);
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  color: #FF9B52;
  background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled):active,
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show>.btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #FF9B52;
  border-color: #FF9B52;
}

.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 155, 82, 0.5);
}

.btn-outline-danger {
  color: #F94687;
  border-color: #F94687;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #F94687;
  border-color: #F94687;
}

.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.5);
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  color: #F94687;
  background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled):active,
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show>.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #F94687;
  border-color: #F94687;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.5);
}

.btn-outline-light {
  color: #F4F5F9;
  border-color: #F4F5F9;
}

.btn-outline-light:hover {
  color: #212529;
  background-color: #F4F5F9;
  border-color: #F4F5F9;
}

.btn-outline-light:focus,
.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 245, 249, 0.5);
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #F4F5F9;
  background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show>.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #F4F5F9;
  border-color: #F4F5F9;
}

.btn-outline-light:not(:disabled):not(.disabled):active:focus,
.btn-outline-light:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 245, 249, 0.5);
}

.btn-outline-dark {
  color: #B1B1B1;
  border-color: #B1B1B1;
}

.btn-outline-dark:hover {
  color: #212529;
  background-color: #B1B1B1;
  border-color: #B1B1B1;
}

.btn-outline-dark:focus,
.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(177, 177, 177, 0.5);
}

.btn-outline-dark.disabled,
.btn-outline-dark:disabled {
  color: #B1B1B1;
  background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled):active,
.btn-outline-dark:not(:disabled):not(.disabled).active,
.show>.btn-outline-dark.dropdown-toggle {
  color: #212529;
  background-color: #B1B1B1;
  border-color: #B1B1B1;
}

.btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(177, 177, 177, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #00ADEE;
  text-decoration: none;
}

.btn-link:hover {
  color: #611fb6;
  text-decoration: underline;
}

.btn-link:focus,
.btn-link.focus {
  text-decoration: underline;
}

.btn-link:disabled,
.btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg,
.btn-group-lg>.btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm,
.btn-group-sm>.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-block+.btn-block {
  margin-top: 0.5rem;
}

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #7e7e7e;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.75rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1440) {
  .dropdown-menu-xxl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-right {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropleft .dropdown-toggle::after {
  display: none;
}

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^="top"],
.dropdown-menu[x-placement^="right"],
.dropdown-menu[x-placement^="bottom"],
.dropdown-menu[x-placement^="left"] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f8f9fa;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #00ADEE;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.765625rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group>.btn,
.btn-group-vertical>.btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group>.btn:hover,
.btn-group-vertical>.btn:hover {
  z-index: 1;
}

.btn-group>.btn:focus,
.btn-group>.btn:active,
.btn-group>.btn.active,
.btn-group-vertical>.btn:focus,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group>.btn:not(:first-child),
.btn-group>.btn-group:not(:first-child) {
  margin-left: -1px;
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn-group:not(:last-child)>.btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group>.btn:not(:first-child),
.btn-group>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm+.dropdown-toggle-split,
.btn-group-sm>.btn+.dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg+.dropdown-toggle-split,
.btn-group-lg>.btn+.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
  width: 100%;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical>.btn-group:not(:last-child)>.btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle>.btn,
.btn-group-toggle>.btn-group>.btn {
  margin-bottom: 0;
}

.btn-group-toggle>.btn input[type="radio"],
.btn-group-toggle>.btn input[type="checkbox"],
.btn-group-toggle>.btn-group>.btn input[type="radio"],
.btn-group-toggle>.btn-group>.btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group>.form-control,
.input-group>.form-control-plaintext,
.input-group>.custom-select,
.input-group>.custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}

.input-group>.form-control+.form-control,
.input-group>.form-control+.custom-select,
.input-group>.form-control+.custom-file,
.input-group>.form-control-plaintext+.form-control,
.input-group>.form-control-plaintext+.custom-select,
.input-group>.form-control-plaintext+.custom-file,
.input-group>.custom-select+.form-control,
.input-group>.custom-select+.custom-select,
.input-group>.custom-select+.custom-file,
.input-group>.custom-file+.form-control,
.input-group>.custom-file+.custom-select,
.input-group>.custom-file+.custom-file {
  margin-left: -1px;
}

.input-group>.form-control:focus,
.input-group>.custom-select:focus,
.input-group>.custom-file .custom-file-input:focus~.custom-file-label {
  z-index: 3;
}

.input-group>.custom-file .custom-file-input:focus {
  z-index: 4;
}

.input-group>.form-control:not(:last-child),
.input-group>.custom-select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group>.form-control:not(:first-child),
.input-group>.custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group>.custom-file {
  display: flex;
  align-items: center;
}

.input-group>.custom-file:not(:last-child) .custom-file-label,
.input-group>.custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group>.custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
  max-height: 45px;
}

.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}

.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}

.input-group-prepend .btn+.btn,
.input-group-prepend .btn+.input-group-text,
.input-group-prepend .input-group-text+.input-group-text,
.input-group-prepend .input-group-text+.btn,
.input-group-append .btn+.btn,
.input-group-append .btn+.input-group-text,
.input-group-append .input-group-text+.input-group-text,
.input-group-append .input-group-text+.btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #f0f1f5;
  border-radius: 0.5rem;
}

.input-group-text input[type="radio"],
.input-group-text input[type="checkbox"] {
  margin-top: 0;
}

.input-group-lg>.form-control:not(textarea),
.input-group-lg>.custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg>.form-control,
.input-group-lg>.custom-select,
.input-group-lg>.input-group-prepend>.input-group-text,
.input-group-lg>.input-group-append>.input-group-text,
.input-group-lg>.input-group-prepend>.btn,
.input-group-lg>.input-group-append>.btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm>.form-control:not(textarea),
.input-group-sm>.custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm>.form-control,
.input-group-sm>.custom-select,
.input-group-sm>.input-group-prepend>.input-group-text,
.input-group-sm>.input-group-append>.input-group-text,
.input-group-sm>.input-group-prepend>.btn,
.input-group-sm>.input-group-append>.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg>.custom-select,
.input-group-sm>.custom-select {
  padding-right: 1.75rem;
}

.input-group>.input-group-prepend>.btn,
.input-group>.input-group-prepend>.input-group-text,
.input-group>.input-group-append:not(:last-child)>.btn,
.input-group>.input-group-append:not(:last-child)>.input-group-text,
.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append:last-child>.input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group>.input-group-append>.btn,
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
          color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.15625rem;
  opacity: 0;
}

.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border-color: #00ADEE;
  background-color: #00ADEE;
}

.custom-control-input:focus~.custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.custom-control-input:focus:not(:checked)~.custom-control-label::before {
  border-color: #cdb0f2;
}

.custom-control-input:not(:disabled):active~.custom-control-label::before {
  color: #fff;
  background-color: #e8dcf9;
  border-color: #e8dcf9;
}

.custom-control-input[disabled]~.custom-control-label,
.custom-control-input:disabled~.custom-control-label {
  color: #6c757d;
}

.custom-control-input[disabled]~.custom-control-label::before,
.custom-control-input:disabled~.custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.custom-control-label::before {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}

.custom-control-label::after {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50% / 50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.75rem;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
  border-color: #00ADEE;
  background-color: #00ADEE;
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: rgba(135, 67, 223, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {
  background-color: rgba(135, 67, 223, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: rgba(135, 67, 223, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}

.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
  top: calc(0.15625rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}

.custom-switch .custom-control-input:checked~.custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}

.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: rgba(135, 67, 223, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #f0f1f5;
  border-radius: 0.75rem;
  appearance: none;
}

.custom-select:focus {
  border-color: #cdb0f2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}

.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}

.custom-select::-ms-expand {
  display: none;
}

.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.765625rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.09375rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0;
}

.custom-file-input:focus~.custom-file-label {
  border-color: #cdb0f2;
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.custom-file-input[disabled]~.custom-file-label,
.custom-file-input:disabled~.custom-file-label {
  background-color: #e9ecef;
}

.custom-file-input:lang(en)~.custom-file-label::after {
  content: "Browse";
}

.custom-file-input~.custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #f0f1f5;
  border-radius: 0.75rem;
}

.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.75rem 0.75rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.custom-range:focus {
  outline: none;
}

.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #E5E6E7, 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #E5E6E7, 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #E5E6E7, 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.custom-range::-moz-focus-outer {
  border: 0;
}

.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #00ADEE;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.custom-range::-webkit-slider-thumb:active {
  background-color: #e8dcf9;
}

.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #00ADEE;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.custom-range::-moz-range-thumb:active {
  background-color: #e8dcf9;
}

.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #00ADEE;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}

.custom-range::-ms-thumb:active {
  background-color: #e8dcf9;
}

.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}

.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}

.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-moz-range-track {
  cursor: default;
}

.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {

  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.nav-link:hover,
.nav-link:focus {
  text-decoration: none;
}

.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #E5E6E7;
  border-color: #dee2e6 #dee2e6 #E5E6E7;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.75rem;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff;
  background-color: #00ADEE;
}

.nav-fill>.nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content>.tab-pane {
  display: none;
}

.tab-content>.active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3359375rem;
  padding-bottom: 0.3359375rem;
  margin-right: 1rem;
  font-size: 1.09375rem;
  line-height: inherit;
  white-space: nowrap;
}

.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.09375rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.75rem;
}

.navbar-toggler:hover,
.navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {

  .navbar-expand-sm>.container,
  .navbar-expand-sm>.container-fluid,
  .navbar-expand-sm>.container-sm,
  .navbar-expand-sm>.container-md,
  .navbar-expand-sm>.container-lg,
  .navbar-expand-sm>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-sm>.container,
  .navbar-expand-sm>.container-fluid,
  .navbar-expand-sm>.container-sm,
  .navbar-expand-sm>.container-md,
  .navbar-expand-sm>.container-lg,
  .navbar-expand-sm>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}

@media (max-width: 767.98px) {

  .navbar-expand-md>.container,
  .navbar-expand-md>.container-fluid,
  .navbar-expand-md>.container-sm,
  .navbar-expand-md>.container-md,
  .navbar-expand-md>.container-lg,
  .navbar-expand-md>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-md>.container,
  .navbar-expand-md>.container-fluid,
  .navbar-expand-md>.container-sm,
  .navbar-expand-md>.container-md,
  .navbar-expand-md>.container-lg,
  .navbar-expand-md>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}

@media (max-width: 991.98px) {

  .navbar-expand-lg>.container,
  .navbar-expand-lg>.container-fluid,
  .navbar-expand-lg>.container-sm,
  .navbar-expand-lg>.container-md,
  .navbar-expand-lg>.container-lg,
  .navbar-expand-lg>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-lg>.container,
  .navbar-expand-lg>.container-fluid,
  .navbar-expand-lg>.container-sm,
  .navbar-expand-lg>.container-md,
  .navbar-expand-lg>.container-lg,
  .navbar-expand-lg>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1199.98px) {

  .navbar-expand-xl>.container,
  .navbar-expand-xl>.container-fluid,
  .navbar-expand-xl>.container-sm,
  .navbar-expand-xl>.container-md,
  .navbar-expand-xl>.container-lg,
  .navbar-expand-xl>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xl>.container,
  .navbar-expand-xl>.container-fluid,
  .navbar-expand-xl>.container-sm,
  .navbar-expand-xl>.container-md,
  .navbar-expand-xl>.container-lg,
  .navbar-expand-xl>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1439.98) {

  .navbar-expand-xxl>.container,
  .navbar-expand-xxl>.container-fluid,
  .navbar-expand-xxl>.container-sm,
  .navbar-expand-xxl>.container-md,
  .navbar-expand-xxl>.container-lg,
  .navbar-expand-xxl>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1440) {
  .navbar-expand-xxl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xxl>.container,
  .navbar-expand-xxl>.container-fluid,
  .navbar-expand-xxl>.container-sm,
  .navbar-expand-xxl>.container-md,
  .navbar-expand-xxl>.container-lg,
  .navbar-expand-xxl>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
}

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.navbar-expand>.container,
.navbar-expand>.container-fluid,
.navbar-expand>.container-sm,
.navbar-expand>.container-md,
.navbar-expand>.container-lg,
.navbar-expand>.container-xl {
  padding-right: 0;
  padding-left: 0;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand>.container,
.navbar-expand>.container-fluid,
.navbar-expand>.container-sm,
.navbar-expand>.container-md,
.navbar-expand>.container-lg,
.navbar-expand>.container-xl {
  flex-wrap: nowrap;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show>.nav-link,
.navbar-light .navbar-nav .active>.nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show>.nav-link,
.navbar-dark .navbar-nav .active>.nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-text a {
  color: #fff;
}

.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.75rem;
}

.card>hr {
  margin-right: 0;
  margin-left: 0;
}

.card>.list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card>.list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.75rem - 1px);
  border-top-right-radius: calc(0.75rem - 1px);
}

.card>.list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.75rem - 1px);
  border-bottom-left-radius: calc(0.75rem - 1px);
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link+.card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header:first-child {
  border-radius: calc(0.75rem - 1px) calc(0.75rem - 1px) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.75rem - 1px) calc(0.75rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.75rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.75rem - 1px);
  border-top-right-radius: calc(0.75rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.75rem - 1px);
  border-bottom-left-radius: calc(0.75rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group>.card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }

  .card-group>.card {
    flex: 1 0;
    margin-bottom: 0;
  }

  .card-group>.card+.card {
    margin-left: 0;
    border-left: 0;
  }

  .card-group>.card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-top,
  .card-group>.card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-bottom,
  .card-group>.card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-top,
  .card-group>.card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-bottom,
  .card-group>.card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }

  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}

.accordion>.card {
  overflow: hidden;
}

.accordion>.card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion>.card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion>.card>.card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.75rem;
}

.breadcrumb-item {
  display: flex;
}

.breadcrumb-item+.breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item+.breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}

.breadcrumb-item+.breadcrumb-item:hover::before {
  text-decoration: underline;
}

.breadcrumb-item+.breadcrumb-item:hover::before {
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.75rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #00ADEE;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-link:hover {
  z-index: 2;
  color: #611fb6;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #00ADEE;
  border-color: #00ADEE;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.09375rem;
  line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.75rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}

a.badge:hover,
a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #00ADEE;
}

a.badge-primary:hover,
a.badge-primary:focus {
  color: #fff;
  background-color: #6d23cc;
}

a.badge-primary:focus,
a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #3F9AE0;
}

a.badge-secondary:hover,
a.badge-secondary:focus {
  color: #fff;
  background-color: #2181cb;
}

a.badge-secondary:focus,
a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(63, 154, 224, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #2BC155;
}

a.badge-success:hover,
a.badge-success:focus {
  color: #fff;
  background-color: #229743;
}

a.badge-success:focus,
a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #2D28FF;
}

a.badge-info:hover,
a.badge-info:focus {
  color: #fff;
  background-color: #0600f4;
}

a.badge-info:focus,
a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(45, 40, 255, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #FF9B52;
}

a.badge-warning:hover,
a.badge-warning:focus {
  color: #212529;
  background-color: #ff7e1f;
}

a.badge-warning:focus,
a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 155, 82, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #F94687;
}

a.badge-danger:hover,
a.badge-danger:focus {
  color: #fff;
  background-color: #f71567;
}

a.badge-danger:focus,
a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #F4F5F9;
}

a.badge-light:hover,
a.badge-light:focus {
  color: #212529;
  background-color: #d3d7e7;
}

a.badge-light:focus,
a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(244, 245, 249, 0.5);
}

.badge-dark {
  color: #212529;
  background-color: #B1B1B1;
}

a.badge-dark:hover,
a.badge-dark:focus {
  color: #212529;
  background-color: #989898;
}

a.badge-dark:focus,
a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(177, 177, 177, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}

@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.75rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3.8125rem;
}

.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #462374;
  background-color: #e7d9f9;
  border-color: #ddcaf6;
}

.alert-primary hr {
  border-top-color: #cfb4f2;
}

.alert-primary .alert-link {
  color: #2e174d;
}

.alert-secondary {
  color: #215074;
  background-color: #d9ebf9;
  border-color: #c9e3f6;
}

.alert-secondary hr {
  border-top-color: #b3d8f2;
}

.alert-secondary .alert-link {
  color: #16354c;
}

.alert-success {
  color: #16642c;
  background-color: #d5f3dd;
  border-color: #c4eecf;
}

.alert-success hr {
  border-top-color: #b0e8bf;
}

.alert-success .alert-link {
  color: #0d3a1a;
}

.alert-info {
  color: #171585;
  background-color: #d5d4ff;
  border-color: #c4c3ff;
}

.alert-info hr {
  border-top-color: #abaaff;
}

.alert-info .alert-link {
  color: #0f0e59;
}

.alert-warning {
  color: #85512b;
  background-color: #ffebdc;
  border-color: #ffe3cf;
}

.alert-warning hr {
  border-top-color: #ffd4b6;
}

.alert-warning .alert-link {
  color: #5e3a1f;
}

.alert-danger {
  color: #812446;
  background-color: #fedae7;
  border-color: #fdcbdd;
}

.alert-danger hr {
  border-top-color: #fcb2cd;
}

.alert-danger .alert-link {
  color: #591930;
}

.alert-light {
  color: #7f7f81;
  background-color: #fdfdfe;
  border-color: #fcfcfd;
}

.alert-light hr {
  border-top-color: #ededf3;
}

.alert-light .alert-link {
  color: #666667;
}

.alert-dark {
  color: #5c5c5c;
  background-color: #efefef;
  border-color: #e9e9e9;
}

.alert-dark hr {
  border-top-color: gainsboro;
}

.alert-dark .alert-link {
  color: #434343;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }

  to {
    background-position: 0 0;
  }
}

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.65625rem;
  background-color: #e9ecef;
  border-radius: 0.75rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #00ADEE;
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.75rem;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}

.list-group-item-action:active {
  color: #7e7e7e;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #00ADEE;
  border-color: #00ADEE;
}

.list-group-item+.list-group-item {
  border-top-width: 0;
}

.list-group-item+.list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal>.list-group-item:first-child {
  border-bottom-left-radius: 0.75rem;
  border-top-right-radius: 0;
}

.list-group-horizontal>.list-group-item:last-child {
  border-top-right-radius: 0.75rem;
  border-bottom-left-radius: 0;
}

.list-group-horizontal>.list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  .list-group-horizontal-sm>.list-group-item:first-child {
    border-bottom-left-radius: 0.75rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item:last-child {
    border-top-right-radius: 0.75rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  .list-group-horizontal-md>.list-group-item:first-child {
    border-bottom-left-radius: 0.75rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item:last-child {
    border-top-right-radius: 0.75rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  .list-group-horizontal-lg>.list-group-item:first-child {
    border-bottom-left-radius: 0.75rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item:last-child {
    border-top-right-radius: 0.75rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  .list-group-horizontal-xl>.list-group-item:first-child {
    border-bottom-left-radius: 0.75rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item:last-child {
    border-top-right-radius: 0.75rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1440) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }

  .list-group-horizontal-xxl>.list-group-item:first-child {
    border-bottom-left-radius: 0.75rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item:last-child {
    border-top-right-radius: 0.75rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush>.list-group-item {
  border-width: 0 0 1px;
}

.list-group-flush>.list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #462374;
  background-color: #ddcaf6;
}

.list-group-item-primary.list-group-item-action:hover,
.list-group-item-primary.list-group-item-action:focus {
  color: #462374;
  background-color: #cfb4f2;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #462374;
  border-color: #462374;
}

.list-group-item-secondary {
  color: #215074;
  background-color: #c9e3f6;
}

.list-group-item-secondary.list-group-item-action:hover,
.list-group-item-secondary.list-group-item-action:focus {
  color: #215074;
  background-color: #b3d8f2;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #215074;
  border-color: #215074;
}

.list-group-item-success {
  color: #16642c;
  background-color: #c4eecf;
}

.list-group-item-success.list-group-item-action:hover,
.list-group-item-success.list-group-item-action:focus {
  color: #16642c;
  background-color: #b0e8bf;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #16642c;
  border-color: #16642c;
}

.list-group-item-info {
  color: #171585;
  background-color: #c4c3ff;
}

.list-group-item-info.list-group-item-action:hover,
.list-group-item-info.list-group-item-action:focus {
  color: #171585;
  background-color: #abaaff;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #171585;
  border-color: #171585;
}

.list-group-item-warning {
  color: #85512b;
  background-color: #ffe3cf;
}

.list-group-item-warning.list-group-item-action:hover,
.list-group-item-warning.list-group-item-action:focus {
  color: #85512b;
  background-color: #ffd4b6;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #85512b;
  border-color: #85512b;
}

.list-group-item-danger {
  color: #812446;
  background-color: #fdcbdd;
}

.list-group-item-danger.list-group-item-action:hover,
.list-group-item-danger.list-group-item-action:focus {
  color: #812446;
  background-color: #fcb2cd;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #812446;
  border-color: #812446;
}

.list-group-item-light {
  color: #7f7f81;
  background-color: #fcfcfd;
}

.list-group-item-light.list-group-item-action:hover,
.list-group-item-light.list-group-item-action:focus {
  color: #7f7f81;
  background-color: #ededf3;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #7f7f81;
  border-color: #7f7f81;
}

.list-group-item-dark {
  color: #5c5c5c;
  background-color: #e9e9e9;
}

.list-group-item-dark.list-group-item-action:hover,
.list-group-item-dark.list-group-item-action:focus {
  color: #5c5c5c;
  background-color: gainsboro;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #5c5c5c;
  border-color: #5c5c5c;
}

.close {
  float: right;
  font-size: 1.3125rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .5;
}

.close:hover {
  color: #000;
  text-decoration: none;
}

.close:not(:disabled):not(.disabled):hover,
.close:not(:disabled):not(.disabled):focus {
  opacity: .75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast.showing {
  opacity: 1;
}

.toast.show {
  display: block;
  opacity: 1;
}

.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}

.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}

.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}

.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #EEEEEE;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #EEEEEE;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.modal-footer>* {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }

  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }

  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }

  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }

  .modal-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {

  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.765625rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top,
.bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0;
}

.bs-tooltip-top .arrow,
.bs-tooltip-auto[x-placement^="top"] .arrow {
  bottom: 0;
}

.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right,
.bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem;
}

.bs-tooltip-right .arrow,
.bs-tooltip-auto[x-placement^="right"] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-right .arrow::before,
.bs-tooltip-auto[x-placement^="right"] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom,
.bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0;
}

.bs-tooltip-bottom .arrow,
.bs-tooltip-auto[x-placement^="bottom"] .arrow {
  top: 0;
}

.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left,
.bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem;
}

.bs-tooltip-left .arrow,
.bs-tooltip-auto[x-placement^="left"] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-left .arrow::before,
.bs-tooltip-auto[x-placement^="left"] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.75rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.765625rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}

.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}

.popover .arrow::before,
.popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top,
.bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem;
}

.bs-popover-top>.arrow,
.bs-popover-auto[x-placement^="top"]>.arrow {
  bottom: calc(-0.5rem - 1px);
}

.bs-popover-top>.arrow::before,
.bs-popover-auto[x-placement^="top"]>.arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top>.arrow::after,
.bs-popover-auto[x-placement^="top"]>.arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right,
.bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem;
}

.bs-popover-right>.arrow,
.bs-popover-auto[x-placement^="right"]>.arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-right>.arrow::before,
.bs-popover-auto[x-placement^="right"]>.arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-right>.arrow::after,
.bs-popover-auto[x-placement^="right"]>.arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom,
.bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem;
}

.bs-popover-bottom>.arrow,
.bs-popover-auto[x-placement^="bottom"]>.arrow {
  top: calc(-0.5rem - 1px);
}

.bs-popover-bottom>.arrow::before,
.bs-popover-auto[x-placement^="bottom"]>.arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-bottom>.arrow::after,
.bs-popover-auto[x-placement^="bottom"]>.arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-left,
.bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem;
}

.bs-popover-left>.arrow,
.bs-popover-auto[x-placement^="left"]>.arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-left>.arrow::before,
.bs-popover-auto[x-placement^="left"]>.arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-left>.arrow::after,
.bs-popover-auto[x-placement^="left"]>.arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #3d4465;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #7e7e7e;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50% / 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: .5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: none;
  }
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow .75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #00ADEE !important;
}

a.bg-primary:hover,
a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #6d23cc !important;
}

.bg-secondary {
  background-color: #3F9AE0 !important;
}

a.bg-secondary:hover,
a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #2181cb !important;
}

.bg-success {
  background-color: #2BC155 !important;
}

a.bg-success:hover,
a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #229743 !important;
}

.bg-info {
  background-color: #2D28FF !important;
}

a.bg-info:hover,
a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0600f4 !important;
}

.bg-warning {
  background-color: #FF9B52 !important;
}

a.bg-warning:hover,
a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #ff7e1f !important;
}

.bg-danger {
  background-color: #F94687 !important;
}

a.bg-danger:hover,
a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #f71567 !important;
}

.bg-light {
  background-color: #F4F5F9 !important;
}

a.bg-light:hover,
a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #d3d7e7 !important;
}

.bg-dark {
  background-color: #B1B1B1 !important;
}

a.bg-dark:hover,
a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #989898 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #EEEEEE !important;
}

.border-top {
  border-top: 1px solid #EEEEEE !important;
}

.border-right {
  border-right: 1px solid #EEEEEE !important;
}

.border-bottom {
  border-bottom: 1px solid #EEEEEE !important;
}

.border-left {
  border-left: 1px solid #EEEEEE !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #00ADEE !important;
}

.border-secondary {
  border-color: #3F9AE0 !important;
}

.border-success {
  border-color: #2BC155 !important;
}

.border-info {
  border-color: #2D28FF !important;
}

.border-warning {
  border-color: #FF9B52 !important;
}

.border-danger {
  border-color: #F94687 !important;
}

.border-light {
  border-color: #F4F5F9 !important;
}

.border-dark {
  border-color: #B1B1B1 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.75rem !important;
}

.rounded-top {
  border-top-left-radius: 0.75rem !important;
  border-top-right-radius: 0.75rem !important;
}

.rounded-right {
  border-top-right-radius: 0.75rem !important;
  border-bottom-right-radius: 0.75rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.75rem !important;
  border-bottom-left-radius: 0.75rem !important;
}

.rounded-left {
  border-top-left-radius: 0.75rem !important;
  border-bottom-left-radius: 0.75rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1440) {
  .d-xxl-none {
    display: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
}

@media print {
  .d-print-none {
    display: none !important;
  }

  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }
}

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

.embed-responsive::before {
  display: block;
  content: "";
}

.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1440) {
  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
}

.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }

  .float-sm-right {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }

  .float-md-right {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }

  .float-lg-right {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }

  .float-xl-right {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }
}

@media (min-width: 1440) {
  .float-xxl-left {
    float: left !important;
  }

  .float-xxl-right {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }

  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }

  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }

  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }

  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }

  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }

  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }

  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }

  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }

  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }

  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 3rem !important;
  }

  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }

  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }

  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }

  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }

  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }

  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }

  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }

  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }

  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }

  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 3rem !important;
  }

  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }

  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }

  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }

  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -1rem !important;
  }

  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }

  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }

  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }

  .m-sm-n4 {
    margin: -1.5rem !important;
  }

  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }

  .m-sm-n5 {
    margin: -3rem !important;
  }

  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }

  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }

  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }

  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }

  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }

  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }

  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }

  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }

  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }

  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }

  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }

  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }

  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }

  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }

  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }

  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }

  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }

  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }

  .m-md-5 {
    margin: 3rem !important;
  }

  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }

  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }

  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }

  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }

  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }

  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }

  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }

  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }

  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }

  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }

  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }

  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }

  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }

  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }

  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }

  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }

  .p-md-5 {
    padding: 3rem !important;
  }

  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }

  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }

  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }

  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -1rem !important;
  }

  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }

  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }

  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }

  .m-md-n4 {
    margin: -1.5rem !important;
  }

  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }

  .m-md-n5 {
    margin: -3rem !important;
  }

  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }

  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }

  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }

  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }

  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }

  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }

  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }

  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }

  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }

  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }

  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }

  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }

  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }

  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }

  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }

  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 3rem !important;
  }

  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }

  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }

  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }

  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }

  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }

  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }

  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }

  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }

  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }

  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 3rem !important;
  }

  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }

  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }

  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }

  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -1rem !important;
  }

  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }

  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }

  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }

  .m-lg-n4 {
    margin: -1.5rem !important;
  }

  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }

  .m-lg-n5 {
    margin: -3rem !important;
  }

  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }

  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }

  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }

  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }

  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }

  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }

  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }

  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }

  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }

  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }

  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }

  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }

  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }

  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 3rem !important;
  }

  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }

  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }

  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }

  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }

  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }

  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }

  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }

  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }

  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 3rem !important;
  }

  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }

  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }

  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }

  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -1rem !important;
  }

  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }

  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }

  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }

  .m-xl-n4 {
    margin: -1.5rem !important;
  }

  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }

  .m-xl-n5 {
    margin: -3rem !important;
  }

  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }

  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }

  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }

  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1440) {
  .m-xxl-0 {
    margin: 0 !important;
  }

  .mt-xxl-0,
  .my-xxl-0 {
    margin-top: 0 !important;
  }

  .mr-xxl-0,
  .mx-xxl-0 {
    margin-right: 0 !important;
  }

  .mb-xxl-0,
  .my-xxl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xxl-0,
  .mx-xxl-0 {
    margin-left: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .mt-xxl-1,
  .my-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mr-xxl-1,
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .mb-xxl-1,
  .my-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-xxl-1,
  .mx-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .mt-xxl-2,
  .my-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mr-xxl-2,
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .mb-xxl-2,
  .my-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-xxl-2,
  .mx-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 1rem !important;
  }

  .mt-xxl-3,
  .my-xxl-3 {
    margin-top: 1rem !important;
  }

  .mr-xxl-3,
  .mx-xxl-3 {
    margin-right: 1rem !important;
  }

  .mb-xxl-3,
  .my-xxl-3 {
    margin-bottom: 1rem !important;
  }

  .ml-xxl-3,
  .mx-xxl-3 {
    margin-left: 1rem !important;
  }

  .m-xxl-4 {
    margin: 1.5rem !important;
  }

  .mt-xxl-4,
  .my-xxl-4 {
    margin-top: 1.5rem !important;
  }

  .mr-xxl-4,
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
  }

  .mb-xxl-4,
  .my-xxl-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-xxl-4,
  .mx-xxl-4 {
    margin-left: 1.5rem !important;
  }

  .m-xxl-5 {
    margin: 3rem !important;
  }

  .mt-xxl-5,
  .my-xxl-5 {
    margin-top: 3rem !important;
  }

  .mr-xxl-5,
  .mx-xxl-5 {
    margin-right: 3rem !important;
  }

  .mb-xxl-5,
  .my-xxl-5 {
    margin-bottom: 3rem !important;
  }

  .ml-xxl-5,
  .mx-xxl-5 {
    margin-left: 3rem !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .pt-xxl-0,
  .py-xxl-0 {
    padding-top: 0 !important;
  }

  .pr-xxl-0,
  .px-xxl-0 {
    padding-right: 0 !important;
  }

  .pb-xxl-0,
  .py-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xxl-0,
  .px-xxl-0 {
    padding-left: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .pt-xxl-1,
  .py-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pr-xxl-1,
  .px-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pb-xxl-1,
  .py-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-xxl-1,
  .px-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .pt-xxl-2,
  .py-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pr-xxl-2,
  .px-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pb-xxl-2,
  .py-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-xxl-2,
  .px-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 1rem !important;
  }

  .pt-xxl-3,
  .py-xxl-3 {
    padding-top: 1rem !important;
  }

  .pr-xxl-3,
  .px-xxl-3 {
    padding-right: 1rem !important;
  }

  .pb-xxl-3,
  .py-xxl-3 {
    padding-bottom: 1rem !important;
  }

  .pl-xxl-3,
  .px-xxl-3 {
    padding-left: 1rem !important;
  }

  .p-xxl-4 {
    padding: 1.5rem !important;
  }

  .pt-xxl-4,
  .py-xxl-4 {
    padding-top: 1.5rem !important;
  }

  .pr-xxl-4,
  .px-xxl-4 {
    padding-right: 1.5rem !important;
  }

  .pb-xxl-4,
  .py-xxl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-xxl-4,
  .px-xxl-4 {
    padding-left: 1.5rem !important;
  }

  .p-xxl-5 {
    padding: 3rem !important;
  }

  .pt-xxl-5,
  .py-xxl-5 {
    padding-top: 3rem !important;
  }

  .pr-xxl-5,
  .px-xxl-5 {
    padding-right: 3rem !important;
  }

  .pb-xxl-5,
  .py-xxl-5 {
    padding-bottom: 3rem !important;
  }

  .pl-xxl-5,
  .px-xxl-5 {
    padding-left: 3rem !important;
  }

  .m-xxl-n1 {
    margin: -0.25rem !important;
  }

  .mt-xxl-n1,
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-xxl-n1,
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-xxl-n1,
  .my-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-xxl-n1,
  .mx-xxl-n1 {
    margin-left: -0.25rem !important;
  }

  .m-xxl-n2 {
    margin: -0.5rem !important;
  }

  .mt-xxl-n2,
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-xxl-n2,
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-xxl-n2,
  .my-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-xxl-n2,
  .mx-xxl-n2 {
    margin-left: -0.5rem !important;
  }

  .m-xxl-n3 {
    margin: -1rem !important;
  }

  .mt-xxl-n3,
  .my-xxl-n3 {
    margin-top: -1rem !important;
  }

  .mr-xxl-n3,
  .mx-xxl-n3 {
    margin-right: -1rem !important;
  }

  .mb-xxl-n3,
  .my-xxl-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-xxl-n3,
  .mx-xxl-n3 {
    margin-left: -1rem !important;
  }

  .m-xxl-n4 {
    margin: -1.5rem !important;
  }

  .mt-xxl-n4,
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-xxl-n4,
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-xxl-n4,
  .my-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-xxl-n4,
  .mx-xxl-n4 {
    margin-left: -1.5rem !important;
  }

  .m-xxl-n5 {
    margin: -3rem !important;
  }

  .mt-xxl-n5,
  .my-xxl-n5 {
    margin-top: -3rem !important;
  }

  .mr-xxl-n5,
  .mx-xxl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xxl-n5,
  .my-xxl-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-xxl-n5,
  .mx-xxl-n5 {
    margin-left: -3rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mt-xxl-auto,
  .my-xxl-auto {
    margin-top: auto !important;
  }

  .mr-xxl-auto,
  .mx-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-auto,
  .my-xxl-auto {
    margin-bottom: auto !important;
  }

  .ml-xxl-auto,
  .mx-xxl-auto {
    margin-left: auto !important;
  }
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }

  .text-sm-right {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }

  .text-md-right {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }

  .text-lg-right {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }

  .text-xl-right {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1440) {
  .text-xxl-left {
    text-align: left !important;
  }

  .text-xxl-right {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #00ADEE !important;
}

a.text-primary:hover,
a.text-primary:focus {
  color: #611fb6 !important;
}

.text-secondary {
  color: #3F9AE0 !important;
}

a.text-secondary:hover,
a.text-secondary:focus {
  color: #1d73b5 !important;
}

.text-success {
  color: #2BC155 !important;
}

a.text-success:hover,
a.text-success:focus {
  color: #1d8239 !important;
}

.text-info {
  color: #2D28FF !important;
}

a.text-info:hover,
a.text-info:focus {
  color: #0500db !important;
}

.text-warning {
  color: #FF9B52 !important;
}

a.text-warning:hover,
a.text-warning:focus {
  color: #ff6f06 !important;
}

.text-danger {
  color: #F94687 !important;
}

a.text-danger:hover,
a.text-danger:focus {
  color: #eb085a !important;
}

.text-light {
  color: #F4F5F9 !important;
}

a.text-light:hover,
a.text-light:focus {
  color: #c3c8de !important;
}

.text-dark {
  color: #B1B1B1 !important;
}

a.text-dark:hover,
a.text-dark:focus {
  color: #8b8b8b !important;
}

.text-body {
  color: #7e7e7e !important;
}

.text-muted {
  color: #89879f !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {

  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }

  a:not(.btn) {
    text-decoration: underline;
  }

  abbr[title]::after {
    content: " (" attr(title) ")";
  }

  pre {
    white-space: pre-wrap !important;
  }

  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }

  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }

  @page {
    size: a3;
  }

  body {
    min-width: 992px !important;
  }

  .container {
    min-width: 992px !important;
  }

  .navbar {
    display: none;
  }

  .badge {
    border: 1px solid #000;
  }

  .table {
    border-collapse: collapse !important;
  }

  .table td,
  .table th {
    background-color: #fff !important;
  }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }

  .table-dark {
    color: inherit;
  }

  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody+tbody {
    border-color: #EEEEEE;
  }

  .table .thead-dark th {
    color: inherit;
    border-color: #EEEEEE;
  }
}

.c-pointer {
  cursor: pointer;
}

* {
  outline: none;
  padding: 0;
}

*::after {
  margin: 0;
  padding: 0;
}

*::before {
  margin: 0;
  padding: 0;
}

::selection {
  color: #fff;
  background: #00ADEE;
}

body {
  overflow-x: hidden;
  height: 100%;
  position: relative;
  max-width: 100%;
  font-size: 1rem;
}

@media only screen and (max-width: 991px) {
  body {
    font-size: 0.875rem;
  }
}

@media only screen and (max-width: 1400px) {
  h2 {
    font-size: 1.5rem;
  }
}

p {
  line-height: 1.8;
}

.box-shadow-none {
  box-shadow: none !important;
}

#main-wrapper {
  opacity: 0;
  transition: all 0.25s ease-in;
  overflow: hidden;
  position: relative;
}

#main-wrapper.show {
  opacity: 1;
}

.rounded-lg {
  border-radius: 1.25rem;
}

.rounded-xl {
  border-radius: 12px !important;
}

ul {
  padding: 0;
  margin: 0;
}

/* li {
  list-style: none;
} */

a {
  color: #7e7e7e;
}

a:hover,
a:focus,
a.active {
  text-decoration: none;
}

.btn-link:hover,
.btn-link:focus,
.btn-link.active {
  text-decoration: none;
}

.w-space-no {
  white-space: nowrap;
}

.content-body .container {
  margin-top: 40px;
}

.content-body .container-fluid,
.content-body .container-sm,
.content-body .container-md,
.content-body .container-lg,
.content-body .container-xl {
  padding-top: 40px;
  padding-right: 40px;
  padding-left: 40px;
}

@media only screen and (max-width: 1600px) {

  .content-body .container-fluid,
  .content-body .container-sm,
  .content-body .container-md,
  .content-body .container-lg,
  .content-body .container-xl {
    padding-top: 30px;
    padding-right: 30px;
    padding-left: 30px;
  }
}

@media only screen and (max-width: 767px) {

  .content-body .container-fluid,
  .content-body .container-sm,
  .content-body .container-md,
  .content-body .container-lg,
  .content-body .container-xl {
    padding-top: 20px;
    padding-right: 20px;
    padding-left: 20px;
  }
}

@media only screen and (max-width: 575px) {

  .content-body .container-fluid,
  .content-body .container-sm,
  .content-body .container-md,
  .content-body .container-lg,
  .content-body .container-xl {
    padding-top: 15px;
    padding-right: 15px;
    padding-left: 15px;
  }
}

/* sp */
.row.sp80,
.sp80 {
  margin-left: -40px;
  margin-right: -40px;
}

.row.sp80 [class*="col-"],
.sp80 [class*="col-"] {
  padding-left: 40px;
  padding-right: 40px;
}

.row.sp60,
.sp60 {
  margin-left: -30px;
  margin-right: -30px;
}

.row.sp60 [class*="col-"],
.sp60 [class*="col-"] {
  padding-left: 30px;
  padding-right: 30px;
}

.row.sp40,
.sp40 {
  margin-left: -20px;
  margin-right: -20px;
}

.row.sp40 [class*="col-"],
.sp40 [class*="col-"] {
  padding-left: 20px;
  padding-right: 20px;
}

.row.sp20,
.sp20 {
  margin-left: -10px;
  margin-right: -10px;
}

.row.sp20 [class*="col-"],
.sp20 [class*="col-"] {
  padding-left: 10px;
  padding-right: 10px;
}

.row.sp16,
.sp16 {
  margin-left: -8px;
  margin-right: -8px;
}

.row.sp16 [class*="col-"],
.sp16 [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

.row.sp10,
.sp10 {
  margin-left: -5px;
  margin-right: -5px;
}

.row.sp10 [class*="col-"],
.sp10 [class*="col-"] {
  padding-left: 5px;
  padding-right: 5px;
}

.row.sp4,
.sp4 {
  margin-left: -2px;
  margin-right: -2px;
}

.row.sp4 [class*="col-"],
.sp4 [class*="col-"] {
  padding-left: 2px;
  padding-right: 2px;
}

.row.spno,
.spno {
  margin-left: 0;
  margin-right: 0;
}

.row.spno [class*="col-"],
.spno [class*="col-"] {
  padding-left: 0;
  padding-right: 0;
}

.content-heading {
  font-size: 16px;
  margin-bottom: 1.875rem;
  margin-top: 3.125rem;
  border-bottom: 1px solid #f0f1f5;
  padding-bottom: 10px;
}

[direction="rtl"] .content-heading {
  text-align: right;
}

.text-ov {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus {
  box-shadow: none;
}

.op1 {
  opacity: 0.1;
}

.op2 {
  opacity: 0.2;
}

.op3 {
  opacity: 0.3;
}

.op4 {
  opacity: 0.4;
}

.op5 {
  opacity: 0.5;
}

.op6 {
  opacity: 0.6;
}

.op7 {
  opacity: 0.7;
}

.op8 {
  opacity: 0.8;
}

.op9 {
  opacity: 0.9;
}

.wspace-no {
  white-space: nowrap;
}

.support-ticket {
  position: fixed;
  bottom: 30px;
  right: 15px;
  z-index: 999999;
}

.support-ticket-btn {
  width: 100px;
  background: #7CB442;
  animation: 0.7s ease-in-out 0s infinite alternate none running crescendo;
  border-radius: 50px;
  color: #fff;
  font-size: 8px;
  font-size: 16px;
  padding: 5px 10px 7px;
  text-align: center;
  display: inline-block;
  box-shadow: rgba(124, 180, 66, 0.7) 0px 8px 35px 0px;
}

.support-ticket-btn:hover,
.support-ticket-btn:focus {
  color: #fff;
}

.text-blue {
  color: #5e72e4;
}

.text-indigo {
  color: #6610f2;
}

.text-purple {
  color: #6f42c1;
}

.text-pink {
  color: #e83e8c;
}

.text-red {
  color: #EE3232;
}

.text-orange {
  color: #ff9900;
}

.text-yellow {
  color: #FFFA6F;
}

.text-green {
  color: #297F00;
}

.text-teal {
  color: #20c997;
}

.text-cyan {
  color: #3065D0;
}

.bg-gray-dark {
  background: #143b64 !important;
}

.bg-purpal {
  background: #4527a0 !important;
}

.bg-red {
  background: #c62828 !important;
}

.bg-blue-dark {
  background: #283593 !important;
}

.bg-blue {
  background: #7356f1 !important;
}

.bg-blue-light {
  background: #3695eb !important;
}

.bg-green-light {
  background: #00838f !important;
}

.bg-green {
  background: #ff8f16 !important;
}

.bg-black {
  background: #000;
}

.text-black {
  color: #000 !important;
}

.dz-scroll {
  position: relative;
}

.h-auto {
  height: auto !important;
}

.list-inline li {
  display: inline-block;
}

.fs-12 {
  font-size: 12px !important;
  line-height: 1.3;
}

.fs-13 {
  font-size: 13px !important;
  line-height: 1.4;
}

.fs-14 {
  font-size: 14px !important;
  line-height: 1.5;
}

.fs-15 {
  font-size: 14px !important;
  line-height: 1.5;
}

.fs-16 {
  font-size: 16px !important;
  line-height: 1.5;
}

.fs-18 {
  font-size: 18px !important;
  line-height: 1.5;
}

.fs-20 {
  font-size: 20px !important;
  line-height: 1.5;
}

.fs-22 {
  font-size: 22px !important;
  line-height: 1.5;
}

.fs-24 {
  font-size: 24px !important;
  line-height: 1.4;
}

.fs-26 {
  font-size: 26px !important;
  line-height: 1.4;
}

.fs-28 {
  font-size: 28px !important;
  line-height: 1.4;
}

.fs-30 {
  font-size: 30px !important;
  line-height: 1.4;
}

.fs-32 {
  font-size: 32px !important;
  line-height: 1.25;
}

.fs-34 {
  font-size: 34px !important;
  line-height: 1.25;
}

.fs-35 {
  font-size: 35px !important;
  line-height: 1.25;
}

.fs-36 {
  font-size: 36px !important;
  line-height: 1.25;
}

.fs-38 {
  font-size: 38px !important;
  line-height: 1.25;
}

.fs-46 {
  font-size: 46px !important;
  line-height: 1.25;
}

.fs-48 {
  font-size: 48px !important;
  line-height: 1.25;
}

.font-w100 {
  font-weight: 100;
}

.font-w200 {
  font-weight: 200;
}

.font-w300 {
  font-weight: 300;
}

.font-w400 {
  font-weight: 400;
}

.font-w500 {
  font-weight: 500;
}

.font-w600 {
  font-weight: 600;
}

.font-w700 {
  font-weight: 700;
}

.font-w800 {
  font-weight: 800;
}

.font-w900 {
  font-weight: 900;
}

.scale1 {
  transform: scale(1.1);
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -o-transform: scale(1.1);
  display: inline-block;
}

.scale2 {
  transform: scale(1.2);
  -moz-transform: scale(1.2);
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  -o-transform: scale(1.2);
  display: inline-block;
}

.scale3 {
  transform: scale(1.3);
  -moz-transform: scale(1.3);
  -webkit-transform: scale(1.3);
  -ms-transform: scale(1.3);
  -o-transform: scale(1.3);
  display: inline-block;
}

.scale4 {
  transform: scale(1.4);
  -moz-transform: scale(1.4);
  -webkit-transform: scale(1.4);
  -ms-transform: scale(1.4);
  -o-transform: scale(1.4);
  display: inline-block;
}

.scale5 {
  transform: scale(1.5);
  -moz-transform: scale(1.5);
  -webkit-transform: scale(1.5);
  -ms-transform: scale(1.5);
  -o-transform: scale(1.5);
  display: inline-block;
}

.scale21 {
  transform: scale(2);
  -moz-transform: scale(2);
  -webkit-transform: scale(2);
  -ms-transform: scale(2);
  -o-transform: scale(2);
  display: inline-block;
}

.height10 {
  height: 10px;
}

.height20 {
  height: 20px;
}

.height30 {
  height: 30px;
}

.height40 {
  height: 40px;
}

.height50 {
  height: 50px;
}

.height60 {
  height: 60px;
}

.height70 {
  height: 70px;
}

.height80 {
  height: 80px;
}

.height90 {
  height: 90px;
}

.height100 {
  height: 100px;
}

.height110 {
  height: 110px;
}

.height120 {
  height: 120px;
}

.height130 {
  height: 130px;
}

.height140 {
  height: 140px;
}

.height150 {
  height: 150px;
}

.height160 {
  height: 160px;
}

.height170 {
  height: 170px;
}

.height180 {
  height: 180px;
}

.height190 {
  height: 190px;
}

.height200 {
  height: 200px;
}

.height210 {
  height: 210px;
}

.height220 {
  height: 220px;
}

.height230 {
  height: 230px;
}

.height240 {
  height: 240px;
}

.height250 {
  height: 250px;
}

.height260 {
  height: 260px;
}

.height270 {
  height: 270px;
}

.height280 {
  height: 280px;
}

.height290 {
  height: 290px;
}

.height300 {
  height: 300px;
}

.height310 {
  height: 310px;
}

.height320 {
  height: 320px;
}

.height330 {
  height: 330px;
}

.height340 {
  height: 340px;
}

.height350 {
  height: 350px;
}

.height360 {
  height: 360px;
}

.height370 {
  height: 370px;
}

.height380 {
  height: 380px;
}

.height390 {
  height: 390px;
}

.height400 {
  height: 400px;
}

.height415 {
  height: 415px;
}

.height720 {
  height: 720px;
}

.height800 {
  height: 800px;
}

.width10 {
  width: 10px;
}

.width20 {
  width: 20px;
}

.width30 {
  width: 30px;
}

.width40 {
  width: 40px;
}

.width50 {
  width: 50px;
}

.width60 {
  width: 60px;
}

.width70 {
  width: 70px;
}

.width80 {
  width: 80px;
}

.width90 {
  width: 90px;
}

.width100 {
  width: 100px;
}

.width110 {
  width: 110px;
}

.width120 {
  width: 120px;
}

.width130 {
  width: 130px;
}

.width140 {
  width: 140px;
}

.width150 {
  width: 150px;
}

.width160 {
  width: 160px;
}

.width170 {
  width: 170px;
}

.width180 {
  width: 180px;
}

.width190 {
  width: 190px;
}

.width200 {
  width: 200px;
}

.width210 {
  width: 210px;
}

.width220 {
  width: 220px;
}

.width230 {
  width: 230px;
}

.width240 {
  width: 240px;
}

.width250 {
  width: 250px;
}

.width260 {
  width: 260px;
}

.width270 {
  width: 270px;
}

.width280 {
  width: 280px;
}

.width290 {
  width: 290px;
}

.width300 {
  width: 300px;
}

.width310 {
  width: 310px;
}

.width320 {
  width: 320px;
}

.width330 {
  width: 330px;
}

.width340 {
  width: 340px;
}

.width350 {
  width: 350px;
}

.width360 {
  width: 360px;
}

.width370 {
  width: 370px;
}

.width380 {
  width: 380px;
}

.width390 {
  width: 390px;
}

.width400 {
  width: 400px;
}

@keyframes gXGDoR {
  from {
    transform: translateY(5px) scale(0.8);
  }

  to {
    transform: translateY(0px) scale(1);
  }
}

@keyframes crescendo {
  from {
    transform: translateY(5px) scale(0.8);
  }

  to {
    transform: translateY(0px) scale(1);
  }
}

@keyframes gXGDoR {
  from {
    transform: translateY(5px) scale(0.8);
  }

  to {
    transform: translateY(0px) scale(1);
  }
}

.border-2 {
  border-width: 2px !important;
}

@media only screen and (min-width: 1200px) and (max-width: 1600px) {
  .col-xxl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-xxl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-xxl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-xxl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-xxl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-xxl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-xxl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-xxl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-xxl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
}

/* Editable */
#preloader {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #fff;
}

.sk-three-bounce {
  margin: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: white;
}

.sk-three-bounce .sk-child {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background-color: #00ADEE;
  border-radius: 100%;
  display: inline-block;
  animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;
}

.sk-three-bounce .sk-bounce1 {
  animation-delay: -0.32s;
}

.sk-three-bounce .sk-bounce2 {
  animation-delay: -0.16s;
}

@keyframes sk-three-bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

.footer {
  padding-left: 21.563rem;
  background-color: #E5E6E7;
}

@media only screen and (max-width: 1400px) {
  .footer {
    padding-left: 17rem;
  }
}

.footer .copyright {
  padding: 0.9375rem;
}

.footer .copyright p {
  text-align: center;
  margin: 0;
}

.footer .copyright a {
  color: #00ADEE;
}

@media only screen and (min-width: 991px) {
  .footer .copyright {
    border-radius: 0 0 0 50px;
  }
}

[data-sidebar-style="mini"] .nav-control,
[data-layout="horizontal"] .nav-control {
  display: none;
}

@media only screen and (max-width: 767px) {
  [data-sidebar-style="overlay"] .nav-header .logo-abbr {
    display: block;
  }
}

[data-header-position="fixed"] .nav-header {
  position: fixed;
  left: auto;
}

.nav-header {
  height: 5rem;
  width: 230px;
  display: inline-block;
  text-align: left;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #fff;
  transition: all .2s ease;
  z-index: 5;
}

.nav-header .logo-abbr {
  max-width: 52px;
}

@media only screen and (max-width: 575px) {
  .nav-header .logo-abbr {
    max-width: 40px;
  }
}

.nav-header .logo-compact {
  display: none;
}

@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .nav-header {
    width: 15rem;
  }
}

.nav-header .brand-logo {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.125rem;
  color: #fff;
  text-decoration: none;
  padding-left: 20px;
  padding-right: 50px;
  font-weight: 700;
}

@media only screen and (max-width: 1400px) {
  .nav-header .brand-logo {
    padding-left: 25px;
    padding-right: 25px;
  }
}

[data-sidebar-style="compact"] .nav-header .brand-logo,
[data-sidebar-style="mini"] .nav-header .brand-logo {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
}

@media only screen and (max-width: 767px) {
  .nav-header .brand-logo {
    padding-left: 0;
    padding-right: 0;
    justify-content: center;
  }
}

.nav-header .brand-title {
  margin-left: 0px;
  max-width: 120px;
  margin-top: 0px;
}

[data-theme-version="dark"] .nav-header .brand-title {
  background-position: 0 120%;
}

@media only screen and (max-width: 1199px) {
  .nav-header {
    width: 5rem;
    height: 5rem;
  }

  .nav-header .brand-title {
    display: none;
  }
}

.nav-control {
  cursor: pointer;
  position: absolute;
  right: -4.0625rem;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  font-size: 1.4rem;
  padding: 2px 0.5rem 0;
  border-radius: 2px;
}

@media only screen and (max-width: 767px) {
  .nav-control {
    right: -2.75rem;
  }
}

@media only screen and (max-width: 575px) {
  .nav-control {
    right: -2.75rem;
  }
}

.hamburger {
  display: inline-block;
  left: 0px;
  position: relative;
  top: 3px;
  transition: all 0.3s ease-in-out 0s;
  width: 26px;
  z-index: 999;
}

.hamburger .line {
  background: #00ADEE;
  display: block;
  height: 3px;
  border-radius: 3px;
  margin-top: 6px;
  margin-bottom: 6px;
  margin-left: auto;
  transition: all 0.3s ease-in-out;
}

.hamburger .line:nth-child(1) {
  width: 20px;
}

.hamburger .line:nth-child(2) {
  width: 26px;
}

.hamburger .line:nth-child(3) {
  width: 22px;
}

.hamburger:hover {
  cursor: pointer;
}

.hamburger:hover .line {
  width: 26px;
}

/*
    .hamburger.is-active {
      left: 60px;
    }
    */
.hamburger.is-active .line:nth-child(1),
.hamburger.is-active .line:nth-child(3) {
  width: 10px;
  height: 2px;
}

.hamburger.is-active .line:nth-child(2) {
  transform: translateX(0px);
  width: 22px;
  height: 2px;
}

.hamburger.is-active .line:nth-child(1) {
  transform: translateY(4px) rotate(45deg);
}

.hamburger.is-active .line:nth-child(3) {
  transform: translateY(-4px) rotate(-45deg);
}

@media (min-width: 767px) {
  [data-sidebar-style="compact"] .nav-control {
    display: none;
  }

  [data-sidebar-style="compact"] .nav-header {
    width: 15rem;
  }
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .brand-title {
  display: none;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .logo-abbr {
  display: block;
}

[data-sidebar-style="full"][data-layout="horizontal"] .logo-compact {
  display: none;
}

[data-sidebar-style="mini"] .nav-header .logo-abbr {
  display: block;
}

[data-sidebar-style="compact"][data-layout="vertical"] .nav-header .brand-title {
  /* display: none; */
}

[data-sidebar-style="compact"][data-layout="vertical"] .nav-header .logo-compact {
  max-width: 75px;
}

[data-sidebar-style="compact"][data-layout="horizontal"] .nav-header .brand-logo {
  padding-left: 30px;
  padding-right: 30px;
  justify-content: start;
}

[data-sidebar-style="modern"][data-layout="vertical"] .nav-header {
  width: 9.375rem;
}

[data-sidebar-style="modern"][data-layout="vertical"] .nav-header .brand-title {
  display: none;
}

[data-sidebar-style="modern"][data-layout="vertical"] .nav-header .logo-compact {
  display: none;
}

.header {
  height: 5rem;
  z-index: 1;
  position: relative;
  padding: 0rem;
  background-color: #fff;
  z-index: 4;
  padding-left: 230px;
  transition: all .2s ease;
}

@media only screen and (max-width: 1400px) {
  .header {
    padding-left: 17rem;
  }
}

.header .header-content {
  height: 100%;
  padding-left: 5.3125rem;
  padding-right: 2.4rem;
  align-items: center;
  display: flex;
}

@media only screen and (max-width: 767px) {
  .header .header-content {
    padding-left: 3.75rem;
    padding-right: 0.938rem;
    border-radius: 0;
  }
}

.header .navbar {
  padding: 0;
  height: 100%;
  width: 100%;
}

.header .navbar .navbar-collapse {
  height: 100%;
  width: 100%;
}

@media only screen and (max-width: 1199px) {
  .header {
    height: 5rem;
  }
}

/* pulse in SVG */
svg.pulse-svg {
  overflow: visible;
}

svg.pulse-svg .first-circle,
svg.pulse-svg .second-circle,
svg.pulse-svg .third-circle {
  transform: scale(0.3);
  transform-origin: center center;
  animation: pulse-me 3s linear infinite;
  fill: #00ADEE;
}

svg.pulse-svg .second-circle {
  animation-delay: 1s;
}

svg.pulse-svg .third-circle {
  animation-delay: 2s;
}

/* pulse in CSS */
.pulse-css {
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  border-radius: 3.5rem;
  height: 1rem;
  position: absolute;
  background: #FF507A;
  right: 5px;
  top: 5px;
  width: 1rem;
}

.pulse-css:after,
.pulse-css:before {
  content: '';
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: -.2rem;
  background-color: #FF507A;
  margin: auto;
  transform: scale(0.3);
  transform-origin: center center;
  animation: pulse-me 3s linear infinite;
}

[direction="rtl"] .pulse-css:after,
[direction="rtl"] .pulse-css:before {
  left: auto;
  right: -.2rem;
}

@media only screen and (max-width: 1400px) {
  .pulse-css {
    height: 0.5rem;
    width: 0.5rem;
  }
}

@keyframes pulse-me {
  0% {
    transform: scale(0.3);
    opacity: 0;
  }

  50% {
    opacity: 0.1;
  }

  70% {
    opacity: 0.09;
  }

  100% {
    transform: scale(3);
    opacity: 0;
  }
}

[data-sidebar-style="full"] .header,
[data-sidebar-style="overlay"] .header {
  width: 100%;
}

@media only screen and (min-width: 1200px) and (max-width: 1350px) {

  [data-sidebar-style="full"] .header,
  [data-sidebar-style="overlay"] .header {
    width: 100%;
    padding-left: 17rem;
  }
}

@media only screen and (max-width: 1199px) {

  [data-sidebar-style="full"] .header,
  [data-sidebar-style="overlay"] .header {
    width: 100%;
    padding-left: 5rem;
  }
}

[data-sidebar-style="mini"] .header {
  width: 100%;
  padding-left: 5rem;
}

[data-sidebar-style="compact"] .header {
  width: 100%;
  padding-left: 15rem;
}

[data-sidebar-style="compact"] .header .header-content {
  padding-left: 2.4rem;
}

[data-header-position="fixed"] .header {
  position: fixed;
  top: 0;
  width: 100%;
}

[data-header-position="fixed"] .content-body {
  padding-top: 4rem;
}

@media only screen and (max-width: 1199px) {
  [data-header-position="fixed"] .content-body {
    padding-top: 5rem;
  }
}

[data-header-position="fixed"] .deznav {
  margin-top: 0;
}

[data-sidebar-style="compact"][data-header-position="fixed"][data-container="boxed"][data-layout="vertical"] .header {
  width: 1199px;
}

[data-sidebar-style="modern"] .header {
  width: 100%;
  padding-left: 9.375rem;
}

[data-sidebar-style="modern"][data-layout="horizontal"] .nav-header .brand-logo {
  justify-content: start;
}

[data-sidebar-style="modern"][data-layout="horizontal"] .header .header-content {
  padding-left: 30px;
}

.header-left {
  height: 100%;
  display: flex;
  align-items: center;
}

.header-left .dashboard_bar {
  font-size: 28px;
  font-weight: 600;
  color: #000;
}

@media only screen and (max-width: 1400px) {
  .header-left .dashboard_bar {
    font-size: 24px;
  }
}

@media only screen and (max-width: 767px) {
  .header-left .dashboard_bar {
    display: none;
  }
}

.header-left input {
  background: #E5E6E7 !important;
  min-width: 170px;
  min-height: 40px;
  color: #B1B1B1 !important;
  border-top-left-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: none;
  padding: 10px 20px;
  font-size: 16px;
  border-right-width: 0 !important;
  border: 1px solid #ebebeb;
  border-width: 1px;
  font-weight: 300;
}

[direction="rtl"] .header-left input {
  border-top-right-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.header-left input:focus,
.header-left input:active,
.header-left input.active {
  border-color: #ebebeb;
  box-shadow: none;
}

.header-left input::placeholder {
  color: #B1B1B1;
}

.header-left .search_bar {
  display: flex;
  align-items: center;
  height: 100%;
}

@media only screen and (max-width: 767px) {
  .header-left .search_bar {
    display: none;
  }
}

.header-left .search_bar .dropdown-menu {
  box-shadow: none;
}

.header-left .search_bar .search_icon {
  background: #E5E6E7 !important;
  height: 56px;
  line-height: 22px;
  padding: 15px 20px 15px 0 !important;
  border-top-right-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  border: 1px solid #ebebeb;
  border-width: 1px;
  border-left-width: 0;
}

.header-left .search_bar .search_icon i {
  font-size: 24px;
  color: #B1B1B1;
  line-height: 1;
}

@media only screen and (max-width: 1400px) {
  .header-left .search_bar .search_icon {
    height: 41px;
    padding: 8px 15px 8px 0 !important;
  }

  .header-left .search_bar .search_icon svg {
    width: 18px;
    height: 18px;
  }
}

@media only screen and (max-width: 767px) {
  .header-left .search_bar {
    position: static;
  }

  .header-left .search_bar .dropdown-menu {
    width: 300px;
    left: -15vw;
    box-shadow: 0px 5px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px !important;
  }
}

@media only screen and (max-width: 767px) and (max-width: 575px) {
  .header-left .search_bar .dropdown-menu {
    width: 250px;
    left: -25vw;
  }
}

@media only screen and (max-width: 767px) {
  .header-left .search_bar .dropdown-menu .form-control {
    border-radius: 4px !important;
    width: 100%;
  }

  [direction="rtl"] .header-left .search_bar .dropdown-menu {
    right: -98px;
  }
}

.header-left .search_bar .dropdown-menu,
.header-left .search_bar .dropdown-menu.show {
  border: 0px;
  background-color: transparent;
  border-top-right-radius: 5rem;
  border-bottom-right-radius: 5rem;
}

@media only screen and (min-width: 768px) {

  .header-left .search_bar .dropdown-menu,
  .header-left .search_bar .dropdown-menu.show {
    left: 0;
    top: 0;
    transform: none;
    display: block;
    position: unset;
  }
}

[data-sidebar-style="compact"] .header-left {
  margin-left: 0;
}

.header-right {
  height: 100%;
}

.header-right .nav-item {
  height: 100%;
  display: flex;
  align-items: center;
}

.header-right .nav-item .nav-link {
  color: #464a53;
  font-size: 18px;
}

.header-right .right-sidebar {
  margin-right: -30px;
}

.header-right .right-sidebar a {
  height: 80px;
  width: 80px;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  border-left: 1px solid #F4F5F9;
}

.header-right>li:not(:first-child) {
  padding-left: 2rem;
}

@media only screen and (max-width: 1400px) {
  .header-right>li:not(:first-child) {
    padding-left: 1rem;
  }
}

@media only screen and (max-width: 575px) {
  .header-right>li:not(:first-child) {
    padding-left: 0.5rem;
  }
}

@media only screen and (max-width: 767px) {
  .header-right .notification_dropdown {
    position: static;
  }
}

.header-right .notification_dropdown .nav-link {
  position: relative;
  color: #00ADEE;
  background: transparent;
  border-radius: 0;
  padding: 12px;
  line-height: 1;
}

@media only screen and (max-width: 1400px) {
  .header-right .notification_dropdown .nav-link {
    padding: 10px;
  }
}

.header-right .notification_dropdown .nav-link.secondary {
  background: #ddedfa;
  color: #3F9AE0;
}

.header-right .notification_dropdown .nav-link.secondary [fill] {
  fill: #3F9AE0;
}

.header-right .notification_dropdown .nav-link.primary {
  background: #f6f1fd;
  color: #00ADEE;
}

.header-right .notification_dropdown .nav-link.primary [fill] {
  fill: #00ADEE;
}

.header-right .notification_dropdown .nav-link.warning {
  background: #fff3eb;
  color: #FF9B52;
}

.header-right .notification_dropdown .nav-link.warning [fill] {
  fill: #FF9B52;
}

.header-right .notification_dropdown .nav-link.success {
  background: #e3f9e9;
  color: #2BC155;
}

.header-right .notification_dropdown .nav-link.success [fill] {
  fill: #2BC155;
}

.header-right .notification_dropdown .nav-link i {
  font-size: 24px;
}

@media only screen and (max-width: 1400px) {
  .header-right .notification_dropdown .nav-link i {
    font-size: 18px;
  }
}

@media only screen and (max-width: 1400px) {
  .header-right .notification_dropdown .nav-link svg {
    width: 24px;
    height: 24px;
  }
}

.header-right .notification_dropdown .nav-link .badge {
  position: absolute;
  font-size: 14px;
  border-radius: 40px;
  right: -1px;
  top: 3px;
  box-shadow: 0px 0px 10px 3px rgba(135, 67, 223, 0.2);
  font-weight: normal;
  height: 26px;
  width: 26px;
  line-height: 26px;
  text-align: center;
  padding: 0px;
}

@media only screen and (max-width: 1400px) {
  .header-right .notification_dropdown .nav-link .badge {
    right: 3px;
    top: 3px;
    font-size: 12px;
    height: 18px;
    width: 18px;
    line-height: 18px;
  }
}

@media only screen and (max-width: 575px) {
  .header-right .notification_dropdown .nav-link .badge {
    right: -1px;
    height: 15px;
    width: 15px;
    font-size: 10px;
    line-height: 15px;
  }
}

.header-right .notification_dropdown .dropdown-item:focus a,
.header-right .notification_dropdown .dropdown-item:active a {
  color: #fff;
}

.header-right .notification_dropdown .dropdown-item a {
  color: #B1B1B1;
}

.header-right .notification_dropdown .dropdown-item a:hover {
  text-decoration: none;
}

.header-right .dropdown-menu {
  border-width: 0;
  box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);
}

[data-theme-version="dark"] .header-right .dropdown-menu {
  box-shadow: none;
}

.header-right .header-profile>a.nav-link {
  padding: 0 0 0 0;
  display: flex;
  align-items: center;
  border-radius: 1.25rem 28px 28px 1.25rem;
}

@media only screen and (max-width: 575px) {
  .header-right .header-profile>a.nav-link {
    background: transparent;
    padding: 0;
  }
}

.header-right .header-profile>a.nav-link i {
  font-weight: 700;
}

.header-right .header-profile>a.nav-link .header-info {
  text-align: right;
  padding-right: 30px;
}

@media only screen and (max-width: 1199px) {
  .header-right .header-profile>a.nav-link .header-info {
    padding-left: 15px;
  }
}

@media only screen and (max-width: 575px) {
  .header-right .header-profile>a.nav-link .header-info {
    display: none;
  }
}

.header-right .header-profile>a.nav-link .header-info span {
  font-size: 16px;
  display: block;
  font-weight: 400;
}

.header-right .header-profile>a.nav-link .header-info strong {
  font-weight: 600;
}

.header-right .header-profile>a.nav-link .header-info small {
  display: block;
  font-size: 13px;
  color: #89879f;
  font-weight: 400;
  line-height: 1.2;
}

.header-right .header-profile .dropdown-menu {
  padding: 15px 0;
  min-width: 12.5rem;
}

.header-right .header-profile .dropdown-menu a:hover,
.header-right .header-profile .dropdown-menu a:focus,
.header-right .header-profile .dropdown-menu a.active {
  color: #00ADEE;
}

.header-right .header-profile img {
  width: 57px;
  height: 57px;
  border-radius: 60px;
}

@media only screen and (max-width: 1400px) {
  .header-right .header-profile img {
    width: 39px;
    height: 39px;
  }
}

.header-right .header-profile .dropdown-toggle i {
  font-size: 1.25rem;
}

@media only screen and (max-width: 575px) {
  .header-right .header-profile .dropdown-toggle span {
    display: none;
  }
}

.header-right .header-profile .profile_title {
  background: #00ADEE;
  color: #fff;
  padding: 10px 20px;
}

.header-right .header-profile .profile_title h5 {
  color: #fff;
  margin-bottom: 3px;
}

.header-right .header-profile .dropdown-item {
  padding: 8px 24px;
}

.dz-fullscreen #icon-minimize {
  display: none;
}

.dz-fullscreen.active #icon-full {
  display: none;
}

.dz-fullscreen.active #icon-minimize {
  display: inline-block;
}

.notification_dropdown .dropdown-menu-right {
  min-width: 310px;
  padding: 0rem 0 1rem;
  top: 100%;
}

.notification_dropdown .dropdown-menu-right .notification_title {
  background: #00ADEE;
  color: #fff;
  padding: 10px 20px;
}

.notification_dropdown .dropdown-menu-right .notification_title h5 {
  color: #fff;
  margin-bottom: 3px;
}

.notification_dropdown .dropdown-menu-right .media {
  width: 45px !important;
  height: 45px !important;
  font-size: 18px !important;
}

[data-theme-version="dark"] .notification_dropdown .dropdown-menu-right .media {
  border-color: #333a54;
}

.notification_dropdown .dropdown-menu-right .media>span {
  width: 35px;
  height: 35px;
  border-radius: 50px;
  display: inline-block;
  padding: 7px 9px;
  margin-right: 10px;
}

[direction="rtl"].notification_dropdown .dropdown-menu-right .media>span {
  margin-right: 0;
  margin-left: 10px;
}

.notification_dropdown .dropdown-menu-right .media>span.success {
  background: #e3f9e9;
  color: #2BC155;
}

.notification_dropdown .dropdown-menu-right .media>span.success [fill] {
  fill: #2BC155;
}

.notification_dropdown .dropdown-menu-right .media>span.primary {
  background: #f6f1fd;
  color: #00ADEE;
}

.notification_dropdown .dropdown-menu-right .media>span.primary svg [fill] {
  fill: #00ADEE;
}

.notification_dropdown .dropdown-menu-right .media>span.danger {
  background: #fff3f7;
  color: #F94687;
}

.notification_dropdown .dropdown-menu-right .media>span.danger [fill] {
  fill: #F94687;
}

.notification_dropdown .dropdown-menu-right .media>span [fill] {
  fill: #00ADEE;
}

.notification_dropdown .dropdown-menu-right .media .notify-time {
  width: 100% !important;
  margin-right: 0 !important;
  color: #828690;
}

.notification_dropdown .dropdown-menu-right .media p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  margin-bottom: 0;
  margin-top: 5px;
}

@media only screen and (max-width: 575px) {
  .notification_dropdown .dropdown-menu-right .media p {
    max-width: 100px;
  }
}

.notification_dropdown .dropdown-menu-right .all-notification {
  display: block;
  padding: 15px 30px 0;
  text-align: center;
  border-top: 1px solid #F4F5F9;
}

.notification_dropdown .dropdown-menu-right .all-notification i {
  margin-left: 10px;
}

.rtl {
  text-align: right;
  direction: rtl;
}

.rtl .nav {
  padding-right: 0;
}

.rtl .navbar-nav .nav-item {
  float: right;
}

.rtl .navbar-nav .nav-item+.nav-item {
  margin-right: 1rem;
  margin-left: inherit;
}

.rtl th {
  text-align: right;
}

.rtl .alert-dismissible {
  padding-right: 1.25rem;
  padding-left: 4rem;
}

.rtl .dropdown-menu {
  right: 0;
  text-align: right;
}

.rtl .checkbox label {
  padding-right: 1.25rem;
  padding-left: inherit;
}

.rtl .btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-radius: 0 0.75rem 0.75rem 0;
}

.rtl .btn-group>.btn:last-child:not(:first-child),
.rtl .btn-group>.dropdown-toggle:not(:first-child) {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .custom-control-label::after,
.rtl .custom-control-label::before {
  right: 0;
  left: inherit;
}

.rtl .custom-select {
  padding: 0.375rem 0.75rem 0.375rem 1.75rem;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat left 0.75rem center;
  background-size: 8px 10px;
}

.rtl .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.rtl .input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
.rtl .input-group>.input-group-append:not(:last-child)>.btn,
.rtl .input-group>.input-group-append:not(:last-child)>.input-group-text,
.rtl .input-group>.input-group-prepend>.btn,
.rtl .input-group>.input-group-prepend>.input-group-text {
  border-radius: 0 0.75rem 0.75rem 0;
}

.rtl .input-group>.input-group-append>.btn,
.rtl .input-group>.input-group-append>.input-group-text,
.rtl .input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.rtl .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.rtl .input-group>.input-group-prepend:not(:first-child)>.btn,
.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .input-group>.custom-select:not(:first-child),
.rtl .input-group>.form-control:not(:first-child) {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .input-group>.custom-select:not(:last-child),
.rtl .input-group>.form-control:not(:last-child) {
  border-radius: 0 0.75rem 0.75rem 0;
}

.rtl .input-group>.custom-select:not(:last-child):not(:first-child),
.rtl .input-group>.form-control:not(:last-child):not(:first-child) {
  border-radius: 0;
}

.rtl .custom-control {
  padding-right: 1.5rem;
  padding-left: inherit;
  margin-right: inherit;
  margin-left: 1rem;
}

.rtl .custom-control-indicator {
  right: 0;
  left: inherit;
}

.rtl .custom-file-label::after {
  right: initial;
  left: -1px;
  border-radius: .25rem 0 0 .25rem;
}

.rtl .radio input,
.rtl .radio-inline,
.rtl .checkbox input,
.rtl .checkbox-inline input {
  margin-right: -1.25rem;
  margin-left: inherit;
}

.rtl .list-group {
  padding-right: 0;
  padding-left: 40px;
}

.rtl .close {
  float: left;
}

.rtl .modal-header .close {
  margin: -15px auto -15px -15px;
}

.rtl .modal-footer> :not(:first-child) {
  margin-right: .25rem;
}

.rtl .alert-dismissible .close {
  right: inherit;
  left: 0;
}

.rtl .dropdown-toggle::after {
  margin-right: .255em;
  margin-left: 0;
}

.rtl .form-check-input {
  margin-right: -1.25rem;
  margin-left: inherit;
}

.rtl .form-check-label {
  padding-right: 1.25rem;
  padding-left: inherit;
}

.rtl .offset-1 {
  margin-right: 8.3333333333%;
  margin-left: 0;
}

.rtl .offset-2 {
  margin-right: 16.6666666667%;
  margin-left: 0;
}

.rtl .offset-3 {
  margin-right: 25%;
  margin-left: 0;
}

.rtl .offset-4 {
  margin-right: 33.3333333333%;
  margin-left: 0;
}

.rtl .offset-5 {
  margin-right: 41.6666666667%;
  margin-left: 0;
}

.rtl .offset-6 {
  margin-right: 50%;
  margin-left: 0;
}

.rtl .offset-7 {
  margin-right: 58.3333333333%;
  margin-left: 0;
}

.rtl .offset-8 {
  margin-right: 66.6666666667%;
  margin-left: 0;
}

.rtl .offset-9 {
  margin-right: 75%;
  margin-left: 0;
}

.rtl .offset-10 {
  margin-right: 83.3333333333%;
  margin-left: 0;
}

.rtl .offset-11 {
  margin-right: 91.6666666667%;
  margin-left: 0;
}

@media (min-width: 576px) {
  .rtl .offset-sm-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-sm-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-sm-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-sm-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-sm-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-sm-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-sm-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-sm-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .rtl .offset-md-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-md-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-md-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-md-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-md-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-md-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-md-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-md-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 992px) {
  .rtl .offset-lg-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-lg-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-lg-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-lg-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-lg-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-lg-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-lg-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-lg-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 1200px) {
  .rtl .offset-xl-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-xl-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xl-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-xl-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xl-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-xl-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xl-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-xl-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 1440) {
  .rtl .offset-xxl-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-xxl-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xxl-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-xxl-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xxl-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-xxl-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xxl-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-xxl-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

.rtl .mr-0,
.rtl .mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.rtl .ml-0,
.rtl .mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.rtl .mr-1,
.rtl .mx-1 {
  margin-right: 0 !important;
  margin-left: 0.25rem !important;
}

.rtl .ml-1,
.rtl .mx-1 {
  margin-left: 0 !important;
  margin-right: 0.25rem !important;
}

.rtl .mr-2,
.rtl .mx-2 {
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}

.rtl .ml-2,
.rtl .mx-2 {
  margin-left: 0 !important;
  margin-right: 0.5rem !important;
}

.rtl .mr-3,
.rtl .mx-3 {
  margin-right: 0 !important;
  margin-left: 1rem !important;
}

.rtl .ml-3,
.rtl .mx-3 {
  margin-left: 0 !important;
  margin-right: 1rem !important;
}

.rtl .mr-4,
.rtl .mx-4 {
  margin-right: 0 !important;
  margin-left: 1.5rem !important;
}

.rtl .ml-4,
.rtl .mx-4 {
  margin-left: 0 !important;
  margin-right: 1.5rem !important;
}

.rtl .mr-5,
.rtl .mx-5 {
  margin-right: 0 !important;
  margin-left: 3rem !important;
}

.rtl .ml-5,
.rtl .mx-5 {
  margin-left: 0 !important;
  margin-right: 3rem !important;
}

.rtl .pr-0,
.rtl .px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.rtl .pl-0,
.rtl .px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.rtl .pr-1,
.rtl .px-1 {
  padding-right: 0 !important;
  padding-left: 0.25rem !important;
}

.rtl .pl-1,
.rtl .px-1 {
  padding-left: 0 !important;
  padding-right: 0.25rem !important;
}

.rtl .pr-2,
.rtl .px-2 {
  padding-right: 0 !important;
  padding-left: 0.5rem !important;
}

.rtl .pl-2,
.rtl .px-2 {
  padding-left: 0 !important;
  padding-right: 0.5rem !important;
}

.rtl .pr-3,
.rtl .px-3 {
  padding-right: 0 !important;
  padding-left: 1rem !important;
}

.rtl .pl-3,
.rtl .px-3 {
  padding-left: 0 !important;
  padding-right: 1rem !important;
}

.rtl .pr-4,
.rtl .px-4 {
  padding-right: 0 !important;
  padding-left: 1.5rem !important;
}

.rtl .pl-4,
.rtl .px-4 {
  padding-left: 0 !important;
  padding-right: 1.5rem !important;
}

.rtl .pr-5,
.rtl .px-5 {
  padding-right: 0 !important;
  padding-left: 3rem !important;
}

.rtl .pl-5,
.rtl .px-5 {
  padding-left: 0 !important;
  padding-right: 3rem !important;
}

.rtl .mr-auto {
  margin-right: 0 !important;
  margin-left: auto !important;
}

.rtl .ml-auto {
  margin-right: auto !important;
  margin-left: 0 !important;
}

.rtl .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

@media (min-width: 576px) {

  .rtl .mr-sm-0,
  .rtl .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-sm-0,
  .rtl .mx-sm-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-sm-1,
  .rtl .mx-sm-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-sm-1,
  .rtl .mx-sm-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-sm-2,
  .rtl .mx-sm-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-sm-2,
  .rtl .mx-sm-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-sm-3,
  .rtl .mx-sm-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-sm-3,
  .rtl .mx-sm-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-sm-4,
  .rtl .mx-sm-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-sm-4,
  .rtl .mx-sm-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-sm-5,
  .rtl .mx-sm-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-sm-5,
  .rtl .mx-sm-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-sm-0,
  .rtl .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-sm-0,
  .rtl .px-sm-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-sm-1,
  .rtl .px-sm-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-sm-1,
  .rtl .px-sm-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-sm-2,
  .rtl .px-sm-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-sm-2,
  .rtl .px-sm-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-sm-3,
  .rtl .px-sm-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-sm-3,
  .rtl .px-sm-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-sm-4,
  .rtl .px-sm-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-sm-4,
  .rtl .px-sm-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-sm-5,
  .rtl .px-sm-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-sm-5,
  .rtl .px-sm-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-sm-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-sm-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {

  .rtl .mr-md-0,
  .rtl .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-md-0,
  .rtl .mx-md-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-md-1,
  .rtl .mx-md-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-md-1,
  .rtl .mx-md-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-md-2,
  .rtl .mx-md-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-md-2,
  .rtl .mx-md-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-md-3,
  .rtl .mx-md-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-md-3,
  .rtl .mx-md-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-md-4,
  .rtl .mx-md-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-md-4,
  .rtl .mx-md-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-md-5,
  .rtl .mx-md-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-md-5,
  .rtl .mx-md-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-md-0,
  .rtl .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-md-0,
  .rtl .px-md-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-md-1,
  .rtl .px-md-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-md-1,
  .rtl .px-md-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-md-2,
  .rtl .px-md-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-md-2,
  .rtl .px-md-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-md-3,
  .rtl .px-md-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-md-3,
  .rtl .px-md-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-md-4,
  .rtl .px-md-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-md-4,
  .rtl .px-md-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-md-5,
  .rtl .px-md-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-md-5,
  .rtl .px-md-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-md-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-md-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {

  .rtl .mr-lg-0,
  .rtl .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-lg-0,
  .rtl .mx-lg-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-lg-1,
  .rtl .mx-lg-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-lg-1,
  .rtl .mx-lg-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-lg-2,
  .rtl .mx-lg-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-lg-2,
  .rtl .mx-lg-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-lg-3,
  .rtl .mx-lg-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-lg-3,
  .rtl .mx-lg-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-lg-4,
  .rtl .mx-lg-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-lg-4,
  .rtl .mx-lg-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-lg-5,
  .rtl .mx-lg-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-lg-5,
  .rtl .mx-lg-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-lg-0,
  .rtl .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-lg-0,
  .rtl .px-lg-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-lg-1,
  .rtl .px-lg-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-lg-1,
  .rtl .px-lg-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-lg-2,
  .rtl .px-lg-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-lg-2,
  .rtl .px-lg-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-lg-3,
  .rtl .px-lg-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-lg-3,
  .rtl .px-lg-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-lg-4,
  .rtl .px-lg-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-lg-4,
  .rtl .px-lg-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-lg-5,
  .rtl .px-lg-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-lg-5,
  .rtl .px-lg-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-lg-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-lg-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {

  .rtl .mr-xl-0,
  .rtl .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-xl-0,
  .rtl .mx-xl-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-xl-1,
  .rtl .mx-xl-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-xl-1,
  .rtl .mx-xl-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-xl-2,
  .rtl .mx-xl-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-xl-2,
  .rtl .mx-xl-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-xl-3,
  .rtl .mx-xl-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-xl-3,
  .rtl .mx-xl-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-xl-4,
  .rtl .mx-xl-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-xl-4,
  .rtl .mx-xl-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-xl-5,
  .rtl .mx-xl-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-xl-5,
  .rtl .mx-xl-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-xl-0,
  .rtl .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-xl-0,
  .rtl .px-xl-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-xl-1,
  .rtl .px-xl-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-xl-1,
  .rtl .px-xl-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-xl-2,
  .rtl .px-xl-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-xl-2,
  .rtl .px-xl-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-xl-3,
  .rtl .px-xl-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-xl-3,
  .rtl .px-xl-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-xl-4,
  .rtl .px-xl-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-xl-4,
  .rtl .px-xl-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-xl-5,
  .rtl .px-xl-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-xl-5,
  .rtl .px-xl-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-xl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-xl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1440) {

  .rtl .mr-xxl-0,
  .rtl .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-xxl-0,
  .rtl .mx-xxl-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-xxl-1,
  .rtl .mx-xxl-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-xxl-1,
  .rtl .mx-xxl-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-xxl-2,
  .rtl .mx-xxl-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-xxl-2,
  .rtl .mx-xxl-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-xxl-3,
  .rtl .mx-xxl-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-xxl-3,
  .rtl .mx-xxl-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-xxl-4,
  .rtl .mx-xxl-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-xxl-4,
  .rtl .mx-xxl-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-xxl-5,
  .rtl .mx-xxl-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-xxl-5,
  .rtl .mx-xxl-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-xxl-0,
  .rtl .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-xxl-0,
  .rtl .px-xxl-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-xxl-1,
  .rtl .px-xxl-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-xxl-1,
  .rtl .px-xxl-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-xxl-2,
  .rtl .px-xxl-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-xxl-2,
  .rtl .px-xxl-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-xxl-3,
  .rtl .px-xxl-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-xxl-3,
  .rtl .px-xxl-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-xxl-4,
  .rtl .px-xxl-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-xxl-4,
  .rtl .px-xxl-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-xxl-5,
  .rtl .px-xxl-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-xxl-5,
  .rtl .px-xxl-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-xxl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-xxl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

.rtl .text-right {
  text-align: left !important;
}

.rtl .text-left {
  text-align: right !important;
}

@media (min-width: 576px) {
  .rtl .text-sm-right {
    text-align: left !important;
  }

  .rtl .text-sm-left {
    text-align: right !important;
  }
}

@media (min-width: 768px) {
  .rtl .text-md-right {
    text-align: left !important;
  }

  .rtl .text-md-left {
    text-align: right !important;
  }
}

@media (min-width: 992px) {
  .rtl .text-lg-right {
    text-align: left !important;
  }

  .rtl .text-lg-left {
    text-align: right !important;
  }
}

@media (min-width: 1200px) {
  .rtl .text-xl-right {
    text-align: left !important;
  }

  .rtl .text-xl-left {
    text-align: right !important;
  }
}

@media (min-width: 1440) {
  .rtl .text-xxl-right {
    text-align: left !important;
  }

  .rtl .text-xxl-left {
    text-align: right !important;
  }
}

.rtl .mx-0 {
  margin-right: auto;
  margin-left: 0 !important;
}

.rtl .mx-0 {
  margin-left: auto;
  margin-right: 0 !important;
}

.rtl .mx-1 {
  margin-right: auto;
  margin-left: 0.25rem !important;
}

.rtl .mx-1 {
  margin-left: auto;
  margin-right: 0.25rem !important;
}

.rtl .mx-2 {
  margin-right: auto;
  margin-left: 0.5rem !important;
}

.rtl .mx-2 {
  margin-left: auto;
  margin-right: 0.5rem !important;
}

.rtl .mx-3 {
  margin-right: auto;
  margin-left: 1rem !important;
}

.rtl .mx-3 {
  margin-left: auto;
  margin-right: 1rem !important;
}

.rtl .mx-4 {
  margin-right: auto;
  margin-left: 1.5rem !important;
}

.rtl .mx-4 {
  margin-left: auto;
  margin-right: 1.5rem !important;
}

.rtl .mx-5 {
  margin-right: auto;
  margin-left: 3rem !important;
}

.rtl .mx-5 {
  margin-left: auto;
  margin-right: 3rem !important;
}

.rtl .px-0 {
  padding-right: auto;
  padding-left: 0 !important;
}

.rtl .px-0 {
  padding-left: auto;
  padding-right: 0 !important;
}

.rtl .px-1 {
  padding-right: auto;
  padding-left: 0.25rem !important;
}

.rtl .px-1 {
  padding-left: auto;
  padding-right: 0.25rem !important;
}

.rtl .px-2 {
  padding-right: auto;
  padding-left: 0.5rem !important;
}

.rtl .px-2 {
  padding-left: auto;
  padding-right: 0.5rem !important;
}

.rtl .px-3 {
  padding-right: auto;
  padding-left: 1rem !important;
}

.rtl .px-3 {
  padding-left: auto;
  padding-right: 1rem !important;
}

.rtl .px-4 {
  padding-right: auto;
  padding-left: 1.5rem !important;
}

.rtl .px-4 {
  padding-left: auto;
  padding-right: 1.5rem !important;
}

.rtl .px-5 {
  padding-right: auto;
  padding-left: 3rem !important;
}

.rtl .px-5 {
  padding-left: auto;
  padding-right: 3rem !important;
}

.rtl .mr-auto {
  margin-right: 0 !important;
  margin-left: auto !important;
}

.rtl .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.rtl .ml-auto {
  margin-right: auto !important;
  margin-left: 0 !important;
}

.rtl .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .rtl .mx-sm-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-sm-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-sm-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-sm-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-sm-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-sm-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-sm-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-sm-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-sm-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-sm-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-sm-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-sm-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-sm-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-sm-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-sm-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-sm-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-sm-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-sm-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-sm-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-sm-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-sm-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-sm-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-sm-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-sm-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-sm-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-sm-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .rtl .mx-md-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-md-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-md-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-md-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-md-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-md-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-md-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-md-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-md-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-md-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-md-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-md-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-md-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-md-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-md-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-md-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-md-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-md-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-md-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-md-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-md-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-md-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-md-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-md-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-md-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-md-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .rtl .mx-lg-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-lg-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-lg-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-lg-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-lg-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-lg-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-lg-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-lg-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-lg-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-lg-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-lg-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-lg-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-lg-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-lg-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-lg-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-lg-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-lg-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-lg-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-lg-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-lg-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-lg-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-lg-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-lg-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-lg-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-lg-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-lg-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .rtl .mx-xl-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-xl-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-xl-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-xl-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-xl-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-xl-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-xl-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-xl-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-xl-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-xl-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-xl-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-xl-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-xl-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-xl-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-xl-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-xl-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-xl-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-xl-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-xl-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-xl-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-xl-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-xl-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-xl-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-xl-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-xl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-xl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1440) {
  .rtl .mx-xxl-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-xxl-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-xxl-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-xxl-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-xxl-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-xxl-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-xxl-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-xxl-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-xxl-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-xxl-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-xxl-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-xxl-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-xxl-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-xxl-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-xxl-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-xxl-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-xxl-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-xxl-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-xxl-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-xxl-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-xxl-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-xxl-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-xxl-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-xxl-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-xxl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-xxl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

.rtl .float-left {
  float: right !important;
}

.rtl .float-right {
  float: left !important;
}

.rtl .float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .rtl .float-sm-left {
    float: right !important;
  }

  .rtl .float-sm-right {
    float: left !important;
  }

  .rtl .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .rtl .float-md-left {
    float: right !important;
  }

  .rtl .float-md-right {
    float: left !important;
  }

  .rtl .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .rtl .float-lg-left {
    float: right !important;
  }

  .rtl .float-lg-right {
    float: left !important;
  }

  .rtl .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .rtl .float-xl-left {
    float: right !important;
  }

  .rtl .float-xl-right {
    float: left !important;
  }

  .rtl .float-xl-none {
    float: none !important;
  }
}

@media (min-width: 1440) {
  .rtl .float-xxl-left {
    float: right !important;
  }

  .rtl .float-xxl-right {
    float: left !important;
  }

  .rtl .float-xxl-none {
    float: none !important;
  }
}

[direction="rtl"][data-theme-version="dark"] .border,
[direction="rtl"][data-theme-version="dark"] .border-left,
[direction="rtl"][data-theme-version="dark"] .border-right {
  border-color: #333a54 !important;
}

[direction="rtl"] .text-right {
  text-align: left !important;
}

[direction="rtl"] .text-left {
  text-align: right !important;
}

[direction="rtl"] .border-right {
  border-left: 1px solid #f0f1f5 !important;
  border-right: 0 !important;
}

[direction="rtl"] .border-left {
  border-right: 1px solid #f0f1f5 !important;
  border-left: 0 !important;
}

[direction="rtl"] .dropdown-menu {
  left: auto;
}

[direction="rtl"] .dropdown-menu-right {
  left: 0;
  right: auto;
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .dropdown-menu-right {
    left: 15px;
  }
}

[direction="rtl"] .notification_dropdown .dropdown-menu-right .media>span {
  margin-left: 10px;
  margin-right: 0;
}

[direction="rtl"]:not([data-container="boxed"]) .nav-header {
  left: auto;
  right: 0;
}

[direction="rtl"][data-container="wide-boxed"] .nav-header {
  left: auto;
  right: 0;
}

[direction="rtl"] .nav-header {
  text-align: right;
  right: auto;
}

[direction="rtl"] .nav-header .brand-title {
  margin-left: 0;
  margin-right: 15px;
}

[direction="rtl"] .nav-header .brand-logo {
  padding-left: 0;
  padding-right: 1.75rem;
}

[data-sidebar-style="compact"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 0;
}

[data-sidebar-style="compact"][direction="rtl"] .nav-header .brand-logo[data-layout="horizontal"] {
  padding-right: 30px;
}

[data-sidebar-style="mini"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 0;
}

[data-sidebar-style="modern"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 0;
}

[data-layout="horizontal"][data-sidebar-style="modern"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 30px;
}

@media (max-width: 767.98px) {
  [direction="rtl"] .nav-header .brand-logo {
    padding-right: 0;
  }
}

[direction="rtl"] .nav-control {
  right: auto;
  left: -4.0625rem;
}

@media (max-width: 767.98px) {
  [direction="rtl"] .nav-control {
    left: -4.0625rem;
  }
}

@media (max-width: 575.98px) {
  [direction="rtl"] .nav-control {
    left: -4.0625rem;
  }
}

[direction="rtl"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active {
  right: 0;
}

[direction="rtl"][data-sidebar-style="compact"][data-layout="horizontal"] .nav-header .brand-logo {
  padding-right: 30px;
}

[direction="rtl"][data-sidebar-style="modern"][data-layout="horizontal"] .nav-header {
  width: 16rem;
}

[direction="rtl"] .header {
  padding: 0 0.9375rem;
  padding-right: 17.1875rem;
}

@media (max-width: 767.98px) {
  [direction="rtl"] .header {
    padding-right: 3.75rem;
    padding-left: 0;
  }
}

[direction="rtl"] .header .header-content {
  padding-left: 0;
  padding-right: 5.3125rem;
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .header .header-content {
    padding-right: 4.5rem;
  }
}

[data-sidebar-style="compact"][direction="rtl"] .header .header-content {
  padding-right: 1.875rem;
}

[data-sidebar-style="modern"][direction="rtl"] .header .header-content {
  padding-right: 5.3125rem;
}

[data-sidebar-style="overlay"][direction="rtl"] .header .header-content {
  padding-right: 5.3125rem;
}

[direction="rtl"] .header .nav-control {
  right: 0.4375rem;
  left: auto;
}

[direction="rtl"] .header-left .search_bar .dropdown-menu,
[direction="rtl"] .header-left .search_bar .dropdown-menu.show {
  right: 40px !important;
}

@media only screen and (max-width: 575px) {

  [direction="rtl"] .header-left .search_bar .dropdown-menu,
  [direction="rtl"] .header-left .search_bar .dropdown-menu.show {
    right: -100px !important;
  }
}

[direction="rtl"] .header-left .search_bar .search_icon {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5rem;
  border-bottom-right-radius: 5rem;
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .header-left .search_bar .search_icon {
    border-radius: 5rem;
  }
}

[direction="rtl"][data-layout="horizontal"] .header {
  padding: 0;
  padding-right: 16rem;
}

[direction="rtl"][data-layout="horizontal"] .header .header-content {
  padding-right: 1.875rem;
  padding-left: 1.875rem;
}

[direction="rtl"][data-layout="horizontal"][data-sidebar-style="mini"] .header {
  padding-right: 6rem;
}

[direction="rtl"][data-sidebar-style="mini"] .header {
  padding: 0 0.9375rem;
  padding-right: 3.75rem;
}

[direction="rtl"][data-sidebar-style="compact"] .header {
  padding: 0 0.9375rem;
  padding-right: 9.375rem;
}

[direction="rtl"][data-sidebar-style="compact"][data-layout="horizontal"] .header {
  padding: 0;
  padding-right: 16rem;
}

[direction="rtl"][data-sidebar-style="modern"] .header {
  padding: 0 0.9375rem;
  padding-right: 9.375rem;
}

[direction="rtl"][data-sidebar-style="modern"][data-layout="horizontal"] .header {
  padding: 0;
  padding-right: 16rem;
}

[direction="rtl"] {
  text-align: right;
}

[direction="rtl"] .deznav {
  text-align: right;
}

[direction="rtl"] .deznav .metismenu ul {
  padding: 0 25px 0 0;
}

[direction="rtl"] .deznav .metismenu ul:after {
  left: auto;
  right: 25px;
}

[direction="rtl"] .deznav .metismenu ul a:before {
  left: auto;
  right: -5px;
}

[direction="rtl"] .deznav .metismenu li>a svg {
  margin-left: 5px;
  margin-right: 0;
}

[data-sidebar-style="compact"][direction="rtl"] .deznav .metismenu li>a svg {
  left: auto;
  margin-left: auto;
  margin-right: auto;
}

[data-sidebar-style="icon-hover"][direction="rtl"] .deznav .metismenu li>a svg {
  margin-left: 0;
}

[direction="rtl"] .deznav .metismenu li.active>.has-arrow:after {
  transform: rotate(45deg) translateY(-50%);
}

[direction="rtl"] .deznav .metismenu .has-arrow:after {
  left: 1.5625rem;
  right: auto;
}

[data-layout="horizontal"][direction="rtl"] .deznav .metismenu .has-arrow:after {
  left: 1.125rem;
}

[data-sidebar-style="modern"][direction="rtl"] .deznav .metismenu .has-arrow:after {
  transform: rotate(-45deg) translateY(-50%);
}

[direction="rtl"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul li:hover ul {
  right: 11.8125rem;
  left: 0;
}

[direction="rtl"] .list-group {
  padding-left: 0;
}

[direction="rtl"] .form-check-input {
  margin-left: -1.25rem;
  margin-right: inherit;
}

[direction="rtl"] .form-check-inline .form-check-input {
  margin-right: 0;
  margin-left: 10px;
}

[direction="rtl"] .radio input,
[direction="rtl"] .radio-inline,
[direction="rtl"] .checkbox input,
[direction="rtl"] .checkbox-inline input {
  margin-left: 0;
  margin-right: 0;
}

[direction="rtl"] .content-body {
  margin-right: 17.1875rem;
  margin-left: auto;
}

[data-sidebar-style="modern"][direction="rtl"] .content-body {
  margin-right: 9.375rem;
}

[direction="rtl"] .content-body .page-titles {
  text-align: right;
}

[direction="rtl"][data-layout="horizontal"] .content-body {
  margin-right: 0;
}

[direction="rtl"][data-layout="horizontal"] .deznav .metismenu li li .has-arrow:after {
  transform: rotate(-45deg) translateY(-50%);
}

[direction="rtl"][data-sidebar-style="mini"]:not([data-layout="horizontal"]) .content-body {
  margin-right: 3.75rem;
}

[direction="rtl"][data-sidebar-style="compact"]:not([data-layout="horizontal"]) .content-body {
  margin-right: 9.375rem;
}

[direction="rtl"][data-sidebar-style="overlay"] .content-body {
  margin-right: 0;
}

[direction="rtl"] #external-events .external-event:before {
  margin-right: 0;
  margin-left: .9rem;
}

[direction="rtl"] .post-input a i {
  margin-left: 15px;
  margin-right: 0;
}

@media only screen and (max-width: 1350px) and (min-width: 1200px) {
  [direction="rtl"] .content-body {
    margin-right: 14.375rem;
  }
}

[direction="rtl"] .sidebar-right {
  left: -15.625rem;
  right: auto;
  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
}

[direction="rtl"] .sidebar-right.show {
  left: 0;
  right: auto;
}

[direction="rtl"] .sidebar-right .sidebar-right-trigger {
  left: 100%;
  right: auto;
  border-radius: 0 5px 5px 0;
  box-shadow: 5px 3px 5px 0px rgba(119, 119, 119, 0.15);
}

[direction="rtl"] .bootstrap-select .dropdown-toggle .filter-option {
  text-align: right;
}

html[dir="rtl"] [direction="rtl"] .footer {
  padding-right: 17.1875rem;
  padding-left: 0;
}

@media (max-width: 767.98px) {
  html[dir="rtl"] [direction="rtl"] .footer {
    padding-right: 0;
  }
}

html[dir="rtl"] [direction="rtl"][data-sidebar-style="overlay"] .footer {
  padding-right: 0;
}

html[dir="rtl"] [direction="rtl"] .menu-toggle .footer {
  padding-right: 3.75rem;
}

html[dir="rtl"] [direction="rtl"][data-container="boxed"] .footer {
  padding-right: 0;
}

html[dir="rtl"] [direction="rtl"][data-sidebar-style="mini"]:not([data-layout="horizontal"]) .footer {
  padding-right: 3.75rem;
}

html[dir="rtl"] [direction="rtl"][data-sidebar-style="compact"]:not([data-layout="horizontal"]) .footer {
  padding-right: 9.375rem;
}

.nav-label {
  margin: 10px 30px 0;
  padding: 1.5625rem 0 10px;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05rem;
  border-top: 1px solid #eaeaea;
  color: #999999;
}

[data-theme-version="dark"] .nav-label {
  border-color: #333a54;
}

.nav-label.first {
  border: 0px;
  margin-top: 0px;
}

.nav-badge {
  position: absolute;
  right: 2.8125rem;
  top: 0.625rem;
}

.content-body {
  margin-left: 230px;
  z-index: 0;
  transition: all .2s ease;
}

@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .content-body {
    margin-left: 15rem;
  }
}

.bell img {
  -webkit-animation: ring 8s .7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 8s .7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 8s .7s ease-in-out infinite;
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }

  1% {
    transform: rotate(30deg);
  }

  3% {
    transform: rotate(-28deg);
  }

  5% {
    transform: rotate(34deg);
  }

  7% {
    transform: rotate(-32deg);
  }

  9% {
    transform: rotate(30deg);
  }

  11% {
    transform: rotate(-28deg);
  }

  13% {
    transform: rotate(26deg);
  }

  15% {
    transform: rotate(-24deg);
  }

  17% {
    transform: rotate(22deg);
  }

  19% {
    transform: rotate(-20deg);
  }

  21% {
    transform: rotate(18deg);
  }

  23% {
    transform: rotate(-16deg);
  }

  25% {
    transform: rotate(14deg);
  }

  27% {
    transform: rotate(-12deg);
  }

  29% {
    transform: rotate(10deg);
  }

  31% {
    transform: rotate(-8deg);
  }

  33% {
    transform: rotate(6deg);
  }

  35% {
    transform: rotate(-4deg);
  }

  37% {
    transform: rotate(2deg);
  }

  39% {
    transform: rotate(-1deg);
  }

  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(0);
  }
}

.deznav {
  width: 21.563rem;
  padding-bottom: 0;
  height: 100%;
  position: absolute;
  top: 0;
  padding-top: 5rem;
  z-index: 3;
  background-color: #3C4B64;
  transition: all .2s ease;
}

@media only screen and (max-width: 1199px) {
  .deznav {
    padding-top: 80px;
  }
}

@media only screen and (max-width: 767px) {
  .deznav {
    width: 18rem;
  }
}

.deznav .deznav-scroll {
  position: relative;
  height: 100%;
}

@media only screen and (min-width: 1200px) and (max-width: 1400px) {
  .deznav {
    width: 15rem;
  }
}

.deznav ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.deznav .metismenu {
  display: flex;
  flex-direction: column;
  padding-top: 0px;
}

@media only screen and (max-width: 767px) {
  .deznav .metismenu {
    padding-top: 0;
  }
}

.deznav .metismenu.fixed {
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
}

.deznav .metismenu>li {
  display: flex;
  flex-direction: column;
}

.deznav .metismenu>li a>i {
  font-size: 1.2rem;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  top: 0;
  height: 50px;
  width: 40px;
  border-radius: 1.25rem;
  line-height: 50px;
  text-align: center;
  transition: all 0.5s;
  margin-right: 15px;
}

[data-sidebar-style="compact"] .deznav .metismenu>li a>i {
  display: block;
  padding: 0;
}

@media only screen and (max-width: 1300px) {
  .deznav .metismenu>li a>i {
    height: auto;
    width: auto;
    margin-right: 0;
    line-height: 1;
    padding: 0;
  }
}

@media only screen and (max-width: 767px) {
  .deznav .metismenu>li a>i {
    font-size: 1.25rem;
    padding: 0 .75rem 0 0;
    margin-right: 0px;
  }
}

.deznav .metismenu>li>a {
  font-weight: 500;
  display: inline-block;
  font-size: 15px;
}

.deznav .metismenu>li>a svg {
  max-width: 24px;
  max-height: 24px;
  height: 100%;
  margin-right: 5px;
  margin-top: -3px;
  color: #00ADEE;
}

.deznav .metismenu>li>a g [fill] {
  fill: #00ADEE;
}

.deznav .metismenu>li:hover>a,
.deznav .metismenu>li:focus>a {
  color: #00ADEE;
}

.deznav .metismenu>li:hover>a g [fill],
.deznav .metismenu>li:focus>a g [fill] {
  fill: #00ADEE;
}

.deznav .metismenu>li.mm-active>a {
  color: #00ADEE;
}

.deznav .metismenu>li.mm-active>a g [fill] {
  fill: #00ADEE;
}

.deznav .metismenu li {
  position: relative;
}

.deznav .metismenu ul {
  transition: all .2s ease-in-out;
  position: relative;
  z-index: 1;
  padding: 0 0;
}

.deznav .metismenu ul a {
  padding-top: .5rem;
  padding-bottom: .5rem;
  position: relative;
  font-size: 16px;
  padding-left: 6rem;
}

@media only screen and (max-width: 1400px) {
  .deznav .metismenu ul a {
    padding-left: 6rem;
    font-size: 14px;
  }
}

@media only screen and (max-width: 767px) {
  .deznav .metismenu ul a {
    padding-left: 3.5rem;
  }
}

.deznav .metismenu ul a:hover,
.deznav .metismenu ul a:focus,
.deznav .metismenu ul a.mm-active {
  text-decoration: none;
  color: #00ADEE;
}

.deznav .metismenu a {
  position: relative;
  display: block;
  padding: 0.625rem 1.875rem;
  outline-width: 0;
  color: #fff;
  text-decoration: none;
}

@media only screen and (max-width: 767px) {
  .deznav .metismenu a {
    padding: 0.625rem 1.25rem;
  }
}

.deznav .metismenu .has-arrow:after {
  width: .5rem;
  height: .5rem;
  right: 1.875rem;
  top: 48%;
  border-color: inherit;
  transform: rotate(-225deg) translateY(-50%);
}

.deznav .metismenu .has-arrow[aria-expanded=true]:after,
.deznav .metismenu .mm-active>.has-arrow:after {
  transform: rotate(-135deg) translateY(-50%);
}

@media only screen and (max-width: 1199px) {
  .nav-header {
    width: 5rem;
  }
}

@media (max-width: 767px) {
  .brand-title {
    display: none;
  }

  .footer {
    padding-left: 0;
  }

  .deznav {
    left: 0;
    top: 5rem;
    padding-top: 1rem;
  }
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu>ul.collapse:not(.in),
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu>ul.collapse:not(.in) {
  height: 252px !important;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu:hover>a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu:hover>a {
  width: calc(70vw + 3.75rem);
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu:hover>ul,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu:hover>ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-height: 13.75rem;
  width: 70vw;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu:hover>ul ul a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu:hover>ul ul a {
  width: 101%;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-xl:hover>a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-xl:hover>a {
  width: calc(70vw + 3rem);
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-xl:hover>ul,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-xl:hover>ul {
  max-height: 200px;
  width: 70vw;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-xl:hover>ul ul a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-xl:hover>ul ul a {
  width: 101%;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-lg:hover>a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-lg:hover>a {
  width: calc(55vw + 3rem);
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-lg:hover>ul,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-lg:hover>ul {
  max-height: 200px;
  width: 55vw;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-lg:hover>ul ul a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-lg:hover>ul ul a {
  width: 101%;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-md:hover>a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-md:hover>a {
  width: calc(45vw + 3);
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-md:hover>ul,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-md:hover>ul {
  max-height: 18.75rem;
  width: 45vw;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-md:hover>ul ul a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-md:hover>ul ul a {
  width: 101%;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-sm:hover>a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-sm:hover>a {
  width: calc(30vw + 3);
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-sm:hover>ul,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-sm:hover>ul {
  max-height: 18.125rem;
  width: 30vw;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mega-menu-sm:hover>ul ul a,
[data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mega-menu-sm:hover>ul ul a {
  width: 101%;
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu:hover>a {
  width: calc(60vw + 3.75rem);
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu:hover>ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-height: 25rem;
  width: 60vw;
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu:hover>ul ul a {
  width: 101%;
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-xl:hover>a {
  width: calc(60vw + 3.75rem);
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-xl:hover>ul {
  max-height: 25.625rem;
  width: 60vw;
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-lg:hover>a {
  width: calc(50vw + 3.75rem);
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-lg:hover>ul {
  max-height: 16.25rem;
  width: 50vw;
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-md:hover>a {
  width: calc(40vw + 3.75rem);
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-md:hover>ul {
  max-height: 18.75rem;
  width: 40vw;
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-sm:hover>a {
  width: calc(22vw + 3.75rem);
}

[data-sidebar-style="mini"][data-layout="vertical"][data-container="boxed"] .deznav .metismenu>li.mega-menu-sm:hover>ul {
  max-height: 18.125rem;
  width: 22vw;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu:not(:last-child) {
  position: static;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul {
  left: 0;
  right: 0;
}

[data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #333a54;
}

[data-sibebarbg="color_2"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #03090f;
}

[data-sibebarbg="color_3"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #551ba1;
}

[data-sibebarbg="color_4"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #22134e;
}

[data-sibebarbg="color_5"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #711717;
}

[data-sibebarbg="color_6"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #121843;
}

[data-sibebarbg="color_7"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #3511d0;
}

[data-sibebarbg="color_8"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #1161aa;
}

[data-sibebarbg="color_9"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #002629;
}

[data-sibebarbg="color_10"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li {
  border-color: #af5b00;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li a {
  transition: all .4s ease-in-out;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu ul li a:hover {
  border-radius: 0.25rem;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-height: 13.75rem;
  width: 70vw;
  z-index: 99;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  content: "";
  height: 100%;
  width: 1px;
  position: absolute;
  background-color: #fff;
  right: 2.8125rem;
  top: 0;
}

[data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #1d2544;
}

[data-sibebarbg="color_2"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #0c223a;
}

[data-sibebarbg="color_3"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #6d23cc;
}

[data-sibebarbg="color_4"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #331d77;
}

[data-sibebarbg="color_5"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #9c1f1f;
}

[data-sibebarbg="color_6"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #1d276b;
}

[data-sibebarbg="color_7"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #4c27ed;
}

[data-sibebarbg="color_8"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #167cd8;
}

[data-sibebarbg="color_9"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #00545c;
}

[data-sibebarbg="color_10"][data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul::after {
  background-color: #e27500;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu:hover>ul ul a {
  width: 101%;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu-xl:hover>ul {
  max-height: 210px;
  width: 70vw;
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu-lg:hover>ul {
  max-height: 210px;
  width: 700px;
  height: 210px !important;
}

@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  [data-layout="horizontal"] .deznav .metismenu>li.mega-menu-lg:hover>ul {
    width: 700px;
  }
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu-md:hover>ul {
  max-height: 20rem;
  width: 54vw;
}

@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  [data-layout="horizontal"] .deznav .metismenu>li.mega-menu-md:hover>ul {
    width: 60vw;
  }
}

[data-layout="horizontal"] .deznav .metismenu>li.mega-menu-sm:hover>ul {
  max-height: 20rem;
  width: 25vw;
}

@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  [data-layout="horizontal"] .deznav .metismenu>li.mega-menu-sm:hover>ul {
    width: 35vw;
  }
}

[data-layout="horizontal"][data-container="boxed"] .deznav .metismenu>li.mega-menu:hover>ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

[data-layout="horizontal"][data-container="boxed"] .deznav .metismenu>li.mega-menu-xl:hover>ul {
  max-height: 21.875rem;
  width: 100%;
}

[data-layout="horizontal"][data-container="boxed"] .deznav .metismenu>li.mega-menu-lg:hover>ul {
  max-height: 21.875rem;
  width: 55vw;
}

[data-layout="horizontal"][data-container="boxed"] .deznav .metismenu>li.mega-menu-md:hover>ul {
  max-height: 18.75rem;
  width: 45vw;
}

[data-layout="horizontal"][data-container="boxed"] .deznav .metismenu>li.mega-menu-sm:hover>ul {
  max-height: 18.125rem;
  width: 50vw;
}

/*\$primary  : #7356f1 !default;*/
/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
[data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li {
  padding: 0 0 0 10px;
}

[data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li>a {
  font-size: 13px;
  padding: 2px 4px;
  border-top-left-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  transition: all 0.5s;
  position: relative;
}

@media only screen and (max-width: 1400px) {
  [data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li>a {
    padding: 4px 6px;
    font-size: 13px;
  }
}

[data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a {
  color: #000;
  background: #E5E6E7;
}

[data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a i {
  color: #00ADEE;
  background: #fff;
  box-shadow: 0px 0px 10px 3px rgba(135, 67, 223, 0.2);
}

[data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li .has-arrow:after {
  right: 2.5rem;
}

@media only screen and (max-width: 1400px) {
  [data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li .has-arrow:after {
    right: 1.5rem;
  }
}

@media only screen and (max-width: 1400px) {
  [data-sidebar-style="full"][data-layout="vertical"] .deznav .metismenu>li {
    padding: 0;
  }
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header {
  width: 5rem;
  z-index: 999;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .brand-logo {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #00ADEE !important;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .copyright,
[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .add-menu-sidebar {
  display: none;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .header {
  padding-left: 6rem;
  width: 100%;
}

[direction="rtl"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .header {
  padding: 0 0.9375rem;
  padding-right: 5rem;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav {
  width: 5rem;
  overflow: visible;
  position: absolute;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .nav-text {
  display: none;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .slimScrollDiv,
[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .deznav-scroll {
  overflow: visible !important;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li {
  position: relative;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li a {
  padding: 13px;
  border-radius: 1.25rem;
  margin: 2px 0;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li a svg {
  max-width: 24px;
  max-height: 24px;
  margin-right: 0;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li a:before {
  content: none;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul {
  position: absolute;
  left: 5rem;
  top: 0;
  width: 12rem;
  z-index: 1001;
  display: none;
  padding-left: 1px;
  height: auto !important;
  box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);
  border-radius: 6px;
  margin-left: 0;
  border: 0;
  background: #3C4B67;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul:after {
  content: "";
  position: absolute;
  background: inherit;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  left: -5px;
  top: 20px;
}

[direction="rtl"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul {
  left: auto;
  right: 3rem;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul li:hover ul {
  left: 11.8125rem;
  top: 0;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul li:hover ul:after {
  content: none;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li:hover>ul {
  display: block;
  height: auto;
  overflow: visible;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li {
  transition: all 0.4s ease-in-out;
  padding: 0 13px;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li>a {
  text-align: center;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li>a.has-arrow:after {
  display: none;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li>a i {
  padding: 0;
  width: auto;
  height: auto;
  background: transparent;
  margin: 0;
  line-height: 1;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a {
  background: #00ADEE;
  border-radius: 1.25rem;
  color: #fff;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a i {
  color: #fff;
  padding: 0;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover:nth-last-child(-n + 1)>ul {
  bottom: 0;
  top: auto;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  border-radius: 1.25rem;
  background: #00ADEE;
  color: #fff;
}

[data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background: #1e2746;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a i {
  color: #fff;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>ul {
  height: auto !important;
  padding: 10px 0;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>ul a {
  padding: 6px 20px 6px 20px;
  margin-left: -.1rem;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>ul ul {
  padding: 10px 0;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>ul ul a {
  padding: 6px 20px 6px 20px;
  margin-left: -.1rem;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu .nav-label,
[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu .nav-badge {
  display: none;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .content-body {
  margin-left: 5rem;
}

[direction="rtl"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .content-body {
  margin-right: 5rem;
  margin-left: auto;
  border: 0;
}

[data-sidebar-style="full"][data-layout="vertical"] .menu-toggle+.footer {
  padding-left: 5rem;
}

[direction="rtl"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle+.footer {
  padding-left: 0;
  padding-right: 5rem;
}

[data-sidebar-style="full"][data-layout="horizontal"] .deznav .metismenu {
  padding: 0 30px;
}

[data-sidebar-style="full"][data-layout="horizontal"] .header .header-content {
  padding-left: 1.875rem;
}

/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
/*\$primary  : #7356f1 !default;*/
@media only screen and (min-width: 768px) {
  [data-sidebar-style="mini"] .nav-header {
    width: 5rem;
  }

  [data-sidebar-style="mini"] .nav-header .nav-control {
    z-index: -1;
  }

  [data-sidebar-style="mini"] .nav-header .nav-control .hamburger {
    left: 5rem !important;
  }

  [data-sidebar-style="mini"] .nav-header .nav-control .hamburger .line {
    background-color: #B1B1B1 !important;
  }

  [data-sidebar-style="mini"] .nav-header .brand-title {
    display: none;
  }

  [data-sidebar-style="mini"] .nav-header .hamburger {
    display: none;
  }

  [data-sidebar-style="mini"] .header .header-content {
    padding-left: 1.875rem;
  }

  [direction="rtl"][data-sidebar-style="mini"] .header .header-content {
    padding-right: 1.875rem;
  }

  [data-sidebar-style="mini"] .deznav {
    width: 5rem;
    overflow: visible;
    position: absolute !important;
  }

  [data-sidebar-style="mini"] .deznav .copyright,
  [data-sidebar-style="mini"] .deznav .add-menu-sidebar {
    display: none;
  }

  [data-sidebar-style="mini"] .deznav .nav-text {
    display: none;
  }

  [data-sidebar-style="mini"] .deznav .slimScrollDiv,
  [data-sidebar-style="mini"] .deznav .deznav-scroll {
    overflow: visible !important;
  }

  [data-sidebar-style="mini"] .deznav .nav-user {
    padding: 11px;
  }

  [data-sidebar-style="mini"] .deznav .nav-user .media-body {
    display: none;
  }

  [data-sidebar-style="mini"] .deznav .metismenu li a {
    padding: 0.813rem 1rem;
  }

  [data-sidebar-style="mini"] .deznav .metismenu li a svg {
    margin-right: 0;
  }

  [data-sidebar-style="mini"] .deznav .metismenu li>ul {
    position: absolute;
    left: 5rem;
    top: 2.9375rem;
    width: 11.875rem;
    z-index: 1001;
    display: none;
    padding-left: 1px;
    box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);
    height: auto !important;
    border-radius: 6px;
    background: #3C4B67;
  }

  [direction="rtl"]:not([data-layout="horizontal"])[data-sidebar-style="mini"] .deznav .metismenu li>ul {
    left: auto;
    right: 5rem;
    box-shadow: -6px 6px 10px rgba(0, 0, 0, 0.15);
  }

  [data-sidebar-style="mini"] .deznav .metismenu>li {
    padding: 2px 15px;
  }

  [data-sidebar-style="mini"] .deznav .metismenu>li>a.has-arrow:after {
    display: none;
  }

  [data-sidebar-style="mini"] .deznav .metismenu .nav-label,
  [data-sidebar-style="mini"] .deznav .metismenu .nav-badge {
    display: none;
  }

  [data-sidebar-style="mini"] .content-body {
    margin-left: 5rem;
  }

  [data-sidebar-style="mini"] .footer {
    padding-left: 5rem;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li:hover>ul {
    display: block;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:nth-last-child(-n + 1)>ul {
    bottom: 0;
    top: auto !important;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:nth-last-child(-n + 1)>ul:after {
    top: auto;
    bottom: 20px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:nth-last-child(-n + 1)>ul {
    bottom: 0;
    top: auto !important;
  }
}

@media only screen and (min-width: 768px) {
  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li>ul {
    overflow: visible;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li>ul:after {
    content: none;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li>ul li:hover ul {
    padding: 10px 0;
    width: 13rem;
    left: 13rem;
    top: -10px;
    border: 0;
    margin: 0;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li>ul li:hover ul:after {
    content: none;
  }

  [direction="rtl"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li>ul li:hover ul {
    left: auto;
    right: 13rem;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a {
    background: #00ADEE;
    color: #fff;
    border-radius: 1.25rem;
  }

  [data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a {
    background: #1e2746;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
    background: #00ADEE;
    color: #fff;
    border-radius: 1.25rem;
    position: unset;
  }

  [data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
    background: #1e2746;
  }

  [direction="rtl"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a .nav-text {
    padding-left: auto;
    padding-right: 1.6875rem;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul {
    height: auto !important;
    overflow: visible;
    border: 0;
    margin-left: 0;
    left: 5rem;
    width: 13rem;
    border-radius: 12px;
    border: 0;
    padding: 10px 0;
    top: 0;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul:after {
    content: "";
    position: absolute;
    background: inherit;
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    left: -5px;
    top: 20px;
  }

  [data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul {
    box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.1);
  }

  [direction="rtl"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul {
    left: auto;
    right: 5rem;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul a {
    padding: 6px 20px 6px 20px;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul a:before {
    content: none;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul a.has-arrow:after {
    right: 1.25rem;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul ul a {
    padding: 6px 20px 6px 20px;
    margin-left: -1.6px;
  }

  [data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>ul ul a:before {
    content: none;
  }

  [data-sidebar-style="mini"][data-header-position="fixed"][data-container="boxed"][data-layout="vertical"] .header {
    width: 1199px;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .deznav .metismenu {
    padding: 0 30px;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .deznav .metismenu>li>a {
    padding: 15px 20px;
  }

  [direction="rtl"][data-sidebar-style="mini"][data-layout="horizontal"] .deznav .metismenu>li>a {
    padding: 15px 20px;
  }

  [direction="rtl"][data-sidebar-style="mini"][data-layout="horizontal"] .deznav .metismenu>li>a svg {
    margin-left: 0;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .deznav .metismenu>li>a svg {
    margin-right: 0;
    margin-top: 0;
  }
}

@media only screen and (max-width: 1199px) {
  [data-sidebar-style="mini"] .deznav li.mm-active ul {
    height: auto !important;
  }

  [data-sidebar-style="mini"] .deznav li a.has-arrow::after {
    transform: rotate(-45deg) translateY(-50%);
  }
}

/*\$primary  : #7356f1 !default;*/
@media (min-width: 1199px) {
  [data-layout="horizontal"] .nav-header {
    width: 16rem;
  }

  [data-layout="horizontal"] .nav-header .nav-control {
    display: none;
  }

  [data-layout="horizontal"] .nav-header .brand-logo {
    /*  padding-left: 0;
       justify-content: center; */
  }

  [data-layout="horizontal"] .header {
    width: 100%;
    padding-left: 16rem;
  }

  [data-layout="horizontal"] .deznav {
    width: 100%;
    position: relative;
    height: auto;
    padding-bottom: 0;
    top: 0;
    z-index: 2;
  }

  [data-layout="horizontal"] .deznav .slimScrollDiv {
    overflow: visible !important;
  }

  [data-layout="horizontal"] .deznav .slimScrollDiv .deznav-scroll {
    overflow: visible !important;
  }

  [data-layout="horizontal"] .deznav .deznav-scroll {
    overflow: visible !important;
  }

  [data-layout="horizontal"] .deznav .slimScrollBar {
    display: none !important;
  }

  [data-layout="horizontal"] .deznav .nav-user,
  [data-layout="horizontal"] .deznav .nav-label {
    display: none;
  }

  [data-layout="horizontal"] .deznav .metismenu {
    flex-direction: row;
  }

  [data-layout="horizontal"] .deznav .metismenu .collapse.in {
    display: none;
  }

  [data-layout="horizontal"] .deznav .metismenu ul {
    border-left: 0;
  }

  [data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu ul {
    box-shadow: 0px 10px 13px 0px rgba(0, 0, 0, 0.1);
  }

  [data-layout="horizontal"] .deznav .metismenu li {
    flex-direction: column;
    position: relative;
  }

  [data-layout="horizontal"] .deznav .metismenu li:hover>ul {
    display: block;
  }

  [data-layout="horizontal"] .deznav .metismenu li>ul {
    position: absolute;
    height: auto !important;
    top: 3.25rem;
    width: 100%;
    min-width: 13.75rem;
    z-index: 999;
    left: auto;
    right: auto;
    padding: 0.5rem 0;
    display: none;
    box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);
    margin: 0;
    background: #3C4B67;
  }

  [data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu li>ul {
    box-shadow: 0px 10px 13px 0px rgba(0, 0, 0, 0.1);
  }

  [data-layout="horizontal"] .deznav .metismenu li>ul li {
    padding: 0;
  }

  [data-layout="horizontal"] .deznav .metismenu li>ul li a {
    transition: all .4s ease-in-out;
    padding: 8px 20px 8px 45px;
    margin-left: -.1rem;
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu li>ul li a {
    padding: 8px 45px 8px 20px;
    text-align: right;
  }

  [data-layout="horizontal"] .deznav .metismenu li>ul li a:hover {
    border-radius: .4rem;
  }

  [data-layout="horizontal"] .deznav .metismenu li>ul li a:before {
    left: 22px;
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu li>ul li a:before {
    left: auto;
    right: 21px;
  }

  [data-layout="horizontal"] .deznav .metismenu li>ul ul {
    left: 100%;
    top: 0;
    box-shadow: 0px 10px 13px 0px rgba(82, 63, 105, 0.05);
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu li>ul ul {
    left: auto;
    right: 100%;
  }

  [data-layout="horizontal"] .deznav .metismenu>li {
    flex: 0 0 auto;
    position: relative;
  }

  [data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li {
    border-color: rgba(255, 255, 255, 0.07);
  }

  [data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li.mm-active {
    border-color: transparent;
  }

  [data-layout="horizontal"] .deznav .metismenu>li.mm-active {
    padding: 0;
  }

  [data-layout="horizontal"] .deznav .metismenu>li.mm-active>a {
    background: #fff;
    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu>li:first-child {
    border-right: 0;
  }

  [data-theme-version="dark"][direction="rtl"][data-layout="horizontal"] .deznav .metismenu>li {
    border-color: #333a54;
  }

  [data-layout="horizontal"] .deznav .metismenu>li>a {
    padding: 15px 40px 15px 15px;
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu>li>a {
    padding: 15px 15px 15px 40px;
  }

  [data-layout="horizontal"] .deznav .metismenu>li>a i {
    padding: 0 0.4375rem 0 0;
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu>li>a i {
    padding: 0 0 0 0.4375rem;
  }

  [data-layout="horizontal"] .deznav .metismenu>li>a .nav-badge {
    display: none;
  }

  [data-layout="horizontal"] .deznav .metismenu>li>a:after {
    right: 20px;
    transform: rotate(-135deg) translateY(-50%);
  }

  [data-layout="horizontal"] .deznav .metismenu>li:hover {
    border-color: transparent;
  }

  [data-layout="horizontal"] .deznav .metismenu>li:hover>ul {
    display: flex !important;
    flex-direction: column;
    flex-wrap: wrap;
    height: auto !important;
    box-shadow: 0px 10px 13px 0px rgba(82, 63, 105, 0.05);
  }

  [data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li:hover>ul {
    box-shadow: 0px 0 13px 0px rgba(0, 0, 0, 0.1);
  }

  [data-layout="horizontal"] .deznav .metismenu>li>ul>li:hover ul.collapse {
    display: block !important;
    position: absolute;
    left: auto !important;
    right: -100% !important;
    top: 0 !important;
  }

  [data-layout="horizontal"] .deznav .metismenu>li:nth-last-child(-n + 5)>ul {
    left: auto;
    right: 0;
  }

  [data-layout="horizontal"] .deznav .metismenu>li:nth-last-child(-n + 5)>ul>li:hover ul.collapse {
    right: auto !important;
    left: -100% !important;
  }

  [data-layout="horizontal"] .deznav .metismenu>li:last-child>ul ul {
    left: -100%;
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu>li:nth-last-child(-n + 3)>ul {
    left: 0;
    right: auto;
  }

  [direction="rtl"][data-layout="horizontal"] .deznav .metismenu>li:nth-last-child(-n + 3)>ul>li:hover ul.collapse {
    right: -100% !important;
    left: auto !important;
  }

  [data-layout="horizontal"] .content-body {
    margin-left: 0;
  }

  [data-layout="horizontal"] .content-body .page-titles {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 1.875rem;
  }

  [data-layout="horizontal"] .footer {
    margin-left: 0;
    margin: 0 auto;
    padding-left: 0;
  }

  [data-layout="horizontal"] .sidebar-right {
    z-index: 1;
  }

  [data-header-position="fixed"][data-layout="horizontal"] .deznav {
    top: 5rem;
  }

  [data-header-position="fixed"][data-sidebar-position="fixed"] .deznav {
    position: fixed;
  }

  [data-header-position="fixed"][data-layout="horizontal"][data-sidebar-position="fixed"] .content-body {
    padding-top: 8.3rem;
  }

  [data-layout="horizontal"][data-container="boxed"] .footer {
    margin-left: 0;
    max-width: 1199px;
    margin: 0 auto;
  }

  [data-layout="horizontal"][data-container="wide"] .page-titles {
    margin-left: -30px;
    margin-right: -30px;
  }

  [data-layout="horizontal"][data-sidebar-style="compact"] .page-titles {
    margin-top: 0;
  }

  [data-layout="horizontal"][data-sidebar-style="compact"] .deznav .metismenu>li>ul {
    top: 4.315rem;
  }

  [data-layout="horizontal"][data-sidebar-style="compact"] .deznav .metismenu>li>a {
    padding: 0.8125rem 2.1rem;
  }

  [data-layout="horizontal"][data-sidebar-style="compact"] .deznav .metismenu>li>a::after {
    display: none;
  }

  [data-layout="horizontal"][data-sidebar-style="compact"] .deznav .metismenu>li li {
    text-align: left;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .nav-header {
    width: 6rem;
    padding-left: 30px;
    padding-right: 30px;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .nav-header .brand-logo {
    justify-content: start;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .header {
    width: 100%;
    padding-left: 6rem;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .metismenu>li:hover a {
    width: auto;
  }

  [data-sidebar-style="mini"][data-layout="horizontal"] .metismenu>li:hover a .nav-text {
    display: none;
  }

  [data-header-position="fixed"][data-layout="horizontal"][data-sidebar-position="fixed"][data-sidebar-style="compact"] .content-body {
    padding-top: 8.75rem;
  }

  [data-sidebar-position="fixed"][data-layout="horizontal"] .deznav.fixed {
    position: fixed;
    left: 0;
    top: 0;
  }
}

@media (min-width: 767px) {
  [data-sidebar-style="compact"] .deznav .nav-user {
    display: none;
  }

  [data-sidebar-style="compact"] .deznav .metismenu>li>a {
    padding: 1.5rem 1.625rem 1.5rem 1.5rem;
  }

  [data-sidebar-style="compact"] .deznav .metismenu>li ul {
    padding: 1rem 0;
  }

  [data-sidebar-style="compact"] .deznav .metismenu>li ul li>a {
    padding: 0.5rem 1rem;
  }

  [data-sidebar-style="compact"] .deznav .metismenu>li ul li>a.has-arrow:after {
    content: "";
  }

  [data-sidebar-style="compact"] .deznav .metismenu li {
    text-align: center;
  }

  [data-sidebar-style="compact"] .deznav .metismenu li a svg {
    max-width: 21px;
    max-height: 21px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  [data-sidebar-style="compact"] .deznav .metismenu li a i {
    font-size: 2.2rem;
  }

  [data-sidebar-style="compact"] .deznav .metismenu li a:after {
    content: none;
  }

  [data-sidebar-style="compact"] .deznav .metismenu li a:before {
    content: "";
    height: 75px;
    width: 0;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translatey(-50%);
    background: #00ADEE;
    border-radius: 0 1.25rem 1.25rem 0;
    transition: all 0.5s;
  }

  [data-sidebar-style="compact"] .deznav .metismenu li ul:after {
    content: none;
  }

  [data-sidebar-style="compact"] .deznav .metismenu li.mm-active>a,
  [data-sidebar-style="compact"] .deznav .metismenu li:hover>a {
    background: linear-gradient(to right, #e0e0e4 0%, rgba(125, 185, 232, 0) 100%);
  }

  [data-sidebar-style="compact"] .deznav .metismenu li.mm-active>a:before,
  [data-sidebar-style="compact"] .deznav .metismenu li:hover>a:before {
    width: 10px;
  }

  [data-sidebar-style="compact"] .nav-text {
    display: inline-block;
    margin-top: 0.7125rem;
  }

  [data-sidebar-style="compact"] .nav-label.first {
    display: none;
  }

  [data-sidebar-style="compact"] .nav-badge {
    display: none;
  }

  [data-sidebar-style="compact"] .footer {
    padding-left: 9.375rem;
  }

  [data-sidebar-style="compact"] .content-body {
    margin-left: 15rem;
  }
}

[data-layout="horizontal"][data-sidebar-style="compact"] .footer {
  padding-left: 0;
}

[data-layout="horizontal"][data-sidebar-style="compact"] .content-body {
  margin-left: 0;
}

[data-layout="horizontal"][data-sidebar-style="compact"] .deznav .metismenu {
  padding: 0 30px;
}

[data-layout="vertical"][data-sidebar-style="compact"] .deznav {
  width: 15rem;
}

[data-layout="vertical"][data-sidebar-style="compact"] .deznav .metismenu ul {
  background: rgba(0, 0, 0, 0.02);
}

[data-theme-version="dark"][data-layout="vertical"][data-sidebar-style="compact"] .deznav .metismenu ul {
  background: 255, 255, 255, 0.05;
}

[data-layout="vertical"][data-sidebar-style="compact"] .deznav .metismenu ul a:before {
  content: none;
}

[data-layout="vertical"][data-sidebar-style="compact"] .deznav .metismenu ul ul a {
  padding: 0.625rem 0.9375rem;
}

[data-layout="vertical"][data-sidebar-style="compact"] .deznav .metismenu>li>a.has-arrow::after {
  top: 1px;
  display: inline-block;
  right: auto;
  margin-left: 5px;
  position: relative;
  width: 7px;
  height: 7px;
  border-width: 2px 0px 0px 2px;
}

[direction="rtl"][data-layout="vertical"][data-sidebar-style="compact"] .deznav .metismenu>li>a.has-arrow::after {
  left: auto;
  margin-left: 0;
  margin-right: 5px;
}

@media (min-width: 767px) {
  [data-sidebar-style="icon-hover"][data-layout="horizontal"] .metismenu {
    padding: 0 30px;
  }

  [data-sidebar-style="icon-hover"][data-layout="horizontal"] .header .header-content {
    padding-left: 1.875rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .nav-header {
    width: 5.063rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .nav-header .brand-logo {
    padding-left: 20px;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .nav-header .brand-logo {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .nav-header .brand-logo .logo-abbr {
    display: block;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .nav-header .brand-logo .brand-title {
    display: none;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .nav-header .nav-control {
    display: none;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .header {
    padding-left: 5.063rem;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .header {
    padding-right: 4.38rem;
    padding-left: 0.9375rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .header .header-content {
    padding-left: 1.375rem;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .header .header-content {
    padding-right: 1.375rem;
    padding-left: 0;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav {
    overflow: visible;
    position: absolute;
    left: -12.125rem;
  }
}

@media only screen and (min-width: 767px) and (min-width: 1200px) and (max-width: 1350px) {
  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav {
    left: -10rem;
  }
}

@media (min-width: 767px) {
  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav {
    left: auto;
    right: -12.125rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .nav-label {
    display: none;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu>li>a {
    display: flex;
    justify-content: space-between;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu>li>a>svg,
  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu>li>a>i {
    order: 1;
    margin-right: 0;
    margin-top: 0;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
    border-left: 0;
    padding-left: 0;
    padding-right: 28px;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
    padding-right: 0;
    padding-left: 28px;
  }

  [data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
    border-color: #333a54;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul:after {
    left: auto;
    right: 28px;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul:after {
    left: 28px;
    right: auto;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul a {
    position: relative;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul a::before {
    left: auto;
    right: -5px;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul a::before {
    right: auto;
    left: -5px;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu .has-arrow::after {
    right: 5rem;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu .has-arrow::after {
    right: auto;
    left: 5rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .icon-hover-toggle .nav-header {
    width: 17.1875rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .icon-hover-toggle .nav-header .brand-logo {
    padding-left: 1.6rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .icon-hover-toggle .nav-header .brand-logo .brand-title {
    display: block;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .icon-hover-toggle .header {
    padding-left: 4.38rem;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .icon-hover-toggle .header {
    padding-right: 4.38rem;
    padding-left: 0.9375rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .icon-hover-toggle .deznav {
    left: 0;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .icon-hover-toggle .deznav {
    left: auto;
    right: 0;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .content-body {
    margin-left: 5rem;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .content-body {
    margin-left: 0;
    margin-right: 5rem;
  }

  [data-sidebar-style="icon-hover"][data-layout="vertical"] .footer {
    padding-left: 4.375rem;
  }

  [direction="rtl"][data-sidebar-style="icon-hover"][data-layout="vertical"] .footer {
    margin-left: 0;
    margin-right: 4.375rem;
  }
}

@media (min-width: 767px) {
  [data-sidebar-style="modern"] .nav-header {
    width: 9.375rem;
  }

  [data-sidebar-style="modern"] .nav-header .brand-logo {
    justify-content: center;
  }

  [data-sidebar-style="modern"] .deznav .metismenu>li {
    text-align: center;
  }

  [data-sidebar-style="modern"] .deznav .metismenu>li>a {
    padding: 20px 15px 20px 15px !important;
  }

  [data-sidebar-style="modern"] .deznav .metismenu>li>a::after {
    display: none;
  }

  [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: white;
  }

  [data-sidebar-style="modern"] .deznav .metismenu>li.mm-active {
    padding: 0;
  }

  [data-sidebar-style="modern"] .deznav .metismenu>li li {
    text-align: left;
  }

  [direction="rtl"][data-sidebar-style="modern"] .deznav .metismenu>li li {
    text-align: right;
  }

  [data-sidebar-style="modern"] .deznav .metismenu li a {
    padding: 0.625rem 0.9375rem 0.625rem 0.9375rem;
  }

  [data-sidebar-style="modern"] .deznav .metismenu li ul:after {
    content: none;
  }

  [data-sidebar-style="modern"] .deznav .metismenu li>ul {
    height: auto !important;
  }

  [data-sidebar-style="modern"] .deznav .metismenu .nav-label {
    display: none;
  }

  [data-sidebar-style="modern"] .deznav .nav-label {
    display: none;
  }

  [data-sidebar-style="modern"] .deznav .nav-text {
    display: block;
    margin-top: 0.3125rem;
  }

  [data-sidebar-style="modern"] .footer {
    padding-left: 9.375rem;
  }

  [data-sidebar-style="modern"] .content-body {
    margin-left: 9.375rem;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav {
    width: 9.375rem;
    left: 0;
  }

  [direction="rtl"][data-sidebar-style="modern"][data-layout="vertical"] .deznav {
    left: auto;
    right: 0;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .slimScrollDiv,
  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .deznav-scroll {
    overflow: visible !important;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu>li>a i {
    font-size: 20px;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu>li>ul {
    display: none;
    padding: 1.875rem 0.9375rem;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li {
    position: relative;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li a {
    padding: 0.625rem 1.5rem;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li a:before {
    content: none;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li ul {
    position: absolute;
    left: 105%;
    top: 0;
    bottom: auto;
    background-color: #fff;
    border: 1px solid #f0f1f5;
    width: 200px;
  }

  [data-theme-version="dark"][data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li ul {
    background: #1e2746;
    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.1);
  }

  [direction="rtl"][data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li ul {
    left: auto;
    right: 105%;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li:hover>ul {
    display: block;
    left: 100%;
    padding: 1rem 0;
    margin-left: -10px;
    border: 0;
    box-shadow: 5px 0px 13px 0px rgba(82, 63, 105, 0.05);
  }

  [data-theme-version="dark"][data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li:hover>ul {
    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.1);
  }

  [direction="rtl"][data-sidebar-style="modern"][data-layout="vertical"] .deznav .metismenu li:hover>ul {
    left: auto;
    right: 100%;
    box-shadow: -5px 0px 13px 0px rgba(82, 63, 105, 0.05);
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .nav-label {
    display: none;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .deznav .nav-text {
    display: block;
    margin-top: 0;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .menu-toggle .deznav {
    left: -9.375rem;
  }

  [direction="rtl"][data-sidebar-style="modern"][data-layout="vertical"] .menu-toggle .deznav {
    left: auto;
    right: -9.375rem;
  }

  [data-sidebar-style="modern"][data-layout="vertical"] .menu-toggle .content-body {
    margin-left: 0;
  }

  [direction="rtl"][data-sidebar-style="modern"][data-layout="vertical"] .menu-toggle .content-body {
    margin-right: 0;
  }

  [data-sidebar-style="modern"][data-layout="horizontal"] .footer,
  [data-sidebar-style="modern"][data-layout="horizontal"] .content-body {
    margin-left: 0;
  }

  [data-sidebar-style="modern"][data-layout="horizontal"] .deznav .metismenu {
    padding: 0 30px;
  }

  [data-sidebar-style="modern"][data-layout="horizontal"] .deznav .metismenu>li>a {
    padding: 0.8125rem 2.25rem;
  }

  [data-sidebar-style="modern"][data-layout="horizontal"] .deznav .metismenu>li>ul {
    top: 4.5625rem;
  }

  [data-sidebar-style="modern"][data-layout="horizontal"][data-container="boxed"] .deznav .metismenu>li>a {
    padding: 0.8125rem 1.25rem;
  }
}

[data-sidebar-style="overlay"] .deznav {
  left: -100%;
}

[direction="rtl"][data-sidebar-style="overlay"] .deznav {
  left: auto;
  right: -100%;
}

[data-sidebar-style="overlay"] .content-body {
  margin-left: 0;
}

[data-sidebar-style="overlay"] .nav-header {
  position: absolute;
}

[data-sidebar-style="overlay"] .nav-header .hamburger.is-active {
  left: 0;
}

[data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #00ADEE;
}

[data-sidebar-style="overlay"] .menu-toggle .nav-header {
  position: absolute;
  left: auto;
}

[data-sidebar-style="overlay"] .menu-toggle .deznav {
  left: 0;
}

[direction="rtl"][data-sidebar-style="overlay"] .menu-toggle .deznav {
  left: auto;
  right: 0;
}

[data-sidebar-style="overlay"] .footer {
  padding-left: 0;
}

[data-sidebar-style="overlay"][data-header-position="fixed"] .nav-header {
  position: fixed;
}

[data-sidebar-position="fixed"][data-header-position="fixed"] .nav-header {
  position: fixed;
}

[data-sidebar-position="fixed"][data-layout="vertical"] .nav-header {
  position: fixed;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

[data-sidebar-position="fixed"][data-layout="vertical"] .deznav {
  position: fixed;
}

[data-sidebar-position="fixed"][data-layout="vertical"] .deznav .deznav-scroll {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

[data-sidebar-position="fixed"][data-layout="vertical"] .menu-toggle .deznav {
  position: fixed;
}

[data-header-position="fixed"][data-sidebar-position="fixed"][data-sidebar-style="overlay"][data-layout="vertical"][data-container="boxed"] .deznav {
  position: absolute;
}

.sidebar-right {
  right: -15.625rem;
  position: fixed;
  top: 0;
  width: 15.625rem;
  background-color: #fff;
  height: calc(100% - 7.0625rem);
  margin-top: 5rem;
  transition: all .5s ease-in-out;
  padding-bottom: 1.875rem;
  box-shadow: -2px 3px 10px 0px rgba(119, 119, 119, 0.1);
}

[direction="rtl"] .sidebar-right .slimScrollDiv {
  overflow: visible !important;
}

.sidebar-right .sidebar-right-trigger {
  position: absolute;
  z-index: 9;
  top: 4.75rem;
  right: 100%;
  background-color: #fff;
  color: #00ADEE;
  display: inline-block;
  height: 3rem;
  width: 3rem;
  text-align: center;
  font-size: 1.75rem;
  line-height: 3rem;
  border-radius: 5px 0 0 5px;
  box-shadow: -5px 3px 5px 0px rgba(119, 119, 119, 0.15);
}

[data-theme-version="dark"] .sidebar-right .sidebar-right-trigger {
  background-color: #31343b;
  color: #fff;
}

.sidebar-right .sidebar-right-trigger:hover {
  color: #00ADEE;
}

.sidebar-right.show {
  right: 0;
  z-index: 999;
}

.sidebar-right .nav-tabs {
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}

[data-theme-version="dark"] .sidebar-right .nav-tabs {
  background-color: #181f39;
}

.sidebar-right .nav-tabs .nav-item {
  margin-bottom: 0;
  flex: 1 1;
}

.sidebar-right .nav-tabs .nav-item .nav-link {
  border: 0;
  font-size: 1.125rem;
  position: relative;
  text-align: center;
  background-color: #fff;
}

.sidebar-right .nav-tabs .nav-item .nav-link::after {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  content: "";
  background: transparent;
}

[data-theme-version="dark"] .sidebar-right .nav-tabs .nav-item .nav-link {
  background-color: #181f39;
}

[data-theme-version="dark"] .sidebar-right .nav-tabs .nav-item .nav-link.active {
  border-right: none;
  border-left: none;
  border-top: none;
}

.sidebar-right .tab-content {
  padding: 1.25rem;
}

.sidebar-right .tab-content .tab-pane .admin-settings>div {
  margin-bottom: 10px;
}

.sidebar-right .tab-content .tab-pane .admin-settings p {
  margin-bottom: 0.125rem;
}

.sidebar-right .tab-content .tab-pane .admin-settings input[type="radio"] {
  display: none;
}

.sidebar-right .tab-content .tab-pane .admin-settings input[type="radio"]+label {
  display: inline-block;
  width: 25px;
  height: 25px;
  cursor: pointer;
  transition: all .1s ease;
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 3px;
}

.sidebar-right .tab-content .tab-pane .admin-settings input[type="radio"]:checked+label {
  position: relative;
}

.sidebar-right .tab-content .tab-pane .admin-settings input[type="radio"]:checked+label::after {
  height: 33px;
  width: 33px;
  left: -4px;
  top: -4px;
  content: "";
  position: absolute;
  background-color: inherit;
  border-radius: 6px;
  opacity: 0.4;
}

.sidebar-right #nav_header_color_1+label,
.sidebar-right #header_color_1+label,
.sidebar-right #sidebar_color_1+label,
.sidebar-right #primary_color_1+label {
  background-color: #fff;
}

.sidebar-right #nav_header_color_2+label,
.sidebar-right #header_color_2+label,
.sidebar-right #sidebar_color_2+label,
.sidebar-right #primary_color_2+label {
  background-color: #143b64;
}

.sidebar-right #nav_header_color_3+label,
.sidebar-right #header_color_3+label,
.sidebar-right #sidebar_color_3+label,
.sidebar-right #primary_color_3+label {
  background-color: #00ADEE;
}

.sidebar-right #nav_header_color_4+label,
.sidebar-right #header_color_4+label,
.sidebar-right #sidebar_color_4+label,
.sidebar-right #primary_color_4+label {
  background-color: #4527a0;
}

.sidebar-right #nav_header_color_5+label,
.sidebar-right #header_color_5+label,
.sidebar-right #sidebar_color_5+label,
.sidebar-right #primary_color_5+label {
  background-color: #c62828;
}

.sidebar-right #nav_header_color_6+label,
.sidebar-right #header_color_6+label,
.sidebar-right #sidebar_color_6+label,
.sidebar-right #primary_color_6+label {
  background-color: #283593;
}

.sidebar-right #nav_header_color_7+label,
.sidebar-right #header_color_7+label,
.sidebar-right #sidebar_color_7+label,
.sidebar-right #primary_color_7+label {
  background-color: #7356f1;
}

.sidebar-right #nav_header_color_8+label,
.sidebar-right #header_color_8+label,
.sidebar-right #sidebar_color_8+label,
.sidebar-right #primary_color_8+label {
  background-color: #3695eb;
}

.sidebar-right #nav_header_color_9+label,
.sidebar-right #header_color_9+label,
.sidebar-right #sidebar_color_9+label,
.sidebar-right #primary_color_9+label {
  background-color: #00838f;
}

.sidebar-right #nav_header_color_10+label,
.sidebar-right #header_color_10+label,
.sidebar-right #sidebar_color_10+label,
.sidebar-right #primary_color_10+label {
  background-color: #ff8f16;
}

.sidebar-right #nav_header_color_11+label,
.sidebar-right #header_color_11+label,
.sidebar-right #sidebar_color_11+label,
.sidebar-right #primary_color_11+label {
  background-color: #6673fd;
}

.sidebar-right #nav_header_color_12+label,
.sidebar-right #header_color_12+label,
.sidebar-right #sidebar_color_12+label,
.sidebar-right #primary_color_12+label {
  background-color: #558b2f;
}

.sidebar-right #nav_header_color_13+label,
.sidebar-right #header_color_13+label,
.sidebar-right #sidebar_color_13+label,
.sidebar-right #primary_color_13+label {
  background-color: #2a2a2a;
}

.sidebar-right #nav_header_color_14+label,
.sidebar-right #header_color_14+label,
.sidebar-right #sidebar_color_14+label,
.sidebar-right #primary_color_14+label {
  background-color: #1367c8;
}

.sidebar-right #nav_header_color_15+label,
.sidebar-right #header_color_15+label,
.sidebar-right #sidebar_color_15+label,
.sidebar-right #primary_color_15+label {
  background-color: #ed0b4c;
}

.sidebar-right #nav_header_color_1+label,
.sidebar-right #header_color_1+label,
.sidebar-right #sidebar_color_1+label,
.sidebar-right #primary_color_1+label {
  border: 1px solid #89879f;
}

@keyframes bounce {
  0% {
    transform: translateX(-8%);
    -webkit-transform: translateX(-8%);
  }

  50% {
    transform: translateX(8%);
    -webkit-transform: translateX(8%);
  }

  100% {
    transform: translateX(-8%);
    -webkit-transform: translateX(-8%);
  }
}

.nav-user {
  background: #00ADEE;
  margin-bottom: 10px;
  padding: 20px 25px 15px;
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .nav-user {
    padding: 20px 15px 15px;
  }
}

.nav-user img {
  width: 35px;
  height: 35px;
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .nav-user img {
    width: 35px;
    height: 35px;
    margin-bottom: 10px;
  }
}

.nav-user h5 {
  margin-left: 10px;
  margin-bottom: 3px;
  color: #fff;
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .nav-user h5 {
    display: none;
  }
}

[data-sibebarbg="color_2"] .nav-user h5 {
  color: #fff;
}

.nav-user p {
  margin-left: 10px;
  margin-bottom: 8px;
  color: #afcff7;
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .nav-user p {
    display: none;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .nav-user i {
    margin-top: 15px;
    display: block;
  }
}

.menu-toggle .nav-user {
  padding: 20px 15px 15px;
}

.menu-toggle .nav-user img {
  width: 35px;
  height: 35px;
  margin-bottom: 10px;
}

.menu-toggle .nav-user h5,
.menu-toggle .nav-user p {
  display: none;
}

.menu-toggle .nav-user i {
  margin-top: 15px;
  display: block;
}

.menu-toggle .nav-user .dropdown-menu {
  left: 45px !important;
  top: 22px !important;
}

.chatbox {
  width: 340px;
  height: 100vh;
  position: fixed;
  right: -500px;
  top: 0;
  z-index: 999;
  background: #fff;
  box-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.15);
  transition: all 0.8s;
}

[data-theme-version="dark"] .chatbox {
  background: #1e2746;
}

.chatbox .chatbox-close {
  position: absolute;
  transition: all 0.2s;
  width: 0;
  height: 100%;
  right: 340px;
  background: #000;
  z-index: 1;
  opacity: 0.1;
  cursor: pointer;
}

.chatbox .card-fotter {
  padding: 0.75rem 1rem;
}

.chatbox .card-body {
  padding: 1rem;
}

.chatbox.active {
  right: 0;
}

.chatbox.active .chatbox-close {
  width: 100vw;
}

.chatbox .type_msg {
  padding-top: 10px;
}

.chatbox .nav {
  padding: 1rem 1rem 0 1rem;
  background: #00ADEE;
  border: 0;
  justify-content: space-between;
}

.chatbox .nav .nav-link {
  color: #fff;
  opacity: 0.7;
  text-transform: uppercase;
}

.chatbox .nav .nav-link:hover,
.chatbox .nav .nav-link.active {
  background: transparent;
  color: #fff;
  opacity: 1;
  border-color: #fff;
}

.chatbox .img_cont {
  width: 40px;
  border-radius: 40px;
  margin-right: 10px;
  position: relative;
  height: 40px;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  min-width: 40px;
  min-height: 40px;
}

.chatbox .img_cont .icon {
  color: #fff;
}

.chatbox .img_cont.primary {
  background: #f6f1fd;
  color: #00ADEE;
}

[data-theme-version="dark"] .chatbox .img_cont.primary {
  background: rgba(135, 67, 223, 0.2);
}

.chatbox .img_cont.warning {
  background: #fff3eb;
  color: #FF9B52;
}

[data-theme-version="dark"] .chatbox .img_cont.warning {
  background: rgba(255, 155, 82, 0.1);
}

.chatbox .img_cont.success {
  background: #e3f9e9;
  color: #2BC155;
}

[data-theme-version="dark"] .chatbox .img_cont.success {
  background: rgba(43, 193, 85, 0.1);
}

.chatbox .img_cont.info {
  background: #dbdbff;
  color: #2D28FF;
}

[data-theme-version="dark"] .chatbox .img_cont.info {
  background: rgba(45, 40, 255, 0.1);
}

.chatbox .img_cont img {
  width: 100%;
}

.chatbox .img_cont .online_icon {
  background: #2BC155;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 15px;
  right: -1px;
  bottom: 0px;
  border: 2px solid #fff;
}

.chatbox .img_cont .online_icon.offline {
  background: #F94687;
}

.chatbox .card {
  box-shadow: none;
}

.chatbox .search {
  height: 40px;
}

.chatbox .user_info span {
  font-size: 15px;
  color: #000;
  display: block;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  max-width: 170px;
}

[data-theme-version="dark"] .chatbox .user_info span {
  color: #fff;
}

.chatbox .user_info p {
  font-size: 13px;
  margin-bottom: 0;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  max-width: 170px;
}

.chatbox .contacts li {
  padding: 7px 1rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

[data-theme-version="dark"] .chatbox .contacts li {
  border-color: #333a54;
}

.chatbox .contacts li>div {
  display: flex;
  align-items: center;
}

.chatbox .contacts li:hover {
  background: #f4f7ff;
}

[data-theme-version="dark"] .chatbox .contacts li:hover {
  background-color: #181f39;
}

.chatbox .contacts .name-first-letter {
  background: #E5E6E7;
  padding: 4px 1rem;
  font-weight: 700;
  color: #000;
  position: sticky;
  top: 0;
  z-index: 1;
}

[data-theme-version="dark"] .chatbox .contacts .name-first-letter {
  color: #fff;
  background: #181f39;
}

.chatbox .msg_card_body {
  height: calc(100vh - 195px);
}

.chatbox .contacts_body {
  height: calc(100vh - 120px);
}

.chatbox .card-header {
  background: #f4f7ff;
  padding: 15px 20px;
  justify-content: center;
}

.chatbox .card-header h6 {
  font-size: 15px;
}

.chatbox .card-header p {
  line-height: 1.2;
  font-size: 12px;
  color: #7e7e7e;
}

.chatbox .chat-list-header {
  justify-content: space-between;
  background: #fff;
}

[data-theme-version="dark"] .chatbox .chat-list-header {
  background: #1e2746;
}

.chatbox .chat-list-header a {
  text-align: center;
  width: 30px;
  height: 30px;
  background: #E5E6E7;
  border-radius: 6px;
  line-height: 30px;
  display: block;
}

[data-theme-version="dark"] .chatbox .chat-list-header a {
  background: rgba(135, 67, 223, 0.2);
}

[data-theme-version="dark"] .chatbox .chat-list-header a svg g [fill] {
  fill: #fff;
}

.chatbox .img_cont_msg {
  width: 30px;
  height: 30px;
  display: block;
  max-width: 30px;
  min-width: 30px;
}

.chatbox .img_cont_msg img {
  width: 100%;
}

.chatbox .msg_cotainer {
  background: #00ADEE;
  margin-left: 10px;
  border-radius: 0 1.25rem 1.25rem 1.25rem;
  padding: 10px 15px;
  color: #fff;
  position: relative;
}

.chatbox .msg_cotainer .msg_time {
  display: block;
  font-size: 11px;
  color: #fff;
  margin-top: 5px;
  opacity: 0.5;
}

.chatbox .msg_cotainer:after {
  content: "";
  position: absolute;
  left: -10px;
  border-right: 10px solid #00ADEE;
  border-bottom: 10px solid transparent;
  border-top: 0px solid;
  top: 0;
}

.chatbox .msg_cotainer_send {
  background: #E5E6E7;
  padding: 10px 15px;
  border-radius: 6px 0px 6px 6px;
  margin-right: 10px;
  color: #222;
  position: relative;
  text-align: right;
}

[data-theme-version="dark"] .chatbox .msg_cotainer_send {
  background: #181f39;
  color: #fff;
}

.chatbox .msg_cotainer_send .msg_time_send {
  display: block;
  font-size: 11px;
  text-align: right;
  margin-top: 5px;
  opacity: 0.6;
}

.chatbox .msg_cotainer_send:after {
  content: "";
  position: absolute;
  right: -10px;
  border-left: 10px solid #E5E6E7;
  border-bottom: 10px solid transparent;
  border-top: 0px solid;
  top: 0;
}

[data-theme-version="dark"] .chatbox .msg_cotainer_send:after {
  border-left: 10px solid #181f39;
}

.chatbox .type_msg .form-control {
  padding: 10px 0;
  height: 50px;
  border: 0;
  resize: none;
}

.chatbox .type_msg .btn {
  font-size: 18px;
  border-radius: 38px !important;
  width: 38px;
  height: 38px;
  padding: 0;
  margin-top: 6px;
}

.chatbox .video_cam {
  margin-left: 15px;
}

.chatbox .video_cam span {
  width: 35px;
  height: 35px;
  background: #10ca93;
  text-align: center;
  line-height: 35px;
  border-radius: 35px;
  color: #fff;
  margin-right: 5px;
  align-self: center;
  font-size: 16px;
  padding: 0 3px;
  display: inline-block;
}

.chatbox .note_card .contacts li {
  padding: 12px 1rem;
}

@media only screen and (max-width: 576px) {
  .chatbox {
    width: 280px;
  }

  .chatbox .chatbox-close {
    right: 280px;
  }
}

[data-nav-headerbg="color_2"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_2"] .nav-header {
  background-color: #143b64;
}

[data-nav-headerbg="color_2"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_2"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_2"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_2"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_2"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_2"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_2"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_2"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_3"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_3"] .nav-header {
  background-color: #00ADEE;
}

[data-nav-headerbg="color_3"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_3"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_3"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_3"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_3"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_3"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_3"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_3"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_4"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_4"] .nav-header {
  background-color: #4527a0;
}

[data-nav-headerbg="color_4"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_4"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_4"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_4"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_4"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_4"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_4"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_4"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_5"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_5"] .nav-header {
  background-color: #c62828;
}

[data-nav-headerbg="color_5"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_5"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_5"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_5"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_5"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_5"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_5"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_5"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_6"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_6"] .nav-header {
  background-color: #283593;
}

[data-nav-headerbg="color_6"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_6"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_6"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_6"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_6"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_6"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_6"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_6"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_7"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_7"] .nav-header {
  background-color: #7356f1;
}

[data-nav-headerbg="color_7"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_7"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_7"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_7"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_7"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_7"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_7"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_7"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_8"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_8"] .nav-header {
  background-color: #3695eb;
}

[data-nav-headerbg="color_8"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_8"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_8"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_8"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_8"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_8"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_8"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_8"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_9"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_9"] .nav-header {
  background-color: #00838f;
}

[data-nav-headerbg="color_9"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_9"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_9"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_9"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_9"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_9"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_9"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_9"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_10"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_10"] .nav-header {
  background-color: #ff8f16;
}

[data-nav-headerbg="color_10"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_10"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_10"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_10"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_10"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_10"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_10"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_10"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_11"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_11"] .nav-header {
  background-color: #6673fd;
}

[data-nav-headerbg="color_11"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_11"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_11"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_11"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_11"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_11"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_11"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_11"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_12"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_12"] .nav-header {
  background-color: #558b2f;
}

[data-nav-headerbg="color_12"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_12"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_12"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_12"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_12"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_12"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_12"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_12"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_13"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_13"] .nav-header {
  background-color: #2a2a2a;
}

[data-nav-headerbg="color_13"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_13"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_13"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_13"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_13"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_13"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_13"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_13"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_14"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_14"] .nav-header {
  background-color: #1367c8;
}

[data-nav-headerbg="color_14"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_14"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_14"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_14"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_14"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_14"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_14"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_14"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_15"][data-theme-version="dark"] .nav-header,
[data-nav-headerbg="color_15"] .nav-header {
  background-color: #ed0b4c;
}

[data-nav-headerbg="color_15"][data-theme-version="dark"] .nav-header .brand-logo,
[data-nav-headerbg="color_15"] .nav-header .brand-logo {
  color: #fff;
}

[data-nav-headerbg="color_15"][data-theme-version="dark"] .nav-header .brand-logo:hover,
[data-nav-headerbg="color_15"] .nav-header .brand-logo:hover {
  color: #fff;
}

[data-nav-headerbg="color_15"][data-theme-version="dark"] .nav-header .hamburger .line,
[data-nav-headerbg="color_15"] .nav-header .hamburger .line {
  background: #fff;
}

[data-nav-headerbg="color_15"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line,
[data-nav-headerbg="color_15"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header,
[data-headerbg="color_2"] .header {
  background-color: #143b64;
  color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_2"] .header-left input {
  border-color: #1d548f;
  background-color: #1d548f !important;
  color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_2"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_2"] .header-left input:focus {
  border-color: #0c223a;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_2"] .header-left .search_icon {
  background-color: #1d548f !important;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_2"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_2"] .header-left .btn {
  background-color: #0c223a;
  border-color: #0c223a;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_2"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_2"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_2"] .header-left .btn:hover,
[data-headerbg="color_2"] .header-left .btn:focus,
[data-headerbg="color_2"] .header-left .btn:active {
  background-color: #03090f;
  border-color: #03090f;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_2"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_2"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_2"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_2"] .header-right .pulse-css:after,
[data-headerbg="color_2"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_2"] .header-right .notification_dropdown .nav-link {
  background-color: #1d548f !important;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_2"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_2"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_2"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_2"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_2"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_2"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_2"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_2"] .nav-control {
  background-color: #1d548f;
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header,
[data-headerbg="color_3"] .header {
  background-color: #00ADEE;
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_3"] .header-left input {
  border-color: #a36fe6;
  background-color: #a36fe6 !important;
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_3"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_3"] .header-left input:focus {
  border-color: #6d23cc;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_3"] .header-left .search_icon {
  background-color: #a36fe6 !important;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_3"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_3"] .header-left .btn {
  background-color: #6d23cc;
  border-color: #6d23cc;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_3"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_3"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_3"] .header-left .btn:hover,
[data-headerbg="color_3"] .header-left .btn:focus,
[data-headerbg="color_3"] .header-left .btn:active {
  background-color: #551ba1;
  border-color: #551ba1;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_3"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_3"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_3"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_3"] .header-right .pulse-css:after,
[data-headerbg="color_3"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_3"] .header-right .notification_dropdown .nav-link {
  background-color: #a36fe6 !important;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_3"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_3"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_3"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_3"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_3"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_3"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_3"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_3"] .nav-control {
  background-color: #a36fe6;
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header,
[data-headerbg="color_4"] .header {
  background-color: #4527a0;
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_4"] .header-left input {
  border-color: #5731c9;
  background-color: #5731c9 !important;
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_4"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_4"] .header-left input:focus {
  border-color: #331d77;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_4"] .header-left .search_icon {
  background-color: #5731c9 !important;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_4"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_4"] .header-left .btn {
  background-color: #331d77;
  border-color: #331d77;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_4"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_4"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_4"] .header-left .btn:hover,
[data-headerbg="color_4"] .header-left .btn:focus,
[data-headerbg="color_4"] .header-left .btn:active {
  background-color: #22134e;
  border-color: #22134e;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_4"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_4"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_4"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_4"] .header-right .pulse-css:after,
[data-headerbg="color_4"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_4"] .header-right .notification_dropdown .nav-link {
  background-color: #5731c9 !important;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_4"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_4"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_4"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_4"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_4"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_4"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_4"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_4"] .nav-control {
  background-color: #5731c9;
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header,
[data-headerbg="color_5"] .header {
  background-color: #c62828;
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_5"] .header-left input {
  border-color: #da4747;
  background-color: #da4747 !important;
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_5"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_5"] .header-left input:focus {
  border-color: #9c1f1f;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_5"] .header-left .search_icon {
  background-color: #da4747 !important;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_5"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_5"] .header-left .btn {
  background-color: #9c1f1f;
  border-color: #9c1f1f;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_5"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_5"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_5"] .header-left .btn:hover,
[data-headerbg="color_5"] .header-left .btn:focus,
[data-headerbg="color_5"] .header-left .btn:active {
  background-color: #711717;
  border-color: #711717;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_5"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_5"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_5"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_5"] .header-right .pulse-css:after,
[data-headerbg="color_5"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_5"] .header-right .notification_dropdown .nav-link {
  background-color: #da4747 !important;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_5"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_5"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_5"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_5"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_5"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_5"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_5"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_5"] .nav-control {
  background-color: #da4747;
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header,
[data-headerbg="color_6"] .header {
  background-color: #283593;
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_6"] .header-left input {
  border-color: #3343bb;
  background-color: #3343bb !important;
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_6"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_6"] .header-left input:focus {
  border-color: #1d276b;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_6"] .header-left .search_icon {
  background-color: #3343bb !important;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_6"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_6"] .header-left .btn {
  background-color: #1d276b;
  border-color: #1d276b;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_6"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_6"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_6"] .header-left .btn:hover,
[data-headerbg="color_6"] .header-left .btn:focus,
[data-headerbg="color_6"] .header-left .btn:active {
  background-color: #121843;
  border-color: #121843;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_6"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_6"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_6"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_6"] .header-right .pulse-css:after,
[data-headerbg="color_6"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_6"] .header-right .notification_dropdown .nav-link {
  background-color: #3343bb !important;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_6"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_6"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_6"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_6"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_6"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_6"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_6"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_6"] .nav-control {
  background-color: #3343bb;
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header,
[data-headerbg="color_7"] .header {
  background-color: #7356f1;
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_7"] .header-left input {
  border-color: #9a85f5;
  background-color: #9a85f5 !important;
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_7"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_7"] .header-left input:focus {
  border-color: #4c27ed;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_7"] .header-left .search_icon {
  background-color: #9a85f5 !important;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_7"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_7"] .header-left .btn {
  background-color: #4c27ed;
  border-color: #4c27ed;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_7"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_7"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_7"] .header-left .btn:hover,
[data-headerbg="color_7"] .header-left .btn:focus,
[data-headerbg="color_7"] .header-left .btn:active {
  background-color: #3511d0;
  border-color: #3511d0;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_7"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_7"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_7"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_7"] .header-right .pulse-css:after,
[data-headerbg="color_7"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_7"] .header-right .notification_dropdown .nav-link {
  background-color: #9a85f5 !important;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_7"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_7"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_7"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_7"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_7"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_7"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_7"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_7"] .nav-control {
  background-color: #9a85f5;
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header,
[data-headerbg="color_8"] .header {
  background-color: #3695eb;
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_8"] .header-left input {
  border-color: #64adf0;
  background-color: #64adf0 !important;
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_8"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_8"] .header-left input:focus {
  border-color: #167cd8;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_8"] .header-left .search_icon {
  background-color: #64adf0 !important;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_8"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_8"] .header-left .btn {
  background-color: #167cd8;
  border-color: #167cd8;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_8"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_8"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_8"] .header-left .btn:hover,
[data-headerbg="color_8"] .header-left .btn:focus,
[data-headerbg="color_8"] .header-left .btn:active {
  background-color: #1161aa;
  border-color: #1161aa;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_8"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_8"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_8"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_8"] .header-right .pulse-css:after,
[data-headerbg="color_8"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_8"] .header-right .notification_dropdown .nav-link {
  background-color: #64adf0 !important;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_8"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_8"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_8"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_8"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_8"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_8"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_8"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_8"] .nav-control {
  background-color: #64adf0;
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header,
[data-headerbg="color_9"] .header {
  background-color: #00838f;
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_9"] .header-left input {
  border-color: #00b2c2;
  background-color: #00b2c2 !important;
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_9"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_9"] .header-left input:focus {
  border-color: #00545c;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_9"] .header-left .search_icon {
  background-color: #00b2c2 !important;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_9"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_9"] .header-left .btn {
  background-color: #00545c;
  border-color: #00545c;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_9"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_9"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_9"] .header-left .btn:hover,
[data-headerbg="color_9"] .header-left .btn:focus,
[data-headerbg="color_9"] .header-left .btn:active {
  background-color: #002629;
  border-color: #002629;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_9"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_9"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_9"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_9"] .header-right .pulse-css:after,
[data-headerbg="color_9"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_9"] .header-right .notification_dropdown .nav-link {
  background-color: #00b2c2 !important;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_9"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_9"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_9"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_9"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_9"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_9"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_9"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_9"] .nav-control {
  background-color: #00b2c2;
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header,
[data-headerbg="color_10"] .header {
  background-color: #ff8f16;
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_10"] .header-left input {
  border-color: #ffa849;
  background-color: #ffa849 !important;
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_10"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_10"] .header-left input:focus {
  border-color: #e27500;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_10"] .header-left .search_icon {
  background-color: #ffa849 !important;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_10"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_10"] .header-left .btn {
  background-color: #e27500;
  border-color: #e27500;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_10"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_10"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_10"] .header-left .btn:hover,
[data-headerbg="color_10"] .header-left .btn:focus,
[data-headerbg="color_10"] .header-left .btn:active {
  background-color: #af5b00;
  border-color: #af5b00;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_10"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_10"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_10"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_10"] .header-right .pulse-css:after,
[data-headerbg="color_10"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_10"] .header-right .notification_dropdown .nav-link {
  background-color: #ffa849 !important;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_10"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_10"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_10"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_10"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_10"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_10"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_10"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_10"] .nav-control {
  background-color: #ffa849;
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header,
[data-headerbg="color_11"] .header {
  background-color: #6673fd;
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_11"] .header-left input {
  border-color: #98a1fe;
  background-color: #98a1fe !important;
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_11"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_11"] .header-left input:focus {
  border-color: #3445fc;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_11"] .header-left .search_icon {
  background-color: #98a1fe !important;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_11"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_11"] .header-left .btn {
  background-color: #3445fc;
  border-color: #3445fc;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_11"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_11"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_11"] .header-left .btn:hover,
[data-headerbg="color_11"] .header-left .btn:focus,
[data-headerbg="color_11"] .header-left .btn:active {
  background-color: #0318fa;
  border-color: #0318fa;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_11"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_11"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_11"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_11"] .header-right .pulse-css:after,
[data-headerbg="color_11"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_11"] .header-right .notification_dropdown .nav-link {
  background-color: #98a1fe !important;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_11"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_11"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_11"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_11"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_11"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_11"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_11"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_11"] .nav-control {
  background-color: #98a1fe;
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header,
[data-headerbg="color_12"] .header {
  background-color: #558b2f;
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_12"] .header-left input {
  border-color: #6cb13c;
  background-color: #6cb13c !important;
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_12"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_12"] .header-left input:focus {
  border-color: #3e6522;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_12"] .header-left .search_icon {
  background-color: #6cb13c !important;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_12"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_12"] .header-left .btn {
  background-color: #3e6522;
  border-color: #3e6522;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_12"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_12"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_12"] .header-left .btn:hover,
[data-headerbg="color_12"] .header-left .btn:focus,
[data-headerbg="color_12"] .header-left .btn:active {
  background-color: #263f15;
  border-color: #263f15;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_12"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_12"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_12"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_12"] .header-right .pulse-css:after,
[data-headerbg="color_12"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_12"] .header-right .notification_dropdown .nav-link {
  background-color: #6cb13c !important;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_12"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_12"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_12"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_12"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_12"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_12"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_12"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_12"] .nav-control {
  background-color: #6cb13c;
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header,
[data-headerbg="color_13"] .header {
  background-color: #2a2a2a;
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_13"] .header-left input {
  border-color: #444444;
  background-color: #444444 !important;
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_13"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_13"] .header-left input:focus {
  border-color: #111111;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_13"] .header-left .search_icon {
  background-color: #444444 !important;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_13"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_13"] .header-left .btn {
  background-color: #111111;
  border-color: #111111;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_13"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_13"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_13"] .header-left .btn:hover,
[data-headerbg="color_13"] .header-left .btn:focus,
[data-headerbg="color_13"] .header-left .btn:active {
  background-color: black;
  border-color: black;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_13"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_13"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_13"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_13"] .header-right .pulse-css:after,
[data-headerbg="color_13"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_13"] .header-right .notification_dropdown .nav-link {
  background-color: #444444 !important;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_13"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_13"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_13"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_13"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_13"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_13"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_13"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_13"] .nav-control {
  background-color: #444444;
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header,
[data-headerbg="color_14"] .header {
  background-color: #1367c8;
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_14"] .header-left input {
  border-color: #2480ea;
  background-color: #2480ea !important;
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_14"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_14"] .header-left input:focus {
  border-color: #0f4f99;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_14"] .header-left .search_icon {
  background-color: #2480ea !important;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_14"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_14"] .header-left .btn {
  background-color: #0f4f99;
  border-color: #0f4f99;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_14"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_14"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_14"] .header-left .btn:hover,
[data-headerbg="color_14"] .header-left .btn:focus,
[data-headerbg="color_14"] .header-left .btn:active {
  background-color: #0a376b;
  border-color: #0a376b;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_14"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_14"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_14"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_14"] .header-right .pulse-css:after,
[data-headerbg="color_14"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_14"] .header-right .notification_dropdown .nav-link {
  background-color: #2480ea !important;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_14"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_14"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_14"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_14"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_14"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_14"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_14"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_14"] .nav-control {
  background-color: #2480ea;
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header,
[data-headerbg="color_15"] .header {
  background-color: #ed0b4c;
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-left input,
[data-headerbg="color_15"] .header-left input {
  border-color: #f6356d;
  background-color: #f6356d !important;
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-left input::placeholder,
[data-headerbg="color_15"] .header-left input::placeholder {
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-left input:focus,
[data-headerbg="color_15"] .header-left input:focus {
  border-color: #bc093c;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-left .search_icon,
[data-headerbg="color_15"] .header-left .search_icon {
  background-color: #f6356d !important;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-left .search_icon i,
[data-headerbg="color_15"] .header-left .search_icon i {
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-left .btn,
[data-headerbg="color_15"] .header-left .btn {
  background-color: #bc093c;
  border-color: #bc093c;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-left .btn:hover,
[data-headerbg="color_15"][data-theme-version="dark"] .header-left .btn:focus,
[data-headerbg="color_15"][data-theme-version="dark"] .header-left .btn:active,
[data-headerbg="color_15"] .header-left .btn:hover,
[data-headerbg="color_15"] .header-left .btn:focus,
[data-headerbg="color_15"] .header-left .btn:active {
  background-color: #8c062d;
  border-color: #8c062d;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-right .dropdown>a,
[data-headerbg="color_15"] .header-right .dropdown>a {
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-right .pulse-css,
[data-headerbg="color_15"] .header-right .pulse-css {
  background-color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-right .pulse-css:after,
[data-headerbg="color_15"][data-theme-version="dark"] .header-right .pulse-css:before,
[data-headerbg="color_15"] .header-right .pulse-css:after,
[data-headerbg="color_15"] .header-right .pulse-css:before {
  background-color: inherit;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-right .notification_dropdown .nav-link,
[data-headerbg="color_15"] .header-right .notification_dropdown .nav-link {
  background-color: #f6356d !important;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-right .right-sidebar a,
[data-headerbg="color_15"] .header-right .right-sidebar a {
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong,
[data-headerbg="color_15"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-headerbg="color_15"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_15"][data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info small,
[data-headerbg="color_15"] .header-right .header-profile>a.nav-link .header-info span,
[data-headerbg="color_15"] .header-right .header-profile>a.nav-link .header-info small {
  color: rgba(255, 255, 255, 0.7);
}

[data-headerbg="color_15"][data-theme-version="dark"] .nav-control,
[data-headerbg="color_15"] .nav-control {
  background-color: #f6356d;
  color: #fff;
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_2"] .deznav {
  background-color: #143b64;
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_2"] .deznav .menu-tabs li a.active {
  color: #143b64;
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_2"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_2"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_2"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_2"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_2"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_2"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_2"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_2"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_2"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_2"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_2"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_2"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_2"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_2"] .deznav .metismenu>li {
  border-color: #1d548f;
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_2"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_2"] .deznav .metismenu a:hover,
[data-sibebarbg="color_2"] .deznav .metismenu a:focus,
[data-sibebarbg="color_2"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_2"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_2"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_2"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_2"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_2"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #1d548f;
}

[data-sibebarbg="color_2"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_2"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_2"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_2"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #1d548f;
}

[data-sibebarbg="color_2"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_2"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_2"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_2"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_2"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_2"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #1d548f;
}

[data-sibebarbg="color_2"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_2"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_2"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_2"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_3"] .deznav {
  background-color: #00ADEE;
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_3"] .deznav .menu-tabs li a.active {
  color: #00ADEE;
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_3"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_3"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_3"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_3"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_3"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_3"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_3"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_3"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_3"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_3"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_3"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_3"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_3"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_3"] .deznav .metismenu>li {
  border-color: #a36fe6;
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_3"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_3"] .deznav .metismenu a:hover,
[data-sibebarbg="color_3"] .deznav .metismenu a:focus,
[data-sibebarbg="color_3"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_3"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_3"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_3"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_3"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_3"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #a36fe6;
}

[data-sibebarbg="color_3"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_3"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_3"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_3"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #a36fe6;
}

[data-sibebarbg="color_3"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_3"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_3"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_3"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_3"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_3"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #a36fe6;
}

[data-sibebarbg="color_3"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_3"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_3"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_3"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_4"] .deznav {
  background-color: #4527a0;
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_4"] .deznav .menu-tabs li a.active {
  color: #4527a0;
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_4"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_4"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_4"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_4"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_4"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_4"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_4"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_4"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_4"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_4"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_4"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_4"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_4"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_4"] .deznav .metismenu>li {
  border-color: #5731c9;
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_4"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_4"] .deznav .metismenu a:hover,
[data-sibebarbg="color_4"] .deznav .metismenu a:focus,
[data-sibebarbg="color_4"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_4"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_4"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_4"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_4"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_4"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #5731c9;
}

[data-sibebarbg="color_4"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_4"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_4"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_4"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #5731c9;
}

[data-sibebarbg="color_4"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_4"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_4"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_4"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_4"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_4"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #5731c9;
}

[data-sibebarbg="color_4"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_4"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_4"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_4"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_5"] .deznav {
  background-color: #c62828;
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_5"] .deznav .menu-tabs li a.active {
  color: #c62828;
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_5"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_5"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_5"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_5"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_5"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_5"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_5"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_5"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_5"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_5"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_5"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_5"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_5"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_5"] .deznav .metismenu>li {
  border-color: #da4747;
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_5"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_5"] .deznav .metismenu a:hover,
[data-sibebarbg="color_5"] .deznav .metismenu a:focus,
[data-sibebarbg="color_5"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_5"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_5"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_5"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_5"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_5"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #da4747;
}

[data-sibebarbg="color_5"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_5"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_5"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_5"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #da4747;
}

[data-sibebarbg="color_5"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_5"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_5"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_5"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_5"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_5"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #da4747;
}

[data-sibebarbg="color_5"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_5"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_5"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_5"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_6"] .deznav {
  background-color: #283593;
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_6"] .deznav .menu-tabs li a.active {
  color: #283593;
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_6"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_6"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_6"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_6"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_6"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_6"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_6"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_6"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_6"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_6"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_6"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_6"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_6"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_6"] .deznav .metismenu>li {
  border-color: #3343bb;
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_6"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_6"] .deznav .metismenu a:hover,
[data-sibebarbg="color_6"] .deznav .metismenu a:focus,
[data-sibebarbg="color_6"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_6"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_6"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_6"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_6"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_6"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #3343bb;
}

[data-sibebarbg="color_6"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_6"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_6"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_6"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #3343bb;
}

[data-sibebarbg="color_6"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_6"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_6"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_6"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_6"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_6"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #3343bb;
}

[data-sibebarbg="color_6"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_6"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_6"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_6"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_7"] .deznav {
  background-color: #7356f1;
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_7"] .deznav .menu-tabs li a.active {
  color: #7356f1;
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_7"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_7"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_7"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_7"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_7"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_7"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_7"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_7"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_7"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_7"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_7"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_7"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_7"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_7"] .deznav .metismenu>li {
  border-color: #9a85f5;
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_7"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_7"] .deznav .metismenu a:hover,
[data-sibebarbg="color_7"] .deznav .metismenu a:focus,
[data-sibebarbg="color_7"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_7"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_7"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_7"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_7"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_7"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #9a85f5;
}

[data-sibebarbg="color_7"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_7"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_7"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_7"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #9a85f5;
}

[data-sibebarbg="color_7"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_7"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_7"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_7"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_7"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_7"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #9a85f5;
}

[data-sibebarbg="color_7"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_7"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_7"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_7"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_8"] .deznav {
  background-color: #3695eb;
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_8"] .deznav .menu-tabs li a.active {
  color: #3695eb;
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_8"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_8"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_8"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_8"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_8"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_8"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_8"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_8"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_8"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_8"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_8"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_8"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_8"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_8"] .deznav .metismenu>li {
  border-color: #64adf0;
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_8"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_8"] .deznav .metismenu a:hover,
[data-sibebarbg="color_8"] .deznav .metismenu a:focus,
[data-sibebarbg="color_8"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_8"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_8"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_8"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_8"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_8"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #64adf0;
}

[data-sibebarbg="color_8"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_8"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_8"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_8"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #64adf0;
}

[data-sibebarbg="color_8"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_8"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_8"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_8"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_8"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_8"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #64adf0;
}

[data-sibebarbg="color_8"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_8"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_8"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_8"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_9"] .deznav {
  background-color: #00838f;
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_9"] .deznav .menu-tabs li a.active {
  color: #00838f;
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_9"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_9"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_9"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_9"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_9"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_9"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_9"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_9"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_9"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_9"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_9"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_9"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_9"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_9"] .deznav .metismenu>li {
  border-color: #00b2c2;
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_9"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_9"] .deznav .metismenu a:hover,
[data-sibebarbg="color_9"] .deznav .metismenu a:focus,
[data-sibebarbg="color_9"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_9"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_9"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_9"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_9"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_9"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #00b2c2;
}

[data-sibebarbg="color_9"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_9"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_9"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_9"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #00b2c2;
}

[data-sibebarbg="color_9"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_9"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_9"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_9"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_9"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_9"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #00b2c2;
}

[data-sibebarbg="color_9"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_9"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_9"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_9"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_10"] .deznav {
  background-color: #ff8f16;
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_10"] .deznav .menu-tabs li a.active {
  color: #ff8f16;
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_10"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_10"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_10"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_10"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_10"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_10"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_10"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_10"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_10"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_10"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_10"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_10"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_10"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_10"] .deznav .metismenu>li {
  border-color: #ffa849;
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_10"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_10"] .deznav .metismenu a:hover,
[data-sibebarbg="color_10"] .deznav .metismenu a:focus,
[data-sibebarbg="color_10"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_10"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_10"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_10"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_10"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_10"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #ffa849;
}

[data-sibebarbg="color_10"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_10"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_10"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_10"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #ffa849;
}

[data-sibebarbg="color_10"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_10"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_10"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_10"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_10"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_10"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #ffa849;
}

[data-sibebarbg="color_10"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_10"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_10"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_10"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_11"] .deznav {
  background-color: #6673fd;
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_11"] .deznav .menu-tabs li a.active {
  color: #6673fd;
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_11"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_11"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_11"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_11"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_11"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_11"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_11"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_11"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_11"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_11"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_11"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_11"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_11"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_11"] .deznav .metismenu>li {
  border-color: #98a1fe;
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_11"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_11"] .deznav .metismenu a:hover,
[data-sibebarbg="color_11"] .deznav .metismenu a:focus,
[data-sibebarbg="color_11"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_11"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_11"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_11"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_11"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_11"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #98a1fe;
}

[data-sibebarbg="color_11"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_11"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_11"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_11"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #98a1fe;
}

[data-sibebarbg="color_11"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_11"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_11"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_11"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_11"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_11"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #98a1fe;
}

[data-sibebarbg="color_11"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_11"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_11"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_11"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_12"] .deznav {
  background-color: #558b2f;
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_12"] .deznav .menu-tabs li a.active {
  color: #558b2f;
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_12"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_12"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_12"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_12"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_12"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_12"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_12"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_12"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_12"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_12"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_12"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_12"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_12"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_12"] .deznav .metismenu>li {
  border-color: #6cb13c;
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_12"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_12"] .deznav .metismenu a:hover,
[data-sibebarbg="color_12"] .deznav .metismenu a:focus,
[data-sibebarbg="color_12"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_12"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_12"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_12"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_12"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_12"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #6cb13c;
}

[data-sibebarbg="color_12"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_12"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_12"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_12"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #6cb13c;
}

[data-sibebarbg="color_12"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_12"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_12"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_12"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_12"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_12"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #6cb13c;
}

[data-sibebarbg="color_12"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_12"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_12"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_12"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_13"] .deznav {
  background-color: #2a2a2a;
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_13"] .deznav .menu-tabs li a.active {
  color: #2a2a2a;
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_13"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_13"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_13"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_13"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_13"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_13"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_13"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_13"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_13"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_13"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_13"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_13"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_13"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_13"] .deznav .metismenu>li {
  border-color: #444444;
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_13"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_13"] .deznav .metismenu a:hover,
[data-sibebarbg="color_13"] .deznav .metismenu a:focus,
[data-sibebarbg="color_13"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_13"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_13"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_13"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_13"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_13"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #444444;
}

[data-sibebarbg="color_13"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_13"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_13"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_13"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #444444;
}

[data-sibebarbg="color_13"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_13"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_13"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_13"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_13"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_13"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #444444;
}

[data-sibebarbg="color_13"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_13"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_13"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_13"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_14"] .deznav {
  background-color: #1367c8;
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_14"] .deznav .menu-tabs li a.active {
  color: #1367c8;
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_14"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_14"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_14"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_14"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_14"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_14"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_14"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_14"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_14"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_14"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_14"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_14"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_14"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_14"] .deznav .metismenu>li {
  border-color: #2480ea;
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_14"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_14"] .deznav .metismenu a:hover,
[data-sibebarbg="color_14"] .deznav .metismenu a:focus,
[data-sibebarbg="color_14"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_14"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_14"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_14"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_14"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_14"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #2480ea;
}

[data-sibebarbg="color_14"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_14"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_14"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_14"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #2480ea;
}

[data-sibebarbg="color_14"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_14"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_14"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_14"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_14"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_14"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #2480ea;
}

[data-sibebarbg="color_14"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_14"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_14"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_14"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav,
[data-sibebarbg="color_15"] .deznav {
  background-color: #ed0b4c;
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .menu-tabs li a.active,
[data-sibebarbg="color_15"] .deznav .menu-tabs li a.active {
  color: #ed0b4c;
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu .nav-label,
[data-sibebarbg="color_15"] .deznav .metismenu .nav-label {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li>a,
[data-sibebarbg="color_15"] .deznav .metismenu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li>a svg,
[data-sibebarbg="color_15"] .deznav .metismenu>li>a svg {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li>a g [fill],
[data-sibebarbg="color_15"] .deznav .metismenu>li>a g [fill] {
  fill: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_15"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_15"] .deznav .metismenu>li:focus>a,
[data-sibebarbg="color_15"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a g [fill],
[data-sibebarbg="color_15"] .deznav .metismenu>li:hover>a g [fill],
[data-sibebarbg="color_15"] .deznav .metismenu>li:focus>a g [fill],
[data-sibebarbg="color_15"] .deznav .metismenu>li.mm-active>a g [fill] {
  fill: #fff;
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li.mm-active>a svg,
[data-sibebarbg="color_15"] .deznav .metismenu>li:hover>a svg,
[data-sibebarbg="color_15"] .deznav .metismenu>li:focus>a svg,
[data-sibebarbg="color_15"] .deznav .metismenu>li.mm-active>a svg {
  color: #fff;
}

[data-layout="horizontal"][data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu>li,
[data-sibebarbg="color_15"] .deznav .metismenu>li {
  border-color: #f6356d;
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu a,
[data-sibebarbg="color_15"] .deznav .metismenu a {
  color: rgba(255, 255, 255, 0.7);
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu a:hover,
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu a:focus,
[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu a.mm-active,
[data-sibebarbg="color_15"] .deznav .metismenu a:hover,
[data-sibebarbg="color_15"] .deznav .metismenu a:focus,
[data-sibebarbg="color_15"] .deznav .metismenu a.mm-active {
  color: #fff;
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu ul,
[data-sibebarbg="color_15"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_15"][data-theme-version="dark"] .deznav .metismenu ul:after,
[data-sibebarbg="color_15"] .deznav .metismenu ul:after {
  background-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_15"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul,
[data-sibebarbg="color_15"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu li>ul {
  background-color: #f6356d;
}

[data-sibebarbg="color_15"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_15"][data-theme-version="dark"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_15"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_15"][data-sidebar-style="mini"][data-layout="vertical"] .deznav .metismenu>li:hover>a {
  background-color: #f6356d;
}

[data-sibebarbg="color_15"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_15"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_15"][data-theme-version="dark"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a,
[data-sibebarbg="color_15"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul,
[data-sibebarbg="color_15"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li.mm-active>a,
[data-sibebarbg="color_15"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu>li:hover>a {
  background-color: #f6356d;
}

[data-sibebarbg="color_15"][data-theme-version="dark"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul,
[data-sibebarbg="color_15"][data-sidebar-style="icon-hover"][data-layout="vertical"] .deznav .metismenu ul {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-sibebarbg="color_15"][data-theme-version="dark"][data-layout="horizontal"] .deznav .metismenu>li,
[data-sibebarbg="color_15"][data-layout="horizontal"] .deznav .metismenu>li {
  border-color: rgba(255, 255, 255, 0.2);
}

[data-headerbg="transparent"] .header {
  box-shadow: none;
  background: transparent;
}

[data-headerbg="color_1"] .nav-header .hamburger.is-active .line,
[data-headerbg="color_1"] .nav-header .hamburger .line {
  background: #00ADEE !important;
}

@media (min-width: 992px) {
  [data-container="boxed"] #main-wrapper {
    max-width: 1199px;
    margin: 0 auto;
  }

  [direction="rtl"][data-container="boxed"] #main-wrapper {
    text-align: right;
  }
}

@media only screen and (min-width: 1350px) {
  [data-layout="vertical"][data-sidebar-style="overlay"][data-container="boxed"][data-header-position="fixed"] .header {
    width: 1199px;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1349px) {
  [data-layout="vertical"][data-sidebar-style="overlay"][data-container="boxed"][data-header-position="fixed"] .header {
    width: 1199px;
  }
}

[data-header-position="fixed"][data-layout="horizontal"][data-container="boxed"] .deznav {
  max-width: 1199px;
}

[data-layout="horizontal"][data-container="boxed"][data-header-position="fixed"] .header {
  width: 1199px;
}

[data-layout="horizontal"][data-container="boxed"][data-header-position="fixed"][data-sidebar-style="mini"] .header {
  width: 1199px;
}

[data-container="boxed"] .metismenu.fixed {
  left: auto;
  max-width: 1199px;
}

[data-container="boxed"] .page-titles {
  margin-bottom: 3rem;
  padding: 15px 15px;
}

[data-container="boxed"] .content-body .container-fluid,
[data-container="boxed"] .content-body .container-sm,
[data-container="boxed"] .content-body .container-md,
[data-container="boxed"] .content-body .container-lg,
[data-container="boxed"] .content-body .container-xl {
  padding: 0.9375rem 0.9375rem 0 0.9375rem;
}

[data-container="boxed"][data-layout="vertical"] .page-titles {
  margin-left: 0;
  margin-right: 0;
}

[data-layout="vertical"][data-container="boxed"][data-sidebar-position="fixed"][data-header-position="static"][data-sidebar-style="overlay"] .nav-header {
  position: absolute;
}

[data-layout="vertical"][data-container="boxed"][data-sidebar-position="fixed"][data-header-position="static"][data-sidebar-style="overlay"] .menu-toggle .deznav {
  position: absolute;
}

[data-container="boxed"][data-sidebar-position="fixed"][data-layout="horizontal"] .deznav.fixed {
  left: auto;
  max-width: 1199px;
}

@media (min-width: 992px) {
  [data-container="wide-boxed"] #main-wrapper {
    max-width: 1480px;
    margin: 0 auto;
  }
}

@media (min-width: 992px) {
  [data-container="wide-boxed"][data-sidebar-style="full"] .header {
    width: 100%;
  }

  [data-container="wide-boxed"][data-sidebar-style="full"] .menu-toggle .header {
    width: 100%;
  }

  [data-header-position="fixed"][data-container="wide-boxed"][data-sidebar-style="full"] .header {
    max-width: 1480px;
  }

  [data-header-position="fixed"][data-container="wide-boxed"][data-sidebar-style="full"] .menu-toggle .header {
    max-width: 1480px;
  }
}

@media (min-width: 992px) {
  [data-container="wide-boxed"][data-sidebar-style="mini"] .header {
    width: 100%;
  }

  [data-header-position="fixed"][data-container="wide-boxed"][data-sidebar-style="mini"] .header {
    max-width: 1480px;
  }

  [data-header-position="fixed"][data-layout="horizontal"][data-container="wide-boxed"][data-sidebar-style="mini"] .header {
    max-width: 1480px;
  }
}

@media (min-width: 992px) {
  [data-container="wide-boxed"][data-sidebar-style="compact"] .header {
    width: 100%;
  }

  [data-header-position="fixed"][data-container="wide-boxed"][data-sidebar-style="compact"] .header {
    max-width: 1480px;
  }
}

@media (min-width: 992px) {
  [data-container="wide-boxed"][data-sidebar-style="overlay"] .header {
    width: 100%;
  }

  [data-header-position="fixed"][data-container="wide-boxed"][data-sidebar-style="overlay"] .header {
    max-width: 1480px;
  }
}

[data-layout="horizontal"][data-container="wide-boxed"] .header {
  width: 100%;
}

[data-sidebar-style="full"][data-header-position="fixed"][data-layout="horizontal"][data-container="wide-boxed"] .header {
  max-width: 1480px;
}

[data-sidebar-style="mini"][data-layout="horizontal"][data-container="wide-boxed"] .header {
  width: 100%;
}

[data-layout="horizontal"][data-container="wide-boxed"][data-sidebar-position="fixed"] .deznav.fixed {
  max-width: 1480px;
  transition: none;
}

[data-layout="horizontal"][data-container="wide-boxed"][data-sidebar-position="fixed"][direction="rtl"] .deznav.fixed {
  right: 5%;
}

[data-layout="horizontal"][data-container="wide-boxed"][data-sidebar-position="fixed"][data-header-position="fixed"] .deznav {
  max-width: 1480px;
  left: 5%;
}

[data-layout="horizontal"][data-container="wide-boxed"][data-sidebar-position="fixed"][data-header-position="fixed"][direction="rtl"] .deznav {
  right: 5%;
}

[data-primary="color_2"] a:hover,
[data-primary="color_2"] a:focus,
[data-primary="color_2"] a.active {
  color: #143b64;
}

[data-primary="color_2"] [data-class="bg-primary"]:before {
  background: #143b64;
}

[data-primary="color_2"] .email-left-box .intro-title {
  background: rgba(20, 59, 100, 0.1);
}

[data-primary="color_2"] .email-left-box .intro-title i {
  color: #143b64;
}

[data-primary="color_2"] .widget-stat .media .media-body h4 {
  color: #143b64 !important;
}

[data-primary="color_2"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(20, 59, 100, 0.1);
}

[data-primary="color_2"] .mail-list .list-group-item.active i {
  color: #143b64;
}

[data-primary="color_2"] .single-mail.active {
  background: #143b64;
}

[data-primary="color_2"] .profile-info h4.text-primary {
  color: #143b64 !important;
}

[data-primary="color_2"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_2"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #143b64;
  color: #143b64;
}

[data-primary="color_2"] .amChartsInputField {
  border: 0;
  background: #143b64;
}

[data-primary="color_2"] .amcharts-period-input,
[data-primary="color_2"] .amcharts-period-input-selected {
  background: #143b64;
}

[data-primary="color_2"] .morris-hover {
  background: #143b64;
}

[data-primary="color_2"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #143b64;
}

[data-primary="color_2"] .custom-select:focus {
  border-color: #143b64;
  color: #143b64;
}

[data-primary="color_2"] .daterangepicker td.active {
  background-color: #143b64;
}

[data-primary="color_2"] .daterangepicker td.active:hover {
  background-color: #143b64;
}

[data-primary="color_2"] .daterangepicker button.applyBtn {
  background-color: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .wizard>.steps li.current a {
  background-color: #143b64;
}

[data-primary="color_2"] .wizard .skip-email a {
  color: #143b64;
}

[data-primary="color_2"] .wizard>.actions li:not(.disabled) a {
  background-color: #143b64;
}

[data-primary="color_2"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #143b64;
}

[data-primary="color_2"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #143b64;
}

[data-primary="color_2"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #143b64;
}

[data-primary="color_2"] .is-invalid .input-group-prepend .input-group-text i {
  color: #2161a4;
}

[data-primary="color_2"] .datamaps-hoverover {
  color: #143b64;
  border: 1px solid rgba(20, 59, 100, 0.3);
}

[data-primary="color_2"] .jqvmap-zoomin,
[data-primary="color_2"] .jqvmap-zoomout {
  background-color: #143b64;
}

[data-primary="color_2"] .table .thead-primary th {
  background-color: #143b64;
}

[data-primary="color_2"] .table.primary-table-bg-hover thead th {
  background-color: #102e4f;
}

[data-primary="color_2"] .table.primary-table-bg-hover tbody tr {
  background-color: #143b64;
}

[data-primary="color_2"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #184879;
}

[data-primary="color_2"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_2"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #102e4f;
}

[data-primary="color_2"] table.dataTable tr.selected {
  color: #143b64;
}

[data-primary="color_2"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #143b64 !important;
  background: rgba(20, 59, 100, 0.1);
}

[data-primary="color_2"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #143b64 !important;
  background: rgba(20, 59, 100, 0.1);
}

[data-primary="color_2"] .clipboard-btn:hover {
  background-color: #143b64;
}

[data-primary="color_2"] .cd-h-timeline__dates::before {
  background: #143b64;
}

[data-primary="color_2"] .cd-h-timeline__dates::after {
  background: #143b64;
}

[data-primary="color_2"] .cd-h-timeline__line {
  background-color: #143b64;
}

[data-primary="color_2"] .cd-h-timeline__date:after {
  border-color: #153d68;
  background-color: #143b64;
}

[data-primary="color_2"] .cd-h-timeline__navigation {
  border-color: #153d68;
}

[data-primary="color_2"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #153d68;
}

[data-primary="color_2"] .dd-handle {
  background: #143b64;
}

[data-primary="color_2"] .dd-handle:hover {
  background: #143b64;
}

[data-primary="color_2"] .dd3-content:hover {
  background: #143b64;
}

[data-primary="color_2"] .noUi-connect {
  background-color: #143b64;
}

[data-primary="color_2"] .noUi-connect.c-3-color {
  background-color: #143b64;
}

[data-primary="color_2"] .noUi-horizontal .noUi-handle,
[data-primary="color_2"] .noUi-vertical .noUi-handle {
  background-color: #143b64;
}

[data-primary="color_2"] #slider-toggle.off .noUi-handle {
  border-color: #143b64;
}

[data-primary="color_2"] .pignose-calendar {
  border-color: #143b64;
}

[data-primary="color_2"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #143b64;
}

[data-primary="color_2"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #143b64;
}

[data-primary="color_2"] .bootstrap-tagsinput .tag {
  background-color: #143b64;
}

[data-primary="color_2"] .toast-success {
  background-color: #143b64;
}

[data-primary="color_2"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #143b64;
}

[data-primary="color_2"] .accordion-header-bg .accordion__header--primary {
  background-color: #143b64;
}

[data-primary="color_2"] .alert-primary {
  background: #297ace;
  border-color: #297ace;
  color: #143b64;
}

[data-primary="color_2"] .alert-alt.alert-primary {
  border-left: 4px solid #143b64;
}

[data-primary="color_2"] .alert-alt.alert-primary.solid {
  border-left: 4px solid black !important;
}

[data-primary="color_2"] .alert.alert-primary.solid {
  background: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .alert.alert-outline-primary {
  color: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .badge-outline-primary {
  border: 1px solid #143b64;
  color: #143b64;
}

[data-primary="color_2"] .badge-primary {
  background-color: #143b64;
}

[data-primary="color_2"] .page-titles h4 {
  color: #143b64;
}

[data-primary="color_2"] .card-action>a {
  background: black;
}

[data-primary="color_2"] .card-action .dropdown {
  background: black;
  color: #143b64;
}

[data-primary="color_2"] .card-action .dropdown:hover,
[data-primary="color_2"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_2"] .card-loader i {
  background: #0e2946;
}

[data-primary="color_2"] .dropdown-outline {
  border: 0.1rem solid #143b64;
}

[data-primary="color_2"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #143b64;
}

[data-primary="color_2"] .card-action .custom-dropdown {
  background: #3a87d8;
}

[data-primary="color_2"] .card-action .custom-dropdown.show,
[data-primary="color_2"] .card-action .custom-dropdown:focus,
[data-primary="color_2"] .card-action .custom-dropdown:hover {
  background: #143b64;
}

[data-primary="color_2"] .label-primary {
  background: #143b64;
}

[data-primary="color_2"] .pagination .page-item .page-link:hover {
  background: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .pagination .page-item.active .page-link {
  background-color: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_2"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #143b64;
}

[data-primary="color_2"] .progress-bar {
  background-color: #143b64;
}

[data-primary="color_2"] .progress-bar-primary {
  background-color: #143b64;
}

[data-primary="color_2"] .ribbon__four {
  background-color: #143b64;
}

[data-primary="color_2"] .ribbon__four:after,
[data-primary="color_2"] .ribbon__four:before {
  background-color: #256db9;
}

[data-primary="color_2"] .ribbon__five {
  background-color: #143b64;
}

[data-primary="color_2"] .ribbon__five::before {
  border-color: transparent transparent #143b64 transparent;
}

[data-primary="color_2"] .ribbon__six {
  background-color: #143b64;
}

[data-primary="color_2"] .multi-steps>li {
  color: #143b64;
}

[data-primary="color_2"] .multi-steps>li:after {
  background-color: #143b64;
}

[data-primary="color_2"] .multi-steps>li.is-active:before {
  border-color: #143b64;
}

[data-primary="color_2"] .timeline-badge.primary {
  background-color: #143b64 !important;
}

[data-primary="color_2"] .tooltip-wrapper button:hover {
  background: #143b64;
}

[data-primary="color_2"] .chart_widget_tab_one .nav-link.active {
  background-color: #143b64;
  border: 1px solid #143b64;
}

[data-primary="color_2"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #143b64;
}

[data-primary="color_2"] .social-icon2 a {
  border: 0.1rem solid #143b64;
}

[data-primary="color_2"] .social-icon2 i {
  color: #143b64;
}

[data-primary="color_2"] .social-icon3 ul li a:hover i {
  color: #143b64;
}

[data-primary="color_2"] .bgl-primary {
  background: #3a87d8;
  border-color: #3a87d8;
  color: #143b64;
}

[data-primary="color_2"] .tdl-holder input[type=checkbox]:checked+i {
  background: #143b64;
}

[data-primary="color_2"] .footer .copyright a {
  color: #143b64;
}

[data-primary="color_2"] .hamburger .line {
  background: #143b64;
}

[data-primary="color_2"] svg.pulse-svg .first-circle,
[data-primary="color_2"] svg.pulse-svg .second-circle,
[data-primary="color_2"] svg.pulse-svg .third-circle {
  fill: #143b64;
}

[data-primary="color_2"] .pulse-css {
  background: #143b64;
}

[data-primary="color_2"] .pulse-css:after,
[data-primary="color_2"] .pulse-css:before {
  background-color: #143b64;
}

[data-primary="color_2"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #143b64;
}

[data-primary="color_2"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_2"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_2"] .header-right .header-profile .dropdown-menu a.active {
  color: #143b64;
}

[data-primary="color_2"] .header-right .header-profile .profile_title {
  background: #143b64;
}

[data-primary="color_2"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #143b64 !important;
}

[data-primary="color_2"] .deznav .metismenu>li>a svg {
  color: #143b64;
}

[data-primary="color_2"] .deznav .metismenu>li:hover>a,
[data-primary="color_2"] .deznav .metismenu>li:focus>a {
  color: #143b64;
}

[data-primary="color_2"] .deznav .metismenu>li.mm-active>a {
  color: #143b64;
}

[data-primary="color_2"] .deznav .metismenu ul a:hover,
[data-primary="color_2"] .deznav .metismenu ul a:focus,
[data-primary="color_2"] .deznav .metismenu ul a.mm-active {
  color: #143b64;
}

@media (min-width: 767px) {

  [data-primary="color_2"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_2"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_2"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_2"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #8fbae9;
  }
}

[data-primary="color_2"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #143b64;
}

[data-primary="color_2"] .nav-user {
  background: #143b64;
}

[data-primary="color_2"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #143b64;
}

[data-primary="color_2"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #143b64;
}

[data-primary="color_2"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"][data-theme-version="dark"] .header-left input:focus {
  border-color: #143b64;
}

[data-primary="color_2"][data-theme-version="dark"] .loader__bar {
  background: #143b64;
}

[data-primary="color_2"][data-theme-version="dark"] .loader__ball {
  background: #143b64;
}

[data-primary="color_2"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #143b64;
}

[data-primary="color_2"] .new-arrival-content .price {
  color: #143b64;
}

[data-primary="color_2"] .chart-link a i.text-primary {
  color: #143b64;
}

[data-primary="color_2"] #user-activity .nav-tabs .nav-link.active {
  background: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] span#counter {
  color: #143b64;
}

[data-primary="color_2"] .welcome-content:after {
  background: #143b64;
}

[data-primary="color_2"] .timeline-badge {
  background-color: #143b64;
}

[data-primary="color_2"] .page-timeline .timeline-workplan[data-primary="color_2"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(20, 59, 100, 0.4);
}

[data-primary="color_2"] .sk-three-bounce .sk-child {
  background-color: #143b64;
}

[data-primary="color_2"] .dropdown-item.active,
[data-primary="color_2"] .dropdown-item:active {
  color: #fff;
  background-color: #143b64;
}

[data-primary="color_2"] .overlay-box:after {
  background: #143b64;
}

[data-primary="color_2"] .btn-primary {
  background-color: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .bg-primary {
  background-color: #143b64 !important;
}

[data-primary="color_2"] .text-primary {
  color: #143b64 !important;
}

[data-primary="color_2"] .btn-primary:hover {
  background-color: #071524;
  border-color: #071524;
}

[data-primary="color_2"] .btn-outline-primary {
  color: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .btn-outline-primary:hover {
  background-color: #143b64;
  border-color: #143b64;
}

[data-primary="color_2"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_2"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_2"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_2"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_2"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_2"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #071524;
  border-color: #071524;
}

[data-primary="color_3"] a:hover,
[data-primary="color_3"] a:focus,
[data-primary="color_3"] a.active {
  color: #00ADEE;
}

[data-primary="color_3"] [data-class="bg-primary"]:before {
  background: #00ADEE;
}

[data-primary="color_3"] .email-left-box .intro-title {
  background: rgba(135, 67, 223, 0.1);
}

[data-primary="color_3"] .email-left-box .intro-title i {
  color: #00ADEE;
}

[data-primary="color_3"] .widget-stat .media .media-body h4 {
  color: #00ADEE !important;
}

[data-primary="color_3"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(135, 67, 223, 0.1);
}

[data-primary="color_3"] .mail-list .list-group-item.active i {
  color: #00ADEE;
}

[data-primary="color_3"] .single-mail.active {
  background: #00ADEE;
}

[data-primary="color_3"] .profile-info h4.text-primary {
  color: #00ADEE !important;
}

[data-primary="color_3"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_3"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #00ADEE;
  color: #00ADEE;
}

[data-primary="color_3"] .amChartsInputField {
  border: 0;
  background: #00ADEE;
}

[data-primary="color_3"] .amcharts-period-input,
[data-primary="color_3"] .amcharts-period-input-selected {
  background: #00ADEE;
}

[data-primary="color_3"] .morris-hover {
  background: #00ADEE;
}

[data-primary="color_3"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #00ADEE;
}

[data-primary="color_3"] .custom-select:focus {
  border-color: #00ADEE;
  color: #00ADEE;
}

[data-primary="color_3"] .daterangepicker td.active {
  background-color: #00ADEE;
}

[data-primary="color_3"] .daterangepicker td.active:hover {
  background-color: #00ADEE;
}

[data-primary="color_3"] .daterangepicker button.applyBtn {
  background-color: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .wizard>.steps li.current a {
  background-color: #00ADEE;
}

[data-primary="color_3"] .wizard .skip-email a {
  color: #00ADEE;
}

[data-primary="color_3"] .wizard>.actions li:not(.disabled) a {
  background-color: #00ADEE;
}

[data-primary="color_3"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #00ADEE;
}

[data-primary="color_3"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #00ADEE;
}

[data-primary="color_3"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #00ADEE;
}

[data-primary="color_3"] .is-invalid .input-group-prepend .input-group-text i {
  color: #b184ea;
}

[data-primary="color_3"] .datamaps-hoverover {
  color: #00ADEE;
  border: 1px solid rgba(135, 67, 223, 0.3);
}

[data-primary="color_3"] .jqvmap-zoomin,
[data-primary="color_3"] .jqvmap-zoomout {
  background-color: #00ADEE;
}

[data-primary="color_3"] .table .thead-primary th {
  background-color: #00ADEE;
}

[data-primary="color_3"] .table.primary-table-bg-hover thead th {
  background-color: #792ddb;
}

[data-primary="color_3"] .table.primary-table-bg-hover tbody tr {
  background-color: #00ADEE;
}

[data-primary="color_3"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #9559e3;
}

[data-primary="color_3"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_3"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #792ddb;
}

[data-primary="color_3"] table.dataTable tr.selected {
  color: #00ADEE;
}

[data-primary="color_3"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #00ADEE !important;
  background: rgba(135, 67, 223, 0.1);
}

[data-primary="color_3"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #00ADEE !important;
  background: rgba(135, 67, 223, 0.1);
}

[data-primary="color_3"] .clipboard-btn:hover {
  background-color: #00ADEE;
}

[data-primary="color_3"] .cd-h-timeline__dates::before {
  background: #00ADEE;
}

[data-primary="color_3"] .cd-h-timeline__dates::after {
  background: #00ADEE;
}

[data-primary="color_3"] .cd-h-timeline__line {
  background-color: #00ADEE;
}

[data-primary="color_3"] .cd-h-timeline__date:after {
  border-color: #8a47e0;
  background-color: #00ADEE;
}

[data-primary="color_3"] .cd-h-timeline__navigation {
  border-color: #8a47e0;
}

[data-primary="color_3"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #8a47e0;
}

[data-primary="color_3"] .dd-handle {
  background: #00ADEE;
}

[data-primary="color_3"] .dd-handle:hover {
  background: #00ADEE;
}

[data-primary="color_3"] .dd3-content:hover {
  background: #00ADEE;
}

[data-primary="color_3"] .noUi-connect {
  background-color: #00ADEE;
}

[data-primary="color_3"] .noUi-connect.c-3-color {
  background-color: #00ADEE;
}

[data-primary="color_3"] .noUi-horizontal .noUi-handle,
[data-primary="color_3"] .noUi-vertical .noUi-handle {
  background-color: #00ADEE;
}

[data-primary="color_3"] #slider-toggle.off .noUi-handle {
  border-color: #00ADEE;
}

[data-primary="color_3"] .pignose-calendar {
  border-color: #00ADEE;
}

[data-primary="color_3"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #00ADEE;
}

[data-primary="color_3"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #00ADEE;
}

[data-primary="color_3"] .bootstrap-tagsinput .tag {
  background-color: #00ADEE;
}

[data-primary="color_3"] .toast-success {
  background-color: #00ADEE;
}

[data-primary="color_3"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #00ADEE;
}

[data-primary="color_3"] .accordion-header-bg .accordion__header--primary {
  background-color: #00ADEE;
}

[data-primary="color_3"] .alert-primary {
  background: #cdb0f2;
  border-color: #cdb0f2;
  color: #00ADEE;
}

[data-primary="color_3"] .alert-alt.alert-primary {
  border-left: 4px solid #00ADEE;
}

[data-primary="color_3"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #4a188b !important;
}

[data-primary="color_3"] .alert.alert-primary.solid {
  background: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .alert.alert-outline-primary {
  color: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .badge-outline-primary {
  border: 1px solid #00ADEE;
  color: #00ADEE;
}

[data-primary="color_3"] .badge-primary {
  background-color: #00ADEE;
}

[data-primary="color_3"] .page-titles h4 {
  color: #00ADEE;
}

[data-primary="color_3"] .card-action>a {
  background: black;
}

[data-primary="color_3"] .card-action .dropdown {
  background: black;
  color: #00ADEE;
}

[data-primary="color_3"] .card-action .dropdown:hover,
[data-primary="color_3"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_3"] .card-loader i {
  background: #7425d9;
}

[data-primary="color_3"] .dropdown-outline {
  border: 0.1rem solid #00ADEE;
}

[data-primary="color_3"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #00ADEE;
}

[data-primary="color_3"] .card-action .custom-dropdown {
  background: #dac6f5;
}

[data-primary="color_3"] .card-action .custom-dropdown.show,
[data-primary="color_3"] .card-action .custom-dropdown:focus,
[data-primary="color_3"] .card-action .custom-dropdown:hover {
  background: #00ADEE;
}

[data-primary="color_3"] .label-primary {
  background: #00ADEE;
}

[data-primary="color_3"] .pagination .page-item .page-link:hover {
  background: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .pagination .page-item.active .page-link {
  background-color: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_3"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #00ADEE;
}

[data-primary="color_3"] .progress-bar {
  background-color: #00ADEE;
}

[data-primary="color_3"] .progress-bar-primary {
  background-color: #00ADEE;
}

[data-primary="color_3"] .ribbon__four {
  background-color: #00ADEE;
}

[data-primary="color_3"] .ribbon__four:after,
[data-primary="color_3"] .ribbon__four:before {
  background-color: #bf9aee;
}

[data-primary="color_3"] .ribbon__five {
  background-color: #00ADEE;
}

[data-primary="color_3"] .ribbon__five::before {
  border-color: transparent transparent #00ADEE transparent;
}

[data-primary="color_3"] .ribbon__six {
  background-color: #00ADEE;
}

[data-primary="color_3"] .multi-steps>li {
  color: #00ADEE;
}

[data-primary="color_3"] .multi-steps>li:after {
  background-color: #00ADEE;
}

[data-primary="color_3"] .multi-steps>li.is-active:before {
  border-color: #00ADEE;
}

[data-primary="color_3"] .timeline-badge.primary {
  background-color: #00ADEE !important;
}

[data-primary="color_3"] .tooltip-wrapper button:hover {
  background: #00ADEE;
}

[data-primary="color_3"] .chart_widget_tab_one .nav-link.active {
  background-color: #00ADEE;
  border: 1px solid #00ADEE;
}

[data-primary="color_3"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #00ADEE;
}

[data-primary="color_3"] .social-icon2 a {
  border: 0.1rem solid #00ADEE;
}

[data-primary="color_3"] .social-icon2 i {
  color: #00ADEE;
}

[data-primary="color_3"] .social-icon3 ul li a:hover i {
  color: #00ADEE;
}

[data-primary="color_3"] .bgl-primary {
  background: #dac6f5;
  border-color: #dac6f5;
  color: #00ADEE;
}

[data-primary="color_3"] .tdl-holder input[type=checkbox]:checked+i {
  background: #00ADEE;
}

[data-primary="color_3"] .footer .copyright a {
  color: #00ADEE;
}

[data-primary="color_3"] .hamburger .line {
  background: #00ADEE;
}

[data-primary="color_3"] svg.pulse-svg .first-circle,
[data-primary="color_3"] svg.pulse-svg .second-circle,
[data-primary="color_3"] svg.pulse-svg .third-circle {
  fill: #00ADEE;
}

[data-primary="color_3"] .pulse-css {
  background: #00ADEE;
}

[data-primary="color_3"] .pulse-css:after,
[data-primary="color_3"] .pulse-css:before {
  background-color: #00ADEE;
}

[data-primary="color_3"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #00ADEE;
}

[data-primary="color_3"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_3"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_3"] .header-right .header-profile .dropdown-menu a.active {
  color: #00ADEE;
}

[data-primary="color_3"] .header-right .header-profile .profile_title {
  background: #00ADEE;
}

[data-primary="color_3"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #00ADEE !important;
}

[data-primary="color_3"] .deznav .metismenu>li>a svg {
  color: #00ADEE;
}

[data-primary="color_3"] .deznav .metismenu>li:hover>a,
[data-primary="color_3"] .deznav .metismenu>li:focus>a {
  color: #00ADEE;
}

[data-primary="color_3"] .deznav .metismenu>li.mm-active>a {
  color: #00ADEE;
}

[data-primary="color_3"] .deznav .metismenu ul a:hover,
[data-primary="color_3"] .deznav .metismenu ul a:focus,
[data-primary="color_3"] .deznav .metismenu ul a.mm-active {
  color: #00ADEE;
}

@media (min-width: 767px) {

  [data-primary="color_3"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_3"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_3"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_3"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: white;
  }
}

[data-primary="color_3"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #00ADEE;
}

[data-primary="color_3"] .nav-user {
  background: #00ADEE;
}

[data-primary="color_3"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #00ADEE;
}

[data-primary="color_3"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #00ADEE;
}

[data-primary="color_3"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"][data-theme-version="dark"] .header-left input:focus {
  border-color: #00ADEE;
}

[data-primary="color_3"][data-theme-version="dark"] .loader__bar {
  background: #00ADEE;
}

[data-primary="color_3"][data-theme-version="dark"] .loader__ball {
  background: #00ADEE;
}

[data-primary="color_3"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #00ADEE;
}

[data-primary="color_3"] .new-arrival-content .price {
  color: #00ADEE;
}

[data-primary="color_3"] .chart-link a i.text-primary {
  color: #00ADEE;
}

[data-primary="color_3"] #user-activity .nav-tabs .nav-link.active {
  background: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] span#counter {
  color: #00ADEE;
}

[data-primary="color_3"] .welcome-content:after {
  background: #00ADEE;
}

[data-primary="color_3"] .timeline-badge {
  background-color: #00ADEE;
}

[data-primary="color_3"] .page-timeline .timeline-workplan[data-primary="color_3"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(135, 67, 223, 0.4);
}

[data-primary="color_3"] .sk-three-bounce .sk-child {
  background-color: #00ADEE;
}

[data-primary="color_3"] .dropdown-item.active,
[data-primary="color_3"] .dropdown-item:active {
  color: #fff;
  background-color: #00ADEE;
}

[data-primary="color_3"] .overlay-box:after {
  background: #00ADEE;
}

[data-primary="color_3"] .btn-primary {
  background-color: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .bg-primary {
  background-color: #00ADEE !important;
}

[data-primary="color_3"] .text-primary {
  color: #00ADEE !important;
}

[data-primary="color_3"] .btn-primary:hover {
  background-color: #611fb6;
  border-color: #611fb6;
}

[data-primary="color_3"] .btn-outline-primary {
  color: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .btn-outline-primary:hover {
  background-color: #00ADEE;
  border-color: #00ADEE;
}

[data-primary="color_3"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_3"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_3"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_3"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_3"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_3"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #611fb6;
  border-color: #611fb6;
}

[data-primary="color_4"] a:hover,
[data-primary="color_4"] a:focus,
[data-primary="color_4"] a.active {
  color: #4527a0;
}

[data-primary="color_4"] [data-class="bg-primary"]:before {
  background: #4527a0;
}

[data-primary="color_4"] .email-left-box .intro-title {
  background: rgba(69, 39, 160, 0.1);
}

[data-primary="color_4"] .email-left-box .intro-title i {
  color: #4527a0;
}

[data-primary="color_4"] .widget-stat .media .media-body h4 {
  color: #4527a0 !important;
}

[data-primary="color_4"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(69, 39, 160, 0.1);
}

[data-primary="color_4"] .mail-list .list-group-item.active i {
  color: #4527a0;
}

[data-primary="color_4"] .single-mail.active {
  background: #4527a0;
}

[data-primary="color_4"] .profile-info h4.text-primary {
  color: #4527a0 !important;
}

[data-primary="color_4"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_4"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #4527a0;
  color: #4527a0;
}

[data-primary="color_4"] .amChartsInputField {
  border: 0;
  background: #4527a0;
}

[data-primary="color_4"] .amcharts-period-input,
[data-primary="color_4"] .amcharts-period-input-selected {
  background: #4527a0;
}

[data-primary="color_4"] .morris-hover {
  background: #4527a0;
}

[data-primary="color_4"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #4527a0;
}

[data-primary="color_4"] .custom-select:focus {
  border-color: #4527a0;
  color: #4527a0;
}

[data-primary="color_4"] .daterangepicker td.active {
  background-color: #4527a0;
}

[data-primary="color_4"] .daterangepicker td.active:hover {
  background-color: #4527a0;
}

[data-primary="color_4"] .daterangepicker button.applyBtn {
  background-color: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .wizard>.steps li.current a {
  background-color: #4527a0;
}

[data-primary="color_4"] .wizard .skip-email a {
  color: #4527a0;
}

[data-primary="color_4"] .wizard>.actions li:not(.disabled) a {
  background-color: #4527a0;
}

[data-primary="color_4"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #4527a0;
}

[data-primary="color_4"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #4527a0;
}

[data-primary="color_4"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #4527a0;
}

[data-primary="color_4"] .is-invalid .input-group-prepend .input-group-text i {
  color: #6642d1;
}

[data-primary="color_4"] .datamaps-hoverover {
  color: #4527a0;
  border: 1px solid rgba(69, 39, 160, 0.3);
}

[data-primary="color_4"] .jqvmap-zoomin,
[data-primary="color_4"] .jqvmap-zoomout {
  background-color: #4527a0;
}

[data-primary="color_4"] .table .thead-primary th {
  background-color: #4527a0;
}

[data-primary="color_4"] .table.primary-table-bg-hover thead th {
  background-color: #3c228b;
}

[data-primary="color_4"] .table.primary-table-bg-hover tbody tr {
  background-color: #4527a0;
}

[data-primary="color_4"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #4e2cb5;
}

[data-primary="color_4"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_4"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #3c228b;
}

[data-primary="color_4"] table.dataTable tr.selected {
  color: #4527a0;
}

[data-primary="color_4"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #4527a0 !important;
  background: rgba(69, 39, 160, 0.1);
}

[data-primary="color_4"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #4527a0 !important;
  background: rgba(69, 39, 160, 0.1);
}

[data-primary="color_4"] .clipboard-btn:hover {
  background-color: #4527a0;
}

[data-primary="color_4"] .cd-h-timeline__dates::before {
  background: #4527a0;
}

[data-primary="color_4"] .cd-h-timeline__dates::after {
  background: #4527a0;
}

[data-primary="color_4"] .cd-h-timeline__line {
  background-color: #4527a0;
}

[data-primary="color_4"] .cd-h-timeline__date:after {
  border-color: #4728a4;
  background-color: #4527a0;
}

[data-primary="color_4"] .cd-h-timeline__navigation {
  border-color: #4728a4;
}

[data-primary="color_4"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #4728a4;
}

[data-primary="color_4"] .dd-handle {
  background: #4527a0;
}

[data-primary="color_4"] .dd-handle:hover {
  background: #4527a0;
}

[data-primary="color_4"] .dd3-content:hover {
  background: #4527a0;
}

[data-primary="color_4"] .noUi-connect {
  background-color: #4527a0;
}

[data-primary="color_4"] .noUi-connect.c-3-color {
  background-color: #4527a0;
}

[data-primary="color_4"] .noUi-horizontal .noUi-handle,
[data-primary="color_4"] .noUi-vertical .noUi-handle {
  background-color: #4527a0;
}

[data-primary="color_4"] #slider-toggle.off .noUi-handle {
  border-color: #4527a0;
}

[data-primary="color_4"] .pignose-calendar {
  border-color: #4527a0;
}

[data-primary="color_4"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #4527a0;
}

[data-primary="color_4"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #4527a0;
}

[data-primary="color_4"] .bootstrap-tagsinput .tag {
  background-color: #4527a0;
}

[data-primary="color_4"] .toast-success {
  background-color: #4527a0;
}

[data-primary="color_4"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #4527a0;
}

[data-primary="color_4"] .accordion-header-bg .accordion__header--primary {
  background-color: #4527a0;
}

[data-primary="color_4"] .alert-primary {
  background: #876bdb;
  border-color: #876bdb;
  color: #4527a0;
}

[data-primary="color_4"] .alert-alt.alert-primary {
  border-left: 4px solid #4527a0;
}

[data-primary="color_4"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #190e39 !important;
}

[data-primary="color_4"] .alert.alert-primary.solid {
  background: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .alert.alert-outline-primary {
  color: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .badge-outline-primary {
  border: 1px solid #4527a0;
  color: #4527a0;
}

[data-primary="color_4"] .badge-primary {
  background-color: #4527a0;
}

[data-primary="color_4"] .page-titles h4 {
  color: #4527a0;
}

[data-primary="color_4"] .card-action>a {
  background: black;
}

[data-primary="color_4"] .card-action .dropdown {
  background: black;
  color: #4527a0;
}

[data-primary="color_4"] .card-action .dropdown:hover,
[data-primary="color_4"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_4"] .card-loader i {
  background: #392083;
}

[data-primary="color_4"] .dropdown-outline {
  border: 0.1rem solid #4527a0;
}

[data-primary="color_4"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #4527a0;
}

[data-primary="color_4"] .card-action .custom-dropdown {
  background: #9880e0;
}

[data-primary="color_4"] .card-action .custom-dropdown.show,
[data-primary="color_4"] .card-action .custom-dropdown:focus,
[data-primary="color_4"] .card-action .custom-dropdown:hover {
  background: #4527a0;
}

[data-primary="color_4"] .label-primary {
  background: #4527a0;
}

[data-primary="color_4"] .pagination .page-item .page-link:hover {
  background: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .pagination .page-item.active .page-link {
  background-color: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_4"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #4527a0;
}

[data-primary="color_4"] .progress-bar {
  background-color: #4527a0;
}

[data-primary="color_4"] .progress-bar-primary {
  background-color: #4527a0;
}

[data-primary="color_4"] .ribbon__four {
  background-color: #4527a0;
}

[data-primary="color_4"] .ribbon__four:after,
[data-primary="color_4"] .ribbon__four:before {
  background-color: #7657d6;
}

[data-primary="color_4"] .ribbon__five {
  background-color: #4527a0;
}

[data-primary="color_4"] .ribbon__five::before {
  border-color: transparent transparent #4527a0 transparent;
}

[data-primary="color_4"] .ribbon__six {
  background-color: #4527a0;
}

[data-primary="color_4"] .multi-steps>li {
  color: #4527a0;
}

[data-primary="color_4"] .multi-steps>li:after {
  background-color: #4527a0;
}

[data-primary="color_4"] .multi-steps>li.is-active:before {
  border-color: #4527a0;
}

[data-primary="color_4"] .timeline-badge.primary {
  background-color: #4527a0 !important;
}

[data-primary="color_4"] .tooltip-wrapper button:hover {
  background: #4527a0;
}

[data-primary="color_4"] .chart_widget_tab_one .nav-link.active {
  background-color: #4527a0;
  border: 1px solid #4527a0;
}

[data-primary="color_4"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #4527a0;
}

[data-primary="color_4"] .social-icon2 a {
  border: 0.1rem solid #4527a0;
}

[data-primary="color_4"] .social-icon2 i {
  color: #4527a0;
}

[data-primary="color_4"] .social-icon3 ul li a:hover i {
  color: #4527a0;
}

[data-primary="color_4"] .bgl-primary {
  background: #9880e0;
  border-color: #9880e0;
  color: #4527a0;
}

[data-primary="color_4"] .tdl-holder input[type=checkbox]:checked+i {
  background: #4527a0;
}

[data-primary="color_4"] .footer .copyright a {
  color: #4527a0;
}

[data-primary="color_4"] .hamburger .line {
  background: #4527a0;
}

[data-primary="color_4"] svg.pulse-svg .first-circle,
[data-primary="color_4"] svg.pulse-svg .second-circle,
[data-primary="color_4"] svg.pulse-svg .third-circle {
  fill: #4527a0;
}

[data-primary="color_4"] .pulse-css {
  background: #4527a0;
}

[data-primary="color_4"] .pulse-css:after,
[data-primary="color_4"] .pulse-css:before {
  background-color: #4527a0;
}

[data-primary="color_4"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #4527a0;
}

[data-primary="color_4"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_4"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_4"] .header-right .header-profile .dropdown-menu a.active {
  color: #4527a0;
}

[data-primary="color_4"] .header-right .header-profile .profile_title {
  background: #4527a0;
}

[data-primary="color_4"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #4527a0 !important;
}

[data-primary="color_4"] .deznav .metismenu>li>a svg {
  color: #4527a0;
}

[data-primary="color_4"] .deznav .metismenu>li:hover>a,
[data-primary="color_4"] .deznav .metismenu>li:focus>a {
  color: #4527a0;
}

[data-primary="color_4"] .deznav .metismenu>li.mm-active>a {
  color: #4527a0;
}

[data-primary="color_4"] .deznav .metismenu ul a:hover,
[data-primary="color_4"] .deznav .metismenu ul a:focus,
[data-primary="color_4"] .deznav .metismenu ul a.mm-active {
  color: #4527a0;
}

@media (min-width: 767px) {

  [data-primary="color_4"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_4"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_4"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_4"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #dad2f4;
  }
}

[data-primary="color_4"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #4527a0;
}

[data-primary="color_4"] .nav-user {
  background: #4527a0;
}

[data-primary="color_4"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #4527a0;
}

[data-primary="color_4"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #4527a0;
}

[data-primary="color_4"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"][data-theme-version="dark"] .header-left input:focus {
  border-color: #4527a0;
}

[data-primary="color_4"][data-theme-version="dark"] .loader__bar {
  background: #4527a0;
}

[data-primary="color_4"][data-theme-version="dark"] .loader__ball {
  background: #4527a0;
}

[data-primary="color_4"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #4527a0;
}

[data-primary="color_4"] .new-arrival-content .price {
  color: #4527a0;
}

[data-primary="color_4"] .chart-link a i.text-primary {
  color: #4527a0;
}

[data-primary="color_4"] #user-activity .nav-tabs .nav-link.active {
  background: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] span#counter {
  color: #4527a0;
}

[data-primary="color_4"] .welcome-content:after {
  background: #4527a0;
}

[data-primary="color_4"] .timeline-badge {
  background-color: #4527a0;
}

[data-primary="color_4"] .page-timeline .timeline-workplan[data-primary="color_4"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(69, 39, 160, 0.4);
}

[data-primary="color_4"] .sk-three-bounce .sk-child {
  background-color: #4527a0;
}

[data-primary="color_4"] .dropdown-item.active,
[data-primary="color_4"] .dropdown-item:active {
  color: #fff;
  background-color: #4527a0;
}

[data-primary="color_4"] .overlay-box:after {
  background: #4527a0;
}

[data-primary="color_4"] .btn-primary {
  background-color: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .bg-primary {
  background-color: #4527a0 !important;
}

[data-primary="color_4"] .text-primary {
  color: #4527a0 !important;
}

[data-primary="color_4"] .btn-primary:hover {
  background-color: #2a1862;
  border-color: #2a1862;
}

[data-primary="color_4"] .btn-outline-primary {
  color: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .btn-outline-primary:hover {
  background-color: #4527a0;
  border-color: #4527a0;
}

[data-primary="color_4"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_4"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_4"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_4"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_4"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_4"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #2a1862;
  border-color: #2a1862;
}

[data-primary="color_5"] a:hover,
[data-primary="color_5"] a:focus,
[data-primary="color_5"] a.active {
  color: #c62828;
}

[data-primary="color_5"] [data-class="bg-primary"]:before {
  background: #c62828;
}

[data-primary="color_5"] .email-left-box .intro-title {
  background: rgba(198, 40, 40, 0.1);
}

[data-primary="color_5"] .email-left-box .intro-title i {
  color: #c62828;
}

[data-primary="color_5"] .widget-stat .media .media-body h4 {
  color: #c62828 !important;
}

[data-primary="color_5"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(198, 40, 40, 0.1);
}

[data-primary="color_5"] .mail-list .list-group-item.active i {
  color: #c62828;
}

[data-primary="color_5"] .single-mail.active {
  background: #c62828;
}

[data-primary="color_5"] .profile-info h4.text-primary {
  color: #c62828 !important;
}

[data-primary="color_5"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_5"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #c62828;
  color: #c62828;
}

[data-primary="color_5"] .amChartsInputField {
  border: 0;
  background: #c62828;
}

[data-primary="color_5"] .amcharts-period-input,
[data-primary="color_5"] .amcharts-period-input-selected {
  background: #c62828;
}

[data-primary="color_5"] .morris-hover {
  background: #c62828;
}

[data-primary="color_5"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #c62828;
}

[data-primary="color_5"] .custom-select:focus {
  border-color: #c62828;
  color: #c62828;
}

[data-primary="color_5"] .daterangepicker td.active {
  background-color: #c62828;
}

[data-primary="color_5"] .daterangepicker td.active:hover {
  background-color: #c62828;
}

[data-primary="color_5"] .daterangepicker button.applyBtn {
  background-color: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .wizard>.steps li.current a {
  background-color: #c62828;
}

[data-primary="color_5"] .wizard .skip-email a {
  color: #c62828;
}

[data-primary="color_5"] .wizard>.actions li:not(.disabled) a {
  background-color: #c62828;
}

[data-primary="color_5"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #c62828;
}

[data-primary="color_5"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #c62828;
}

[data-primary="color_5"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #c62828;
}

[data-primary="color_5"] .is-invalid .input-group-prepend .input-group-text i {
  color: #de5c5c;
}

[data-primary="color_5"] .datamaps-hoverover {
  color: #c62828;
  border: 1px solid rgba(198, 40, 40, 0.3);
}

[data-primary="color_5"] .jqvmap-zoomin,
[data-primary="color_5"] .jqvmap-zoomout {
  background-color: #c62828;
}

[data-primary="color_5"] .table .thead-primary th {
  background-color: #c62828;
}

[data-primary="color_5"] .table.primary-table-bg-hover thead th {
  background-color: #b12424;
}

[data-primary="color_5"] .table.primary-table-bg-hover tbody tr {
  background-color: #c62828;
}

[data-primary="color_5"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #d63232;
}

[data-primary="color_5"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_5"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #b12424;
}

[data-primary="color_5"] table.dataTable tr.selected {
  color: #c62828;
}

[data-primary="color_5"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #c62828 !important;
  background: rgba(198, 40, 40, 0.1);
}

[data-primary="color_5"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #c62828 !important;
  background: rgba(198, 40, 40, 0.1);
}

[data-primary="color_5"] .clipboard-btn:hover {
  background-color: #c62828;
}

[data-primary="color_5"] .cd-h-timeline__dates::before {
  background: #c62828;
}

[data-primary="color_5"] .cd-h-timeline__dates::after {
  background: #c62828;
}

[data-primary="color_5"] .cd-h-timeline__line {
  background-color: #c62828;
}

[data-primary="color_5"] .cd-h-timeline__date:after {
  border-color: #ca2929;
  background-color: #c62828;
}

[data-primary="color_5"] .cd-h-timeline__navigation {
  border-color: #ca2929;
}

[data-primary="color_5"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #ca2929;
}

[data-primary="color_5"] .dd-handle {
  background: #c62828;
}

[data-primary="color_5"] .dd-handle:hover {
  background: #c62828;
}

[data-primary="color_5"] .dd3-content:hover {
  background: #c62828;
}

[data-primary="color_5"] .noUi-connect {
  background-color: #c62828;
}

[data-primary="color_5"] .noUi-connect.c-3-color {
  background-color: #c62828;
}

[data-primary="color_5"] .noUi-horizontal .noUi-handle,
[data-primary="color_5"] .noUi-vertical .noUi-handle {
  background-color: #c62828;
}

[data-primary="color_5"] #slider-toggle.off .noUi-handle {
  border-color: #c62828;
}

[data-primary="color_5"] .pignose-calendar {
  border-color: #c62828;
}

[data-primary="color_5"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #c62828;
}

[data-primary="color_5"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #c62828;
}

[data-primary="color_5"] .bootstrap-tagsinput .tag {
  background-color: #c62828;
}

[data-primary="color_5"] .toast-success {
  background-color: #c62828;
}

[data-primary="color_5"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #c62828;
}

[data-primary="color_5"] .accordion-header-bg .accordion__header--primary {
  background-color: #c62828;
}

[data-primary="color_5"] .alert-primary {
  background: #e78787;
  border-color: #e78787;
  color: #c62828;
}

[data-primary="color_5"] .alert-alt.alert-primary {
  border-left: 4px solid #c62828;
}

[data-primary="color_5"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #5c1313 !important;
}

[data-primary="color_5"] .alert.alert-primary.solid {
  background: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .alert.alert-outline-primary {
  color: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .badge-outline-primary {
  border: 1px solid #c62828;
  color: #c62828;
}

[data-primary="color_5"] .badge-primary {
  background-color: #c62828;
}

[data-primary="color_5"] .page-titles h4 {
  color: #c62828;
}

[data-primary="color_5"] .card-action>a {
  background: black;
}

[data-primary="color_5"] .card-action .dropdown {
  background: black;
  color: #c62828;
}

[data-primary="color_5"] .card-action .dropdown:hover,
[data-primary="color_5"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_5"] .card-loader i {
  background: #a82222;
}

[data-primary="color_5"] .dropdown-outline {
  border: 0.1rem solid #c62828;
}

[data-primary="color_5"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #c62828;
}

[data-primary="color_5"] .card-action .custom-dropdown {
  background: #eb9c9c;
}

[data-primary="color_5"] .card-action .custom-dropdown.show,
[data-primary="color_5"] .card-action .custom-dropdown:focus,
[data-primary="color_5"] .card-action .custom-dropdown:hover {
  background: #c62828;
}

[data-primary="color_5"] .label-primary {
  background: #c62828;
}

[data-primary="color_5"] .pagination .page-item .page-link:hover {
  background: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .pagination .page-item.active .page-link {
  background-color: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_5"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #c62828;
}

[data-primary="color_5"] .progress-bar {
  background-color: #c62828;
}

[data-primary="color_5"] .progress-bar-primary {
  background-color: #c62828;
}

[data-primary="color_5"] .ribbon__four {
  background-color: #c62828;
}

[data-primary="color_5"] .ribbon__four:after,
[data-primary="color_5"] .ribbon__four:before {
  background-color: #e27272;
}

[data-primary="color_5"] .ribbon__five {
  background-color: #c62828;
}

[data-primary="color_5"] .ribbon__five::before {
  border-color: transparent transparent #c62828 transparent;
}

[data-primary="color_5"] .ribbon__six {
  background-color: #c62828;
}

[data-primary="color_5"] .multi-steps>li {
  color: #c62828;
}

[data-primary="color_5"] .multi-steps>li:after {
  background-color: #c62828;
}

[data-primary="color_5"] .multi-steps>li.is-active:before {
  border-color: #c62828;
}

[data-primary="color_5"] .timeline-badge.primary {
  background-color: #c62828 !important;
}

[data-primary="color_5"] .tooltip-wrapper button:hover {
  background: #c62828;
}

[data-primary="color_5"] .chart_widget_tab_one .nav-link.active {
  background-color: #c62828;
  border: 1px solid #c62828;
}

[data-primary="color_5"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #c62828;
}

[data-primary="color_5"] .social-icon2 a {
  border: 0.1rem solid #c62828;
}

[data-primary="color_5"] .social-icon2 i {
  color: #c62828;
}

[data-primary="color_5"] .social-icon3 ul li a:hover i {
  color: #c62828;
}

[data-primary="color_5"] .bgl-primary {
  background: #eb9c9c;
  border-color: #eb9c9c;
  color: #c62828;
}

[data-primary="color_5"] .tdl-holder input[type=checkbox]:checked+i {
  background: #c62828;
}

[data-primary="color_5"] .footer .copyright a {
  color: #c62828;
}

[data-primary="color_5"] .hamburger .line {
  background: #c62828;
}

[data-primary="color_5"] svg.pulse-svg .first-circle,
[data-primary="color_5"] svg.pulse-svg .second-circle,
[data-primary="color_5"] svg.pulse-svg .third-circle {
  fill: #c62828;
}

[data-primary="color_5"] .pulse-css {
  background: #c62828;
}

[data-primary="color_5"] .pulse-css:after,
[data-primary="color_5"] .pulse-css:before {
  background-color: #c62828;
}

[data-primary="color_5"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #c62828;
}

[data-primary="color_5"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_5"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_5"] .header-right .header-profile .dropdown-menu a.active {
  color: #c62828;
}

[data-primary="color_5"] .header-right .header-profile .profile_title {
  background: #c62828;
}

[data-primary="color_5"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #c62828 !important;
}

[data-primary="color_5"] .deznav .metismenu>li>a svg {
  color: #c62828;
}

[data-primary="color_5"] .deznav .metismenu>li:hover>a,
[data-primary="color_5"] .deznav .metismenu>li:focus>a {
  color: #c62828;
}

[data-primary="color_5"] .deznav .metismenu>li.mm-active>a {
  color: #c62828;
}

[data-primary="color_5"] .deznav .metismenu ul a:hover,
[data-primary="color_5"] .deznav .metismenu ul a:focus,
[data-primary="color_5"] .deznav .metismenu ul a.mm-active {
  color: #c62828;
}

@media (min-width: 767px) {

  [data-primary="color_5"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_5"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_5"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_5"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #fcf1f1;
  }
}

[data-primary="color_5"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #c62828;
}

[data-primary="color_5"] .nav-user {
  background: #c62828;
}

[data-primary="color_5"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #c62828;
}

[data-primary="color_5"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #c62828;
}

[data-primary="color_5"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"][data-theme-version="dark"] .header-left input:focus {
  border-color: #c62828;
}

[data-primary="color_5"][data-theme-version="dark"] .loader__bar {
  background: #c62828;
}

[data-primary="color_5"][data-theme-version="dark"] .loader__ball {
  background: #c62828;
}

[data-primary="color_5"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #c62828;
}

[data-primary="color_5"] .new-arrival-content .price {
  color: #c62828;
}

[data-primary="color_5"] .chart-link a i.text-primary {
  color: #c62828;
}

[data-primary="color_5"] #user-activity .nav-tabs .nav-link.active {
  background: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] span#counter {
  color: #c62828;
}

[data-primary="color_5"] .welcome-content:after {
  background: #c62828;
}

[data-primary="color_5"] .timeline-badge {
  background-color: #c62828;
}

[data-primary="color_5"] .page-timeline .timeline-workplan[data-primary="color_5"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(198, 40, 40, 0.4);
}

[data-primary="color_5"] .sk-three-bounce .sk-child {
  background-color: #c62828;
}

[data-primary="color_5"] .dropdown-item.active,
[data-primary="color_5"] .dropdown-item:active {
  color: #fff;
  background-color: #c62828;
}

[data-primary="color_5"] .overlay-box:after {
  background: #c62828;
}

[data-primary="color_5"] .btn-primary {
  background-color: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .bg-primary {
  background-color: #c62828 !important;
}

[data-primary="color_5"] .text-primary {
  color: #c62828 !important;
}

[data-primary="color_5"] .btn-primary:hover {
  background-color: #861b1b;
  border-color: #861b1b;
}

[data-primary="color_5"] .btn-outline-primary {
  color: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .btn-outline-primary:hover {
  background-color: #c62828;
  border-color: #c62828;
}

[data-primary="color_5"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_5"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_5"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_5"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_5"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_5"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #861b1b;
  border-color: #861b1b;
}

[data-primary="color_6"] a:hover,
[data-primary="color_6"] a:focus,
[data-primary="color_6"] a.active {
  color: #283593;
}

[data-primary="color_6"] [data-class="bg-primary"]:before {
  background: #283593;
}

[data-primary="color_6"] .email-left-box .intro-title {
  background: rgba(40, 53, 147, 0.1);
}

[data-primary="color_6"] .email-left-box .intro-title i {
  color: #283593;
}

[data-primary="color_6"] .widget-stat .media .media-body h4 {
  color: #283593 !important;
}

[data-primary="color_6"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(40, 53, 147, 0.1);
}

[data-primary="color_6"] .mail-list .list-group-item.active i {
  color: #283593;
}

[data-primary="color_6"] .single-mail.active {
  background: #283593;
}

[data-primary="color_6"] .profile-info h4.text-primary {
  color: #283593 !important;
}

[data-primary="color_6"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_6"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #283593;
  color: #283593;
}

[data-primary="color_6"] .amChartsInputField {
  border: 0;
  background: #283593;
}

[data-primary="color_6"] .amcharts-period-input,
[data-primary="color_6"] .amcharts-period-input-selected {
  background: #283593;
}

[data-primary="color_6"] .morris-hover {
  background: #283593;
}

[data-primary="color_6"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #283593;
}

[data-primary="color_6"] .custom-select:focus {
  border-color: #283593;
  color: #283593;
}

[data-primary="color_6"] .daterangepicker td.active {
  background-color: #283593;
}

[data-primary="color_6"] .daterangepicker td.active:hover {
  background-color: #283593;
}

[data-primary="color_6"] .daterangepicker button.applyBtn {
  background-color: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .wizard>.steps li.current a {
  background-color: #283593;
}

[data-primary="color_6"] .wizard .skip-email a {
  color: #283593;
}

[data-primary="color_6"] .wizard>.actions li:not(.disabled) a {
  background-color: #283593;
}

[data-primary="color_6"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #283593;
}

[data-primary="color_6"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #283593;
}

[data-primary="color_6"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #283593;
}

[data-primary="color_6"] .is-invalid .input-group-prepend .input-group-text i {
  color: #3d4eca;
}

[data-primary="color_6"] .datamaps-hoverover {
  color: #283593;
  border: 1px solid rgba(40, 53, 147, 0.3);
}

[data-primary="color_6"] .jqvmap-zoomin,
[data-primary="color_6"] .jqvmap-zoomout {
  background-color: #283593;
}

[data-primary="color_6"] .table .thead-primary th {
  background-color: #283593;
}

[data-primary="color_6"] .table.primary-table-bg-hover thead th {
  background-color: #232e7f;
}

[data-primary="color_6"] .table.primary-table-bg-hover tbody tr {
  background-color: #283593;
}

[data-primary="color_6"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #2d3ca7;
}

[data-primary="color_6"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_6"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #232e7f;
}

[data-primary="color_6"] table.dataTable tr.selected {
  color: #283593;
}

[data-primary="color_6"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #283593 !important;
  background: rgba(40, 53, 147, 0.1);
}

[data-primary="color_6"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #283593 !important;
  background: rgba(40, 53, 147, 0.1);
}

[data-primary="color_6"] .clipboard-btn:hover {
  background-color: #283593;
}

[data-primary="color_6"] .cd-h-timeline__dates::before {
  background: #283593;
}

[data-primary="color_6"] .cd-h-timeline__dates::after {
  background: #283593;
}

[data-primary="color_6"] .cd-h-timeline__line {
  background-color: #283593;
}

[data-primary="color_6"] .cd-h-timeline__date:after {
  border-color: #293697;
  background-color: #283593;
}

[data-primary="color_6"] .cd-h-timeline__navigation {
  border-color: #293697;
}

[data-primary="color_6"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #293697;
}

[data-primary="color_6"] .dd-handle {
  background: #283593;
}

[data-primary="color_6"] .dd-handle:hover {
  background: #283593;
}

[data-primary="color_6"] .dd3-content:hover {
  background: #283593;
}

[data-primary="color_6"] .noUi-connect {
  background-color: #283593;
}

[data-primary="color_6"] .noUi-connect.c-3-color {
  background-color: #283593;
}

[data-primary="color_6"] .noUi-horizontal .noUi-handle,
[data-primary="color_6"] .noUi-vertical .noUi-handle {
  background-color: #283593;
}

[data-primary="color_6"] #slider-toggle.off .noUi-handle {
  border-color: #283593;
}

[data-primary="color_6"] .pignose-calendar {
  border-color: #283593;
}

[data-primary="color_6"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #283593;
}

[data-primary="color_6"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #283593;
}

[data-primary="color_6"] .bootstrap-tagsinput .tag {
  background-color: #283593;
}

[data-primary="color_6"] .toast-success {
  background-color: #283593;
}

[data-primary="color_6"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #283593;
}

[data-primary="color_6"] .accordion-header-bg .accordion__header--primary {
  background-color: #283593;
}

[data-primary="color_6"] .alert-primary {
  background: #6573d5;
  border-color: #6573d5;
  color: #283593;
}

[data-primary="color_6"] .alert-alt.alert-primary {
  border-left: 4px solid #283593;
}

[data-primary="color_6"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #0d112f !important;
}

[data-primary="color_6"] .alert.alert-primary.solid {
  background: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .alert.alert-outline-primary {
  color: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .badge-outline-primary {
  border: 1px solid #283593;
  color: #283593;
}

[data-primary="color_6"] .badge-primary {
  background-color: #283593;
}

[data-primary="color_6"] .page-titles h4 {
  color: #283593;
}

[data-primary="color_6"] .card-action>a {
  background: black;
}

[data-primary="color_6"] .card-action .dropdown {
  background: black;
  color: #283593;
}

[data-primary="color_6"] .card-action .dropdown:hover,
[data-primary="color_6"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_6"] .card-loader i {
  background: #202b77;
}

[data-primary="color_6"] .dropdown-outline {
  border: 0.1rem solid #283593;
}

[data-primary="color_6"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #283593;
}

[data-primary="color_6"] .card-action .custom-dropdown {
  background: #7985db;
}

[data-primary="color_6"] .card-action .custom-dropdown.show,
[data-primary="color_6"] .card-action .custom-dropdown:focus,
[data-primary="color_6"] .card-action .custom-dropdown:hover {
  background: #283593;
}

[data-primary="color_6"] .label-primary {
  background: #283593;
}

[data-primary="color_6"] .pagination .page-item .page-link:hover {
  background: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .pagination .page-item.active .page-link {
  background-color: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_6"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #283593;
}

[data-primary="color_6"] .progress-bar {
  background-color: #283593;
}

[data-primary="color_6"] .progress-bar-primary {
  background-color: #283593;
}

[data-primary="color_6"] .ribbon__four {
  background-color: #283593;
}

[data-primary="color_6"] .ribbon__four:after,
[data-primary="color_6"] .ribbon__four:before {
  background-color: #5161d0;
}

[data-primary="color_6"] .ribbon__five {
  background-color: #283593;
}

[data-primary="color_6"] .ribbon__five::before {
  border-color: transparent transparent #283593 transparent;
}

[data-primary="color_6"] .ribbon__six {
  background-color: #283593;
}

[data-primary="color_6"] .multi-steps>li {
  color: #283593;
}

[data-primary="color_6"] .multi-steps>li:after {
  background-color: #283593;
}

[data-primary="color_6"] .multi-steps>li.is-active:before {
  border-color: #283593;
}

[data-primary="color_6"] .timeline-badge.primary {
  background-color: #283593 !important;
}

[data-primary="color_6"] .tooltip-wrapper button:hover {
  background: #283593;
}

[data-primary="color_6"] .chart_widget_tab_one .nav-link.active {
  background-color: #283593;
  border: 1px solid #283593;
}

[data-primary="color_6"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #283593;
}

[data-primary="color_6"] .social-icon2 a {
  border: 0.1rem solid #283593;
}

[data-primary="color_6"] .social-icon2 i {
  color: #283593;
}

[data-primary="color_6"] .social-icon3 ul li a:hover i {
  color: #283593;
}

[data-primary="color_6"] .bgl-primary {
  background: #7985db;
  border-color: #7985db;
  color: #283593;
}

[data-primary="color_6"] .tdl-holder input[type=checkbox]:checked+i {
  background: #283593;
}

[data-primary="color_6"] .footer .copyright a {
  color: #283593;
}

[data-primary="color_6"] .hamburger .line {
  background: #283593;
}

[data-primary="color_6"] svg.pulse-svg .first-circle,
[data-primary="color_6"] svg.pulse-svg .second-circle,
[data-primary="color_6"] svg.pulse-svg .third-circle {
  fill: #283593;
}

[data-primary="color_6"] .pulse-css {
  background: #283593;
}

[data-primary="color_6"] .pulse-css:after,
[data-primary="color_6"] .pulse-css:before {
  background-color: #283593;
}

[data-primary="color_6"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #283593;
}

[data-primary="color_6"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_6"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_6"] .header-right .header-profile .dropdown-menu a.active {
  color: #283593;
}

[data-primary="color_6"] .header-right .header-profile .profile_title {
  background: #283593;
}

[data-primary="color_6"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #283593 !important;
}

[data-primary="color_6"] .deznav .metismenu>li>a svg {
  color: #283593;
}

[data-primary="color_6"] .deznav .metismenu>li:hover>a,
[data-primary="color_6"] .deznav .metismenu>li:focus>a {
  color: #283593;
}

[data-primary="color_6"] .deznav .metismenu>li.mm-active>a {
  color: #283593;
}

[data-primary="color_6"] .deznav .metismenu ul a:hover,
[data-primary="color_6"] .deznav .metismenu ul a:focus,
[data-primary="color_6"] .deznav .metismenu ul a.mm-active {
  color: #283593;
}

@media (min-width: 767px) {

  [data-primary="color_6"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_6"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_6"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_6"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #cacef0;
  }
}

[data-primary="color_6"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #283593;
}

[data-primary="color_6"] .nav-user {
  background: #283593;
}

[data-primary="color_6"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #283593;
}

[data-primary="color_6"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #283593;
}

[data-primary="color_6"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #283593;
  border-color: #283593;
}

[data-primary="color_6"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #283593;
  border-color: #283593;
}

[data-primary="color_6"][data-theme-version="dark"] .header-left input:focus {
  border-color: #283593;
}

[data-primary="color_6"][data-theme-version="dark"] .loader__bar {
  background: #283593;
}

[data-primary="color_6"][data-theme-version="dark"] .loader__ball {
  background: #283593;
}

[data-primary="color_6"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #283593;
}

[data-primary="color_6"] .new-arrival-content .price {
  color: #283593;
}

[data-primary="color_6"] .chart-link a i.text-primary {
  color: #283593;
}

[data-primary="color_6"] #user-activity .nav-tabs .nav-link.active {
  background: #283593;
  border-color: #283593;
}

[data-primary="color_6"] span#counter {
  color: #283593;
}

[data-primary="color_6"] .welcome-content:after {
  background: #283593;
}

[data-primary="color_6"] .timeline-badge {
  background-color: #283593;
}

[data-primary="color_6"] .page-timeline .timeline-workplan[data-primary="color_6"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(40, 53, 147, 0.4);
}

[data-primary="color_6"] .sk-three-bounce .sk-child {
  background-color: #283593;
}

[data-primary="color_6"] .dropdown-item.active,
[data-primary="color_6"] .dropdown-item:active {
  color: #fff;
  background-color: #283593;
}

[data-primary="color_6"] .overlay-box:after {
  background: #283593;
}

[data-primary="color_6"] .btn-primary {
  background-color: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .bg-primary {
  background-color: #283593 !important;
}

[data-primary="color_6"] .text-primary {
  color: #283593 !important;
}

[data-primary="color_6"] .btn-primary:hover {
  background-color: #181f57;
  border-color: #181f57;
}

[data-primary="color_6"] .btn-outline-primary {
  color: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .btn-outline-primary:hover {
  background-color: #283593;
  border-color: #283593;
}

[data-primary="color_6"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_6"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_6"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_6"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_6"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_6"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #181f57;
  border-color: #181f57;
}

[data-primary="color_7"] a:hover,
[data-primary="color_7"] a:focus,
[data-primary="color_7"] a.active {
  color: #7356f1;
}

[data-primary="color_7"] [data-class="bg-primary"]:before {
  background: #7356f1;
}

[data-primary="color_7"] .email-left-box .intro-title {
  background: rgba(115, 86, 241, 0.1);
}

[data-primary="color_7"] .email-left-box .intro-title i {
  color: #7356f1;
}

[data-primary="color_7"] .widget-stat .media .media-body h4 {
  color: #7356f1 !important;
}

[data-primary="color_7"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(115, 86, 241, 0.1);
}

[data-primary="color_7"] .mail-list .list-group-item.active i {
  color: #7356f1;
}

[data-primary="color_7"] .single-mail.active {
  background: #7356f1;
}

[data-primary="color_7"] .profile-info h4.text-primary {
  color: #7356f1 !important;
}

[data-primary="color_7"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_7"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #7356f1;
  color: #7356f1;
}

[data-primary="color_7"] .amChartsInputField {
  border: 0;
  background: #7356f1;
}

[data-primary="color_7"] .amcharts-period-input,
[data-primary="color_7"] .amcharts-period-input-selected {
  background: #7356f1;
}

[data-primary="color_7"] .morris-hover {
  background: #7356f1;
}

[data-primary="color_7"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #7356f1;
}

[data-primary="color_7"] .custom-select:focus {
  border-color: #7356f1;
  color: #7356f1;
}

[data-primary="color_7"] .daterangepicker td.active {
  background-color: #7356f1;
}

[data-primary="color_7"] .daterangepicker td.active:hover {
  background-color: #7356f1;
}

[data-primary="color_7"] .daterangepicker button.applyBtn {
  background-color: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .wizard>.steps li.current a {
  background-color: #7356f1;
}

[data-primary="color_7"] .wizard .skip-email a {
  color: #7356f1;
}

[data-primary="color_7"] .wizard>.actions li:not(.disabled) a {
  background-color: #7356f1;
}

[data-primary="color_7"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #7356f1;
}

[data-primary="color_7"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #7356f1;
}

[data-primary="color_7"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #7356f1;
}

[data-primary="color_7"] .is-invalid .input-group-prepend .input-group-text i {
  color: #ae9df7;
}

[data-primary="color_7"] .datamaps-hoverover {
  color: #7356f1;
  border: 1px solid rgba(115, 86, 241, 0.3);
}

[data-primary="color_7"] .jqvmap-zoomin,
[data-primary="color_7"] .jqvmap-zoomout {
  background-color: #7356f1;
}

[data-primary="color_7"] .table .thead-primary th {
  background-color: #7356f1;
}

[data-primary="color_7"] .table.primary-table-bg-hover thead th {
  background-color: #5f3eef;
}

[data-primary="color_7"] .table.primary-table-bg-hover tbody tr {
  background-color: #7356f1;
}

[data-primary="color_7"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #876ef3;
}

[data-primary="color_7"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_7"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #5f3eef;
}

[data-primary="color_7"] table.dataTable tr.selected {
  color: #7356f1;
}

[data-primary="color_7"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #7356f1 !important;
  background: rgba(115, 86, 241, 0.1);
}

[data-primary="color_7"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #7356f1 !important;
  background: rgba(115, 86, 241, 0.1);
}

[data-primary="color_7"] .clipboard-btn:hover {
  background-color: #7356f1;
}

[data-primary="color_7"] .cd-h-timeline__dates::before {
  background: #7356f1;
}

[data-primary="color_7"] .cd-h-timeline__dates::after {
  background: #7356f1;
}

[data-primary="color_7"] .cd-h-timeline__line {
  background-color: #7356f1;
}

[data-primary="color_7"] .cd-h-timeline__date:after {
  border-color: #775af1;
  background-color: #7356f1;
}

[data-primary="color_7"] .cd-h-timeline__navigation {
  border-color: #775af1;
}

[data-primary="color_7"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #775af1;
}

[data-primary="color_7"] .dd-handle {
  background: #7356f1;
}

[data-primary="color_7"] .dd-handle:hover {
  background: #7356f1;
}

[data-primary="color_7"] .dd3-content:hover {
  background: #7356f1;
}

[data-primary="color_7"] .noUi-connect {
  background-color: #7356f1;
}

[data-primary="color_7"] .noUi-connect.c-3-color {
  background-color: #7356f1;
}

[data-primary="color_7"] .noUi-horizontal .noUi-handle,
[data-primary="color_7"] .noUi-vertical .noUi-handle {
  background-color: #7356f1;
}

[data-primary="color_7"] #slider-toggle.off .noUi-handle {
  border-color: #7356f1;
}

[data-primary="color_7"] .pignose-calendar {
  border-color: #7356f1;
}

[data-primary="color_7"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #7356f1;
}

[data-primary="color_7"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #7356f1;
}

[data-primary="color_7"] .bootstrap-tagsinput .tag {
  background-color: #7356f1;
}

[data-primary="color_7"] .toast-success {
  background-color: #7356f1;
}

[data-primary="color_7"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #7356f1;
}

[data-primary="color_7"] .accordion-header-bg .accordion__header--primary {
  background-color: #7356f1;
}

[data-primary="color_7"] .alert-primary {
  background: #d5ccfb;
  border-color: #d5ccfb;
  color: #7356f1;
}

[data-primary="color_7"] .alert-alt.alert-primary {
  border-left: 4px solid #7356f1;
}

[data-primary="color_7"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #2f0fb8 !important;
}

[data-primary="color_7"] .alert.alert-primary.solid {
  background: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .alert.alert-outline-primary {
  color: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .badge-outline-primary {
  border: 1px solid #7356f1;
  color: #7356f1;
}

[data-primary="color_7"] .badge-primary {
  background-color: #7356f1;
}

[data-primary="color_7"] .page-titles h4 {
  color: #7356f1;
}

[data-primary="color_7"] .card-action>a {
  background: #090322;
}

[data-primary="color_7"] .card-action .dropdown {
  background: #090322;
  color: #7356f1;
}

[data-primary="color_7"] .card-action .dropdown:hover,
[data-primary="color_7"] .card-action .dropdown:focus {
  background: #090322;
}

[data-primary="color_7"] .card-loader i {
  background: #5835ee;
}

[data-primary="color_7"] .dropdown-outline {
  border: 0.1rem solid #7356f1;
}

[data-primary="color_7"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #7356f1;
}

[data-primary="color_7"] .card-action .custom-dropdown {
  background: #e8e3fd;
}

[data-primary="color_7"] .card-action .custom-dropdown.show,
[data-primary="color_7"] .card-action .custom-dropdown:focus,
[data-primary="color_7"] .card-action .custom-dropdown:hover {
  background: #7356f1;
}

[data-primary="color_7"] .label-primary {
  background: #7356f1;
}

[data-primary="color_7"] .pagination .page-item .page-link:hover {
  background: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .pagination .page-item.active .page-link {
  background-color: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_7"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #7356f1;
}

[data-primary="color_7"] .progress-bar {
  background-color: #7356f1;
}

[data-primary="color_7"] .progress-bar-primary {
  background-color: #7356f1;
}

[data-primary="color_7"] .ribbon__four {
  background-color: #7356f1;
}

[data-primary="color_7"] .ribbon__four:after,
[data-primary="color_7"] .ribbon__four:before {
  background-color: #c1b4f9;
}

[data-primary="color_7"] .ribbon__five {
  background-color: #7356f1;
}

[data-primary="color_7"] .ribbon__five::before {
  border-color: transparent transparent #7356f1 transparent;
}

[data-primary="color_7"] .ribbon__six {
  background-color: #7356f1;
}

[data-primary="color_7"] .multi-steps>li {
  color: #7356f1;
}

[data-primary="color_7"] .multi-steps>li:after {
  background-color: #7356f1;
}

[data-primary="color_7"] .multi-steps>li.is-active:before {
  border-color: #7356f1;
}

[data-primary="color_7"] .timeline-badge.primary {
  background-color: #7356f1 !important;
}

[data-primary="color_7"] .tooltip-wrapper button:hover {
  background: #7356f1;
}

[data-primary="color_7"] .chart_widget_tab_one .nav-link.active {
  background-color: #7356f1;
  border: 1px solid #7356f1;
}

[data-primary="color_7"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #7356f1;
}

[data-primary="color_7"] .social-icon2 a {
  border: 0.1rem solid #7356f1;
}

[data-primary="color_7"] .social-icon2 i {
  color: #7356f1;
}

[data-primary="color_7"] .social-icon3 ul li a:hover i {
  color: #7356f1;
}

[data-primary="color_7"] .bgl-primary {
  background: #e8e3fd;
  border-color: #e8e3fd;
  color: #7356f1;
}

[data-primary="color_7"] .tdl-holder input[type=checkbox]:checked+i {
  background: #7356f1;
}

[data-primary="color_7"] .footer .copyright a {
  color: #7356f1;
}

[data-primary="color_7"] .hamburger .line {
  background: #7356f1;
}

[data-primary="color_7"] svg.pulse-svg .first-circle,
[data-primary="color_7"] svg.pulse-svg .second-circle,
[data-primary="color_7"] svg.pulse-svg .third-circle {
  fill: #7356f1;
}

[data-primary="color_7"] .pulse-css {
  background: #7356f1;
}

[data-primary="color_7"] .pulse-css:after,
[data-primary="color_7"] .pulse-css:before {
  background-color: #7356f1;
}

[data-primary="color_7"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #7356f1;
}

[data-primary="color_7"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_7"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_7"] .header-right .header-profile .dropdown-menu a.active {
  color: #7356f1;
}

[data-primary="color_7"] .header-right .header-profile .profile_title {
  background: #7356f1;
}

[data-primary="color_7"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #7356f1 !important;
}

[data-primary="color_7"] .deznav .metismenu>li>a svg {
  color: #7356f1;
}

[data-primary="color_7"] .deznav .metismenu>li:hover>a,
[data-primary="color_7"] .deznav .metismenu>li:focus>a {
  color: #7356f1;
}

[data-primary="color_7"] .deznav .metismenu>li.mm-active>a {
  color: #7356f1;
}

[data-primary="color_7"] .deznav .metismenu ul a:hover,
[data-primary="color_7"] .deznav .metismenu ul a:focus,
[data-primary="color_7"] .deznav .metismenu ul a.mm-active {
  color: #7356f1;
}

@media (min-width: 767px) {

  [data-primary="color_7"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_7"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_7"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_7"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: white;
  }
}

[data-primary="color_7"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #7356f1;
}

[data-primary="color_7"] .nav-user {
  background: #7356f1;
}

[data-primary="color_7"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #7356f1;
}

[data-primary="color_7"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #7356f1;
}

[data-primary="color_7"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"][data-theme-version="dark"] .header-left input:focus {
  border-color: #7356f1;
}

[data-primary="color_7"][data-theme-version="dark"] .loader__bar {
  background: #7356f1;
}

[data-primary="color_7"][data-theme-version="dark"] .loader__ball {
  background: #7356f1;
}

[data-primary="color_7"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #7356f1;
}

[data-primary="color_7"] .new-arrival-content .price {
  color: #7356f1;
}

[data-primary="color_7"] .chart-link a i.text-primary {
  color: #7356f1;
}

[data-primary="color_7"] #user-activity .nav-tabs .nav-link.active {
  background: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] span#counter {
  color: #7356f1;
}

[data-primary="color_7"] .welcome-content:after {
  background: #7356f1;
}

[data-primary="color_7"] .timeline-badge {
  background-color: #7356f1;
}

[data-primary="color_7"] .page-timeline .timeline-workplan[data-primary="color_7"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(115, 86, 241, 0.4);
}

[data-primary="color_7"] .sk-three-bounce .sk-child {
  background-color: #7356f1;
}

[data-primary="color_7"] .dropdown-item.active,
[data-primary="color_7"] .dropdown-item:active {
  color: #fff;
  background-color: #7356f1;
}

[data-primary="color_7"] .overlay-box:after {
  background: #7356f1;
}

[data-primary="color_7"] .btn-primary {
  background-color: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .bg-primary {
  background-color: #7356f1 !important;
}

[data-primary="color_7"] .text-primary {
  color: #7356f1 !important;
}

[data-primary="color_7"] .btn-primary:hover {
  background-color: #3b13e7;
  border-color: #3b13e7;
}

[data-primary="color_7"] .btn-outline-primary {
  color: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .btn-outline-primary:hover {
  background-color: #7356f1;
  border-color: #7356f1;
}

[data-primary="color_7"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_7"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_7"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_7"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_7"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_7"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #3b13e7;
  border-color: #3b13e7;
}

[data-primary="color_8"] a:hover,
[data-primary="color_8"] a:focus,
[data-primary="color_8"] a.active {
  color: #3695eb;
}

[data-primary="color_8"] [data-class="bg-primary"]:before {
  background: #3695eb;
}

[data-primary="color_8"] .email-left-box .intro-title {
  background: rgba(54, 149, 235, 0.1);
}

[data-primary="color_8"] .email-left-box .intro-title i {
  color: #3695eb;
}

[data-primary="color_8"] .widget-stat .media .media-body h4 {
  color: #3695eb !important;
}

[data-primary="color_8"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(54, 149, 235, 0.1);
}

[data-primary="color_8"] .mail-list .list-group-item.active i {
  color: #3695eb;
}

[data-primary="color_8"] .single-mail.active {
  background: #3695eb;
}

[data-primary="color_8"] .profile-info h4.text-primary {
  color: #3695eb !important;
}

[data-primary="color_8"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_8"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #3695eb;
  color: #3695eb;
}

[data-primary="color_8"] .amChartsInputField {
  border: 0;
  background: #3695eb;
}

[data-primary="color_8"] .amcharts-period-input,
[data-primary="color_8"] .amcharts-period-input-selected {
  background: #3695eb;
}

[data-primary="color_8"] .morris-hover {
  background: #3695eb;
}

[data-primary="color_8"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #3695eb;
}

[data-primary="color_8"] .custom-select:focus {
  border-color: #3695eb;
  color: #3695eb;
}

[data-primary="color_8"] .daterangepicker td.active {
  background-color: #3695eb;
}

[data-primary="color_8"] .daterangepicker td.active:hover {
  background-color: #3695eb;
}

[data-primary="color_8"] .daterangepicker button.applyBtn {
  background-color: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .wizard>.steps li.current a {
  background-color: #3695eb;
}

[data-primary="color_8"] .wizard .skip-email a {
  color: #3695eb;
}

[data-primary="color_8"] .wizard>.actions li:not(.disabled) a {
  background-color: #3695eb;
}

[data-primary="color_8"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #3695eb;
}

[data-primary="color_8"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #3695eb;
}

[data-primary="color_8"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #3695eb;
}

[data-primary="color_8"] .is-invalid .input-group-prepend .input-group-text i {
  color: #7cbaf2;
}

[data-primary="color_8"] .datamaps-hoverover {
  color: #3695eb;
  border: 1px solid rgba(54, 149, 235, 0.3);
}

[data-primary="color_8"] .jqvmap-zoomin,
[data-primary="color_8"] .jqvmap-zoomout {
  background-color: #3695eb;
}

[data-primary="color_8"] .table .thead-primary th {
  background-color: #3695eb;
}

[data-primary="color_8"] .table.primary-table-bg-hover thead th {
  background-color: #1f89e9;
}

[data-primary="color_8"] .table.primary-table-bg-hover tbody tr {
  background-color: #3695eb;
}

[data-primary="color_8"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #4da1ed;
}

[data-primary="color_8"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_8"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #1f89e9;
}

[data-primary="color_8"] table.dataTable tr.selected {
  color: #3695eb;
}

[data-primary="color_8"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #3695eb !important;
  background: rgba(54, 149, 235, 0.1);
}

[data-primary="color_8"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #3695eb !important;
  background: rgba(54, 149, 235, 0.1);
}

[data-primary="color_8"] .clipboard-btn:hover {
  background-color: #3695eb;
}

[data-primary="color_8"] .cd-h-timeline__dates::before {
  background: #3695eb;
}

[data-primary="color_8"] .cd-h-timeline__dates::after {
  background: #3695eb;
}

[data-primary="color_8"] .cd-h-timeline__line {
  background-color: #3695eb;
}

[data-primary="color_8"] .cd-h-timeline__date:after {
  border-color: #3a97eb;
  background-color: #3695eb;
}

[data-primary="color_8"] .cd-h-timeline__navigation {
  border-color: #3a97eb;
}

[data-primary="color_8"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #3a97eb;
}

[data-primary="color_8"] .dd-handle {
  background: #3695eb;
}

[data-primary="color_8"] .dd-handle:hover {
  background: #3695eb;
}

[data-primary="color_8"] .dd3-content:hover {
  background: #3695eb;
}

[data-primary="color_8"] .noUi-connect {
  background-color: #3695eb;
}

[data-primary="color_8"] .noUi-connect.c-3-color {
  background-color: #3695eb;
}

[data-primary="color_8"] .noUi-horizontal .noUi-handle,
[data-primary="color_8"] .noUi-vertical .noUi-handle {
  background-color: #3695eb;
}

[data-primary="color_8"] #slider-toggle.off .noUi-handle {
  border-color: #3695eb;
}

[data-primary="color_8"] .pignose-calendar {
  border-color: #3695eb;
}

[data-primary="color_8"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #3695eb;
}

[data-primary="color_8"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #3695eb;
}

[data-primary="color_8"] .bootstrap-tagsinput .tag {
  background-color: #3695eb;
}

[data-primary="color_8"] .toast-success {
  background-color: #3695eb;
}

[data-primary="color_8"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #3695eb;
}

[data-primary="color_8"] .accordion-header-bg .accordion__header--primary {
  background-color: #3695eb;
}

[data-primary="color_8"] .alert-primary {
  background: #aad2f7;
  border-color: #aad2f7;
  color: #3695eb;
}

[data-primary="color_8"] .alert-alt.alert-primary {
  border-left: 4px solid #3695eb;
}

[data-primary="color_8"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #0f5493 !important;
}

[data-primary="color_8"] .alert.alert-primary.solid {
  background: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .alert.alert-outline-primary {
  color: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .badge-outline-primary {
  border: 1px solid #3695eb;
  color: #3695eb;
}

[data-primary="color_8"] .badge-primary {
  background-color: #3695eb;
}

[data-primary="color_8"] .page-titles h4 {
  color: #3695eb;
}

[data-primary="color_8"] .card-action>a {
  background: black;
}

[data-primary="color_8"] .card-action .dropdown {
  background: black;
  color: #3695eb;
}

[data-primary="color_8"] .card-action .dropdown:hover,
[data-primary="color_8"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_8"] .card-loader i {
  background: #1784e6;
}

[data-primary="color_8"] .dropdown-outline {
  border: 0.1rem solid #3695eb;
}

[data-primary="color_8"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #3695eb;
}

[data-primary="color_8"] .card-action .custom-dropdown {
  background: #c1def9;
}

[data-primary="color_8"] .card-action .custom-dropdown.show,
[data-primary="color_8"] .card-action .custom-dropdown:focus,
[data-primary="color_8"] .card-action .custom-dropdown:hover {
  background: #3695eb;
}

[data-primary="color_8"] .label-primary {
  background: #3695eb;
}

[data-primary="color_8"] .pagination .page-item .page-link:hover {
  background: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .pagination .page-item.active .page-link {
  background-color: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_8"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #3695eb;
}

[data-primary="color_8"] .progress-bar {
  background-color: #3695eb;
}

[data-primary="color_8"] .progress-bar-primary {
  background-color: #3695eb;
}

[data-primary="color_8"] .ribbon__four {
  background-color: #3695eb;
}

[data-primary="color_8"] .ribbon__four:after,
[data-primary="color_8"] .ribbon__four:before {
  background-color: #93c6f4;
}

[data-primary="color_8"] .ribbon__five {
  background-color: #3695eb;
}

[data-primary="color_8"] .ribbon__five::before {
  border-color: transparent transparent #3695eb transparent;
}

[data-primary="color_8"] .ribbon__six {
  background-color: #3695eb;
}

[data-primary="color_8"] .multi-steps>li {
  color: #3695eb;
}

[data-primary="color_8"] .multi-steps>li:after {
  background-color: #3695eb;
}

[data-primary="color_8"] .multi-steps>li.is-active:before {
  border-color: #3695eb;
}

[data-primary="color_8"] .timeline-badge.primary {
  background-color: #3695eb !important;
}

[data-primary="color_8"] .tooltip-wrapper button:hover {
  background: #3695eb;
}

[data-primary="color_8"] .chart_widget_tab_one .nav-link.active {
  background-color: #3695eb;
  border: 1px solid #3695eb;
}

[data-primary="color_8"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #3695eb;
}

[data-primary="color_8"] .social-icon2 a {
  border: 0.1rem solid #3695eb;
}

[data-primary="color_8"] .social-icon2 i {
  color: #3695eb;
}

[data-primary="color_8"] .social-icon3 ul li a:hover i {
  color: #3695eb;
}

[data-primary="color_8"] .bgl-primary {
  background: #c1def9;
  border-color: #c1def9;
  color: #3695eb;
}

[data-primary="color_8"] .tdl-holder input[type=checkbox]:checked+i {
  background: #3695eb;
}

[data-primary="color_8"] .footer .copyright a {
  color: #3695eb;
}

[data-primary="color_8"] .hamburger .line {
  background: #3695eb;
}

[data-primary="color_8"] svg.pulse-svg .first-circle,
[data-primary="color_8"] svg.pulse-svg .second-circle,
[data-primary="color_8"] svg.pulse-svg .third-circle {
  fill: #3695eb;
}

[data-primary="color_8"] .pulse-css {
  background: #3695eb;
}

[data-primary="color_8"] .pulse-css:after,
[data-primary="color_8"] .pulse-css:before {
  background-color: #3695eb;
}

[data-primary="color_8"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #3695eb;
}

[data-primary="color_8"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_8"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_8"] .header-right .header-profile .dropdown-menu a.active {
  color: #3695eb;
}

[data-primary="color_8"] .header-right .header-profile .profile_title {
  background: #3695eb;
}

[data-primary="color_8"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #3695eb !important;
}

[data-primary="color_8"] .deznav .metismenu>li>a svg {
  color: #3695eb;
}

[data-primary="color_8"] .deznav .metismenu>li:hover>a,
[data-primary="color_8"] .deznav .metismenu>li:focus>a {
  color: #3695eb;
}

[data-primary="color_8"] .deznav .metismenu>li.mm-active>a {
  color: #3695eb;
}

[data-primary="color_8"] .deznav .metismenu ul a:hover,
[data-primary="color_8"] .deznav .metismenu ul a:focus,
[data-primary="color_8"] .deznav .metismenu ul a.mm-active {
  color: #3695eb;
}

@media (min-width: 767px) {

  [data-primary="color_8"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_8"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_8"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_8"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: white;
  }
}

[data-primary="color_8"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #3695eb;
}

[data-primary="color_8"] .nav-user {
  background: #3695eb;
}

[data-primary="color_8"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #3695eb;
}

[data-primary="color_8"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #3695eb;
}

[data-primary="color_8"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"][data-theme-version="dark"] .header-left input:focus {
  border-color: #3695eb;
}

[data-primary="color_8"][data-theme-version="dark"] .loader__bar {
  background: #3695eb;
}

[data-primary="color_8"][data-theme-version="dark"] .loader__ball {
  background: #3695eb;
}

[data-primary="color_8"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #3695eb;
}

[data-primary="color_8"] .new-arrival-content .price {
  color: #3695eb;
}

[data-primary="color_8"] .chart-link a i.text-primary {
  color: #3695eb;
}

[data-primary="color_8"] #user-activity .nav-tabs .nav-link.active {
  background: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] span#counter {
  color: #3695eb;
}

[data-primary="color_8"] .welcome-content:after {
  background: #3695eb;
}

[data-primary="color_8"] .timeline-badge {
  background-color: #3695eb;
}

[data-primary="color_8"] .page-timeline .timeline-workplan[data-primary="color_8"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(54, 149, 235, 0.4);
}

[data-primary="color_8"] .sk-three-bounce .sk-child {
  background-color: #3695eb;
}

[data-primary="color_8"] .dropdown-item.active,
[data-primary="color_8"] .dropdown-item:active {
  color: #fff;
  background-color: #3695eb;
}

[data-primary="color_8"] .overlay-box:after {
  background: #3695eb;
}

[data-primary="color_8"] .btn-primary {
  background-color: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .bg-primary {
  background-color: #3695eb !important;
}

[data-primary="color_8"] .text-primary {
  color: #3695eb !important;
}

[data-primary="color_8"] .btn-primary:hover {
  background-color: #136fc1;
  border-color: #136fc1;
}

[data-primary="color_8"] .btn-outline-primary {
  color: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .btn-outline-primary:hover {
  background-color: #3695eb;
  border-color: #3695eb;
}

[data-primary="color_8"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_8"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_8"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_8"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_8"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_8"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #136fc1;
  border-color: #136fc1;
}

[data-primary="color_9"] a:hover,
[data-primary="color_9"] a:focus,
[data-primary="color_9"] a.active {
  color: #00838f;
}

[data-primary="color_9"] [data-class="bg-primary"]:before {
  background: #00838f;
}

[data-primary="color_9"] .email-left-box .intro-title {
  background: rgba(0, 131, 143, 0.1);
}

[data-primary="color_9"] .email-left-box .intro-title i {
  color: #00838f;
}

[data-primary="color_9"] .widget-stat .media .media-body h4 {
  color: #00838f !important;
}

[data-primary="color_9"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(0, 131, 143, 0.1);
}

[data-primary="color_9"] .mail-list .list-group-item.active i {
  color: #00838f;
}

[data-primary="color_9"] .single-mail.active {
  background: #00838f;
}

[data-primary="color_9"] .profile-info h4.text-primary {
  color: #00838f !important;
}

[data-primary="color_9"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_9"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #00838f;
  color: #00838f;
}

[data-primary="color_9"] .amChartsInputField {
  border: 0;
  background: #00838f;
}

[data-primary="color_9"] .amcharts-period-input,
[data-primary="color_9"] .amcharts-period-input-selected {
  background: #00838f;
}

[data-primary="color_9"] .morris-hover {
  background: #00838f;
}

[data-primary="color_9"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #00838f;
}

[data-primary="color_9"] .custom-select:focus {
  border-color: #00838f;
  color: #00838f;
}

[data-primary="color_9"] .daterangepicker td.active {
  background-color: #00838f;
}

[data-primary="color_9"] .daterangepicker td.active:hover {
  background-color: #00838f;
}

[data-primary="color_9"] .daterangepicker button.applyBtn {
  background-color: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .wizard>.steps li.current a {
  background-color: #00838f;
}

[data-primary="color_9"] .wizard .skip-email a {
  color: #00838f;
}

[data-primary="color_9"] .wizard>.actions li:not(.disabled) a {
  background-color: #00838f;
}

[data-primary="color_9"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #00838f;
}

[data-primary="color_9"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #00838f;
}

[data-primary="color_9"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #00838f;
}

[data-primary="color_9"] .is-invalid .input-group-prepend .input-group-text i {
  color: #00c9dc;
}

[data-primary="color_9"] .datamaps-hoverover {
  color: #00838f;
  border: 1px solid rgba(0, 131, 143, 0.3);
}

[data-primary="color_9"] .jqvmap-zoomin,
[data-primary="color_9"] .jqvmap-zoomout {
  background-color: #00838f;
}

[data-primary="color_9"] .table .thead-primary th {
  background-color: #00838f;
}

[data-primary="color_9"] .table.primary-table-bg-hover thead th {
  background-color: #006c76;
}

[data-primary="color_9"] .table.primary-table-bg-hover tbody tr {
  background-color: #00838f;
}

[data-primary="color_9"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #009aa9;
}

[data-primary="color_9"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_9"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #006c76;
}

[data-primary="color_9"] table.dataTable tr.selected {
  color: #00838f;
}

[data-primary="color_9"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #00838f !important;
  background: rgba(0, 131, 143, 0.1);
}

[data-primary="color_9"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #00838f !important;
  background: rgba(0, 131, 143, 0.1);
}

[data-primary="color_9"] .clipboard-btn:hover {
  background-color: #00838f;
}

[data-primary="color_9"] .cd-h-timeline__dates::before {
  background: #00838f;
}

[data-primary="color_9"] .cd-h-timeline__dates::after {
  background: #00838f;
}

[data-primary="color_9"] .cd-h-timeline__line {
  background-color: #00838f;
}

[data-primary="color_9"] .cd-h-timeline__date:after {
  border-color: #008794;
  background-color: #00838f;
}

[data-primary="color_9"] .cd-h-timeline__navigation {
  border-color: #008794;
}

[data-primary="color_9"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #008794;
}

[data-primary="color_9"] .dd-handle {
  background: #00838f;
}

[data-primary="color_9"] .dd-handle:hover {
  background: #00838f;
}

[data-primary="color_9"] .dd3-content:hover {
  background: #00838f;
}

[data-primary="color_9"] .noUi-connect {
  background-color: #00838f;
}

[data-primary="color_9"] .noUi-connect.c-3-color {
  background-color: #00838f;
}

[data-primary="color_9"] .noUi-horizontal .noUi-handle,
[data-primary="color_9"] .noUi-vertical .noUi-handle {
  background-color: #00838f;
}

[data-primary="color_9"] #slider-toggle.off .noUi-handle {
  border-color: #00838f;
}

[data-primary="color_9"] .pignose-calendar {
  border-color: #00838f;
}

[data-primary="color_9"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #00838f;
}

[data-primary="color_9"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #00838f;
}

[data-primary="color_9"] .bootstrap-tagsinput .tag {
  background-color: #00838f;
}

[data-primary="color_9"] .toast-success {
  background-color: #00838f;
}

[data-primary="color_9"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #00838f;
}

[data-primary="color_9"] .accordion-header-bg .accordion__header--primary {
  background-color: #00838f;
}

[data-primary="color_9"] .alert-primary {
  background: #10ebff;
  border-color: #10ebff;
  color: #00838f;
}

[data-primary="color_9"] .alert-alt.alert-primary {
  border-left: 4px solid #00838f;
}

[data-primary="color_9"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #000e10 !important;
}

[data-primary="color_9"] .alert.alert-primary.solid {
  background: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .alert.alert-outline-primary {
  color: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .badge-outline-primary {
  border: 1px solid #00838f;
  color: #00838f;
}

[data-primary="color_9"] .badge-primary {
  background-color: #00838f;
}

[data-primary="color_9"] .page-titles h4 {
  color: #00838f;
}

[data-primary="color_9"] .card-action>a {
  background: black;
}

[data-primary="color_9"] .card-action .dropdown {
  background: black;
  color: #00838f;
}

[data-primary="color_9"] .card-action .dropdown:hover,
[data-primary="color_9"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_9"] .card-loader i {
  background: #00626b;
}

[data-primary="color_9"] .dropdown-outline {
  border: 0.1rem solid #00838f;
}

[data-primary="color_9"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #00838f;
}

[data-primary="color_9"] .card-action .custom-dropdown {
  background: #29edff;
}

[data-primary="color_9"] .card-action .custom-dropdown.show,
[data-primary="color_9"] .card-action .custom-dropdown:focus,
[data-primary="color_9"] .card-action .custom-dropdown:hover {
  background: #00838f;
}

[data-primary="color_9"] .label-primary {
  background: #00838f;
}

[data-primary="color_9"] .pagination .page-item .page-link:hover {
  background: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .pagination .page-item.active .page-link {
  background-color: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_9"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #00838f;
}

[data-primary="color_9"] .progress-bar {
  background-color: #00838f;
}

[data-primary="color_9"] .progress-bar-primary {
  background-color: #00838f;
}

[data-primary="color_9"] .ribbon__four {
  background-color: #00838f;
}

[data-primary="color_9"] .ribbon__four:after,
[data-primary="color_9"] .ribbon__four:before {
  background-color: #00e0f5;
}

[data-primary="color_9"] .ribbon__five {
  background-color: #00838f;
}

[data-primary="color_9"] .ribbon__five::before {
  border-color: transparent transparent #00838f transparent;
}

[data-primary="color_9"] .ribbon__six {
  background-color: #00838f;
}

[data-primary="color_9"] .multi-steps>li {
  color: #00838f;
}

[data-primary="color_9"] .multi-steps>li:after {
  background-color: #00838f;
}

[data-primary="color_9"] .multi-steps>li.is-active:before {
  border-color: #00838f;
}

[data-primary="color_9"] .timeline-badge.primary {
  background-color: #00838f !important;
}

[data-primary="color_9"] .tooltip-wrapper button:hover {
  background: #00838f;
}

[data-primary="color_9"] .chart_widget_tab_one .nav-link.active {
  background-color: #00838f;
  border: 1px solid #00838f;
}

[data-primary="color_9"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #00838f;
}

[data-primary="color_9"] .social-icon2 a {
  border: 0.1rem solid #00838f;
}

[data-primary="color_9"] .social-icon2 i {
  color: #00838f;
}

[data-primary="color_9"] .social-icon3 ul li a:hover i {
  color: #00838f;
}

[data-primary="color_9"] .bgl-primary {
  background: #29edff;
  border-color: #29edff;
  color: #00838f;
}

[data-primary="color_9"] .tdl-holder input[type=checkbox]:checked+i {
  background: #00838f;
}

[data-primary="color_9"] .footer .copyright a {
  color: #00838f;
}

[data-primary="color_9"] .hamburger .line {
  background: #00838f;
}

[data-primary="color_9"] svg.pulse-svg .first-circle,
[data-primary="color_9"] svg.pulse-svg .second-circle,
[data-primary="color_9"] svg.pulse-svg .third-circle {
  fill: #00838f;
}

[data-primary="color_9"] .pulse-css {
  background: #00838f;
}

[data-primary="color_9"] .pulse-css:after,
[data-primary="color_9"] .pulse-css:before {
  background-color: #00838f;
}

[data-primary="color_9"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #00838f;
}

[data-primary="color_9"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_9"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_9"] .header-right .header-profile .dropdown-menu a.active {
  color: #00838f;
}

[data-primary="color_9"] .header-right .header-profile .profile_title {
  background: #00838f;
}

[data-primary="color_9"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #00838f !important;
}

[data-primary="color_9"] .deznav .metismenu>li>a svg {
  color: #00838f;
}

[data-primary="color_9"] .deznav .metismenu>li:hover>a,
[data-primary="color_9"] .deznav .metismenu>li:focus>a {
  color: #00838f;
}

[data-primary="color_9"] .deznav .metismenu>li.mm-active>a {
  color: #00838f;
}

[data-primary="color_9"] .deznav .metismenu ul a:hover,
[data-primary="color_9"] .deznav .metismenu ul a:focus,
[data-primary="color_9"] .deznav .metismenu ul a.mm-active {
  color: #00838f;
}

@media (min-width: 767px) {

  [data-primary="color_9"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_9"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_9"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_9"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #8ff6ff;
  }
}

[data-primary="color_9"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #00838f;
}

[data-primary="color_9"] .nav-user {
  background: #00838f;
}

[data-primary="color_9"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #00838f;
}

[data-primary="color_9"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #00838f;
}

[data-primary="color_9"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"][data-theme-version="dark"] .header-left input:focus {
  border-color: #00838f;
}

[data-primary="color_9"][data-theme-version="dark"] .loader__bar {
  background: #00838f;
}

[data-primary="color_9"][data-theme-version="dark"] .loader__ball {
  background: #00838f;
}

[data-primary="color_9"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #00838f;
}

[data-primary="color_9"] .new-arrival-content .price {
  color: #00838f;
}

[data-primary="color_9"] .chart-link a i.text-primary {
  color: #00838f;
}

[data-primary="color_9"] #user-activity .nav-tabs .nav-link.active {
  background: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] span#counter {
  color: #00838f;
}

[data-primary="color_9"] .welcome-content:after {
  background: #00838f;
}

[data-primary="color_9"] .timeline-badge {
  background-color: #00838f;
}

[data-primary="color_9"] .page-timeline .timeline-workplan[data-primary="color_9"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(0, 131, 143, 0.4);
}

[data-primary="color_9"] .sk-three-bounce .sk-child {
  background-color: #00838f;
}

[data-primary="color_9"] .dropdown-item.active,
[data-primary="color_9"] .dropdown-item:active {
  color: #fff;
  background-color: #00838f;
}

[data-primary="color_9"] .overlay-box:after {
  background: #00838f;
}

[data-primary="color_9"] .btn-primary {
  background-color: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .bg-primary {
  background-color: #00838f !important;
}

[data-primary="color_9"] .text-primary {
  color: #00838f !important;
}

[data-primary="color_9"] .btn-primary:hover {
  background-color: #003d43;
  border-color: #003d43;
}

[data-primary="color_9"] .btn-outline-primary {
  color: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .btn-outline-primary:hover {
  background-color: #00838f;
  border-color: #00838f;
}

[data-primary="color_9"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_9"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_9"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_9"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_9"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_9"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #003d43;
  border-color: #003d43;
}

[data-primary="color_10"] a:hover,
[data-primary="color_10"] a:focus,
[data-primary="color_10"] a.active {
  color: #ff8f16;
}

[data-primary="color_10"] [data-class="bg-primary"]:before {
  background: #ff8f16;
}

[data-primary="color_10"] .email-left-box .intro-title {
  background: rgba(255, 143, 22, 0.1);
}

[data-primary="color_10"] .email-left-box .intro-title i {
  color: #ff8f16;
}

[data-primary="color_10"] .widget-stat .media .media-body h4 {
  color: #ff8f16 !important;
}

[data-primary="color_10"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(255, 143, 22, 0.1);
}

[data-primary="color_10"] .mail-list .list-group-item.active i {
  color: #ff8f16;
}

[data-primary="color_10"] .single-mail.active {
  background: #ff8f16;
}

[data-primary="color_10"] .profile-info h4.text-primary {
  color: #ff8f16 !important;
}

[data-primary="color_10"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_10"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #ff8f16;
  color: #ff8f16;
}

[data-primary="color_10"] .amChartsInputField {
  border: 0;
  background: #ff8f16;
}

[data-primary="color_10"] .amcharts-period-input,
[data-primary="color_10"] .amcharts-period-input-selected {
  background: #ff8f16;
}

[data-primary="color_10"] .morris-hover {
  background: #ff8f16;
}

[data-primary="color_10"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #ff8f16;
}

[data-primary="color_10"] .custom-select:focus {
  border-color: #ff8f16;
  color: #ff8f16;
}

[data-primary="color_10"] .daterangepicker td.active {
  background-color: #ff8f16;
}

[data-primary="color_10"] .daterangepicker td.active:hover {
  background-color: #ff8f16;
}

[data-primary="color_10"] .daterangepicker button.applyBtn {
  background-color: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .wizard>.steps li.current a {
  background-color: #ff8f16;
}

[data-primary="color_10"] .wizard .skip-email a {
  color: #ff8f16;
}

[data-primary="color_10"] .wizard>.actions li:not(.disabled) a {
  background-color: #ff8f16;
}

[data-primary="color_10"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #ff8f16;
}

[data-primary="color_10"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #ff8f16;
}

[data-primary="color_10"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #ff8f16;
}

[data-primary="color_10"] .is-invalid .input-group-prepend .input-group-text i {
  color: #ffb463;
}

[data-primary="color_10"] .datamaps-hoverover {
  color: #ff8f16;
  border: 1px solid rgba(255, 143, 22, 0.3);
}

[data-primary="color_10"] .jqvmap-zoomin,
[data-primary="color_10"] .jqvmap-zoomout {
  background-color: #ff8f16;
}

[data-primary="color_10"] .table .thead-primary th {
  background-color: #ff8f16;
}

[data-primary="color_10"] .table.primary-table-bg-hover thead th {
  background-color: #fc8300;
}

[data-primary="color_10"] .table.primary-table-bg-hover tbody tr {
  background-color: #ff8f16;
}

[data-primary="color_10"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #ff9b30;
}

[data-primary="color_10"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_10"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #fc8300;
}

[data-primary="color_10"] table.dataTable tr.selected {
  color: #ff8f16;
}

[data-primary="color_10"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #ff8f16 !important;
  background: rgba(255, 143, 22, 0.1);
}

[data-primary="color_10"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #ff8f16 !important;
  background: rgba(255, 143, 22, 0.1);
}

[data-primary="color_10"] .clipboard-btn:hover {
  background-color: #ff8f16;
}

[data-primary="color_10"] .cd-h-timeline__dates::before {
  background: #ff8f16;
}

[data-primary="color_10"] .cd-h-timeline__dates::after {
  background: #ff8f16;
}

[data-primary="color_10"] .cd-h-timeline__line {
  background-color: #ff8f16;
}

[data-primary="color_10"] .cd-h-timeline__date:after {
  border-color: #ff911b;
  background-color: #ff8f16;
}

[data-primary="color_10"] .cd-h-timeline__navigation {
  border-color: #ff911b;
}

[data-primary="color_10"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #ff911b;
}

[data-primary="color_10"] .dd-handle {
  background: #ff8f16;
}

[data-primary="color_10"] .dd-handle:hover {
  background: #ff8f16;
}

[data-primary="color_10"] .dd3-content:hover {
  background: #ff8f16;
}

[data-primary="color_10"] .noUi-connect {
  background-color: #ff8f16;
}

[data-primary="color_10"] .noUi-connect.c-3-color {
  background-color: #ff8f16;
}

[data-primary="color_10"] .noUi-horizontal .noUi-handle,
[data-primary="color_10"] .noUi-vertical .noUi-handle {
  background-color: #ff8f16;
}

[data-primary="color_10"] #slider-toggle.off .noUi-handle {
  border-color: #ff8f16;
}

[data-primary="color_10"] .pignose-calendar {
  border-color: #ff8f16;
}

[data-primary="color_10"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #ff8f16;
}

[data-primary="color_10"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #ff8f16;
}

[data-primary="color_10"] .bootstrap-tagsinput .tag {
  background-color: #ff8f16;
}

[data-primary="color_10"] .toast-success {
  background-color: #ff8f16;
}

[data-primary="color_10"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #ff8f16;
}

[data-primary="color_10"] .accordion-header-bg .accordion__header--primary {
  background-color: #ff8f16;
}

[data-primary="color_10"] .alert-primary {
  background: #ffcc96;
  border-color: #ffcc96;
  color: #ff8f16;
}

[data-primary="color_10"] .alert-alt.alert-primary {
  border-left: 4px solid #ff8f16;
}

[data-primary="color_10"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #964e00 !important;
}

[data-primary="color_10"] .alert.alert-primary.solid {
  background: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .alert.alert-outline-primary {
  color: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .badge-outline-primary {
  border: 1px solid #ff8f16;
  color: #ff8f16;
}

[data-primary="color_10"] .badge-primary {
  background-color: #ff8f16;
}

[data-primary="color_10"] .page-titles h4 {
  color: #ff8f16;
}

[data-primary="color_10"] .card-action>a {
  background: black;
}

[data-primary="color_10"] .card-action .dropdown {
  background: black;
  color: #ff8f16;
}

[data-primary="color_10"] .card-action .dropdown:hover,
[data-primary="color_10"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_10"] .card-loader i {
  background: #f17d00;
}

[data-primary="color_10"] .dropdown-outline {
  border: 0.1rem solid #ff8f16;
}

[data-primary="color_10"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #ff8f16;
}

[data-primary="color_10"] .card-action .custom-dropdown {
  background: #ffd9af;
}

[data-primary="color_10"] .card-action .custom-dropdown.show,
[data-primary="color_10"] .card-action .custom-dropdown:focus,
[data-primary="color_10"] .card-action .custom-dropdown:hover {
  background: #ff8f16;
}

[data-primary="color_10"] .label-primary {
  background: #ff8f16;
}

[data-primary="color_10"] .pagination .page-item .page-link:hover {
  background: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .pagination .page-item.active .page-link {
  background-color: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_10"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #ff8f16;
}

[data-primary="color_10"] .progress-bar {
  background-color: #ff8f16;
}

[data-primary="color_10"] .progress-bar-primary {
  background-color: #ff8f16;
}

[data-primary="color_10"] .ribbon__four {
  background-color: #ff8f16;
}

[data-primary="color_10"] .ribbon__four:after,
[data-primary="color_10"] .ribbon__four:before {
  background-color: #ffc07c;
}

[data-primary="color_10"] .ribbon__five {
  background-color: #ff8f16;
}

[data-primary="color_10"] .ribbon__five::before {
  border-color: transparent transparent #ff8f16 transparent;
}

[data-primary="color_10"] .ribbon__six {
  background-color: #ff8f16;
}

[data-primary="color_10"] .multi-steps>li {
  color: #ff8f16;
}

[data-primary="color_10"] .multi-steps>li:after {
  background-color: #ff8f16;
}

[data-primary="color_10"] .multi-steps>li.is-active:before {
  border-color: #ff8f16;
}

[data-primary="color_10"] .timeline-badge.primary {
  background-color: #ff8f16 !important;
}

[data-primary="color_10"] .tooltip-wrapper button:hover {
  background: #ff8f16;
}

[data-primary="color_10"] .chart_widget_tab_one .nav-link.active {
  background-color: #ff8f16;
  border: 1px solid #ff8f16;
}

[data-primary="color_10"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #ff8f16;
}

[data-primary="color_10"] .social-icon2 a {
  border: 0.1rem solid #ff8f16;
}

[data-primary="color_10"] .social-icon2 i {
  color: #ff8f16;
}

[data-primary="color_10"] .social-icon3 ul li a:hover i {
  color: #ff8f16;
}

[data-primary="color_10"] .bgl-primary {
  background: #ffd9af;
  border-color: #ffd9af;
  color: #ff8f16;
}

[data-primary="color_10"] .tdl-holder input[type=checkbox]:checked+i {
  background: #ff8f16;
}

[data-primary="color_10"] .footer .copyright a {
  color: #ff8f16;
}

[data-primary="color_10"] .hamburger .line {
  background: #ff8f16;
}

[data-primary="color_10"] svg.pulse-svg .first-circle,
[data-primary="color_10"] svg.pulse-svg .second-circle,
[data-primary="color_10"] svg.pulse-svg .third-circle {
  fill: #ff8f16;
}

[data-primary="color_10"] .pulse-css {
  background: #ff8f16;
}

[data-primary="color_10"] .pulse-css:after,
[data-primary="color_10"] .pulse-css:before {
  background-color: #ff8f16;
}

[data-primary="color_10"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #ff8f16;
}

[data-primary="color_10"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_10"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_10"] .header-right .header-profile .dropdown-menu a.active {
  color: #ff8f16;
}

[data-primary="color_10"] .header-right .header-profile .profile_title {
  background: #ff8f16;
}

[data-primary="color_10"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #ff8f16 !important;
}

[data-primary="color_10"] .deznav .metismenu>li>a svg {
  color: #ff8f16;
}

[data-primary="color_10"] .deznav .metismenu>li:hover>a,
[data-primary="color_10"] .deznav .metismenu>li:focus>a {
  color: #ff8f16;
}

[data-primary="color_10"] .deznav .metismenu>li.mm-active>a {
  color: #ff8f16;
}

[data-primary="color_10"] .deznav .metismenu ul a:hover,
[data-primary="color_10"] .deznav .metismenu ul a:focus,
[data-primary="color_10"] .deznav .metismenu ul a.mm-active {
  color: #ff8f16;
}

@media (min-width: 767px) {

  [data-primary="color_10"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_10"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_10"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_10"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: white;
  }
}

[data-primary="color_10"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #ff8f16;
}

[data-primary="color_10"] .nav-user {
  background: #ff8f16;
}

[data-primary="color_10"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #ff8f16;
}

[data-primary="color_10"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #ff8f16;
}

[data-primary="color_10"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"][data-theme-version="dark"] .header-left input:focus {
  border-color: #ff8f16;
}

[data-primary="color_10"][data-theme-version="dark"] .loader__bar {
  background: #ff8f16;
}

[data-primary="color_10"][data-theme-version="dark"] .loader__ball {
  background: #ff8f16;
}

[data-primary="color_10"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #ff8f16;
}

[data-primary="color_10"] .new-arrival-content .price {
  color: #ff8f16;
}

[data-primary="color_10"] .chart-link a i.text-primary {
  color: #ff8f16;
}

[data-primary="color_10"] #user-activity .nav-tabs .nav-link.active {
  background: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] span#counter {
  color: #ff8f16;
}

[data-primary="color_10"] .welcome-content:after {
  background: #ff8f16;
}

[data-primary="color_10"] .timeline-badge {
  background-color: #ff8f16;
}

[data-primary="color_10"] .page-timeline .timeline-workplan[data-primary="color_10"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(255, 143, 22, 0.4);
}

[data-primary="color_10"] .sk-three-bounce .sk-child {
  background-color: #ff8f16;
}

[data-primary="color_10"] .dropdown-item.active,
[data-primary="color_10"] .dropdown-item:active {
  color: #fff;
  background-color: #ff8f16;
}

[data-primary="color_10"] .overlay-box:after {
  background: #ff8f16;
}

[data-primary="color_10"] .btn-primary {
  background-color: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .bg-primary {
  background-color: #ff8f16 !important;
}

[data-primary="color_10"] .text-primary {
  color: #ff8f16 !important;
}

[data-primary="color_10"] .btn-primary:hover {
  background-color: #c96800;
  border-color: #c96800;
}

[data-primary="color_10"] .btn-outline-primary {
  color: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .btn-outline-primary:hover {
  background-color: #ff8f16;
  border-color: #ff8f16;
}

[data-primary="color_10"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_10"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_10"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_10"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_10"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_10"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #c96800;
  border-color: #c96800;
}

[data-primary="color_11"] a:hover,
[data-primary="color_11"] a:focus,
[data-primary="color_11"] a.active {
  color: #6673fd;
}

[data-primary="color_11"] [data-class="bg-primary"]:before {
  background: #6673fd;
}

[data-primary="color_11"] .email-left-box .intro-title {
  background: rgba(102, 115, 253, 0.1);
}

[data-primary="color_11"] .email-left-box .intro-title i {
  color: #6673fd;
}

[data-primary="color_11"] .widget-stat .media .media-body h4 {
  color: #6673fd !important;
}

[data-primary="color_11"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(102, 115, 253, 0.1);
}

[data-primary="color_11"] .mail-list .list-group-item.active i {
  color: #6673fd;
}

[data-primary="color_11"] .single-mail.active {
  background: #6673fd;
}

[data-primary="color_11"] .profile-info h4.text-primary {
  color: #6673fd !important;
}

[data-primary="color_11"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_11"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #6673fd;
  color: #6673fd;
}

[data-primary="color_11"] .amChartsInputField {
  border: 0;
  background: #6673fd;
}

[data-primary="color_11"] .amcharts-period-input,
[data-primary="color_11"] .amcharts-period-input-selected {
  background: #6673fd;
}

[data-primary="color_11"] .morris-hover {
  background: #6673fd;
}

[data-primary="color_11"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #6673fd;
}

[data-primary="color_11"] .custom-select:focus {
  border-color: #6673fd;
  color: #6673fd;
}

[data-primary="color_11"] .daterangepicker td.active {
  background-color: #6673fd;
}

[data-primary="color_11"] .daterangepicker td.active:hover {
  background-color: #6673fd;
}

[data-primary="color_11"] .daterangepicker button.applyBtn {
  background-color: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .wizard>.steps li.current a {
  background-color: #6673fd;
}

[data-primary="color_11"] .wizard .skip-email a {
  color: #6673fd;
}

[data-primary="color_11"] .wizard>.actions li:not(.disabled) a {
  background-color: #6673fd;
}

[data-primary="color_11"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #6673fd;
}

[data-primary="color_11"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #6673fd;
}

[data-primary="color_11"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #6673fd;
}

[data-primary="color_11"] .is-invalid .input-group-prepend .input-group-text i {
  color: #b2b8fe;
}

[data-primary="color_11"] .datamaps-hoverover {
  color: #6673fd;
  border: 1px solid rgba(102, 115, 253, 0.3);
}

[data-primary="color_11"] .jqvmap-zoomin,
[data-primary="color_11"] .jqvmap-zoomout {
  background-color: #6673fd;
}

[data-primary="color_11"] .table .thead-primary th {
  background-color: #6673fd;
}

[data-primary="color_11"] .table.primary-table-bg-hover thead th {
  background-color: #4d5cfd;
}

[data-primary="color_11"] .table.primary-table-bg-hover tbody tr {
  background-color: #6673fd;
}

[data-primary="color_11"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #7f8afd;
}

[data-primary="color_11"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_11"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #4d5cfd;
}

[data-primary="color_11"] table.dataTable tr.selected {
  color: #6673fd;
}

[data-primary="color_11"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #6673fd !important;
  background: rgba(102, 115, 253, 0.1);
}

[data-primary="color_11"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #6673fd !important;
  background: rgba(102, 115, 253, 0.1);
}

[data-primary="color_11"] .clipboard-btn:hover {
  background-color: #6673fd;
}

[data-primary="color_11"] .cd-h-timeline__dates::before {
  background: #6673fd;
}

[data-primary="color_11"] .cd-h-timeline__dates::after {
  background: #6673fd;
}

[data-primary="color_11"] .cd-h-timeline__line {
  background-color: #6673fd;
}

[data-primary="color_11"] .cd-h-timeline__date:after {
  border-color: #6b77fd;
  background-color: #6673fd;
}

[data-primary="color_11"] .cd-h-timeline__navigation {
  border-color: #6b77fd;
}

[data-primary="color_11"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #6b77fd;
}

[data-primary="color_11"] .dd-handle {
  background: #6673fd;
}

[data-primary="color_11"] .dd-handle:hover {
  background: #6673fd;
}

[data-primary="color_11"] .dd3-content:hover {
  background: #6673fd;
}

[data-primary="color_11"] .noUi-connect {
  background-color: #6673fd;
}

[data-primary="color_11"] .noUi-connect.c-3-color {
  background-color: #6673fd;
}

[data-primary="color_11"] .noUi-horizontal .noUi-handle,
[data-primary="color_11"] .noUi-vertical .noUi-handle {
  background-color: #6673fd;
}

[data-primary="color_11"] #slider-toggle.off .noUi-handle {
  border-color: #6673fd;
}

[data-primary="color_11"] .pignose-calendar {
  border-color: #6673fd;
}

[data-primary="color_11"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #6673fd;
}

[data-primary="color_11"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #6673fd;
}

[data-primary="color_11"] .bootstrap-tagsinput .tag {
  background-color: #6673fd;
}

[data-primary="color_11"] .toast-success {
  background-color: #6673fd;
}

[data-primary="color_11"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #6673fd;
}

[data-primary="color_11"] .accordion-header-bg .accordion__header--primary {
  background-color: #6673fd;
}

[data-primary="color_11"] .alert-primary {
  background: #e4e6ff;
  border-color: #e4e6ff;
  color: #6673fd;
}

[data-primary="color_11"] .alert-alt.alert-primary {
  border-left: 4px solid #6673fd;
}

[data-primary="color_11"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #0316e1 !important;
}

[data-primary="color_11"] .alert.alert-primary.solid {
  background: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .alert.alert-outline-primary {
  color: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .badge-outline-primary {
  border: 1px solid #6673fd;
  color: #6673fd;
}

[data-primary="color_11"] .badge-primary {
  background-color: #6673fd;
}

[data-primary="color_11"] .page-titles h4 {
  color: #6673fd;
}

[data-primary="color_11"] .card-action>a {
  background: #01063f;
}

[data-primary="color_11"] .card-action .dropdown {
  background: #01063f;
  color: #6673fd;
}

[data-primary="color_11"] .card-action .dropdown:hover,
[data-primary="color_11"] .card-action .dropdown:focus {
  background: #01063f;
}

[data-primary="color_11"] .card-loader i {
  background: #4353fd;
}

[data-primary="color_11"] .dropdown-outline {
  border: 0.1rem solid #6673fd;
}

[data-primary="color_11"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #6673fd;
}

[data-primary="color_11"] .card-action .custom-dropdown {
  background: #fdfdff;
}

[data-primary="color_11"] .card-action .custom-dropdown.show,
[data-primary="color_11"] .card-action .custom-dropdown:focus,
[data-primary="color_11"] .card-action .custom-dropdown:hover {
  background: #6673fd;
}

[data-primary="color_11"] .label-primary {
  background: #6673fd;
}

[data-primary="color_11"] .pagination .page-item .page-link:hover {
  background: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .pagination .page-item.active .page-link {
  background-color: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_11"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #6673fd;
}

[data-primary="color_11"] .progress-bar {
  background-color: #6673fd;
}

[data-primary="color_11"] .progress-bar-primary {
  background-color: #6673fd;
}

[data-primary="color_11"] .ribbon__four {
  background-color: #6673fd;
}

[data-primary="color_11"] .ribbon__four:after,
[data-primary="color_11"] .ribbon__four:before {
  background-color: #cbcffe;
}

[data-primary="color_11"] .ribbon__five {
  background-color: #6673fd;
}

[data-primary="color_11"] .ribbon__five::before {
  border-color: transparent transparent #6673fd transparent;
}

[data-primary="color_11"] .ribbon__six {
  background-color: #6673fd;
}

[data-primary="color_11"] .multi-steps>li {
  color: #6673fd;
}

[data-primary="color_11"] .multi-steps>li:after {
  background-color: #6673fd;
}

[data-primary="color_11"] .multi-steps>li.is-active:before {
  border-color: #6673fd;
}

[data-primary="color_11"] .timeline-badge.primary {
  background-color: #6673fd !important;
}

[data-primary="color_11"] .tooltip-wrapper button:hover {
  background: #6673fd;
}

[data-primary="color_11"] .chart_widget_tab_one .nav-link.active {
  background-color: #6673fd;
  border: 1px solid #6673fd;
}

[data-primary="color_11"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #6673fd;
}

[data-primary="color_11"] .social-icon2 a {
  border: 0.1rem solid #6673fd;
}

[data-primary="color_11"] .social-icon2 i {
  color: #6673fd;
}

[data-primary="color_11"] .social-icon3 ul li a:hover i {
  color: #6673fd;
}

[data-primary="color_11"] .bgl-primary {
  background: #fdfdff;
  border-color: #fdfdff;
  color: #6673fd;
}

[data-primary="color_11"] .tdl-holder input[type=checkbox]:checked+i {
  background: #6673fd;
}

[data-primary="color_11"] .footer .copyright a {
  color: #6673fd;
}

[data-primary="color_11"] .hamburger .line {
  background: #6673fd;
}

[data-primary="color_11"] svg.pulse-svg .first-circle,
[data-primary="color_11"] svg.pulse-svg .second-circle,
[data-primary="color_11"] svg.pulse-svg .third-circle {
  fill: #6673fd;
}

[data-primary="color_11"] .pulse-css {
  background: #6673fd;
}

[data-primary="color_11"] .pulse-css:after,
[data-primary="color_11"] .pulse-css:before {
  background-color: #6673fd;
}

[data-primary="color_11"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #6673fd;
}

[data-primary="color_11"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_11"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_11"] .header-right .header-profile .dropdown-menu a.active {
  color: #6673fd;
}

[data-primary="color_11"] .header-right .header-profile .profile_title {
  background: #6673fd;
}

[data-primary="color_11"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #6673fd !important;
}

[data-primary="color_11"] .deznav .metismenu>li>a svg {
  color: #6673fd;
}

[data-primary="color_11"] .deznav .metismenu>li:hover>a,
[data-primary="color_11"] .deznav .metismenu>li:focus>a {
  color: #6673fd;
}

[data-primary="color_11"] .deznav .metismenu>li.mm-active>a {
  color: #6673fd;
}

[data-primary="color_11"] .deznav .metismenu ul a:hover,
[data-primary="color_11"] .deznav .metismenu ul a:focus,
[data-primary="color_11"] .deznav .metismenu ul a.mm-active {
  color: #6673fd;
}

@media (min-width: 767px) {

  [data-primary="color_11"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_11"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_11"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_11"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: white;
  }
}

[data-primary="color_11"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #6673fd;
}

[data-primary="color_11"] .nav-user {
  background: #6673fd;
}

[data-primary="color_11"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #6673fd;
}

[data-primary="color_11"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #6673fd;
}

[data-primary="color_11"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"][data-theme-version="dark"] .header-left input:focus {
  border-color: #6673fd;
}

[data-primary="color_11"][data-theme-version="dark"] .loader__bar {
  background: #6673fd;
}

[data-primary="color_11"][data-theme-version="dark"] .loader__ball {
  background: #6673fd;
}

[data-primary="color_11"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #6673fd;
}

[data-primary="color_11"] .new-arrival-content .price {
  color: #6673fd;
}

[data-primary="color_11"] .chart-link a i.text-primary {
  color: #6673fd;
}

[data-primary="color_11"] #user-activity .nav-tabs .nav-link.active {
  background: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] span#counter {
  color: #6673fd;
}

[data-primary="color_11"] .welcome-content:after {
  background: #6673fd;
}

[data-primary="color_11"] .timeline-badge {
  background-color: #6673fd;
}

[data-primary="color_11"] .page-timeline .timeline-workplan[data-primary="color_11"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(102, 115, 253, 0.4);
}

[data-primary="color_11"] .sk-three-bounce .sk-child {
  background-color: #6673fd;
}

[data-primary="color_11"] .dropdown-item.active,
[data-primary="color_11"] .dropdown-item:active {
  color: #fff;
  background-color: #6673fd;
}

[data-primary="color_11"] .overlay-box:after {
  background: #6673fd;
}

[data-primary="color_11"] .btn-primary {
  background-color: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .bg-primary {
  background-color: #6673fd !important;
}

[data-primary="color_11"] .text-primary {
  color: #6673fd !important;
}

[data-primary="color_11"] .btn-primary:hover {
  background-color: #1a2efc;
  border-color: #1a2efc;
}

[data-primary="color_11"] .btn-outline-primary {
  color: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .btn-outline-primary:hover {
  background-color: #6673fd;
  border-color: #6673fd;
}

[data-primary="color_11"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_11"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_11"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_11"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_11"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_11"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #1a2efc;
  border-color: #1a2efc;
}

[data-primary="color_12"] a:hover,
[data-primary="color_12"] a:focus,
[data-primary="color_12"] a.active {
  color: #558b2f;
}

[data-primary="color_12"] [data-class="bg-primary"]:before {
  background: #558b2f;
}

[data-primary="color_12"] .email-left-box .intro-title {
  background: rgba(85, 139, 47, 0.1);
}

[data-primary="color_12"] .email-left-box .intro-title i {
  color: #558b2f;
}

[data-primary="color_12"] .widget-stat .media .media-body h4 {
  color: #558b2f !important;
}

[data-primary="color_12"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(85, 139, 47, 0.1);
}

[data-primary="color_12"] .mail-list .list-group-item.active i {
  color: #558b2f;
}

[data-primary="color_12"] .single-mail.active {
  background: #558b2f;
}

[data-primary="color_12"] .profile-info h4.text-primary {
  color: #558b2f !important;
}

[data-primary="color_12"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_12"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #558b2f;
  color: #558b2f;
}

[data-primary="color_12"] .amChartsInputField {
  border: 0;
  background: #558b2f;
}

[data-primary="color_12"] .amcharts-period-input,
[data-primary="color_12"] .amcharts-period-input-selected {
  background: #558b2f;
}

[data-primary="color_12"] .morris-hover {
  background: #558b2f;
}

[data-primary="color_12"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #558b2f;
}

[data-primary="color_12"] .custom-select:focus {
  border-color: #558b2f;
  color: #558b2f;
}

[data-primary="color_12"] .daterangepicker td.active {
  background-color: #558b2f;
}

[data-primary="color_12"] .daterangepicker td.active:hover {
  background-color: #558b2f;
}

[data-primary="color_12"] .daterangepicker button.applyBtn {
  background-color: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .wizard>.steps li.current a {
  background-color: #558b2f;
}

[data-primary="color_12"] .wizard .skip-email a {
  color: #558b2f;
}

[data-primary="color_12"] .wizard>.actions li:not(.disabled) a {
  background-color: #558b2f;
}

[data-primary="color_12"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #558b2f;
}

[data-primary="color_12"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #558b2f;
}

[data-primary="color_12"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #558b2f;
}

[data-primary="color_12"] .is-invalid .input-group-prepend .input-group-text i {
  color: #79c046;
}

[data-primary="color_12"] .datamaps-hoverover {
  color: #558b2f;
  border: 1px solid rgba(85, 139, 47, 0.3);
}

[data-primary="color_12"] .jqvmap-zoomin,
[data-primary="color_12"] .jqvmap-zoomout {
  background-color: #558b2f;
}

[data-primary="color_12"] .table .thead-primary th {
  background-color: #558b2f;
}

[data-primary="color_12"] .table.primary-table-bg-hover thead th {
  background-color: #497829;
}

[data-primary="color_12"] .table.primary-table-bg-hover tbody tr {
  background-color: #558b2f;
}

[data-primary="color_12"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #619e35;
}

[data-primary="color_12"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_12"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #497829;
}

[data-primary="color_12"] table.dataTable tr.selected {
  color: #558b2f;
}

[data-primary="color_12"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #558b2f !important;
  background: rgba(85, 139, 47, 0.1);
}

[data-primary="color_12"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #558b2f !important;
  background: rgba(85, 139, 47, 0.1);
}

[data-primary="color_12"] .clipboard-btn:hover {
  background-color: #558b2f;
}

[data-primary="color_12"] .cd-h-timeline__dates::before {
  background: #558b2f;
}

[data-primary="color_12"] .cd-h-timeline__dates::after {
  background: #558b2f;
}

[data-primary="color_12"] .cd-h-timeline__line {
  background-color: #558b2f;
}

[data-primary="color_12"] .cd-h-timeline__date:after {
  border-color: #578e30;
  background-color: #558b2f;
}

[data-primary="color_12"] .cd-h-timeline__navigation {
  border-color: #578e30;
}

[data-primary="color_12"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #578e30;
}

[data-primary="color_12"] .dd-handle {
  background: #558b2f;
}

[data-primary="color_12"] .dd-handle:hover {
  background: #558b2f;
}

[data-primary="color_12"] .dd3-content:hover {
  background: #558b2f;
}

[data-primary="color_12"] .noUi-connect {
  background-color: #558b2f;
}

[data-primary="color_12"] .noUi-connect.c-3-color {
  background-color: #558b2f;
}

[data-primary="color_12"] .noUi-horizontal .noUi-handle,
[data-primary="color_12"] .noUi-vertical .noUi-handle {
  background-color: #558b2f;
}

[data-primary="color_12"] #slider-toggle.off .noUi-handle {
  border-color: #558b2f;
}

[data-primary="color_12"] .pignose-calendar {
  border-color: #558b2f;
}

[data-primary="color_12"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #558b2f;
}

[data-primary="color_12"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #558b2f;
}

[data-primary="color_12"] .bootstrap-tagsinput .tag {
  background-color: #558b2f;
}

[data-primary="color_12"] .toast-success {
  background-color: #558b2f;
}

[data-primary="color_12"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #558b2f;
}

[data-primary="color_12"] .accordion-header-bg .accordion__header--primary {
  background-color: #558b2f;
}

[data-primary="color_12"] .alert-primary {
  background: #94cd6c;
  border-color: #94cd6c;
  color: #558b2f;
}

[data-primary="color_12"] .alert-alt.alert-primary {
  border-left: 4px solid #558b2f;
}

[data-primary="color_12"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #1b2c0f !important;
}

[data-primary="color_12"] .alert.alert-primary.solid {
  background: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .alert.alert-outline-primary {
  color: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .badge-outline-primary {
  border: 1px solid #558b2f;
  color: #558b2f;
}

[data-primary="color_12"] .badge-primary {
  background-color: #558b2f;
}

[data-primary="color_12"] .page-titles h4 {
  color: #558b2f;
}

[data-primary="color_12"] .card-action>a {
  background: black;
}

[data-primary="color_12"] .card-action .dropdown {
  background: black;
  color: #558b2f;
}

[data-primary="color_12"] .card-action .dropdown:hover,
[data-primary="color_12"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_12"] .card-loader i {
  background: #457026;
}

[data-primary="color_12"] .dropdown-outline {
  border: 0.1rem solid #558b2f;
}

[data-primary="color_12"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #558b2f;
}

[data-primary="color_12"] .card-action .custom-dropdown {
  background: #a2d47f;
}

[data-primary="color_12"] .card-action .custom-dropdown.show,
[data-primary="color_12"] .card-action .custom-dropdown:focus,
[data-primary="color_12"] .card-action .custom-dropdown:hover {
  background: #558b2f;
}

[data-primary="color_12"] .label-primary {
  background: #558b2f;
}

[data-primary="color_12"] .pagination .page-item .page-link:hover {
  background: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .pagination .page-item.active .page-link {
  background-color: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_12"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #558b2f;
}

[data-primary="color_12"] .progress-bar {
  background-color: #558b2f;
}

[data-primary="color_12"] .progress-bar-primary {
  background-color: #558b2f;
}

[data-primary="color_12"] .ribbon__four {
  background-color: #558b2f;
}

[data-primary="color_12"] .ribbon__four:after,
[data-primary="color_12"] .ribbon__four:before {
  background-color: #86c759;
}

[data-primary="color_12"] .ribbon__five {
  background-color: #558b2f;
}

[data-primary="color_12"] .ribbon__five::before {
  border-color: transparent transparent #558b2f transparent;
}

[data-primary="color_12"] .ribbon__six {
  background-color: #558b2f;
}

[data-primary="color_12"] .multi-steps>li {
  color: #558b2f;
}

[data-primary="color_12"] .multi-steps>li:after {
  background-color: #558b2f;
}

[data-primary="color_12"] .multi-steps>li.is-active:before {
  border-color: #558b2f;
}

[data-primary="color_12"] .timeline-badge.primary {
  background-color: #558b2f !important;
}

[data-primary="color_12"] .tooltip-wrapper button:hover {
  background: #558b2f;
}

[data-primary="color_12"] .chart_widget_tab_one .nav-link.active {
  background-color: #558b2f;
  border: 1px solid #558b2f;
}

[data-primary="color_12"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #558b2f;
}

[data-primary="color_12"] .social-icon2 a {
  border: 0.1rem solid #558b2f;
}

[data-primary="color_12"] .social-icon2 i {
  color: #558b2f;
}

[data-primary="color_12"] .social-icon3 ul li a:hover i {
  color: #558b2f;
}

[data-primary="color_12"] .bgl-primary {
  background: #a2d47f;
  border-color: #a2d47f;
  color: #558b2f;
}

[data-primary="color_12"] .tdl-holder input[type=checkbox]:checked+i {
  background: #558b2f;
}

[data-primary="color_12"] .footer .copyright a {
  color: #558b2f;
}

[data-primary="color_12"] .hamburger .line {
  background: #558b2f;
}

[data-primary="color_12"] svg.pulse-svg .first-circle,
[data-primary="color_12"] svg.pulse-svg .second-circle,
[data-primary="color_12"] svg.pulse-svg .third-circle {
  fill: #558b2f;
}

[data-primary="color_12"] .pulse-css {
  background: #558b2f;
}

[data-primary="color_12"] .pulse-css:after,
[data-primary="color_12"] .pulse-css:before {
  background-color: #558b2f;
}

[data-primary="color_12"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #558b2f;
}

[data-primary="color_12"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_12"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_12"] .header-right .header-profile .dropdown-menu a.active {
  color: #558b2f;
}

[data-primary="color_12"] .header-right .header-profile .profile_title {
  background: #558b2f;
}

[data-primary="color_12"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #558b2f !important;
}

[data-primary="color_12"] .deznav .metismenu>li>a svg {
  color: #558b2f;
}

[data-primary="color_12"] .deznav .metismenu>li:hover>a,
[data-primary="color_12"] .deznav .metismenu>li:focus>a {
  color: #558b2f;
}

[data-primary="color_12"] .deznav .metismenu>li.mm-active>a {
  color: #558b2f;
}

[data-primary="color_12"] .deznav .metismenu ul a:hover,
[data-primary="color_12"] .deznav .metismenu ul a:focus,
[data-primary="color_12"] .deznav .metismenu ul a.mm-active {
  color: #558b2f;
}

@media (min-width: 767px) {

  [data-primary="color_12"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_12"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_12"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_12"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #daeecb;
  }
}

[data-primary="color_12"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #558b2f;
}

[data-primary="color_12"] .nav-user {
  background: #558b2f;
}

[data-primary="color_12"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #558b2f;
}

[data-primary="color_12"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #558b2f;
}

[data-primary="color_12"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"][data-theme-version="dark"] .header-left input:focus {
  border-color: #558b2f;
}

[data-primary="color_12"][data-theme-version="dark"] .loader__bar {
  background: #558b2f;
}

[data-primary="color_12"][data-theme-version="dark"] .loader__ball {
  background: #558b2f;
}

[data-primary="color_12"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #558b2f;
}

[data-primary="color_12"] .new-arrival-content .price {
  color: #558b2f;
}

[data-primary="color_12"] .chart-link a i.text-primary {
  color: #558b2f;
}

[data-primary="color_12"] #user-activity .nav-tabs .nav-link.active {
  background: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] span#counter {
  color: #558b2f;
}

[data-primary="color_12"] .welcome-content:after {
  background: #558b2f;
}

[data-primary="color_12"] .timeline-badge {
  background-color: #558b2f;
}

[data-primary="color_12"] .page-timeline .timeline-workplan[data-primary="color_12"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(85, 139, 47, 0.4);
}

[data-primary="color_12"] .sk-three-bounce .sk-child {
  background-color: #558b2f;
}

[data-primary="color_12"] .dropdown-item.active,
[data-primary="color_12"] .dropdown-item:active {
  color: #fff;
  background-color: #558b2f;
}

[data-primary="color_12"] .overlay-box:after {
  background: #558b2f;
}

[data-primary="color_12"] .btn-primary {
  background-color: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .bg-primary {
  background-color: #558b2f !important;
}

[data-primary="color_12"] .text-primary {
  color: #558b2f !important;
}

[data-primary="color_12"] .btn-primary:hover {
  background-color: #32521c;
  border-color: #32521c;
}

[data-primary="color_12"] .btn-outline-primary {
  color: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .btn-outline-primary:hover {
  background-color: #558b2f;
  border-color: #558b2f;
}

[data-primary="color_12"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_12"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_12"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_12"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_12"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_12"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #32521c;
  border-color: #32521c;
}

[data-primary="color_13"] a:hover,
[data-primary="color_13"] a:focus,
[data-primary="color_13"] a.active {
  color: #2a2a2a;
}

[data-primary="color_13"] [data-class="bg-primary"]:before {
  background: #2a2a2a;
}

[data-primary="color_13"] .email-left-box .intro-title {
  background: rgba(42, 42, 42, 0.1);
}

[data-primary="color_13"] .email-left-box .intro-title i {
  color: #2a2a2a;
}

[data-primary="color_13"] .widget-stat .media .media-body h4 {
  color: #2a2a2a !important;
}

[data-primary="color_13"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(42, 42, 42, 0.1);
}

[data-primary="color_13"] .mail-list .list-group-item.active i {
  color: #2a2a2a;
}

[data-primary="color_13"] .single-mail.active {
  background: #2a2a2a;
}

[data-primary="color_13"] .profile-info h4.text-primary {
  color: #2a2a2a !important;
}

[data-primary="color_13"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_13"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #2a2a2a;
  color: #2a2a2a;
}

[data-primary="color_13"] .amChartsInputField {
  border: 0;
  background: #2a2a2a;
}

[data-primary="color_13"] .amcharts-period-input,
[data-primary="color_13"] .amcharts-period-input-selected {
  background: #2a2a2a;
}

[data-primary="color_13"] .morris-hover {
  background: #2a2a2a;
}

[data-primary="color_13"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .custom-select:focus {
  border-color: #2a2a2a;
  color: #2a2a2a;
}

[data-primary="color_13"] .daterangepicker td.active {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .daterangepicker td.active:hover {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .daterangepicker button.applyBtn {
  background-color: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .wizard>.steps li.current a {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .wizard .skip-email a {
  color: #2a2a2a;
}

[data-primary="color_13"] .wizard>.actions li:not(.disabled) a {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #2a2a2a;
}

[data-primary="color_13"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #2a2a2a;
}

[data-primary="color_13"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .is-invalid .input-group-prepend .input-group-text i {
  color: #505050;
}

[data-primary="color_13"] .datamaps-hoverover {
  color: #2a2a2a;
  border: 1px solid rgba(42, 42, 42, 0.3);
}

[data-primary="color_13"] .jqvmap-zoomin,
[data-primary="color_13"] .jqvmap-zoomout {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .table .thead-primary th {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .table.primary-table-bg-hover thead th {
  background-color: #1d1d1d;
}

[data-primary="color_13"] .table.primary-table-bg-hover tbody tr {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #373737;
}

[data-primary="color_13"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_13"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #1d1d1d;
}

[data-primary="color_13"] table.dataTable tr.selected {
  color: #2a2a2a;
}

[data-primary="color_13"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #2a2a2a !important;
  background: rgba(42, 42, 42, 0.1);
}

[data-primary="color_13"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #2a2a2a !important;
  background: rgba(42, 42, 42, 0.1);
}

[data-primary="color_13"] .clipboard-btn:hover {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .cd-h-timeline__dates::before {
  background: #2a2a2a;
}

[data-primary="color_13"] .cd-h-timeline__dates::after {
  background: #2a2a2a;
}

[data-primary="color_13"] .cd-h-timeline__line {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .cd-h-timeline__date:after {
  border-color: #2c2c2c;
  background-color: #2a2a2a;
}

[data-primary="color_13"] .cd-h-timeline__navigation {
  border-color: #2c2c2c;
}

[data-primary="color_13"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #2c2c2c;
}

[data-primary="color_13"] .dd-handle {
  background: #2a2a2a;
}

[data-primary="color_13"] .dd-handle:hover {
  background: #2a2a2a;
}

[data-primary="color_13"] .dd3-content:hover {
  background: #2a2a2a;
}

[data-primary="color_13"] .noUi-connect {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .noUi-connect.c-3-color {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .noUi-horizontal .noUi-handle,
[data-primary="color_13"] .noUi-vertical .noUi-handle {
  background-color: #2a2a2a;
}

[data-primary="color_13"] #slider-toggle.off .noUi-handle {
  border-color: #2a2a2a;
}

[data-primary="color_13"] .pignose-calendar {
  border-color: #2a2a2a;
}

[data-primary="color_13"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .bootstrap-tagsinput .tag {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .toast-success {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .accordion-header-bg .accordion__header--primary {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .alert-primary {
  background: #6a6a6a;
  border-color: #6a6a6a;
  color: #2a2a2a;
}

[data-primary="color_13"] .alert-alt.alert-primary {
  border-left: 4px solid #2a2a2a;
}

[data-primary="color_13"] .alert-alt.alert-primary.solid {
  border-left: 4px solid black !important;
}

[data-primary="color_13"] .alert.alert-primary.solid {
  background: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .alert.alert-outline-primary {
  color: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .badge-outline-primary {
  border: 1px solid #2a2a2a;
  color: #2a2a2a;
}

[data-primary="color_13"] .badge-primary {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .page-titles h4 {
  color: #2a2a2a;
}

[data-primary="color_13"] .card-action>a {
  background: black;
}

[data-primary="color_13"] .card-action .dropdown {
  background: black;
  color: #2a2a2a;
}

[data-primary="color_13"] .card-action .dropdown:hover,
[data-primary="color_13"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_13"] .card-loader i {
  background: #181818;
}

[data-primary="color_13"] .dropdown-outline {
  border: 0.1rem solid #2a2a2a;
}

[data-primary="color_13"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #2a2a2a;
}

[data-primary="color_13"] .card-action .custom-dropdown {
  background: #777777;
}

[data-primary="color_13"] .card-action .custom-dropdown.show,
[data-primary="color_13"] .card-action .custom-dropdown:focus,
[data-primary="color_13"] .card-action .custom-dropdown:hover {
  background: #2a2a2a;
}

[data-primary="color_13"] .label-primary {
  background: #2a2a2a;
}

[data-primary="color_13"] .pagination .page-item .page-link:hover {
  background: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .pagination .page-item.active .page-link {
  background-color: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_13"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #2a2a2a;
}

[data-primary="color_13"] .progress-bar {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .progress-bar-primary {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .ribbon__four {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .ribbon__four:after,
[data-primary="color_13"] .ribbon__four:before {
  background-color: #5d5d5d;
}

[data-primary="color_13"] .ribbon__five {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .ribbon__five::before {
  border-color: transparent transparent #2a2a2a transparent;
}

[data-primary="color_13"] .ribbon__six {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .multi-steps>li {
  color: #2a2a2a;
}

[data-primary="color_13"] .multi-steps>li:after {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .multi-steps>li.is-active:before {
  border-color: #2a2a2a;
}

[data-primary="color_13"] .timeline-badge.primary {
  background-color: #2a2a2a !important;
}

[data-primary="color_13"] .tooltip-wrapper button:hover {
  background: #2a2a2a;
}

[data-primary="color_13"] .chart_widget_tab_one .nav-link.active {
  background-color: #2a2a2a;
  border: 1px solid #2a2a2a;
}

[data-primary="color_13"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #2a2a2a;
}

[data-primary="color_13"] .social-icon2 a {
  border: 0.1rem solid #2a2a2a;
}

[data-primary="color_13"] .social-icon2 i {
  color: #2a2a2a;
}

[data-primary="color_13"] .social-icon3 ul li a:hover i {
  color: #2a2a2a;
}

[data-primary="color_13"] .bgl-primary {
  background: #777777;
  border-color: #777777;
  color: #2a2a2a;
}

[data-primary="color_13"] .tdl-holder input[type=checkbox]:checked+i {
  background: #2a2a2a;
}

[data-primary="color_13"] .footer .copyright a {
  color: #2a2a2a;
}

[data-primary="color_13"] .hamburger .line {
  background: #2a2a2a;
}

[data-primary="color_13"] svg.pulse-svg .first-circle,
[data-primary="color_13"] svg.pulse-svg .second-circle,
[data-primary="color_13"] svg.pulse-svg .third-circle {
  fill: #2a2a2a;
}

[data-primary="color_13"] .pulse-css {
  background: #2a2a2a;
}

[data-primary="color_13"] .pulse-css:after,
[data-primary="color_13"] .pulse-css:before {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #2a2a2a;
}

[data-primary="color_13"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_13"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_13"] .header-right .header-profile .dropdown-menu a.active {
  color: #2a2a2a;
}

[data-primary="color_13"] .header-right .header-profile .profile_title {
  background: #2a2a2a;
}

[data-primary="color_13"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #2a2a2a !important;
}

[data-primary="color_13"] .deznav .metismenu>li>a svg {
  color: #2a2a2a;
}

[data-primary="color_13"] .deznav .metismenu>li:hover>a,
[data-primary="color_13"] .deznav .metismenu>li:focus>a {
  color: #2a2a2a;
}

[data-primary="color_13"] .deznav .metismenu>li.mm-active>a {
  color: #2a2a2a;
}

[data-primary="color_13"] .deznav .metismenu ul a:hover,
[data-primary="color_13"] .deznav .metismenu ul a:focus,
[data-primary="color_13"] .deznav .metismenu ul a.mm-active {
  color: #2a2a2a;
}

@media (min-width: 767px) {

  [data-primary="color_13"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_13"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_13"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_13"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #aaaaaa;
  }
}

[data-primary="color_13"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .nav-user {
  background: #2a2a2a;
}

[data-primary="color_13"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #2a2a2a;
}

[data-primary="color_13"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #2a2a2a;
}

[data-primary="color_13"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"][data-theme-version="dark"] .header-left input:focus {
  border-color: #2a2a2a;
}

[data-primary="color_13"][data-theme-version="dark"] .loader__bar {
  background: #2a2a2a;
}

[data-primary="color_13"][data-theme-version="dark"] .loader__ball {
  background: #2a2a2a;
}

[data-primary="color_13"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #2a2a2a;
}

[data-primary="color_13"] .new-arrival-content .price {
  color: #2a2a2a;
}

[data-primary="color_13"] .chart-link a i.text-primary {
  color: #2a2a2a;
}

[data-primary="color_13"] #user-activity .nav-tabs .nav-link.active {
  background: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] span#counter {
  color: #2a2a2a;
}

[data-primary="color_13"] .welcome-content:after {
  background: #2a2a2a;
}

[data-primary="color_13"] .timeline-badge {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .page-timeline .timeline-workplan[data-primary="color_13"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(42, 42, 42, 0.4);
}

[data-primary="color_13"] .sk-three-bounce .sk-child {
  background-color: #2a2a2a;
}

[data-primary="color_13"] .dropdown-item.active,
[data-primary="color_13"] .dropdown-item:active {
  color: #fff;
  background-color: #2a2a2a;
}

[data-primary="color_13"] .overlay-box:after {
  background: #2a2a2a;
}

[data-primary="color_13"] .btn-primary {
  background-color: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .bg-primary {
  background-color: #2a2a2a !important;
}

[data-primary="color_13"] .text-primary {
  color: #2a2a2a !important;
}

[data-primary="color_13"] .btn-primary:hover {
  background-color: #040404;
  border-color: #040404;
}

[data-primary="color_13"] .btn-outline-primary {
  color: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .btn-outline-primary:hover {
  background-color: #2a2a2a;
  border-color: #2a2a2a;
}

[data-primary="color_13"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_13"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_13"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_13"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_13"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_13"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #040404;
  border-color: #040404;
}

[data-primary="color_14"] a:hover,
[data-primary="color_14"] a:focus,
[data-primary="color_14"] a.active {
  color: #1367c8;
}

[data-primary="color_14"] [data-class="bg-primary"]:before {
  background: #1367c8;
}

[data-primary="color_14"] .email-left-box .intro-title {
  background: rgba(19, 103, 200, 0.1);
}

[data-primary="color_14"] .email-left-box .intro-title i {
  color: #1367c8;
}

[data-primary="color_14"] .widget-stat .media .media-body h4 {
  color: #1367c8 !important;
}

[data-primary="color_14"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(19, 103, 200, 0.1);
}

[data-primary="color_14"] .mail-list .list-group-item.active i {
  color: #1367c8;
}

[data-primary="color_14"] .single-mail.active {
  background: #1367c8;
}

[data-primary="color_14"] .profile-info h4.text-primary {
  color: #1367c8 !important;
}

[data-primary="color_14"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_14"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #1367c8;
  color: #1367c8;
}

[data-primary="color_14"] .amChartsInputField {
  border: 0;
  background: #1367c8;
}

[data-primary="color_14"] .amcharts-period-input,
[data-primary="color_14"] .amcharts-period-input-selected {
  background: #1367c8;
}

[data-primary="color_14"] .morris-hover {
  background: #1367c8;
}

[data-primary="color_14"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #1367c8;
}

[data-primary="color_14"] .custom-select:focus {
  border-color: #1367c8;
  color: #1367c8;
}

[data-primary="color_14"] .daterangepicker td.active {
  background-color: #1367c8;
}

[data-primary="color_14"] .daterangepicker td.active:hover {
  background-color: #1367c8;
}

[data-primary="color_14"] .daterangepicker button.applyBtn {
  background-color: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .wizard>.steps li.current a {
  background-color: #1367c8;
}

[data-primary="color_14"] .wizard .skip-email a {
  color: #1367c8;
}

[data-primary="color_14"] .wizard>.actions li:not(.disabled) a {
  background-color: #1367c8;
}

[data-primary="color_14"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #1367c8;
}

[data-primary="color_14"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #1367c8;
}

[data-primary="color_14"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #1367c8;
}

[data-primary="color_14"] .is-invalid .input-group-prepend .input-group-text i {
  color: #3b8dec;
}

[data-primary="color_14"] .datamaps-hoverover {
  color: #1367c8;
  border: 1px solid rgba(19, 103, 200, 0.3);
}

[data-primary="color_14"] .jqvmap-zoomin,
[data-primary="color_14"] .jqvmap-zoomout {
  background-color: #1367c8;
}

[data-primary="color_14"] .table .thead-primary th {
  background-color: #1367c8;
}

[data-primary="color_14"] .table.primary-table-bg-hover thead th {
  background-color: #115bb1;
}

[data-primary="color_14"] .table.primary-table-bg-hover tbody tr {
  background-color: #1367c8;
}

[data-primary="color_14"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #1573df;
}

[data-primary="color_14"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_14"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #115bb1;
}

[data-primary="color_14"] table.dataTable tr.selected {
  color: #1367c8;
}

[data-primary="color_14"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #1367c8 !important;
  background: rgba(19, 103, 200, 0.1);
}

[data-primary="color_14"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #1367c8 !important;
  background: rgba(19, 103, 200, 0.1);
}

[data-primary="color_14"] .clipboard-btn:hover {
  background-color: #1367c8;
}

[data-primary="color_14"] .cd-h-timeline__dates::before {
  background: #1367c8;
}

[data-primary="color_14"] .cd-h-timeline__dates::after {
  background: #1367c8;
}

[data-primary="color_14"] .cd-h-timeline__line {
  background-color: #1367c8;
}

[data-primary="color_14"] .cd-h-timeline__date:after {
  border-color: #1369cc;
  background-color: #1367c8;
}

[data-primary="color_14"] .cd-h-timeline__navigation {
  border-color: #1369cc;
}

[data-primary="color_14"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #1369cc;
}

[data-primary="color_14"] .dd-handle {
  background: #1367c8;
}

[data-primary="color_14"] .dd-handle:hover {
  background: #1367c8;
}

[data-primary="color_14"] .dd3-content:hover {
  background: #1367c8;
}

[data-primary="color_14"] .noUi-connect {
  background-color: #1367c8;
}

[data-primary="color_14"] .noUi-connect.c-3-color {
  background-color: #1367c8;
}

[data-primary="color_14"] .noUi-horizontal .noUi-handle,
[data-primary="color_14"] .noUi-vertical .noUi-handle {
  background-color: #1367c8;
}

[data-primary="color_14"] #slider-toggle.off .noUi-handle {
  border-color: #1367c8;
}

[data-primary="color_14"] .pignose-calendar {
  border-color: #1367c8;
}

[data-primary="color_14"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #1367c8;
}

[data-primary="color_14"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #1367c8;
}

[data-primary="color_14"] .bootstrap-tagsinput .tag {
  background-color: #1367c8;
}

[data-primary="color_14"] .toast-success {
  background-color: #1367c8;
}

[data-primary="color_14"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #1367c8;
}

[data-primary="color_14"] .accordion-header-bg .accordion__header--primary {
  background-color: #1367c8;
}

[data-primary="color_14"] .alert-primary {
  background: #6aa8f1;
  border-color: #6aa8f1;
  color: #1367c8;
}

[data-primary="color_14"] .alert-alt.alert-primary {
  border-left: 4px solid #1367c8;
}

[data-primary="color_14"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #082b54 !important;
}

[data-primary="color_14"] .alert.alert-primary.solid {
  background: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .alert.alert-outline-primary {
  color: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .badge-outline-primary {
  border: 1px solid #1367c8;
  color: #1367c8;
}

[data-primary="color_14"] .badge-primary {
  background-color: #1367c8;
}

[data-primary="color_14"] .page-titles h4 {
  color: #1367c8;
}

[data-primary="color_14"] .card-action>a {
  background: black;
}

[data-primary="color_14"] .card-action .dropdown {
  background: black;
  color: #1367c8;
}

[data-primary="color_14"] .card-action .dropdown:hover,
[data-primary="color_14"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_14"] .card-loader i {
  background: #1056a7;
}

[data-primary="color_14"] .dropdown-outline {
  border: 0.1rem solid #1367c8;
}

[data-primary="color_14"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #1367c8;
}

[data-primary="color_14"] .card-action .custom-dropdown {
  background: #81b6f3;
}

[data-primary="color_14"] .card-action .custom-dropdown.show,
[data-primary="color_14"] .card-action .custom-dropdown:focus,
[data-primary="color_14"] .card-action .custom-dropdown:hover {
  background: #1367c8;
}

[data-primary="color_14"] .label-primary {
  background: #1367c8;
}

[data-primary="color_14"] .pagination .page-item .page-link:hover {
  background: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .pagination .page-item.active .page-link {
  background-color: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_14"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #1367c8;
}

[data-primary="color_14"] .progress-bar {
  background-color: #1367c8;
}

[data-primary="color_14"] .progress-bar-primary {
  background-color: #1367c8;
}

[data-primary="color_14"] .ribbon__four {
  background-color: #1367c8;
}

[data-primary="color_14"] .ribbon__four:after,
[data-primary="color_14"] .ribbon__four:before {
  background-color: #529bef;
}

[data-primary="color_14"] .ribbon__five {
  background-color: #1367c8;
}

[data-primary="color_14"] .ribbon__five::before {
  border-color: transparent transparent #1367c8 transparent;
}

[data-primary="color_14"] .ribbon__six {
  background-color: #1367c8;
}

[data-primary="color_14"] .multi-steps>li {
  color: #1367c8;
}

[data-primary="color_14"] .multi-steps>li:after {
  background-color: #1367c8;
}

[data-primary="color_14"] .multi-steps>li.is-active:before {
  border-color: #1367c8;
}

[data-primary="color_14"] .timeline-badge.primary {
  background-color: #1367c8 !important;
}

[data-primary="color_14"] .tooltip-wrapper button:hover {
  background: #1367c8;
}

[data-primary="color_14"] .chart_widget_tab_one .nav-link.active {
  background-color: #1367c8;
  border: 1px solid #1367c8;
}

[data-primary="color_14"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #1367c8;
}

[data-primary="color_14"] .social-icon2 a {
  border: 0.1rem solid #1367c8;
}

[data-primary="color_14"] .social-icon2 i {
  color: #1367c8;
}

[data-primary="color_14"] .social-icon3 ul li a:hover i {
  color: #1367c8;
}

[data-primary="color_14"] .bgl-primary {
  background: #81b6f3;
  border-color: #81b6f3;
  color: #1367c8;
}

[data-primary="color_14"] .tdl-holder input[type=checkbox]:checked+i {
  background: #1367c8;
}

[data-primary="color_14"] .footer .copyright a {
  color: #1367c8;
}

[data-primary="color_14"] .hamburger .line {
  background: #1367c8;
}

[data-primary="color_14"] svg.pulse-svg .first-circle,
[data-primary="color_14"] svg.pulse-svg .second-circle,
[data-primary="color_14"] svg.pulse-svg .third-circle {
  fill: #1367c8;
}

[data-primary="color_14"] .pulse-css {
  background: #1367c8;
}

[data-primary="color_14"] .pulse-css:after,
[data-primary="color_14"] .pulse-css:before {
  background-color: #1367c8;
}

[data-primary="color_14"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #1367c8;
}

[data-primary="color_14"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_14"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_14"] .header-right .header-profile .dropdown-menu a.active {
  color: #1367c8;
}

[data-primary="color_14"] .header-right .header-profile .profile_title {
  background: #1367c8;
}

[data-primary="color_14"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #1367c8 !important;
}

[data-primary="color_14"] .deznav .metismenu>li>a svg {
  color: #1367c8;
}

[data-primary="color_14"] .deznav .metismenu>li:hover>a,
[data-primary="color_14"] .deznav .metismenu>li:focus>a {
  color: #1367c8;
}

[data-primary="color_14"] .deznav .metismenu>li.mm-active>a {
  color: #1367c8;
}

[data-primary="color_14"] .deznav .metismenu ul a:hover,
[data-primary="color_14"] .deznav .metismenu ul a:focus,
[data-primary="color_14"] .deznav .metismenu ul a.mm-active {
  color: #1367c8;
}

@media (min-width: 767px) {

  [data-primary="color_14"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_14"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_14"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_14"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #deecfc;
  }
}

[data-primary="color_14"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #1367c8;
}

[data-primary="color_14"] .nav-user {
  background: #1367c8;
}

[data-primary="color_14"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #1367c8;
}

[data-primary="color_14"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #1367c8;
}

[data-primary="color_14"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"][data-theme-version="dark"] .header-left input:focus {
  border-color: #1367c8;
}

[data-primary="color_14"][data-theme-version="dark"] .loader__bar {
  background: #1367c8;
}

[data-primary="color_14"][data-theme-version="dark"] .loader__ball {
  background: #1367c8;
}

[data-primary="color_14"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #1367c8;
}

[data-primary="color_14"] .new-arrival-content .price {
  color: #1367c8;
}

[data-primary="color_14"] .chart-link a i.text-primary {
  color: #1367c8;
}

[data-primary="color_14"] #user-activity .nav-tabs .nav-link.active {
  background: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] span#counter {
  color: #1367c8;
}

[data-primary="color_14"] .welcome-content:after {
  background: #1367c8;
}

[data-primary="color_14"] .timeline-badge {
  background-color: #1367c8;
}

[data-primary="color_14"] .page-timeline .timeline-workplan[data-primary="color_14"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(19, 103, 200, 0.4);
}

[data-primary="color_14"] .sk-three-bounce .sk-child {
  background-color: #1367c8;
}

[data-primary="color_14"] .dropdown-item.active,
[data-primary="color_14"] .dropdown-item:active {
  color: #fff;
  background-color: #1367c8;
}

[data-primary="color_14"] .overlay-box:after {
  background: #1367c8;
}

[data-primary="color_14"] .btn-primary {
  background-color: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .bg-primary {
  background-color: #1367c8 !important;
}

[data-primary="color_14"] .text-primary {
  color: #1367c8 !important;
}

[data-primary="color_14"] .btn-primary:hover {
  background-color: #0c4382;
  border-color: #0c4382;
}

[data-primary="color_14"] .btn-outline-primary {
  color: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .btn-outline-primary:hover {
  background-color: #1367c8;
  border-color: #1367c8;
}

[data-primary="color_14"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_14"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_14"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_14"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_14"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_14"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #0c4382;
  border-color: #0c4382;
}

[data-primary="color_15"] a:hover,
[data-primary="color_15"] a:focus,
[data-primary="color_15"] a.active {
  color: #ed0b4c;
}

[data-primary="color_15"] [data-class="bg-primary"]:before {
  background: #ed0b4c;
}

[data-primary="color_15"] .email-left-box .intro-title {
  background: rgba(237, 11, 76, 0.1);
}

[data-primary="color_15"] .email-left-box .intro-title i {
  color: #ed0b4c;
}

[data-primary="color_15"] .widget-stat .media .media-body h4 {
  color: #ed0b4c !important;
}

[data-primary="color_15"] .email-right-box .right-box-border {
  border-right: 2px solid rgba(237, 11, 76, 0.1);
}

[data-primary="color_15"] .mail-list .list-group-item.active i {
  color: #ed0b4c;
}

[data-primary="color_15"] .single-mail.active {
  background: #ed0b4c;
}

[data-primary="color_15"] .profile-info h4.text-primary {
  color: #ed0b4c !important;
}

[data-primary="color_15"] .profile-tab .nav-item .nav-link:hover,
[data-primary="color_15"] .profile-tab .nav-item .nav-link.active {
  border-bottom: 0.2px solid #ed0b4c;
  color: #ed0b4c;
}

[data-primary="color_15"] .amChartsInputField {
  border: 0;
  background: #ed0b4c;
}

[data-primary="color_15"] .amcharts-period-input,
[data-primary="color_15"] .amcharts-period-input-selected {
  background: #ed0b4c;
}

[data-primary="color_15"] .morris-hover {
  background: #ed0b4c;
}

[data-primary="color_15"] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .custom-select:focus {
  border-color: #ed0b4c;
  color: #ed0b4c;
}

[data-primary="color_15"] .daterangepicker td.active {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .daterangepicker td.active:hover {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .daterangepicker button.applyBtn {
  background-color: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .wizard>.steps li.current a {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .wizard .skip-email a {
  color: #ed0b4c;
}

[data-primary="color_15"] .wizard>.actions li:not(.disabled) a {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .step-form-horizontal .wizard .steps li.done a .number {
  background: #ed0b4c;
}

[data-primary="color_15"] .step-form-horizontal .wizard .steps li.current a .number {
  color: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .step-form-horizontal .wizard .steps li.disabled a .number {
  color: #ed0b4c;
}

[data-primary="color_15"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .is-invalid .input-group-prepend .input-group-text i {
  color: #f74e7e;
}

[data-primary="color_15"] .datamaps-hoverover {
  color: #ed0b4c;
  border: 1px solid rgba(237, 11, 76, 0.3);
}

[data-primary="color_15"] .jqvmap-zoomin,
[data-primary="color_15"] .jqvmap-zoomout {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .table .thead-primary th {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .table.primary-table-bg-hover thead th {
  background-color: #d50a44;
}

[data-primary="color_15"] .table.primary-table-bg-hover tbody tr {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .table.primary-table-bg-hover tbody tr:hover {
  background-color: #f51d5b;
}

[data-primary="color_15"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,
[data-primary="color_15"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #d50a44;
}

[data-primary="color_15"] table.dataTable tr.selected {
  color: #ed0b4c;
}

[data-primary="color_15"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #ed0b4c !important;
  background: rgba(237, 11, 76, 0.1);
}

[data-primary="color_15"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  color: #ed0b4c !important;
  background: rgba(237, 11, 76, 0.1);
}

[data-primary="color_15"] .clipboard-btn:hover {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .cd-h-timeline__dates::before {
  background: #ed0b4c;
}

[data-primary="color_15"] .cd-h-timeline__dates::after {
  background: #ed0b4c;
}

[data-primary="color_15"] .cd-h-timeline__line {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .cd-h-timeline__date:after {
  border-color: #f10b4d;
  background-color: #ed0b4c;
}

[data-primary="color_15"] .cd-h-timeline__navigation {
  border-color: #f10b4d;
}

[data-primary="color_15"] .cd-h-timeline__navigation--inactive:hover {
  border-color: #f10b4d;
}

[data-primary="color_15"] .dd-handle {
  background: #ed0b4c;
}

[data-primary="color_15"] .dd-handle:hover {
  background: #ed0b4c;
}

[data-primary="color_15"] .dd3-content:hover {
  background: #ed0b4c;
}

[data-primary="color_15"] .noUi-connect {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .noUi-connect.c-3-color {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .noUi-horizontal .noUi-handle,
[data-primary="color_15"] .noUi-vertical .noUi-handle {
  background-color: #ed0b4c;
}

[data-primary="color_15"] #slider-toggle.off .noUi-handle {
  border-color: #ed0b4c;
}

[data-primary="color_15"] .pignose-calendar {
  border-color: #ed0b4c;
}

[data-primary="color_15"] .pignose-calendar .pignose-calendar-top-date {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .bootstrap-tagsinput .tag {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .toast-success {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .accordion-header-bg .accordion__header--primary {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .alert-primary {
  background: #f97ea2;
  border-color: #f97ea2;
  color: #ed0b4c;
}

[data-primary="color_15"] .alert-alt.alert-primary {
  border-left: 4px solid #ed0b4c;
}

[data-primary="color_15"] .alert-alt.alert-primary.solid {
  border-left: 4px solid #730525 !important;
}

[data-primary="color_15"] .alert.alert-primary.solid {
  background: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .alert.alert-outline-primary {
  color: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .badge-outline-primary {
  border: 1px solid #ed0b4c;
  color: #ed0b4c;
}

[data-primary="color_15"] .badge-primary {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .page-titles h4 {
  color: #ed0b4c;
}

[data-primary="color_15"] .card-action>a {
  background: black;
}

[data-primary="color_15"] .card-action .dropdown {
  background: black;
  color: #ed0b4c;
}

[data-primary="color_15"] .card-action .dropdown:hover,
[data-primary="color_15"] .card-action .dropdown:focus {
  background: black;
}

[data-primary="color_15"] .card-loader i {
  background: #cb0941;
}

[data-primary="color_15"] .dropdown-outline {
  border: 0.1rem solid #ed0b4c;
}

[data-primary="color_15"] .custom-dropdown .dropdown-menu .dropdown-item:hover {
  color: #ed0b4c;
}

[data-primary="color_15"] .card-action .custom-dropdown {
  background: #fa97b3;
}

[data-primary="color_15"] .card-action .custom-dropdown.show,
[data-primary="color_15"] .card-action .custom-dropdown:focus,
[data-primary="color_15"] .card-action .custom-dropdown:hover {
  background: #ed0b4c;
}

[data-primary="color_15"] .label-primary {
  background: #ed0b4c;
}

[data-primary="color_15"] .pagination .page-item .page-link:hover {
  background: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .pagination .page-item.active .page-link {
  background-color: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,
[data-primary="color_15"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #ed0b4c;
}

[data-primary="color_15"] .progress-bar {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .progress-bar-primary {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .ribbon__four {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .ribbon__four:after,
[data-primary="color_15"] .ribbon__four:before {
  background-color: #f86690;
}

[data-primary="color_15"] .ribbon__five {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .ribbon__five::before {
  border-color: transparent transparent #ed0b4c transparent;
}

[data-primary="color_15"] .ribbon__six {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .multi-steps>li {
  color: #ed0b4c;
}

[data-primary="color_15"] .multi-steps>li:after {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .multi-steps>li.is-active:before {
  border-color: #ed0b4c;
}

[data-primary="color_15"] .timeline-badge.primary {
  background-color: #ed0b4c !important;
}

[data-primary="color_15"] .tooltip-wrapper button:hover {
  background: #ed0b4c;
}

[data-primary="color_15"] .chart_widget_tab_one .nav-link.active {
  background-color: #ed0b4c;
  border: 1px solid #ed0b4c;
}

[data-primary="color_15"] .chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #ed0b4c;
}

[data-primary="color_15"] .social-icon2 a {
  border: 0.1rem solid #ed0b4c;
}

[data-primary="color_15"] .social-icon2 i {
  color: #ed0b4c;
}

[data-primary="color_15"] .social-icon3 ul li a:hover i {
  color: #ed0b4c;
}

[data-primary="color_15"] .bgl-primary {
  background: #fa97b3;
  border-color: #fa97b3;
  color: #ed0b4c;
}

[data-primary="color_15"] .tdl-holder input[type=checkbox]:checked+i {
  background: #ed0b4c;
}

[data-primary="color_15"] .footer .copyright a {
  color: #ed0b4c;
}

[data-primary="color_15"] .hamburger .line {
  background: #ed0b4c;
}

[data-primary="color_15"] svg.pulse-svg .first-circle,
[data-primary="color_15"] svg.pulse-svg .second-circle,
[data-primary="color_15"] svg.pulse-svg .third-circle {
  fill: #ed0b4c;
}

[data-primary="color_15"] .pulse-css {
  background: #ed0b4c;
}

[data-primary="color_15"] .pulse-css:after,
[data-primary="color_15"] .pulse-css:before {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .notification_dropdown .dropdown-menu-right .notification_title {
  background: #ed0b4c;
}

[data-primary="color_15"] .header-right .header-profile .dropdown-menu a:hover,
[data-primary="color_15"] .header-right .header-profile .dropdown-menu a:focus,
[data-primary="color_15"] .header-right .header-profile .dropdown-menu a.active {
  color: #ed0b4c;
}

[data-primary="color_15"] .header-right .header-profile .profile_title {
  background: #ed0b4c;
}

[data-primary="color_15"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .nav-header .nav-control .hamburger .line {
  background-color: #ed0b4c !important;
}

[data-primary="color_15"] .deznav .metismenu>li>a svg {
  color: #ed0b4c;
}

[data-primary="color_15"] .deznav .metismenu>li:hover>a,
[data-primary="color_15"] .deznav .metismenu>li:focus>a {
  color: #ed0b4c;
}

[data-primary="color_15"] .deznav .metismenu>li.mm-active>a {
  color: #ed0b4c;
}

[data-primary="color_15"] .deznav .metismenu ul a:hover,
[data-primary="color_15"] .deznav .metismenu ul a:focus,
[data-primary="color_15"] .deznav .metismenu ul a.mm-active {
  color: #ed0b4c;
}

@media (min-width: 767px) {

  [data-primary="color_15"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:hover>a,
  [data-primary="color_15"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:focus>a,
  [data-primary="color_15"] [data-sidebar-style="modern"] .deznav .metismenu>li>a:active>a,
  [data-primary="color_15"] [data-sidebar-style="modern"] .deznav .metismenu>li>a.mm-active>a {
    background-color: #fff8fa;
  }
}

[data-primary="color_15"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active .line {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .nav-user {
  background: #ed0b4c;
}

[data-primary="color_15"] .sidebar-right .sidebar-right .sidebar-right-trigger {
  color: #ed0b4c;
}

[data-primary="color_15"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {
  color: #ed0b4c;
}

[data-primary="color_15"][data-theme-version="dark"] .pagination .page-item .page-link:hover {
  background: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"][data-theme-version="dark"] .pagination .page-item.active .page-link {
  background: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"][data-theme-version="dark"] .header-left input:focus {
  border-color: #ed0b4c;
}

[data-primary="color_15"][data-theme-version="dark"] .loader__bar {
  background: #ed0b4c;
}

[data-primary="color_15"][data-theme-version="dark"] .loader__ball {
  background: #ed0b4c;
}

[data-primary="color_15"][data-theme-version="transparent"] .header-left input:focus {
  border-color: #ed0b4c;
}

[data-primary="color_15"] .new-arrival-content .price {
  color: #ed0b4c;
}

[data-primary="color_15"] .chart-link a i.text-primary {
  color: #ed0b4c;
}

[data-primary="color_15"] #user-activity .nav-tabs .nav-link.active {
  background: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] span#counter {
  color: #ed0b4c;
}

[data-primary="color_15"] .welcome-content:after {
  background: #ed0b4c;
}

[data-primary="color_15"] .timeline-badge {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .page-timeline .timeline-workplan[data-primary="color_15"] .page-timeline .timeline .timeline-badge:after {
  background-color: rgba(237, 11, 76, 0.4);
}

[data-primary="color_15"] .sk-three-bounce .sk-child {
  background-color: #ed0b4c;
}

[data-primary="color_15"] .dropdown-item.active,
[data-primary="color_15"] .dropdown-item:active {
  color: #fff;
  background-color: #ed0b4c;
}

[data-primary="color_15"] .overlay-box:after {
  background: #ed0b4c;
}

[data-primary="color_15"] .btn-primary {
  background-color: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .bg-primary {
  background-color: #ed0b4c !important;
}

[data-primary="color_15"] .text-primary {
  color: #ed0b4c !important;
}

[data-primary="color_15"] .btn-primary:hover {
  background-color: #a40835;
  border-color: #a40835;
}

[data-primary="color_15"] .btn-outline-primary {
  color: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .btn-outline-primary:hover {
  background-color: #ed0b4c;
  border-color: #ed0b4c;
}

[data-primary="color_15"] .btn-primary:not(:disabled):not(.disabled):active,
[data-primary="color_15"] .btn-primary:not(:disabled):not(.disabled).active,
[data-primary="color_15"] .show>.btn-primary.dropdown-toggle,
[data-primary="color_15"] .btn-outline-primary:not(:disabled):not(.disabled):active,
[data-primary="color_15"] .btn-outline-primary:not(:disabled):not(.disabled).active,
[data-primary="color_15"] .show>.btn-outline-primary.dropdown-toggle {
  background-color: #a40835;
  border-color: #a40835;
}

.bg-primary-alt {
  background-color: rgba(135, 67, 223, 0.1);
}

.bg-secondary-alt {
  background-color: rgba(63, 154, 224, 0.1);
}

.bg-success-alt {
  background-color: rgba(43, 193, 85, 0.1);
}

.bg-info-alt {
  background-color: rgba(45, 40, 255, 0.1);
}

.bg-warning-alt {
  background-color: rgba(255, 155, 82, 0.1);
}

.bg-danger-alt {
  background-color: rgba(249, 70, 135, 0.1);
}

.bg-light-alt {
  background-color: rgba(244, 245, 249, 0.1);
}

.bg-dark-alt {
  background-color: rgba(177, 177, 177, 0.1);
}

[data-typography="opensans"] {
  font-family: 'Open Sans', sans-serif;
}

[data-typography="poppins"] {
  font-family: 'poppins', sans-serif;
}

[data-typography="roboto"] {
  font-family: 'Roboto', sans-serif;
}

[data-typography="helvetica"] {
  font-family: 'HelveticaNeue';
}

/*\$primary  : #7356f1 !default;*/
[data-theme-version="transparent"] {
  /* background: url("../images/body/12.jpg"); */
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  position: relative;
  color: #fff;
}

[data-theme-version="transparent"] h1,
[data-theme-version="transparent"] h2,
[data-theme-version="transparent"] h3,
[data-theme-version="transparent"] h4,
[data-theme-version="transparent"] h5,
[data-theme-version="transparent"] h6 {
  color: #fff !important;
}

[data-theme-version="transparent"] a.link {
  color: #ddd;
}

[data-theme-version="transparent"] a.link:focus,
[data-theme-version="transparent"] a.link:hover {
  color: #2D28FF;
}

[data-theme-version="transparent"] a {
  color: #fff;
}

[data-theme-version="transparent"] a:hover {
  color: #828690;
}

[data-theme-version="transparent"] .border-right {
  border-right: 1px solid #333a54 !important;
}

[data-theme-version="transparent"] .border-left {
  border-left: 1px solid #333a54 !important;
}

[data-theme-version="transparent"] .border-top {
  border-top: 1px solid #333a54 !important;
}

[data-theme-version="transparent"] .border-bottom {
  border-bottom: 1px solid #333a54 !important;
}

[data-theme-version="transparent"] .border {
  border: 1px solid #333a54 !important;
}

[data-theme-version="transparent"] .dropdown-menu {
  background-color: #1e2746;
}

[data-theme-version="transparent"] .dropdown-item:hover,
[data-theme-version="transparent"] .dropdown-item:focus {
  background-color: #181f39;
  color: #fff;
}

[data-theme-version="transparent"] .form-control {
  background-color: #181f39;
  border-color: #333a54;
  color: #fff;
}

[data-theme-version="transparent"] .card {
  background-color: rgba(0, 0, 0, 0.15);
}

[data-theme-version="transparent"] .header {
  background-color: rgba(0, 0, 0, 0.15);
}

[data-theme-version="transparent"] .header-left input {
  border-color: #333a54;
  color: #fff;
}

[data-theme-version="transparent"] .header-left input:focus {
  box-shadow: none;
  border-color: #00ADEE;
}

[data-theme-version="transparent"] .header-left input::placeholder {
  color: #fff;
}

[data-theme-version="transparent"] .header-right .dropdown .nav-link:hover {
  color: #fff;
}

[data-theme-version="transparent"] .header-right .notification_dropdown .dropdown-item a {
  color: #fff;
}

[data-theme-version="transparent"] .nav-header,
[data-theme-version="transparent"] .nav-control {
  background-color: rgba(0, 0, 0, 0.15) !important;
}

[data-theme-version="transparent"] .nav-control {
  color: #fff;
}

[data-theme-version="transparent"] .brand-logo {
  color: #fff;
}

[data-theme-version="transparent"] .brand-logo:hover {
  color: #fff;
}

[data-theme-version="transparent"] .nav-header,
[data-theme-version="transparent"] .nav-control {
  background-color: rgba(0, 0, 0, 0.15) !important;
}

[data-theme-version="transparent"] .nav-control {
  color: #fff;
}

[data-theme-version="transparent"] .brand-logo {
  color: #fff;
}

[data-theme-version="transparent"] .brand-logo:hover {
  color: #fff;
}

[data-theme-version="transparent"] .deznav {
  background-color: rgba(0, 0, 0, 0.15) !important;
}

[data-theme-version="transparent"] .deznav .metismenu>li>a {
  color: rgba(0, 0, 0, 0.15);
}

[data-theme-version="transparent"] .deznav .metismenu>li:hover>a,
[data-theme-version="transparent"] .deznav .metismenu>li:focus>a,
[data-theme-version="transparent"] .deznav .metismenu>li.mm-active>a {
  background-color: rgba(0, 0, 0, 0.15) !important;
  color: #fff;
}

[data-theme-version="transparent"] .deznav .metismenu>li:hover>a::after,
[data-theme-version="transparent"] .deznav .metismenu>li:focus>a::after,
[data-theme-version="transparent"] .deznav .metismenu>li.mm-active>a::after {
  border-color: transparent transparent #fff transparent;
}

[data-theme-version="transparent"] .deznav .metismenu>li.mm-active ul ul {
  background-color: transparent;
}

[data-theme-version="transparent"] .deznav .metismenu ul {
  background-color: rgba(0, 0, 0, 0.15);
}

[data-theme-version="transparent"] .deznav .metismenu ul a:hover,
[data-theme-version="transparent"] .deznav .metismenu ul a:focus,
[data-theme-version="transparent"] .deznav .metismenu ul a.mm-active {
  color: #fff;
}

[data-theme-version="transparent"] .deznav .metismenu a {
  color: rgba(0, 0, 0, 0.15);
}

[data-theme-version="transparent"] .deznav .metismenu ul {
  background-color: rgba(0, 0, 0, 0.15) !important;
}

[data-theme-version="transparent"] .deznav .metismenu .has-arrow:after {
  border-color: transparent transparent rgba(0, 0, 0, 0.15) transparent;
}

/*\$primary  : #7356f1 !default;*/
[data-theme-version="dark"] {
  background: #181f39;
  color: #828690;
}

[data-theme-version="dark"] h1,
[data-theme-version="dark"] h2,
[data-theme-version="dark"] h3,
[data-theme-version="dark"] h4,
[data-theme-version="dark"] h5,
[data-theme-version="dark"] h6 {
  color: #fff !important;
}

[data-theme-version="dark"] a.link {
  color: #ddd;
}

[data-theme-version="dark"] a.link:focus,
[data-theme-version="dark"] a.link:hover {
  color: #2D28FF;
}

[data-theme-version="dark"] a:hover {
  color: #fff;
}

[data-theme-version="dark"] .border-right {
  border-right: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border-left {
  border-left: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border-top {
  border-top: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border-bottom {
  border-bottom: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border {
  border: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .dropdown-menu {
  background-color: #181f39;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
}

[data-theme-version="dark"] .dropdown-menu .dropdown-item.selected,
[data-theme-version="dark"] .dropdown-menu .dropdown-item.selected.active,
[data-theme-version="dark"] .dropdown-menu .dropdown-item.active,
[data-theme-version="dark"] .dropdown-menu .dropdown-item:hover,
[data-theme-version="dark"] .dropdown-menu .dropdown-item:focus {
  background-color: #1e2746;
  color: #7e7e7e;
}

[data-theme-version="dark"] .form-control {
  background-color: #181f39;
  border-color: #333a54;
  color: #fff;
}

[data-theme-version="dark"] .card {
  background-color: #1e2746;
  box-shadow: none;
}

[data-theme-version="dark"] .btn-outline-dark:hover {
  background-color: #181f39;
  border-color: #181f39;
}

[data-theme-version="dark"] .tdl-holder input[type=text],
[data-theme-version="dark"] .tdl-holder li {
  background-color: #1e2746;
  border-color: #333a54;
}

[data-theme-version="dark"] .tdl-holder input[type=text]::placeholder {
  color: #828690;
}

[data-theme-version="dark"] .tdl-holder label:hover {
  background-color: #333a54;
  color: #fff;
}

[data-theme-version="dark"] .text-muted {
  color: #828690 !important;
}

[data-theme-version="dark"] .modal-content {
  background: #1e2746;
}

[data-theme-version="dark"] .modal-footer,
[data-theme-version="dark"] .modal-header {
  border-color: #333a54;
}

[data-theme-version="dark"] .close {
  font-weight: 400;
  color: #fff;
  text-shadow: none;
}

[data-theme-version="dark"] .close:hover {
  color: #fff;
}

[data-theme-version="dark"] .table strong {
  color: #fff;
}

[data-theme-version="dark"] .text-dark {
  color: #828690 !important;
}

[data-theme-version="dark"] .star-rating .product-review,
[data-theme-version="dark"] .new-arrival-content .item {
  color: #fff;
}

[data-theme-version="dark"] .custom-dropdown .dropdown-menu {
  border-color: #333a54;
}

[data-theme-version="dark"] .widget-stat .media>span {
  background: #333a54;
  border-color: #333a54;
  color: #fff;
}

[data-theme-version="dark"] .plus-minus-input .custom-btn {
  background: #181f39;
  border-color: #333a54;
}

[data-theme-version="dark"] .dropdown-divider,
[data-theme-version="dark"] .size-filter ul li {
  border-color: #333a54;
}

[data-theme-version="dark"] .custom-select {
  border-color: #333a54;
  color: #828690;
  background: #181f39;
}

[data-theme-version="dark"] .nav-tabs {
  border-color: #333a54;
}

[data-theme-version="dark"] .mail-list .list-group-item.active i {
  color: #fff;
}

[data-theme-version="dark"] hr {
  border-color: #333a54;
}

[data-theme-version="dark"] .grid-col {
  background: #181f39;
}

[data-theme-version="dark"] .noUi-target {
  border-color: #333a54;
  border-radius: 8px;
  box-shadow: none;
}

[data-theme-version="dark"] .noUi-target .noUi-connects {
  background: #333a54;
}

[data-theme-version="dark"] .noUi-marker-large,
[data-theme-version="dark"] .noUi-marker {
  background: #333a54;
}

[data-theme-version="dark"] .input-group-text {
  background: #333a54;
  color: #7e7e7e;
}

[data-theme-version="dark"] .note-editor.note-frame {
  border-color: #333a54;
}

[data-theme-version="dark"] .note-editor.note-frame .btn {
  color: #fff;
}

[data-theme-version="dark"] .note-editor.note-frame .note-editing-area .note-editable {
  color: #fff;
}

[data-theme-version="dark"] .widget-media .timeline .timeline-panel {
  border-color: #333a54;
}

[data-theme-version="dark"] .notification_dropdown .dropdown-menu-right .all-notification {
  border-color: #333a54;
}

[data-theme-version="dark"] #user-activity .nav-tabs .nav-link {
  border-color: #333a54;
}

[data-theme-version="dark"] .list-group-item-action {
  color: #7e7e7e;
}

[data-theme-version="dark"] .list-group-item-action:focus,
[data-theme-version="dark"] .list-group-item-action:hover,
[data-theme-version="dark"] .list-group-item-action:focus {
  background-color: #181f39;
  border-color: #181f39;
}

[data-theme-version="dark"] .list-group-item.active {
  color: #fff;
  border-color: #00ADEE;
}

[data-theme-version="dark"] .list-group-item.active:focus,
[data-theme-version="dark"] .list-group-item.active:hover,
[data-theme-version="dark"] .list-group-item.active:focus {
  background-color: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
}

[data-theme-version="dark"] .swal2-popup {
  background: #1e2746;
}

[data-theme-version="dark"] .header {
  background-color: #1e2746;
}

[data-theme-version="dark"] .header-left input {
  background: #181f39 !important;
  border-color: transparent;
  color: #fff !important;
}

[data-theme-version="dark"] .header-left input:focus {
  box-shadow: none;
  border-color: #00ADEE;
}

[data-theme-version="dark"] .header-left input::placeholder {
  color: #fff;
}

[data-theme-version="dark"] .header-left .search_icon {
  background: #181f39 !important;
}

[data-theme-version="dark"] .header-left .search_icon i {
  color: #fff;
}

[data-theme-version="dark"] .header-right .right-sidebar a {
  color: #00ADEE;
  border-color: #333a54;
}

[data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-theme-version="dark"] .header-right .notification_dropdown .nav-link {
  background: #181f39;
}

[data-theme-version="dark"] .header-right .dropdown .nav-link {
  color: #fff;
}

[data-theme-version="dark"] .header-right .dropdown .nav-link:hover {
  color: #fff;
}

[data-theme-version="dark"] .header-right .notification_dropdown .dropdown-item a {
  color: #fff;
}

[data-theme-version="dark"] .nav-header,
[data-theme-version="dark"] .nav-control {
  background-color: #181f39;
}

[data-theme-version="dark"] .nav-control {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo:hover {
  color: #fff;
}

[data-theme-version="dark"] .nav-header,
[data-theme-version="dark"] .nav-control {
  background-color: #181f39;
}

[data-theme-version="dark"] .nav-control {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo:hover {
  color: #fff;
}

[data-theme-version="dark"][data-sidebar-style="mini"] .deznav .metismenu li>ul {
  background-color: #1e2746;
}

[data-theme-version="dark"] .fixed-content-box {
  background-color: #1e2746;
}

[data-theme-version="dark"] .fixed-content-box .head-name {
  background: #1e2746;
  color: #fff;
  border-color: #333a54;
}

[data-theme-version="dark"] .fixed-content-box+.header+.deznav {
  background-color: #181f39;
}

[data-theme-version="dark"] .deznav {
  background-color: #1e2746;
}

[data-theme-version="dark"] .deznav .metismenu>li>a {
  color: #b3b3b3;
}

[data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-theme-version="dark"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu>li:hover>a::after,
[data-theme-version="dark"] .deznav .metismenu>li:focus>a::after,
[data-theme-version="dark"] .deznav .metismenu>li.mm-active>a::after {
  border-color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu>li.mm-active ul ul {
  background-color: transparent;
}

[data-theme-version="dark"] .deznav .metismenu ul:after {
  background-color: #333a54;
}

[data-theme-version="dark"] .deznav .metismenu ul a:hover,
[data-theme-version="dark"] .deznav .metismenu ul a:focus,
[data-theme-version="dark"] .deznav .metismenu ul a.mm-active {
  color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu ul a:before {
  background-color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu a {
  color: #b3b3b3;
}

[data-theme-version="dark"] .deznav .metismenu .has-arrow:after {
  border-color: #fff;
}

[data-theme-version="dark"] .sidebar-right {
  background-color: #1d2544;
}

[data-theme-version="dark"] .sidebar-right .nav-tabs {
  background-color: #1d2544;
  border-bottom: 1px solid #181f39;
}

[data-theme-version="dark"] .sidebar-right .nav-tabs .nav-link.active {
  background-color: #181f39;
}

[data-theme-version="dark"] .footer {
  background-color: transparent;
}

[data-theme-version="dark"] .footer .copyright {
  background-color: transparent;
}

[data-theme-version="dark"] .footer .copyright p {
  color: #fff;
}

/* =============
   Calendar
============= */
.app-fullcalender button {
  border-radius: 0px;
  color: #B1B1B1;
}

.app-fullcalender td {
  border-color: #f0f1f5;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-view {
  margin-top: 1.875rem;
}

.fc-toolbar {
  margin-bottom: 0.3125rem;
  margin-top: 0.9375rem;
}

@media (max-width: 575.98px) {
  .fc-toolbar .fc-left {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.625rem;
    float: none;
  }
}

@media (max-width: 575.98px) {
  .fc-toolbar .fc-right {
    display: flex;
    justify-content: center;
    float: none;
    margin-bottom: 0.3125rem;
  }
}

@media (max-width: 575.98px) {
  .fc-toolbar .fc-center {
    display: flex;
    justify-content: center;
  }

  .fc-toolbar .fc-center * {
    float: none;
  }
}

.fc-toolbar h2 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.875rem;
  text-transform: uppercase;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar .ui-state-hover,
.fc-toolbar button:focus,
.fc-toolbar button:hover {
  z-index: 0;
  box-shadow: none;
}

.fc-widget-header {
  border: 1px solid #f0f1f5;
  border-bottom: 0 !important;
}

.fc th.fc-widget-header {
  background: #f0f1f5 !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.625rem 0;
  text-transform: uppercase;
}

.fc-button {
  border: 1px solid #f0f1f5;
  text-transform: capitalize;
}

.fc-button.active {
  box-shadow: none !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 1rem;
}

.fc-event {
  border-radius: 0.125rem;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 0.3125rem 0.4375rem;
  padding: 0.3125rem;
  text-align: center;
}

.external-event {
  cursor: move;
  margin: 0.625rem 0;
  padding: 0.125rem 0;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 0.3125rem;
}

.fc-basic-view td.fc-day-number {
  padding-right: 0.3125rem;
}

#drop-remove {
  margin-right: 8px;
  top: 0.1875rem;
}

#add-category .modal-dialog,
#event-modal .modal-dialog {
  max-width: 37.5rem;
}

.fc-content {
  color: #fff;
}

.fc th.fc-widget-header {
  background: transparent !important;
}

.fc-button {
  background: #fff;
}

.fc-state-hover {
  background: #fff !important;
}

.fc-state-highlight {
  background: #f2f4fa !important;
}

[data-theme-version="dark"] .fc-state-highlight {
  color: #fff !important;
}

.fc-cell-overlay {
  background: #fff !important;
}

.fc-unthemed .fc-today {
  background: #f2f4fa !important;
}

.fc-day-top {
  color: #B1B1B1 !important;
}

[data-theme-version="dark"] .fc-day-top {
  color: #fff !important;
}

.external-event {
  color: #fff;
}

[data-theme-version="dark"] .external-event {
  color: #fff !important;
}

.fc-basic-view .fc-body .fc-row {
  min-height: 1rem;
}

.fc-scroller.fc-day-grid-container {
  height: 490px !important;
}

.fc-row.fc-week.fc-widget-content.fc-rigid {
  height: 81px !important;
}

@media only screen and (max-width: 1440px) {
  .email_left_pane {
    display: none;
  }
}

#external-events .external-event:before {
  content: "";
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: .9rem;
  position: relative;
  top: 2px;
}

#external-events [data-class="bg-primary"] {
  background-color: transparent !important;
  color: #B1B1B1;
}

[data-theme-version="dark"] #external-events [data-class="bg-primary"] {
  color: #fff !important;
}

#external-events [data-class="bg-primary"]::before {
  background: #00ADEE;
}

#external-events [data-class="bg-success"] {
  background-color: transparent !important;
  color: #B1B1B1;
}

#external-events [data-class="bg-success"]::before {
  background: #2BC155;
}

#external-events [data-class="bg-warning"] {
  background-color: transparent !important;
  color: #B1B1B1;
}

#external-events [data-class="bg-warning"]::before {
  background: #FF9B52;
}

#external-events [data-class="bg-dark"] {
  background-color: transparent !important;
  color: #B1B1B1;
}

#external-events [data-class="bg-dark"]::before {
  background: #B1B1B1;
}

#external-events [data-class="bg-danger"] {
  background-color: transparent !important;
  color: #B1B1B1;
}

#external-events [data-class="bg-danger"]::before {
  background: #F94687;
}

#external-events [data-class="bg-info"] {
  background-color: transparent !important;
  color: #B1B1B1;
}

#external-events [data-class="bg-info"]::before {
  background: #2D28FF;
}

#external-events [data-class="bg-pink"] {
  background-color: transparent !important;
  color: #B1B1B1;
}

#external-events [data-class="bg-pink"]::before {
  background: #e83e8c;
}

.fc .fc-row .fc-content-skeleton table,
.fc .fc-row .fc-content-skeleton td,
.fc .fc-row .fc-helper-skeleton td {
  border-color: #f0f1f5;
}

[data-theme-version="dark"] .fc .fc-row .fc-content-skeleton table,
[data-theme-version="dark"] .fc .fc-row .fc-content-skeleton td,
[data-theme-version="dark"] .fc .fc-row .fc-helper-skeleton td {
  border-color: #333a54;
}

[data-theme-version="dark"] .fc-unthemed .fc-content,
[data-theme-version="dark"] .fc-unthemed .fc-divider,
[data-theme-version="dark"] .fc-unthemed .fc-list-heading td,
[data-theme-version="dark"] .fc-unthemed .fc-list-view,
[data-theme-version="dark"] .fc-unthemed .fc-popover,
[data-theme-version="dark"] .fc-unthemed .fc-row,
[data-theme-version="dark"] .fc-unthemed tbody,
[data-theme-version="dark"] .fc-unthemed td,
[data-theme-version="dark"] .fc-unthemed th,
[data-theme-version="dark"] .fc-unthemed thead {
  border-color: #333a54;
}

.email-left-box {
  width: 15rem;
  float: left;
  padding: 0 1.25rem 1.25rem 1rem;
  border-top: 0;
  border-left: 0;
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .email-left-box {
    width: 100%;
    padding-bottom: 0px !important;
  }
}

@media (max-width: 575.98px) {
  .email-left-box {
    width: 100%;
    float: none;
    border: none;
    padding-bottom: 30px !important;
  }
}

.email-left-box .intro-title {
  background: rgba(135, 67, 223, 0.1);
  padding: 1rem;
  margin: 1.875rem 0 1.25rem 0;
}

.email-left-box .intro-title h5 {
  margin-bottom: 0;
  color: #6a707e;
  font-size: 14px;
}

.email-left-box .intro-title h5 i {
  font-size: 0.75rem;
  position: relative;
  bottom: 1px;
}

.email-left-box .intro-title i {
  color: #00ADEE;
}

.email-right-box {
  padding-left: 15rem;
  padding-right: 1rem;
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .email-right-box {
    padding-left: 0;
    margin-left: 0 !important;
    clear: both;
  }
}

@media (max-width: 575.98px) {
  .email-right-box {
    padding-left: 0;
    padding-right: 0;
  }
}

.email-right-box .right-box-border {
  border-right: 2px solid rgba(135, 67, 223, 0.1);
}

@media screen and (min-width: 649px) and (max-width: 1200px) {
  .email-right-box .right-box-padding {
    padding-left: 1.25rem;
  }
}

@media (min-width: 1700px) {
  .email-right-box .right-box-padding {
    padding-left: 0.9375rem;
  }
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .email-right-box .right-box-padding {
    padding-left: 0;
  }
}

.toolbar .btn-group .btn {
  border: 0;
}

.toolbar .btn-group input {
  position: relative;
  top: 2px;
}

.read-content textarea {
  height: 150px;
  padding: 15px 20px;
}

.read-content-email {
  font-size: 0.875rem;
}

.read-content h5 {
  color: #6a707e;
}

.read-content p strong {
  color: #6a707e;
}

.read-content-body p {
  margin-bottom: 1.875rem;
}

.read-content-attachment {
  padding: 0.5rem 0;
}

.read-content-attachment h6 {
  font-size: 1.125rem;
  color: #6a707e;
}

.read-content-attachment h6 i {
  padding-right: 0.3125rem;
}

.read-content-attachment .attachment>div:not(:last-child) {
  border-right: 1px solid #DDDFE1;
}

.compose-content .wysihtml5-toolbar {
  border-color: #eaeaea;
}

.compose-content .dropzone {
  background: #f2f4fa !important;
}

.compose-content h5 {
  font-size: 1.0625rem;
  color: #6a707e;
}

.compose-content h5 i {
  font-size: 1.125rem;
  transform: rotate(90deg);
}

.compose-content .dropzone {
  border: 1px dashed #DDDFE1;
  min-height: 13.125rem;
  position: relative;
}

.compose-content .dropzone .dz-message {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.email-list {
  display: block;
  padding-left: 0;
}

.email-list .message {
  position: relative;
  display: block;
  height: 3.125rem;
  line-height: 3.125rem;
  cursor: default;
  transition-duration: 0.3s;
}

.email-list .message a {
  color: #828690;
}

.email-list .message-single .custom-checkbox {
  margin-top: 2px;
}

.email-list .message-single i {
  color: #89879f;
  font-size: 1.125rem;
  padding-left: .4rem;
}

.email-list .message:hover {
  transition-duration: 0.05s;
  background: rgba(152, 166, 173, 0.15);
}

.email-list .message .col-mail {
  float: left;
  position: relative;
}

.email-list .message .col-mail-1 {
  width: 5.625rem;
}

.email-list .message .col-mail-1 .star-toggle {
  display: block;
  float: left;
  margin-top: 1.125rem;
  font-size: 1rem;
  margin-left: 0.3125rem;
}

.email-list .message .col-mail-1 .email-checkbox {
  display: block;
  float: left;
  margin: 0.9375rem 0.625rem 0 1.25rem;
}

.email-list .message .col-mail-1 .dot {
  display: block;
  float: left;
  border: .4rem solid transparent;
  border-radius: 6.25rem;
  margin: 1.375rem 1.625rem 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}

.email-list .message .col-mail-2 {
  position: absolute;
  top: 0;
  left: 5.625rem;
  right: 0;
  bottom: 0;
}

.email-list .message .col-mail-2 .subject {
  position: absolute;
  top: 0;
  left: 0;
  right: 5.5rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.email-list .message .col-mail-2 .date {
  position: absolute;
  top: 0;
  right: 0;
}

.email-checkbox {
  cursor: pointer;
  height: 0.9375rem;
  width: 0.9375rem;
  position: relative;
  display: inline-block;
  border-radius: .1rem;
  position: relative;
  top: 0.3125rem;
  box-shadow: inset 0 0 0 0.1rem #828690;
}

.email-checkbox input {
  opacity: 0;
  cursor: pointer;
}

.email-checkbox input:checked label {
  opacity: 1;
}

.email-checkbox label {
  position: absolute;
  top: .3rem;
  left: .3rem;
  right: .3rem;
  bottom: .3rem;
  cursor: pointer;
  opacity: 0;
  margin-bottom: 0 !important;
  transition-duration: 0.05s;
}

.mail-list a {
  vertical-align: middle;
  padding: 0.625rem 0.9375rem;
  display: block;
  background: transparent;
  color: #464a53;
  font-weight: 600;
}

.mail-list .list-group-item {
  color: #6a707e;
  padding: 0.75rem 1.0625rem;
}

.mail-list .list-group-item i {
  font-size: 1rem;
  padding-right: 0.625rem;
  color: #cccccc;
}

.mail-list .list-group-item.active {
  color: #fff;
}

.mail-list .list-group-item.active i {
  color: #fff;
}

.chat-wrap {
  padding: 1.0625rem 1.875rem;
}

.chat-wrap .media .media-body h6 {
  font-size: 1.0625rem;
  color: #6a707e;
}

.chat-wrap .media .media-body p {
  font-size: 0.875rem;
}

@media (min-width: 648px) {
  .email-filter {
    padding-left: 1.25rem;
  }
}

@media (min-width: 1700px) {
  .email-filter {
    padding-left: 1.875rem;
  }
}

.email-filter .input-group-prepend i {
  font-size: 0.875rem;
  color: #89879f;
}

.email-filter .input-group-prepend .input-group-text {
  border: 0;
  border-bottom: 1px solid #DDDFE1 !important;
  background: transparent;
}

.email-filter .input-group .form-control {
  padding: 0 0 0 0.3125rem;
  border: 0;
  font-size: 0.875rem;
  height: 1.875rem;
  color: #89879f;
  border-bottom: 1px solid #DDDFE1;
}

.email-filter .input-group .form-control::placeholder {
  font-size: 0.875rem;
  color: #89879f;
}

.email-filter .input-group>.form-control {
  min-height: 1.875rem;
}

.single-mail {
  display: block;
  padding: 1.5625rem 0;
}

.single-mail .media {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

@media (min-width: 1700px) {
  .single-mail .media {
    padding-left: 1.875rem;
    padding-right: 1.875rem;
  }
}

.single-mail .media img {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  margin-right: 0.9375rem;
}

@media (min-width: 1700px) {
  .single-mail .media img {
    margin-right: 1.875rem;
  }
}

.single-mail .media-body h6 {
  color: #abafb3;
}

.single-mail .media-body h4 {
  font-size: 1rem;
  color: #6a707e;
}

.single-mail .media-body h4 button i {
  font-size: 1.125rem;
  color: #abafb3;
  font-weight: bold;
  transform: rotate(90deg);
}

.single-mail .media-body p {
  font-size: 0.875rem;
  color: #abafb3;
}

.single-mail.active {
  background: #00ADEE;
}

.single-mail.active h6,
.single-mail.active h4,
.single-mail.active p,
.single-mail.active i {
  color: #fff !important;
}

[direction="rtl"] .email-right-box {
  padding-left: 1rem;
  padding-right: 15rem;
}

@media only screen and (max-width: 991px) {
  [direction="rtl"] .email-right-box {
    padding-left: 1rem;
    padding-right: 12rem;
  }
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .email-right-box {
    padding-left: 0;
    padding-right: 0;
  }
}

[direction="rtl"] .email-left-box {
  float: right;
}

[direction="rtl"] .email-list .message .col-mail-2 {
  right: 5.625rem;
  left: 0;
  float: right;
}

[direction="rtl"] .email-list .message .col-mail-2 .date {
  right: auto;
  left: 0;
}

[direction="rtl"] .email-list .message .col-mail-2 .subject {
  right: 0;
  left: 5.5rem;
}

.photo-content {
  position: relative;
}

.photo-content .cover-photo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: cover;
  background-position: center;
  min-height: 250px;
  width: 100%;
}

.profile .profile-photo {
  max-width: 100px;
  position: relative;
  z-index: 1;
  margin-top: -40px;
  margin-right: 10px;
}

@media only screen and (max-width: 575px) {
  .profile .profile-photo {
    width: 80px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }
}

[direction="rtl"] .profile .photo-content .profile-photo {
  left: auto;
  right: 50px;
}

[direction="rtl"] .profile .profile-photo {
  left: auto;
  right: 30px;
}

@media only screen and (max-width: 1199px) {
  [direction="rtl"] .profile .profile-photo {
    right: 15px;
  }
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .profile .profile-photo {
    width: 80px;
    right: calc(50% - 40px);
    top: -100px;
  }
}

.profile-info {
  padding: 15px 20px;
}

@media only screen and (max-width: 575px) {
  .profile-info {
    padding: 0 0 20px;
    text-align: center;
  }
}

.profile-info h4 {
  color: #464a53 !important;
}

.profile-info h4.text-primary {
  color: #00ADEE !important;
}

.profile-info p {
  color: #828690;
}

.profile-info .prf-col {
  min-width: 250px;
  padding: 10px 50px 0;
}

.profile-interest .row {
  margin: 0 -.70px;
}

.profile-interest .row .int-col {
  padding: 0 .70px;
}

.profile-interest .row .int-col .interest-cat {
  margin-bottom: 1.40px;
  position: relative;
  display: block;
}

.profile-interest .row .int-col .interest-cat:after {
  background: #000;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
}

.profile-interest .row .int-col .interest-cat p {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 5px;
  left: 0;
  margin: 0;
  z-index: 1;
  color: white;
  font-size: 1.20px;
}

.profile-tab .nav-item .nav-link {
  font-size: 16px;
  margin-right: 30px;
  transition: all 0.5s ease-in-out;
  border: none;
  border-bottom: .20px solid transparent;
  color: #828690;
}

.profile-tab .nav-item .nav-link:hover,
.profile-tab .nav-item .nav-link.active {
  border: 0;
  background: transparent;
  background: transparent;
  border-bottom: 0.2px solid #00ADEE;
  color: #00ADEE;
}

@media only screen and (max-width: 575px) {
  .profile-tab .nav-item .nav-link {
    margin-right: 0px;
  }
}

.profile-info {
  display: flex;
}

@media only screen and (max-width: 575px) {
  .profile-info {
    display: block;
  }
}

.profile-info .profile-details {
  display: flex;
  width: 100%;
}

@media only screen and (max-width: 575px) {
  .profile-info .profile-details {
    display: block;
  }

  .profile-info .profile-details .dropdown {
    position: absolute;
    top: 30px;
    right: 30px;
  }
}

.post-input {
  margin-bottom: 30px;
}

.post-input .form-control {
  height: 75px;
  font-weight: 400;
  margin: 15px 0;
}

.profile-uoloaded-post .post-title h3 {
  font-size: 24px;
}

@media only screen and (max-width: 575px) {
  .profile-uoloaded-post .post-title h3 {
    font-size: 18px;
  }
}

.profile-uoloaded-post img {
  margin-bottom: 20px;
}

.profile-uoloaded-post a h4 {
  margin-bottom: 10px;
  color: #464a53;
}

.event-chat-ryt .chat-area .chat-reciver,
.event-chat-ryt .chat-area .chat-sender {
  margin-bottom: 1.875rem;
  padding: 0;
}

.event-chat-ryt .chat-area .chat-reciver img,
.event-chat-ryt .chat-area .chat-sender img {
  border-radius: 30px;
}

.event-chat-ryt .chat-area .media {
  position: relative;
}

.event-chat-ryt .chat-area .media-body p {
  margin: 0;
  max-width: 100%;
  display: inline-block;
  position: relative;
}

.event-chat-ryt .chat-area .media-body p span {
  padding: 1rem;
  display: inline-block;
  top: 103%;
  position: relative;
  border: 1px solid #f0f1f5;
}

.event-chat-ryt .chat-reciver {
  padding: .5rem 1rem;
  display: flex;
  justify-content: flex-end;
}

.event-chat-ryt .chat-reciver .media {
  flex: 1 1;
}

.event-chat-ryt .chat-reciver .media .media-body {
  margin-right: 2rem;
  text-align: right;
}

[direction="rtl"] .event-chat-ryt .chat-reciver .media .media-body {
  text-align: left;
  margin-left: 2rem;
  margin-right: auto;
}

.event-chat-ryt .chat-reciver .media .media-body p {
  background: #fff;
  margin-bottom: 0;
  border-radius: 5px 5px 0 5px;
}

.event-chat-ryt .chat-reciver .media .media-body p span {
  text-align: left;
  border: 1px solid #f0f1f5;
}

.event-chat-ryt .chat-reciver .media .media-body p span::after {
  content: "";
  width: 20px;
  height: 20px;
  border-bottom: 1px solid #f0f1f5;
  border-right: 1px solid #f0f1f5;
  position: absolute;
  right: 0;
  bottom: 0;
  background: #fff;
  transform: rotate(-45deg) translateX(15px);
}

[direction="rtl"] .event-chat-ryt .chat-reciver .media .media-body p span::after {
  left: 0;
  right: auto;
  transform: rotate(135deg) translateY(15px);
}

.event-chat-ryt .chat-reciver .media .media-body p .time {
  position: absolute;
  font-size: 12px;
  color: #7e7e7e;
  font-weight: 400;
  bottom: 0;
  left: -80px;
}

[direction="rtl"] .event-chat-ryt .chat-reciver .media .media-body p .time {
  right: -5rem;
  left: auto;
}

.event-chat-ryt .chat-sender {
  text-align: left;
  padding: .5rem 1rem;
}

.event-chat-ryt .chat-sender .media .media-body {
  margin-left: 2rem;
}

[direction="rtl"] .event-chat-ryt .chat-sender .media .media-body {
  text-align: right;
  margin-right: 2rem;
  margin-left: auto;
}

.event-chat-ryt .chat-sender .media .media-body p {
  background-color: #fff;
  margin-bottom: 0;
}

.event-chat-ryt .chat-sender .media .media-body p span::after {
  content: "";
  width: 20px;
  height: 20px;
  border-bottom: 1px solid #f0f1f5;
  border-left: 1px solid #f0f1f5;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #fff;
  transform: rotate(45deg) translateX(-15px);
}

[direction="rtl"] .event-chat-ryt .chat-sender .media .media-body p span::after {
  left: auto;
  right: 0;
  transform: rotate(-135deg) translateY(15px);
}

.event-chat-ryt .chat-sender .media .media-body p .time {
  position: absolute;
  font-size: 10px;
  color: #7e7e7e;
  font-weight: 400;
  bottom: 0;
  right: -5rem;
}

[direction="rtl"] .event-chat-ryt .chat-sender .media .media-body p .time {
  left: -5rem;
  right: auto;
}

.char-type {
  padding-top: 30px;
  padding-bottom: 30px;
}

.char-type form .form-control {
  height: 45px;
  padding-left: 18px;
  background: #E5E6E7;
  border-right: 0;
}

.char-type form .input-group-append i {
  color: #898989;
  font-size: 18px;
}

.char-type form .input-group-append .input-group-text {
  padding-left: .7rem;
  padding-right: .7rem;
  background: #E5E6E7;
  border-color: #f0f1f5;
  border-left: 0;
}

.char-type form .input-group-append .input-group-text:last-child {
  padding-right: 1.8rem;
}

.media-avatar {
  padding: 25px 0;
  border-bottom: 1px solid #f0f1f5;
}

.media-avatar:last-child {
  border-bottom: 0px;
}

.media-avatar p {
  margin-bottom: 0;
}

.media-avatar .avatar-status {
  position: relative;
}

.media-avatar .avatar-status i {
  position: absolute;
  right: 0;
  bottom: 0;
}

.ct-golden-section:before {
  float: none;
}

.ct-chart {
  max-height: 15.7rem;
}

.ct-chart .ct-label {
  fill: #a3afb7;
  color: #a3afb7;
  font-size: 0.75rem;
  line-height: 1;
}

.ct-grid {
  stroke: rgba(49, 58, 70, 0.1);
}

.ct-chart.simple-pie-chart-chartist .ct-label {
  color: #ffffff;
  fill: #ffffff;
  font-size: 0.625rem;
}

.ct-chart .ct-series.ct-series-a .ct-bar,
.ct-chart .ct-series.ct-series-a .ct-line,
.ct-chart .ct-series.ct-series-a .ct-point,
.ct-chart .ct-series.ct-series-a .ct-slice-donut {
  stroke: #00ADEE;
}

.ct-chart .ct-series.ct-series-b .ct-bar,
.ct-chart .ct-series.ct-series-b .ct-line,
.ct-chart .ct-series.ct-series-b .ct-point,
.ct-chart .ct-series.ct-series-b .ct-slice-donut {
  stroke: #2BC155;
}

.ct-chart .ct-series.ct-series-c .ct-bar,
.ct-chart .ct-series.ct-series-c .ct-line,
.ct-chart .ct-series.ct-series-c .ct-point,
.ct-chart .ct-series.ct-series-c .ct-slice-donut {
  stroke: #FF9B52;
}

.ct-chart .ct-series.ct-series-d .ct-bar,
.ct-chart .ct-series.ct-series-d .ct-line,
.ct-chart .ct-series.ct-series-d .ct-point,
.ct-chart .ct-series.ct-series-d .ct-slice-donut {
  stroke: #F94687;
}

.ct-chart .ct-series.ct-series-e .ct-bar,
.ct-chart .ct-series.ct-series-e .ct-line,
.ct-chart .ct-series.ct-series-e .ct-point,
.ct-chart .ct-series.ct-series-e .ct-slice-donut {
  stroke: #2D28FF;
}

.ct-chart .ct-series.ct-series-f .ct-bar,
.ct-chart .ct-series.ct-series-f .ct-line,
.ct-chart .ct-series.ct-series-f .ct-point,
.ct-chart .ct-series.ct-series-f .ct-slice-donut {
  stroke: #B1B1B1;
}

.ct-chart .ct-series.ct-series-g .ct-bar,
.ct-chart .ct-series.ct-series-g .ct-line,
.ct-chart .ct-series.ct-series-g .ct-point,
.ct-chart .ct-series.ct-series-g .ct-slice-donut {
  stroke: #8d6e63;
}

.ct-series-a .ct-area,
.ct-series-a .ct-slice-pie {
  fill: #3F9AE0;
}

.ct-series-b .ct-area,
.ct-series-b .ct-slice-pie {
  fill: #00A2FF;
}

.ct-series-c .ct-area,
.ct-series-c .ct-slice-pie {
  fill: #ff9800;
}

.ct-series-d .ct-area,
.ct-series-d .ct-slice-pie {
  fill: #ff9800;
}

.chartist-tooltip {
  position: absolute;
  display: inline-block;
  opacity: 0;
  min-width: 0.625rem;
  padding: 2px 0.625rem;
  border-radius: 3px;
  background: #313a46;
  color: #ffffff;
  text-align: center;
  pointer-events: none;
  z-index: 1;
  transition: opacity .2s linear;
}

.chartist-tooltip.tooltip-show {
  opacity: 1;
}

#donught_graph .ct-series.ct-series-a .ct-slice-donut {
  stroke: #3FC6D4;
}

#donught_graph .ct-series.ct-series-b .ct-slice-donut {
  stroke: #333333;
}

#donught_graph .ct-series.ct-series-c .ct-slice-donut {
  stroke: #F63465;
}

@media only screen and (max-width: 767px) {
  #pie-chart .ct-label {
    color: #fff;
    fill: #fff;
  }
}

#visitor_graph {
  height: 253px !important;
}

#user_rating_graph {
  height: 280px !important;
}

#visitorOnline {
  height: 72px !important;
}

#trendMeter {
  height: 72px !important;
}

#widget-revenue1,
#widget-revenue2,
#widget-revenue3 {
  height: 117px !important;
}

#widget-profit1,
#widget-profit2,
#widget-profit3 {
  height: 160px !important;
}

#comparison-rate {
  height: 230px !important;
}

#session_day {
  height: 175px !important;
  width: auto !important;
  margin: 0 auto;
}

#walet-status {
  height: 140px !important;
}

#bar1 {
  height: 150px !important;
}

#sold-product {
  height: 230px !important;
}

#chart-venue-expenses,
#chart-online-sale,
#chart-gross-sale {
  height: 150px !important;
}

#areaChart_3 {
  height: 295px !important;
}

.chart-point {
  display: flex;
  align-items: center;
}

.chart-point .check-point-area {
  width: 100px;
  height: 100px;
  margin-top: -10px;
  margin-left: -10px;
}

.chart-point .chart-point-list {
  margin: 0;
  padding-left: 5px;
}

.chart-point .chart-point-list li {
  list-style: none;
  font-size: 13px;
  padding: 2px 0;
}

.chart-point .chart-point-list li i {
  margin-right: 5px;
  font-size: 11px;
  position: relative;
  top: -1px;
}

.c3 {
  height: 250px;
}

.c3-legend-item {
  fill: #9fabb1;
}

.c3 .c3-axis-x path,
.c3 .c3-axis-x line,
.c3 .c3-axis-y path,
.c3 .c3-axis-y line,
.tick text {
  stroke: #fff;
}

.flot-chart {
  height: 15.7rem;
}

.tooltipflot {
  background-color: transparent;
  font-size: 1.4rem;
  padding: .5rem 1rem;
  color: rgba(255, 255, 255, 0.7);
  border-radius: .2rem;
}

.legendColorBox>div {
  border: 0 !important;
  padding: 0 !important;
}

.legendLabel {
  font-size: 0.825rem;
  padding-left: .5rem;
  color: #fff;
}

.flotTip {
  background: #000;
  border: 1px solid #000;
  color: #fff;
}

.legend>div {
  background: transparent !important;
}

#balance_graph {
  height: 260px;
}

.morris-hover {
  position: absolute;
  z-index: 1;
  background: #00ADEE;
  color: #fff;
}

.morris-hover .morris-hover-point {
  color: #fff !important;
  margin: 3px 0;
  text-align: center;
  padding: 0 25px;
}

.morris-hover .morris-hover-row-label {
  background-color: #B1B1B1;
  text-align: center;
  padding: 5px;
  margin-bottom: 5px;
}

.morris-hover.morris-default-style {
  border-radius: 5px;
  padding: 0;
  margin: 0;
  border: none;
  overflow: hidden;
}

svg text {
  font-weight: 600 !important;
}

#morris_donught,
#morris_donught_2,
#line_chart_2,
#morris_bar,
#morris_bar_stalked,
#morris_bar_2,
#morris_area_2,
#morris_area {
  height: 240px !important;
}

#morris_line {
  height: 278px !important;
}

#crypto-btc-card,
#crypto-eth-card,
#crypto-rpl-card,
#crypto-ltc-card {
  height: 9.375rem;
}

#daily-sales,
#comparison-rate,
#usage-chart,
#walet-status {
  width: 100%;
  display: block;
}

#daily-sales canvas,
#comparison-rate canvas,
#usage-chart canvas,
#walet-status canvas {
  max-width: 100% !important;
  width: 100% !important;
}

#sparkline-composite-chart canvas,
#composite-bar canvas,
#sparkline11 canvas,
#StackedBarChart canvas,
#spark-bar canvas,
#tristate canvas {
  height: 100px !important;
}

#sparkline11 canvas {
  width: 100px !important;
}

.easy-pie-chart {
  position: relative;
  text-align: center;
}

.easy-pie-chart .inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
}

.easy-pie-chart img {
  width: 75px;
  height: 75px;
  border-radius: 50%;
}

.easy-pie-chart canvas {
  display: block;
  margin: 0 auto;
}

#revenue-chart {
  height: 27.7rem;
}

#duration-value-axis {
  height: 27.6rem;
  width: 100%;
}

#combined-bullet {
  height: 28.125rem;
  width: 100%;
}

#zoomable-chart {
  height: 28.125rem;
  width: 100%;
}

#chartMap {
  height: 28.125rem;
  width: 100%;
}

#professional-candlesticks {
  width: 100%;
  height: 28.125rem;
}

#comparing-stock-indices {
  width: 100%;
  height: 28.125rem;
}

#multiple-panel-data {
  width: 100%;
  height: 28.125rem;
}

#depth-chart {
  width: 100%;
  height: 28.125rem;
}

.amcharts-export-menu {
  display: none;
}

.amcharts-data-set-selector-div {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  width: 16.875rem;
  margin: 0 auto;
}

.amcharts-data-set-selector-div select {
  border: 0;
  margin-left: 0.625rem;
  background: #ddd;
  color: #000;
}

.amChartsInputField {
  border: 0;
  background: #00ADEE;
  color: #fff;
  padding: 0.3125rem 0.9375rem;
  margin: 0 0.9375rem;
}

.amcharts-data-set-select {
  border: 0;
  background: #ddd;
  color: #000;
}

.amcharts-period-input,
.amcharts-period-input-selected {
  border: 0;
  margin-left: 0.625rem;
  background: #00ADEE;
  color: #fff;
  padding: 0.3125rem 0.9375rem;
}

.amcharts-graph-g2 .amcharts-graph-stroke {
  stroke-dasharray: 3px 3px;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: am-moving-dashes 1s linear infinite;
}

@keyframes am-moving-dashes {
  100% {
    stroke-dashoffset: -1.9375rem;
  }
}

.lastBullet {
  animation: am-pulsating 1s ease-out infinite;
}

@keyframes am-pulsating {
  0% {
    stroke-opacity: 1;
    stroke-width: 0px;
  }

  100% {
    stroke-opacity: 0;
    stroke-width: 3.125rem;
  }
}

.amcharts-graph-column-front {
  transition: all .3s .3s ease-out;
}

.amcharts-graph-column-front:hover {
  fill: #496375;
  stroke: #496375;
  transition: all .3s ease-out;
}

@keyframes am-draw {
  0% {
    stroke-dashoffset: 500%;
  }

  100% {
    stroke-dashoffset: 0%;
  }
}

@media only screen and (max-width: 991px) {
  .amChartsPeriodSelector>fieldset>div {
    float: none !important;
    display: block !important;
    margin-bottom: 0.625rem;
  }
}

.highcharts-root text {
  font-weight: 300 !important;
}

.highcharts-credits {
  display: none;
}

#chart_employee_gender,
#chart_employee_status {
  width: auto;
  height: 350px;
}

.form-control {
  border-radius: 1.25rem;
  background: #fff;
  border: 1px solid #f0f1f5;
  color: #B1B1B1;
  height: 56px;
}

@media only screen and (max-width: 1400px) {
  .form-control {
    height: 41px;
  }
}

.form-control:hover,
.form-control:focus,
.form-control.active {
  box-shadow: none;
  background: #fff;
  color: #B1B1B1;
}

.input-rounded {
  border-radius: 100px;
}

[data-theme-version="light"] .input-primary .form-control,
[data-theme-version="dark"] .input-primary .form-control {
  border-color: #00ADEE;
}

[data-theme-version="light"] .input-primary .input-group-text,
[data-theme-version="dark"] .input-primary .input-group-text {
  background-color: #00ADEE;
  color: #fff;
}

[data-theme-version="light"] .input-danger .form-control,
[data-theme-version="dark"] .input-danger .form-control {
  border-color: #F94687;
}

[data-theme-version="light"] .input-danger .input-group-text,
[data-theme-version="dark"] .input-danger .input-group-text {
  background-color: #F94687;
  color: #fff;
}

[data-theme-version="light"] .input-info .form-control,
[data-theme-version="dark"] .input-info .form-control {
  border-color: #2D28FF;
}

[data-theme-version="light"] .input-info .input-group-text,
[data-theme-version="dark"] .input-info .input-group-text {
  background-color: #2D28FF;
  color: #fff;
}

[data-theme-version="light"] .input-success .form-control,
[data-theme-version="dark"] .input-success .form-control {
  border-color: #2BC155;
}

[data-theme-version="light"] .input-success .input-group-text,
[data-theme-version="dark"] .input-success .input-group-text {
  background-color: #2BC155;
  color: #fff;
}

[data-theme-version="light"] .input-warning .form-control,
[data-theme-version="dark"] .input-warning .form-control {
  border-color: #FF9B52;
}

[data-theme-version="light"] .input-warning .input-group-text,
[data-theme-version="dark"] .input-warning .input-group-text {
  background-color: #FF9B52;
  color: #fff;
}

[data-theme-version="light"] .input-primary-o .form-control,
[data-theme-version="dark"] .input-primary-o .form-control {
  border-color: #00ADEE;
}

[data-theme-version="light"] .input-primary-o .input-group-text,
[data-theme-version="dark"] .input-primary-o .input-group-text {
  background-color: transparent;
  border-color: #00ADEE;
  color: #00ADEE;
}

[data-theme-version="light"] .input-danger-o .form-control,
[data-theme-version="dark"] .input-danger-o .form-control {
  border-color: #F94687;
}

[data-theme-version="light"] .input-danger-o .input-group-text,
[data-theme-version="dark"] .input-danger-o .input-group-text {
  background-color: transparent;
  border-color: #F94687;
  color: #F94687;
}

[data-theme-version="light"] .input-info-o .form-control,
[data-theme-version="dark"] .input-info-o .form-control {
  border-color: #2D28FF;
}

[data-theme-version="light"] .input-info-o .input-group-text,
[data-theme-version="dark"] .input-info-o .input-group-text {
  background-color: transparent;
  border-color: #2D28FF;
  color: #2D28FF;
}

[data-theme-version="light"] .input-success-o .form-control,
[data-theme-version="dark"] .input-success-o .form-control {
  border-color: #2BC155;
}

[data-theme-version="light"] .input-success-o .input-group-text,
[data-theme-version="dark"] .input-success-o .input-group-text {
  background-color: transparent;
  border-color: #2BC155;
  color: #2BC155;
}

[data-theme-version="light"] .input-warning-o .form-control,
[data-theme-version="dark"] .input-warning-o .form-control {
  border-color: #FF9B52;
}

[data-theme-version="light"] .input-warning-o .input-group-text,
[data-theme-version="dark"] .input-warning-o .input-group-text {
  background-color: transparent;
  border-color: #FF9B52;
  color: #FF9B52;
}

.input-group-text {
  background: #d7dae3;
  border: 1px solid transparent;
  min-width: 50px;
  display: flex;
  justify-content: center;
  padding: 0.532rem 0.75rem;
  border-radius: 1.25rem;
}

.input-group-text i {
  font-size: 16px;
}

.custom-file-label {
  height: 40px;
  padding: 0.5rem 0.75rem;
  border-radius: 0;
}

.input-group-prepend .btn,
.input-group-append .btn {
  z-index: 0;
}

.custom-select {
  background: none;
  border-color: #f0f1f5;
  color: #B1B1B1;
}

.custom-select:focus {
  box-shadow: none;
  border-color: #00ADEE;
  color: #00ADEE;
}

.custom-file-label:after {
  background: #656C73;
  border: 1px solid #f0f1f5;
  color: #fff;
  border-radius: 0;
}

[data-theme-version="dark"] .custom-file-label:after {
  background: #333a54;
  border-color: #333a54;
  color: #7e7e7e;
}

.custom_file_input .custom-file-label::after {
  height: 100%;
}

.form-control:disabled,
.form-control[readonly] {
  background: #fff;
  opacity: 1;
}

.custom-file-label {
  background: #fff;
  border-color: #f0f1f5;
}

[data-theme-version="dark"] .custom-file-label {
  background: #181f39;
  border-color: #333a54;
}

/*\$primary  : #7356f1 !default;*/
input[type="checkbox"]:after {
  content: '';
  display: block;
  width: 1rem;
  height: 1rem;
  margin-top: 0px;
  margin-left: -1px;
  border: 1px solid transparent;
  border-radius: 3px;
  background: #d4d7da;
  line-height: 1.3;
}

input[type="checkbox"]:checked:after {
  width: 1rem;
  height: 1rem;
  display: block;
  content: "\\f00c";
  font-family: 'FontAwesome';
  color: #fff;
  font-weight: 100;
  font-size: 12px;
  text-align: center;
  border-radius: 3px;
  background: #00ADEE;
}

.form-check-label {
  margin-left: 5px;
  margin-top: 3px;
}

.form-check-inline .form-check-input {
  margin-right: 0.625rem;
}

.custom-control-label:before,
.custom-control-label:after {
  top: 2px;
  width: 1.25rem;
  height: 1.25rem;
  border-color: #e7e7e7;
}

.rtl .custom-control-label:before,
.rtl .custom-control-label:after {
  right: -1.5rem !important;
  left: inherit;
}

.custom-control {
  line-height: normal;
}

.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border-color: #00ADEE;
}

.custom-control-input:focus~.custom-control-label::before {
  box-shadow: none !important;
}

.custom-control-label::before {
  background-color: transparent;
  border-color: #BEBEBE;
  border-width: 2px;
  border-radius: 5px !important;
}

[data-theme-version="dark"] .custom-control-label::before {
  background-color: transparent;
  border-color: #333a54;
}

.check-xs .custom-control-label:before,
.check-xs .custom-control-label:after {
  width: 18px;
  height: 18px;
}

.check-lg .custom-control-label:before,
.check-lg .custom-control-label:after {
  width: 24px;
  height: 24px;
}

.check-xl .custom-control-label:before,
.check-xl .custom-control-label:after {
  width: 28px;
  height: 28px;
}

.checkbox-info .custom-control-label::before {
  background-color: transparent;
  border-color: #dbdbff;
}

[data-theme-version="dark"] .checkbox-info .custom-control-label::before {
  background-color: rgba(45, 40, 255, 0.1);
  border-color: transparent;
}

.checkbox-info .custom-control-input:checked~.custom-control-label::before {
  background-color: #2D28FF;
  border-color: #2D28FF;
}

.checkbox-danger .custom-control-label::before {
  background-color: transparent;
  border-color: #fff3f7;
}

[data-theme-version="dark"] .checkbox-danger .custom-control-label::before {
  background-color: rgba(249, 70, 135, 0.15);
  border-color: transparent;
}

.checkbox-danger .custom-control-input:checked~.custom-control-label::before {
  background-color: #F94687;
  border-color: #F94687;
}

.checkbox-success .custom-control-label::before {
  background-color: transparent;
  border-color: #e3f9e9;
}

[data-theme-version="dark"] .checkbox-success .custom-control-label::before {
  background-color: rgba(43, 193, 85, 0.1);
  border-color: transparent;
}

.checkbox-success .custom-control-input:checked~.custom-control-label::before {
  background-color: #2BC155;
  border-color: #2BC155;
}

.checkbox-warning .custom-control-label::before {
  background-color: transparent;
  border-color: #fff3eb;
}

[data-theme-version="dark"] .checkbox-warning .custom-control-label::before {
  background-color: rgba(255, 155, 82, 0.1);
  border-color: transparent;
}

.checkbox-warning .custom-control-input:checked~.custom-control-label::before {
  background-color: #FF9B52;
  border-color: #FF9B52;
}

.checkbox-secondary .custom-control-label::before {
  background-color: transparent;
  border-color: #ddedfa;
}

[data-theme-version="dark"] .checkbox-secondary .custom-control-label::before {
  background-color: rgba(63, 154, 224, 0.5);
  border-color: transparent;
}

.checkbox-secondary .custom-control-input:checked~.custom-control-label::before {
  background-color: #3F9AE0;
  border-color: #3F9AE0;
}

.toggle-switch {
  padding-left: 50px;
  line-height: 1.25;
}

.toggle-switch .custom-control-label {
  font-weight: 500;
}

.toggle-switch .custom-control-label:after {
  width: 24px;
  background: #959595;
  height: 24px;
  border-radius: 24px;
  top: -2px;
  left: -50px;
  transition: all 0.5s;
}

.toggle-switch .custom-control-label:before {
  border: 0;
  background: #D8D8D8;
  width: 40px;
  border-radius: 20px !important;
  height: 16px;
  left: -50px;
  transition: all 0.5s;
}

.toggle-switch .custom-control-input:checked~.custom-control-label:after {
  left: -43px;
  background: #00ADEE;
}

.toggle-switch .custom-control-input:checked~.custom-control-label:before {
  background: #f6f1fd;
}

.toggle-switch.text-right {
  padding-left: 0;
  padding-right: 50px;
}

.toggle-switch.text-right .custom-control-label:after {
  left: auto;
  right: -30px;
}

.toggle-switch.text-right .custom-control-label:before {
  left: auto;
  right: -50px;
}

.toggle-switch.text-right .custom-control-input:checked~.custom-control-label:after {
  left: auto;
  right: -43px;
}

.check-switch {
  padding-left: 40px;
}

.check-switch .custom-control-label {
  line-height: 30px;
  font-weight: 500;
}

.check-switch .custom-control-label:after,
.check-switch .custom-control-label:before {
  height: 1.5rem;
  width: 1.5rem;
  left: -2rem;
  border-radius: 3rem !important;
  border-color: rgba(135, 67, 223, 0.3);
}

.js-switch+.switchery {
  border-radius: 50px;
  margin-right: 4rem;
}

@media (max-width: 767.98px) {
  .js-switch+.switchery {
    margin-right: 1rem;
  }
}

.js-switch+.switchery>small {
  top: 2px;
}

.js-switch.js-switch-lg+.switchery {
  height: 2rem;
  width: 4.5rem;
}

.js-switch.js-switch-lg+.switchery>small {
  width: 1.75rem;
  height: 1.75rem;
}

.js-switch.js-switch-md+.switchery {
  height: 1.5rem;
  width: 3.5rem;
}

.js-switch.js-switch-md+.switchery>small {
  width: 1.25rem;
  height: 1.25rem;
}

.js-switch.js-switch-sm+.switchery {
  height: 1rem;
  width: 2.2rem;
}

.js-switch.js-switch-sm+.switchery>small {
  width: 0.875rem;
  height: 0.875rem;
  top: 1px;
}

.js-switch-square+.switchery {
  border-radius: 0;
}

.js-switch-square+.switchery>small {
  border-radius: 0;
  top: 2px;
}

.js-switch-square.js-switch-lg+.switchery {
  height: 2rem;
  width: 4.5rem;
}

.js-switch-square.js-switch-lg+.switchery>small {
  width: 1.75rem;
  height: 1.75rem;
}

.js-switch-square.js-switch-md+.switchery {
  height: 1.5rem;
  width: 3.5rem;
}

.js-switch-square.js-switch-md+.switchery>small {
  width: 1.25rem;
  height: 1.25rem;
}

.js-switch-square.js-switch-sm+.switchery {
  height: 1rem;
  width: 2.2rem;
}

.js-switch-square.js-switch-sm+.switchery>small {
  width: 0.875rem;
  height: 0.875rem;
  top: 1px;
}

.form-control.is-valid {
  border-color: #2BC155 !important;
  border-right: 0px !important;
}

.form-control.is-valid:focus {
  box-shadow: none;
}

.form-control.is-warning {
  border-color: #FF9B52 !important;
  border-right: 0px !important;
}

.form-control.is-warning:focus {
  box-shadow: none;
}

.form-control.is-invalid {
  border-color: #F94687 !important;
  border-right: 0px !important;
}

.form-control.is-invalid:focus {
  box-shadow: none;
}

.is-valid .input-group-prepend .input-group-text i {
  color: #2BC155;
}

.is-invalid .input-group-prepend .input-group-text i {
  color: #b184ea;
}

.asColorPicker-dropdown {
  max-width: 26rem;
}

.asColorPicker-trigger {
  border: 0 none;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: 2.1875rem;
}

[direction="rtl"] .asColorPicker-trigger {
  right: 99%;
  left: auto;
}

.asColorPicker-clear {
  display: none;
  position: absolute;
  right: 1rem;
  text-decoration: none;
  top: .5rem;
}

.daterangepicker td.active {
  background-color: #00ADEE;
}

.daterangepicker td.active:hover {
  background-color: #00ADEE;
}

.daterangepicker button.applyBtn {
  background-color: #00ADEE;
  border-color: #00ADEE;
}

.datepicker.datepicker-dropdown {
  background: #f2f4fa;
  border-radius: 1px;
  border: 1px solid #EEEEEE;
}

.datepicker.datepicker-dropdown td.day,
.datepicker.datepicker-dropdown th.next,
.datepicker.datepicker-dropdown th.prev {
  height: 30px;
  width: 30px !important;
  padding: 0;
  text-align: center;
  font-weight: 300;
  border-radius: 50px;
}

.datepicker.datepicker-dropdown td.day:hover,
.datepicker.datepicker-dropdown th.next:hover,
.datepicker.datepicker-dropdown th.prev:hover {
  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);
  color: #fff;
}

.datepicker.datepicker-dropdown th.datepicker-switch,
.datepicker.datepicker-dropdown th.next,
.datepicker.datepicker-dropdown th.prev {
  font-weight: 300;
  color: #333;
}

.datepicker.datepicker-dropdown th.dow {
  font-weight: 300;
}

.datepicker table tr td.selected,
.datepicker table tr td.active.active {
  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);
  border: 0;
}

.datepicker table tr td.today {
  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);
  color: #ffffff;
}

.datepicker table tr td.today:hover {
  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);
  color: #ffffff;
}

.datepicker table tr td.today.disabled {
  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);
  color: #ffffff;
}

.datepicker table tr td.today.disabled:hover {
  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);
  color: #ffffff;
}

.picker__select--month,
.picker__select--year {
  height: 2.5em;
}

.picker__input {
  background-color: transparent !important;
}

[data-theme-version="dark"] .picker__input {
  background-color: transparent !important;
  border: 1px solid #333a54;
}

.asColorPicker-wrap .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

#image {
  max-width: 100%;
}

.docs-options .dropdown-menu {
  padding: 1.5rem;
}

.docs-preview {
  margin-bottom: 3rem;
}

.docs-preview .img-preview {
  float: left;
  margin-right: .5rem;
  margin-bottom: .5rem;
  overflow: hidden;
  max-width: 100% !important;
}

.docs-preview .img-preview>img {
  max-width: 100% !important;
}

.docs-preview .img-preview.preview-lg {
  width: 16rem;
  height: 9rem;
}

.docs-preview .img-preview.preview-md {
  width: 8rem;
  height: 4.5rem;
}

.docs-preview .img-preview.preview-sm {
  width: 4rem;
  height: 2.25rem;
}

.docs-preview .img-preview.preview-xs {
  width: 2rem;
  height: 1.125rem;
  margin-right: 0;
}

.select2-container {
  width: 100% !important;
}

.select2-container--default .select2-selection--single {
  border-radius: 1.25rem;
  border: 1px solid #F4F5F9;
  height: 40px;
  background: #fff;
}

[data-theme-version="dark"] .select2-container--default .select2-selection--single {
  background: #181f39;
  border-color: #333a54;
}

.select2-container--default .select2-selection--single:hover,
.select2-container--default .select2-selection--single:focus,
.select2-container--default .select2-selection--single.active {
  box-shadow: none;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 40px;
  color: #7e7e7e;
  padding-left: 15px;
  min-height: 40px;
}

.select2-container--default .select2-selection--multiple {
  border-color: #f0f1f5;
  border-radius: 0;
}

.select2-dropdown {
  border-radius: 0;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #00ADEE;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #f0f1f5;
  background: #fff;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 6px;
  right: 15px;
}

.select2-container .select2-selection--multiple {
  min-height: 40px;
  color: #7e7e7e;
  border-radius: 1.25rem;
  border: 1px solid #F4F5F9;
}

[data-theme-version="dark"] .select2-container .select2-selection--multiple {
  background: #181f39;
  border-color: #333a54;
}

[data-theme-version="dark"] .select2-search--dropdown .select2-search__field {
  background: #1e2746;
  border-color: #333a54;
}

.select2-dropdown {
  border-color: #F4F5F9;
}

[data-theme-version="dark"] .select2-dropdown {
  background: #181f39;
  border-color: #333a54;
}

.swal2-popup .swal2-content {
  color: #7e7e7e;
}

/*\$primary  : #7356f1 !default;*/
/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
/*  .wizard > .content > .body input.error {
    position: absolute;
    top: 100% !important;
}

.wizard {
    position: relative;

    &>.steps {
        width: 100%;
        // padding-left: 3%;
		margin-bottom: 20px;
	
        @media(min-width: 1200px){
            width: 100%;
            // margin-left: 3%;
        }

        li {

            &.current {
                a {
                    background-color: \$primary;
                    color: \$white;
                }
            }

            &.disabled, &.done {
                a {
                    background-color: \$white;
                    color: \$heading;

                    &:hover {
                        margin: 0;
                        background-color: \$white;
                        border-radius: 0;
                        color: \$heading;
                    }
                }
            }

            a {
                text-align: center;
                margin: 0;
                border-radius: 0;
                background-color: \$white;

                &:hover {
                    margin: 0;
                    background-color: \$white;
                    border-radius: 0;
                    color: \$heading;
                }

                @include respond(phone-land) {
                    padding: 1em 4px;
                }

                .number {
                    display: none;
                }
            }
        }
    }

    .content  {
        min-height: 32rem;
        margin: 0;

        @include media-breakpoint-down(md) {
            min-height: 41rem;
        }

        & > .body {
            background-color: transparent;
            width: 100%;
            height: 100%;
            padding: 0;
            
            @include respond(phone) {
                padding: 0;
            }

            .form-control {
                // background-color: \$l-bg;
                border: 1px solid \$border;
				@at-root [data-theme-version="dark"] & {
					border-color: \$d-border;
				}
            }
    
            input.error {
                position: relative;
            }
    
            label.error {
				margin-top: 5px;
				margin-left: 0;
				margin-bottom: 0;
            }
        }
    }

    .emial-setup {
        label.mailclinet {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 10rem;
            height: 10rem;
            border-radius: 50%;
            cursor: pointer;
            background-color: #EEF5F9;
			text-align: center;
			margin: auto;
			@at-root [data-theme-version="dark"] & {
				background-color: \$d-bg;
			}
            @include respond(phone) {
                width: 7rem;
                height: 7rem;
            }

            .mail-icon {
                font-size: 3rem;
                display: inline-block;
                line-height: 1;
                margin-top: -1rem;

                @include respond(phone) {
                    font-size: 2rem;
                }
            }

            .mail-text {
                font-size: 1rem;
                text-align: center;
                margin-top: .5rem;

                @include respond(phone) {
                    font-size: 16px;
					line-height: 20px;
                }
            }

            input[type="radio"] {
                display: none;
            }
        }
    }

    .skip-email {
        margin-top: 6rem;

        p {
            margin-bottom: 1rem;
        }

        a {
            color: \$primary;
            text-decoration: underline;
        }
    }

    &>.actions {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 2rem;

        li:not(.disabled) {
            a {
                background-color: \$primary;
                color: \$white;
            }
        }
    }
}

.wizard .actions ul li{
    &.disabled a{
        color: #333333 !important;
        background: #F7FAFC !important;
        border: 1px solid #EEEEEE;

        @at-root [data-theme-version="dark"] & {
            background: \$d-bg !important;
            border-color: \$d-border;
			color:\$white !important;
        }
    }

    & a{
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        padding: 0.55em 2em;
    }

}

.wizard > .actions a, .wizard > .actions a:hover, .wizard > .actions a:active{
    padding: 0.55em 2em;
}

// .wizard > .steps > ul > li{

//     @media(max-width: 680px){
//         width: 100%;
//         padding-left: 0;
//     }
// }

// .wizard > .steps{

//     @media(max-width: 680px){
//         padding-left: 0;
//     }
// }

.wizard > .content{
    background: transparent;
    // box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1); 
}

.wizard, .tabcontrol{
    overflow: visible;
}

.step-form-horizontal {
    .wizard {
        padding-top: 3.5rem;
        
        .steps {
            li {
                position: relative;

                &.done {
                    a {
                        text-align: center;
                        background-color: \$white;
                        color: \$dark;
						@at-root [data-theme-version="dark"] & {
							background-color: \$d-bg;
							color: \$body-color;
						}
                        &:hover {
                            text-align: center;
                            background-color: \$white;
                            color: \$dark;
                        }

                        .number {
                            color: \$white;
                            background: \$primary;
                            border-color: transparent; 
							@at-root [data-theme-version="dark"] & {
								border-color:\$primary;
							}
                        }
                    }
                }

                &.current a, &.disabled a {
                    background-color: transparent;
                    text-align: center;
                    color: \$white;

                    &:hover, &:active {
                        background-color: transparent;
                        color: \$white;
                    }
                }

                &.current a {
                    .number {
                        color: \$primary;
                        background: \$white;
                        border: 2px solid \$primary; 
                    }
                }

                &.disabled a {
                    .number {
                        color: \$primary;
                    }
                }

                a {
                    position: relative;
                    z-index: 1;

                    @include media-breakpoint-down(sm) {
                        padding-left: 0;
                        padding-right: 0;
                        margin: 0;
                    }

                    @include media-breakpoint-down(xs) {
                        font-size: 0.75rem;
                        padding-top: 0.9375rem;
                    }

                    .number {
						position: absolute;
						top: -55px;
						left: 50%;
						transform: translateX(-50%);
						background-color: #fff;
						border: 3px solid #d7dae3;
						display: flex;
						justify-content: center;
						align-items: center;
						height: 3rem;
						border-radius: 50px;
						width: 3rem;

                        // @include respond(phone) {
                        //     width: 4rem;
                        //     height: 4rem;
                        // }
						
						@at-root [data-theme-version="dark"] & {
							background:\$d-bg;
							border-color:\$d-border;
						}
                        @include respond('phone') {
							top: -45px;
						}
                    }
                }

                &:not(:last-child) {
                    z-index: 1;

                    &::after {
                        position: absolute;
                        width: 100%;
                        height: 0.375rem;
                        content: "";
                        left: 50%;
                        top: -2.1rem;
                        background-color: \$primary;
                        z-index: -1;

                        @include media-breakpoint-down(xs) {
                            height: 0.375rem;
                            top: -1.3125rem;
                        }
                    }

                    &.current {
                        &::after {
                            background-color: #F3F3F3;
							@at-root [data-theme-version="dark"] & {
								background:\$d-bg;
							}
                        }


                        &~li {
                            &::after {
                                background-color: #F3F3F3;
								@at-root [data-theme-version="dark"] & {
									background:\$d-bg;
								}
                            }
                        }
                    }
                }
            }
        }

        .actions {
            padding: 0;

            @include respond(phone) {
                padding: 0;
            }
        }
    }
}
 */
.form-wizard {
  border: 0;
}

.form-wizard .nav-wizard {
  box-shadow: none !important;
  margin-bottom: 2rem;
}

.form-wizard .nav-wizard li .nav-link {
  position: relative;
}

.form-wizard .nav-wizard li .nav-link span {
  border-radius: 50px;
  width: 3rem;
  height: 3rem;
  border: 2px solid #00ADEE;
  display: block;
  line-height: 3rem;
  color: #00ADEE;
  font-size: 18px;
  margin: auto;
  background-color: #fff;
  position: relative;
  z-index: 1;
}

.form-wizard .nav-wizard li .nav-link:after {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 3px;
  transform: translateY(-50%);
  background: #f1f1f1 !important;
  z-index: 0;
  width: 100%;
}

.form-wizard .nav-wizard li .nav-link.active:after {
  background: #f1f1f1 !important;
}

.form-wizard .nav-wizard li .nav-link.done:after {
  background: #00ADEE !important;
}

.form-wizard .nav-wizard li .nav-link.done span {
  background-color: #00ADEE;
  color: #fff;
}

.form-wizard .nav-wizard li:last-child .nav-link:after {
  content: none;
}

.form-wizard .toolbar-bottom .btn {
  background-color: #00ADEE;
  border: 0;
  padding: 12px 18px;
}

.form-wizard .tab-content .tab-pane {
  padding: 0;
}

.form-wizard .emial-setup label.mailclinet {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  cursor: pointer;
  background-color: #EEF5F9;
  text-align: center;
  margin: auto;
}

[data-theme-version="dark"] .form-wizard .emial-setup label.mailclinet {
  background-color: #181f39;
}

@media only screen and (max-width: 575px) {
  .form-wizard .emial-setup label.mailclinet {
    width: 7rem;
    height: 7rem;
  }
}

.form-wizard .emial-setup label.mailclinet .mail-icon {
  font-size: 3rem;
  display: inline-block;
  line-height: 1;
  margin-top: -1rem;
}

@media only screen and (max-width: 575px) {
  .form-wizard .emial-setup label.mailclinet .mail-icon {
    font-size: 2rem;
  }
}

.form-wizard .emial-setup label.mailclinet .mail-text {
  font-size: 1rem;
  text-align: center;
  margin-top: .5rem;
}

@media only screen and (max-width: 575px) {
  .form-wizard .emial-setup label.mailclinet .mail-text {
    font-size: 16px;
    line-height: 20px;
  }
}

.form-wizard .emial-setup label.mailclinet input[type="radio"] {
  display: none;
}

.form-wizard .emial-setup label.mailclinet {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  cursor: pointer;
  background-color: #EEF5F9;
  text-align: center;
  margin: auto;
}

[data-theme-version="dark"] .form-wizard .emial-setup label.mailclinet {
  background-color: #181f39;
}

@media only screen and (max-width: 575px) {
  .form-wizard .emial-setup label.mailclinet {
    width: 7rem;
    height: 7rem;
  }
}

.form-wizard .emial-setup label.mailclinet .mail-icon {
  font-size: 3rem;
  display: inline-block;
  line-height: 1;
  margin-top: -1rem;
}

@media only screen and (max-width: 575px) {
  .form-wizard .emial-setup label.mailclinet .mail-icon {
    font-size: 2rem;
  }
}

.form-wizard .emial-setup label.mailclinet .mail-text {
  font-size: 1rem;
  text-align: center;
  margin-top: .5rem;
}

@media only screen and (max-width: 575px) {
  .form-wizard .emial-setup label.mailclinet .mail-text {
    font-size: 16px;
    line-height: 20px;
  }
}

.form-wizard .emial-setup label.mailclinet input[type="radio"] {
  display: none;
}

@media only screen and (max-width: 767px) {
  .form-wizard .nav-wizard {
    flex-direction: unset !important;
  }

  .form-wizard .tab-content {
    height: 100% !important;
  }
}

@media only screen and (max-width: 575px) {
  .form-wizard .nav-wizard li .nav-link {
    padding: 0;
  }
}

.note-icon-caret,
.note-popover {
  display: none;
}

.note-editor.note-frame .panel-heading {
  padding: .6rem 1rem 1rem;
  z-index: 1;
}

.note-editor.note-frame {
  border-color: #f0f1f5;
}

.note-editor.note-frame .note-editing-area .note-editable {
  background-color: #fff;
}

[data-theme-version="dark"] .note-editor.note-frame .note-editing-area .note-editable {
  background-color: #181f39;
}

.note-editor.note-frame .note-statusbar {
  background-color: #fff;
}

.ql-container {
  height: 25rem;
}

#world-datamap {
  padding-bottom: 46% !important;
}

.datamaps-hoverover {
  background: #fff;
  padding: 0.3125rem;
  border-radius: 0.3125rem;
  font-family: 'Roboto' !important;
  color: #00ADEE;
  border: 1px solid rgba(135, 67, 223, 0.3);
}

@media only screen and (max-width: 1440px) {
  .world_map_card ul.list-group {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin-top: 35px;
  }
}

.jqvmap-zoomin,
.jqvmap-zoomout {
  height: 20px;
  width: 20px;
  line-height: 14px;
  background-color: #00ADEE;
  color: #fff;
}

.jqvmap-zoomout {
  top: 35px;
}

#world-map {
  height: 400px;
}

.blockUI.blockMsg.blockPage {
  border: 0 !important;
}

#loginForm {
  cursor: auto;
}

.blockMsg {
  border: 0px !important;
  width: 20% !important;
}

.blockMsg h1 {
  font-size: 16px;
  padding: 8px 0;
  margin-bottom: 0;
}

.bootstrap-select {
  margin-bottom: 0;
}

.bootstrap-select .btn {
  border: 1px solid #f0f1f5 !important;
  background-color: transparent !important;
  font-weight: 400;
  color: #7e7e7e !important;
}

[data-theme-version="dark"] .bootstrap-select .btn {
  border-color: #333a54 !important;
}

.bootstrap-select .btn:active,
.bootstrap-select .btn:focus,
.bootstrap-select .btn:hover {
  outline: none !important;
  outline-offset: 0;
}

[data-theme-version="dark"] .bootstrap-select .btn:active,
[data-theme-version="dark"] .bootstrap-select .btn:focus,
[data-theme-version="dark"] .bootstrap-select .btn:hover {
  color: #7e7e7e !important;
}

.bootstrap-select .dropdown-menu {
  border-color: #f0f1f5 !important;
  box-shadow: 0px 0Epx 40px 0px rgba(82, 63, 105, 0.1);
}

.bootstrap-select .dropdown-menu .dropdown-item {
  padding: 0.25rem 1rem;
}

[data-theme-version="dark"] .bootstrap-select .dropdown-menu {
  border-color: #f0f1f5 !important;
}

.input-group>.bootstrap-select:not(:first-child) .dropdown-toggle {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group>.bootstrap-select:not(:last-child) .dropdown-toggle {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/*\$primary  : #7356f1 !default;*/
.clipboard-btn {
  transition: all .1s ease-in-out;
}

.clipboard-btn:hover {
  background-color: #00ADEE;
  color: #fff;
}

.crypto-ticker {
  background: rgba(0, 0, 0, 0.5);
  margin-top: 20px;
  padding: 10px 20px;
  border-radius: 3px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
}

[data-theme-version="dark"] .crypto-ticker {
  background: #1e2746;
}

#webticker-big {
  font: inherit !important;
  font-size: inherit !important;
  font-weight: normal !important;
}

#webticker-big li i {
  font-size: 18px;
  margin-right: 7px;
}

#webticker-big li p {
  margin-bottom: 0px;
  font-size: 12px;
  font-weight: 700;
}

/*\$primary  : #7356f1 !default;*/
.twitter-typeahead {
  width: 100%;
}

.twitter-typeahead .tt-dataset.tt-dataset-states {
  border: 1px solid #f0f1f5;
}

.twitter-typeahead .tt-menu {
  width: 100%;
  background-color: #fff;
}

.twitter-typeahead .tt-menu .tt-suggestion {
  padding: 0.625rem;
  cursor: pointer;
}

.twitter-typeahead .tt-menu .tt-suggestion:hover {
  background-color: #00ADEE;
  color: #fff;
}

.weather-one i {
  font-size: 8rem;
  position: relative;
  top: .5rem;
}

.weather-one h2 {
  display: inline-block;
  float: right;
  font-size: 4.8rem;
}

.weather-one .city {
  position: relative;
  text-align: right;
  top: -2.5rem;
}

.weather-one .currently {
  font-size: 1.6rem;
  font-weight: 400;
  position: relative;
  top: 2.5rem;
}

.weather-one .celcious {
  text-align: right;
  font-size: 2rem;
}

/*\$primary  : #7356f1 !default;*/
.noUi-target {
  border-color: transparent;
  border-radius: 0;
}

.noUi-connect {
  background-color: #00ADEE;
}

.noUi-connects {
  background-color: #D2D6DE;
}

.noUi-connect.c-1-color {
  background-color: #2BC155;
}

.noUi-connect.c-2-color {
  background-color: #2D28FF;
}

.noUi-connect.c-3-color {
  background-color: #00ADEE;
}

.noUi-connect.c-4-color {
  background-color: #FF9B52;
}

.noUi-vertical {
  width: 0.375rem;
}

.noUi-horizontal {
  height: 0.375rem;
  margin-bottom: 10px;
}

.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
  height: 12px;
  width: 12px;
  border-radius: 50px;
  box-shadow: none;
  border: none;
  background-color: #00ADEE;
}

.noUi-horizontal .noUi-handle::after,
.noUi-horizontal .noUi-handle::before,
.noUi-vertical .noUi-handle::after,
.noUi-vertical .noUi-handle::before {
  display: none;
}

.noUi-vertical .noUi-handle {
  left: -4px;
  top: -6px;
}

.noUi-horizontal .noUi-handle {
  top: -4px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -6px;
}

#slider-toggle {
  height: 50px;
}

#slider-toggle.off .noUi-handle {
  border-color: #00ADEE;
}

.colorpicker-slider .sliders.noUi-target#red,
.colorpicker-slider .sliders.noUi-target#green,
.colorpicker-slider .sliders.noUi-target#blue {
  margin: 10px;
  display: inline-block;
  height: 200px;
}

.colorpicker-slider .sliders.noUi-target#red .noUi-connect {
  background: #c0392b;
}

.colorpicker-slider .sliders.noUi-target#green .noUi-connect {
  background: #27ae60;
}

.colorpicker-slider .sliders.noUi-target#blue .noUi-connect {
  background: #2980b9;
}

.colorpicker-slider #result {
  margin: 60px 26px;
  height: 100px;
  width: 100px;
  display: inline-block;
  vertical-align: top;
  color: #7f7f7f;
  background: #7f7f7f;
  border: 1px solid #fff;
  box-shadow: 0 0 10px;
}

.slider-vertical {
  height: 18rem;
}

.nestable-cart {
  overflow: hidden;
}

.dd-handle {
  color: #fff;
  background: #00ADEE;
  border-radius: 5px;
  padding: 8px 15px;
  height: auto;
  border: 1px solid #f0f1f5;
}

.dd-handle:hover {
  color: #fff;
  background: #00ADEE;
}

.dd3-content:hover {
  color: #fff;
  background: #00ADEE;
}

.dd3-content {
  color: #fff;
}

.dd-item>button {
  line-height: 28px;
  color: #fff;
}

.pignose-calendar {
  box-shadow: none;
  width: 100%;
  max-width: none;
  border-color: #00ADEE;
}

.pignose-calendar .pignose-calendar-top-date {
  background-color: #00ADEE;
}

.pignose-calendar .pignose-calendar-top-date .pignose-calendar-top-month {
  color: #fff;
}

.pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
  background-color: #00ADEE;
  box-shadow: none;
}

.pignose-calendar .pignose-calendar-top {
  box-shadow: none;
  border-bottom: 0;
}

.pignose-calendar.pignose-calendar-blue {
  background-color: rgba(0, 0, 0, 0.15);
}

.pignose-calendar .pignose-calendar-unit {
  height: 4.8em;
}

.cd-h-timeline {
  opacity: 0;
  transition: opacity 0.2s;
}

.cd-h-timeline--loaded {
  opacity: 1;
}

.cd-h-timeline__container {
  position: relative;
  height: 100px;
  max-width: 800px;
}

.cd-h-timeline__dates {
  position: relative;
  height: 100%;
  margin: 0 40px;
  overflow: hidden;
}

.cd-h-timeline__dates::after,
.cd-h-timeline__dates::before {
  content: '';
  position: absolute;
  z-index: 2;
  top: 0;
  height: 100%;
  width: 20px;
}

.cd-h-timeline__dates::before {
  left: 0;
  background: #00ADEE;
}

.cd-h-timeline__dates::after {
  right: 0;
  background: #00ADEE;
}

.cd-h-timeline__line {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 49px;
  height: 2px;
  background-color: #00ADEE;
  transition: transform 0.4s;
}

.cd-h-timeline__filling-line {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: #2BC155;
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.3s;
}

.cd-h-timeline__date {
  position: absolute;
  bottom: 0;
  z-index: 2;
  text-align: center;
  font-size: 0.8em;
  padding-bottom: var(--space-sm);
  color: var(--cd-color-1);
  -webkit-user-select: none;
          user-select: none;
  text-decoration: none;
}

.cd-h-timeline__date::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -5px;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  border-color: #8a47e0;
  background-color: #00ADEE;
  transition: background-color 0.3s, border-color .3s;
}

.cd-h-timeline__date:hover::after {
  background-color: #2BC155;
  border-color: #2BC155;
}

.cd-h-timeline__date--selected {
  pointer-events: none;
}

.cd-h-timeline__date--selected::after {
  background-color: #2BC155;
  border-color: #2BC155;
}

.cd-h-timeline__date--older-event::after {
  border-color: #2BC155;
}

.cd-h-timeline__navigation {
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  height: 34px;
  width: 34px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  border-color: #8a47e0;
  transition: border-color 0.3s;
}

.cd-h-timeline__navigation::after {
  content: '';
  position: absolute;
  height: 16px;
  width: 16px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  /* background: url(../images/svg/cd-arrow.svg) no-repeat 0 0;*/
}

.cd-h-timeline__navigation:hover {
  border-color: #2BC155;
}

.cd-h-timeline__navigation--prev {
  left: 0;
  transform: translateY(-50%) rotate(180deg);
}

.cd-h-timeline__navigation--next {
  right: 0;
}

.cd-h-timeline__navigation--inactive {
  cursor: not-allowed;
}

.cd-h-timeline__navigation--inactive::after {
  background-position: 0 -16px;
}

.cd-h-timeline__navigation--inactive:hover {
  border-color: #8a47e0;
}

.cd-h-timeline__events {
  position: relative;
  width: 100%;
  overflow: hidden;
  transition: height .4s;
}

.cd-h-timeline__event {
  position: absolute;
  z-index: 1;
  width: 100%;
  left: 0;
  top: 0;
  transform: translateX(-100%);
  padding: 1px 5%;
  opacity: 0;
  animation-duration: 0.4s;
  animation-timing-function: ease-in-out;
}

.cd-h-timeline__event--selected {
  position: relative;
  z-index: 2;
  opacity: 1;
  transform: translateX(0);
}

.cd-h-timeline__event--enter-right,
.cd-h-timeline__event--leave-right {
  animation-name: cd-enter-right;
}

.cd-h-timeline__event--enter-left,
.cd-h-timeline__event--leave-left {
  animation-name: cd-enter-left;
}

.cd-h-timeline__event--leave-right,
.cd-h-timeline__event--leave-left {
  animation-direction: reverse;
}

.cd-h-timeline__event-content {
  max-width: 800px;
}

.cd-h-timeline__event-title {
  color: var(--cd-color-1);
  font-family: var(--font-secondary);
  font-weight: 700;
  font-size: var(--text-xxxl);
}

.cd-h-timeline__event-date {
  display: block;
  font-style: italic;
  margin: var(--space-xs) auto;
}

.cd-h-timeline__event-date::before {
  content: '- ';
}

@keyframes cd-enter-right {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }

  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}

@keyframes cd-enter-left {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }

  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}

/* Light Gallery */
.lg-actions .lg-next,
.lg-actions .lg-prev,
.lg-sub-html,
.lg-toolbar {
  background-color: rgba(30, 30, 30, 0.6);
}

.lg-outer .lg-toogle-thumb,
.lg-outer .lg-thumb-outer,
.lg-outer .lg-img-wrap,
.lg-outer .lg-item {
  background-color: transparent;
}

.lg-thumb-outer.lg-grab,
.lg-toogle-thumb.lg-icon {
  background-color: rgba(30, 30, 30, 0.6);
}

.lg-backdrop {
  background-color: rgba(30, 30, 30, 0.9);
}

.lg-outer .lg-toogle-thumb,
.lg-actions .lg-next,
.lg-actions .lg-prev,
.lg-toolbar .lg-icon,
#lg-counter {
  color: #fff;
}

.lg-outer .lg-thumb-item.active,
.lg-outer .lg-thumb-item:hover {
  border-color: #00ADEE;
}

.lightimg {
  cursor: pointer;
}

.toast-success {
  background-color: #00ADEE;
}

.toast-info {
  background-color: #2D28FF;
}

.toast-warning {
  background-color: #FF9B52;
}

.toast-error {
  background-color: #F94687;
}

#toast-container>div {
  box-shadow: none;
  border-radius: 0;
  width: auto;
  max-width: 250px;
  opacity: 1;
}

[direction="rtl"] #toast-container>div {
  padding: 15px 50px 15px 15px;
  background-position: calc(100% - 15px);
  text-align: right;
}

#toast-container>div:hover {
  box-shadow: none;
}

#toast-container .toast-title {
  margin-bottom: 5px;
  font-weight: 600;
}

#toast-container .toast-message {
  font-size: 12px;
}

#toast-container .toast-close-button {
  opacity: 1;
  font-size: 20px;
  font-weight: normal;
  text-shadow: none;
}

[direction="rtl"] .toast-top-right.demo_rtl_class {
  left: 12px;
  right: auto;
}

.jqvmap-zoomin,
.jqvmap-zoomout {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #000000;
  padding: 3px;
  color: white;
  width: 17px;
  height: 17px;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
}

.jqvmap-zoomin {
  top: 10px;
}

.jqvmap-zoomout {
  top: 30px;
}

.ps__rail-x:hover,
.ps__rail-y:hover,
.ps__rail-x:focus,
.ps__rail-y:focus,
.ps__rail-x.ps--clicking,
.ps__rail-y.ps--clicking {
  background-color: transparent;
  opacity: 0.9;
}

.ps__rail-y:hover>.ps__thumb-y,
.ps__rail-y:focus>.ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #DAE2F3;
  width: 4px;
}

.ps__thumb-y {
  background-color: #DAE2F3;
  width: 4px;
}

.total-average {
  position: relative;
  height: 300px;
}

.widget-chat {
  position: relative;
  height: 250px;
}

.widget-todo {
  position: relative;
  height: 210px;
}

.widget-team {
  position: relative;
  height: 285px;
}

.widget-timeline {
  position: relative;
}

.widget-comments {
  position: relative;
  height: 400px;
}

.sidebar-right-inner {
  position: relative;
  height: 100%;
}

.widget-team .ps .ps__rail-x:hover,
.widget-team .ps .ps__rail-y:hover,
.widget-team .ps .ps__rail-x:focus,
.widget-team .ps .ps__rail-y:focus,
.widget-team .ps .ps__rail-x.ps--clicking,
.widget-team .ps .ps__rail-y.ps--clicking {
  background-color: transparent !important;
  opacity: 0.9;
}

.accordion-primary .accordion__header {
  background: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
  box-shadow: 0 15px 20px 0 rgba(135, 67, 223, 0.15);
}

.accordion-primary .accordion__header.collapsed {
  background: #f6f1fd;
  border-color: #f6f1fd;
  color: #211c37;
  box-shadow: none;
}

[data-theme-version="dark"] .accordion-primary .accordion__header.collapsed {
  background: rgba(135, 67, 223, 0.2);
  border-color: rgba(135, 67, 223, 0.2);
  color: #7e7e7e;
}

.accordion-primary-solid .accordion__header {
  background: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
  box-shadow: 0 -10px 20px 0 rgba(135, 67, 223, 0.15);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion-primary-solid .accordion__header.collapsed {
  background: #f6f1fd;
  border-color: #f6f1fd;
  color: #211c37;
  box-shadow: none;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

[data-theme-version="dark"] .accordion-primary-solid .accordion__header.collapsed {
  background: rgba(135, 67, 223, 0.2);
  border-color: rgba(135, 67, 223, 0.2);
  color: #7e7e7e;
}

.accordion-primary-solid .accordion__body {
  border: 2px solid #00ADEE;
  border-top: none;
  box-shadow: 0 15px 20px 0 rgba(135, 67, 223, 0.15);
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.accordion-danger .accordion__header {
  background: #F94687;
  border-color: #F94687;
  color: #fff;
  box-shadow: 0 15px 20px 0 rgba(249, 70, 135, 0.15);
}

.accordion-danger .accordion__header.collapsed {
  background: #fff3f7;
  border-color: #fff3f7;
  color: #211c37;
  box-shadow: none;
}

.accordion-danger-solid .accordion__header {
  background: #F94687;
  border-color: #F94687;
  color: #fff;
  box-shadow: 0 -10px 20px 0 rgba(249, 70, 135, 0.15);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion-danger-solid .accordion__header.collapsed {
  background: #fff3f7;
  border-color: #fff3f7;
  color: #211c37;
  box-shadow: none;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

[data-theme-version="dark"] .accordion-danger-solid .accordion__header.collapsed {
  background: rgba(249, 70, 135, 0.15);
  border-color: rgba(249, 70, 135, 0.15);
  color: #7e7e7e;
}

.accordion-danger-solid .accordion__body {
  border: 2px solid #F94687;
  border-top: none;
  box-shadow: 0 15px 20px 0 rgba(249, 70, 135, 0.15);
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.accordion__item {
  margin-bottom: 1.25rem;
}

.accordion__header {
  padding: 1rem 1.75rem;
  border: 1px solid #f0f1f5;
  cursor: pointer;
  position: relative;
  color: #333;
  font-weight: 400;
  border-radius: 1.25rem;
  transition: all 0.5s;
}

[data-theme-version="dark"] .accordion__header {
  color: #fff;
  border-color: #333a54;
}

.accordion__header--indicator {
  font-family: 'themify';
  position: absolute;
  right: 1.5625rem;
  top: 50%;
  transform: translateY(-50%);
}

[direction="rtl"] .accordion__header--indicator {
  right: auto;
  left: 1.5625rem;
}

.accordion__header--indicator.indicator_bordered {
  display: inline-block;
  width: 25px;
  text-align: center;
  height: 25px;
  border: 1px solid #f0f1f5;
  border-radius: 50%;
  line-height: 25px;
}

.accordion__header:not(.collapsed) .accordion__header--indicator::before {
  content: "\\e622";
}

.accordion__header:not(.collapsed) .accordion__header--indicator.style_two::before {
  content: "\\e648";
}

.accordion__header.collapsed .accordion__header--indicator::before {
  content: "\\e61a";
}

.accordion__header.collapsed .accordion__header--indicator.style_two::before {
  content: "\\e64b";
}

.accordion__body--text {
  padding: 0.875rem 1.25rem;
}

.accordion-bordered .accordion__body {
  border: 1px solid #f0f1f5;
  border-top: none;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

[data-theme-version="dark"] .accordion-bordered .accordion__body {
  border-color: #333a54;
}

.accordion-bordered .accordion__header.collapsed {
  border-radius: 1.25rem;
}

.accordion-bordered .accordion__header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion-no-gutter .accordion__item {
  margin-bottom: 0;
}

.accordion-no-gutter .accordion__item .accordion__header.collapsed {
  border-bottom: none;
}

.accordion-no-gutter .accordion__item:last-child .accordion__header {
  border-bottom: 1px solid #f0f1f5;
}

[data-theme-version="dark"] .accordion-no-gutter .accordion__item:last-child .accordion__header {
  border-color: #333a54;
}

.accordion-no-gutter.accordion__bordered .accordion__item:not(:last-child) .accordion__body {
  border-bottom: none;
}

.accordion-left-indicator .accordion__header--text {
  padding-left: 2.5rem;
}

.accordion-left-indicator .accordion__header--indicator {
  right: auto;
  left: 1.5625rem;
}

.accordion-with-icon .accordion__header--text {
  padding-left: 2.5rem;
}

[direction="rtl"] .accordion-with-icon .accordion__header--text {
  padding-left: 0;
  padding-right: 2.5rem;
}

.accordion-with-icon .accordion__header--icon {
  position: absolute;
  right: auto;
  left: 1.5625rem;
  font-family: 'themify';
}

[direction="rtl"] .accordion-with-icon .accordion__header--icon {
  left: auto;
  right: 1.5625rem;
}

.accordion-with-icon .accordion__header--icon::before {
  content: "\\e645";
}

.accordion-header-bg .accordion__header {
  background-color: #F4F5F9;
}

[data-theme-version="dark"] .accordion-header-bg .accordion__header {
  background-color: #181f39;
  color: #fff;
}

.accordion-header-bg .accordion__header--primary {
  background-color: #00ADEE;
  color: #fff;
  border-color: #00ADEE;
}

[data-theme-version="dark"] .accordion-header-bg .accordion__header--primary {
  background-color: #00ADEE;
}

.accordion-header-bg .accordion__header--info {
  background-color: #2D28FF;
  color: #fff;
  border-color: #2D28FF;
}

[data-theme-version="dark"] .accordion-header-bg .accordion__header--info {
  background-color: #2D28FF;
}

.accordion-header-bg .accordion__header--success {
  background-color: #2BC155;
  color: #fff;
  border-color: #2BC155;
}

[data-theme-version="dark"] .accordion-header-bg .accordion__header--success {
  background-color: #2BC155;
}

.accordion-header-bg.accordion-no-gutter .accordion__header {
  border-color: transparent;
  border-radius: 0;
}

.accordion-header-bg.accordion-no-gutter .accordion__item:first-child .accordion__header {
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
}

.accordion-header-bg.accordion-no-gutter .accordion__item:last-child .accordion__header {
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.accordion.accordion-no-gutter .accordion__header {
  border-radius: 0;
}

.accordion.accordion-no-gutter .accordion__header.collapsed {
  border-radius: 0;
}

.accordion.accordion-no-gutter .accordion__body {
  border-radius: 0;
}

.accordion.accordion-no-gutter .accordion__item:first-child .accordion__header {
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
}

.accordion.accordion-no-gutter .accordion__item:last-child .accordion__header.collapsed {
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.accordion.accordion-no-gutter .accordion__item:last-child .accordion__body {
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.accordion-solid-bg .accordion__header {
  border-color: transparent;
  background-color: #f6f1fd;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[data-theme-version="dark"] .accordion-solid-bg .accordion__header {
  background-color: #181f39;
}

.accordion-solid-bg .accordion__header.collapsed {
  border-radius: 1.25rem;
}

.accordion-solid-bg .accordion__body {
  border-color: transparent;
  background-color: #f6f1fd;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

[data-theme-version="dark"] .accordion-solid-bg .accordion__body {
  background-color: #181f39;
}

.accordion-active-header .accordion__header:not(.collapsed) {
  background-color: #2D28FF;
  border-color: #2D28FF;
  color: #fff;
}

.accordion-header-shadow .accordion__header {
  border: none;
  box-shadow: 0 0 0.9375rem -3px rgba(0, 0, 0, 0.3);
}

.accordion-rounded-stylish .accordion__header {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.accordion-rounded-stylish .accordion__body {
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.accordion-rounded .accordion__header {
  border-radius: 0.3125rem;
}

.accordion-gradient .accordion__header {
  color: #fff;
  background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);
  border-color: transparent;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion-gradient .accordion__header.collapsed {
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}

.accordion-gradient .accordion__body {
  color: #fff;
  background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);
  border-color: transparent;
}

.alert {
  border-radius: 1.25rem;
  padding: 1rem 3rem 1rem 1.5rem;
}

.alert p {
  line-height: 1.5;
}

.alert-rounded {
  border-radius: 30px;
}

.alert-primary {
  background: #f6f1fd;
  border-color: #f6f1fd;
  color: #00ADEE;
}

[data-theme-version="dark"] .alert-primary {
  background: rgba(135, 67, 223, 0.2);
  border-color: rgba(135, 67, 223, 0.2);
}

.alert-secondary {
  background: #ddedfa;
  border-color: #ddedfa;
  color: #3F9AE0;
}

[data-theme-version="dark"] .alert-secondary {
  background: rgba(63, 154, 224, 0.5);
  border-color: rgba(63, 154, 224, 0.5);
  color: #7e7e7e;
}

.alert-success {
  background: #e3f9e9;
  border-color: #e3f9e9;
  color: #2BC155;
}

[data-theme-version="dark"] .alert-success {
  background: rgba(43, 193, 85, 0.1);
  border-color: rgba(43, 193, 85, 0.1);
}

.alert-warning {
  background: #fff3eb;
  border-color: #fff3eb;
  color: #FF9B52;
}

[data-theme-version="dark"] .alert-warning {
  background: rgba(255, 155, 82, 0.1);
  border-color: rgba(255, 155, 82, 0.1);
}

.alert-danger {
  background: #fff3f7;
  border-color: #fff3f7;
  color: #F94687;
}

[data-theme-version="dark"] .alert-danger {
  background: rgba(249, 70, 135, 0.15);
  border-color: rgba(249, 70, 135, 0.15);
}

.alert-info {
  background: #dbdbff;
  border-color: #dbdbff;
  color: #2D28FF;
}

[data-theme-version="dark"] .alert-info {
  background: rgba(45, 40, 255, 0.1);
  border-color: rgba(45, 40, 255, 0.1);
}

.alert-dark {
  background: #f1f1f1;
  border-color: #f1f1f1;
  color: #B1B1B1;
}

[data-theme-version="dark"] .alert-dark {
  background: rgba(177, 177, 177, 0.35);
  border-color: rgba(177, 177, 177, 0.35);
  color: #7e7e7e;
}

.alert-light {
  background: #F4F5F9;
  border-color: #F4F5F9;
  color: #B1B1B1;
}

.alert-alt.alert-primary {
  border-left: 4px solid #00ADEE;
}

.alert-alt.alert-secondary {
  border-left: 4px solid #3F9AE0;
}

.alert-alt.alert-success {
  border-left: 4px solid #2BC155;
}

.alert-alt.alert-warning {
  border-left: 4px solid #FF9B52;
}

.alert-alt.alert-danger {
  border-left: 4px solid #F94687;
}

.alert-alt.alert-info {
  border-left: 4px solid #2D28FF;
}

.alert-alt.alert-dark {
  border-left: 4px solid #B1B1B1;
}

.alert-alt.alert-light {
  border-left: 4px solid #c3c8de;
}

.alert-alt.alert-primary.solid {
  border-left: 4px solid #4a188b !important;
}

.alert-alt.alert-secondary.solid {
  border-left: 4px solid #165789 !important;
}

.alert-alt.alert-success.solid {
  border-left: 4px solid #145927 !important;
}

.alert-alt.alert-warning.solid {
  border-left: 4px solid #d25800 !important;
}

.alert-alt.alert-danger.solid {
  border-left: 4px solid #b90647 !important;
}

.alert-alt.alert-info.solid {
  border-left: 4px solid #0400a8 !important;
}

.alert-alt.alert-dark.solid {
  border-left: 4px solid #717171 !important;
}

.alert-alt.alert-light.solid {
  border-left: 4px solid #a2aacc !important;
}

.alert-dismissible.solid .close:hover {
  color: #fff;
  opacity: 1;
}

.alert.alert-primary.solid {
  background: #00ADEE;
  color: #fff;
  border-color: #00ADEE;
}

.alert.alert-secondary.solid {
  background: #3F9AE0;
  color: #fff;
  border-color: #3F9AE0;
}

.alert.alert-success.solid {
  background: #2BC155;
  color: #fff;
  border-color: #2BC155;
}

.alert.alert-warning.solid {
  background: #FF9B52;
  color: #fff;
  border-color: #FF9B52;
}

.alert.alert-danger.solid {
  background: #F94687;
  color: #fff;
  border-color: #F94687;
}

.alert.alert-info.solid {
  background: #2D28FF;
  color: #fff;
  border-color: #2D28FF;
}

.alert.alert-dark.solid {
  background: #B1B1B1;
  color: #fff;
  border-color: #B1B1B1;
}

.alert.alert-light.solid {
  background: #F4F5F9;
  color: #B1B1B1;
  border-color: #F4F5F9;
}

.alert-right-icon>span i {
  font-size: 18px;
  margin-right: 5px;
}

.alert-right-icon .close i {
  font-size: 16px;
}

.alert.alert-outline-primary {
  background: transparent;
  color: #00ADEE;
  border-color: #00ADEE;
}

.alert.alert-outline-secondary {
  background: transparent;
  color: #7e7e7e;
  border-color: #3F9AE0;
}

.alert.alert-outline-success {
  background: transparent;
  color: #2BC155;
  border-color: #2BC155;
}

.alert.alert-outline-info {
  background: transparent;
  color: #2D28FF;
  border-color: #2D28FF;
}

.alert.alert-outline-warning {
  background: transparent;
  color: #FF9B52;
  border-color: #FF9B52;
}

.alert.alert-outline-danger {
  background: transparent;
  color: #F94687;
  border-color: #F94687;
}

.alert.alert-outline-dark {
  background: transparent;
  color: #7e7e7e;
  border-color: #B1B1B1;
}

.alert.alert-outline-light {
  background: transparent;
  color: #B1B1B1;
  border-color: #F4F5F9;
}

.alert-social {
  color: #fff;
}

.alert-social .alert-social-icon {
  align-self: center;
  margin-right: 0.9375rem;
}

.alert-social .alert-social-icon i {
  font-size: 42px;
}

.alert-social.facebook {
  background-color: #3b5998;
}

.alert-social.twitter {
  background-color: #1da1f2;
}

.alert-social.linkedin {
  background-color: #007bb6;
}

.alert-social.google-plus {
  background-color: #db4439;
}

.alert-social .close:hover {
  opacity: 1 !important;
  color: #fff !important;
}

.left-icon-big .alert-left-icon-big {
  align-self: center;
  margin-right: 0.9375rem;
}

.left-icon-big .alert-left-icon-big i {
  font-size: 35px;
  line-height: 1;
}

[direction="rtl"] .left-icon-big .alert-left-icon-big,
[direction="rtl"] .alert-social .alert-social-icon {
  margin-left: 0;
  margin-right: 0.9375rem;
}

.badge {
  line-height: 1.5;
  border-radius: 1.25rem;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 10px;
  border: 1px solid transparent;
}

.badge-rounded {
  border-radius: 20px;
  padding: 3px 13px;
}

.badge-circle {
  border-radius: 100px;
  padding: 3px 7px;
}

.badge-outline-primary {
  border: 1px solid #00ADEE;
  color: #00ADEE;
}

.badge-outline-secondary {
  border: 1px solid #3F9AE0;
  color: #3F9AE0;
}

[data-theme-version="dark"] .badge-outline-secondary {
  color: #7e7e7e;
}

.badge-outline-success {
  border: 1px solid #2BC155;
  color: #2BC155;
}

.badge-outline-info {
  border: 1px solid #2D28FF;
  color: #2D28FF;
}

.badge-outline-warning {
  border: 1px solid #FF9B52;
  color: #FF9B52;
}

.badge-outline-danger {
  border: 1px solid #F94687;
  color: #F94687;
}

.badge-outline-light {
  border: 1px solid #f0f1f5;
  color: #B1B1B1;
}

[data-theme-version="dark"] .badge-outline-light {
  color: #7e7e7e;
}

.badge-outline-dark {
  border: 1px solid #B1B1B1;
  color: #B1B1B1;
}

[data-theme-version="dark"] .badge-outline-dark {
  color: #7e7e7e;
}

.badge-xs {
  font-size: 10px;
  padding: 0px 5px;
  line-height: 18px;
}

.badge-sm {
  font-size: 11px;
  padding: 5px 8px;
  line-height: 11px;
}

.badge-lg {
  font-size: 14px;
  padding: 0px 10px;
  line-height: 30px;
}

.badge-xl {
  font-size: 15px;
  padding: 0px 15px;
  line-height: 35px;
}

.badge-default {
  background: #ADB6C7;
}

.badge-success {
  background-color: #2BC155;
}

.badge-info {
  background-color: #2D28FF;
}

.badge-primary {
  background-color: #00ADEE;
}

.badge-warning {
  background-color: #FF9B52;
}

.badge-danger {
  background-color: #F94687;
}

.badge-dark {
  background-color: #B1B1B1;
}

.badge-light {
  background-color: #F4F5F9;
}

.light.badge-default {
  background: #ADB6C7;
}

.light.badge-success {
  background-color: #e3f9e9;
  color: #2BC155;
}

[data-theme-version="dark"] .light.badge-success {
  background-color: rgba(43, 193, 85, 0.1);
}

.light.badge-info {
  background-color: #dbdbff;
  color: #2D28FF;
}

[data-theme-version="dark"] .light.badge-info {
  background-color: rgba(45, 40, 255, 0.1);
}

.light.badge-primary {
  background-color: #f6f1fd;
  color: #00ADEE;
}

[data-theme-version="dark"] .light.badge-primary {
  background-color: rgba(135, 67, 223, 0.2);
}

.light.badge-secondary {
  background-color: #ddedfa;
  color: #3F9AE0;
}

[data-theme-version="dark"] .light.badge-secondary {
  background-color: rgba(63, 154, 224, 0.5);
  color: #7e7e7e;
}

.light.badge-warning {
  background-color: #fff3eb;
  color: #FF9B52;
}

[data-theme-version="dark"] .light.badge-warning {
  background-color: rgba(255, 155, 82, 0.1);
}

.light.badge-danger {
  background-color: #fff3f7;
  color: #F94687;
}

[data-theme-version="dark"] .light.badge-danger {
  background-color: rgba(249, 70, 135, 0.15);
}

.light.badge-dark {
  background-color: #f1f1f1;
  color: #B1B1B1;
}

[data-theme-version="dark"] .light.badge-dark {
  background-color: rgba(177, 177, 177, 0.35);
  color: #7e7e7e;
}

.bootstrap-label .label {
  display: inline-block;
  margin-right: 1rem;
}

.bootstrap-label .label:last-child {
  margin-right: 0;
}

.badge-demo .badge {
  margin-right: 5px;
  margin-bottom: 5px;
}

.badge-demo .badge:last-child {
  margin-right: 0;
}

.bootstrap-badge-buttons button {
  margin-right: .2rem;
  margin-bottom: 1rem;
}

.bootstrap-badge-buttons button:last-child {
  margin-right: 0;
}

.welcome-text span,
.welcome-text p {
  display: none;
}

.page-titles {
  margin-bottom: 25px;
  display: block;
  margin-left: -40px;
  margin-right: -40px;
  padding: 20px 40px;
  margin-top: -15px;
  background: #E5E6E7;
  display: block;
}

.page-titles [class*="col-"] {
  display: block !important;
  max-width: 100%;
  width: 100%;
  margin: 0;
}

@media only screen and (max-width: 1600px) {
  .page-titles {
    margin-left: -30px;
    margin-top: 0px;
    margin-right: -30px;
    margin-bottom: 30px;
    padding: 15px 30px;
  }
}

@media only screen and (max-width: 767px) {
  .page-titles {
    margin-left: -15px;
    margin-top: -15px;
    margin-right: -15px;
    margin-bottom: 0px;
    padding: 15px;
  }
}

.page-titles .justify-content-sm-end {
  align-items: center;
}

.page-titles h4 {
  margin-bottom: 10px;
  margin-top: 0;
  color: #000;
  font-size: 1.75rem;
  font-weight: 600;
}

.page-titles h4 span {
  font-size: 1.25rem;
}

.page-titles .breadcrumb {
  margin-bottom: 0;
  padding: 0;
  background: transparent;
  /* .breadcrumb-item + .breadcrumb-item {
        &:before {
            content: "\\e606";
            font-family: 'simple-line-icons';
            // font-weight: 4;
            font-size: 10px;
        }
    } */
}

.page-titles .breadcrumb li {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
}

@media only screen and (max-width: 767px) {
  .page-titles .breadcrumb li {
    font-size: 15px;
  }
}

.page-titles .breadcrumb li a {
  color: #656773;
}

.page-titles .breadcrumb li.active a {
  color: #00ADEE;
  font-weight: 600;
}

.page-titles .breadcrumb-datepicker {
  font-size: 0.75rem;
  color: #89879f;
}

.page-titles .breadcrumb-datepicker__icon {
  font-size: 0.875rem;
}

.page-titles .breadcrumb-widget .border-dark {
  border-color: #dee2e6 !important;
}

.page-titles .breadcrumb-widget h4 {
  color: #646c9a;
  font-weight: 600;
}

@media only screen and (max-width: 575px) {
  .page-titles .breadcrumb-widget {
    text-align: left !important;
    margin-bottom: 0.9375rem;
  }
}

button {
  cursor: pointer;
}

button:focus {
  outline: 0;
  box-shadow: none;
}

.btn-primary {
  color: #fff;
}

.btn {
  padding: 0.56rem 1rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: .8rem;
}

.btn:hover,
.btn:focus,
.btn:active,
.btn.active {
  outline: 0 !important;
}

@media only screen and (max-width: 1400px) {
  .btn {
    padding: 0.625rem 1rem;
    font-size: 0.813rem;
  }
}

.btn-transparent {
  background-color: transparent;
}

.sharp {
  min-width: 40px;
  padding: 7px;
  height: 40px;
  min-height: 40px;
}

.sharp.btn-xs {
  padding: 3px;
  width: 26px;
  height: 26px;
  min-width: 26px;
  min-height: 26px;
}

.light.tp-btn {
  background-color: transparent;
}

.light.btn-default {
  background: #ADB6C7;
}

.light.btn-success {
  background-color: #e3f9e9;
  border-color: #e3f9e9;
  color: #2BC155;
}

.light.btn-success g [fill] {
  fill: #2BC155;
}

[data-theme-version="dark"] .light.btn-success {
  background-color: rgba(43, 193, 85, 0.1);
  border-color: transparent;
}

.light.btn-success:hover {
  background-color: #2BC155;
  border-color: #2BC155;
  color: #fff;
}

.light.btn-success:hover g [fill] {
  fill: #fff;
}

.light.btn-info {
  background-color: #dbdbff;
  border-color: #dbdbff;
  color: #2D28FF;
}

.light.btn-info g [fill] {
  fill: #2D28FF;
}

[data-theme-version="dark"] .light.btn-info {
  background-color: rgba(45, 40, 255, 0.1);
  border-color: transparent;
}

.light.btn-info:hover {
  background-color: #2D28FF;
  border-color: #2D28FF;
  color: #fff;
}

.light.btn-info:hover g [fill] {
  fill: #fff;
}

.light.btn-primary {
  background-color: #f6f1fd;
  border-color: #f6f1fd;
  color: #00ADEE;
}

.light.btn-primary g [fill] {
  fill: #00ADEE;
}

[data-theme-version="dark"] .light.btn-primary {
  background-color: rgba(135, 67, 223, 0.2);
  border-color: transparent;
}

.light.btn-primary:hover {
  background-color: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
}

.light.btn-primary:hover g [fill] {
  fill: #fff;
}

.light.btn-primary:hover svg path {
  fill: #fff;
}

.light.btn-secondary {
  background-color: #ddedfa;
  border-color: #ddedfa;
  color: #3F9AE0;
}

.light.btn-secondary g [fill] {
  fill: #3F9AE0;
}

[data-theme-version="dark"] .light.btn-secondary {
  background-color: rgba(63, 154, 224, 0.5);
  border-color: transparent;
  color: #fff;
}

.light.btn-secondary:hover {
  background-color: #3F9AE0;
  border-color: #3F9AE0;
  color: #fff;
}

.light.btn-secondary:hover g [fill] {
  fill: #fff;
}

.light.btn-warning {
  background-color: #fff3eb;
  border-color: #fff3eb;
  color: #FF9B52;
}

.light.btn-warning g [fill] {
  fill: #FF9B52;
}

[data-theme-version="dark"] .light.btn-warning {
  background-color: rgba(255, 155, 82, 0.1);
  border-color: transparent;
}

.light.btn-warning:hover {
  background-color: #FF9B52;
  border-color: #FF9B52;
  color: #fff;
}

.light.btn-warning:hover g [fill] {
  fill: #fff;
}

.light.btn-danger {
  background-color: #fff3f7;
  border-color: #fff3f7;
  color: #F94687;
}

.light.btn-danger g [fill] {
  fill: #F94687;
}

[data-theme-version="dark"] .light.btn-danger {
  background-color: rgba(249, 70, 135, 0.15);
  border-color: transparent;
}

.light.btn-danger:hover {
  background-color: #F94687;
  border-color: #F94687;
  color: #fff;
}

.light.btn-danger:hover g [fill] {
  fill: #fff;
}

.light.btn-danger:hover svg path {
  fill: #fff;
}

.light.btn-dark {
  background-color: #f1f1f1;
  border-color: #f1f1f1;
  color: #B1B1B1;
}

.light.btn-dark g [fill] {
  fill: #B1B1B1;
}

[data-theme-version="dark"] .light.btn-dark {
  background-color: rgba(177, 177, 177, 0.35);
  border-color: transparent;
  color: #fff;
}

.light.btn-dark:hover {
  background-color: #B1B1B1;
  border-color: #B1B1B1;
  color: #fff;
}

.light.btn-dark:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn {
  background-color: transparent;
  border-color: transparent;
}

.btn.tp-btn.btn-default {
  background: #ADB6C7;
}

.btn.tp-btn.btn-success {
  color: #2BC155;
}

.btn.tp-btn.btn-success g [fill] {
  fill: #2BC155;
}

.btn.tp-btn.btn-success:hover {
  background-color: #2BC155;
  border-color: #2BC155;
  color: #fff;
}

.btn.tp-btn.btn-success:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn.btn-info {
  color: #2D28FF;
}

.btn.tp-btn.btn-info g [fill] {
  fill: #2D28FF;
}

.btn.tp-btn.btn-info:hover {
  background-color: #2D28FF;
  border-color: #2D28FF;
  color: #fff;
}

.btn.tp-btn.btn-info:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn.btn-primary {
  color: #00ADEE;
}

.btn.tp-btn.btn-primary g [fill] {
  fill: #00ADEE;
}

.btn.tp-btn.btn-primary:hover {
  background-color: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
}

.btn.tp-btn.btn-primary:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn.btn-secondary {
  color: #3F9AE0;
}

.btn.tp-btn.btn-secondary g [fill] {
  fill: #3F9AE0;
}

.btn.tp-btn.btn-secondary:hover {
  background-color: #3F9AE0;
  border-color: #3F9AE0;
  color: #fff;
}

.btn.tp-btn.btn-secondary:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn.btn-warning {
  color: #FF9B52;
}

.btn.tp-btn.btn-warning g [fill] {
  fill: #FF9B52;
}

.btn.tp-btn.btn-warning:hover {
  background-color: #FF9B52;
  border-color: #FF9B52;
  color: #fff;
}

.btn.tp-btn.btn-warning:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn.btn-danger {
  color: #F94687;
}

.btn.tp-btn.btn-danger g [fill] {
  fill: #F94687;
}

.btn.tp-btn.btn-danger:hover {
  background-color: #F94687;
  border-color: #F94687;
  color: #fff;
}

.btn.tp-btn.btn-danger:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn.btn-light {
  color: #B1B1B1;
}

.btn.tp-btn.btn-light g [fill] {
  fill: #B1B1B1;
}

.btn.tp-btn.btn-light:hover {
  background-color: #F4F5F9;
  border-color: #F4F5F9;
  color: #B1B1B1;
}

.btn.tp-btn.btn-light:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn.btn-dark {
  color: #B1B1B1;
}

.btn.tp-btn.btn-dark g [fill] {
  fill: #B1B1B1;
}

.btn.tp-btn.btn-dark:hover {
  background-color: #B1B1B1;
  border-color: #B1B1B1;
  color: #fff;
}

.btn.tp-btn.btn-dark:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn-light {
  background-color: transparent;
  border-color: transparent;
}

.btn.tp-btn-light.btn-success {
  color: #2BC155;
}

.btn.tp-btn-light.btn-success g [fill] {
  fill: #2BC155;
}

.btn.tp-btn-light.btn-success:hover {
  background-color: #e3f9e9;
  border-color: #e3f9e9;
  color: #2BC155;
}

.btn.tp-btn-light.btn-success:hover g [fill] {
  fill: #2BC155;
}

.btn.tp-btn-light.btn-info {
  color: #2D28FF;
}

.btn.tp-btn-light.btn-info g [fill] {
  fill: #2D28FF;
}

.btn.tp-btn-light.btn-info:hover {
  background-color: #dbdbff;
  border-color: #dbdbff;
  color: #2D28FF;
}

.btn.tp-btn-light.btn-info:hover g [fill] {
  fill: #2D28FF;
}

.btn.tp-btn-light.btn-primary {
  color: #00ADEE;
}

.btn.tp-btn-light.btn-primary g [fill] {
  fill: #00ADEE;
}

.btn.tp-btn-light.btn-primary:hover {
  background-color: #f6f1fd;
  border-color: #f6f1fd;
  color: #00ADEE;
}

.btn.tp-btn-light.btn-primary:hover g [fill] {
  fill: #00ADEE;
}

.btn.tp-btn-light.btn-secondary {
  color: #3F9AE0;
}

.btn.tp-btn-light.btn-secondary g [fill] {
  fill: #3F9AE0;
}

.btn.tp-btn-light.btn-secondary:hover {
  background-color: #ddedfa;
  border-color: #ddedfa;
  color: #3F9AE0;
}

.btn.tp-btn-light.btn-secondary:hover g [fill] {
  fill: #3F9AE0;
}

.btn.tp-btn-light.btn-warning {
  color: #FF9B52;
}

.btn.tp-btn-light.btn-warning g [fill] {
  fill: #FF9B52;
}

.btn.tp-btn-light.btn-warning:hover {
  background-color: #fff3eb;
  border-color: #fff3eb;
  color: #FF9B52;
}

.btn.tp-btn-light.btn-warning:hover g [fill] {
  fill: #FF9B52;
}

.btn.tp-btn-light.btn-danger {
  color: #F94687;
}

.btn.tp-btn-light.btn-danger g [fill] {
  fill: #F94687;
}

.btn.tp-btn-light.btn-danger:hover {
  background-color: #fff3f7;
  border-color: #fff3f7;
  color: #F94687;
}

.btn.tp-btn-light.btn-danger:hover g [fill] {
  fill: #fff;
}

.btn.tp-btn-light.btn-dark {
  color: #B1B1B1;
}

.btn.tp-btn-light.btn-dark g [fill] {
  fill: #B1B1B1;
}

.btn.tp-btn-light.btn-dark:hover {
  background-color: #f1f1f1;
  border-color: #f1f1f1;
  color: #B1B1B1;
}

.btn.tp-btn-light.btn-dark:hover [fill] {
  fill: #fff;
}

.shadow.btn-primary {
  box-shadow: 0 5px 15px 0 rgba(135, 67, 223, 0.2) !important;
}

.shadow.btn-secondary {
  box-shadow: 0 5px 15px 0 rgba(63, 154, 224, 0.2) !important;
}

.shadow.btn-warning {
  box-shadow: 0 5px 15px 0 rgba(255, 155, 82, 0.2) !important;
}

.shadow.btn-danger {
  box-shadow: 0 5px 15px 0 rgba(249, 70, 135, 0.2) !important;
}

.shadow.btn-info {
  box-shadow: 0 5px 15px 0 rgba(45, 40, 255, 0.2) !important;
}

.shadow.btn-success {
  box-shadow: 0 5px 15px 0 rgba(43, 193, 85, 0.2) !important;
}

.btn-xxs {
  padding: 6px 15px;
  font-size: 11px;
  line-height: 1.3;
}

.btn-xs {
  font-size: 0.75rem;
  padding: 0.438rem 1rem;
  font-weight: 600;
}

@media only screen and (max-width: 1400px) {
  .btn-xs {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    font-weight: 500;
  }
}

.btn-sm,
.btn-group-sm>.btn {
  font-size: 0.813rem !important;
  padding: 0.625rem 1rem;
}

@media only screen and (max-width: 1400px) {

  .btn-sm,
  .btn-group-sm>.btn {
    padding: 0.375rem 1rem;
    font-size: 0.75rem;
  }
}

.btn-md {
  font-size: 0.813rem !important;
  padding: 0.875rem 1.25rem;
}

@media only screen and (max-width: 1400px) {
  .btn-md {
    padding: 0.5rem 1rem;
    font-size: 0.813rem;
  }
}

.btn-lg,
.btn-group-lg>.btn {
  padding: 1rem 2rem;
  font-size: 1.125rem !important;
}

@media only screen and (max-width: 1400px) {

  .btn-lg,
  .btn-group-lg>.btn {
    padding: 0.75rem 1.5rem;
    font-size: 1rem !important;
  }
}

.btn-xl {
  padding: 0.6rem 1rem;
}

.btn-xl.btn-default {
  font-weight: 600;
}

.btn-square {
  border-radius: 0;
}

.btn-rounded {
  border-radius: 30px !important;
}

.btn-icon-right {
  border-left: 1px solid white;
  display: inline-block;
  margin: -.8rem 0 -.8rem 1rem;
  padding: 0.4375rem 0 0.4375rem 1rem;
  margin: -1rem -0.25rem -1rem 1rem;
  padding: 1rem 0 1rem 1.25rem;
}

@media only screen and (max-width: 1400px) {
  .btn-icon-right {
    padding: 1rem 0 1rem 0.6rem;
  }
}

.btn-icon-left {
  background: #fff;
  border-radius: 10rem;
  display: inline-block;
  margin: -0.5rem 0.75rem -0.5rem -1.188rem;
  padding: 0.5rem 0.80rem 0.5rem;
  float: left;
}

@media only screen and (max-width: 1199px) {
  .btn-icon-left {
    margin: -0.5rem 0.75rem -0.5rem -0.800rem;
  }
}

[direction="rtl"] .btn-icon-left {
  margin: -.5rem -1.5rem -.5rem 1rem;
}

[direction="rtl"] .btn-icon-right {
  border-left: 0px solid white;
  display: inline-block;
  margin: -.8rem 1rem -.8rem 0;
  padding: 0.4375rem 1rem 0.4375rem 0;
  border-right: 1px solid white;
}

.toggle-dropdown::after {
  margin-left: 0.755em;
}

.social-btn-icon .btn {
  min-width: 7.5rem;
  margin-bottom: 1.5rem;
}

.social-icon .btn {
  padding: .7rem 1.4rem;
}

.btn-circle {
  height: 5rem;
  width: 5rem;
  border-radius: 50% !important;
}

.btn-circle-sm {
  width: 4.5rem;
  height: 4.5rem;
  font-size: 1.8rem;
}

.btn-circle-md {
  width: 6rem;
  height: 6rem;
  font-size: 2.5rem;
}

.btn-circle-md i {
  font-size: 2.4rem;
}

.btn-circle-lg {
  width: 8rem;
  height: 8rem;
  font-size: 3.2rem;
}

.btn-circle-lg i {
  font-size: 3.1rem;
}

.btn-page .btn {
  min-width: 110px;
  margin-right: 4px;
  margin-bottom: 8px;
}

.size-1 {
  min-width: 160px !important;
  font-size: 24px;
  padding: 0.68rem 0.75rem;
}

.size-2 {
  font-size: 20px;
  min-width: 130px !important;
  padding: 0.57rem 0.75rem;
}

.size-3 {
  font-size: 14px;
  min-width: 110px !important;
  padding: 0.536rem 0.75rem;
}

.size-4 {
  font-size: 14px;
  min-width: 100px !important;
}

.size-5 {
  font-size: 14px;
  min-width: 90px !important;
  padding: .22rem 0.75rem;
}

.size-6 {
  font-size: 13px;
  min-width: 80px !important;
  padding: 0.097rem 0.75rem;
}

.size-7 {
  font-size: 12px;
  min-width: 60px !important;
  padding: 0.001rem 0.75rem;
}

.btn-light {
  background: #F4F5F9;
  border-color: #F4F5F9;
}

.btn-light:active,
.btn-light:focus,
.btn-light:hover {
  background: white;
  border-color: white;
}

.btn-outline-primary:hover {
  color: #fff;
}

.btn-outline-light {
  color: #B1B1B1;
}

[data-theme-version="dark"] .btn-outline-light {
  color: #7e7e7e;
}

[data-theme-version="dark"] .btn-outline-secondary {
  color: #7e7e7e;
}

[data-theme-version="dark"] .btn-outline-dark {
  color: #7e7e7e;
}

.btn-dark {
  background: #B1B1B1;
  border-color: #B1B1B1;
  color: #fff;
}

.btn-dark:active,
.btn-dark:focus,
.btn-dark:hover {
  background: #989898;
  color: #fff;
  border-color: #989898;
}

.btn-group.btn-rounded .btn:first-child {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

.btn-group.btn-rounded .btn:last-child {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.btn-facebook {
  background: #3b5998;
  border-color: #3b5998;
  color: #fff;
}

.btn-facebook:active,
.btn-facebook:focus,
.btn-facebook:hover {
  background: #2d4373;
  color: #fff;
  border-color: #2d4373;
}

.btn-twitter {
  background: #1da1f2;
  border-color: #1da1f2;
  color: #fff;
}

.btn-twitter:active,
.btn-twitter:focus,
.btn-twitter:hover {
  background: #0c85d0;
  color: #fff;
  border-color: #0c85d0;
}

.btn-youtube {
  background: #FF0000;
  border-color: #FF0000;
  color: #fff;
}

.btn-youtube:active,
.btn-youtube:focus,
.btn-youtube:hover {
  background: #cc0000;
  color: #fff;
  border-color: #cc0000;
}

.btn-instagram {
  background: #c32aa3;
  border-color: #c32aa3;
  color: #fff;
}

.btn-instagram:active,
.btn-instagram:focus,
.btn-instagram:hover {
  background: #992180;
  color: #fff;
  border-color: #992180;
}

.btn-pinterest {
  background: #bd081c;
  border-color: #bd081c;
  color: #fff;
}

.btn-pinterest:active,
.btn-pinterest:focus,
.btn-pinterest:hover {
  background: #8c0615;
  color: #fff;
  border-color: #8c0615;
}

.btn-linkedin {
  background: #007bb6;
  border-color: #007bb6;
  color: #fff;
}

.btn-linkedin:active,
.btn-linkedin:focus,
.btn-linkedin:hover {
  background: #005983;
  color: #fff;
  border-color: #005983;
}

.btn-google-plus {
  background: #db4439;
  border-color: #db4439;
  color: #fff;
}

.btn-google-plus:active,
.btn-google-plus:focus,
.btn-google-plus:hover {
  background: #be2d23;
  color: #fff;
  border-color: #be2d23;
}

.btn-google {
  background: #4285f4;
  border-color: #4285f4;
  color: #fff;
}

.btn-google:active,
.btn-google:focus,
.btn-google:hover {
  background: #1266f1;
  color: #fff;
  border-color: #1266f1;
}

.btn-snapchat {
  background: #fffc00;
  border-color: #fffc00;
  color: #000;
}

.btn-snapchat:active,
.btn-snapchat:focus,
.btn-snapchat:hover {
  background: #ccca00;
  color: #000;
  border-color: #ccca00;
}

.btn-whatsapp {
  background: #25d366;
  border-color: #25d366;
  color: #fff;
}

.btn-whatsapp:active,
.btn-whatsapp:focus,
.btn-whatsapp:hover {
  background: #1da851;
  color: #fff;
  border-color: #1da851;
}

.btn-tumblr {
  background: #35465d;
  border-color: #35465d;
  color: #fff;
}

.btn-tumblr:active,
.btn-tumblr:focus,
.btn-tumblr:hover {
  background: #222e3d;
  color: #fff;
  border-color: #222e3d;
}

.btn-reddit {
  background: #ff4500;
  border-color: #ff4500;
  color: #fff;
}

.btn-reddit:active,
.btn-reddit:focus,
.btn-reddit:hover {
  background: #cc3700;
  color: #fff;
  border-color: #cc3700;
}

.btn-spotify {
  background: #1ed760;
  border-color: #1ed760;
  color: #fff;
}

.btn-spotify:active,
.btn-spotify:focus,
.btn-spotify:hover {
  background: #18aa4c;
  color: #fff;
  border-color: #18aa4c;
}

.btn-yahoo {
  background: #430297;
  border-color: #430297;
  color: #fff;
}

.btn-yahoo:active,
.btn-yahoo:focus,
.btn-yahoo:hover {
  background: #2d0165;
  color: #fff;
  border-color: #2d0165;
}

.btn-dribbble {
  background: #ea4c89;
  border-color: #ea4c89;
  color: #fff;
}

.btn-dribbble:active,
.btn-dribbble:focus,
.btn-dribbble:hover {
  background: #e51e6b;
  color: #fff;
  border-color: #e51e6b;
}

.btn-skype {
  background: #00aff0;
  border-color: #00aff0;
  color: #fff;
}

.btn-skype:active,
.btn-skype:focus,
.btn-skype:hover {
  background: #008abd;
  color: #fff;
  border-color: #008abd;
}

.btn-quora {
  background: #aa2200;
  border-color: #aa2200;
  color: #fff;
}

.btn-quora:active,
.btn-quora:focus,
.btn-quora:hover {
  background: #771800;
  color: #fff;
  border-color: #771800;
}

.btn-vimeo {
  background: #1ab7ea;
  border-color: #1ab7ea;
  color: #fff;
}

.btn-vimeo:active,
.btn-vimeo:focus,
.btn-vimeo:hover {
  background: #1295bf;
  color: #fff;
  border-color: #1295bf;
}

.card {
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all .5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.5rem;
  box-shadow: 0px 12px 23px 0px rgba(63, 154, 224, 0.04);
  height: calc(100% - 30px);
}

@media only screen and (max-width: 575px) {
  .card {
    margin-bottom: 0.938rem;
    height: calc(100% - 0.938rem);
  }
}

.card-body {
  padding: 1.875rem;
}

@media only screen and (max-width: 575px) {
  .card-body {
    padding: 1rem;
  }
}

.card-title {
  font-size: 20px;
  font-weight: 500;
  color: #000;
  text-transform: capitalize;
}

.card-title--large {
  font-size: 1.5rem;
}

.card-title--medium {
  font-size: 1rem;
}

.card-title--small {
  font-size: 0.875rem;
}

.card-header {
  border-color: #f0f1f5;
  position: relative;
  background: transparent;
  padding: 1.5rem 1.875rem 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media only screen and (max-width: 575px) {
  .card-header {
    padding: 1.25rem 1rem 1.25rem;
  }
}

[data-theme-version="dark"] .card-header {
  border-color: #333a54;
}

.card-header .card-title {
  margin-bottom: 0px;
}

.card-header .subtitle {
  padding-top: 5px;
  font-size: 14px;
  line-height: 1.5;
}

.card-footer {
  border-color: #f0f1f5;
  background: transparent;
  padding: 1.25rem 1.875rem 1.25rem;
}

[data-theme-version="dark"] .card-footer {
  border-color: #333a54;
}

@media only screen and (max-width: 575px) {
  .card-footer {
    padding: 1rem;
  }
}

.transparent-card.card {
  background: transparent;
  border: 1px solid transparent;
  box-shadow: none;
}

.card-action>a {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  border-color: transparent;
  text-align: center;
  background: black;
  color: #fff;
  margin-right: 8px;
}

[data-theme-version="dark"] .card-action>a {
  background: #181f39;
}

.card-action>a:last-child {
  margin-right: 0;
}

.card-action>a:hover,
.card-action>a:focus {
  background: black;
}

[data-theme-version="dark"] .card-action>a:hover,
[data-theme-version="dark"] .card-action>a:focus {
  background: #181f39;
}

.card-action>a i,
.card-action>a span {
  font-size: 1rem;
}

.card-action .dropdown {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  border-color: transparent;
  text-align: center;
  margin-right: 8px;
  top: -2px;
  position: relative;
  display: inline-block;
  background: black;
  color: #00ADEE;
}

[data-theme-version="dark"] .card-action .dropdown {
  background: #181f39;
}

.card-action .dropdown:hover,
.card-action .dropdown:focus {
  background: black;
}

[data-theme-version="dark"] .card-action .dropdown:hover,
[data-theme-version="dark"] .card-action .dropdown:focus {
  background: #181f39;
}

.card-action .dropdown .btn {
  padding: 0;
  line-height: 27px;
  color: #fff;
}

.card-action .dropdown .btn:focus {
  box-shadow: none;
}

.card-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999999;
  overflow: auto;
}

.card-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 999;
}

.card-loader i {
  margin: 0 auto;
  background: #7425d9;
  padding: 10px;
  border-radius: 50%;
  color: #fff;
  font-size: 1rem;
}

.rotate-refresh {
  animation: mymove 0.8s infinite linear;
  display: inline-block;
}

.card-header .date_picker {
  display: inline-block;
  padding: 8px;
  border: 1px solid #f0f1f5;
  cursor: pointer;
  border-radius: .375rem;
}

.card-header .border-0 {
  padding-bottom: 0;
}

@keyframes mymove {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.carousel-custom-prev,
.carousel-custom-next {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  display: inline-block;
  border-radius: 50%;
  background: #fff;
  text-align: center;
}

.carousel-custom-prev i,
.carousel-custom-next i {
  font-size: 1rem;
}

.carousel-custom-prev:hover,
.carousel-custom-next:hover {
  background: linear-gradient(to right, rgba(245, 60, 121, 0.99) 0%, rgba(246, 104, 47, 0.99) 100%);
  color: #fff;
}

.carousel-custom-next {
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}

.carousel-custom-prev {
  position: absolute;
  top: 50%;
  left: 30px;
  transform: translateY(-50%);
}

.carousel-caption {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.78);
  z-index: 0;
}

.carousel-caption h5 {
  color: #fff;
  font-size: 1.8rem;
}

.carousel-caption p {
  margin-bottom: 0;
}

.dropdown-toggle:focus {
  box-shadow: none !important;
}

.dropdown-outline {
  border: 0.1rem solid #00ADEE;
}

.dropdown-menu {
  font-size: inherit;
  border: 0;
  box-shadow: 0 10px 40px 0 rgba(32, 28, 69, 0.1);
  margin-top: 0;
  border-radius: 0;
}

.dropdown-menu .dropdown-item {
  font-size: 16px;
  color: #7e7e7e;
  padding: 0.5rem 1.75rem;
}

@media only screen and (max-width: 1400px) {
  .dropdown-menu .dropdown-item {
    padding: 0.375rem 1rem;
    font-size: 14px;
  }
}

.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus,
.dropdown-menu .dropdown-item:active,
.dropdown-menu .dropdown-item.active {
  color: #00ADEE;
  background: #F4F5F9;
}

.dropdown-menu .dropdown-item.active,
.dropdown-menu .dropdown-item:active {
  color: #00ADEE !important;
}

[direction="rtl"] .dropdown-menu {
  right: auto !important;
}

.dropdown-toggle-split {
  padding: 0 10px;
  opacity: 0.85;
}

.dropdown-toggle-split:after {
  margin-left: 0 !important;
}

.dropdown-toggle-split:active,
.dropdown-toggle-split:focus,
.dropdown-toggle-split:hover {
  opacity: 1;
}

.dropleft .dropdown-toggle:before,
.dropright .dropdown-toggle:before,
.dropup .dropdown-toggle:after,
.dropdown-toggle:after {
  content: "\\f107";
  font-family: FontAwesome;
  border: 0;
  vertical-align: middle;
  margin-left: 0.25em;
  line-height: 1;
}

.dropup .dropdown-toggle:after {
  content: "\\f106";
}

.dropleft .dropdown-toggle::before {
  content: "\\f104";
}

.dropright .dropdown-toggle::before {
  content: "\\f105";
}

.dropright .dropdown-toggle::after {
  content: none;
}

.custom-dropdown {
  display: inline-block;
  margin-bottom: 1rem;
}

.custom-dropdown .dropdown-menu {
  border: 0px;
  min-width: 160px;
}

.card-action .custom-dropdown {
  margin: 0px;
  background: #dac6f5;
}

.card-action .custom-dropdown.show,
.card-action .custom-dropdown:focus,
.card-action .custom-dropdown:hover {
  background: #00ADEE;
  color: #fff;
}

.card-action .custom-dropdown i {
  display: inline-block;
  padding-top: 9px;
}

.dropdown .dropdown-dots {
  position: relative;
  height: 5px;
  width: 5px;
  background: rgba(177, 177, 177, 0.4);
  border-radius: 5px;
  display: block;
}

.dropdown .dropdown-dots:after,
.dropdown .dropdown-dots:before {
  content: "";
  height: 5px;
  width: 5px;
  background: rgba(177, 177, 177, 0.4);
  position: absolute;
  border-radius: 5px;
}

.dropdown .dropdown-dots:after {
  right: -8px;
}

.dropdown .dropdown-dots:before {
  left: -8px;
}

.dropdown .dropdown-dots.text-white {
  background: rgba(255, 255, 255, 0.7);
}

.dropdown .dropdown-dots.text-white:after,
.dropdown .dropdown-dots.text-white:before {
  background: rgba(255, 255, 255, 0.7);
}

.grid-col {
  padding: 0.5rem !important;
  background: #f2f4fa;
}

.row.grid {
  margin-bottom: 1.5rem;
  text-align: center;
}

.row.grid .grid-col:first-child {
  text-align: left;
}

.label {
  display: inline-block;
  text-align: center;
  font-size: 0.75rem;
  padding: .2rem .8rem;
}

.label-fixed {
  width: 7.5rem;
  padding: .6rem 0;
}

.label-fixed-lg {
  width: 9.5rem;
  padding: .6rem 0;
}

.label-big {
  width: 16.8rem;
  font-size: 1.4rem;
  padding: 1.1rem 0;
}

.label-xl {
  width: 10.5rem;
  padding: 1.1rem 0;
  font-size: 1.5rem;
}

.label-lg {
  width: 9.5rem;
  padding: 1.1rem 0;
}

.label-md {
  width: 8.5rem;
  padding: 1.1rem 0;
}

.label-sm {
  width: 7.5rem;
  padding: 1.1rem 0;
}

.label-default {
  background: #ADB6C7;
}

.label-primary {
  background: #00ADEE;
  color: #fff;
}

.label-secondary {
  background: #3F9AE0;
  color: #fff;
}

.label-info {
  background: #2D28FF;
  color: #fff;
}

.label-success {
  background: #2BC155;
  color: #fff;
}

.label-warning {
  background: #FF9B52;
  color: #fff;
}

.label-danger {
  background: #F94687;
  color: #fff;
}

.label-light {
  background: #F4F5F9;
  color: #000;
}

.label-dark {
  background: #B1B1B1;
  color: #fff;
}

code {
  word-break: break-word;
  padding: 2px 5px;
  border-radius: 3px;
  background: #fee9f1;
  color: #F94687;
}

[data-theme-version="dark"] code {
  background: rgba(249, 70, 135, 0.1);
}

.heading-labels {
  color: #333333;
}

.heading-labels>* {
  margin-bottom: .8rem;
}

.heading-labels h1 .label {
  font-size: 18px;
  font-weight: normal;
  padding: .4rem .9rem;
}

.heading-labels h2 .label {
  font-size: 16px;
  font-weight: normal;
  padding: 0.3rem .9rem;
}

.heading-labels h3 .label {
  font-size: 14px;
  font-weight: normal;
}

.heading-labels h4 .label {
  font-size: 12px;
  font-weight: normal;
}

.heading-labels h5 .label {
  font-size: 12px;
  font-weight: normal;
}

.heading-labels h6 .label {
  font-size: 12px;
  font-weight: normal;
}

.list-group-item {
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid #f0f1f5;
  padding: 1rem 1.5rem;
  border-radius: 0;
}

[data-theme-version="dark"] .list-group-item {
  border-color: #333a54;
}

.list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.list-group-item:last-child {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #fff;
  background-color: #3F9AE0;
  border-color: #3F9AE0;
}

[class*="bg-"] .list-group-item {
  border-color: rgba(255, 255, 255, 0.05);
}

.bg-warning .list-group-item {
  border-color: rgba(0, 0, 0, 0.05);
}

.media img {
  border-radius: 3px;
}

.vertical-card__menu:hover {
  box-shadow: none;
}

.vertical-card__menu--image {
  text-align: center;
}

.vertical-card__menu--image img {
  width: 100%;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.vertical-card__menu--status.closed {
  background: #F94687;
}

.vertical-card__menu--status.closed:after {
  border-top: 10px solid #F94687;
}

.vertical-card__menu--status.closed .ribbon-curve {
  border-top: 11px solid #F94687;
  border-bottom: 10px solid #F94687;
}

.vertical-card__menu--desc p {
  margin-bottom: 0.625rem;
}

.vertical-card__menu--price {
  font-size: 1.25rem;
  margin: 0;
  font-weight: 700;
}

.vertical-card__menu--rating {
  font-size: 0.75rem;
}

.vertical-card__menu--title {
  font-weight: 700;
}

.vertical-card__menu--button button {
  font-size: 0.75rem;
}

.vertical-card__menu .card-footer {
  padding: 15px 20px;
  background-color: #f0f1f5;
  border-top: none;
}

@media only screen and (min-width: 1200px) and (max-width: 1440px) {
  .vertical-card__menu .card-footer {
    padding: 15px;
  }
}

.vertical-card__menu .card-footer span {
  color: #B1B1B1;
  margin-right: 0.3125rem;
}

.horizontal-card__menu {
  box-shadow: 0 0 7px rgba(173, 173, 173, 0.32);
  display: flex;
  flex-direction: row;
}

@media (max-width: 575.98px) {
  .horizontal-card__menu {
    display: block;
  }
}

.horizontal-card__menu .card-body {
  padding: 0;
  padding: 20px 30px;
}

.horizontal-card__menu--image {
  flex-basis: 30%;
  max-width: 30%;
}

.horizontal-card__menu--image img {
  height: 100%;
  width: 100%;
}

@media (max-width: 575.98px) {
  .horizontal-card__menu--image {
    max-width: unset;
    flex-basis: 100%;
  }
}

.horizontal-card__menu--title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.3125rem;
}

.horizontal-card__menu--fav {
  margin-right: 0.5rem;
}

.horizontal-card__menu--price {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.horizontal-card__menu--rating {
  font-size: 0.625rem;
}

.horizontal-card__menu--footer {
  margin-top: 10px;
}

.prev_price {
  text-decoration: line-through;
  font-size: 80%;
  opacity: 0.5;
}

.modal-header {
  padding: 1rem 1.875rem;
}

.modal-header .close {
  padding: 0.875rem 1.815rem;
  margin: 0;
  position: absolute;
  right: 0;
  float: none;
  top: 0;
  font-size: 30px;
  font-weight: 100;
}

.modal-body {
  padding: 1.875rem;
}

.modal-footer {
  padding: 1rem 1.875rem;
}

.modal-content {
  border-radius: 1.25rem;
}

.modal-backdrop {
  z-index: 10 !important;
}

.pagination .page-item .page-link:hover {
  background: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
}

.pagination .page-item.active .page-link {
  background: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
}

.pagination {
  margin-bottom: 20px;
}

.pagination .page-item.page-indicator .page-link {
  padding: .65rem .8rem;
  font-size: 14px;
}

.pagination .page-item.page-indicator:hover .page-link {
  color: #B1B1B1;
}

.pagination .page-item .page-link {
  text-align: center;
  z-index: 2;
  padding: 0.55rem 1rem;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.15);
  color: #B1B1B1;
  border: 1px solid #f0f1f5;
}

[data-theme-version="dark"] .pagination .page-item .page-link {
  border-color: #333a54;
  color: #828690;
  background: rgba(255, 255, 255, 0);
}

.pagination .page-item .page-link:hover i,
.pagination .page-item .page-link span {
  color: #fff;
}

.pagination .page-item .page-link:focus {
  outline: 0;
  box-shadow: none;
}

.pagination .page-item .page-link:hover {
  background: #00ADEE;
  color: #fff;
  border-color: #00ADEE;
}

.pagination .page-item.active .page-link {
  background-color: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
  box-shadow: 0 10px 20px 0px rgba(135, 67, 223, 0.2);
}

[data-theme-version="dark"] .pagination .page-item.active .page-link {
  color: #fff;
}

.pagination .page-item .page-link {
  color: #B1B1B1;
  transition: all 0.5s;
}

.pagination .page-item:last-child .page-link {
  margin-right: 0;
}

[direction="rtl"] .pagination .page-item:first-child .page-link {
  margin-right: 0;
}

.pagination.no-bg li:not(.page-indicator):not(.active) .page-link {
  background: transparent;
  border-color: transparent;
}

.pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {
  background: #00ADEE;
  border-color: #00ADEE;
}

[data-theme-version="dark"] .pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {
  background: #00ADEE;
  border-color: #00ADEE;
}

.pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {
  background: #F94687;
  border-color: #F94687;
}

[data-theme-version="dark"] .pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {
  background: #F94687;
  border-color: #F94687;
}

.pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {
  background: #2D28FF;
  border-color: #2D28FF;
}

[data-theme-version="dark"] .pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {
  background: #2D28FF;
  border-color: #2D28FF;
}

.pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {
  background: #FF9B52;
  border-color: #FF9B52;
}

[data-theme-version="dark"] .pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {
  background: #FF9B52;
  border-color: #FF9B52;
}

.pagination-primary .page-item .page-link {
  background: #f6f1fd;
  border-color: #f6f1fd;
  color: #00ADEE;
}

[data-theme-version="dark"] .pagination-primary .page-item .page-link {
  background: rgba(135, 67, 223, 0.2);
  border-color: transparent;
  color: #00ADEE;
}

.pagination-primary .page-item:hover .page-link,
.pagination-primary .page-item.active .page-link {
  background: #00ADEE;
  border-color: #00ADEE;
  box-shadow: 0 10px 20px 0px rgba(135, 67, 223, 0.2);
}

[data-theme-version="dark"] .pagination-primary .page-item:hover .page-link,
[data-theme-version="dark"] .pagination-primary .page-item.active .page-link {
  color: #fff;
}

.pagination-danger .page-item .page-link {
  background: #fff3f7;
  border-color: #fff3f7;
  color: #F94687;
}

[data-theme-version="dark"] .pagination-danger .page-item .page-link {
  background: rgba(249, 70, 135, 0.15);
  border-color: transparent;
  color: #F94687;
}

.pagination-danger .page-item:hover .page-link,
.pagination-danger .page-item.active .page-link {
  background: #F94687;
  border-color: #F94687;
  box-shadow: 0 10px 20px 0px rgba(249, 70, 135, 0.2);
}

[data-theme-version="dark"] .pagination-danger .page-item:hover .page-link,
[data-theme-version="dark"] .pagination-danger .page-item.active .page-link {
  color: #fff;
}

.pagination-info .page-item .page-link {
  background: #dbdbff;
  border-color: #dbdbff;
  color: #2D28FF;
}

[data-theme-version="dark"] .pagination-info .page-item .page-link {
  background: rgba(45, 40, 255, 0.1);
  border-color: transparent;
  color: #2D28FF;
}

.pagination-info .page-item:hover .page-link,
.pagination-info .page-item.active .page-link {
  background: #2D28FF;
  border-color: #2D28FF;
  box-shadow: 0 10px 20px 0px rgba(45, 40, 255, 0.2);
}

.pagination-warning .page-item .page-link {
  background: #fff3eb;
  border-color: #fff3eb;
  color: #FF9B52;
}

[data-theme-version="dark"] .pagination-warning .page-item .page-link {
  background: rgba(255, 155, 82, 0.1);
  border-color: transparent;
  color: #FF9B52;
}

.pagination-warning .page-item:hover .page-link,
.pagination-warning .page-item.active .page-link {
  background: #FF9B52;
  border-color: #FF9B52;
  box-shadow: 0 10px 20px 0px rgba(255, 155, 82, 0.2);
}

.pagination-gutter .page-item {
  margin-right: 7px;
}

.pagination-gutter .page-item .page-link {
  border-radius: 1.25rem !important;
}

.pagination-circle .page-item {
  margin-right: 7px;
}

.pagination-circle .page-item .page-link,
.pagination-circle .page-item.page-indicator .page-link {
  width: 40px;
  height: 40px;
  padding: 0;
  line-height: 40px;
  border-radius: 50% !important;
  padding: 0;
}

.pagination.pagination-md .page-item .page-link {
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}

.pagination.pagination-sm .page-item.page-indicator .page-link {
  font-size: 12px;
}

.pagination.pagination-sm .page-item .page-link {
  padding: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}

.pagination.pagination-xs .page-item.page-indicator .page-link {
  font-size: 10px;
}

.pagination.pagination-xs .page-item .page-link {
  padding: 0;
  width: 25px;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
}

.popover {
  border: 2px solid #3F9AE0;
  min-width: 210px;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

[data-theme-version="dark"] .popover {
  background-color: #181f39;
}

.popover-header {
  background: #3F9AE0;
  color: #fff;
  font-weight: 300;
  border-radius: 0;
}

.popover-header::before {
  border-bottom: 0 !important;
}

.popover-body {
  font-size: 0.75rem;
}

[data-theme-version="dark"] .popover .popover-header {
  border-color: #1e2746;
}

.bootstrap-popover-wrapper .bootstrap-popover:not(:last-child) {
  margin-right: 8px;
}

.bootstrap-popover-wrapper .bootstrap-popover {
  margin-bottom: .5rem;
}

.bootstrap-popover-wrapper .bootstrap-popover button:hover,
.bootstrap-popover-wrapper .bootstrap-popover button:focus {
  background: #00ADEE;
  color: #fff;
  box-shadow: none;
}

.bs-popover-top .arrow::after,
.bs-popover-auto[x-placement^="top"] .arrow::after,
.bs-popover-auto[x-placement^="top"] .arrow::after {
  bottom: 0px;
  border-top-color: #3F9AE0;
}

.bs-popover-left .arrow::after,
.bs-popover-auto[x-placement^="left"] .arrow::after,
.bs-popover-auto[x-placement^="left"] .arrow::after {
  right: 0px;
  border-left-color: #3F9AE0;
}

.bs-popover-right .arrow::after,
.bs-popover-auto[x-placement^="right"] .arrow::after,
.bs-popover-auto[x-placement^="right"] .arrow::after {
  left: 0px;
  border-right-color: #3F9AE0;
}

.bs-popover-bottom .arrow::after,
.bs-popover-auto[x-placement^="bottom"] .arrow::after,
.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  top: 0px;
  border-bottom-color: #3F9AE0;
}

.note-popover {
  display: none;
}

.progress-bar {
  background-color: #00ADEE;
}

.progress-bar-primary {
  background-color: #00ADEE;
}

.progress-bar-success {
  background-color: #2BC155;
}

.progress-bar-info {
  background-color: #2D28FF;
}

.progress-bar-danger {
  background-color: #F94687;
}

.progress-bar-warning {
  background-color: #FF9B52;
}

.progress-bar-pink {
  background-color: #e83e8c;
}

.progress {
  height: 6px;
  overflow: hidden;
  border-radius: 1.25rem;
}

[data-theme-version="dark"] .progress {
  background-color: #181f39;
}

.progress-bar {
  border-radius: 4px;
}

.progress-vertical {
  display: inline-block;
  margin-bottom: 0;
  margin-right: 2rem;
  min-height: 17rem;
  position: relative;
}

@media (max-width: 991.98px) {
  .progress-vertical {
    margin-right: 1rem;
  }
}

.progress-vertical-bottom {
  display: inline-block;
  margin-bottom: 0;
  margin-right: 2rem;
  min-height: 17rem;
  position: relative;
  transform: rotate(180deg);
}

@media (max-width: 991.98px) {
  .progress-vertical-bottom {
    margin-right: 1rem;
  }
}

.progress-animated {
  animation-duration: 5s;
  animation-name: myanimation;
  transition: all 5s ease 0s;
}

@keyframes myanimation {
  0% {
    width: 0;
  }
}

@keyframes myanimation {
  0% {
    width: 0;
  }
}

.ribbon {
  position: absolute;
  z-index: 1;
  text-transform: uppercase;
}

.ribbon__one {
  top: 15px;
  left: -11px;
  min-height: 20px;
  min-width: 52px;
  text-align: center;
  padding: 3px 10px;
  background: #3AB54B;
  color: #fff;
  font-size: 0.625rem;
}

.ribbon__one::after {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 10px solid #239132;
  border-left: 11px solid transparent;
  left: 0;
  content: "";
  bottom: -10px;
}

.ribbon__two {
  width: 50px;
  height: 50px;
  display: inline-block;
  background: #FF9B52;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  right: 15px;
  top: 15px;
  border-radius: 3px;
}

.ribbon__three {
  left: -1.875rem;
  top: 0.875rem;
  width: 6.875rem;
  height: 1.5625rem;
  background-color: #F94687;
  clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);
  transform: rotate(-45deg);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.ribbon__four {
  left: 8px;
  top: -8px;
  width: 110px;
  height: 50px;
  background-color: #00ADEE;
  z-index: auto;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ribbon__four:after {
  right: -5px;
}

.ribbon__four:before {
  left: -5px;
}

.ribbon__four:after,
.ribbon__four:before {
  z-index: -1;
  background-color: #bf9aee;
  top: 3px;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  width: 10px;
  position: absolute;
}

.ribbon__five {
  left: -1.875rem;
  top: 0.625rem;
  width: 6.875rem;
  height: 1.875rem;
  background-color: #00ADEE;
  transform: rotate(-45deg);
  font-size: 0.75rem;
  color: #fff;
  padding-bottom: 0.3125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.ribbon__five::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 50px 50px 50px;
  border-color: transparent transparent #00ADEE transparent;
  left: 0.25rem;
  top: -2.8125rem;
}

.ribbon__six {
  left: 0;
  top: 1.125rem;
  width: 6.875rem;
  height: 2.375rem;
  background-color: #00ADEE;
  clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);
  display: flex;
  font-size: 1.25rem;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.ribbon-curve {
  position: absolute;
  top: 0;
  right: -6px;
  width: 10px;
  height: 11px;
  border-top: 11px solid #3AB54B;
  border-bottom: 10px solid #3AB54B;
  border-right: 5px solid transparent;
}

.jsgrid-grid-body::-webkit-scrollbar,
.dataTables_scrollBody::-webkit-scrollbar,
.table-responsive::-webkit-scrollbar {
  background-color: #F5F5F5;
  width: 8px;
  height: 8px;
}

.jsgrid-grid-body::-webkit-scrollbar-track,
.dataTables_scrollBody::-webkit-scrollbar-track,
.table-responsive::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

.jsgrid-grid-body::-webkit-scrollbar-thumb,
.dataTables_scrollBody::-webkit-scrollbar-thumb,
.table-responsive::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #7e7e7e;
}

.multi-steps>li.is-active:before,
.multi-steps>li.is-active~li:before {
  content: counter(stepNum);
  font-family: inherit;
  font-weight: 400;
}

.multi-steps>li.is-active:after,
.multi-steps>li.is-active~li:after {
  background-color: #f0f1f5;
}

.multi-steps {
  display: table;
  table-layout: fixed;
  width: 100%;
}

.multi-steps>li {
  counter-increment: stepNum;
  text-align: center;
  display: table-cell;
  position: relative;
  color: #00ADEE;
}

@media (max-width: 575.98px) {
  .multi-steps>li {
    font-size: 0.75rem;
  }
}

.multi-steps>li:before {
  content: '\\2713';
  display: block;
  margin: 0 auto 4px;
  background-color: #fff;
  width: 25px;
  height: 25px;
  line-height: 22px;
  text-align: center;
  font-weight: bold;
  position: relative;
  z-index: 1;
  border-width: 2px;
  border-style: solid;
  border-color: #00ADEE;
  border-radius: 5px;
}

@media (max-width: 575.98px) {
  .multi-steps>li:before {
    width: 25px;
    height: 25px;
    line-height: 21px;
  }
}

.multi-steps>li:after {
  content: '';
  height: 2px;
  width: 100%;
  background-color: #00ADEE;
  position: absolute;
  top: 12px;
  left: 50%;
}

[direction="rtl"] .multi-steps>li:after {
  left: auto;
  right: 50%;
}

@media (max-width: 575.98px) {
  .multi-steps>li:after {
    top: 12px;
  }
}

.multi-steps>li:last-child:after {
  display: none;
}

.multi-steps>li.is-active:before {
  background-color: #fff;
  border-color: #00ADEE;
}

.multi-steps>li.is-active~li {
  color: #7e7e7e;
}

.multi-steps>li.is-active~li:before {
  background-color: #f0f1f5;
  border-color: #f0f1f5;
}

.nav-pills .nav-link {
  border-radius: 1.25rem;
  padding: 0.75rem 1.25rem;
}

.default-tab .nav-link {
  background: transparent;
  border-radius: 0px;
  font-weight: 500;
}

.default-tab .nav-link i {
  display: inline-block;
  transform: scale(1.5);
  color: #00ADEE;
}

.default-tab .nav-link:focus,
.default-tab .nav-link:hover,
.default-tab .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff #ebeef6;
  border-radius: 1.25rem 1.25rem 0 0;
  color: #00ADEE;
}

[data-theme-version="dark"] .default-tab .nav-link:focus,
[data-theme-version="dark"] .default-tab .nav-link:hover,
[data-theme-version="dark"] .default-tab .nav-link.active {
  background-color: rgba(135, 67, 223, 0.2);
  border-color: transparent transparent #333a54 transparent;
}

.custom-tab-1 .nav-link {
  background: transparent;
  border-radius: 0px;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  border-width: 0 0px 3px 0;
}

.custom-tab-1 .nav-link i {
  display: inline-block;
  transform: scale(1.5);
  color: #00ADEE;
}

.custom-tab-1 .nav-link:focus,
.custom-tab-1 .nav-link:hover,
.custom-tab-1 .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #00ADEE;
  border-radius: 0;
  color: #00ADEE;
  border-width: 0 0px 3px 0;
}

[data-theme-version="dark"] .custom-tab-1 .nav-link:focus,
[data-theme-version="dark"] .custom-tab-1 .nav-link:hover,
[data-theme-version="dark"] .custom-tab-1 .nav-link.active {
  background-color: rgba(135, 67, 223, 0.2);
}

.nav-pills.light .nav-link.active,
.nav-pills.light .show>.nav-link {
  background: #f6f1fd;
  color: #00ADEE;
  box-shadow: none;
}

[data-theme-version="dark"] .nav-pills.light .nav-link.active,
[data-theme-version="dark"] .nav-pills.light .show>.nav-link {
  background: rgba(135, 67, 223, 0.2);
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  box-shadow: 0 0 20px 0 rgba(135, 67, 223, 0.2);
}

.tooltip-wrapper button:not(:last-child) {
  margin-right: 8px;
}

.tooltip-wrapper button:hover {
  background: #00ADEE;
  color: #fff;
}

.tooltip-wrapper button {
  margin-bottom: .5rem;
}

.tooltip-wrapper button:focus {
  box-shadow: none;
}

.tooltip-inner {
  border-radius: 0;
  background: #333333;
  font-size: 12px;
  font-weight: 300;
  padding: 0.35rem 0.7rem;
}

.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  border-bottom-color: #333333;
}

.bs-tooltip-right .arrow::before,
.bs-tooltip-auto[x-placement^="right"] .arrow::before,
.bs-tooltip-auto[x-placement^="right"] .arrow::before {
  border-right-color: #333333;
}

.bs-tooltip-left .arrow::before,
.bs-tooltip-auto[x-placement^="left"] .arrow::before,
.bs-tooltip-auto[x-placement^="left"] .arrow::before {
  border-left-color: #333333;
}

.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  border-top-color: #333333;
}

.widget-timeline .timeline {
  list-style: none;
  position: relative;
}

.widget-timeline .timeline:before {
  top: 20px;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 3px;
  left: 9px;
  margin-right: -1.5px;
  background: #F4F5F9;
}

[data-theme-version="dark"] .widget-timeline .timeline:before {
  background: #333a54;
}

[direction="rtl"] .widget-timeline .timeline:before {
  left: auto;
  right: 9px;
  margin-right: auto;
  margin-left: -1.5px;
}

.widget-timeline .timeline>li {
  margin-bottom: 15px;
  position: relative;
}

.widget-timeline .timeline>li:before {
  content: " ";
  display: table;
}

.widget-timeline .timeline>li:after {
  content: " ";
  display: table;
  clear: both;
}

.widget-timeline .timeline>li>.timeline-panel {
  border-radius: 1.25rem;
  padding: 15px 20px;
  position: relative;
  display: block;
  margin-left: 40px;
  border-width: 1px;
  border-style: solid;
}

.widget-timeline .timeline>li>.timeline-panel span {
  font-size: 12px;
  display: block;
  margin-bottom: 5px;
  opacity: 0.8;
  letter-spacing: 1px;
}

.widget-timeline .timeline>li>.timeline-panel p {
  font-size: 14px;
}

.widget-timeline .timeline>li>.timeline-panel:after {
  content: "";
  width: 10px;
  height: 10px;
  background: inherit;
  border-color: inherit;
  border-style: solid;
  border-width: 0px 0px 1px 1px;
  display: block;
  position: absolute;
  left: -5px;
  transform: rotate(45deg);
  top: 15px;
}

.widget-timeline .timeline>li>.timeline-badge {
  border-radius: 50%;
  height: 22px;
  left: 0;
  position: absolute;
  top: 10px;
  width: 22px;
  border-width: 2px;
  border-style: solid;
  background: #fff;
  padding: 4px;
}

[data-theme-version="dark"] .widget-timeline .timeline>li>.timeline-badge {
  background-color: #1e2746;
}

.widget-timeline .timeline>li>.timeline-badge:after {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 100%;
  display: block;
}

[direction="rtl"] .widget-timeline .timeline>li>.timeline-badge {
  left: auto;
  right: 19px;
}

.widget-timeline .timeline-body>p {
  font-size: 12px;
}

.widget-timeline .timeline-badge.primary {
  border-color: #f6f1fd;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.primary {
  border-color: rgba(135, 67, 223, 0.2);
}

.widget-timeline .timeline-badge.primary:after {
  background-color: #00ADEE !important;
  box-shadow: 0 5px 10px 0 rgba(135, 67, 223, 0.2);
}

.widget-timeline .timeline-badge.primary+.timeline-panel {
  background: #f6f1fd;
  border-color: #f6f1fd;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.primary+.timeline-panel {
  border-color: transparent;
  background-color: rgba(135, 67, 223, 0.2);
}

.widget-timeline .timeline-badge.success {
  border-color: #e3f9e9;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.success {
  border-color: rgba(43, 193, 85, 0.1);
}

.widget-timeline .timeline-badge.success:after {
  background-color: #2BC155 !important;
  box-shadow: 0 5px 10px 0 rgba(43, 193, 85, 0.2);
}

.widget-timeline .timeline-badge.success+.timeline-panel {
  background: #e3f9e9;
  border-color: #e3f9e9;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.success+.timeline-panel {
  background-color: rgba(43, 193, 85, 0.1);
  border-color: transparent;
}

.widget-timeline .timeline-badge.warning {
  border-color: #fff3eb;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.warning {
  border-color: rgba(255, 155, 82, 0.1);
}

.widget-timeline .timeline-badge.warning:after {
  background-color: #FF9B52 !important;
  box-shadow: 0 5px 10px 0 rgba(255, 155, 82, 0.2);
}

.widget-timeline .timeline-badge.warning+.timeline-panel {
  background: #fff3eb;
  border-color: #fff3eb;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.warning+.timeline-panel {
  background-color: rgba(255, 155, 82, 0.1);
  border-color: transparent;
}

.widget-timeline .timeline-badge.danger {
  border-color: #fff3f7;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.danger {
  border-color: rgba(249, 70, 135, 0.15);
}

.widget-timeline .timeline-badge.danger:after {
  background-color: #F94687 !important;
  box-shadow: 0 5px 10px 0 rgba(249, 70, 135, 0.2);
}

.widget-timeline .timeline-badge.danger+.timeline-panel {
  background: #fff3f7;
  border-color: #fff3f7;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.danger+.timeline-panel {
  background-color: rgba(249, 70, 135, 0.15);
  border-color: transparent;
}

.widget-timeline .timeline-badge.info {
  border-color: #dbdbff;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.info {
  border-color: rgba(45, 40, 255, 0.1);
}

.widget-timeline .timeline-badge.info:after {
  background-color: #2D28FF !important;
  box-shadow: 0 5px 10px 0 rgba(45, 40, 255, 0.2);
}

.widget-timeline .timeline-badge.info+.timeline-panel {
  background: #dbdbff;
  border-color: #dbdbff;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.info+.timeline-panel {
  background-color: rgba(45, 40, 255, 0.1);
  border-color: transparent;
}

.widget-timeline .timeline-badge.dark {
  border-color: #f1f1f1;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.dark {
  border-color: rgba(177, 177, 177, 0.35);
}

.widget-timeline .timeline-badge.dark:after {
  background-color: #B1B1B1 !important;
  box-shadow: 0 5px 10px 0 rgba(177, 177, 177, 0.2);
}

.widget-timeline .timeline-badge.dark+.timeline-panel {
  background: #f1f1f1;
  border-color: #f1f1f1;
}

[data-theme-version="dark"] .widget-timeline .timeline-badge.dark+.timeline-panel {
  background-color: rgba(177, 177, 177, 0.35);
  border-color: transparent;
}

.widget-timeline.style-1 .timeline-panel {
  background: transparent;
}

.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge+.timeline-panel {
  background: transparent !important;
  border-style: solid;
  border-width: 0 0 0 5px;
  border-radius: 0;
  padding: 5px 10px 5px 15px;
}

.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge+.timeline-panel:after {
  border: 0;
  left: -9px;
  width: 7px;
  height: 7px;
}

.widget-timeline.style-1 .timeline .timeline-badge.primary+.timeline-panel {
  border-color: #00ADEE;
}

.widget-timeline.style-1 .timeline .timeline-badge.primary+.timeline-panel:after {
  background: #00ADEE;
}

.widget-timeline.style-1 .timeline .timeline-badge.success+.timeline-panel {
  border-color: #2BC155;
}

.widget-timeline.style-1 .timeline .timeline-badge.success+.timeline-panel:after {
  background: #2BC155;
}

.widget-timeline.style-1 .timeline .timeline-badge.warning+.timeline-panel {
  border-color: #FF9B52;
}

.widget-timeline.style-1 .timeline .timeline-badge.warning+.timeline-panel:after {
  background: #FF9B52;
}

.widget-timeline.style-1 .timeline .timeline-badge.danger+.timeline-panel {
  border-color: #F94687;
}

.widget-timeline.style-1 .timeline .timeline-badge.danger+.timeline-panel:after {
  background: #F94687;
}

.widget-timeline.style-1 .timeline .timeline-badge.info+.timeline-panel {
  border-color: #2D28FF;
}

.widget-timeline.style-1 .timeline .timeline-badge.info+.timeline-panel:after {
  background: #2D28FF;
}

.widget-timeline.style-1 .timeline .timeline-badge.dark+.timeline-panel {
  border-color: #B1B1B1;
}

.widget-timeline.style-1 .timeline .timeline-badge.dark+.timeline-panel:after {
  background: #B1B1B1;
}

#chart_widget_4 {
  height: 255px !important;
}

#chart_widget_5 .ct-series-a .ct-line,
#chart_widget_5 .ct-series-a .ct-point {
  stroke: #46ffc8;
}

#chart_widget_5 .ct-line {
  stroke-width: 1px;
}

#chart_widget_5 .ct-point {
  stroke-width: 2px;
}

#chart_widget_5 .ct-series-a .ct-area {
  fill: #43d66c;
}

#chart_widget_5 .ct-area {
  fill-opacity: 1;
}

#chart_widget_6 .ct-series-a .ct-line,
#chart_widget_6 .ct-series-a .ct-point {
  stroke: #2D28FF;
}

#chart_widget_6 .ct-line {
  stroke-width: 2px;
}

#chart_widget_6 .ct-point {
  stroke-width: 5px;
}

#chart_widget_6 .ct-series-a .ct-area {
  fill: #2D28FF;
}

#chart_widget_6 .ct-area {
  fill-opacity: .5;
}

#chart_widget_8 {
  height: 255px;
}

#chart_widget_8 .ct-series-a .ct-line,
#chart_widget_8 .ct-series-a .ct-point {
  stroke: #2D28FF;
}

#chart_widget_8 .ct-line {
  stroke-width: 2px;
}

#chart_widget_8 .ct-point {
  stroke-width: 5px;
}

#chart_widget_8 .ct-series-a .ct-area {
  fill: #2D28FF;
}

#chart_widget_8 .ct-area {
  fill-opacity: .5;
}

#chart_widget_9,
#chart_widget_10 {
  height: 250px !important;
}

#chart_widget_11 .ct-slice-donut,
#chart_widget_12 .ct-slice-donut,
#chart_widget_13 .ct-slice-donut {
  stroke-width: 25px !important;
}

#chart_widget_11 {
  height: 270px !important;
}

#chart_widget_17 {
  height: 150px !important;
}

.chart_widget_tab_one .nav-link {
  border: 1px solid #ddd;
}

.chart_widget_tab_one .nav-link.active {
  background-color: #00ADEE;
  border: 1px solid #00ADEE;
  color: #fff;
}

.chart_widget_tab_one .nav-link.active:hover {
  border: 1px solid #00ADEE;
}

.chart_widget_tab_one .nav-link:hover {
  border: 1px solid #ddd;
}

[data-theme-version="dark"] .ccc-widget>div {
  background: #1e2746 !important;
  border-color: #333a54 !important;
}

.social-icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  text-align: center;
  background: #E5E6E7;
  margin-bottom: 0.5rem;
  font-size: 20px;
}

.social-icon i {
  color: #fff;
}

.social-icon.youtube {
  background: #FF0000;
}

.social-icon.facebook {
  background: #3b5998;
}

.social-icon.twitter {
  background: #1da1f2;
}

.social-icon2 a {
  border: 0.1rem solid #00ADEE;
  display: block;
  padding: 1rem;
  margin-top: 1.5rem;
  margin-bottom: .5rem;
  border-radius: .3rem;
  font-size: 1.6rem;
}

.social-icon2 i {
  font-size: 12px;
  color: #00ADEE;
}

.social-icon3 ul li {
  display: inline-block;
}

.social-icon3 ul li a {
  display: block;
}

.social-icon3 ul li a i {
  font-size: 1.4rem;
  padding: 1rem .7rem;
  color: #464a53;
}

.social-icon3 ul li a:hover i {
  color: #00ADEE;
}

.social-icons-muted ul li a i {
  color: #89879f;
}

.social-links a {
  padding: .5rem;
}

.widget-stat .media {
  padding: 0px 0;
  align-items: center;
}

.widget-stat .media>span {
  height: 85px;
  width: 85px;
  border-radius: 100%;
  padding: 10px 12px;
  font-size: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #464a53;
}

@media only screen and (max-width: 1400px) {
  .widget-stat .media>span {
    height: 70px;
    width: 70px;
    min-width: 70px;
  }
}

.widget-stat .media .media-body p {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
}

@media only screen and (max-width: 1400px) {
  .widget-stat .media .media-body p {
    font-size: 14px;
  }
}

[data-theme-version="dark"] .widget-stat .media .media-body p {
  color: #c4c9d5;
}

.widget-stat .media .media-body small,
.widget-stat .media .media-body .small {
  font-size: 75%;
}

.widget-stat .media .media-body h3 {
  font-size: 30px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.widget-stat .media .media-body h4 {
  font-size: 24px;
  display: inline-block;
  vertical-align: middle;
}

.widget-stat .media .media-body span {
  margin-left: 5px;
}

.widget-stat[class*="bg-"] .media>span {
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.widget-stat[class*="bg-"] .progress {
  background-color: rgba(255, 255, 255, 0.25) !important;
}

[direction="rtl"] .widget-stat .media .media-body span {
  margin-left: 0;
  margin-right: 10px;
}

.dez-widget-1 .card {
  background: #FFE7DB;
}

.dez-widget-1 .card .card-body p {
  color: #f87533;
}

.dez-widget-1 .icon {
  float: right;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 28px;
}

.bgl-primary {
  background: #f6f1fd;
  border-color: #f6f1fd;
}

[data-theme-version="dark"] .bgl-primary {
  background-color: rgba(135, 67, 223, 0.2);
  border-color: rgba(135, 67, 223, 0.2);
}

.bgl-secondary {
  background: #ddedfa;
  border-color: #ddedfa;
}

[data-theme-version="dark"] .bgl-secondary {
  background-color: rgba(63, 154, 224, 0.5);
  border-color: rgba(63, 154, 224, 0.5);
}

.bgl-success {
  background: #e3f9e9;
  border-color: #e3f9e9;
}

[data-theme-version="dark"] .bgl-success {
  background-color: rgba(43, 193, 85, 0.1);
  border-color: rgba(43, 193, 85, 0.1);
}

.bgl-warning {
  background: #fff3eb;
  border-color: #fff3eb;
}

[data-theme-version="dark"] .bgl-warning {
  background-color: rgba(255, 155, 82, 0.1);
  border-color: rgba(255, 155, 82, 0.1);
}

.bgl-danger {
  background: #fff3f7;
  border-color: #fff3f7;
}

[data-theme-version="dark"] .bgl-danger {
  background-color: rgba(249, 70, 135, 0.15);
  border-color: rgba(249, 70, 135, 0.15);
}

.bgl-info {
  background: #dbdbff;
  border-color: #dbdbff;
}

[data-theme-version="dark"] .bgl-info {
  background-color: rgba(45, 40, 255, 0.1);
  border-color: rgba(45, 40, 255, 0.1);
}

.bg-primary-light {
  background: rgba(246, 241, 253, 0.5);
}

[data-theme-version="dark"] .bg-primary-light {
  background-color: rgba(135, 67, 223, 0.05);
}

.bg-secondary-light {
  background: rgba(221, 237, 250, 0.5);
}

[data-theme-version="dark"] .bg-secondary-light {
  background-color: rgba(63, 154, 224, 0.05);
}

.bg-success-light {
  background: rgba(227, 249, 233, 0.5);
}

[data-theme-version="dark"] .bg-success-light {
  background-color: rgba(43, 193, 85, 0.05);
}

.bg-warning-light {
  background: rgba(255, 243, 235, 0.5);
}

[data-theme-version="dark"] .bg-warning-light {
  background-color: rgba(255, 155, 82, 0.05);
}

.bg-danger-light {
  background: rgba(255, 243, 247, 0.5);
}

[data-theme-version="dark"] .bg-danger-light {
  background-color: rgba(249, 70, 135, 0.05);
}

.bg-info-light {
  background: rgba(219, 219, 255, 0.5);
}

[data-theme-version="dark"] .bg-info-light {
  background-color: rgba(45, 40, 255, 0.05);
}

.bgl-dark {
  background: #f1f1f1;
  border-color: #f1f1f1;
}

.bgl-light {
  background: #F4F5F9;
  border-color: #F4F5F9;
}

.overlay-box {
  position: relative;
  z-index: 1;
}

.overlay-box:after {
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  opacity: 0.85;
  background: #00ADEE;
  z-index: -1;
}

.rating-bar {
  font-size: 13px;
}

.tdl-holder {
  margin: 0 auto;
}

.tdl-holder ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tdl-holder li {
  background-color: #fff;
  border-bottom: 1px solid #f0f1f5;
  list-style: none none;
  margin: 0;
  padding: 0;
}

.tdl-holder li span {
  margin-left: 35px;
  font-size: 1rem;
  vertical-align: middle;
  transition: all 0.2s linear;
}

[direction="rtl"] .tdl-holder li span {
  margin-left: auto;
  margin-right: 35px;
}

.tdl-holder label {
  cursor: pointer;
  display: block;
  line-height: 50px;
  padding-left: 1.5rem;
  position: relative;
  margin: 0 !important;
}

[direction="rtl"] .tdl-holder label {
  padding-left: 0;
  padding-right: 1.5rem;
}

.tdl-holder label:hover {
  background-color: #eef1f6;
  color: #B1B1B1;
}

.tdl-holder label:hover a {
  color: #F94687;
}

.tdl-holder label a {
  color: #fff;
  display: inline-block;
  line-height: normal;
  height: 100%;
  text-align: center;
  text-decoration: none;
  width: 50px;
  transition: all 0.2s linear;
  padding: 18px 0px;
  font-size: 18px;
  position: absolute;
  right: 0;
}

[direction="rtl"] .tdl-holder label a {
  right: auto;
  left: 0;
}

.tdl-holder input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  position: absolute;
}

.tdl-holder input[type=checkbox]+i {
  background-color: #fff;
  border: 1px solid #e7e7e7;
  display: block;
  height: 20px;
  position: absolute;
  top: 15px;
  width: 20px;
  z-index: 1;
  border-radius: 00px;
  font-size: 11px;
  border-radius: 4px;
}

.tdl-holder input[type=checkbox]:checked+i {
  background: #00ADEE;
  border-color: transparent;
}

.tdl-holder input[type=checkbox]:checked+i::after {
  content: "\\f00c";
  font-family: 'fontAwesome';
  display: block;
  left: 2px;
  position: absolute;
  top: -14px;
  z-index: 2;
  color: #fff;
}

.tdl-holder input[type=checkbox]:checked~span {
  text-decoration: line-through;
  position: relative;
}

.tdl-holder input[type=text] {
  background-color: #fff;
  height: 50px;
  margin-top: 29px;
  border-radius: 3px;
}

.tdl-holder input[type=text]::placeholder {
  color: #B1B1B1;
}

.widget-message p {
  font-size: 14px;
  line-height: 1.5;
}

.picker .picker__frame {
  min-width: 450px !important;
  max-width: 450px !important;
}

.picker .picker__frame .picker__box {
  padding: 20px;
  border: 0;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}

.picker .picker__frame .picker__box .picker__header {
  margin-top: 0;
}

.picker .picker__frame .picker__box .picker__header .picker__year {
  color: #00ADEE;
  font-style: inherit;
  font-size: 20px;
}

.picker .picker__frame .picker__box .picker__header .picker__nav--prev,
.picker .picker__frame .picker__box .picker__header .picker__nav--next {
  width: 40px;
  height: 40px;
  padding: 0;
  line-height: 40px;
  border-radius: 2px;
}

.picker .picker__frame .picker__box .picker__header .picker__nav--prev:before,
.picker .picker__frame .picker__box .picker__header .picker__nav--next:before {
  content: none !important;
}

.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after,
.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {
  font-family: fontawesome;
  border: 0;
  margin: 0 auto;
  font-size: 22px;
}

.picker .picker__frame .picker__box .picker__header .picker__nav--prev:hover,
.picker .picker__frame .picker__box .picker__header .picker__nav--next:hover {
  background-color: #dac6f5 !important;
  color: #00ADEE !important;
}

.picker .picker__frame .picker__box .picker__header .picker__nav--prev {
  left: 0;
}

.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after {
  content: "\\f0d9";
}

.picker .picker__frame .picker__box .picker__header .picker__nav--next {
  right: 0;
}

.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {
  content: "\\f0da";
}

.picker .picker__frame .picker__box .picker__table .picker__weekday {
  padding: 10px 0;
  font-size: 16px;
}

.picker .picker__frame .picker__box .picker__table .picker__day {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  padding: 0 !important;
  font-size: 16px;
  line-height: 40px;
  margin: auto;
  border: 0 !important;
}

.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--today:before {
  content: none !important;
}

.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--highlighted {
  border: 0 !important;
  padding: 0;
  background-color: #dac6f5 !important;
  color: #fff !important;
}

.picker .picker__frame .picker__box .picker__table .picker__day:hover {
  background-color: #dac6f5 !important;
  color: #fff !important;
}

.picker .picker__frame .picker__box .picker__footer .picker__button--today {
  background-color: #dac6f5 !important;
  color: #fff !important;
}

.picker .picker__frame .picker__box .picker__footer .picker__button--today:before {
  content: none !important;
}

.picker .picker__frame .picker__box .picker__footer .picker__button--clear,
.picker .picker__frame .picker__box .picker__footer .picker__button--close,
.picker .picker__frame .picker__box .picker__footer .picker__button--today {
  border: 0;
  border-radius: 2px;
  font-size: 16px;
}

.picker .picker__frame .picker__box .picker__footer .picker__button--clear:hover,
.picker .picker__frame .picker__box .picker__footer .picker__button--close:hover,
.picker .picker__frame .picker__box .picker__footer .picker__button--today:hover {
  background-color: #dac6f5 !important;
  color: #fff !important;
}

@media only screen and (max-width: 575px) {
  .picker .picker__frame {
    min-width: 100% !important;
    max-width: 100% !important;
  }

  .picker .picker__frame .picker__box {
    padding: 15px;
    margin: 0 10px;
  }
}

.card-list {
  overflow: unset;
  height: calc(100% - 50px);
}

.card-list .card-header {
  padding-top: 0;
  padding-bottom: 0;
}

.card-list .card-header .photo {
  overflow: hidden;
  border-radius: 5px;
  width: 100%;
}

@media only screen and (max-width: 1199px) {
  .card-list {
    height: calc(100% - 40px);
  }
}

.card-list.list-left {
  margin-top: 15px;
  margin-left: 15px;
}

.card-list.list-left .card-header {
  padding-left: 0;
}

.card-list.list-left .card-header .photo {
  margin: -15px 15px 0 -15px;
}

.card-list.list-right {
  margin-top: 15px;
  margin-right: 15px;
  text-align: right;
}

.card-list.list-right .card-header {
  padding-right: 0;
}

.card-list.list-right .card-header .photo {
  margin: -15px -15px 0 15px;
}

.card-list.list-right .card-header .photo img {
  width: 100%;
}

.card-list.list-center {
  margin-top: 15px;
}

.card-list.list-center .card-header .photo {
  margin: -15px 0 0 0;
}

.card-list .photo img {
  width: 100%;
}

.card-profile .profile-photo {
  margin-top: -20px;
}

.widget-media .timeline .timeline-panel {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.widget-media .timeline .timeline-panel .media {
  width: 50px;
  height: 50px;
  background: #eee;
  border-radius: 1.25rem;
  overflow: hidden;
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  align-self: start;
}

.widget-media .timeline .timeline-panel .media-primary {
  background: #f6f1fd;
  color: #00ADEE;
}

[data-theme-version="dark"] .widget-media .timeline .timeline-panel .media-primary {
  background-color: rgba(135, 67, 223, 0.2);
}

.widget-media .timeline .timeline-panel .media-info {
  background: #dbdbff;
  color: #2D28FF;
}

[data-theme-version="dark"] .widget-media .timeline .timeline-panel .media-info {
  background-color: rgba(45, 40, 255, 0.1);
}

.widget-media .timeline .timeline-panel .media-warning {
  background: #fff3eb;
  color: #FF9B52;
}

[data-theme-version="dark"] .widget-media .timeline .timeline-panel .media-warning {
  background-color: rgba(255, 155, 82, 0.1);
}

.widget-media .timeline .timeline-panel .media-danger {
  background: #fff3f7;
  color: #F94687;
}

[data-theme-version="dark"] .widget-media .timeline .timeline-panel .media-danger {
  background-color: rgba(249, 70, 135, 0.15);
}

.widget-media .timeline .timeline-panel .media-success {
  background: #e3f9e9;
  color: #2BC155;
}

[data-theme-version="dark"] .widget-media .timeline .timeline-panel .media-success {
  background-color: rgba(43, 193, 85, 0.1);
}

.widget-media .timeline .timeline-panel .media-body p {
  font-size: 14px;
  line-height: 1.5;
}

.widget-media .timeline .timeline-panel .dropdown {
  align-self: self-end;
  margin-top: 5px;
}

.widget-media .timeline li:last-child .timeline-panel {
  margin-bottom: 0;
  border-bottom: 0;
  padding-bottom: 0;
}

.card[class*="bg-"] .timeline .timeline-panel {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

@media only screen and (max-width: 1199px) {
  .table {
    font-size: 0.875rem !important;
  }
}

.table strong {
  color: #B1B1B1;
}

.table td {
  border-color: #f0f1f5;
  padding: 12px 9px;
}

[data-theme-version="dark"] .table td {
  border-color: #333a54;
}

.table.shadow-hover tr:hover {
  background-color: #fff;
  box-shadow: 0 0px 30px rgba(135, 67, 223, 0.15);
}

[data-theme-version="dark"] .table.shadow-hover tr:hover {
  background-color: #181f39;
}

.table.bg-secondary-hover th,
.table.bg-secondary-hover td {
  border: none;
  font-weight: 500;
}

.table.bg-secondary-hover tr:hover {
  background: #3F9AE0;
}

.table.bg-secondary-hover tr:hover td,
.table.bg-secondary-hover tr:hover th {
  color: #fff !important;
}

.table.bg-info-hover th,
.table.bg-info-hover td {
  border: none;
  font-weight: 500;
}

.table.bg-info-hover tr:hover {
  background: #2D28FF;
}

.table.bg-info-hover tr:hover td,
.table.bg-info-hover tr:hover th {
  color: #fff !important;
}

.table.bg-warning-hover th,
.table.bg-warning-hover td {
  border: none;
  font-weight: 500;
}

.table.bg-warning-hover tr:hover {
  background: #FF9B52;
}

.table.bg-warning-hover tr:hover td,
.table.bg-warning-hover tr:hover th {
  color: #fff !important;
}

.table thead th {
  border-bottom-width: 1px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-color: #f0f1f5;
  padding: 5px 20px !important;
  
}

[data-theme-version="dark"] .table thead th {
  border-color: #333a54;
}

.table tbody tr td {
  vertical-align: middle;
  border-color: #f0f1f5;
}

[data-theme-version="dark"] .table tbody tr td {
  border-color: #333a54;
}

.table:not(.table-bordered) thead th {
  border-top: none;
  white-space:normal;
  text-align: center;
  vertical-align: middle;
}

.table .thead-primary th {
  background-color: #00ADEE;
  color: #fff;
}

.table .thead-info th {
  background-color: #2D28FF;
  color: #fff;
}

.table .thead-warning th {
  background-color: #FF9B52;
  color: #fff;
}

.table .thead-danger th {
  background-color: #F94687;
  color: #fff;
}

.table .thead-success th {
  background-color: #2BC155;
  color: #fff;
}

.table.primary-table-bordered {
  border: 1px solid #f0f1f5;
}

[data-theme-version="dark"] .table.primary-table-bordered {
  border-color: #333a54;
}

.table.primary-table-bg-hover thead th {
  background-color: #792ddb;
  color: #fff;
  border-bottom: none;
}

.table.primary-table-bg-hover tbody tr {
  background-color: #00ADEE;
  color: #fff;
  transition: all .1s ease;
}

.table.primary-table-bg-hover tbody tr:hover {
  background-color: #9559e3;
}

.table.primary-table-bg-hover tbody tr:not(:last-child) td,
.table.primary-table-bg-hover tbody tr:not(:last-child) th {
  border-bottom: 1px solid #792ddb;
}

.table-responsive-tiny {
  min-width: 18.75rem;
}

.table-responsive-sm {
  min-width: 30rem !important;
}

.table-responsive-md {
  min-width: 36rem !important;
}

.table-responsive-lg {
  min-width: 60.9375rem !important;
}

.table-responsive-xl {
  min-width: 70.9375rem !important;
}

.table-primary,
.table-primary>th,
.table-primary>td {
  background-color: #f6f1fd;
  color: #00ADEE;
}

[data-theme-version="dark"] .table-primary,
[data-theme-version="dark"] .table-primary>th,
[data-theme-version="dark"] .table-primary>td {
  background-color: rgba(135, 67, 223, 0.2);
}

.table-success,
.table-success>th,
.table-success>td {
  background-color: #e3f9e9;
  color: #2BC155;
}

[data-theme-version="dark"] .table-success,
[data-theme-version="dark"] .table-success>th,
[data-theme-version="dark"] .table-success>td {
  background-color: rgba(43, 193, 85, 0.1);
}

.table-info,
.table-info>th,
.table-info>td {
  background-color: #dbdbff;
  color: #2D28FF;
}

[data-theme-version="dark"] .table-info,
[data-theme-version="dark"] .table-info>th,
[data-theme-version="dark"] .table-info>td {
  background-color: rgba(45, 40, 255, 0.1);
}

.table-warning,
.table-warning>th,
.table-warning>td {
  background-color: #fff3eb;
  color: #FF9B52;
}

[data-theme-version="dark"] .table-warning,
[data-theme-version="dark"] .table-warning>th,
[data-theme-version="dark"] .table-warning>td {
  background-color: rgba(255, 155, 82, 0.1);
}

.table-danger,
.table-danger>th,
.table-danger>td {
  background-color: #fff3f7;
  color: #F94687;
}

[data-theme-version="dark"] .table-danger,
[data-theme-version="dark"] .table-danger>th,
[data-theme-version="dark"] .table-danger>td {
  background-color: rgba(249, 70, 135, 0.15);
}

.table-active,
.table-active>th,
.table-active>td {
  background-color: #f2f4fa;
}

[data-theme-version="dark"] .table-active,
[data-theme-version="dark"] .table-active>th,
[data-theme-version="dark"] .table-active>td {
  background-color: #181f39;
}

.card-table th:first-child,
.card-table td:first-child {
  padding-left: 20px;
  padding-right: 20px;
  width: 50px;
}

@media only screen and (max-width: 575px) {

  .card-table th:first-child,
  .card-table td:first-child {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.card-table th:last-child,
.card-table td:last-child {
  padding-left: 20px;
  padding-right: 20px;
}

@media only screen and (max-width: 575px) {

  .card-table th:last-child,
  .card-table td:last-child {
    padding-right: 10px;
    padding-left: 10px;
  }
}

.bootgrid-header {
  padding: 0 !important;
  margin: 0;
}

@media only screen and (max-width: 575px) {
  .bootgrid-header .actionBar {
    padding: 0;
  }

  .bootgrid-header .search {
    margin: 0 0 10px 0;
  }
}

table#example {
  padding: 0rem 0 2rem 0;
}

table.dataTable {
  color: #000;
  border-radius: 0.5rem;
}

#example2_wrapper .dataTables_scrollBody {
  max-height: 33.25rem !important;
}

#employees,
#custommers {
  padding: .5rem 0 1rem 0;
}

.dataTables_wrapper .dataTables_paginate {
  padding: 25px 0;
}

@media only screen and (max-width: 1400px) {
  .dataTables_wrapper .dataTables_paginate {
    padding: 10px 0;
  }
}

table.dataTable thead th,
table.dataTable thead td {
  padding: 20px 15px;
  border-bottom: 1px solid #f0f1f5;
}

@media only screen and (max-width: 1400px) {

  table.dataTable thead th,
  table.dataTable thead td {
    padding: 8px 15px;
  }
}

table.dataTable tfoot th,
table.dataTable tfoot td {
  border-top: 0;
}

table.dataTable tbody td {
  background: #fff !important;
}

table.dataTable thead th {
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  font-weight: 600;
  text-align: center;
}

[data-theme-version="dark"] table.dataTable thead th {
  color: #fff;
}

@media only screen and (max-width: 1400px) {
  table.dataTable thead th {
    font-size: 12px;
  }
}

table.dataTable tbody td {
  font-size: 11px;
  padding: 2px 4px;
}

@media only screen and (max-width: 1400px) {
  table.dataTable tbody td {
    padding: 2px 4px;
    font-size: 12px;
  }
}

table.dataTable tr.selected {
  color: #00ADEE;
}

table.dataTable tfoot th {
  color: #B1B1B1;
  font-weight: 600;
}

[data-theme-version="dark"] table.dataTable tfoot th {
  color: #fff;
}

.dataTables_wrapper input[type="search"],
.dataTables_wrapper input[type="text"],
.dataTables_wrapper select {
  border: 1px solid #e2e2e2;
  padding: .3rem 0.5rem;
  color: #715d5d;
  border-radius: 5px;
}

[data-theme-version="dark"] .dataTables_wrapper input[type="search"],
[data-theme-version="dark"] .dataTables_wrapper input[type="text"],
[data-theme-version="dark"] .dataTables_wrapper select {
  background: #181f39;
  border-color: #333a54;
  color: #fff;
}

.dataTables_wrapper .dataTables_length {
  margin-bottom: 15px;
}

.dataTables_wrapper .dataTables_length .bootstrap-select {
  width: 80px !important;
  margin: 0 5px;
}

table.dataTable.no-footer {
  border-bottom: 0;
}

.min-w850 {
  min-width: 850px;
}

.rounded-lg {
  min-width: 30px;
}

.dataTables_scroll {
  padding: 1rem 0;
}

.dataTables_scrollFoot {
  padding-top: 1rem;
}

@media (max-width: 991.98px) {

  .dataTables_wrapper .dataTables_length,
  .dataTables_wrapper .dataTables_filter {
    text-align: left;
  }
}

.dataTablesCard {
  background-color: #3C4B64;
  box-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);
  border-radius: 0;
}

.dataTablesCard tbody {
  background: #fff;
}

.dataTablesCard tbody tr:hover {
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.dataTablesCard tbody tr:hover td {
  background: transparent !important;
}

table.dataTable.display tbody tr:hover {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

table.dataTable.display tbody tr:hover td {
  background: transparent;
}

.dataTables_wrapper .dataTables_info {
  padding: 25px 0;
}

@media only screen and (max-width: 1400px) {
  .dataTables_wrapper .dataTables_info {
    padding: 8px 0;
  }
}

table.dataTable.display.white-border td {
  border-color: #fff;
}

table.dataTable.row-border tbody th,
table.dataTable.row-border tbody td,
table.dataTable.display tbody th,
table.dataTable.display tbody td {
  border-left: #EEEEEE;
  border-right: 1px solid #EEEEEE;
  border-left: #EEEEEE;
  border-left: #EEEEEE;
  text-align: center;
}

/* table only column name align */
.left-Column-align {
  text-align: left !important;
  max-width: 150px;
}

[data-theme-version="dark"] table.dataTable.row-border tbody th,
[data-theme-version="dark"] table.dataTable.row-border tbody td,
[data-theme-version="dark"] table.dataTable.display tbody th,
[data-theme-version="dark"] table.dataTable.display tbody td {
  border-color: #333a54;
}

table.dataTable thead .sorting {
  background-position: center right 15px;
}

.dataTables_wrapper .dataTables_paginate {
  border-radius: 1.25rem;
}

.dataTables_wrapper .dataTables_paginate span {
  border-radius: 1.25rem;
  display: inline-block;
  background: rgba(135, 67, 223, 0.08);
  border: 0px solid #00ADEE;
  margin: 0 0;
}

.dataTables_wrapper .dataTables_paginate span a {
  color: #fff;
  background: transparent !important;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  border: 0 !important;
  padding: 15px 24px;
  background: transparent !important;
  border-radius: 1.25rem;
  color: #00ADEE !important;
  font-size: 16px;
  margin: 0;
  display: inline-block;
}

@media only screen and (max-width: 1400px) {
  .dataTables_wrapper .dataTables_paginate .paginate_button {
    padding: 8px 15px;
    font-size: 14px;
  }
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.current {
  color: #fff !important;
  background: #00ADEE !important;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.previous,
.dataTables_wrapper .dataTables_paginate .paginate_button.next {
  background: #fff !important;
  color: #00ADEE !important;
  margin: 0 10px;
  border: 0px solid #00ADEE !important;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.previous:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.next:hover {
  background: #00ADEE !important;
  color: #fff !important;
}

.fooicon {
  font-size: 1.25rem;
  color: #B1B1B1;
}

.jsgrid-table .jsgrid-header-row>.jsgrid-header-cell {
  color: #B1B1B1;
}

.jsgrid-table>tbody>tr>td {
  padding: 1.2em;
}

.jsgrid-table .jsgrid-insert-row input,
.jsgrid-table .jsgrid-insert-row select,
.jsgrid-table .jsgrid-edit-row input,
.jsgrid-table .jsgrid-edit-row select {
  border: 1px solid #DDDFE1;
}

.jsgrid .jsgrid-button {
  border: 0 !important;
  margin-left: 10px;
}

.error-page .error-text {
  font-size: 150px;
  line-height: 1;
  color: #3F9AE0;
}

@media only screen and (max-width: 575px) {
  .error-page .error-text {
    font-size: 80px;
  }
}

.error-page h4 {
  font-size: 40px;
  margin-bottom: 5px;
  color: #3F9AE0;
}

@media only screen and (max-width: 575px) {
  .error-page h4 {
    font-size: 20px;
  }
}

.error-page p {
  font-size: 16px;
}

@media only screen and (max-width: 575px) {
  .error-page p {
    font-size: 14px;
  }
}

.authentication-content {
  background: #fff;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
  border-radius: 5px;
  background: rgb(255 255 255/85%);
}

[data-theme-version="dark"] .authentication-content {
  background: #1e2746;
  box-shadow: none;
}

.welcome-content {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: cover;
  background-position: center;
  height: 100%;
  padding: 75px 50px;
  position: relative;
  z-index: 1;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.welcome-content::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #00ADEE;
  opacity: 0.75;
  z-index: -1;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.welcome-content .welcome-title {
  color: #fff;
  font-weight: 500;
  font-size: 20px;
}

.welcome-content p {
  color: #fff;
}

.welcome-content .brand-logo a {
  display: inline-block;
  margin-bottom: 20px;
  font-weight: 700;
  color: #fff;
  font-size: 20px;
}

.welcome-content .brand-logo a img {
  width: 100px;
}

.welcome-content .intro-social {
  position: absolute;
  bottom: 75px;
}

.welcome-content .intro-social ul {
  margin-bottom: 0;
}

.welcome-content .intro-social ul li {
  display: inline-block;
}

.welcome-content .intro-social ul li a {
  color: #fff;
  font-size: 14px;
  padding: 0px 7px;
}

.auth-form {
  padding: 50px 50px;
}

@media only screen and (max-width: 575px) {
  .auth-form {
    padding: 30px;
  }
}

.auth-form .btn {
  font-weight: 700;
}

.auth-form .page-back {
  display: inline-block;
  margin-bottom: 15px;
}

.pricing_table_content {
  background: #fff;
  text-align: center;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
  padding: 25px;
  transition: all 0.25s ease-in-out;
}

.pricing_table_content .package {
  font-weight: 700;
  font-size: 18px;
}

.pricing_table_content .price {
  font-weight: 700;
  font-size: 50px;
  line-height: 100px;
  color: #B1B1B1;
}

.pricing_table_content hr {
  margin: 0;
}

.pricing_table_content .price_list {
  padding: 30px 0;
  text-align: left;
  max-width: 175px;
  margin: 0 auto;
}

.pricing_table_content .price_list li {
  color: #909093;
  font-size: 14px;
  line-height: 25px;
  padding: 7px 0;
}

.pricing_table_content .price_list li i {
  margin-right: 15px;
}

.pricing_table_content .price-btn {
  padding: 15px 50px;
  box-shadow: none;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 25px;
  transition: all 0.25s ease-in-out;
}

.pricing_table_content:focus,
.pricing_table_content:hover {
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.175);
}

.pricing_table_content:focus .price-btn,
.pricing_table_content:hover .price-btn {
  color: #F94687;
}

.page-timeline .timeline {
  list-style: none;
  padding: 40px 0;
  position: relative;
}

.page-timeline .timeline-workplan.page-timeline .timeline {
  padding-bottom: 0;
  margin-bottom: 0;
}

.page-timeline .timeline-workplan.page-timeline .timeline.timeline>li>.timeline-badge {
  top: 4.5rem;
}

.page-timeline .timeline-workplan.page-timeline .timeline>li {
  margin-bottom: 2.6rem;
}

@media only screen and (min-width: 1200px) and (max-width: 1650px) {
  .page-timeline .timeline-workplan.page-timeline .timeline li>p {
    max-width: 8rem;
  }
}

@media only screen and (max-width: 1199px) {
  .page-timeline .timeline-workplan.page-timeline .timeline li>p {
    max-width: 7rem;
  }
}

@media only screen and (max-width: 991px) {
  .page-timeline .timeline-workplan.page-timeline .timeline li>p {
    max-width: 100%;
  }
}

@media only screen and (max-width: 575px) {
  .page-timeline .timeline-workplan.page-timeline .timeline li>p {
    max-width: 7rem;
  }
}

.page-timeline .timeline-workplan.page-timeline .timeline::before {
  left: 20%;
  top: 6rem;
}

[direction="rtl"] .page-timeline .timeline-workplan.page-timeline .timeline::before {
  right: 22%;
  left: auto;
}

@media only screen and (max-width: 575px) {
  .page-timeline .timeline-workplan.page-timeline .timeline::before {
    left: 22%;
  }
}

.page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {
  left: 21.4%;
  height: 0.9rem;
  width: 0.9rem;
  background-color: #00ADEE;
}

[direction="rtl"] .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {
  right: 19.2%;
  left: auto;
}

@media only screen and (min-width: 1200px) and (max-width: 1650px) {
  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {
    left: 22.4%;
  }
}

@media only screen and (max-width: 1199px) {
  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {
    left: 22.4%;
  }
}

@media only screen and (max-width: 991px) {
  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {
    left: 21.7%;
  }
}

@media only screen and (max-width: 767px) {
  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {
    left: 19.5%;
  }
}

@media only screen and (max-width: 575px) {
  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {
    left: 21.4%;
  }
}

.page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge::after {
  position: absolute;
  width: 1.9rem;
  height: 1.9rem;
  background-color: rgba(135, 67, 223, 0.4);
  content: "";
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.page-timeline .timeline-workplan.page-timeline .timeline .timeline-panel {
  width: 70%;
}

.page-timeline .timeline:before {
  top: 0;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 2px;
  background-color: #ECEFF2;
  left: 50%;
  margin-left: -1.5px;
}

.page-timeline .timeline>li {
  margin-bottom: 20px;
  position: relative;
}

.page-timeline .timeline>li:after,
.page-timeline .timeline>li:before {
  content: " ";
  display: table;
}

.page-timeline .timeline>li:after {
  clear: both;
}

.page-timeline .timeline>li:after,
.page-timeline .timeline>li:before {
  content: " ";
  display: table;
}

.page-timeline .timeline>li:after {
  clear: both;
}

.page-timeline .timeline>li>.timeline-panel {
  width: 46%;
  float: left;
  border-radius: 2px;
  position: relative;
}

.page-timeline .timeline>li>.timeline-badge {
  background-color: #f2f4fa;
  border: 1px solid #DDDFE1;
  border-radius: 50%;
  color: #B1B1B1;
  height: 40px;
  left: 50%;
  line-height: 40px;
  margin-left: -13px;
  position: absolute;
  text-align: center;
  top: 30px;
  width: 40px;
  z-index: 1;
  transform: translate(-25%, -3rem);
}

@media (min-width: 576px) {
  .page-timeline .timeline>li>.timeline-badge {
    width: 50px;
    height: 50px;
    line-height: 50px;
  }
}

.page-timeline .timeline>li.timeline-inverted>.timeline-panel {
  float: right;
}

.page-timeline .timeline>li.timeline-inverted>.timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}

.page-timeline .timeline>li.timeline-inverted>.timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}

.page-timeline .timeline-title {
  margin-top: 0;
  color: inherit;
}

.page-timeline .event_time {
  font-size: 14px;
  font-weight: 600;
}

.page-timeline .event_vanue {
  font-size: 14px;
  margin: 5px 0;
  font-weight: 600;
}

.page-timeline .timeline_img {
  height: 100px;
  width: 100px;
}

.page-timeline .timeline-body>p,
.page-timeline .timeline-body>ul {
  margin-bottom: 0;
}

@media (max-width: 767px) {
  .page-timeline ul.timeline:before {
    left: 40px;
  }

  .page-timeline ul.timeline>li>.timeline-panel {
    width: calc(100% - 90px);
    width: -webkit-calc(100% - 90px);
  }

  .page-timeline ul.timeline>li>.timeline-badge {
    left: 28px;
    margin-left: 0;
    top: 16px;
  }

  .page-timeline ul.timeline>li>.timeline-panel {
    float: right;
  }

  .page-timeline ul.timeline>li>.timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }

  .page-timeline ul.timeline>li>.timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }

  .page-timeline .timeline_img {
    height: 30%;
    width: 30%;
  }
}

.page-timeline .timeline-timestamp {
  text-align: center;
}

.page-timeline .timeline-timestamp .badge {
  padding: .8rem 2rem;
  border-radius: 50px;
  font-size: 0.8125rem;
}

.full-map-area {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}

.full-map-area a {
  position: absolute;
  bottom: 30px;
  left: 30px;
}

.full-map-area i {
  background: #3e4954;
  position: absolute;
  top: 30px;
  right: 30px;
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  font-size: 24px;
  color: #fff;
  border-radius: 56px;
}

.full-map-area img {
  width: 100%;
}

.iconbox {
  position: relative;
  padding-left: 70px;
}

.iconbox i {
  background: #00ADEE;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50px;
  text-align: center;
  font-size: 28px;
  color: #fff;
  position: absolute;
  left: 0;
  top: 0;
}

.iconbox p {
  margin: 0;
  color: #484848;
  font-size: 18px;
  line-height: 1.3;
  font-weight: 500;
}

.iconbox small {
  margin-bottom: 5px;
  font-size: 16px;
  display: block;
}

.widget-timeline-icon li {
  padding-left: 25px;
  position: relative;
  margin-left: 11px;
  border-left: 3px solid #00ADEE;
  min-height: 80px;
  padding-top: 1px;
}

.widget-timeline-icon li .icon {
  position: absolute;
  width: 22px;
  height: 22px;
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 22px;
  border-radius: 22px;
  left: -13px;
  top: 0;
}

.widget-timeline-icon li:last-child {
  border-left: 3px solid transparent;
}

.contact-icon {
  height: 50px;
  width: 50px;
  min-width: 50px;
  background: rgba(135, 67, 223, 0.2);
  color: #00ADEE;
  font-size: 28px;
  border-radius: 1.25rem;
  line-height: 50px;
  transition: all 0.5s;
  text-align: center;
}

.contact-icon:hover {
  color: #fff;
  background: #00ADEE;
}

@media only screen and (max-width: 1400px) {
  .contact-icon {
    height: 40px;
    width: 40px;
    min-width: 40px;
    line-height: 42px;
    font-size: 25px;
  }
}

.review-table {
  padding: 25px;
  box-shadow: none;
  border-radius: 0;
  border-bottom: 1px solid #eee;
  height: auto;
  margin-bottom: 0;
}

.review-table .star-review i {
  font-size: 20px;
}

.review-table .media-body p {
  color: #3e4954;
  font-size: 18px;
  line-height: 1.5;
}

.review-table .disease {
  border-left: 1px solid #EEEEEE;
  padding-left: 20px;
}

.review-table .media-footer {
  min-width: 500px;
  margin-left: 10px;
}

@media only screen and (max-width: 1400px) {
  .review-table .media-footer {
    min-width: 273px;
    margin-left: 10px;
  }
}

@media only screen and (max-width: 991px) {
  .review-table .star-review i {
    font-size: 16px;
  }

  .review-table .custom-control {
    float: right;
    right: -20px;
  }

  .review-table .media {
    display: block !important;
  }

  .review-table .media-body p {
    font-size: 14px;
  }

  .review-table img {
    float: left;
    width: 80px;
  }

  .review-table .media-footer {
    margin-left: 0;
    margin-top: 25px;
  }

  .review-table .disease {
    border-left: 0;
    padding-left: 0;
    margin-right: 10px !important;
    margin-left: 0;
  }
}

@media only screen and (max-width: 575px) {
  .review-table .media-footer {
    flex-flow: wrap;
  }

  .review-table .media-footer .disease {
    margin-right: auto !important;
  }

  .review-table .media-footer .edit {
    margin-left: 0 !important;
  }
}

.review-tab .nav-link {
  border-radius: 0;
  font-weight: 600;
  border-bottom: 2px solid #D9D9D9;
  transition: all 0.5s;
}

.review-tab .nav-link.active {
  background: transparent;
  color: #00ADEE;
  transition: all 0.5s;
  box-shadow: none;
  border-color: #00ADEE;
}

@media only screen and (max-width: 575px) {
  .review-tab .nav-link {
    padding: 10px 16px;
    font-size: 13px;
  }
}

.search-job .form-control {
  width: 50%;
}

@media only screen and (max-width: 767px) {
  .search-job .form-control {
    width: 100%;
  }
}

.sharp-lg {
  min-width: 50px;
  height: 50px;
  line-height: 48px;
  min-height: 50px;
  text-align: center;
}

@media only screen and (max-width: 1400px) {
  .sharp-lg {
    min-height: 40px;
    height: 40px;
    min-width: 40px;
    line-height: 38px;
  }
}

.search-row .title {
  font-size: 20px;
  font-weight: 600;
}

.search-row .sub-title {
  font-size: 18px;
}

.search-row:hover {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

@media only screen and (max-width: 1400px) {
  .search-row .title {
    font-size: 17px;
  }

  .search-row .sub-title {
    font-size: 16px;
  }
}

.aroundYou {
  border-right: 1px solid #EEEEEE;
}

@media only screen and (max-width: 991px) {
  .aroundYou {
    border-right: 0;
  }
}

.like-btn {
  display: inline-block;
  padding-left: 0;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-family: FontAwesome;
}

.like-btn input {
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  display: block;
}

.checkmark {
  height: 40px;
  text-align: center;
  line-height: 38px;
  width: 40px;
  display: block;
  border: 1px solid #00ADEE;
  border-radius: 20px;
}

@media only screen and (max-width: 1400px) {
  .checkmark {
    height: 32px;
    width: 32px;
    line-height: 29px;
  }
}

.like-btn .checkmark:before {
  content: "\\f097";
  font-size: 20px;
  font-weight: 400;
  color: #00ADEE;
}

@media only screen and (max-width: 1400px) {
  .like-btn .checkmark:before {
    font-size: 17px;
  }
}

.like-btn input:checked~.checkmark {
  background-color: #00ADEE;
}

.like-btn input:checked~.checkmark:before {
  width: 100%;
  height: 100%;
  background-color: #00ADEE;
  left: 0;
  top: 0;
  border-radius: 20px;
  color: #fff;
  padding: 3px 6px;
}

.profile-card .title {
  position: relative;
}

.profile-card .title span {
  display: inline-block;
  text-transform: uppercase;
  background: #fff;
  position: relative;
  z-index: 1;
  padding-right: 30px;
}

.profile-card .title:after {
  width: 100%;
  height: 1px;
  background: #E7E7E7;
  position: absolute;
  top: 50%;
  transform: translatey(-50%);
  left: 0;
  content: "";
}

.profile-card .form-group {
  margin-bottom: 30px;
}

.profile-card .form-group label {
  font-weight: 500;
}

.profile-card .form-group .input-icon .form-control {
  padding-left: 70px;
  z-index: 0;
}

@media only screen and (max-width: 767px) {
  .profile-card .form-group .input-icon .form-control {
    padding-left: 50px;
  }
}

.profile-card .form-group .input-group-prepend {
  position: absolute;
  top: 50%;
  left: 10px;
  z-index: 1;
  transform: translatey(-50%);
}

.profile-card .form-group .input-group-prepend .input-group-text {
  background: transparent;
}

.profile-card .form-group .input-group-prepend .input-group-text i {
  font-size: 30px;
  color: #00ADEE;
}

@media only screen and (max-width: 767px) {
  .profile-card .form-group .input-group-prepend .input-group-text i {
    font-size: 20px;
  }
}

@media only screen and (max-width: 767px) {
  .profile-card .form-group .input-group-prepend {
    left: 0;
  }
}

.profile-card .form-group .bootstrap-select.form-control {
  padding: 0;
}

.profile-card .form-group .bootstrap-select.form-control button {
  padding: 10px 20px;
  height: 70px;
  font-size: 18px;
  line-height: 45px;
  background: #FBFBFB;
  border-color: #C2C2C2 !important;
  color: #000;
  border-radius: 1.25rem;
}

@media only screen and (max-width: 767px) {
  .profile-card .form-group .bootstrap-select.form-control button {
    height: 45px;
    font-size: 14px;
    padding: 0 10px;
  }
}

.profile-card .form-group .bootstrap-select.form-control .dropdown-toggle:after {
  color: #00ADEE;
  font-size: 30px;
}

@media only screen and (max-width: 575px) {
  .profile-card .form-group .bootstrap-select.form-control .dropdown-toggle:after {
    font-size: 20px;
  }
}

.profile-card .form-group .form-control {
  height: 70px;
  font-size: 18px;
  padding: 0 20px;
  border-color: #C2C2C2 !important;
  background: #FBFBFB;
  color: #000;
  border-radius: 1.25rem;
}

.profile-card .form-group .form-control::placeholder {
  color: #BBBBBB;
}

@media only screen and (max-width: 767px) {
  .profile-card .form-group .form-control {
    height: 45px;
    font-size: 14px;
  }
}

.profile-card .form-group textarea.form-control {
  height: unset !important;
  border: 1px solid;
  border-color: #C2C2C2;
  border-radius: 1.25rem;
  color: rgba(0, 0, 0, 0.7);
  background: #FBFBFB;
  border-width: 1px !important;
  font-size: 16px !important;
  padding: 15px 20px !important;
}

.progress-icon {
  height: 62px;
  width: 62px;
  display: block;
  font-weight: 600;
  border-radius: 1.25rem;
  line-height: 62px;
  text-align: center;
  background: rgba(135, 67, 223, 0.1);
  color: #00ADEE;
}

@media only screen and (max-width: 575px) {
  .progress-icon {
    height: 50px;
    width: 50px;
    line-height: 50px;
  }
}

.skill-progress {
  overflow: visible;
}

.skill-progress .progress-bar {
  position: relative;
  border-radius: 10px;
  overflow: visible;
}

.skill-progress .progress-bar:after {
  content: "";
  position: absolute;
  height: 26px;
  width: 26px;
  top: 50%;
  transform: translatey(-50%);
  right: 0;
  border-radius: 5px;
  background: #00ADEE;
}

@media only screen and (max-width: 575px) {
  .skill-progress .progress-bar:after {
    height: 20px;
    width: 20px;
  }
}

.network-chart {
  margin-top: -90px;
  margin-bottom: -40px;
}

@media only screen and (max-width: 1600px) {
  .network-chart {
    margin-top: 0;
  }
}

@media only screen and (max-width: 1199px) {
  .network-chart {
    margin-top: -90px;
  }
}

@media only screen and (max-width: 575px) {
  .network-chart {
    margin-top: -30px;
    margin-bottom: -40px;
  }
}

.network-header {
  position: relative;
  z-index: 3;
}

.items-table tbody tr {
  padding: 0;
  border-radius: 1.25rem;
  position: relative;
  box-shadow: 0 1px 0 0 #f8f8f8;
  transition: all 0.5s;
}

.items-table tbody tr .dropdown {
  opacity: 0;
}

.items-table tbody tr.active,
.items-table tbody tr:hover {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  z-index: 1;
}

.items-table tbody tr.active .dropdown,
.items-table tbody tr:hover .dropdown {
  opacity: 1;
}

.items-table tbody tr th,
.items-table tbody tr td {
  border: 0;
  padding: 18px 8px;
}

@media only screen and (max-width: 575px) {
  .items-table {
    width: 500px;
  }
}

.star-review i {
  font-size: 16px;
}

.star-review i.text-gray {
  color: #d9d9d9;
}

.star-review span {
  color: #000;
}

.form-head {
  /* .btn i{
  	line-height: 1;
  	transform: scale(1.3);
  	display: inline-block;
  	margin-right: 5px;
  } */
  /* .btn-outline-primary{
  	border-color:#eee;
  	&:hover{
  		border-color:\$primary;
  	}
  } */
}

.form-head .breadcrumb {
  background: transparent;
  padding: 0;
}

.form-head .search-area {
  max-width: 300px;
  border-radius: 0;
}

@media only screen and (max-width: 1400px) {
  .form-head .search-area {
    max-width: 250px;
  }
}

@media only screen and (max-width: 575px) {
  .form-head .search-area {
    max-width: 250px;
  }
}

.form-head .search-area .form-control {
  border: 0;
  height: 45px;
  padding: 10px 15px;
  font-size: 16px;
  background: #f1f1f1;
  border-radius: 0;
}

@media only screen and (max-width: 1400px) {
  .form-head .search-area .form-control {
    height: 41px;
    padding: 10px 15px;
    font-size: 13px;
  }
}

.form-head .search-area .input-group-append .input-group-text {
  background: #f1f1f1;
  padding: 0 5px 0 30px;
}

@media only screen and (max-width: 1400px) {
  .form-head .search-area .input-group-append .input-group-text {
    padding: 0 5px 0 30px;
  }
}

.form-head .search-area .input-group-append .input-group-text i {
  font-size: 20px;
  color: #7e7e7e;
}

@media only screen and (max-width: 1400px) {
  .form-head .search-area .input-group-append .input-group-text i {
    font-size: 18px;
  }
}

.form-head .dropdown .btn i {
  transform: scale(1.3);
  -moz-transform: scale(1.3);
  -webkit-transform: scale(1.3);
  -ms-transform: scale(1.3);
  -o-transform: scale(1.3);
  display: inline-block;
}

.form-head .dropdown:after {
  color: #00ADEE;
  font-size: 25px;
}

@media only screen and (max-width: 767px) {
  .form-head>* {
    margin-right: 5px !important;
    margin-bottom: 10px;
    vertical-align: baseline;
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 767px) {
  .form-head {
    display: block !important;
  }
}

.rounded {
  border-radius: 1.25rem !important;
}

.btn-link {
  font-weight: 500;
  font-size: 16px;
}

@media only screen and (max-width: 1400px) {
  .btn-link {
    font-size: 14px;
  }
}

.deznav .copyright {
  font-size: 14px;
  padding: 0 45px 60px;
  margin-top: 40px;
  color: #969BA0;
  margin-bottom: 40px;
}

.deznav .copyright p {
  margin-bottom: 10px;
}

.deznav .copyright strong {
  display: block;
}

@media only screen and (max-width: 1400px) {
  .deznav .copyright {
    padding: 0 25px 60px;
  }
}

@media only screen and (max-width: 767px) {
  .deznav .copyright {
    padding-bottom: 60px;
  }
}

.widget-buyer .media img {
  width: 30px;
}

.widget-buyer .media .media-body h5 {
  font-size: 14px;
  margin-bottom: 0px;
}

.widget-buyer .media .media-body p {
  font-size: 13px;
}

.recentOrderTable table {
  margin-bottom: 0;
  overflow: hidden;
}

.recentOrderTable table thead th {
  font-size: 12px;
}

.recentOrderTable table tbody td {
  color: #B1B1B1;
  font-weight: 500;
  line-height: 40px;
}

[data-theme-version="dark"] .recentOrderTable table tbody td {
  color: #828690;
}

.recentOrderTable table tbody td img {
  border-radius: 50px;
}

.recentOrderTable table tbody td .custom-dropdown i {
  padding: 0 10px;
  cursor: pointer;
}

.activity_overview .nav-tabs {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.activity_overview .custom-tab-1 .nav-link {
  color: rgba(255, 255, 255, 0.5);
  padding-left: 0;
  padding-right: 0;
  margin-right: 30px;
}

.activity_overview .custom-tab-1 .nav-link:hover,
.activity_overview .custom-tab-1 .nav-link.active {
  background: transparent;
  color: #fff;
  border-color: #fff;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: transparent !important;
  opacity: 0.9;
}

@media only screen and (max-width: 575px) {
  .chart-link {
    display: flex;
    align-items: center;
  }
}

@media only screen and (max-width: 1199px) {
  .chart-link {
    display: flex;
    align-items: center;
  }
}

@media only screen and (min-width: 1200px) {
  .chart-link {
    display: flex;
    align-items: center;
  }
}

.chart-link .week-link {
  display: inline-block;
}

.chart-link a {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
}

.chart-link a i {
  font-size: 13px;
}

.chart-link a i.text-primary {
  color: #00ADEE;
}

.chart-link a i.text-muted {
  color: #DAE2F3 !important;
}

.chart-link .form-control {
  max-width: 97px;
  display: inline-block;
}

.input-group.input-group-lg .form-control,
.input-group.input-group-lg .input-group-text {
  height: 80px;
  padding: 10px 30px;
}

@media only screen and (max-width: 575px) {

  .input-group.input-group-lg .form-control,
  .input-group.input-group-lg .input-group-text {
    height: 50px;
    padding: 10px 15px;
    font-size: 14px;
  }
}

.input-group.input-group-lg .input-group-text {
  width: 200px;
  text-align: left;
}

@media only screen and (max-width: 575px) {
  .input-group.input-group-lg .input-group-text {
    width: 120px;
    padding: 10px 15px;
    height: 50px;
    font-size: 14px;
  }
}

.card-tabs .nav-tabs {
  border-bottom: 0px;
  background: transparent;
  padding: 0;
  border-radius: 0;
  flex-wrap: unset;
}

.card-tabs .nav-tabs .nav-link {
  border-radius: 0;
  padding: 12px 20px;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid #EEEEEE;
  color: #00ADEE;
}

.card-tabs .nav-tabs .nav-link.active {
  background: #F4F5F9;
}

@media only screen and (max-width: 1400px) {
  .card-tabs .nav-tabs .nav-link {
    padding: 8px 15px;
    font-weight: 400;
    font-size: 13px;
  }
}

.card-tabs .nav-tabs.tabs-lg .nav-link {
  padding: 23px 30px;
  font-size: 16px;
}

@media only screen and (max-width: 767px) {
  .card-tabs .nav-tabs.tabs-lg .nav-link {
    padding: 10px 15px;
    font-size: 14px;
  }
}

.card-tabs.icontabs .nav-tabs {
  background: transparent;
}

.card-tabs.icontabs .nav-tabs .nav-item .nav-link {
  height: 42px;
  width: 42px;
  line-height: 42px;
  text-align: center;
  background: rgba(137, 137, 137, 0.6);
  color: #fff;
  margin-right: 15px;
  border-radius: 50px;
  padding: 0;
}

.card-tabs.icontabs .nav-tabs .nav-item .nav-link.active {
  background: #FF9B52;
}

.card-tabs.icontabs .nav-tabs .nav-item .nav-link i {
  font-size: 25px;
  line-height: 42px;
}

.revenue-chart .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
  display: flex !important;
  margin-right: 30px !important;
  margin-bottom: 30px !important;
}

.revenue-chart-bar {
  margin-bottom: -30px;
}

@media only screen and (max-width: 575px) {
  .revenue-chart-bar {
    margin-bottom: 20px;
    float: none;
    padding-left: 20px;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1600px) {
  .revenue-chart-bar {
    margin-bottom: 20px;
    float: none;
    padding-left: 20px;
  }
}

#activeUser {
  height: 215px !important;
}

#activeUser {
  height: 180px !important;
}

span#counter {
  font-size: 30px;
  font-weight: 700;
  color: #00ADEE;
}

.social-graph-wrapper {
  text-align: center;
  padding: 20px;
  position: relative;
  color: #fff;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.social-graph-wrapper.widget-facebook {
  background-color: #3b5998;
}

.social-graph-wrapper.widget-twitter {
  background-color: #1da1f2;
}

.social-graph-wrapper.widget-linkedin {
  background-color: #007bb6;
}

.social-graph-wrapper.widget-googleplus {
  background-color: #db4439;
}

.social-graph-wrapper .s-icon {
  font-size: 24px;
  position: relative;
  padding: 0 10px;
}

.recent-stats i {
  font-size: 11px;
  position: relative;
  top: -1px;
}

@media only screen and (min-width: 1200px) and (max-width: 1600px) {
  #lineChart_3Kk {
    height: 140px !important;
  }
}

/* add menu sidebar */
.add-menu-sidebar {
  background: #00ADEE;
  padding: 40px 20px 20px;
  border-radius: 0;
  position: relative;
  margin: 50px 50px 30px;
}

@media only screen and (max-width: 1400px) {
  .add-menu-sidebar {
    margin: 50px 25px 30px;
  }
}

@media only screen and (max-width: 575px) {
  .add-menu-sidebar {
    margin: 20px 25px 30px;
  }
}

.add-menu-sidebar p {
  font-size: 16px;
  line-height: 1.4;
  font-weight: 300;
  color: #fff;
}

.add-menu-sidebar:after {
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  bottom: 10px;
  right: 20px;
  content: "";
  height: 30px;
  width: 25px;
}

.donut-chart-sale {
  position: relative;
}

.donut-chart-sale small {
  font-size: 16px;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  display: flex;
  align-items: center;
  top: 0;
  justify-content: center;
  font-weight: 600;
}

.profile-bx .profile-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.profile-bx .profile-image img {
  margin: 18px;
  width: 118px;
}

.search-area {
  width: 300px;
}



.search-area .form-control {
  background: #EFEFEF !important;
  border-width: 0px;
  padding-left: 20px;
  min-height: 45px;
  max-height: 45px;
  border-radius: 0.5rem;
  /* border-top-left-radius: 60px;
  border-bottom-left-radius: 60px; */
}

.search-area .form-control::placeholder {
  color: #757575;
}

.search-area .input-group-text {
  background: #EFEFEF;
  border-width: 0px;
  border-top-right-radius: 60px;
  border-bottom-right-radius: 60px;
  padding-left: 0;
  padding-right: 20px;
}

.search-area .input-group-text i {
  font-size: 25px;
}

@media only screen and (max-width: 1400px) {
  .search-area .form-control {
    min-height: 45px;
    max-height: 45px;
  }

  .search-area .input-group-text i {
    font-size: 18px;
  }
}

@media only screen and (max-width: 991px) {
  .search-area .form-control {
    min-height: 45px;
    max-height: 45px;
    max-width: 200px;
  }
}

@media only screen and (max-width: 767px) {
  .search-area .form-control {
    min-height: 45px;
    max-height: 45px;
    max-width: 200px;
  }
}

@media only screen and (max-width: 576px) {
  .search-area .form-control {
    min-height: 45px;
    max-width: 200px;
  }
}

.donut-chart-sale {
  z-index: 1;
}

.donut-chart-sale .circle {
  height: 50px;
  width: 50px;
  z-index: -1;
  content: "";
  position: absolute;
  border-radius: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.donut-chart-sale small {
  font-size: 14px;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  display: flex;
  align-items: center;
  top: 0;
  justify-content: center;
  font-weight: 600;
}

.min-w24 {
  min-width: 24px;
}

.min-w30 {
  min-width: 30px;
}

.min-w32 {
  min-width: 32px;
}

.min-w42 {
  min-width: 42px;
}

.min-w46 {
  min-width: 46px;
}

.min-w50 {
  min-width: 50px;
}

.form-group.style-1 .form-control {
  border-color: transparent;
  margin-right: -45px;
  z-index: 0;
  color: #000;
  background: #F0F0F0;
  border-radius: 1.25rem;
}

.previous-transactions tbody tr td:first-child {
  width: 100px;
}

.rating-widget .rating-stars ul li i {
  font-size: 25px !important;
}

.border-card h2 {
  font-size: 54px;
}

@media only screen and (max-width: 1199px) {
  .border-card h2 {
    font-size: 42px;
  }
}

@media only screen and (max-width: 575px) {
  .border-card h2 {
    font-size: 35px;
  }
}

.border-card .position {
  font-size: 18px;
}

@media only screen and (max-width: 1199px) {
  .border-card .position {
    font-size: 14px;
  }
}

.border-card .cd-icon {
  height: 70px;
  width: 70px;
  line-height: 70px;
  min-width: 70px;
  text-align: center;
  border-radius: 1.25rem;
}

@media only screen and (max-width: 1199px) {
  .border-card .cd-icon {
    height: 50px;
    width: 50px;
    min-height: 50px;
    line-height: 46px;
    min-width: 50px;
  }

  .border-card .cd-icon svg {
    width: 25px;
    height: 25px;
  }
}

.border-card .line {
  height: 4px;
  border-radius: 1.25rem;
  width: 95%;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.heart {
  width: 60px;
  height: 60px;
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  cursor: pointer;
  margin: -25px -15px;
}

.heart-blast {
  background-position: -1680px 0;
  transition: background 1s steps(28);
}

@media only screen and (max-width: 1199px) {
  .profile-bx {
    border-right: 1px solid #EEEEEE;
  }
}

@media only screen and (max-width: 767px) {
  .profile-bx {
    border-right: 0;
  }
}

/*
===================================
    Product detail
===================================*/
.produtct-detail-tag {
  display: inline-block;
}

.produtct-detail-tag a {
  font-style: 13px;
  color: #B1B1B1;
}

.product-detail-content .item-tag {
  background: #828690;
  border-radius: 6px;
  display: inline-block;
  font-size: 12px;
  margin-right: 4px;
  padding: 2px 12px;
  color: #fff;
}

.filtaring-area h4 {
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 400;
  text-transform: lowercase;
}

.plus-minus-input .input-icon {
  font-size: 13px;
  color: #B1B1B1;
}

.plus-minus-input {
  display: flex;
  width: 120px;
}

.plus-minus-input .custom-btn {
  border-radius: 0;
  height: 40px;
  padding: 12px 8px;
  background: #fff;
  border: 1px solid #f0f1f5;
}

.plus-minus-input .form-control:hover,
.plus-minus-input .form-control:focus,
.plus-minus-input .form-control:active {
  border: 1px solid #f0f1f5;
}

.btn-reveal-trigger .avatar-xl {
  min-width: 30px;
}

.share-view {
  display: inline-block;
}

.share-view ul li {
  display: inline-block;
}

.share-view .share-icon {
  width: 40px;
  height: 40px;
  display: inline-block;
  border: 1px solid #f0f1f5;
  text-align: center;
  line-height: 40px;
  font-style: 16px;
  color: #f0f1f5;
  margin-right: 8px;
}

/*--------tab----------*/
.veritical-line {
  padding: 20px 30px;
  border-top: 1px solid #f0f1f5;
  border-right: 1px solid #f0f1f5;
  border-bottom: 1px solid #f0f1f5;
  position: relative;
}

.veritical-line:before {
  background: #f0f1f5;
  bottom: 0;
  content: "";
  height: 100%;
  left: -1px;
  max-height: 40%;
  position: absolute;
  width: 1px;
}

.tab-content-text p {
  color: #B1B1B1;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 25px;
}

.tab-item-list li a {
  background: #fff;
  border-top: 1px solid #f0f1f5;
  border-left: 1px solid #f0f1f5;
  border-right: 1px solid #f0f1f5;
  color: #B1B1B1;
  display: block;
  font-size: 16px;
  padding: 16px;
  text-transform: uppercase;
}

.tab-item-list li a:hover,
.tab-item-list li a:focus {
  background: #fff;
  color: #B1B1B1;
  border-right: 0px;
}

.tab-item-list li:last-child {
  border-bottom: 1px solid #f0f1f5;
}

.tab-list li {
  margin-bottom: 7px;
  font-size: 13px;
}

.tab-list li i {
  font-size: 13px;
  margin-right: 14px;
}

.slide-item-list {
  text-align: center;
  margin: 0 -5px;
}

.slide-item-list li {
  display: inline-block;
  flex: 0 0 25%;
  width: 25%;
  padding: 0 5px;
}

.slide-item-list li a {
  display: inline-block;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  background: transparent;
  padding-bottom: 0px;
}

.slide-item-list li a:hover,
.slide-item-list li a:focus {
  background: transparent;
}

.slide-item-list li a img {
  width: 100%;
}

.product-detail-text {
  padding-top: 28px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 70px;
}

.star-rating .product-review {
  font-style: 13px;
  color: #B1B1B1;
  font-weight: 400;
  text-decoration: underline !important;
}

.product-detail .tab-content img {
  display: inline-block;
  width: 100%;
}

.popular-tag ul {
  margin: 0px;
  padding: 0px;
}

.popular-tag ul li {
  display: inline-block;
  padding: 8px 15px;
  background: #f8f8f8;
  font-size: 13px;
  color: #fff;
  margin-right: 10px;
  margin-bottom: 10px;
}

.size-filter ul li {
  display: inline-block;
}

.intro {
  border: 1px solid red;
  color: #1d1d1d;
}

#listResults .slider {
  margin: 25px 0;
}

#listResults .slider-box {
  width: 90%;
  margin: 25px auto;
}

#listResults input {
  width: 10%;
}

#listResults label {
  border: none;
  display: inline-block;
  margin-right: -4px;
  vertical-align: top;
  width: 30%;
}

.plus-minus-input .input-icon {
  font-size: 13px;
  color: #aaaaaa;
}

.plus-minus-input .custom-btn {
  border-radius: 0;
  height: 40px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #c8c8c8;
}

.plus-minus-input .custom-btn:hover,
.plus-minus-input .custom-btn:focus,
.plus-minus-input .custom-btn.active {
  box-shadow: none;
  outline: none;
}

.plus-minus-input .form-control {
  height: 40px;
  border-top: 1px solid #c8c8c8;
  border-bottom: 1px solid #c8c8c8;
  border-left: 0px solid #c8c8c8;
  border-right: 1px solid #c8c8c8;
}

.plus-minus-input .form-control:hover,
.plus-minus-input .form-control:focus,
.plus-minus-input .form-control:active {
  border-top: 1px solid #c8c8c8;
  border-bottom: 1px solid #c8c8c8;
  border-left: 0px solid #c8c8c8;
  border-right: 0px solid #c8c8c8;
}

.new-arrival-product .new-arrivals-img-contnent {
  overflow: hidden;
}

.new-arrival-product .new-arrivals-img-contnent img {
  width: 100%;
  transition: all 0.5s;
}

.new-arrival-product:hover .new-arrivals-img-contnent img {
  transform: scale(1.5) translateY(12%);
  -moz-transform: scale(1.5) translateY(12%);
  -webkit-transform: scale(1.5) translateY(12%);
  -ms-transform: scale(1.5) translateY(12%);
  -o-transform: scale(1.5) translateY(12%);
}

/*
===================================
    list view
===================================*/
.new-arrival-content .item {
  font-size: 12px;
  color: #B1B1B1;
}

.new-arrival-content h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.new-arrival-content h4 a {
  color: #000;
}

.new-arrival-content .price {
  font-weight: 600;
  color: #00ADEE;
  font-size: 24px;
  margin-bottom: 0;
  float: right;
}

@media only screen and (max-width: 575px) {
  .new-arrival-content .price {
    float: none;
    margin-top: 10px;
  }
}

.new-arrival-content p {
  font-size: 14px;
  color: #828690;
  margin-bottom: 6px;
  line-height: 24px;
}

.new-arrival-content .text-content {
  margin-top: 18px;
}

.new-arrival-content.text-center .price {
  float: unset;
}

.success-icon {
  color: #2BC155;
  font-size: 16px;
}

.comment-review {
  margin-bottom: 15px;
  display: table;
  width: 100%;
}

.comment-review .client-review {
  color: #828690;
  padding-right: 20px;
  text-decoration: underline !important;
  font-size: 14px;
}

.comment-review .span {
  color: #828690;
  font-size: 14px;
}

@media only screen and (max-width: 575px) {
  .comment-review {
    margin-bottom: 0;
  }
}

.star-rating li {
  display: inline-block;
}

.star-rating li i {
  color: gold;
}

.rtl {
  text-align: right;
  direction: rtl;
}

.rtl .nav {
  padding-right: 0;
}

.rtl .navbar-nav .nav-item {
  float: right;
}

.rtl .navbar-nav .nav-item+.nav-item {
  margin-right: 1rem;
  margin-left: inherit;
}

.rtl th {
  text-align: right;
}

.rtl .alert-dismissible {
  padding-right: 1.25rem;
  padding-left: 4rem;
}

.rtl .dropdown-menu {
  right: 0;
  text-align: right;
}

.rtl .checkbox label {
  padding-right: 1.25rem;
  padding-left: inherit;
}

.rtl .btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-radius: 0 0.75rem 0.75rem 0;
}

.rtl .btn-group>.btn:last-child:not(:first-child),
.rtl .btn-group>.dropdown-toggle:not(:first-child) {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .custom-control-label::after,
.rtl .custom-control-label::before {
  right: 0;
  left: inherit;
}

.rtl .custom-select {
  padding: 0.375rem 0.75rem 0.375rem 1.75rem;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat left 0.75rem center;
  background-size: 8px 10px;
}

.rtl .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.rtl .input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
.rtl .input-group>.input-group-append:not(:last-child)>.btn,
.rtl .input-group>.input-group-append:not(:last-child)>.input-group-text,
.rtl .input-group>.input-group-prepend>.btn,
.rtl .input-group>.input-group-prepend>.input-group-text {
  border-radius: 0 0.75rem 0.75rem 0;
}

.rtl .input-group>.input-group-append>.btn,
.rtl .input-group>.input-group-append>.input-group-text,
.rtl .input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.rtl .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.rtl .input-group>.input-group-prepend:not(:first-child)>.btn,
.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .input-group>.custom-select:not(:first-child),
.rtl .input-group>.form-control:not(:first-child) {
  border-radius: 0.75rem 0 0 0.75rem;
}

.rtl .input-group>.custom-select:not(:last-child),
.rtl .input-group>.form-control:not(:last-child) {
  border-radius: 0 0.75rem 0.75rem 0;
}

.rtl .input-group>.custom-select:not(:last-child):not(:first-child),
.rtl .input-group>.form-control:not(:last-child):not(:first-child) {
  border-radius: 0;
}

.rtl .custom-control {
  padding-right: 1.5rem;
  padding-left: inherit;
  margin-right: inherit;
  margin-left: 1rem;
}

.rtl .custom-control-indicator {
  right: 0;
  left: inherit;
}

.rtl .custom-file-label::after {
  right: initial;
  left: -1px;
  border-radius: .25rem 0 0 .25rem;
}

.rtl .radio input,
.rtl .radio-inline,
.rtl .checkbox input,
.rtl .checkbox-inline input {
  margin-right: -1.25rem;
  margin-left: inherit;
}

.rtl .list-group {
  padding-right: 0;
  padding-left: 40px;
}

.rtl .close {
  float: left;
}

.rtl .modal-header .close {
  margin: -15px auto -15px -15px;
}

.rtl .modal-footer> :not(:first-child) {
  margin-right: .25rem;
}

.rtl .alert-dismissible .close {
  right: inherit;
  left: 0;
}

.rtl .dropdown-toggle::after {
  margin-right: .255em;
  margin-left: 0;
}

.rtl .form-check-input {
  margin-right: -1.25rem;
  margin-left: inherit;
}

.rtl .form-check-label {
  padding-right: 1.25rem;
  padding-left: inherit;
}

.rtl .offset-1 {
  margin-right: 8.3333333333%;
  margin-left: 0;
}

.rtl .offset-2 {
  margin-right: 16.6666666667%;
  margin-left: 0;
}

.rtl .offset-3 {
  margin-right: 25%;
  margin-left: 0;
}

.rtl .offset-4 {
  margin-right: 33.3333333333%;
  margin-left: 0;
}

.rtl .offset-5 {
  margin-right: 41.6666666667%;
  margin-left: 0;
}

.rtl .offset-6 {
  margin-right: 50%;
  margin-left: 0;
}

.rtl .offset-7 {
  margin-right: 58.3333333333%;
  margin-left: 0;
}

.rtl .offset-8 {
  margin-right: 66.6666666667%;
  margin-left: 0;
}

.rtl .offset-9 {
  margin-right: 75%;
  margin-left: 0;
}

.rtl .offset-10 {
  margin-right: 83.3333333333%;
  margin-left: 0;
}

.rtl .offset-11 {
  margin-right: 91.6666666667%;
  margin-left: 0;
}

@media (min-width: 576px) {
  .rtl .offset-sm-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-sm-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-sm-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-sm-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-sm-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-sm-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-sm-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-sm-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-sm-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .rtl .offset-md-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-md-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-md-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-md-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-md-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-md-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-md-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-md-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-md-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 992px) {
  .rtl .offset-lg-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-lg-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-lg-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-lg-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-lg-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-lg-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-lg-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-lg-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-lg-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 1200px) {
  .rtl .offset-xl-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-xl-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xl-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-xl-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xl-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-xl-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xl-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-xl-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xl-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

@media (min-width: 1440) {
  .rtl .offset-xxl-0 {
    margin-right: 0;
    margin-left: 0;
  }

  .rtl .offset-xxl-1 {
    margin-right: 8.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-2 {
    margin-right: 16.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xxl-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .offset-xxl-4 {
    margin-right: 33.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-5 {
    margin-right: 41.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xxl-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .offset-xxl-7 {
    margin-right: 58.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-8 {
    margin-right: 66.6666666667%;
    margin-left: 0;
  }

  .rtl .offset-xxl-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .offset-xxl-10 {
    margin-right: 83.3333333333%;
    margin-left: 0;
  }

  .rtl .offset-xxl-11 {
    margin-right: 91.6666666667%;
    margin-left: 0;
  }
}

.rtl .mr-0,
.rtl .mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.rtl .ml-0,
.rtl .mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.rtl .mr-1,
.rtl .mx-1 {
  margin-right: 0 !important;
  margin-left: 0.25rem !important;
}

.rtl .ml-1,
.rtl .mx-1 {
  margin-left: 0 !important;
  margin-right: 0.25rem !important;
}

.rtl .mr-2,
.rtl .mx-2 {
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}

.rtl .ml-2,
.rtl .mx-2 {
  margin-left: 0 !important;
  margin-right: 0.5rem !important;
}

.rtl .mr-3,
.rtl .mx-3 {
  margin-right: 0 !important;
  margin-left: 1rem !important;
}

.rtl .ml-3,
.rtl .mx-3 {
  margin-left: 0 !important;
  margin-right: 1rem !important;
}

.rtl .mr-4,
.rtl .mx-4 {
  margin-right: 0 !important;
  margin-left: 1.5rem !important;
}

.rtl .ml-4,
.rtl .mx-4 {
  margin-left: 0 !important;
  margin-right: 1.5rem !important;
}

.rtl .mr-5,
.rtl .mx-5 {
  margin-right: 0 !important;
  margin-left: 3rem !important;
}

.rtl .ml-5,
.rtl .mx-5 {
  margin-left: 0 !important;
  margin-right: 3rem !important;
}

.rtl .pr-0,
.rtl .px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.rtl .pl-0,
.rtl .px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.rtl .pr-1,
.rtl .px-1 {
  padding-right: 0 !important;
  padding-left: 0.25rem !important;
}

.rtl .pl-1,
.rtl .px-1 {
  padding-left: 0 !important;
  padding-right: 0.25rem !important;
}

.rtl .pr-2,
.rtl .px-2 {
  padding-right: 0 !important;
  padding-left: 0.5rem !important;
}

.rtl .pl-2,
.rtl .px-2 {
  padding-left: 0 !important;
  padding-right: 0.5rem !important;
}

.rtl .pr-3,
.rtl .px-3 {
  padding-right: 0 !important;
  padding-left: 1rem !important;
}

.rtl .pl-3,
.rtl .px-3 {
  padding-left: 0 !important;
  padding-right: 1rem !important;
}

.rtl .pr-4,
.rtl .px-4 {
  padding-right: 0 !important;
  padding-left: 1.5rem !important;
}

.rtl .pl-4,
.rtl .px-4 {
  padding-left: 0 !important;
  padding-right: 1.5rem !important;
}

.rtl .pr-5,
.rtl .px-5 {
  padding-right: 0 !important;
  padding-left: 3rem !important;
}

.rtl .pl-5,
.rtl .px-5 {
  padding-left: 0 !important;
  padding-right: 3rem !important;
}

.rtl .mr-auto {
  margin-right: 0 !important;
  margin-left: auto !important;
}

.rtl .ml-auto {
  margin-right: auto !important;
  margin-left: 0 !important;
}

.rtl .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

@media (min-width: 576px) {

  .rtl .mr-sm-0,
  .rtl .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-sm-0,
  .rtl .mx-sm-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-sm-1,
  .rtl .mx-sm-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-sm-1,
  .rtl .mx-sm-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-sm-2,
  .rtl .mx-sm-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-sm-2,
  .rtl .mx-sm-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-sm-3,
  .rtl .mx-sm-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-sm-3,
  .rtl .mx-sm-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-sm-4,
  .rtl .mx-sm-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-sm-4,
  .rtl .mx-sm-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-sm-5,
  .rtl .mx-sm-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-sm-5,
  .rtl .mx-sm-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-sm-0,
  .rtl .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-sm-0,
  .rtl .px-sm-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-sm-1,
  .rtl .px-sm-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-sm-1,
  .rtl .px-sm-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-sm-2,
  .rtl .px-sm-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-sm-2,
  .rtl .px-sm-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-sm-3,
  .rtl .px-sm-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-sm-3,
  .rtl .px-sm-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-sm-4,
  .rtl .px-sm-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-sm-4,
  .rtl .px-sm-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-sm-5,
  .rtl .px-sm-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-sm-5,
  .rtl .px-sm-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-sm-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-sm-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {

  .rtl .mr-md-0,
  .rtl .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-md-0,
  .rtl .mx-md-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-md-1,
  .rtl .mx-md-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-md-1,
  .rtl .mx-md-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-md-2,
  .rtl .mx-md-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-md-2,
  .rtl .mx-md-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-md-3,
  .rtl .mx-md-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-md-3,
  .rtl .mx-md-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-md-4,
  .rtl .mx-md-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-md-4,
  .rtl .mx-md-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-md-5,
  .rtl .mx-md-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-md-5,
  .rtl .mx-md-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-md-0,
  .rtl .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-md-0,
  .rtl .px-md-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-md-1,
  .rtl .px-md-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-md-1,
  .rtl .px-md-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-md-2,
  .rtl .px-md-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-md-2,
  .rtl .px-md-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-md-3,
  .rtl .px-md-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-md-3,
  .rtl .px-md-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-md-4,
  .rtl .px-md-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-md-4,
  .rtl .px-md-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-md-5,
  .rtl .px-md-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-md-5,
  .rtl .px-md-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-md-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-md-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {

  .rtl .mr-lg-0,
  .rtl .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-lg-0,
  .rtl .mx-lg-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-lg-1,
  .rtl .mx-lg-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-lg-1,
  .rtl .mx-lg-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-lg-2,
  .rtl .mx-lg-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-lg-2,
  .rtl .mx-lg-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-lg-3,
  .rtl .mx-lg-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-lg-3,
  .rtl .mx-lg-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-lg-4,
  .rtl .mx-lg-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-lg-4,
  .rtl .mx-lg-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-lg-5,
  .rtl .mx-lg-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-lg-5,
  .rtl .mx-lg-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-lg-0,
  .rtl .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-lg-0,
  .rtl .px-lg-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-lg-1,
  .rtl .px-lg-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-lg-1,
  .rtl .px-lg-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-lg-2,
  .rtl .px-lg-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-lg-2,
  .rtl .px-lg-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-lg-3,
  .rtl .px-lg-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-lg-3,
  .rtl .px-lg-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-lg-4,
  .rtl .px-lg-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-lg-4,
  .rtl .px-lg-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-lg-5,
  .rtl .px-lg-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-lg-5,
  .rtl .px-lg-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-lg-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-lg-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {

  .rtl .mr-xl-0,
  .rtl .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-xl-0,
  .rtl .mx-xl-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-xl-1,
  .rtl .mx-xl-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-xl-1,
  .rtl .mx-xl-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-xl-2,
  .rtl .mx-xl-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-xl-2,
  .rtl .mx-xl-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-xl-3,
  .rtl .mx-xl-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-xl-3,
  .rtl .mx-xl-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-xl-4,
  .rtl .mx-xl-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-xl-4,
  .rtl .mx-xl-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-xl-5,
  .rtl .mx-xl-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-xl-5,
  .rtl .mx-xl-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-xl-0,
  .rtl .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-xl-0,
  .rtl .px-xl-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-xl-1,
  .rtl .px-xl-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-xl-1,
  .rtl .px-xl-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-xl-2,
  .rtl .px-xl-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-xl-2,
  .rtl .px-xl-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-xl-3,
  .rtl .px-xl-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-xl-3,
  .rtl .px-xl-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-xl-4,
  .rtl .px-xl-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-xl-4,
  .rtl .px-xl-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-xl-5,
  .rtl .px-xl-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-xl-5,
  .rtl .px-xl-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-xl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-xl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1440) {

  .rtl .mr-xxl-0,
  .rtl .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .rtl .ml-xxl-0,
  .rtl .mx-xxl-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .rtl .mr-xxl-1,
  .rtl .mx-xxl-1 {
    margin-right: 0 !important;
    margin-left: 0.25rem !important;
  }

  .rtl .ml-xxl-1,
  .rtl .mx-xxl-1 {
    margin-left: 0 !important;
    margin-right: 0.25rem !important;
  }

  .rtl .mr-xxl-2,
  .rtl .mx-xxl-2 {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
  }

  .rtl .ml-xxl-2,
  .rtl .mx-xxl-2 {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  .rtl .mr-xxl-3,
  .rtl .mx-xxl-3 {
    margin-right: 0 !important;
    margin-left: 1rem !important;
  }

  .rtl .ml-xxl-3,
  .rtl .mx-xxl-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  .rtl .mr-xxl-4,
  .rtl .mx-xxl-4 {
    margin-right: 0 !important;
    margin-left: 1.5rem !important;
  }

  .rtl .ml-xxl-4,
  .rtl .mx-xxl-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }

  .rtl .mr-xxl-5,
  .rtl .mx-xxl-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }

  .rtl .ml-xxl-5,
  .rtl .mx-xxl-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }

  .rtl .pr-xxl-0,
  .rtl .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .rtl .pl-xxl-0,
  .rtl .px-xxl-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .rtl .pr-xxl-1,
  .rtl .px-xxl-1 {
    padding-right: 0 !important;
    padding-left: 0.25rem !important;
  }

  .rtl .pl-xxl-1,
  .rtl .px-xxl-1 {
    padding-left: 0 !important;
    padding-right: 0.25rem !important;
  }

  .rtl .pr-xxl-2,
  .rtl .px-xxl-2 {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
  }

  .rtl .pl-xxl-2,
  .rtl .px-xxl-2 {
    padding-left: 0 !important;
    padding-right: 0.5rem !important;
  }

  .rtl .pr-xxl-3,
  .rtl .px-xxl-3 {
    padding-right: 0 !important;
    padding-left: 1rem !important;
  }

  .rtl .pl-xxl-3,
  .rtl .px-xxl-3 {
    padding-left: 0 !important;
    padding-right: 1rem !important;
  }

  .rtl .pr-xxl-4,
  .rtl .px-xxl-4 {
    padding-right: 0 !important;
    padding-left: 1.5rem !important;
  }

  .rtl .pl-xxl-4,
  .rtl .px-xxl-4 {
    padding-left: 0 !important;
    padding-right: 1.5rem !important;
  }

  .rtl .pr-xxl-5,
  .rtl .px-xxl-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }

  .rtl .pl-xxl-5,
  .rtl .px-xxl-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }

  .rtl .mr-xxl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .ml-xxl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

.rtl .text-right {
  text-align: left !important;
}

.rtl .text-left {
  text-align: right !important;
}

@media (min-width: 576px) {
  .rtl .text-sm-right {
    text-align: left !important;
  }

  .rtl .text-sm-left {
    text-align: right !important;
  }
}

@media (min-width: 768px) {
  .rtl .text-md-right {
    text-align: left !important;
  }

  .rtl .text-md-left {
    text-align: right !important;
  }
}

@media (min-width: 992px) {
  .rtl .text-lg-right {
    text-align: left !important;
  }

  .rtl .text-lg-left {
    text-align: right !important;
  }
}

@media (min-width: 1200px) {
  .rtl .text-xl-right {
    text-align: left !important;
  }

  .rtl .text-xl-left {
    text-align: right !important;
  }
}

@media (min-width: 1440) {
  .rtl .text-xxl-right {
    text-align: left !important;
  }

  .rtl .text-xxl-left {
    text-align: right !important;
  }
}

.rtl .mx-0 {
  margin-right: auto;
  margin-left: 0 !important;
}

.rtl .mx-0 {
  margin-left: auto;
  margin-right: 0 !important;
}

.rtl .mx-1 {
  margin-right: auto;
  margin-left: 0.25rem !important;
}

.rtl .mx-1 {
  margin-left: auto;
  margin-right: 0.25rem !important;
}

.rtl .mx-2 {
  margin-right: auto;
  margin-left: 0.5rem !important;
}

.rtl .mx-2 {
  margin-left: auto;
  margin-right: 0.5rem !important;
}

.rtl .mx-3 {
  margin-right: auto;
  margin-left: 1rem !important;
}

.rtl .mx-3 {
  margin-left: auto;
  margin-right: 1rem !important;
}

.rtl .mx-4 {
  margin-right: auto;
  margin-left: 1.5rem !important;
}

.rtl .mx-4 {
  margin-left: auto;
  margin-right: 1.5rem !important;
}

.rtl .mx-5 {
  margin-right: auto;
  margin-left: 3rem !important;
}

.rtl .mx-5 {
  margin-left: auto;
  margin-right: 3rem !important;
}

.rtl .px-0 {
  padding-right: auto;
  padding-left: 0 !important;
}

.rtl .px-0 {
  padding-left: auto;
  padding-right: 0 !important;
}

.rtl .px-1 {
  padding-right: auto;
  padding-left: 0.25rem !important;
}

.rtl .px-1 {
  padding-left: auto;
  padding-right: 0.25rem !important;
}

.rtl .px-2 {
  padding-right: auto;
  padding-left: 0.5rem !important;
}

.rtl .px-2 {
  padding-left: auto;
  padding-right: 0.5rem !important;
}

.rtl .px-3 {
  padding-right: auto;
  padding-left: 1rem !important;
}

.rtl .px-3 {
  padding-left: auto;
  padding-right: 1rem !important;
}

.rtl .px-4 {
  padding-right: auto;
  padding-left: 1.5rem !important;
}

.rtl .px-4 {
  padding-left: auto;
  padding-right: 1.5rem !important;
}

.rtl .px-5 {
  padding-right: auto;
  padding-left: 3rem !important;
}

.rtl .px-5 {
  padding-left: auto;
  padding-right: 3rem !important;
}

.rtl .mr-auto {
  margin-right: 0 !important;
  margin-left: auto !important;
}

.rtl .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.rtl .ml-auto {
  margin-right: auto !important;
  margin-left: 0 !important;
}

.rtl .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .rtl .mx-sm-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-sm-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-sm-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-sm-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-sm-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-sm-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-sm-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-sm-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-sm-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-sm-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-sm-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-sm-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-sm-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-sm-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-sm-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-sm-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-sm-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-sm-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-sm-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-sm-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-sm-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-sm-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-sm-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-sm-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-sm-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-sm-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .rtl .mx-md-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-md-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-md-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-md-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-md-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-md-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-md-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-md-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-md-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-md-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-md-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-md-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-md-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-md-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-md-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-md-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-md-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-md-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-md-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-md-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-md-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-md-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-md-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-md-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-md-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-md-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .rtl .mx-lg-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-lg-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-lg-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-lg-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-lg-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-lg-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-lg-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-lg-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-lg-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-lg-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-lg-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-lg-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-lg-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-lg-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-lg-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-lg-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-lg-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-lg-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-lg-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-lg-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-lg-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-lg-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-lg-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-lg-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-lg-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-lg-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .rtl .mx-xl-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-xl-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-xl-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-xl-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-xl-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-xl-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-xl-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-xl-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-xl-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-xl-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-xl-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-xl-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-xl-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-xl-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-xl-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-xl-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-xl-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-xl-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-xl-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-xl-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-xl-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-xl-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-xl-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-xl-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-xl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-xl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

@media (min-width: 1440) {
  .rtl .mx-xxl-0 {
    margin-right: auto;
    margin-left: 0 !important;
  }

  .rtl .mx-xxl-0 {
    margin-left: auto;
    margin-right: 0 !important;
  }

  .rtl .mx-xxl-1 {
    margin-right: auto;
    margin-left: 0.25rem !important;
  }

  .rtl .mx-xxl-1 {
    margin-left: auto;
    margin-right: 0.25rem !important;
  }

  .rtl .mx-xxl-2 {
    margin-right: auto;
    margin-left: 0.5rem !important;
  }

  .rtl .mx-xxl-2 {
    margin-left: auto;
    margin-right: 0.5rem !important;
  }

  .rtl .mx-xxl-3 {
    margin-right: auto;
    margin-left: 1rem !important;
  }

  .rtl .mx-xxl-3 {
    margin-left: auto;
    margin-right: 1rem !important;
  }

  .rtl .mx-xxl-4 {
    margin-right: auto;
    margin-left: 1.5rem !important;
  }

  .rtl .mx-xxl-4 {
    margin-left: auto;
    margin-right: 1.5rem !important;
  }

  .rtl .mx-xxl-5 {
    margin-right: auto;
    margin-left: 3rem !important;
  }

  .rtl .mx-xxl-5 {
    margin-left: auto;
    margin-right: 3rem !important;
  }

  .rtl .px-xxl-0 {
    padding-right: auto;
    padding-left: 0 !important;
  }

  .rtl .px-xxl-0 {
    padding-left: auto;
    padding-right: 0 !important;
  }

  .rtl .px-xxl-1 {
    padding-right: auto;
    padding-left: 0.25rem !important;
  }

  .rtl .px-xxl-1 {
    padding-left: auto;
    padding-right: 0.25rem !important;
  }

  .rtl .px-xxl-2 {
    padding-right: auto;
    padding-left: 0.5rem !important;
  }

  .rtl .px-xxl-2 {
    padding-left: auto;
    padding-right: 0.5rem !important;
  }

  .rtl .px-xxl-3 {
    padding-right: auto;
    padding-left: 1rem !important;
  }

  .rtl .px-xxl-3 {
    padding-left: auto;
    padding-right: 1rem !important;
  }

  .rtl .px-xxl-4 {
    padding-right: auto;
    padding-left: 1.5rem !important;
  }

  .rtl .px-xxl-4 {
    padding-left: auto;
    padding-right: 1.5rem !important;
  }

  .rtl .px-xxl-5 {
    padding-right: auto;
    padding-left: 3rem !important;
  }

  .rtl .px-xxl-5 {
    padding-left: auto;
    padding-right: 3rem !important;
  }

  .rtl .mr-xxl-auto {
    margin-right: 0 !important;
    margin-left: auto !important;
  }

  .rtl .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .rtl .ml-xxl-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  .rtl .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
}

.rtl .float-left {
  float: right !important;
}

.rtl .float-right {
  float: left !important;
}

.rtl .float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .rtl .float-sm-left {
    float: right !important;
  }

  .rtl .float-sm-right {
    float: left !important;
  }

  .rtl .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .rtl .float-md-left {
    float: right !important;
  }

  .rtl .float-md-right {
    float: left !important;
  }

  .rtl .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .rtl .float-lg-left {
    float: right !important;
  }

  .rtl .float-lg-right {
    float: left !important;
  }

  .rtl .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .rtl .float-xl-left {
    float: right !important;
  }

  .rtl .float-xl-right {
    float: left !important;
  }

  .rtl .float-xl-none {
    float: none !important;
  }
}

@media (min-width: 1440) {
  .rtl .float-xxl-left {
    float: right !important;
  }

  .rtl .float-xxl-right {
    float: left !important;
  }

  .rtl .float-xxl-none {
    float: none !important;
  }
}

[direction="rtl"][data-theme-version="dark"] .border,
[direction="rtl"][data-theme-version="dark"] .border-left,
[direction="rtl"][data-theme-version="dark"] .border-right {
  border-color: #333a54 !important;
}

[direction="rtl"] .text-right {
  text-align: left !important;
}

[direction="rtl"] .text-left {
  text-align: right !important;
}

[direction="rtl"] .border-right {
  border-left: 1px solid #f0f1f5 !important;
  border-right: 0 !important;
}

[direction="rtl"] .border-left {
  border-right: 1px solid #f0f1f5 !important;
  border-left: 0 !important;
}

[direction="rtl"] .dropdown-menu {
  left: auto;
}

[direction="rtl"] .dropdown-menu-right {
  left: 0;
  right: auto;
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .dropdown-menu-right {
    left: 15px;
  }
}

[direction="rtl"] .notification_dropdown .dropdown-menu-right .media>span {
  margin-left: 10px;
  margin-right: 0;
}

[direction="rtl"]:not([data-container="boxed"]) .nav-header {
  left: auto;
  right: 0;
}

[direction="rtl"][data-container="wide-boxed"] .nav-header {
  left: auto;
  right: 0;
}

[direction="rtl"] .nav-header {
  text-align: right;
  right: auto;
}

[direction="rtl"] .nav-header .brand-title {
  margin-left: 0;
  margin-right: 15px;
}

[direction="rtl"] .nav-header .brand-logo {
  padding-left: 0;
  padding-right: 1.75rem;
}

[data-sidebar-style="compact"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 0;
}

[data-sidebar-style="compact"][direction="rtl"] .nav-header .brand-logo[data-layout="horizontal"] {
  padding-right: 30px;
}

[data-sidebar-style="mini"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 0;
}

[data-sidebar-style="modern"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 0;
}

[data-layout="horizontal"][data-sidebar-style="modern"][direction="rtl"] .nav-header .brand-logo {
  padding-right: 30px;
}

@media (max-width: 767.98px) {
  [direction="rtl"] .nav-header .brand-logo {
    padding-right: 0;
  }
}

[direction="rtl"] .nav-control {
  right: auto;
  left: -4.0625rem;
}

@media (max-width: 767.98px) {
  [direction="rtl"] .nav-control {
    left: -4.0625rem;
  }
}

@media (max-width: 575.98px) {
  [direction="rtl"] .nav-control {
    left: -4.0625rem;
  }
}

[direction="rtl"][data-sidebar-style="overlay"] .nav-header .hamburger.is-active {
  right: 0;
}

[direction="rtl"][data-sidebar-style="compact"][data-layout="horizontal"] .nav-header .brand-logo {
  padding-right: 30px;
}

[direction="rtl"][data-sidebar-style="modern"][data-layout="horizontal"] .nav-header {
  width: 16rem;
}

[direction="rtl"] .header {
  padding: 0 0.9375rem;
  padding-right: 17.1875rem;
}

@media (max-width: 767.98px) {
  [direction="rtl"] .header {
    padding-right: 3.75rem;
    padding-left: 0;
  }
}

[direction="rtl"] .header .header-content {
  padding-left: 0;
  padding-right: 5.3125rem;
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .header .header-content {
    padding-right: 4.5rem;
  }
}

[data-sidebar-style="compact"][direction="rtl"] .header .header-content {
  padding-right: 1.875rem;
}

[data-sidebar-style="modern"][direction="rtl"] .header .header-content {
  padding-right: 5.3125rem;
}

[data-sidebar-style="overlay"][direction="rtl"] .header .header-content {
  padding-right: 5.3125rem;
}

[direction="rtl"] .header .nav-control {
  right: 0.4375rem;
  left: auto;
}

[direction="rtl"] .header-left .search_bar .dropdown-menu,
[direction="rtl"] .header-left .search_bar .dropdown-menu.show {
  right: 40px !important;
}

@media only screen and (max-width: 575px) {

  [direction="rtl"] .header-left .search_bar .dropdown-menu,
  [direction="rtl"] .header-left .search_bar .dropdown-menu.show {
    right: -100px !important;
  }
}

[direction="rtl"] .header-left .search_bar .search_icon {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5rem;
  border-bottom-right-radius: 5rem;
}

@media only screen and (max-width: 575px) {
  [direction="rtl"] .header-left .search_bar .search_icon {
    border-radius: 5rem;
  }
}

[direction="rtl"][data-layout="horizontal"] .header {
  padding: 0;
  padding-right: 16rem;
}

[direction="rtl"][data-layout="horizontal"] .header .header-content {
  padding-right: 1.875rem;
  padding-left: 1.875rem;
}

[direction="rtl"][data-layout="horizontal"][data-sidebar-style="mini"] .header {
  padding-right: 6rem;
}

[direction="rtl"][data-sidebar-style="mini"] .header {
  padding: 0 0.9375rem;
  padding-right: 3.75rem;
}

[direction="rtl"][data-sidebar-style="compact"] .header {
  padding: 0 0.9375rem;
  padding-right: 9.375rem;
}

[direction="rtl"][data-sidebar-style="compact"][data-layout="horizontal"] .header {
  padding: 0;
  padding-right: 16rem;
}

[direction="rtl"][data-sidebar-style="modern"] .header {
  padding: 0 0.9375rem;
  padding-right: 9.375rem;
}

[direction="rtl"][data-sidebar-style="modern"][data-layout="horizontal"] .header {
  padding: 0;
  padding-right: 16rem;
}

[direction="rtl"] {
  text-align: right;
}

[direction="rtl"] .deznav {
  text-align: right;
}

[direction="rtl"] .deznav .metismenu ul {
  padding: 0 25px 0 0;
}

[direction="rtl"] .deznav .metismenu ul:after {
  left: auto;
  right: 25px;
}

[direction="rtl"] .deznav .metismenu ul a:before {
  left: auto;
  right: -5px;
}

[direction="rtl"] .deznav .metismenu li>a svg {
  margin-left: 5px;
  margin-right: 0;
}

[data-sidebar-style="compact"][direction="rtl"] .deznav .metismenu li>a svg {
  left: auto;
  margin-left: auto;
  margin-right: auto;
}

[data-sidebar-style="icon-hover"][direction="rtl"] .deznav .metismenu li>a svg {
  margin-left: 0;
}

[direction="rtl"] .deznav .metismenu li.active>.has-arrow:after {
  transform: rotate(45deg) translateY(-50%);
}

[direction="rtl"] .deznav .metismenu .has-arrow:after {
  left: 1.5625rem;
  right: auto;
}

[data-layout="horizontal"][direction="rtl"] .deznav .metismenu .has-arrow:after {
  left: 1.125rem;
}

[data-sidebar-style="modern"][direction="rtl"] .deznav .metismenu .has-arrow:after {
  transform: rotate(-45deg) translateY(-50%);
}

[direction="rtl"][data-sidebar-style="full"][data-layout="vertical"] .menu-toggle .deznav .metismenu li>ul li:hover ul {
  right: 11.8125rem;
  left: 0;
}

[direction="rtl"] .list-group {
  padding-left: 0;
}

[direction="rtl"] .form-check-input {
  margin-left: -1.25rem;
  margin-right: inherit;
}

[direction="rtl"] .form-check-inline .form-check-input {
  margin-right: 0;
  margin-left: 10px;
}

[direction="rtl"] .radio input,
[direction="rtl"] .radio-inline,
[direction="rtl"] .checkbox input,
[direction="rtl"] .checkbox-inline input {
  margin-left: 0;
  margin-right: 0;
}

[direction="rtl"] .content-body {
  margin-right: 17.1875rem;
  margin-left: auto;
}

[data-sidebar-style="modern"][direction="rtl"] .content-body {
  margin-right: 9.375rem;
}

[direction="rtl"] .content-body .page-titles {
  text-align: right;
}

[direction="rtl"][data-layout="horizontal"] .content-body {
  margin-right: 0;
}

[direction="rtl"][data-layout="horizontal"] .deznav .metismenu li li .has-arrow:after {
  transform: rotate(-45deg) translateY(-50%);
}

[direction="rtl"][data-sidebar-style="mini"]:not([data-layout="horizontal"]) .content-body {
  margin-right: 3.75rem;
}

[direction="rtl"][data-sidebar-style="compact"]:not([data-layout="horizontal"]) .content-body {
  margin-right: 9.375rem;
}

[direction="rtl"][data-sidebar-style="overlay"] .content-body {
  margin-right: 0;
}

[direction="rtl"] #external-events .external-event:before {
  margin-right: 0;
  margin-left: .9rem;
}

[direction="rtl"] .post-input a i {
  margin-left: 15px;
  margin-right: 0;
}

@media only screen and (max-width: 1350px) and (min-width: 1200px) {
  [direction="rtl"] .content-body {
    margin-right: 14.375rem;
  }
}

[direction="rtl"] .sidebar-right {
  left: -15.625rem;
  right: auto;
  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
}

[direction="rtl"] .sidebar-right.show {
  left: 0;
  right: auto;
}

[direction="rtl"] .sidebar-right .sidebar-right-trigger {
  left: 100%;
  right: auto;
  border-radius: 0 5px 5px 0;
  box-shadow: 5px 3px 5px 0px rgba(119, 119, 119, 0.15);
}

[direction="rtl"] .bootstrap-select .dropdown-toggle .filter-option {
  text-align: right;
}

html[dir="rtl"] [direction="rtl"] .footer {
  padding-right: 17.1875rem;
  padding-left: 0;
}

@media (max-width: 767.98px) {
  html[dir="rtl"] [direction="rtl"] .footer {
    padding-right: 0;
  }
}

html[dir="rtl"] [direction="rtl"][data-sidebar-style="overlay"] .footer {
  padding-right: 0;
}

html[dir="rtl"] [direction="rtl"] .menu-toggle .footer {
  padding-right: 3.75rem;
}

html[dir="rtl"] [direction="rtl"][data-container="boxed"] .footer {
  padding-right: 0;
}

html[dir="rtl"] [direction="rtl"][data-sidebar-style="mini"]:not([data-layout="horizontal"]) .footer {
  padding-right: 3.75rem;
}

html[dir="rtl"] [direction="rtl"][data-sidebar-style="compact"]:not([data-layout="horizontal"]) .footer {
  padding-right: 9.375rem;
}

/*\$primary  : #7356f1 !default;*/
[data-theme-version="dark"] {
  background: #181f39;
  color: #828690;
}

[data-theme-version="dark"] h1,
[data-theme-version="dark"] h2,
[data-theme-version="dark"] h3,
[data-theme-version="dark"] h4,
[data-theme-version="dark"] h5,
[data-theme-version="dark"] h6 {
  color: #fff !important;
}

[data-theme-version="dark"] a.link {
  color: #ddd;
}

[data-theme-version="dark"] a.link:focus,
[data-theme-version="dark"] a.link:hover {
  color: #2D28FF;
}

[data-theme-version="dark"] a:hover {
  color: #fff;
}

[data-theme-version="dark"] .border-right {
  border-right: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border-left {
  border-left: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border-top {
  border-top: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border-bottom {
  border-bottom: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .border {
  border: 1px solid #333a54 !important;
}

[data-theme-version="dark"] .dropdown-menu {
  background-color: #181f39;
  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
}

[data-theme-version="dark"] .dropdown-menu .dropdown-item.selected,
[data-theme-version="dark"] .dropdown-menu .dropdown-item.selected.active,
[data-theme-version="dark"] .dropdown-menu .dropdown-item.active,
[data-theme-version="dark"] .dropdown-menu .dropdown-item:hover,
[data-theme-version="dark"] .dropdown-menu .dropdown-item:focus {
  background-color: #1e2746;
  color: #7e7e7e;
}

[data-theme-version="dark"] .form-control {
  background-color: #181f39;
  border-color: #333a54;
  color: #fff;
}

[data-theme-version="dark"] .card {
  background-color: #1e2746;
  box-shadow: none;
}

[data-theme-version="dark"] .btn-outline-dark:hover {
  background-color: #181f39;
  border-color: #181f39;
}

[data-theme-version="dark"] .tdl-holder input[type=text],
[data-theme-version="dark"] .tdl-holder li {
  background-color: #1e2746;
  border-color: #333a54;
}

[data-theme-version="dark"] .tdl-holder input[type=text]::placeholder {
  color: #828690;
}

[data-theme-version="dark"] .tdl-holder label:hover {
  background-color: #333a54;
  color: #fff;
}

[data-theme-version="dark"] .text-muted {
  color: #828690 !important;
}

[data-theme-version="dark"] .modal-content {
  background: #1e2746;
}

[data-theme-version="dark"] .modal-footer,
[data-theme-version="dark"] .modal-header {
  border-color: #333a54;
}

[data-theme-version="dark"] .close {
  font-weight: 400;
  color: #fff;
  text-shadow: none;
}

[data-theme-version="dark"] .close:hover {
  color: #fff;
}

[data-theme-version="dark"] .table strong {
  color: #fff;
}

[data-theme-version="dark"] .text-dark {
  color: #828690 !important;
}

[data-theme-version="dark"] .star-rating .product-review,
[data-theme-version="dark"] .new-arrival-content .item {
  color: #fff;
}

[data-theme-version="dark"] .custom-dropdown .dropdown-menu {
  border-color: #333a54;
}

[data-theme-version="dark"] .widget-stat .media>span {
  background: #333a54;
  border-color: #333a54;
  color: #fff;
}

[data-theme-version="dark"] .plus-minus-input .custom-btn {
  background: #181f39;
  border-color: #333a54;
}

[data-theme-version="dark"] .dropdown-divider,
[data-theme-version="dark"] .size-filter ul li {
  border-color: #333a54;
}

[data-theme-version="dark"] .custom-select {
  border-color: #333a54;
  color: #828690;
  background: #181f39;
}

[data-theme-version="dark"] .nav-tabs {
  border-color: #333a54;
}

[data-theme-version="dark"] .mail-list .list-group-item.active i {
  color: #fff;
}

[data-theme-version="dark"] hr {
  border-color: #333a54;
}

[data-theme-version="dark"] .grid-col {
  background: #181f39;
}

[data-theme-version="dark"] .noUi-target {
  border-color: #333a54;
  border-radius: 8px;
  box-shadow: none;
}

[data-theme-version="dark"] .noUi-target .noUi-connects {
  background: #333a54;
}

[data-theme-version="dark"] .noUi-marker-large,
[data-theme-version="dark"] .noUi-marker {
  background: #333a54;
}

[data-theme-version="dark"] .input-group-text {
  background: #333a54;
  color: #7e7e7e;
}

[data-theme-version="dark"] .note-editor.note-frame {
  border-color: #333a54;
}

[data-theme-version="dark"] .note-editor.note-frame .btn {
  color: #fff;
}

[data-theme-version="dark"] .note-editor.note-frame .note-editing-area .note-editable {
  color: #fff;
}

[data-theme-version="dark"] .widget-media .timeline .timeline-panel {
  border-color: #333a54;
}

[data-theme-version="dark"] .notification_dropdown .dropdown-menu-right .all-notification {
  border-color: #333a54;
}

[data-theme-version="dark"] #user-activity .nav-tabs .nav-link {
  border-color: #333a54;
}

[data-theme-version="dark"] .list-group-item-action {
  color: #7e7e7e;
}

[data-theme-version="dark"] .list-group-item-action:focus,
[data-theme-version="dark"] .list-group-item-action:hover,
[data-theme-version="dark"] .list-group-item-action:focus {
  background-color: #181f39;
  border-color: #181f39;
}

[data-theme-version="dark"] .list-group-item.active {
  color: #fff;
  border-color: #00ADEE;
}

[data-theme-version="dark"] .list-group-item.active:focus,
[data-theme-version="dark"] .list-group-item.active:hover,
[data-theme-version="dark"] .list-group-item.active:focus {
  background-color: #00ADEE;
  border-color: #00ADEE;
  color: #fff;
}

[data-theme-version="dark"] .swal2-popup {
  background: #1e2746;
}

[data-theme-version="dark"] .header {
  background-color: #1e2746;
}

[data-theme-version="dark"] .header-left input {
  background: #181f39 !important;
  border-color: transparent;
  color: #fff !important;
}

[data-theme-version="dark"] .header-left input:focus {
  box-shadow: none;
  border-color: #00ADEE;
}

[data-theme-version="dark"] .header-left input::placeholder {
  color: #fff;
}

[data-theme-version="dark"] .header-left .search_icon {
  background: #181f39 !important;
}

[data-theme-version="dark"] .header-left .search_icon i {
  color: #fff;
}

[data-theme-version="dark"] .header-right .right-sidebar a {
  color: #00ADEE;
  border-color: #333a54;
}

[data-theme-version="dark"] .header-right .header-profile>a.nav-link .header-info strong {
  color: #fff;
}

[data-theme-version="dark"] .header-right .notification_dropdown .nav-link {
  background: #181f39;
}

[data-theme-version="dark"] .header-right .dropdown .nav-link {
  color: #fff;
}

[data-theme-version="dark"] .header-right .dropdown .nav-link:hover {
  color: #fff;
}

[data-theme-version="dark"] .header-right .notification_dropdown .dropdown-item a {
  color: #fff;
}

[data-theme-version="dark"] .nav-header,
[data-theme-version="dark"] .nav-control {
  background-color: #181f39;
}

[data-theme-version="dark"] .nav-control {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo:hover {
  color: #fff;
}

[data-theme-version="dark"] .nav-header,
[data-theme-version="dark"] .nav-control {
  background-color: #181f39;
}

[data-theme-version="dark"] .nav-control {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo {
  color: #fff;
}

[data-theme-version="dark"] .brand-logo:hover {
  color: #fff;
}

[data-theme-version="dark"][data-sidebar-style="mini"] .deznav .metismenu li>ul {
  background-color: #1e2746;
}

[data-theme-version="dark"] .fixed-content-box {
  background-color: #1e2746;
}

[data-theme-version="dark"] .fixed-content-box .head-name {
  background: #1e2746;
  color: #fff;
  border-color: #333a54;
}

[data-theme-version="dark"] .fixed-content-box+.header+.deznav {
  background-color: #181f39;
}

[data-theme-version="dark"] .deznav {
  background-color: #1e2746;
}

[data-theme-version="dark"] .deznav .metismenu>li>a {
  color: #b3b3b3;
}

[data-theme-version="dark"] .deznav .metismenu>li:hover>a,
[data-theme-version="dark"] .deznav .metismenu>li:focus>a,
[data-theme-version="dark"] .deznav .metismenu>li.mm-active>a {
  color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu>li:hover>a::after,
[data-theme-version="dark"] .deznav .metismenu>li:focus>a::after,
[data-theme-version="dark"] .deznav .metismenu>li.mm-active>a::after {
  border-color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu>li.mm-active ul ul {
  background-color: transparent;
}

[data-theme-version="dark"] .deznav .metismenu ul:after {
  background-color: #333a54;
}

[data-theme-version="dark"] .deznav .metismenu ul a:hover,
[data-theme-version="dark"] .deznav .metismenu ul a:focus,
[data-theme-version="dark"] .deznav .metismenu ul a.mm-active {
  color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu ul a:before {
  background-color: #fff;
}

[data-theme-version="dark"] .deznav .metismenu a {
  color: #b3b3b3;
}

[data-theme-version="dark"] .deznav .metismenu .has-arrow:after {
  border-color: #fff;
}

[data-theme-version="dark"] .sidebar-right {
  background-color: #1d2544;
}

[data-theme-version="dark"] .sidebar-right .nav-tabs {
  background-color: #1d2544;
  border-bottom: 1px solid #181f39;
}

[data-theme-version="dark"] .sidebar-right .nav-tabs .nav-link.active {
  background-color: #181f39;
}

[data-theme-version="dark"] .footer {
  background-color: transparent;
}

[data-theme-version="dark"] .footer .copyright {
  background-color: transparent;
}

[data-theme-version="dark"] .footer .copyright p {
  color: #fff;
}

.Color-box {
  /* background-color: #00ADEE;  border: 1px solid #00ADEE;  color: #00ADEE; */
  border: 1px solid #00ADEE;
  color: #00ADEE;
}

.form-control.Color-box:focus {
  border: 1px solid #00ADEE;
}

.Color-box {
  border: 1px solid #00ADEE;
  color: grey !important;
  padding: 10px !important;
  border-radius: 25px !important;
}

.suggestions-div {
  border-bottom: 1px solid #00ADEE;
  text-align: center;
  border-radius: 0;
  position: relative;
  color: white;
  background-color: #3C4B67;
  height: auto;
  cursor: pointer;
  z-index: 3
}

.suggestions-div:hover {
  background-color: #00ADEE;
}

.deznav .metismenu>li.mm-active>a {
  color: #fff !important;
}

.light.badge-success {
  background-color: #00ADEE !important;
  color: white !important;
}

a:hover {
  color: #00ADEE;
  text-decoration: underline;
}

.tox-statusbar__branding {
  display: none !important;
}

.Description-Label {
  color: black;
  font-weight: 500
}

.textAlign-Right {
  text-align: right;
}

.btn-success {
  color: #fff;
  background-color: #00ADEE !important;
  border-color: #00ADEE !important;
}

.btn-success:hover {
  color: #fff;
  background-color: #00ADEE !important;
  border-color: #00ADEE !important;
}

.btn-close {
  content: "✖";
  /* content: "&#9587";  */
  border: 1px solid #00ADEE;
  background-color: white;
  padding: 0.7em;
  cursor: pointer;
  font-weight: bold;
}

/* for type equal to number */

.remove-spin::-webkit-inner-spin-button,
.remove-spin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.show-desktop-animation {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.show-desktop-animation2 {

  display: flex;
  flex-direction: column;

}

.background-image-login {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  /* height: 100vh;
  text-align: center;
  background-size: cover; */
  background-repeat: no-repeat;
}

@media (max-width:991.98px) {
  .show-results {
    display: none;
  }

  .search-area {
    max-width: 250px;
  }

  .background-image-login {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  }

  /* .background-image-register{
    background-image: url('../images/login_bg/regImg.jpeg');
  } */
}

/* css animation for background images */
.search-image {

  animation: searchh 2s linear 4s infinite;
}

@keyframes searchh {
  0% {
    left: -10px;
    top: -150px;
  }

  15% {
    left: -25px;
    top: -150px;
  }

  20% {
    left: -10px;
    top: -120px;
  }

  36% {
    left: 10px;
    top: -130px;
  }

  45% {
    left: 3px;
    top: -135px;
  }

  60% {
    left: 5px;
    top: -140px;
  }

  70% {
    left: -10px;
    top: -150px;
  }

  100% {
    left: -10px;
    top: -150px;
  }
}
.view-profile{
  background-color: rgb(0, 173, 238);
    border: none;
    font-size: 10px !important;
    padding: 6px 10px;
    border-radius: 9px;
}
.alignCenter{
  justify-content: center;
}

.deznav {
  width: 21.563rem;
  max-width: 230px;
  padding-bottom: 0;
  height: 100%;
  position: absolute;
  top: 0;
  padding-top: 5rem;
  z-index: 3;
  background-color: #3C4B64;
  transition: all .2s ease;
}`, "",{"version":3,"sources":["webpack://./src/scss/main.scss","webpack://./src/css/style.css","webpack://./src/scss/abstracts/_bs-custom.scss","webpack://./src/scss/abstracts/_inheritance.scss","webpack://./src/scss/abstracts/_mixin.scss","webpack://./../vendor/bootstrap/scss/bootstrap.scss","webpack://./../vendor/bootstrap/scss/_root.scss","webpack://./../vendor/bootstrap/scss/_reboot.scss","webpack://./../vendor/bootstrap/scss/vendor/_rfs.scss","webpack://./../vendor/bootstrap/scss/_variables.scss","webpack://./../vendor/bootstrap/scss/_type.scss","webpack://./../vendor/bootstrap/scss/mixins/_image.scss","webpack://./../vendor/bootstrap/scss/_images.scss","webpack://./../vendor/bootstrap/scss/_code.scss","webpack://./../vendor/bootstrap/scss/_grid.scss","webpack://./../vendor/bootstrap/scss/mixins/_grid.scss","webpack://./../vendor/bootstrap/scss/mixins/_breakpoints.scss","webpack://./../vendor/bootstrap/scss/_functions.scss","webpack://./../vendor/bootstrap/scss/mixins/_grid-framework.scss","webpack://./../vendor/bootstrap/scss/_tables.scss","webpack://./../vendor/bootstrap/scss/mixins/_hover.scss","webpack://./../vendor/bootstrap/scss/mixins/_table-row.scss","webpack://./../vendor/bootstrap/scss/_forms.scss","webpack://./../vendor/bootstrap/scss/mixins/_transition.scss","webpack://./../vendor/bootstrap/scss/mixins/_forms.scss","webpack://./../vendor/bootstrap/scss/mixins/_border-radius.scss","webpack://./../vendor/bootstrap/scss/_buttons.scss","webpack://./../vendor/bootstrap/scss/mixins/_buttons.scss","webpack://./../vendor/bootstrap/scss/mixins/_gradients.scss","webpack://./../vendor/bootstrap/scss/_transitions.scss","webpack://./../vendor/bootstrap/scss/_dropdown.scss","webpack://./../vendor/bootstrap/scss/mixins/_caret.scss","webpack://./../vendor/bootstrap/scss/_button-group.scss","webpack://./../vendor/bootstrap/scss/_input-group.scss","webpack://./../vendor/bootstrap/scss/_custom-forms.scss","webpack://./../vendor/bootstrap/scss/_nav.scss","webpack://./../vendor/bootstrap/scss/_navbar.scss","webpack://./../vendor/bootstrap/scss/_card.scss","webpack://./../vendor/bootstrap/scss/_breadcrumb.scss","webpack://./../vendor/bootstrap/scss/_pagination.scss","webpack://./../vendor/bootstrap/scss/mixins/_pagination.scss","webpack://./../vendor/bootstrap/scss/_badge.scss","webpack://./../vendor/bootstrap/scss/mixins/_badge.scss","webpack://./../vendor/bootstrap/scss/_jumbotron.scss","webpack://./../vendor/bootstrap/scss/_alert.scss","webpack://./../vendor/bootstrap/scss/mixins/_alert.scss","webpack://./../vendor/bootstrap/scss/_progress.scss","webpack://./../vendor/bootstrap/scss/_media.scss","webpack://./../vendor/bootstrap/scss/_list-group.scss","webpack://./../vendor/bootstrap/scss/mixins/_list-group.scss","webpack://./../vendor/bootstrap/scss/_close.scss","webpack://./../vendor/bootstrap/scss/_toasts.scss","webpack://./../vendor/bootstrap/scss/_modal.scss","webpack://./../vendor/bootstrap/scss/_tooltip.scss","webpack://./../vendor/bootstrap/scss/mixins/_reset-text.scss","webpack://./../vendor/bootstrap/scss/_popover.scss","webpack://./../vendor/bootstrap/scss/_carousel.scss","webpack://./../vendor/bootstrap/scss/mixins/_clearfix.scss","webpack://./../vendor/bootstrap/scss/_spinners.scss","webpack://./../vendor/bootstrap/scss/utilities/_align.scss","webpack://./../vendor/bootstrap/scss/mixins/_background-variant.scss","webpack://./../vendor/bootstrap/scss/utilities/_background.scss","webpack://./../vendor/bootstrap/scss/utilities/_borders.scss","webpack://./../vendor/bootstrap/scss/utilities/_display.scss","webpack://./../vendor/bootstrap/scss/utilities/_embed.scss","webpack://./../vendor/bootstrap/scss/utilities/_flex.scss","webpack://./../vendor/bootstrap/scss/utilities/_float.scss","webpack://./../vendor/bootstrap/scss/utilities/_interactions.scss","webpack://./../vendor/bootstrap/scss/utilities/_overflow.scss","webpack://./../vendor/bootstrap/scss/utilities/_position.scss","webpack://./../vendor/bootstrap/scss/utilities/_screenreaders.scss","webpack://./../vendor/bootstrap/scss/mixins/_screen-reader.scss","webpack://./../vendor/bootstrap/scss/utilities/_shadows.scss","webpack://./../vendor/bootstrap/scss/utilities/_sizing.scss","webpack://./../vendor/bootstrap/scss/utilities/_spacing.scss","webpack://./../vendor/bootstrap/scss/utilities/_stretched-link.scss","webpack://./../vendor/bootstrap/scss/utilities/_text.scss","webpack://./../vendor/bootstrap/scss/mixins/_text-truncate.scss","webpack://./../vendor/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./../vendor/bootstrap/scss/mixins/_text-hide.scss","webpack://./../vendor/bootstrap/scss/utilities/_visibility.scss","webpack://./../vendor/bootstrap/scss/_print.scss","webpack://./src/scss/base/_helper.scss","webpack://./src/scss/base/_reset.scss","webpack://./src/scss/base/_custom-grid.scss","webpack://./src/scss/_preloader.scss","webpack://./src/scss/layout/footer/_footer.scss","webpack://./src/scss/layout/header/nav-header/_nav-control.scss","webpack://./src/scss/layout/header/_header-global.scss","webpack://./src/scss/layout/header/_header-left.scss","webpack://./src/scss/layout/header/_header-right.scss","webpack://./src/scss/abstracts/_variable.scss","webpack://./../vendor/bootstrap-v4-rtl/scss/_rtl.scss","webpack://./../vendor/bootstrap-v4-rtl/scss/mixins/_breakpoints.scss","webpack://./src/scss/layout/rtl/_rtl-reset.scss","webpack://./../vendor/bootstrap-v4-rtl/scss/mixins/_float.scss","webpack://./src/scss/layout/rtl/_rtl-nav-header.scss","webpack://./src/scss/layout/rtl/_rtl-header.scss","webpack://./src/scss/layout/rtl/_rtl-sidebar.scss","webpack://./src/scss/layout/rtl/_rtl-global.scss","webpack://./src/scss/layout/rtl/_rtl-sidebar-right.scss","webpack://./src/scss/layout/rtl/_rtl-footer.scss","webpack://./src/scss/layout/sidebar/_sidebar-global.scss","webpack://./src/scss/layout/sidebar/_mega-menu.scss","webpack://./src/scss/layout/sidebar/_sidebar-full.scss","webpack://./src/scss/layout/sidebar/_sidebar-mini-nav.scss","webpack://./src/scss/layout/sidebar/_sidebar-horizontal.scss","webpack://./src/scss/layout/sidebar/_sidebar-compact-nav.scss","webpack://./src/scss/layout/sidebar/_sidebar-icon-hover.scss","webpack://./src/scss/layout/sidebar/_sidebar-modern.scss","webpack://./src/scss/layout/sidebar/_sidebar-overlay.scss","webpack://./src/scss/layout/sidebar/_sidebar-vertical-nav.scss","webpack://./src/scss/layout/sidebar/_sidebar-right.scss","webpack://./src/scss/layout/sidebar/_sidebar-profile.scss","webpack://./src/scss/layout/sidebar/_fixed-sidebar.scss","webpack://./src/scss/layout/theme/_theme-bg.scss","webpack://./src/scss/layout/theme/_theme-boxed.scss","webpack://./src/scss/layout/theme/_theme-wide-boxed.scss","webpack://./src/scss/layout/theme/_theme-color.scss","webpack://./src/scss/layout/typography/_opensans.scss","webpack://./src/scss/layout/typography/_poppins.scss","webpack://./src/scss/layout/typography/_helvetica.scss","webpack://./src/scss/layout/version-transparent/_transparent-reset.scss","webpack://./src/scss/layout/version-transparent/_transparent-global.scss","webpack://./src/scss/layout/version-transparent/_transparent-header.scss","webpack://./src/scss/layout/version-transparent/_transparent-nav-header.scss","webpack://./src/scss/layout/version-transparent/_transparent-left-sidebar.scss","webpack://./src/scss/layout/version-dark/_dark-reset.scss","webpack://./src/scss/layout/version-dark/_dark-global.scss","webpack://./src/scss/layout/version-dark/_dark-header.scss","webpack://./src/scss/layout/version-dark/_dark-nav-header.scss","webpack://./src/scss/layout/version-dark/_dark-left-sidebar.scss","webpack://./src/scss/layout/version-dark/_dark-right-sidebar.scss","webpack://./src/scss/layout/version-dark/_dark-footer.scss","webpack://./src/scss/components/app/_app-calender-event.scss","webpack://./src/scss/components/app/_email.scss","webpack://./src/scss/components/app/_profile.scss","webpack://./src/scss/components/app/_chat.scss","webpack://./src/scss/components/charts/_chart-chartist.scss","webpack://./src/scss/components/charts/_chart-chartjs.scss","webpack://./src/scss/components/charts/_chart-c3.scss","webpack://./src/scss/components/charts/_chart-flot.scss","webpack://./src/scss/components/charts/_chart-morris.scss","webpack://./src/scss/components/charts/_chart-sparkline.scss","webpack://./src/scss/components/charts/_easy-pie-chart.scss","webpack://./src/scss/components/charts/_chart-amchart.scss","webpack://./src/scss/components/charts/_chart-highcharts.scss","webpack://./src/scss/components/charts/_echarts.scss","webpack://./src/scss/components/forms/_form-basic.scss","webpack://./src/scss/components/forms/_form-checkbox.scss","webpack://./src/scss/components/forms/_form-switch.scss","webpack://./src/scss/components/forms/_form-validation.scss","webpack://./src/scss/components/forms/_form-pickers.scss","webpack://./src/scss/components/forms/_form-addons-cropper.scss","webpack://./src/scss/components/forms/_form-addons-select2.scss","webpack://./src/scss/components/forms/_form-steps.scss","webpack://./src/scss/components/forms/_form-summernote.scss","webpack://./src/scss/components/forms/_form-editor-quill.scss","webpack://./src/scss/components/map/_map-datamap.scss","webpack://./src/scss/components/map/_map-jqvmap.scss","webpack://./src/scss/components/uc/_uc-blockui.scss","webpack://./src/scss/components/uc/_uc-bootstrap-select.scss","webpack://./src/scss/components/uc/_uc-ticker.scss","webpack://./src/scss/components/uc/_uc-typeahead.scss","webpack://./src/scss/components/uc/_uc-weather.scss","webpack://./src/scss/components/uc/_uc-noui-slider.scss","webpack://./src/scss/components/uc/_uc-nestable.scss","webpack://./src/scss/components/uc/_uc-pignose-calender.scss","webpack://./src/scss/components/uc/_uc-horizontal-timeline.scss","webpack://./src/scss/components/uc/_uc-lightgallery.scss","webpack://./src/scss/components/uc/_uc-toastr.scss","webpack://./src/scss/components/uc/_jqvmap.scss","webpack://./src/scss/components/uc/_perfect-scroll.scss","webpack://./src/scss/components/ui/_ui-accordion.scss","webpack://./src/scss/components/ui/_ui-alert.scss","webpack://./src/scss/components/ui/_ui-badge.scss","webpack://./src/scss/components/ui/_ui-breadcrumb.scss","webpack://./src/scss/components/ui/_ui-button.scss","webpack://./src/scss/components/ui/_ui-card.scss","webpack://./src/scss/components/ui/_ui-carousel.scss","webpack://./src/scss/components/ui/_ui-dropdown.scss","webpack://./src/scss/components/ui/_ui-grid.scss","webpack://./src/scss/components/ui/_ui-label.scss","webpack://./src/scss/components/ui/_ui-list-group.scss","webpack://./src/scss/components/ui/_ui-media.scss","webpack://./src/scss/components/ui/_ui-menu.scss","webpack://./src/scss/components/ui/_ui-modal.scss","webpack://./src/scss/components/ui/_ui-pagination.scss","webpack://./src/scss/components/ui/_ui-popover.scss","webpack://./src/scss/components/ui/_ui-progressbar.scss","webpack://./src/scss/components/ui/_ui-ribbon.scss","webpack://./src/scss/components/ui/_ui-scrollbar.scss","webpack://./src/scss/components/ui/_ui-step.scss","webpack://./src/scss/components/ui/_ui-tab.scss","webpack://./src/scss/components/ui/_ui-tooltip.scss","webpack://./src/scss/components/ui/_ui-timeline.scss","webpack://./src/scss/components/widget/_widget-chart.scss","webpack://./src/scss/components/widget/_widget-social.scss","webpack://./src/scss/components/widget/_widget-stat.scss","webpack://./src/scss/components/widget/_widget-todo-list.scss","webpack://./src/scss/components/widget/_widget-messages.scss","webpack://./src/scss/components/widget/_widget-pickadate.scss","webpack://./src/scss/components/widget/_widget-card-list.scss","webpack://./src/scss/components/widget/_widget-media.scss","webpack://./src/scss/components/tables/_table-basic.scss","webpack://./src/scss/components/tables/_table-bootgrid.scss","webpack://./src/scss/components/tables/_table-datatable.scss","webpack://./src/scss/components/tables/_table-footable.scss","webpack://./src/scss/components/tables/_table-jsgrid.scss","webpack://./src/scss/pages/_page-error.scss","webpack://./src/scss/pages/_page-auth.scss","webpack://./src/scss/pages/_page-pricing.scss","webpack://./src/scss/pages/_page-timeline.scss","webpack://./src/scss/pages/_page-order.scss","webpack://./src/scss/pages/_application.scss","webpack://./src/scss/pages/_review.scss","webpack://./src/scss/pages/_search-job.scss","webpack://./src/scss/pages/_profile.scss","webpack://./src/scss/pages/_statistics.scss","webpack://./src/scss/pages/_homepage.scss","webpack://./src/scss/pages/_ecom-product-detail.scss","webpack://./src/scss/pages/_ecom-product-grid.scss","webpack://./src/scss/pages/_ecom-product-list.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CCsDC;ACgDD,gCAAA;;ADlCA;EACE,sGAAsG;AEjExG;;AFoEA;EEjEI,mBAAY;EFqEd,2EAA2E;EEhE7E,kHAAY;AFkEZ;;AAEA;EEhEI,mBAAY;EAIhB,2EAAY;EACR,kHAAmB;AFiEvB;;AAEA;EE/DI,mBAAQ;EAIR,2EAAmB;EACnB,kHAAgE;AFgEpE;;AAEA;EACE,mBAAmB;EE3DjB,+DAAY;EACZ,kHAAkE;AF+DtE;;AAEA;EE5DA,mBAAY;EAGR,0EAAkE;EAClE,kHAAyE;AF8D7E;;AE1DA;EACI,mBAAmB;EAGnB,0EAAyE;EACzE,kHAAQ;AF6DZ;;AAEA;EE1DI,mBAAY;EAGZ,0EAAQ;EF4DV,kHAAkH;AEvDpH;;AF0DA;EEvDI,mBAAY;EF2Dd,gEAAgE;EEtDlE,kHAAa;AFwDb;;AAEA;;;;;;;;;;EAUE,8BAA8B;EElD5B,0EAAgE;EAChE,kHAAkE;AFsDtE;;AAEA;EEnDA,8BAAa;EAGT,wEAAkE;EAClE,kHAA8D;AFqDlE;;AEjDA;EACI,mBAAmB;EAGnB,+DAA4D;EAC5D,kHAAQ;AFoDZ;;AAEA;EEjDI,mBAAY;EAGZ,+DAAQ;EFmDV,kHAAkH;AEhDpH;;AFmDA;EEhDI,mBAAY;EFoDd,+DAA+D;EE/CjE,kHAAa;AFiDb;;AAEA;EE/CI,mBAAY;EAIhB,6DAAa;EACT,kHAAmB;AFgDvB;;AAEA;EE9CI,mBAAQ;EFkDV,6DAA6D;EAC7D,kHAAkH;AACpH;;AAEA;EACE,mBAAmB;EG/LnB,6DAAA;ECXF,kHAAA;AJ+MA;;AAEA;EACE,mBAAmB;EK9MjB,6DAAsB;EAAtB,kHAAsB;ALmN1B;;AAEA;EKrNI,mBAAsB;EAAtB,+DAAsB;EAAtB,kHAAsB;AL2N1B;;AAEA;;;;;;;;;CASC;AACD;;;;;EK1NE;ALgOF;EACE,eAAe;EMhOjB,iBAAA;ENkOE,iBAAiB;EACjB,eMjOO;EACP,cAAY;ENkOZ,iBAAiB;EM/NnB,iBAAK;EACH,gBAAa;EACb,eAAa;EACb,eAAA;EACA,aAAA;ENiOA,eAAe;EM3NjB,oBAAA;EACE,kBAAc;EN6Nd,oBAAoB;EMnNtB,kBAAK;EACH,eAAS;EACT,kBLlCiB;EMkHb,iBAtCa;EDxCjB,gBL3BuB;EK4BvB,eEkP4B;EFjP5B,kBEo9B6C;EFn9B7C,sBAAgB;EAChB,sBEy9BkC;ERpwBlC,sBAAsB;EMzMxB,uBAAA;EACE,sBAAqB;EN2MrB,+MAA+M;EMlM9M,6GAAA;ANoMH;;AAEA;;;EMrLE,sBAAa;ANyLf;;AMjLA;EACE,uBAAa;EACb,iBEoF0B;ERgG1B,8BAA8B;EMzKhC,6CAAA;AN2KA;;AAEA;;;;;;;;;;EM9JA,cAAA;ANyKA;;AAEA;EMvKE,SAAA;ENyKA,iCAAiC;EMtKnC,mBAAA;ENwKE,gBAAgB;EAChB,gBAAgB;EAChB,cMvKI;EACJ,gBAAgB;ENwKhB,yBAAyB;AMrK3B;;ANwKA;EMpKG,qBAAA;ANsKH;;AAEA;EMnKA,uBAAW;EACT,SAAQ;ENqKR,iBAAiB;AMlKnB;;ANqKA;;;;;;EAME,aM5JE;EACF,qBAAkB;AN6JpB;;AAEA;EACE,aAAa;EM1Jf,mBAAI;AN4JJ;;AM3JA;;EN+JE,0BAA0B;EMxJ1B,yCAAA;UAAA,iCAAA;EACA,YEq0BkC;EFp0BlC,gBAAe;EACf,8BAA6B;AN0J/B;;AAEA;EACE,mBAAmB;EMhJrB,kBAAA;EACE,oBAAc;ANkJhB;;AAEA;;;EMtIA,aAAA;EN0IE,mBAAmB;AACrB;;AAEA;;;;EMnIE,gBAAa;ANwIf;;AAEA;EACE,gBAAgB;AM5HlB;;AN+HA;EMrHA,oBAAI;EACF,cAAc;ANuHhB;;AMnHA;EAGE,gBAAgB;ANoHlB;;AM3GA;;EN+GE,mBAAmB;AM3GrB;;AN8GA;EM3GE,cEqGuC;ARQzC;;AAEA;;EMpGE,kBAAY;EACZ,cAAY;ENuGZ,cAAc;EM/FhB,wBAAM;ANiGN;;AAEA;EM1FA,cAAO;AN4FP;;AMnFA;EACE,UAAS;ANsFX;;AMlFA;ENqFE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EOhVI,cAAW;ED8Pb,0BAAoB;ANqFtB;;AAEA;EMlFE,cAAU;ENoFV,qBAAqB;AMjFvB;;ANoFA;EACE,cAAc;EM7EhB,qBAAgB;AN+EhB;;AMxEA;;;;EN8EE,iGAAiG;EACjG,cAAc;AAChB;;AAEA;EM7DI,aAAA;EN+DF,mBAAmB;EACnB,cAAc;EACd,6BMjEmB;ANkErB;;AM3DA;EN8DE,gBAAgB;AAClB;;AAEA;EM5DE,sBAAkB;EN8DlB,kBAAkB;AM3DpB;;AN8DA;EM3DE,gBAAU;EN6DV,sBAAsB;AMzDxB;;AN4DA;EACE,yBAAyB;AMvD3B;;AN0DA;EMjDE,oBAAS;EACT,uBAAS;ENmDT,cAAc;EM9ChB,gBAAO;EACL,oBAAc;ANgDhB;;AAEA;EM9CE,mBAAe;ECnSX,gCAtCqD;AP0X3D;;AAEA;EACE,qBAAqB;EM7CvB,qBAAS;AN+CT;;AM1CA;EN6CE,gBAAgB;AAClB;;AMzCA;EAKE,mBAAgB;EAChB,0CAAwB;ANwC1B;;AAEA;;;;;EAKE,SAAS;EMtBX,oBAAO;EACL,kBAAS;ENwBT,oBAAoB;AMrBtB;;ANwBA;;EMnBA,iBAAS;ANsBT;;AMhBA;;ENoBE,oBAAoB;AS/etB;;ATkfA;ES9eE,eRKwB;AD2e1B;;AAEA;ES7eA,iBAAQ;AT+eR;;AS9eA;;;;EF+GM,0BAtCqD;AP4a3D;;AAEA;;;;EAIE,eAAe;ASvfjB;;AT0fA;;;;EAIE,UAAU;EStfZ,kBAAW;ATwfX;;AAEA;;ESrfA,sBAAW;EF8FL,UAAS;AP2Zf;;AAEA;EStfA,cAAW;EFyFL,gBAtCa;APscnB;;AAEA;EStfA,YAAW;EFoFL,UAAS;EElFb,SAAA;EACA,SAAA;ATwfF;;AAEA;EShfE,cAAa;EACb,WAAS;EACT,eAAY;ETkfZ,UAAU;ES1eZ,oBAAA;ET4eE,iBS3eK;EFKH,oBAA+B;EEHjC,cD0N4B;ERkR5B,mBAAmB;ASzerB;;AT4eA;ESzeE,wBD0Q4B;ARiO9B;;AAEA;;EAEE,YAAY;ASled;;ATqeA;EACE,oBAAoB;ESnetB,wBAAkB;ATqelB;;AAEA;EACE,wBAAwB;AS1d1B;;AT6dA;EACE,aAAa;ESxdf,0BAAY;AT0dZ;;AAEA;ESvdA,qBAAmB;ATydnB;;AAEA;EStdE,kBAAA;ETwdA,eSvdW;ATwdb;;AAEA;EUtkBE,aAAY;AVwkBd;;AAEA;EWzkBE,wBH+/BkC;ARpbpC;;AAEA;;;;;;;;;;;;EWpjBE,qBH+/B2C;ER9b3C,gBAAgB;EYxmBlB,gBAAK;ELuED,cAAW;APoiBf;;AAEA;;EAEE,kBAAkB;AYnmBpB;;AZsmBA;;EYlmBE,mBJqlCkC;ARhfpC;;AAEA;;EAEE,iBQzS4B;AR0S9B;;AAEA;;EY5lBE,mBJqkC2C;ARte7C;;AAEA;;EAEE,eAAe;AYxlBjB;;AZ2lBA;;EajoBE,mBAAA;AbooBF;;AAEA;EACE,qBAAqB;EACrB,gBatoBiB;AbuoBnB;;AAEA;EczoBE,eAAc;EACd,gBAAa;Ed2oBb,gBAAgB;AexlBd;;Af2lBJ;Ee3lBI,iBAAA;EFzCE,gBAAA;EbuoBJ,gBgBxoBa;AD0CX;;AfimBJ;EejmBI,iBAAA;EFzCE,gBAAA;Eb6oBJ,gBgB9oBa;AH8Bb;;AbmnBF;EcppBE,iBAAc;EACd,gBAAa;EdspBb,gBAAgB;AahnBhB;;AbmnBF;Ea/mBI,gBAAA;EbinBF,mBAAmB;EACnB,SahnBI;EbinBJ,wCahnBmB;AbinBrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EiB5qBI,cAAa;EACb,yBAAyB;AjB+qB7B;;AAEA;EiBzpBQ,eAAY;EACZ,gBAAe;AjB2pBvB;;AAEA;Ec/nBI,eAAwB;EdioB1B,gBAAgB;AcnoBhB;;AdsoBF;EACE,qBAAqB;AcvoBrB;;Ad0oBF;EACE,oBAAoB;Ac3oBpB;;Ad8oBF;EACE,cAAc;Ec/oBd,yBAAI;AdipBN;;AAEA;EcnpBE,mBAAI;EACF,qBAAM;AdqpBV;;AiBvqBM;EHCJ,cAAc;EACd,cAAW;EACX,cAAW;Ad0qBb;;AAEA;EclrBE,qBAAW;AdorBb;;AAEA;EctrBE,eAAW;EdwrBX,YAAY;AiB/qBJ;;AjBkrBV;EACE,gBAAgB;EiBnrBR,yBAAoB;EHb5B,yBAAsC;EAItC,sBAAW;EdgsBX,eAAe;EiBvrBP,YAAoB;AjByrB9B;;AAEA;EiB3rBU,qBAAoB;AjB6rB9B;;AAEA;EiB/rBU,qBAAoB;EHb5B,cAAM;Ad+sBR;;AiBlsBU;EHbR,cAAM;EAIN,cAAW;AdgtBb;;AAEA;EcltBE,gBAAuC;EdotBvC,cAAc;EiB3sBN,qBAAoB;AjB6sB9B;;AAEA;EiB/sBU,cAAoB;AjBitB9B;;AAEA;EiBntBU,sBAAoB;EHb5B,gBAAsC;EAItC,WAAW;EdguBX,yBAAyB;EiBjtBrB,qBAAsB;AjBmtB5B;;AiBjtBM;EAAuB,UAAmB;EjBqtB9C,eAAe;EiBltBT,gBAAsB;AjBotB9B;;AiBptBQ;EAAwB,cAAS;EjBwtBvC,gBAAgB;EiBxtBV,cAAsB;AjB0tB9B;;AiB1tBQ;EAAwB,kBAAS;EjB8tBvC,cAAc;EiB9tBR,kBAAsB;AjBguB9B;;AiBhuBQ;EAAwB,iBAAS;EjBouBvC,kBAAkB;AiBpuBZ;;AjBuuBR;;;;;;EAME,WAAW;EiB7uBL,mBAAsB;EAAE,kBAAS;EjBgvBvC,kBAAkB;EiBhvBZ,iBAAsB;AjBkvB9B;;AiBlvBQ;;EjBsvBN;;IiBtvB8B,gBAAS;EjByvBvC;AiBlvBU;;AjBqvBZ;;EcrwBE;;;IAAA,gBAA+C;Ed2wB/C;AiB3vBU;;AjB8vBZ;;Ec9wBE;;;;IdoxBE,gBAAgB;EiBpwBR;AjBswBZ;;AiBtwBY;;EjB0wBV;;;;;Ic1xBA,iBAAa;EdgyBb;AiBhxBU;;AjBmxBZ;Ee9xBI,aAAA;EE3BE,eAAc;EjB4zBlB,mBiB3zBmB;EjB4zBnB,kBiB3zBkB;AjB4zBpB;;AAEA;EACE,ecjyBQ;EdkyBR,ccjyBa;AdkyBf;;AAEA;;EAEE,gBAAgB;EcxyBhB,eAAA;Ad0yBF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EiB5yBQ,kBAAsB;EjBi4B5B,WiBj4BuC;EjBk4BvC,mBAAmB;EiBl4Bb,kBAAsB;AjBo4B9B;;AAEA;EACE,aiBv4BuC;EjBw4BvC,YAAY;EiBx4BN,eAAsB;AjB04B9B;;AAEA;EACE,ciB74BuC;EjB84BvC,eAAe;AACjB;;AAEA;EiBj5BQ,aAAsB;EjBm5B5B,ciBn5BuC;AjBo5BzC;;AAEA;EACE,wBAAwB;EiBv5BlB,yBAAsB;AjBy5B9B;;AAEA;EACE,acr6BW;Eds6BX,cAAc;AAChB;;AAEA;EiBz5BY,aAAuB;EjB25BjC,cc36BW;Ad46Bb;;AAEA;EACE,wBAAwB;EiB/5Bd,yBAAuB;AjBi6BnC;;AAEA;EACE,ccp7BW;Edq7BX,WAAW;EiBr6BD,eAAuB;AjBu6BnC;;AAEA;EACE,uBc17Ba;Ed27Bb,wBAAwB;AAC1B;;AAEA;EiB96BY,wBAAuB;EjBg7BjC,yBch8B+C;Adi8BjD;;AAEA;EACE,aAAa;EiBp7BH,cAAuB;AjBs7BnC;;AAEA;EACE,wBiB99BmB;EjB+9BnB,yBiB99BkB;AjB+9BpB;;AAEA;EACE,wBcp8ByB;Edq8BzB,yBcp8B0B;Adq8B5B;;AAEA;EACE,acx8Ba;Edy8Bb,cAAc;AAChB;;AAEA;EACE,wBAAwB;Ec/8BxB,yBAAI;Adi9BN;;AAEA;Ecn9BE,wBAAI;Edq9BJ,yBcp9ByB;Adq9B3B;;AAEA;EACE,acx9BQ;Edy9BR,ccx9Ba;Ady9Bf;;AAEA;EACE,wBc7+BW;Ed8+BX,yBc7+Be;Ad8+BjB;;AAEA;EACE,wBcv/BW;Edw/BX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EiBn/BN,eAAoB;AjBq/B9B;;AAEA;EiBv/BU,SAAoB;AjBy/B9B;;AAEA;EiB3/BU,SAAoB;AjB6/B9B;;AAEA;EiB//BU,QAAA;AjBigCV;;AAEA;EiBngCU,QAAA;AjBqgCV;;AAEA;EiBvgCU,QAAA;AjBygCV;;AAEA;EiB3gCU,QAAA;AjB6gCV;;AAEA;EiB/gCU,QAAA;AjBihCV;;AAEA;EiBnhCU,QAAA;AjBqhCV;;AAEA;EiBvhCU,QAAA;AjByhCV;;AAEA;EiBrhCM,QAAA;AjBuhCN;;AAEA;EACE,QiBxhCgC;AjByhClC;;AAEA;EACE,QAAQ;AACV;;AAEA;EiB5hCQ,SAAA;AjB8hCR;;AAEA;EACE,SiBjiCqC;AjBkiCvC;;AAEA;EACE,SAAS;AACX;;AAEA;EiBxiCQ,0BAAsB;AjB0iC9B;;AAEA;EACE,2BiB7iCuC;AjB8iCzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EiBpjCQ,2BAAsB;AjBsjC9B;;AAEA;EACE,2BiBzjCuC;AjB0jCzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EiBzjCY,2BAAuB;AjB2jCnC;;AAEA;EACE,2Bc9kCa;Ad+kCf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EiBrkCY,2BAAuB;AjBukCnC;;AAEA;EACE,2Bc1lC+C;Ad2lCjD;;AAEA;EACE;IiB9kCU,aAAuB;IHhBjC,YAAW;IdimCT,eAAe;EiBjlCP;;EjBolCV;IiBplCU,cAAuB;IHhBjC,eAAa;EdumCb;;EAEA;IepmCE,aAAA;IE3BE,cAAc;EjBkoClB;;EAEA;IACE,wBAAwB;IctmC1B,yBAAI;EdwmCJ;;EAEA;Ic1mCA,aAAA;IACE,cAAuB;Ed4mCzB;;Ec7mCA;IACE,aAAM;IACN,cAAW;EdgnCb;;EAEA;IclnCE,wBAAwB;IdonCxB,yBAAyB;EctnC3B;;EdynCA;IACE,cAAc;Ic1nChB,WAAA;IACE,eAAM;Ed4nCR;;EiB9oCI;IHCJ,uBAAc;IACd,wBAAW;EdipCX;;EiB7oCQ;IHbR,wBAAsC;IAItC,yBAAuC;Ed2pCvC;;EAEA;Ic7pCA,aAAW;Id+pCT,cAAc;EiBtpCR;;EjBypCR;IACE,wBAAwB;IiB1pClB,yBAAoB;EjB4pC5B;;EAEA;IiB9pCQ,wBAAoB;IHb5B,yBAAsC;Ed8qCtC;;EiBjqCQ;IHbR,aAAsC;IAItC,cAAuC;Ed+qCvC;;EAEA;IcjrCA,wBAAW;IdmrCT,yBAAyB;EiB1qCnB;;EjB6qCR;IACE,wBAAwB;IiB9qClB,yBAAoB;EjBgrC5B;;EAEA;IiBlrCQ,aAAoB;IHb5B,cAAM;EdksCN;;EiBrrCQ;IHbR,wBAAsC;IAItC,yBAAuC;EdmsCvC;;EAEA;IcrsCA,wBAAuC;IdusCrC,yBAAyB;EiBxrCvB;;EjB2rCJ;IiBzrCI,cAAqB;IAAE,eAAmB;EjB4rC9C;;EAEA;IACE,SAAS;EiB5rCL;;EjB+rCN;IiB/rCM,SAAsB;EjBisC5B;;EiBjsCM;IAAwB,QAAS;EjBqsCvC;;EAEA;IACE,QAAQ;EiBxsCJ;;EjB2sCN;IiB3sCM,QAAA;EjB6sCN;;EiB7sCM;IAAwB,QAAS;EjBitCvC;;EAEA;IACE,QAAQ;EiBptCJ;;EjButCN;IiBvtCM,QAAA;EjBytCN;;EiBztCM;IAAwB,QAAO;EjB6tCrC;;EAEA;IACE,QAAQ;EiBztCA;;EjB4tCV;IiB5tCU,QAAA;EjB8tCV;;EiB9tCU;IHhBV,QAAA;EdkvCA;;EAEA;IACE,SAAS;EiBruCD;;EjBwuCV;IiBxuCU,SAAA;EjB0uCV;;EiB1uCU;IHhBV,SAAA;Ed8vCA;;EAEA;IACE,cAAc;EiBjvCN;;EjBovCV;IiBpvCU,0BAAuB;EjBsvCjC;;EiBtvCU;IHhBV,2BAA+C;Ed0wC/C;;EAEA;IevwCE,gBAAA;EE3BE;;EjBsyCJ;IiBnyCM,2BAAe;EjBqyCrB;;EAEA;IczwCE,2BAAwB;Ed2wC1B;;EAEA;Ic7wCE,gBAAwB;Ed+wC1B;;EAEA;IcjxCE,2BAAwB;EdmxC1B;;EAEA;IcrxCE,2BAAwB;EduxC1B;;EAEA;IczxCE,gBAAwB;Ed2xC1B;;EAEA;Ic7xCE,2BAAwB;Ed+xC1B;;EAEA;IclzCA,2BAAW;EdozCX;AACF;;AAEA;EACE;IACE,aAAa;IiBrzCP,YAAoB;IHb5B,eAAM;Edq0CN;;EiBxzCQ;IHbR,cAAsC;IAItC,eAAuC;Eds0CvC;;EAEA;Icx0CA,aAAW;Id00CT,cAAc;EiBj0CR;;EjBo0CR;IACE,wBAAwB;IiBr0ClB,yBAAoB;EjBu0C5B;;EAEA;IiBz0CQ,aAAoB;IHb5B,cAAM;Edy1CN;;EiB50CQ;IHbR,aAAM;IAIN,cAAW;Ed01CX;;EAEA;Ic51CA,wBAAuC;Id81CrC,yBAAyB;EiBr1CnB;;EjBw1CR;IACE,cAAc;IiBz1CR,WAAoB;IHb5B,eAAM;Edy2CN;;EiB51CQ;IHbR,uBAAsC;IAItC,wBAAuC;Ed02CvC;;EAEA;IACE,wBAAwB;IiB51CtB,yBAAqB;EjB81CzB;;EiB31CM;IAAwB,aAAS;IjB+1CrC,cAAc;EiB/1CV;;EjBk2CN;IiBl2CM,wBAAsB;IAAE,yBAAS;EjBq2CvC;;EAEA;IACE,wBAAwB;IiBx2CpB,yBAAsB;EjB02C5B;;EiB12CM;IAAwB,aAAS;IjB82CrC,cAAc;EiB92CV;;EjBi3CN;IiBj3CM,wBAAsB;IAAE,yBAAS;EjBo3CvC;;EAEA;IACE,wBAAwB;IiBv3CpB,yBAAsB;EjBy3C5B;;EiBz3CM;IAAwB,aAAS;IjB63CrC,cAAc;EiB73CV;;EjBg4CN;IiBh4CM,wBAAsB;IAAE,yBAAS;EjBm4CvC;;EAEA;IACE,wBAAwB;IiB/3ChB,yBAAuB;EjBi4CjC;;EiBj4CU;IHhBV,cAAa;Idq5CX,eAAe;EiBr4CP;;EjBw4CV;IiBx4CU,SAAA;EjB04CV;;EiB14CU;IHhBV,SAAA;Ed85CA;;EAEA;IACE,QAAQ;EiBj5CA;;EjBo5CV;IiBp5CU,QAAA;EjBs5CV;;EiBt5CU;IHhBV,QAAA;Ed06CA;;EAEA;IACE,QAAQ;EiB75CA;;EFXR;IE3BE,QAAc;EjBw8ClB;;EAEA;IACE,QAAQ;Ec56CV;;Ed+6CA;IACE,QAAQ;Ech7CV;;Edm7CA;IACE,QAAQ;Ecp7CV;;Edu7CA;IACE,QAAQ;Ecx7CV;;Ed27CA;IACE,QAAQ;Ec57CV;;Ed+7CA;IACE,SAAS;Ech8CX;;Edm8CA;IACE,SAAS;EiBr9CP;;EjBw9CJ;Icr9CA,SAAS;Edu9CT;;EAEA;Ic/9CA,cAAW;Edi+CX;;EAEA;Icn+CA,0BAAuC;Edq+CvC;;EAEA;Icv+CA,2BAAuC;Edy+CvC;;EAEA;Ic3+CA,gBAAW;Ed6+CX;;EAEA;Ic/+CA,2BAAuC;Edi/CvC;;EAEA;Icn/CA,2BAAuC;Edq/CvC;;EAEA;Icv/CA,gBAAW;Edy/CX;;EAEA;Ic3/CA,2BAAuC;Ed6/CvC;;EAEA;Ic//CA,2BAAuC;EdigDvC;;EAEA;IcngDA,gBAAW;EdqgDX;;EAEA;IcvgDA,2BAAuC;EdygDvC;;EAEA;Ic3gDA,2BAAuC;Ed6gDvC;AACF;;AAEA;EiB//CM;IAAuB,aAAmB;IjBkgD5C,YAAY;IiB//CR,eAAsB;EjBigD5B;;EiBjgDM;IAAwB,cAAS;IjBqgDrC,eAAe;EiBrgDX;;EjBwgDN;IiBxgDM,aAAsB;IAAE,cAAS;EjB2gDvC;;EAEA;IACE,wBAAwB;IiB9gDpB,yBAAsB;EjBghD5B;;EiBhhDM;IAAwB,aAAS;IjBohDrC,cAAc;EiBphDV;;EjBuhDN;IiBvhDM,aAAsB;IAAE,cAAS;EjB0hDvC;;EAEA;IACE,wBAAwB;IiB7hDpB,yBAAsB;EjB+hD5B;;EiB/hDM;IAAwB,cAAS;IjBmiDrC,WAAW;IiBniDP,eAAsB;EjBqiD5B;;EiB9hDU;IHhBV,uBAA4B;IdkjD1B,wBAAwB;EiBliDhB;;EjBqiDV;IiBriDU,wBAAuB;IHhBjC,yBAAa;EdwjDb;;EAEA;IACE,aAAa;IiB3iDL,cAAuB;EjB6iDjC;;EiB7iDU;IHhBV,wBAAa;IdikDX,yBAAyB;EiBjjDjB;;EjBojDV;IiBpjDU,wBAAuB;IHhBjC,yBAAa;EdukDb;;EAEA;IACE,aAAa;IiB1jDL,cAAuB;EjB4jDjC;;EiB5jDU;IHhBV,wBAAa;IdglDX,yBAAyB;EiBhkDjB;;ECnEZ;IACE,wBAAW;IACX,yBViIW;EUhIX;;ElBwoDA;IkBnoDE,aVkV0B;IUjV1B,cAAc;ElBqoDhB;;EAEA;IkBjoDE,wBAAe;IAGjB,yBAAc;ElBioDd;;EkBtnDA;IlBynDE,wBkBxnDC;IACD,yBV4T+B;ER6zCjC;;EkB/mDA;IAEA,cAAA;IlBinDE,eAAe;EACjB;;EAEA;IkB5mDI,SAAA;ElB8mDJ;;EAEA;IACE,SAAS;EACX;;EAEA;IkBjmDA,QAAA;EACE;;EC/DF;ID2EI,QVg7B8B;EU/6B9B;;EElFF;IpB8qDA,QAAQ;EACV;;EoBxqDI;IpB2qDF,QAAQ;EACV;;EoBxqDM;IpB2qDJ,QAAQ;EmBhrDV;;ECmBM;IpBiqDJ,QAAQ;EACV;;EoB3rDE;IpB8rDA,QAAQ;EACV;;EoBxrDI;IpB2rDF,QAAQ;EACV;;EoBxrDM;IpB2rDJ,QAAQ;EmBhsDV;;ECmBM;IpBirDJ,QAAQ;EACV;;EoB3sDE;IpB8sDA,SAAS;EACX;;EoBxsDI;IpB2sDF,SAAS;EACX;;EoBxsDM;IpB2sDJ,SAAS;EmBhtDX;;ECmBM;IpBisDJ,cAAc;EAChB;;EoB3tDE;IpB8tDA,0BAA0B;EAC5B;;EoBxtDI;IpB2tDF,2BAA2B;EAC7B;;EoBxtDM;IpB2tDJ,gBAAgB;EmBhuDlB;;ECmBM;IpBitDJ,2BAA2B;EAC7B;;EoB3uDE;IpB8uDA,2BAA2B;EAC7B;;EoBxuDI;IpB2uDF,gBAAgB;EAClB;;EoBxuDM;IpB2uDJ,2BAA2B;EmBhvD7B;;ECmBM;IpBiuDJ,2BAA2B;EAC7B;;EoB3vDE;IpB8vDA,gBAAgB;EAClB;;EoBxvDI;IpB2vDF,2BAA2B;EAC7B;;EoBxvDM;IpB2vDJ,2BAA2B;EmBhwD7B;AnBkwDF;;AAEA;EACE;IACE,aAAa;IoB5wDb,YAAA;IpB8wDA,eAAe;EACjB;;EoBxwDI;IpB2wDF,cAAc;IACd,eAAe;EACjB;;EAEA;ImBhxDA,aAAA;ICiBM,cAAgB;EAEhB;;EpBkwDN;IACE,wBAAwB;IoB5xDxB,yBAAA;EpB8xDF;;EoB3xDI;IAIA,aAAA;IpB2xDF,cAAc;EAChB;;EoBxxDM;IpB2xDJ,aAAa;ImBhyDf,cAAA;ECiBM;;EpBmxDN;IoB/wDQ,wBARa;IpByxDnB,yBAAyB;EoB5yDzB;;EpB+yDF;IoB5yDI,cAAgB;IpB8yDlB,WAAW;ImB3yDb,eAAA;ECiBM;;EpB8xDN;IoB1xDQ,uBARa;IpBoyDnB,wBAAwB;EkB5sDxB;;EAEE;IACA,wBVgQqD;IU3PvD,yBAAG;EACD;;EAEA;IlB0sDF,aAAa;IkBrsDjB,cAAY;EACV;;EAGA;IlBssDE,wBAAwB;IACxB,yBkBrsDO;ElBssDT;;EAEA;IkB/rDE,wBAAA;IACE,yBVgOwB;EWrW5B;;EnBw0DA;IACE,aAAa;Ie5wDb,cAAA;EGiGA;;ElB+qDF;IkB3qDM,wBAAgB;IAChB,yBAAA;ElB6qDN;;EenxDE;IGiGA,wBAAW;IAEP,yBAAc;ElBqrDpB;;EAEA;IkBjrDM,aAAA;IlBmrDJ,ckBlrDe;EH1Gf;;Ef+xDF;IkB3rDM,wBAAW;IACX,yBAAgB;ElB6rDtB;;EAEA;IepyDE,wBAAA;IGiGA,yBAAW;ElBssDb;;EAEA;IkBnsDM,cAAA;IAGA,eAAA;ElBmsDN;;EkB3sDE;IAEI,SAAS;ElB6sDf;;EAEA;IkBzsDM,SAAA;ElB2sDN;;EkBjtDM;IACA,QAAO;EACP;;EAIA;IACE,QAAQ;ElBktDhB;;EqB93DA;IACA,QAAO;EACP;;EdsHI;IclHJ,QAAA;EACA;;EAEA;IACA,QAAA;EACA;;ECFI;IAIA,QAAA;EtBi4DJ;;EqB13DA;IACE,QAAA;ErB63DF;;EAEA;IqBx3DE,QAAA;EEtBF;;EvBk5DA;IuB/4DE,QAAA;EvBi5DF;;EqBv3DA;IACE,Qb4/BgC;ER83BlC;;EAEA;IqB92DE,SAAS;ErBg3DX;;EAEA;IACE,SAAS;EACX;;EAEA;IqBx2DA,SAAA;EAME;;ErBs2DF;IqBh2DF,cAAA;ErBk2DE;;EqB/1DA;IrBk2DE,0BAA0B;EqBx1D9B;;EAEE;IACA,2BAAgB;Ed3Bd;;EPu3DF;IqBv1DF,gBAAmB;EACjB;;EdsBI;IcnBJ,2Bb0W+D;ER++C/D;;EqBr1DA;IACA,2BLSiC;ETK7B;;EP40DJ;IqB/0DF,gBAAA;EACE;;EAEA;IACA,2BAAgB;EdDZ;;EcIJ;IACA,2BAA6B;EAC7B;;EAGA;IAEE,gBAAgB;ErB+0DlB;;EqBl0DF;IACE,2BbmckC;EalclC;;EAEA;IGzIE,2BAV0C;ExBy9D5C;AqBl0DF;;ArBq0DA;EOr2DM;IcoCJ,abmTsC;IgBpcpC,YAAa;IxBs9Db,eAAe;EqB/zDjB;;ErBk0DA;IqB5zDF,cAAA;IACE,eAAY;ErB8zDZ;;EqBrzDA;IrBwzDE,aAAa;IqBrzDjB,cAAW;EACT;;ErBwzDA;IqB/yDF,wBAAU;IACR,yBAAa;EACb;;EAEA;IAEA,aAAA;IrBgzDE,cAAc;EAChB;;EAEA;IqBvyDF,aAAY;IACV,cAAU;EACV;;ErB0yDA;IqBtyDF,wBAAkB;IAChB,yBAAkB;EAClB;;EAIA;IAEE,cbkJqC;IRmpDrC,WAAW;IqBjyDf,eAAkB;EAChB;;EAGF;IACE,uBAAoB;IACpB,wBAAmB;EACnB;;EAIA;IACE,wBAAgB;IAChB,yBAAa;ErBgyDf;;EAEA;IuB7+DA,aAAoB;IAClB,cAAa;EACb;;EhB0BA;IgBvBA,wBPoD8B;IhB27D9B,yBAAyB;EuB5+D3B;;EAEE;IACA,wBAAO;IACP,yBAAU;EACV;;EAEA;IACA,aAAY;IhBmEV,cAtCa;EgB3Bf;;EAEA;IC9CA,wBAV0C;IxBuiE1C,yBAAyB;EuB1+DzB;;EvB6+DF;IACE,wBuB7+DqB;IACnB,yBAAc;EvB8+DlB;;EuBx+DI;IAGE,afqiB4B;IepiB5B,cAAgB;EAChB;;EAEA;IAGF,wBAAA;IACE,yBPa0B;EhB09DhC;;EuB/hEE;IAkEI,wBfmhB4B;IelhB5B,yBAAqB;EvBi+D3B;;EuB19DI;IAGE,cf8doC;Ie7dpC,eAAY;EAGd;;EvB09DJ;IACE,SAAS;EuBl9DP;;EAIA;IvBk9DF,SAAS;EACX;;EAEA;IuB58DI,QAAA;EACE;;EvB+8DN;IuBv8DM,QAAA;EACE;;EAMF;IACE,QAAU;EAGZ;;EvBo8DN;IuB17DI,QAAA;EACE;;EAKE;IACA,QAAU;EvBy7DlB;;EuBxjEE;IACA,QAAO;EACP;;EAEA;IvB2jEA,QAAQ;EuBxjEV;;EAEE;IACA,QAAO;EACP;;EAEA;IACA,QAAS;EACT;;EAEA;IACA,QPuCW;EOtCX;;EvB2jEF;IuBtjEE,SAAA;EvBwjEF;;EAEA;IuBxjEI,SAAS;EvB0jEb;;EuBpjEI;IAGE,SAAA;EACA;;EAEA;IACA,cAAe;EAGjB;;EvBojEJ;IACE,0BAA0B;EuB5mE1B;;EAmEI;IvB6iEJ,2BAA2B;EuBhnE3B;;EA6EI;IACA,gBAAY;EAGd;;EvBsiEJ;IACE,2BAA2B;EuB9hEzB;;EAIA;IvB8hEF,2BAA2B;EAC7B;;EAEA;IuBxhEI,gBAAA;EACE;;EvB2hEN;IuBnhEM,2BAAA;EACE;;EAMF;IACE,2BAAY;EAGd;;EvBghEN;IuBtgEI,gBAAA;EACE;;EAKE;IACA,2BAAY;EvBqgEpB;;EqB95DA;IACA,2BAAmB;EACnB;ArBi6DF;;AAEA;EACE,WqBz5DE;ErB05DF,mBqBz5DiB;ErB05DjB,cqBz5DI;ArB05DN;;AAEA;;EAEE,gBqBt5DU;ErBu5DV,mBqBt5De;ErBu5Df,6BqBt5DuB;ArBu5DzB;;AAEA;EACE,sBqBn5De;ErBo5Df,gCqBn5D0B;ArBo5D5B;;AAEA;EACE,6BqB94DiB;ArB+4DnB;;AAEA;;EAEE,eqB14DI;ArB24DN;;AAEA;EACE,yBqBz4DsB;ArB04DxB;;AAEA;;EAEE,yBqBv4DE;ArBw4DJ;;AAEA;;EAEE,wBAAwB;AyBxtE1B;;AzB2tEA;;;;EyBltEE,SAAA;AzButEF;;AAEA;EOzmEM,qCAtCqD;APipE3D;;AAEA;EsBxtEM,cAAA;EtB0tEJ,sCyBxuEG;AzByuEL;;AAEA;;;EAGE,yByBxtEY;AzBytEd;;AAEA;;;;EyBjsEA,qBAAA;AzBssEA;;AAEA;EyB7rEE,yBAAe;AzB+rEjB;;AAEA;;EAEE,yBgB9pE2C;AhB+pE7C;;AAEA;;;EAGE,yB0BrvE6B;A1BsvE/B;;AAEA;;;;EAIE,qBgB3qE2C;AhB4qE7C;;AAEA;EACE,yB0B5tEkB;A1B6tEpB;;AAEA;;E0BhxEE,yBV6FgC;AhBsrElC;;AAEA;;;EAGE,yBgB1rE2C;AhB2rE7C;;AAEA;;;;EAIE,qBgBlsEQ;AhBmsEV;;AAEA;EACE,yB0BzvE8B;A1B0vEhC;;AAEA;;E0BxyEE,yBVgG2C;AhB2sE7C;;AAEA;;;EAGE,yB0BxyE6B;A1ByyE/B;;AAEA;;;;EAIE,qBgBvtE2C;AhBwtE7C;;AAEA;EACE,yBgB3tE2C;AhB4tE7C;;AAEA;;EAEE,yBAAyB;AyBrwEzB;;AzBwwEF;;;EAGE,yBgBtuE2C;AhBuuE7C;;AAEA;;;;EAIE,qB0BzzEgB;A1B0zElB;;AAEA;EACE,yBgBlvEgC;AhBmvElC;;AAEA;;EAEE,yB0BxyEE;A1ByyEJ;;AyB5xEE;;;ECzDA,yBV6FgC;AhB8vElC;;AAEA;;;;EAIE,qB2Bn2EoB;A3Bo2EtB;;AAEA;EACE,yBQvwC2C;ARwwC7C;;AAEA;;EAEE,yB0Bp0EoB;A1Bq0EtB;;AAEA;;;E0B/2EE,yBVgG2C;AhBmxE7C;;AAEA;;;;E0B12EE,qBAAA;A1B+2EF;;AAEA;EACE,yB0Bz2EgB;A1B02ElB;;AAEA;;E0B51EE,yBAAA;A1B+1EF;;AAEA;;;EAGE,yBAAyB;AyB70EzB;;AzBg1EF;;;;EAIE,qB2B/4EoB;A3Bg5EtB;;AAEA;EACE,2B2Bn5E0B;A3Bo5E5B;;AAEA;;EAEE,2BgBzzEgC;AhB0zElC;;AAEA;;;EAGE,sC0Bh3EE;A1Bi3EJ;;AyBp2EE;EC3DA,sClBgmC2C;ARm0C7C;;AAEA;;EAEE,sC2Bv6E0B;A3Bw6E5B;;AAEA;EACE,W2B36EE;E3B46EF,yB0B75E6B;E1B85E7B,qB0Bz5EgB;A1B05ElB;;AAEA;EACE,c0Bp5Ec;EAOd,yBAAA;E1B+4EA,qBQn1C2C;ARo1C7C;;AAEA;EACE,W0Bp4EM;E1Bq4EN,yBAAyB;AyBv3EzB;;AzB03EF;;;EAGE,qBgB/1EQ;AhBg2EV;;AAEA;E0Bz3EE,SAAA;A1B23EF;;AAEA;EACE,2CgBt2E2C;AhBu2E7C;;AAEA;EACE,W0Bh3EM;E1Bi3EN,4CAA4C;AyB14E5C;;AzB64EF;EmBx8EE;IOwDE,cVkCyC;IUjCzC,WAAA;IACA,gBV+BM;IU5BR,iCAAA;E1Bi5EA;;EAEA;I0B34EE,SAAA;EAGF;A1B24EF;;AAEA;EACE;IACE,c0Bn4EgB;I1Bo4EhB,WAAW;IyB75Eb,gBAAuB;ICPvB,iCVqCgC;EUpChC;;E1Bw6EA;I0Bp6EE,SAAA;E1Bs6EF;AACF;;AAEA;EACE;I0B95EE,cAAA;IAGF,WAAA;IAGE,gBVeyC;IUdzC,iCVa8B;EhB+4EhC;;EAEA;IACE,SAAS;EyBh7EX;AzBk7EF;;AAEA;EACE;I0Bv7EE,cAAA;IACA,WAAA;IAGF,gBAAA;IAEE,iCAAY;EAGd;;E1Bq7EA;I0B/6EA,SAAA;E1Bi7EA;AACF;;AAEA;EACE;IACE,cAAc;IyBn8EhB,WAAA;ICPA,gBVqCgC;IUpChC,iCVoCgC;EGzFhC;;EnBogFA;I0B18EE,SAAA;EAGF;A1B08EF;;AAEA;EACE,c0Br8EE;EAGF,WAAA;E1Bo8EA,gBQl7C2C;ERm7C3C,iCgBp7EgC;AhBq7ElC;;AAEA;EACE,SAAS;AyBt9ET;;AzBy9EF;EmBphFE,cAAA;EnBshFA,WgB57Ea;EhB67Eb,mCgB97EgC;EhB+7EhC,yBgB/7EgC;EU5BhC,mBAAA;E1B69EA,gB0B39Ec;EAGd,gBAAA;E1B09EA,cgBn8EQ;EhBo8ER,sB0Bx9EoB;EAGpB,4BAAA;E1Bu9EA,yBgBr8E2C;EhBs8E3C,sBgBv8EQ;EhBw8ER,wEgBx8EgC;AhBy8ElC;;AAEA;EyBz+EE,qBAAuB;ECPvB,2BVqCgC;AhB88ElC;;AAEA;EACE,sBgBj9EQ;EhBk9ER,4BgBl9EgC;AhBm9ElC;;AAEA;EACE,4BgBt9EgC;EhBu9EhC,0B0B3+EoB;A1B4+EtB;;AAEA;EACE,gBgB39EQ;AhB49EV;;AAEA;EyB5/EE,0BAAuB;AzB8/EzB;;AAEA;EACE;I0BngFE,gBAAgB;E1BqgFlB;AACF;;AAEA;EACE,6BgBz+EgC;EhB0+EhC,S0B9/EE;A1B+/EJ;;AAEA;EACE,kBgB9+EQ;EhB++ER,0B0Bz/EE;A1B0/EJ;;AyBngFA;EACE,cjB4M4B;EiB3M5B,sBTiBgC;EShBhC,qBjB2F4C;EWpK5C,UAAA;EnBglFA,iDQtzDmD;ARuzDrD;;AAEA;EyB9/EE,cAAA;EzBggFA,UQ1jDkC;AR2jDpC;;AyBn/EA;;ElBgBM,yBAtCqD;EmBiBzD,UAAA;A1B8/EF;;AyBr/EA;;;;EDjGI,gBAVW;AxBumFf;;AAEA;EyBn/EE,cAAW;EAGX,sBAAA;AzBm/EF;;AyB1+EE;;EzB8+EA,cAAc;EyB7+EZ,WAAW;AzB++Ef;;AAEA;EsBxmFM,iCAAA;EtB0mFJ,oC4B9nFI;E5B+nFJ,gBsB1mFkB;EMlBlB,kBAAa;E5B8nFb,gB4B7nFY;A5B8nFd;;AAEA;EACE,+BAA+B;E4BvnFjC,kCAAY;EACV,qBAAkB;EAClB,gBAAS;A5BynFX;;AAEA;EACE,gC4B9nFU;E5B+nFV,mCsBxnFsB;EtBynFtB,sBAAsB;E6B7oFxB,gBAAA;A7B+oFA;;AAEA;E6B7oFE,cAAU;E7B+oFV,WAAW;E6B5oFb,mBAAiB;EACf,gBAAa;ECoBX,mBAAA;E9B2nFF,gB8B1nFa;E9B2nFb,c8B1nFe;E9B2nFf,6BQ75E8C;ER85E9C,yB8B1nFe;E9B2nFf,mB8B3pFY;A9B4pFd;;AAEA;;EAEE,gB8BvmFkB;E9BwmFlB,eAAe;A6BlpFjB;;A7BqpFA;E6BlpFE,kCAAO;EACP,uBrBwpBsC;EqBvpBtC,sBAAa;EACb,gBAAW;EACX,qBrB8tBuC;ARs7DzC;;AAEA;E6BlpFE,gCrB4+B6C;EqB3+B7C,oBAAgB;EAChB,qBAAgB;EAChB,gBAAgB;EAChB,qBAAiB;A7BopFnB;;AAEA;;E6B3oFM,YAAW;A7B8oFjB;;A6B1oFI;EACE,YAAQ;A7B6oFd;;AehoFI;EcnBA,mBAAA;A7BupFJ;;AAEA;E6BppFI,cAAA;E7BspFF,mB6BrpFY;A7BspFd;;AAEA;EACE,a6B9pFe;E7B+pFf,e6B9pFW;E7B+pFX,kBAAkB;E6B5pFhB,iBAAA;A7B8pFJ;;AehpFI;;EfopFF,kB6BtqFe;E7BuqFf,iB6BtqFW;A7BuqFb;;AAEA;EACE,kB6BrqFc;EdYZ,cAAA;EcnBA,qBAAA;A7B+qFJ;;AAEA;E6B5qFI,kBAAA;E7B8qFF,kB6B7qFY;E7B8qFZ,qB6B7qFc;AdYZ;;AfoqFJ;;EAEE,cAAc;AAChB;;AAEA;E6B7qFE,gBAAA;A7B+qFF;;AAEA;E6B7qFI,oBrB4rBgC;EsB3tBhC,mBAAA;EACE,eAAS;EACT,qBtB+N0C;ARg/EhD;;AAEA;E8BvuFE,gBAAc;EACd,aAAa;EACb,uBAAa;EA8CX,cAAA;A9B4rFJ;;A6BhrFE;EACE,aAAM;EACN,WAAW;EACX,mBAAU;EACV,cAAa;EACb,crB8qBgC;AsB3tBhC;;A9BkuFJ;E8B/tFM,kBtB6NwB;EsB5NxB,SAAS;EAlBb,OAAA;EACA,UAAA;EACA,aAAa;EACb,eAAa;EAuCX,uBAAA;EACE,iBAAc;EDqBhB,sBAAA;EACE,gBAAgB;E7B0rFpB,WAAW;E6BprFX,wCAAe;EACb,sBAAM;A7BsrFV;;AAEA;;;;E8BhvFM,ctB+NwB;ARshF9B;;A8BxuFM;;EAIA,qBAAA;EACE,oCAAqB;EACrB,yDtB4MwC;EsB3MxC,4BtB0MwC;EsBzMxC,2DAAW;EA9BjB,gEAA0C;A9BwwF5C;;A8BruFI;;EDuCA,qBAAA;EACE,gDAAiB;A7BmsFvB;;AAEA;;EAEE,oCAAoC;E6BrrFtC,kFAAkB;A7BurFlB;;AAEA;;EAEE,qBAAqB;E6BprFvB,uCAAe;EACb,wNAAc;A7BsrFhB;;AAEA;;E6BnrFE,qBrBs+B2C;EqBr+B3C,gDAAmB;A7BsrFrB;;AAEA;;EAEE,cQtjEkC;ARujEpC;;AAEA;;;;E6B9pFE,cAAA;A7BmqFF;;AAEA;;E6BzpFA,cAAA;A7B4pFA;;A6BvpFA;;EAEE,qBrB8lBkC;AR4jEpC;;AAEA;;EAEE,qBAAqB;E6BtpFvB,yBAAoB;A7BwpFpB;;AAEA;;E+Bl1FA,gDAAA;A/Bq1FA;;AAEA;;E+Bj1FE,qBAAA;A/Bo1FF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,gD+Bl1Fc;A/Bm1FhB;;AAEA;E+B70FE,aAAW;EACX,WAAA;EAEA,mBAAA;E/B80FA,c+B70Fa;E/B80Fb,cAAc;A+Bx0Fd;;A/B20FF;E+Br0FE,kBAAA;E/Bu0FA,SAAS;EwBl1FP,OAAA;EACA,UAAA;EOeF,aAAA;E/Bs0FA,eAAe;EwBx0Fb,uBAAsB;EACtB,iBAAA;ExB00FF,sBAAsB;E+BvzFxB,gBAAA;EACE,WAAA;EACA,yCAAkC;EAElC,sBAAA;A/BwzFF;;AAEA;;;;E+B7yFE,cAAc;A/BkzFhB;;AAEA;;EAEE,qBAAqB;E+B7xFvB,oCAAoB;EAClB,yDAAsB;EACtB,4BAAuB;EACvB,2DAAuB;EAEvB,gEAAA;A/B8xFF;;AAEA;;EAEE,qB+B3xFgC;EAIhC,iDAAA;A/ByxFF;;AAEA;;EAEE,oCAAoC;EACpC,kFwBp5F4C;AxBq5F9C;;A+BtwFE;;EAEE,qBAAgB;EAEhB,uCAAA;E/BwwFF,wNAAknB;AACpnB;;AAEA;;EAEE,qB+BzwFoB;E/B0wFpB,iDAAiD;AgCn6FnD;;AhCs6FA;;EgCl6FE,cAAa;AhCq6Ff;;AAEA;;;;EAIE,cgCn6FQ;AhCo6FV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,yBgC36FqC;AhC46FvC;;AAEA;;EgCl6FE,iDAAA;AhCq6FF;;AAEA;;EAEE,qBwB56FE;AxB66FJ;;AAEA;;EgCh6FE,qBAAA;AhCm6FF;;AAEA;;EAEE,qBwBt7FE;ExBu7FF,iDgCl6FE;AhCm6FJ;;AAEA;EgC15FA,aAAA;EhC45FE,mBgC35FkB;EAClB,mBAAa;AhC45Ff;;AAEA;EACE,WgCx5FW;AhCy5Fb;;AAEA;EgCp5FE;IhCs5FE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IgCx5FE,aAAa;IhC05Fb,cAAc;IgCt5FlB,mBAAqB;IAAE,mBAAkC;IhCy5FrD,gBAAgB;EgCx5FpB;;EhC25FE;IgCn5FF,qBAAkB;IAChB,WAAa;IACb,sBAAmB;EACnB;;EzBwBI;IyBrBJ,qBxBqL+B;EwBpL/B;;EAEA;;IAEA,WAAA;EACA;;EAIA;IhCm5FE,aAAa;IgCj5Fb,mBAAa;IhCm5Fb,uBAAuB;IgCz4F3B,WAAA;IhC24FI,eAAe;EgCz4FjB;;EAGF;IhC04FI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;EgCx4FhB;;EAEA;IR3HE,mBAV0C;IxBghG1C,uBAAuB;EgCv4F3B;;EAEE;IhCy4FE,gBAAgB;EgCt4FpB;AhCw4FA;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EgCt4FhB,cAAS;EzB7BL,kBAtCa;EyBqEjB,sBxBmT+D;EgB/b7D,yBAVW;UAUX,iBAVW;ExB+hGb,6BAA6B;EgCr4F/B,6BAAA;EhCu4FE,yBAAyB;EgCr4FzB,mBAAe;EhCu4Ff,gBAAgB;EgC53FlB,qBAAA;EhC83FE,qIAAqI;AACvI;;AAEA;EACE;IwB/gGE,gBAAA;EACA;AxBihGJ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EiCpjGZ,iDAAgB;AjCsjGhB;;AAEA;;EiCnjGE,aAAY;AjCsjGd;;AiCljGA;EACE,eAAS;AjCqjGX;;AiCjjGA;;EAEE,oBAAO;AjCojGT;;AAEA;EiCljGE,WAAU;EAEV,yBAAA;EjCmjGA,qBgB5+F2C;AhB6+F7C;;AAEA;EACE,WiC3iGI;EAIJ,yBAAA;EjCyiGA,qBQl+EkC;ARm+EpC;;AAEA;;EiC9hGI,WAAA;EjCiiGF,yBQvjE2C;ERwjE3C,qBiC/hGI;EjCgiGJ,gDQ3jE2C;AR4jE7C;;AAEA;;EiCphGE,WAAA;EAIA,yBAAA;EjCohGA,qBiCnhGoB;AjCohGtB;;AAEA;;;EAGE,WiCnhGE;EjCohGF,yBiCnhGa;EjCohGb,qBgBzgGa;AhB0gGf;;AAEA;;;EAGE,gDiC/gGgB;AjCghGlB;;AAEA;EACE,WiC/gGE;EjCghGF,yBAAyB;EiCtgGzB,qBAAA;AjCwgGF;;AAEA;EiC//FI,WAAA;EACE,yBjB3B4B;EW/F9B,qBX+FM;AiB+BN;;AAMA;;EAGA,WAAA;ENvIA,yBnBwhB4C;ER0mF9C,qBAAqB;EiCh/FrB,gDAA8B;AjCk/FhC;;AAEA;;E2BtoGI,WAAA;E3ByoGF,yBAAyB;EiCh+F3B,qBAAe;AjCk+Ff;;AAEA;;;EAGE,WiC99FI;EAGF,yBAAA;EjC69FF,qBgB9hGiC;AhB+hGnC;;AAEA;;;EAGE,gDsB9oGgB;AtB+oGlB;;AAEA;EiCz9FI,WAAA;EjC29FF,yBgB7jG2C;EhB8jG3C,qBiC19Fe;AjC29FjB;;AAEA;EiC38FA,WAAA;EACE,yBAAqB;EACrB,qBAAW;AjC68Fb;;AAEA;;EiCz8FE,WAAW;EACX,yBzBgyB0D;EyB/xB1D,qBAAgB;EAChB,gDAAY;AjC48Fd;;AAEA;;EAEE,WiCz8FE;EjC08FF,yBiCz8FY;EjC08FZ,qBQnmFkC;ARomFpC;;AAEA;;;EAGE,WiC17FE;EjC27FF,yBiC17FwB;EAGxB,qBAAA;AjCy7FF;;AAEA;;;EAGE,gDiCl7FoB;AjCm7FtB;;AiC96FA;EACE,WzBgUkC;EyB/TlC,yBzB4TqD;EyB3TrD,qBzB2TkC;ARsnFpC;;AAEA;EiC96FA,WAAA;EACE,yBzB6TkC;EyB5TlC,qBzByTqD;ARunFvD;;AAEA;;EiCv6FA,WAAa;EACX,yBAAkB;EAClB,qBAAqB;EACrB,+CAAW;AjC06Fb;;AAEA;;EiCt6FE,WAAU;EACV,yBAAU;EACV,qBAAW;AjCy6Fb;;AAEA;;;EAGE,WiCv6FE;EAIF,yBAAA;EjCq6FA,qBQrsEkC;ARssEpC;;AAEA;;;EiCx5FA,+CAAmB;AjC45FnB;;AAEA;EiC15FE,cAAO;EACP,yBAAU;EACV,qBzByRkC;ARmoFpC;;AAEA;EiCz5FE,czBqqB0D;EyBpqB1D,yBjB3P2C;EiB4P3C,qBAAQ;AjC25FV;;AAEA;;EAEE,ciCx5FU;EjCy5FV,yBiCx5FW;EjCy5FX,qBiCx5FY;EjCy5FZ,gDiCx5FgB;AjCy5FlB;;AAEA;;EAEE,ciCx5FW;EjCy5FX,yBQruEkC;ERsuElC,qBiCx5Fe;AjCy5FjB;;AiC94FA;;;EAGE,cAAU;EACV,yBAAkB;EAClB,qBAAgB;AjCi5FlB;;AAEA;;;EAGE,gDQ1qF2C;AR2qF7C;;AAEA;EACE,WiC74FW;EAGX,yBAAA;EjC44FA,qBQtrF+C;ARurFjD;;AAEA;EACE,WQvrF4C;ERwrF5C,yBwB5xG4C;ExB6xG5C,qBsBrxGgB;AtBsxGlB;;AAEA;;EAEE,WiC54FE;EjC64FF,yBQ1rF2C;EyB9M3C,qBAAA;EjC04FA,gDQ3sFsC;AR4sFxC;;AAEA;;EAEE,WiCz4FE;EjC04FF,yBwB3yG4C;ESsa5C,qBAAA;AjCu4FF;;AAEA;;;EAGE,WsB1yGI;EtB2yGJ,yBiCr4FkB;EjCs4FlB,qBsBxyGI;AtByyGN;;AAEA;;;EAGE,gDQhuFsC;ARiuFxC;;AAEA;EACE,ciCp4FE;EjCq4FF,yBiCp4FgB;EjCq4FhB,qBwBh0G4C;AxBi0G9C;;AAEA;EACE,ciCj4Fc;EjCk4Fd,yBQ7tF6D;ER8tF7D,qBQ9tF6D;AR+tF/D;;AAEA;;EAEE,ciCh4Fc;EjCi4Fd,yBsBh0GI;EtBi0GJ,qBiC74FA;EjC84FA,iDsBj0GsB;AtBk0GxB;;AAEA;;EAEE,cQxvFkC;ERyvFlC,yBiC/3FoB;EjCg4FpB,qBQzvFyC;AR0vF3C;;AAEA;;;EAGE,cwBj1GE;ESwdF,yBAAA;EjC23FA,qBiC13FoB;AjC23FtB;;AAEA;;;EAGE,iDiCr3FmB;AjCs3FrB;;AAEA;EACE,ciCj3FY;EAGV,yBAAA;EjCg3FF,qBQ/vF2C;ARgwF7C;;AAEA;EACE,ciC52Fa;EXzfT,yBAAY;EAIZ,qBAAA;AtBo2GN;;AAEA;;EAEE,cAAc;EkCv3GhB,yBAAK;EACH,qBAAa;EACb,iDAAe;AlCy3GjB;;AAEA;;EkCr3GA,cAAU;EACR,yBAAc;EACd,qBAAgD;AlCw3GlD;;AAEA;;;EAGE,ckCl3GU;ElCm3GV,yBAAyB;EkC32G3B,qBAAU;AlC62GV;;AAEA;;;EAGE,iDwB54G4C;AxB64G9C;;AAEA;EACE,ckCv2GE;ElCw2GF,qBQl3E2C;ARm3E7C;;AAEA;EACE,WAAW;EACX,yBQz5E0D;ER05E1D,qBQj5EkC;ARk5EpC;;AAEA;;EAEE,gDwB55G4C;AxB65G9C;;AAEA;;EAEE,cAAc;EkCt1GZ,6BlBmByC;AhBq0G7C;;AkC70GE;;;EAGE,WAAU;ElCg1GZ,yBAAyB;EkC30GzB,qBAAA;AlC60GF;;AAEA;;;EkCj0GE,gDAAY;AlCq0Gd;;AAEA;EACE,cAAc;EmC36GhB,qBAAQ;AnC66GR;;AAEA;EmC36GE,WAAW;EACX,yBAAiB;EACjB,qBAA4C;AnC66G9C;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,cmC96GE;EnC+6GF,6BAA6B;AmC35G/B;;AnC85GA;;;EOl1GM,WAtCa;E4BhCjB,yBAAoB;EACpB,qBAAmB;AnC65GrB;;AAEA;;;EmCj5GE,gDAAsB;AnCq5GxB;;AAEA;EmCl5GE,cAAA;EnCo5GA,qBmCn5GkB;AnCo5GpB;;AAEA;EACE,WmCj5GS;EnCk5GT,yBAAyB;EmCz4G3B,qBAAa;AnC24Gb;;AAEA;;EmC93GA,+CAAiB;AnCi4GjB;;AAEA;;EmC13GA,cAAgB;EACd,6BAA4D;AnC63G9D;;AAEA;;;EmBr+GE,WAAA;EnBy+GA,yBmC33GuB;EnC43GvB,qBAAqB;AmCt3GvB;;AnCy3GA;;;EmCp3GE,+CAAW;AnCw3Gb;;AAEA;Ee17GI,cAAA;EoB8EI,qBAAA;AnC+2GR;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBmCn3GwB;AnCo3G1B;;AAEA;;EAEE,+CmCt2GiC;AnCu2GnC;;AAEA;;EAEE,cmCl2GQ;EnCm2GR,6BQt0FuC;ARu0FzC;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBmCn2GyB;AnCo2G3B;;AAEA;;;Eex9GI,+CAAyB;Af49G7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;Eeh/GI,cAAA;EoByFA,yBAAW;EnC05Gb,qBmCt4GiB;AnCu4GnB;;AAEA;;EAEE,gDmCp4G4B;AnCq4G9B;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cmCt3GiB;EnCu3GjB,yBmCp3GwB;EnCq3GxB,qBmCl3GM;AnCm3GR;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,cmCn7GoB;EpB7FlB,qBAAA;AfkhHJ;;AAEA;EACE,WmCr6GM;EnCs6GN,yBmCr6G2B;EnCs6G3B,qBmCp6GQ;AnCq6GV;;AAEA;;EAEE,gDmC95GM;AnC+5GR;;AAEA;;EAEE,cAAc;EACd,6BmCn6GyB;AnCo6G3B;;AAEA;;;EexhHI,WAAA;EoB8EI,yBAAA;EnC+8GN,qBAAqB;AACvB;;AAEA;;;EAGE,gDmCn9GuB;ApB7FrB;;AfmjHJ;EACE,cmCt8GM;EnCu8GN,qBmCr8GM;AnCs8GR;;AAEA;EACE,cmCl8GQ;EnCm8GR,yBQt6FkC;ERu6FlC,qBQv6FkC;ARw6FpC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cmCp7GkB;EnCq7GlB,6BmCl7GM;AnCm7GR;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;Ae/kHI;;;EfolHF,iDmCt+GiC;AnCu+GnC;;AAEA;EACE,cmCp+GkB;EnCq+GlB,qBmCl+GQ;AnCm+GV;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDmCt9GgC;AnCu9GlC;;AAEA;;EmC1/GQ,cAAW;EACX,6BAA2B;AnC6/GnC;;AAEA;;;EAGE,cAAc;EACd,yBmCrhHwB;EnCshHxB,qBmCrhHuB;AnCshHzB;;AAEA;;;EAGE,iDQp+FuC;ARq+FzC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cmCp/GiB;EnCq/GjB,0BmCl/GwB;AnCm/G1B;;AAEA;;EmCl+GI,0B3B4gBgE;ARy9FpE;;AmC79GI;;EhBxNF,cAAA;EnB0rHA,oBQr+FkC;ARs+FpC;;AmCv9GI;;EnC29GF,oBAAoB;EACpB,qBAAqB;EmCx9GjB,gB3BofoC;E2BhfxC,qBAAA;AnCu9GF;;AmCl9GE;;EAIA,uBAAA;EACE,sB3B8dgC;E2B7dhC,gBAAA;EnCm9GF,qBQ9+FwC;AR++F1C;;AAEA;EmC18GE,cAAA;EACE,WnB9KyC;AhB0nH7C;;AmCp8GI;EACE,kB3Bgc8B;ARugGpC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EmC57GE,gCAAgB;AnC87GlB;;AmCz7GE;EACE;IAGF,gBAAA;EACE;AnC07GJ;;AAEA;EACE,UmCx7GW;AnCy7Gb;;AAEA;EoCpvHE,aAAa;ApCsvHf;;AAEA;EoCnvHE,kBpB2Fa;EoB1Fb,SAAA;EACA,gBAAQ;EZKN,6BAV0C;AxB2vH9C;;AAEA;EoChvHE;IACE,gBAAY;EpCkvHd;AACF;;AAEA;;;;EAIE,kBwBtuHE;AxBuuHJ;;AAEA;EACE,mBoC3uHe;ApC4uHjB;;AAEA;EoCpuHE,qBAAe;EACf,oB5B0wByC;ER49FzC,uBAAuB;EoCluHzB,WAAY;EACV,uB5BowBwC;ERg+FxC,qCAAqC;EoCjuHvC,gBAAe;EACb,oCAA+B;ApCmuHjC;;AoC/tHA;EACE,cAAa;ApCkuHf;;AAEA;EoC5tHE,kBAAA;EACE,SAAA;EpC8tHF,OAAO;EoCttHT,aAAa;EACX,aAAS;EACT,WAAA;EAEA,gBAAgB;EAChB,iBAAe;EAEf,oBAAA;EpCstHA,mBwBvyHa;ExBwyHb,cAAc;EoCltHhB,gBAAa;EACX,gBAAS;EAET,sB5BiuBkC;E4BhuBlC,4BAAY;EAEZ,qCAAa;EpCktHb,sBwB5yHa;AxB6yHf;;AAEA;EoCzsHE,WAAA;EACA,OAAA;ApC2sHF;;AoCvsHA;EACE,QAAA;EACA,UAAA;ApC0sHF;;AAEA;EoCtsHE;IACA,WAAQ;IACR,OAAS;EACT;;EZ9GE;IxBwzHA,QAAQ;IoCrsHZ,UAAA;EpCusHE;AACF;;AAEA;EACE;IoCpsHF,WAAA;IpCssHI,OAAO;EwBvzHP;;ExB0zHF;IoCpsHF,QAAA;IpCssHI,UAAU;EwB9yHV;AxBgzHJ;;AoC/rHE;EACE;IrB/FA,WAAA;IqB6FJ,OAAA;EpCssHE;;EAEA;IoC/rHE,QAAA;IAEA,UAAA;EpCgsHF;AACF;;AAEA;EACE;IoClrHA,WAAA;IACE,OAAA;ErB3HA;;EfizHF;IoCjrHE,QAAA;IAGA,UAAA;EpCirHF;AACF;;AAEA;EACE;IACE,WoC1qHI;IpC2qHJ,OwBp1HA;ExBq1HF;;EAEA;IACE,QoCzqHQ;IpC0qHR,UoCxqHM;EpCyqHR;AACF;;AAEA;EACE,SwB/0HE;ExBg1HF,YoCpqHQ;EpCqqHR,aAAa;EACb,uBoCnqHU;ApCoqHZ;;AAEA;EACE,qBAAqB;EoCppHrB,oBAAM;EACJ,uB5B2lB8C;EOnxB9C,WAAA;EqBsLJ,aAAc;EpC0pHZ,qCQ/jGmC;ERgkGnC,0BQ/jGyC;ERgkGzC,oCoCppHY;ApCqpHd;;AAEA;EACE,coCnpHW;ApCopHb;;AAEA;EoCzoHE,MAAA;EpC2oHA,WoC1oHU;EpC2oHV,UoCzoHE;EpC0oHF,aoCzoHI;EpC0oHJ,qBwBj3HE;AxBk3HJ;;AAEA;EACE,qBwBl4HE;ExBm4HF,oBoCvoHE;EpCwoHF,uBwBx5H4C;ExBy5H5C,WoCvoHI;EpCwoHJ,mCAAmC;EqCl6HrC,eAAY;EACV,sCAAa;EACb,wBAAe;ArCo6HjB;;AAEA;EqCj6HE,cAAA;ArCm6HF;;AqC/5HA;EACE,iBAAa;ArCk6Hf;;AAEA;EACE,MqC95HI;ErC+5HJ,WqC95HI;ErC+5HJ,UqC95HS;ErC+5HT,aQ54FkC;E6BxgClC,sBAAA;ArCs5HF;;AAEA;EqCh5HE,qBAAA;ErCk5HA,oBQn5F2C;ERo5F3C,uBAAuB;EsC37HzB,WAAY;AtC67HZ;;AAEA;EwB76HI,aAAa;AxB+6HjB;;AAEA;EsC37HE,qBAAc;EACd,qBAAS;EACT,uBAAsC;EACtC,WAAW;EACX,mCtByFgC;EsBvFhC,yBtBwF2C;EsBvF3C,sCAA+D;AtC47HjE;;AAEA;EACE,csC17HE;AtC27HJ;;AAEA;EACE,iBsCx7HY;AtCy7Hd;;AAEA;;;;EwBp6HI,WAAA;EcTA,YAAA;AtCm7HJ;;AsC96HE;EACE,SAAS;EACT,gBtBuDyC;EsBtDzC,gBAAgB;EAChB,6BtBoD8B;AsBjDhC;;AtCg7HF;EsC56HI,cAAY;EACZ,WAAA;EACA,uB9Bs9ByC;ERw9F3C,WAAW;EuCr+HX,gBAAA;EACE,cAAS;EhC2HP,mBAtCa;EgCnFf,mB/BmO6B;E+B9N3B,6BAAA;EfqCF,SAAA;AxB+7HJ;;AAEA;;EAEE,cAAc;EuCh/Hd,qBAAA;EACE,yBAA8B;AvCk/HlC;;AuC3+HM;;EfsCF,WAAA;EejCE,qBAAA;EfkBF,yBA1BW;AxBq/Hf;;AwCx/HA;;EAEE,cAAS;EjCiEP,oBAA+B;EiC/DjC,6BhCk5BmD;ARymGrD;;AAEA;EwCz/HE,cAAc;AxC2/HhB;;AAEA;EACE,cwCtgIK;ExCugIL,sBsBv/HsB;EHLtB,gBAAA;EnB8/HA,sBwC3/HqB;EAKrB,cAAQ;ExCw/HR,mBwCv/He;AxCw/HjB;;AAEA;EwCn/HE,cAAS;ExCq/HT,uBAAuB;EwC9+HzB,cAAY;AxCg/HZ;;AAEA;;EwCv+HE,kBAAiB;ECjDjB,oBzBqG2C;EyBpG3C,sBzBmGQ;AhBy7HV;;AAEA;;EAEE,kByCthIc;EzCuhId,cyCthIgB;AzCuhIlB;;AAEA;;EmBthIE,UAAA;AnByhIF;;AAEA;;;;;;EyCziIE,UAAA;AzCgjIF;;AAEA;EyC1iII,aAAA;EzC4iIF,eyC1iIc;EzC2iId,2ByC1iIgB;AzC2iIlB;;AAEA;EyCxjIE,WAAA;AzC0jIF;;AAEA;;EAEE,iByCpjIc;AzCqjIhB;;AwC/gIE;;EChDA,0BzBmGgC;EGrFhC,6BAAA;AnBujIF;;AAEA;;EAEE,yByC9jIgB;EzC+jIhB,4BAA4B;AwC1hI5B;;AxC6hIF;EmB/jIE,wBAAA;EnBikIA,uBgB3+H2C;AhB4+H7C;;AAEA;;;EwCliIE,cAAiB;AxCsiInB;;AAEA;EACE,eQr/FkC;ARs/FpC;;AAEA;;EAEE,uBAAuB;EwC9iIvB,sBAAiB;AxCgjInB;;AAEA;;EAEE,sByC/lIsB;EAGpB,qBAAA;AzC8lIJ;;AAEA;E0C1mIA,sBAAW;EACT,uBAAoD;EACpD,uBlCmzBsC;ARyzGxC;;AAEA;;EAEE,W0C1mIS;A1C2mIX;;AAEA;;EwBnmII,gBAV0C;AxBgnI9C;;AAEA;;E2CnnIE,6BnCm9BsC;EmCl9BtC,4BAAQ;A3CsnIV;;A2CjnIA;;E3CqnIE,yBAAyB;E2C/mI3B,0BAAY;A3CinIZ;;A2CxmIA;;EAIE,gBAAA;A3CymIF;;AAEA;;;;EAIE,kBAAkB;E2C/lIlB,sBAAiB;EC/CjB,oBAAa;A5CipIf;;AAEA;EACE,kB4C/oIkB;EAGlB,aAAA;E5C8oIA,e4C7oIS;E5C8oIT,oBAAoB;E2CxmIpB,WAAA;A3C0mIF;;AAEA;;;;EAIE,kB4CtpI4B;E5CupI5B,cAAc;E2CjnId,SAAA;EC/CA,YAAO;EjBKL,gBAAgB;A3B+pIpB;;AAEA;;;;;;;;;;;;EAYE,iBAAiB;A2CnoIjB;;A3CsoIF;;;EAGE,U4CnrIE;A5CorIJ;;AAEA;E2C5oIE,UAAA;A3C8oIF;;AAEA;;EAEE,0B4C5rIoB;EAGpB,6BAAY;A5C2rId;;A2CppIE;;EhB1CE,yBAAwB;EiBH1B,4BAAqB;A5CusIvB;;AAEA;EACE,a4CnsIS;E5CosIT,mBAAmB;A2C9pInB;;A3CiqIF;;E4C5sIE,0BAAG;E5C+sIH,6B4C9sIuC;A5C+sIzC;;AAEA;E6CrtIE,yBAAA;EACE,4BAAK;A7CutIT;;AAEA;;E6CntIE,aAAa;EACb,gBrC49BsC;AR0vGxC;;AAEA;;EwBhtII,kBAVW;ExB6tIb,UAAU;A6CltIZ;;A7CqtIA;;E6CjtIE,UAAU;A7CotIZ;;AAEA;;;;;;;;E2BlsIE,iBAAgB;A3B2sIlB;;A6CjtIE;EACE,kBAAW;A7CotIf;;AAEA;EACE,iBAAiB;A8C7vInB;;A9CgwIA;EACE,aAAa;E8C5vIf,mBAAY;EACV,yBAAO;E9C8vIP,gBAAgB;E+ChwIlB,mBAAY;EACV,gBAAa;EACb,gBAAgB;EAGhB,cAAc;EACd,kBAAgB;EvBQd,mBAVW;ExBmwIb,yBAAyB;E+CvvI3B,yBAAwB;EACtB,qBAAW;A/CyvIb;;AAEA;;EAEE,aQ7wGkC;AR8wGpC;;AAEA;;EAEE,gCQlvG2C;ARmvG7C;;AAEA;;;;;;EAME,oBwBrwIE;ExBswIF,qBwBrwIE;EuB6BF,gBAAA;E/C0uIA,qBwB1vIE;AxB2vIJ;;AAEA;;EAEE,kCgBlsI2C;AhBmsI7C;;AAEA;;;;;;EAME,uB+CjuIyC;E/CkuIzC,sBQ5zGkC;ER6zGlC,gBAAgB;E+CptId,qBAAgC;A/CstIpC;;AAEA;;E+C/sIQ,sBAAA;A/CktIR;;AAEA;;;;;;EAME,0B+C5sIgD;E/C6sIhD,6BQ70G+C;AR80GjD;;AAEA;;;;;;EAME,yBwB/wIE;ExBgxIF,4BwBpwIE;ExBqwIF,kC+CjuIM;E/CkuIN,+B+CjuIqB;A/CkuIvB;;AAEA;EACE,kB+C9tIQ;E/C+tIR,U+C9tIU;E/C+tIV,c+C9tIU;EhC3DR,qBAAA;EgCmCA,oBAAA;E/CyvIF,iC+CxvIoB;U/CwvIpB,mB+CxvIoB;A/CyvItB;;AAEA;EACE,oB+CpvIM;E/CqvIN,kBwBhyIE;AxBiyIJ;;AAEA;EACE,kB+ChvIM;E/CivIN,O+ChvIQ;E/CivIR,W+ChvIQ;E/CivIR,W+C/uIQ;E/CgvIR,kB+C/uIqB;E/CgvIrB,U+C/uIU;AhC3DR;;Af6yIJ;EACE,W+CvwIM;E/CwwIN,qBwBlyIE;ExBmyIF,yBwB/yIE;AxBgzIJ;;AAEA;EACE,iD+CnwIM;A/CowIR;;AAEA;EACE,qB+CjwIyB;A/CkwI3B;;AAEA;Ee3zII,WAAA;EgCmCA,yBAAgC;E/C2xIlC,qB+C1xIuB;A/C2xIzB;;AAEA;;EAEE,cwBl0IE;AxBm0IJ;;AAEA;;EAEE,yBQ94G+C;AR+4GjD;;AAEA;EACE,kB+CjxIU;EhC3DR,gBAAA;EgCmCA,mBAAA;A/C4yIJ;;AAEA;EACE,kBwBj1IE;ExBk1IF,e+CvyIM;E/CwyIN,awBn1IE;ExBo1IF,cwBx0IE;ExBy0IF,W+CryIM;E/CsyIN,Y+CryIQ;E/CsyIR,oB+CnyIM;E/CoyIN,W+CnyIQ;E/CoyIR,sB+CnyIyB;E/CoyIzB,yB+ClyIQ;A/CmyIV;;A+CnxIA;EvBnHI,kBAV0C;EuBgI5C,eAAA;E/CqxIA,a+CpxIE;E/CqxIF,c+CnxIE;E/CoxIF,W+CnxII;E/CoxIJ,YAAY;EgD75IZ,WAAA;EACE,mCAAa;AhD+5IjB;;AAEA;EACE,sBgD55IwB;AhD65I1B;;AAEA;EACE,yDgD15I0B;AhD25I5B;;AAEA;EgDx6II,qBAAkB;E7BWpB,yBAAA;AnBg6IF;;AAEA;EACE,yDgB70I2C;AhB80I7C;;AAEA;EgDn7IE,yCAA2B;AhDq7I7B;;AAEA;EACE,yCgDl7ImB;AhDm7IrB;;AAEA;EACE,kBgDh7IsB;AhDi7IxB;;AgD77IE;EACE,yDAAa;AhDg8IjB;;AAEA;EACE,yCgD77I+C;AhD87IjD;;AAEA;EACE,qBgD37IoB;AhD47ItB;;AAEA;EgDz8II,cAAA;E7BWF,cAAA;EnBi8IA,mBgDx8ImB;EhDy8InB,qBgDx8IwB;AhDy8I1B;;AAEA;EACE,2BgDt8I0B;EhDu8I1B,0BAA0B;EgDp9I1B,uBAA2B;EACzB,wBAAa;EACb,yBAA6B;E7BW/B,qBAAA;EnB48IA,yIgDn9ImB;AhDo9IrB;;AAEA;EACE;IgDh9IM,gBAAc;EhDk9IpB;AgD/9IA;;AhDk+IF;EmBr9IE,sBAAA;EnBu9IA,8BgD99ImB;AhD+9IrB;;AAEA;EACE,yCgD59I8B;AhD69IhC;;AgDz+IE;EACE,qBAAa;EACb,WAAA;E7BWF,mCAAA;EnBk+IA,0CgDz+ImB;EhD0+InB,mBgDz+IsB;EAGlB,gBAAA;EhDw+IJ,gBgB/4I2C;EhBg5I3C,cgDv+IM;EhDw+IN,sBgDv+IoB;EhDw+IpB,gGAAuO;EiDx/IzO,yBAAO;EACL,sBAAY;E1C8HR,gBAtCa;APm6InB;;AAEA;EiDx/IE,qBzCklCkC;EyCjlClC,UAAS;E9BKT,iDAAQ;AnBs/IV;;AAEA;EACE,ciDp/IgB;EjDq/IhB,sBAAsB;AiD1+IxB;;AjD6+IA;;EAEE,YAAY;EiDt+Id,sBAAiB;EACf,sBAAoB;AjDw+ItB;;AAEA;EkD5gJE,c1Co4BkC;EDzwB9B,yBAtCqD;AP07I3D;;AAEA;EkD3gJE,a1Cu4BkC;ARsoHpC;;AAEA;EACE,kBQjpHkC;E0Cv3BlC,0BAAU;AlD0gJZ;;AAEA;EACE,kCkDvgJY;EAGZ,oBAAO;ElDsgJP,uBkDrgJe;ElDsgJf,oBAAoB;EkDlgJtB,sBAAc;AlDogJd;;AAEA;EkDlgJE,gC1CmgC2C;E0ClgC3C,mB1C+2BkC;E0C92BlC,sBAAiB;EACjB,kBAAe;E1BZb,qBAAA;AxBihJJ;;AkDjgJA;EACE,kB1C61BwC;ERuqHxC,qBAAqB;EmD1iJvB,WAAY;EAEV,mCAAgB;EAEhB,gBAAA;AnD0iJF;;AAEA;EmDriJA,kBAAO;EACL,UAAU;EACV,WAAM;EACN,mCAAO;EACP,S3C2pBkC;E2C1pBlC,UAAS;AnDuiJX;;AAEA;EmDniJE,qBAAU;EnDqiJV,iDAAiD;AmD9hJnD;;AnDiiJA;;EmD5hJE,yBAAoB;AnD+hJtB;;AAEA;EACE,iBsBtjJI;AtBujJN;;AAEA;EACE,0BQ/nHsC;ARgoHxC;;AAEA;EmDxhJA,kBAAA;EACE,MAAA;EACA,QAAA;EAEA,OAAA;EnDyhJA,UmDxhJE;EnDyhJF,mCmDxhJkB;EAGlB,yBAAA;EnDuhJA,gBAAgB;EAChB,gBmDthJgB;EAGhB,cAAA;EnDqhJA,sBmDphJkB;EnDqhJlB,yBAAyB;EmDjhJ3B,sBAAuB;AnDmhJvB;;AAEA;EmD/gJE,kBAAA;EnDihJA,MmDhhJE;EnDihJF,QmDhhJQ;EnDihJR,SmDhhJQ;EnDihJR,UmDhhJS;EAIT,cAAA;EnD8gJA,6BmD7gJwB;EnD8gJxB,yBmD7gJyB;EnD8gJzB,gBmD7gJc;EnD8gJd,cmD5gJE;EnD6gJF,iBmD5gJgB;EnD6gJhB,yBmD1gJE;EnD2gJF,oBmD1gJiB;EnD2gJjB,kCAAkC;AmDrgJpC;;AnDwgJA;EmDrgJE,WAAA;EACA,cAAW;EAGX,UAAA;EACA,6BnCZ2C;EmCa3C,gBAAe;AnDqgJjB;;AAEA;EACE,aAAa;AmD//If;;AnDkgJA;EmD//IE,oEAAO;AnDigJT;;AAEA;EmD//IE,oEnC7B2C;AhB8hJ7C;;AAEA;EACE,oEQvsHoC;ARwsHtC;;AAEA;EmD5/IE,SAAA;AnD8/IF;;AAEA;EwBnnJI,WAAA;EACA,YAAA;E2BwHF,oBAAO;EnD8/IP,yBQ3sHkF;ER4sHlF,SmD5/IQ;EnD6/IR,mBAAmB;EmDx/IrB,oHAAa;EAAb,4GAAa;EACX,gBAAgB;AnD0/IlB;;AmDp/IA;EACE;IAGA,wBAAc;IAAd,gBAAc;EACd;AnDq/IF;;AAEA;EmDj/IE,yBAAe;AnDm/IjB;;AAEA;EmDj/IE,WAAU;E3BzIR,cAAA;EACA,kBAAA;E2B8IF,eAAA;EnDg/IA,yBmD/+I0C;EnDg/I1C,yBAAyB;EmD3+I3B,mBAAA;AnD6+IA;;AAEA;EmD3+IE,WAAQ;EACR,YAAU;EnD6+IV,yBAAyB;EepnJvB,SAAA;EoC6IF,mBAAc;EnD0+Id,iHQxuHuC;ERwuHvC,4GQxuHuC;ERyuHvC,gBmDz+IU;AnD0+IZ;;AAEA;EACE;IACE,qBgB3iJ+B;IhB2iJ/B,gBgB3iJ+B;EhB4iJjC;AACF;;AAEA;EACE,yBgBhjJiC;AhBijJnC;;AAEA;EACE,WmD/9IqB;EpCvKnB,cAAA;EoC2KF,kBAAA;EnD89IA,emD79IU;EnD89IV,yBQ5vHuC;EO94BrC,yBAAyB;EoCkL3B,mBAAU;AnD29IZ;;AAEA;EoDxsJE,W5C+qBkC;E4C9qBlC,YAAS;EACT,a5Cu1BmC;E6C31BnC,oBpDYiB;EoDVjB,mBAAkB;EAClB,yB7C2R+B;E6C1R/B,SAAA;EACA,mBAAgB;EAChB,gHAAiB;EAAjB,4GAAiB;EACjB,gBAAe;ArD8sJjB;;AAEA;EqD5sJE;IACA,oBAAc;IAAd,gBAAc;EACd;ArD8sJF;;AAEA;EoDltJE,yBAAU;ApDotJZ;;AAEA;EACE,WoDltJU;EpDmtJV,coDltJW;EpDmtJX,kBQv4HuC;ERw4HvC,eQv4HkC;ERw4HlC,6BoDjtJY;EpDktJZ,yBoDjtJsB;EpDktJtB,oBoDjtJe;ApDktJjB;;AAEA;EoD7sJA,yBAAA;EACE,mBAAgC;ApD+sJlC;;AAEA;EACE,kBoD5sJU;EpD6sJV,yBoD5sJkB;EpD6sJlB,mBoD5sJI;ApD6sJN;;AAEA;EoDvsJE,yBAAA;ApDysJF;;AAEA;EACE,eoDvsJE;ApDwsJJ;;AAEA;EACE,yBAAyB;AoDnsJ3B;;ApDssJA;EACE,eoDnsJQ;ApDosJV;;AAEA;EACE,yBgBlqJa;AhBmqJf;;AAEA;;;EAGE,4GQ/6HuC;ARg7HzC;;AAEA;;EAEE;;;IoDvqJA,gB5CyuBuC;E4CxuBvC;ApD2qJF;;AAEA;EwBxwJI,aAAa;ExB0wJf,eAAe;EsD5xJjB,eAAS;EACP,gBAAU;EACV,gBAAM;AtD8xJR;;AAEA;EsD5xJE,c9Cy2BkC;E6C92BlC,oBpDYiB;ADwxJnB;;AAEA;;EqDhyJE,qBAAiB;ArDmyJnB;;AAEA;EqDjyJE,cAAc;EACd,oBAAkB;EAClB,eAAc;ArDmyJhB;;AAEA;EsDtyJE,gCAAqB;AtDwyJvB;;AAEA;EwBpyJI,mBAVW;AxBgzJf;;AAEA;EACE,6BQ57HsC;ER67HtC,+BQ57HuC;ER67HvC,gCsDryJkC;AtDsyJpC;;AAEA;;EAEE,qCsDnyJ6B;AtDoyJ/B;;AsD9xJA;EACE,cAAa;EAEb,6BAAA;EtDgyJA,yBgB1rJiC;AhB2rJnC;;AAEA;;EAEE,csD5xJE;EtD6xJF,yBQ99H+C;ER+9H/C,qCsD5xJoE;AtD6xJtE;;AsDvxJA;EACE,gB9Cs0BkC;E8Cp0BlC,yBAAA;EtDyxJA,0BgBvsJiC;AhBwsJnC;;AAEA;EACE,sBsDvxJE;AtDwxJJ;;AAEA;;EAEE,WQ9+HkC;ER++HlC,yBsDrxJkB;AtDsxJpB;;AsDhxJA;;EAGE,cAAA;EtDkxJA,kBgBvtJiC;AhBwtJnC;;AAEA;;EAEE,asD9wJE;EtD+wJF,YQ3/H+C;ER4/H/C,kBsD9wJkB;AtD+wJpB;;AAEA;EACE,asD1wJQ;AtD2wJV;;AAEA;EACE,csD1wJa;AtD2wJf;;AAEA;EsDvwJA,kBAAA;EACE,aAAY;EAEZ,eAAA;EtDwwJA,mBgB7uJiC;EhB8uJjC,8BQ5/HuC;ER6/HvC,oBQ9/HsC;AR+/HxC;;AAEA;;;;;;EAME,asDpwJI;EtDqwJJ,eAAe;EsD/uJjB,mBAAgB;EACd,8BAA4D;AtDivJ9D;;AAEA;EsD/uJE,qB9CytBkC;E8CxtBlC,yBAAe;E9BnIb,4BAjBW;EAkBX,kBAAA;E8BqIF,qBAAQ;EtDivJR,oBsDhvJe;EtDivJf,mBAAmB;AsD7uJrB;;AtDgvJA;;EuDz4JA,qBAAU;AvD44JV;;AuDx4JA;EACE,aAAY;EvD24JZ,sBAAsB;EuDx4JxB,eAAgB;EACd,gBAAU;EACV,gBAAW;AvD04Jb;;AAEA;EACE,gBwDj6Ja;ExDk6Jb,ewDj6Ja;AxDk6Jf;;AAEA;EuD14JE,gBAAa;EACb,WAAW;AvD44Jb;;AAEA;EsB75JM,qBAAY;EAIZ,mBAAA;EtB45JJ,sBuDp5Ja;AvDq5Jf;;AuD34JA;EvD84JE,gBAAgB;EAChB,YAAY;EuD54JZ,mBAAc;AvD84JhB;;AAEA;EuD34JE,wBAAW;EvD64JX,qBAAqB;EuD14JvB,cAAA;EvD44JE,6BuD34JyB;EACzB,6BAA4B;EvD44J5B,sBAAsB;AuDn4JtB;;AvDs4JF;;EuDh4JE,qBAAA;AvDm4JF;;AAEA;EuDj4JI,qBAAU;EAGZ,YAAA;EvDi4JA,aAAa;EuD/3JX,sBAAU;EACV,WAAU;EjC5DR,mCAAuB;EAIvB,0BAAA;AtB27JN;;AAEA;;EuD33JA;;;;;;IAOE,gBAAa;IACb,eAAa;EACb;AvD63JF;;AAEA;EuD33JE;IjCnFI,qBAAY;IAIZ,2BAAA;EtB88JJ;;EAEA;ImBp9JA,mBAAA;EnBs9JA;;EAEA;IuD/3JE,kBAAiB;EvDi4JnB;;EAEA;IuD93JF,qBAAuB;IACrB,oBAAO;EvDg4JP;;EuD13JA;;;;;;IAWA,iB/C+7BuC;E+C97BvC;;EAEF;IACE,wBvCvEe;IhB+7Jb,gBAAgB;EuDt3JpB;;EvDy3JE;IuD/2JF,aAAA;EACE;AvDi3JF;;AAEA;;EuD92JE;;;;;;IAQA,gBAAA;IACE,eAAY;EvD+2Jd;AACF;;AAEA;EACE;IuD72JE,qBAAmB;IACnB,2BAAe;EvD+2JjB;;EAEA;IuD52JE,mBAAe;EvD82JjB;;EAEA;IACE,kBuD93JF;EvD+3JA;;EAEA;IACE,qBAAqB;IuDt2JzB,oBAAkB;EAChB;;EAEA;;;;;;IAMA,iBAAkB;EvDw2JlB;;EyDtiKA;IAAK,wBAAW;IAGlB,gBAAgB;EACd;;EAEA;IACA,aAAc;EACd;AzDwiKF;;AAEA;;EyDniKA;;;;;;IAWK,gBAAA;IACD,eAAW;EAEb;AzDgiKF;;AyD1hKA;EACE;IACA,qBjDgiC0B;IiD/hC1B,2BjDgiCoC;EiD/hCpC;;EAGA;IACA,mBAAU;EACV;;EAGF;IACE,kBjDyhC4B;EiDxhC5B;;ECpDF;IAAqB,qBAAgB;I1DklKjC,oBAAoB;E0DjlKxB;;E1DolKE;;;;;;IAME,iBAAiB;E0DvlKrB;;E1D0lKE;I0DzlKF,wBAAmB;IAAE,gBAAgB;E1D4lKnC;;E2D7lKE;I3DgmKA,aAAa;EmBtlKf;AnBwlKF;;AAEA;;E2DrmKE;;;;;;IAMI,gBAAkB;I3DwmKpB,eAAe;E2D9mKjB;A3DgnKF;;AmBrmKE;EnBwmKA;IACE,qBmBxmKM;IwCNJ,2BAAkB;E3DgnKtB;;E2DrnKE;I3DwnKA,mBAAmB;EmB9mKrB;;EnBinKA;I2DtnKI,kBAAkB;E3DwnKtB;;E2D7nKE;I3DgoKA,qBAAqB;ImBtnKvB,oBAAA;EnBwnKA;;E2D7nKI;;;;;;I3DqoKF,iBAAiB;EACnB;;EAEA;I2D9oKA,wBAAW;IACT,gBAAkB;E3DgpKpB;;EAEA;IACE,aAAa;E2D9oKX;A3DgpKN;;AAEA;;EmB7oKE;;;;;;IyCHA,gBAAkB;I5DypKhB,eAAe;E4DtpKnB;A5DwpKA;;A6DlqKA;EAAkB;I7DsqKd,qBAAqB;I6DrqKzB,2BAAgB;EAAE;;EAClB;IAAkB,mBAAc;E7D0qK9B;;E6DzqKgB;I7D4qKd,kBAAkB;E6D3qKtB;;E7D8qKE;I6D5qKF,qBAAiB;IAAE,oBAAoB;E7D+qKrC;;E6D9qKiB;;;;;;IAEA,iBAAe;E7DqrKhC;;E6DprKiB;I7DurKf,wBAAwB;I6DprK1B,gBAAkB;EAChB;;EADF;IACE,aAAc;E7DyrKhB;A6D1rKA;;A7D6rKF;E6D7rKE,qBAAkB;EAChB,2BAAc;A7D+rKlB;;AAEA;;;;;;E6DjsKI,gBAAc;E7DwsKhB,eAAe;A6DzsKf;;A7D4sKF;E6DvsKA,mBAAc;A7DysKd;;A6DjsKA;EACE,kBAAe;A7DosKjB;;AAEA;EACE,qBAAqB;E6DhsKvB,oBAAa;A7DksKb;;AAEA;;;;;;E6DzrKE,iBAAA;A7DgsKF;;A6D5rKA;EACE,wBAAwB;EACxB,gBAAA;A7D+rKF;;AAEA;EACE,aAAa;A6D3rKf;;A7D8rKA;E6D1rKA,yBAAc;A7D4rKd;;A6DxrKA;;E7D4rKE,yBAAyB;AwDnwKzB;;AxDswKF;EwDnwKI,yBAAW;AxDqwKf;;AAEA;;E8DhwKM,yBAAsB;A9DmwK5B;;A8DnwKM;EAAwB,yBAAS;A9DuwKvC;;AAEA;;;;EAIE,yBAAyB;A8D7wKrB;;A9DgxKN;E8DhxKM,yBAAsB;EAAE,gCAA0B;A9DmxKxD;;AAEA;EACE,yDAAmR;A8DtxK/Q;;A9DyxKN;EexuKI,yBAAyB;Af0uK7B;;AAEA;E8D7xKM,yBAAsB;A9D+xK5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;E8DtyKM,WAAsB;A9DwyK5B;;AAEA;;EAEE,WAAW;AACb;;AAEA;E8D/yKM,+BAAsB;A9DizK5B;;AAEA;;EelwKI,gCAAyB;AfqwK7B;;AAEA;E8DxzKM,gCAAsB;A9D0zK5B;;AAEA;;;;EAIE,W8Dh0KqC;A9Di0KvC;;AAEA;EACE,+BAA+B;E8Dp0K3B,sCAAsB;A9Ds0K5B;;AAEA;EACE,yD8Dz0KsD;A9D00KxD;;AAEA;EACE,+BAA+B;AACjC;;Ae7xKI;E+CjDE,WAAsB;A9Dk1K5B;;AAEA;;EAEE,WAAW;AACb;;AAEA;E8Dz1KM,kBAAsB;E9D21K1B,a8D31KqC;E9D41KrC,sBAAsB;E8D51KlB,YAAsB;E9D81K1B,qB8D91KqC;E9D+1KrC,sBAAsB;E8D/1KlB,2BAAsB;E9Di2K1B,sC8Dj2KsD;E9Dk2KtD,sBAAsB;AACxB;;AAEA;E8Dr2KM,eAAsB;E9Du2K1B,c8Dv2KqC;A9Dw2KvC;;AAEA;EezzKI,mBAAA;E+CjDE,sBAAsB;A9D62K5B;;AAEA;EACE,mB8Dh3KqC;E9Di3KrC,2CAA2C;E8Dj3KvC,4CAAsB;A9Dm3K5B;;AAEA;EACE,sB8Dt3KqC;E9Du3KrC,+CAA+C;E8Dv3K3C,8CAAsB;A9Dy3K5B;;AAEA;;EAEE,aAAa;AACf;;AAEA;E8Dh4KM,cAAsB;E9Dk4K1B,e8Dl4KqC;E9Dm4KrC,gBAAgB;AAClB;;Aen1KI;E+CjDE,sBAAsB;A9Dw4K5B;;AAEA;EACE,qB8D34KqC;E9D44KrC,gBAAgB;AAClB;;AAEA;E8D/4KM,gBAAsB;A9Di5K5B;;AAEA;EACE,qB8Dp5KqC;A9Dq5KvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;E8D35KM,wBAAsB;E9D65K1B,gB8D75KqC;E9D85KrC,qCAAqC;E8D95KjC,6CAAsB;A9Dg6K5B;;AAEA;EACE,0D8Dv5KiD;A9Dw5KnD;;AAEA;EACE,wBAAwB;E8D35KtB,qCAAmB;E9D65KrB,0C8D75KiD;A9D85KnD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;E8Dp6KI,uBAAmB;E9Ds6KrB,uB8Dt6KgC;E9Du6KhC,sBAAsB;E8Dv6KpB,gBAAA;A9Dy6KJ;;AAEA;EACE,uB8D56KgC;E9D66KhC,sBAAsB;AACxB;;A+Dn8KA;EACE,kBAAkB;EAClB,MAAA;EACA,QAAO;EACP,SAAS;EACT,OAAA;EAEA,gBAAA;E/Dq8KA,kC+Dp8KgB;A/Dq8KlB;;AAEA;;;EAGE,cAAc;EACd,W+Dl8KU;A/Dm8KZ;;AAEA;;EAEE,2C+Dl8Kc;E/Dm8Kd,4C+Dl8KW;A/Dm8Kb;;AAEA;;E+D57KI,+CAAU;EACR,8CAA4F;A/D+7KlG;;AAEA;EACE,mBAAmB;A+Dn8KjB;;A/Ds8KJ;EgE99KI;IAAgC,aAAc;IhEi+K9C,mBAAmB;IgEh+KnB,mBAA8B;IAAE,kBAAgB;EhEm+KlD;;EgEl+KkC;IhEq+KhC,SAAY;IgEp+KZ,kBAA8B;IAAE,gBAAgB;IhEu+KhD,iBAAiB;EgEr+KjB;AhEu+KJ;;AgEt+KI;EAA8B,mBAAW;AhE0+K7C;;AAEA;EACE;IgE3+KE,aAA4B;IAAE,mBAAM;EhE8+KtC;;EgE7+KgC;IhEg/K9B,SAAY;IgE/+KZ,gBAA4B;EAAE;;EAC9B;IAA8B,cAAa;IhEo/K3C,cAAc;EgEn/Kd;;EhEs/KF;IgEp/KE,0BAAkC;IAAE,6BAAiB;EhEu/KvD;;EgEt/KsC;;IACpC,0BAAkC;EAAE;;EACpC;;IhE6/KA,6BAA6B;EgE5/K7B;;EhE+/KF;IgE7/KE,yBAA+B;IAAE,4BAAa;EhEggLhD;;EgE//KmC;;IACjC,yBAA+B;EAAE;;EACjC;;IhEsgLA,4BAA4B;EgErgL5B;AhEugLJ;;AgErgLI;EAAkC,sBAAe;AhEygLrD;;AAEA;EACE;IgE1gLE,eAAA;IAAkC,mBAAe;IhE6gLjD,UAAU;IgE5gLV,SAAA;EAAkC;;EAClC;IAAkC,qBAAe;IhEihLjD,WAAW;EgEhhLX;AhEkhLJ;;AgEhhLI;EAAgC,qBAAY;AhEohLhD;;AAEA;EACE,gBAAgB;AgErhLd;;AhEwhLJ;EgEvhLI,gBAA8B;EAAE,6BAA6B;EhE0hL/D,4BAA4B;AgEzhL1B;;AhE4hLJ;EgE3hLI,yBAA8B;EAAE,0BAAY;AhE8hLhD;;AAEA;EACE,gBgEvkLgD;EhEwkLhD,mBAAmB;AACrB;;AAEA;EgEzkLI,aAAA;EhE2kLF,egE3kLkC;EhE4kLlC,qBAAqB;EgE3kLnB,mBAAA;EhE6kLF,gBgE7kLgD;EhE8kLhD,yBAAyB;EgE5kLvB,sBAA4B;AhE8kLhC;;AAEA;EACE,agEhlL2C;AhEilL7C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EgEplLI,qBAA4B;EhEslL9B,qBgEtlL2C;EhEulL3C,cAAc;EgEtlLZ,YAAA;AhEwlLJ;;AAEA;EACE,0BgE1lL6C;AhE2lL/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EgE7lLI,cAAA;AhE+lLJ;;AAEA;EACE,agEjmLsC;EhEkmLtC,eAAe;EgEjmLb,gBAAA;EhEmmLF,sBgEnmLuD;AhEomLzD;;AAEA;EACE,kBAAkB;EgEpmLhB,cAAA;EhEsmLF,uBgEtmLgD;EhEumLhD,iBAAiB;EgEtmLf,iBAAA;EhEwmLF,cgExmL8C;EhEymL9C,sBAAsB;EgExmLpB,yBAA+B;AhE0mLnC;;AAEA;EACE,UgE5mLmC;EhE6mLnC,cAAc;EgE5mLZ,qBAAA;EhE8mLF,yBgE9mLgD;EhE+mLhD,qBAAqB;AACvB;;AAEA;EgE/mLI,UAAA;EhEinLF,UgEjnLoC;EhEknLpC,iDAAiD;AACnD;;AAEA;EgEnnLI,cAAA;EhEqnLF,+BgErnLmD;EhEsnLnD,kCAAkC;AACpC;;AAEA;EgEvnLI,gCAAgC;EhEynLlC,mCgEznLqE;AhE0nLvE;;AAEA;EACE,UAAU;EgE1nLR,WAAA;EhE4nLF,yBgE5nL8C;EhE6nL9C,qBAAqB;AACvB;;AAEA;EgE9nLI,cAAA;EhEgoLF,oBgEhoL8C;EhEioL9C,YAAY;EgEhoLV,sBAAA;EhEkoLF,qBgEloL8C;AhEmoLhD;;AAEA;EexnLI,uBAAyB;EiDlDzB,qBAA8B;EhE6qLhC,gBgE7qLgD;AhE8qLlD;;AAEA;EACE,8BAA8B;EgE/qL5B,iCAA8B;AhEirLlC;;AAEA;EACE,+BgEnrLkD;EhEorLlD,kCAAkC;AACpC;;AAEA;EgEprLI,uBAA4B;EhEsrL9B,sBgEtrL2C;EhEurL3C,gBAAgB;AAClB;;AAEA;EgExrLI,8BAA4B;EhE0rL9B,iCgE1rLyD;AhE2rL3D;;AAEA;EACE,+BAA+B;EgE5rL7B,kCAA4B;AhE8rLhC;;AAEA;EACE,qBgEhsL6C;EhEisL7C,qBAAqB;EgEhsLnB,cAAA;EhEksLF,gBgElsL6C;EhEmsL7C,cAAc;EgEjsLZ,kBAAA;EhEmsLF,mBgEnsLuD;EhEosLvD,wBAAwB;EgEnsLtB,sBAAA;EhEqsLF,qIgErsL0E;AhEssL5E;;AAEA;EACE;IgEvsLE,gBAAA;EhEysLF;AACF;;AAEA;;EgEzsLI,qBAA+B;AhE4sLnC;;AAEA;EACE,agE9sL8C;AhE+sLhD;;AAEA;EACE,kBAAkB;EgEhtLhB,SAAA;AhEktLJ;;AAEA;EACE,oBgEptLgD;EhEqtLhD,mBAAmB;EgEntLjB,oBAAA;AhEqtLJ;;AAEA;EACE,WgEvtLoC;EhEwtLpC,yBAAyB;AAC3B;;AAEA;;EAEE,WgE3tLoC;EhE4tLpC,yBAAyB;AAC3B;;AAEA;;EAEE,UgE/tLoC;EhEguLpC,gDAAgD;AAClD;;AAEA;EgEhuLI,WAAA;EhEkuLF,yBgEluL8C;AhEmuLhD;;AAEA;;EgEnuLI,WAAA;EhEsuLF,yBgEtuL8C;AhEuuLhD;;AAEA;;EgEvuLI,UAAA;EhE0uLF,gDgE1uLgE;AjDY9D;;AfiuLJ;EACE,WAAW;EgEnxLT,yBAA8B;AhEqxLlC;;AAEA;;EAEE,WAAW;EgEvxLT,yBAA8B;AhEyxLlC;;AAEA;;EAEE,UAAU;EgE1xLR,+CAA4B;AhE4xLhC;;AAEA;EACE,WgE9xLyC;EhE+xLzC,yBAAyB;AAC3B;;AAEA;;EAEE,WgElyLyC;EhEmyLzC,yBAAyB;AAC3B;;AAEA;;EAEE,UgEtyLgC;EhEuyLhC,+CAA+C;AACjD;;AAEA;EgEvyLI,cAAA;EhEyyLF,yBgEzyLuD;AhE0yLzD;;AAEA;;EgE1yLI,cAAA;EhE6yLF,yBgE7yLuD;AhE8yLzD;;AAEA;;EgE9yLI,UAAA;EhEizLF,gDgEjzL8E;AhEkzLhF;;AAEA;EACE,WAAW;EgElzLT,yBAA+B;AhEozLnC;;AAEA;;EAEE,WAAW;EgEtzLT,yBAA+B;AhEwzLnC;;AAEA;;EAEE,UAAU;EgEzzLR,gDAAgC;AhE2zLpC;;AAEA;EACE,cgE7zLoC;EhE8zLpC,yBAAyB;AAC3B;;AAEA;;EAEE,cgEj0LoC;EhEk0LpC,yBAAyB;AAC3B;;AAEA;;EAEE,UgEr0LoC;EhEs0LpC,iDAAiD;AACnD;;AAEA;EgEt0LI,cAAA;EhEw0LF,yBgEx0L8C;AhEy0LhD;;AAEA;;EgEz0LI,cAAA;EhE40LF,yBgE50L8C;AhE60LhD;;AAEA;;EgE70LI,UAAA;EhEg1LF,iDgEh1LgE;AjDY9D;;Afu0LJ;EACE,kBAAkB;EgEz3LhB,mBAA8B;EhE23LhC,yBgE33LkD;EhE43LlD,qBAAqB;AACvB;;AAEA;EgE73LI;IAAgC,kBAAgB;EhEg4LlD;AACF;;AAEA;EgEh4LI,gBAA4B;EhEk4L9B,egEl4L2C;EhEm4L3C,gBAAgB;AAClB;;AAEA;EgEp4LI,kBAA4B;EhEs4L9B,wBgEt4LsC;EhEu4LtC,mBAAmB;EgEt4LjB,6BAA4B;EhEw4L9B,sBgEx4L2C;AhEy4L7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EgE54LI,gBAAA;AhE84LJ;;AAEA;EACE,wBgE/4LuD;AhEg5LzD;;AAEA;EACE,kBAAkB;EgEj5LhB,MAAA;EhEm5LF,QgEn5LsC;EhEo5LtC,UAAU;EgEn5LR,wBAAA;EhEq5LF,cgEr5LsC;AhEs5LxC;;AAEA;EACE,cAAc;EgEt5LZ,yBAA+B;EhEw5LjC,qBgEx5LgD;AhEy5LlD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EgE55LI,cAAA;AhE85LJ;;AAEA;EACE,cgEh6L8C;EhEi6L9C,yBAAyB;EgE/5LvB,qBAAA;AhEi6LJ;;AAEA;EACE,yBgEn6LmD;AhEo6LrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EgEv6LI,cAAA;EhEy6LF,yBgEz6LmD;EhE06LnD,qBAAqB;AACvB;;AAEA;EgE16LI,yBAA8B;AhE46LlC;;AAEA;EACE,cgE96L8C;AhE+6LhD;;AAEA;EACE,cAAc;EgEh7LZ,yBAA8B;EhEk7LhC,qBgEl7L8C;AhEm7LhD;;AAEA;EACE,yBAAyB;AAC3B;;Aez6LI;EiDlDA,cAA8B;AhE+9LlC;;AAEA;EACE,cgEj+LkC;EhEk+LlC,yBAAyB;EgEj+LvB,qBAA8B;AhEm+LlC;;AAEA;EACE,yBgEr+LkD;AhEs+LpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EgEx+LI,cAAA;EhE0+LF,yBgE1+L2C;EhE2+L3C,qBAAqB;AACvB;;AAEA;EgE5+LI,yBAA4B;AhE8+LhC;;AAEA;EACE,cgEh/L2C;AhEi/L7C;;AAEA;EACE,cAAc;EgEl/LZ,yBAA4B;EhEo/L9B,qBgEp/L6C;AhEq/L/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EgEv/LI,cAAA;AhEy/LJ;;AAEA;EACE,cgE3/LsC;EhE4/LtC,yBAAyB;EgE3/LvB,qBAAA;AhE6/LJ;;AAEA;EACE,2BgE9/LgD;AhE+/LlD;;AAEA;EACE,cAAc;AAChB;;AAEA;EgElgMI;IAAiC,2BAAa;EhEqgMhD;;EAEA;IACE,wBAAwB;EgErgMxB;AhEugMJ;;AAEA;EACE,agEzgMoC;EhE0gMpC,YAAY;EgEzgMV,gBAAA;EhE2gMF,cgE3gMoC;EhE4gMpC,qBAAqB;EgE3gMnB,yBAAA;EhE6gMF,sBgE7gMmD;AhE8gMrD;;AAEA;EACE,aAAa;EgE/gMX,sBAAA;EhEihMF,uBgEjhMmD;EhEkhMnD,gBAAgB;EgEhhMd,WAAA;EhEkhMF,kBgElhM8C;EhEmhM9C,mBAAmB;EgElhMjB,yBAA8B;EhEohMhC,2BgEphM8C;AhEqhMhD;;AAEA;EACE;IgEthME,gBAAA;EhEwhMF;AACF;;AAEA;EACE,qMAAqM;EgE1hMnM,0BAA8B;AhE4hMlC;;AAEA;EACE,kDAAkD;AiExkMhD;;AjE2kMJ;EiE1kMI;IAAwB,eAAO;EjE6kMjC;AezhME;;Af4hMJ;EACE,aAAa;EiEllMX,uBAAsB;AjEolM1B;;AAEA;EACE,SiEtlM+B;AlDoD7B;;AfqiMJ;EACE,aAAa;EiE3lMX,sBAAsB;EjE6lMxB,eiE7lMiC;EjE8lMjC,gBAAgB;EiE7lMd,sBAAsB;AjE+lM1B;;AAEA;EACE,WiEpmMiC;EjEqmMjC,cAAc;EiEpmMZ,mBAAsB;AjEsmM1B;;AAEA;;EenjMI,UAAA;EkDtDA,cAAsB;EjE6mMxB,qBiE7mMiC;EjE8mMjC,yBAAyB;AAC3B;;AAEA;EiE/mMI,cAAsB;EjEinMxB,yBiEjnMgD;AlDoD9C;;AfgkMJ;EACE,kBAAkB;EiEtnMhB,cAAA;EjEwnMF,wBiExnMiC;EjEynMjC,sBAAsB;EiExnMpB,sCAAsB;AjE0nM1B;;AAEA;EACE,+BAA+B;EkEloM/B,gCAAuB;AlEooMzB;;AkEpoME;EAAyB,mCAA8B;ElEwoMvD,kCAAkC;AmExoMlC;;AnE2oMF;;EmE3oMwB,cAAU;EnE8oMhC,oBAAoB;EoE7oMpB,sBAAuB;ApE+oMzB;;AoE/oME;EAAyB,UAAU;EpEmpMnC,WAAW;EoEnpMX,yBAAuB;EAAE,qBAAU;ApEspMrC;;AAEA;EACE,mBAAmB;AoEzpMnB;;ApE4pMF;EoEvpMA,gBAAW;EACT,qBAAe;ApEypMjB;;AAEA;EoEvpME,mB5DgqBsC;ARy/KxC;;AAEA;EoEtpME,kCAAQ;EACR,0BAAS;ApEwpMX;;AAEA;EoEppME,gCAIC;EALH,4BAAY;ApEwpMZ;;AAEA;EACE,aAAa;AqEhrMf;;ArEmrMA;EsE/qME,qBAAW;EACX,oBAAU;AtEirMZ;;AAEA;EsE/qME,iBAAa;EACb,sBAAS;AtEirMX;;AAEA;EsEtqMI;IACA,mBAAY;EACZ;;EAEA;ItEwqMA,kCAAkC;IuErsMtC,0BAAW;EAAE;;EACb;IAAU,gCAAY;IvE0sMlB,4BAA4B;EuEzsMhC;;EvE4sME;IuE3sMF,aAAa;EAAE;;ECCX;IAAuB,qBAA4B;IxEgtMnD,oBAAoB;EwEhtMpB;;ExEmtMF;IwEntME,iBAAqB;IAAE,sBAA4B;ExEstMrD;AwEttME;;AxEytMJ;EwEztMI;IAAuB,mBAAU;ExE4tMnC;;EwE5tMyB;IxE+tMvB,kCAAkC;IwE/tMlC,0BAAqB;EAAE;;EAAvB;IAAuB,gCAA4B;IxEquMnD,4BAA4B;EwEruM5B;;ExEwuMF;IwExuME,aAAqB;EAAE;;EAI3B;IAAU,qBAAW;IxE0uMjB,oBAAoB;EwEzuMxB;;ExE4uME;IwExuMF,iBAAY;IAAE,sBAAW;ExE2uMvB;AwE1uMF;;AxE6uMA;EwE3uMA;IAAU,mBAAO;ExE8uMf;;EwE7uMQ;IxEgvMN,kCAAkC;IyEzvMA,0BAAA;EAAE;;EAChC;IzE6vMJ,gCyE5vMmC;IAC7B,4BAAgC;EzE6vMxC;;EAEA;IyE3vMQ,aAAgB;EzE6vMxB;;EAEA;IyE3vMQ,qBAAiB;IzE6vMvB,oBAAoB;EyE3vMhB;;EAEE;IzE6vMN,iBAAiB;IyE5wMiB,sBAAA;EAAE;AzE+wMxC;;AAEA;EyE9wMU;IzEgxMN,mBAAmB;EyE9wMf;;EAEE;IzEgxMN,kCAAkC;IyE9wM9B,0BAAA;EzEgxMN;;EAEA;IyE9wMM,gCAAA;IzEgxMJ,4ByE/wMmC;EAC7B;;EAfF;IAAgC,aAAU;EzEkyMhD;;EAEA;IyEjyMQ,qBAAc;IzEmyMpB,oBAAoB;EyEjyMhB;;EAEE;IzEmyMN,iBAAiB;IyEjyMb,sBAAA;EzEmyMN;AACF;;AyEhyMQ;EzEmyMN;IyEjyMQ,mBAAe;EzEmyMvB;;EyElzMsC;IzEqzMpC,kCAAkC;IyEpzM9B,0BAAA;EzEszMN;;EAEA;IyEpzMM,gCAAA;IzEszMJ,4ByErzMmC;EAC7B;;EAEF;IzEszMJ,ayErzMmC;EAC7B;;EAEF;IzEszMJ,qByErzMmC;IAC7B,oBAAe;EzEszMvB;;EyEr0MsC;IzEw0MpC,iBAAiB;IyEv0Mb,sBAAA;EzEy0MN;AACF;;AyEt0MQ;EzEy0MN,gByEx0MqC;AzEy0MvC;;AyEt0MQ;EzEy0MN,qByEx0MqC;AzEy0MvC;;AyEt0MQ;EzEy0MN,sByEx0MqC;AzEy0MvC;;AyEv1MQ;EAAgC,cAAU;EzE21MhD,yBAAyB;AyE11MnB;;AzE61MR;;EyEz1MQ,cAAA;EzE41MN,yByE31MqC;AzE41MvC;;AyEz1MQ;EzE41MN,WyE31MqC;EAC7B,yBAAiB;EzE41MzB,qBAAqB;AyE11Mf;;AzE61MR;EACE,cAAc;EyE32MR,yBAA8B;AzE62MtC;;AyE52MQ;;EAEE,cAAc;EzE+2MtB,yBAAyB;AyE72MnB;;AzEg3MR;EACE,WAAW;EyE72ML,yBAAA;EzE+2MN,qByE92MqC;AzE+2MvC;;AyE52MQ;EzE+2MN,cyE92MqC;EAC7B,yBAAe;AzE+2MzB;;AAEA;;EyE/3MQ,cAAA;EzEk4MN,yByEj4MqC;AzEk4MvC;;AyE/3MQ;EzEk4MN,WyEj4MqC;EAC7B,yBAAgB;EzEk4MxB,qBAAqB;AyEh4Mf;;AzEm4MR;EACE,cAAc;EyEh4MR,yBAAA;AzEk4MR;;AAEA;;EyEj5MwC,cAAU;EzEo5MhD,yBAAyB;AyEn5MnB;;AzEs5MR;EACE,WAAW;EyEn5ML,yBAAA;EzEq5MN,qByEp5MqC;AzEq5MvC;;AyEl5MQ;EzEq5MN,cyEp5MqC;EAC7B,yBAAiB;AzEq5M3B;;AAEA;;EAEE,cAAc;EyEp6MR,yBAA8B;AzEs6MtC;;AyEr6MQ;EzEw6MN,WyEv6MqC;EAC7B,yBAAc;EzEw6MtB,qBAAqB;AyEt6Mf;;AzEy6MR;EACE,cAAc;EyEt6MR,yBAAA;AzEw6MR;;AAEA;;EAEE,cyEv6MqC;EAC7B,yBAAe;AzEw6MzB;;AAEA;EACE,WAAW;EyEz7ML,yBAAA;EzE27MN,qByE17MqC;AzE27MvC;;AyEx7MQ;EzE27MN,cyE17MqC;EAC7B,yBAAgB;AzE27M1B;;AAEA;;EAEE,cAAc;EyEz7MR,yBAAA;AzE27MR;;AAEA;EyE18MQ,WAA8B;EAAE,yBAA4B;EzE68MlE,qBAAqB;AyE58Mf;;AzE+8MR;EACE,cAAc;EyE58MR,yBAAA;AzE88MR;;AAEA;;EAEE,cyE78MqC;EAC7B,2BAAiB;AzE88M3B;;AAEA;EyE58MU,WAAA;EzE88MR,yBAAyB;EyEt8MnB,qBAAsB;AzEw8M9B;;AyEv8MQ;EzE08MN,YyEz8M6B;EACrB,oBAAY;EzE08MpB,gBAAgB;EyEx8MV,cAAA;EzE08MN,WyEz8M6B;EACrB,yBAAc;EzE08MtB,WAAW;AyEx8ML;;AzE28MR;EACE,WAAW;EyEx8ML,qBAAA;AzE08MR;;AAEA;;EyEz9MgC,YAAQ;AzE49MxC;;AAEA;EyE39MU,UAAU;EzE69MlB,6BAA6B;EyE39MvB,SAAA;AzE69MR;;AAEA;EyE39MQ,oBAAA;AzE69MR;;AAEA;EyE39MQ,iBAAA;EzE69MN,gByE59M6B;EACrB,mBAAa;EzE69MrB,2CAA2C;EyE5+MrC,4BAAsB;EAAE,oCAA2B;EzE++MzD,gDAAgD;EyE9+M1C,UAAA;EzEg/MN,sByE/+M6B;AzEg/M/B;;AyE7+MQ;EzEg/MN,sByE/+M6B;AzEg/M/B;;AyE7+MQ;EzEg/MN,UyE/+M6B;AzEg/M/B;;AyE7+MQ;EzEg/MN,cyE/+M6B;EACrB,UAAA;AzEg/MV;;AAEA;EACE,aAAa;AyEjgNP;;AzEogNR;EACE,aAAa;EyEjgNP,mBAAA;EzEmgNN,wByElgN6B;EACrB,cAAc;EzEmgNtB,2CAA2C;EyEjgNrC,4BAAA;EzEmgNN,4CyElgN6B;EACrB,2CAAkC;EzEmgN1C,4CAA4C;AyEjgNtC;;AzEogNR;EACE,gBAAgB;AyElhNV;;AzEqhNR;EyEphNQ,gBAAA;AzEshNR;;AAEA;EyEphNQ,kBAAA;EzEshNN,gByErhN6B;AzEshN/B;;AyEnhNQ;EzEshNN,eyErhN6B;EACrB,MAAA;EzEshNR,OAAO;EyEphND,aAAA;EzEshNN,ayErhN6B;EACrB,WAAW;EzEshNnB,YAAY;EyEhhNV,gBAAiB;EAAE,UAAQ;AzEmhN/B;;AAEA;EyElhNM,kBAAY;EzEohNhB,WAAW;EyElhNT,cAAA;EzEohNF,oByEnhNoB;AzEohNtB;;AyEjhNI;EzEohNF,mCyEnhNoB;EAChB,8BAA8B;AzEohNpC;;AAEA;EyElhNM;IzEohNF,gBAAgB;Ee7hNhB;Af+hNJ;;AAEA;EyEllNQ,eAAA;AzEolNR;;AAEA;EyEllNQ,sBAAA;AzEolNR;;AAEA;EyEllNQ,aAAA;EzEolNN,6ByEnlNqC;AzEolNvC;;AAEA;EACE,8ByEnlNqC;EzEolNrC,gByEnlNuB;AzEolNzB;;AAEA;;EyEpmNQ,cAAA;AzEumNR;;AAEA;EyErmNQ,gBAAA;AzEumNR;;AAEA;EyErmNQ,aAAA;EzEumNN,mByEtmNqC;EzEumNrC,6ByEtmNyB;AzEumN3B;;AAEA;EACE,cyEtmNqB;EzEumNrB,0BAA0B;EyEtnNpB,mBAA8B;EzEwnNpC,WyExnNgD;AzEynNlD;;AAEA;EACE,sByEznNsB;EzE0nNtB,uBAAuB;EyExnNjB,YAAA;AzE0nNR;;AAEA;EyExnNQ,gBAAA;AzE0nNR;;AAEA;EyExnNQ,aAAA;AzE0nNR;;AAEA;EyEzoNQ,kBAA8B;EzE2oNpC,ayE3oNgD;EzE4oNhD,sBAAsB;EyE3oNhB,WAAA;EzE6oNN,oByE5oNqC;EzE6oNrC,sByE5oNsB;EzE6oNtB,4BAA4B;EyE3oNtB,oCAAA;EzE6oNN,qByE5oNqC;EzE6oNrC,UyE5oNQ;AzE6oNV;;AAEA;EACE,eyE5oNuB;EzE6oNvB,MAAM;EyE3oNA,OAAA;EzE6oNN,ayE5oNqC;EzE6oNrC,YyE5oNQ;EzE6oNR,aAAa;EyE5pNP,sBAA8B;AzE8pNtC;;AAEA;EACE,UyE/pNqC;AzEgqNvC;;AAEA;EACE,YyE/pNqC;AzEgqNvC;;AAEA;EACE,ayE/pNqC;EzEgqNrC,uByE/pNyB;EzEgqNzB,8BAA8B;EyE9pNxB,kBAAA;EzEgqNN,gCyE/pNqC;EzEgqNrC,0CyE/pNyC;EzEgqNzC,2CAA2C;AAC7C;;AAEA;EyEjrNQ,kBAAA;EzEmrNN,8ByElrNqC;AzEmrNvC;;AAEA;EACE,gByElrNqC;EzEmrNrC,gByElrNwB;AzEmrN1B;;AAEA;EACE,kByElrNyB;EzEmrNzB,cAAc;EyEjrNR,aAAA;AzEmrNR;;AAEA;EyElsNQ,aAA8B;EzEosNpC,eyEpsNgD;EzEqsNhD,mBAAmB;EyEpsNb,yBAAA;EzEssNN,gByErsNqC;EzEssNrC,6ByErsNwC;EzEssNxC,8CAA8C;EyEpsNxC,6CAAA;AzEssNR;;AAEA;EyEpsNQ,eAAA;AzEssNR;;AAEA;EyEpsNQ,kBAAA;EzEssNN,YyErsNqC;EzEssNrC,WyErsNQ;EzEssNR,YAAY;EyErtNN,gBAA8B;AzEutNtC;;AAEA;EACE;IyEvtNQ,gBAAc;IzEytNpB,oBAAoB;EyEvtNhB;;EzE0tNN;IACE,+BAA+B;EyEvtN3B;;EzE0tNN;IACE,gCAAgC;EyEvtN5B;;EzE0tNN;IACE,+BAA+B;EyExuN3B;;EzE2uNN;IyE1uNM,4BAAA;IzE4uNJ,mByE3uNmC;EzE4uNrC;;EyEzuNM;IzE4uNJ,gByE3uNmC;EzE4uNrC;AACF;;AAEA;;EAEE;;IAEE,gByE3uNmC;EzE4uNrC;AACF;;AAEA;EACE;IyE7vNM,iBAAA;EzE+vNN;AACF;;AAEA;EACE,kByE9vNqC;EzE+vNrC,ayE9vNQ;EzE+vNR,cAAc;EyE7vNR,SAAA;EzE+vNN,iCyE9vNqC;EzE+vNrC,kByE9vNyB;EzE+vNzB,gBAAgB;EyE7vNV,gBAAA;EzE+vNN,gByE9vNqC;EzE+vNrC,iByE9vNuB;EzE+vNvB,qBAAqB;EyE9wNf,iBAA8B;EzEgxNpC,oByEhxNgD;EzEixNhD,sBAAsB;EyEhxNhB,kBAAA;EzEkxNN,oByEjxNqC;EzEkxNrC,mByEjxNsB;EzEkxNtB,gBAAgB;EyEhxNV,sBAAA;EzEkxNN,qByEjxNqC;EzEkxNrC,UyEjxNQ;AzEkxNV;;AAEA;EACE,YyEjxNQ;AzEkxNV;;AAEA;EACE,kByEjxNuB;EzEkxNvB,cAAc;EyEjyNR,aAA8B;EzEmyNpC,cyEnyNgD;AzEoyNlD;;AAEA;EACE,kByEpyNsB;EzEqyNtB,WAAW;EyEnyNL,yBAAA;EzEqyNN,mByEpyNqC;AzEqyNvC;;AAEA;;EAEE,iByEpyNuB;AzEqyNzB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,MAAM;EACN,6ByEhyNoB;EzEiyNpB,sBAAsB;AACxB;;AAEA;;EyE9xNQ,iBAAA;AzEiyNR;;AAEA;;EAEE,OAAO;EACP,ayEhyNmB;EzEiyNnB,cAAc;AAChB;;AAEA;;EAEE,QAAQ;EACR,oCyEnzNuC;EzEozNvC,wBAAwB;AAC1B;;AAEA;;EyEjzNQ,iBAAA;AzEozNR;;AAEA;;EAEE,MAAM;AACR;;AAEA;;EAEE,SAAS;EyEr0NH,6BAAA;EzEu0NN,yByEt0N6B;AzEu0N/B;;AAEA;;EAEE,iByEt0NsB;AzEu0NxB;;AAEA;;EAEE,QAAQ;EyEr0NF,aAAA;EzEu0NN,cyEt0N6B;AzEu0N/B;;AAEA;;EAEE,OAAO;EyEx1ND,oCAAA;EzE01NN,uByEz1N6B;AzE01N/B;;AAEA;EACE,gByEz1N6B;EzE01N7B,uByEz1NsB;EzE01NtB,WAAW;EyEx1NL,kBAAA;EzE01NN,sByEz1N6B;EzE01N7B,sByEz1NuB;AzE01NzB;;AAEA;EACE,kByEz1NqB;EzE01NrB,MAAM;EyEz2NA,OAAA;EzE22NN,ayE32NsC;EzE42NtC,cAAc;EyE32NR,gBAAA;EzE62NN,iCyE52N6B;EzE62N7B,kByE52NoB;EzE62NpB,gBAAgB;EyE32NV,gBAAA;EzE62NN,gByE52N6B;EzE62N7B,iByE52NsB;EzE62NtB,qBAAqB;EyE32Nf,iBAAA;EzE62NN,oByE52N6B;EzE62N7B,sByE52NuB;EzE62NvB,kBAAkB;EyE32NZ,oBAAA;EzE62NN,mByE52N6B;EzE62N7B,gByE52NqB;EzE62NrB,sBAAsB;EyEv2NpB,qBAAiB;EzEy2NnB,sByEz2N6B;EzE02N7B,4BAA4B;EyEz2N1B,oCAAA;EzE22NF,qByE12NoB;AzE22NtB;;AAEA;EACE,kByE12NoB;EzE22NpB,cyE12NgB;EzE22NhB,WAAW;EyEz2NT,cAAA;EzE22NF,gByE12NoB;AzE22NtB;;AAEA;;EAEE,kByE12NiB;E1DTf,cAAA;E0DlDI,WAA8B;EzEw6NpC,yByEx6NkE;EzEy6NlE,mBAAmB;AACrB;;AAEA;;EyEv6NQ,qBAAA;AzE06NR;;AAEA;;EAEE,2ByEz6NqC;AzE06NvC;;AAEA;;EAEE,SyEz6NQ;EzE06NR,6BAA6B;EyEz7NvB,qCAA8B;AzE27NtC;;AAEA;;EAEE,WyE57NQ;EzE67NR,6BAA6B;EyE37NvB,sBAAA;AzE67NR;;AAEA;;EAEE,mByE57NqC;AzE67NvC;;AAEA;;EAEE,yByE57NuB;EzE67NvB,aAAa;EyE58NP,YAA8B;EzE88NpC,gByE98NgD;AzE+8NlD;;AAEA;;EAEE,OAAO;EyE98ND,oCAAA;EzEg9NN,uCyE/8NqC;AzEg9NvC;;AAEA;;EAEE,SyE/8NQ;EzEg9NR,oCAAoC;EyE98N9B,wBAAA;AzEg9NR;;AAEA;;EAEE,kByEj+NgD;AzEk+NlD;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EyEh+NQ,MAAA;EzEm+NN,oCyEl+NqC;EzEm+NrC,wCyEl+N2C;AzEm+N7C;;AAEA;;EAEE,QAAQ;EyEl/NF,oCAA8B;EzEo/NpC,yByEp/NgD;AzEq/NlD;;AAEA;;EAEE,kBAAkB;EyEp/NZ,MAAA;EzEs/NN,SyEr/NqC;EzEs/NrC,cyEr/NsB;EzEs/NtB,WAAW;EyEp/NL,oBAAA;EzEs/NN,WyEr/NqC;EzEs/NrC,gCyEr/NyB;AzEs/N3B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,0ByExgOqC;EzEygOrC,ayExgOoB;EzEygOpB,YAAY;EyEvgON,gBAAA;AzEygOR;;AAEA;;EAEE,QyExgOqC;EzEygOrC,oCyExgO2C;EzEygO3C,sCAAsC;AACxC;;AAEA;;EyEvhOQ,UAA8B;EzE0hOpC,oCyE1hOkE;EzE2hOlE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EyE1hOjB,gBAAA;EzE4hON,mByE3hOqC;EzE4hOrC,cyE3hOQ;EzE4hOR,yBAAyB;EyE1hOnB,gCAAA;EzE4hON,0CyE3hOqC;EzE4hOrC,2CyE3hO2C;AzE4hO7C;;AAEA;EACE,ayE3hOQ;AzE4hOV;;AAEA;EACE,uBAAuB;EyE7iOjB,cAAA;AzE+iOR;;AAEA;EyE7iOQ,kBAAA;AzE+iOR;;AAEA;EyE7iOQ,mBAAA;AzE+iOR;;AAEA;EyE7iOQ,kBAAA;EzE+iON,WyE9iOqC;EzE+iOrC,gByE9iOuB;AzE+iOzB;;AAEA;EACE,cAAc;EyEhkOR,WAAA;EzEkkON,WyEjkOqC;AzEkkOvC;;AAEA;EACE,kByEjkOqC;EzEkkOrC,ayEjkOQ;EzEkkOR,WAAW;EyEhkOL,WAAA;EzEkkON,mByEjkOqC;EzEkkOrC,2ByEjkOyB;EzEkkOzB,sCAAsC;AACxC;;AAEA;EACE;IyEjlOM,gBAA8B;EzEmlOpC;AACF;;AAEA;;;EyEjlOQ,cAAA;AzEqlOR;;AAEA;;EAEE,2ByEplOqC;AzEqlOvC;;AAEA;;EAEE,4ByEplOuB;AzEqlOzB;;AAEA;EACE,UAAU;EyEtmOJ,4BAAA;EzEwmON,eyEvmOqC;AzEwmOvC;;AAEA;;;EAGE,UAAU;EyEtmOJ,UAAA;AzEwmOR;;AAEA;;EAEE,UyEvmOqC;EzEwmOrC,UyEvmOQ;EzEwmOR,2BAA2B;AAC7B;;AAEA;;EAEE;;IAEE,gBAAgB;EyEznOZ;AzE2nOR;;AAEA;;EAEE,kByE1nOqC;EzE2nOrC,MyE1nOQ;EzE2nOR,SAAS;EyEznOH,UAAA;EzE2nON,ayE1nOqC;EzE2nOrC,mByE1nOuB;EzE2nOvB,uBAAuB;EyEnnOjB,UAAsB;EzEqnO5B,WyErnOsC;EzEsnOtC,kBAAkB;EyErnOZ,YAAA;EzEunON,8ByEtnO6B;AzEunO/B;;AAEA;;EAEE;;IyEpnOM,gBAAA;EzEunON;AACF;;AAEA;;;;EyEnoOQ,WAAsB;EzEwoO5B,qByExoOsC;EzEyoOtC,UAAU;EyExoOJ,YAAA;AzE0oOR;;AAEA;EyExoOQ,OAAA;AzE0oOR;;AAEA;EyExoOQ,QAAA;AzE0oOR;;AAEA;;EAEE,qByEzoO6B;EzE0oO7B,WyEzoOQ;EzE0oOR,YAAY;EyEzpON,qCAAsB;AzE2pO9B;;AAEA;EACE,yDyE5pO6B;AzE6pO/B;;AAEA;EACE,yDyE5pO6B;AzE6pO/B;;AAEA;EACE,kByE5pO6B;EzE6pO7B,QyE5pOQ;EzE6pOR,SAAS;EyE3pOH,OAAA;EzE6pON,WyE5pO6B;EzE6pO7B,ayE5pOmB;EzE6pOnB,uBAAuB;EyE5qOjB,eAAsB;EzE8qO5B,iByE9qOsC;EzE+qOtC,gBAAgB;EyE9qOV,gBAAA;AzEgrOR;;AAEA;EyE9qOQ,uBAAA;EzEgrON,cyE/qO6B;EzEgrO7B,WyE/qOQ;EzEgrOR,WAAW;EyE9qOL,iBAAA;EzEgrON,gByE/qO6B;EzEgrO7B,mByE/qOuB;EzEgrOvB,eAAe;EyE9qOT,sBAAA;EzEgrON,4ByE/qO6B;EzEgrO7B,kCyE/qOwC;EzEgrOxC,qCAAqC;EyE/rO/B,WAAsB;EzEisO5B,6ByEjsOyD;AzEksO3D;;AAEA;EACE;IACE,gBAAgB;EyEjsOZ;AzEmsOR;;AAEA;EyEjsOQ,UAAA;AzEmsOR;;AAEA;EyEjsOQ,kBAAA;EzEmsON,UyElsO6B;EzEmsO7B,YyElsOQ;EzEmsOR,SAAS;EyE7rOP,WAAiB;EzE+rOnB,iByE/rO6B;EzEgsO7B,oBAAoB;EyE/rOlB,WAAA;EzEisOF,kByEhsOoB;AzEisOtB;;AAEA;EACE;IyE/rOI,yBAAc;EzEisOlB;AACF;;AAEA;EACE,qBAAqB;EyE/rOnB,WAAA;EzEisOF,YyEhsOoB;EzEisOpB,2ByEhsOiB;E1DTf,iCAAyB;E0DlDrB,+BAA8B;EzE8vOpC,kByE9vOgD;EzE+vOhD,8CAA8C;AAChD;;AAEA;EACE,WAAW;EyE9vOL,YAAA;EzEgwON,mByE/vOqC;AzEgwOvC;;AAEA;EACE;IyE9vOQ,mBAAiB;EzEgwOzB;;EAEA;IyE9vOQ,UAAA;IzEgwON,eAAe;EyE/wOX;AzEixOR;;AAEA;EACE,qByElxOqC;EzEmxOrC,WyElxOQ;EzEmxOR,YAAY;EyEjxON,2BAAA;EzEmxON,8ByElxOqC;EzEmxOrC,kByElxOwB;EzEmxOxB,UAAU;EyEjxOJ,4CAAA;AzEmxOR;;AAEA;EyEjxOQ,WAAA;EzEmxON,YyElxOqC;AzEmxOvC;;AAEA;EACE,mCyEpyOkE;AzEqyOpE;;AAEA;EACE,8ByEryOsB;AzEsyOxB;;AAEA;EACE,iCyEryO0C;AzEsyO5C;;AAEA;EACE,iCyEryOyB;AzEsyO3B;;AAEA;EACE,sCyEryOyC;AzEsyO3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCyExzO2C;AzEyzO7C;;AAEA;EACE,oCyExzOyC;AzEyzO3C;;AAEA;;;;EAIE,oCyE30OwC;AzE40O1C;;AAEA;EACE,oCyE30O0C;AzE40O5C;;AAEA;;;;EAIE,oCyE30OqC;AzE40OvC;;AAEA;EACE,oCyE71OkE;AzE81OpE;;AAEA;;;;EAIE,oCyE91OqC;AzE+1OvC;;AAEA;EACE,oCyE91OqC;AzE+1OvC;;AAEA;;;;EyE32OQ,oCAA8B;AzEg3OtC;;AAEA;EACE,oCyEj3OqC;AzEk3OvC;;AAEA;;;;EyE72OQ,oCAAA;AzEk3OR;;AAEA;EyEh3OQ,oCAAA;AzEk3OR;;AAEA;;;;EyEh4OQ,oCAAA;AzEq4OR;;AAEA;EyEn4OQ,oCAAA;AzEq4OR;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EyEt5OQ,wCAAA;AzEw5OR;;AAEA;EyEt5OQ,oCAAA;AzEw5OR;;AAEA;EyEt5OQ,wCAAA;AzEw5OR;;AAEA;EyEt5OQ,0CAAA;AzEw5OR;;AAEA;EyEv6OQ,2CAA8B;AzEy6OtC;;AAEA;EACE,yCyE16OqC;AzE26OvC;;AAEA;EACE,oByE16OqC;AzE26OvC;;AAEA;EACE,wByE16OqC;AzE26OvC;;AAEA;EACE,0ByE16OqC;AzE26OvC;;AAEA;EACE,2ByE57OgD;AzE67OlD;;AAEA;EACE,yByE77OsB;AzE87OxB;;AAEA;EACE,gCyE77OwB;AzE87O1B;;AAEA;EACE,gCyE77OyB;AzE87O3B;;AAEA;EACE,gCyE77OuB;AzE87OzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EyE38OQ,6BAAA;AzE68OR;;AAEA;EyE38OQ,gCAAA;AzE68OR;;AAEA;EyE38OQ,iCAAA;AzE68OR;;AAEA;EyE38OQ,0CAAA;EzE68ON,2CyE58O6B;AzE68O/B;;AAEA;EACE,2CyE99OyD;EzE+9OzD,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EyE99OxC,6CAAA;AzEg+OR;;AAEA;EyE99OQ,0CAAA;EzEg+ON,6CyE/9O6B;AzEg+O/B;;AAEA;EACE,gCyE/9O6B;AzEg+O/B;;AAEA;EACE,6ByEj/OyD;AzEk/O3D;;AAEA;EACE,+ByEl/OuC;AzEm/OzC;;AAEA;EACE,2ByEl/OsB;AzEm/OxB;;AAEA;EACE,cyEl/OQ;EzEm/OR,WAAW;EyEj/OL,WAAA;AzEm/OR;;AAEA;EyElgPQ,wBAAsB;AzEogP9B;;AAEA;EACE,0ByErgP6B;AzEsgP/B;;AAEA;EACE,gCyErgP6B;AzEsgP/B;;AAEA;EACE,yByErgP6B;AzEsgP/B;;AAEA;EACE,yByErgP6B;AzEsgP/B;;AAEA;EACE,6ByEvhPyD;AzEwhP3D;;AAEA;EACE,8ByExhPuC;AzEyhPzC;;AAEA;EACE,wByExhPsB;AzEyhPxB;;AAEA;EACE,+ByExhPuB;AzEyhPzB;;AAEA;EACE;IACE,wBAAwB;EyEnhPxB;;EzEshPF;IyErhPE,0BAAA;EzEuhPF;;EAEA;IyErhPE,gCAAA;EzEuhPF;;EAEA;IyErhPE,yBAAA;EzEuhPF;;EAEA;IyErhPE,yBAAA;EzEuhPF;;Ee9hPE;I0DlDI,6BAA8B;EzEolPpC;;EyEnlPM;IzEslPJ,8ByErlPmC;EzEslPrC;;EyEnlPM;IzEslPJ,wByErlPmC;EzEslPrC;;EyEnlPM;IzEslPJ,+ByErlPmC;EzEslPrC;AACF;;AAEA;EACE;IACE,wBAAwB;EyErmPpB;;EzEwmPN;IyEvmPM,0BAAA;EzEymPN;;EAEA;IyEvmPM,gCAAA;EzEymPN;;EAEA;IyEvmPM,yBAAA;EzEymPN;;EAEA;IyEvmPM,yBAAA;EzEymPN;;EAEA;IyExnPM,6BAA8B;EzE0nPpC;;EyEznPM;IzE4nPJ,8ByE3nPmC;EzE4nPrC;;EyEznPM;IzE4nPJ,wByE3nPmC;EzE4nPrC;;EyEznPM;IzE4nPJ,+ByE3nPmC;EzE4nPrC;AACF;;AAEA;EACE;IACE,wBAAwB;EyE3oPpB;;EzE8oPN;IyE7oPM,0BAAA;EzE+oPN;;EAEA;IyE7oPM,gCAAA;EzE+oPN;;EAEA;IyE7oPM,yBAAA;EzE+oPN;;EAEA;IyE7oPM,yBAAA;EzE+oPN;;EAEA;IyE9pPM,6BAA8B;EzEgqPpC;;EyE/pPM;IzEkqPJ,8ByEjqPmC;EzEkqPrC;;EyE/pPM;IzEkqPJ,wByEjqPmC;EzEkqPrC;;EyE/pPM;IzEkqPJ,+ByEjqPmC;EzEkqPrC;AACF;;AAEA;EACE;IACE,wBAAwB;EyEjrPpB;;EzEorPN;IyEnrPM,0BAAA;EzEqrPN;;EAEA;IyEnrPM,gCAAA;EzEqrPN;;EAEA;IyEnrPM,yBAAA;EzEqrPN;;EAEA;IyEnrPM,yBAAA;EzEqrPN;;EAEA;IyEpsPM,6BAA8B;EzEssPpC;;EyErsPM;IzEwsPJ,8ByEvsPmC;EzEwsPrC;;EyErsPM;IzEwsPJ,wByEvsPmC;EzEwsPrC;;EyErsPM;IzEwsPJ,+ByEvsPmC;EzEwsPrC;AACF;;AAEA;EACE;IACE,wBAAwB;EyEvtPpB;;EzE0tPN;IyEztPM,0BAAA;EzE2tPN;;EAEA;IyEztPM,gCAAA;EzE2tPN;;EAEA;IyEztPM,yBAAA;EzE2tPN;;EAEA;IyEztPM,yBAAA;EzE2tPN;;EAEA;IyE1uPM,6BAA8B;EzE4uPpC;;EyE3uPM;IzE8uPJ,8ByE7uPmC;EzE8uPrC;;EyE3uPM;IzE8uPJ,wByE7uPmC;EzE8uPrC;;EyE3uPM;IzE8uPJ,+ByE7uPmC;EzE8uPrC;AACF;;AAEA;EACE;IACE,wBAAwB;EyE7vPpB;;EzEgwPN;IyE/vPM,0BAAA;EzEiwPN;;EAEA;IyE/vPM,gCAAA;EzEiwPN;;EAEA;IyE/vPM,yBAAA;EzEiwPN;;EAEA;IyE/vPM,yBAAA;EzEiwPN;;EAEA;IyEhxPM,6BAA8B;EzEkxPpC;;EyEjxPM;IzEoxPJ,8ByEnxPmC;EzEoxPrC;;EyEjxPM;IzEoxPJ,wByEnxPmC;EzEoxPrC;;EyEjxPM;IzEoxPJ,+ByEnxPmC;EzEoxPrC;AACF;;AAEA;EACE,kByEnxPuB;EzEoxPvB,cAAc;EyEnyPR,WAA8B;EzEqyPpC,UyEryP8C;EzEsyP9C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EyEryPR,WAAA;AzEuyPR;;AAEA;;;;;EyEjyPQ,kBAAA;EzEuyPN,MAAM;EACN,SyEtyPQ;EzEuyPR,OAAO;EyE/xPD,WAAsB;EzEiyP5B,YyEjyPsC;EzEkyPtC,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EyEpzPQ,8BAAA;AzEszPR;;AAEA;EyEpzPQ,iCAAA;AzEszPR;;AAEA;EyEpzPQ,sCAAA;AzEszPR;;AAEA;EyEpzPQ,yCAAA;AzEszPR;;AAEA;EyEr0PQ,0BAAsB;AzEu0P9B;;AAEA;EACE,4ByEx0P6B;AzEy0P/B;;AAEA;EACE,kCyEx0P6B;AzEy0P/B;;AAEA;EACE,yByEx0P6B;AzEy0P/B;;AAEA;EACE,uByEx0P6B;AzEy0P/B;;AAEA;EACE,uByE11PsC;AzE21PxC;;AAEA;EACE,yByE31PoB;AzE41PtB;;AAEA;EACE,yByE31PsB;AzE41PxB;;AAEA;EACE,sCyE31P0C;AzE41P5C;;AAEA;EACE,oCyE31PwC;AzE41P1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EyE32PI,8BAAA;AzE62PJ;;AAEA;EyE32PI,gCAAA;AzE62PJ;;AAEA;EyE32PI,+BAAA;AzE62PJ;;AAEA;EyE32PI,oCAAA;AzE62PJ;;Aep3PI;E0DlDI,kCAA8B;AzE06PtC;;AAEA;EACE,gCyE36PqC;AzE46PvC;;AAEA;EACE,uCyE36PqC;AzE46PvC;;AAEA;EACE,sCyE36PqC;AzE46PvC;;AAEA;EACE,iCyE36PqC;AzE46PvC;;AAEA;EACE,2ByE77PgD;AzE87PlD;;AAEA;EACE,iCyE97PwC;AzE+7P1C;;AAEA;EACE,+ByE97PwB;AzE+7P1B;;AAEA;EACE,6ByE97PyB;AzE+7P3B;;AAEA;EACE,+ByE97PuB;AzE+7PzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IyEh9PM,8BAAA;EzEk9PN;;EAEA;IyEh9PM,iCAAA;EzEk9PN;;EAEA;IyEh9PM,sCAAA;EzEk9PN;;EAEA;IyEj+PM,yCAA8B;EzEm+PpC;;EyEl+PM;IzEq+PJ,0ByEp+PmC;EzEq+PrC;;EyEl+PM;IzEq+PJ,4ByEp+PmC;EzEq+PrC;;EyEl+PM;IzEq+PJ,kCyEp+PmC;EzEq+PrC;;EyEl+PM;IzEq+PJ,yByEp+PmC;EzEq+PrC;;EyEn/PM;IAAgC,uBAAU;EzEu/PhD;;EAEA;IyEt/PQ,uBAAc;EzEw/PtB;;EAEA;IyEt/PQ,yBAAgB;EzEw/PxB;;EAEA;IyEt/PQ,yBAAiB;EzEw/PzB;;EAEA;IyEt/PQ,sCAAiC;EzEw/PzC;;EAEA;IACE,oCAAoC;EyEzgQhC;;EzE4gQN;IACE,kCAAkC;EyEzgQ9B;;EzE4gQN;IACE,yCAAyC;EyEzgQrC;;EzE4gQN;IACE,wCAAwC;EyEzgQpC;;EzE4gQN;IACE,kCAAkC;EyE1hQ9B;;EzE6hQN;IyE5hQM,gCAAA;EzE8hQN;;EAEA;IyE5hQM,8BAAA;EzE8hQN;;EAEA;IyE5hQM,gCAAA;EzE8hQN;;EAEA;IyE5hQM,+BAAA;EzE8hQN;;EAEA;IyE7iQM,oCAA8B;EzE+iQpC;;EyE9iQM;IzEijQJ,kCyEhjQmC;EzEijQrC;;EyE9iQM;IzEijQJ,gCyEhjQmC;EzEijQrC;;EyE9iQM;IzEijQJ,uCyEhjQmC;EzEijQrC;;EyE9iQM;IzEijQJ,sCyEhjQmC;EzEijQrC;;EyE/jQM;IAAgC,iCAA4B;EzEmkQlE;;EAEA;IyElkQQ,2BAAc;EzEokQtB;;EAEA;IyElkQQ,iCAAkC;EzEokQ1C;;EAEA;IyElkQQ,+BAAiB;EzEokQzB;;EAEA;IyElkQQ,6BAAe;EzEokQvB;;EAEA;IACE,+BAA+B;EyErlQ3B;;EzEwlQN;IACE,8BAA8B;EyErlQ1B;AzEulQR;;AAEA;EyErlQQ;IzEulQJ,8ByEtlQmC;EzEulQrC;;EyEplQM;IzEulQJ,iCyEtlQmC;EzEulQrC;;EyErmQM;IAAgC,sCAA4B;EzEymQlE;;EAEA;IyExmQQ,yCAAgC;EzE0mQxC;;EAEA;IyExmQQ,0BAAgB;EzE0mQxB;;EAEA;IyExmQQ,4BAAiB;EzE0mQzB;;EAEA;IyExmQQ,kCAAiC;EzE0mQzC;;EAEA;IACE,yBAAyB;EyE3nQrB;;EzE8nQN;IACE,uBAAuB;EyE3nQnB;;EzE8nQN;IACE,uBAAuB;EyE3nQnB;;EzE8nQN;IACE,yBAAyB;EyE3nQrB;;EzE8nQN;IACE,yBAAyB;EyErnQrB;;EzEwnQN;IyEvnQM,sCAAA;EzEynQN;;EAEA;IyEvnQM,oCAAA;EzEynQN;;EAEA;IyEvnQM,kCAAA;EzEynQN;;EAEA;IyEvnQM,yCAAA;EzEynQN;;EAEA;IyExoQM,wCAAsB;EzE0oQ5B;;EyEzoQM;IzE4oQJ,kCyE3oQ2B;EzE4oQ7B;;EyEzoQM;IzE4oQJ,gCyE3oQ2B;EzE4oQ7B;;EyEzoQM;IzE4oQJ,8ByE3oQ2B;EzE4oQ7B;;EyEzoQM;IzE4oQJ,gCyE3oQ2B;EzE4oQ7B;;EyE1pQM;IAAwB,+BAA2B;EzE8pQzD;;EAEA;IyE7pQQ,oCAA+B;EzE+pQvC;;EAEA;IyE7pQQ,kCAAiC;EzE+pQzC;;EAEA;IyE7pQQ,gCAAkC;EzE+pQ1C;;EAEA;IyE7pQQ,uCAAgC;EzE+pQxC;;EAEA;IACE,sCAAsC;EyEhrQlC;;EzEmrQN;IACE,iCAAiC;EyEhrQ7B;;EzEmrQN;IACE,2BAA2B;EyEhrQvB;;EzEmrQN;IACE,iCAAiC;EyEhrQ7B;;EzEmrQN;IACE,+BAA+B;EyEjsQ3B;;EzEosQN;IyEnsQM,6BAAA;EzEqsQN;;EAEA;IyEnsQM,+BAAA;EzEqsQN;;EAEA;IyEnsQM,8BAAA;EzEqsQN;AACF;;AAEA;EACE;IyEnsQQ,8BAAgC;EzEqsQxC;;EAEA;IACE,iCAAiC;EyEjsQjC;;EzEosQF;IACE,sCAAsC;EyEjsQtC;;EzEosQF;IACE,yCAAyC;EyEjsQzC;;EzEosQF;IACE,0BAA0B;EyEjsQ1B;;EzEosQF;I0ElwQA,4BAAS;EACP;;EAEA;IACA,kCAAS;EACT;;EAGA;IACA,yBAAW;EAEX;;ECVJ;IAAkB,uBAAa;E3E+wQ7B;;E2E3wQe;I3E8wQb,uBAAuB;E2E7wQ3B;;E3EgxQE;I2E/wQF,yBAAe;EAAE;;EACjB;ICTE,yBAAgB;EAChB;;E5E8xQA;I2E9wQE,sCAAsB;EAAE;;EACxB;IAAwB,oCAA4B;E3EmxQtD;;E2ElxQ0B;I3EqxQxB,kCAAkC;EehvQlC;;EfmvQF;IACE,yCAAyC;E2E1xQzC;;E3E6xQF;I2E5xQE,wCAAsB;E3E8xQxB;;E2EhyQE;IAAwB,kCAA2B;E3EoyQrD;;EAEA;IACE,gCAAgC;E2EryQhC;;E5DqCA;I4DvCA,8BAAsB;E3E4yQxB;;E2E3yQE;IAAwB,gCAA4B;E3E+yQtD;;EAEA;Ie3wQE,+BAAyB;E4DvCzB;;E3EszQF;I2ErzQE,oCAAsB;E3EuzQxB;;E2EtzQE;IAAwB,kCAA6B;E5DqCrD;;EfuxQF;IACE,gCAAgC;E2E9zQhC;;E3Ei0QF;I2Eh0QE,uCAAsB;E3Ek0QxB;;E2E5zQiB;I3E+zQf,sCAAsC;E2E9zQ1C;;E3Ei0QE;I2Eh0QF,iCAAiB;EAAE;;EAInB;IAAuB,2BAA0C;E3Ek0Q/D;;E2Ej0QqB;I3Eo0QnB,iCAAiC;E2En0QrC;;E3Es0QE;I2Er0QF,+BAAqB;EAAE;;EACvB;IAAuB,6BAA2C;E3E00QhE;;E2Ez0QqB;I3E40QnB,+BAA+B;E2Ex0QnC;;E3E20QE;I6El3QA,8BAAW;EACT;A7Eo3QJ;;AAEA;EACE;I6Ex3QA,8BAAW;EACT;;E1DUF;I0DLM,iCAA0E;E7Ew3QhF;;E6E73QE;I7Eg4QA,sCAAsC;EmBt3QxC;;EnBy3QA;I6Ep4QA,yCAAW;EACT;;E1DUF;I0DLM,0BAA0E;E7Eo4QhF;;E6Ez4QE;I7E44QA,4BAA4B;EmBl4Q9B;;EnBq4QA;I6Eh5QA,kCAAW;EACT;;E1DUF;I0DLM,yBAA0E;E7Eg5QhF;;E6Er5QE;I7Ew5QA,uBAAuB;EmB94QzB;;EnBi5QA;I6E55QA,uBAAW;EACT;;E1DUF;I0DLM,yBAA0E;E7E45QhF;;E2Er3QW;I3Ew3QT,yBAAyB;E2Ev3Q7B;;E3E03QE;I2Ex3QF,sCAAe;EAAE;;EACjB;IAAiB,oCAAO;E3E63QtB;;E8Eh7QA;IACA,kCAAkB;EAClB;;EAEA;I9Em7QE,yCAAyC;E2E53Q7C;;E3E+3QE;I2E73QF,wCAAY;EACV;;E3Eg4QA;I2E13QF,kCAAY;EAAE;;EIjEd;IACE,gCAA8B;E/Eg8Q9B;;E+E57QA;I/E+7QE,8BAA8B;EgF/7QhC;;EhFk8QA;IACE,gCgFh8QS;EhFi8QX;;EAEA;IgF17QI,+BAAY;EhF47QhB;;EgFl7QE;IACE,oCAA6B;EhFq7QjC;;EAEA;IACE,kCAAkC;EgFv6QlC;;EhF06QF;IgFv6QI,gCAAwB;EhFy6Q5B;;EAEA;IACE,uCAAuC;EgFh6QvC;;EhFm6QF;IACE,sCAAsC;EgF/5QtC;;EhFk6QF;IgF/5QI,iCAAU;EhFi6Qd;;EgF75QE;IACG,2BAAA;EhFg6QL;;EgFv5QE;IACE,iCxE2hCgC;EwEzhClC;;EhF05QF;IgFv5QE,+BAAW;EhFy5Qb;;EgFp5QE;IACE,6BAAa;EhFu5QjB;;EAEA;IACE,+BAA+B;EgFp5Q/B;;EhFu5QF;IACE,8BgFp5QK;EhFq5QP;AACF;;AAEA;EACE;IACE,8BAA8B;EgF94Q9B;;EhFi5QF;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EgF34QtC;;EhF84QF;IiFnhRF,yCAAW;EACP;;ECIF;IACE,0BAAa;EACb;;ElFohRF;IkFjhRM,4BAAU;EAEd;;ElFmhRF;IACE,kCAAkC;EkF/gRtC;;EAEC;IlFihRG,yBAAyB;EkF/gR7B;;EAEI;IACA,uBAAkB;EAClB;;E/EEF;I+ENF,uBAAK;ElFwhRH;;EGzgRM;I+EJL,yBAAA;ElFihRD;;EkF5gRE;IlF+gRA,yBAAyB;EkF5gR7B;;ElF+gRE;IkF3gRF,sCAAc;EACV;;EAEA;IACA,oCAAkB;EAElB;;ElF6gRF;IkFzgRF,kCAAW;EACV;;EAED;IACC,yCAA6B;ElF2gR5B;;EkFxgRE;IACA,wCAAS;ElF2gRX;;EkFvgRE;IlF0gRA,kCAAkC;EkFvgRpC;;EAEE;IAGI,gCAAqB;ElFugR3B;;EkFhgRA;IlFmgRE,8BAA8B;EkFhgRlC;;ElFmgRE;IkFt/QE,gCAAW;EACP;;EAGA;IACA,+BAAmB;EACnB;;ElFw/QN;IACE,oCkFv/QgB;ElFw/QlB;;EGliRM;I+EqCJ,kCAAA;ElFigRF;;EAEA;IGxiRM,gCAAA;EH0iRN;;EAEA;IACE,uCkFv/QiB;ElFw/QnB;;EkFn/QF;IlFs/QI,sCkFr/QC;EACJ;;EAEA;IlFs/QG,iCkFt/QY;ElFu/Qd;;EAEA;IkFp/QF,2BAAA;ElFs/QE;;EkFn/QD;IACA,iCAAA;ElFs/QC;;EAEA;IACE,+BAA+B;EkFp/QnC;;EAEC;IACA,6BAAkB;EAClB;;ElFu/QC;IkFr/QA,+BAAkB;ElFu/QlB;;EAEA;IkFp/QD,8BAAiB;EACjB;AlFs/QD;;AAEA;EACE,sBkFt/QkB;AlFu/QpB;;AAEA;EkFp/QC,uBAAgB;AlFs/QjB;;AAEA;EACE,sBkFt/QgB;AlFu/QlB;;AkFn/QA;ElFs/QE;IkFp/QD,sBAAgB;EAChB;;ElFu/QC;IkFr/QA,uBAAgB;ElFu/QhB;;EkFn/QF;IACI,sBAAA;EACH;AlFs/QD;;AAEA;EACE;IkFr/QA,sBAAiB;ElFu/QjB;;EAEA;IkFp/QD,uBAAa;EACb;;ElFu/QC;IkFr/QA,sBAAc;ElFu/Qd;AACF;;AAEA;EkFp/QI;IACA,sBAAoB;EACpB;;EAES;IACL,uBAAiB;ElFs/QvB;;EkFh/QE;IACA,sBAAuB;EACvB;AlFm/QJ;;AAEA;EACE;IkFr+QE,sBAAA;EAAC;;EACL;IAAK,uBAAW;ElF0+Qd;;EkFz+QG;IlF4+QD,sBAAsB;EkF3+Q1B;AlF6+QA;;AkF5+QA;EAAK;IlFg/QD,sBAAsB;EkF/+Q1B;;ElFk/QE;IkFj/QE,uBAAA;EAAC;;EACL;IAAK,sBAAW;ElFs/Qd;AkFr/QF;;AlFw/QA;EkFv/QA,mCAAU;UAAV,2BAAU;AlFy/QV;;AkFr/QA;EACI,oCAAe;UAAf,4BAAe;AlFw/QnB;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AkFr/Q9B;;AlFw/QA;EkFr/QI,yBAAW;AlFu/Qf;;AAEA;EkFr/QI,2BAAe;AlFu/QnB;;AAEA;EkFr/QI,2BAAY;AlFu/QhB;;AAEA;EkFn/QA,6BAAY;AlFq/QZ;;AkFp/QA;EAAc,6BjFvNE;AD+sRhB;;AAEA;EACE,0BAA0B;AkFz/Q5B;;AlF4/QA;EkF3/QA,2BAAY;AlF6/QZ;;AkF5/QA;EAAc,ejFvNE;EDutRd,MAAM;EkF//QR,QAAA;EAAc,OjFvNL;EDytRP,aAAa;AkFjgRf;;AlFogRA;EkFngRA,eAAY;EAAE,QjFvNL;ED6tRP,SAAS;EkFrgRX,OAAA;EAAc,ajFvNL;AD+tRT;;AAEA;EACE;IkFtgRF,gBAAU;IACT,MAAA;IlFwgRG,aAAa;EkFtgRjB;AlFwgRA;;AkFrgRA;EACC,kBAAW;ElFwgRV,UAAU;EkFtgRZ,WAAQ;EACP,UAAU;ElFwgRT,YAAY;EkFtgRd,gBAAc;EACb,sBAAW;ElFwgRV,mBAAmB;EkFtgRrB,SAAA;AlFwgRA;;AkFrgRA;;ElFygRE,gBAAgB;EkFtgRlB,WAAS;EACR,YlErMc;EhB6sRb,iBAAiB;EkFtgRnB,UAAW;EACV,mBAAM;AlFwgRP;;AAEA;EACE,8DAA8D;AkFtgRhE;;AlFygRA;EkFtgRA,wDAAe;AlFwgRf;;AkFrgRA;EAAO,uDAAyB;AlFygRhC;;AkFxgRA;EAAO,2BAAyB;AlF4gRhC;;AkF3gRA;EAAO,qBAAU;AlF+gRjB;;AkF9gRA;EAAO,qBAAU;AlFkhRjB;;AkFjhRA;EAAO,qBAAU;AlFqhRjB;;AkFphRA;EAAO,sBAAU;AlFwhRjB;;AkFvhRA;EAAO,sBAAU;AlF2hRjB;;AkF1hRA;EAAO,sBAAU;AlF8hRjB;;AkF7hRA;EAAO,sBAAU;AlFiiRjB;;AkFhiRA;EAAO,sBAAU;AlFoiRjB;;AkFniRA;EAAO,uBAAU;AlFuiRjB;;AkFtiRA;EAAO,uBAAU;AlF0iRjB;;AkFziRA;EAAO,0BAAyB;AlF6iRhC;;AkF5iRA;EAAO,2BAAyB;AlFgjRhC;;AkF/iRA;EAAO,2BAAyB;AlFmjRhC;;AkFljRA;EAAO,4BAAyB;AlFsjRhC;;AkFrjRA;EAAO,uBAAU;AlFyjRjB;;AkFxjRA;EAAO,wBAAU;AlF4jRjB;;AkF3jRA;EAAO,oBAAU;AlF+jRjB;;AkF9jRA;;ElFkkRE,wBAAwB;AkFjkR1B;;AlFokRA;;EkFnkRW,0BAAe;AlFskR1B;;AAEA;;EkFtkRA,2BAAU;AlFykRV;;AkFxkRA;;ElF4kRE,yBAAyB;AkF3kR3B;;AlF8kRA;EkF7kRA,0BAAU;AlF+kRV;;AkF9kRA;;ElFklRE,8BAA8B;AkFjlRhC;;AlFolRA;;EkFhlRC,gCAAwB;AlFmlRzB;;AAEA;;EkFhlRC,iCAAoB;AlFmlRrB;;AAEA;;EkFhlRC,+BAAoB;AlFmlRrB;;AAEA;EkFjlRC,yBAAe;AlFmlRhB;;AAEA;;EAEE,6BAA6B;AkFjlR/B;;AlFolRA;;EkFhlRC,+BAAwB;AlFmlRzB;;AAEA;;EkFhlRC,gCAAoB;AlFmlRrB;;AAEA;;EkFhlRC,8BAAoB;AlFmlRrB;;AAEA;EkFjlRC,uBAAe;AlFmlRhB;;AAEA;;EAEE,2BAA2B;AkF7kR7B;;AlFglRA;;EkF/kRY,6BAAW;AlFklRvB;;AAEA;;EkFllRA,8BAAU;AlFqlRV;;AkFplRA;;ElFwlRE,4BAA4B;AkFvlR9B;;AlF0lRA;EkFzlRA,yBAAU;AlF2lRV;;AkF1lRA;;ElF8lRE,6BAA6B;AkF7lR/B;;AlFgmRA;;EkF/lRY,+BAAY;AlFkmRxB;;AAEA;;EkFlmRA,gCAAW;AlFqmRX;;AkFpmRA;;ElFwmRE,8BAA8B;AkFvmRhC;;AlF0mRA;EkFzmRA,uBAAW;AlF2mRX;;AkF1mRA;;ElF8mRE,2BAA2B;AkF7mR7B;;AlFgnRA;;EkF/mRa,6BAAY;AlFknRzB;;AAEA;;EkFlnRA,8BAAU;AlFqnRV;;AkFpnRA;;ElFwnRE,4BAA4B;AkFvnR9B;;AlF0nRA;EkFznRA,qBAAW;AlF2nRX;;AkF1nRA;;ElF8nRE,yBAAyB;AkF7nR3B;;AlFgoRA;;EkF/nRa,2BAAY;AlFkoRzB;;AAEA;;EkFloRA,4BAAW;AlFqoRX;;AkFpoRA;;ElFwoRE,0BAA0B;AkFvoR5B;;AlF0oRA;EkFzoRA,2BAAW;AlF2oRX;;AkF1oRA;;ElF8oRE,+BAA+B;AkF7oRjC;;AlFgpRA;;EkF/oRa,iCAAY;AlFkpRzB;;AAEA;;EkFlpRA,kCAAW;AlFqpRX;;AkFppRA;;ElFwpRE,gCAAgC;AkFvpRlC;;AlF0pRA;EkFzpRA,0BAAW;AlF2pRX;;AkF1pRA;;ElF8pRE,8BAA8B;AkF7pRhC;;AlFgqRA;;EkF/pRY,gCAAY;AlFkqRxB;;AAEA;;EkFlqRA,iCAAU;AlFqqRV;;AkFpqRA;;ElFwqRE,+BAA+B;AkFvqRjC;;AlF0qRA;EkFzqRA,wBAAU;AlF2qRV;;AkF1qRA;;ElF8qRE,4BAA4B;AkF7qR9B;;AlFgrRA;;EkF/qRY,8BAAU;AlFkrRtB;;AAEA;;EkFlrRA,+BAAU;AlFqrRV;;AkFprRA;;ElFwrRE,6BAA6B;AkFvrR/B;;AlF0rRA;EkFzrRA,0BAAU;AlF2rRV;;AkF1rRA;;ElF8rRE,8BAA8B;AkF7rRhC;;AlFgsRA;;EkF/rRY,gCAAW;AlFksRvB;;AAEA;;EkFlsRA,iCAAU;AlFqsRV;;AkFpsRA;;ElFwsRE,+BAA+B;AkFvsRjC;;AlF0sRA;EkFzsRA,wBAAU;AlF2sRV;;AkF1sRA;;ElF8sRE,4BAA4B;AkF7sR9B;;AlFgtRA;;EkF/sRY,8BAAW;AlFktRvB;;AAEA;;EkFltRA,+BAAU;AlFqtRV;;AkFptRA;;ElFwtRE,6BAA6B;AkFvtR/B;;AlF0tRA;EkFztRA,2BAAU;AlF2tRV;;AkF1tRA;;ElF8tRE,+BAA+B;AkF7tRjC;;AlFguRA;;EkF/tRY,iCAAW;AlFkuRvB;;AAEA;;EkFluRA,kCAAU;AlFquRV;;AkFpuRA;;ElFwuRE,gCAAgC;AkFvuRlC;;AlF0uRA;EkFzuRA,0BAAU;AlF2uRV;;AkF1uRA;;ElF8uRE,8BAA8B;AkF7uRhC;;AlFgvRA;;EkF/uRY,gCAAW;AlFkvRvB;;AAEA;;EkFlvRA,iCAWC;AlF0uRD;;AAEA;;EkFjvRI,+BAAG;AlFovRP;;AAEA;EkF/uRA,wBAWC;AlFsuRD;;AAEA;;EkF7uRI,4BAAG;AlFgvRP;;AAEA;;EkF1uRI,8BAAK;AlF6uRT;;AAEA;;EAEE,+BkF3uRyB;AlF4uR3B;;AkFtuRA;;ElF0uRE,6BkFxuRyB;AlFyuR3B;;AAEA;EACE,0BkFvuRyB;AlFwuR3B;;AkF5tRA;;ElFguRE,8BAA8B;AmF1uShC;;AnF6uSA;;EAEE,gCAAgC;AAClC;;AAEA;;EmFhvSQ,iCAAe;AnFmvSvB;;AAEA;;EAEE,+BmFtvSkD;AnFuvSpD;;AAEA;EACE,wBmF1vSgB;AnF2vSlB;;AAEA;;EAEE,4BmF9vSmD;AnF+vSrD;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EmFxwSQ,+BAAe;AnF2wSvB;;AAEA;;EAEE,6BmF9wSkD;AnF+wSpD;;AAEA;EACE,uBmFlxSgB;AnFmxSlB;;AAEA;;EAEE,2BmFtxSmD;AnFuxSrD;;AAEA;;EoFvySA,6BAAW;ApF0ySX;;AAEA;;EoFvySI,8BAAM;ApF0ySV;;AoFtySA;;EAEI,4BAAW;ApFyySf;;AAEA;EACE;IoFtySF,oBAAA;EACI;;EAEA;;IAEA,wBAAY;EACZ;;EAEA;;IAEA,0BAAW;EpFwySb;;EoFpySE;;IpFwySA,2BAA2B;EoFpyS/B;;EAEI;;IAGJ,yBAAA;EACI;;EpFsySF;IoFnySM,0BAAmB;EpFqySzB;;EAEA;;IoF9xSF,8BAWC;EAVG;;EpFkySF;;IoF9xSM,gCAAmB;EAEvB;;EpFiySF;;IqF31SE,iCAAuB;EACvB;;ErF+1SF;;IqF31SE,+BAAW;ErF81Sb;;EAEA;IACE,yBqF51SiB;ErF61SnB;;EAEA;;IAEE,6BqF11SuB;ErF21SzB;;EAEA;;IAEE,+BAA+B;EG91S3B;;EHi2SN;;IsFv2SE,gCAAA;EACI;;EtF22SN;;IsFl2SE,8BAAc;EACd;;EAEA;IACA,uBAAkB;EAClB;;EAEA;;IAEA,2BAAU;EAGV;;EtFo2SF;;IAEE,6BsFn2Sc;EAId;;EnFcI;;IHs1SJ,8BsF71SgB;EAEhB;;EtF81SF;;IsF11SM,4BAA2B;EtF61SjC;;EAEA;IsF31SM,yBAAqB;EtF61S3B;;EAEA;;IAEE,6BsFz2SY;EtF02Sd;;EAEA;;IAEE,+BsFr1SwB;EtFs1S1B;;EAEA;;IAEE,gCsFr1SwB;EtFs1S1B;;EAEA;;IsFj1SA,8BAAe;EtFo1Sf;;EAEA;IGj5SA,uBAAA;EmF0EE;;EtF20SF;;IAEE,2BsFz0SqB;EAKzB;;EAEI;;IAEA,6BAAkB;EAClB;;EAEA;;IAIA,8BAAqB;EAErB;;EtFo0SF;;IGn7SA,4BAAA;EHs7SA;;EAEA;IsFvzSF,qBAAW;EAEP;;EAEA;;IAEA,yBAAoB;EACpB;;EAEA;;IAGJ,2BAAiB;EACb;;EAEA;;IAEA,4BAAe;EACf;;EAGA;;ItFuzSA,0BAA0B;EsFnzS9B;;EtFszSE;IsFlzSF,2BAA8B;EAC1B;;EAGJ;;ItFozSI,+BAA+B;EsFhzSnC;;EtFmzSE;;IsF9ySE,iCAAW;EtFizSb;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IsF3ySE,gCAAW;EtF8ySb;;EsF1ySE;IACA,0BAA2B;EAC3B;;EtF8ySF;;IsFzySE,8BAAmB;EACnB;;EAGJ;;IAEI,gCAAW;EtF2ySb;;EsFrySM;;IAGA,iCAAA;EtFuySN;;EsF9xSU;;IAII,+BAAc;EtF+xS5B;;EsFvxSM;ItF0xSJ,wBAAwB;EsFpxSpB;;EtFuxSN;;IsF9wSU,4BAAoB;EAExB;;EtFixSN;;IsF1wSM,8BAAkB;EACxB;;EtF8wSA;;IsFxwSM,+BAAe;EACf;;EAGA;;ItF2wSJ,6BAA6B;EuFniTjC;;EAGI;IACA,0BAAkB;EAClB;;EAEA;;IAGA,8BAAwB;EpFuBpB;;EH8gTN;;IuFthTM,gCAAY;EvFyhTlB;;EAEA;;IGx/SM,iCAAA;EH2/SN;;EAEA;;IuF5/SE,+BAAQ;EvF+/SV;;EAEA;IuF7/SM,wBAAA;EvF+/SN;;EGniTA;;IHuiTE,4BuF7/SS;EvF8/SX;;EuF9+SF;;IAEI,8BAAA;EvFi/SF;;EAEA;;IuF9+SM,+BAAmB;EvFi/SzB;;EuF7+SE;;IAGI,6BAAmB;EAEvB;;EvF++SF;IACE,2BAA2B;EuFx+S/B;;EAhCI;;IAEA,+BAA4B;EAkC5B;;EAEA;;IAEA,iCAAU;EACV;;EAEA;;IA3CA,kCA8CwB;EvF0+S1B;;EAEA;;IuFz+SM,gCAAQ;EvF4+Sd;;EAEA;IuF1+SM,0BAAY;EvF4+SlB;;EAEA;;IuFz+SM,8BAAmB;EvF4+SzB;;EAEA;;IGtlTM,gCAAA;EHylTN;;EAEA;;IuFr+SF,iCAiBC;EAhBG;;EvFy+SF;;IuFp+SE,+BAAI;EvFu+SN;;EAEA;IuFn+SE,wBAAK;EvFq+SP;;EAEA;;IuF/9SK,4BAAA;EvFk+SL;;EAEA;;IuF99SM,8BAAY;EAEhB;;EAGA;;IAEI,+BAAmB;EvF+9SzB;;EAEA;;IGjmTM,6BAAA;EHomTN;;EAEA;IACE,0BuF59S2B;EpFtK7B;;EHqoTA;;IAEE,8BuF79S0B;EvF89S5B;;EuFv9SM;;IvF29SJ,gCAAgC;EuFr9ShC;;EAEI;;IAEL,iCAAoB;EvFu9SrB;;EuFh9SM;;IAEA,+BAAW;EAEf;;EpFtMF;IoFsME,wBAAA;EvFq9SF;;EuF98SM;;IAIJ,4BAAA;EACI;;EAIJ;;IAEF,8BAAsB;EAKtB;;EAGA;;IvFy8SE,+BAA+B;EwFzsTnC;;EAEI;;IAGH,6BAAe;ExF0sTd;;EAEA;IG7qTM,uBAAA;EH+qTN;;EAEA;;IAEE,2BwF1sTW;EAIX;;ExFysTF;;IwFrsTM,6BAAsB;ExFwsT5B;;EAEA;;IwFrsTM,8BAAgB;ExFwsTtB;;EAEA;;IwFrsTA,4BAAiB;ExFwsTjB;AACF;;AAEA;EACE;IACE,oBwFnsTQ;ExFosTV;;EAEA;;IAEE,wBwF/rTkB;ExFgsTpB;;EAEA;;IwF3rTM,0BAAA;ExF8rTN;;EAEA;;IwF9qTM,2BAAY;ExFirTlB;;EAEA;;IAEE,yBwFhrTwB;ExFirT1B;;EAEA;IACE,0BwF7qTe;ExF8qTjB;;EAEA;;IAEE,8BwF7qTgB;ExF8qTlB;;EAEA;;IAEE,gCwF5qTc;ExF6qThB;;EAEA;;IAEE,iCwF5qTA;ExF6qTF;;EAEA;;IAEE,+BwF1qTwB;ExF2qT1B;;EAEA;IACE,yBwF1qTY;ExF2qTd;;EAEA;;IAEE,6BwF3qTY;ExF4qTd;;EAEA;;IAEE,+BwF1qTqB;ExF2qTvB;;EAEA;;IAEE,gCwFlqTqC;ExFmqTvC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBwFpqTc;ExFqqThB;;EwF7pTE;;IxFiqTA,2BAA2B;EyFzzT/B;;EAKI;;IAEI,6BAAa;EzFwzTnB;;EAEA;;IyFnzTD,8BAAc;EzFszTb;;EAEA;;IAEE,4ByFrzTiB;EzFszTnB;;EAEA;IACE,yByFrzTY;EAIR;;EzFozTN;;IAEE,6ByFnzTiB;EzFozTnB;;EAEA;;IyF/yTE,+BAAA;EzFkzTF;;EAEA;;IyF7yTC,gCAAuB;EzFgzTxB;;EAEA;;IAEE,8ByFvzTI;EzFwzTN;;EAEA;IACE,uBgB/vT8B;EhBgwThC;;EAEA;;IAEE,2BgBpwT8B;EhBqwThC;;EAEA;;IAEE,6BgBzwT8B;EhB0wThC;;EAEA;;IAEE,8BgB9wT8B;EhB+wThC;;EAEA;;IAEE,4BGp1TI;EHq1TN;;EAEA;IACE,qByFnyTD;EzFoyTD;;EAEA;;IAEE,yByFhyT2B;EzFiyT7B;;EAEA;;IAEE,2ByFhyT+B;EzFiyTjC;;EAEA;;IAEE,4ByFhyTwB;EzFiyT1B;;EAEA;;IAEE,0ByFjyTgB;EzFkyTlB;;EAEA;IACE,2BGn4TF;EHo4TA;;EAEA;;IAEE,+ByFjyTe;EzFkyTjB;;EAEA;;IyFvxTc,iCzEhCkB;EhB0zThC;;EyFnxTE;;IAEI,kCAAY;EzFsxTlB;;EyFhxTM;;IAEL,gCAAa;EzFmxTd;;EAEA;IACE,0ByFxxTI;EzFyxTN;;EAEA;;IyF/wTC,8BAAA;EzFkxTD;;EAEA;;IAEE,gCyFlxTkB;EzFmxTpB;;EAEA;;IAEE,iCyFjxTe;EzFkxTjB;;EAEA;;IAEE,+ByF/wTA;EzFgxTF;;EAEA;IACE,wByF/wTgB;EzFgxTlB;;EAEA;;IyFzwTc,4BAAA;EzF4wTd;;EAEA;;IyFpwTU,8BAAmB;EzFuwT7B;;EAEA;;IyFjwTU,+BAAA;EzFowTV;;EAEA;;IyF7vTM,6BAAA;EzFgwTN;;EAEA;IyF9vTU,0BAAA;EzFgwTV;;EyFxvTM;;IzF4vTJ,8BAA8B;EyFrvTjC;;EAIC;;IAGA,gCAAc;EACb;;EAKC;;IAEI,iCAAoB;EACpB;;EzFkvTN;;IyF7uTU,+BAAkB;EzFgvT5B;;EAEA;IyF5uTM,wBAAA;EzF8uTN;;EAEA;;IAEE,4B0Fp+Tc;E1Fq+ThB;;EAEA;;IAEE,8ByFxuTiC;EzFyuTnC;;EAEA;;IAEE,+ByFxuTmB;EzFyuTrB;;EAEA;;IAEE,6BgBn6T8B;EhBo6ThC;;EAEA;IACE,2ByFruTC;EzFsuTH;;EAEA;;IAEE,+ByFnuTC;EzFouTH;;EAEA;;IAEE,iCyF/tTiC;EzFguTnC;;EAEA;;IAEE,kCyF9tT4B;EzF+tT9B;;EAEA;;IAEE,gCG/gUF;EHghUA;;EyF1tTM;IACI,0BAAc;EzF6tTxB;;EAEA;;IAEE,8ByF1tT6B;EzF2tT/B;;E2FziUA;;IAGA,gCAAK;E3F2iUL;;EAEA;;I2FpiUE,iCAAkB;E3FuiUpB;;EAEA;;I2FhiUE,+BAAsB;E3FmiUxB;;EAEA;I2F/hUE,wBAAiB;EAGnB;;E3FgiUA;;I2F1hUE,4BAAe;EAGjB;;E3F4hUA;;I2FthUE,8BAAe;EAGjB;;E3FwhUA;;I2FlhUA,+BAAe;E3FqhUf;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;I2FxgUA,iCAAA;E3F2gUA;;E2FtgUA;;IAEE,+BAAqB;E3FygUvB;;E2FrgUA;IACE,wBAAQ;E3FwgUV;;EAEA;;I2FngUE,4BAAe;EAGjB;;E3FqgUA;;I2FjgUE,8BAAsB;E3FogUxB;;EAEA;;I2F7/TA,+BAAO;E3FggUP;;EAEA;;I2Fz/TE,6BAAoB;EAGtB;;E3F2/TA;I2Ft/TA,uBAAA;E3Fw/TA;;E2Fn/TA;;IAEE,2BAAoB;EAGtB;;E3Fq/TA;;I2F9+TE,6BAAgD;E3Fi/TlD;;EAEA;;I2Fz+TU,8BAAuB;E3F4+TjC;;E2F5+TU;;IATR,4BAAc;EASN;A3Fk/TZ;;AAEA;EACE;I2F9/TE,oBAAc;EASN;;E3Fy/TV;;I2FngUE,wBAAc;E3FsgUhB;;EAEA;;I2F9/TU,0BAAuB;E3FigUjC;;E2FjgUU;;IATR,2BAAc;ECnGd;;E5FonUF;;I2FxgUU,yBAAuB;E3F2gUjC;;EAEA;IACE,0B2FxhUc;E3FyhUhB;;EAEA;;I2FjhUU,8BAAuB;E3FohUjC;;EAEA;;IAEE,gC2FjiUc;E3FkiUhB;;EAEA;;IAEE,iC2FviUgD;E3FwiUlD;;EAEA;;I2FhiUU,+BAAuB;E3FmiUjC;;EAEA;IACE,yB2FhjUc;E3FijUhB;;EAEA;;I4FrpUE,6BAAyB;E5FwpU3B;;EAEA;;IAEE,+B2F1jUgD;E3F2jUlD;;EAEA;;I2FnjUU,gCAAuB;E3FsjUjC;;EAEA;;IAEE,8B2FnkUc;E3FokUhB;;EAEA;I2F7jUU,uBAAuB;E3F+jUjC;;EAEA;;IAEE,2B2F5kUc;E3F6kUhB;;EAEA;;IAEE,6B2FllUgD;E3FmlUlD;;EAEA;;I2F3kUU,8BAAuB;E3F8kUjC;;E4F1rUE;;I5F8rUA,4B2F5lU6B;E3F6lU/B;;EAEA;IACE,yB2F/lUc;E3FgmUhB;;EAEA;;IAEE,6B2FrmUgD;E3FsmUlD;;EAEA;;I2F9lUU,+BAAuB;E3FimUjC;;EAEA;;IAEE,gC2F9mUc;E3F+mUhB;;EAEA;;IAEE,8B2FpnUgD;E3FqnUlD;;EAEA;IACE,uB2FvnUc;E3FwnUhB;;EAEA;;IAEE,2B2F7nUc;E3F8nUhB;;EAEA;;IAEE,6B2FjoUc;E3FkoUhB;;EAEA;;IAEE,8B2FvoUgD;E3FwoUlD;;EAEA;;I2FhoUU,4BAAuB;E3FmoUjC;;EAEA;IACE,qB2FhpUc;E3FipUhB;;EAEA;;I2FzoUU,yBAAuB;E3F4oUjC;;EAEA;;IAEE,2B2FzpUc;E3F0pUhB;;EAEA;;IAEE,4B2F/pUc;E3FgqUhB;;EAEA;;I4FpwUE,0BAAyB;E5FuwU3B;;EAEA;I2F7pUU,2BAAuB;E3F+pUjC;;EAEA;;IAEE,+B2F5qUc;E3F6qUhB;;EAEA;;IAEE,iC2FlrUgD;E3FmrUlD;;EAEA;;I2F3qUU,kCAAuB;E3F8qUjC;;EAEA;;IAEE,gC2F3rUc;E3F4rUhB;;EAEA;I2FrrUU,0BAAuB;E3FurUjC;;EAEA;;IAEE,8B2FpsUc;E3FqsUhB;;EAEA;;IAEE,gC2F3qUqC;E3F4qUvC;;E2FxqUQ;;IAEE,iCAA2B;E3F2qUrC;;EAEA;;I2FjrUU,+BAAiC;EAEnC;;E3ForUR;I2FjrUU,wBAAgB;EARlB;;E3F6rUR;;I2FxrUQ,4BAAA;E3F2rUR;;EAEA;;IAEE,8B2FnsUqC;E3FosUvC;;E2FhsUQ;;IAEE,+BAA2B;E3FmsUrC;;EAEA;;I2FzsUU,6BAAe;EAEjB;;E3F4sUR;I2FzsUU,0BAAgB;EARlB;;E3FqtUR;;I2FhtUQ,8BAAA;E3FmtUR;;EAEA;;IAEE,gC2F3tUqC;E3F4tUvC;;E2FxtUQ;;IAEE,iCAA2B;E3F2tUrC;;EAEA;;I2FjuUU,+BAAe;EAEjB;;E3FouUR;I2FjuUU,wBAAgB;EARlB;;E3F6uUR;;I2FxuUQ,4BAAA;E3F2uUR;;EAEA;;IAEE,8B2FnvUqC;E3FovUvC;;E2FhvUQ;;IAEE,+BAA2B;E3FmvUrC;;EAEA;;I2FzvUU,6BAAe;EAEjB;;E3F4vUR;I2FzvUU,2BAAgB;EARlB;;E3FqwUR;;I2FhwUQ,+BAAA;E3FmwUR;;EAEA;;I2F5vUM,iCAA0B;E3F+vUhC;;EAEA;;I2F1vUI,kCAAiB;E3F6vUrB;;E4Fl5UE;;I5Fs5UA,gC2FrxUqC;E3FsxUvC;;EAEA;IACE,0B2FpxUqC;E3FqxUvC;;EAEA;;IAEE,8B2F7xUoC;E3F8xUtC;;EAEA;;IAEE,gC2F5xUwB;E3F6xU1B;;EAEA;;I2FlyUQ,iCAAA;E3FqyUR;;EAEA;;IAEE,+B2F7yUqC;E3F8yUvC;;EAEA;IACE,wB2F5yUqC;E3F6yUvC;;EAEA;;IAEE,4B2FrzUoC;E3FszUtC;;EAEA;;IAEE,8B2FpzUwB;E3FqzU1B;;EAEA;;I2F1zUQ,+BAAA;E3F6zUR;;EAEA;;IAEE,6B2Fr0UqC;E3Fs0UvC;;EAEA;IACE,0B2Fp0UqC;E3Fq0UvC;;EAEA;;IAEE,8B2F70UoC;E3F80UtC;;EAEA;;IAEE,gC2F50UwB;E3F60U1B;;EAEA;;I2Fl1UQ,iCAAA;E3Fq1UR;;EAEA;;IAEE,+B2F71UqC;E3F81UvC;;EAEA;IACE,wB2F51UqC;E3F61UvC;;EAEA;;IAEE,4B2Fr2UwB;E3Fs2U1B;;EAEA;;IAEE,8B2Fp2UwB;E3Fq2U1B;;EAEA;;I2F12UQ,+BAAA;E3F62UR;;EAEA;;IAEE,6B2Fx2U8B;E3Fy2UhC;;EAEA;IACE,uB2Fv2UiB;E3Fw2UnB;;EAEA;;I2F73UQ,2BAAA;E3Fg4UR;;EAEA;;IAEE,6B2F93UqC;E3F+3UvC;;EAEA;;IAEE,8B2Fv4UoC;E3Fw4UtC;;EAEA;;IAEE,4B2Ft4UwB;E3Fu4U1B;AACF;;AAEA;EACE;IACE,oB2F94UqC;E3F+4UvC;;EAEA;;IAEE,wB2Fv5UwB;E3Fw5U1B;;EAEA;;IAEE,0B2Ft5UwB;E3Fu5U1B;;EAEA;;I2F55UQ,2BAAA;E3F+5UR;;EAEA;;IAEE,yB2Fv6UqC;E3Fw6UvC;;EAEA;IACE,0B2Ft6UqC;E3Fu6UvC;;EAEA;;IAEE,8B2F/6UoC;E3Fg7UtC;;EAEA;;IAEE,gC2F96U0C;E3F+6U5C;;EAEA;;I2Fp7UQ,iCAAA;E3Fu7UR;;EAEA;;IAEE,+B2F/7UqC;E3Fg8UvC;;EAEA;IACE,yB2F97UqC;E3F+7UvC;;EAEA;;IAEE,6B2Fv8UoC;E3Fw8UtC;;EAEA;;IAEE,+B2Ft8UwB;E3Fu8U1B;;EAEA;;I2F58UQ,gCAAA;E3F+8UR;;EAEA;;IAEE,8B2Fv9UqC;E3Fw9UvC;;EAEA;IACE,uB2Ft9UqC;E3Fu9UvC;;EAEA;;IAEE,2B2Fl9UiB;E3Fm9UnB;;EAEA;;IAEE,6B2Fh9UkB;E3Fi9UpB;;EAEA;;IAEE,8B2Fz+UoC;E3F0+UtC;;EAEA;;IAEE,4B2Fx+U0C;E3Fy+U5C;;EAEA;IACE,yB2Fj/UuB;E3Fk/UzB;;EAEA;;I2Fv/UQ,6BAAA;E3F0/UR;;EAEA;;IAEE,+B2Fx/UqC;E3Fy/UvC;;EAEA;;IAEE,gC2FjgVoC;E3FkgVtC;;EAEA;;IAEE,8B2FhgVwB;E3FigV1B;;EAEA;IACE,uB2FzgVuB;E3F0gVzB;;EAEA;;I2F/gVQ,2BAAA;E3FkhVR;;EAEA;;IAEE,6B2FhhVqC;E3FihVvC;;EAEA;;IAEE,8B2FzhVoC;E3F0hVtC;;EAEA;;IAEE,4B2FxhVwB;E3FyhV1B;;EAEA;IACE,qB2FjiVuB;E3FkiVzB;;EAEA;;I2FviVQ,yBAAA;E3F0iVR;;EAEA;;IAEE,2B2FxiVqC;E3FyiVvC;;EAEA;;IAEE,4B2FjjVwB;E3FkjV1B;;EAEA;;IAEE,0B2FhjVwB;E3FijV1B;;EAEA;IACE,2B2FzjVuB;E3F0jVzB;;EAEA;;I2F/jVQ,+BAAA;E3FkkVR;;EAEA;;IAEE,iC2FhkVqC;E3FikVvC;;EAEA;;IAEE,kC2F5jVgC;E3F6jVlC;;EAEA;;IAEE,gC2F1jViC;E3F2jVnC;;EAEA;IACE,0B2FnlVqC;E3FolVvC;;EAEA;;IAEE,8B2FllVmC;E3FmlVrC;;EAEA;;IAEE,gC2F3lVuB;E3F4lVzB;;EAEA;;I2FjmVQ,iCAAA;E3FomVR;;EAEA;;IAEE,+B2FlmVqC;E3FmmVvC;;EAEA;IACE,wB2F3mVqC;E3F4mVvC;;EAEA;;IAEE,4B2F1mVmC;E3F2mVrC;;EAEA;;IAEE,8B2FnnVuB;E3FonVzB;;EAEA;;I2FznVQ,+BAAA;E3F4nVR;;EAEA;;IAEE,6B2F1nVqC;E3F2nVvC;;EAEA;IACE,0B2FnoVqC;E3FooVvC;;EAEA;;IAEE,8B2FloVmC;E3FmoVrC;;EAEA;;IAEE,gC2F3oVuB;E3F4oVzB;;EAEA;;I2FjpVQ,iCAAA;E3FopVR;;EAEA;;IAEE,+B2FlpVqC;E3FmpVvC;;EAEA;IACE,wB2F3pVqC;E3F4pVvC;;EAEA;;IAEE,4B2F1pVmC;E3F2pVrC;;EAEA;;IAEE,8B2FnqVuB;E3FoqVzB;;EAEA;;I2FzqVQ,+BAAA;E3F4qVR;;EAEA;;IAEE,6B2F1qVqC;E3F2qVvC;;EAEA;IACE,2B2FtqVkB;E3FuqVpB;;EAEA;;I2FlqVI,+BAAiB;E3FqqVrB;;E4F1zVE;;I5F8zVA,iC2F7rVqC;E3F8rVvC;;EAEA;;IAEE,kC2F5rVmC;E3F6rVrC;;EAEA;;IAEE,gC2FrsVuB;E3FssVzB;;EAEA;IACE,0B2FpsVwB;E3FqsV1B;;EAEA;;I2F1sVQ,8BAAA;E3F6sVR;;EAEA;;IAEE,gC2FrtVqC;E3FstVvC;;EAEA;;IAEE,iC2FptVmC;E3FqtVrC;;EAEA;;IAEE,+B2F7tVuB;E3F8tVzB;;EAEA;IACE,wB2F5tVwB;E3F6tV1B;;EAEA;;I2FluVQ,4BAAA;E3FquVR;;EAEA;;IAEE,8B2F7uVqC;E3F8uVvC;;EAEA;;IAEE,+B2F5uVmC;E3F6uVrC;;EAEA;;IAEE,6B2FrvVuB;E3FsvVzB;;EAEA;IACE,0B2FpvVwB;E3FqvV1B;;EAEA;;I2F1vVQ,8BAAA;E3F6vVR;;EAEA;;IAEE,gC2FrwVqC;E3FswVvC;;EAEA;;IAEE,iC2FpwVmC;E3FqwVrC;;EAEA;;IAEE,+B2F7wVuB;E3F8wVzB;;EAEA;IACE,wB2F5wVwB;E3F6wV1B;;EAEA;;I2FlxVQ,4BAAA;E3FqxVR;;EAEA;;IAEE,8B2FhxV8B;E3FixVhC;;EAEA;;I2F5wVI,+BAAiB;E3F+wVrB;;E2FrwVI;;IACA,6BAAqB;E3FywVzB;;EAEA;IACE,uB2F7wVuC;E3F8wVzC;;E4F76VE;;I5Fi7VA,2B2FlxVuC;E3FmxVzC;;E4Fl7VE;;I5Fs7VA,6B2FvxVsD;E3FwxVxD;;E4Fv7VE;;I5F27VA,8B2F5xVsD;E3F6xVxD;;E4F57VE;;I5Fg8VA,4B2FjyVuC;E3FkyVzC;AACF;;A6Fx+VU;EACE;IACA,oBAAe;EAQjB;;EAEE;;IAXA,wBAAoB;EACpB;;EASA;;IAXF,0BAA+B;EAC7B;;EASF;;IAEE,2BAAgB;EAZlB;;EAEE;;IASA,yBAAmB;EACnB;;EAXA;IACA,0BAAe;EAQjB;;EAEE;;IAXA,8BAAoB;EACpB;;EASA;;IAXF,gCAA+B;EAC7B;;EASF;;IAEE,iCAAkC;EAZpC;;EAEE;;IASA,+BAAmB;EACnB;;EAXA;IACA,yBAAe;EAQjB;;EAEE;;IAXA,6BAAoB;EACpB;;EASA;;IAXF,+BAA+B;EAC7B;;EASF;;IAEE,gCAAkC;EAZpC;;EAEE;;IASA,8BAAmB;EACnB;;EAMJ;IACA,uBAAa;EAEf;;EAEE;;IAGA,2BAA6B;EAC7B;;EAGA;;IDQJ,6BAAyB;ECtCnB;;E7FikWR;;I6FtjWU,8BAAmB;E7FyjW7B;;EAEA;;I6F5jWQ,4BAA+B;E7F+jWvC;;E6FzkWQ;IACE,yBAAoB;E7F4kW9B;;EAEA;;I6F/kWQ,6BAA+B;E7FklWvC;;E6FxkWQ;;IAEE,+BAAkC;EAZpC;;E7FylWR;;I6F9kWU,gCAAmB;E7FilW7B;;EAEA;;I6FplWQ,8BAA+B;E7FulWvC;;E6FjmWQ;IACE,uBAAoB;E7FomW9B;;EAEA;;I6FvmWQ,2BAA+B;E7F0mWvC;;E6FhmWQ;;IAEE,6BAAgB;EAZlB;;E7FinWR;;I6FtmWU,8BAAmB;E7FymW7B;;EAEA;;I6F5mWQ,4BAA+B;E7F+mWvC;;E6FznWQ;IACE,qBAAoB;E7F4nW9B;;EAEA;;I6F/nWQ,yBAA+B;E7FkoWvC;;E6FxnWQ;;IAEE,2BAAgB;EAKtB;;E7FwnWJ;;I6FnnWM,4BAAc;E7FsnWpB;;EAEA;;I6FjnWI,0BAAkB;E7FonWtB;;E4F3mWE;ICtCM,2BAA+B;E7FqpWvC;;E6F3oWQ;;IAEE,+BAAkC;EAZpC;;E7F4pWR;;I6FjpWU,iCAAmB;E7FopW7B;;EAEA;;I6FvpWQ,kCAA+B;E7F0pWvC;;E6FpqWQ;;IAEE,gCAAiC;EAQnC;;E7FiqWR;I6F3qWQ,0BAA+B;E7F6qWvC;;E6FnqWQ;;IAEE,8BAAgB;EAZlB;;E7ForWR;;I6FzqWU,gCAAmB;E7F4qW7B;;EAEA;;I6F/qWQ,iCAA+B;E7FkrWvC;;E6F5rWQ;;IAEE,+BAAe;EAQjB;;E7FyrWR;I6FnsWQ,wBAA+B;E7FqsWvC;;E6F3rWQ;;IAEE,4BAAgB;EAZlB;;E7F4sWR;;I6FjsWU,8BAAmB;E7FosW7B;;EAEA;;I6FvsWQ,+BAA+B;E7F0sWvC;;E6FptWQ;;IAEE,6BAAiC;EAQnC;;E7FitWR;I6F1sWI,0BAAkB;E7F4sWtB;;E6FxsWI;;IAEE,8BAA4B;EAE9B;;E7F2sWJ;;I6FtsWM,gCAA6B;E7FysWnC;;E6FvuWQ;;IAEE,iCAAiC;EAQnC;;E7FouWR;;I6F7uWU,+BAAoB;E7FgvW9B;;EAEA;I6FvuWU,wBAAgB;EAZlB;;E7FuvWR;;I6F5uWU,4BAAmB;E7F+uW7B;;EAEA;;I6FlvWQ,8BAA+B;E7FqvWvC;;E6F/vWQ;;IAEE,+BAAiC;EAQnC;;E7F4vWR;;I6FrwWU,6BAAoB;E7FwwW9B;;EAEA;I6F/vWU,2BAAgB;EAZlB;;E7F+wWR;;I6FpwWU,+BAAmB;E7FuwW7B;;EAEA;;I6F1wWQ,iCAA+B;E7F6wWvC;;E6FvxWQ;;IAEE,kCAAiC;EAQnC;;E7FoxWR;;I6F7xWU,gCAAoB;E7FgyW9B;;EAEA;I6FvxWU,0BAAgB;EAZlB;;E7FuyWR;;I6F5xWU,8BAAmB;E7F+xW7B;;EAEA;;I6FlyWQ,gCAA+B;E7FqyWvC;;E6F9xWI;;IAEE,iCAA4B;EAE9B;;E7FiyWJ;;I6F5xWM,+BAA6B;E7F+xWnC;;EAEA;I6F5xWM,wBAAa;EDOjB;;E5FyxWF;;I6FrzWQ,4BAA+B;E7FwzWvC;;E6Fl0WQ;;IAEE,8BAAe;EAQjB;;E7F+zWR;;I6Fx0WU,+BAAoB;E7F20W9B;;EAEA;;I6F90WQ,6BAA+B;E7Fi1WvC;;E6Fv0WQ;IACE,0BAAmB;E7F00W7B;;EAEA;;I6F70WQ,8BAA+B;E7Fg1WvC;;E6F11WQ;;IAEE,gCAAiC;EAQnC;;E7Fu1WR;;I6Fh2WU,iCAAoB;E7Fm2W9B;;EAEA;;I6Ft2WQ,+BAA+B;E7Fy2WvC;;E6F/1WQ;IACE,wBAAmB;E7Fk2W7B;;EAEA;;I6Fr2WQ,4BAA+B;E7Fw2WvC;;E6Fl3WQ;;IAEE,8BAAiC;EAQnC;;E7F+2WR;;I6Fx3WU,+BAAoB;E7F23W9B;;EAEA;;I6F93WQ,6BAA+B;E7Fi4WvC;;E6Fv3WQ;IACE,uBAAmB;E7F03W7B;;EAEA;;I6Fl3WI,2BAAkB;E7Fq3WtB;;E6Fj3WI;;IAEE,6BAAyB;EAE3B;;E7Fo3WJ;;I6Fj5WQ,8BAA+B;E7Fo5WvC;;E6F14WQ;;IAEE,4BAAkC;EAZpC;A7F05WV;;AAEA;EACE,kB6Fl5WyB;E7Fm5WzB,M6Fl5WU;EAZF,QAAA;E7Fg6WR,S6F/5WU;E7Fg6WV,O6F/5WU;EAQF,UAAA;E7Fy5WR,oB6Fx5W6B;E7Fy5W7B,W6Fx5WU;EAZF,kCAA+B;A7Fs6WzC;;AAEA;EACE,4G6F95W6B;A7F+5W/B;;AAEA;EACE,8B6F36WyB;A7F46W3B;;AAEA;E6Fh7WU,8BAA+B;A7Fk7WzC;;AAEA;EACE,8B6F16W6B;A7F26W/B;;AAEA;EACE,gB6Fv7WyB;EAQjB,uBAA+B;E7Fi7WvC,mB6Fh7WyB;A7Fi7W3B;;AAEA;EACE,2B6F77WyB;A7F87W3B;;AAEA;E6Fl8WU,4BAA+B;A7Fo8WzC;;AAEA;EACE,6B6F57W6B;A7F67W/B;;AAEA;EACE;I6Fj8WQ,2BAA+B;E7Fm8WvC;;E6F78WQ;IACE,4BAAoB;E7Fg9W9B;;EAEA;I6Fv8WU,6BAAgB;EAZlB;A7Fs9WV;;AAEA;EACE;I6F78WU,2BAAgB;EAKtB;;E7F48WJ;I6Fx8WI,4BAAkB;E7F08WtB;;E6Ft8WI;IACE,6BAA6B;E7Fy8WnC;AACF;;AAEA;E6F77WM;ICzDJ,2BAAuB;ED0DnB;;EACA;ICxDJ,4BAAsB;EFmDpB;;E5Fy8WF;I6Fr8WI,6BAAsB;E7Fu8W1B;AACF;;A4F58WI;ECGE;ICzDJ,2BAAuB;ED0DnB;;EACA;ICxDJ,4BAAsB;EFmDpB;;E5Fu9WF;I6Fn9WI,6BAAsB;E7Fq9W1B;AACF;;A4F19WI;ECGE;ICzDJ,2BAAuB;ED0DnB;;EACA;ICxDJ,4BAAsB;EFmDpB;;E5Fq+WF;I6Fj+WI,6BAAsB;E7Fm+W1B;AACF;;AAEA;E6Fx9WU,oCAAA;A7F09WV;;AAEA;E6Fn9WM,oCAAW;A7Fq9WjB;;AAEA;E6Fj9WU,qCAA0B;AAI9B;;A7Fi9WN;E6F58WM,2BAAA;A7F88WN;;AAEA;E6F18WG,+BAAW;A7F48Wd;;AAEA;E6Fz8WG,2BAAA;A7F28WH;;AAEA;E+FxjXQ,2BAAA;A/F0jXR;;A+FnjXQ;EACI,8BAAU;A/FsjXtB;;AAEA;E+FjjXQ,6BAAW;A/FmjXnB;;AAEA;E+FhjXQ,sBAAA;A/FkjXR;;AAEA;EACE,yB+FhjXmB;A/FijXrB;;AAEA;;EAEE,yB+F7iXU;A/F8iXZ;;AAEA;EACE,yB4F/gXE;A5FghXJ;;A+FpiXI;;EAEI,yBAAgB;A/FuiXxB;;AAEA;E4FvhXI,yBAAA;A5FyhXJ;;A+F7hXgB;;E/FiiXd,yBAAyB;A+FjhX1B;;A/FohXD;E+F/gXC,yBAAA;A/FihXD;;AgGvmXI;;EAEI,yBAAyB;AhG0mXjC;;AAEA;EACE,yBgGzmXyB;AhG0mX3B;;AAEA;;EAEE,yBgG3mXM;AhG4mXR;;AAEA;EACE,yBgGrmXU;AhGsmXZ;;AAEA;;EAEE,yBgGjmX0B;AhGkmX5B;;AAEA;EgG1lXO,yBAAsB;AhG4lX7B;;AAEA;;EgGzlXG,yBAAA;AhG4lXH;;AAEA;EgG1lXI,yBAAA;AhG4lXJ;;AAEA;;EgGnlXY,yBAAU;AhGslXtB;;AAEA;EACE,yBgGplXwB;AAKxB;;AAKM;EACI,yBAAoB;AhG8kXhC;;AAEA;EgGxkXY,oCAAuB;AAGhC;;AhGykXH;EgGlkXQ,0CAAA;AhGokXR;;AgG/jXG;EACC,WAAS;EACT,kBAAe;EhGkkXjB,iBAAiB;EiGtqXnB,6BAAkB;EACjB,SAAA;AjGwqXD;;AAEA;EACE,gCiGpqXqB;AjGqqXvB;;AAEA;EACE,iCiGnqXE;EjGoqXF,gCiGnqXY;AjGoqXd;;AAEA;EACE,yBiGhqXiB;AjGiqXnB;;AAEA;EACE,8BiGhqXsB;AjGiqXxB;;AAEA;EACE,6BiGzpXiC;AjG0pXnC;;AAEA;;EAEE;;;IAGE,4BiGjpXa;IAgBe,2BAAA;EjGmoX9B;;EAEA;IkGxsXA,0BAAW;EACV;;EAGG;IACH,6BAAqB;EAEtB;;EAEC;IAED,gCAAA;ElGusXA;;EAEA;;IkGpsXC,yBAAe;IAEV,wBAAA;EACI;;EAEA;IACR,2BAAsB;EAEd;;EAMA;;IAGT,wBAAA;EACC;;EAMQ;;;IAOI,UAAY;IAKhB,SAAA;EACI;;EAIb;;IAGD,uBAAA;EACI;;ElGkrXJ;IkG5qXF,QAAA;EAEE;;ECrEE;IACI,2BAAgB;EAChB;;EAGA;IACI,2BAAO;EnGmvXjB;;EAEA;ImG/uXU,aAAW;EnGivXrB;;EmG5uXD;IACC,sBAAgB;EnG+uXhB;;EoGhwXU;IACA,oCAAe;ERmEvB;;E5FksXF;;IoG5vXc,iCAAgB;EAKpB;;EAMA;;IAMA,oCAAA;EACI;;EAMA;IpG+uXZ,cAAc;EqGnxXlB;;EAEI;;;;IAIA,qBAAY;EACf;;ErGsxXC;IqGjxXE,cAAQ;IACJ,qBAAW;ErGmxXjB;AACF;;AAEA;EqG/wXI,eAAO;ArGixXX;;AqG7wXA;EACI,aAAa;EACb,UAAU;ArGgxXd;;AAEA;EACE,SqGhxXM;ErGixXN,UAAU;AqG7wXZ;;ArGgxXA;EqG7wXC,SAAA;EACA,UAAA;ArG+wXD;;AqG3wXA;EACE,WAAG;ErG8wXH,mBqG9wXsB;ArG+wXxB;;AAEA;EACE,kBqGhxXK;EACL,YAAG;ErGixXH,kBqGjxXK;EACL,eAAG;ErGkxXH,eqGlxXK;ArGmxXP;;AAEA;EACE;IqGnxXA,mBAAI;ErGqxXJ;AACF;;AAEA;EACE;IqGtxXA,iBAAI;ErGwxXJ;AACF;;AAEA;EACE,gBqG1xXM;ArG2xXR;;AAEA;EACE,2BqG5xXyB;ArG6xX3B;;AAEA;EACE,UqG9xXM;EACN,6BAAI;ErG+xXJ,gBqG/xXM;EACN,kBAAI;ArGgyXN;;AAEA;EqGhyXE,UAAI;ArGkyXN;;AAEA;EqGlyXE,sBAAI;ArGoyXN;;AAEA;EqGnyXA,8BAyBC;ArG4wXD;;AAEA;EACE,UqGtyXK;EACL,SAAG;ArGuyXL;;AAEA;;GAEG;;AAEH;EqGzyXE,cAAI;ArG2yXN;;AAEA;;;EqG1yXE,qBAAI;ArG8yXN;;AAEA;;;EqG7yXE,qBAAI;ArGizXN;;AAEA;EqGjzXE,mBAAI;ArGmzXN;;AAEA;EqGnzXE,gBAAI;ArGqzXN;;AAEA;;;;;EqGnzXE,iBAAI;ErGyzXJ,mBqGzzXsB;EACtB,kBAAI;ArG0zXN;;AAEA;;EAEE;;;;;IqGxzXK,iBAAW;IACb,mBAAA;IAAE,kBAAW;EAChB;ArG+zXF;;AAEA;;EAEE;;;;;IqG9zXA,iBAAI;IAAE,mBAAW;IACjB,kBAAI;ErGq0XJ;AACF;;AAEA;;EqGr0XE;;;;;IAEM,iBAAW;IACjB,mBAAI;IAAE,kBAAW;EACjB;ArG40XF;;AAEA,OqG70XQ;ArG80XR;;EqG50XE,kBAAI;ErG+0XJ,mBqG/0XiB;ArGg1XnB;;AAEA;;EqG/0XE,kBAAI;ErGk1XJ,mBqGl1XiB;ArGm1XnB;;AqG30XA;;EAEI,kBAAiB;EACjB,mBAAW;ArG80Xf;;AAEA;;EqG30XI,kBrFjCW;EqFmCX,mBAAY;ArG60XhB;;AAEA;;EAEE,kBqG31XM;ErG41XN,mBqGz0XmB;ArG00XrB;;AAEA;;EAEE,kBqGj2XM;ErGk2XN,mBqGj0XkB;ArGk0XpB;;AAEA;;EqG7zXI,kBAAW;ErGg0Xb,mBqG/zXmB;ArGg0XrB;;AAEA;;EAEE,kBqG/zXY;ErGg0XZ,mBqG9zXM;ArG+zXR;;AAEA;;EAEE,iBqG7zXM;ErG8zXN,kBqG7zXuB;ArG8zXzB;;AAEA;;EAEE,iBqG3zXkB;ErG4zXlB,kBqG1zX4B;ArG2zX9B;;AAEA;;EAEE,iBqG1zXc;ErG2zXd,kBqG1zXc;ArG2zXhB;;AAEA;;EAEE,iBqG3zXY;ErG4zXZ,kBqG3zXY;ArG4zXd;;AAEA;;EAEE,iBqG3zXU;ErG4zXV,kBqG3zXI;ArG4zXN;;AAEA;;EAEE,iBqG3zXI;ErG4zXJ,kBqG3zXW;ArG4zXb;;AAEA;;EAEE,cqGxzXE;ErGyzXF,eqGvzXE;ArGwzXJ;;AAEA;;EAEE,eqGvzXG;ErGwzXH,gBgBx7XQ;AhBy7XV;;AAEA;EACE,egB57XQ;EhB67XR,uBqGhzXG;ErGizXH,oBgB97XQ;EhB+7XR,gCqGzyXE;ErG0yXF,oBgBh8XgC;AhBi8XlC;;AAEA;EACE,iBqGnyXoB;ArGoyXtB;;AAEA;EACE,mBqG/xXW;ErGgyXX,uBqG/xXa;ErGgyXb,gBqG9xXU;ArG+xXZ;;AAEA;;EAEE,gBqG9xXE;ArG+xXJ;;AAEA;EACE,YqG/xXG;ArGgyXL;;AAEA;EACE,YqG9xXc;ArG+xXhB;;AAEA;EACE,YqGxxXkB;ArGyxXpB;;AAEA;EACE,YqGxxXiB;ArGyxXnB;;AAEA;EACE,YqGzxXE;ArG0xXJ;;AAEA;EACE,YqGtxXqB;ArGuxXvB;;AAEA;EACE,YqGtxXc;ArGuxXhB;;AAEA;EACE,YqGnxXU;ArGoxXZ;;AAEA;EACE,YqG5wXO;ArG6wXT;;AAEA;EACE,mBqG1wXa;ArG2wXf;;AAEA;EACE,eAAe;EqGzwXb,YAAQ;ErG2wXV,WqG1wXa;ErG2wXb,eqG1wXS;ArG2wXX;;AAEA;EsG5lYwB,YAAQ;EAIR,mBAAA;EtG2lYtB,wEAAwE;EsG1lY9C,mBAAO;EAGX,WAAA;EtG0lYtB,cAAc;EsGzlYY,eAAa;EACb,qBAAe;EACf,kBAAgB;EAChB,qBAAoB;EACpB,oDAAW;AtG2lYvC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EsGnlYgC,cAAY;AtGqlY5C;;AAEA;EACE,csGplY6C;AASnB;;AtG8kY5B;EsG1kY4B,cAAA;AtG4kY5B;;AAEA;EsG1kYgC,cAAA;AtG4kYhC;;AsGnkY4B;EtGskY1B,cAAc;AAChB;;AAEA;EsGrkYgC,cAAY;AtGukY5C;;AAEA;EACE,csGtkY6C;AAQnB;;AtGikY5B;EsG9jY4B,cAAA;AtGgkY5B;;AAEA;EsG9jYgC,cAAA;AtGgkYhC;;AAEA;EsG7iYwB,cAAA;AtG+iYxB;;AAEA;EsG5iY4B,8BAAe;AtG8iY3C;;AAEA;EsG3iY4B,8BAAA;AtG6iY5B;;AAEA;EsGpiY4B,8BAAA;AtGsiY5B;;AsG5hY4B;EACI,8BAA2B;AAG/B;;AtG8hY5B;EsGrhY4B,8BAAA;AtGuhY5B;;AAEA;EsGphYgC,8BAAW;AAOf;;AAGA;EACI,8BAAqB;AtG+gYrD;;AsGz/XoB;EACI,8BAAgB;AAGpB;;AtG2/XpB;EsGp/XqC,gBAAA;AtGs/XrC;;AAEA;EsGh/XqC,sBAAA;AtGk/XrC;;AAEA;EsG5+XqC,kBAAA;AtG8+XrC;;AAEA;EsGx+XqC,uBAAA;AtG0+XrC;;AAEA;EsGp+XqC,qBAAA;AtGs+XrC;;AAEA;EsGh+X4B,0BAAA;EtGk+X1B,gBsGj+X0C;AtGk+X5C;;AsGx9XwB;EACI,0BAAa;EACb,gBAAe;AtG29X3C;;AAEA;EsGz9X4B,0BAAW;EAEX,gBAAA;AtG09X5B;;AAEA;EACE,0BsGz9XgD;EtG09XhD,gBsGz9X8B;AtG09XhC;;AAEA;EACE,0BsGx9XoD;EtGy9XpD,gBsGt9XuC;AtGu9XzC;;AAEA;EACE,0BsGl9XuC;EtGm9XvC,gBsGl9XkC;AtGm9XpC;;AAEA;EACE,0BsG98XoD;EtG+8XpD,gBsG58XuC;AtG68XzC;;AAEA;EACE,0BsGx8XuC;EtGy8XvC,gBsGx8XkC;AtGy8XpC;;AAEA;EACE,0BsGn8XyC;EAOf,gBAAA;AtG87X5B;;AsGn7X4B;EACpB,0BAAiB;EACjB,gBAAY;AtGs7XpB;;AAEA;EACE,0BsGr7X8C;EAQpB,gBAAA;AtG+6X5B;;AAEA;EACE,0BsGl7X0B;EtGm7X1B,gBsG96X6C;AAQnB;;AtGy6X5B;EGttYQ,0BAAA;EHwtYN,iBsG36X0B;AtG46X5B;;AsGr5XwB;EACI,0BAAa;EACb,iBAAe;AtGw5X3C;;AAEA;EsGj5XgC,0BAAW;EASf,iBAAA;AtG24X5B;;AsGl4X4B;EACI,0BAAoB;EACpB,iBAAW;AAOf;;AtGg4X5B;EACE,0BAA0B;EChsY5B,iBAAA;AEpGA;;AHwyYA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EGryY1B,iBAAA;AoGJC;;AvG6yYH;EACE,gBuG1yYc;AvG2yYhB;;AAEA;EACE,gBG3uYD;AH4uYD;;AAEA;EACE,gBGzxYM;AH0xYR;;AAEA;EuGxyYK,gBAAA;AvG0yYL;;AAEA;EACE,gB0F9tYgB;A1F+tYlB;;AAEA;EACE,gBuGryYgB;AvGsyYlB;;AAEA;EGxyYQ,gBAAA;AH0yYR;;AuG5xYQ;EACI,gBAAW;AvG+xYvB;;AAEA;EACE,gBuG9xY2B;AvG+xY7B;;AAEA;EuGtxYE,qBAAA;EvGwxYA,0BAA0B;EuGtxYzB,6BAAY;EAEP,yBAAA;EACI,wBAAkB;EAClB,qBAAW;AvGuxYvB;;AAEA;EuGnxYQ,qBAAA;EACI,0BAAW;EACX,6BAAiB;EACjB,yBAAkB;EAClB,wBAAA;EvGqxYV,qBuGpxY2B;AvGqxY7B;;AAEA;EuG9wYgB,qBAAA;EvGgxYd,0BuG/wYoC;EvGgxYpC,6BuG9wYkB;EvG+wYlB,yBuG9wYmC;EvG+wYnC,wB0FzvYO;E1F0vYP,qBuG9wYgB;AvG+wYlB;;AAEA;EACE,qBuG7wYoB;EvG8wYpB,0BuG5wYI;EvG6wYJ,6BuG5wYiB;EvG6wYjB,yBuG1wYkB;EvG2wYlB,wBuG1wYwC;EvG2wYxC,qBuG1wYc;AvG2wYhB;;AAEA;EACE,qBuG1wYiB;EvG2wYjB,0BuG1wYqB;EvG2wYrB,6BuG1wY2B;EvG2wY3B,yBuG1wYgB;EvG2wYhB,wBuG1wYsB;EvG2wYtB,qBuG1wYkB;AvG2wYpB;;AAEA;EACE,mBuG1wYgB;EvG2wYhB,wBuG1wYuB;EvG2wYvB,2BuG1wYwB;EvG2wYxB,uBuG1wYgB;EvG2wYhB,sBuG1wYiB;EvG2wYjB,qBuG1wYgB;AvG2wYlB;;AAEA;EACE,YuG1wYW;AvG2wYb;;AAEA;EACE,YuGzwY+B;AvG0wYjC;;AAEA;EACE,YuGrwYM;AvGswYR;;AAEA;EACE,YuGjwY8B;AvGkwYhC;;AAEA;EACE,YuG/vYY;AvGgwYd;;AAEA;EACE,YuG7vY8B;AvG8vYhC;;AAEA;EACE,YuG3vYW;AvG4vYb;;AAEA;EACE,YuGzvYkB;AvG0vYpB;;AAEA;EACE,YuGvvYI;AvGwvYN;;AAEA;EACE,auGnvYuC;AvGovYzC;;AAEA;EACE,auGjvYK;AvGkvYP;;AAEA;EACE,auGhvYK;AvGivYP;;AAEA;EACE,auG9uYc;AvG+uYhB;;AAEA;EACE,auG5uY0B;AvG6uY5B;;AAEA;EACE,auG5uYO;AvG6uYT;;AAEA;EuGluYQ,aAAA;AvGouYR;;AAEA;EACE,auGnuYyB;AvGouY3B;;AAEA;EuGhuYqB,aAAA;AvGkuYrB;;AAEA;EuG5tYC,aAAA;AvG8tYD;;AAEA;EACE,aAAa;AGz9Yf;;AH49YA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AC93YA;EEnCQ,aAAA;AHq6YR;;AAEA;EACE,awGh+YuB;AxGi+YzB;;AAEA;EACE,awGh+YsB;AxGi+YxB;;AAEA;EACE,awG59YuB;AxG69YzB;;AAEA;EACE,awG19YE;AxG29YJ;;AAEA;EACE,awGx9YoB;AxGy9YtB;;AAEA;EACE,awGv9YU;AxGw9YZ;;AAEA;EACE,awGr9YsB;AxGs9YxB;;AAEA;EACE,awGp9YyB;AxGq9Y3B;;AAEA;EACE,awG98YK;AxG+8YP;;AAEA;EACE,awG38Y2B;AxG48Y7B;;AAEA;EACE,awG38YsB;AxG48YxB;;AAEA;EACE,awG38YI;AxG48YN;;AAEA;EACE,awG18Y0B;AxG28Y5B;;AAEA;EACE,awGp8YqC;AxGq8YvC;;AAEA;EwG37YQ,aAAA;AxG67YR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,awG36YkC;AxG46YpC;;AAEA;EACE,awG36Ya;ArGpGb;;AHkhZF;EACE,awGt6YmC;ArG1E7B;;AHm/YR;EACE,awGl6YI;AxGm6YN;;AAEA;EACE,WwG/5Ya;AxGg6Yf;;AAEA;EACE,WwG/5YY;AxGg6Yd;;AAEA;EACE,WwG95YW;AxG+5Yb;;AAEA;EACE,W0Fl+YgB;A1Fm+YlB;;AAEA;EwGl5YwB,WAAA;AxGo5YxB;;AAEA;EACE,WwGn5Ya;AxGo5Yf;;AAEA;EACE,WwG94YkC;AxG+4YpC;;AAEA;EACE,WwG34YkC;AxG44YpC;;AAEA;EACE,WwG34YY;AxG44Yd;;AAEA;EACE,YwG34YW;AxG44Yb;;AAEA;EACE,YwG14YM;AxG24YR;;AAEA;EACE,YwG14YM;AxG24YR;;AAEA;EACE,YwG14YW;AxG24Yb;;AAEA;EACE,YwGv4YY;AxGw4Yd;;AAEA;EACE,YwGr4YS;AxGs4YX;;AAEA;EACE,YwG93YM;AxG+3YR;;AAEA;EACE,YwG93YQ;AxG+3YV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YwGh3YU;AxGi3YZ;;AAEA;EACE,YwGh3YG;AxGi3YL;;AAEA;EG1mZE,YAAA;AH4mZF;;AAEA;EACE,YwG/1Y+B;AvG1MjC;;AD4iZA;EACE,YyG1oZiB;AzG2oZnB;;AAEA;EACE,YyGvoZa;AzGwoZf;;AAEA;EACE,YyGpoZU;AzGqoZZ;;AAEA;EACE,YyGloZkB;AzGmoZpB;;AAEA;EACE,YyGhoZU;AzGioZZ;;AAEA;EACE,YyG7nZC;AzG8nZH;;AAEA;EACE,YyG1nZU;AzG2nZZ;;AAEA;EACE,YyGxnZc;AzGynZhB;;AAEA;EACE,YyGtnZG;AzGunZL;;AAEA;EACE,YyGpnZkB;AzGqnZpB;;AAEA;EACE,YyG/mZkB;AzGgnZpB;;AAEA;EACE,YyG/mZsB;AzGgnZxB;;AAEA;EACE,YyG/mZsB;AzGgnZxB;;AAEA;EACE,YyG/mZI;AzGgnZN;;AAEA;EACE,YyG5mZsB;AzG6mZxB;;AAEA;EACE,YyG3mZ8B;AzG4mZhC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAgBA;EACE;IAGE,qCyGzlZmB;EzG0lZrB;;EAEA;IAGE,mCyG5kZgB;EzG6kZlB;AACF;;AAEA;EACE;IAGE,qCyGvkZoB;EzGwkZtB;;EAEA;IAGE,mCyGpkZ0B;EzGqkZ5B;AACF;;AAEA;EACE;IAGE,qCyGnkZgB;EzGokZlB;;EAEA;IAGE,mCyG5jZgD;EzG6jZlD;AACF;;AAEA;EACE,4ByGrjZ6C;AzGsjZ/C;;AAEA;EACE;IACE,uByGxiZ+B;IzGyiZ/B,wByGxiZmC;EzGyiZrC;;EAEA;IyG3hZM,wBAAA;IACI,yBAAc;EzG6hZxB;;EAEA;IACE,ayG5hZY;IAIR,cAAA;EzG0hZN;;EAEA;IyGthZM,wBAAA;IACI,yBAAU;EzGwhZpB;;EAEA;IACE,wBAAwB;IyGhhZpB,yBAAA;EzGkhZN;;EyG5gZM;IACI,aAAa;IzG+gZrB,cAAc;EyGzgZV;;EzG4gZN;IyGzgZU,wBAAc;IzG2gZtB,yBAAyB;EyGtgZrB;;EzGygZN;IACE,wBAAwB;IyGngZpB,yBAAA;EzGqgZN;;EAEA;IyG5/YkB,aAAA;IACI,cAAS;EzG8/Y/B;;EyGv/YkB;IACI,wBAAgB;IzG0/YpC,yBAAyB;EyGl/YrB;;EzGq/YN;IyGl/YC,wBAAmB;IACf,yBAAA;EzGo/YL;;EAEA;IyG/+YU,cAAc;IAMN,eAAA;EzG4+YlB;;EAEA;IACE,gCAAgC;EyGn+Y5B;AzGq+YR;;AAEA,ayGj+YQ;AzGk+YR;EACE,eyGj+YiB;EzGk+YjB,WyGj+YgB;ECtXlB,YAAA;EAKY,OAAA;E1Gq1ZV,M0Gp1Zc;EAMX,sBAAA;A1Gg1ZL;;AAEA;EACE,S0G70ZI;E1G80ZJ,W0G70ZY;E1G80ZZ,Y0G70ZK;E1G80ZL,kB0G70ZiB;EAKH,uBAAA;A1G00ZhB;;AAEA;EACE,kB0Gt0ZiB;E1Gu0ZjB,Q0Gt0ZK;E1Gu0ZL,2B0Gt0ZsB;E1Gu0ZtB,W0Gt0ZK;E1Gu0ZL,Y0Gr0ZI;E1Gs0ZJ,yB0Gr0ZqB;E1Gs0ZrB,mB0Gp0ZI;E1Gq0ZJ,qB0Gp0ZiB;E1Gs0ZjB,4D0Gn0ZgB;A1Go0ZlB;;AAEA;EAEE,uB0Gn0Za;A1Go0Zf;;AAEA;EAEE,uBG/yZe;AHgzZjB;;AAiBA;;EAEE;;;I0GpyZA,mBAAa;EAEd;;E1GyyZC;I0GnyZM,mBAAY;EAIR;A1GmyZZ;;AAEA;EACE,uB0G9xZG;E1G+xZH,yB0G9xZgB;A1G+xZlB;;AAEA;EACE;I0GrxZG,mBAAS;E1GuxZZ;AACF;;AAEA;EACE,kB0GtxZc;A1GuxZhB;;AAEA;EACE,kB0GtxZkB;E1GuxZlB,S0GtxZI;A1GuxZN;;AAEA;EACE,c2Gh7ZU;A3Gi7ZZ;;AAEA;E2G56ZQ;IACI,yBAAe;E3G86ZzB;AACF;;AAEA;;EAEE,a2G36Zc;A3G46ZhB;;AAEA;EACE;IACE,c2Gt6ZqB;EAIjB;A3Go6ZR;;AAEA;EACE,e2Gl6Zc;E3Gm6Zd,U2Gh6ZU;A3Gi6ZZ;;AAEA;EACE,Y2G/5ZkB;EAKZ,YAAA;E3G45ZN,qB2G35Z2B;E3G45Z3B,gB2G35ZoB;E3G45ZpB,kB2G35Z0B;ExGIpB,OAAA;EHy5ZN,M2Gh6ZM;E3Gi6ZN,sB2G15Z0B;EA3D5B,wBAA0B;E3Gu9ZxB,U2Gz5ZmB;A3G05ZrB;;AAEA;EACE,e2Gv5ZuB;A3Gw5ZzB;;AAEA;EACE;IACE,e2Gj5ZgC;E3Gk5ZlC;AACF;;AAEA;EACE,a2G74ZG;A3G84ZL;;AAEA;EACE;IACE,Y2G54ZU;E3G64ZZ;AACF;;AAEA;EACE,a2G34Za;E3G44Zb,Y2G34ZS;E3G44ZT,W2G34ZK;E3G44ZL,2B2Gz4ZkB;E3G04ZlB,mB2Gz4ZgC;E3G04ZhC,mB2Gx4ZsB;E3Gy4ZtB,W2Gx4ZK;E3Gy4ZL,qB2Gx4ZgB;E3Gy4ZhB,kB2Gv4ZmC;E3Gw4ZnC,mB2Gv4ZqC;E3Gw4ZrC,gB2Gv4ZmC;A3Gw4ZrC;;AAEA;EACE;IACE,kB2Gh4ZkC;IAS1B,mBAAA;E3Gy3ZV;AACF;;AAEA;;E2G/2ZY,eAAA;E3Gk3ZV,gB2Gj3Z4B;E3Gk3Z5B,uB2Gh3ZuB;A3Gi3ZzB;;AAEA;EACE;I2G32ZuB,eAAA;I3G62ZrB,gB2G52Z0B;I3G62Z1B,uB2G52ZwB;EAKpB;A3Gy2ZR;;AAEA;EACE,gB2Gv2Z0B;EAIpB,gBAAA;E3Gq2ZN,e2Gp2ZsB;A3Gq2ZxB;;AAEA;E4GxhaA,2BAAyB;A5G0hazB;;AAEA;EACE;I4Ghhac,WAAA;IACI,YAAY;E5Gkha9B;;EAEA;IACE,a4G7gaiC;E5G8ganC;AACF;;AAEA;EACE,e4GngakB;E5GogalB,kB4GngakC;E5GogalC,iB4Glga+B;E5Gmga/B,kB4GlgasC;EAOpB,QAAA;E5G6/ZlB,2B4G5/Z+B;EAE5B,aAAA;E5G4/ZH,iB4G3/ZgB;EAGE,qBAAA;E5G0/ZlB,kB4Gz/Z8B;A5G0/ZhC;;AAEA;EACE;I4Gh/ZU,eAAA;E5Gk/ZV;AACF;;AAEA;E4G5+ZQ;IACI,eAAa;E5G8+ZvB;AACF;;AAEA;EACE,qB4Gz+ZU;E5G0+ZV,S4Gz+ZM;E5G0+ZN,kB4Gz+ZU;E5G0+ZV,Q4Gv+ZU;E5Gy+ZV,mC4Gv+Z0C;E5Gw+Z1C,W4Gl+ZsB;E5Gm+ZtB,Y4Gl+Z0B;A5Gm+Z5B;;AAEA;EACE,mB4G39Zc;E5G49Zd,c4G39Z4B;E5G49Z5B,W4G19ZkB;E5G29ZlB,kB4G19Z8B;E5G29Z9B,e4G19ZI;E5G29ZJ,kB4G19Za;E5G29Zb,iB4Gv9ZkB;E5Gy9ZlB,gC4Gv9ZgC;A5Gw9ZlC;;AAEA;EACE,W4Gv9ZsB;A5Gw9ZxB;;AAEA;EACE,W4Gr9ZK;A5Gs9ZP;;AAEA;EACE,W4G/8ZsB;A5Gg9ZxB;;AAEA;EACE,e4G/8ZK;A5Gg9ZP;;AAEA;EACE,W4G98ZM;A5G+8ZR;;AAEA;;;;K4G97ZY;A5Gm8ZZ;;E4G37ZY,WAAA;E5G87ZV,W4G77ZoB;A5G87ZtB;;AAEA;EAEE,0B4Gz7Z4B;E5G07Z5B,W4Gz7ZW;E5G07ZX,W4Gz7ZkB;A5G07ZpB;;AAEA;E4Gh7ZY,wCAAA;A5Gm7ZZ;;AAEA;EAEE,0C4G96ZoC;A5G+6ZtC;;A6GpoaI;EACI;IACS,aAAA;E7Guoaf;;E6GloaE;IACI,YAAc;EAElB;A7GooaJ;;AAEA;EACE,a6GnoaU;A7GooaZ;;AAEA;E6G9naY,cAAU;AAEd;;A7GgoaR;EACE,a6G9nawB;A7G+na1B;;AAEA;EACE,cAAc;A6GvnaZ;;A7G0naJ;E6GpnaI,mBAAA;A7GsnaJ;;A8GlqaI;EACI,eAAe;A9GqqavB;;A8G/paI;EACI,kBAAe;EAEf,mBAAA;E9GiqaN,sB8GhqaU;A9GiqaZ;;AAEA;EACE,eAAe;A8Gxpab;;A9G2paJ;E+GjraA,aAAe;A/Gmraf;;AAEA;E+GhraI,aAAO;A/GkraX;;AAEA;E+GhraI,YAAY;EACZ,UAAA;EACA,kBAAY;EAGC,aAAA;E/Ggraf,sB+G/qaoB;EAGlB,UAAA;E/G8qaF,mB+G5qagB;E/G6qahB,wB+G5qagB;A/G6qalB;;AAEA;EACE;I+G3qaM,mBAAS;E/G6qaf;AACF;;AAEA;EACE,Y+G5qaM;E/G6qaN,uB+G5qae;E/G6qaf,qB+G5qaY;E/G6qaZ,mB+G3qaS;E/G4qaT,a+G3qaC;A/G4qaH;;AAEA;E+GtqaI;IACI,qBAAQ;IACR,uBAAY;IAGhB,gBAAA;E/GsqaF;AACF;;AAEA;EACE,U+Grqaa;E/Gsqab,Y+Gpqae;E/Gqqaf,W+GpqaU;A/GqqaZ;;AAEA;EACE,Y+GhqaU;E/GiqaV,W+Ghqac;A/GiqahB;;AAEA;EACE;IACE,Y+G/paY;E/Ggqad;AACF;;AAEA,iB+G/pa2B;A/Ggqa3B;EACE,iB+G/pa2B;A/Ggqa7B;;AAEA;;;EAIE,qB+GzpakC;E/G2palC,+B+GnpasB;E/GqpatB,sC+G/oasB;E/GgpatB,a+G9oac;A/G+oahB;;AAEA;EAEE,mB+G1oa+B;A/G2oajC;;AAEA;EAEE,mB+G1oaiB;A/G2oanB;;AAEA,iB+GvoawB;A/GwoaxB;EACE,W+Gtoa0B;E/Guoa1B,Y+Gtoa8B;E/Guoa9B,qB+GtoayC;E/GuoazC,qB+GtoawC;E/GuoaxC,Y+GtoaiC;E/GuoajC,kB+GtoauC;E/GuoavC,mB+GtoawC;E/GuoaxC,U+Gtoa8B;E/Guoa9B,Q+GtoaM;E/GuoaN,W+GtoaM;A/GuoaR;;AAEA;;EAEE,W+GvnakB;EADJ,WAAA;E/G0nad,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,M+G5nakB;EADJ,QAAA;E/G+nad,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,Y+GjoakB;E/GmoalB,qBAAqB;EAErB,+BAA+B;E+GtoajB,sCAAA;A/GyoahB;;AAEA;;E+G3oagB,UAAA;E/G8oad,aAAa;AACf;;AAEA;E+GjpagB;I/GmpaZ,cAAc;IACd,aAAa;EACf;AACF;;AAwBA;EACE;IAEE,qBAAqB;IACrB,UAAU;EACZ;;E+Gnrac;I/GsraZ,YAAY;EACd;;EAEA;I+Gzrac,aAAA;E/G2rad;;EAEA;I+GtraU,mBAAA;I/GyraR,UAAU;EACZ;AACF;;AAEA;;E+GpraC,WAAG;A/GuraJ;;AAEA;;EAEE;;I+GlraM,WAAW;IACX,mBAAmB;EAI3B;A/GkraA;;AAEA;;EAEE;;I+G7qaD,WAAK;IACE,kBAAW;E/GgrajB;AgHr3aF;;AhHw3aA;EgHp3aI,WAAS;E7GoDL,kBAAA;AHm0aR;;AAEA;EACE,WgHr3aa;EhHs3ab,mBgHr3akB;AhHs3apB;;AAEA;EACE,oBgHt3asB;AhHu3axB;;AAEA;EACE,egHp3amB;EhHq3anB,MgHp3aM;EhHq3aN,WGj1aM;AHk1aR;;AAEA;EACE,iB0F3yasB;A1F4yaxB;;AAEA;EACE;IGz1aM,iBAAA;EH21aN;AACF;;AAEA;EACE,agHh3aU;AhHi3aZ;;AgHt2aI;EACI,aAAS;AhHy2ajB;;AAEA;EACE,WgHx2aU;EAEJ,sBAAA;AhHw2aR;;AAEA;EACE,sBgHt2a0B;AhHu2a5B;;AAEA;EACE,kBgHr2ae;AhHs2ajB;;AAEA;EiH56aC,YAAO;EACP,aAAS;EACT,mBAAY;AjH86ab;;AAEA;EiH56aC,eAAY;E9GiEZ,gBAAA;EACA,WAAA;AH82aD;;AAEA;EiH76aC;IACC,eAAU;EjH+6aV;AACF;;AAEA;EACE;IiH/6aA,aAAY;EjHi7aZ;AACF;;AAEA;EiH96aC,8BAAa;EjHg7aZ,gBiH/6aS;EAEV,gBAAA;EjH+6aC,yBiH96aa;EAEd,+BAAQ;EjH86aP,kCiH76aO;EjH86aP,0BiH56aA;EjH66aA,6BiH56aa;EAGd,gBAAA;EjH26aC,kBiH16aa;EAEd,eAAI;EjH06aH,gCiHz6a4B;EjH06a5B,yB0F52awB;E1F62axB,iBiHz6aS;EjH06aT,gBiHz6aA;AjH06aF;;AAEA;EACE,gCiHx6a0B;EjHy6a1B,mCiHv6aC;EjHw6aD,yBiHt6aa;EjHu6ab,4BiHt6aa;AjHu6af;;AAEA;;;EAGE,qBiHn6akB;EjHo6alB,gBiHn6aU;AjHo6aZ;;AAYA;EACE,c0F14agB;A1F24alB;;AAEA;EACE,aiH/5aC;EjHg6aD,mBgBj5agC;EhBk5ahC,YiH/5aU;AjHg6aZ;;AAEA;EACE;IACE,aiH75aQ;EjH85aV;AACF;;AAEA;EACE,gBiH35aU;AjH45aZ;;AAEA;EACE,8BiHv5aA;EjHw5aA,YiHv5aK;EjHw5aL,iBiHv5aY;EjHw5aZ,oCiHv5aa;EjHw5ab,gCiHv5ac;EjHw5ad,mCiHv5aqB;EjHw5arB,yBiHv5aa;EjHw5ab,iBiHv5aa;EjHw5ab,oBiHv5aU;AjHw5aZ;;AAEA;EACE,eiH54aW;EAEZ,cAAA;EjH44aC,ciH34aW;AjH44ab;;AAEA;EACE;IiHx4aC,YAAW;IACX,kCAAc;EjH04af;;EAEA;IiHx4aC,WAAU;IACV,YAAS;EjH04aV;AACF;;AAEA;EACE;IiHt4aC,gBAAe;EjHw4ahB;;EAEA;IiHt4aC,YAAU;IACV,WAAS;IACT,6CAAgB;IAIjB,6BAAE;EjHq4aF;AACF;;AAEA;EACE;IiHl4aC,YAAA;IjHo4aC,WiHn4aQ;EjHo4aV;AACF;;AAEA;EACE;IiH93aA,6BAAA;IACC,WAAU;EjHg4aX;;EAEA;IiH93aC,YAAU;EjHg4aX;AACF;;AAEA;;EiHx3aC,WAAA;EjH23aC,6BiH13a2B;EAE5B,6BAAc;EjH03ab,gCiHz3a2B;AjH03a7B;;AAEA;;EAEE;;IiHr3aA,OAAA;IjHw3aE,MiHv3aD;IjHw3aC,eiHv3aS;IjHw3aT,cC98aiB;IgH0FpB,eAAA;EjHs3aC;AACF;;AAEA;EACE,ciHp3aA;AjHq3aF;;AAEA;EACE,YiHp3aC;AjHq3aH;;AAEA;EACE,YiHp3aU;EjHq3aV,aiHp3aE;EjHq3aF,mBiHp3aE;AjHq3aJ;;AAEA;EACE,ciHh3aY;EjHi3aZ,eiHh3aS;AjHi3aX;;AAEA;EACE,mBiH/2aW;AjHg3ab;;AAEA;EACE,YiH72aA;EjH82aA,WiH72aS;EjH82aT,kBiH72aU;EjH82aV,uBiH72aiB;EjH82ajB,aiH72aA;EjH82aA,mBiH72ae;EjH82af,8BiH72agB;AjH82alB;;AAEA;EACE,kBiH52aA;AjH62aF;;AAEA;EACE;IACE,kBiH52ac;EjH62ahB;AACF;;AAEA;EACE;IiHz2aA,oBAAe;EjH22af;AACF;;AAEA;EACE;IACE,gB0FlnbG;E1FmnbL;AACF;;AAEA;EACE,kBiHv2aa;EjHw2ab,ciHv2aW;EjHw2aX,uBiHv2aa;EjHw2ab,gBiHt2aA;EjHu2aA,aiHt2aU;EjHu2aV,ciHt2aW;AjHu2ab;;AAEA;EACE;IACE,aiHt2aK;EjHu2aP;AACF;;AAEA;EACE,mBiHl2aa;EjHm2ab,ciHl2aU;AjHm2aZ;;AAEA;EACE,aiHj2aC;AjHk2aH;;AAEA;EACE,mBiHj2agB;EAGjB,cAAA;AjHg2aD;;AAEA;EACE,aiH/1aS;AjHg2aX;;AAEA;EACE,mBiH/1agB;EjHg2ahB,ciH/1aQ;AjHg2aV;;AAEA;EACE,aiH/1aU;AjHg2aZ;;AAEA;EACE,mBAAmB;EGxnbb,cAAA;AH0nbR;;AAEA;EACE,aiH11aQ;AC7VE;;AlH0rbZ;EkHvrbgB,eAAA;AlHyrbhB;;AAEA;EACE;IACE,e0FhmboB;EwBtFpB;AlHwrbJ;;AkHlrbI;ElHqrbF;IkHprbG,WAAW;IlHsrbZ,YAAY;EkHvsbJ;AlHysbZ;;AAEA;EACE,kBAAkB;EAClB,e0F7mbsB;E1F8mbtB,mBkHxsbkB;ElHysblB,WAAW;EACX,QkHzsbsB;EAGpB,oDAAA;ElHwsbF,mBAAmB;EACnB,YkHxsba;EAKX,WAAA;ElHqsbF,iBAAiB;EkHpsbd,kBAAe;ElHssblB,YAAY;AkHvtbF;;AlH0tbZ;EkHvtbgB;IlHytbZ,UAAU;IkHxtbM,QxB4FF;IwB1FE,eAAA;IlHytbhB,YAAY;IACZ,W0Fhobc;IwBtFd,iBAAA;ElHwtbF;AACF;;AAEA;EkHptbK;IlHstbD,WAAW;IkHvubH,YAAA;IlHyubR,WAAW;IkHxubC,eAAgB;IAEhB,iBAAA;ElHyubd;AACF;;AAEA;;EkHrubI,WAAA;AlHwubJ;;AkHlubI;ElHqubF,cAAc;AAChB;;AkHtvbY;ElHyvbV,qBAAqB;AACvB;;AAEA;EACE,e0F7pbsB;E1F8pbtB,0CkHxvbkB;AlHyvbpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EkHpvbK,gBAAe;ElHsvblB,aAAa;EkHvwbH,mBAAA;ElHywbV,wCkHzwbsB;AlH0wbxB;;AAEA;EACE;IkHvwbkB,uBAAA;IlHywbhB,UAAU;EACZ;AACF;;AAEA;EkHnwbI,gBAAA;AlHqwbJ;;AAEA;EkHvxbY,iBAAA;ElHyxbV,mBAAmB;AACrB;;AAEA;EACE;IkHvxbkB,kBAAA;ElHyxblB;AACF;;AAEA;EACE;IkHnxbE,aAAA;ElHqxbF;AACF;;AkHtybY;ElHyybV,eAAe;EkHxybD,cAAA;EAEA,gBAAA;AlHyybhB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,ckHxybc;EAKZ,eAAA;ElHqybF,cAAc;EkHpybX,gBAAe;ElHsyblB,gBAAgB;AkHvzbN;;AlH0zbZ;EkHvzbgB,eAAA;ElHyzbd,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EkHpzbK,WAAU;ElHszbb,YAAY;EkHv0bF,mBAAA;AlHy0bZ;;AAEA;EACE;IkHx0bkB,WxB4FI;IwB1FJ,YAAA;ElHy0blB;AACF;;AAEA;EACE,kBkHx0bkB;AAKhB;;AlHs0bJ;EACE;IkHv1bU,aAAA;ElHy1bV;AACF;;AAEA;EACE,mB0F7vbsB;E1F8vbtB,WkHx1bkB;ElHy1blB,kBAAkB;AACpB;;AAEA;EACE,WkHx1bG;EAKD,kBAAA;AlHq1bJ;;AAEA;EkHv2bY,iBAAA;AlHy2bZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,a0FhxbgB;A1FixblB;;AAEA;EkHn2bI,qBAAA;AlHq2bJ;;AAEA;EkHv3bY,gBAAA;ElHy3bV,oBAAoB;EkHx3bN,SAAA;AlH03bhB;;AAEA;EACE,mBkHx3bkB;ElHy3blB,WAAW;EACX,kB0FhybsB;A1FiybxB;;AAEA;EkHn3bI,WAAA;ElHq3bF,kBAAkB;AACpB;;AkHt4bY;ElHy4bV,sBAAsB;EkHx4bR,uBxB6GG;EwB3GH,0BAAA;AlHy4bhB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WkHx4bG;EAKD,YAAA;ElHq4bF,mBAAmB;EkHp4bhB,qBAAe;ElHs4blB,gBAAgB;EkHr3bN,kBAAA;AlHu3bZ;;AAEA;EkHp3bgB,eAAA;ElHs3bd,iBAAiB;AACnB;;AAEA;EkHn3boB,mBAAA;ElHq3blB,cAAc;AAChB;;AAEA;EACE,akHp3bsB;AAGpB;;AlHo3bJ;EkHl3bK,mBAAA;ElHo3bH,cAAc;AAChB;;AAEA;EkHj3boB,aAAA;AlHm3bpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AkH12boB;ElH62blB,aAAa;AACf;;AAEA;EkH32bK,aAAA;AlH62bL;;AAEA;EACE,sBkH72bqB;EAGnB,0BAAA;ElH42bF,cAAc;AAChB;;AAEA;EkH32bK,uBAAa;EACb,gBxBKmB;EwBFnB,mBAAA;ElH22bH,gBAAgB;EkH12bZ,gBxBCkB;EwBCnB,eAAA;AlH22bL;;AAEA;EkH32bM;IAIM,gBAAA;ElH02bV;AACF;;AAEA;EkHl7bY,cAAA;ElHo7bV,oBAAoB;EkHn7bN,kBxB+DE;EwB9DF,6BxB4DQ;AwBzDR;;AlHo7bhB;EkHl7boB,iBAAgB;AlHo7bpC;;AAEA;EACE,iB0Fh4bsB;EwB/CJ,cAAA;AlHi7bpB;;AkH76bI;ElHg7bF,gBAAgB;AAClB;;AAEA;EACE,YkHj7bW;AAIG;;AlHg7bhB;EkH96boB,kBAAc;EAEd,oBAAA;AlH+6bpB;;AAEA;EACE,iBkH/6bsB;AlHg7bxB;;AAEA;EkHz6bwB,sBxBoBA;EwBjBpB,kBAAA;AlHy6bJ;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EkHx6bK,sBAAkB;EAEnB,qBAAA;AlHy6bJ;;AAEA;EkHt6bK,kCAAA;AlHw6bL;;AkHr6bK;;ElHy6bH,kCAAkC;AACpC;;AkHp6bY;ElHu6bV,kCAAkC;AACpC;;AAEA;;EAEE,QAAQ;EkHh/bM,aAAA;AlHk/bhB;;AAEA;EkH/+boB,0CAAmD;EACnD,uFAAkE;EAClE,yBxBsDI;A1F27bxB;;AAEA;;;;;;EkHv+bQ,kCAAkB;AlH8+b1B;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;;EkHp+boB,kCAAA;AlHu+bpB;;AkHn+bI;;EACC,kCxBgBmB;A1Fu9bxB;;AAEA;;EkHn+bI,gBAAA;AlHs+bJ;;AkHn+bI;ElHs+bF,qBAAqB;EkHr+blB,qBAAa;EACb,qBxBKmB;EwBFnB,iBAAA;AlHq+bL;;AkHl+bK;ElHq+bH,QAAQ;EACR,aAAa;AACf;;AkHj+bY;ElHo+bV,cAAc;EkHn+bA,UAAA;EACA,gCxBTQ;A1F8+bxB;;AAEA;;;;EAIE,sBAAsB;EkH5icJ,oBAAc;AlH8iclC;;AAEA;EACE,gBAAgB;EAChB,kB0F1/bsB;A1F2/bxB;;AAEA;EkHxicI,WAAA;AlH0icJ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EkHxicoB,oBAAkB;AlH0ictC;;AAEA;EACE,cAAc;EACd,OAAO;AACT;;AkHjicoB;ElHoiclB,oBAAoB;EkHnicE,cxBoBA;AwBjBpB;;AlHoicJ;EkHlicK,sBAAA;ElHoicH,oBAAoB;AACtB;;AkHhicI;ElHmicF,sBAAsB;EkHlicnB,qBAAkB;AAEnB;;AlHoicJ;EkHlicK,2BxBKmB;EwBFnB,cAAA;AlHkicL;;AkH/hcK;ElHkicH,4BAA4B;EAC5B,cAAc;AAChB;;AkH9hcY;ElHiicV,iBAAiB;EkHhicH,cAAA;AlHkichB;;AkHxmcY;ElH2mcV,4BAA4B;EkH1mcd,cAAA;AlH4mchB;;AAEA;EkHzmcoB,4BAAmD;EACnD,cAAA;AlH2mcpB;;AAEA;EACE,iB0FvjcsB;EwB/CJ,cAAA;AlHwmcpB;;AkHpmcI;ElHumcF,4BAA4B;EkHtmctB,cAAA;AlHwmcR;;AAEA;EkHpmcgB,4BAAA;ElHsmcd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EkH/lcoB,4BAAA;ElHimclB,cAAc;AAChB;;AAEA;EkH/lcK,4BxBgBmB;EwBfnB,cAAA;AlHimcL;;AAEA;EkH9lcI;IlHgmcA,eAAe;IkH/lcd,cAAgB;EAEjB;;EACC;IACA,2BxBKmB;IwBFnB,cAAA;ElH+lcH;;EkH5lcG;IlH+lcD,4BAA4B;IAC5B,cAAc;EAChB;;EkH3lcU;IlH8lcR,iBAAiB;IkH7lcL,cAAgB;EAChB;;EAvEJ;IlHwqcR,4BAA4B;IkHvqchB,cAAgB;EAChB;;ElH0qcd;IkHtqckB,4BAAmD;IACnD,cAAgB;EAChB;;ElHyqclB;IkHrqcsB,iBxBkDA;IwB/CJ,cAAA;ElHqqclB;;EkHjqcE;IlHoqcA,4BAA4B;IkHnqcxB,cAAgB;EACnB;;ElHsqcH;IkHjqcc,4BAAA;IlHmqcZ,cAAc;EkHlqcE;;EAGA;IlHmqchB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IkH5pckB,4BAAA;IlH8pchB,cAAc;EkH7pcM;;ElHgqctB;IkH5pcG,4BxBgBmB;IwBfnB,cAAA;ElH8pcH;AACF;;AkH1pcI;ElH6pcF;IkH5pcG,eAAgB;IAEjB,cAAA;ElH6pcF;;EkH3pcG;IAGA,2BAAA;IlH4pcD,cAAc;EkH3pcZ;;ElH8pcJ;IACE,4BAA4B;IAC5B,cAAc;EkH5pcZ;;ElH+pcJ;IkH1pcc,iBAAkB;IAClB,cxBTQ;E1FqqctB;;EAEA;IkHpucc,4BxBoES;IwBnET,cxB4DQ;EwBzDR;;EACI;IACA,4BAAkB;IAClB,cxBsDI;EwBnDJ;;ElHouclB;IkHhuckB,iBAAA;IlHkuchB,cAAc;EAChB;;EAEA;IkHhucM,4BAAkB;IACrB,cAAA;ElHkucH;;EkH7tcc;IlHgucZ,4BAA4B;IkH/tcZ,cAAgB;EAChB;;ElHkuclB;IACE,iBAAiB;IACjB,cAAc;EAChB;;EkHxtckB;IlH2tchB,4BAA4B;IkH1tcR,cxBoBA;EwBjBpB;;EACC;IACA,4BAAA;IlH2tcD,cAAc;EAChB;AACF;;AAEA;EkHztcK;IAED,eAAA;IlH0tcA,cAAc;EkHztcb;;EAIA;IlHytcD,2BAA2B;IkHxtczB,cxBCkB;EwBCnB;;ElH0tcH;IACE,4BAA4B;IkHztc1B,cAAM;EAIA;;EACI;IACA,iBxBTQ;I1FkucpB,cAAc;EkHhycN;;EACI;IACA,4BxB4DQ;IwBzDR,cAAA;ElHiycd;;EkH/xckB;IACA,4BxBsDI;IwBnDJ,cAAA;ElHgyclB;;EkH5xckB;IlH+xchB,iBAAiB;IkH9xcG,cAAc;EAGlC;;EACI;IACH,4BAAA;IlH+xcD,cAAc;EAChB;;EAEA;IkH5xckB,4BAAsD;IACtD,cAAc;EAEd;;ElH8xclB;IACE,iBAAiB;IkH5xcG,cAAA;ElH8xctB;;EAEA;IkHvxcsB,4BxBoBA;IwBjBpB,cAAA;ElHuxcF;;EkHrxcG;IlHwxcD,4BAA4B;IAC5B,cAAc;EAChB;AkHrxcE;;AlHwxcJ;EkHrxcI;IlHuxcA,eAAe;IkHtxcd,cAAa;EACb;;ElHyxcH;IkHrxcI,2BxBCkB;IwBCnB,cAAA;ElHsxcH;;EAEA;IkHtxcI,4BAAM;IAIA,cAAA;ElHqxcV;;EkHnxcc;IlHsxcZ,iBAAiB;IkH71cT,cAAA;ElH+1cV;;EkH71cc;IAGA,4BAAA;IlH81cZ,cAAc;EkH71cE;;EAEA;IAGA,4BAAA;IlH61chB,cAAc;EAChB;;EAEA;IkH31csB,iBAAc;IAGlC,cAAA;ElH21cF;;EkHz1cG;IlH41cD,4BAA4B;IkH31c1B,cAAW;EAID;;EACI;IACA,4BAAkD;IAElD,cAAA;ElH01clB;;EAEA;IkHz1csB,iBAAgB;IAChB,cAAc;EAOlB;;EACI;IAGpB,4BAAA;IlHo1cA,cAAc;EkHn1cb;;ElHs1cH;IACE,4BAA4B;IkHp1c1B,cAAA;EAGF;AlHo1cJ;;AkHj1cI;ElHo1cF;IkHn1cG,eAAa;IACb,cxBKmB;EwBFnB;;EACC;IAED,2BAAA;IlHm1cD,cAAc;EAChB;;EkHl1cI;IAIM,4BAAA;IlHk1cR,cAAc;EkHj1cF;;ElHo1cd;IkH15cU,iBAAA;IlH45cR,cAAc;EkH35cF;;EAIA;IlH25cZ,4BAA4B;IkH15cZ,cAAc;EACd;;EAIA;IlH05chB,4BAA4B;IkHz5cR,cxBkDA;EwB/CJ;;ElH05clB;IkHt5cE,iBAAA;IlHw5cA,cAAc;EkHv5cV;;ElH05cN;IkHx5cI,4BAAW;IAID,cAAA;ElHu5cd;;EkHr5ckB;IAEA,4BAAA;IlHu5chB,cAAc;EAChB;;EAEA;IkHt5csB,iBAAc;IAOlB,cAAA;ElHk5clB;;EkH94cE;IlHi5cA,4BAA4B;IkHh5c3B,cAAgB;EAChB;;ElHm5cH;IkHj5cI,4BAAwB;IAG1B,cAAA;ElHi5cF;AACF;;AAEA;;EkH/4cK,0BxBKmB;EwBFnB,yBAAA;AlHg5cL;;AkH74cK;;ElHi5cH,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EkH74cgB,0BxBTQ;E1Fy5ctB,+BAA+B;AkHv9crB;;AlH09cZ;;EkHr9cgB,yBAAA;ElHw9cd,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,8B0Fr6csB;A1Fs6cxB;;AAEA;;EAEE,yBAAyB;EkHp9cnB,+BAAkB;AlHs9c1B;;AAEA;;EAEE,0BAA0B;EkHn9cR,4BAAsD;AlHq9c1E;;AAEA;;EAEE,yBAAyB;EACzB,6BkHp9c4E;AlHq9c9E;;AAEA;;EkH38cI,0BAAA;ElH88cF,8BAA8B;AAChC;;AAEA;;EAEE,yBkH/8cqB;EAGnB,+BAAA;AlH88cJ;;AkH38cI;;EACC,0BAAa;EACb,4BxBKmB;AwBFnB;;AlH88cL;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;;AkHz8cY;;EACI,2BAAuD;EACvD,0BxBTQ;A1Fs9cxB;;AAEA;;EkHphdgB,0BxB4DQ;EwBzDR,2BAAA;AlHqhdhB;;AAEA;;EkHjhdoB,2BAAA;ElHohdlB,gCAAgC;AAClC;;AAEA;;EkH/gdI,0BAAA;ElHkhdF,iCAAiC;AACnC;;AAEA;;EkH9gdgB,2BAAA;ElHihdd,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;EAC1B,gCAAgC;AAClC;;AkHzgdoB;;EACI,2BxBoBA;EwBjBpB,6BAAA;AlH2gdJ;;AAEA;;EAEE,0BAA0B;EAC1B,8BkH5gd4B;AAG1B;;AlH4gdJ;;EAEE,2BAA2B;EkH1gdxB,+BAAa;AlH4gdlB;;AAEA;;EkHvgdK,0BAAA;ElH0gdH,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;EkHxgdb,6BAAuD;AlH0gdvE;;AkHhldY;;EACI,0BxB0EU;EwBzEV,8BxB4DQ;AwBzDR;;AlHmldhB;EkHjldoB,0BAAkB;EAClB,4BxBsDI;A1F6hdxB;;AAEA;EkH9kdoB,6BAAA;ElHgldlB,yBAAyB;AAC3B;;AAEA;EkH9kdQ,6BAAkB;EACrB,4BAAA;AlHgldL;;AkH3kdgB;;EACI;;IAGA,0BAAA;IlH8kdhB,yBAAyB;EAC3B;;EAEA;;IkHtkdkB,yBAAA;IlHykdhB,0BAA0B;EkHxkdN;;ElH2kdtB;;IkHtkdG,0BAAA;IlHykdD,+BAA+B;EACjC;;EkHrkdE;;IACC,yBAAkB;IAEnB,gCAAA;ElHwkdF;;EkHtkdG;;IlH0kdD,0BAA0B;IkHtkdxB,8BxBCkB;EwBCnB;;ElHwkdH;;IkHtkdI,yBAAM;IAIA,+BAAA;ElHskdV;;EkHpkdc;;IAvEJ,0BAAA;IlHgpdR,4BAA4B;EkH/odhB;;EAIA;;IACI,yBAAmD;IACnD,6BAAkB;EAClB;;ElHipdlB;;IkH1odkB,0BAAA;IlH6odhB,8BAA8B;EAChC;;EAEA;;IkH1odG,yBAAA;IlH6odD,+BAA+B;EACjC;;EAEA;;IkHzodkB,0BAAkD;IAElD,4BAAA;ElH2odlB;;EAEA;;IkHzodsB,yBAAkD;IAOtD,6BAAA;ElHsodlB;;EkHlodE;;IACC,2BxBgBmB;IwBfnB,0BAAA;ElHsodH;;EAEA;;IAEE,0BAA0B;IkHpodzB,2BAAkB;EAEnB;;EACC;;IAIA,2BAAA;IlHoodD,gCAAgC;EkHnod9B;;ElHsodJ;;IAEE,0BAA0B;IkHpodxB,iCAA2B;EAIrB;;EACI;;IlHqodZ,2BAA2B;IkHtnd5B,+BAAA;ElHwndD;;EkHtndE;;IACC,0BxBzBoB;IwB4BpB,gCAAA;ElHwndH;;EAEA;;IAEE,2BAA2B;IkHtndH,6BAAQ;ElHwndlC;;EAEA;;IAEE,0BAA0B;IAC1B,8BkHxndU;EAQc;;ElHmnd1B;;IkHlnd8B,2BxBjDR;IwBkDhB,+BAAA;ElHqndN;;EAEA;;IkHpndM,0BAAA;IlHundJ,gCAAgC;EAClC;;EAEA;;IkHhnd8B,2BAAmD;IAK/D,6BAAA;ElH+mdlB;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IkH5mdsB,0BAAc;IAChC,4BAAA;ElH8mdJ;;EkHjmdE;IlHomdA,6BAA6B;IkHnmd5B,yBAAuD;EAExD;;ElHqmdF;IACE,6BAA6B;IkHpmd5B,4BAAuD;EAIxD;AlHmmdJ;;AAEA;;EAEE;;IkHhmdE,0BAAA;IlHmmdA,yBAAyB;EkHlmdxB;;ElHqmdH;;IAEE,yBAAyB;IkH9rd1B,0BAAA;ElHgsdD;;EkH9rdE;;IACC,0BxBxBqB;IwB2BrB,+BAAA;ElHgsdH;;EAEA;;IAEE,yBAAyB;IkH9rdD,gCAA6B;ElHgsdvD;;EAEA;;IAEE,0BAA0B;IAC1B,8BkHhsdU;EAQc;;ElH2rd1B;;IkH1rd8B,yBxBjDR;IwBkDhB,+BAAA;ElH6rdN;;EAEA;;IkH5rdM,0BAAA;IlH+rdJ,4BAA4B;EAC9B;;EAEA;;IkHxrd8B,yBAAmD;IAK/D,6BAAA;ElHurdlB;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IkHnrdI,yBAAA;IlHsrdF,+BAA+B;EACjC;;EAEA;;IkHzqdE,0BAAA;IlH4qdA,4BAA4B;EAC9B;;EkH3qdG;;IlH+qdD,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IkHxqdE,2BAAA;IlH2qdA,0BAA0B;EkH1qdzB;;ElH6qdH;;IAEE,0BAA0B;IkHtwd3B,2BAAA;ElHwwdD;;EkHtwdE;;IACC,2BxBvBoB;IwB0BpB,gCAAA;ElHwwdH;;EAEA;;IAEE,0BAA0B;IkHtwdF,iCAA6B;ElHwwdvD;;EAEA;;IAEE,2BAA2B;IAC3B,+BkHxwdU;EAQc;;ElHmwd1B;;IkHlwd8B,0BxBjDR;IwBkDhB,gCAAA;ElHqwdN;;EAEA;;IkHpwdM,2BAAA;IlHuwdJ,6BAA6B;EAC/B;;EAEA;;IkHhwd8B,0BAAmD;IAK/D,8BAAA;ElH+vdlB;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IkH3vdI,0BAAA;IlH8vdF,gCAAgC;EAClC;;EAEA;;IkHjvdE,2BAAA;IlHovdA,6BAA6B;EAC/B;;EkHnvdG;;IlHuvdD,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IkHpvdG,0BAAuD;IAIxD,4BAAA;ElHmvdF;;EkH9udE;IlHivdA,6BAA6B;IkHhvd5B,yBAAc;ElHkvdjB;;EAEA;IkH/0dc,6BxBpBS;IwBqBrB,4BAAA;ElHi1dF;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;IkH90dF,yBAAQ;ElHg1dlC;;EAEA;;IAEE,yBAAyB;IACzB,0BkHh1dU;EAQc;;ElH20d1B;;IkH10d8B,0BxBjDR;IwBkDhB,+BAAA;ElH60dN;;EAEA;;IkH50dM,yBAAA;IlH+0dJ,gCAAgC;EAClC;;EAEA;;IkHx0d8B,0BAAmD;IAK/D,8BAAA;ElHu0dlB;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IkHn0dI,0BAAA;IlHs0dF,4BAA4B;EAC9B;;EAEA;;IkHzzdE,yBAAA;IlH4zdA,6BAA6B;EAC/B;;EkH3zdG;;IlH+zdD,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IkHxzdE,yBAAA;IlH2zdA,+BAA+B;EkH1zd9B;;ElH6zdH;;IAEE,0BAA0B;IkHt5d3B,4BAAA;ElHw5dD;;EkHt5dE;;IACC,yBxBrBoB;IwBwBpB,6BAAA;ElHw5dH;;EAEA;;IAEE,2BAA2B;IkHt5dH,0BAAQ;ElHw5dlC;;EAEA;;IAEE,0BAA0B;IAC1B,2BkHx5dU;EAQc;;ElHm5d1B;;IkHl5d8B,2BxBjDR;IwBkDhB,gCAAA;ElHq5dN;;EAEA;;IkHp5dM,0BAAA;IlHu5dJ,iCAAiC;EACnC;;EAEA;;IkHh5d8B,2BAAmD;IAK/D,+BAAA;ElH+4dlB;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IkH34dI,2BAAA;IlH84dF,6BAA6B;EAC/B;;EAEA;;IkHj4dE,0BAAA;IlHo4dA,8BAA8B;EAChC;;EkHn4dG;;IlHu4dD,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IkHh4dE,0BAAA;IlHm4dA,gCAAgC;EkHl4d/B;;ElHq4dH;;IAEE,2BAA2B;IkH99d5B,6BAAA;ElHg+dD;;EkH99dE;;IACC,0BxBpBoB;IwBuBpB,8BAAA;ElHg+dH;;EAEA;IkH79dsB,0BAAA;IlH+9dpB,4BAA4B;EAC9B;;EAEA;IACE,6BkHh+dU;IAEP,yBAAA;ElHg+dL;;EkHv9d0B;IlH09dxB,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IkH59dM,0BAAA;IlH+9dJ,yBAAyB;EAC3B;;EAEA;;IkHx9d8B,yBAAmD;IAK/D,0BAAA;ElHu9dlB;;EAEA;;IAEE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;;IkHn9dI,yBAAA;IlHs9dF,gCAAgC;EAClC;;EAEA;;IkHz8dE,0BAAA;IlH48dA,8BAA8B;EAChC;;EkH38dG;;IlH+8dD,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IkHx8dE,0BAAA;IlH28dA,4BAA4B;EkH18d3B;;ElH68dH;;IAEE,yBAAyB;IkHtie1B,6BAAA;ElHwieD;;EkHtieE;;IACC,0BxBnBoB;IwBsBpB,8BAAA;ElHwieH;;EAEA;;IAEE,yBAAyB;IkHtieD,+BAA6B;ElHwievD;;EAEA;;IAEE,0BAA0B;IAC1B,4BkHxieU;EAQc;;ElHmie1B;;IkHlie8B,yBxBjDR;IwBkDhB,6BAAA;ElHqieN;;EAEA;;IkHpieM,2BAAA;IlHuieJ,0BAA0B;EAC5B;;EAEA;;IkHhie8B,0BAAmD;IAK/D,2BAAA;ElH+helB;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;;IkH3heI,0BAAA;IlH8heF,iCAAiC;EACnC;;EAEA;;IkHjheE,2BAAA;IlHoheA,+BAA+B;EACjC;;EkHnheG;;IlHuheD,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IkHhheE,2BAAA;IlHmheA,6BAA6B;EkHlhe5B;;ElHqheH;;IAEE,0BAA0B;IkH9me3B,8BAAA;ElHgneD;;EkH9meE;;IACC,2BxBlBoB;IwBqBpB,+BAAA;ElHgneH;;EAEA;;IAEE,0BAA0B;IkH9meF,gCAA6B;ElHgnevD;;EAEA;;IAEE,2BAA2B;IAC3B,6BkHhneU;EAQc;;ElH2me1B;;IkH1me8B,0BxBjDR;IwBkDhB,8BAAA;ElH6meN;;EAEA;IACE,0B0FlqeoB;IwBqDhB,4BAAA;ElH+meN;;EAEA;IACE,6B0FvqeoB;IwB6DT,yBAAA;ElH4meb;;EAEA;IkHtmesB,6BAAO;IAEP,4BAAA;ElHumetB;AACF;;AAEA;;EAEE;;IkHnmeI,0BAAA;IlHsmeF,yBAAyB;EAC3B;;EAEA;;IkHzleE,yBAAA;IlH4leA,0BAA0B;EAC5B;;EkH3leG;;IlH+leD,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;;IkHxleE,yBAAA;IlH2leA,gCAAgC;EkH1le/B;;ElH6leH;;IAEE,0BAA0B;IkHtre3B,8BAAA;ElHwreD;;EkHtreE;;IACC,yBxBjBqB;IwBoBrB,+BAAA;ElHwreH;;EAEA;;IAEE,0BAA0B;IkHtreF,4BAAQ;ElHwrelC;;EAEA;;IAEE,yBAAyB;IACzB,6BkHxreU;EAQc;;ElHmre1B;;IkHlre8B,0BxBjDR;IwBkDhB,8BAAA;ElHqreN;;EAEA;;IkHpreM,yBAAA;IlHureJ,+BAA+B;EACjC;;EAEA;;IkHhre8B,0BAAmD;IAK/D,4BAAA;ElH+qelB;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IkH3qeI,2BAAA;IlH8qeF,0BAA0B;EAC5B;;EAEA;;IkHjqeE,0BAAA;IlHoqeA,2BAA2B;EAC7B;;EkHnqeG;;IlHuqeD,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;;IkHhqeE,0BAAA;IlHmqeA,iCAAiC;EkHlqehC;;ElHqqeH;;IAEE,2BAA2B;IkH9ve5B,+BAAA;ElHgweD;;EkH9veE;;IACC,0BxBhBqB;IwBmBrB,gCAAA;ElHgweH;;EAEA;;IAEE,2BAA2B;IkH9veH,6BAAQ;ElHgwelC;;EAEA;;IAEE,0BAA0B;IAC1B,8BkHhweU;EAQc;;ElH2ve1B;;IkH1ve8B,2BxBjDR;IwBkDhB,+BAAA;ElH6veN;;EAEA;;IkH5veM,0BAAA;IlH+veJ,gCAAgC;EAClC;;EAEA;;IkHxve8B,2BAAmD;IAK/D,6BAAA;ElHuvelB;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IkHpvesB,0BAAc;IAChC,4BAAA;ElHsveJ;;EkHzueE;IlH4ueA,6BAA6B;IkH3ue5B,yBAAuD;EAExD;;ElH6ueF;IACE,6BAA6B;IkH5ue5B,4BAAuD;EAIxD;AlH2ueJ;;AAEA;EACE,2BAA2B;AAC7B;;AkHxueI;ElH2ueF,4BAA4B;AAC9B;;AAEA;EkHxueK;IlH0ueD,2BAA2B;EkHt0e5B;;EACa;IACZ,4BAAA;ElHy0eF;AACF;;AAEA;EACE;IkHv0eI,2BAAa;EAGK;;ElHw0etB;IkHt0eK,4BAAA;ElHw0eL;AACF;;AAEA;EACE;IkHh0e0B,2BAAA;ElHk0e1B;;EAEA;IkHn0e8B,4BxBjDR;E1Fs3etB;AACF;;AAEA;EACE;IkHr0eM,2BAAA;ElHu0eN;;EAEA;IACE,4B0F/3eoB;EwB6DT;AlHo0ef;;AAEA;EACE;IkH7zesB,2BAAA;ElH+zetB;;EAEA;IACE,4B0Fz4eoB;EwB8EJ;AlH6zepB;;AAEA;EACE,kBAAkB;EAClB,yBkH9zeuB;AAYrB;;AlHqzeJ;EkHlzeI,iBAAA;ElHozeF,0BAA0B;AAC5B;;AAEA;EkHjzeI,kBAAA;ElHmzeF,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EkHpzed,gCAAuD;AAIxD;;AlHozeJ;EkH/yeI,kBAAA;ElHizeF,8BAA8B;AAChC;;AkH74eG;ElHg5eD,iBAAiB;EkH/4eH,+BxBZU;A1F65e1B;;AAEA;EkH94eK,kBAAA;ElHg5eH,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BkH/4ekC;AlHg5epC;;AAEA;EACE,kBkH/4eK;ElHg5eL,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EkHr4eoB,mBAAA;ElHu4elB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBkHr4eoC;ElHs4epC,gCkHr4eI;AlHs4eN;;AkHz3eI;ElH43eF,kBAAkB;EkH33ef,iCAAuD;AAExD;;AlH63eJ;EACE,mBAAmB;EkH53ehB,+BAAuD;AAIxD;;AlH43eJ;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AkHx3eI;ElH23eF,mBAAmB;EkH13ehB,6BAAc;AAIf;;AlH03eJ;EACE,kBAAkB;EkHt9ejB,8BAAA;AlHw9eH;;AAEA;EACE,mBAAmB;EACnB,+B0Ft+ewB;A1Fu+e1B;;AAEA;EACE,kBkHx9eiB;EAGK,gCAAA;AlHu9exB;;AAEA;EACE,mBAAmB;EACnB,6BkHx9eY;AlHy9ed;;AAEA;EkHh9e4B,kBAAA;ElHk9e1B,8BAA8B;AAChC;;AAEA;EACE,0BkHp9eM;ElHq9eN,4BAA4B;AAC9B;;AAEA;EACE,6BkHt9eM;ElHu9eN,4BAA4B;AAC9B;;AAEA;EkHl9ee,6BAAA;ElHo9eb,yBkHl9eiF;AlHm9enF;;AAEA;EACE,6BkH98esB;ElH+8etB,4BAA4B;AAC9B;;AAEA;EkH38eoB;IlH68ehB,kBAAkB;IkH58eE,yBAAc;ElH88epC;;EAEA;IkHl8eE,iBAAA;IlHo8eA,0BAA0B;EkHn8ezB;;ElHs8eH;IACE,kBAAkB;IAClB,+BAA+B;EkHp8e9B;;ElHu8eH;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EkHn8eG;IAID,kBAAA;IlHm8eA,8BAA8B;EkHl8e7B;;ElHq8eH;IkHh8eG,iBAAc;IlHk8ef,+BAA+B;EkH9hfhC;;EACa;IACZ,kBAAA;IlHiifA,4BAA4B;EAC9B;;EAEA;IkH/hfI,iBAAM;IACN,6BAAa;EAGK;;ElHgiftB;IkH9hfK,kBAAA;IlHgifH,8BAA8B;EAChC;;EAEA;IACE,iBkHhifU;IAQc,+BAAA;ElH0hf1B;;EAEA;IkH3hf8B,kBxBjDR;IwBkDhB,4BAAA;ElH6hfN;;EAEA;IACE,iB0FllfoB;IwBqDhB,6BAAA;ElH+hfN;;EAEA;IACE,mB0FvlfoB;IwB6DT,0BAAA;ElH4hfb;;EAEA;IkHthfsB,kBAAO;IAEP,2BAAA;ElHuhftB;;EAEA;IACE,mB0FjmfoB;IwB8EJ,gCAAA;ElHqhflB;;EAEA;IACE,kBAAkB;IAClB,iCkHthfqB;EAYrB;;EACC;IAED,mBAAA;IlH4gfA,+BAA+B;EACjC;;EkH3gfG;IAID,kBAAA;IlH2gfA,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IkH5gflB,6BAAuD;EAIxD;;EACC;IAID,kBAAA;IlHygfA,8BAA8B;EkHxgf7B;;EAQD;IACF,mBAAgB;IACV,+BAAuB;ElHogf7B;;EAEA;IkHhgfA,kBAAW;IlHkgfT,gCAAgC;EmH1ufpC;;EnH6ufE;ImHzufU,mBAAc;IAEL,6BAAA;EnH0ufnB;;EmH/tfM;IACI,kBAAa;IhHyCjB,8BAAA;EgHlCA;;EAQJ;IACI,0BAAiB;InHutfrB,4BAA4B;EmHltf5B;;EnHqtfF;ImH/sfE,6BAAA;IACI,4BAAa;EnHitfnB;;EmH1sfM;IACA,6BAAiB;IAGrB,yBAAA;EACI;;EAIJ;IACI,6BAAS;InHysfb,4BAA4B;EmHpsf5B;AnHssfJ;;AAEA;EmHjsfI;IACI,kBAAkB;IAIlB,yBAAA;EACI;;EAMR;IACI,iBAAU;IACV,0BAAiB;EnH4rfvB;;EoHnxfM;IACI,kBAAiB;IACjB,+BAAc;EpHsxfxB;;EoH/wfM;IACI,iBAAW;IAGX,gCAAA;EpHgxfV;;EAEA;IoHzwfc,kBAAA;IACI,8BAAiB;EpH2wfnC;;EoHlwfM;IACI,iBAAW;IAGX,+BAAA;EpHmwfV;;EAEA;IACE,kBAAkB;IoHzvflB,4BAA0B;EACtB;;EAII;IACI,iBAAiB;IpHyvf7B,6BAA6B;EoHlvf7B;;EpHqvfF;IoHhvfU,kBAAA;IACI,8BAAiB;EpHkvf/B;;EoH1ufM;IAGA,iBAAA;IACI,+BAAiB;EAIrB;;EpHyufN;IoHlufE,kBAAA;IACI,4BAAiB;EACjB;;EAII;IpHkufR,iBAAiB;IoH5tfjB,6BAAA;EACI;;EAIA;IACI,mBAAS;IpH4tfjB,0BAA0B;EqHr0f1B;;EAMD;IACC,kB3ByFqB;I2BvFtB,2BAAA;EACC;;ErHm0fF;IqH9zfC,mBAAA;IACI,gCAAwB;EAE5B;;EAGA;IACa,kB3B0ES;I2BxEtB,iCAAA;EACC;;EAGA;IAGA,mBAAA;IAEC,+BAAe;EACf;;EAID;IACA,kB3ByDqB;I2BvDtB,gCAAA;ErHszfD;;EqHlzfC;IACC,mB3BkDqB;I2BhDtB,6BAAA;EACC;;EAGA;IACA,kB3B2CqB;I2BxCrB,8BAAA;EACC;;ErHkzfH;IqH3yfE,mBAAA;IACC,+B3B+BoB;E2B9BpB;;EAKA;IAED,kBAAA;IACC,gC3BsBoB;E2BpBrB;;EAUK;IACC,mB3BSe;I2BJjB,6BAAA;EACC;;EAKD;IACC,kB3BHgB;I2BOjB,8BAAA;EACC;;EAQL;IAED,0BAAA;IACC,4B3BnBqB;E2BoBrB;;ErHgxfF;IqH5wfE,6B3BxBqB;I2B2BrB,4BAAA;EACC;;EAIC;IAED,6BAAA;IACC,yB3BnCmB;E2BoCnB;;EAKC;IACC,6BAAe;IAQpB,4BAAA;EACC;AAED;;ArH+vfH;EqH3vfG;IACC,kBAAO;IACP,yBAAY;EAEb;;EAIC;IACC,iB3BlEoB;I2BoErB,0BAAA;EACC;;EAID;IAED,kBAAA;IACC,+BAAkC;EAClC;;EAGA;IAED,iBAAA;IACC,gCAAkC;EAEnC;;EAGA;IACC,kB3BzFqB;I2B2FtB,8BAAA;EACC;;EAGA;IACA,iBAAA;IACC,+B3BjGoB;E2BoGtB;;EAGA;IACC,kB3BxGc;I2B0Gf,4BAAA;EACC;;ErH6ufF;IqHvufC,iBAAA;IACC,6B3BlHqB;E2BoHtB;;EAIC;IACC,kB3BzHa;I2B4Hf,8BAAA;EACC;;EAMG;IAKJ,iBAAA;IACC,+BAAgC;EAChC;;EAGD;IACC,kBAAa;IAEd,4BAAA;EACC;;EAGA;IACA,iB3BrJc;I2BuJf,6BAAA;EACC;;EAGD;IACC,mBAAQ;IACR,0B3B7JqB;E2B+JtB;;EAGA;IACC,kB3BnKqB;I2BsKrB,2BAAA;EACC;;EAMA;IACA,mB3B9KoB;I2B+KpB,gCAAA;ErH+sfH;;EqHzsfE;IAGD,kBAAA;IACC,iCAA0B;EAE3B;;EAGA;IACC,mBAAgC;IAC/B,+BAAA;ErHwsfH;;EqHnsfE;IAKE,kBAAA;IACC,gC3B3MkB;E2B4MlB;;EAID;IACA,mB3BjNmB;I2BsNrB,6BAAA;ErH4rfF;;EqHvrfC;IACC,kB3B5Nc;I2B8Nf,8BAAA;EACE;;EAIA;IACA,mBAAA;IACC,+BAAuD;EAGzD;;EAGC;IACC,kBAAc;IAGhB,gCAAA;EACC;;EAKA;IACA,mBAAA;IACC,6B3BvPmB;E2ByPpB;;EAKF;IACC,kBAAkB;IAIjB,8BAAA;EACC;;EAQA;IACA,0BAAwB;IACxB,4BAAA;ErHkqfJ;;EqH1pfG;IAED,6BAAA;IACC,4B3BzRoB;E2B4RtB;;EAGA;IACC,6BAAgC;IAChC,yBAAkC;EAClC;;EAGA;IAED,6BAAA;IACC,4B3BxSqB;E2B0StB;ArHspfH;;AAEA;EqHlpfG;IACC,kB3BjTqB;I2BkTrB,yBAAA;ErHopfF;;EqH9ofE;IAMG,iBAAA;IAGC,0B3BjUiB;E2BqUpB;;EAMD;IACC,kBAAkB;IAKlB,+BAAA;EACC;;EAKC;IAID,iBAAA;IACC,gC3B5VkB;E2BiWpB;;EAOF;IAUO,kBAAA;IACC,8BAAuD;EAU9D;;EAID;IACC,iB3BlYqB;I2BoYtB,+BAAA;EACC;;ErH4lfF;IqHrlfG,kBAAA;IACC,4B3B7YmB;E2B8YnB;;EAGA;IACA,iB3BlZY;I2BqZd,6BAAA;EACC;;EAIC;IAED,kBAAA;IACC,8B3B7ZmB;E2BkarB;;EAID;IACC,iB3BvaqB;I2ByatB,+BAAA;EACC;;EAGA;IACA,kB3B9ac;I2Bgbf,4BAAA;EACC;;EAIA;IAED,iBAAA;IACa,6B3BxbS;E2B6bnB;;EAMH;IACC,mB3Bpcc;I2Bscf,0BAAA;ErH4jfD;;EqHzjfE;IAED,kBAAA;IACC,2B3B5cqB;E2B8ctB;;EAEC;IAED,mBAAA;IACC,gCAAkB;EAEnB;;EAGA;IACC,kBAAiB;IACjB,iCAAgC;EAEjC;;EAEC;IAED,mBAAA;IACC,+B3BjeqB;E2BkerB;;ErHsjfF;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EqHjjfE;IACA,mBAAgC;IrHojfhC,6BAA6B;EqH/ngB7B;;EAMD;IACC,kB3B0FsB;I2BxFvB,8BAAA;EACC;;ErH6ngBF;IqHxngBC,mBAAA;IACI,+BAAwB;EAE5B;;EAGA;IACa,kB3B2EU;I2BzEvB,gCAAA;EACC;;EAGA;IAGA,mBAAA;IAEC,6BAAe;EACf;;EAID;IACA,kB3B0DsB;I2BxDvB,8BAAA;ErHgngBD;;EqH5mgBC;IACC,0B3BmDsB;I2BjDvB,4BAAA;EACC;;EAGA;IACA,6B3B4CsB;I2BzCtB,4BAAA;EACC;;ErH4mgBH;IqHrmgBE,6BAAA;IACC,yB3BgCqB;E2B/BrB;;EAKA;IAED,6BAAA;IACC,4B3BuBqB;E2BrBtB;ArHkmgBJ;;AAEA;EqHplgBQ;IACC,kB3BIiB;I2BHjB,yB3BGiB;E2BClB;;EAKA;IACC,iB3BPS;I2Bcf,0BAAA;EACC;;EAGA;IACA,kBAAQ;IAET,+BAAA;ErHwkgBD;;EqHnkgBE;IACC,iB3B3Ba;I2B8Bb,gCAAA;EACC;;EAGA;IACA,kBAAA;IACC,8BAAsD;EAItD;;EASJ;IACC,iB3BlDsB;I2BoDvB,+BAAA;EACC;;EAGD;IACC,kBAAO;IACP,4BAAY;EAEb;;EAIC;IACC,iB3BjEqB;I2BmEtB,6BAAA;EACC;;EAID;IAED,kBAAA;IACC,8BAAkC;EAClC;;EAGA;IAED,iBAAA;IACC,+BAAkC;EAEnC;;EAGA;IACC,kB3BxFsB;I2B0FvB,4BAAA;EACC;;EAGA;IACA,iBAAA;IACC,6B3BhGqB;E2BmGvB;;EAGA;IACC,mB3BvGsB;I2ByGvB,0BAAA;EACC;;ErHuigBF;IqHjigBC,kBAAA;IACC,2B3BjHsB;E2BmHvB;;EAIC;IACC,mB3BxHa;I2B2Hf,gCAAA;EACC;;EAMG;IAKJ,kBAAA;IACC,iCAAgC;EAChC;;EAGD;IACC,mBAAa;IAEd,+BAAA;EACC;;EAGA;IACA,kB3BpJc;I2BsJf,gCAAA;EACC;;EAGD;IACC,mBAAQ;IACR,6B3B5JsB;E2B8JvB;;EAGA;IACC,kB3BlKsB;I2BqKtB,8BAAA;EACC;;EAMA;IACA,mB3B7KqB;I2B8KrB,+BAAA;ErHyggBH;;EqHnggBE;IAGD,kBAAA;IACC,gCAA0B;EAE3B;;EAGA;IACC,mBAAgC;IAC/B,6BAAA;ErHkggBH;;EqH7/fE;IAKE,kBAAA;IACC,8B3B1MmB;E2B2MnB;;EAID;IACA,0B3BhNoB;I2BqNtB,4BAAA;ErHs/fF;;EqHj/fC;IACC,6B3B3NsB;I2B6NvB,4BAAA;EACE;;EAIA;IACA,6BAAA;IACC,yBAAuD;EAGzD;;EAGC;IACC,6BAAc;IAGhB,4BAAA;EACC;AAID;;ArH0+fJ;EACE,uB0F9tgBgB;A1F+tgBlB;;AqHl+fG;EACC,sBAAkB;AAIjB;;AAQA;EACC,sB3B3QY;A1FuugBlB;;AAEA;EqHr9fI;IACC,uBAAQ;EAET;;EAID;IACC,sB3B5RsB;E2B8RvB;;EAEC;IACA,sB3BjSsB;E2BmSvB;ArHk9fH;;AAEA;EqH98fG;IACC,uB3B1SsB;E2B4SvB;;EAGA;IACC,sB3BhTsB;E2BiTtB;;EAKD;IACC,sB3BvTsB;E2B6TnB;ArHs8fP;;AAEA;EqH37fI;IACC,uBAAkB;EAKlB;;EAKC;IACC,sB3BtVmB;E2B0VpB;;EAMD;IAGC,sB3BnWoB;E2BuWvB;ArH06fH;;AqHr5fI;EACC;IAGF,uBAAA;EACC;;EAGA;IACA,sBAAA;ErHq5fF;;EqH94fI;IACA,sB3B7YoB;E2B+YrB;ArHg5fL;;AqH34fI;EACC;IAGA,uBAAA;EACC;;EAGA;IAKF,sBAAA;EACC;;EAID;IAED,sBAAA;EACC;AAED;;ArHo4fH;;;EqH53fG,gCAAA;ArHg4fH;;AAEA;EqHz3fM,2BAAA;ArH23fN;;AAEA;EqHp3fG,4BAAA;ArHs3fH;;AAEA;EqHn3fG,yCAAmB;EAClB,0B3B3csB;A2B6cvB;;ArHq3fH;EqHj3fG,0CAAW;EACV,yBAAkB;AAEnB;;AAGA;EACC,UAAA;ArHi3fJ;;AAEA;EqH92fI,OAAA;EAED,WAAA;ArH+2fH;;AqH32fG;ErH82fD;IACE,UAAU;EACZ;AACF;;AAEA;EqH52fI,iBAAc;ErH82fhB,eAAe;AqHz7gBb;;AAMD;EACC,UAAU;EAEX,QAAA;ArHs7gBH;;AAEA;EqHl7gBG,UAAA;EACI,QAAO;AAEX;;AAGA;EACa,iB3B4ES;E2B1EtB,WAAA;ArHi7gBH;;AAEA;EqH56gBI,cAAA;EAEC,kBAAe;ArH66gBpB;;AAEA;EqHz6gBI,e3B2Dc;E2BzDf,sBAAA;ArH06gBH;;AqHt6gBG;EACC,gB3BoDc;A2BlDf;;AAGA;EACC,mB3B8Cc;A1Fy3gBlB;;AAEA;EqHl6gBK,gBAAA;ArHo6gBL;;AAEA;EqH/5gBK,gB3BgCa;A2B5Bd;;AAGA;EACC,mB3BwBoB;A2BtBrB;;AAUK;EACC;IAKF,gBAAA;EACC;ArHg5gBT;;AAEA;EqHx4gBQ,WAAA;EACC,gBAAgB;AAOtB;;AAGA;EACC;IACA,gBAAQ;EAET;ArHk4gBH;;AqH73gBI;EACC;IAGA,gBAAA;EACC;AAED;;ArH83gBL;EACE,QqH53gBK;ArH63gBP;;AqHh3gBG;EACC,mB3BjDqB;A2BmDtB;;ArHm3gBH;EqH/2gBG,YAAA;ArHi3gBH;;AqH72gBG;EACC,oB3B5Dc;E2B+Dd,yBAAA;ArH82gBJ;;AAEA;EqHz2gBG;IACC,sB3BvEc;I2ByEf,eAAA;EACC;ArH02gBJ;;AAEA;EqHt2gBG,eAAA;EACC,wBAAkC;AAEnC;;AAGA;EACC;IAED,qBAAA;EACC;AAED;;ArHq2gBH;EACE,uB0Fl8gBgB;A2BkGf;;AAGA;EACC,wB3BtGqB;A2BwGtB;;ArHi2gBH;EACE,wB0F18gBgB;A2B+Gf;;AAGA;EACC,gBAAgB;EAGhB,UAAA;ArH01gBJ;;AAEA;;EqHj1gBO,sB3BjIW;A2BsIf;;ArHi1gBH;;EqH50gBG;;IAGA,wBAAA;EACC;AAED;;ArH80gBH;EqH10gBG,yBAAA;EACC,4B3BtJqB;E2BuJrB,6B3BvJqB;E2ByJtB,gCAAA;ArH20gBH;;AqHv0gBG;EACC;IAED,mBAAA;EACC;AAGA;;AAMA;EACC,UAAU;EACV,oB3B5KoB;A1F++gBzB;;AqH7zgBG;EACC,uBAA6B;EAG9B,sBAAA;ArH8zgBH;;AAEA;EqH1zgBG,mBAAA;ArH4zgBH;;AAEA;EqHxzgBG,oBAAA;EACC,sB3BnMqB;A2BwMnB;;ArHuzgBN;EqHlzgBK,oBAAA;EACC,uB3B9MY;A1FkghBlB;;AAEA;EqH9ygBK,UAAU;EAGZ,oBAAA;ArH8ygBH;;AAEA;EqHzygBI,oBAAA;EACC,uB3BjOa;A1F4ghBlB;;AqHtygBI;EACC,UAAA;EAEA,oBAAA;ArHwygBL;;AAEA;EqHjygBI,iBAAA;ArHmygBJ;;AAEA;EqHhygBK,iBAAA;ArHkygBL;;AAEA;EqH1xgBK,mBAAA;ArH4xgBL;;AAEA;EqHpxgBM,UAAQ;EACR,WAAA;ArHsxgBN;;AAEA;EqH9wgBI,UAAA;EACC,W3BvRa;A2B0Rf;;AAGA;EACC,gBAAY;EACZ,eAAc;ArH6wgBlB;;AAEA;EqHzwgBG,UAAA;EACC,iB3BtSqB;E2BwStB,kBAAA;ArH0wgBH;;AAEA;EqHtwgBG,cAAA;ArHwwgBH;;AAEA;EqHnwgBG,yCAAA;ArHqwgBH;;AAEA;EqHzvgBK,eAAA;EACC,WAAU;AAKZ;;AAMC;EACC,c3BhVmB;A2BoVnB;;AAKA;EAMD,0CAAA;ArHyugBL;;AAEA;EACE,iBqH1tgBS;EAUP,OAAA;ArHktgBJ;;AAEA;EqH7sgBG,eAAA;ArH+sgBH;;AAEA;EqHzsgBK,qBAAA;EACC,qB3B3YmB;A1FslhBzB;;AAEA;EqHxsgBM,e3BhZY;E2BmZd,iBAAA;ArHwsgBJ;;AAEA;;;;EqH5rgBK,c3Bjaa;E2Boaf,eAAA;ArH+rgBH;;AAEA;EqH3rgBG,wBAAA;EACC,iB3B3ac;A1FwmhBlB;;AAEA;EqHxrgBG,sBAAA;ArH0rgBH;;AAEA;EqHnrgBM,iBAAA;ArHqrgBN;;AAEA;EqH9qgBG,eAAA;ArHgrgBH;;AAEA;EqH5qgBI,0C3B1cqB;A2B4ctB;;ArH+qgBH;EqH3qgBG,qBAAA;ArH6qgBH;;AAEA;EqHzqgBG,sBAAA;ArH2qgBH;;AqHvqgBG;EACC,e3B3dqB;A1FqohBzB;;AAEA;EqHvqgBI,e3Bhec;E2Bkef,kBAAA;ArHwqgBH;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EqHnvhBI;IAGC,uB3BgGoB;E2B7FtB;ArHivhBH;;AAEA;EqH9uhBI,gBAAA;ErHgvhBF,W0FxphBgB;E2BpFf,qDAAA;ArH8uhBH;;AAEA;EqH1uhBG,OAAA;EACa,W3B6EE;A2B3Ef;;AAGA;EACC,UAAO;EAGP,WAAA;EAEC,0BAAe;EACf,qD3BiEoB;A2B9DtB;;ArHsuhBH;EqHluhBG,iBAAA;ArHouhBH;;AqHhuhBG;EACC,yB3BqDqB;E2BnDtB,eAAA;ArHkuhBH;;AAEA;EqH/thBI;IAGA,gBAAA;EACC;ArH+thBL;;AqHxthBI;EACC,gBAAgB;ArH2thBrB;;AAEA;EqHrthBI,sBAAA;ArHuthBJ;;AAEA;EqH5shBS,gBAAA;ArH8shBT;;AAEA;EqHxshBS,sB3BKgB;A2BDjB;;AAKA;EACC,uB3BLS;A2BYf;;AAGA;EACC,mB3BhBqB;E2BiBrB,yBAAQ;EAET,yBAAA;ErH4rhBD,kBAAkB;EqH1rhBhB,uB3BrBc;E2BwBd,6BAAA;EACC,cAAA;AAGA;;AAGA;EACC,qB3BhCY;A1FuthBlB;;AAEA;EACE,WqHnrhBM;EAQL,eAAA;ArH6qhBH;;AAEA;EqH1qhBI,kBAAY;EAEb,gBAAA;EACC,aAAO;ArH2qhBX;;AAEA;EqHtqhBI,kBAAA;EACC,UAAU;EAEX,wBAAA;ArHuqhBJ;;AAEA;EqHlqhBG;IACC,kBAAc;EACd;AAED;;AAGA;EACC,mDAAkC;EAEnC,iCAAW;EACV,gD3BnFqB;E2BqFtB,8BAAA;EACC,2C3BtFqB;A2BwFtB;;AAiYA;EACC;IACA,oB3B3dqB;E2B6dtB;;EAEC;IAED,wBAAA;ErHk+gBD;;EAEA;IACE,yBAAyB;EAC3B;;EqH/9gBE;IrHk+gBA,wBAAwB;EqH7iiBxB;;EAMD;IACC,yB3B6FqB;E2B3FtB;;EAEC;IACC,wB3BwFoB;E2BrFtB;;EAGA;IACC,yBAAc;EAEf;;EAGA;IACC,wB3B2EqB;E2BzEtB;;EAIC;IAEC,yBAAe;EACf;;EAID;IACA,wB3B6DqB;E2B3DtB;;EAEC;IAED,yBAAA;EACC;;EAGA;IAED,wBAAA;EACC;;EAIA;IACC,yB3B2CoB;E2BzCpB;;EAKD;IACC,wB3BmCoB;E2BlCpB;;EAKA;IAED,yBAAA;EACC;;EAGA;IASI,wBAAA;EACC;;EAMD;IACA,wB3BMgB;E2BFjB;;EAKA;IACC,uB3BJgB;E2BWtB;;EAGA;IACC,wB3BfqB;E2BgBrB;;ErHw/hBF;IqHp/hBE,uB3BpBqB;E2BuBrB;;EAIC;IACC,wBAAqD;EAEtD;;EAEC;IACC,uBAAkB;EAIlB;;EASJ;IACC,oB3B/CqB;E2BiDtB;;EAEC;IAED,oBAAA;EACC;ArHq+hBJ;;AAEA;EqHh+hBI,gBAAA;EACC,iB3B9Da;E2BgEd,YAAA;EACC,kB3BjEa;E2BoEf,MAAA;EACC,iBAAgB;EAEjB,UAAA;EACC,yBAAkC;EAClC,wB3BzEc;A2B2Ef;;AAGA;EACC;IAED,iBAAA;EACC;AAED;;AAGA;EACC;IAED,YAAA;EACC;ArHw9hBJ;;AqHn9hBG;EACC,kB3BjGc;E2BmGf,YAAA;ArHq9hBH;;AAEA;EqHj9hBI;IACC,YAAA;EAGF;ArHi9hBH;;AAEA;EqH58hBI,UAAA;EACC,SAAA;EAGF,gBAAA;ArH48hBH;;AAEA;EqHl8hBG,aAAA;EACC,sBAAgC;EAChC,gBAAc;ArHo8hBlB;;AAEA;EqHh8hBG;IACC,cAAa;EAEd;ArHi8hBH;;AqH77hBG;EACC,e3BpJqB;E2BqJrB,MAAA;EAED,WAAA;EACC,OAAM;ArH+7hBV;;AAEA;EqH37hBG,aAAA;EACC,sB3B/JqB;A2BkKrB;;AAMA;EACC,iBAA8B;EAC9B,qB3B1KoB;E2B2KpB,sBAAA;ErHu7hBH,kBqHt7hBgB;EAIf,MAAA;EACC,YAAY;EAGb,WAAA;EACC,sBAAQ;EAET,iBAAA;EACC,kB3BxLqB;E2B4LpB,oBAAA;ErHg7hBH,kB0F5miBgB;A2BgMf;;AAMG;EACC,c3BvMW;E2BwMX,UAAA;AAGF;;ArHy6hBL;EqHl6hBI;IrHo6hBA,YAAY;IqHl6hBX,W3BpNa;I2BuNf,eAAA;IACC,cAAgB;IAEjB,UAAA;EACE;AAGD;;ArHg6hBJ;EACE;IqH35hBE,kBAAA;IACC,qB3BrOa;I2BuOb,iBAAA;ErH45hBH;AqHx5hBE;;AAKA;EACC,gB3BjPoB;E2BkPpB,qBAAA;ErHu5hBH,eqHt5hBI;ArHu5hBN;;AqHh5hBG;EACC,eAAA;EAIC,gBAAA;EACC,Y3BhQY;E2BuQb,iBAAA;EACC,gBAAgB;EAChB,cAAQ;ArH04hBd;;AqHl4hBI;EACC,aAAQ;AAET;;AAID;;EAGA,cAAA;ArHi4hBH;;AAEA;;EqH73hBI,a3BjSc;A2BmSf;;AAGA;EACC,c3BvSc;A2BySf;;AAGA;EACC,a3B7Sc;A1FyqiBlB;;AqHt3hBG;EACC,kB3BpTc;A2B0TX;;AAOF;EACC,+B3BlUmB;E2BuUrB,kBAAA;EACC,UAAA;EAKA,YAAA;ArHu2hBL;;AAEA;EqH/1hBM,kBAAA;EACC,qB3BxVkB;E2B6VpB,kBAAA;EAGC,e3BhWmB;E2BoWtB,kBAAA;ArHw1hBH;;AqHn0hBI;EACC;IAGF,kBAAA;IACC,e3B9Xc;E2BgYf;ArHm0hBH;;AAEA;EqH7zhBK;IACC,oB3BzYmB;E2B0YnB;AAED;;ArH+zhBL;;;EqHtzhBK,qBAAA;EACC,c3BtZY;A2BwZb;;AAMD;EACC,kB3B/Za;E2Bkaf,cAAA;EACC,0B3BnaqB;E2BqatB,gBAAA;EACC,W3Btac;E2Bwaf,qBAAA;ArHizhBH;;AqH7yhBG;EACC;IAGD,yBAAA;EACC;AAED;;AAMG;EACC,YAAA;EAKJ,aAAA;EACC,eAAA;EAED,QAAA;ErHoyhBD,qBAAqB;EqHjyhBnB,2C3BrcqB;A2BuctB;;AAGA;;EAIA,2CAAW;ArHiyhBd;;AAEA;EqH7xhBG;IACC,WAAA;EACA;AAED;;ArH+xhBH;EqH3xhBG;IACC,aAAA;EACA;;ErH8xhBF;IACE,eAAe;EACjB;;EAEA;IqH1xhBE,OAAA;IACA,SAAA;IrH4xhBA,iBAAiB;EqHv2iBjB;ArHy2iBJ;;AAEA;;EqHj2iBI,wBAAY;ArHo2iBhB;;AqH/1iBG;;EAGA,2BAAA;ArHi2iBH;;AAEA;;EqH51iBI,a3B4Ec;E2B1Ef,eAAA;EACC,sBAAO;EAGP,oBAAA;EAEC,WAAA;ArH21iBL;;AAEA;;EqHr1iBG,WAAA;ArHw1iBH;;AqHp1iBG;;EAGA,wBAAA;ArHs1iBH;;AAEA;;EqHh1iBI,iBAAA;EACC,WAAA;ArHm1iBL;;AqH50iBI;;EAEC,WAAA;AAID;;AAGA;;EAGA,wBAAA;ArH00iBJ;;AAEA;;EqH3ziBS,iB3BQgB;E2BPhB,WAAA;AAID;;AAKA;;EAQL,WAAA;ArHkziBH;;AAEA;;EqH7yiBG,qBAAA;ArHgziBH;;AqH3yiBI;;EAIC,oBAAA;EACC,WAAA;AAED;;ArH4yiBL;;EqHryiBO,WAAA;ArHwyiBP;;AAEA;;EqH7xiBI,qBAAO;ArHgyiBX;;AAEA;;EqH3xiBG,qBAAA;EACC,WAAA;AAGA;;AAGA;;EAID,WAAA;ArHyxiBH;;AAEA;EqHtxiBI,2B3BxEqB;A2B0EtB;;AAGA;EACC,aAAY;EAEb,eAAA;EACC,sB3BjFqB;E2BmFtB,iBAAA;EACC,WAAU;AAEX;;AAGA;EACC,WAAA;ArHkxiBJ;;AqH7wiBG;EACC,2B3BhGqB;A2BkGtB;;AAGA;EACC,qB3BtGqB;E2BwGrB,WAAA;ArH6wiBJ;;AAEA;EqHxwiBG,2BAAA;ArH0wiBH;;AAEA;EqHpwiBG,oBAAA;EACC,WAAA;AAKE;;AAMH;EACC,2BAAgC;ArH8viBpC;;AqH1viBG;EACC,oBAAa;EAEd,WAAA;ArH4viBH;;AAEA;EqHzviBI,2B3BhJqB;A2BkJtB;;ArH2viBH;EqHvviBG,qBAAA;EACC,WAAQ;ArHyviBZ;;AAEA;EqHrviBG,gBAAA;ArHuviBH;;AAEA;EqH/uiBI,OAAA;EACC,QAAA;ArHiviBL;;AAEA;EqH5uiBG,qBAAA;ArH8uiBH;;AAEA;EqHzuiBG,qBAAA;ArH2uiBH;;AAEA;EqHxuiBK,qBAAA;ArH0uiBL;;AAEA;EqHluiBM,qBAAA;ArHouiBN;;AqH/tiBK;EACC,qB3B3MY;A1F66iBlB;;AAEA;EqH5tiBK,qB3BnNoB;A2BsNtB;;AAGA;EACE,qB3B1Na;A2B6Nd;;ArH0tiBJ;EACE,qBqHxtiBsB;AAGpB;;ArHwtiBJ;EACE,qBqHrtiBkB;AAGhB;;AAKA;EACC,qB3BhPoB;A1Fi8iBzB;;AAEA;EACE,+B0Fp8iBuB;A2ByPtB;;AAKE;EACC,sB3B/PmB;A2BsQpB;;ArHqsiBL;EqHlsiBM,aAAA;ErHosiBJ,eqHnsiBa;EAMX,sBAAA;EACC,oBAAQ;EAET,WAAA;EACC,W3BpRa;A2BuRf;;AAGA;EACC,WAAU;EACV,YAAY;EACZ,U3B7Rc;E2B+Rf,kBAAA;EACC,sB3BhSqB;E2BkStB,gBAAA;EACC,MAAK;AAEN;;AAGA;EACC,yB3BzSqB;A2B2StB;;ArHuriBH;EACE,yB0Fn+iBgB;A2BkTf;;AAOI;EAGC,yB3B5TiB;A2BgUpB;;AAMD;EACC,yBAAkB;AAKlB;;AAKC;EACC,yB3BlVkB;A2BsVnB;;AAMD;EAGC,yB3B/VmB;A2BmWtB;;ArHmpiBH;EqH9niBI,yBAAA;ArHgoiBJ;;AAEA;EqH3niBG,yBAAA;ArH6niBH;;AAEA;EqHvniBK,yBAAA;ArHyniBL;;AqHrniBK;EACC,yB3B5YmB;A1FogjBzB;;AAEA;EqHlniBK,WAAA;ArHoniBL;;AAEA;EqH7miBI,iBAAA;EACC,WAAA;AAGF;;AAGA;EACC,iB3BraqB;E2BuatB,YAAA;EACC,wB3BxaqB;A1FmhjBzB;;AAEA;EqHtmiBG;IACC,Y3Bhbc;E2Bkbf;ArHumiBH;;AAEA;EqH7liBG,iBAAA;EACC,WAAA;AAED;;ArH+liBH;EqH5liBI;IAED,WAAA;EACC;AAED;;ArH6liBH;EqHzliBG,iBAAA;EACC,WAAA;AAED;;AAGA;EACC;IACA,WAAY;EAEb;ArHwliBH;;AqHpliBG;EACC,aAAA;EACA,e3B7dc;E2B+df,sBAAA;ArHsliBH;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EqHjqjBI,qBAAA;EAGC,W3BmGa;A2BhGf;;AAGA;EACC,oBAAY;EACZ,WAAA;ArH8pjBJ;;AAEA;EqHzpjBG,qBAAA;EACC,WAAA;AAED;;AAGA,gCAAA;ArHypjBH;;;;;;;;;CqHxojBG;ArHkpjBH;EqHhpjBI,mB3B2DqB;A2BzDtB;;AAGA;EACC,eAAA;EAED,gBAAA;EACC,+B3BkDqB;E2BjDrB,kC3BiDqB;E2B3CpB,oBAAA;ErH4ojBH,kBqH3ojBoB;AAIlB;;ArH0ojBJ;EqHpojBI;IACC,gB3B+Ba;I2B7Bd,eAAA;EACC;AAED;;AAUK;EACC,WAAU;EAKZ,mBAAA;ArHwnjBR;;AqHlnjBQ;EACC,c3BGgB;E2BCjB,gBAAA;EACC,oD3BFgB;A2BStB;;AAGA;EACC,a3Bbc;A1FwnjBlB;;AAEA;EqHxmjBI;IAGA,aAAA;EACC;AAGA;;AAGA;EACC;IACA,UAAA;ErHqmjBJ;AACF;;AqHxljBG;EACC,W3B7Cc;E2B+Cf,YAAA;ArH0ljBH;;AqHtljBG;EACC,eAAO;EACP,gBAAY;EAEb,uBAAA;ArHwljBH;;AAEA;EqHnljBI,oCAAA;ArHqljBJ;;AAEA;;EqH/kjBI,aAAY;ArHkljBhB;;AAEA;EqH9kjBG,kBAAA;EACC,WAAA;AAED;;AAGA;EACC,oB3BnFqB;E2BqFtB,mBAAA;ArH6kjBH;;AAEA;EqH1kjBI,WAAA;ErH4kjBF,iBqH3kjBG;EAGF,kBAAA;ArH0kjBH;;AAEA;EqHtkjBG,aAAA;ArHwkjBH;;AAEA;;EqHlkjBI,4B3B5GqB;A2B8GtB;;AAIC;EACC,kB3BnHa;A2BsHf;;AAMG;EACC,aAAA;EAKJ,sBAAA;EACC,aAAY;ArHwjjBhB;;AqHpjjBG;EACC,eAAa;EAEd,gBAAA;EACC,eAAa;AAEd;;ArHsjjBH;EqHljjBG,aAAA;ArHojjBH;;AqHhjjBG;EACC,kBAAQ;EACR,U3BvJc;E2ByJf,MAAA;EACC,YAAA;EAED,aAAA;EACC,a3B7Jc;E2BgKd,iBAAA;EACC,uBAA8B;EAK/B,mDAAS;EACR,kBAA8B;EAC9B,c3BxKoB;E2ByKpB,SAAA;ErH2ijBH,mBqH1ijBkC;AAIjC;;AAIA;EACC,WAAQ;EAET,kBAAA;EACC,mB3BtLqB;E2BwLtB,WAAA;EACC,YAAY;EACX,wBAAA;ErHoijBH,gC0F9tjBuB;E2B8LtB,4BAAA;EACC,6B3B/LqB;E2BoMnB,UAAA;EACC,SAAA;ArH8hjBP;;AAEA;EqH1hjBM,UAAA;EAKF,WAAA;ArHwhjBJ;;AqHnhjBG;EACC,gBAAgB;EAEjB,MAAA;ArHqhjBH;;AAEA;EqHjhjBK,aAAA;ArHmhjBL;;AAEA;EqH9gjBK,cAAA;ErHghjBH,YqH/gjBI;EAGF,iBAAA;ArH8gjBJ;;AAEA;EqHzgjBK,gCAAA;ErH2gjBH,eqH1gjBI;ArH2gjBN;;AqHpgjBG;EACC,kBAAkB;AAIjB;;AAQA;EACC,aAAA;ArH8/iBN;;AAEA;EqHv/iBI,UAAA;EACC,WAAQ;EAET,YAAA;EACC,uB3BnRoB;E2BsRtB,SAAA;EACC,c3BvRqB;A2ByRtB;;ArHs/iBH;EqHn/iBI,mB3B5RqB;E2B8RtB,sBAAA;EACC,WAAU;AAEX;;AAGA;EACC,WAAU;EAEX,UAAA;ArHi/iBH;;AAEA;EqH9+iBI,SAAA;ErHg/iBF,SqH9+iBG;AAGF;;AAOI;EAGC,sB3B3TiB;E2B+TpB,mBAAA;EACC,WAAU;AAKZ;;AAMC;EACC,mB3B5UmB;A2BgVnB;;AAKA;EACC,W3BtVW;A2B2Vb;;AAOF;EAUO,uBAAA;ErHm8iBR,eqHl8iBS;AAUP;;AAID;EACC,0B3B5XqB;E2B8XtB,mBAAA;ArHu7iBH;;AAEA;EqHj7iBK,eAAA;ArHm7iBL;;AqH/6iBK;EACC,0B3B3YmB;E2B4YnB,mB3B5YY;A2B+Yd;;AAIC;;EAGA,aAAA;ArH66iBL;;AAEA;EqHr6iBG,iBAAA;ArHu6iBH;;AAEA;EqHn6iBG,kBAAA;EACC,iB3Bvac;E2Bwad,SAAA;AAED;;AAIA;EACC,kB3B/ac;A2Bibf;;AAMG;EACC,eAAA;EAKJ,mBAAA;ArHy5iBH;;AAEA;EqHt5iBI,eAAW;ArHw5iBf;;AAEA;EqHp5iBG,sBAAA;ArHs5iBH;;AqHl5iBG;;;;;;;;;CrH65iBF;AqH/4iBE,gCAAA;ArHi5iBH;EqH/4iBI;IAED,WAAA;ErHg5iBD;;EAEA;IACE,WAAW;EACb;;EqH74iBE;IrHg5iBA,qBAAqB;EqH39jBrB;;EAMD;IACC,oC3BgGqB;E2B9FtB;;EAEC;IACC,a3B2Fa;E2BxFf;;EAGA;IACC,aAAc;EAEf;;EAGA;IACC,sB3B8EqB;E2B5EtB;;EAIC;IAEC,uBAAe;EACf;;EAID;IACA,W3BgEc;I2B9Df,iBAAA;IrH48jBC,6BAA6B;EqH18jB7B;;EAGA;;IAGA,aAAA;EAED;;EAEC;IAGA,aAAA;EACC;;ErHw8jBH;;IqHh8jBG,4B3BsCoB;E2BrCpB;;EAKA;IAED,aAAA;EACC;;EAGA;IASI,aAAA;EACC;;EAMD;IACA,sB3BSgB;E2BLjB;;EAKA;IACC,eAAgB;EAOtB;;EAGA;IACC,kB3BZqB;I2BarB,UAAQ;IAET,cAAA;IrHo6jBC,gBAAgB;IqHl6jBhB,aAAA;IAGA,aAAA;IACC,iB3BrBa;I2BwBb,mDAAA;IACC,uBAAqD;IAEtD,kBAAA;IACC,mB3B5BY;E2B6BZ;;EAKC;IACC,UAAA;IAQL,WAAA;IACC,6C3B5CqB;E2B8CtB;;EAEC;IAED,iBAAA;EACC;;EAGD;IACC,aAAA;EAGA;;EAGA;;IAID,aAAA;EACC;;EAGA;IACA,iB3BtEc;E2BwEf;;EAGA;IACC,kBAAc;EAEf;;EAGA;IACC,c3BlFc;E2BoFf;;EAGA;IACC,SAAA;IACA,oBAAA;ErHs4jBF;;EqHj4jBE;IAED,SAAA;IACC,Y3BjGc;E2BmGf;ArHk4jBH;;AAEA;EqH73jBG;IACC,SAAA;IAED,oBAAA;EACC;AAGA;;AAID;EACC;IAKE,iBAAA;EACC;;EAMH;IACA,aAAc;EACd;;EAGA;IAED,eAAA;IACC,YAAa;IAEd,WAAA;IACC,U3B7Ic;I2B8Id,SAAA;IAED,SAAA;EACC;;EAGD;IACC,aAAQ;EACR;;EAGA;IAED,UAAA;IACC,Y3B5JqB;E2B+JrB;;EAMA;IACC,mBAA8B;IAC9B,W3BvKa;I2BwKb,sBAAA;ErHq2jBH;;EqH/1jBE;IAGD,mBAAA;EACC;;EAGA;IAED,mBAAA;IACC,WAAY;IACX,sBAAA;IACA,e3B1La;E2B6Lf;;EAMG;IACC,mB3BpMkB;E2BqMlB;;EAID;IACA,kB3B1MY;I2B+Md,wBAAA;ErHk1jBF;;EqH70jBC;IACC,uB3BrNqB;I2BuNtB,iBAAA;IACE,SAAA;IAGD,cAAA;IACC,UAAA;IACA,YAAA;IACC,mBAAkB;IAGpB,SAAA;IACC,eAAgB;IAEhB,MAAA;ErH00jBH;;EqHr0jBG;IAID,WAAA;IACC,kB3B9OoB;I2B+OpB,mBAAA;IACC,WAAA;IAED,YAAA;IACE,wB3BnPkB;I2BuPtB,gCAAA;IACC,4BAAkB;IAIjB,6BAAA;IACC,U3B7PY;I2BoQb,SAAA;EACC;;EAEA;IACC,+CAAwB;EAM3B;;EAGA;IACC,U3BlRa;I2BqRf,WAAA;EACC;;EAGA;IACA,0BAAkC;EAClC;;EAGA;IAED,aAAA;EACC;;EAGA;IAED,cAAA;EACC;;EAGA;IACA,0BAAA;IAEC,mB3B7Sa;E2BgTf;;EAOI;IAGC,a3B1TiB;E2B8TpB;;EAMD;IACC,aAAA;EAKA;;EAKC;IACC,e3BhVkB;E2BoVnB;;EAMD;IAGC,kB3B7VmB;E2BiWtB;;ErHuwjBD;IqHlvjBE,kBAAA;EACC;;EAID;IAED,cAAA;EACC;;ErHkvjBF;IqH3ujBG,eAAA;IACC,a3BtYY;E2BuYZ;AAED;;ArH6ujBL;EqHxujBI;IACC,uB3B/YoB;E2BkZpB;;EAGA;IACC,0C3BtZmB;E2B2ZrB;ArHmujBJ;;AAEA,gC0FhokByB;A2BkatB;EACC;IAED,YAAA;EACC;;EAGD;IACC,a3B1aqB;E2B6atB;;EAGA;IACa;iCAKV;EACC;;EAMH;IAED,WAAA;IrHktjBC,mBAAmB;EqHhtjBnB;;EAGD;IACC,W3Brcc;I2Bucf,kBAAA;IACI,YAAA;IACH,iB3Bzcc;I2B2cf,MAAA;IACC,UAAA;EAED;;EAGA;IACC,4BAAmC;EACnC;;EAGA;IACA,4B3BvdqB;E2BydtB;;EAEC;IAED,4BAAA;ErH0sjBD;;EAEA;IACE,wBAAwB;EAC1B;;EqHvsjBE;;IA3kBA,aAAA;EAGC;;EAID;IAED,mBAAA;EACC;;ErHmxkBF;IqH9wkBC,aAAA;EACI;;EAGH;IAED,cAAA;EACa;;EAGZ;IAED,gDAAA;EACC;;EAKC;IACA,sB3BsEqB;I2BnEvB,kBAAA;EACC;;EAGD;IrHswkBC,cAAc;EqHpwkBd;;EAGA;IAED,kBAAA;IACC,uB3BuDsB;I2BrDvB,YAAA;IACC,WAAY;IACZ,mB3BmDsB;I2BhDtB,YAAA;IACC,UAAA;IAEA,WAAA;IACC,iBAAgB;IAIlB,aAAA;IACC,mD3BuCqB;I2BtCrB,SAAA;IAID,mBAAA;EACC;;EAGA;IAED,gDAAA;EACC;;EAUK;IAKF,UAAA;EACC;;EAKD;IACC,+B3BKiB;I2BDlB,0BAAA;IACC,mB3BAU;E2BOhB;;EAGA;IACC,0B3BXsB;I2BYtB,iBAAQ;EAET;;EAEC;IAGA,oBAAA;EACC;;EAIC;IAED,UAAA;EACC;;ErH0tkBJ;IqHptkBK,UAAA;IACC,WAAA;EAQL;;EAGA;IACC,UAAO;IACP,MAAA;IAED,qDAAA;EACC;;EAGD;IACC,UAAA;IAGA,WAAA;EACC;;EAGA;IAGF,cAAA;IACC,kB3BjEe;E2BmEhB;;EAEC;IAED,uCAAA;EACC;;EAGA;IAED,yBAAA;EACC;;EAGA;IAED,UAAA;EACC;;EAGA;IACA,gBAAA;IACC,oD3BzFqB;E2B4FvB;;EAGA;IACC,e3BhGe;E2BkGhB;;EAGC;IACC,qB3BtGc;E2ByGhB;;EAGA;IACC,4B3B7GsB;E2BgHtB;;EAID;IACC,4B3BrHsB;E2B0HpB;;EAMH;IACC,wBAAgC;EAChC;;EAGD;IACC,wBAAa;EAEd;;EAGA;IACC,a3B5Ie;E2B6If;;EAGA;IACA,WAAY;IAEb,2CAAA;EACC;;EAGD;IACC,yB3BxJsB;E2B0JvB;;EAIC;IACC,wBAA8B;IAK/B,sBAAA;IACC,eAA8B;IAC9B,uB3BtKqB;I2BuKrB,qDAAA;ErH+pkBH;;EqHzpkBE;IAGD,6CAAiB;EAChB;;EAGA;IAED,yBAAA;IACC,kBAAgC;IAC/B,qBAAA;IACA,uB3BzLqB;I2B4LvB,iBAAA;EACC;;EAMG;IACA,UAAY;IAGd,QAAA;EACC;;EAMF;IrH4okBA,sBAAsB;IqH1okBrB,sB3BhNqB;E2BmNvB;;EAGA;IACE,WAAA;EAGD;;EAEC;IACC,OAAA;IAGF,WAAA;EACC;;ErHsokBH;IqHhokBE,uBAAA;IACC,qB3BxOc;E2B4Of;;EAEC;IACC,cAAA;EAED;;EAKF;IACC,cAAgB;IAIf,eAAA;IACC,uB3B5PoB;E2BmQrB;;EAEC;IACA,cAAA;IACC,cAAQ;IAMX,eAAA;EACC;;EAGA;IAGF,UAAA;EACC;;EAGA;IACA,SAAA;EACA;;EAGA;IAED,eAAA;EACC;;EAGA;IAED,mBAAA;EACC;;EAGA;IACA,cAAA;IAEC,iBAAgB;IAGlB,cAAA;EACC;;EASI;IAIH,kBAAA;IACC,mB3B9ToB;E2BmUtB;;EAMC;IACC,a3B1UoB;E2B8UpB;;EAKA;IACC,a3BpVmB;E2ByVrB;;EAOF;IAUO,yBAAA;ErHujkBR;;EqH3ikBG;IAGF,aAAA;EACC;;EAGA;IACA,gBAAA;ErH2ikBF;;EqHpikBI;IACA,WAAY;IAEb,kBAAA;IACC,mB3BzYoB;E2B0YpB;;EAID;IAGA,sBAAA;EACC;;EAGA;IAKF,WAAA;IACC,kB3B3Zc;E2B8ZhB;;EAGA;IACC,W3Blae;E2BoahB;;EAEC;IAED,aAAA;EACC;;EAIA;IAED,oBAAA;EACa;;EAMT;IAKJ,eAAA;IACC,OAAA;IAED,MAAA;ErH4gkBD;AACF;;AqHxgkBG;EACC;IAED,aAAA;EACI;;EAGJ;IACC,sCAAmC;EAEpC;;EAGA;IACC,eAAgB;EAChB;;EAGA;IACA,oB3BtdsB;E2BwdvB;;EAEC;IAED,WAAA;ErHogkBD;;EAEA;IACE,kBAAkB;EACpB;;EqHjgkBE;IrHogkBA,eAAe;IqH/klBf,gBAAA;IAGC,c3BsGqB;I2BnGvB,iBAAA;IACC,kB3BkGsB;E2BhGvB;;EAEC;IACC,iB3B6FqB;E2B1FvB;;EAGA;IACC,aAAc;EAEf;;EAGA;IACC,W3BgFe;I2B9EhB,YAAA;IACC,QAAO;IAGP,kBAAA;IAEC,OAAA;IACA,Q3BuEc;I2BpEhB,2BAAA;IACC,mBAAS;IACT,kC3BkEsB;I2B9DtB,oB3B8DsB;E2B5DvB;;EAGA;IACC,aAAA;EAED;;EAEC;;IAOE,8E3B6CoB;E2BzCtB;;EAEC;;IAKA,WAAA;EAED;;EAGA;IACC,qB3B4Bc;I2BnBV,qBAAA;EACC;;EAMD;IACA,a3BWU;E2BPX;;EAKA;IACC,aAAA;EAON;;EAGA;IACC,sB3BVsB;E2BWtB;;ErH0hlBF;IqHthlBE,kB3Bfe;E2BkBf;ArHshlBJ;;AAEA;EqHjhlBK,eAAA;ArHmhlBL;;AAEA;EqH9glBO,cAAA;ArHghlBP;;AAEA;EqHtglBG,eAAA;ArHwglBH;;AqHpglBG;EACC,YAAO;ArHuglBX;;AAEA;EqHlglBI,+BAAA;ArHoglBJ;;AAEA;EqH//kBG,+BAAA;ArHiglBH;;AAEA;EqH9/kBI,aAAA;AAED;;AAGA;EACC,2BAAkC;AAEnC;;AAGA;EACC,QAAA;EAED,qBAAA;EACC,WAAU;EAEX,gBAAA;EACC,kB3BtFe;E2BuFf,UAAA;ErH0/kBF,WqHz/kBG;EAGF,6BAAA;ArHw/kBH;;AAEA;EqHp/kBG,UAAA;EACC,c3BlGe;E2BoGf,iBAAA;ArHq/kBJ;;AAEA;EqHh/kBG;IACC,eAAgB;EAGhB;;EAID;IACC,sB3BpHe;E2ByHb;;EAMH;IACC,eAAY;EACZ;;EAGD;IACC,kBAAa;EAEd;;EAGA;IACC,qB3B3IsB;I2B4ItB,sB3B5IsB;E2B8IvB;;EAEC;IAED,cAAA;EACC;;EAGD;IACC,aAAA;EAED;;EAIC;IACC,aAAY;EAKb;;EAEC;IACA,sBAAA;ErHy9kBH;;EqHn9kBE;IAGD,sBAAA;IACC,uBAAQ;EAET;;EAGA;IACC,sBAAgC;EAC/B;;EAIF;IACC,uB3B5LsB;I2BiMpB,eAAA;EACC;;EAIF;IACC,iB3BvMa;I2BwMb,kB3BxMa;I2B6Mf,gBAAA;ErHs8kBF;AACF;;AAEA;EqHj8kBG;IACE,YAAA;EAGD;ArHi8kBJ;;AAEA;EqH77kBI;IACC,UAAA;IAEA,iBAAA;ErH87kBH;;EqHz7kBG;IAID,aAAA;EACC;;ErH07kBH;IqHt7kBG,aAAA;IACE,8B3BjPmB;E2BqPvB;;EAKE;;IAQA,QAAA;IACC,eAAgB;IAChB,aAAQ;EACR;;EAOF;IACC,cAAQ;IAET,eAAA;IACC,mB3BhRqB;E2BmRvB;;EAGA;IACC,gBAAY;IACZ,kBAAc;EACd;;EAGA;IAED,qBAAA;EACC;;EAGA;IAED,UAAA;IACC,W3BrSsB;E2BuSvB;;EAEC;IAEC,UAAA;IAGF,WAAA;EACC;;EASI;IAIH,kBAAA;EACC;;EAMD;IAKA,UAAA;IACC,W3BzUa;E2B6Ub;;EAKA;IACC,W3BnVY;I2BwVd,UAAA;EAGC;;EAcI;IACC,WAAA;EAUP;;EAID;IACC,W3BzXe;I2B2XhB,UAAA;EACC;;ErHs2kBF;IqH/1kBG,iBAAA;EACC;;EAGD;IACC,oB3BxYoB;E2ByYpB;;EAID;IAGA,cAAA;EACC;;EAGA;IAKF,qBAAA;EACC;;EAID;IAED,sBAAA;IACC,uB3BjasB;E2BmavB;;EAEC;IAED,OAAA;EACC;;EAIA;IAED,UAAA;IACa,QAAA;EAKV;;EAMH;IACC,iB3B3be;E2B6bhB;;EAEC;IACA,cAAgB;IAEjB,kBAAA;EACC;;EAGG;IACH,sB3BvcsB;E2BycvB;;EAGA;IACC,cAAM;IAEP,sBAAA;EACC;ArHi0kBJ;;AAEA;EqH9zkBI;IAED,eAAA;EACC;;EAGD;IrH8zkBC,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EqH5zkBlB;;ErH+zkBF;IqHz4lBE,uCAAA;EAGC;;EAID;IAED,aAAA;EACC;;ErHu4lBF;;;;IqH93lBE,uBAAc;EAEf;;EAGA;IACC,U3BiFe;E2B/EhB;;EAIC;IAEC,gBAAe;EACf;;EAID;IACA,iB3BmEsB;E2BjEvB;;EAEC;IAED,8CAAc;EACb;;EAGA;IAED,aAAA;EACC;;EAIA;IACC,uB3BiDqB;E2B/CrB;;EAKD;IACC,aAAA;EACA;;EAKA;IAED,aAAA;EACC;;EAGA;IASI,cAAA;IACC,qB3BmBgB;E2BdlB;;EAEC;IAID,sBAAA;EACC;;EAKA;IAON,qBAAA;EACC;;EAGA;IACA,eAAQ;IAET,OAAA;ErHk1lBD;;EqH70lBE;IACC,UAAA;IAGA,QAAA;EACC;;EAGA;;IAEC,4BAAsD;EAItD;;EASJ;IACC,e3BzCsB;E2B2CvB;;EAEC;IAED,aAAA;IACC,2BAAwB;EACxB;;EAGA;IAGA,kBAAA;EACC;;EAGA;IAGF,wBAAA;EACC;;EAGA;IACA,aAAA;EAED;;EAGA;IACC,kBAAc;IAEf,UAAA;IACC,MAAA;IAED,YAAA;IACC,sB3B/EsB;I2BiFvB,yBAAA;IACC,Y3BlFe;E2BoFhB;;EAEC;IACC,mB3BvFc;I2B0FhB,+CAAA;EACC;;EAGA;IAED,UAAA;IACC,WAAY;EAEZ;;EAID;IACC,cAAgB;IAEjB,UAAA;IACC,eAAgB;IAGhB,kBAAA;IACC,SAAA;IAGF,oDAAA;EACC;;EAMG;IAKJ,+CAAc;EACb;;EAEA;IAED,UAAA;IACC,WAAa;IAEd,qDAA8B;EAC7B;;EAGA;IACA,a3B3Ie;E2B6IhB;;EAEC;IAED,cAAA;IACC,aAAQ;EACR;;EAGA;IAED,eAAA;EACC;;EAIC;IAKD,UAAA;IACC,gBAA8B;EAC9B;;ErHoxlBH;IqH9wlBC,cAAA;EACC;;EAIA;IAED,eAAA;EACC;;EAGA;;IAEC,c3BvLc;E2B0LhB;;EAMG;IACC,e3BjMY;E2BkMZ;;EAID;IACA,0B3BvMoB;E2B4MtB;;EAEC;IAGF,cAAA;EACC;;EAGC;IAGD,0BAAA;EACC;ArH2vlBL;;AqHtvlBI;EACC,WAAA;ArHyvlBL;;AqHnvlBI;EACC,UAAA;EAID,YAAA;ArHmvlBJ;;AAEA;EqHhvlBK,cAAA;ArHkvlBL;;AAEA;EqH1ulBK,kBAAA;ArH4ulBL;;AAEA;EqHpulBM,OAAM;ArHsulBZ;;AqH9tlBI;EACC,yBAAQ;AAET;;AAID;EACC,kB3BnRsB;E2BqRvB,UAAA;ArH6tlBH;;AAEA;EqH1tlBG,OAAA;ArH4tlBH;;AAEA;EqHxtlBG,UAAA;EACC,QAAA;AAED;;AAGA;EACC,e3BvSe;A1F+/lBnB;;AqHltlBG;EACC,e3B9Se;A2BoTZ;;AAOF;EACC,e3B5Ta;A2BiUf;;AAMC;EACC,e3BxUoB;E2B4UpB,2BAAA;EACC,4B3B7UmB;A2BiVpB;;AAMD;EAGC,e3B1VoB;A2B8VvB;;ArHqrlBH;EqHhqlBI,2BAAA;EACC,4B3BpXqB;A2BuXvB;;AAGA;EACC,e3B3XsB;A1F0hmB1B;;AqHxplBK;EACC,kB3BnYa;A1F8hmBnB;;AAEA;EqHxplBM,iB3BxYa;E2B2Yf,eAAA;EACC,MAAA;EAGA,gBAAA;EACC,sB3BhZoB;E2BkZrB,8BAAA;EACC,gB3BnZa;E2BwZf,+BAAA;EACC,wB3BzZqB;E2B4ZvB,sDAA4B;ArH+olB/B;;AAEA;EqH3olBG,4BAAA;ArH6olBH;;AqHzolBG;EACC,kB3BvasB;E2B0avB,UAAA;EACC,Y3B3ae;E2B6ahB,WAAA;EACa,sB3B9aG;E2Bmbb,cAAA;EACC,qBAAkB;EAKtB,YAAA;EACC,WAAA;EAED,kBAAA;ErHgolBD,kBAAkB;EqH9nlBhB,iBAAW;EACX,0B3B/bsB;E2BicvB,sDAAmB;ArH+nlBtB;;AAEA;EqH5nlBI,yB3BtcsB;E2BwcvB,WAAA;ArH6nlBH;;AAEA;EqHznlBG,cAAA;ArH2nlBH;;AqHvnlBG;EACC,Q3Bnde;E2Bodf,YAAY;AAEb;;ArH0nlBH;EqHtnlBG,8BAAA;ErHwnlBD,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AqHnsmBvB;;AAMD;EACC,gB3BoGe;E2BlGhB,SAAA;ArHgsmBH;;AAEA;EqH5rmBG,SAAA;EACI,mBAAO;EAEX,kBAAA;EACC,kBAAc;EAEf,sBAAA;ArH4rmBH;;AAEA;EqHxrmBG,kBAAA;EACC,OAAO;EAGP,SAAA;EAEC,WAAA;EACA,W3ByEc;E2BtEhB,WAAA;EACC,uBAAS;ArHqrmBb;;AAEA;EqHlrmBI,yB3BgEsB;A2B9DvB;;AAGA;EACC,kB3B0De;E2BxDhB,iBAAA;EACC,gB3BuDe;A1F0nmBnB;;AAEA;EqH5qmBK,gBAAA;ArH8qmBL;;AAEA;EqHzqmBK,mB3ByCc;A2BrCf;;AAGA;EACC,uB3BiCqB;A2B/BtB;;AAUK;EACC,a3BoBS;A2BfX;;ArH2pmBR;EqHrpmBQ,qBAAA;EACC,W3BQU;E2BJX,YAAA;EACC,eAAA;EAON,wBAAA;EACC,kBAA2B;EAE5B,iBAAA;EACC,kB3BRsB;A1FqpmB1B;;AAEA;EqH1omBI,kB3Bbe;A2BgBf;;AAIC;EACC,YAAA;EAED,WAAA;EACC,UAAA;EACA,SAAA;ErHuomBJ,WqHtomBK;EAIA,kBAAA;ErHoomBL,yBqHnomBqB;EAQpB,kBAAA;EACC,Y3BxCe;A2B0ChB;;ArH6nmBH;;;;EqHrnmBG,sBAAA;ArH0nmBH;;AAEA;;;;EqHhnmBI,yB3B9DsB;A2BgEvB;;ArHqnmBH;;;;EqH7mmBI,yBAAkC;AAEnC;;AAGA;;;;EAMA,yBAAA;ArH8mmBH;;AAEA;;;;EqHtmmBI,yB3B7FsB;A2B+FvB;;ArH2mmBH;;;;EqHjmmBG,yBAAA;ArHsmmBH;;AAEA;;;;EqHzlmBO,yB3BxHmB;A2B6HvB;;ArH2lmBH;;;;EqHnlmBG,yBAAA;ArHwlmBH;;AAEA;;;;EqHjlmBI,yB3B9IsB;A2BgJvB;;ArHslmBH;;;;EqH9kmBI,yB3BxJsB;A2B2JtB;;AAMA;;;;ErHglmBF,yBqH5kmBkC;AAIjC;;AAIA;;;;EAMA,yBAAA;ArHskmBH;;AAEA;;;;EqH3jmBO,yB3BhMmB;A1FgwmB1B;;AAEA;;;;EqHrjmBK,yB3B7MqB;A2BgNvB;;AAGA;;;;EAME,yBAAA;ArHqjmBL;;AAEA;;;;EqH3imBK,yB3BrOqB;A2ByOtB;;ArH8imBJ;EACE;IqH1imBG,0BAAA;IACE,kC3B/OmB;E2BmPvB;;EAKE;IACC,yB3BzPoB;I2BgQrB,iCAAA;EACC;;EAEA;IACC,0BAAwB;IAM3B,kCAAA;EACC;AAED;;ArH4imBJ;EqH7gmBG,mBAAA;EACC,mB3B7SsB;E2BmTnB,uBAAA;ArH0gmBP;;AAEA;EqH//lBI;IACC,uBAAkB;EAKlB;ArH6/lBL;;AAEA;EqHr/lBM,WAAA;EACC,Y3BjVY;A2BsVd;;AAOF;EAUO;IACC,WAAA;IAUP,YAAA;IACC,mB3BnXc;E2BsXhB;ArH09lBH;;AAEA;EqHv9lBI,iBAAA;ErHy9lBF,kB0Fp1mBwB;E2BiYrB,WAAA;ArHq9lBL;;AqHj9lBK;EACC;IACA,a3BvYa;E2B0Yf;ArHk9lBJ;;AAEA;EqH78lBK,WAAA;ArH+8lBL;;AAEA;EqHv8lBG,iBAAA;EACC,kB3B5ZsB;E2B8ZvB,cAAA;ArHw8lBH;;AAEA;EqHr8lBI;IAED,aAAA;EACC;AAGD;;AAGA;EACa;IAKV,gBAAA;IACC,cAAgB;EAKpB;ArH27lBH;;AAEA;EqHx7lBI,uBAAW;ArH07lBf;;AAEA;EqHt7lBG,WAAA;EACI,YAAA;EACH,mB3Brce;A2BuchB;;AAGA;;EAGA,aAAA;ArHq7lBH;;AqHj7lBG;EACC,gB3BldsB;E2BmdtB,c3Bnde;A2BqdhB;;ArHo7lBH;EqHh7lBG,qBAAA;ErHk7lBD,oBAAoB;AACtB;;AAEA;EACE,YAAY;EqHh7lBV,aAAA;EACA,eAAc;ErHk7lBhB,aAAa;EqH7/mBX,MAAA;EAGC,Y3ByGc;E2BtGhB,gBAAA;EACC,oD3BqGsB;E2BjGtB,oBAAA;ArH0/mBJ;;AAEA;EqHr/mBG,mBAAA;ArHu/mBH;;AAEA;EqHn/mBG,kBAAA;EAIC,oBAAO;EAGP,QAAA;EAEC,YAAA;EACA,Y3B0Ec;E2BvEhB,gBAAA;EACC,UAAS;EACT,Y3BqEe;E2BnEhB,eAAA;ArH8+mBH;;AqH1+mBG;EACC,qB3B8DsB;A2B5DvB;;AAGA;EACC,aAAY;ArH2+mBhB;;AAEA;EqHt+mBK,QAAA;ArHw+mBL;;AAEA;EqHn+mBK,YAAY;AAIb;;AAGA;EACC,iB3BkCqB;A2BhCtB;;AAUK;EACC,yB3BqBgB;E2BhBlB,mBAAA;EACC,S3BeU;E2BdV,8B3BciB;A2BVlB;;AAKA;EACC,WAAA;EAON,YAAA;EACC,yBAA2B;AAE5B;;ArHw8mBH;;EAEE,uBAAuB;EqHp8mBrB,WAAA;EAGA,UAAA;EACC,kB3BhBc;A2BmBd;;AAGA;EACC,WAAA;EACA,mBAAA;ErHi8mBJ,kBqHh8mBqB;EAIhB,kBAAA;ErH87mBL,YqH77mBM;EAQL,gBAAA;EACC,a3BvCe;E2ByChB,mBAAA;EACC,uBAAO;EACP,gBAAY;EAEb,eAAA;EACC,eAAO;EACP,gBAAY;AAEb;;AAIC;EACC,WAAU;AAEX;;AAID;EACC,mB3B7De;E2B+DhB,cAAA;ArH86mBH;;AqH16mBG;EACC,mCAAkC;AAEnC;;AAGA;EACC,mB3B1EsB;E2B4EvB,cAAA;ArH06mBH;;AAEA;EqHt6mBG,mCAAA;ArHw6mBH;;AAEA;EqHp6mBG,mBAAA;EACC,cAAA;AAED;;AAGA;EACC,kC3B/FsB;A1FmgnB1B;;AqH95mBG;EACC,mB3BtGe;E2BwGhB,cAAA;ArHg6mBH;;AAEA;EqH15mBG,kCAAA;ArH45mBH;;AAEA;EqHl5mBG,WAAA;ArHo5mBH;;AAEA;EqHj5mBG,mBAAA;EACC,kBAAa;EAEd,WAAA;EACC,YAAW;EAEZ,mBAAA;EACC,WAAU;EACV,WAAA;EAED,sBAAA;ArHg5mBH;;AqH54mBG;EACC,mBAAQ;ArH+4mBZ;;AAEA;EqH34mBG,gBAAA;ArH64mBH;;AAEA;EqHr4mBI,YAAA;ArHu4mBJ;;AAEA;EACE,eqHt4mBgB;EAIf,WAAA;EACC,cAAY;EAGb,gBAAA;EACC,cAAQ;EAET,kBAAA;EACC,uB3BhLsB;E2BkLvB,mBAAA;EACC,gBAAY;EACX,cAAA;ErHg4mBH,gB0FpjnBiB;A2BwLhB;;AAMG;EACC,WAAU;ArH03mBjB;;AAEA;EqHt3mBM,e3BrMa;E2B0Mf,gBAAA;ErHo3mBF,cAAc;EqHl3mBX,uB3B5MqB;E2B+MvB,mBAAA;EACC,gBAAgB;EAEjB,cAAA;EACE,gBAAgB;AAGjB;;ArHg3mBJ;EACE,iBqH92mBI;EAGF,6BAAA;EACC,eAAA;ArH62mBL;;AqHv2mBI;EACC,qB3BpOc;A2BwOf;;ArHw2mBJ;EACE,aqHt2mBI;EAED,mBAAA;ArHs2mBL;;AAEA;EqH91mBK,mBAAA;ArHg2mBL;;AAEA;EqHx1mBM,yBAAwB;ArH01mB9B;;AqHl1mBI;EACC,mBAAQ;EAET,iBAAA;EACC,gB3B7QqB;E2BgRvB,WAAA;EACC,gB3BjRsB;E2BmRvB,MAAA;EACC,UAAU;ArHi1mBd;;AqH70mBG;EACC,WAAU;EAEX,mBAAA;ArH+0mBH;;AAEA;EqH30mBG,2BAAA;ArH60mBH;;AAEA;EqH10mBI,2BAAA;ArH40mBJ;;AAEA;EqHl0mBO,mBAAA;EAGC,kB3BrTkB;E2ByTrB,uBAAA;ArH+zmBL;;AAEA;EqHrzmBK,eAAA;ArHuzmBL;;AAEA;EqH/ymBM,gBAAA;EACC,e3BhVmB;E2BqVrB,cAAA;ArH6ymBL;;AAEA;EACE,8BqH9xmBgE;EAU9D,gBAAA;ArHsxmBJ;;AAEA;EqHjxmBG,mBAAA;ArHmxmBH;;AAEA;EqH7wmBK,kBAAA;EACC,WAAU;EACV,YAAY;EAEb,mBAAA;EACC,kB3BrYa;E2BsYb,iB3BtYa;E2ByYf,cAAA;ArH4wmBJ;;AAEA;EqHvwmBK,mCAAA;ArHywmBL;;AAEA;EqHjwmBG,UAAA;ArHmwmBH;;AAEA;EqH/vmBG,WAAA;EACC,Y3Bjae;E2Bkaf,c3Blae;E2BoahB,eAAA;EACC,e3BrasB;A2BwavB;;AAGA;EACa,WAAA;AAKV;;AAMH;EACC,mB3Bxbe;E2B0bhB,iBAAA;ErHovmBD,wCAAwC;EqHlvmBtC,kBAAW;EACX,WAAA;EAED,kBAAA;ArHmvmBH;;AAEA;EqHhvmBI,c3Bpce;E2BschB,eAAA;EACC,WAAA;EAED,eAAA;EACC,YAAM;AAEP;;ArHgvmBH;EqH5umBG,WAAA;EACC,kB3BjdsB;E2BkdtB,WAAA;EAED,gCAAA;EACC,qC3BrdsB;E2BsdtB,qB3BtdsB;E2BwdvB,MAAA;ArH4umBH;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EqH1umBhB,8BAAmC;EACnC,kBAAc;ErH4umBhB,WAAW;EqHvznBT,kBAAA;EAGC,iB3B0GqB;A2BvGvB;;AAGA;EACC,mBAAY;EACZ,WAAA;ArHoznBJ;;AAEA;EqH/ynBG,cAAA;EACC,eAAc;EAEf,iBAAA;EACa,e3BuFU;E2BrFvB,YAAA;ArH+ynBH;;AAEA;EqH1ynBI,WAAA;EAEC,kBAAe;EACf,Y3B2Ec;E2BxEhB,+BAAA;EACC,qCAAS;EACT,qB3BsEsB;E2BpEvB,MAAA;ArHwynBH;;AqHpynBG;EACC,+B3B+DsB;A2B7DvB;;AAGA;EACC,e3ByDe;E2BxDf,Y3BwDe;E2BrDf,SAAA;EACC,YAAA;ArHmynBL;;AqH5xnBI;EACC,eAAA;EACA,8B3B2CqB;E2BvCtB,WAAA;EACC,YAAA;EAED,UAAA;EACC,e3BmCqB;A2BjCtB;;AAUK;EACC,iB3BsBS;A2BjBX;;ArH+wnBR;EqHzwnBQ,WAAA;EACC,Y3BUU;E2BNX,mBAAA;EACC,kB3BKU;E2BEhB,iBAAA;EACC,mBAA2B;EAE5B,WAAA;EACC,iB3BNsB;E2BOtB,kBAAQ;EAET,eAAA;ErHgwnBD,cAAc;EqH9vnBZ,qB3BXe;A2Bcf;;AAIC;EACC,kBAAkB;AAEnB;;ArH4vnBL;EACE;IqHtvnBK,YAAA;ErHwvnBL;;EqH9unBE;IAED,YAAA;EACC;ArHgvnBJ;;AAEA;;EqH3unBG,yBAAA;ArH8unBH;;AAEA;;EqHxunBK,WAAU;AAGZ;;AAGA;;EAEC,WAAA;AAED;;AAGA;;EAGA,gBAAA;ArHqunBH;;AAEA;;EqHhunBI,gB3B/Ee;A2BiFhB;;ArHmunBH;;EqH7tnBG,yBAAA;ArHgunBH;;AAEA;;EqH3tnBI,WAAA;ArH8tnBJ;;AqHxtnBG;;EAGA,WAAA;ArH0tnBH;;AAEA;;EqHntnBI,gBAAgB;AAKd;;AAMH;;EAEC,gBAAc;ArH8snBlB;;AAEA;;EqHzsnBI,yBAAa;AAEd;;ArH4snBH;;EqHvsnBI,W3B3Ie;A1Fq1nBnB;;AAEA;;EqHrsnBG,WAAA;ArHwsnBH;;AAEA;;EqHlsnBK,gBAAY;AAKb;;ArHksnBJ;;EAEE,gBqHhsnBgB;AAIf;;AAIA;;EAGA,yBAAA;ArH2rnBH;;AAEA;;EAEE,WqHzrnBG;AAGF;;AAMG;;EAEC,WAAA;AAGF;;ArHmrnBL;;EAEE,gBAAgB;AAClB;;AAEA;;EqHxqnBK,gBAAgB;AAGjB;;ArH0qnBJ;;EqHpqnBI,yBAAA;ArHuqnBJ;;AAEA;;EqHjqnBK,WAAA;AAID;;ArHkqnBJ;;EqH7pnBK,WAAA;ArHgqnBL;;AAEA;;EqHvpnBM,gB3BvPa;A2B8Pd;;ArHqpnBL;;EAEE,gBqHnpnBa;AAMX;;AAGA;;EAID,yBAAA;ArH4onBH;;AAEA;;EqHxonBI,W3BrRe;A2BuRhB;;AAGA;;EAGA,WAAA;ArHwonBH;;AAEA;;EqHnonBI,gB3BpSe;A1F06nBnB;;AqHhonBG;;EAOI,gBAAA;ArH8nnBP;;AAEA;;EqHlnnBK,yBAAkB;AAKlB;;AAKC;;EAKA,WAAA;ArH2mnBN;;AAEA;;EqHtlnBU,WAAA;ArHylnBV;;AAEA;;EqH3knBI,gB3BrXe;A2BuXhB;;ArH8knBH;;EqHtknBK,gBAAA;ArHyknBL;;AqHrknBK;;EAEC,yB3BrYoB;A2BwYtB;;AAIC;;EAGA,WAAA;ArHmknBL;;AAEA;;EqH1jnBI,W3B1Ze;A2B4ZhB;;AAGA;;EAEC,gB3Bjae;A2BmahB;;AAIA;;EAGA,gBAAA;ArHujnBH;;AAEA;;EqH5inBI,yB3BvbsB;A2BybvB;;ArH+inBH;;EqH1inBG,WAAA;ArH6inBH;;AAEA;;EqHxinBG,WAAA;ArH2inBH;;AAEA;;EqHtinBI,gBAAgB;ArHyinBpB;;AAEA;;EqHpinBG,gBAAA;ArHuinBH;;AqHninBG;;ErHuinBD,yBAAyB;AAC3B;;AAEA;;EqHninBI,WAAA;ArHsinBJ;;AAEA;;EqHhinBI,WAAA;ArHminBJ;;AqHninBI;;ErHuinBF,gBAAgB;AqHvinBd;;ArH0inBJ;;EqHzinBQ,gBAAgB;ArH4inBxB;;AAEA;;EqH/inBI,yBAAkB;ArHkjnBtB;;AqHljnBI;;ErHsjnBF,WAAW;AsH/ooBb;;AtHkpoBA;;EuHjpoBI,WAAW;AvHopoBf;;AAEA;;EwHvpoBA,gBAAA;AxH0poBA;;ACpjoBA;;EwH/FI,gBAAY;AzHwpoBhB;;AAEA;;EyHrpoBI,yBAAkB;AzHwpoBtB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,W0F1poBM;A1F2poBR;;AAEA;;EAEE,gB0F7koBsB;A1F8koBxB;;AAEA;;EyHrooBY,gBAAA;AzHwooBZ;;AAEA;;EAEE,yByH3ooBgC;AzH4ooBlC;;AAEA;;E0H5roBQ,WAAA;AAIA;;A1H6roBR;;E0HtroBQ,WAAA;A1HyroBR;;A0HproBI;;E1HwroBF,gBAAgB;A2HzsoBd;;AAMI;;EAEI,gBjC2FY;A1F4moBxB;;AAEA;;EAEE,yB0FhnoBsB;AiC1ER;;AAQA;;E3HuroBd,WAAW;A4HztoBT;;A5H4toBJ;;E4HttoBQ,WlC8FgB;AkC3FpB;;A5HwtoBJ;;EAEE,gBAAgB;A4HnuoBd;;A5HsuoBJ;;E4HhuoBQ,gBlC8FgB;AkC3FpB;;A5HkuoBJ;;EAEE,yBAAyB;E6H5uoBvB,WAAA;A7H8uoBJ;;AAEA;;EAEE,qB6HjuoBwC;E7HkuoBxC,oC0FhpoBsB;E1FipoBtB,W6HhuoBsB;A7HiuoBxB;;AAEA;;EAEE,W6HntoBc;A7HotoBhB;;AAEA;;E6HvsoBY,qBAAA;A7H0soBZ;;AAEA;;EC7poBA,oCAAiC;A6HlGjC;;A9HowoBA;;EAEE,WAAW;AACb;;AAEA;;EAEE,yB8HhwoB8B;EAE5B,qBAAA;A9HgwoBJ;;AAEA;;;;;;E8H7uoBY,yBAAA;E9HovoBV,qB8HnvoBgC;A9HovoBlC;;AAEA;;E8H3voBY,WAAA;A9H8voBZ;;A+H9xoBI;;EAEF,sBAAY;A/HiyoBd;;AAEA;;;;E+HlxoBQ,yBrCgFgB;AqC7EpB;;A/HsxoBJ;;E+HjxoBE,oCrCPY;A1F2xoBd;;AAEA;;E+HhxoBE,sCrCdgB;EqCiBhB,WAAA;A/HixoBF;;AAEA;;E+H3woBC,WAAA;A/H8woBD;;AAEA;;;;E+HtwoBC,+BAAA;A/H2woBD;;AAEA;;EAEE,yB0FluoBsB;EqCpCvB,WAAA;A/HwwoBD;;AAEA;;EAEE,yBAAyB;E+HpwoBzB,WrC4BsB;AqC1BvB;;AAGA;;EAEI,qBrC3Da;EqC4DhB,oCrCoBsB;EqClBvB,WAAA;A/HmwoBD;;A+H/voBC;;EAEC,WAAA;AAED;;A/HkwoBD;;E+H7voBC,qBAAA;A/HgwoBD;;AAEA;;E+H3voBE,oCrClFgB;AqCqFjB;;AAIA;;EAEC,WAAA;A/H0voBF;;AAEA;;EAEE,yBAAyB;E+HrvoBzB,qBrCpGgB;AqCsGjB;;A/HuvoBD;;;;;;EAME,yB0FnxoBsB;EqCmCvB,qBAAA;A/HkvoBD;;AAEA;;E+H7uoBE,WAAA;AAED;;AAGA;;E/H+uoBC,sBAAsB;AACxB;;A+H1uoBC;;;;E/HgvoBC,yB0FnyoBgB;A1FoyoBlB;;A+HtuoBC;;E/H0uoBC,oCAAoC;AgI74oBlC;;AAKI;;EAEI,sCAAyB;EACzB,WAAO;AhI44oBnB;;AAEA;;EAEE,W0FrzoBgB;AsChFhB;;AhIw4oBF;;;;EgI53oBG,+BtCZe;AsCchB;;AAGA;;EAIU,yBAAA;EACR,WtC0DoB;A1Fm0oBxB;;AgIl3oBgB;;EhIs3oBd,yBAAyB;EiI36oBvB,WAAA;AjI66oBJ;;AiIx6oBI;;EAIA,qBAAA;EACI,oCvC0FgB;EuCxFhB,WAAA;AjIw6oBR;;AiIp7oBI;;EAEI,WAAA;AAGJ;;AAIA;;EAGI,qBAAA;AjIk7oBR;;AkI57oBE;;EAKD,oCAAA;AlI47oBD;;AAEA;;EAEE,WkI37oBC;AlI47oBH;;AkIr7oBI;;EAQY,yBAAA;ElIk7oBd,qBkIj7oB6D;AlIk7oB/D;;AAEA;;;;;;EkIh5oBoB,yBAAA;ElIu5oBlB,qB0Fn3oBsB;A1Fo3oBxB;;AAEA;;EkIz4oBgB,WAAA;AlI44oBhB;;AmI79oBI;;EAGI,sBAAA;AnI+9oBR;;AAEA;;;;EoIn+oBQ,yBAAkB;ApIw+oB1B;;AAEA;;EAEE,oCAAoC;AqI9+oBtC;;ArIi/oBA;;EqI3+oBQ,sCAAkB;EAClB,WpIsGI;AoIpGR;;ArI8+oBJ;;EqIx+oBI,WAAmB;ArI2+oBvB;;AqIv+oBA;;;;EAKI,+BAAwB;ArIy+oB5B;;AAEA;;EAEE,yBqIv+oB2B;ErIw+oB3B,WqIv+oBU;ArIw+oBZ;;AAEA;;EAEE,yBqIp+oB2B;ErIq+oB3B,WqIp+oBiB;ArIq+oBnB;;AAEA;;EAEE,qBqIj+oB2B;ErIk+oB3B,oCqIj+oBY;ErIk+oBZ,WqIj+oBmB;ArIk+oBrB;;AAEA;;EqI39oBI,WAAW;ArI89oBf;;AqIz9oBA;;ErI69oBE,qBAAqB;AACvB;;AAEA;;EAEE,oCAAoC;AqIz9oBtC;;ArI49oBA;;EqIj9oBA,WAAA;ArIo9oBA;;AAEA;;EqIj9oBI,yBAAyB;ErIo9oB3B,qBAAqB;AqIj9oBvB;;ArIo9oBA;;;;;;EqI18oBI,yBAAiB;ErIi9oBnB,qBAAqB;AqI58oBvB;;ArI+8oBA;;EqI38oBI,WAAe;ArI88oBnB;;AAEA;;EqI18oBA,sBAAgB;ArI68oBhB;;AAEA;;;;EAIE,yBAAyB;AqIz8oB3B;;ArI48oBA;;EqIv8oBI,oCAAiB;ArI08oBrB;;AqIn8oBI;;EACI,sCAAkB;ErIu8oBxB,WAAW;AqIn8oBb;;ArIs8oBA;;EqI97oBI,WAAU;ArIi8oBd;;AAEA;;;;EAIE,+BAA+B;AqI97oBjC;;ArIi8oBA;;EAEE,yBAAyB;EqI77oB3B,WAAA;ArI+7oBA;;AqI57oBA;;ErIg8oBE,yBAAyB;EqI57oB3B,WAAW;ArI87oBX;;AAEA;;EqIz7oBA,qBAAgB;EACZ,oC3CjFoB;E2CkFX,WAAA;ArI47oBb;;AqIx7oBA;;ErI47oBE,WAAW;AqIx7oBb;;ArI27oBA;;EqIt7oBI,qBAAQ;ArIy7oBZ;;AAEA;;EAEE,oCAAoC;AqIh7oBrC;;ArIm7oBD;;EqI/6oBE,WAAQ;ArIk7oBV;;AAEA;;EqI96oBI,yBAAA;EACI,qBAAkB;ArIi7oB1B;;AAEA;;;;;;EqIt6oBQ,yBAAA;ErI66oBN,qBgBjjpBgC;AqHwI9B;;ArI46oBJ;;EAEE,WqIz6oBU;AAGR;;ArIy6oBJ;;EAEE,sBCnjpBiB;AoIgJf;;ArIs6oBJ;;;;EqI75oBQ,yBAAkB;ArIk6oB1B;;AAEA;;EqI55oBQ,oCAAkB;ArI+5oB1B;;AAEA;;EqIv5oBA,sCAAA;EAGI,WAAA;ArIw5oBJ;;AAEA;;EAEE,WAAW;AqIp5oBA;;ArIu5oBb;;;;EsIvrpBI,+BAA+B;AtI4rpBnC;;AAEA;;EAEE,yBsI1rpBiB;EtI2rpBjB,WsI1rpBA;AtI2rpBF;;AAEA;;EAEE,yBsIzrpBkB;EtI0rpBlB,WsIzrpBA;AtI0rpBF;;AAEA;;EAEE,qBsIhrpBM;EtIirpBN,oCsIhrpB0B;EtIirpB1B,WsIhrpBiB;AtIirpBnB;;AAEA;;EAEE,WsI/qpBc;AtIgrpBhB;;AAEA;;EsIpqpBI,qBAAmB;AtIuqpBvB;;AAEA;;EAEE,oCsItqpBwB;AtIuqpB1B;;AAEA;;EAEE,WsIrqpBM;AtIsqpBR;;AAEA;;EAEE,yBsIxppB+B;EAGzB,qBAAA;AtIuppBR;;AAEA;;;;;;EsItopBQ,yBAAK;EACD,qBAAkB;AtI6opB9B;;AsItopBI;;EAEF,WAAS;AAGP;;AAIA;;EAMI,sBAAM;AtIiopBd;;AAEA;;;;EAIE,yBsIvnpB6B;AtIwnpB/B;;AAEA;;EAEE,oCsIjnpB6C;AtIknpB/C;;AAEA;;EsItmpBQ,sCAA2B;EAG/B,WAAA;AtIumpBJ;;AAEA;;EAEE,WsIrmpBmB;AAIjB;;AtIompBJ;;;;EAIE,+BsIjmpB4B;AtIkmpB9B;;AAEA;;EsI5lpBA,yBAAY;EACR,WAAS;AtI+lpBb;;AAEA;;EAEE,yBsI7lpBsB;EtI8lpBtB,WsI7lpBM;AtI8lpBR;;AAEA;;EAEE,qBsI1lpBU;EtI2lpBV,oCsI1lpB6B;EtI2lpB7B,WsIxlpBU;AtIylpBZ;;AAEA;;EAEE,WsIllpBU;AtImlpBZ;;AAEA;;EAEE,qBsI9kpBM;AtI+kpBR;;AAEA;;EAEE,oCsI7kpBkC;AtI8kpBpC;;AAEA;;EAEE,WsI3kpBmB;AtI4kpBrB;;AAEA;;EAEE,yBsIzkpBsB;EtI0kpBtB,qBsIzkpB6B;AtI0kpB/B;;AAEA;;;;;;EAME,yBsItkpBwB;EtIukpBxB,qBsItkpBkB;AtIukpBpB;;AAEA;;EAEE,WsIrkpBkB;AtIskpBpB;;AAEA;;EAEE,sBsInkpBU;AtIokpBZ;;AAEA;;;;EsIzjpBI,yBAAiB;AtI8jpBrB;;AAEA;;EsI3jpBI,oCAAkB;AtI8jpBtB;;AAEA;;EAEE,sCsI5jpBqB;EtI6jpBrB,WsI1jpBU;AtI2jpBZ;;AAEA;;EAEE,WsItjpBY;AtIujpBd;;AAEA;;;;EAIE,+BAA+B;AsIjjpB7B;;AtIojpBJ;;EsIhjpBQ,yBAAuB;EACvB,W5C7RA;A1Fg1pBR;;AAEA;;EsI5ipBQ,yBAAA;EtI+ipBN,WsI9ipBmB;AtI+ipBrB;;AAEA;;EAEE,qBsI3ipBU;EtI4ipBV,oC0FzypBsB;E1F0ypBtB,WAAW;AsItipBb;;AtIyipBA;;EAEE,WsIlipBqB;AtImipBvB;;AAEA;;EsI3hpBA,qBAAa;AtI8hpBb;;AAEA;;EsIlhpBY,oCAAC;AtIqhpBb;;AsIhhpBY;;EAEI,WAAA;AtImhpBhB;;AAEA;;EsI7gpBY,yBAAmB;EACnB,qBAAgB;AtIghpB5B;;AAEA;;;;;;EsIlgpBA,yBAAY;EACR,qBAAc;AtIygpBlB;;AAEA;;EAEE,WsItgpBM;AtIugpBR;;AAEA;;EAEE,sBsIrgpBqB;AtIsgpBvB;;AAEA;;;;EAIE,yBsIhgpBU;AtIigpBZ;;AAEA;;EAEE,oCsI3/oBkB;AtI4/oBpB;;AAEA;;EAEE,sCsIv/oBW;EtIw/oBX,WsIv/oBc;AtIw/oBhB;;AAEA;;EAEE,WsIl/oBiB;AtIm/oBnB;;AAEA;;;;EAIE,+BsIh/oBmB;AtIi/oBrB;;AAEA;;EAEE,yBsIh/oBiB;EAGlB,WAAA;AtI++oBD;;AAEA;;EsI3+oBE,yBAAY;EACZ,WAAA;AtI8+oBF;;AAEA;;EAEE,qBsI5+oBa;EtI6+oBb,oCAAoC;EuI7+pBtC,WAAA;AvI++pBA;;AAEA;;EAEE,WuI9+pBM;AvI++pBR;;AAEA;;EuIz+pBC,qBAAgB;AvI4+pBjB;;AAEA;;EG1+pBE,oCAAA;AH6+pBF;;AAEA;;EAEE,WuIx+pBA;AvIy+pBF;;AAEA;;EuIn+pBC,yBAAA;EACC,qBAAS;AvIs+pBX;;AAEA;;;;;;EAME,yBuIt+pBY;EvIu+pBZ,qBAAqB;AuIj+pBvB;;AvIo+pBA;;EAEE,WuIl+pBO;AvIm+pBT;;AAEA;;EAEE,sBuI/9pBa;AvIg+pBf;;AAEA;;;;EuIr9pBI,yBAAI;AvI09pBR;;AAEA;;EAEE,oCuIz9pBmC;AvI09pBrC;;AAEA;;EAEE,sCuIz9pB2B;EvI09pB3B,WuIz9pBkB;AvI09pBpB;;AAEA;;EAEE,WuIz9pBuB;AvI09pBzB;;AAEA;;;;EAIE,+BuIr9pB8B;AvIs9pBhC;;AAEA;;EAEE,yBuIr9pBmC;EvIs9pBnC,WAAW;AuI78pBL;;AvIg9pBR;;EuI58pBY,yBAAY;EACZ,WAAA;AvI+8pBZ;;AAEA;;EAEE,qBuI98pB0B;EvI+8pB1B,oCuI98pBiD;EvI+8pBjD,W0Ft+pBgB;A1Fu+pBlB;;AAEA;;EuIv8pBA,WAAa;AvI08pBb;;AAEA;;EuIv8pBC,qBAAA;AvI08pBD;;AAEA;;EAEE,oCuI18pBc;AvI28pBhB;;AAEA;;EAEE,WAAW;AuIr8pBb;;AvIw8pBA;;EAEE,yBuIt8pBsB;EvIu8pBtB,qBuIt8pBoB;AvIu8pBtB;;AAEA;;;;;;EuIv7pBQ,yBAAE;EACE,qBAAmB;AvI87pB/B;;AwI9mqBQ;;EAEI,WAAA;AxIinqBZ;;AAEA;;EwI5mqBQ,sBAAA;AxI+mqBR;;AAEA;;;;EAIE,yBwItmqBkB;AxIumqBpB;;AAEA;;EAEE,oCwItmqB+C;AAO7C;;AxIkmqBJ;;EwI9lqBQ,sCAAa;EACb,WAAA;AxIimqBR;;AAEA;;EAEE,WwI/lqBsB;AxIgmqBxB;;AAEA;;;;EAIE,+BwI7lqBmC;AxI8lqBrC;;AAEA;;EAEE,yBwI3lqBiC;ExI4lqBjC,WwI1lqBkB;AxI2lqBpB;;AAEA;;EAEE,yBwIzlqBqC;ExI0lqBrC,WwIzlqB0B;AxI0lqB5B;;AAEA;;EAEE,qBwIzlqBmC;ExI0lqBnC,oC0FtkqBsB;E1FukqBtB,WwIzlqB0B;AxI0lqB5B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,qBCpjqBmB;ADqjqBrB;;AAEA;;EAEE,oCwIllqBsC;AxImlqBxC;;AAEA;;EwItkqBY,WAAA;AxIykqBZ;;AAEA;;EAEE,yBwIvkqBmC;ExIwkqBnC,qBwIrkqBc;AxIskqBhB;;AAEA;;;;;;EAME,yBwInkqB4C;ExIokqB5C,qBwInkqBiC;AxIokqBnC;;AAEA;;EAEE,WwIlkqBmC;AxImkqBrC;;AAEA;;EAEE,sBwI9jqBkB;AxI+jqBpB;;AAEA;;;;EAIE,yBwI7jqB+B;AxI8jqBjC;;AAEA;;EwIljqBI,oCAAiB;AxIqjqBrB;;AAEA;;EAEE,sC0FruqBe;E1FsuqBf,WwIhjqBU;AxIijqBZ;;AAEA;;EAEE,WwI1iqBkB;AxI2iqBpB;;AAEA;;;;EAIE,+BAA+B;AwIhiqBjC;;AxImiqBA;;EAEE,yBwIjiqBwB;EAEtB,WAAA;AxIiiqBJ;;AAEA;;EAEE,yBwI/hqB4B;ExIgiqB5B,WwI/hqBiB;AxIgiqBnB;;AyIlwqBA;;EzIswqBE,qBAAqB;EyInwqBrB,oCAAU;EACR,WAAU;AzIqwqBd;;AAEA;;EyIlwqBI,WAAW;AzIqwqBf;;AyIlwqBE;;EzIswqBA,qBAAqB;AyInwqBrB;;AzIswqBF;;EAEE,oCAAoC;AyInwqBpC;;AzIswqBF;;EyIlwqBI,W/C4Ec;A1FyrqBlB;;AAEA;;EAEE,yBAAyB;EyInwqBvB,qBzHoE8B;AhBisqBlC;;AAEA;;;;;;EAME,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EyIlwqBE,sBAAA;AzIqwqBF;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EyIlwqBE,oCAAA;AzIqwqBF;;AAEA;;EAEE,sCyIpwqB2B;EACzB,WAAM;AzIqwqBV;;AAEA;;EAEE,WAAW;AyInwqBX;;AzIswqBF;;;;EyIhwqBI,+BAAqB;AzIqwqBzB;;AAEA;;EyIlwqBI,yBAAmB;EACnB,WAAO;AzIqwqBX;;AAEA;;EyIlwqBI,yBAAiB;EACjB,WAAA;AzIqwqBJ;;AyIlwqBE;;EzIswqBA,qBAAqB;EyI7vqBnB,oCAAA;EACE,WAAQ;AAGV;;AAIA;;EzI4vqBF,WAAW;AGz1qBL;;AH41qBR;;EAEE,qBAAqB;A0In3qBvB;;A1Is3qBA;;E0Ij3qBI,oCAAwB;A1Io3qB5B;;AAEA;;E0I12qBA,WAAW;A1I62qBX;;A0I12qBA;;E1I82qBE,yB0I52qBc;EACZ,qBAAQ;A1I62qBZ;;AAEA;;;;;;EAME,yBAAyB;E0I12qB3B,qBAAY;A1I42qBZ;;AAEA;;E0Ix2qBA,WAAc;A1I22qBd;;A0Ix2qBA;;E1I42qBE,sBAAsB;A0Iz2qBxB;;A1I42qBA;;;;E0Ip2qBI,yBAAwB;A1Iy2qB5B;;AAEA;;E0Ip2qBA,oCAAY;A1Iu2qBZ;;AAEA;;EAEE,sC0Ir2qBa;E1Is2qBb,W0Ir2qBA;A1Is2qBF;;AAEA;;EAEE,W0In2qBA;A1Io2qBF;;AAEA;;;;EAIE,+B0Il2qBoB;A1Im2qBtB;;A2It7qBA;;E3I07qBE,yBAAyB;E2Iv7qB3B,WAAA;A3Iy7qBA;;A2Ir7qBC;;E3Iy7qBC,yBAAyB;EACzB,WAAW;AACb;;AAEA;;E4Il8qBI,qBAAe;E5Iq8qBjB,oCAAoC;E4Il8qBtC,WAAa;A5Io8qBb;;AAEA;;E4Ij8qBI,WAAA;A5Io8qBJ;;AAEA;;EAEE,qBAAqB;A4Il8qBrB;;A5Iq8qBF;;EAEE,oCAAoC;A4Ij8qBtC;;A5Io8qBA;;EAEE,WAAW;A4Ih8qBb;;A5Im8qBA;;E4I97qBE,yBAAa;E5Ii8qBb,qBAAqB;A6In+qBvB;;A7Is+qBA;;;;;;E6I79qBC,yBAAa;EACb,qBAAkB;A7Io+qBnB;;A6Ih+qBA;;EAEC,WAAU;A7Im+qBX;;AAEA;;E6I/9qBC,sBAAkB;A7Ik+qBnB;;AAEA;;;;E6I59qBI,yBAAa;A7Ii+qBjB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;E6I59qBI,sCAAwB;E7I+9qB1B,WAAW;A6I59qBb;;A7I+9qBA;;EAEE,WAAW;AACb;;AAEA;;;;E8I/grBI,+BAAc;A9IohrBlB;;AAEA;;E8IvgrBI,yBAAA;E9I0grBF,WAAW;AACb;;AAEA;;E8I5grBQ,yBAAwB;A9I+grBhC;;AAEA;;E+InirBA,cAAgB;A/IsirBhB;;AAEA;;EAEE,+B+IpirBe;E/IqirBf,sC+IpirBc;A/IqirBhB;;AAEA;;EAEE,+B+IlirBkB;A/ImirBpB;;AAEA;;EAEE,+BAA+B;AgJrjrBjC;;AhJwjrBA;;EgJ/irBI,8BAAe;AhJkjrBnB;;AgJ9irBA;;;;;;EAOI,WAAW;AhJgjrBf;;AAEA;;;;;;EAME,UAAU;AgJ3irBZ;;AhJ8irBA;;;;;;EgJpirBA,WAAa;AhJ2irBb;;AAEA;;EgJ3grBI,qBAAa;AhJ8grBjB;;AAEA;;EgJ1grBI,+BAAQ;AhJ6grBZ;;AAEA;;;;;;EAME,WAAW;AgJzgrBb;;AhJ4grBA;;EgJxgrBI,sCAA4B;AhJ2grBhC;;AgJvgrBA;;EAEI,0CAAgB;AhJ0grBpB;;AgJtgrBA;;EAEI,yBAAS;AhJygrBb;;AAEA;;;;EgJhgrBI,yBAAyB;AhJqgrB7B;;AAEA;;;;;;EgJ1/qBA,yBAIC;AhJ6/qBD;;AgJ3/qBA;;EAEI,sCAAW;AhJ8/qBf;;AAEA;;EAEE,sCgJ5/qBuB;AhJ6/qBzB;;AAEA;;EgJt/qBI,yBAAG;AhJy/qBP;;AAEA;;EAEE,cgJv/qBkB;AAIpB;;AhJs/qBA;;EgJj/qBA,+BAAA;EACI,sCAAa;AhJo/qBjB;;AAEA;;EgJh/qBA,+BAOC;AhJ4+qBD;;AAEA;;EgJ5+qBA,+BAOC;AhJw+qBD;;AAEA;;EGnprBE,8BAAA;AHsprBF;;AAEA;;;;;;EiJ5qrBA,WAAA;AjJmrrBA;;AkJ1rrBA;;;;;;ECKI,UAAU;AnJ8rrBd;;AAEA;;;;;;EAME,WmJ5rrBM;AnJ6rrBR;;AmJvrrBA;;EnJ2rrBE,qBAAqB;AmJlrrBrB;;AnJqrrBF;;EAEE,+BAA+B;AACjC;;AmJ/qrBE;;;;;;EAKC,WzDyDqB;AyDrDtB;;AnJirrBF;;EAEE,sCAAsC;AACxC;;AmJ3qrBE;;EACC,0CnI2C+B;AmIzChC;;AnJ+qrBF;;EmJzqrBE,yBAAA;AnJ4qrBF;;AmJzqrBE;;;;EnJ+qrBA,yBAAyB;AmJrqrBzB;;AnJwqrBF;;;;;;EmJ7prBE,yBAAA;AnJoqrBF;;AmJjqrBE;;EACC,sCAA4B;AnJqqrB/B;;AmJ/prBE;;EACC,sCnIA+B;AmIEhC;;AnJmqrBF;;EmJhqrBG,yBnIL+B;AmIShC;;AnJiqrBF;;EAEE,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;EmJ7prB9B,sCnIpB+B;AmIsBhC;;AnJ+prBF;;EmJ5prBG,+BnIzB+B;AhBwrrBlC;;AAEA;;EmJ3orBI,+BAAe;AnJ8orBnB;;AAEA;;EmJ1orBI,8BAAC;AnJ6orBL;;AmJzorBA;;;;;;EnJiprBE,WAAW;AACb;;AmJzorBA;;;;;;EnJiprBE,UmJzorBM;AnJ0orBR;;AmJlorBI;;;;;;EnJ0orBF,WmJporBC;AnJqorBH;;AAEA;;EmJznrBQ,qBAAY;AnJ4nrBpB;;AAEA;;EmJrnrBI,+BAAU;AnJwnrBd;;AAEA;;;;;;ECxurBA,WAAA;AmJnGI;;ApJo1rBJ;;EoJh1rBQ,sCAAY;ApJm1rBpB;;AAEA;;EoJh1rBQ,0CAAmB;ApJm1rB3B;;AAEA;;EoJ90rBQ,yBAAc;ApJi1rBtB;;AAEA;;;;EoJ50rBQ,yBAAkB;ApJi1rB1B;;AoJ50rBA;;;;;;EpJo1rBE,yBAAyB;AoJx0rB1B;;ApJ20rBD;;EoJt0rBE,sCAAqB;ApJy0rBvB;;AAEA;;EAEE,sCAAsC;AoJn0rBxC;;ApJs0rBA;;EoJj0rBI,yBAAW;ApJo0rBf;;AoJ/zrBA;;EpJm0rBE,cAAc;AoJh0rBhB;;ApJm0rBA;;EoJ/zrBC,+BAA6B;EAEpB,sCAAA;ApJi0rBV;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,WoJvzrBE;AAGF;;ApJuzrBF;;;;;;EAME,UoJlzrBE;AAGF;;ApJkzrBF;;;;;;EAME,WoJ7yrBE;AAGF;;ApJ6yrBF;;EoJtyrBG,qBAAkB;ApJyyrBrB;;AAEA;;EoJpyrBE,+BAAA;ApJuyrBF;;AoJjyrBE;;;;;;EAQA,WAAA;ApJkyrBF;;AAEA;;EoJ5xrBC,sCAAiB;ApJ+xrBlB;;AAEA;;EAEE,0CoJ7xrBY;ApJ8xrBd;;AAEA;;EAEE,yBoJ7xrBY;ApJ8xrBd;;AAEA;;;;EAIE,yBoJ9xrBY;ApJ+xrBd;;AAEA;;;;;;EAME,yB0Fl4rBwB;A1Fm4rB1B;;AAEA;;EAEE,sCoJ1xrBkB;ApJ2xrBpB;;AAEA;;EAEE,sCoJxxrBY;ApJyxrBd;;AAEA;;EAEE,yBAAyB;AoJ/wrB3B;;ApJkxrBA;;EAEE,coJhxrBW;ApJixrBb;;AAEA;;EAEE,+BoJhxrBgB;EpJixrBhB,sCoJhxrBc;ApJixrBhB;;AAEA;;E4F77rBI,+BAAyB;A5Fg8rB7B;;AAEA;;EqJ3/rBQ,+BAAA;ArJ8/rBR;;AAEA;;EAEE,8BqJ5/rB6B;AAMvB;;ArJy/rBR;;;;;;EqJ3+rBY,WAAO;ArJk/rBnB;;AAEA;;;;;;EAME,UqJz+rBsB;AAKZ;;ArJu+rBZ;;;;;;EqJz9rBgB,WAAO;ArJg+rBvB;;AAEA;;EqJv9rBgB,qBAAY;ArJ09rB5B;;AAEA;;EAEE,+BqJx9rB0B;ArJy9rB5B;;AAEA;;;;;;EsJ9isBI,WAAA;AtJqjsBJ;;AAEA;;EsJhjsBA,sCAAyB;AtJmjsBzB;;AAEA;;EAEE,0CAA0C;AsJzisBhC;;AtJ4isBZ;;EsJjisBgB,yBACJ;AtJmisBZ;;AAEA;;;;EuJ1ksBI,yBAAc;AvJ+ksBlB;;AAEA;;;;;;EAME,yBAAyB;AuJ7ksB3B;;AvJglsBA;;EuJ5ksBI,sCAAqB;AvJ+ksBzB;;AuJxksBI;;EAGI,sCAAQ;AvJ0ksBhB;;AAEA;;EAEE,yBAAyB;AuJjksBvB;;AvJoksBJ;;EuJ/jsBQ,cAAA;AvJkksBR;;AAEA;;EAEE,+BuJjksB0B;EvJkksB1B,sCuJjksB6B;AvJkksB/B;;AAEA;;EAEE,+BuJ5jsB0B;AvJ6jsB5B;;AAEA;;EuJjjsBY,+BAAY;AvJojsBxB;;AAEA;;EuJ5isBgB,8BAAA;AvJ+isBhB;;AuJxisBY;;;;;;EvJgjsBV,WAAW;AuJ/hsBT;;AAIA;;;;;;EAWH,UAAA;AvJ0hsBD;;AAEA;;;;;;EAME,WAAW;AwJzpsBb;;AxJ4psBA;;EAEE,qBwJzpsBqB;AxJ0psBvB;;AAEA;;EAEE,+BwJxpsB8B;AxJypsBhC;;AAEA;;;;;;EAME,WwJlpsBU;AxJmpsBZ;;AAEA;;EAEE,sCAAsC;AyJ1rsBxC;;AzJ6rsBA;;EyJxrsBI,0C/DgHY;A1F2ksBhB;;AAEA;;EAEE,yB0F/qsBY;A1FgrsBd;;AAEA;;;;EyJjrsBC,yBxJ2G+B;AD2ksBhC;;AAEA;;;;;;EyJ5qsBI,yBAAgB;AzJmrsBpB;;AAEA;;EyJ9qsBA,sCAAA;AzJirsBA;;AAEA;;EyJ9qsBI,sCAAQ;AzJirsBZ;;AyJ9qsBA;;EAEC,yBxJ8E+B;ADmmsBhC;;AAEA;;EAEE,cyJhrsBY;AzJirsBd;;AAEA;;EAEE,+BAA+B;EyJ5qsBjC,sCAAiB;AzJ8qsBjB;;AAEA;;EAEE,+BAA+B;AyJ3qsBjC;;AzJ8qsBA;;EGrvsBA,+BAAA;AHwvsBA;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;A0J3vsBA;;EAEC,+BAAW;A1J8vsBZ;;AAEA;;;;;;EAME,W0J5vsBG;A1J6vsBL;;AAEA;;EAEE,sC0J5vsBe;A1J6vsBjB;;AAEA;;EAEE,0C0J3vsBqB;A1J4vsBvB;;AAEA;;EAEE,yB0J3vsBe;A1J4vsBjB;;AAEA;;;;EAIE,yB0JrvsBG;A1JsvsBL;;AAEA;;;;;;E0JjusBE,yBAAA;A1JwusBF;;AAEA;;EAEE,sC0JpusBiC;A1JqusBnC;;AAEA;;EAEE,sC0JpusByB;A1JqusB3B;;AAEA;;EAEE,yB0FtqtBK;A1FuqtBP;;AAEA;;EAEE,c0JlusBU;A1JmusBZ;;AAEA;;EAEE,+BGrrtBA;EHsrtBA,sC0JxusBU;A1JyusBZ;;AAEA;;EAEE,+B0J/tsB+B;A1JgusBjC;;AAEA;;EAEE,+B0J5tsBU;A1J6tsBZ;;AAEA;;EAEE,8B0JttsBiC;A1JutsBnC;;AAEA;;;;;;EAME,W0JttsBU;A1JutsBZ;;AAEA;;;;;;EAME,U0JptsBc;A1JqtsBhB;;AAEA;;;;;;EAME,WGhutBA;AHiutBF;;AAEA;;EAEE,qB0J9ssB2B;A1J+ssB7B;;AAEA;;EAEE,+B0J1ssBuB;A1J2ssBzB;;AAEA;;;;;;E2JtvtBA,WAAA;A3J6vtBA;;AAEA;;E2JzvtBI,sCjEiDwB;A1F2stB5B;;AAEA;;EAEE,0C0FxvtBY;A1FyvtBd;;AAEA;;E4JjxtBA,yBAAa;A5JoxtBb;;A6JpxtBA;;;;EAKI,yBnEgGoB;A1FsrtBxB;;AAEA;;;;;;EAME,yB6JnxtBuB;A7JoxtBzB;;AAEA;;E8JtytBA,sCAAA;A9JyytBA;;AAEA;;E8JtytBI,sCpEkGsB;A1FustB1B;;A8JrytBA;;E9JyytBE,yBAAyB;A8JrytB3B;;A9JwytBA;;E+JpztBI,cAAQ;A/JuztBZ;;AAEA;;E+JlztBA,+BAAU;EACN,sCAAqB;A/JqztBzB;;AAEA;;EAEE,+B+JpztBsB;A/JqztBxB;;AAEA;;EAEE,+BgKn0tBQ;AhKo0tBV;;AAEA;;EAEE,8BgKl0tBc;AhKm0tBhB;;AAEA;;;;;;EAME,WgK1ztBA;AhK2ztBF;;AAEA;;;;;;EgK/ytBA,UAAA;AhKsztBA;;AAEA;;;;;;EAME,W0FlwtBgB;A1FmwtBlB;;AAEA;;EiKn2tBI,qBAAkB;AjKs2tBtB;;AAEA;;EAEE,+BAA+B;AiKh2tBjC;;AjKm2tBA;;;;;;EAME,WiK/1tBU;AjKg2tBZ;;AAEA;;EkK33tBA,sCAAmB;AlK83tBnB;;AAEA;;EAEE,0CkKt3tBiB;AlKu3tBnB;;AAEA;;EAEE,yBkKp3tBU;AlKq3tBZ;;AAEA;;;;EmKt4tBQ,yBAAgB;AAGpB;;AnK04tBJ;;;;;;EmK93tBI,yBAAW;AnKq4tBf;;AAEA;;EmKh4tBI,sCAAU;AnKm4tBd;;AAEA;;EoK75tBA,sCAAa;ApKg6tBb;;AAEA;;EoK55tBI,yB1E6FsB;A1Fk0tB1B;;AAEA;;EoKv5tBI,cAAA;ApK05tBJ;;AAEA;;EAEE,+BgB70tBgC;EhB80tBhC,sCAAsC;AoKl5tBxC;;ApKq5tBA;;EoKh5tBI,+BAAgB;ApKm5tBpB;;AoK/4tBA;;EAEI,+BAAW;ApKk5tBf;;AAEA;;EoK94tBI,8BAAA;ApKi5tBJ;;AoK74tBA;;;;;;EpKq5tBE,WAAW;AoK94tBb;;ApKi5tBA;;;;;;EAME,UAAU;AoKx4tBJ;;ApK24tBR;;;;;;EoK73tBQ,WAAA;ApKo4tBR;;AAEA;;EoK73tBQ,qBAAY;ApKg4tBpB;;AAEA;;EoK73tBQ,+BAAsB;ApKg4tB9B;;AoK33tBA;;;;;;ECpGA,WAAW;ArKw+tBX;;AAEA;;EqKr+tBC,sCAAW;ArKw+tBZ;;AqKr+tBA;;EAEI,0C3EoFsB;A1Fo5tB1B;;AAEA;;EAEE,yBAAyB;AqK39tB3B;;ArK89tBA;;;;EAIE,yBAAyB;AsKtguB3B;;AtKyguBA;;;;;;EAME,yB0F16tBsB;A1F26tBxB;;AAEA;;EAEE,sCAAsC;AsKhguBxC;;AtKmguBA;;EsK9/tBA,sCAAwC;AtKiguBxC;;AsK7/tBA;;EtKiguBE,yBAAyB;AuK9huB3B;;AvKiiuBA;;EuK5huBE,cAAA;AvK+huBF;;AuK3huBE;;EAEE,+BAAa;EACb,sCAAgB;AvK8huBpB;;AAEA;;EuK1huBI,+BAAc;AvK6huBlB;;AAEA;;EAEE,+BuK3huBc;AvK4huBhB;;AAEA;;EAEE,8BuKzhuBW;AvK0huBb;;AAEA;;;;;;EuK/guBI,WAAO;AvKshuBX;;AAEA;;;;;;EuK9guBI,UAAO;AvKqhuBX;;AAEA;;;;;;EuK7guBE,WAAA;AvKohuBF;;AAEA;;EuKjhuBI,qBAAgB;AvKohuBpB;;AAEA;;EuKhhuBI,+BAAS;AvKmhuBb;;AAEA;;;;;;EAME,WuKlhuBI;AvKmhuBN;;AAEA;;EuK9guBI,sCAAe;AvKihuBnB;;AAEA;;EuKtguBI,0CAAoB;AvKyguBxB;;AAEA;;EuKnguBE,yBAAA;AvKsguBF;;AuKlguBE;;;;EAIE,yBAAW;AvKqguBf;;AAEA;;;;;;EAME,yBuKnguBe;AvKoguBjB;;AAEA;;EAEE,sCuKnguBa;AvKoguBf;;AAEA;;EAEE,sCAAsC;AuK9/tBtC;;AvKiguBF;EACE,gBAAgB;EuK7/tBhB,uBAAA;AvK+/tBF;;AuK3/tBE;;EAGE,8BAAA;AvK6/tBJ;;AAEA;EACE;IuKv/tBA,iBAAA;IACE,cAAU;EACV;;EAEA;IvKy/tBA,iBAAiB;EuKt/tBnB;AvKw/tBF;;AAEA;EuKt/tBI;IACA,aAAM;EACN;AvKw/tBJ;;AAEA;EuKt/tBI;IvKw/tBA,aAAa;EuKr/tBf;AvKu/tBF;;AAEA;EuKr/tBI,iBAAW;AvKu/tBf;;AAEA;EuKp/tBI,aAAA;AvKs/tBJ;;AAEA;EuKn/tBI,aAAA;AvKq/tBJ;;AAEA;EuKl/tBI,UAAA;EvKo/tBF,iBAAiB;AuKj/tBjB;;AvKo/tBF;EuKh/tBE,mBAAA;EACE,kBAAO;AvKk/tBX;;AAEA;;;;;EuK3+tBI,wCAA4B;AvKi/tBhC;;AAEA;EuK5+tBE,cAAA;EACE,eAAG;AvK8+tBP;;AAEA;EACE,kBuK3+tBc;AvK4+tBhB;;AAEA;EACE,kBuKx+tBc;AvKy+tBhB;;AAEA;EACE,UuKt+tBI;ECzPN,iBAAmB;AACnB;;AxKkuuBA;EACE;IwK/tuBE,iBAAkB;IxKiuuBlB,cAAc;EwK9tuBjB;AxKguuBD;;AAEA;EwK9tuBE;IxKguuBE,WAAW;EwK7tuBf;;EAEC;IxK+tuBG,WAAW;EwK7tuBf;;ExKguuBE;IwK7tuBF,iBAAA;ExK+tuBE;;EAEA;IACE,iBwK9tuBO;EACP;AxK+tuBJ;;AAEA;EACE;IwKxtuBF,WAAS;EACR;;ECrCG;IACI,iB/EqGU;E+ElGd;;EAIA;IACI,iBzJ2FE;EyJxFN;AzK2vuBJ;;AyKpvuBI;EACI;IACA,WAAa;EACb;;EAEA;IAES,iBAAA;EzKsvuBf;AACF;;AAEA;EACE;IyK/uuBE,WAAA;EACI;;EAIJ;IACI,iBAAe;EAGnB;AzK6uuBJ;;AAEA;EyK3uuBQ,WAAW;AzK6uuBnB;;AAEA;EyKtuuBQ,iBAAW;AzKwuuBnB;;AAEA;E0KlyuBC,WAAU;A1KoyuBX;;AAEA;E0KlyuBC,iBAAY;EACZ,gBAAY;A1KoyuBb;;AAEA;E0KlyuBC,SAAQ;A1KoyuBT;;AAEA;E0KlyuBA,iBACA;EACC,QAAK;A1KmyuBN;;AAEA;EACE,SAAS;A2KpyuBX;;A3KuyuBA;;;EAGE,cAAc;AAChB;;AAEA;E2KnyuBA,mBAAA;A3KqyuBA;;AAEA;E2KnyuBI,kCAAU;A3KqyuBd;;AAEA;E2KlyuBI,cAAU;A3KoyuBd;;AAEA;E2KjyuBI,yBAAa;A3KmyuBjB;;AAEA;E2KhyuBI,8CAAa;A3KkyuBjB;;AAEA;E2K/xuBI,cAAa;A3KiyuBjB;;AAEA;E2K9xuBI,mBAAa;A3KgyuBjB;;AAEA;EACE,yBAAyB;A2K5xuB3B;;A3K+xuBA;;E2K1xuBA,kCAAqB;EACjB,cAAU;A3K6xuBd;;A2KxxuBI;E3K2xuBF,SAAS;EACT,mBAAmB;AACrB;;AAEA;;E2KxxuBQ,mBAAY;A3K2xuBpB;;AAEA;E4Kl2uBG,mBlFuFe;A1F6wuBlB;;AAEA;EACE,yB0F11uBoC;A1F21uBtC;;AAEA;EACE,qB4Kl3uBW;E5Km3uBX,c4Kl3uBa;A5Km3uBf;;A4Kv2uBE;EAcC,yBlFmEuB;A1F0xuB1B;;AAEA;E4K31uBG,yBAAyB;A5K61uB5B;;AAEA;EACE,yB0F32uBoC;E1F42uBpC,qB4K/2uBgB;A5Kg3uBlB;;AAEA;EACE,yB4K/2uBW;A5Kg3uBb;;AAEA;E4Kr2uBE,cAAA;A5Ku2uBF;;AAEA;E4Kr2uBG,yBAAyB;A5Ku2uB5B;;AAEA;E4K31uBG,mB5JwCO;AhBqzuBV;;AAEA;EACE,c0F53uBa;E1F63uBb,qB0F73uBa;A1F83uBf;;A4K51uBE;EAcC,c5JoBO;AhB8zuBV;;AAEA;E4Kh1uBG,yBAAyB;A5Kk1uB5B;;AAEA;EACE,c4Kp2uBc;A5Kq2uBhB;;AAEA;EACE,c4Kp2uBE;E5Kq2uBF,wC4Kp2uBW;A5Kq2uBb;;AAEA;;E4Kz1uBY,yBAAyB;A5K41uBrC;;AAEA;E4K11uBG,yBAAA;AAMC;;AAKA;EACI,yBAAoB;A5Ko1uB5B;;AAEA;E4Kl1uBQ,yBlFtDM;A1F04uBd;;AAEA;EGp3uBC,yBAAwB;AHs3uBzB;;AAEA;;E4K90uBQ,gCAAa;A5Ki1uBrB;;AAEA;EACE,c4Kh1uBkB;A5Ki1uBpB;;AAEA;EACE,yB4Kh1uBkB;E5Ki1uBlB,kC4K/0uBU;A5Kg1uBZ;;AAEA;EACE,yB4K/0uB0B;E5Kg1uB1B,kC4K/0uBuC;A5Kg1uBzC;;AAEA;EACE,yB4K10uBkC;A5K20uBpC;;AAEA;EACE,mB4K/zuBkC;A5Kg0uBpC;;A4KjzuBQ;EACI,mBAAS;AAOb;;A5K+yuBR;E4K5yuBG,yBAAyB;A5K8yuB5B;;AAEA;E4K1yuBE,qBAAA;EACC,yBlF3Ea;AkF6Ed;;A5K4yuBF;E4KnyuBQ,qBAAA;A5KqyuBR;;AAEA;E4K7xuBgB,qBAAA;A5K+xuBhB;;AAEA;E4KlxuBgB,mBAAA;A5KoxuBhB;;AAEA;E4KxwuBY,mBAAA;A5K0wuBZ;;A4KhwuBY;EACI,mBAAc;A5KmwuB9B;;AAEA;E4K9vuBY,yBAAA;A5KgwuBZ;;AAEA;E4K9vuBgB,yBAAsB;A5KgwuBtC;;AAEA;;EAEE,yB4K9vuBkC;AAS5B;;A5KwvuBR;EACE,qB0F3/uBK;A1F4/uBP;;AAEA;EACE,qB0Fh7uBsB;A1Fi7uBxB;;AAEA;E4KhvuBY,yBAAA;A5KkvuBZ;;AAEA;EACE,yB4KjvuBW;A5KkvuBb;;AAEA;EACE,yB0F57uBsB;A1F67uBxB;;AAEA;E4KtuuBQ,yBAAA;A5KwuuBR;;A4KluuBI;EACC,yBlF/MI;A1Fo7uBT;;AAEA;E4KhuuBK,yBAAA;AAMG;;AAGN;EACC,mBAAgB;EAEjB,qBAAA;EACC,cAAa;AAIZ;;A5KytuBJ;E4KntuBI,8BAAA;A5KqtuBJ;;A4KjtuBI;EACC,uClFlPW;A1Fs8uBhB;;AAEA;E4K5suBY,mBlFrVI;EkFsVb,qBAAA;A5K8suBH;;AAEA;E4K1suBG,cAAA;E5K4suBD,qB0F/8uBO;AkFwQD;;A5K0suBR;E4KvsuBG,yBAAyB;EACzB,cAAA;A5KysuBH;;A4K/ruBY;EACI,yB5JxSkB;AhB0+uBlC;;A4KzruBQ;EACI,cAAY;A5K4ruBxB;;AAEA;E4KrruBY,iBAAA;AAGJ;;A5KsruBR;E4K9quBQ,iBAAA;EACI,cAAa;AAMjB;;A5K4quBR;;E4KxquBG,iBAAA;A5K2quBH;;AAEA;EACE,mB4K1quBE;AAII;;A5KyquBR;E4KtquBY,4BAAyB;A5KwquBrC;;AAEA;E6KvmvBC,cAAQ;A7KymvBT;;AAEA;E6KlmvBA,mBAAc;A7KomvBd;;A6K7lvBA;;;EAGI,mBnFgFsB;A1FghvB1B;;AAEA;EACE,mBAAmB;A6K5lvBrB;;A7K+lvBA;E6K5lvBI,mB7JoE8B;E6JnExB,qBAAA;A7K8lvBV;;AAEA;EACE,yBAAyB;E6KzlvB3B,qBAAc;A7K2lvBd;;AAEA;;EAEE,mB0F/lvBgB;A1FgmvBlB;;A6KtlvBA;EACI,yBnFrBkC;A1F8mvBtC;;AAEA;EACE,yB0FtmvBgB;A1FumvBlB;;A6KplvBA;EACI,yBnF9BgC;A1FqnvBpC;;AAEA;;EAEE,yB0F9mvBe;A1F+mvBjB;;AAEA;E6KnlvBI,yBnFxC4B;A1F6nvBhC;;AAEA;EACE,yD0FrnvB6B;A1FsnvB/B;;AAEA;E6KjlvBI,yBnFjD4B;A1FoovBhC;;AAEA;EACE,c6KllvBY;A7KmlvBd;;A6K/kvBA;EACI,yB7JQ8B;AhB0kvBlC;;AAEA;E6K3kvBA,qBAAA;A7K6kvBA;;A6KzkvBA;EACI,oCAAiC;A7K4kvBrC;;AAEA;EACE,mBAAmB;A6KvkvBrB;;A7K0kvBA;E6KtkvBA,yBAAuB;EACnB,yBAAa;A7KwkvBjB;;AAEA;EACE,yBAAyB;A6KpkvB3B;;A7KukvBA;E6KpkvBA,4BAAsB;A7KskvBtB;;A6K9jvBA;EACI,cAAa;A7KikvBjB;;AAEA;EACE,cAAc;A6K5jvBhB;;A7K+jvBA;E6K3jvBA,mBAAA;EACI,qBAAa;E7K6jvBf,cAAc;A6K1jvBhB;;A7K6jvBA;E6KzjvBA,mBAAA;A7K2jvBA;;A6KvjvBA;EACI,cAAa;A7K0jvBjB;;AAEA;EACE,mBAAmB;A6KnjvBb;;A7KsjvBR;;;E6KxivBI,anFrFc;A1FiovBlB;;AAEA;E6KzivBA,mBAAA;A7K2ivBA;;AAEA;;E6KxivBA,yBAA0B;A7K2ivB1B;;AAEA;EACE,mBAAmB;A6KxivBrB;;A7K2ivBA;;;E6KrivBA,cAAA;A7KyivBA;;AAEA;EACE,mBAAmB;A6KtivBrB;;A7KyivBA;E6KtivBI,oC7JtH8B;AhB8pvBlC;;AAEA;E6KpivBI,cnF5HoB;A1FkqvBxB;;A6KjivBA;;EAEI,c5K3He;AD+pvBnB;;A6K1hvBI;EACI,cAAW;A7K6hvBnB;;AAEA;;;E6KnhvBI,cAAY;A7KuhvBhB;;AAEA;;E6KlhvBI;;;;IAMJ,yBAA4B;EACxB;A7KmhvBJ;;AAEA;E6K/gvBA,yBAAyB;A7KihvBzB;;AAEA;EACE,mBAAmB;A6K7gvBrB;;A7KghvBA;E6K7gvBI,c7JxLM;AhBusvBV;;AAEA;E6K5gvBI,c7J7L8B;AhB2svBlC;;A6K1gvBA;EACI,mBAAY;EACZ,qB5KtK4B;ADmrvBhC;;A6KzgvBA;EACI,mBAAY;EACZ,qB5KjMe;AD6svBnB;;A6KrgvBA;EACI,qBnFjNoB;A1FytvBxB;;AAEA;EACE,mB6KvgvBM;A7KwgvBR;;AAEA;E6KngvBI,mBAAA;A7KqgvBJ;;AAEA;E6KjgvBI,qBAAA;A7KmgvBJ;;AAEA;EACE,c6KhgvBiB;A7KigvBnB;;AAEA;E6Kx/uBQ,cAAc;A7K0/uBtB;;AAEA;EACE,mBAAmB;E6K7+uBpB,qBAAA;A7K++uBD;;AAEA;EACE,cAAc;A8Kv1vBhB;;A9K01vBA;E8Kv1vBK,mBAAe;A9Ky1vBpB;;AAEA;EACE,yBAAyB;A8Kt1vB3B;;A9Ky1vBA;EACE,wCAAwC;A8Kt1vB1C;;A9Ky1vBA;EACE,yBAAyB;A8Kj1vB3B;;A9Ko1vBA;;E8Kh1vBA,WAAA;EACI,yBAA4B;A9Km1vBhC;;AAEA;EACE,mBAAmB;A8Kh1vBrB;;A9Km1vBA;EACE,yBAAyB;E8Kh1vB3B,qBAAmB;A9Kk1vBnB;;AAEA;E8Kh1vBA,oCAAsB;A9Kk1vBtB;;AAEA;E8Kh1vBA,yBAAqB;A9Kk1vBrB;;AAEA;E8Kh1vBA,yBAAoB;EAChB,qBAAQ;A9Kk1vBZ;;AAEA;EACE,cAAc;E8K/0vBhB,qBAAmB;A9Ki1vBnB;;AAEA;EACE,yBC7wvB8B;ED8wvB9B,qBAAqB;A8K30vBvB;;A9K80vBA;;;;;;E8Kt0vBI,yBAAiB;E9K60vBnB,qBAAqB;A8Kt0vBvB;;A9Ky0vBA;;;E8Kl0vBA,cAAU;A9Ks0vBV;;AAEA;EACE,mBAAmB;A8Kp0vBrB;;A9Ku0vBA;E8Kp0vBA,mCAAe;A9Ks0vBf;;A8Kn0vBA;EACI,cAAA;A9Ks0vBJ;;AAEA;EACE,yBAAyB;A8Kp0vB3B;;A9Ku0vBA;E8Kp0vBA,+CAAc;A9Ks0vBd;;A8Kn0vBA;EACI,cAAA;A9Ks0vBJ;;AAEA;EACE,mBAAmB;A8Kj0vBrB;;A9Ko0vBA;E8Kj0vBA,yBAAqB;A9Km0vBrB;;AAEA;;EAEE,kCAAkC;E8Kh0vBpC,cAAA;A9Kk0vBA;;AAEA;EACE,S8Kj0vBA;E9Kk0vBA,mBAAmB;A8K/zvBrB;;A9Kk0vBA;;EAEE,mB8Kh0vBgB;A9Ki0vBlB;;AAEA;E8K9zvBC,mB9JhDiC;AhBg3vBlC;;AAEA;EACE,yBAAyB;A8K7zvB3B;;A9Kg0vBA;E8K7zvBU,qBAAA;E9K+zvBR,c8K9zvBA;A9K+zvBF;;AAEA;E8K5zvBC,yB9J/DiC;AhB63vBlC;;AAEA;E8K3zvBA,yBAAkB;A9K6zvBlB;;AAEA;EACE,yB0F37vBa;E1F47vBb,qBCx2vB8B;ADy2vBhC;;AAEA;E8KlzvBQ,yBAAkB;A9KozvB1B;;AAEA;E8K5yvBI,cAAA;A9K8yvBJ;;AAEA;EACE,yB8K5yvByB;A9K6yvB3B;;AAEA;E8KtyvBQ,mBAAmB;A9KwyvB3B;;AAEA;E+K3/vBC,cAAA;E/K6/vBC,qB+K5/vBA;A/K6/vBF;;A+Kz/vBA;EACI,cAAa;A/K4/vBjB;;AAEA;E+K1/vBI,yBAAkB;A/K4/vBtB;;AAEA;E+Kt/vBC,cAAA;A/Kw/vBD;;AAEA;EACE,c+Kv/vBS;E5KuCH,yCAAA;AHk9vBR;;AAEA;;EAEE,yB+Kv/vBmB;A/Kw/vBrB;;AAEA;EACE,yB+Kv/vBwB;A/Kw/vB1B;;AAEA;EACE,yB+Kv/vBa;A/Kw/vBf;;AAEA;EACE,yB+Kn/vByB;A/Ko/vB3B;;AAEA;EACE,yB+Kn/vBgB;A/Ko/vBlB;;AAEA;;EAEE,gC+Kh/vBgB;A/Ki/vBlB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mC+K79vBU;A/K89vBZ;;AAEA;EACE,yB+Kv/vBgB;E/Kw/vBhB,mCGliwBM;AHmiwBR;;AAEA;EACE,yB+Kv/vB2B;A/Kw/vB7B;;AAEA;EACE,mB+Kx+vBM;A/Ky+vBR;;AAEA;EACE,mB+Kv+vByB;A/Kw+vB3B;;AAEA;EACE,yB0FrkwBa;A1FskwBf;;AAEA;EACE,qB+Kj+vBsB;E/Kk+vBtB,yB+Kj+vByB;A/Kk+vB3B;;AAEA;EgLrkwBI,qBAAO;AhLukwBX;;AAEA;EgLnkwBA,qBAAY;AhLqkwBZ;;AgLhkwBA;EACC,mBAAQ;AhLmkwBT;;AAEA;EgL/jwBI,mBAAA;AhLikwBJ;;AAEA;EACE,mBgL9jwBS;AhL+jwBX;;AAEA;EACE,yBAAyB;AgLvjwB3B;;AhL0jwBA;EgLvjwBI,yBAAY;AhLyjwBhB;;AgLtjwBA;;EAEI,yBAAW;AhLyjwBf;;AAEA;EACE,qBAAqB;AgLrjwBtB;;AAGA;EACC,qBAAmB;AAEpB;;AhLsjwBD;EgLnjwBE,yBhK+BgC;AhBshwBlC;;AAEA;EACE,yB0FplwBgB;A1FqlwBlB;;AAEA;EACE,yBgB7hwBgC;AhB8hwBlC;;AAEA;EgL7iwBC,yBAAW;AhL+iwBZ;;AAEA;EgL7iwBE,yBAAQ;AhL+iwBV;;AAEA;EACE,yBgL7iwBc;AhL8iwBhB;;AAEA;EACE,mBgL5iwBY;EhL6iwBZ,qBgL5iwBC;EhL6iwBD,c0F/iwBsB;AsFOvB;;AhL2iwBD;EgLxiwBE,8BtFRwB;A1FkjwB1B;;AAEA;EACE,yC0FpnwBgB;A1FqnwBlB;;AAEA;EACE,mB0FzjwBgB;E1F0jwBhB,qBgLviwBY;AhLwiwBd;;AAEA;EACE,c0FhkwBsB;EsFgCvB,qBAAgB;AhLkiwBjB;;AAEA;EgLhiwBE,yBAAA;EhLkiwBA,cgBtkwBQ;AhBukwBV;;AAEA;EACE,yB0F1kwBsB;A1F2kwBxB;;AAEA;EACE,cgL/hwBY;AhLgiwBd;;AgL1hwBC;EACC,iBAAgB;AhL6hwBlB;;AAEA;EACE,iBgBtlwBgC;EgK4DvB,cAAA;AhL4hwBX;;AAEA;;EAEE,iBgB5lwBQ;AhB6lwBV;;AAEA;EgLthwBC,mBAAa;AhLwhwBd;;AAEA;EgLthwBE,4BAAQ;AhLwhwBV;;AAEA;EACE,cgLthwBa;AhLuhwBf;;AAEA;EACE,mBgLrhwBY;AhLshwBd;;AAEA;;;EgL9gwBE,mBtFnKW;A1FqrwBb;;AAEA;EACE,mBC9mwBiB;AD+mwBnB;;AAEA;EACE,mB0F1nwBsB;EsF4GtB,qBAAO;AhLghwBT;;AAEA;EACE,yBgL/gwBC;EhLghwBD,qB0FhowBsB;A1FiowBxB;;AAEA;;EgL1gwBC,mBAAA;AhL6gwBD;;AAEA;EACE,yBgL3gwBA;AhL4gwBF;;AAEA;EACE,yBgB7owBgC;AhB8owBlC;;AAEA;EgLtgwBC,yBAAW;AhLwgwBZ;;AAEA;;EAEE,yBgBtpwBQ;AhBupwBV;;AAEA;EACE,yB0F1pwBsB;A1F2pwBxB;;AAEA;EACE,yD0F5pwBwB;A1F6pwB1B;;AAEA;EACE,yBgLlgwBY;AhLmgwBd;;AAEA;EACE,cgBtqwBQ;AhBuqwBV;;AAEA;EACE,yBgB1qwBQ;AhB2qwBV;;AAEA;EACE,qB0F9qwBsB;A1F+qwBxB;;AAEA;EACE,oCgBlrwBgC;AhBmrwBlC;;AAEA;EACE,mBgL1/vBY;AhL2/vBd;;AAEA;EACE,yBgB1rwBgC;EhB2rwBhC,yBgLv/vBA;AhLw/vBF;;AAEA;EACE,yBgB/rwBgC;AhBgswBlC;;AAEA;EgLl/vBC,4BAAY;AhLo/vBb;;AAEA;EACE,cgLl/vBA;AhLm/vBF;;AAEA;EACE,cgLl/vBC;AhLm/vBH;;AAEA;EACE,mBgL/+vBA;EhLg/vBA,qBCxswBiB;EDyswBjB,cgL9+vBA;AhL++vBF;;AAEA;EACE,mBgL9+vBC;AhL++vBH;;AgLz+vBA;EACC,cAAA;AhL4+vBD;;AAEA;EACE,mBgL1+vBA;AhL2+vBF;;AAEA;;;EAGE,agLz+vBC;AhL0+vBH;;AAEA;EACE,mBgLt+vBA;AhLu+vBF;;AAEA;;EAEE,yBgB5uwBgC;AhB6uwBlC;;AAEA;EACE,mB0F9uwBwB;A1F+uwB1B;;AAEA;;;EAGE,c0FpvwBgB;A1FqvwBlB;;AAEA;EACE,mBgB1vwBgC;AhB2vwBlC;;AAEA;EACE,oC0Fr0wBwC;A1Fs0wB1C;;AAEA;EACE,cgBlwwBQ;AhBmwwBV;;AAEA;;EAEE,cgLz9vBA;AhL09vBF;;AAEA;EACE,cgLz9vBC;AhL09vBH;;AAEA;;;EAGE,cgLr9vBA;AhLs9vBF;;AAEA;;EAEE;;;;IAIE,uBClxwBe;EDmxwBjB;AACF;;AAEA;EACE,yBgLj9vBC;AhLk9vBH;;AgL18vBA;EACI,mBAAkB;AhL68vBtB;;AgL18vBA;EACI,cAAA;AhL68vBJ;;AgL18vBA;EACI,cAAA;AhL68vBJ;;AgL18vBA;EACI,mBAAkB;EAClB,qBAAY;AhL68vBhB;;AAEA;EgL38vBI,mBAAY;EhL68vBd,qBAAqB;AgL38vBvB;;AhL88vBA;EACE,qBAAqB;AgLx8vBvB;;AhL28vBA;EgLx8vBI,mBAAgB;AhL08vBpB;;AAEA;EgLx8vBI,mBAAS;AhL08vBb;;AAEA;EACE,qBgLz8vBW;AhL08vBb;;AAEA;EgLt8vBA,cAAA;AhLw8vBA;;AAEA;EACE,cgL38vBF;AhL48vBA;;AAEA;EgLt8vBA,mBAAQ;EACJ,qBAAW;AhLw8vBf;;AAEA;EACE,cgLx8vBS;AhLy8vBX;;AgLr8vBA;EACI,mBAAkB;AhLw8vBtB;;AAEA;EACE,yBgLx8vBS;AhLy8vBX;;AgLp8vBA;EACI,yCAAoB;AhLu8vBxB;;AAEA;EgLl8vBA,yBAAY;AhLo8vBZ;;AgLh8vBA;;EhLo8vBE,WAAW;EgLh8vBb,yBAAgB;AhLk8vBhB;;AAEA;EgLh8vBI,mBAAS;AhLk8vBb;;AAEA;EACE,yBgLz8vBc;EhL08vBd,qBgLl8vBS;AhLm8vBX;;AAEA;EgL/7vBI,oCAAoB;AhLi8vBxB;;AAEA;EgL/7vBI,yBAAW;AhLi8vBf;;AAEA;EACE,yBAAyB;EgL97vB1B,qBAAA;AhLg8vBD;;AAEA;EgL77vBE,cAAS;EACT,qBAAQ;AhL+7vBV;;AAEA;EgL57vBA,yBAAwB;EACpB,qBAAoB;AhL87vBxB;;AAEA;;;;;;EgLh7vBA,yBAAY;EACR,qBAAmB;AhLu7vBvB;;AAEA;;;EAGE,cgLr7vBiB;AhLs7vBnB;;AAEA;EACE,mBgLn7vBuB;AhLo7vBzB;;AAEA;EACE,kCgL/6vBiB;AhLg7vBnB;;AAEA;EACE,cgL96vBmB;AhL+6vBrB;;AAEA;EgLz6vBQ,yBAAiB;AhL26vBzB;;AgLj6vBA;EACI,8CAA2B;AhLo6vB/B;;AAEA;EgLj6vBA,cAAO;AhLm6vBP;;AAEA;EACE,mBAAmB;AgLh6vBrB;;AhLm6vBA;EgLh6vBI,yBAAyB;AhLk6vB7B;;AAEA;;EAEE,kCAAkC;EgLh6vBpC,cAAO;AhLk6vBP;;AAEA;EACE,SAAS;EgLh6vBX,mBAAO;AhLk6vBP;;AAEA;;EgL/5vBA,mBAAO;AhLk6vBP;;AAEA;EACE,mBAAmB;AgL35vBrB;;AhL85vBA;EgLz5vBI,yBAAA;AhL25vBJ;;AAEA;EgLr5vBC,qBAAA;EACC,ctFnkBsB;A1F09wBxB;;AAEA;EgLp5vBU,yBAAA;AhLs5vBV;;AgLj5vBU;EACR,yB/KjjB8B;ADq8wBhC;;AAEA;EACE,yBAAyB;EgL74vB3B,qBAAU;AhL+4vBV;;AAEA;EgL34vBI,yBAAA;AhL64vBJ;;AAEA;EACE,cAAc;AgLn4vBR;;AhLs4vBR;EgLj4vBQ,yBAAA;AhLm4vBR;;AAEA;EgLx3vBA,mBAAc;AhL03vBd;;AAEA;EgLv3vBI,cAAA;EhLy3vBF,qBgLt3vB0C;AhLu3vB5C;;AAEA;EgLn3vBA,cAAa;AhLq3vBb;;AAEA;EgLl3vBI,yBAAA;AhLo3vBJ;;AAEA;EACE,cAAc;AgL92vBhB;;AhLi3vBA;EgL92vBI,ctF5pBoB;EsF8pBpB,wCAAA;AhL+2vBJ;;AAEA;;EgLx2vBA,yBAAe;AhL22vBf;;AAEA;EgLx2vBI,yBAAA;AhL02vBJ;;AAEA;EACE,yBAAyB;AgLp2vB3B;;AhLu2vBA;EgLp2vBI,yBtFxrBoB;A1F8hxBxB;;AAEA;EACE,yBgLl2vB2C;AhLm2vB7C;;AAEA;;EgL91vBI,gCtFtsBoB;A1FuixBxB;;AAEA;EACE,cgL71vBkB;AhL81vBpB;;AAEA;EgL11vBI,yBtFhvBiB;EsFivBjB,kCtFptBoB;A1FgjxBxB;;AAEA;EACE,yBgLx1vB6C;EhLy1vB7C,kCAAkC;AgLr1vBpC;;AhLw1vBA;EgLr1vBI,yBtFluBoB;A1FyjxBxB;;AAEA;EACE,mBgLn1vBoB;AhLo1vBtB;;AAEA;EgLh1vBI,mBtFvwBO;A1FylxBX;;AAEA;EACE,yB0F5pxBU;A1F6pxBZ;;AgL10vBA;EACI,qBtFnxBc;EsFoxBd,yBtFpxBc;A1FimxBlB;;AAEA;EACE,qB0F7kxBsB;A1F8kxBxB;;AgLr0vBA;EACI,qBtFhyBY;A1FwmxBhB;;AAEA;EACE,mBgLp0vBoB;AhLq0vBtB;;AAEA;EgLj0vBA,mBAAY;AhLm0vBZ;;AAEA;EgLh0vBI,mBAAA;AhLk0vBJ;;AAEA;EACE,yBAAyB;AgL5zvB3B;;AhL+zvBA;EgL5zvBI,yBtFxyBoB;A1FsmxBxB;;AAEA;;EAEE,yBAAyB;AgLvzvB3B;;AhL0zvBA;EgLvzvBI,qBtFtzBoB;A1F+mxBxB;;AAEA;EACE,qBgLrzvBoB;AhLszvBtB;;AAEA;EgLlzvBI,yBtFr1Bc;A1FyoxBlB;;AAEA;EACE,yB0F1nxBsB;A1F2nxBxB;;AgL5yvBA;EACI,yBtFj2BW;A1FgpxBf;;AAEA;EACE,yBgL3yvBuC;AhL4yvBzC;;AAEA;EgLxyvBA,yBAAW;AhL0yvBX;;AAEA;EgLvyvBI,yBAAA;AhLyyvBJ;;AAEA;EACE,mBAAmB;EgLnyvBrB,qBAAW;EACP,ctF13BI;A1F+pxBR;;AAEA;EACE,8BgLjyvBuC;AhLkyvBzC;;AAEA;EiL5vxBA,yCAAM;AjL8vxBN;;AAEA;EiL5vxBI,mBAAkB;EAClB,qBAAQ;AjL8vxBZ;;AAEA;EGtsxBQ,cAAA;EHwsxBN,qBiLvwxBI;AjLwwxBN;;AAEA;EACE,yBiL1vxBuB;EjL2vxBvB,cG3vxBA;AH4vxBF;;AAEA;EACE,yBiLxvxBqB;AjLyvxBvB;;AAEA;EACE,ciLrvxBM;AjLsvxBR;;AAEA;EACE,iBiLjvxBM;AjLkvxBR;;AAEA;EACE,iBiL9uxBgB;EjL+uxBhB,ciL9uxBkB;AjL+uxBpB;;AAEA;;EAEE,iBGjxxBA;AHkxxBF;;AAEA;EACE,mB0FjxxBS;A1FkxxBX;;AAEA;EACE,4BiL1uxB0B;AjL2uxB5B;;AAEA;EACE,ciLvuxBkB;AjLwuxBpB;;AAEA;EACE,mB0F7xxBS;A1F8xxBX;;AAEA;;;EiLhuxBQ,mBAAY;AjLouxBpB;;AAEA;EiLztxBI,mBAAI;AjL2txBR;;AAEA;EiLztxBQ,mBAAiB;EACjB,qBAAkB;AjL2txB1B;;AAEA;EiLztxBQ,yBvFNgB;EuFOhB,qBAAiB;AjL2txBzB;;AAEA;;EiLptxBQ,mBAAA;AjLutxBR;;AAEA;EiLhtxBQ,yBAAA;AjLktxBR;;AAEA;EiL3sxBQ,yBAAY;AjL6sxBpB;;AAEA;EiL3sxBQ,yBAAiB;AjL6sxBzB;;AAEA;;EiL1sxBQ,yBvFzCkB;A1FsvxB1B;;AAEA;EACE,yBiLzsxB0C;AjL0sxB5C;;AAEA;EACE,yDiLrsxBoB;AjLssxBtB;;AAEA;EACE,yBiLpsxB8B;AjLqsxBhC;;AAEA;EiL/rxBI,cAAM;AjLisxBV;;AAEA;EiL/rxBI,yBAAiB;AjLisxBrB;;AiL7rxBA;EACI,qBAAkB;AjLgsxBtB;;AAEA;EiL9rxBI,oCAAY;AjLgsxBhB;;AAEA;EiL9rxBI,mBAAmB;AjLgsxBvB;;AAEA;EiL9rxBI,yBAAY;EjLgsxBd,yBAAyB;AiL7rxB3B;;AjLgsxBA;EiL7rxBI,yBAAa;AjL+rxBjB;;AAEA;EACE,4BAA4B;AiL5rxB9B;;AjL+rxBA;EiL5rxBI,cAAS;AjL8rxBb;;AAEA;EiL1rxBQ,cAAY;AjL4rxBpB;;AAEA;EiLzrxBC,mBAAA;EACC,qBAAgB;EjL2rxBhB,cAAc;AiLtrxBhB;;AjLyrxBA;EACE,mBiLvrxBiB;AjLwrxBnB;;AAEA;EiLlrxBA,cAAA;AjLorxBA;;AAEA;EiLjrxBI,mBAAK;AjLmrxBT;;AkLl6xBI;;;EAGI,aAAa;AlLq6xBrB;;AAEA;EkLn6xBQ,mBAAkB;AlLq6xB1B;;AAEA;;EAEE,yB0F70xBsB;AwFhFpB;;AlLg6xBJ;EkL75xBQ,mBAAW;AlL+5xBnB;;AAEA;;;EkLz5xBQ,cAAW;AlL65xBnB;;AAEA;EkLx5xBC,mBAAS;AlL05xBV;;AAEA;EkLr5xBI,oCAAC;AlLu5xBL;;AmLr8xBA;EACI,cAAY;AnLw8xBhB;;AAEA;;EmLn8xBA,cAAc;AnLs8xBd;;AAEA;EmLp8xBC,cAAY;AnLs8xBb;;AAEA;;;EAGE,cGn7xBM;AHo7xBR;;AAEA;;EAEE;;;;ImLv7xBQ,yBAAA;EnL47xBR;AACF;;AAEA;EmLr7xBI,yBAAa;AnLu7xBjB;;AAEA;EACE,mBmLn7xBS;AnLo7xBX;;AAEA;EACE,cAAc;AAChB;;AAEA;EmLj7xBC,cAAS;AnLm7xBV;;AAEA;EACE,mBAAmB;EmLj7xBrB,qBAAA;AnLm7xBA;;AmLh7xBA;EACC,mBAAe;EnLm7xBd,qBAAqB;AmLj7xBvB;;AnLo7xBA;EmLj7xBA,qBAAA;AnLm7xBA;;AmLh7xBA;EACI,mBAAS;AnLm7xBb;;AAEA;EACE,mBmLj7xBsB;AnLk7xBxB;;AAEA;EmL36xBQ,qBAAkC;AnL66xB1C;;AAEA;EmLz6xBQ,cAAA;AnL26xBR;;AAEA;EmLr6xBC,cAAA;AnLu6xBD;;AAEA;EmLr6xBE,mBAAY;EACZ,qBAAkB;AnLu6xBpB;;AAEA;EACE,cmLr6xBY;AnLs6xBd;;AAEA;EACE,mBmLr6xBgB;AnLs6xBlB;;AAEA;EACE,yBmLn6xBW;AnLo6xBb;;AAEA;EACE,wCmLh6xB+B;AnLi6xBjC;;AAEA;EoLziyBI,yB1FoDU;A1Fu/xBd;;AAEA;;EAEE,WAAW;EoLpiyBb,yBAAA;ApLsiyBA;;AqLnjyBA;EACI,mBAAS;ArLsjyBb;;AAEA;EqLnjyBI,yBAAQ;ErLqjyBV,qBqLpjyBmB;ArLqjyBrB;;AAEA;EACE,oCqLnjyB0B;ArLojyB5B;;AAEA;EACE,yBqLhjyBuB;ArLijyBzB;;AAEA;EACE,yBqL9iyBuB;EAGrB,qBAAK;ArL6iyBT;;AAEA;EACE,cqL1iyBa;ErL2iyBb,qBqL1iyBuB;ArL2iyBzB;;AAEA;EACE,yBAAyB;EqLriyB3B,qBAAc;ArLuiyBd;;AqLniyBA;;;;;;EAOI,yB3F8CoB;E1Fu/xBtB,qBAAqB;AqLliyBvB;;ArLqiyBA;;;EqL/hyBI,crKqCM;AhB8/xBV;;AqL/hyBA;EACI,mBrKgC8B;AhBkgyBlC;;AqL9hyBA;EACI,kCrK2B8B;AhBsgyBlC;;AqL5hyBA;EACI,crKqBM;AhB0gyBV;;AqL1hyBA;EACI,yBpLuBe;ADsgyBnB;;AqLvhyBA;EACI,8CAAsB;ArL0hyB1B;;AAEA;EqLxhyBI,crKI8B;AhBshyBlC;;AAEA;EqLthyBA,mBAAe;ArLwhyBf;;AAEA;EqLlhyBQ,yBAAM;ArLohyBd;;AAEA;;EAEE,kCqL/gyByB;ErLghyBzB,cqL/gyBqB;ArLghyBvB;;AAEA;EACE,SqL3gyBU;EAKJ,mBAAA;ArLwgyBR;;AAEA;;EAEE,mBqLngyBuB;ArLogyBzB;;AAEA;EACE,mBAAmB;AsLtpyBrB;;AtLypyBA;EsLtpyBC,yBAAoB;AtLwpyBrB;;AAEA;EsLrpyBC,qBAAA;EtLupyBC,csLtpyBA;AtLupyBF;;AAEA;EACE,yBsLrpyBA;AtLspyBF;;AAEA;EsLlpyBI,yBtKiF8B;AhBmkyBlC;;AsLhpyBC;EACC,yBAAa;EtLmpyBb,qBAAqB;AsL/oyBtB;;AtLkpyBD;EuL9qyBI,yBAAG;AvLgryBP;;AwL9qyBI;EACI,cAAY;AAGhB;;AxLgryBJ;EACE,yBwL7qyBqB;AxL8qyBvB;;AwLvqyBQ;EACI,mBxKkFsB;AhBwlyBlC;;AAEA;EACE,cwLtqyB0B;ExLuqyB1B,qBwLtqyB6B;AAUvB;;AAKJ;EACI,cAAW;AxL2pyBnB;;AwLtpyBI;EACI,yBAAkB;AAGtB;;AAMI;EACI,cAAW;AAQnB;;AxL6oyBJ;EwLzoyBQ,cAAY;ErLZZ,wCAAA;AHwpyBR;;AAEA;;EAEE,yBwLxoyBiC;AxLyoyBnC;;AAEA;EwLpoyBI,yBAAa;AxLsoyBjB;;AAEA;EACE,yBwLroyBoB;AxLsoyBtB;;AAEA;EwL9nyBI,yBAAA;AxLgoyBJ;;AAEA;EACE,yBwL9nyBsB;AxL+nyBxB;;AAEA;;EAEE,gCwL7nyB0B;AxL8nyB5B;;AAEA;EACE,cwL1nyBM;AxL2nyBR;;AAEA;EACE,yBwLtnyBe;ExLunyBf,kCwLtnyBqB;AxLunyBvB;;AAEA;EwLjnyBI,yBAAA;ExLmnyBF,kCwLlnyBsB;AxLmnyBxB;;AAEA;EwL9myBI,yBAAc;AxLgnyBlB;;AyL7qyBA;EACC,mBAAS;AzLgryBV;;AAEA;EACE,mByL9qyBU;AzL+qyBZ;;AAEA;EACE,yByL9qyBe;AzL+qyBjB;;AyL3qyBA;EACC,qBAAiB;EzL8qyBhB,yBAAyB;AyL5qyB3B;;AzL+qyBA;EyL5qyBA,qBAAc;AzL8qyBd;;AyL3qyBA;EACI,qBAAS;AzL8qyBb;;AAEA;E0LnxyBI,mBhGgGc;A1FqryBlB;;AAEA;E0LjxyBG,mBhG0Fe;A1FyryBlB;;A0L/wyBA;EACI,mBAAmB;A1LkxyBvB;;AAEA;E0L1wyBY,yBAAA;A1L4wyBZ;;AAEA;EACE,yB0LvwyBU;A1LwwyBZ;;AAEA;;EAEE,yB0LtwyBkB;A1LuwyBpB;;AAEA;EACE,qB0LtwyBc;A1LuwyBhB;;AAEA;EACE,qB0LnwyBwB;A1LowyB1B;;AAEA;EACE,yB0FvtyBsB;A1FwtyBxB;;AAEA;EACE,yB0FztyBwB;A1F0tyB1B;;AAEA;EACE,yB0F/tyBsB;A1FguyBxB;;AAEA;EACE,yBGzvyBe;AH0vyBjB;;AAEA;E0LrvyBqB,yBAAA;A1LuvyBrB;;AAEA;EACE,yB0LlvyBe;A1LmvyBjB;;AAEA;EACE,mB0L/uyBW;E1LgvyBX,qB0F9uyBgB;E1F+uyBhB,c0L/uyBG;A1LgvyBL;;AAEA;EACE,8B0L3uyBW;A1L4uyBb;;AAEA;EACE,yCgBzvyBgC;AhB0vyBlC;;AAEA;EACE,mBgB7vyBQ;E0K2BP,qBAAA;A1LouyBH;;AAEA;EACE,c0LnuyBa;E1LouyBb,qBgBnwyBQ;AhBowyBV;;AAEA;EACE,yB0FrwyBwB;E1FswyBxB,c0L7tyBW;A1L8tyBb;;AAEA;E0LxtyBI,yBAAA;A1L0tyBJ;;AAEA;EACE,c0LztyBY;A1L0tyBd;;AAEA;EACE,iB0Fx1yBa;A1Fy1yBf;;AAEA;EACE,iB0LltyBe;E1LmtyBf,cgBzxyBQ;AhB0xyBV;;AAEA;;EAEE,iB0L9syBY;A1L+syBd;;AAEA;EACE,mB0Fr2yBW;A1Fs2yBb;;AAEA;EACE,4B0LvsyBgB;A1LwsyBlB;;AAEA;EACE,c0LnsyBe;A1LosyBjB;;AAEA;EACE,mB0Fn3yBc;A1Fo3yBhB;;AAEA;;;E0LtryBI,mBAAA;A1L0ryBJ;;AAEA;E0LjryBQ,mBAAA;A1LmryBR;;AAEA;E0L3qyBQ,mBAAA;E1L6qyBN,qB0L5qyB2B;A1L6qyB7B;;AAEA;EACE,yB0L3qyBwB;E1L4qyBxB,qB0L3qyB+B;A1L4qyBjC;;AAEA;;EAEE,mB0LnqyB0B;A1LoqyB5B;;AAEA;EACE,yB0L3pyB6B;A1L4pyB/B;;AAEA;EACE,yB0LzpyB0B;A1L0pyB5B;;AAEA;EACE,yB0LjpyB6B;A1LkpyB/B;;AAEA;;EAEE,yB0L/oyB+B;A1LgpyBjC;;A2L97yBA;EACI,yBAA4B;A3Li8yBhC;;AAEA;E2L/7yBU,yDAA8B;A3Li8yBxC;;AAEA;EACE,yB0Fp2yBsB;A1Fq2yBxB;;AAEA;EACE,c2L/7yBU;A3Lg8yBZ;;AAEA;EACE,yB0F17yBiB;A1F27yBnB;;AAEA;E2Ll7yBI,qBAAA;A3Lo7yBJ;;AAEA;EACE,oC0Fp3yBsB;A1Fq3yBxB;;A2Lx6yBA;EACI,mBAAW;A3L26yBf;;A2Lv6yBA;EACI,yBAAU;EACV,yB3K4CM;AhB83yBV;;AAEA;E2Lv6yBI,yB3KuCM;AhBk4yBV;;AAEA;E2Lt6yBI,4B3KkC8B;AhBs4yBlC;;AAEA;EACE,cAAc;A4L7+yBf;;A5Lg/yBD;E4L5+yBC,cAAA;A5L8+yBD;;A4L1+yBC;EACI,mB5K2FK;EhBk5yBR,qBAAqB;E4L1+yBtB,cAAA;A5L4+yBD;;A4Lx+yBC;EACI,mB5KmFK;AhBw5yBV;;AAEA;EACE,cAAc;A4Lv+yBf;;A5L0+yBD;E4Lt+yBA,mBAAU;A5Lw+yBV;;AAEA;;;E4Ll+yBK,aAAK;A5Ls+yBV;;A4Lh+yBC;EACI,mBAAS;A5Lm+yBd;;AAEA;;E4Fx8yBI,yBAAA;A5F28yBJ;;AAEA;E4L/9yBC,mBAAA;A5Li+yBD;;AAEA;;;E4L79yBK,cAAW;A5Li+yBhB;;AAEA;EACE,mBAAmB;A4L79yBpB;;A5Lg+yBD;E4L79yBK,oCAA0B;A5L+9yB/B;;AAEA;EACE,c4L79yBe;AAIhB;;A5L49yBD;;E6L3izBI,cAAU;A7L8izBd;;AAEA;EACE,c6L5izBe;A7L6izBjB;;AAEA;;;EAGE,c6L5izBkB;A7L6izBpB;;AAEA;;EAEE;;;;IAIE,yB6L3izBe;E7L4izBjB;AACF;;AAEA;EACE,yB6LxizBkB;A7LyizBpB;;AAEA;EACE,mB6LxizBkB;A7LyizBpB;;AAEA;EACE,c6LxizBe;A7LyizBjB;;AAEA;EACE,c6LzhzBW;A7L0hzBb;;AAEA;EACE,mB6LzhzBiB;E7L0hzBjB,qB6LzhzBiB;A7L0hzBnB;;AAEA;EACE,mB6LzhzBuB;E7L0hzBvB,qB6LzhzBqB;A7L0hzBvB;;AAEA;EACE,qB6LvhzBkB;A7LwhzBpB;;AAEA;EACE,mB0F//yBsB;A1FggzBxB;;AAEA;EACE,mB6LvhzBuB;A7LwhzBzB;;AAEA;EACE,qB6LphzBoB;A7LqhzBtB;;AAEA;EACE,c6L9gzBkB;A7L+gzBpB;;AAEA;EACE,c6L9gzBiB;A7L+gzBnB;;AAEA;EACE,mB6L3gzBmB;E7L4gzBnB,qB6L3gzBqB;A7L4gzBvB;;AAEA;EACE,c6L3gzBiB;A7L4gzBnB;;AAEA;EACE,mB6L3gzBmB;A7L4gzBrB;;AAEA;EACE,yB6L1gzB4B;A7L2gzB9B;;AAEA;EACE,wC6L1gzB6B;A7L2gzB/B;;AAEA;EACE,yB6L1gzByB;A7L2gzB3B;;AAEA;;EAEE,W6LvgzBc;E7LwgzBd,yB0F5izBgB;A1F6izBlB;;AAEA;EACE,mB6LvgzBiB;A7LwgzBnB;;AAEA;E6LpgzBI,yBAAQ;E7LsgzBV,qB6LrgzBwB;A7LsgzB1B;;AAEA;EACE,oC6LrgzBkB;A7LsgzBpB;;AAEA;EACE,yBAAyB;A8LjqzBvB;;A9LoqzBJ;E8LnqzBQ,yBAAyB;EACzB,qBAAU;A9LqqzBlB;;AAEA;EACE,cAAc;E8LnqzBR,qBAAoB;A9LqqzB5B;;A8LhqzBI;E9LmqzBF,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;E+L5qzBI,yBAAA;EACI,qBrGoDa;A1F+nzBrB;;AAEA;;;E+L5qzBI,cAAA;A/LgrzBJ;;AAEA;EACE,mB+L/qzBgB;A/LgrzBlB;;AAEA;EACE,kC+L/qzB4B;A/LgrzB9B;;AAEA;EACE,c+L7qzBkB;A/L8qzBpB;;AAEA;EACE,yB+L7qzB2B;A/L8qzB7B;;AAEA;EACE,8C+L7qzBoB;A/L8qzBtB;;AAEA;EACE,c+LrqzBc;A/LsqzBhB;;AAEA;EACE,mB+LjrzBsB;A/LkrzBxB;;AAEA;EACE,yB+LvqzBqB;A/LwqzBvB;;AAEA;;EAEE,kC+LvqzBmB;E/LwqzBnB,c+LtqzBmB;A/LuqzBrB;;AAEA;EACE,S+LnrzBM;E/LorzBN,mB+LrqzBuB;A/LsqzBzB;;AAEA;;EAEE,mB0F5ozBgB;A1F6ozBlB;;AAEA;EACE,mB+LvpzBkB;A/LwpzBpB;;AgMvvzBI;EACF,yBtGoHc;A1FsozBhB;;AgMpvzBI;EACI,qBAAY;EACZ,cAAa;AhMuvzBrB;;AAEA;EACE,yBgMtvzBqB;AhMuvzBvB;;AAEA;EACE,yBgMjvzBuB;AhMkvzBzB;;AAEA;EACE,yBgMjvzBU;EhMkvzBV,qBgMjvzBkB;AhMkvzBpB;;AgM1uzBI;EACI,yBAAuB;AhM6uzB/B;;AAEA;EgM3uzBE,cAAc;AhM6uzBhB;;AAEA;EACE,yB0FlrzBwB;A1FmrzB1B;;AAEA;EACE,mB0FtrzBgB;A1FurzBlB;;AAEA;EACE,cgMxuzBU;EhMyuzBV,qBgMxuzBkB;AhMyuzBpB;;AAEA;EgM9tzBG,ctGgCuB;A1FgszB1B;;AAEA;EACE,yB0FlwzBgB;AsGuCjB;;AhM8tzBD;EACE,cAAc;AiM1yzBR;;AAIA;EACI,cvG8FM;EuG7FN,wCvG2FY;AuGxFhB;;AjMyyzBR;;EiMhyzBI,yBAAO;AjMmyzBX;;AAEA;EiMjyzBQ,yBAAgB;AjMmyzBxB;;AiM7xzBA;EAEI,yBAAqB;AjM+xzBzB;;AAEA;EACE,yBAAyB;AiM3xzB3B;;AjM8xzBA;EiM1xzBA,yBAAA;AjM4xzBA;;AkMt0zBC;;EAEC,gCAAkB;AlMy0zBpB;;AAEA;EACE,ckMx0zBW;AlMy0zBb;;AAEA;EACE,yBkMx0zBqB;ElMy0zBrB,kCgBjvzBgC;AhBkvzBlC;;AAEA;EACE,yBkMv0zBY;ElMw0zBZ,kCkMv0zBY;AlMw0zBd;;AAEA;EACE,yBkMp0zBoB;AlMq0zBtB;;AAEA;EACE,mBkMp0zBgB;AlMq0zBlB;;AAEA;EACE,mBkMn0zBa;AlMo0zBf;;AAEA;EACE,yBkMj0zBqB;AlMk0zBvB;;AAEA;EACE,qBkMj0zBgB;ElMk0zBhB,yBkMj0zBG;AlMk0zBL;;AAEA;EACE,qBkMj0zBgB;AlMk0zBlB;;AAEA;EACE,qBkM/zzBG;AlMg0zBL;;AAEA;EACE,mBkM/zzBgB;AlMg0zBlB;;AAEA;EACE,mBkM/zzBa;AlMg0zBf;;AAEA;EACE,mBkM/zzBa;AlMg0zBf;;AAEA;EACE,yBkM7zzBU;AlM8zzBZ;;AAEA;EACE,yBkM7zzBoB;AlM8zzBtB;;AAEA;;EAEE,yB0F13zBU;A1F23zBZ;;AAEA;EACE,qBkM5zzBe;AlM6zzBjB;;AAEA;EACE,qBkM1zzBc;AlM2zzBhB;;AAEA;EkMhzzBI,yBAAA;AlMkzzBJ;;AAEA;EkM/yzBE,yBAAA;AlMizzBF;;AAEA;EACE,yB0Fx4zBoC;A1Fy4zBtC;;AAEA;EACE,yB0Fj4zBgB;AwGsFd;;AlM8yzBJ;EACE,yB0Fn4zBgB;A1Fo4zBlB;;AAEA;EkMzyzBE,yBAAA;AlM2yzBF;;AAEA;EACE,mBkM1yzBE;ElM2yzBF,qBkM1yzBgB;EAId,cAAA;AlMwyzBJ;;AAEA;EkMryzBE,8BAAA;AlMuyzBF;;AAEA;EACE,yC0F/5zBoC;A1Fg6zBtC;;AAEA;EACE,mBkMryzBgB;EAId,qBAAA;AlMmyzBJ;;AAEA;EkMhyzBE,cAAA;ElMkyzBA,qBkMjyzBoB;AlMkyzBtB;;AAEA;EACE,yB0F56zBkC;E1F66zBlC,ckMhyzBU;AlMiyzBZ;;AkM1xzBI;EACF,yBxGpJ8B;A1Fi7zBhC;;AAEA;EACE,ckM3xzBC;AlM4xzBH;;AAEA;EACE,iB0Fx7zBW;A1Fy7zBb;;AAEA;EkMtxzBI,iBAAA;EACF,cxGrKW;A1F67zBb;;AAEA;;EAEE,iBkMtxzBa;AlMuxzBf;;AAEA;EACE,mBkMrxzBU;AlMsxzBZ;;AkM7wzBE;EACC,4BAAsB;AAKpB;;AlM6wzBL;EkM1wzBM,cAAc;AlM4wzBpB;;AAEA;EACE,mBkM3wzBa;AlM4wzBf;;AAEA;;;EkMpwzBM,mBAAA;AlMwwzBN;;AAEA;EkMlwzBM,mBAAA;AlMowzBN;;AAEA;EkM9vzBM,mBAAA;ElMgwzBJ,qBgB95zBgC;AkLoK7B;;AlM6vzBL;EACE,yBgBl6zBgC;EkL4K7B,qBAAA;AlMwvzBL;;AAEA;;EkMjvzBM,mBjM7KM;ADi6zBZ;;AAEA;EmMhh0BA,yBAAgB;AnMkh0BhB;;AmM7g0BI;EnMgh0BF,yBAAyB;AAC3B;;AAEA;EmM1g0BI,yBAAU;AnM4g0Bd;;AAEA;;EmMrg0BQ,yBAAe;AnMwg0BvB;;AAEA;EmMng0BQ,yBnLuE0B;AmLpE9B;;AAIA;EACI,yDAAiB;AAGrB;;AAIA;EACI,yBAAgB;AnM6/zBxB;;AAEA;EmMx/zBI,cAAA;AnM0/zBJ;;AAEA;EACE,yBmMv/zBuB;AnMw/zBzB;;AAEA;EACE,qBgBj9zBgC;AhBk9zBlC;;AAEA;EmM9+zBA,oCAAkC;AnMg/zBlC;;AmM3+zBI;EACI,mBAAc;AnM8+zBtB;;AAEA;EACE,yBAAyB;EmMx+zB3B,yBAAiB;AnM0+zBjB;;AmMp+zBI;EACI,yBAAsB;AnMu+zB9B;;AAEA;EACE,4B0Ft+zBsB;A1Fu+zBxB;;AAEA;EACE,cmMj+zBkB;AnMk+zBpB;;AAEA;EmM39zBY,cAAc;AnM69zB1B;;AAEA;EoMpl0BI,mBAAW;EACX,qBAAY;EACZ,cAAa;ApMsl0BjB;;AAEA;EoMpl0BI,mBAAe;ApMsl0BnB;;AAEA;EoMjl0BI,cAAA;ApMml0BJ;;AAEA;EoM/k0BI,mBAAA;ApMil0BJ;;AoM1k0BI;;;EAGI,aAAa;ApM6k0BrB;;AAEA;EoM3k0BQ,mBAAiB;AAGrB;;ApM4k0BJ;;EoMpk0BQ,yBAAE;ApMuk0BV;;AAEA;EACE,mBoMtk0Bc;ApMuk0BhB;;AAEA;;;EAGE,cAAc;AoM5j0BZ;;ApM+j0BJ;EoMzj0BI,mBAAE;ApM2j0BN;;AqMlo0BI;EACI,oCAAc;ArMqo0BtB;;AAEA;EACE,cqMpo0BqB;ArMqo0BvB;;AAEA;;EAEE,cqMpo0BU;ArMqo0BZ;;AAEA;EACE,cqM/o0BM;ArMgp0BR;;AAEA;;;EAGE,cqMho0Ba;ArMio0Bf;;AAEA;;EAEE;;;;IqM1n0BE,yBAAc;EAEN;ArM8n0BZ;;AAEA;EACE,yBqM7n0BkB;ArM8n0BpB;;AAEA;EACE,mBqM5n0BkB;ArM6n0BpB;;AqMrn0BC;EACC,cAAA;ArMwn0BF;;AAEA;EACE,cAAc;AqMln0Bf;;ArMqn0BD;EACE,mBAAmB;EqMhn0BjB,qBAAM;ArMkn0BV;;AAEA;EqMzm0BC,mBAAK;EACJ,qBAAY;ArM2m0Bd;;AAEA;EqMzm0BE,qBAAkB;ArM2m0BpB;;AAEA;EACE,mBAAmB;AqMxm0BrB;;ArM2m0BA;EqMxm0BU,mBAAA;ArM0m0BV;;AAEA;EqMvm0BA,qBAAc;ArMym0Bd;;AAEA;EACE,cqMxm0BA;ArMym0BF;;AqMpm0BA;EACI,c3GhFY;A1Fur0BhB;;AAEA;EACE,mB0F/q0BgB;E1Fgr0BhB,qBAAqB;AqMnm0BvB;;ArMsm0BA;EqMnm0BU,cAAA;ArMqm0BV;;AAEA;EqMjm0BA,mBAAW;ArMmm0BX;;AAEA;EACE,yB0F1r0Be;A1F2r0BjB;;AqM9l0BA;EACI,wC3GxG4B;A1Fys0BhC;;AAEA;EACE,yB0Fjs0Ba;A1Fks0Bf;;AAEA;;EAEE,WqM9l0BA;ErM+l0BA,yBAAyB;AqM5l0B3B;;ArM+l0BA;EACE,mBqM7l0BgB;ArM8l0BlB;;AAEA;EqM3l0BY,yBAAA;ErM6l0BV,qBqM5l0BkB;ArM6l0BpB;;AAEA;EqM1l0BY,oCAAA;ArM4l0BZ;;AqMxl0BA;EACG,yBAAa;ArM2l0BhB;;AAEA;EqMxl0BA,yBAAc;EACV,qBAAa;ArM0l0BjB;;AAEA;EqMrl0BA,cAAS;EACL,qB3GtJ4B;A1F6u0BhC;;AqMpl0BA;EACI,yBrLxF8B;EqLyF9B,qBrLzF8B;AhBgr0BlC;;AAEA;;;;;;EAME,yBqMtl0BM;ErMul0BN,qBqMtl0BK;ArMul0BP;;AAEA;;;EqMll0BA,cAAW;ArMsl0BX;;AsMry0BA;EACE,mBAAc;AtMwy0BhB;;AAEA;EACE,mCsMvy0BY;AtMwy0Bd;;AAEA;EACE,csMry0Bc;AtMsy0BhB;;AAEA;EACE,yBsMry0BqB;AtMsy0BvB;;AAEA;EACE,+CsMly0BoC;AtMmy0BtC;;AAEA;EACE,csM/x0BU;AtMgy0BZ;;AAEA;EACE,mBsM/x0BY;AtMgy0Bd;;AAEA;EACE,yBsM9x0ByB;AtM+x0B3B;;AAEA;;EAEE,kCgBpu0BgC;EhBqu0BhC,csMrx0BE;AtMsx0BJ;;AAEA;EACE,SsMrx0BI;EtMsx0BJ,mBsMrx0BgB;AtMsx0BlB;;AAEA;;EAEE,mBsMrx0BmB;AtMsx0BrB;;AAEA;EACE,mBsMrx0Bc;AtMsx0BhB;;AAEA;EACE,yBsMpx0Ba;AtMqx0Bf;;AAEA;EACE,qBsMhx0BsB;EtMix0BtB,csMhx0BI;AtMix0BN;;AAEA;EACE,yBsMhx0BkB;AtMix0BpB;;AAEA;EACE,yBsMhx0BgB;AtMix0BlB;;AAEA;EACE,yBsM7w0BM;EtM8w0BN,qB0Fvw0BgB;A1Fww0BlB;;AAEA;EACE,yBsM1w0BqB;AtM2w0BvB;;AAEA;EACE,csM1w0BkB;AtM2w0BpB;;AAEA;EACE,yBsMzw0ByB;AtM0w0B3B;;AAEA;EACE,mBsMtw0BgB;AtMuw0BlB;;AAEA;EACE,cCrx0BU;EDsx0BV,qBAAqB;AuMl40BtB;;AvMq40BD;EACE,cAAc;AwMt40Bf;;AxMy40BD;EwMr40BE,yBAAA;AxMu40BF;;AAEA;EACE,cwMr40BC;AxMs40BH;;AAEA;EACE,cwMp40BG;ExMq40BH,yCwMp40BkB;AxMq40BpB;;AAEA;;EAEE,yBwMl40Ba;AxMm40Bf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBwMn40BiB;AxMo40BnB;;AAEA;EACE,yBwMl40BG;AxMm40BL;;AAEA;EACE,yBwMj40BE;AxMk40BJ;;AAEA;;EAEE,gCwM/30BW;AxMg40Bb;;AAEA;EACE,cwM130BY;AxM230Bd;;AAEA;EACE,yBwMz30Be;ExM030Bf,mCwMz30BsB;AxM030BxB;;AAEA;EACE,yBwMz30Be;ExM030Bf,mCwMz30BsB;AxM030BxB;;AAEA;EACE,yBwMp30BY;AxMq30Bd;;AAEA;EACE,mBwMl30BG;AxMm30BL;;AAEA;EACE,mBwM720BG;AxM820BL;;AAEA;EACE,yBwMz20BE;AxM020BJ;;AAEA;EACE,qBwMz20BkB;ExM020BlB,yBwMz20BkB;AxM020BpB;;AAEA;EACE,qBwM320BI;AxM420BN;;AAEA;EACE,qBwMt20BY;AxMu20Bd;;AAEA;EACE,mBwMr20BU;AxMs20BZ;;AAEA;EyM990BC,mBAAQ;AzMg+0BT;;AAEA;EACE,mByM790BA;AzM890BF;;AAEA;EGx80BE,yBAAA;AH080BF;;AAEA;EACE,yByMz90BgB;AzM090BlB;;AAEA;;EAEE,yByMv90BU;AzMw90BZ;;AAEA;EACE,qByMn90BiB;AzMo90BnB;;AAEA;EACE,qByMj90BU;AzMk90BZ;;AAEA;EACE,yByM580BgB;AzM680BlB;;AAEA;EACE,yByMt80BU;AzMu80BZ;;AAEA;EACE,yBAAyB;A0Mpg1BzB;;A1Mug1BF;E0Mpg1BG,yBAAc;A1Msg1BjB;;AAEA;EACE,yB0Mpg1Ba;A1Mqg1Bf;;AAEA;EACE,yB0Mpg1BkB;A1Mqg1BpB;;AAEA;EACE,mB0Mpg1Be;E1Mqg1Bf,qB0Mpg1BmB;E1Mqg1BnB,c0Mpg1Ba;A1Mqg1Bf;;AAEA;EACE,8B0Fr70BwB;A1Fs70B1B;;AAEA;EACE,yC0F9/0B8B;A1F+/0BhC;;AAEA;EACE,mB0M//0BE;E1Mgg1BF,qB0Frg1Bc;A1Fsg1BhB;;AAEA;EACE,c0M7/0BE;E1M8/0BF,qB0Fzg1Ba;A1F0g1Bf;;AAEA;EACE,yB0M3/0BE;E1M4/0BF,c0M3/0Ba;A1M4/0Bf;;AAEA;E0Mt/0BI,yBAAA;A1Mw/0BJ;;AAEA;EACE,c0Mr/0Bc;A1Ms/0BhB;;AAEA;E0Mj/0BI,mBAAe;A1Mm/0BnB;;A0M3+0BE;EACC,mBAAa;E1M8+0Bd,cAAc;AGhi1Bd;;AHmi1BF;;E2M5j1BE,mB1MsGiB;A0MpGf;;A3M+j1BJ;E2M3j1BW,mBAAA;A3M6j1BX;;AAEA;E2Mzj1BE,4BAAY;A3M2j1Bd;;A2Mrj1BE;EACC,cAAW;A3Mwj1Bd;;AAEA;E2Mrj1BG,mBAAA;A3Muj1BH;;AAEA;;;E2M9i1BG,mB3L2D+B;AhBu/0BlC;;A2M3i1BE;EACC,mBAAW;A3M8i1Bd;;AAEA;E2M3i1BG,mBAAA;E3M6i1BD,qB2M5i1BQ;AAKN;;A3M0i1BJ;E2Mti1BQ,yBAAgB;EAChB,qBAAqB;A3Mwi1B7B;;AAEA;;E2Mji1BQ,mBAAgB;A3Moi1BxB;;AAEA;E2M7h1BQ,yBAAA;A3M+h1BR;;AAEA;E2Mzh1BQ,yBjHSgB;AiHPvB;;A3M2h1BD;E2Mvh1BC,yBAAkB;A3Myh1BnB;;A2Mrh1BC;;EAEO,yBjHHgB;AiHKvB;;A3Mwh1BD;E2Mlh1BI,yBAAA;A3Moh1BJ;;AAEA;E2M7g1BQ,yDAAS;A3M+g1BjB;;AAEA;E2M3g1BQ,yBAAA;A3M6g1BR;;AAEA;E2M1g1BY,cAAA;A3M4g1BZ;;AAEA;E2Mhg1BQ,yBAAO;A3Mkg1Bf;;AAEA;E2Mx/0BQ,qBAAK;A3M0/0Bb;;AAEA;E2Ml/0BQ,oCAAK;A3Mo/0Bb;;A2M/+0BA;EAGC,mBjHnJe;A1Fmo1BhB;;AAEA;EACE,yBAAyB;EACzB,yB0F5n1BgB;A1F6n1BlB;;AAEA;E2M7+0BC,yB3LrFiC;AhBok1BlC;;AAEA;EACE,4B0Flo1BgB;A1Fmo1BlB;;AAEA;E2M5+0BC,c3L9FiC;AhB4k1BlC;;AAEA;EACE,c2M/+0BM;A3Mg/0BR;;AAEA;E2M3+0BC,mB3LvGiC;E2LwGxB,qBAAA;E3M6+0BR,cAAc;AAChB;;AAEA;E2M5+0BA,mBAAA;A3M8+0BA;;AAEA;EACE,cAAc;AAChB;;AAEA;E2M3+0BA,mBAAA;A3M6+0BA;;AAEA;;;EAGE,aAAa;A2Mv+0BP;;A3M0+0BR;EACE,mB2M3+0BM;A3M4+0BR;;AAEA;;EAEE,yB2M1+0BA;A3M2+0BF;;A4Mtt1BA;EACI,mBAAS;A5Myt1Bb;;AAEA;;;EAGE,c4Mrt1BkB;A5Mst1BpB;;AAEA;EACE,mBAAmB;A6M/t1BrB;;A7Mku1BA;EACE,oCAAoC;A6M9t1BlC;;A7Miu1BJ;E6M5t1BA,cAAA;A7M8t1BA;;A6M1t1BA;;E1MkBQ,cAAA;AH6s1BR;;AAEA;E6M3t1BA,cAAA;A7M6t1BA;;AAEA;;;EAGE,cAAc;AAChB;;A6M1t1BA;;EAEI;;;;I7Mgu1BA,uBAAuB;E6Mzt1B3B;A7M2t1BA;;AAEA;E6Mzt1BI,yBAAgB;A7M2t1BpB;;AAEA;EACE,mB6Mlu1BF;A7Mmu1BA;;A6Mtt1BA;EACC,cAAW;A7Myt1BZ;;AAEA;EACE,c6Mzt1BQ;A7M0t1BV;;A6Mrt1BA;EACI,mBnHsCsB;E1Fkr1BxB,qBAAqB;A6Mrt1BvB;;A7Mwt1BA;E6Mrt1Ba,mBAAA;E7Mut1BX,qB0Fzr1BsB;A1F0r1BxB;;AAEA;E6Mnt1BQ,qBAAqB;A7Mqt1B7B;;AAEA;EACE,mB0Fhx1BK;A1Fix1BP;;A6Mht1BC;EACC,mBAAmB;A7Mmt1BrB;;AAEA;EACE,qBAAqB;A6M/s1BvB;;A7Mkt1BA;E6M/s1BA,cAAS;A7Mit1BT;;A6M7s1BA;EACC,cAAU;A7Mgt1BX;;AAEA;E6M7s1BI,mBAAA;E7M+s1BF,qB6M9s1BuB;A7M+s1BzB;;AAEA;EACE,cAAc;AAChB;;A6M1s1BA;EACC,mBAAkB;A7M6s1BnB;;AAEA;EACE,yB6M3s1BW;A7M4s1Bb;;AAEA;EACE,yCAAyC;A6Mxs1B3C;;A7M2s1BA;EACE,yB6Mzs1BW;A7M0s1Bb;;AAEA;;EAEE,W6M3s1BF;E7M4s1BE,yB6Mzs1Ba;A7M0s1Bf;;AAEA;EACE,mBAAmB;A6Mvs1BrB;;A7M0s1BA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;E6Mts1BA,oCAA8B;A7Mws1B9B;;A6Mps1BA;EACC,yBnH1Ce;A1Fiv1BhB;;AAEA;EACE,yB6Mts1BW;E7Mus1BX,qB6Mts1BO;A7Mus1BT;;AAEA;EACE,c6Mrs1BW;EAGZ,qBAAA;A7Mos1BD;;AAEA;EACE,yB0F9v1Bc;E1F+v1Bd,qB6Mns1BM;A7Mos1BR;;AAEA;;;;;;EAME,yB6Mjs1BO;E7Mks1BP,qB6Mjs1BY;A7Mks1Bd;;AAEA;;;EAGE,c6M9r1BC;A7M+r1BH;;AAEA;E8Mx41BA,mBAAS;A9M041BT;;AAEA;E+Mx41BQ,mCAAA;A/M041BR;;AAEA;E+Mj41BQ,cAAA;A/Mm41BR;;A+M731BA;EACI,yBAAoB;A/Mg41BxB;;AgNr51BC;EACC,+CAAgB;AhNw51BlB;;AAEA;EACE,cgN551BD;AhN651BD;;AAEA;EgNr51BE,mBAAkB;AhNu51BpB;;AAEA;EACE,yBgNv51BgB;AAGjB;;AhNu51BD;;EAEE,kCgNt51BgB;EhNu51BhB,cAAc;AiN361BhB;;AjN861BA;EiN361BI,SAAA;EACS,mBAAA;AjN661Bb;;AAEA;;EiNx61BI,mBAAY;AjN261BhB;;AAEA;EiNz61BI,mBAAkB;AjN261BtB;;AAEA;EiNz61BI,yBAAyB;AjN261B7B;;AAEA;EACE,qBiN161Ba;EjN261Bb,ciN161Bc;AjN261BhB;;AAEA;EACE,yBiN161BmB;AjN261BrB;;AAEA;EiNx61BI,yBAAA;AjN061BJ;;AAEA;EiNv61BI,yBAAC;EjNy61BH,qB0F121BsB;A1F221BxB;;AAEA;EACE,yBiNr61B0B;AjNs61B5B;;AAEA;EACE,ciNr61BiB;AjNs61BnB;;AAEA;EACE,yBiNj61BM;AjNk61BR;;AAEA;EACE,mBiNj61Bc;AjNk61BhB;;AAEA;EACE,cAAc;EiN551BhB,qBAAU;AjN851BV;;AAEA;EACE,ciN951BS;AjN+51BX;;AAEA;EACE,yBiN551B2B;AjN651B7B;;AkN7+1BA;EACI,cxHoGc;A1F441BlB;;AAEA;EkN9+1BI,cAAwB;EACxB,yCAAyC;AlNg/1B7C;;AAEA;;EkNz+1BI,yBAAA;AlN4+1BJ;;AAEA;EACE,yBCj51BiB;ADk51BnB;;AAEA;EACE,yBkNt+1BwB;AlNu+1B1B;;AAEA;EACE,yBkNr+1BM;AlNs+1BR;;AAEA;EACE,yBkNp+1B4B;AlNq+1B9B;;AAEA;;EAEE,gCkN991B8B;AlN+91BhC;;AAEA;EACE,ckN791BiB;AlN891BnB;;AAEA;EACE,yBkN591B0B;EAGxB,mCAAA;AlN291BJ;;AAEA;EACE,yBkNz91B0B;ElN091B1B,mCkNx91BM;AlNy91BR;;AmN7h2BI;EACI,yBAAgB;AnNgi2BxB;;AAEA;EACE,mBmN9h2B2B;AnN+h2B7B;;AAEA;EACE,mBmN3h2BU;AnN4h2BZ;;AAEA;EACE,yBmNvh2BqC;AnNwh2BvC;;AAEA;EACE,qBGth2BA;EHuh2BA,yBmN/h2Bc;AnNgi2BhB;;AAEA;EACE,qBmNph2BqC;AnNqh2BvC;;AAEA;EACE,qBmN/g2BuB;AnNgh2BzB;;AAEA;EACE,mBmNvh2BU;AnNwh2BZ;;AAEA;EACE,mBmN3g2B4B;AnN4g2B9B;;AAEA;EACE,mBmN1g2B8B;AnN2g2BhC;;AAEA;EACE,yBmNzg2B6B;AnN0g2B/B;;AAEA;EACE,yBGnj2BA;AHoj2BF;;AAEA;;EAEE,yBmNtg2B6B;AnNug2B/B;;AAEA;EACE,qBmNng2Bc;AnNog2BhB;;AAEA;EACE,qBmNng2BkB;AnNog2BpB;;AAEA;EACE,yBmNng2B0B;AnNog2B5B;;AAEA;EmN5/1BI,yBAAA;AnN8/1BJ;;AAEA;EmN5/1BQ,yBAAqB;AnN8/1B7B;;AAEA;EmN5/1BQ,yBAAwB;AAG5B;;AnN6/1BJ;EmNx/1BI,yBAAA;AnN0/1BJ;;AAEA;EmNt/1BI,yBAAA;AnNw/1BJ;;AAEA;EmNp/1BQ,mBAAY;EACZ,qBAAc;EAGlB,cAAA;AnNo/1BJ;;AAEA;EmNh/1BQ,8BAAwB;AnNk/1BhC;;AmNz+1BI;EACI,yCzHhGM;A1F4k2Bd;;AAEA;EmNz+1BQ,mBAAsB;EACtB,qBAAqB;AnN2+1B7B;;AAEA;EmNz+1BQ,cAAkB;EAClB,qBAAsB;AnN2+1B9B;;AAEA;E4Fll2BI,yBAAyB;E5Fol2B3B,cmN3/1BE;AnN4/1BJ;;AAEA;EmNh+1BI,yBAAA;AnNk+1BJ;;AAEA;EmN191BQ,cAAA;AnN491BR;;AmNv91BI;EACI,iBAAiB;AnN091BzB;;AAEA;EmNt91BI,iBAAA;EACI,cAAa;AnNw91BrB;;AAEA;;EmN/81BI,iBAAA;AnNk91BJ;;AAEA;EmN581BI,mBAAA;AnN881BJ;;AmNz81BI;EnN481BF,4BAA4B;AAC9B;;AAEA;EACE,cmN181BoB;AnN281BtB;;AAEA;EmNr81BQ,mBAAA;AnNu81BR;;AAEA;;;EmN371BQ,mBAAA;AnN+71BR;;AAEA;EACE,mBmN971BkC;AnN+71BpC;;AAEA;EACE,mBmN571BmC;EnN671BnC,qBmN571BkC;AnN671BpC;;AAEA;EmNp71BI,yBAAA;EACI,qBAAkB;AnNs71B1B;;AAEA;;EAEE,mBAAmB;AoN/s2BrB;;ApNkt2BA;EoN/s2BI,yBAAgB;ApNit2BpB;;AAEA;EACE,yBoN/s2BS;ApNgt2BX;;AAEA;EACE,yBoN9s2BS;ApN+s2BX;;AAEA;;EAEE,yBoN9s2BiB;ApN+s2BnB;;AAEA;EoN5s2BC,yBACA;ApN6s2BD;;AoNzs2BA;EACI,yDAAkB;ApN4s2BtB;;AAEA;EACE,yBoN1s2BU;ApN2s2BZ;;AAEA;EACE,coN1s2BW;ApN2s2Bb;;AAEA;EACE,yBoN1s2BM;ApN2s2BR;;AAEA;EACE,qBoNzs2Bc;ApN0s2BhB;;AAEA;EoNvs2BC,oCAAK;ApNys2BN;;AAEA;EACE,mBAAmB;AoNrs2BpB;;ApNws2BD;EoNrs2BE,yBAAiB;EACjB,yBAAa;ApNus2Bf;;AAEA;EACE,yBoNrs2BmB;ApNss2BrB;;AAEA;EACE,4BoNrs2BY;ApNss2Bd;;AAEA;EACE,coNrs2BW;ApNss2Bb;;AAEA;EACE,cAAc;AqNrx2BhB;;ArNwx2BA;EqNrx2BI,mBAAe;EACf,qBAAW;EACX,c3HkGsB;A1Fqr2B1B;;AAEA;EGht2BC,mBAAkB;AHkt2BnB;;AAEA;EqNvx2BC,cAAA;ArNyx2BD;;AAEA;EACE,mBqNvy2BY;ArNwy2Bd;;AAEA;;;EAGE,aAAa;AsN7y2Bf;;AtNgz2BA;EsN7y2BI,mBAAgB;AtN+y2BpB;;AAEA;;EAEE,yBsN9y2Be;AtN+y2BjB;;AAEA;EACE,mBsN5y2BiB;AtN6y2BnB;;AAEA;;;EAGE,csNzy2BW;AtN0y2Bb;;AAEA;EACE,mBsNxy2Bc;AtNyy2BhB;;AAEA;EACE,oCsNry2BgB;AtNsy2BlB;;AAEA;EACE,csNpy2BU;AtNqy2BZ;;AAEA;;EAEE,csNhy2BQ;AtNiy2BV;;AAEA;EACE,csN9x2BA;AtN+x2BF;;AAEA;;;EAGE,csN5x2BA;AtN6x2BF;;AAEA;;EAEE;;;;IsNjx2BA,uBAAe;EACf;AtNsx2BF;;AAEA;EsNtx2BE,yBAAA;AtNwx2BF;;AAEA;EACE,mBG9x2Be;AH+x2BjB;;AAEA;EG/12BE,cAAA;AHi22BF;;AAEA;EACE,cAAc;AuNp32Bf;;AvNu32BD;EACE,mBuNx32BD;EvNy32BC,qBuNt32BW;AvNu32Bb;;AAEA;EuNn32BI,mBAAY;EACf,qBAAgB;AvNq32BjB;;AAEA;EACE,qBuN332BQ;AvN432BV;;AAEA;EACE,mBuNr32Ba;AvNs32Bf;;AAEA;EuNl32BE,mBAAe;AAEhB;;AAGA;EACC,qBAAY;ApNMN;;AH822BR;EuN922BE,cAAA;AvNg32BF;;AuN322BA;EACC,cAAa;AvN822Bd;;AAEA;EACE,mBAAmB;EuN522BrB,qBAAU;AvN822BV;;AAEA;EuN522BI,cAAQ;AvN822BZ;;AAEA;EuN522BI,mBAAiB;AvN822BrB;;AAEA;EuN522BA,yBAAgB;AvN822BhB;;AAEA;EuN522BI,yCAAQ;AvN822BZ;;AuN322BA;EACI,yBAAY;AvN822BhB;;AAEA;;EuN322BI,WAAQ;EACR,yBAAmB;AvN822BvB;;AAEA;EACE,mBuN922BU;AvN+22BZ;;AuN322BA;EACI,yBAAgB;EAChB,qBAAe;AvN822BnB;;AAEA;EACE,oCuNn32B0B;AvNo32B5B;;AuN122BA;EACI,yB7HYsB;A1Fi22B1B;;AAEA;EuN122BI,yBAAY;EACZ,qB7HMc;A1Fs22BlB;;AAEA;EuN122BI,cAAW;EACX,qBAAgB;AvN422BpB;;AAEA;EwNj92BE,yBAAI;ExNm92BJ,qBwNl92BS;AxNm92BX;;AAEA;;;;;;EAME,yBwNj92BmB;ExNk92BnB,qBwNj92BkB;AxNk92BpB;;AAEA;;;EwN582BE,cAAa;AxNg92Bf;;AAEA;EACE,mBwN782BgB;AxN882BlB;;AAEA;EACE,kCwN982BqB;AxN+82BvB;;AAEA;EACE,cwN382BW;AxN482Bb;;AAEA;EACE,yBwN382Ba;AxN482Bf;;AAEA;EACE,8CGp+2BM;AHq+2BR;;AAEA;EACE,cwN192BA;AxN292BF;;AAEA;EACE,mBwNx82BC;AxNy82BH;;AAEA;EACE,yBwNx82BmB;AxNy82BrB;;AAEA;;EAEE,kCGr/2BM;EHs/2BN,cwNl92BC;AxNm92BH;;AAEA;EACE,SwNv82BC;ExNw82BD,mB0F162BwB;A1F262B1B;;AAEA;;EwNn82BE,mBAAA;AxNs82BF;;AAEA;EACE,mBwNr82Bc;AxNs82BhB;;AAEA;EACE,yBwNr82BC;AxNs82BH;;AAEA;EACE,qBwNr82Bc;ExNs82Bd,cwNr82BE;AxNs82BJ;;AAEA;EACE,yBwNn82BqB;AxNo82BvB;;AAEA;EACE,yBwNn82Be;AxNo82BjB;;AAEA;EwN/72BA,yBAAc;EACb,qBAAW;AxNi82BZ;;AAEA;EwN/72BC,yB9HEe;A1F+72BhB;;AAEA;EwN/72BC,c9HjByB;A1Fk92B1B;;AAEA;EACE,yBwNj82BU;AxNk82BZ;;AwN972BA;EACC,mBAAiB;AxNi82BlB;;AAEA;EACE,cwNh82BU;ExNi82BV,qBwNh82BA;AxNi82BF;;AAEA;EACE,cwNh82BO;AxNi82BT;;AAEA;EACE,yBwNh82BkB;AxNi82BpB;;AAEA;EACE,cwN/72BU;AxNg82BZ;;AyNll3BA;EACC,cAAW;EACX,wCAAmB;AzNql3BpB;;AAEA;;EAEE,yByN3l3BY;AzN4l3Bd;;AAEA;EACE,yByNrl3BiB;AzNsl3BnB;;AyNll3BA;EACC,yBAAiB;AzNql3BlB;;A0Nhm3BE;EACC,yBAAS;A1Nmm3BZ;;AAEA;EG5h3BC,yBAAoB;AH8h3BrB;;AAEA;;E0Njm3BG,gCAAA;A1Nom3BH;;AAEA;EACE,c0Nlm3BY;A1Nmm3Bd;;AAEA;EACE,yB0Nhm3BkB;EvNPlB,kCAAA;AHym3BF;;AAEA;E0N1l3BC,yBAAC;EACA,kCAAc;A1N4l3BhB;;A0Nvl3BC;EACC,yBhI5BU;A1Fsn3BZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mB0N1h3BG;A1N2h3BL;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qB0Nhm3BW;E1Nim3BX,yB0Nhm3BS;A1Nim3BX;;AAEA;EACE,qBGnn3BM;AHon3BR;;AAEA;EACE,qB0Ntm3BD;A1Num3BD;;AAEA;EACE,mB0N/l3Ba;A1Ngm3Bf;;AAEA;EACE,mB0N/l3Be;A1Ngm3BjB;;AAEA;EACE,mB0Nhm3BW;A1Nim3Bb;;AAEA;EACE,yB0N9l3BU;A1N+l3BZ;;AAEA;EACE,yB0N9l3BC;A1N+l3BH;;AAEA;;EAEE,yB0N/l3BkB;A1Ngm3BpB;;AAEA;EACE,qB0Nxl3BqB;A1Nyl3BvB;;AAEA;E0Nrl3BE,qBAAA;A1Nul3BF;;AAEA;EACE,yB0Nzk3BI;A1N0k3BN;;AAEA;EACE,yB0Nxk3Ba;A1Nyk3Bf;;AAEA;EACE,yBAAyB;A0Nrk3B3B;;A1Nwk3BA;E0Nrk3BA,yBAAS;A1Nuk3BT;;AAEA;EACE,yB0N1k3BO;A1N2k3BT;;A0Npk3BA;EACC,yBAAc;A1Nuk3Bf;;AAEA;E0Nrk3BC,mBAAmB;EAEnB,qBAAC;E1Nsk3BA,c0Nrk3BA;A1Nsk3BF;;AAEA;EACE,8B0Njl3BgB;A1Nkl3BlB;;AAEA;EACE,yC0Nnk3BoB;A1Nok3BtB;;AAEA;E0N7j3BY,mBAAA;EACI,qBAAe;A1N+j3B/B;;AAEA;EACE,cAAc;E0Nvj3BZ,qBAAM;A1Nyj3BV;;AAEA;EACE,yB0Nvj3B6B;EAInB,cAAA;A1Nqj3BZ;;AAEA;EACE,yB0Npj3BuB;A1Nqj3BzB;;AAEA;EACE,c0Njj3BkB;A1Nkj3BpB;;AAEA;E0N1i3BC,iBAAA;A1N4i3BD;;AAEA;E0Nzi3BE,iBAAe;EACf,cAAa;A1N2i3Bf;;AAEA;;EAEE,iB0Nxi3Be;A1Nyi3BjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;E0Nri3BI,4BAAkB;A1Nui3BtB;;AG/v3BE;EuN4NF,cAAY;A1Nui3BZ;;AGpv3BE;EuN6MF,mBAAY;A1N2i3BZ;;AG/u3BQ;;;EHov3BN,mB0Nri3BmB;AAEjB;;AAMA;EACI,mBAAS;A1Nii3BjB;;AAEA;E0N/h3BQ,mBAAE;E1Nii3BR,qB0Nhi3ByB;A1Nii3B3B;;AAEA;EACE,yB0N/h3BqB;EAInB,qBAAA;A1N6h3BJ;;AAEA;;E0Nvh3BG,mBAAW;A1N0h3Bd;;AAEA;EACE,yB0N1h3Ba;A1N2h3Bf;;A0Nth3BE;EACC,yBAAW;A1Nyh3Bd;;AAEA;EACE,yB0Nzh3Ba;A1N0h3Bf;;AAEA;;E0Nnh3BI,yBAAU;A1Nsh3Bd;;AAEA;E0Nph3BE,yBAAgB;A1Nsh3BlB;;AAEA;EACE,yD0Nph3BsB;A1Nqh3BxB;;AAEA;EACE,yB0Ftu3BwB;A1Fuu3B1B;;AAEA;EACE,c0N9h3BM;A1N+h3BR;;AAEA;E0Nhh3BG,yBAAA;A1Nkh3BH;;AAEA;EACE,qB0Nrh3BC;A1Nsh3BH;;A0N3g3BE;EACC,oCAAsB;A1N8g3BzB;;AAEA;EACE,mB0N5g3BmB;A1N6g3BrB;;AAEA;EACE,yB0N5g3BoB;E1N6g3BpB,yB0N5g3BsB;A1N6g3BxB;;AAEA;EACE,yB0N3g3BG;A1N4g3BL;;AAEA;E0Npg3BA,4BAAA;A1Nsg3BA;;AAEA;EACE,cAAc;A0Npg3BhB;;A1Nug3BA;EACE,c0Nxg3BF;A1Nyg3BA;;AAEA;EACE,mBAAmB;E0Nng3BrB,qBAAA;EACC,cAAA;A1Nqg3BD;;AAEA;E0Njg3BA,mBAAY;A1Nmg3BZ;;A0Nhg3BA;EACI,cAAQ;A1Nmg3BZ;;AAEA;E0Njg3BI,mBAAgB;A1Nmg3BpB;;A0Nhg3BA;;;EAGI,aAAU;A1Nmg3Bd;;AAEA;E0Nhg3BI,mBAAA;A1Nkg3BJ;;AAEA;;EAEE,yB0F903BS;A1F+03BX;;AAEA;EACE,mB0N7/2BqB;A1N8/2BvB;;AAEA;;;E0Nx/2BI,cAAU;A1N4/2Bd;;A0Nz/2BA;EACC,mBAAc;A1N4/2Bf;;A0Nv/2BA;EACC,oChIzUyB;A1Fm03B1B;;AAEA;E0Nx/2BI,cAAQ;A1N0/2BZ;;AAEA;;EAEE,c0Nng3BF;A1Nog3BA;;AAEA;EACE,c0Nx/2BW;A1Ny/2Bb;;AAEA;;;EAGE,c0Nv/2BA;A1Nw/2BF;;AAEA;;EAEE;;;;I0Nj/2BD,yBAAM;E1Ns/2BL;AACF;;AAEA;EACE,yB0Nr/2BO;A1Ns/2BT;;AAEA;EACE,mB0Nr/2BiB;A1Ns/2BnB;;A0Nj/2BC;EACC,cAAA;A1No/2BF;;AAEA;E0Nl/2BE,cAAA;A1No/2BF;;AAEA;E0N9+2BC,mBAAY;EACZ,qBAAY;A1Ng/2Bb;;AAEA;EACE,mB0N/+2Bc;E1Ng/2Bd,qB0N/+2BgB;A1Ng/2BlB;;AAEA;EACE,qB0N/+2BA;A1Ng/2BF;;AAEA;EACE,mB0N7+2BgB;A1N8+2BlB;;AAEA;EACE,mB0N7+2Be;A1N8+2BjB;;AAEA;EACE,qB0N1+2BA;A1N2+2BF;;AAEA;EGx93BE,cAAA;AH093BF;;AAEA;E0Np+2BC,cAAA;A1Ns+2BD;;AAEA;EACE,mB0Nr+2BW;E1Ns+2BX,qB0Nr+2BW;A1Ns+2Bb;;AAEA;EACE,c0Nr+2BQ;A1Ns+2BV;;AAEA;EACE,mB0Np+2Be;A1Nq+2BjB;;AAEA;EACE,yB0Np+2BO;A1Nq+2BT;;AAEA;EACE,wC0Np+2BuB;A1Nq+2BzB;;A0Nh+2BC;EACA,yBAAc;A1Nm+2Bf;;AAEA;;E0Nj+2BC,WAAQ;EACR,yBAAc;A1No+2Bf;;AAEA;EACE,mBAAmB;A0Nl+2BpB;;A1Nq+2BD;E0Nl+2BC,yBAAQ;EACR,qBAAc;A1No+2Bf;;AAEA;E0N792BE,oCAAmB;A1N+92BrB;;AAEA;E0N792BE,yBhIpdc;A1Fm73BhB;;AAEA;EACE,yBAAyB;E0Nl92B3B,qBAAA;A1No92BA;;A0N782BC;EACC,cAAU;EvNlkBV,qBAAA;AHmh4BF;;AAEA;EACE,yB0Nr92BC;E1Ns92BD,qB0Nh92Be;AAGhB;;A1Ng92BD;;;;;;E0Nv82BE,yBAAgB;EAChB,qBAAc;A1N882BhB;;AAEA;;;EAGE,c0N982BQ;A1N+82BV;;AAEA;EACE,mB0N982BC;A1N+82BH;;A0Nz82BC;EACC,mCAAU;A1N482BZ;;AAEA;E0N182BE,cAAS;A1N482BX;;AAEA;E0Nv82BA,yBAAO;A1Ny82BP;;AAEA;E0Nv82BI,+CAAqC;A1Ny82BzC;;AAEA;E0Nv82BA,cAAa;A1Ny82Bb;;AAEA;EGlk4BE,mBAAA;AHok4BF;;AG9k4BQ;EuNuoBR,yBAAW;A1N282BX;;A2Nxm4BA;;E3N4m4BE,kCAAkC;EAClC,cAAc;A2Nxm4BhB;;A3N2m4BA;EACE,S2Nzm4BM;E3N0m4BN,mBCrg4BiB;ADsg4BnB;;AAEA;;E2Npm4BQ,mBAAS;A3Num4BjB;;AAEA;E2Nrm4BQ,mBAAW;A3Num4BnB;;AAEA;E2Nlm4BQ,yBAAe;A3Nom4BvB;;AAEA;E2N/l4BI,qBAAA;EACI,cAAW;A3Nim4BnB;;A2N5l4BA;EACI,yBAAa;A3N+l4BjB;;AAEA;EACE,yB2N9l4BkB;A3N+l4BpB;;AAEA;E2N3l4BQ,yBAAA;E3N6l4BN,qB2N1l4BkB;A3N2l4BpB;;AAEA;EACE,yBAAyB;A2Nvl4B3B;;A3N0l4BA;EACE,c2Nvl4BmB;A3Nwl4BrB;;AAEA;EACE,yB2Npl4B2B;A3Nql4B7B;;AAEA;EACE,mB2Npl4BsB;A3Nql4BxB;;AAEA;E2Nhl4BA,cAAA;EAEA,qBAAgB;A3Nil4BhB;;AAEA;E2N/k4BI,cAAa;A3Nil4BjB;;AAEA;EACE,yB2Nhl4Be;A3Nil4BjB;;AAEA;EACE,c2Nhl4BkB;A3Nil4BpB;;AAEA;E2N5k4BI,cAAA;EACI,yC1NGW;AD2k4BnB;;AAEA;;EAEE,yBAAyB;A2Nxk4BnB;;A3N2k4BR;E2Nxk4BY,yBAAa;A3N0k4BzB;;AAEA;E2Nxk4BY,yBAAe;A3N0k4B3B;;AAEA;EACE,yB0Fnm4BsB;A1Fom4BxB;;A2Npk4BQ;EACI,yBAAe;A3Nuk4B3B;;AAEA;;E2Nhk4BQ,gCAAE;A3Nmk4BV;;AAEA;E2N9j4BA,cAAiB;A3Ngk4BjB;;AAEA;EACE,yB2N9j4B2B;E3N+j4B3B,mC2N9j4Ba;A3N+j4Bf;;AAEA;EACE,yB2N7j4B+B;E3N8j4B/B,mC2N5j4ByB;A3N6j4B3B;;AAEA;EACE,yB2N5j4B6B;A3N6j4B/B;;AAEA;EACE,mB2N1j4ByB;A3N2j4B3B;;AAEA;E2Nrj4BI,mBAAkB;A3Nuj4BtB;;AAEA;E2Nnj4BI,yBAAA;A3Nqj4BJ;;AAEA;E2Nnj4BQ,qBAAiB;E3Nqj4BvB,yBAAyB;A2N/i4BnB;;A3Nkj4BR;EACE,qBAAqB;A2N5i4BvB;;A3N+i4BA;E2N5i4BI,qBAAG;A3N8i4BP;;AAEA;EACE,mB2N7i4BqB;A3N8i4BvB;;AAEA;EACE,mBAAmB;A2N1i4BrB;;A3N6i4BA;E2Nzi4BA,mBAAO;A3N2i4BP;;AAEA;E2Nvi4BI,yBAAQ;A3Nyi4BZ;;AAEA;E2Nti4BQ,yBAAiB;AAErB;;AAGA;;EAEI,yBAAqB;A3Nsi4B7B;;AAEA;EACE,qBAAqB;A2N1h4BnB;;A3N6h4BJ;E2Nzh4BI,qBAAA;A3N2h4BJ;;AAEA;E2Nzh4BQ,yBAAmB;A3N2h4B3B;;AAEA;EACE,yB2Nxh4BuB;AAGrB;;A3Nwh4BJ;E2Nrh4BQ,yBAAe;A3Nuh4BvB;;AAEA;EACE,yB2Nph4BsB;A3Nqh4BxB;;AAEA;EACE,yBAAyB;A4Nhz4B1B;;A5Nmz4BD;EACE,yB4Nhz4BW;A5Niz4Bb;;AAEA;E4N/y4BC,mBAAA;EACC,qBAAW;EACX,cAAc;A5Niz4BhB;;AAEA;EACE,8BAA8B;A6N/z4BhC;;A7Nk04BA;EACE,yC6Nh04BmC;AAGjC;;A7Ng04BJ;E6N5z4BI,mBAAA;EACI,qBAAe;A7N8z4BvB;;AAEA;EACE,c0F/z4BU;EmIKR,qBAAA;A7N4z4BJ;;AAEA;E6N1z4BE,yBAAgB;EAChB,cAAY;A7N4z4Bd;;AAEA;EACE,yB6N5z4BgB;AAGd;;A7N4z4BJ;E6Nzz4BQ,cAAa;A7N2z4BrB;;AAEA;EACE,iBAAiB;A6Nvz4BnB;;A7N0z4BA;E6Ntz4BA,iBAAc;EACV,c7MyD8B;AhB+v4BlC;;A6Npz4BA;;EAEI,iBAAc;A7Nuz4BlB;;AAEA;EACE,mB6Ntz4BqB;A7Nuz4BvB;;AAEA;EACE,4B0F514Ba;A1F614Bf;;AAEA;EACE,c6Nrz4BA;A7Nsz4BF;;AAEA;E6Nlz4BI,mBAAE;A7Noz4BN;;A2Fz34BA;;;EAIE,mBAAK;A3F234BP;;AAEA;E2Fr34BE,mBAAA;A3Fu34BF;;AAEA;EACE,mB2Fp34BmB;EAGnB,qBAAA;A3Fm34BF;;AAEA;EACE,yB2Fh34BU;E3Fi34BV,qB2Fh34BmB;A3Fi34BrB;;AAEA;;EAEE,mB2F524BiB;A3F624BnB;;AAEA;E2Fv24BE,yBAAA;A3Fy24BF;;AAEA;EACE,yB2Ft24BU;A3Fu24BZ;;AAEA;EACE,yB2Fp24Bc;A3Fq24BhB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;E2F/14BE,yBAAA;A3Fi24BF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,c2F514BE;A3F614BJ;;AAEA;E2Fv14BE,yBAAgB;A3Fy14BlB;;AAEA;EACE,qB2Fx14BmB;A3Fy14BrB;;AAEA;E2Fp14BE,oCAA0B;A3Fs14B5B;;AAEA;E2Fl14BE,mBAAA;A3Fo14BF;;AAEA;EACE,yB2Fn14BwB;E3Fo14BxB,yB2Fn14BsB;A3Fo14BxB;;AAEA;E2F904BE,yBAAO;A3Fg14BT;;AAEA;E2F104BE,4BAAA;A3F404BF;;AAEA;EACE,c2Fz04BS;A3F004BX;;AAEA;E2Fp04BE,cAAA;A3Fs04BF;;AAEA;EACE,mB2Fn04BiB;E3Fo04BjB,qB2Fn04BgB;EAeN,cAAuB;A3Fsz4BnC;;AAEA;EACE,mB2Fn04BgB;A3Fo04BlB;;AAEA;EACE,c2Ft04Ba;A3Fu04Bf;;AAEA;E2Fh04BY,mBAAuB;A3Fk04BnC;;AAEA;;;E2Fp04BY,aAAA;A3Fw04BZ;;AAEA;EACE,mB2Fr14BgB;A3Fs14BlB;;AAEA;;E2F904BY,yBAAuB;A3Fi14BnC;;AAEA;EACE,mB2F914BgB;A3F+14BlB;;AAEA;;;EAGE,c2F114BU;A3F214BZ;;AAEA;EACE,mB2Fx24BgB;A3Fy24BlB;;AAEA;EACE,oC2F324BgB;A3F424BlB;;AAEA;EACE,c2Ft24BU;A3Fu24BZ;;AAEA;;EAEE,c2Fp34BE;A3Fq34BJ;;AAEA;EACE,c2F/24BU;A3Fg34BZ;;AAEA;;;EAGE,c2Fr34BU;A3Fs34BZ;;AAEA;;EAEE;;;;IAIE,uB2Fv44Bc;E3Fw44BhB;AACF;;AAEA;EACE,yB2F744BgB;A3F844BlB;;AAEA;EACE,mB2Fh54BgB;A3Fi54BlB;;AAEA;EACE,c2F344BU;A3F444BZ;;AAEA;EACE,c2Fz54BE;A3F054BJ;;AAEA;EACE,mB2F554BgB;E3F654BhB,qB2Fp54BiC;A3Fq54BnC;;AAEA;EACE,mB2Fl64BgB;E3Fm64BhB,qB2Fl64BgB;A3Fm64BlB;;AAEA;EACE,qB2F754BiC;A3F854BnC;;AAEA;EACE,mB2Fj64BiC;A3Fk64BnC;;AAEA;EACE,mB2F/64BgB;A3Fg74BlB;;AAEA;EACE,qB2Fl74BgB;A3Fm74BlB;;AAEA;EACE,c2F764BU;A3F864BZ;;AAEA;EACE,c2F374BE;A3F474BJ;;AAEA;EACE,mB2F974BgB;E3F+74BhB,qB2Ft74BiC;A3Fu74BnC;;AAEA;EACE,c2Fp84BE;A3Fq84BJ;;AAEA;EACE,mB2Fv84BgB;A3Fw84BlB;;AAEA;EACE,yB2Fl84BiC;A3Fm84BnC;;AAEA;EACE,yC2Ft84BiC;A3Fu84BnC;;AAEA;EACE,yB2Fp94BgB;A3Fq94BlB;;AAEA;;EAEE,W2F/84BU;E3Fg94BV,yB2F194BkD;A3F294BpD;;AAEA;EACE,mB2F794BgB;A3F894BlB;;AAEA;EACE,yB2Fx94BiC;E3Fy94BjC,qB2Fn+4BkD;A3Fo+4BpD;;AAEA;EACE,oC2Ft+4BgB;A3Fu+4BlB;;AAEA;EACE,yB2Fj+4BiC;A3Fk+4BnC;;AAEA;EACE,yB2F/+4BgB;E3Fg/4BhB,qB2F/+4BgB;A3Fg/4BlB;;AAEA;E4Frl5BI,cAAA;E5Ful5BF,qB2F3+4BiC;A3F4+4BnC;;AAEA;EACE,yB2Fz/4BgB;E3F0/4BhB,qB2Fz/4BgB;A3F0/4BlB;;AAEA;;;;;;EAME,yB2Flg5BgB;E3Fmg5BhB,qB2F1/4BiC;A3F2/4BnC;;AAEA;;;EAGE,c2Fhg5BU;A3Fig5BZ;;AAEA;EACE,mB2F9g5BgB;A3F+g5BlB;;AAEA;EACE,oC2Fjh5BgB;A3Fkh5BlB;;AAEA;EACE,c2F5g5BU;A3F6g5BZ;;AAEA;EACE,yB2F3/4BuC;A3F4/4BzC;;AAEA;EACE,gD2F1/4BuC;A3F2/4BzC;;AAEA;EACE,c2Fng5BuC;A3Fog5BzC;;AAEA;EACE,mB2Flg5BuC;A3Fmg5BzC;;AAEA;EACE,yB2F3g5BuC;A3F4g5BzC;;AAEA;;EAEE,kC2F1g5BqC;E3F2g5BrC,c2F1g5BwB;A3F2g5B1B;;AAEA;EACE,S2Fnh5BU;EAEF,mBAAA;A3Fmh5BV;;AAEA;;EAEE,mB2F3h5BuC;A3F4h5BzC;;AAEA;EACE,mB2F1h5BuC;A3F2h5BzC;;AAEA;EACE,yB2Fni5BuC;A3Foi5BzC;;AAEA;EACE,qB2Fli5BuC;E3Fmi5BvC,c2Fli5BuB;A3Fmi5BzB;;AAEA;EACE,yB2F3i5B0B;A3F4i5B5B;;AAEA;EACE,yB2F1i5ByB;A3F2i5B3B;;AAEA;EACE,yB2Fnj5B0B;E3Foj5B1B,qB2Fnj5ByB;A3Foj5B3B;;AAEA;EACE,yB2Flj5B0B;A3Fmj5B5B;;AAEA;EACE,c2F3j5BuB;A3F4j5BzB;;AAEA;EACE,yB2F1j5B0B;A3F2j5B5B;;AAEA;EACE,mB2Fnk5ByB;A3Fok5B3B;;AAEA;EACE,c2Flk5BU;EARF,qBAAA;A3F4k5BV;;AAEA;E2Fzk5BU,cAAA;A3F2k5BV;;AAEA;E2Fll5BU,yBAAA;A3Fol5BV;;AAEA;E2Fjl5BU,cAAA;A3Fml5BV;;AAEA;E2F7k5BM,cAAiB;E3F+k5BrB,0C2F9k5BgC;A3F+k5BlC;;AAEA;;E2F1k5BM,yBAAiB;A3F6k5BvB;;AAEA;EACE,yB2Frm5BQ;A3Fsm5BV;;AAEA;EACE,yB2Fpm5BQ;A3Fqm5BV;;AAEA;EACE,yB2F7m5BQ;A3F8m5BV;;AAEA;EACE,yB2F5m5BQ;A3F6m5BV;;AAEA;;EAEE,gC2Frn5BuC;A3Fsn5BzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yB2F7n5BuC;E3F8n5BvC,oC2F7n5BsC;A3F8n5BxC;;AAEA;EACE,yB2F5n5ByB;E3F6n5BzB,oC2F5n5B4C;A3F6n5B9C;;AAEA;EACE,yB2Fro5ByB;A3Fso5B3B;;AAEA;EACE,mB2Fpo5B0B;A3Fqo5B5B;;AAEA;EACE,mB2F7o5ByB;A3F8o5B3B;;AAEA;EACE,yB2F5o5B0B;A3F6o5B5B;;AAEA;EACE,qB2Frp5ByB;E3Fsp5BzB,yB2Fpp5BQ;A3Fqp5BV;;AAEA;EACE,qB2F7p5BQ;A3F8p5BV;;AAEA;EACE,qB2F5p5BQ;A3F6p5BV;;AAEA;EACE,mB2Frq5BQ;A3Fsq5BV;;AAEA;EACE,mB2Fpq5BQ;A3Fqq5BV;;AAEA;EACE,mB2F7q5BQ;A3F8q5BV;;AAEA;EACE,yB2F5q5BQ;A3F6q5BV;;AAEA;EACE,yB2Frr5BQ;A3Fsr5BV;;AAEA;;EAEE,yB2Fpr5BuC;A3Fqr5BzC;;AAEA;EACE,qB2F7r5BuC;A3F8r5BzC;;AAEA;EACE,qB2F5r5BuC;A3F6r5BzC;;AAEA;EACE,yB2Fxr5BoB;A3Fyr5BtB;;AAEA;EACE,yB2Fvr5BmB;A3Fwr5BrB;;AAEA;E4F705BI,yBAAyB;A5F+05B7B;;AAEA;EACE,yB2F/s5ByB;A3Fgt5B3B;;AAEA;EACE,yB2F9s5B0B;A3F+s5B5B;;AAEA;EACE,yB2Fvt5ByB;A3Fwt5B3B;;AAEA;EACE,mB2Ftt5B0B;E3Fut5B1B,qB2F/t5BQ;E3Fgu5BR,cAAc;AAChB;;AAEA;EACE,8B2F9t5BuC;A3F+t5BzC;;AAEA;EACE,yC2Fvu5BuC;A3Fwu5BzC;;AAEA;EACE,mB2Ftu5BuC;E3Fuu5BvC,qB2Ftu5ByB;A3Fuu5B3B;;AAEA;EACE,c2F/u5BU;E3Fgv5BV,qB2F/u5ByB;A3Fgv5B3B;;AAEA;EACE,yB2F9u5B0B;E3F+u5B1B,c2Fvv5BQ;A3Fwv5BV;;AAEA;EACE,yB2Ftv5BQ;A3Fuv5BV;;AAEA;EACE,c2F/v5BQ;A3Fgw5BV;;AAEA;EACE,mB2F9v5BQ;A3F+v5BV;;AAEA;EACE,mB2Fvw5BQ;E3Fww5BR,cAAc;AAChB;;AAEA;;EAEE,mB2Ftw5ByB;A3Fuw5B3B;;AAEA;EACE,mB2F/w5B0B;A3Fgx5B5B;;AAEA;EACE,4B2F9w5ByB;A3F+w5B3B;;AAEA;EACE,c2Fvx5BU;A3Fwx5BZ;;AAEA;EACE,mB2Ftx5ByB;A3Fux5B3B;;AAEA;;;EAGE,mB2F9x5BQ;A3F+x5BV;;AAEA;EACE,mB2Fvy5BQ;A3Fwy5BV;;AAEA;EACE,mB2Fty5BQ;E3Fuy5BR,qB2Fty5BuC;A3Fuy5BzC;;AAEA;EACE,yB2Fly5BoB;E3Fmy5BpB,qB2Fly5BmB;A3Fmy5BrB;;AAEA;;EAEE,mB2Fhy5BoB;A3Fiy5BtB;;AAEA;EACE,yB2Fzz5BuC;A3F0z5BzC;;AAEA;EACE,yB2Fxz5BuC;A3Fyz5BzC;;AAEA;EACE,yB2Fj05BuC;A3Fk05BzC;;AAEA;;EAEE,yB2Fh05ByB;A3Fi05B3B;;AAEA;EACE,yB2Fz05B0B;A3F005B5B;;AAEA;EACE,yD2Fx05BqC;A3Fy05BvC;;AAEA;EACE,yB2Fj15B0B;A3Fk15B5B;;AAEA;EACE,c2Fh15BU;A3Fi15BZ;;AAEA;EACE,yB2Fz15B0B;A3F015B5B;;AAEA;EACE,qB2Fx15ByB;A3Fy15B3B;;AAEA;EACE,oC2Fj25BsC;A3Fk25BxC;;AAEA;EACE,mB2Fh25ByB;A3Fi25B3B;;AAEA;EACE,yB2Fz25B0B;E3F025B1B,yB2Fz25ByB;A3F025B3B;;AAEA;EACE,yB2Fx25B0B;A3Fy25B5B;;AAEA;EACE,4B2Fj35ByB;A3Fk35B3B;;AAEA;EACE,c2Fh35BU;A3Fi35BZ;;AAEA;EACE,c2Fz35BU;A3F035BZ;;AAEA;EACE,mB2Fx35B0B;E3Fy35B1B,qB2Fj45BQ;E3Fk45BR,cAAc;AAChB;;AAEA;EACE,mB2Fh45BuC;A3Fi45BzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mB2Fx45BuC;A3Fy45BzC;;AAEA;;;EAGE,a2Fj55BU;A3Fk55BZ;;AAEA;EACE,mB2Fh55B0B;A3Fi55B5B;;AAEA;;EAEE,yB2F345BoB;A3F445BtB;;AAEA;EACE,mB2F145BmB;A3F245BrB;;AAEA;;;EAGE,c2Fl65BQ;A3Fm65BV;;AAEA;EACE,mB2F365BQ;A3F465BV;;AAEA;EACE,oC2F165BQ;A3F265BV;;AAEA;EACE,c2Fn75BQ;A3Fo75BV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,c2F175BU;A3F275BZ;;AAEA;;EAEE;;;;I2Fv85BQ,uBAAA;E3F485BR;AACF;;AAEA;EACE,yB2F185BuC;A3F285BzC;;AAEA;EACE,mB2Fn95BuC;A3Fo95BzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mB2F195BuC;E3F295BvC,qB2F195ByB;A3F295B3B;;AAEA;EACE,mB2Fn+5B0B;E3Fo+5B1B,qB2Fn+5ByB;A3Fo+5B3B;;AAEA;EACE,qB2Fl+5B0B;A3Fm+5B5B;;AAEA;EACE,mB2F3+5ByB;A3F4+5B3B;;AAEA;EACE,mB2F1+5B0B;A3F2+5B5B;;AAEA;EACE,qB2Fn/5ByB;A3Fo/5B3B;;AAEA;EACE,c2Fl/5BU;A3Fm/5BZ;;AAEA;EACE,c2F3/5BU;A3F4/5BZ;;AAEA;EACE,mB2F1/5B0B;E3F2/5B1B,qB2Ft/5BqB;A3Fu/5BvB;;AAEA;EACE,c2Fr/5BM;A3Fs/5BR;;AAEA;EACE,mB2Fp/5BmB;A3Fq/5BrB;;AAEA;EACE,yB2F7g6B0B;A3F8g6B5B;;AAEA;EACE,0C2F5g6BqC;A3F6g6BvC;;AAEA;EACE,yB2Frh6B0B;A3Fsh6B5B;;AAEA;;EAEE,W2Fph6BU;E3Fqh6BV,yB2F7h6BQ;A3F8h6BV;;AAEA;EACE,mB2F5h6BQ;A3F6h6BV;;AAEA;EACE,yB2Fri6BQ;E3Fsi6BR,qB2Fri6BuC;A3Fsi6BzC;;AAEA;EACE,oC2Fpi6BuC;A3Fqi6BzC;;AAEA;EACE,yB2F7i6BuC;A3F8i6BzC;;AAEA;EACE,yB2F5i6BuC;E3F6i6BvC,qB2F5i6ByB;A3F6i6B3B;;AAEA;EACE,c2Frj6BU;E3Fsj6BV,qB2Frj6ByB;A3Fsj6B3B;;AAEA;EACE,yB2Fpj6B0B;E3Fqj6B1B,qB2F7j6BQ;A3F8j6BV;;AAEA;;;;;;EAME,yB2Frk6BuC;E3Fsk6BvC,qB2Frk6B0B;A3Fsk6B5B;;AAEA;;;EAGE,c2F7k6BQ;A3F8k6BV;;AAEA;EACE,mB2F5k6BQ;A3F6k6BV;;AAEA;EACE,kC2Frl6BQ;A3Fsl6BV;;AAEA;EACE,c2Fpl6BQ;A3Fql6BV;;AAEA;EACE,yB2F7l6BQ;A3F8l6BV;;AAEA;EACE,8C2F5l6BQ;A3F6l6BV;;AAEA;EACE,c2Frm6BQ;A3Fsm6BV;;AAEA;EACE,mB2Fpm6BQ;A3Fqm6BV;;AAEA;EACE,yB2Fhm6BqB;A3Fim6BvB;;AAEA;;EAEE,kC2F/l6B+B;E3Fgm6B/B,c2F9l6BI;A3F+l6BN;;AAEA;EACE,S2Fxl6B6B;EACzB,mBAAqB;A3Fyl6B3B;;AAEA;;EAEE,mB2F7l6BI;A3F8l6BN;;AAEA;EACE,mB2Flm6ByC;A3Fmm6B3C;;AAEA;EACE,yB2Ftm6B2B;A3Fum6B7B;;AAEA;E4Fxw6BI,qBAAA;E5F0w6BF,c2F3m6BI;A3F4m6BN;;AAEA;E4F7w6BI,yBAAyB;A5F+w6B7B;;AAEA;EACE,yB2Fln6BuC;A3Fmn6BzC;;AAEA;E6Fzz6BY,yBAAiC;EAQnC,qBAA+B;A7Foz6BzC;;A6F9z6BU;EACE,yBAAoB;A7Fi06BhC;;AAEA;E6Fxz6BY,cAAgB;AAZlB;;A7Fw06BV;E6F9z6BU,yBAA+B;A7Fg06BzC;;A6F106BU;EACE,mBAAoB;A7F606BhC;;AAEA;E6Fp06BY,cAAgB;EAZlB,qBAA+B;A7Fm16BzC;;A6Fz06BU;EACE,cAAe;A7F406B3B;;AAEA;E6Fv16BY,yBAAe;AAQjB;;A7Fm16BV;E6F716BU,cAA+B;A7F+16BzC;;A6Fr16BU;EACE,cAAe;EACf,wCAAkC;AAZpC;;A7Fs26BV;;E6F316BY,yBAAmB;A7F816B/B;;AAEA;E6Fz26BY,yBAAe;AAQjB;;A7Fq26BV;E6F/26BU,yBAA+B;A7Fi36BzC;;A6Fv26BU;EACE,yBAAmB;A7F026B/B;;AAEA;E6Fr36BY,yBAAe;AAQjB;;A7Fi36BV;;E6F136BY,gCAAoB;A7F636BhC;;AAEA;E6Fp36BY,cAAc;AAKpB;;A7Fm36BN;E6F/26BM,yBAAkB;EAChB,kCAA4B;A7Fi36BpC;;AAEA;E6F926BQ,yBAAyB;EAE3B,kCAAkB;A7F+26BxB;;A4Ft26BI;ECtCM,yBAA+B;A7Fg56BzC;;AAEA;EACE,mB6Fx46B6B;A7Fy46B/B;;AAEA;EACE,mB6Fr56ByB;A7Fs56B3B;;AAEA;E6F156BU,yBAA+B;A7F456BzC;;AAEA;EACE,qB6Fp56B6B;E7Fq56B7B,yB6Fp56B0B;A7Fq56B5B;;AAEA;E6Fz56BU,qBAA+B;A7F256BzC;;AAEA;EACE,qB6Fv66B8B;A7Fw66BhC;;AAEA;EACE,mB6Fh66B0B;A7Fi66B5B;;AAEA;E6Fr66BU,mBAA+B;A7Fu66BzC;;AAEA;EACE,mB6Fn76B0B;A7Fo76B5B;;AAEA;EACE,yB6F566B0B;A7F666B5B;;AAEA;E6Fj76BU,yBAA+B;A7Fm76BzC;;AAEA;;EAEE,yB6F/76ByB;A7Fg86B3B;;AAEA;E6Fp86BU,qBAA+B;A7Fs86BzC;;AAEA;EACE,qB6F976B6B;A7F+76B/B;;AAEA;EACE,yB6F386ByB;A7F486B3B;;AAEA;E6Fh96BU,yBAA+B;A7Fk96BzC;;AAEA;EACE,yB6F186B6B;A7F286B/B;;AAEA;EACE,yB6Ft86BmB;A7Fu86BrB;;AAEA;E6Fn86BM,yBAAkB;A7Fq86BxB;;AAEA;EACE,yB6Fn86BoB;A7Fo86BtB;;AAEA;EACE,mB6Fp+6B0B;E7Fq+6B1B,qB6Fp+6ByB;EAQjB,cAA+B;A7F896BzC;;AAEA;EACE,8B6F1+6B8B;A7F2+6BhC;;AAEA;EACE,yC6Fn+6B4C;A7Fo+6B9C;;AAEA;E6Fx+6BU,mBAA+B;E7F0+6BvC,qB6Fz+6B6B;A7F0+6B/B;;AAEA;EACE,c6Ft/6BuB;EAQf,qBAA+B;A7Fg/6BzC;;AAEA;EACE,yB6F5/6B8B;E7F6/6B9B,c6F5/6BuB;A7F6/6BzB;;AAEA;E6Fjg7BU,yBAA+B;A7Fmg7BzC;;AAEA;EACE,c6F3/6BuB;A7F4/6BzB;;AAEA;EACE,iB6Fxg7ByB;A7Fyg7B3B;;AAEA;E6F7g7BU,iBAA+B;E7F+g7BvC,c6F9g7BU;A7F+g7BZ;;AAEA;;E6Flh7BU,iBAA+B;A7Fqh7BzC;;AAEA;EACE,mB6F7g7ByB;A7F8g7B3B;;AAEA;EACE,4B6F1h7ByB;A7F2h7B3B;;AAEA;E6F/h7BU,cAA+B;A7Fii7BzC;;AAEA;EACE,mB6Fzh7ByB;A7F0h7B3B;;AAEA;;;EAGE,mB6F/h7ByB;A7Fgi7B3B;;AAEA;EACE,mB6F3h7BmB;A7F4h7BrB;;AAEA;E6Fxh7BM,mBAAkB;E7F0h7BtB,qB6Fzh7BoB;A7F0h7BtB;;AAEA;EACE,yB6Fxh7BmB;EDOjB,qBAAA;A5Fmh7BJ;;AAEA;;EAEE,mB6Flj7B6B;A7Fmj7B/B;;AAEA;EACE,yB6F/j7ByB;A7Fgk7B3B;;AAEA;E6Fpk7BU,yBAA+B;A7Fsk7BzC;;AAEA;EACE,yB6F9j7B6B;A7F+j7B/B;;AAEA;;E6Flk7BU,yBAA+B;A7Fqk7BzC;;AAEA;EACE,yB6Fjl7B8B;A7Fkl7BhC;;AAEA;EACE,yD6F1k7B4C;A7F2k7B9C;;AAEA;E6F/k7BU,yBAA+B;A7Fil7BzC;;AAEA;EACE,c6F7l7BU;A7F8l7BZ;;AAEA;EACE,yB6Ftl7B0B;A7Ful7B5B;;AAEA;E6F3l7BU,qBAA+B;A7F6l7BzC;;AAEA;EACE,oC6Fzm7B8B;A7F0m7BhC;;AAEA;EACE,mB6Flm7B0B;A7Fmm7B5B;;AAEA;E6Fvm7BU,yBAA+B;E7Fym7BvC,yB6Fxm7B6B;A7Fym7B/B;;AAEA;EACE,yB6Frn7ByB;A7Fsn7B3B;;AAEA;E6F1n7BU,4BAA+B;A7F4n7BzC;;AAEA;EACE,c6Fpn7BuB;A7Fqn7BzB;;AAEA;EACE,c6Fhn7BiB;A7Fin7BnB;;AAEA;E6F7m7BM,mBAAkB;E7F+m7BtB,qB6F9m7BoB;E7F+m7BpB,c6F9m7BiB;A7F+m7BnB;;AAEA;E4Ftm7BI,mBAAA;A5Fwm7BJ;;AAEA;E6Fto7BU,cAA+B;A7Fwo7BzC;;AAEA;EACE,mB6Fpp7B0B;A7Fqp7B5B;;AAEA;;;EAGE,a6F1p7BU;A7F2p7BZ;;AAEA;EACE,mB6Fnp7B0B;A7Fop7B5B;;AAEA;;EAEE,yB6Fzp7B6B;A7F0p7B/B;;AAEA;EACE,mB6Ftq7ByB;A7Fuq7B3B;;AAEA;;;EAGE,c6F5q7BuB;A7F6q7BzB;;AAEA;E6Fjr7BU,mBAA+B;A7Fmr7BzC;;AAEA;EACE,oC6F3q7B6B;A7F4q7B/B;;AAEA;EACE,c6Fxr7BuB;A7Fyr7BzB;;AAEA;;EAEE,c6F9r7BU;A7F+r7BZ;;AAEA;EACE,c6Fvr7BU;A7Fwr7BZ;;AAEA;;;EAGE,c6F7r7BU;A7F8r7BZ;;AAEA;;EAEE;;;;I6F5s7BU,yBAAe;EAQjB;A7F0s7BV;;AAEA;EACE,yB6Frs7BoB;A7Fss7BtB;;AAEA;EACE,mB6Fps7BmB;A7Fqs7BrB;;AAEA;E6Fjs7BM,cAAA;A7Fms7BN;;A4F1r7BI;ECtCM,cAA+B;A7Fou7BzC;;AAEA;EACE,mB6F5t7B6B;E7F6t7B7B,qB6F5t7B0B;A7F6t7B5B;;AAEA;E6Fju7BU,mBAA+B;E7Fmu7BvC,qB6Flu7B6B;A7Fmu7B/B;;AAEA;EACE,qB6F/u7ByB;A7Fgv7B3B;;AAEA;E6Fpv7BU,mBAA+B;A7Fsv7BzC;;AAEA;EACE,mB6F9u7B6B;A7F+u7B/B;;AAEA;EACE,qB6F3v7ByB;A7F4v7B3B;;AAEA;E6Fhw7BU,cAA+B;A7Fkw7BzC;;AAEA;EACE,c6F1v7BuB;A7F2v7BzB;;AAEA;EACE,mB6Fvw7ByB;EAQjB,qBAA+B;A7Fiw7BzC;;AAEA;EACE,c6F7w7BU;A7F8w7BZ;;AAEA;EACE,mB6Ftw7B0B;A7Fuw7B5B;;AAEA;E6F3w7BU,yBAA+B;A7F6w7BzC;;AAEA;EACE,wC6Fzx7B8B;A7F0x7BhC;;AAEA;EACE,yB6Flx7B0B;A7Fmx7B5B;;AAEA;;EAEE,W6Fxx7BU;E7Fyx7BV,yB6Fxx7B0B;A7Fyx7B5B;;AAEA;E6F7x7BU,mBAA+B;A7F+x7BzC;;AAEA;EACE,yB6F1x7BoB;E7F2x7BpB,qB6F1x7BmB;A7F2x7BrB;;AAEA;E6Fvx7BM,oCAAkB;A7Fyx7BxB;;AAEA;EACE,yB6Fvx7BoB;A7Fwx7BtB;;AAEA;E6F9w7BM,yBAAsB;EC7D1B,qBAAO;AD8DH;;ADLF;ECGE,cAAA;E7Fsx7BJ,qB8F/07BO;A9Fg17BT;;AAEA;EACE,yB8Fh17BsB;EFmDpB,qBAAA;A5F+x7BJ;;AAEA;;;;;;EAME,yB8F717BuB;ED0DnB,qBAAsB;A7Fqy7B5B;;AAEA;;;EAGE,c8Fp27BO;A9Fq27BT;;AAEA;EACE,mB8Fr27BO;AFmDL;;A5Fqz7BJ;E6Fjz7BM,iCAAsB;A7Fmz7B5B;;AAEA;EACE,cAAc;A6Fxy7BN;;AAKJ;EACI,yBAAY;AAGhB;;AAIA;EACI,6CAAyC;A7Fmy7BnD;;AAEA;E6F9x7BU,cAAa;AAGjB;;AAIA;EACH,mBAAO;A7F4x7BV;;AAEA;EACE,yB6F5x7BY;AAGX;;A7F4x7BH;;E+Fv47BQ,kCAAA;EACI,cAAU;A/F047BtB;;AAEA;E+Fp47BY,SAAQ;EAIhB,mBAAA;A/Fm47BJ;;AAEA;;EAEE,mB+Fl47Be;A/Fm47BjB;;AAEA;EACE,mB+Fh47BU;A/Fi47BZ;;AAEA;EACE,yB+F937BmB;A/F+37BrB;;AAEA;EACE,qB+F737BW;E/F837BX,c+F737BG;A/F837BL;;AAEA;E+Fr37BI,yBAAA;A/Fu37BJ;;AAEA;EACE,yB+F137BE;A/F237BJ;;AAEA;EACE,yB+Fr37ByB;EAOX,qBAAA;A/Fg37BhB;;A+Fh27BC;EACC,yBAAmB;A/Fm27BrB;;AAEA;EACE,cAAc;AgGx77BZ;;AhG277BJ;E4Ft37BI,yBAAA;A5Fw37BJ;;AAEA;EgGt77BQ,mBAAA;AhGw77BR;;AAEA;EACE,cgG377BM;EhG477BN,qBgGv77B6B;AhGw77B/B;;AAEA;EACE,cgGr77BE;AhGs77BJ;;AAEA;EACE,yBgGj77B0B;AhGk77B5B;;AAEA;EgG167BO,cAAO;AhG467Bd;;AAEA;EACE,cgG767BU;EAGT,uCAAA;AhG467BH;;AAEA;;EG587BE,yBAAA;AH+87BF;;AgGn67BQ;EACI,yBAAU;AhGs67BtB;;AAEA;EACE,yBgGp67BwB;AAKxB;;AAKM;EACI,yBAAoB;AhG857BhC;;AAEA;EgGx57BY,yBAAuB;AAGhC;;AhGy57BH;;EgGj57BY,gCAAoB;AhGo57BhC;;AAEA;EgGh57BI,cAAa;AhGk57BjB;;AAEA;EiGr/7BI,yBAAQ;EjGu/7BV,iCiGt/7BuB;AjGu/7BzB;;AAEA;EACE,yBiGp/7BY;EjGq/7BZ,iCiGp/7Ba;AjGq/7Bf;;AAEA;EACE,yBiGh/7BE;AjGi/7BJ;;AAEA;EACE,mBiGh/7Bc;AjGi/7BhB;;AAEA;EACE,mBiG/+7BgB;AjGg/7BlB;;AAEA;EACE,yBiGn+7BiC;AjGo+7BnC;;AAEA;EACE,qBiGj+7BY;EjGk+7BZ,yBiGj+7BuB;AjGk+7BzB;;AAEA;EACE,qBiGl97ByC;AjGm97B3C;;AAEA;EkGvh8BE,qBAAA;AlGyh8BF;;AkGrh8BE;EACC,mBAAe;AlGwh8BlB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EkGph8BQ,mBAAA;AlGsh8BR;;AAEA;EACE,yBkGrh8BwB;AlGsh8B1B;;AkG9g8BY;EACI,yBAAe;AAE5B;;AlGih8BH;;EkGzg8BgB,yBAAqB;AAKzB;;AAMA;EACI,qBAAe;AAG7B;;AlGmg8BF;EkG//7BE,qBAAA;AlGig8BF;;AAEA;EkG5/7BA,yBAAA;AlG8/7BA;;AmGjk8BI;EACI,yBAAgB;AnGok8BxB;;AAEA;EACE,yBmGlk8BiB;AnGmk8BnB;;AAEA;EACE,yBmGhk8BqB;AnGik8BvB;;AmG5j8BC;EACC,yBAAgB;AnG+j8BlB;;AAEA;EoGjl8BY,yBAAe;ApGml8B3B;;AAEA;EoG7k8BY,mBAAA;EACI,qBAAgB;EAKpB,cAAA;ApG2k8BZ;;AAEA;EoGjk8BY,8BAAA;ApGmk8BZ;;AAEA;EACE,uCAAuC;AChg8BzC;;ADmg8BA;E8Hnm8BI,mBpCcW;EoCXX,qBAAA;A9Hmm8BJ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;E8H/l8BI,yBAAA;E9Him8BF,cAAc;AAChB;;AAEA;E8Hll8BY,yBAAA;A9Hol8BZ;;AAEA;E8Htl8BY,cAAA;A9Hwl8BZ;;AAEA;E8H9l8BY,iBAAA;A9Hgm8BZ;;A+Hho8BI;EACI,iBAAgB;EACtB,cAAY;A/Hmo8Bd;;AAEA;;E+Htn8BQ,iBAAgB;A/Hyn8BxB;;A+Hpn8BI;EACI,mBrCFI;A1Fyn8BZ;;AAEA;E+Hpn8BE,4BrCRY;AqCUb;;A/Hsn8BD;E+Hnn8BE,crCdS;AqCiBT;;AAIE;EACF,mBrCtBS;A1Fuo8BX;;AAEA;;;E+H1m8BC,mBAAA;A/H8m8BD;;A+H1m8BC;EACI,mBAAgB;A/H6m8BrB;;AAEA;EACE,mB0Fpk8BsB;EqCpCvB,qBAAA;A/H0m8BD;;AAEA;E+Htm8BC,yBAAA;E/Hwm8BC,qBAAqB;AACvB;;AAEA;;E+Hnm8BK,mBrC1Da;A1Fgq8BlB;;A+Hlm8BC;EACC,yBrC9DY;A1Fmq8Bd;;AAEA;E+Hlm8BE,yBrCpEgB;AqCsEjB;;A/Hom8BD;E+Hjm8BE,yBrCxEY;AqC0Eb;;AAGA;;EAGA,yBAAA;A/Hgm8BD;;AAEA;E+H1l8BC,yBAAA;A/H4l8BD;;AAEA;E+Hzl8BE,yDAAc;A/H2l8BhB;;AAEA;E+Hvl8BE,yBrCpGgB;AqCsGjB;;A/Hyl8BD;E+Hrl8BC,cAAA;A/Hul8BD;;AAEA;E+Hpl8BE,yBAAA;A/Hsl8BF;;AAEA;E+Hjl8BC,qBAAA;A/Hml8BD;;AAEA;E+H/k8BC,oCAAA;A/Hil8BD;;AAEA;EACE,mBAAmB;AACrB;;A+H5k8BC;EACC,yBrCtDsB;EqCuDtB,yBrCrDwB;A1Foo8B1B;;AAEA;EACE,yB0Fzo8BsB;AqCgEvB;;A/H4k8BD;EgI/u8BI,4BAAA;AhIiv8BJ;;AAEA;EgI5u8BY,cAAc;AhI8u8B1B;;AAEA;EACE,cgI5u8B0B;AhI6u8B5B;;AgItu8BE;EACI,mBAAY;EAEf,qBAAA;EhIwu8BD,c0F3p8BsB;AsCtEtB;;AhIou8BF;EgIhu8BE,mBAAA;AhIku8BF;;AAEA;EgI7t8BY,cAAA;AhI+t8BZ;;AAEA;EgIrt8BgB,mBAAA;AhIut8BhB;;AiI5w8BI;;;EAKA,aAAA;AjI6w8BJ;;AAEA;EiIxw8BQ,mBAAA;AjI0w8BR;;AiItx8BI;;EAEI,yBvCmBM;AuChBV;;AAIA;EACI,mBvC0FgB;A1F2r8BxB;;AAEA;;;EkI1x8BC,cAAA;AlI8x8BD;;AAEA;EACE,mB0Fps8BsB;A1Fqs8BxB;;AAEA;EkIxx8BI,oCAAQ;AlI0x8BZ;;AAEA;EkI5w8BoB,cAAA;AlI8w8BpB;;AAEA;;EAEE,ckIpw8B0B;AlIqw8B5B;;AAEA;EACE,c0Frt8BsB;A1Fst8BxB;;AAEA;;;EAGE,ckI7u8B8B;AlI8u8BhC;;AAEA;;EAEE;;;;IAIE,yBAAyB;EoIx08BzB;ApI008BJ;;AAEA;EACE,yBoIv08BU;ApIw08BZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE;;;;IAIE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE;;;;IAIE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,gDAAgD;EAChD,WAAW;AACb;;AAEA;;;EAGE,sDAAsD;AACxD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qEAAqE;AACvE;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;;eAEe;AACf;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;;;;;EAUE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,+BAA+B;EACjC;AACF;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oDAA4C;EAC5C,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EAGnB,aAAa;EAGb,yBAAyB;AAC3B;;AAEA;EAGE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAEhB,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,WAAW;EAEX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAEhB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,QAAQ;EAER,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EAIV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,cAAc;AAChB;;AAEA;;;;EAIE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EAErB,8CAA8C;AAChD;;AAQA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EAEE,4CAA4C;AAC9C;;AAcA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EAEf,4BAA4B;AAC9B;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,QAAQ;EACR,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,WAAW;EAGX,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EAGX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;EAGE,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,oDAAoD;EACpD,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;;;;;;;;;CASC;AACD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+XE;AACF;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;EAC9B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,4CAA4C;EAC5C,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,0CAA0C;AAC5C;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,OAAO;EACP,MAAM;EACN,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;;;;EAIE,uCAAuC;AACzC;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EAGV,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;EAME,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;;EAME,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,mDAAmD;EACnD,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kDAAkD;EAClD,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,mDAAmD;EACnD,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kDAAkD;EAClD,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EAGtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,sGAAsG;EACtG,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,sGAAsG;EACtG,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB;;;;;;;OAOK;AACP;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,2DAA2D;AAC7D;;AAEA;EAEE,2DAA2D;AAC7D;;AAEA;EAEE,2DAA2D;AAC7D;;AAEA;EAEE,2DAA2D;AAC7D;;AAEA;EAEE,0DAA0D;AAC5D;;AAEA;EAEE,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE;;IAEE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE;;IAEE,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,mCAAmC;EACnC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,yCAAyC;EACzC,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EAGZ,aAAa;EAGb,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EAEE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAcA;EACE;IAEE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,iGAAiG;EACjG,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,+CAA+C;EAC/C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;;;;EAIE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,MAAM;EACN,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EAGd,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;;EAGE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;;EAGE,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sDAAsD;EACtD,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,QAAQ;EACR,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,yDAAyD;EACzD,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EAEzB,+EAA+E;EAC/E,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;;EAGE,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EAIX,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;;AAE9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oDAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EAEb,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAElB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EAEnB,iCAAiC;AACnC;;AAEA;;EAGE,sBAAsB;EAEtB,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yCAAyC;EACzC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;EAClC;;EAEA;IACE,UAAU;IACV,cAAc;IACd,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EAGjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAGhC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EAGd,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,OAAO;EACP,MAAM;EACN,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;EACP,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAG7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;;;;KAKG;EACH;;;;;KAKG;AACL;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;EAME,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE;;IAEE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0DAA2C;EAC3C,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0DAA6C;EAC7C,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;;AAIA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB;oCACkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oDAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;oCAGoC;AACpC;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;EAGE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EAGX,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,6CAA6C;EAC7C,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;;;oCAGoC;AACpC;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,uFAA+M;EAC/M,yBAAyB;AAC3B;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gCAAgC;AAClC;;AAEA;;;;EAIE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;AACF;;AAEA;;EAEE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE;;IAEE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;;IAEE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;;IAEE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;;IAEE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;;IAEE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;;IAEE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;;IAEE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;;;;;EAKE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4EAA4E;EAC5E,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,6BAA6B;;AAE7B;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,0DAAkD;EAClD;;2BAEyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0DAAyD;EAC3D;;EAEA;;KAEG;AACL;;AAEA,wCAAwC;AACxC;;EAEE,wCAAwC;AAC1C;;AAEA;EACE;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;EACb;AACF;AACA;EACE,kCAAkC;IAChC,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;AACtB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":["/*\n    Table of Contents\n\n    Name                 : Qerza\n    Author               : DexignZone\n    Author Portfolio     : https://themeforest.net/user/dexignzone/portfolio\n    \n\n\n    Table of Sass Contents\n\n    1. Abstracts\n        _bs-custom\n        _inheritance\n        _maps\n        _mixin\n        _variable\n\n    2. bootstrap \n        -Here goes all official bootstrap scss files\n\n    3. Global/Base\n        _color\n        _custom-grid\n        _fonts\n        _helper\n        _reset\n\n    4. layout\n        +footer\n        +header\n        +rtl\n        +sidebar\n        +tables\n        +theme\n        +version-dark\n\n    5. Conponents\n        +app\n        +charts\n        +forms\n        +map\n        +uc\n        +ui\n        +widget\n\n    6. Page\n        _index-1\n        _page-error\n        _page-register\n        _page-signin\n        _page-user-lock\n        _page-user-lock\n\n*/\n\n\n\n\n\n\n\n\n////////////////////\n// Abstracts\n////////////////////\n@import \"./abstracts/abstracts\";\n\n//bootstrap library scss files\n@import \"./../vendor/bootstrap/scss/bootstrap\";\n\n\n\n////////////////////\n// Global\n////////////////////\n@import \"./base/base\";\n\n@import \"./preloader\";\n\n\n////////////////////\n// Components\n////////////////////\n@import \"./layout/layout\";\n\n\n////////////////////\n// Components\n////////////////////\n@import \"./components/components\";\n\n\n////////////////////\n// All pages\n////////////////////\n@import \"./pages/pages\";\n\n\n\n////////////////////\n// RTL\n////////////////////\n@import \"./layout/rtl/rtl\";\n\n\n////////////////////\n// Version Color\n////////////////////\n@import \"./layout/version-dark/main\";","/*\n    Table of Contents\n\n    Name                 : Qerza\n    Author               : DexignZone\n    Author Portfolio     : https://themeforest.net/user/dexignzone/portfolio\n    \n\n\n    Table of Sass Contents\n\n    1. Abstracts\n        _bs-custom\n        _inheritance\n        _maps\n        _mixin\n        _variable\n\n    2. bootstrap \n        -Here goes all official bootstrap scss files\n\n    3. Global/Base\n        _color\n        _custom-grid\n        _fonts\n        _helper\n        _reset\n\n    4. layout\n        +footer\n        +header\n        +rtl\n        +sidebar\n        +tables\n        +theme\n        +version-dark\n\n    5. Conponents\n        +app\n        +charts\n        +forms\n        +map\n        +uc\n        +ui\n        +widget\n\n    6. Page\n        _index-1\n        _page-error\n        _page-register\n        _page-signin\n        _page-user-lock\n        _page-user-lock\n\n*/\n/*$primary  : #7356f1 !default;*/\n@import url(\"./../icons/simple-line-icons/css/simple-line-icons.css\");\n@import url(\"./../icons/font-awesome-old/css/font-awesome.min.css\");\n@import url(\"./../icons/material-design-iconic-font/css/materialdesignicons.min.css\");\n@import url(\"./../icons/themify-icons/css/themify-icons.css\");\n@import url(\"./../icons/line-awesome/css/line-awesome.min.css\");\n@import url(\"./../icons/avasta/css/style.css\");\n@import url(\"./../icons/flaticon/flaticon.css\");\n@import url(./../vendor/animate/animate.min.css);\n@import url(./../vendor/aos/css/aos.min.css);\n@import url(./../vendor/perfect-scrollbar/css/perfect-scrollbar.css);\n@import url(./../vendor/metismenu/css/metisMenu.min.css);\n\n.gradient_one {\n  background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);\n}\n\n.gradient-1 {\n  background: #f0a907;\n  background: -moz-linear-gradient(top, #f0a907 0%, #f53c79 100%);\n  background: -webkit-linear-gradient(top, #f0a907 0%, #f53c79 100%);\n  background: linear-gradient(to bottom, #f0a907 0%, #f53c79 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f0a907', endColorstr='#f53c79', GradientType=0);\n}\n\n.gradient-2 {\n  background: #4dedf5;\n  background: -moz-linear-gradient(top, #4dedf5 0%, #480ceb 100%);\n  background: -webkit-linear-gradient(top, #4dedf5 0%, #480ceb 100%);\n  background: linear-gradient(to bottom, #4dedf5 0%, #480ceb 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#4dedf5', endColorstr='#480ceb', GradientType=0);\n}\n\n.gradient-3 {\n  background: #51f5ae;\n  background: -moz-linear-gradient(top, #51f5ae 0%, #3fbcda 100%);\n  background: -webkit-linear-gradient(top, #51f5ae 0%, #3fbcda 100%);\n  background: linear-gradient(to bottom, #51f5ae 0%, #3fbcda 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#51f5ae', endColorstr='#3fbcda', GradientType=0);\n}\n\n.gradient-4 {\n  background: #f25521;\n  background: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n  background: -webkit-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n  background: linear-gradient(to right, #f25521 0%, #f9c70a 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f25521', endColorstr='#f9c70a', GradientType=1);\n}\n\n.gradient-5 {\n  background: #f53c79;\n  background: -moz-linear-gradient(left, #f53c79 0%, #f0a907 100%);\n  background: -webkit-linear-gradient(left, #f53c79 0%, #f0a907 100%);\n  background: linear-gradient(to right, #f53c79 0%, #f0a907 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f53c79', endColorstr='#f0a907', GradientType=1);\n}\n\n.gradient-6 {\n  background: #36b9d8;\n  background: -moz-linear-gradient(left, #36b9d8 0%, #4bffa2 100%);\n  background: -webkit-linear-gradient(left, #36b9d8 0%, #4bffa2 100%);\n  background: linear-gradient(to right, #36b9d8 0%, #4bffa2 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#36b9d8', endColorstr='#4bffa2', GradientType=1);\n}\n\n.gradient-7 {\n  background: #4400eb;\n  background: -moz-linear-gradient(left, #4400eb 0%, #44e7f5 100%);\n  background: -webkit-linear-gradient(left, #4400eb 0%, #44e7f5 100%);\n  background: linear-gradient(to right, #4400eb 0%, #44e7f5 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#4400eb', endColorstr='#44e7f5', GradientType=1);\n}\n\n.gradient-8 {\n  background: #F7B00F;\n  background: -moz-linear-gradient(top, #F7B00F 0%, #F25521 100%);\n  background: -webkit-linear-gradient(top, #F7B00F 0%, #F25521 100%);\n  background: linear-gradient(to bottom, #F7B00F 0%, #F25521 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F7B00F', endColorstr='#F25521', GradientType=1);\n}\n\n.gradient-9,\n.datepicker.datepicker-dropdown td.day:hover,\n.datepicker.datepicker-dropdown th.next:hover,\n.datepicker.datepicker-dropdown th.prev:hover,\n.datepicker table tr td.selected,\n.datepicker table tr td.active,\n.datepicker table tr td.today,\n.datepicker table tr td.today:hover,\n.datepicker table tr td.today.disabled,\n.datepicker table tr td.today.disabled:hover {\n  background: #f31e7a !important;\n  background: -moz-linear-gradient(left, #f31e7a 0%, #fd712c 100%);\n  background: -webkit-linear-gradient(left, #f31e7a 0%, #fd712c 100%);\n  background: linear-gradient(to right, #f31e7a 0%, #fd712c 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f31e7a', endColorstr='#fd712c', GradientType=1);\n}\n\n.gradient-10 {\n  background: #f25521 !important;\n  background: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n  background: -webkit-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n  background: linear-gradient(to top, #f25521 0%, #f9c70a 100%) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f25521', endColorstr='#f9c70a', GradientType=1);\n}\n\n.gradient-11 {\n  background: #3398fb;\n  background: -moz-linear-gradient(left, #3398fb 0%, #8553ee 100%);\n  background: -webkit-linear-gradient(left, #3398fb 0%, #8553ee 100%);\n  background: linear-gradient(to right, #3398fb 0%, #8553ee 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3398fb', endColorstr='#8553ee', GradientType=1);\n}\n\n.gradient-12 {\n  background: #36e1b4;\n  background: -moz-linear-gradient(left, #36e1b4 0%, #11cae7 100%);\n  background: -webkit-linear-gradient(left, #36e1b4 0%, #11cae7 100%);\n  background: linear-gradient(to right, #36e1b4 0%, #11cae7 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#36e1b4', endColorstr='#11cae7', GradientType=1);\n}\n\n.gradient-13 {\n  background: #ffbf31;\n  background: -moz-linear-gradient(left, #ffbf31 0%, #ff890e 100%);\n  background: -webkit-linear-gradient(left, #ffbf31 0%, #ff890e 100%);\n  background: linear-gradient(to right, #ffbf31 0%, #ff890e 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffbf31', endColorstr='#ff890e', GradientType=1);\n}\n\n.gradient-14 {\n  background: #23bdb8;\n  background: -moz-linear-gradient(-45deg, #23bdb8 0%, #43e794 100%);\n  background: -webkit-linear-gradient(-45deg, #23bdb8 0%, #43e794 100%);\n  background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#23bdb8', endColorstr='#43e794', GradientType=1);\n}\n\n.gradient-15 {\n  background: #9a56ff;\n  background: -moz-linear-gradient(-45deg, #9a56ff 0%, #e36cd9 100%);\n  background: -webkit-linear-gradient(-45deg, #9a56ff 0%, #e36cd9 100%);\n  background: linear-gradient(135deg, #9a56ff 0%, #e36cd9 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#9a56ff', endColorstr='#e36cd9', GradientType=1);\n}\n\n.gradient-16 {\n  background: #f48665;\n  background: -moz-linear-gradient(-45deg, #f48665 0%, #fda23f 100%);\n  background: -webkit-linear-gradient(-45deg, #f48665 0%, #fda23f 100%);\n  background: linear-gradient(135deg, #f48665 0%, #fda23f 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f48665', endColorstr='#fda23f', GradientType=1);\n}\n\n.gradient-17 {\n  background: #e36cd9;\n  background: -moz-linear-gradient(-45deg, #e36cd9 0%, #fe60ae 100%);\n  background: -webkit-linear-gradient(-45deg, #e36cd9 0%, #fe60ae 100%);\n  background: linear-gradient(135deg, #e36cd9 0%, #fe60ae 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e36cd9', endColorstr='#fe60ae', GradientType=1);\n}\n\n.gradient-18 {\n  background: #a15cff;\n  background: -moz-linear-gradient(left, #a15cff 0%, #ce82fd 100%);\n  background: -webkit-linear-gradient(left, #a15cff 0%, #ce82fd 100%);\n  background: linear-gradient(to right, #a15cff 0%, #ce82fd 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#a15cff', endColorstr='#ce82fd', GradientType=1);\n}\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n/*!\n * Bootstrap v4.5.3 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root {\n  --blue: #5e72e4;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #EE3232;\n  --orange: #ff9900;\n  --yellow: #FFFA6F;\n  --green: #297F00;\n  --teal: #20c997;\n  --cyan: #3065D0;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --primary: #00ADEE;\n  --secondary: #3F9AE0;\n  --success: #2BC155;\n  --info: #2D28FF;\n  --warning: #FF9B52;\n  --danger: #F94687;\n  --light: #F4F5F9;\n  --dark: #B1B1B1;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --breakpoint-xxl: 1440;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #7e7e7e;\n  text-align: left;\n  background-color: #E5E6E7;\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -.25em;\n}\n\nsup {\n  top: -.5em;\n}\n\na {\n  color: #00ADEE;\n  text-decoration: none;\n  background-color: transparent;\n}\n\na:hover {\n  color: #611fb6;\n  text-decoration: underline;\n}\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #89879f;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: #3d4465;\n}\n\nh1,\n.h1 {\n  font-size: 2.25rem;\n}\n\nh2,\n.h2 {\n  font-size: 1.875rem;\n}\n\nh3,\n.h3 {\n  font-size: 1.5rem;\n}\n\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\n\nh5,\n.h5 {\n  font-size: 1rem;\n}\n\nh6,\n.h6 {\n  font-size: 0.938rem;\n}\n\n.lead {\n  font-size: 1.09375rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.09375rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d;\n}\n\n.blockquote-footer::before {\n  content: \"\\2014\\00A0\";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #E5E6E7;\n  border: 1px solid #dee2e6;\n  border-radius: 0.75rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #6c757d;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-wrap: break-word;\n}\n\na>code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem;\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 700;\n}\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529;\n}\n\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n\n  .container,\n  .container-sm {\n    max-width: 540px;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .container,\n  .container-sm,\n  .container-md {\n    max-width: 720px;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .container,\n  .container-sm,\n  .container-md,\n  .container-lg {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .container,\n  .container-sm,\n  .container-md,\n  .container-lg,\n  .container-xl {\n    max-width: 1140px;\n  }\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.no-gutters>.col,\n.no-gutters>[class*=\"col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-1,\n.col-2,\n.col-3,\n.col-4,\n.col-5,\n.col-6,\n.col-7,\n.col-8,\n.col-9,\n.col-10,\n.col-11,\n.col-12,\n.col,\n.col-auto,\n.col-sm-1,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm,\n.col-sm-auto,\n.col-md-1,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md,\n.col-md-auto,\n.col-lg-1,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg,\n.col-lg-auto,\n.col-xl-1,\n.col-xl-2,\n.col-xl-3,\n.col-xl-4,\n.col-xl-5,\n.col-xl-6,\n.col-xl-7,\n.col-xl-8,\n.col-xl-9,\n.col-xl-10,\n.col-xl-11,\n.col-xl-12,\n.col-xl,\n.col-xl-auto,\n.col-xxl-1,\n.col-xxl-2,\n.col-xxl-3,\n.col-xxl-4,\n.col-xxl-5,\n.col-xxl-6,\n.col-xxl-7,\n.col-xxl-8,\n.col-xxl-9,\n.col-xxl-10,\n.col-xxl-11,\n.col-xxl-12,\n.col-xxl,\n.col-xxl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.row-cols-1>* {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.row-cols-2>* {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.row-cols-3>* {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.row-cols-4>* {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.row-cols-5>* {\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n.row-cols-6>* {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  flex: 0 0 8.3333333333%;\n  max-width: 8.3333333333%;\n}\n\n.col-2 {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.col-5 {\n  flex: 0 0 41.6666666667%;\n  max-width: 41.6666666667%;\n}\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 58.3333333333%;\n  max-width: 58.3333333333%;\n}\n\n.col-8 {\n  flex: 0 0 66.6666666667%;\n  max-width: 66.6666666667%;\n}\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 83.3333333333%;\n  max-width: 83.3333333333%;\n}\n\n.col-11 {\n  flex: 0 0 91.6666666667%;\n  max-width: 91.6666666667%;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  order: -1;\n}\n\n.order-last {\n  order: 13;\n}\n\n.order-0 {\n  order: 0;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.3333333333%;\n}\n\n.offset-2 {\n  margin-left: 16.6666666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.3333333333%;\n}\n\n.offset-5 {\n  margin-left: 41.6666666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.3333333333%;\n}\n\n.offset-8 {\n  margin-left: 66.6666666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.3333333333%;\n}\n\n.offset-11 {\n  margin-left: 91.6666666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-sm-1>* {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-sm-2>* {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-sm-3>* {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-sm-4>* {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-sm-5>* {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-sm-6>* {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-sm-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-sm-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-sm-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-sm-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-sm-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-sm-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-sm-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-sm-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-sm-first {\n    order: -1;\n  }\n\n  .order-sm-last {\n    order: 13;\n  }\n\n  .order-sm-0 {\n    order: 0;\n  }\n\n  .order-sm-1 {\n    order: 1;\n  }\n\n  .order-sm-2 {\n    order: 2;\n  }\n\n  .order-sm-3 {\n    order: 3;\n  }\n\n  .order-sm-4 {\n    order: 4;\n  }\n\n  .order-sm-5 {\n    order: 5;\n  }\n\n  .order-sm-6 {\n    order: 6;\n  }\n\n  .order-sm-7 {\n    order: 7;\n  }\n\n  .order-sm-8 {\n    order: 8;\n  }\n\n  .order-sm-9 {\n    order: 9;\n  }\n\n  .order-sm-10 {\n    order: 10;\n  }\n\n  .order-sm-11 {\n    order: 11;\n  }\n\n  .order-sm-12 {\n    order: 12;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-md-1>* {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-md-2>* {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-md-3>* {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-md-4>* {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-md-5>* {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-md-6>* {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-md-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-md-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-md-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-md-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-md-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-md-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-md-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-md-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-md-first {\n    order: -1;\n  }\n\n  .order-md-last {\n    order: 13;\n  }\n\n  .order-md-0 {\n    order: 0;\n  }\n\n  .order-md-1 {\n    order: 1;\n  }\n\n  .order-md-2 {\n    order: 2;\n  }\n\n  .order-md-3 {\n    order: 3;\n  }\n\n  .order-md-4 {\n    order: 4;\n  }\n\n  .order-md-5 {\n    order: 5;\n  }\n\n  .order-md-6 {\n    order: 6;\n  }\n\n  .order-md-7 {\n    order: 7;\n  }\n\n  .order-md-8 {\n    order: 8;\n  }\n\n  .order-md-9 {\n    order: 9;\n  }\n\n  .order-md-10 {\n    order: 10;\n  }\n\n  .order-md-11 {\n    order: 11;\n  }\n\n  .order-md-12 {\n    order: 12;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-lg-1>* {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-lg-2>* {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-lg-3>* {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-lg-4>* {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-lg-5>* {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-lg-6>* {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-lg-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-lg-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-lg-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-lg-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-lg-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-lg-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-lg-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-lg-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-lg-first {\n    order: -1;\n  }\n\n  .order-lg-last {\n    order: 13;\n  }\n\n  .order-lg-0 {\n    order: 0;\n  }\n\n  .order-lg-1 {\n    order: 1;\n  }\n\n  .order-lg-2 {\n    order: 2;\n  }\n\n  .order-lg-3 {\n    order: 3;\n  }\n\n  .order-lg-4 {\n    order: 4;\n  }\n\n  .order-lg-5 {\n    order: 5;\n  }\n\n  .order-lg-6 {\n    order: 6;\n  }\n\n  .order-lg-7 {\n    order: 7;\n  }\n\n  .order-lg-8 {\n    order: 8;\n  }\n\n  .order-lg-9 {\n    order: 9;\n  }\n\n  .order-lg-10 {\n    order: 10;\n  }\n\n  .order-lg-11 {\n    order: 11;\n  }\n\n  .order-lg-12 {\n    order: 12;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-xl-1>* {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-xl-2>* {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-xl-3>* {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-xl-4>* {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-xl-5>* {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-xl-6>* {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-xl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-xl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-xl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-xl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-xl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xl-first {\n    order: -1;\n  }\n\n  .order-xl-last {\n    order: 13;\n  }\n\n  .order-xl-0 {\n    order: 0;\n  }\n\n  .order-xl-1 {\n    order: 1;\n  }\n\n  .order-xl-2 {\n    order: 2;\n  }\n\n  .order-xl-3 {\n    order: 3;\n  }\n\n  .order-xl-4 {\n    order: 4;\n  }\n\n  .order-xl-5 {\n    order: 5;\n  }\n\n  .order-xl-6 {\n    order: 6;\n  }\n\n  .order-xl-7 {\n    order: 7;\n  }\n\n  .order-xl-8 {\n    order: 8;\n  }\n\n  .order-xl-9 {\n    order: 9;\n  }\n\n  .order-xl-10 {\n    order: 10;\n  }\n\n  .order-xl-11 {\n    order: 11;\n  }\n\n  .order-xl-12 {\n    order: 12;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n\n@media (min-width: 1440) {\n  .col-xxl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-xxl-1>* {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-xxl-2>* {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-xxl-3>* {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-xxl-4>* {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-xxl-5>* {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-xxl-6>* {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-xxl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-xxl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-xxl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xxl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-xxl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-xxl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xxl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-xxl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-xxl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xxl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-xxl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-xxl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xxl-first {\n    order: -1;\n  }\n\n  .order-xxl-last {\n    order: 13;\n  }\n\n  .order-xxl-0 {\n    order: 0;\n  }\n\n  .order-xxl-1 {\n    order: 1;\n  }\n\n  .order-xxl-2 {\n    order: 2;\n  }\n\n  .order-xxl-3 {\n    order: 3;\n  }\n\n  .order-xxl-4 {\n    order: 4;\n  }\n\n  .order-xxl-5 {\n    order: 5;\n  }\n\n  .order-xxl-6 {\n    order: 6;\n  }\n\n  .order-xxl-7 {\n    order: 7;\n  }\n\n  .order-xxl-8 {\n    order: 8;\n  }\n\n  .order-xxl-9 {\n    order: 9;\n  }\n\n  .order-xxl-10 {\n    order: 10;\n  }\n\n  .order-xxl-11 {\n    order: 11;\n  }\n\n  .order-xxl-12 {\n    order: 12;\n  }\n\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xxl-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-xxl-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xxl-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-xxl-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xxl-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-xxl-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xxl-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-xxl-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #7e7e7e;\n}\n\n.table th,\n.table td {\n  padding: 0.75rem;\n  vertical-align: top;\n  border-top: 1px solid #EEEEEE;\n}\n\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #EEEEEE;\n}\n\n.table tbody+tbody {\n  border-top: 2px solid #EEEEEE;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n\n.table-bordered {\n  border: 1px solid #EEEEEE;\n}\n\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #EEEEEE;\n}\n\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 2px;\n}\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody+tbody {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.table-hover tbody tr:hover {\n  color: #7e7e7e;\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-primary,\n.table-primary>th,\n.table-primary>td {\n  background-color: #ddcaf6;\n}\n\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody+tbody {\n  border-color: #c19dee;\n}\n\n.table-hover .table-primary:hover {\n  background-color: #cfb4f2;\n}\n\n.table-hover .table-primary:hover>td,\n.table-hover .table-primary:hover>th {\n  background-color: #cfb4f2;\n}\n\n.table-secondary,\n.table-secondary>th,\n.table-secondary>td {\n  background-color: #c9e3f6;\n}\n\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody+tbody {\n  border-color: #9bcaef;\n}\n\n.table-hover .table-secondary:hover {\n  background-color: #b3d8f2;\n}\n\n.table-hover .table-secondary:hover>td,\n.table-hover .table-secondary:hover>th {\n  background-color: #b3d8f2;\n}\n\n.table-success,\n.table-success>th,\n.table-success>td {\n  background-color: #c4eecf;\n}\n\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody+tbody {\n  border-color: #91dfa7;\n}\n\n.table-hover .table-success:hover {\n  background-color: #b0e8bf;\n}\n\n.table-hover .table-success:hover>td,\n.table-hover .table-success:hover>th {\n  background-color: #b0e8bf;\n}\n\n.table-info,\n.table-info>th,\n.table-info>td {\n  background-color: #c4c3ff;\n}\n\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody+tbody {\n  border-color: #928fff;\n}\n\n.table-hover .table-info:hover {\n  background-color: #abaaff;\n}\n\n.table-hover .table-info:hover>td,\n.table-hover .table-info:hover>th {\n  background-color: #abaaff;\n}\n\n.table-warning,\n.table-warning>th,\n.table-warning>td {\n  background-color: #ffe3cf;\n}\n\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody+tbody {\n  border-color: #ffcba5;\n}\n\n.table-hover .table-warning:hover {\n  background-color: #ffd4b6;\n}\n\n.table-hover .table-warning:hover>td,\n.table-hover .table-warning:hover>th {\n  background-color: #ffd4b6;\n}\n\n.table-danger,\n.table-danger>th,\n.table-danger>td {\n  background-color: #fdcbdd;\n}\n\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody+tbody {\n  border-color: #fc9fc1;\n}\n\n.table-hover .table-danger:hover {\n  background-color: #fcb2cd;\n}\n\n.table-hover .table-danger:hover>td,\n.table-hover .table-danger:hover>th {\n  background-color: #fcb2cd;\n}\n\n.table-light,\n.table-light>th,\n.table-light>td {\n  background-color: #fcfcfd;\n}\n\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody+tbody {\n  border-color: #f9fafc;\n}\n\n.table-hover .table-light:hover {\n  background-color: #ededf3;\n}\n\n.table-hover .table-light:hover>td,\n.table-hover .table-light:hover>th {\n  background-color: #ededf3;\n}\n\n.table-dark,\n.table-dark>th,\n.table-dark>td {\n  background-color: #e9e9e9;\n}\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody+tbody {\n  border-color: #d6d6d6;\n}\n\n.table-hover .table-dark:hover {\n  background-color: gainsboro;\n}\n\n.table-hover .table-dark:hover>td,\n.table-hover .table-dark:hover>th {\n  background-color: gainsboro;\n}\n\n.table-active,\n.table-active>th,\n.table-active>td {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-hover .table-active:hover>td,\n.table-hover .table-active:hover>th {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #454d55;\n}\n\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #EEEEEE;\n}\n\n.table-dark {\n  color: #fff;\n  background-color: #343a40;\n}\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: #454d55;\n}\n\n.table-dark.table-bordered {\n  border: 0;\n}\n\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.table-dark.table-hover tbody tr:hover {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-sm>.table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-md>.table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-lg>.table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-xl>.table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 1439.98) {\n  .table-responsive-xxl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-responsive-xxl>.table-bordered {\n    border: 0;\n  }\n}\n\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table-responsive>.table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #f0f1f5;\n  border-radius: 0.75rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.rpt-container {\n  width: 0px !important;\n  overflow: hidden !important;\n}\n\n.hover-toltip:hover .rpt-container {\n  width: auto !important;\n  overflow: visible !important;\n}\n\n.rpt-hover>span {\n  padding: 8px 14px !important;\n  font-size: 12px !important;\n}\n\n.rpt-arrow {\n  margin-top: -70%;\n}\n\n.rpt-textbox-container {\n  max-width: 87px !important;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n\n.form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: #cdb0f2;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\ninput[type=\"date\"].form-control,\ninput[type=\"time\"].form-control,\ninput[type=\"datetime-local\"].form-control,\ninput[type=\"month\"].form-control {\n  appearance: none;\n}\n\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.09375rem;\n  line-height: 1.5;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.765625rem;\n  line-height: 1.5;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #7e7e7e;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n\n.form-control-plaintext.form-control-sm,\n.form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\nselect.form-control[size],\nselect.form-control[multiple] {\n  height: auto;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n\n.form-row>.col,\n.form-row>[class*=\"col-\"] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n\n.form-check-input[disabled]~.form-check-label,\n.form-check-input:disabled~.form-check-label {\n  color: #89879f;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #2BC155;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.765625rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(43, 193, 85, 0.9);\n  border-radius: 0.75rem;\n}\n\n.was-validated :valid~.valid-feedback,\n.was-validated :valid~.valid-tooltip,\n.is-valid~.valid-feedback,\n.is-valid~.valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid,\n.form-control.is-valid {\n  border-color: #2BC155;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%232BC155' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus {\n  border-color: #2BC155;\n  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .custom-select:valid,\n.custom-select.is-valid {\n  border-color: #2BC155;\n  padding-right: calc(0.75em + 2.3125rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%232BC155' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .custom-select:valid:focus,\n.custom-select.is-valid:focus {\n  border-color: #2BC155;\n  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);\n}\n\n.was-validated .form-check-input:valid~.form-check-label,\n.form-check-input.is-valid~.form-check-label {\n  color: #2BC155;\n}\n\n.was-validated .form-check-input:valid~.valid-feedback,\n.was-validated .form-check-input:valid~.valid-tooltip,\n.form-check-input.is-valid~.valid-feedback,\n.form-check-input.is-valid~.valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid~.custom-control-label,\n.custom-control-input.is-valid~.custom-control-label {\n  color: #2BC155;\n}\n\n.was-validated .custom-control-input:valid~.custom-control-label::before,\n.custom-control-input.is-valid~.custom-control-label::before {\n  border-color: #2BC155;\n}\n\n.was-validated .custom-control-input:valid:checked~.custom-control-label::before,\n.custom-control-input.is-valid:checked~.custom-control-label::before {\n  border-color: #49d670;\n  background-color: #49d670;\n}\n\n.was-validated .custom-control-input:valid:focus~.custom-control-label::before,\n.custom-control-input.is-valid:focus~.custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);\n}\n\n.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before,\n.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before {\n  border-color: #2BC155;\n}\n\n.was-validated .custom-file-input:valid~.custom-file-label,\n.custom-file-input.is-valid~.custom-file-label {\n  border-color: #2BC155;\n}\n\n.was-validated .custom-file-input:valid:focus~.custom-file-label,\n.custom-file-input.is-valid:focus~.custom-file-label {\n  border-color: #2BC155;\n  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #F94687;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.765625rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(249, 70, 135, 0.9);\n  border-radius: 0.75rem;\n}\n\n.was-validated :invalid~.invalid-feedback,\n.was-validated :invalid~.invalid-tooltip,\n.is-invalid~.invalid-feedback,\n.is-invalid~.invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n  border-color: #F94687;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F94687' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F94687' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n  border-color: #F94687;\n  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .custom-select:invalid,\n.custom-select.is-invalid {\n  border-color: #F94687;\n  padding-right: calc(0.75em + 2.3125rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F94687' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F94687' stroke='none'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .custom-select:invalid:focus,\n.custom-select.is-invalid:focus {\n  border-color: #F94687;\n  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);\n}\n\n.was-validated .form-check-input:invalid~.form-check-label,\n.form-check-input.is-invalid~.form-check-label {\n  color: #F94687;\n}\n\n.was-validated .form-check-input:invalid~.invalid-feedback,\n.was-validated .form-check-input:invalid~.invalid-tooltip,\n.form-check-input.is-invalid~.invalid-feedback,\n.form-check-input.is-invalid~.invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid~.custom-control-label,\n.custom-control-input.is-invalid~.custom-control-label {\n  color: #F94687;\n}\n\n.was-validated .custom-control-input:invalid~.custom-control-label::before,\n.custom-control-input.is-invalid~.custom-control-label::before {\n  border-color: #F94687;\n}\n\n.was-validated .custom-control-input:invalid:checked~.custom-control-label::before,\n.custom-control-input.is-invalid:checked~.custom-control-label::before {\n  border-color: #fb77a7;\n  background-color: #fb77a7;\n}\n\n.was-validated .custom-control-input:invalid:focus~.custom-control-label::before,\n.custom-control-input.is-invalid:focus~.custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);\n}\n\n.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before,\n.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before {\n  border-color: #F94687;\n}\n\n.was-validated .custom-file-input:invalid~.custom-file-label,\n.custom-file-input.is-invalid~.custom-file-label {\n  border-color: #F94687;\n}\n\n.was-validated .custom-file-input:invalid:focus~.custom-file-label,\n.custom-file-input.is-invalid:focus~.custom-file-label {\n  border-color: #F94687;\n  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.25);\n}\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n\n.form-inline .form-check {\n  width: 100%;\n}\n\n@media (min-width: 576px) {\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n\n  .form-inline .form-group {\n    display: flex;\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n    align-items: center;\n    margin-bottom: 0;\n  }\n\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n\n  .form-inline .input-group,\n  .form-inline .custom-select {\n    width: auto;\n  }\n\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n\n  .form-inline .form-check-input {\n    position: relative;\n    flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #7e7e7e;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.5rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn:hover {\n  color: #7e7e7e;\n  text-decoration: none;\n}\n\n.btn:focus,\n.btn.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.btn.disabled,\n.btn:disabled {\n  opacity: 0.65;\n}\n\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #3C4B67;\n  border-color: #3C4B67;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #3C4B67;\n  border-color: #3C4B67;\n}\n\n.btn-primary:focus,\n.btn-primary.focus {\n  color: #fff;\n  background-color: #3C4B67;\n  border-color: #3C4B67;\n  box-shadow: 0 0 0 0.2rem rgba(153, 95, 228, 0.5);\n}\n\n.btn-primary.disabled,\n.btn-primary:disabled {\n  color: #fff;\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active,\n.btn-primary:not(:disabled):not(.disabled).active,\n.show>.btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #3C4B67;\n  border-color: #3C4B67;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(153, 95, 228, 0.5);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background-color: #2388d6;\n  border-color: #2181cb;\n}\n\n.btn-secondary:focus,\n.btn-secondary.focus {\n  color: #fff;\n  background-color: #2388d6;\n  border-color: #2181cb;\n  box-shadow: 0 0 0 0.2rem rgba(92, 169, 229, 0.5);\n}\n\n.btn-secondary.disabled,\n.btn-secondary:disabled {\n  color: #fff;\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active,\n.btn-secondary:not(:disabled):not(.disabled).active,\n.show>.btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #2181cb;\n  border-color: #1f7ac0;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(92, 169, 229, 0.5);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #2BC155;\n  border-color: #2BC155;\n}\n\n.btn-success:hover {\n  color: #fff;\n  background-color: #24a247;\n  border-color: #229743;\n}\n\n.btn-success:focus,\n.btn-success.focus {\n  color: #fff;\n  background-color: #24a247;\n  border-color: #229743;\n  box-shadow: 0 0 0 0.2rem rgba(75, 202, 111, 0.5);\n}\n\n.btn-success.disabled,\n.btn-success:disabled {\n  color: #fff;\n  background-color: #2BC155;\n  border-color: #2BC155;\n}\n\n.btn-success:not(:disabled):not(.disabled):active,\n.btn-success:not(:disabled):not(.disabled).active,\n.show>.btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: #229743;\n  border-color: #1f8d3e;\n}\n\n.btn-success:not(:disabled):not(.disabled):active:focus,\n.btn-success:not(:disabled):not(.disabled).active:focus,\n.show>.btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(75, 202, 111, 0.5);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.btn-info:hover {\n  color: #fff;\n  background-color: #0802ff;\n  border-color: #0600f4;\n}\n\n.btn-info:focus,\n.btn-info.focus {\n  color: #fff;\n  background-color: #0802ff;\n  border-color: #0600f4;\n  box-shadow: 0 0 0 0.2rem rgba(77, 72, 255, 0.5);\n}\n\n.btn-info.disabled,\n.btn-info:disabled {\n  color: #fff;\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.btn-info:not(:disabled):not(.disabled):active,\n.btn-info:not(:disabled):not(.disabled).active,\n.show>.btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #0600f4;\n  border-color: #0500e7;\n}\n\n.btn-info:not(:disabled):not(.disabled):active:focus,\n.btn-info:not(:disabled):not(.disabled).active:focus,\n.show>.btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(77, 72, 255, 0.5);\n}\n\n.btn-warning {\n  color: #212529;\n  background-color: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.btn-warning:hover {\n  color: #212529;\n  background-color: #ff852c;\n  border-color: #ff7e1f;\n}\n\n.btn-warning:focus,\n.btn-warning.focus {\n  color: #212529;\n  background-color: #ff852c;\n  border-color: #ff7e1f;\n  box-shadow: 0 0 0 0.2rem rgba(222, 137, 76, 0.5);\n}\n\n.btn-warning.disabled,\n.btn-warning:disabled {\n  color: #212529;\n  background-color: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active,\n.btn-warning:not(:disabled):not(.disabled).active,\n.show>.btn-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #ff7e1f;\n  border-color: #ff7612;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active:focus,\n.btn-warning:not(:disabled):not(.disabled).active:focus,\n.show>.btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(222, 137, 76, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #F94687;\n  border-color: #F94687;\n}\n\n.btn-danger:hover {\n  color: #fff;\n  background-color: #f8216f;\n  border-color: #f71567;\n}\n\n.btn-danger:focus,\n.btn-danger.focus {\n  color: #fff;\n  background-color: #f8216f;\n  border-color: #f71567;\n  box-shadow: 0 0 0 0.2rem rgba(250, 98, 153, 0.5);\n}\n\n.btn-danger.disabled,\n.btn-danger:disabled {\n  color: #fff;\n  background-color: #F94687;\n  border-color: #F94687;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active,\n.btn-danger:not(:disabled):not(.disabled).active,\n.show>.btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #f71567;\n  border-color: #f7085f;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active:focus,\n.btn-danger:not(:disabled):not(.disabled).active:focus,\n.show>.btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(250, 98, 153, 0.5);\n}\n\n.btn-light {\n  color: #212529;\n  background-color: #F4F5F9;\n  border-color: #F4F5F9;\n}\n\n.btn-light:hover {\n  color: #212529;\n  background-color: #dbdfec;\n  border-color: #d3d7e7;\n}\n\n.btn-light:focus,\n.btn-light.focus {\n  color: #212529;\n  background-color: #dbdfec;\n  border-color: #d3d7e7;\n  box-shadow: 0 0 0 0.2rem rgba(212, 214, 218, 0.5);\n}\n\n.btn-light.disabled,\n.btn-light:disabled {\n  color: #212529;\n  background-color: #F4F5F9;\n  border-color: #F4F5F9;\n}\n\n.btn-light:not(:disabled):not(.disabled):active,\n.btn-light:not(:disabled):not(.disabled).active,\n.show>.btn-light.dropdown-toggle {\n  color: #212529;\n  background-color: #d3d7e7;\n  border-color: #cbd0e3;\n}\n\n.btn-light:not(:disabled):not(.disabled):active:focus,\n.btn-light:not(:disabled):not(.disabled).active:focus,\n.show>.btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(212, 214, 218, 0.5);\n}\n\n.btn-dark {\n  color: #212529;\n  background-color: #B1B1B1;\n  border-color: #B1B1B1;\n}\n\n.btn-dark:hover {\n  color: #212529;\n  background-color: #9e9e9e;\n  border-color: #989898;\n}\n\n.btn-dark:focus,\n.btn-dark.focus {\n  color: #212529;\n  background-color: #9e9e9e;\n  border-color: #989898;\n  box-shadow: 0 0 0 0.2rem rgba(155, 156, 157, 0.5);\n}\n\n.btn-dark.disabled,\n.btn-dark:disabled {\n  color: #212529;\n  background-color: #B1B1B1;\n  border-color: #B1B1B1;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active,\n.btn-dark:not(:disabled):not(.disabled).active,\n.show>.btn-dark.dropdown-toggle {\n  color: #212529;\n  background-color: #989898;\n  border-color: #919191;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active:focus,\n.btn-dark:not(:disabled):not(.disabled).active:focus,\n.show>.btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(155, 156, 157, 0.5);\n}\n\n.btn-outline-primary {\n  color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.btn-outline-primary:focus,\n.btn-outline-primary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.5);\n}\n\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n  color: #00ADEE;\n  background-color: transparent;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active,\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.show>.btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #3F9AE0;\n  border-color: #3F9AE0;\n}\n\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n}\n\n.btn-outline-secondary:focus,\n.btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(63, 154, 224, 0.5);\n}\n\n.btn-outline-secondary.disabled,\n.btn-outline-secondary:disabled {\n  color: #3F9AE0;\n  background-color: transparent;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\n.show>.btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(63, 154, 224, 0.5);\n}\n\n.btn-outline-success {\n  color: #2BC155;\n  border-color: #2BC155;\n}\n\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #2BC155;\n  border-color: #2BC155;\n}\n\n.btn-outline-success:focus,\n.btn-outline-success.focus {\n  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.5);\n}\n\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n  color: #2BC155;\n  background-color: transparent;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active,\n.btn-outline-success:not(:disabled):not(.disabled).active,\n.show>.btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #2BC155;\n  border-color: #2BC155;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.5);\n}\n\n.btn-outline-info {\n  color: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.btn-outline-info:focus,\n.btn-outline-info.focus {\n  box-shadow: 0 0 0 0.2rem rgba(45, 40, 255, 0.5);\n}\n\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n  color: #2D28FF;\n  background-color: transparent;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active,\n.btn-outline-info:not(:disabled):not(.disabled).active,\n.show>.btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(45, 40, 255, 0.5);\n}\n\n.btn-outline-warning {\n  color: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.btn-outline-warning:focus,\n.btn-outline-warning.focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 155, 82, 0.5);\n}\n\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n  color: #FF9B52;\n  background-color: transparent;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active,\n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.show>.btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 155, 82, 0.5);\n}\n\n.btn-outline-danger {\n  color: #F94687;\n  border-color: #F94687;\n}\n\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #F94687;\n  border-color: #F94687;\n}\n\n.btn-outline-danger:focus,\n.btn-outline-danger.focus {\n  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.5);\n}\n\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n  color: #F94687;\n  background-color: transparent;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active,\n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.show>.btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #F94687;\n  border-color: #F94687;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.5);\n}\n\n.btn-outline-light {\n  color: #F4F5F9;\n  border-color: #F4F5F9;\n}\n\n.btn-outline-light:hover {\n  color: #212529;\n  background-color: #F4F5F9;\n  border-color: #F4F5F9;\n}\n\n.btn-outline-light:focus,\n.btn-outline-light.focus {\n  box-shadow: 0 0 0 0.2rem rgba(244, 245, 249, 0.5);\n}\n\n.btn-outline-light.disabled,\n.btn-outline-light:disabled {\n  color: #F4F5F9;\n  background-color: transparent;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active,\n.btn-outline-light:not(:disabled):not(.disabled).active,\n.show>.btn-outline-light.dropdown-toggle {\n  color: #212529;\n  background-color: #F4F5F9;\n  border-color: #F4F5F9;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active:focus,\n.btn-outline-light:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(244, 245, 249, 0.5);\n}\n\n.btn-outline-dark {\n  color: #B1B1B1;\n  border-color: #B1B1B1;\n}\n\n.btn-outline-dark:hover {\n  color: #212529;\n  background-color: #B1B1B1;\n  border-color: #B1B1B1;\n}\n\n.btn-outline-dark:focus,\n.btn-outline-dark.focus {\n  box-shadow: 0 0 0 0.2rem rgba(177, 177, 177, 0.5);\n}\n\n.btn-outline-dark.disabled,\n.btn-outline-dark:disabled {\n  color: #B1B1B1;\n  background-color: transparent;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active,\n.btn-outline-dark:not(:disabled):not(.disabled).active,\n.show>.btn-outline-dark.dropdown-toggle {\n  color: #212529;\n  background-color: #B1B1B1;\n  border-color: #B1B1B1;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus,\n.btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n.show>.btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(177, 177, 177, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #00ADEE;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  color: #611fb6;\n  text-decoration: underline;\n}\n\n.btn-link:focus,\n.btn-link.focus {\n  text-decoration: underline;\n}\n\n.btn-link:disabled,\n.btn-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n\n.btn-lg,\n.btn-group-lg>.btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.btn-sm,\n.btn-group-sm>.btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n.btn-block+.btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 0.875rem;\n  color: #7e7e7e;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.75rem;\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1440) {\n  .dropdown-menu-xxl-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xxl-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-menu[x-placement^=\"top\"],\n.dropdown-menu[x-placement^=\"right\"],\n.dropdown-menu[x-placement^=\"bottom\"],\n.dropdown-menu[x-placement^=\"left\"] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.dropdown-item:hover,\n.dropdown-item:focus {\n  color: #16181b;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #00ADEE;\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.765625rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.btn-group>.btn,\n.btn-group-vertical>.btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.btn-group>.btn:hover,\n.btn-group-vertical>.btn:hover {\n  z-index: 1;\n}\n\n.btn-group>.btn:focus,\n.btn-group>.btn:active,\n.btn-group>.btn.active,\n.btn-group-vertical>.btn:focus,\n.btn-group-vertical>.btn:active,\n.btn-group-vertical>.btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group>.btn:not(:first-child),\n.btn-group>.btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn-group:not(:last-child)>.btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn-group>.btn:not(:first-child),\n.btn-group>.btn-group:not(:first-child)>.btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropright .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm+.dropdown-toggle-split,\n.btn-group-sm>.btn+.dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg+.dropdown-toggle-split,\n.btn-group-lg>.btn+.dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.btn-group-vertical>.btn,\n.btn-group-vertical>.btn-group {\n  width: 100%;\n}\n\n.btn-group-vertical>.btn:not(:first-child),\n.btn-group-vertical>.btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical>.btn-group:not(:last-child)>.btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical>.btn:not(:first-child),\n.btn-group-vertical>.btn-group:not(:first-child)>.btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle>.btn,\n.btn-group-toggle>.btn-group>.btn {\n  margin-bottom: 0;\n}\n\n.btn-group-toggle>.btn input[type=\"radio\"],\n.btn-group-toggle>.btn input[type=\"checkbox\"],\n.btn-group-toggle>.btn-group>.btn input[type=\"radio\"],\n.btn-group-toggle>.btn-group>.btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n\n.input-group>.form-control,\n.input-group>.form-control-plaintext,\n.input-group>.custom-select,\n.input-group>.custom-file {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n\n.input-group>.form-control+.form-control,\n.input-group>.form-control+.custom-select,\n.input-group>.form-control+.custom-file,\n.input-group>.form-control-plaintext+.form-control,\n.input-group>.form-control-plaintext+.custom-select,\n.input-group>.form-control-plaintext+.custom-file,\n.input-group>.custom-select+.form-control,\n.input-group>.custom-select+.custom-select,\n.input-group>.custom-select+.custom-file,\n.input-group>.custom-file+.form-control,\n.input-group>.custom-file+.custom-select,\n.input-group>.custom-file+.custom-file {\n  margin-left: -1px;\n}\n\n.input-group>.form-control:focus,\n.input-group>.custom-select:focus,\n.input-group>.custom-file .custom-file-input:focus~.custom-file-label {\n  z-index: 3;\n}\n\n.input-group>.custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n\n.input-group>.form-control:not(:last-child),\n.input-group>.custom-select:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group>.form-control:not(:first-child),\n.input-group>.custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group>.custom-file {\n  display: flex;\n  align-items: center;\n}\n\n.input-group>.custom-file:not(:last-child) .custom-file-label,\n.input-group>.custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group>.custom-file:not(:first-child) .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n  max-height: 45px;\n}\n\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n\n.input-group-prepend .btn:focus,\n.input-group-append .btn:focus {\n  z-index: 3;\n}\n\n.input-group-prepend .btn+.btn,\n.input-group-prepend .btn+.input-group-text,\n.input-group-prepend .input-group-text+.input-group-text,\n.input-group-prepend .input-group-text+.btn,\n.input-group-append .btn+.btn,\n.input-group-append .btn+.input-group-text,\n.input-group-append .input-group-text+.input-group-text,\n.input-group-append .input-group-text+.btn {\n  margin-left: -1px;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #f0f1f5;\n  border-radius: 0.5rem;\n}\n\n.input-group-text input[type=\"radio\"],\n.input-group-text input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n\n.input-group-lg>.form-control:not(textarea),\n.input-group-lg>.custom-select {\n  height: calc(1.5em + 1rem + 2px);\n}\n\n.input-group-lg>.form-control,\n.input-group-lg>.custom-select,\n.input-group-lg>.input-group-prepend>.input-group-text,\n.input-group-lg>.input-group-append>.input-group-text,\n.input-group-lg>.input-group-prepend>.btn,\n.input-group-lg>.input-group-append>.btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm>.form-control:not(textarea),\n.input-group-sm>.custom-select {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n\n.input-group-sm>.form-control,\n.input-group-sm>.custom-select,\n.input-group-sm>.input-group-prepend>.input-group-text,\n.input-group-sm>.input-group-append>.input-group-text,\n.input-group-sm>.input-group-prepend>.btn,\n.input-group-sm>.input-group-append>.btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg>.custom-select,\n.input-group-sm>.custom-select {\n  padding-right: 1.75rem;\n}\n\n.input-group>.input-group-prepend>.btn,\n.input-group>.input-group-prepend>.input-group-text,\n.input-group>.input-group-append:not(:last-child)>.btn,\n.input-group>.input-group-append:not(:last-child)>.input-group-text,\n.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),\n.input-group>.input-group-append:last-child>.input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group>.input-group-append>.btn,\n.input-group>.input-group-append>.input-group-text,\n.input-group>.input-group-prepend:not(:first-child)>.btn,\n.input-group>.input-group-prepend:not(:first-child)>.input-group-text,\n.input-group>.input-group-prepend:first-child>.btn:not(:first-child),\n.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: 1.3125rem;\n  padding-left: 1.5rem;\n  color-adjust: exact;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1rem;\n  height: 1.15625rem;\n  opacity: 0;\n}\n\n.custom-control-input:checked~.custom-control-label::before {\n  color: #fff;\n  border-color: #00ADEE;\n  background-color: #00ADEE;\n}\n\n.custom-control-input:focus~.custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.custom-control-input:focus:not(:checked)~.custom-control-label::before {\n  border-color: #cdb0f2;\n}\n\n.custom-control-input:not(:disabled):active~.custom-control-label::before {\n  color: #fff;\n  background-color: #e8dcf9;\n  border-color: #e8dcf9;\n}\n\n.custom-control-input[disabled]~.custom-control-label,\n.custom-control-input:disabled~.custom-control-label {\n  color: #6c757d;\n}\n\n.custom-control-input[disabled]~.custom-control-label::before,\n.custom-control-input:disabled~.custom-control-label::before {\n  background-color: #e9ecef;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n\n.custom-control-label::before {\n  position: absolute;\n  top: 0.15625rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fff;\n  border: #adb5bd solid 1px;\n}\n\n.custom-control-label::after {\n  position: absolute;\n  top: 0.15625rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: \"\";\n  background: no-repeat 50% / 50% 50%;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.75rem;\n}\n\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {\n  border-color: #00ADEE;\n  background-color: #00ADEE;\n}\n\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {\n  background-color: rgba(135, 67, 223, 0.5);\n}\n\n.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {\n  background-color: rgba(135, 67, 223, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n\n.custom-radio .custom-control-input:checked~.custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {\n  background-color: rgba(135, 67, 223, 0.5);\n}\n\n.custom-switch {\n  padding-left: 2.25rem;\n}\n\n.custom-switch .custom-control-label::before {\n  left: -2.25rem;\n  width: 1.75rem;\n  pointer-events: all;\n  border-radius: 0.5rem;\n}\n\n.custom-switch .custom-control-label::after {\n  top: calc(0.15625rem + 2px);\n  left: calc(-2.25rem + 2px);\n  width: calc(1rem - 4px);\n  height: calc(1rem - 4px);\n  background-color: #adb5bd;\n  border-radius: 0.5rem;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n\n.custom-switch .custom-control-input:checked~.custom-control-label::after {\n  background-color: #fff;\n  transform: translateX(0.75rem);\n}\n\n.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before {\n  background-color: rgba(135, 67, 223, 0.5);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px;\n  border: 1px solid #f0f1f5;\n  border-radius: 0.75rem;\n  appearance: none;\n}\n\n.custom-select:focus {\n  border-color: #cdb0f2;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.custom-select:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n\n.custom-select[multiple],\n.custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n\n.custom-select:disabled {\n  color: #6c757d;\n  background-color: #e9ecef;\n}\n\n.custom-select::-ms-expand {\n  display: none;\n}\n\n.custom-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n\n.custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.765625rem;\n}\n\n.custom-select-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.09375rem;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin: 0;\n  opacity: 0;\n}\n\n.custom-file-input:focus~.custom-file-label {\n  border-color: #cdb0f2;\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.custom-file-input[disabled]~.custom-file-label,\n.custom-file-input:disabled~.custom-file-label {\n  background-color: #e9ecef;\n}\n\n.custom-file-input:lang(en)~.custom-file-label::after {\n  content: \"Browse\";\n}\n\n.custom-file-input~.custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #f0f1f5;\n  border-radius: 0.75rem;\n}\n\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.5em + 0.75rem);\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  content: \"Browse\";\n  background-color: #e9ecef;\n  border-left: inherit;\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: 1.4rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n\n.custom-range:focus {\n  outline: none;\n}\n\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #E5E6E7, 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #E5E6E7, 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #E5E6E7, 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #00ADEE;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n\n.custom-range::-webkit-slider-thumb:active {\n  background-color: #e8dcf9;\n}\n\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #00ADEE;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n\n.custom-range::-moz-range-thumb:active {\n  background-color: #e8dcf9;\n}\n\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0.2rem;\n  margin-left: 0.2rem;\n  background-color: #00ADEE;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    transition: none;\n  }\n}\n\n.custom-range::-ms-thumb:active {\n  background-color: #e8dcf9;\n}\n\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n}\n\n.custom-range::-ms-fill-lower {\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-ms-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .custom-control-label::before,\n  .custom-file-label,\n  .custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n\n.nav-link:hover,\n.nav-link:focus {\n  text-decoration: none;\n}\n\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n\n.nav-tabs .nav-item {\n  margin-bottom: -1px;\n}\n\n.nav-tabs .nav-link {\n  border: 1px solid transparent;\n  border-top-left-radius: 0.75rem;\n  border-top-right-radius: 0.75rem;\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #495057;\n  background-color: #E5E6E7;\n  border-color: #dee2e6 #dee2e6 #E5E6E7;\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0.75rem;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  color: #fff;\n  background-color: #00ADEE;\n}\n\n.nav-fill>.nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified>.nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content>.tab-pane {\n  display: none;\n}\n\n.tab-content>.active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n\n.navbar .container,\n.navbar .container-fluid,\n.navbar .container-sm,\n.navbar .container-md,\n.navbar .container-lg,\n.navbar .container-xl {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3359375rem;\n  padding-bottom: 0.3359375rem;\n  margin-right: 1rem;\n  font-size: 1.09375rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n\n.navbar-brand:hover,\n.navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.09375rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.75rem;\n}\n\n.navbar-toggler:hover,\n.navbar-toggler:focus {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n@media (max-width: 575.98px) {\n\n  .navbar-expand-sm>.container,\n  .navbar-expand-sm>.container-fluid,\n  .navbar-expand-sm>.container-sm,\n  .navbar-expand-sm>.container-md,\n  .navbar-expand-sm>.container-lg,\n  .navbar-expand-sm>.container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-sm>.container,\n  .navbar-expand-sm>.container-fluid,\n  .navbar-expand-sm>.container-sm,\n  .navbar-expand-sm>.container-md,\n  .navbar-expand-sm>.container-lg,\n  .navbar-expand-sm>.container-xl {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n\n  .navbar-expand-md>.container,\n  .navbar-expand-md>.container-fluid,\n  .navbar-expand-md>.container-sm,\n  .navbar-expand-md>.container-md,\n  .navbar-expand-md>.container-lg,\n  .navbar-expand-md>.container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-md>.container,\n  .navbar-expand-md>.container-fluid,\n  .navbar-expand-md>.container-sm,\n  .navbar-expand-md>.container-md,\n  .navbar-expand-md>.container-lg,\n  .navbar-expand-md>.container-xl {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n\n  .navbar-expand-lg>.container,\n  .navbar-expand-lg>.container-fluid,\n  .navbar-expand-lg>.container-sm,\n  .navbar-expand-lg>.container-md,\n  .navbar-expand-lg>.container-lg,\n  .navbar-expand-lg>.container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-lg>.container,\n  .navbar-expand-lg>.container-fluid,\n  .navbar-expand-lg>.container-sm,\n  .navbar-expand-lg>.container-md,\n  .navbar-expand-lg>.container-lg,\n  .navbar-expand-lg>.container-xl {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 1199.98px) {\n\n  .navbar-expand-xl>.container,\n  .navbar-expand-xl>.container-fluid,\n  .navbar-expand-xl>.container-sm,\n  .navbar-expand-xl>.container-md,\n  .navbar-expand-xl>.container-lg,\n  .navbar-expand-xl>.container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xl>.container,\n  .navbar-expand-xl>.container-fluid,\n  .navbar-expand-xl>.container-sm,\n  .navbar-expand-xl>.container-md,\n  .navbar-expand-xl>.container-lg,\n  .navbar-expand-xl>.container-xl {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 1439.98) {\n\n  .navbar-expand-xxl>.container,\n  .navbar-expand-xxl>.container-fluid,\n  .navbar-expand-xxl>.container-sm,\n  .navbar-expand-xxl>.container-md,\n  .navbar-expand-xxl>.container-lg,\n  .navbar-expand-xxl>.container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 1440) {\n  .navbar-expand-xxl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .navbar-expand-xxl>.container,\n  .navbar-expand-xxl>.container-fluid,\n  .navbar-expand-xxl>.container-sm,\n  .navbar-expand-xxl>.container-md,\n  .navbar-expand-xxl>.container-lg,\n  .navbar-expand-xxl>.container-xl {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n}\n\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n\n.navbar-expand>.container,\n.navbar-expand>.container-fluid,\n.navbar-expand>.container-sm,\n.navbar-expand>.container-md,\n.navbar-expand>.container-lg,\n.navbar-expand>.container-xl {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.navbar-expand>.container,\n.navbar-expand>.container-fluid,\n.navbar-expand>.container-sm,\n.navbar-expand>.container-md,\n.navbar-expand>.container-lg,\n.navbar-expand>.container-xl {\n  flex-wrap: nowrap;\n}\n\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-brand:hover,\n.navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-nav .nav-link:hover,\n.navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .show>.nav-link,\n.navbar-light .navbar-nav .active>.nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-text a:hover,\n.navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n\n.navbar-dark .navbar-brand:hover,\n.navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-nav .nav-link:hover,\n.navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .show>.nav-link,\n.navbar-dark .navbar-nav .active>.nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-text a {\n  color: #fff;\n}\n\n.navbar-dark .navbar-text a:hover,\n.navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.75rem;\n}\n\n.card>hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.card>.list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n\n.card>.list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.75rem - 1px);\n  border-top-right-radius: calc(0.75rem - 1px);\n}\n\n.card>.list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.75rem - 1px);\n  border-bottom-left-radius: calc(0.75rem - 1px);\n}\n\n.card>.card-header+.list-group,\n.card>.list-group+.card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.25rem;\n}\n\n.card-title {\n  margin-bottom: 0.75rem;\n}\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n\n.card-link+.card-link {\n  margin-left: 1.25rem;\n}\n\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.card-header:first-child {\n  border-radius: calc(0.75rem - 1px) calc(0.75rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.75rem - 1px) calc(0.75rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: calc(0.75rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.75rem - 1px);\n  border-top-right-radius: calc(0.75rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.75rem - 1px);\n  border-bottom-left-radius: calc(0.75rem - 1px);\n}\n\n.card-deck .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-deck {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n\n  .card-deck .card {\n    flex: 1 0 0%;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group>.card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n\n  .card-group>.card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n\n  .card-group>.card+.card {\n    margin-left: 0;\n    border-left: 0;\n  }\n\n  .card-group>.card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group>.card:not(:last-child) .card-img-top,\n  .card-group>.card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n\n  .card-group>.card:not(:last-child) .card-img-bottom,\n  .card-group>.card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child) .card-img-top,\n  .card-group>.card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child) .card-img-bottom,\n  .card-group>.card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 0.75rem;\n}\n\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion {\n  overflow-anchor: none;\n}\n\n.accordion>.card {\n  overflow: hidden;\n}\n\n.accordion>.card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.accordion>.card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.accordion>.card>.card-header {\n  border-radius: 0;\n  margin-bottom: -1px;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.75rem;\n}\n\n.breadcrumb-item {\n  display: flex;\n}\n\n.breadcrumb-item+.breadcrumb-item {\n  padding-left: 0.5rem;\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: \"/\";\n}\n\n.breadcrumb-item+.breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n\n.breadcrumb-item+.breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.75rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #00ADEE;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n\n.page-link:hover {\n  z-index: 2;\n  color: #611fb6;\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.page-link:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.25);\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.75rem;\n  border-bottom-right-radius: 0.75rem;\n}\n\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.765625rem;\n  line-height: 1.5;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.75rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\n\na.badge:hover,\na.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #fff;\n  background-color: #00ADEE;\n}\n\na.badge-primary:hover,\na.badge-primary:focus {\n  color: #fff;\n  background-color: #6d23cc;\n}\n\na.badge-primary:focus,\na.badge-primary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(135, 67, 223, 0.5);\n}\n\n.badge-secondary {\n  color: #fff;\n  background-color: #3F9AE0;\n}\n\na.badge-secondary:hover,\na.badge-secondary:focus {\n  color: #fff;\n  background-color: #2181cb;\n}\n\na.badge-secondary:focus,\na.badge-secondary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(63, 154, 224, 0.5);\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #2BC155;\n}\n\na.badge-success:hover,\na.badge-success:focus {\n  color: #fff;\n  background-color: #229743;\n}\n\na.badge-success:focus,\na.badge-success.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(43, 193, 85, 0.5);\n}\n\n.badge-info {\n  color: #fff;\n  background-color: #2D28FF;\n}\n\na.badge-info:hover,\na.badge-info:focus {\n  color: #fff;\n  background-color: #0600f4;\n}\n\na.badge-info:focus,\na.badge-info.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(45, 40, 255, 0.5);\n}\n\n.badge-warning {\n  color: #212529;\n  background-color: #FF9B52;\n}\n\na.badge-warning:hover,\na.badge-warning:focus {\n  color: #212529;\n  background-color: #ff7e1f;\n}\n\na.badge-warning:focus,\na.badge-warning.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(255, 155, 82, 0.5);\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #F94687;\n}\n\na.badge-danger:hover,\na.badge-danger:focus {\n  color: #fff;\n  background-color: #f71567;\n}\n\na.badge-danger:focus,\na.badge-danger.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(249, 70, 135, 0.5);\n}\n\n.badge-light {\n  color: #212529;\n  background-color: #F4F5F9;\n}\n\na.badge-light:hover,\na.badge-light:focus {\n  color: #212529;\n  background-color: #d3d7e7;\n}\n\na.badge-light:focus,\na.badge-light.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(244, 245, 249, 0.5);\n}\n\n.badge-dark {\n  color: #212529;\n  background-color: #B1B1B1;\n}\n\na.badge-dark:hover,\na.badge-dark:focus {\n  color: #212529;\n  background-color: #989898;\n}\n\na.badge-dark:focus,\na.badge-dark.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(177, 177, 177, 0.5);\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.3rem;\n}\n\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.75rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 3.8125rem;\n}\n\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 0.75rem 1.25rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: #462374;\n  background-color: #e7d9f9;\n  border-color: #ddcaf6;\n}\n\n.alert-primary hr {\n  border-top-color: #cfb4f2;\n}\n\n.alert-primary .alert-link {\n  color: #2e174d;\n}\n\n.alert-secondary {\n  color: #215074;\n  background-color: #d9ebf9;\n  border-color: #c9e3f6;\n}\n\n.alert-secondary hr {\n  border-top-color: #b3d8f2;\n}\n\n.alert-secondary .alert-link {\n  color: #16354c;\n}\n\n.alert-success {\n  color: #16642c;\n  background-color: #d5f3dd;\n  border-color: #c4eecf;\n}\n\n.alert-success hr {\n  border-top-color: #b0e8bf;\n}\n\n.alert-success .alert-link {\n  color: #0d3a1a;\n}\n\n.alert-info {\n  color: #171585;\n  background-color: #d5d4ff;\n  border-color: #c4c3ff;\n}\n\n.alert-info hr {\n  border-top-color: #abaaff;\n}\n\n.alert-info .alert-link {\n  color: #0f0e59;\n}\n\n.alert-warning {\n  color: #85512b;\n  background-color: #ffebdc;\n  border-color: #ffe3cf;\n}\n\n.alert-warning hr {\n  border-top-color: #ffd4b6;\n}\n\n.alert-warning .alert-link {\n  color: #5e3a1f;\n}\n\n.alert-danger {\n  color: #812446;\n  background-color: #fedae7;\n  border-color: #fdcbdd;\n}\n\n.alert-danger hr {\n  border-top-color: #fcb2cd;\n}\n\n.alert-danger .alert-link {\n  color: #591930;\n}\n\n.alert-light {\n  color: #7f7f81;\n  background-color: #fdfdfe;\n  border-color: #fcfcfd;\n}\n\n.alert-light hr {\n  border-top-color: #ededf3;\n}\n\n.alert-light .alert-link {\n  color: #666667;\n}\n\n.alert-dark {\n  color: #5c5c5c;\n  background-color: #efefef;\n  border-color: #e9e9e9;\n}\n\n.alert-dark hr {\n  border-top-color: gainsboro;\n}\n\n.alert-dark .alert-link {\n  color: #434343;\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  line-height: 0;\n  font-size: 0.65625rem;\n  background-color: #e9ecef;\n  border-radius: 0.75rem;\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #00ADEE;\n  transition: width 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.75rem;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n\n.list-group-item-action:hover,\n.list-group-item-action:focus {\n  z-index: 1;\n  color: #495057;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n\n.list-group-item-action:active {\n  color: #7e7e7e;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n}\n\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.list-group-item+.list-group-item {\n  border-top-width: 0;\n}\n\n.list-group-item+.list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n\n.list-group-horizontal>.list-group-item:first-child {\n  border-bottom-left-radius: 0.75rem;\n  border-top-right-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item:last-child {\n  border-top-right-radius: 0.75rem;\n  border-bottom-left-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item.active {\n  margin-top: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-sm>.list-group-item:first-child {\n    border-bottom-left-radius: 0.75rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item:last-child {\n    border-top-right-radius: 0.75rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-md>.list-group-item:first-child {\n    border-bottom-left-radius: 0.75rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item:last-child {\n    border-top-right-radius: 0.75rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-lg>.list-group-item:first-child {\n    border-bottom-left-radius: 0.75rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item:last-child {\n    border-top-right-radius: 0.75rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xl>.list-group-item:first-child {\n    border-bottom-left-radius: 0.75rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item:last-child {\n    border-top-right-radius: 0.75rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n@media (min-width: 1440) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item:first-child {\n    border-bottom-left-radius: 0.75rem;\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item:last-child {\n    border-top-right-radius: 0.75rem;\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item+.list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n\n.list-group-flush {\n  border-radius: 0;\n}\n\n.list-group-flush>.list-group-item {\n  border-width: 0 0 1px;\n}\n\n.list-group-flush>.list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: #462374;\n  background-color: #ddcaf6;\n}\n\n.list-group-item-primary.list-group-item-action:hover,\n.list-group-item-primary.list-group-item-action:focus {\n  color: #462374;\n  background-color: #cfb4f2;\n}\n\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: #462374;\n  border-color: #462374;\n}\n\n.list-group-item-secondary {\n  color: #215074;\n  background-color: #c9e3f6;\n}\n\n.list-group-item-secondary.list-group-item-action:hover,\n.list-group-item-secondary.list-group-item-action:focus {\n  color: #215074;\n  background-color: #b3d8f2;\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: #215074;\n  border-color: #215074;\n}\n\n.list-group-item-success {\n  color: #16642c;\n  background-color: #c4eecf;\n}\n\n.list-group-item-success.list-group-item-action:hover,\n.list-group-item-success.list-group-item-action:focus {\n  color: #16642c;\n  background-color: #b0e8bf;\n}\n\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: #16642c;\n  border-color: #16642c;\n}\n\n.list-group-item-info {\n  color: #171585;\n  background-color: #c4c3ff;\n}\n\n.list-group-item-info.list-group-item-action:hover,\n.list-group-item-info.list-group-item-action:focus {\n  color: #171585;\n  background-color: #abaaff;\n}\n\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: #171585;\n  border-color: #171585;\n}\n\n.list-group-item-warning {\n  color: #85512b;\n  background-color: #ffe3cf;\n}\n\n.list-group-item-warning.list-group-item-action:hover,\n.list-group-item-warning.list-group-item-action:focus {\n  color: #85512b;\n  background-color: #ffd4b6;\n}\n\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: #85512b;\n  border-color: #85512b;\n}\n\n.list-group-item-danger {\n  color: #812446;\n  background-color: #fdcbdd;\n}\n\n.list-group-item-danger.list-group-item-action:hover,\n.list-group-item-danger.list-group-item-action:focus {\n  color: #812446;\n  background-color: #fcb2cd;\n}\n\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: #812446;\n  border-color: #812446;\n}\n\n.list-group-item-light {\n  color: #7f7f81;\n  background-color: #fcfcfd;\n}\n\n.list-group-item-light.list-group-item-action:hover,\n.list-group-item-light.list-group-item-action:focus {\n  color: #7f7f81;\n  background-color: #ededf3;\n}\n\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: #7f7f81;\n  border-color: #7f7f81;\n}\n\n.list-group-item-dark {\n  color: #5c5c5c;\n  background-color: #e9e9e9;\n}\n\n.list-group-item-dark.list-group-item-action:hover,\n.list-group-item-dark.list-group-item-action:focus {\n  color: #5c5c5c;\n  background-color: gainsboro;\n}\n\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: #5c5c5c;\n  border-color: #5c5c5c;\n}\n\n.close {\n  float: right;\n  font-size: 1.3125rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5;\n}\n\n.close:hover {\n  color: #000;\n  text-decoration: none;\n}\n\n.close:not(:disabled):not(.disabled):hover,\n.close:not(:disabled):not(.disabled):focus {\n  opacity: .75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.toast {\n  flex-basis: 350px;\n  max-width: 350px;\n  font-size: 0.875rem;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  border-radius: 0.25rem;\n}\n\n.toast:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast.showing {\n  opacity: 1;\n}\n\n.toast.show {\n  display: block;\n  opacity: 1;\n}\n\n.toast.hide {\n  display: none;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.toast-body {\n  padding: 0.75rem;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n\n.modal.show .modal-dialog {\n  transform: none;\n}\n\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-header,\n.modal-dialog-scrollable .modal-footer {\n  flex-shrink: 0;\n}\n\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  height: min-content;\n  content: \"\";\n}\n\n.modal-dialog-centered.modal-dialog-scrollable {\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n}\n\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #EEEEEE;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n\n.modal-header .close {\n  padding: 1rem 1rem;\n  margin: -1rem -1rem -1rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  border-top: 1px solid #EEEEEE;\n  border-bottom-right-radius: calc(0.3rem - 1px);\n  border-bottom-left-radius: calc(0.3rem - 1px);\n}\n\n.modal-footer>* {\n  margin: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n    height: min-content;\n  }\n\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.765625rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n\n.tooltip.show {\n  opacity: 0.9;\n}\n\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top,\n.bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-top .arrow,\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n  bottom: 0;\n}\n\n.bs-tooltip-top .arrow::before,\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-right,\n.bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-right .arrow,\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-right .arrow::before,\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom,\n.bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-bottom .arrow,\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n  top: 0;\n}\n\n.bs-tooltip-bottom .arrow::before,\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-left,\n.bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-left .arrow,\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-left .arrow::before,\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.75rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.765625rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n}\n\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.3rem;\n}\n\n.popover .arrow::before,\n.popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top,\n.bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem;\n}\n\n.bs-popover-top>.arrow,\n.bs-popover-auto[x-placement^=\"top\"]>.arrow {\n  bottom: calc(-0.5rem - 1px);\n}\n\n.bs-popover-top>.arrow::before,\n.bs-popover-auto[x-placement^=\"top\"]>.arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-top>.arrow::after,\n.bs-popover-auto[x-placement^=\"top\"]>.arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-right,\n.bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem;\n}\n\n.bs-popover-right>.arrow,\n.bs-popover-auto[x-placement^=\"right\"]>.arrow {\n  left: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n\n.bs-popover-right>.arrow::before,\n.bs-popover-auto[x-placement^=\"right\"]>.arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-right>.arrow::after,\n.bs-popover-auto[x-placement^=\"right\"]>.arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom,\n.bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem;\n}\n\n.bs-popover-bottom>.arrow,\n.bs-popover-auto[x-placement^=\"bottom\"]>.arrow {\n  top: calc(-0.5rem - 1px);\n}\n\n.bs-popover-bottom>.arrow::before,\n.bs-popover-auto[x-placement^=\"bottom\"]>.arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-bottom>.arrow::after,\n.bs-popover-auto[x-placement^=\"bottom\"]>.arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n\n.bs-popover-bottom .popover-header::before,\n.bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #f7f7f7;\n}\n\n.bs-popover-left,\n.bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem;\n}\n\n.bs-popover-left>.arrow,\n.bs-popover-auto[x-placement^=\"left\"]>.arrow {\n  right: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3rem 0;\n}\n\n.bs-popover-left>.arrow::before,\n.bs-popover-auto[x-placement^=\"left\"]>.arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-left>.arrow::after,\n.bs-popover-auto[x-placement^=\"left\"]>.arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #3d4465;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #7e7e7e;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .carousel-fade .active.carousel-item-left,\n  .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n\n.carousel-control-prev:hover,\n.carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: no-repeat 50% / 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n\n.carousel-indicators li {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: .5;\n  transition: opacity 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border .75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow .75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #00ADEE !important;\n}\n\na.bg-primary:hover,\na.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #6d23cc !important;\n}\n\n.bg-secondary {\n  background-color: #3F9AE0 !important;\n}\n\na.bg-secondary:hover,\na.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #2181cb !important;\n}\n\n.bg-success {\n  background-color: #2BC155 !important;\n}\n\na.bg-success:hover,\na.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #229743 !important;\n}\n\n.bg-info {\n  background-color: #2D28FF !important;\n}\n\na.bg-info:hover,\na.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #0600f4 !important;\n}\n\n.bg-warning {\n  background-color: #FF9B52 !important;\n}\n\na.bg-warning:hover,\na.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #ff7e1f !important;\n}\n\n.bg-danger {\n  background-color: #F94687 !important;\n}\n\na.bg-danger:hover,\na.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #f71567 !important;\n}\n\n.bg-light {\n  background-color: #F4F5F9 !important;\n}\n\na.bg-light:hover,\na.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #d3d7e7 !important;\n}\n\n.bg-dark {\n  background-color: #B1B1B1 !important;\n}\n\na.bg-dark:hover,\na.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #989898 !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #EEEEEE !important;\n}\n\n.border-top {\n  border-top: 1px solid #EEEEEE !important;\n}\n\n.border-right {\n  border-right: 1px solid #EEEEEE !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #EEEEEE !important;\n}\n\n.border-left {\n  border-left: 1px solid #EEEEEE !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #00ADEE !important;\n}\n\n.border-secondary {\n  border-color: #3F9AE0 !important;\n}\n\n.border-success {\n  border-color: #2BC155 !important;\n}\n\n.border-info {\n  border-color: #2D28FF !important;\n}\n\n.border-warning {\n  border-color: #FF9B52 !important;\n}\n\n.border-danger {\n  border-color: #F94687 !important;\n}\n\n.border-light {\n  border-color: #F4F5F9 !important;\n}\n\n.border-dark {\n  border-color: #B1B1B1 !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded-sm {\n  border-radius: 0.2rem !important;\n}\n\n.rounded {\n  border-radius: 0.75rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.75rem !important;\n  border-top-right-radius: 0.75rem !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 0.75rem !important;\n  border-bottom-right-radius: 0.75rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.75rem !important;\n  border-bottom-left-radius: 0.75rem !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 0.75rem !important;\n  border-bottom-left-radius: 0.75rem !important;\n}\n\n.rounded-lg {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .d-xxl-none {\n    display: none !important;\n  }\n\n  .d-xxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxl-block {\n    display: block !important;\n  }\n\n  .d-xxl-table {\n    display: table !important;\n  }\n\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxl-flex {\n    display: flex !important;\n  }\n\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.8571428571%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n}\n\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n\n  .float-sm-right {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n\n  .float-md-right {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n\n  .float-lg-right {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n\n  .float-xl-right {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .float-xxl-left {\n    float: left !important;\n  }\n\n  .float-xxl-right {\n    float: right !important;\n  }\n\n  .float-xxl-none {\n    float: none !important;\n  }\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -3rem !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n  }\n\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n  }\n\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n  }\n\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important;\n  }\n\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n\n  .m-sm-n5 {\n    margin: -3rem !important;\n  }\n\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important;\n  }\n\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important;\n  }\n\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important;\n  }\n\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n  }\n\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n  }\n\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important;\n  }\n\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n  }\n\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important;\n  }\n\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n\n  .m-md-n5 {\n    margin: -3rem !important;\n  }\n\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important;\n  }\n\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important;\n  }\n\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important;\n  }\n\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n  }\n\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n  }\n\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n  }\n\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important;\n  }\n\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n\n  .m-lg-n5 {\n    margin: -3rem !important;\n  }\n\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important;\n  }\n\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important;\n  }\n\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important;\n  }\n\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n  }\n\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n  }\n\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n  }\n\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important;\n  }\n\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n\n  .m-xl-n5 {\n    margin: -3rem !important;\n  }\n\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important;\n  }\n\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important;\n  }\n\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important;\n  }\n\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xxl-0,\n  .my-xxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xxl-0,\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xxl-0,\n  .my-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xxl-0,\n  .mx-xxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .mt-xxl-1,\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mr-xxl-1,\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .mb-xxl-1,\n  .my-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .ml-xxl-1,\n  .mx-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .mt-xxl-2,\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mr-xxl-2,\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .mb-xxl-2,\n  .my-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .ml-xxl-2,\n  .mx-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n\n  .mt-xxl-3,\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mr-xxl-3,\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n  }\n\n  .mb-xxl-3,\n  .my-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .ml-xxl-3,\n  .mx-xxl-3 {\n    margin-left: 1rem !important;\n  }\n\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n\n  .mt-xxl-4,\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mr-xxl-4,\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .mb-xxl-4,\n  .my-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .ml-xxl-4,\n  .mx-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n\n  .mt-xxl-5,\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mr-xxl-5,\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n  }\n\n  .mb-xxl-5,\n  .my-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .ml-xxl-5,\n  .mx-xxl-5 {\n    margin-left: 3rem !important;\n  }\n\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xxl-0,\n  .py-xxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xxl-0,\n  .px-xxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xxl-0,\n  .py-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xxl-0,\n  .px-xxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .pt-xxl-1,\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pr-xxl-1,\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pb-xxl-1,\n  .py-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pl-xxl-1,\n  .px-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .pt-xxl-2,\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pr-xxl-2,\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pb-xxl-2,\n  .py-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pl-xxl-2,\n  .px-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n\n  .pt-xxl-3,\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pr-xxl-3,\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pb-xxl-3,\n  .py-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pl-xxl-3,\n  .px-xxl-3 {\n    padding-left: 1rem !important;\n  }\n\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n\n  .pt-xxl-4,\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pr-xxl-4,\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pb-xxl-4,\n  .py-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pl-xxl-4,\n  .px-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n\n  .pt-xxl-5,\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pr-xxl-5,\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-xxl-5,\n  .py-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pl-xxl-5,\n  .px-xxl-5 {\n    padding-left: 3rem !important;\n  }\n\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .mt-xxl-n1,\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mr-xxl-n1,\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .mb-xxl-n1,\n  .my-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .ml-xxl-n1,\n  .mx-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .mt-xxl-n2,\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mr-xxl-n2,\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .mb-xxl-n2,\n  .my-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .ml-xxl-n2,\n  .mx-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .m-xxl-n3 {\n    margin: -1rem !important;\n  }\n\n  .mt-xxl-n3,\n  .my-xxl-n3 {\n    margin-top: -1rem !important;\n  }\n\n  .mr-xxl-n3,\n  .mx-xxl-n3 {\n    margin-right: -1rem !important;\n  }\n\n  .mb-xxl-n3,\n  .my-xxl-n3 {\n    margin-bottom: -1rem !important;\n  }\n\n  .ml-xxl-n3,\n  .mx-xxl-n3 {\n    margin-left: -1rem !important;\n  }\n\n  .m-xxl-n4 {\n    margin: -1.5rem !important;\n  }\n\n  .mt-xxl-n4,\n  .my-xxl-n4 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mr-xxl-n4,\n  .mx-xxl-n4 {\n    margin-right: -1.5rem !important;\n  }\n\n  .mb-xxl-n4,\n  .my-xxl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .ml-xxl-n4,\n  .mx-xxl-n4 {\n    margin-left: -1.5rem !important;\n  }\n\n  .m-xxl-n5 {\n    margin: -3rem !important;\n  }\n\n  .mt-xxl-n5,\n  .my-xxl-n5 {\n    margin-top: -3rem !important;\n  }\n\n  .mr-xxl-n5,\n  .mx-xxl-n5 {\n    margin-right: -3rem !important;\n  }\n\n  .mb-xxl-n5,\n  .my-xxl-n5 {\n    margin-bottom: -3rem !important;\n  }\n\n  .ml-xxl-n5,\n  .mx-xxl-n5 {\n    margin-left: -3rem !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xxl-auto,\n  .my-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xxl-auto,\n  .mx-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-auto,\n  .my-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xxl-auto,\n  .mx-xxl-auto {\n    margin-left: auto !important;\n  }\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n\n  .text-sm-right {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n\n  .text-md-right {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n\n  .text-lg-right {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n\n  .text-xl-right {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .text-xxl-left {\n    text-align: left !important;\n  }\n\n  .text-xxl-right {\n    text-align: right !important;\n  }\n\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n\n.font-weight-bolder {\n  font-weight: bolder !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-primary {\n  color: #00ADEE !important;\n}\n\na.text-primary:hover,\na.text-primary:focus {\n  color: #611fb6 !important;\n}\n\n.text-secondary {\n  color: #3F9AE0 !important;\n}\n\na.text-secondary:hover,\na.text-secondary:focus {\n  color: #1d73b5 !important;\n}\n\n.text-success {\n  color: #2BC155 !important;\n}\n\na.text-success:hover,\na.text-success:focus {\n  color: #1d8239 !important;\n}\n\n.text-info {\n  color: #2D28FF !important;\n}\n\na.text-info:hover,\na.text-info:focus {\n  color: #0500db !important;\n}\n\n.text-warning {\n  color: #FF9B52 !important;\n}\n\na.text-warning:hover,\na.text-warning:focus {\n  color: #ff6f06 !important;\n}\n\n.text-danger {\n  color: #F94687 !important;\n}\n\na.text-danger:hover,\na.text-danger:focus {\n  color: #eb085a !important;\n}\n\n.text-light {\n  color: #F4F5F9 !important;\n}\n\na.text-light:hover,\na.text-light:focus {\n  color: #c3c8de !important;\n}\n\n.text-dark {\n  color: #B1B1B1 !important;\n}\n\na.text-dark:hover,\na.text-dark:focus {\n  color: #8b8b8b !important;\n}\n\n.text-body {\n  color: #7e7e7e !important;\n}\n\n.text-muted {\n  color: #89879f !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  word-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  pre {\n    white-space: pre-wrap !important;\n  }\n\n  pre,\n  blockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid;\n  }\n\n  thead {\n    display: table-header-group;\n  }\n\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n\n  @page {\n    size: a3;\n  }\n\n  body {\n    min-width: 992px !important;\n  }\n\n  .container {\n    min-width: 992px !important;\n  }\n\n  .navbar {\n    display: none;\n  }\n\n  .badge {\n    border: 1px solid #000;\n  }\n\n  .table {\n    border-collapse: collapse !important;\n  }\n\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6 !important;\n  }\n\n  .table-dark {\n    color: inherit;\n  }\n\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th,\n  .table-dark tbody+tbody {\n    border-color: #EEEEEE;\n  }\n\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #EEEEEE;\n  }\n}\n\n.c-pointer {\n  cursor: pointer;\n}\n\n* {\n  outline: none;\n  padding: 0;\n}\n\n*::after {\n  margin: 0;\n  padding: 0;\n}\n\n*::before {\n  margin: 0;\n  padding: 0;\n}\n\n::selection {\n  color: #fff;\n  background: #00ADEE;\n}\n\nbody {\n  overflow-x: hidden;\n  height: 100%;\n  position: relative;\n  max-width: 100%;\n  font-size: 1rem;\n}\n\n@media only screen and (max-width: 991px) {\n  body {\n    font-size: 0.875rem;\n  }\n}\n\n@media only screen and (max-width: 1400px) {\n  h2 {\n    font-size: 1.5rem;\n  }\n}\n\np {\n  line-height: 1.8;\n}\n\n.box-shadow-none {\n  box-shadow: none !important;\n}\n\n#main-wrapper {\n  opacity: 0;\n  transition: all 0.25s ease-in;\n  overflow: hidden;\n  position: relative;\n}\n\n#main-wrapper.show {\n  opacity: 1;\n}\n\n.rounded-lg {\n  border-radius: 1.25rem;\n}\n\n.rounded-xl {\n  border-radius: 12px !important;\n}\n\nul {\n  padding: 0;\n  margin: 0;\n}\n\n/* li {\n  list-style: none;\n} */\n\na {\n  color: #7e7e7e;\n}\n\na:hover,\na:focus,\na.active {\n  text-decoration: none;\n}\n\n.btn-link:hover,\n.btn-link:focus,\n.btn-link.active {\n  text-decoration: none;\n}\n\n.w-space-no {\n  white-space: nowrap;\n}\n\n.content-body .container {\n  margin-top: 40px;\n}\n\n.content-body .container-fluid,\n.content-body .container-sm,\n.content-body .container-md,\n.content-body .container-lg,\n.content-body .container-xl {\n  padding-top: 40px;\n  padding-right: 40px;\n  padding-left: 40px;\n}\n\n@media only screen and (max-width: 1600px) {\n\n  .content-body .container-fluid,\n  .content-body .container-sm,\n  .content-body .container-md,\n  .content-body .container-lg,\n  .content-body .container-xl {\n    padding-top: 30px;\n    padding-right: 30px;\n    padding-left: 30px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n\n  .content-body .container-fluid,\n  .content-body .container-sm,\n  .content-body .container-md,\n  .content-body .container-lg,\n  .content-body .container-xl {\n    padding-top: 20px;\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n\n  .content-body .container-fluid,\n  .content-body .container-sm,\n  .content-body .container-md,\n  .content-body .container-lg,\n  .content-body .container-xl {\n    padding-top: 15px;\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n}\n\n/* sp */\n.row.sp80,\n.sp80 {\n  margin-left: -40px;\n  margin-right: -40px;\n}\n\n.row.sp80 [class*=\"col-\"],\n.sp80 [class*=\"col-\"] {\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.row.sp60,\n.sp60 {\n  margin-left: -30px;\n  margin-right: -30px;\n}\n\n.row.sp60 [class*=\"col-\"],\n.sp60 [class*=\"col-\"] {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n\n.row.sp40,\n.sp40 {\n  margin-left: -20px;\n  margin-right: -20px;\n}\n\n.row.sp40 [class*=\"col-\"],\n.sp40 [class*=\"col-\"] {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.row.sp20,\n.sp20 {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.row.sp20 [class*=\"col-\"],\n.sp20 [class*=\"col-\"] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.row.sp16,\n.sp16 {\n  margin-left: -8px;\n  margin-right: -8px;\n}\n\n.row.sp16 [class*=\"col-\"],\n.sp16 [class*=\"col-\"] {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.row.sp10,\n.sp10 {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n\n.row.sp10 [class*=\"col-\"],\n.sp10 [class*=\"col-\"] {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.row.sp4,\n.sp4 {\n  margin-left: -2px;\n  margin-right: -2px;\n}\n\n.row.sp4 [class*=\"col-\"],\n.sp4 [class*=\"col-\"] {\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.row.spno,\n.spno {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.row.spno [class*=\"col-\"],\n.spno [class*=\"col-\"] {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.content-heading {\n  font-size: 16px;\n  margin-bottom: 1.875rem;\n  margin-top: 3.125rem;\n  border-bottom: 1px solid #f0f1f5;\n  padding-bottom: 10px;\n}\n\n[direction=\"rtl\"] .content-heading {\n  text-align: right;\n}\n\n.text-ov {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.btn-primary:not(:disabled):not(.disabled).active:focus {\n  box-shadow: none;\n}\n\n.op1 {\n  opacity: 0.1;\n}\n\n.op2 {\n  opacity: 0.2;\n}\n\n.op3 {\n  opacity: 0.3;\n}\n\n.op4 {\n  opacity: 0.4;\n}\n\n.op5 {\n  opacity: 0.5;\n}\n\n.op6 {\n  opacity: 0.6;\n}\n\n.op7 {\n  opacity: 0.7;\n}\n\n.op8 {\n  opacity: 0.8;\n}\n\n.op9 {\n  opacity: 0.9;\n}\n\n.wspace-no {\n  white-space: nowrap;\n}\n\n.support-ticket {\n  position: fixed;\n  bottom: 30px;\n  right: 15px;\n  z-index: 999999;\n}\n\n.support-ticket-btn {\n  width: 100px;\n  background: #7CB442;\n  animation: 0.7s ease-in-out 0s infinite alternate none running crescendo;\n  border-radius: 50px;\n  color: #fff;\n  font-size: 8px;\n  font-size: 16px;\n  padding: 5px 10px 7px;\n  text-align: center;\n  display: inline-block;\n  box-shadow: rgba(124, 180, 66, 0.7) 0px 8px 35px 0px;\n}\n\n.support-ticket-btn:hover,\n.support-ticket-btn:focus {\n  color: #fff;\n}\n\n.text-blue {\n  color: #5e72e4;\n}\n\n.text-indigo {\n  color: #6610f2;\n}\n\n.text-purple {\n  color: #6f42c1;\n}\n\n.text-pink {\n  color: #e83e8c;\n}\n\n.text-red {\n  color: #EE3232;\n}\n\n.text-orange {\n  color: #ff9900;\n}\n\n.text-yellow {\n  color: #FFFA6F;\n}\n\n.text-green {\n  color: #297F00;\n}\n\n.text-teal {\n  color: #20c997;\n}\n\n.text-cyan {\n  color: #3065D0;\n}\n\n.bg-gray-dark {\n  background: #143b64 !important;\n}\n\n.bg-purpal {\n  background: #4527a0 !important;\n}\n\n.bg-red {\n  background: #c62828 !important;\n}\n\n.bg-blue-dark {\n  background: #283593 !important;\n}\n\n.bg-blue {\n  background: #7356f1 !important;\n}\n\n.bg-blue-light {\n  background: #3695eb !important;\n}\n\n.bg-green-light {\n  background: #00838f !important;\n}\n\n.bg-green {\n  background: #ff8f16 !important;\n}\n\n.bg-black {\n  background: #000;\n}\n\n.text-black {\n  color: #000 !important;\n}\n\n.dz-scroll {\n  position: relative;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.list-inline li {\n  display: inline-block;\n}\n\n.fs-12 {\n  font-size: 12px !important;\n  line-height: 1.3;\n}\n\n.fs-13 {\n  font-size: 13px !important;\n  line-height: 1.4;\n}\n\n.fs-14 {\n  font-size: 14px !important;\n  line-height: 1.5;\n}\n\n.fs-15 {\n  font-size: 14px !important;\n  line-height: 1.5;\n}\n\n.fs-16 {\n  font-size: 16px !important;\n  line-height: 1.5;\n}\n\n.fs-18 {\n  font-size: 18px !important;\n  line-height: 1.5;\n}\n\n.fs-20 {\n  font-size: 20px !important;\n  line-height: 1.5;\n}\n\n.fs-22 {\n  font-size: 22px !important;\n  line-height: 1.5;\n}\n\n.fs-24 {\n  font-size: 24px !important;\n  line-height: 1.4;\n}\n\n.fs-26 {\n  font-size: 26px !important;\n  line-height: 1.4;\n}\n\n.fs-28 {\n  font-size: 28px !important;\n  line-height: 1.4;\n}\n\n.fs-30 {\n  font-size: 30px !important;\n  line-height: 1.4;\n}\n\n.fs-32 {\n  font-size: 32px !important;\n  line-height: 1.25;\n}\n\n.fs-34 {\n  font-size: 34px !important;\n  line-height: 1.25;\n}\n\n.fs-35 {\n  font-size: 35px !important;\n  line-height: 1.25;\n}\n\n.fs-36 {\n  font-size: 36px !important;\n  line-height: 1.25;\n}\n\n.fs-38 {\n  font-size: 38px !important;\n  line-height: 1.25;\n}\n\n.fs-46 {\n  font-size: 46px !important;\n  line-height: 1.25;\n}\n\n.fs-48 {\n  font-size: 48px !important;\n  line-height: 1.25;\n}\n\n.font-w100 {\n  font-weight: 100;\n}\n\n.font-w200 {\n  font-weight: 200;\n}\n\n.font-w300 {\n  font-weight: 300;\n}\n\n.font-w400 {\n  font-weight: 400;\n}\n\n.font-w500 {\n  font-weight: 500;\n}\n\n.font-w600 {\n  font-weight: 600;\n}\n\n.font-w700 {\n  font-weight: 700;\n}\n\n.font-w800 {\n  font-weight: 800;\n}\n\n.font-w900 {\n  font-weight: 900;\n}\n\n.scale1 {\n  transform: scale(1.1);\n  -moz-transform: scale(1.1);\n  -webkit-transform: scale(1.1);\n  -ms-transform: scale(1.1);\n  -o-transform: scale(1.1);\n  display: inline-block;\n}\n\n.scale2 {\n  transform: scale(1.2);\n  -moz-transform: scale(1.2);\n  -webkit-transform: scale(1.2);\n  -ms-transform: scale(1.2);\n  -o-transform: scale(1.2);\n  display: inline-block;\n}\n\n.scale3 {\n  transform: scale(1.3);\n  -moz-transform: scale(1.3);\n  -webkit-transform: scale(1.3);\n  -ms-transform: scale(1.3);\n  -o-transform: scale(1.3);\n  display: inline-block;\n}\n\n.scale4 {\n  transform: scale(1.4);\n  -moz-transform: scale(1.4);\n  -webkit-transform: scale(1.4);\n  -ms-transform: scale(1.4);\n  -o-transform: scale(1.4);\n  display: inline-block;\n}\n\n.scale5 {\n  transform: scale(1.5);\n  -moz-transform: scale(1.5);\n  -webkit-transform: scale(1.5);\n  -ms-transform: scale(1.5);\n  -o-transform: scale(1.5);\n  display: inline-block;\n}\n\n.scale21 {\n  transform: scale(2);\n  -moz-transform: scale(2);\n  -webkit-transform: scale(2);\n  -ms-transform: scale(2);\n  -o-transform: scale(2);\n  display: inline-block;\n}\n\n.height10 {\n  height: 10px;\n}\n\n.height20 {\n  height: 20px;\n}\n\n.height30 {\n  height: 30px;\n}\n\n.height40 {\n  height: 40px;\n}\n\n.height50 {\n  height: 50px;\n}\n\n.height60 {\n  height: 60px;\n}\n\n.height70 {\n  height: 70px;\n}\n\n.height80 {\n  height: 80px;\n}\n\n.height90 {\n  height: 90px;\n}\n\n.height100 {\n  height: 100px;\n}\n\n.height110 {\n  height: 110px;\n}\n\n.height120 {\n  height: 120px;\n}\n\n.height130 {\n  height: 130px;\n}\n\n.height140 {\n  height: 140px;\n}\n\n.height150 {\n  height: 150px;\n}\n\n.height160 {\n  height: 160px;\n}\n\n.height170 {\n  height: 170px;\n}\n\n.height180 {\n  height: 180px;\n}\n\n.height190 {\n  height: 190px;\n}\n\n.height200 {\n  height: 200px;\n}\n\n.height210 {\n  height: 210px;\n}\n\n.height220 {\n  height: 220px;\n}\n\n.height230 {\n  height: 230px;\n}\n\n.height240 {\n  height: 240px;\n}\n\n.height250 {\n  height: 250px;\n}\n\n.height260 {\n  height: 260px;\n}\n\n.height270 {\n  height: 270px;\n}\n\n.height280 {\n  height: 280px;\n}\n\n.height290 {\n  height: 290px;\n}\n\n.height300 {\n  height: 300px;\n}\n\n.height310 {\n  height: 310px;\n}\n\n.height320 {\n  height: 320px;\n}\n\n.height330 {\n  height: 330px;\n}\n\n.height340 {\n  height: 340px;\n}\n\n.height350 {\n  height: 350px;\n}\n\n.height360 {\n  height: 360px;\n}\n\n.height370 {\n  height: 370px;\n}\n\n.height380 {\n  height: 380px;\n}\n\n.height390 {\n  height: 390px;\n}\n\n.height400 {\n  height: 400px;\n}\n\n.height415 {\n  height: 415px;\n}\n\n.height720 {\n  height: 720px;\n}\n\n.height800 {\n  height: 800px;\n}\n\n.width10 {\n  width: 10px;\n}\n\n.width20 {\n  width: 20px;\n}\n\n.width30 {\n  width: 30px;\n}\n\n.width40 {\n  width: 40px;\n}\n\n.width50 {\n  width: 50px;\n}\n\n.width60 {\n  width: 60px;\n}\n\n.width70 {\n  width: 70px;\n}\n\n.width80 {\n  width: 80px;\n}\n\n.width90 {\n  width: 90px;\n}\n\n.width100 {\n  width: 100px;\n}\n\n.width110 {\n  width: 110px;\n}\n\n.width120 {\n  width: 120px;\n}\n\n.width130 {\n  width: 130px;\n}\n\n.width140 {\n  width: 140px;\n}\n\n.width150 {\n  width: 150px;\n}\n\n.width160 {\n  width: 160px;\n}\n\n.width170 {\n  width: 170px;\n}\n\n.width180 {\n  width: 180px;\n}\n\n.width190 {\n  width: 190px;\n}\n\n.width200 {\n  width: 200px;\n}\n\n.width210 {\n  width: 210px;\n}\n\n.width220 {\n  width: 220px;\n}\n\n.width230 {\n  width: 230px;\n}\n\n.width240 {\n  width: 240px;\n}\n\n.width250 {\n  width: 250px;\n}\n\n.width260 {\n  width: 260px;\n}\n\n.width270 {\n  width: 270px;\n}\n\n.width280 {\n  width: 280px;\n}\n\n.width290 {\n  width: 290px;\n}\n\n.width300 {\n  width: 300px;\n}\n\n.width310 {\n  width: 310px;\n}\n\n.width320 {\n  width: 320px;\n}\n\n.width330 {\n  width: 330px;\n}\n\n.width340 {\n  width: 340px;\n}\n\n.width350 {\n  width: 350px;\n}\n\n.width360 {\n  width: 360px;\n}\n\n.width370 {\n  width: 370px;\n}\n\n.width380 {\n  width: 380px;\n}\n\n.width390 {\n  width: 390px;\n}\n\n.width400 {\n  width: 400px;\n}\n\n@-webkit-keyframes crescendo {\n  from {\n    -webkit-transform: translateY(5px) scale(0.8);\n    -ms-transform: translateY(5px) scale(0.8);\n    transform: translateY(5px) scale(0.8);\n  }\n\n  to {\n    -webkit-transform: translateY(0px) scale(1);\n    -ms-transform: translateY(0px) scale(1);\n    transform: translateY(0px) scale(1);\n  }\n}\n\n@keyframes gXGDoR {\n  from {\n    -webkit-transform: translateY(5px) scale(0.8);\n    -ms-transform: translateY(5px) scale(0.8);\n    transform: translateY(5px) scale(0.8);\n  }\n\n  to {\n    -webkit-transform: translateY(0px) scale(1);\n    -ms-transform: translateY(0px) scale(1);\n    transform: translateY(0px) scale(1);\n  }\n}\n\n@keyframes crescendo {\n  from {\n    -webkit-transform: translateY(5px) scale(0.8);\n    -ms-transform: translateY(5px) scale(0.8);\n    transform: translateY(5px) scale(0.8);\n  }\n\n  to {\n    -webkit-transform: translateY(0px) scale(1);\n    -ms-transform: translateY(0px) scale(1);\n    transform: translateY(0px) scale(1);\n  }\n}\n\n@keyframes gXGDoR {\n  from {\n    -webkit-transform: translateY(5px) scale(0.8);\n    -ms-transform: translateY(5px) scale(0.8);\n    transform: translateY(5px) scale(0.8);\n  }\n\n  to {\n    -webkit-transform: translateY(0px) scale(1);\n    -ms-transform: translateY(0px) scale(1);\n    transform: translateY(0px) scale(1);\n  }\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n  .col-xxl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-xxl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-xxl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xxl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-xxl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-xxl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xxl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-xxl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-xxl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xxl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-xxl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-xxl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n}\n\n/* Editable */\n#preloader {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background-color: #fff;\n}\n\n.sk-three-bounce {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background-color: white;\n}\n\n.sk-three-bounce .sk-child {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  background-color: #00ADEE;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;\n  animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;\n}\n\n.sk-three-bounce .sk-bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.sk-three-bounce .sk-bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-three-bounce {\n\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-three-bounce {\n\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n.footer {\n  padding-left: 21.563rem;\n  background-color: #E5E6E7;\n}\n\n@media only screen and (max-width: 1400px) {\n  .footer {\n    padding-left: 17rem;\n  }\n}\n\n.footer .copyright {\n  padding: 0.9375rem;\n}\n\n.footer .copyright p {\n  text-align: center;\n  margin: 0;\n}\n\n.footer .copyright a {\n  color: #00ADEE;\n}\n\n@media only screen and (min-width: 991px) {\n  .footer .copyright {\n    border-radius: 0 0 0 50px;\n  }\n}\n\n[data-sidebar-style=\"mini\"] .nav-control,\n[data-layout=\"horizontal\"] .nav-control {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  [data-sidebar-style=\"overlay\"] .nav-header .logo-abbr {\n    display: block;\n  }\n}\n\n[data-header-position=\"fixed\"] .nav-header {\n  position: fixed;\n  left: auto;\n}\n\n.nav-header {\n  height: 5rem;\n  width: 230px;\n  display: inline-block;\n  text-align: left;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: #fff;\n  transition: all .2s ease;\n  z-index: 5;\n}\n\n.nav-header .logo-abbr {\n  max-width: 52px;\n}\n\n@media only screen and (max-width: 575px) {\n  .nav-header .logo-abbr {\n    max-width: 40px;\n  }\n}\n\n.nav-header .logo-compact {\n  display: none;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1400px) {\n  .nav-header {\n    width: 15rem;\n  }\n}\n\n.nav-header .brand-logo {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 1.125rem;\n  color: #fff;\n  text-decoration: none;\n  padding-left: 20px;\n  padding-right: 50px;\n  font-weight: 700;\n}\n\n@media only screen and (max-width: 1400px) {\n  .nav-header .brand-logo {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n}\n\n[data-sidebar-style=\"compact\"] .nav-header .brand-logo,\n[data-sidebar-style=\"mini\"] .nav-header .brand-logo {\n  padding-left: 0;\n  padding-right: 0;\n  justify-content: center;\n}\n\n@media only screen and (max-width: 767px) {\n  .nav-header .brand-logo {\n    padding-left: 0;\n    padding-right: 0;\n    justify-content: center;\n  }\n}\n\n.nav-header .brand-title {\n  margin-left: 0px;\n  max-width: 120px;\n  margin-top: 0px;\n}\n\n[data-theme-version=\"dark\"] .nav-header .brand-title {\n  background-position: 0 120%;\n}\n\n@media only screen and (max-width: 1199px) {\n  .nav-header {\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .nav-header .brand-title {\n    display: none;\n  }\n}\n\n.nav-control {\n  cursor: pointer;\n  position: absolute;\n  right: -4.0625rem;\n  text-align: center;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 9999;\n  font-size: 1.4rem;\n  padding: 2px 0.5rem 0;\n  border-radius: 2px;\n}\n\n@media only screen and (max-width: 767px) {\n  .nav-control {\n    right: -2.75rem;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .nav-control {\n    right: -2.75rem;\n  }\n}\n\n.hamburger {\n  display: inline-block;\n  left: 0px;\n  position: relative;\n  top: 3px;\n  -webkit-transition: all 0.3s ease-in-out 0s;\n  transition: all 0.3s ease-in-out 0s;\n  width: 26px;\n  z-index: 999;\n}\n\n.hamburger .line {\n  background: #00ADEE;\n  display: block;\n  height: 3px;\n  border-radius: 3px;\n  margin-top: 6px;\n  margin-bottom: 6px;\n  margin-left: auto;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.hamburger .line:nth-child(1) {\n  width: 20px;\n}\n\n.hamburger .line:nth-child(2) {\n  width: 26px;\n}\n\n.hamburger .line:nth-child(3) {\n  width: 22px;\n}\n\n.hamburger:hover {\n  cursor: pointer;\n}\n\n.hamburger:hover .line {\n  width: 26px;\n}\n\n/*\n    .hamburger.is-active {\n      left: 60px;\n    }\n    */\n.hamburger.is-active .line:nth-child(1),\n.hamburger.is-active .line:nth-child(3) {\n  width: 10px;\n  height: 2px;\n}\n\n.hamburger.is-active .line:nth-child(2) {\n  -webkit-transform: translateX(0px);\n  transform: translateX(0px);\n  width: 22px;\n  height: 2px;\n}\n\n.hamburger.is-active .line:nth-child(1) {\n  -webkit-transform: translateY(4px) rotate(45deg);\n  transform: translateY(4px) rotate(45deg);\n}\n\n.hamburger.is-active .line:nth-child(3) {\n  -webkit-transform: translateY(-4px) rotate(-45deg);\n  transform: translateY(-4px) rotate(-45deg);\n}\n\n@media (min-width: 767px) {\n  [data-sidebar-style=\"compact\"] .nav-control {\n    display: none;\n  }\n\n  [data-sidebar-style=\"compact\"] .nav-header {\n    width: 15rem;\n  }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .brand-title {\n  display: none;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .logo-abbr {\n  display: block;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"horizontal\"] .logo-compact {\n  display: none;\n}\n\n[data-sidebar-style=\"mini\"] .nav-header .logo-abbr {\n  display: block;\n}\n\n[data-sidebar-style=\"compact\"][data-layout=\"vertical\"] .nav-header .brand-title {\n  /* display: none; */\n}\n\n[data-sidebar-style=\"compact\"][data-layout=\"vertical\"] .nav-header .logo-compact {\n  max-width: 75px;\n}\n\n[data-sidebar-style=\"compact\"][data-layout=\"horizontal\"] .nav-header .brand-logo {\n  padding-left: 30px;\n  padding-right: 30px;\n  justify-content: start;\n}\n\n[data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .nav-header {\n  width: 9.375rem;\n}\n\n[data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .nav-header .brand-title {\n  display: none;\n}\n\n[data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .nav-header .logo-compact {\n  display: none;\n}\n\n.header {\n  height: 5rem;\n  z-index: 1;\n  position: relative;\n  padding: 0rem;\n  background-color: #fff;\n  z-index: 4;\n  padding-left: 230px;\n  transition: all .2s ease;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header {\n    padding-left: 17rem;\n  }\n}\n\n.header .header-content {\n  height: 100%;\n  padding-left: 5.3125rem;\n  padding-right: 2.4rem;\n  align-items: center;\n  display: flex;\n}\n\n@media only screen and (max-width: 767px) {\n  .header .header-content {\n    padding-left: 3.75rem;\n    padding-right: 0.938rem;\n    border-radius: 0;\n  }\n}\n\n.header .navbar {\n  padding: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.header .navbar .navbar-collapse {\n  height: 100%;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1199px) {\n  .header {\n    height: 5rem;\n  }\n}\n\n/* pulse in SVG */\nsvg.pulse-svg {\n  overflow: visible;\n}\n\nsvg.pulse-svg .first-circle,\nsvg.pulse-svg .second-circle,\nsvg.pulse-svg .third-circle {\n  -webkit-transform: scale(0.3);\n  transform: scale(0.3);\n  -webkit-transform-origin: center center;\n  transform-origin: center center;\n  -webkit-animation: pulse-me 3s linear infinite;\n  animation: pulse-me 3s linear infinite;\n  fill: #00ADEE;\n}\n\nsvg.pulse-svg .second-circle {\n  -webkit-animation-delay: 1s;\n  animation-delay: 1s;\n}\n\nsvg.pulse-svg .third-circle {\n  -webkit-animation-delay: 2s;\n  animation-delay: 2s;\n}\n\n/* pulse in CSS */\n.pulse-css {\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.5rem;\n  border-radius: 3.5rem;\n  height: 1rem;\n  position: absolute;\n  background: #FF507A;\n  right: 5px;\n  top: 5px;\n  width: 1rem;\n}\n\n.pulse-css:after,\n.pulse-css:before {\n  content: '';\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.5rem;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: -.2rem;\n  background-color: #FF507A;\n  margin: auto;\n  -webkit-transform: scale(0.3);\n  transform: scale(0.3);\n  -webkit-transform-origin: center center;\n  transform-origin: center center;\n  -webkit-animation: pulse-me 3s linear infinite;\n  animation: pulse-me 3s linear infinite;\n}\n\n[direction=\"rtl\"] .pulse-css:after,\n[direction=\"rtl\"] .pulse-css:before {\n  left: auto;\n  right: -.2rem;\n}\n\n@media only screen and (max-width: 1400px) {\n  .pulse-css {\n    height: 0.5rem;\n    width: 0.5rem;\n  }\n}\n\n@-webkit-keyframes pulse-me {\n  0% {\n    -webkit-transform: scale(0.3);\n    transform: scale(0.3);\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0.1;\n  }\n\n  70% {\n    opacity: 0.09;\n  }\n\n  100% {\n    -webkit-transform: scale(3);\n    transform: scale(3);\n    opacity: 0;\n  }\n}\n\n@keyframes pulse-me {\n  0% {\n    -webkit-transform: scale(0.3);\n    transform: scale(0.3);\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0.1;\n  }\n\n  70% {\n    opacity: 0.09;\n  }\n\n  100% {\n    -webkit-transform: scale(3);\n    transform: scale(3);\n    opacity: 0;\n  }\n}\n\n[data-sidebar-style=\"full\"] .header,\n[data-sidebar-style=\"overlay\"] .header {\n  width: 100%;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1350px) {\n\n  [data-sidebar-style=\"full\"] .header,\n  [data-sidebar-style=\"overlay\"] .header {\n    width: 100%;\n    padding-left: 17rem;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n\n  [data-sidebar-style=\"full\"] .header,\n  [data-sidebar-style=\"overlay\"] .header {\n    width: 100%;\n    padding-left: 5rem;\n  }\n}\n\n[data-sidebar-style=\"mini\"] .header {\n  width: 100%;\n  padding-left: 5rem;\n}\n\n[data-sidebar-style=\"compact\"] .header {\n  width: 100%;\n  padding-left: 15rem;\n}\n\n[data-sidebar-style=\"compact\"] .header .header-content {\n  padding-left: 2.4rem;\n}\n\n[data-header-position=\"fixed\"] .header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n}\n\n[data-header-position=\"fixed\"] .content-body {\n  padding-top: 4rem;\n}\n\n@media only screen and (max-width: 1199px) {\n  [data-header-position=\"fixed\"] .content-body {\n    padding-top: 5rem;\n  }\n}\n\n[data-header-position=\"fixed\"] .deznav {\n  margin-top: 0;\n}\n\n[data-sidebar-style=\"compact\"][data-header-position=\"fixed\"][data-container=\"boxed\"][data-layout=\"vertical\"] .header {\n  width: 1199px;\n}\n\n[data-sidebar-style=\"modern\"] .header {\n  width: 100%;\n  padding-left: 9.375rem;\n}\n\n[data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .nav-header .brand-logo {\n  justify-content: start;\n}\n\n[data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .header .header-content {\n  padding-left: 30px;\n}\n\n.header-left {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.header-left .dashboard_bar {\n  font-size: 28px;\n  font-weight: 600;\n  color: #000;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-left .dashboard_bar {\n    font-size: 24px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header-left .dashboard_bar {\n    display: none;\n  }\n}\n\n.header-left input {\n  background: #E5E6E7 !important;\n  min-width: 170px;\n  min-height: 40px;\n  color: #B1B1B1 !important;\n  border-top-left-radius: 1.25rem;\n  border-bottom-left-radius: 1.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  box-shadow: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-right-width: 0 !important;\n  border: 1px solid #ebebeb;\n  border-width: 1px;\n  font-weight: 300;\n}\n\n[direction=\"rtl\"] .header-left input {\n  border-top-right-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.header-left input:focus,\n.header-left input:active,\n.header-left input.active {\n  border-color: #ebebeb;\n  box-shadow: none;\n}\n\n.header-left input::-webkit-input-placeholder {\n  /* Edge */\n  color: #B1B1B1;\n}\n\n.header-left input:-ms-input-placeholder {\n  /* Internet Explorer */\n  color: #B1B1B1;\n}\n\n.header-left input::placeholder {\n  color: #B1B1B1;\n}\n\n.header-left .search_bar {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n@media only screen and (max-width: 767px) {\n  .header-left .search_bar {\n    display: none;\n  }\n}\n\n.header-left .search_bar .dropdown-menu {\n  box-shadow: none;\n}\n\n.header-left .search_bar .search_icon {\n  background: #E5E6E7 !important;\n  height: 56px;\n  line-height: 22px;\n  padding: 15px 20px 15px 0 !important;\n  border-top-right-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n  border: 1px solid #ebebeb;\n  border-width: 1px;\n  border-left-width: 0;\n}\n\n.header-left .search_bar .search_icon i {\n  font-size: 24px;\n  color: #B1B1B1;\n  line-height: 1;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-left .search_bar .search_icon {\n    height: 41px;\n    padding: 8px 15px 8px 0 !important;\n  }\n\n  .header-left .search_bar .search_icon svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header-left .search_bar {\n    position: static;\n  }\n\n  .header-left .search_bar .dropdown-menu {\n    width: 300px;\n    left: -15vw;\n    box-shadow: 0px 5px 10px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 4px !important;\n  }\n}\n\n@media only screen and (max-width: 767px) and (max-width: 575px) {\n  .header-left .search_bar .dropdown-menu {\n    width: 250px;\n    left: -25vw;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header-left .search_bar .dropdown-menu .form-control {\n    border-radius: 4px !important;\n    width: 100%;\n  }\n\n  [direction=\"rtl\"] .header-left .search_bar .dropdown-menu {\n    right: -98px;\n  }\n}\n\n.header-left .search_bar .dropdown-menu,\n.header-left .search_bar .dropdown-menu.show {\n  border: 0px;\n  background-color: transparent;\n  border-top-right-radius: 5rem;\n  border-bottom-right-radius: 5rem;\n}\n\n@media only screen and (min-width: 768px) {\n\n  .header-left .search_bar .dropdown-menu,\n  .header-left .search_bar .dropdown-menu.show {\n    left: 0;\n    top: 0;\n    transform: none;\n    display: block;\n    position: unset;\n  }\n}\n\n[data-sidebar-style=\"compact\"] .header-left {\n  margin-left: 0;\n}\n\n.header-right {\n  height: 100%;\n}\n\n.header-right .nav-item {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.header-right .nav-item .nav-link {\n  color: #464a53;\n  font-size: 18px;\n}\n\n.header-right .right-sidebar {\n  margin-right: -30px;\n}\n\n.header-right .right-sidebar a {\n  height: 80px;\n  width: 80px;\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  border-left: 1px solid #F4F5F9;\n}\n\n.header-right>li:not(:first-child) {\n  padding-left: 2rem;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-right>li:not(:first-child) {\n    padding-left: 1rem;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .header-right>li:not(:first-child) {\n    padding-left: 0.5rem;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .header-right .notification_dropdown {\n    position: static;\n  }\n}\n\n.header-right .notification_dropdown .nav-link {\n  position: relative;\n  color: #00ADEE;\n  background: transparent;\n  border-radius: 0;\n  padding: 12px;\n  line-height: 1;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-right .notification_dropdown .nav-link {\n    padding: 10px;\n  }\n}\n\n.header-right .notification_dropdown .nav-link.secondary {\n  background: #ddedfa;\n  color: #3F9AE0;\n}\n\n.header-right .notification_dropdown .nav-link.secondary [fill] {\n  fill: #3F9AE0;\n}\n\n.header-right .notification_dropdown .nav-link.primary {\n  background: #f6f1fd;\n  color: #00ADEE;\n}\n\n.header-right .notification_dropdown .nav-link.primary [fill] {\n  fill: #00ADEE;\n}\n\n.header-right .notification_dropdown .nav-link.warning {\n  background: #fff3eb;\n  color: #FF9B52;\n}\n\n.header-right .notification_dropdown .nav-link.warning [fill] {\n  fill: #FF9B52;\n}\n\n.header-right .notification_dropdown .nav-link.success {\n  background: #e3f9e9;\n  color: #2BC155;\n}\n\n.header-right .notification_dropdown .nav-link.success [fill] {\n  fill: #2BC155;\n}\n\n.header-right .notification_dropdown .nav-link i {\n  font-size: 24px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-right .notification_dropdown .nav-link i {\n    font-size: 18px;\n  }\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-right .notification_dropdown .nav-link svg {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.header-right .notification_dropdown .nav-link .badge {\n  position: absolute;\n  font-size: 14px;\n  border-radius: 40px;\n  right: -1px;\n  top: 3px;\n  box-shadow: 0px 0px 10px 3px rgba(135, 67, 223, 0.2);\n  font-weight: normal;\n  height: 26px;\n  width: 26px;\n  line-height: 26px;\n  text-align: center;\n  padding: 0px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-right .notification_dropdown .nav-link .badge {\n    right: 3px;\n    top: 3px;\n    font-size: 12px;\n    height: 18px;\n    width: 18px;\n    line-height: 18px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .header-right .notification_dropdown .nav-link .badge {\n    right: -1px;\n    height: 15px;\n    width: 15px;\n    font-size: 10px;\n    line-height: 15px;\n  }\n}\n\n.header-right .notification_dropdown .dropdown-item:focus a,\n.header-right .notification_dropdown .dropdown-item:active a {\n  color: #fff;\n}\n\n.header-right .notification_dropdown .dropdown-item a {\n  color: #B1B1B1;\n}\n\n.header-right .notification_dropdown .dropdown-item a:hover {\n  text-decoration: none;\n}\n\n.header-right .dropdown-menu {\n  border-width: 0;\n  box-shadow: 0 0 37px rgba(8, 21, 66, 0.05);\n}\n\n[data-theme-version=\"dark\"] .header-right .dropdown-menu {\n  box-shadow: none;\n}\n\n.header-right .header-profile>a.nav-link {\n  padding: 0 0 0 0;\n  display: flex;\n  align-items: center;\n  border-radius: 1.25rem 28px 28px 1.25rem;\n}\n\n@media only screen and (max-width: 575px) {\n  .header-right .header-profile>a.nav-link {\n    background: transparent;\n    padding: 0;\n  }\n}\n\n.header-right .header-profile>a.nav-link i {\n  font-weight: 700;\n}\n\n.header-right .header-profile>a.nav-link .header-info {\n  text-align: right;\n  padding-right: 30px;\n}\n\n@media only screen and (max-width: 1199px) {\n  .header-right .header-profile>a.nav-link .header-info {\n    padding-left: 15px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .header-right .header-profile>a.nav-link .header-info {\n    display: none;\n  }\n}\n\n.header-right .header-profile>a.nav-link .header-info span {\n  font-size: 16px;\n  display: block;\n  font-weight: 400;\n}\n\n.header-right .header-profile>a.nav-link .header-info strong {\n  font-weight: 600;\n}\n\n.header-right .header-profile>a.nav-link .header-info small {\n  display: block;\n  font-size: 13px;\n  color: #89879f;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\n.header-right .header-profile .dropdown-menu {\n  padding: 15px 0;\n  min-width: 12.5rem;\n}\n\n.header-right .header-profile .dropdown-menu a:hover,\n.header-right .header-profile .dropdown-menu a:focus,\n.header-right .header-profile .dropdown-menu a.active {\n  color: #00ADEE;\n}\n\n.header-right .header-profile img {\n  width: 57px;\n  height: 57px;\n  border-radius: 60px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .header-right .header-profile img {\n    width: 39px;\n    height: 39px;\n  }\n}\n\n.header-right .header-profile .dropdown-toggle i {\n  font-size: 1.25rem;\n}\n\n@media only screen and (max-width: 575px) {\n  .header-right .header-profile .dropdown-toggle span {\n    display: none;\n  }\n}\n\n.header-right .header-profile .profile_title {\n  background: #00ADEE;\n  color: #fff;\n  padding: 10px 20px;\n}\n\n.header-right .header-profile .profile_title h5 {\n  color: #fff;\n  margin-bottom: 3px;\n}\n\n.header-right .header-profile .dropdown-item {\n  padding: 8px 24px;\n}\n\n.dz-fullscreen #icon-minimize {\n  display: none;\n}\n\n.dz-fullscreen.active #icon-full {\n  display: none;\n}\n\n.dz-fullscreen.active #icon-minimize {\n  display: inline-block;\n}\n\n.notification_dropdown .dropdown-menu-right {\n  min-width: 310px;\n  padding: 0rem 0 1rem;\n  top: 100%;\n}\n\n.notification_dropdown .dropdown-menu-right .notification_title {\n  background: #00ADEE;\n  color: #fff;\n  padding: 10px 20px;\n}\n\n.notification_dropdown .dropdown-menu-right .notification_title h5 {\n  color: #fff;\n  margin-bottom: 3px;\n}\n\n.notification_dropdown .dropdown-menu-right .media {\n  width: 45px !important;\n  height: 45px !important;\n  font-size: 18px !important;\n}\n\n[data-theme-version=\"dark\"] .notification_dropdown .dropdown-menu-right .media {\n  border-color: #333a54;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span {\n  width: 35px;\n  height: 35px;\n  border-radius: 50px;\n  display: inline-block;\n  padding: 7px 9px;\n  margin-right: 10px;\n}\n\n[direction=\"rtl\"].notification_dropdown .dropdown-menu-right .media>span {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span.success {\n  background: #e3f9e9;\n  color: #2BC155;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span.success [fill] {\n  fill: #2BC155;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span.primary {\n  background: #f6f1fd;\n  color: #00ADEE;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span.primary svg [fill] {\n  fill: #00ADEE;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span.danger {\n  background: #fff3f7;\n  color: #F94687;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span.danger [fill] {\n  fill: #F94687;\n}\n\n.notification_dropdown .dropdown-menu-right .media>span [fill] {\n  fill: #00ADEE;\n}\n\n.notification_dropdown .dropdown-menu-right .media .notify-time {\n  width: 100% !important;\n  margin-right: 0 !important;\n  color: #828690;\n}\n\n.notification_dropdown .dropdown-menu-right .media p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 200px;\n  margin-bottom: 0;\n  margin-top: 5px;\n}\n\n@media only screen and (max-width: 575px) {\n  .notification_dropdown .dropdown-menu-right .media p {\n    max-width: 100px;\n  }\n}\n\n.notification_dropdown .dropdown-menu-right .all-notification {\n  display: block;\n  padding: 15px 30px 0;\n  text-align: center;\n  border-top: 1px solid #F4F5F9;\n}\n\n.notification_dropdown .dropdown-menu-right .all-notification i {\n  margin-left: 10px;\n}\n\n.rtl {\n  text-align: right;\n  direction: rtl;\n}\n\n.rtl .nav {\n  padding-right: 0;\n}\n\n.rtl .navbar-nav .nav-item {\n  float: right;\n}\n\n.rtl .navbar-nav .nav-item+.nav-item {\n  margin-right: 1rem;\n  margin-left: inherit;\n}\n\n.rtl th {\n  text-align: right;\n}\n\n.rtl .alert-dismissible {\n  padding-right: 1.25rem;\n  padding-left: 4rem;\n}\n\n.rtl .dropdown-menu {\n  right: 0;\n  text-align: right;\n}\n\n.rtl .checkbox label {\n  padding-right: 1.25rem;\n  padding-left: inherit;\n}\n\n.rtl .btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.rtl .btn-group>.btn:last-child:not(:first-child),\n.rtl .btn-group>.dropdown-toggle:not(:first-child) {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .custom-control-label::after,\n.rtl .custom-control-label::before {\n  right: 0;\n  left: inherit;\n}\n\n.rtl .custom-select {\n  padding: 0.375rem 0.75rem 0.375rem 1.75rem;\n  background: #fff url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") no-repeat left 0.75rem center;\n  background-size: 8px 10px;\n}\n\n.rtl .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),\n.rtl .input-group>.input-group-append:last-child>.input-group-text:not(:last-child),\n.rtl .input-group>.input-group-append:not(:last-child)>.btn,\n.rtl .input-group>.input-group-append:not(:last-child)>.input-group-text,\n.rtl .input-group>.input-group-prepend>.btn,\n.rtl .input-group>.input-group-prepend>.input-group-text {\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.rtl .input-group>.input-group-append>.btn,\n.rtl .input-group>.input-group-append>.input-group-text,\n.rtl .input-group>.input-group-prepend:first-child>.btn:not(:first-child),\n.rtl .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),\n.rtl .input-group>.input-group-prepend:not(:first-child)>.btn,\n.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .input-group>.custom-select:not(:first-child),\n.rtl .input-group>.form-control:not(:first-child) {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .input-group>.custom-select:not(:last-child),\n.rtl .input-group>.form-control:not(:last-child) {\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.rtl .input-group>.custom-select:not(:last-child):not(:first-child),\n.rtl .input-group>.form-control:not(:last-child):not(:first-child) {\n  border-radius: 0;\n}\n\n.rtl .custom-control {\n  padding-right: 1.5rem;\n  padding-left: inherit;\n  margin-right: inherit;\n  margin-left: 1rem;\n}\n\n.rtl .custom-control-indicator {\n  right: 0;\n  left: inherit;\n}\n\n.rtl .custom-file-label::after {\n  right: initial;\n  left: -1px;\n  border-radius: .25rem 0 0 .25rem;\n}\n\n.rtl .radio input,\n.rtl .radio-inline,\n.rtl .checkbox input,\n.rtl .checkbox-inline input {\n  margin-right: -1.25rem;\n  margin-left: inherit;\n}\n\n.rtl .list-group {\n  padding-right: 0;\n  padding-left: 40px;\n}\n\n.rtl .close {\n  float: left;\n}\n\n.rtl .modal-header .close {\n  margin: -15px auto -15px -15px;\n}\n\n.rtl .modal-footer> :not(:first-child) {\n  margin-right: .25rem;\n}\n\n.rtl .alert-dismissible .close {\n  right: inherit;\n  left: 0;\n}\n\n.rtl .dropdown-toggle::after {\n  margin-right: .255em;\n  margin-left: 0;\n}\n\n.rtl .form-check-input {\n  margin-right: -1.25rem;\n  margin-left: inherit;\n}\n\n.rtl .form-check-label {\n  padding-right: 1.25rem;\n  padding-left: inherit;\n}\n\n.rtl .offset-1 {\n  margin-right: 8.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-2 {\n  margin-right: 16.6666666667%;\n  margin-left: 0;\n}\n\n.rtl .offset-3 {\n  margin-right: 25%;\n  margin-left: 0;\n}\n\n.rtl .offset-4 {\n  margin-right: 33.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-5 {\n  margin-right: 41.6666666667%;\n  margin-left: 0;\n}\n\n.rtl .offset-6 {\n  margin-right: 50%;\n  margin-left: 0;\n}\n\n.rtl .offset-7 {\n  margin-right: 58.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-8 {\n  margin-right: 66.6666666667%;\n  margin-left: 0;\n}\n\n.rtl .offset-9 {\n  margin-right: 75%;\n  margin-left: 0;\n}\n\n.rtl .offset-10 {\n  margin-right: 83.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-11 {\n  margin-right: 91.6666666667%;\n  margin-left: 0;\n}\n\n@media (min-width: 576px) {\n  .rtl .offset-sm-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .offset-md-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .offset-lg-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .offset-xl-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .offset-xxl-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n.rtl .mr-0,\n.rtl .mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.rtl .ml-0,\n.rtl .mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.rtl .mr-1,\n.rtl .mx-1 {\n  margin-right: 0 !important;\n  margin-left: 0.25rem !important;\n}\n\n.rtl .ml-1,\n.rtl .mx-1 {\n  margin-left: 0 !important;\n  margin-right: 0.25rem !important;\n}\n\n.rtl .mr-2,\n.rtl .mx-2 {\n  margin-right: 0 !important;\n  margin-left: 0.5rem !important;\n}\n\n.rtl .ml-2,\n.rtl .mx-2 {\n  margin-left: 0 !important;\n  margin-right: 0.5rem !important;\n}\n\n.rtl .mr-3,\n.rtl .mx-3 {\n  margin-right: 0 !important;\n  margin-left: 1rem !important;\n}\n\n.rtl .ml-3,\n.rtl .mx-3 {\n  margin-left: 0 !important;\n  margin-right: 1rem !important;\n}\n\n.rtl .mr-4,\n.rtl .mx-4 {\n  margin-right: 0 !important;\n  margin-left: 1.5rem !important;\n}\n\n.rtl .ml-4,\n.rtl .mx-4 {\n  margin-left: 0 !important;\n  margin-right: 1.5rem !important;\n}\n\n.rtl .mr-5,\n.rtl .mx-5 {\n  margin-right: 0 !important;\n  margin-left: 3rem !important;\n}\n\n.rtl .ml-5,\n.rtl .mx-5 {\n  margin-left: 0 !important;\n  margin-right: 3rem !important;\n}\n\n.rtl .pr-0,\n.rtl .px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.rtl .pl-0,\n.rtl .px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.rtl .pr-1,\n.rtl .px-1 {\n  padding-right: 0 !important;\n  padding-left: 0.25rem !important;\n}\n\n.rtl .pl-1,\n.rtl .px-1 {\n  padding-left: 0 !important;\n  padding-right: 0.25rem !important;\n}\n\n.rtl .pr-2,\n.rtl .px-2 {\n  padding-right: 0 !important;\n  padding-left: 0.5rem !important;\n}\n\n.rtl .pl-2,\n.rtl .px-2 {\n  padding-left: 0 !important;\n  padding-right: 0.5rem !important;\n}\n\n.rtl .pr-3,\n.rtl .px-3 {\n  padding-right: 0 !important;\n  padding-left: 1rem !important;\n}\n\n.rtl .pl-3,\n.rtl .px-3 {\n  padding-left: 0 !important;\n  padding-right: 1rem !important;\n}\n\n.rtl .pr-4,\n.rtl .px-4 {\n  padding-right: 0 !important;\n  padding-left: 1.5rem !important;\n}\n\n.rtl .pl-4,\n.rtl .px-4 {\n  padding-left: 0 !important;\n  padding-right: 1.5rem !important;\n}\n\n.rtl .pr-5,\n.rtl .px-5 {\n  padding-right: 0 !important;\n  padding-left: 3rem !important;\n}\n\n.rtl .pl-5,\n.rtl .px-5 {\n  padding-left: 0 !important;\n  padding-right: 3rem !important;\n}\n\n.rtl .mr-auto {\n  margin-right: 0 !important;\n  margin-left: auto !important;\n}\n\n.rtl .ml-auto {\n  margin-right: auto !important;\n  margin-left: 0 !important;\n}\n\n.rtl .mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n\n  .rtl .mr-sm-0,\n  .rtl .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-sm-0,\n  .rtl .mx-sm-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-sm-1,\n  .rtl .mx-sm-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-sm-1,\n  .rtl .mx-sm-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-sm-2,\n  .rtl .mx-sm-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-sm-2,\n  .rtl .mx-sm-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-sm-3,\n  .rtl .mx-sm-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-sm-3,\n  .rtl .mx-sm-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-sm-4,\n  .rtl .mx-sm-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-sm-4,\n  .rtl .mx-sm-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-sm-5,\n  .rtl .mx-sm-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-sm-5,\n  .rtl .mx-sm-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-sm-0,\n  .rtl .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-sm-0,\n  .rtl .px-sm-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-sm-1,\n  .rtl .px-sm-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-sm-1,\n  .rtl .px-sm-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-sm-2,\n  .rtl .px-sm-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-sm-2,\n  .rtl .px-sm-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-sm-3,\n  .rtl .px-sm-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-sm-3,\n  .rtl .px-sm-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-sm-4,\n  .rtl .px-sm-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-sm-4,\n  .rtl .px-sm-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-sm-5,\n  .rtl .px-sm-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-sm-5,\n  .rtl .px-sm-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-sm-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-sm-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .rtl .mr-md-0,\n  .rtl .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-md-0,\n  .rtl .mx-md-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-md-1,\n  .rtl .mx-md-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-md-1,\n  .rtl .mx-md-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-md-2,\n  .rtl .mx-md-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-md-2,\n  .rtl .mx-md-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-md-3,\n  .rtl .mx-md-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-md-3,\n  .rtl .mx-md-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-md-4,\n  .rtl .mx-md-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-md-4,\n  .rtl .mx-md-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-md-5,\n  .rtl .mx-md-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-md-5,\n  .rtl .mx-md-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-md-0,\n  .rtl .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-md-0,\n  .rtl .px-md-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-md-1,\n  .rtl .px-md-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-md-1,\n  .rtl .px-md-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-md-2,\n  .rtl .px-md-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-md-2,\n  .rtl .px-md-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-md-3,\n  .rtl .px-md-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-md-3,\n  .rtl .px-md-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-md-4,\n  .rtl .px-md-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-md-4,\n  .rtl .px-md-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-md-5,\n  .rtl .px-md-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-md-5,\n  .rtl .px-md-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-md-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-md-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .rtl .mr-lg-0,\n  .rtl .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-lg-0,\n  .rtl .mx-lg-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-lg-1,\n  .rtl .mx-lg-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-lg-1,\n  .rtl .mx-lg-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-lg-2,\n  .rtl .mx-lg-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-lg-2,\n  .rtl .mx-lg-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-lg-3,\n  .rtl .mx-lg-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-lg-3,\n  .rtl .mx-lg-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-lg-4,\n  .rtl .mx-lg-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-lg-4,\n  .rtl .mx-lg-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-lg-5,\n  .rtl .mx-lg-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-lg-5,\n  .rtl .mx-lg-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-lg-0,\n  .rtl .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-lg-0,\n  .rtl .px-lg-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-lg-1,\n  .rtl .px-lg-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-lg-1,\n  .rtl .px-lg-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-lg-2,\n  .rtl .px-lg-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-lg-2,\n  .rtl .px-lg-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-lg-3,\n  .rtl .px-lg-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-lg-3,\n  .rtl .px-lg-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-lg-4,\n  .rtl .px-lg-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-lg-4,\n  .rtl .px-lg-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-lg-5,\n  .rtl .px-lg-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-lg-5,\n  .rtl .px-lg-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-lg-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-lg-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .rtl .mr-xl-0,\n  .rtl .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-xl-0,\n  .rtl .mx-xl-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-xl-1,\n  .rtl .mx-xl-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-xl-1,\n  .rtl .mx-xl-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-xl-2,\n  .rtl .mx-xl-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-xl-2,\n  .rtl .mx-xl-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-xl-3,\n  .rtl .mx-xl-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-xl-3,\n  .rtl .mx-xl-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-xl-4,\n  .rtl .mx-xl-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-xl-4,\n  .rtl .mx-xl-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-xl-5,\n  .rtl .mx-xl-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-xl-5,\n  .rtl .mx-xl-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-xl-0,\n  .rtl .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-xl-0,\n  .rtl .px-xl-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-xl-1,\n  .rtl .px-xl-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-xl-1,\n  .rtl .px-xl-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-xl-2,\n  .rtl .px-xl-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-xl-2,\n  .rtl .px-xl-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-xl-3,\n  .rtl .px-xl-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-xl-3,\n  .rtl .px-xl-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-xl-4,\n  .rtl .px-xl-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-xl-4,\n  .rtl .px-xl-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-xl-5,\n  .rtl .px-xl-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-xl-5,\n  .rtl .px-xl-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1440) {\n\n  .rtl .mr-xxl-0,\n  .rtl .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-xxl-0,\n  .rtl .mx-xxl-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-xxl-1,\n  .rtl .mx-xxl-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-xxl-1,\n  .rtl .mx-xxl-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-xxl-2,\n  .rtl .mx-xxl-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-xxl-2,\n  .rtl .mx-xxl-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-xxl-3,\n  .rtl .mx-xxl-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-xxl-3,\n  .rtl .mx-xxl-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-xxl-4,\n  .rtl .mx-xxl-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-xxl-4,\n  .rtl .mx-xxl-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-xxl-5,\n  .rtl .mx-xxl-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-xxl-5,\n  .rtl .mx-xxl-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-xxl-0,\n  .rtl .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-xxl-0,\n  .rtl .px-xxl-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-xxl-1,\n  .rtl .px-xxl-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-xxl-1,\n  .rtl .px-xxl-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-xxl-2,\n  .rtl .px-xxl-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-xxl-2,\n  .rtl .px-xxl-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-xxl-3,\n  .rtl .px-xxl-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-xxl-3,\n  .rtl .px-xxl-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-xxl-4,\n  .rtl .px-xxl-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-xxl-4,\n  .rtl .px-xxl-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-xxl-5,\n  .rtl .px-xxl-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-xxl-5,\n  .rtl .px-xxl-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xxl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xxl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n.rtl .text-right {\n  text-align: left !important;\n}\n\n.rtl .text-left {\n  text-align: right !important;\n}\n\n@media (min-width: 576px) {\n  .rtl .text-sm-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-sm-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .text-md-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-md-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .text-lg-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-lg-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .text-xl-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-xl-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .text-xxl-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-xxl-left {\n    text-align: right !important;\n  }\n}\n\n.rtl .mx-0 {\n  margin-right: auto;\n  margin-left: 0 !important;\n}\n\n.rtl .mx-0 {\n  margin-left: auto;\n  margin-right: 0 !important;\n}\n\n.rtl .mx-1 {\n  margin-right: auto;\n  margin-left: 0.25rem !important;\n}\n\n.rtl .mx-1 {\n  margin-left: auto;\n  margin-right: 0.25rem !important;\n}\n\n.rtl .mx-2 {\n  margin-right: auto;\n  margin-left: 0.5rem !important;\n}\n\n.rtl .mx-2 {\n  margin-left: auto;\n  margin-right: 0.5rem !important;\n}\n\n.rtl .mx-3 {\n  margin-right: auto;\n  margin-left: 1rem !important;\n}\n\n.rtl .mx-3 {\n  margin-left: auto;\n  margin-right: 1rem !important;\n}\n\n.rtl .mx-4 {\n  margin-right: auto;\n  margin-left: 1.5rem !important;\n}\n\n.rtl .mx-4 {\n  margin-left: auto;\n  margin-right: 1.5rem !important;\n}\n\n.rtl .mx-5 {\n  margin-right: auto;\n  margin-left: 3rem !important;\n}\n\n.rtl .mx-5 {\n  margin-left: auto;\n  margin-right: 3rem !important;\n}\n\n.rtl .px-0 {\n  padding-right: auto;\n  padding-left: 0 !important;\n}\n\n.rtl .px-0 {\n  padding-left: auto;\n  padding-right: 0 !important;\n}\n\n.rtl .px-1 {\n  padding-right: auto;\n  padding-left: 0.25rem !important;\n}\n\n.rtl .px-1 {\n  padding-left: auto;\n  padding-right: 0.25rem !important;\n}\n\n.rtl .px-2 {\n  padding-right: auto;\n  padding-left: 0.5rem !important;\n}\n\n.rtl .px-2 {\n  padding-left: auto;\n  padding-right: 0.5rem !important;\n}\n\n.rtl .px-3 {\n  padding-right: auto;\n  padding-left: 1rem !important;\n}\n\n.rtl .px-3 {\n  padding-left: auto;\n  padding-right: 1rem !important;\n}\n\n.rtl .px-4 {\n  padding-right: auto;\n  padding-left: 1.5rem !important;\n}\n\n.rtl .px-4 {\n  padding-left: auto;\n  padding-right: 1.5rem !important;\n}\n\n.rtl .px-5 {\n  padding-right: auto;\n  padding-left: 3rem !important;\n}\n\n.rtl .px-5 {\n  padding-left: auto;\n  padding-right: 3rem !important;\n}\n\n.rtl .mr-auto {\n  margin-right: 0 !important;\n  margin-left: auto !important;\n}\n\n.rtl .mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.rtl .ml-auto {\n  margin-right: auto !important;\n  margin-left: 0 !important;\n}\n\n.rtl .mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .rtl .mx-sm-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-sm-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-sm-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-sm-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-sm-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-sm-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-sm-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-sm-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-sm-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-sm-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-sm-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-sm-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-sm-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-sm-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-sm-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-sm-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-sm-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-sm-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-sm-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-sm-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-sm-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-sm-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-sm-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-sm-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-sm-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-sm-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .mx-md-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-md-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-md-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-md-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-md-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-md-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-md-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-md-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-md-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-md-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-md-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-md-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-md-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-md-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-md-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-md-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-md-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-md-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-md-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-md-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-md-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-md-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-md-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-md-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-md-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-md-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .mx-lg-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-lg-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-lg-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-lg-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-lg-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-lg-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-lg-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-lg-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-lg-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-lg-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-lg-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-lg-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-lg-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-lg-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-lg-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-lg-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-lg-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-lg-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-lg-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-lg-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-lg-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-lg-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-lg-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-lg-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-lg-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-lg-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .mx-xl-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xl-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-xl-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-xl-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-xl-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-xl-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-xl-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-xl-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-xl-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-xl-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-xl-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-xl-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-xl-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-xl-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-xl-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-xl-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-xl-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-xl-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-xl-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-xl-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-xl-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-xl-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-xl-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-xl-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .mx-xxl-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xxl-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-xxl-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-xxl-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-xxl-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-xxl-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-xxl-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-xxl-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-xxl-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-xxl-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-xxl-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-xxl-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-xxl-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-xxl-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-xxl-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-xxl-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-xxl-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-xxl-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-xxl-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-xxl-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-xxl-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-xxl-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-xxl-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-xxl-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xxl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xxl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n.rtl .float-left {\n  float: right !important;\n}\n\n.rtl .float-right {\n  float: left !important;\n}\n\n.rtl .float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .rtl .float-sm-left {\n    float: right !important;\n  }\n\n  .rtl .float-sm-right {\n    float: left !important;\n  }\n\n  .rtl .float-sm-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .float-md-left {\n    float: right !important;\n  }\n\n  .rtl .float-md-right {\n    float: left !important;\n  }\n\n  .rtl .float-md-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .float-lg-left {\n    float: right !important;\n  }\n\n  .rtl .float-lg-right {\n    float: left !important;\n  }\n\n  .rtl .float-lg-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .float-xl-left {\n    float: right !important;\n  }\n\n  .rtl .float-xl-right {\n    float: left !important;\n  }\n\n  .rtl .float-xl-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .float-xxl-left {\n    float: right !important;\n  }\n\n  .rtl .float-xxl-right {\n    float: left !important;\n  }\n\n  .rtl .float-xxl-none {\n    float: none !important;\n  }\n}\n\n[direction=\"rtl\"][data-theme-version=\"dark\"] .border,\n[direction=\"rtl\"][data-theme-version=\"dark\"] .border-left,\n[direction=\"rtl\"][data-theme-version=\"dark\"] .border-right {\n  border-color: #333a54 !important;\n}\n\n[direction=\"rtl\"] .text-right {\n  text-align: left !important;\n}\n\n[direction=\"rtl\"] .text-left {\n  text-align: right !important;\n}\n\n[direction=\"rtl\"] .border-right {\n  border-left: 1px solid #f0f1f5 !important;\n  border-right: 0 !important;\n}\n\n[direction=\"rtl\"] .border-left {\n  border-right: 1px solid #f0f1f5 !important;\n  border-left: 0 !important;\n}\n\n[direction=\"rtl\"] .dropdown-menu {\n  left: auto;\n}\n\n[direction=\"rtl\"] .dropdown-menu-right {\n  left: 0;\n  right: auto;\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .dropdown-menu-right {\n    left: 15px;\n  }\n}\n\n[direction=\"rtl\"] .notification_dropdown .dropdown-menu-right .media>span {\n  margin-left: 10px;\n  margin-right: 0;\n}\n\n[direction=\"rtl\"]:not([data-container=\"boxed\"]) .nav-header {\n  left: auto;\n  right: 0;\n}\n\n[direction=\"rtl\"][data-container=\"wide-boxed\"] .nav-header {\n  left: auto;\n  right: 0;\n}\n\n[direction=\"rtl\"] .nav-header {\n  text-align: right;\n  right: auto;\n}\n\n[direction=\"rtl\"] .nav-header .brand-title {\n  margin-left: 0;\n  margin-right: 15px;\n}\n\n[direction=\"rtl\"] .nav-header .brand-logo {\n  padding-left: 0;\n  padding-right: 1.75rem;\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 0;\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .nav-header .brand-logo[data-layout=\"horizontal\"] {\n  padding-right: 30px;\n}\n\n[data-sidebar-style=\"mini\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 0;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 0;\n}\n\n[data-layout=\"horizontal\"][data-sidebar-style=\"modern\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 30px;\n}\n\n@media (max-width: 767.98px) {\n  [direction=\"rtl\"] .nav-header .brand-logo {\n    padding-right: 0;\n  }\n}\n\n[direction=\"rtl\"] .nav-control {\n  right: auto;\n  left: -4.0625rem;\n}\n\n@media (max-width: 767.98px) {\n  [direction=\"rtl\"] .nav-control {\n    left: -4.0625rem;\n  }\n}\n\n@media (max-width: 575.98px) {\n  [direction=\"rtl\"] .nav-control {\n    left: -4.0625rem;\n  }\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active {\n  right: 0;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"][data-layout=\"horizontal\"] .nav-header .brand-logo {\n  padding-right: 30px;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .nav-header {\n  width: 16rem;\n}\n\n[direction=\"rtl\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 17.1875rem;\n}\n\n@media (max-width: 767.98px) {\n  [direction=\"rtl\"] .header {\n    padding-right: 3.75rem;\n    padding-left: 0;\n  }\n}\n\n[direction=\"rtl\"] .header .header-content {\n  padding-left: 0;\n  padding-right: 5.3125rem;\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .header .header-content {\n    padding-right: 4.5rem;\n  }\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .header .header-content {\n  padding-right: 1.875rem;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .header .header-content {\n  padding-right: 5.3125rem;\n}\n\n[data-sidebar-style=\"overlay\"][direction=\"rtl\"] .header .header-content {\n  padding-right: 5.3125rem;\n}\n\n[direction=\"rtl\"] .header .nav-control {\n  right: 0.4375rem;\n  left: auto;\n}\n\n[direction=\"rtl\"] .header-left .search_bar .dropdown-menu,\n[direction=\"rtl\"] .header-left .search_bar .dropdown-menu.show {\n  right: 40px !important;\n}\n\n@media only screen and (max-width: 575px) {\n\n  [direction=\"rtl\"] .header-left .search_bar .dropdown-menu,\n  [direction=\"rtl\"] .header-left .search_bar .dropdown-menu.show {\n    right: -100px !important;\n  }\n}\n\n[direction=\"rtl\"] .header-left .search_bar .search_icon {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 5rem;\n  border-bottom-right-radius: 5rem;\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .header-left .search_bar .search_icon {\n    border-radius: 5rem;\n  }\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .header {\n  padding: 0;\n  padding-right: 16rem;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .header .header-content {\n  padding-right: 1.875rem;\n  padding-left: 1.875rem;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"][data-sidebar-style=\"mini\"] .header {\n  padding-right: 6rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"mini\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 3.75rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 9.375rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"][data-layout=\"horizontal\"] .header {\n  padding: 0;\n  padding-right: 16rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"modern\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 9.375rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .header {\n  padding: 0;\n  padding-right: 16rem;\n}\n\n[direction=\"rtl\"] {\n  text-align: right;\n}\n\n[direction=\"rtl\"] .deznav {\n  text-align: right;\n}\n\n[direction=\"rtl\"] .deznav .metismenu ul {\n  padding: 0 25px 0 0;\n}\n\n[direction=\"rtl\"] .deznav .metismenu ul:after {\n  left: auto;\n  right: 25px;\n}\n\n[direction=\"rtl\"] .deznav .metismenu ul a:before {\n  left: auto;\n  right: -5px;\n}\n\n[direction=\"rtl\"] .deznav .metismenu li>a svg {\n  margin-left: 5px;\n  margin-right: 0;\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .deznav .metismenu li>a svg {\n  left: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n[data-sidebar-style=\"icon-hover\"][direction=\"rtl\"] .deznav .metismenu li>a svg {\n  margin-left: 0;\n}\n\n[direction=\"rtl\"] .deznav .metismenu li.active>.has-arrow:after {\n  transform: rotate(45deg) translateY(-50%);\n}\n\n[direction=\"rtl\"] .deznav .metismenu .has-arrow:after {\n  left: 1.5625rem;\n  right: auto;\n}\n\n[data-layout=\"horizontal\"][direction=\"rtl\"] .deznav .metismenu .has-arrow:after {\n  left: 1.125rem;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .deznav .metismenu .has-arrow:after {\n  -webkit-transform: rotate(-45deg) translateY(-50%);\n  transform: rotate(-45deg) translateY(-50%);\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul li:hover ul {\n  right: 11.8125rem;\n  left: 0;\n}\n\n[direction=\"rtl\"] .list-group {\n  padding-left: 0;\n}\n\n[direction=\"rtl\"] .form-check-input {\n  margin-left: -1.25rem;\n  margin-right: inherit;\n}\n\n[direction=\"rtl\"] .form-check-inline .form-check-input {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n[direction=\"rtl\"] .radio input,\n[direction=\"rtl\"] .radio-inline,\n[direction=\"rtl\"] .checkbox input,\n[direction=\"rtl\"] .checkbox-inline input {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n[direction=\"rtl\"] .content-body {\n  margin-right: 17.1875rem;\n  margin-left: auto;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .content-body {\n  margin-right: 9.375rem;\n}\n\n[direction=\"rtl\"] .content-body .page-titles {\n  text-align: right;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .content-body {\n  margin-right: 0;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu li li .has-arrow:after {\n  -webkit-transform: rotate(-4deg) translateY(-50%);\n  transform: rotate(-45deg) translateY(-50%);\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"mini\"]:not([data-layout=\"horizontal\"]) .content-body {\n  margin-right: 3.75rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"]:not([data-layout=\"horizontal\"]) .content-body {\n  margin-right: 9.375rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"overlay\"] .content-body {\n  margin-right: 0;\n}\n\n[direction=\"rtl\"] #external-events .external-event:before {\n  margin-right: 0;\n  margin-left: .9rem;\n}\n\n[direction=\"rtl\"] .post-input a i {\n  margin-left: 15px;\n  margin-right: 0;\n}\n\n@media only screen and (max-width: 1350px) and (min-width: 1200px) {\n  [direction=\"rtl\"] .content-body {\n    margin-right: 14.375rem;\n  }\n}\n\n[direction=\"rtl\"] .sidebar-right {\n  left: -15.625rem;\n  right: auto;\n  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n}\n\n[direction=\"rtl\"] .sidebar-right.show {\n  left: 0;\n  right: auto;\n}\n\n[direction=\"rtl\"] .sidebar-right .sidebar-right-trigger {\n  left: 100%;\n  right: auto;\n  border-radius: 0 5px 5px 0;\n  box-shadow: 5px 3px 5px 0px rgba(119, 119, 119, 0.15);\n}\n\n[direction=\"rtl\"] .bootstrap-select .dropdown-toggle .filter-option {\n  text-align: right;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"] .footer {\n  padding-right: 17.1875rem;\n  padding-left: 0;\n}\n\n@media (max-width: 767.98px) {\n  html[dir=\"rtl\"] [direction=\"rtl\"] .footer {\n    padding-right: 0;\n  }\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-sidebar-style=\"overlay\"] .footer {\n  padding-right: 0;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"] .menu-toggle .footer {\n  padding-right: 3.75rem;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-container=\"boxed\"] .footer {\n  padding-right: 0;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-sidebar-style=\"mini\"]:not([data-layout=\"horizontal\"]) .footer {\n  padding-right: 3.75rem;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-sidebar-style=\"compact\"]:not([data-layout=\"horizontal\"]) .footer {\n  padding-right: 9.375rem;\n}\n\n.nav-label {\n  margin: 10px 30px 0;\n  padding: 1.5625rem 0 10px;\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 0.05rem;\n  border-top: 1px solid #eaeaea;\n  color: #999999;\n}\n\n[data-theme-version=\"dark\"] .nav-label {\n  border-color: #333a54;\n}\n\n.nav-label.first {\n  border: 0px;\n  margin-top: 0px;\n}\n\n.nav-badge {\n  position: absolute;\n  right: 2.8125rem;\n  top: 0.625rem;\n}\n\n.content-body {\n  margin-left: 230px;\n  z-index: 0;\n  transition: all .2s ease;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1400px) {\n  .content-body {\n    margin-left: 15rem;\n  }\n}\n\n.bell img {\n  -webkit-animation: ring 8s .7s ease-in-out infinite;\n  -webkit-transform-origin: 50% 4px;\n  -moz-animation: ring 8s .7s ease-in-out infinite;\n  -moz-transform-origin: 50% 4px;\n  animation: ring 8s .7s ease-in-out infinite;\n}\n\n@-webkit-keyframes ring {\n  0% {\n    -webkit-transform: rotateZ(0);\n  }\n\n  1% {\n    -webkit-transform: rotateZ(30deg);\n  }\n\n  3% {\n    -webkit-transform: rotateZ(-28deg);\n  }\n\n  5% {\n    -webkit-transform: rotateZ(34deg);\n  }\n\n  7% {\n    -webkit-transform: rotateZ(-32deg);\n  }\n\n  9% {\n    -webkit-transform: rotateZ(30deg);\n  }\n\n  11% {\n    -webkit-transform: rotateZ(-28deg);\n  }\n\n  13% {\n    -webkit-transform: rotateZ(26deg);\n  }\n\n  15% {\n    -webkit-transform: rotateZ(-24deg);\n  }\n\n  17% {\n    -webkit-transform: rotateZ(22deg);\n  }\n\n  19% {\n    -webkit-transform: rotateZ(-20deg);\n  }\n\n  21% {\n    -webkit-transform: rotateZ(18deg);\n  }\n\n  23% {\n    -webkit-transform: rotateZ(-16deg);\n  }\n\n  25% {\n    -webkit-transform: rotateZ(14deg);\n  }\n\n  27% {\n    -webkit-transform: rotateZ(-12deg);\n  }\n\n  29% {\n    -webkit-transform: rotateZ(10deg);\n  }\n\n  31% {\n    -webkit-transform: rotateZ(-8deg);\n  }\n\n  33% {\n    -webkit-transform: rotateZ(6deg);\n  }\n\n  35% {\n    -webkit-transform: rotateZ(-4deg);\n  }\n\n  37% {\n    -webkit-transform: rotateZ(2deg);\n  }\n\n  39% {\n    -webkit-transform: rotateZ(-1deg);\n  }\n\n  41% {\n    -webkit-transform: rotateZ(1deg);\n  }\n\n  43% {\n    -webkit-transform: rotateZ(0);\n  }\n\n  100% {\n    -webkit-transform: rotateZ(0);\n  }\n}\n\n@-moz-keyframes ring {\n  0% {\n    -moz-transform: rotate(0);\n  }\n\n  1% {\n    -moz-transform: rotate(30deg);\n  }\n\n  3% {\n    -moz-transform: rotate(-28deg);\n  }\n\n  5% {\n    -moz-transform: rotate(34deg);\n  }\n\n  7% {\n    -moz-transform: rotate(-32deg);\n  }\n\n  9% {\n    -moz-transform: rotate(30deg);\n  }\n\n  11% {\n    -moz-transform: rotate(-28deg);\n  }\n\n  13% {\n    -moz-transform: rotate(26deg);\n  }\n\n  15% {\n    -moz-transform: rotate(-24deg);\n  }\n\n  17% {\n    -moz-transform: rotate(22deg);\n  }\n\n  19% {\n    -moz-transform: rotate(-20deg);\n  }\n\n  21% {\n    -moz-transform: rotate(18deg);\n  }\n\n  23% {\n    -moz-transform: rotate(-16deg);\n  }\n\n  25% {\n    -moz-transform: rotate(14deg);\n  }\n\n  27% {\n    -moz-transform: rotate(-12deg);\n  }\n\n  29% {\n    -moz-transform: rotate(10deg);\n  }\n\n  31% {\n    -moz-transform: rotate(-8deg);\n  }\n\n  33% {\n    -moz-transform: rotate(6deg);\n  }\n\n  35% {\n    -moz-transform: rotate(-4deg);\n  }\n\n  37% {\n    -moz-transform: rotate(2deg);\n  }\n\n  39% {\n    -moz-transform: rotate(-1deg);\n  }\n\n  41% {\n    -moz-transform: rotate(1deg);\n  }\n\n  43% {\n    -moz-transform: rotate(0);\n  }\n\n  100% {\n    -moz-transform: rotate(0);\n  }\n}\n\n@keyframes ring {\n  0% {\n    transform: rotate(0);\n  }\n\n  1% {\n    transform: rotate(30deg);\n  }\n\n  3% {\n    transform: rotate(-28deg);\n  }\n\n  5% {\n    transform: rotate(34deg);\n  }\n\n  7% {\n    transform: rotate(-32deg);\n  }\n\n  9% {\n    transform: rotate(30deg);\n  }\n\n  11% {\n    transform: rotate(-28deg);\n  }\n\n  13% {\n    transform: rotate(26deg);\n  }\n\n  15% {\n    transform: rotate(-24deg);\n  }\n\n  17% {\n    transform: rotate(22deg);\n  }\n\n  19% {\n    transform: rotate(-20deg);\n  }\n\n  21% {\n    transform: rotate(18deg);\n  }\n\n  23% {\n    transform: rotate(-16deg);\n  }\n\n  25% {\n    transform: rotate(14deg);\n  }\n\n  27% {\n    transform: rotate(-12deg);\n  }\n\n  29% {\n    transform: rotate(10deg);\n  }\n\n  31% {\n    transform: rotate(-8deg);\n  }\n\n  33% {\n    transform: rotate(6deg);\n  }\n\n  35% {\n    transform: rotate(-4deg);\n  }\n\n  37% {\n    transform: rotate(2deg);\n  }\n\n  39% {\n    transform: rotate(-1deg);\n  }\n\n  41% {\n    transform: rotate(1deg);\n  }\n\n  43% {\n    transform: rotate(0);\n  }\n\n  100% {\n    transform: rotate(0);\n  }\n}\n\n.deznav {\n  width: 21.563rem;\n  padding-bottom: 0;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  padding-top: 5rem;\n  z-index: 3;\n  background-color: #3C4B64;\n  transition: all .2s ease;\n}\n\n@media only screen and (max-width: 1199px) {\n  .deznav {\n    padding-top: 80px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .deznav {\n    width: 18rem;\n  }\n}\n\n.deznav .deznav-scroll {\n  position: relative;\n  height: 100%;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1400px) {\n  .deznav {\n    width: 15rem;\n  }\n}\n\n.deznav ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.deznav .metismenu {\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n}\n\n@media only screen and (max-width: 767px) {\n  .deznav .metismenu {\n    padding-top: 0;\n  }\n}\n\n.deznav .metismenu.fixed {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  left: 0;\n}\n\n.deznav .metismenu>li {\n  display: flex;\n  flex-direction: column;\n}\n\n.deznav .metismenu>li a>i {\n  font-size: 1.2rem;\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  top: 0;\n  height: 50px;\n  width: 40px;\n  border-radius: 1.25rem;\n  line-height: 50px;\n  text-align: center;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n  margin-right: 15px;\n}\n\n[data-sidebar-style=\"compact\"] .deznav .metismenu>li a>i {\n  display: block;\n  padding: 0;\n}\n\n@media only screen and (max-width: 1300px) {\n  .deznav .metismenu>li a>i {\n    height: auto;\n    width: auto;\n    margin-right: 0;\n    line-height: 1;\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .deznav .metismenu>li a>i {\n    font-size: 1.25rem;\n    padding: 0 .75rem 0 0;\n    margin-right: 0px;\n  }\n}\n\n.deznav .metismenu>li>a {\n  font-weight: 500;\n  display: inline-block;\n  font-size: 15px;\n}\n\n.deznav .metismenu>li>a svg {\n  max-width: 24px;\n  max-height: 24px;\n  height: 100%;\n  margin-right: 5px;\n  margin-top: -3px;\n  color: #00ADEE;\n}\n\n.deznav .metismenu>li>a g [fill] {\n  fill: #00ADEE;\n}\n\n.deznav .metismenu>li:hover>a,\n.deznav .metismenu>li:focus>a {\n  color: #00ADEE;\n}\n\n.deznav .metismenu>li:hover>a g [fill],\n.deznav .metismenu>li:focus>a g [fill] {\n  fill: #00ADEE;\n}\n\n.deznav .metismenu>li.mm-active>a {\n  color: #00ADEE;\n}\n\n.deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #00ADEE;\n}\n\n.deznav .metismenu li {\n  position: relative;\n}\n\n.deznav .metismenu ul {\n  transition: all .2s ease-in-out;\n  position: relative;\n  z-index: 1;\n  padding: 0 0;\n}\n\n.deznav .metismenu ul a {\n  padding-top: .5rem;\n  padding-bottom: .5rem;\n  position: relative;\n  font-size: 16px;\n  padding-left: 6rem;\n}\n\n@media only screen and (max-width: 1400px) {\n  .deznav .metismenu ul a {\n    padding-left: 6rem;\n    font-size: 14px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .deznav .metismenu ul a {\n    padding-left: 3.5rem;\n  }\n}\n\n.deznav .metismenu ul a:hover,\n.deznav .metismenu ul a:focus,\n.deznav .metismenu ul a.mm-active {\n  text-decoration: none;\n  color: #00ADEE;\n}\n\n.deznav .metismenu a {\n  position: relative;\n  display: block;\n  padding: 0.625rem 1.875rem;\n  outline-width: 0;\n  color: #fff;\n  text-decoration: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .deznav .metismenu a {\n    padding: 0.625rem 1.25rem;\n  }\n}\n\n.deznav .metismenu .has-arrow:after {\n  width: .5rem;\n  height: .5rem;\n  right: 1.875rem;\n  top: 48%;\n  border-color: inherit;\n  -webkit-transform: rotate(-225deg) translateY(-50%);\n  transform: rotate(-225deg) translateY(-50%);\n}\n\n.deznav .metismenu .has-arrow[aria-expanded=true]:after,\n.deznav .metismenu .mm-active>.has-arrow:after {\n  -webkit-transform: rotate(-135deg) translateY(-50%);\n  transform: rotate(-135deg) translateY(-50%);\n}\n\n@media only screen and (max-width: 1199px) {\n  .nav-header {\n    width: 5rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .brand-title {\n    display: none;\n  }\n\n  .footer {\n    padding-left: 0;\n  }\n\n  .deznav {\n    left: 0;\n    top: 5rem;\n    padding-top: 1rem;\n  }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu>ul.collapse:not(.in),\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu>ul.collapse:not(.in) {\n  height: 252px !important;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu:hover>a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu:hover>a {\n  width: calc(70vw + 3.75rem);\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu:hover>ul,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu:hover>ul {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  max-height: 13.75rem;\n  width: 70vw;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu:hover>ul ul a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu:hover>ul ul a {\n  width: 101%;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-xl:hover>a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-xl:hover>a {\n  width: calc(70vw + 3rem);\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-xl:hover>ul,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-xl:hover>ul {\n  max-height: 200px;\n  width: 70vw;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-xl:hover>ul ul a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-xl:hover>ul ul a {\n  width: 101%;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-lg:hover>a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-lg:hover>a {\n  width: calc(55vw + 3rem);\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-lg:hover>ul,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-lg:hover>ul {\n  max-height: 200px;\n  width: 55vw;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-lg:hover>ul ul a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-lg:hover>ul ul a {\n  width: 101%;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-md:hover>a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-md:hover>a {\n  width: calc(45vw + 3);\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-md:hover>ul,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-md:hover>ul {\n  max-height: 18.75rem;\n  width: 45vw;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-md:hover>ul ul a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-md:hover>ul ul a {\n  width: 101%;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-sm:hover>a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-sm:hover>a {\n  width: calc(30vw + 3);\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-sm:hover>ul,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-sm:hover>ul {\n  max-height: 18.125rem;\n  width: 30vw;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mega-menu-sm:hover>ul ul a,\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mega-menu-sm:hover>ul ul a {\n  width: 101%;\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu:hover>a {\n  width: calc(60vw + 3.75rem);\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu:hover>ul {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  max-height: 25rem;\n  width: 60vw;\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu:hover>ul ul a {\n  width: 101%;\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-xl:hover>a {\n  width: calc(60vw + 3.75rem);\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-xl:hover>ul {\n  max-height: 25.625rem;\n  width: 60vw;\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-lg:hover>a {\n  width: calc(50vw + 3.75rem);\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-lg:hover>ul {\n  max-height: 16.25rem;\n  width: 50vw;\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-md:hover>a {\n  width: calc(40vw + 3.75rem);\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-md:hover>ul {\n  max-height: 18.75rem;\n  width: 40vw;\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-sm:hover>a {\n  width: calc(22vw + 3.75rem);\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-sm:hover>ul {\n  max-height: 18.125rem;\n  width: 22vw;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:not(:last-child) {\n  position: static;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul {\n  left: 0;\n  right: 0;\n}\n\n[data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #333a54;\n}\n\n[data-sibebarbg=\"color_2\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #03090f;\n}\n\n[data-sibebarbg=\"color_3\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #551ba1;\n}\n\n[data-sibebarbg=\"color_4\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #22134e;\n}\n\n[data-sibebarbg=\"color_5\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #711717;\n}\n\n[data-sibebarbg=\"color_6\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #121843;\n}\n\n[data-sibebarbg=\"color_7\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #3511d0;\n}\n\n[data-sibebarbg=\"color_8\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #1161aa;\n}\n\n[data-sibebarbg=\"color_9\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #002629;\n}\n\n[data-sibebarbg=\"color_10\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li {\n  border-color: #af5b00;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li a {\n  transition: all .4s ease-in-out;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu ul li a:hover {\n  border-radius: 0.25rem;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  max-height: 13.75rem;\n  width: 70vw;\n  z-index: 99;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  content: \"\";\n  height: 100%;\n  width: 1px;\n  position: absolute;\n  background-color: #fff;\n  right: 2.8125rem;\n  top: 0;\n}\n\n[data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #1d2544;\n}\n\n[data-sibebarbg=\"color_2\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #0c223a;\n}\n\n[data-sibebarbg=\"color_3\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #6d23cc;\n}\n\n[data-sibebarbg=\"color_4\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #331d77;\n}\n\n[data-sibebarbg=\"color_5\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #9c1f1f;\n}\n\n[data-sibebarbg=\"color_6\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #1d276b;\n}\n\n[data-sibebarbg=\"color_7\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #4c27ed;\n}\n\n[data-sibebarbg=\"color_8\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #167cd8;\n}\n\n[data-sibebarbg=\"color_9\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #00545c;\n}\n\n[data-sibebarbg=\"color_10\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul::after {\n  background-color: #e27500;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu:hover>ul ul a {\n  width: 101%;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu-xl:hover>ul {\n  max-height: 210px;\n  width: 70vw;\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu-lg:hover>ul {\n  max-height: 210px;\n  width: 700px;\n  height: 210px !important;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  [data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu-lg:hover>ul {\n    width: 700px;\n  }\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu-md:hover>ul {\n  max-height: 20rem;\n  width: 54vw;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  [data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu-md:hover>ul {\n    width: 60vw;\n  }\n}\n\n[data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu-sm:hover>ul {\n  max-height: 20rem;\n  width: 25vw;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  [data-layout=\"horizontal\"] .deznav .metismenu>li.mega-menu-sm:hover>ul {\n    width: 35vw;\n  }\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu:hover>ul {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-xl:hover>ul {\n  max-height: 21.875rem;\n  width: 100%;\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-lg:hover>ul {\n  max-height: 21.875rem;\n  width: 55vw;\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-md:hover>ul {\n  max-height: 18.75rem;\n  width: 45vw;\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"] .deznav .metismenu>li.mega-menu-sm:hover>ul {\n  max-height: 18.125rem;\n  width: 50vw;\n}\n\n/*$primary  : #7356f1 !default;*/\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li {\n  padding: 0 0 0 10px;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li>a {\n  font-size: 13px;\n  padding: 2px 4px;\n  border-top-left-radius: 1.25rem;\n  border-bottom-left-radius: 1.25rem;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n  position: relative;\n}\n\n@media only screen and (max-width: 1400px) {\n  [data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li>a {\n    padding: 4px 6px;\n    font-size: 13px;\n  }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a {\n  color: #000;\n  background: #E5E6E7;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a i {\n  color: #00ADEE;\n  background: #fff;\n  box-shadow: 0px 0px 10px 3px rgba(135, 67, 223, 0.2);\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li .has-arrow:after {\n  right: 2.5rem;\n}\n\n@media only screen and (max-width: 1400px) {\n  [data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li .has-arrow:after {\n    right: 1.5rem;\n  }\n}\n\n@media only screen and (max-width: 1400px) {\n  [data-sidebar-style=\"full\"][data-layout=\"vertical\"] .deznav .metismenu>li {\n    padding: 0;\n  }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header {\n  width: 5rem;\n  z-index: 999;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .brand-logo {\n  padding-left: 0;\n  padding-right: 0;\n  justify-content: center;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #00ADEE !important;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .copyright,\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .add-menu-sidebar {\n  display: none;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .header {\n  padding-left: 6rem;\n  width: 100%;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .header {\n  padding: 0 0.9375rem;\n  padding-right: 5rem;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav {\n  width: 5rem;\n  overflow: visible;\n  position: absolute;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .nav-text {\n  display: none;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .slimScrollDiv,\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .deznav-scroll {\n  overflow: visible !important;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li {\n  position: relative;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li a {\n  padding: 13px;\n  border-radius: 1.25rem;\n  margin: 2px 0;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li a svg {\n  max-width: 24px;\n  max-height: 24px;\n  margin-right: 0;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li a:before {\n  content: none;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul {\n  position: absolute;\n  left: 5rem;\n  top: 0;\n  width: 12rem;\n  z-index: 1001;\n  display: none;\n  padding-left: 1px;\n  height: auto !important;\n  box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);\n  border-radius: 6px;\n  margin-left: 0;\n  border: 0;\n  background: #3C4B67;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul:after {\n  content: \"\";\n  position: absolute;\n  background: inherit;\n  width: 10px;\n  height: 10px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  left: -5px;\n  top: 20px;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul {\n  left: auto;\n  right: 3rem;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul li:hover ul {\n  left: 11.8125rem;\n  top: 0;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul li:hover ul:after {\n  content: none;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li:hover>ul {\n  display: block;\n  height: auto;\n  overflow: visible;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li {\n  transition: all 0.4s ease-in-out;\n  padding: 0 13px;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li>a {\n  text-align: center;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li>a.has-arrow:after {\n  display: none;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li>a i {\n  padding: 0;\n  width: auto;\n  height: auto;\n  background: transparent;\n  margin: 0;\n  line-height: 1;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a {\n  background: #00ADEE;\n  border-radius: 1.25rem;\n  color: #fff;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a i {\n  color: #fff;\n  padding: 0;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover:nth-last-child(-n + 1)>ul {\n  bottom: 0;\n  top: auto;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  border-radius: 1.25rem;\n  background: #00ADEE;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background: #1e2746;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a i {\n  color: #fff;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>ul {\n  height: auto !important;\n  padding: 10px 0;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>ul a {\n  padding: 6px 20px 6px 20px;\n  margin-left: -.1rem;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>ul ul {\n  padding: 10px 0;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>ul ul a {\n  padding: 6px 20px 6px 20px;\n  margin-left: -.1rem;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu .nav-label,\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu .nav-badge {\n  display: none;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .content-body {\n  margin-left: 5rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .content-body {\n  margin-right: 5rem;\n  margin-left: auto;\n  border: 0;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle+.footer {\n  padding-left: 5rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle+.footer {\n  padding-left: 0;\n  padding-right: 5rem;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"horizontal\"] .deznav .metismenu {\n  padding: 0 30px;\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"horizontal\"] .header .header-content {\n  padding-left: 1.875rem;\n}\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n/*$primary  : #7356f1 !default;*/\n@media only screen and (min-width: 768px) {\n  [data-sidebar-style=\"mini\"] .nav-header {\n    width: 5rem;\n  }\n\n  [data-sidebar-style=\"mini\"] .nav-header .nav-control {\n    z-index: -1;\n  }\n\n  [data-sidebar-style=\"mini\"] .nav-header .nav-control .hamburger {\n    left: 5rem !important;\n  }\n\n  [data-sidebar-style=\"mini\"] .nav-header .nav-control .hamburger .line {\n    background-color: #B1B1B1 !important;\n  }\n\n  [data-sidebar-style=\"mini\"] .nav-header .brand-title {\n    display: none;\n  }\n\n  [data-sidebar-style=\"mini\"] .nav-header .hamburger {\n    display: none;\n  }\n\n  [data-sidebar-style=\"mini\"] .header .header-content {\n    padding-left: 1.875rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"mini\"] .header .header-content {\n    padding-right: 1.875rem;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav {\n    width: 5rem;\n    overflow: visible;\n    position: absolute !important;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .copyright,\n  [data-sidebar-style=\"mini\"] .deznav .add-menu-sidebar {\n    display: none;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .nav-text {\n    display: none;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .slimScrollDiv,\n  [data-sidebar-style=\"mini\"] .deznav .deznav-scroll {\n    overflow: visible !important;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .nav-user {\n    padding: 11px;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .nav-user .media-body {\n    display: none;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .metismenu li a {\n    padding: 0.813rem 1rem;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .metismenu li a svg {\n    margin-right: 0;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .metismenu li>ul {\n    position: absolute;\n    left: 5rem;\n    top: 2.9375rem;\n    width: 11.875rem;\n    z-index: 1001;\n    display: none;\n    padding-left: 1px;\n    box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);\n    height: auto !important;\n    border-radius: 6px;\n    background: #3C4B67;\n  }\n\n  [direction=\"rtl\"]:not([data-layout=\"horizontal\"])[data-sidebar-style=\"mini\"] .deznav .metismenu li>ul {\n    left: auto;\n    right: 5rem;\n    box-shadow: -6px 6px 10px rgba(0, 0, 0, 0.15);\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .metismenu>li {\n    padding: 2px 15px;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .metismenu>li>a.has-arrow:after {\n    display: none;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav .metismenu .nav-label,\n  [data-sidebar-style=\"mini\"] .deznav .metismenu .nav-badge {\n    display: none;\n  }\n\n  [data-sidebar-style=\"mini\"] .content-body {\n    margin-left: 5rem;\n  }\n\n  [data-sidebar-style=\"mini\"] .footer {\n    padding-left: 5rem;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li:hover>ul {\n    display: block;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:nth-last-child(-n + 1)>ul {\n    bottom: 0;\n    top: auto !important;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:nth-last-child(-n + 1)>ul:after {\n    top: auto;\n    bottom: 20px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1199px) {\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:nth-last-child(-n + 1)>ul {\n    bottom: 0;\n    top: auto !important;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li>ul {\n    overflow: visible;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li>ul:after {\n    content: none;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li>ul li:hover ul {\n    padding: 10px 0;\n    width: 13rem;\n    left: 13rem;\n    top: -10px;\n    border: 0;\n    margin: 0;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li>ul li:hover ul:after {\n    content: none;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li>ul li:hover ul {\n    left: auto;\n    right: 13rem;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a {\n    background: #00ADEE;\n    color: #fff;\n    border-radius: 1.25rem;\n  }\n\n  [data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a {\n    background: #1e2746;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n    background: #00ADEE;\n    color: #fff;\n    border-radius: 1.25rem;\n    position: unset;\n  }\n\n  [data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n    background: #1e2746;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a .nav-text {\n    padding-left: auto;\n    padding-right: 1.6875rem;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul {\n    height: auto !important;\n    overflow: visible;\n    border: 0;\n    margin-left: 0;\n    left: 5rem;\n    width: 13rem;\n    border-radius: 12px;\n    border: 0;\n    padding: 10px 0;\n    top: 0;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul:after {\n    content: \"\";\n    position: absolute;\n    background: inherit;\n    width: 10px;\n    height: 10px;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    left: -5px;\n    top: 20px;\n  }\n\n  [data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul {\n    box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.1);\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul {\n    left: auto;\n    right: 5rem;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul a {\n    padding: 6px 20px 6px 20px;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul a:before {\n    content: none;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul a.has-arrow:after {\n    right: 1.25rem;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul ul a {\n    padding: 6px 20px 6px 20px;\n    margin-left: -1.6px;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>ul ul a:before {\n    content: none;\n  }\n\n  [data-sidebar-style=\"mini\"][data-header-position=\"fixed\"][data-container=\"boxed\"][data-layout=\"vertical\"] .header {\n    width: 1199px;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .deznav .metismenu {\n    padding: 0 30px;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .deznav .metismenu>li>a {\n    padding: 15px 20px;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .deznav .metismenu>li>a {\n    padding: 15px 20px;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .deznav .metismenu>li>a svg {\n    margin-left: 0;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .deznav .metismenu>li>a svg {\n    margin-right: 0;\n    margin-top: 0;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  [data-sidebar-style=\"mini\"] .deznav li.mm-active ul {\n    height: auto !important;\n  }\n\n  [data-sidebar-style=\"mini\"] .deznav li a.has-arrow::after {\n    transform: rotate(-45deg) translateY(-50%);\n  }\n}\n\n/*$primary  : #7356f1 !default;*/\n@media (min-width: 1199px) {\n  [data-layout=\"horizontal\"] .nav-header {\n    width: 16rem;\n  }\n\n  [data-layout=\"horizontal\"] .nav-header .nav-control {\n    display: none;\n  }\n\n  [data-layout=\"horizontal\"] .nav-header .brand-logo {\n    /*  padding-left: 0;\n       justify-content: center; */\n  }\n\n  [data-layout=\"horizontal\"] .header {\n    width: 100%;\n    padding-left: 16rem;\n  }\n\n  [data-layout=\"horizontal\"] .deznav {\n    width: 100%;\n    position: relative;\n    height: auto;\n    padding-bottom: 0;\n    top: 0;\n    z-index: 2;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .slimScrollDiv {\n    overflow: visible !important;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .slimScrollDiv .deznav-scroll {\n    overflow: visible !important;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .deznav-scroll {\n    overflow: visible !important;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .slimScrollBar {\n    display: none !important;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .nav-user,\n  [data-layout=\"horizontal\"] .deznav .nav-label {\n    display: none;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu {\n    flex-direction: row;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu .collapse.in {\n    display: none;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu ul {\n    border-left: 0;\n  }\n\n  [data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu ul {\n    box-shadow: 0px 10px 13px 0px rgba(0, 0, 0, 0.1);\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li {\n    flex-direction: column;\n    position: relative;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li:hover>ul {\n    display: block;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li>ul {\n    position: absolute;\n    height: auto !important;\n    top: 3.25rem;\n    width: 100%;\n    min-width: 13.75rem;\n    z-index: 999;\n    left: auto;\n    right: auto;\n    padding: 0.5rem 0;\n    display: none;\n    box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);\n    margin: 0;\n    background: #3C4B67;\n  }\n\n  [data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu li>ul {\n    box-shadow: 0px 10px 13px 0px rgba(0, 0, 0, 0.1);\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li>ul li {\n    padding: 0;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li>ul li a {\n    transition: all .4s ease-in-out;\n    padding: 8px 20px 8px 45px;\n    margin-left: -.1rem;\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu li>ul li a {\n    padding: 8px 45px 8px 20px;\n    text-align: right;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li>ul li a:hover {\n    border-radius: .4rem;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li>ul li a:before {\n    left: 22px;\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu li>ul li a:before {\n    left: auto;\n    right: 21px;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu li>ul ul {\n    left: 100%;\n    top: 0;\n    box-shadow: 0px 10px 13px 0px rgba(82, 63, 105, 0.05);\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu li>ul ul {\n    left: auto;\n    right: 100%;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li {\n    flex: 0 0 auto;\n    position: relative;\n  }\n\n  [data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n    border-color: rgba(255, 255, 255, 0.07);\n  }\n\n  [data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li.mm-active {\n    border-color: transparent;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li.mm-active {\n    padding: 0;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li.mm-active>a {\n    background: #fff;\n    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu>li:first-child {\n    border-right: 0;\n  }\n\n  [data-theme-version=\"dark\"][direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n    border-color: #333a54;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li>a {\n    padding: 15px 40px 15px 15px;\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu>li>a {\n    padding: 15px 15px 15px 40px;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li>a i {\n    padding: 0 0.4375rem 0 0;\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu>li>a i {\n    padding: 0 0 0 0.4375rem;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li>a .nav-badge {\n    display: none;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li>a:after {\n    right: 20px;\n    transform: rotate(-135deg) translateY(-50%);\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li:hover {\n    border-color: transparent;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li:hover>ul {\n    display: flex !important;\n    flex-direction: column;\n    flex-wrap: wrap;\n    height: auto !important;\n    box-shadow: 0px 10px 13px 0px rgba(82, 63, 105, 0.05);\n  }\n\n  [data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li:hover>ul {\n    box-shadow: 0px 0 13px 0px rgba(0, 0, 0, 0.1);\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li>ul>li:hover ul.collapse {\n    display: block !important;\n    position: absolute;\n    left: auto !important;\n    right: -100% !important;\n    top: 0 !important;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li:nth-last-child(-n + 5)>ul {\n    left: auto;\n    right: 0;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li:nth-last-child(-n + 5)>ul>li:hover ul.collapse {\n    right: auto !important;\n    left: -100% !important;\n  }\n\n  [data-layout=\"horizontal\"] .deznav .metismenu>li:last-child>ul ul {\n    left: -100%;\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu>li:nth-last-child(-n + 3)>ul {\n    left: 0;\n    right: auto;\n  }\n\n  [direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu>li:nth-last-child(-n + 3)>ul>li:hover ul.collapse {\n    right: -100% !important;\n    left: auto !important;\n  }\n\n  [data-layout=\"horizontal\"] .content-body {\n    margin-left: 0;\n  }\n\n  [data-layout=\"horizontal\"] .content-body .page-titles {\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 1.875rem;\n  }\n\n  [data-layout=\"horizontal\"] .footer {\n    margin-left: 0;\n    margin: 0 auto;\n    padding-left: 0;\n  }\n\n  [data-layout=\"horizontal\"] .sidebar-right {\n    z-index: 1;\n  }\n\n  [data-header-position=\"fixed\"][data-layout=\"horizontal\"] .deznav {\n    top: 5rem;\n  }\n\n  [data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"] .deznav {\n    position: fixed;\n  }\n\n  [data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-sidebar-position=\"fixed\"] .content-body {\n    padding-top: 8.3rem;\n  }\n\n  [data-layout=\"horizontal\"][data-container=\"boxed\"] .footer {\n    margin-left: 0;\n    max-width: 1199px;\n    margin: 0 auto;\n  }\n\n  [data-layout=\"horizontal\"][data-container=\"wide\"] .page-titles {\n    margin-left: -30px;\n    margin-right: -30px;\n  }\n\n  [data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .page-titles {\n    margin-top: 0;\n  }\n\n  [data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .deznav .metismenu>li>ul {\n    top: 4.315rem;\n  }\n\n  [data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .deznav .metismenu>li>a {\n    padding: 0.8125rem 2.1rem;\n  }\n\n  [data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .deznav .metismenu>li>a::after {\n    display: none;\n  }\n\n  [data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .deznav .metismenu>li li {\n    text-align: left;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .nav-header {\n    width: 6rem;\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .nav-header .brand-logo {\n    justify-content: start;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .header {\n    width: 100%;\n    padding-left: 6rem;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .metismenu>li:hover a {\n    width: auto;\n  }\n\n  [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] .metismenu>li:hover a .nav-text {\n    display: none;\n  }\n\n  [data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"compact\"] .content-body {\n    padding-top: 8.75rem;\n  }\n\n  [data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] .deznav.fixed {\n    position: fixed;\n    left: 0;\n    top: 0;\n  }\n}\n\n@media (min-width: 767px) {\n  [data-sidebar-style=\"compact\"] .deznav .nav-user {\n    display: none;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu>li>a {\n    padding: 1.5rem 1.625rem 1.5rem 1.5rem;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu>li ul {\n    padding: 1rem 0;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu>li ul li>a {\n    padding: 0.5rem 1rem;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu>li ul li>a.has-arrow:after {\n    content: \"\";\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li {\n    text-align: center;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li a svg {\n    max-width: 21px;\n    max-height: 21px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li a i {\n    font-size: 2.2rem;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li a:after {\n    content: none;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li a:before {\n    content: \"\";\n    height: 75px;\n    width: 0;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translatey(-50%);\n    background: #00ADEE;\n    border-radius: 0 1.25rem 1.25rem 0;\n    -webkit-transition: all 0.5s;\n    -ms-transition: all 0.5s;\n    transition: all 0.5s;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li ul:after {\n    content: none;\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li.mm-active>a,\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li:hover>a {\n    background: -moz-linear-gradient(left, #e0e0e4 0%, rgba(125, 185, 232, 0) 100%);\n    background: -webkit-linear-gradient(left, #e0e0e4 0%, rgba(125, 185, 232, 0) 100%);\n    background: linear-gradient(to right, #e0e0e4 0%, rgba(125, 185, 232, 0) 100%);\n  }\n\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li.mm-active>a:before,\n  [data-sidebar-style=\"compact\"] .deznav .metismenu li:hover>a:before {\n    width: 10px;\n  }\n\n  [data-sidebar-style=\"compact\"] .nav-text {\n    display: inline-block;\n    margin-top: 0.7125rem;\n  }\n\n  [data-sidebar-style=\"compact\"] .nav-label.first {\n    display: none;\n  }\n\n  [data-sidebar-style=\"compact\"] .nav-badge {\n    display: none;\n  }\n\n  [data-sidebar-style=\"compact\"] .footer {\n    padding-left: 9.375rem;\n  }\n\n  [data-sidebar-style=\"compact\"] .content-body {\n    margin-left: 15rem;\n  }\n}\n\n[data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .footer {\n  padding-left: 0;\n}\n\n[data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .content-body {\n  margin-left: 0;\n}\n\n[data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] .deznav .metismenu {\n  padding: 0 30px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-style=\"compact\"] .deznav {\n  width: 15rem;\n}\n\n[data-layout=\"vertical\"][data-sidebar-style=\"compact\"] .deznav .metismenu ul {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n[data-theme-version=\"dark\"][data-layout=\"vertical\"][data-sidebar-style=\"compact\"] .deznav .metismenu ul {\n  background: 255, 255, 255, 0.05;\n}\n\n[data-layout=\"vertical\"][data-sidebar-style=\"compact\"] .deznav .metismenu ul a:before {\n  content: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-style=\"compact\"] .deznav .metismenu ul ul a {\n  padding: 0.625rem 0.9375rem;\n}\n\n[data-layout=\"vertical\"][data-sidebar-style=\"compact\"] .deznav .metismenu>li>a.has-arrow::after {\n  top: 1px;\n  display: inline-block;\n  right: auto;\n  margin-left: 5px;\n  position: relative;\n  width: 7px;\n  height: 7px;\n  border-width: 2px 0px 0px 2px;\n}\n\n[direction=\"rtl\"][data-layout=\"vertical\"][data-sidebar-style=\"compact\"] .deznav .metismenu>li>a.has-arrow::after {\n  left: auto;\n  margin-left: 0;\n  margin-right: 5px;\n}\n\n@media (min-width: 767px) {\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"horizontal\"] .metismenu {\n    padding: 0 30px;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"horizontal\"] .header .header-content {\n    padding-left: 1.875rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .nav-header {\n    width: 5.063rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .nav-header .brand-logo {\n    padding-left: 20px;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .nav-header .brand-logo {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .nav-header .brand-logo .logo-abbr {\n    display: block;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .nav-header .brand-logo .brand-title {\n    display: none;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .nav-header .nav-control {\n    display: none;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .header {\n    padding-left: 5.063rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .header {\n    padding-right: 4.38rem;\n    padding-left: 0.9375rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .header .header-content {\n    padding-left: 1.375rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .header .header-content {\n    padding-right: 1.375rem;\n    padding-left: 0;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav {\n    overflow: visible;\n    position: absolute;\n    left: -12.125rem;\n  }\n}\n\n@media only screen and (min-width: 767px) and (min-width: 1200px) and (max-width: 1350px) {\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav {\n    left: -10rem;\n  }\n}\n\n@media (min-width: 767px) {\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav {\n    left: auto;\n    right: -12.125rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .nav-label {\n    display: none;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu>li>a {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu>li>a>svg,\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu>li>a>i {\n    order: 1;\n    margin-right: 0;\n    margin-top: 0;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n    border-left: 0;\n    padding-left: 0;\n    padding-right: 28px;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n    padding-right: 0;\n    padding-left: 28px;\n  }\n\n  [data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n    border-color: #333a54;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul:after {\n    left: auto;\n    right: 28px;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul:after {\n    left: 28px;\n    right: auto;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul a {\n    position: relative;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul a::before {\n    left: auto;\n    right: -5px;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul a::before {\n    right: auto;\n    left: -5px;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu .has-arrow::after {\n    right: 5rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu .has-arrow::after {\n    right: auto;\n    left: 5rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .icon-hover-toggle .nav-header {\n    width: 17.1875rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .icon-hover-toggle .nav-header .brand-logo {\n    padding-left: 1.6rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .icon-hover-toggle .nav-header .brand-logo .brand-title {\n    display: block;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .icon-hover-toggle .header {\n    padding-left: 4.38rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .icon-hover-toggle .header {\n    padding-right: 4.38rem;\n    padding-left: 0.9375rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .icon-hover-toggle .deznav {\n    left: 0;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .icon-hover-toggle .deznav {\n    left: auto;\n    right: 0;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .content-body {\n    margin-left: 5rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .content-body {\n    margin-left: 0;\n    margin-right: 5rem;\n  }\n\n  [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .footer {\n    padding-left: 4.375rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .footer {\n    margin-left: 0;\n    margin-right: 4.375rem;\n  }\n}\n\n@media (min-width: 767px) {\n  [data-sidebar-style=\"modern\"] .nav-header {\n    width: 9.375rem;\n  }\n\n  [data-sidebar-style=\"modern\"] .nav-header .brand-logo {\n    justify-content: center;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li {\n    text-align: center;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a {\n    padding: 20px 15px 20px 15px !important;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a::after {\n    display: none;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: white;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li.mm-active {\n    padding: 0;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu>li li {\n    text-align: left;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"modern\"] .deznav .metismenu>li li {\n    text-align: right;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu li a {\n    padding: 0.625rem 0.9375rem 0.625rem 0.9375rem;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu li ul:after {\n    content: none;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu li>ul {\n    height: auto !important;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .metismenu .nav-label {\n    display: none;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .nav-label {\n    display: none;\n  }\n\n  [data-sidebar-style=\"modern\"] .deznav .nav-text {\n    display: block;\n    margin-top: 0.3125rem;\n  }\n\n  [data-sidebar-style=\"modern\"] .footer {\n    padding-left: 9.375rem;\n  }\n\n  [data-sidebar-style=\"modern\"] .content-body {\n    margin-left: 9.375rem;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav {\n    width: 9.375rem;\n    left: 0;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav {\n    left: auto;\n    right: 0;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .slimScrollDiv,\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .deznav-scroll {\n    overflow: visible !important;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu>li>a i {\n    font-size: 20px;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu>li>ul {\n    display: none;\n    padding: 1.875rem 0.9375rem;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li {\n    position: relative;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li a {\n    padding: 0.625rem 1.5rem;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li a:before {\n    content: none;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li ul {\n    position: absolute;\n    left: 105%;\n    top: 0;\n    bottom: auto;\n    background-color: #fff;\n    border: 1px solid #f0f1f5;\n    width: 200px;\n  }\n\n  [data-theme-version=\"dark\"][data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li ul {\n    background: #1e2746;\n    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.1);\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li ul {\n    left: auto;\n    right: 105%;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li:hover>ul {\n    display: block;\n    left: 100%;\n    padding: 1rem 0;\n    margin-left: -10px;\n    border: 0;\n    box-shadow: 5px 0px 13px 0px rgba(82, 63, 105, 0.05);\n  }\n\n  [data-theme-version=\"dark\"][data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li:hover>ul {\n    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.1);\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .metismenu li:hover>ul {\n    left: auto;\n    right: 100%;\n    box-shadow: -5px 0px 13px 0px rgba(82, 63, 105, 0.05);\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .nav-label {\n    display: none;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .deznav .nav-text {\n    display: block;\n    margin-top: 0;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .menu-toggle .deznav {\n    left: -9.375rem;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .menu-toggle .deznav {\n    left: auto;\n    right: -9.375rem;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .menu-toggle .content-body {\n    margin-left: 0;\n  }\n\n  [direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"vertical\"] .menu-toggle .content-body {\n    margin-right: 0;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .footer,\n  [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .content-body {\n    margin-left: 0;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .deznav .metismenu {\n    padding: 0 30px;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .deznav .metismenu>li>a {\n    padding: 0.8125rem 2.25rem;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .deznav .metismenu>li>ul {\n    top: 4.5625rem;\n  }\n\n  [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"][data-container=\"boxed\"] .deznav .metismenu>li>a {\n    padding: 0.8125rem 1.25rem;\n  }\n}\n\n[data-sidebar-style=\"overlay\"] .deznav {\n  left: -100%;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"overlay\"] .deznav {\n  left: auto;\n  right: -100%;\n}\n\n[data-sidebar-style=\"overlay\"] .content-body {\n  margin-left: 0;\n}\n\n[data-sidebar-style=\"overlay\"] .nav-header {\n  position: absolute;\n}\n\n[data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active {\n  left: 0;\n}\n\n[data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #00ADEE;\n}\n\n[data-sidebar-style=\"overlay\"] .menu-toggle .nav-header {\n  position: absolute;\n  left: auto;\n}\n\n[data-sidebar-style=\"overlay\"] .menu-toggle .deznav {\n  left: 0;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"overlay\"] .menu-toggle .deznav {\n  left: auto;\n  right: 0;\n}\n\n[data-sidebar-style=\"overlay\"] .footer {\n  padding-left: 0;\n}\n\n[data-sidebar-style=\"overlay\"][data-header-position=\"fixed\"] .nav-header {\n  position: fixed;\n}\n\n[data-sidebar-position=\"fixed\"][data-header-position=\"fixed\"] .nav-header {\n  position: fixed;\n}\n\n[data-sidebar-position=\"fixed\"][data-layout=\"vertical\"] .nav-header {\n  position: fixed;\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n}\n\n[data-sidebar-position=\"fixed\"][data-layout=\"vertical\"] .deznav {\n  position: fixed;\n}\n\n[data-sidebar-position=\"fixed\"][data-layout=\"vertical\"] .deznav .deznav-scroll {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n}\n\n[data-sidebar-position=\"fixed\"][data-layout=\"vertical\"] .menu-toggle .deznav {\n  position: fixed;\n}\n\n[data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"overlay\"][data-layout=\"vertical\"][data-container=\"boxed\"] .deznav {\n  position: absolute;\n}\n\n.sidebar-right {\n  right: -15.625rem;\n  position: fixed;\n  top: 0;\n  width: 15.625rem;\n  background-color: #fff;\n  height: calc(100% - 7.0625rem);\n  margin-top: 5rem;\n  transition: all .5s ease-in-out;\n  padding-bottom: 1.875rem;\n  box-shadow: -2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n}\n\n[direction=\"rtl\"] .sidebar-right .slimScrollDiv {\n  overflow: visible !important;\n}\n\n.sidebar-right .sidebar-right-trigger {\n  position: absolute;\n  z-index: 9;\n  top: 4.75rem;\n  right: 100%;\n  background-color: #fff;\n  color: #00ADEE;\n  display: inline-block;\n  height: 3rem;\n  width: 3rem;\n  text-align: center;\n  font-size: 1.75rem;\n  line-height: 3rem;\n  border-radius: 5px 0 0 5px;\n  box-shadow: -5px 3px 5px 0px rgba(119, 119, 119, 0.15);\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .sidebar-right-trigger {\n  background-color: #31343b;\n  color: #fff;\n}\n\n.sidebar-right .sidebar-right-trigger:hover {\n  color: #00ADEE;\n}\n\n.sidebar-right.show {\n  right: 0;\n  z-index: 999;\n}\n\n.sidebar-right .nav-tabs {\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  background-color: #fff;\n  z-index: 2;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .nav-tabs {\n  background-color: #181f39;\n}\n\n.sidebar-right .nav-tabs .nav-item {\n  margin-bottom: 0;\n  flex: 1;\n}\n\n.sidebar-right .nav-tabs .nav-item .nav-link {\n  border: 0;\n  font-size: 1.125rem;\n  position: relative;\n  text-align: center;\n  background-color: #fff;\n}\n\n.sidebar-right .nav-tabs .nav-item .nav-link::after {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 2px;\n  content: \"\";\n  background: transparent;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .nav-tabs .nav-item .nav-link {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .nav-tabs .nav-item .nav-link.active {\n  border-right: none;\n  border-left: none;\n  border-top: none;\n}\n\n.sidebar-right .tab-content {\n  padding: 1.25rem;\n}\n\n.sidebar-right .tab-content .tab-pane .admin-settings>div {\n  margin-bottom: 10px;\n}\n\n.sidebar-right .tab-content .tab-pane .admin-settings p {\n  margin-bottom: 0.125rem;\n}\n\n.sidebar-right .tab-content .tab-pane .admin-settings input[type=\"radio\"] {\n  display: none;\n}\n\n.sidebar-right .tab-content .tab-pane .admin-settings input[type=\"radio\"]+label {\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n  transition: all .1s ease;\n  border-radius: 4px;\n  margin-right: 5px;\n  margin-bottom: 3px;\n}\n\n.sidebar-right .tab-content .tab-pane .admin-settings input[type=\"radio\"]:checked+label {\n  position: relative;\n}\n\n.sidebar-right .tab-content .tab-pane .admin-settings input[type=\"radio\"]:checked+label::after {\n  height: 33px;\n  width: 33px;\n  left: -4px;\n  top: -4px;\n  content: \"\";\n  position: absolute;\n  background-color: inherit;\n  border-radius: 6px;\n  opacity: 0.4;\n}\n\n.sidebar-right #nav_header_color_1+label,\n.sidebar-right #header_color_1+label,\n.sidebar-right #sidebar_color_1+label,\n.sidebar-right #primary_color_1+label {\n  background-color: #fff;\n}\n\n.sidebar-right #nav_header_color_2+label,\n.sidebar-right #header_color_2+label,\n.sidebar-right #sidebar_color_2+label,\n.sidebar-right #primary_color_2+label {\n  background-color: #143b64;\n}\n\n.sidebar-right #nav_header_color_3+label,\n.sidebar-right #header_color_3+label,\n.sidebar-right #sidebar_color_3+label,\n.sidebar-right #primary_color_3+label {\n  background-color: #00ADEE;\n}\n\n.sidebar-right #nav_header_color_4+label,\n.sidebar-right #header_color_4+label,\n.sidebar-right #sidebar_color_4+label,\n.sidebar-right #primary_color_4+label {\n  background-color: #4527a0;\n}\n\n.sidebar-right #nav_header_color_5+label,\n.sidebar-right #header_color_5+label,\n.sidebar-right #sidebar_color_5+label,\n.sidebar-right #primary_color_5+label {\n  background-color: #c62828;\n}\n\n.sidebar-right #nav_header_color_6+label,\n.sidebar-right #header_color_6+label,\n.sidebar-right #sidebar_color_6+label,\n.sidebar-right #primary_color_6+label {\n  background-color: #283593;\n}\n\n.sidebar-right #nav_header_color_7+label,\n.sidebar-right #header_color_7+label,\n.sidebar-right #sidebar_color_7+label,\n.sidebar-right #primary_color_7+label {\n  background-color: #7356f1;\n}\n\n.sidebar-right #nav_header_color_8+label,\n.sidebar-right #header_color_8+label,\n.sidebar-right #sidebar_color_8+label,\n.sidebar-right #primary_color_8+label {\n  background-color: #3695eb;\n}\n\n.sidebar-right #nav_header_color_9+label,\n.sidebar-right #header_color_9+label,\n.sidebar-right #sidebar_color_9+label,\n.sidebar-right #primary_color_9+label {\n  background-color: #00838f;\n}\n\n.sidebar-right #nav_header_color_10+label,\n.sidebar-right #header_color_10+label,\n.sidebar-right #sidebar_color_10+label,\n.sidebar-right #primary_color_10+label {\n  background-color: #ff8f16;\n}\n\n.sidebar-right #nav_header_color_11+label,\n.sidebar-right #header_color_11+label,\n.sidebar-right #sidebar_color_11+label,\n.sidebar-right #primary_color_11+label {\n  background-color: #6673fd;\n}\n\n.sidebar-right #nav_header_color_12+label,\n.sidebar-right #header_color_12+label,\n.sidebar-right #sidebar_color_12+label,\n.sidebar-right #primary_color_12+label {\n  background-color: #558b2f;\n}\n\n.sidebar-right #nav_header_color_13+label,\n.sidebar-right #header_color_13+label,\n.sidebar-right #sidebar_color_13+label,\n.sidebar-right #primary_color_13+label {\n  background-color: #2a2a2a;\n}\n\n.sidebar-right #nav_header_color_14+label,\n.sidebar-right #header_color_14+label,\n.sidebar-right #sidebar_color_14+label,\n.sidebar-right #primary_color_14+label {\n  background-color: #1367c8;\n}\n\n.sidebar-right #nav_header_color_15+label,\n.sidebar-right #header_color_15+label,\n.sidebar-right #sidebar_color_15+label,\n.sidebar-right #primary_color_15+label {\n  background-color: #ed0b4c;\n}\n\n.sidebar-right #nav_header_color_1+label,\n.sidebar-right #header_color_1+label,\n.sidebar-right #sidebar_color_1+label,\n.sidebar-right #primary_color_1+label {\n  border: 1px solid #89879f;\n}\n\n@keyframes bounce {\n  0% {\n    transform: translateX(-8%);\n    -webkit-transform: translateX(-8%);\n  }\n\n  50% {\n    transform: translateX(8%);\n    -webkit-transform: translateX(8%);\n  }\n\n  100% {\n    transform: translateX(-8%);\n    -webkit-transform: translateX(-8%);\n  }\n}\n\n@-webkit-keyframes bounce {\n  0% {\n    transform: translateX(-8%);\n    -webkit-transform: translateX(-8%);\n  }\n\n  50% {\n    transform: translateX(8%);\n    -webkit-transform: translateX(8%);\n  }\n\n  100% {\n    transform: translateY(-8%);\n    -webkit-transform: translateY(-8%);\n  }\n}\n\n.nav-user {\n  background: #00ADEE;\n  margin-bottom: 10px;\n  padding: 20px 25px 15px;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1199px) {\n  .nav-user {\n    padding: 20px 15px 15px;\n  }\n}\n\n.nav-user img {\n  width: 35px;\n  height: 35px;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1199px) {\n  .nav-user img {\n    width: 35px;\n    height: 35px;\n    margin-bottom: 10px;\n  }\n}\n\n.nav-user h5 {\n  margin-left: 10px;\n  margin-bottom: 3px;\n  color: #fff;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1199px) {\n  .nav-user h5 {\n    display: none;\n  }\n}\n\n[data-sibebarbg=\"color_2\"] .nav-user h5 {\n  color: #fff;\n}\n\n.nav-user p {\n  margin-left: 10px;\n  margin-bottom: 8px;\n  color: #afcff7;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1199px) {\n  .nav-user p {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1199px) {\n  .nav-user i {\n    margin-top: 15px;\n    display: block;\n  }\n}\n\n.menu-toggle .nav-user {\n  padding: 20px 15px 15px;\n}\n\n.menu-toggle .nav-user img {\n  width: 35px;\n  height: 35px;\n  margin-bottom: 10px;\n}\n\n.menu-toggle .nav-user h5,\n.menu-toggle .nav-user p {\n  display: none;\n}\n\n.menu-toggle .nav-user i {\n  margin-top: 15px;\n  display: block;\n}\n\n.menu-toggle .nav-user .dropdown-menu {\n  left: 45px !important;\n  top: 22px !important;\n}\n\n.chatbox {\n  width: 340px;\n  height: 100vh;\n  position: fixed;\n  right: -500px;\n  top: 0;\n  z-index: 999;\n  background: #fff;\n  box-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.15);\n  -webkit-transition: all 0.8s;\n  -ms-transition: all 0.8s;\n  transition: all 0.8s;\n}\n\n[data-theme-version=\"dark\"] .chatbox {\n  background: #1e2746;\n}\n\n.chatbox .chatbox-close {\n  position: absolute;\n  -webkit-transition: all 0.2s;\n  -ms-transition: all 0.2s;\n  transition: all 0.2s;\n  width: 0;\n  height: 100%;\n  right: 340px;\n  background: #000;\n  z-index: 1;\n  opacity: 0.1;\n  cursor: pointer;\n}\n\n.chatbox .card-fotter {\n  padding: 0.75rem 1rem;\n}\n\n.chatbox .card-body {\n  padding: 1rem;\n}\n\n.chatbox.active {\n  right: 0;\n}\n\n.chatbox.active .chatbox-close {\n  width: 100vw;\n}\n\n.chatbox .type_msg {\n  padding-top: 10px;\n}\n\n.chatbox .nav {\n  padding: 1rem 1rem 0 1rem;\n  background: #00ADEE;\n  border: 0;\n  justify-content: space-between;\n}\n\n.chatbox .nav .nav-link {\n  color: #fff;\n  opacity: 0.7;\n  text-transform: uppercase;\n}\n\n.chatbox .nav .nav-link:hover,\n.chatbox .nav .nav-link.active {\n  background: transparent;\n  color: #fff;\n  opacity: 1;\n  border-color: #fff;\n}\n\n.chatbox .img_cont {\n  width: 40px;\n  border-radius: 40px;\n  margin-right: 10px;\n  position: relative;\n  height: 40px;\n  background: #eee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  min-width: 40px;\n  min-height: 40px;\n}\n\n.chatbox .img_cont .icon {\n  color: #fff;\n}\n\n.chatbox .img_cont.primary {\n  background: #f6f1fd;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .chatbox .img_cont.primary {\n  background: rgba(135, 67, 223, 0.2);\n}\n\n.chatbox .img_cont.warning {\n  background: #fff3eb;\n  color: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .chatbox .img_cont.warning {\n  background: rgba(255, 155, 82, 0.1);\n}\n\n.chatbox .img_cont.success {\n  background: #e3f9e9;\n  color: #2BC155;\n}\n\n[data-theme-version=\"dark\"] .chatbox .img_cont.success {\n  background: rgba(43, 193, 85, 0.1);\n}\n\n.chatbox .img_cont.info {\n  background: #dbdbff;\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .chatbox .img_cont.info {\n  background: rgba(45, 40, 255, 0.1);\n}\n\n.chatbox .img_cont img {\n  width: 100%;\n}\n\n.chatbox .img_cont .online_icon {\n  background: #2BC155;\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border-radius: 15px;\n  right: -1px;\n  bottom: 0px;\n  border: 2px solid #fff;\n}\n\n.chatbox .img_cont .online_icon.offline {\n  background: #F94687;\n}\n\n.chatbox .card {\n  box-shadow: none;\n}\n\n.chatbox .search {\n  height: 40px;\n}\n\n.chatbox .user_info span {\n  font-size: 15px;\n  color: #000;\n  display: block;\n  font-weight: 500;\n  line-height: 1;\n  margin-bottom: 5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n  max-width: 170px;\n}\n\n[data-theme-version=\"dark\"] .chatbox .user_info span {\n  color: #fff;\n}\n\n.chatbox .user_info p {\n  font-size: 13px;\n  margin-bottom: 0;\n  line-height: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n  max-width: 170px;\n}\n\n.chatbox .contacts li {\n  padding: 7px 1rem;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n}\n\n[data-theme-version=\"dark\"] .chatbox .contacts li {\n  border-color: #333a54;\n}\n\n.chatbox .contacts li>div {\n  display: flex;\n  align-items: center;\n}\n\n.chatbox .contacts li:hover {\n  background: #f4f7ff;\n}\n\n[data-theme-version=\"dark\"] .chatbox .contacts li:hover {\n  background-color: #181f39;\n}\n\n.chatbox .contacts .name-first-letter {\n  background: #E5E6E7;\n  padding: 4px 1rem;\n  font-weight: 700;\n  color: #000;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n[data-theme-version=\"dark\"] .chatbox .contacts .name-first-letter {\n  color: #fff;\n  background: #181f39;\n}\n\n.chatbox .msg_card_body {\n  height: calc(100vh - 195px);\n}\n\n.chatbox .contacts_body {\n  height: calc(100vh - 120px);\n}\n\n.chatbox .card-header {\n  background: #f4f7ff;\n  padding: 15px 20px;\n  justify-content: center;\n}\n\n.chatbox .card-header h6 {\n  font-size: 15px;\n}\n\n.chatbox .card-header p {\n  line-height: 1.2;\n  font-size: 12px;\n  color: #7e7e7e;\n}\n\n.chatbox .chat-list-header {\n  justify-content: space-between;\n  background: #fff;\n}\n\n[data-theme-version=\"dark\"] .chatbox .chat-list-header {\n  background: #1e2746;\n}\n\n.chatbox .chat-list-header a {\n  text-align: center;\n  width: 30px;\n  height: 30px;\n  background: #E5E6E7;\n  border-radius: 6px;\n  line-height: 30px;\n  display: block;\n}\n\n[data-theme-version=\"dark\"] .chatbox .chat-list-header a {\n  background: rgba(135, 67, 223, 0.2);\n}\n\n[data-theme-version=\"dark\"] .chatbox .chat-list-header a svg g [fill] {\n  fill: #fff;\n}\n\n.chatbox .img_cont_msg {\n  width: 30px;\n  height: 30px;\n  display: block;\n  max-width: 30px;\n  min-width: 30px;\n}\n\n.chatbox .img_cont_msg img {\n  width: 100%;\n}\n\n.chatbox .msg_cotainer {\n  background: #00ADEE;\n  margin-left: 10px;\n  border-radius: 0 1.25rem 1.25rem 1.25rem;\n  padding: 10px 15px;\n  color: #fff;\n  position: relative;\n}\n\n.chatbox .msg_cotainer .msg_time {\n  display: block;\n  font-size: 11px;\n  color: #fff;\n  margin-top: 5px;\n  opacity: 0.5;\n}\n\n.chatbox .msg_cotainer:after {\n  content: \"\";\n  position: absolute;\n  left: -10px;\n  border-right: 10px solid #00ADEE;\n  border-bottom: 10px solid transparent;\n  border-top: 0px solid;\n  top: 0;\n}\n\n.chatbox .msg_cotainer_send {\n  background: #E5E6E7;\n  padding: 10px 15px;\n  border-radius: 6px 0px 6px 6px;\n  margin-right: 10px;\n  color: #222;\n  position: relative;\n  text-align: right;\n}\n\n[data-theme-version=\"dark\"] .chatbox .msg_cotainer_send {\n  background: #181f39;\n  color: #fff;\n}\n\n.chatbox .msg_cotainer_send .msg_time_send {\n  display: block;\n  font-size: 11px;\n  text-align: right;\n  margin-top: 5px;\n  opacity: 0.6;\n}\n\n.chatbox .msg_cotainer_send:after {\n  content: \"\";\n  position: absolute;\n  right: -10px;\n  border-left: 10px solid #E5E6E7;\n  border-bottom: 10px solid transparent;\n  border-top: 0px solid;\n  top: 0;\n}\n\n[data-theme-version=\"dark\"] .chatbox .msg_cotainer_send:after {\n  border-left: 10px solid #181f39;\n}\n\n.chatbox .type_msg .form-control {\n  padding: 10px 0;\n  height: 50px;\n  border: 0;\n  resize: none;\n}\n\n.chatbox .type_msg .btn {\n  font-size: 18px;\n  border-radius: 38px !important;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  margin-top: 6px;\n}\n\n.chatbox .video_cam {\n  margin-left: 15px;\n}\n\n.chatbox .video_cam span {\n  width: 35px;\n  height: 35px;\n  background: #10ca93;\n  text-align: center;\n  line-height: 35px;\n  border-radius: 35px;\n  color: #fff;\n  margin-right: 5px;\n  align-self: center;\n  font-size: 16px;\n  padding: 0 3px;\n  display: inline-block;\n}\n\n.chatbox .note_card .contacts li {\n  padding: 12px 1rem;\n}\n\n@media only screen and (max-width: 576px) {\n  .chatbox {\n    width: 280px;\n  }\n\n  .chatbox .chatbox-close {\n    right: 280px;\n  }\n}\n\n[data-nav-headerbg=\"color_2\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_2\"] .nav-header {\n  background-color: #143b64;\n}\n\n[data-nav-headerbg=\"color_2\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_2\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_2\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_2\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_2\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_2\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_2\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_3\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_3\"] .nav-header {\n  background-color: #00ADEE;\n}\n\n[data-nav-headerbg=\"color_3\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_3\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_3\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_3\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_3\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_3\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_3\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_4\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_4\"] .nav-header {\n  background-color: #4527a0;\n}\n\n[data-nav-headerbg=\"color_4\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_4\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_4\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_4\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_4\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_4\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_4\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_5\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_5\"] .nav-header {\n  background-color: #c62828;\n}\n\n[data-nav-headerbg=\"color_5\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_5\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_5\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_5\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_5\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_5\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_5\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_6\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_6\"] .nav-header {\n  background-color: #283593;\n}\n\n[data-nav-headerbg=\"color_6\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_6\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_6\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_6\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_6\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_6\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_6\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_7\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_7\"] .nav-header {\n  background-color: #7356f1;\n}\n\n[data-nav-headerbg=\"color_7\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_7\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_7\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_7\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_7\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_7\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_7\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_8\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_8\"] .nav-header {\n  background-color: #3695eb;\n}\n\n[data-nav-headerbg=\"color_8\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_8\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_8\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_8\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_8\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_8\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_8\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_9\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_9\"] .nav-header {\n  background-color: #00838f;\n}\n\n[data-nav-headerbg=\"color_9\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_9\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_9\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_9\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_9\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_9\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_9\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_10\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_10\"] .nav-header {\n  background-color: #ff8f16;\n}\n\n[data-nav-headerbg=\"color_10\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_10\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_10\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_10\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_10\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_10\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_10\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_11\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_11\"] .nav-header {\n  background-color: #6673fd;\n}\n\n[data-nav-headerbg=\"color_11\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_11\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_11\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_11\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_11\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_11\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_11\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_12\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_12\"] .nav-header {\n  background-color: #558b2f;\n}\n\n[data-nav-headerbg=\"color_12\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_12\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_12\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_12\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_12\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_12\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_12\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_13\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_13\"] .nav-header {\n  background-color: #2a2a2a;\n}\n\n[data-nav-headerbg=\"color_13\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_13\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_13\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_13\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_13\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_13\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_13\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_14\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_14\"] .nav-header {\n  background-color: #1367c8;\n}\n\n[data-nav-headerbg=\"color_14\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_14\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_14\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_14\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_14\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_14\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_14\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_15\"][data-theme-version=\"dark\"] .nav-header,\n[data-nav-headerbg=\"color_15\"] .nav-header {\n  background-color: #ed0b4c;\n}\n\n[data-nav-headerbg=\"color_15\"][data-theme-version=\"dark\"] .nav-header .brand-logo,\n[data-nav-headerbg=\"color_15\"] .nav-header .brand-logo {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_15\"][data-theme-version=\"dark\"] .nav-header .brand-logo:hover,\n[data-nav-headerbg=\"color_15\"] .nav-header .brand-logo:hover {\n  color: #fff;\n}\n\n[data-nav-headerbg=\"color_15\"][data-theme-version=\"dark\"] .nav-header .hamburger .line,\n[data-nav-headerbg=\"color_15\"] .nav-header .hamburger .line {\n  background: #fff;\n}\n\n[data-nav-headerbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line,\n[data-nav-headerbg=\"color_15\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_2\"] .header {\n  background-color: #143b64;\n  color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_2\"] .header-left input {\n  border-color: #1d548f;\n  background-color: #1d548f !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_2\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_2\"] .header-left input:focus {\n  border-color: #0c223a;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_2\"] .header-left .search_icon {\n  background-color: #1d548f !important;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_2\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_2\"] .header-left .btn {\n  background-color: #0c223a;\n  border-color: #0c223a;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_2\"] .header-left .btn:hover,\n[data-headerbg=\"color_2\"] .header-left .btn:focus,\n[data-headerbg=\"color_2\"] .header-left .btn:active {\n  background-color: #03090f;\n  border-color: #03090f;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_2\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_2\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_2\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_2\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_2\"] .header-right .notification_dropdown .nav-link {\n  background-color: #1d548f !important;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_2\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_2\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_2\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_2\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_2\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_2\"] .nav-control {\n  background-color: #1d548f;\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_3\"] .header {\n  background-color: #00ADEE;\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_3\"] .header-left input {\n  border-color: #a36fe6;\n  background-color: #a36fe6 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_3\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_3\"] .header-left input:focus {\n  border-color: #6d23cc;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_3\"] .header-left .search_icon {\n  background-color: #a36fe6 !important;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_3\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_3\"] .header-left .btn {\n  background-color: #6d23cc;\n  border-color: #6d23cc;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_3\"] .header-left .btn:hover,\n[data-headerbg=\"color_3\"] .header-left .btn:focus,\n[data-headerbg=\"color_3\"] .header-left .btn:active {\n  background-color: #551ba1;\n  border-color: #551ba1;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_3\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_3\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_3\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_3\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_3\"] .header-right .notification_dropdown .nav-link {\n  background-color: #a36fe6 !important;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_3\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_3\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_3\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_3\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_3\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_3\"] .nav-control {\n  background-color: #a36fe6;\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_4\"] .header {\n  background-color: #4527a0;\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_4\"] .header-left input {\n  border-color: #5731c9;\n  background-color: #5731c9 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_4\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_4\"] .header-left input:focus {\n  border-color: #331d77;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_4\"] .header-left .search_icon {\n  background-color: #5731c9 !important;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_4\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_4\"] .header-left .btn {\n  background-color: #331d77;\n  border-color: #331d77;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_4\"] .header-left .btn:hover,\n[data-headerbg=\"color_4\"] .header-left .btn:focus,\n[data-headerbg=\"color_4\"] .header-left .btn:active {\n  background-color: #22134e;\n  border-color: #22134e;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_4\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_4\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_4\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_4\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_4\"] .header-right .notification_dropdown .nav-link {\n  background-color: #5731c9 !important;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_4\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_4\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_4\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_4\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_4\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_4\"] .nav-control {\n  background-color: #5731c9;\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_5\"] .header {\n  background-color: #c62828;\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_5\"] .header-left input {\n  border-color: #da4747;\n  background-color: #da4747 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_5\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_5\"] .header-left input:focus {\n  border-color: #9c1f1f;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_5\"] .header-left .search_icon {\n  background-color: #da4747 !important;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_5\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_5\"] .header-left .btn {\n  background-color: #9c1f1f;\n  border-color: #9c1f1f;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_5\"] .header-left .btn:hover,\n[data-headerbg=\"color_5\"] .header-left .btn:focus,\n[data-headerbg=\"color_5\"] .header-left .btn:active {\n  background-color: #711717;\n  border-color: #711717;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_5\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_5\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_5\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_5\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_5\"] .header-right .notification_dropdown .nav-link {\n  background-color: #da4747 !important;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_5\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_5\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_5\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_5\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_5\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_5\"] .nav-control {\n  background-color: #da4747;\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_6\"] .header {\n  background-color: #283593;\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_6\"] .header-left input {\n  border-color: #3343bb;\n  background-color: #3343bb !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_6\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_6\"] .header-left input:focus {\n  border-color: #1d276b;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_6\"] .header-left .search_icon {\n  background-color: #3343bb !important;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_6\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_6\"] .header-left .btn {\n  background-color: #1d276b;\n  border-color: #1d276b;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_6\"] .header-left .btn:hover,\n[data-headerbg=\"color_6\"] .header-left .btn:focus,\n[data-headerbg=\"color_6\"] .header-left .btn:active {\n  background-color: #121843;\n  border-color: #121843;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_6\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_6\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_6\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_6\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_6\"] .header-right .notification_dropdown .nav-link {\n  background-color: #3343bb !important;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_6\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_6\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_6\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_6\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_6\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_6\"] .nav-control {\n  background-color: #3343bb;\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_7\"] .header {\n  background-color: #7356f1;\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_7\"] .header-left input {\n  border-color: #9a85f5;\n  background-color: #9a85f5 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_7\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_7\"] .header-left input:focus {\n  border-color: #4c27ed;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_7\"] .header-left .search_icon {\n  background-color: #9a85f5 !important;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_7\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_7\"] .header-left .btn {\n  background-color: #4c27ed;\n  border-color: #4c27ed;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_7\"] .header-left .btn:hover,\n[data-headerbg=\"color_7\"] .header-left .btn:focus,\n[data-headerbg=\"color_7\"] .header-left .btn:active {\n  background-color: #3511d0;\n  border-color: #3511d0;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_7\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_7\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_7\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_7\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_7\"] .header-right .notification_dropdown .nav-link {\n  background-color: #9a85f5 !important;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_7\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_7\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_7\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_7\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_7\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_7\"] .nav-control {\n  background-color: #9a85f5;\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_8\"] .header {\n  background-color: #3695eb;\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_8\"] .header-left input {\n  border-color: #64adf0;\n  background-color: #64adf0 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_8\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_8\"] .header-left input:focus {\n  border-color: #167cd8;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_8\"] .header-left .search_icon {\n  background-color: #64adf0 !important;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_8\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_8\"] .header-left .btn {\n  background-color: #167cd8;\n  border-color: #167cd8;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_8\"] .header-left .btn:hover,\n[data-headerbg=\"color_8\"] .header-left .btn:focus,\n[data-headerbg=\"color_8\"] .header-left .btn:active {\n  background-color: #1161aa;\n  border-color: #1161aa;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_8\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_8\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_8\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_8\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_8\"] .header-right .notification_dropdown .nav-link {\n  background-color: #64adf0 !important;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_8\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_8\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_8\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_8\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_8\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_8\"] .nav-control {\n  background-color: #64adf0;\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_9\"] .header {\n  background-color: #00838f;\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_9\"] .header-left input {\n  border-color: #00b2c2;\n  background-color: #00b2c2 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_9\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_9\"] .header-left input:focus {\n  border-color: #00545c;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_9\"] .header-left .search_icon {\n  background-color: #00b2c2 !important;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_9\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_9\"] .header-left .btn {\n  background-color: #00545c;\n  border-color: #00545c;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_9\"] .header-left .btn:hover,\n[data-headerbg=\"color_9\"] .header-left .btn:focus,\n[data-headerbg=\"color_9\"] .header-left .btn:active {\n  background-color: #002629;\n  border-color: #002629;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_9\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_9\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_9\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_9\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_9\"] .header-right .notification_dropdown .nav-link {\n  background-color: #00b2c2 !important;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_9\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_9\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_9\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_9\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_9\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_9\"] .nav-control {\n  background-color: #00b2c2;\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_10\"] .header {\n  background-color: #ff8f16;\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_10\"] .header-left input {\n  border-color: #ffa849;\n  background-color: #ffa849 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_10\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_10\"] .header-left input:focus {\n  border-color: #e27500;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_10\"] .header-left .search_icon {\n  background-color: #ffa849 !important;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_10\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_10\"] .header-left .btn {\n  background-color: #e27500;\n  border-color: #e27500;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_10\"] .header-left .btn:hover,\n[data-headerbg=\"color_10\"] .header-left .btn:focus,\n[data-headerbg=\"color_10\"] .header-left .btn:active {\n  background-color: #af5b00;\n  border-color: #af5b00;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_10\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_10\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_10\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_10\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_10\"] .header-right .notification_dropdown .nav-link {\n  background-color: #ffa849 !important;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_10\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_10\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_10\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_10\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_10\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_10\"] .nav-control {\n  background-color: #ffa849;\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_11\"] .header {\n  background-color: #6673fd;\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_11\"] .header-left input {\n  border-color: #98a1fe;\n  background-color: #98a1fe !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_11\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_11\"] .header-left input:focus {\n  border-color: #3445fc;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_11\"] .header-left .search_icon {\n  background-color: #98a1fe !important;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_11\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_11\"] .header-left .btn {\n  background-color: #3445fc;\n  border-color: #3445fc;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_11\"] .header-left .btn:hover,\n[data-headerbg=\"color_11\"] .header-left .btn:focus,\n[data-headerbg=\"color_11\"] .header-left .btn:active {\n  background-color: #0318fa;\n  border-color: #0318fa;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_11\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_11\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_11\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_11\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_11\"] .header-right .notification_dropdown .nav-link {\n  background-color: #98a1fe !important;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_11\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_11\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_11\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_11\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_11\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_11\"] .nav-control {\n  background-color: #98a1fe;\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_12\"] .header {\n  background-color: #558b2f;\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_12\"] .header-left input {\n  border-color: #6cb13c;\n  background-color: #6cb13c !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_12\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_12\"] .header-left input:focus {\n  border-color: #3e6522;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_12\"] .header-left .search_icon {\n  background-color: #6cb13c !important;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_12\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_12\"] .header-left .btn {\n  background-color: #3e6522;\n  border-color: #3e6522;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_12\"] .header-left .btn:hover,\n[data-headerbg=\"color_12\"] .header-left .btn:focus,\n[data-headerbg=\"color_12\"] .header-left .btn:active {\n  background-color: #263f15;\n  border-color: #263f15;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_12\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_12\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_12\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_12\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_12\"] .header-right .notification_dropdown .nav-link {\n  background-color: #6cb13c !important;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_12\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_12\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_12\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_12\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_12\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_12\"] .nav-control {\n  background-color: #6cb13c;\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_13\"] .header {\n  background-color: #2a2a2a;\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_13\"] .header-left input {\n  border-color: #444444;\n  background-color: #444444 !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_13\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_13\"] .header-left input:focus {\n  border-color: #111111;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_13\"] .header-left .search_icon {\n  background-color: #444444 !important;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_13\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_13\"] .header-left .btn {\n  background-color: #111111;\n  border-color: #111111;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_13\"] .header-left .btn:hover,\n[data-headerbg=\"color_13\"] .header-left .btn:focus,\n[data-headerbg=\"color_13\"] .header-left .btn:active {\n  background-color: black;\n  border-color: black;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_13\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_13\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_13\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_13\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_13\"] .header-right .notification_dropdown .nav-link {\n  background-color: #444444 !important;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_13\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_13\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_13\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_13\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_13\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_13\"] .nav-control {\n  background-color: #444444;\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_14\"] .header {\n  background-color: #1367c8;\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_14\"] .header-left input {\n  border-color: #2480ea;\n  background-color: #2480ea !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_14\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_14\"] .header-left input:focus {\n  border-color: #0f4f99;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_14\"] .header-left .search_icon {\n  background-color: #2480ea !important;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_14\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_14\"] .header-left .btn {\n  background-color: #0f4f99;\n  border-color: #0f4f99;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_14\"] .header-left .btn:hover,\n[data-headerbg=\"color_14\"] .header-left .btn:focus,\n[data-headerbg=\"color_14\"] .header-left .btn:active {\n  background-color: #0a376b;\n  border-color: #0a376b;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_14\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_14\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_14\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_14\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_14\"] .header-right .notification_dropdown .nav-link {\n  background-color: #2480ea !important;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_14\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_14\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_14\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_14\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_14\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_14\"] .nav-control {\n  background-color: #2480ea;\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header,\n[data-headerbg=\"color_15\"] .header {\n  background-color: #ed0b4c;\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left input,\n[data-headerbg=\"color_15\"] .header-left input {\n  border-color: #f6356d;\n  background-color: #f6356d !important;\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left input::placeholder,\n[data-headerbg=\"color_15\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left input:focus,\n[data-headerbg=\"color_15\"] .header-left input:focus {\n  border-color: #bc093c;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left .search_icon,\n[data-headerbg=\"color_15\"] .header-left .search_icon {\n  background-color: #f6356d !important;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left .search_icon i,\n[data-headerbg=\"color_15\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left .btn,\n[data-headerbg=\"color_15\"] .header-left .btn {\n  background-color: #bc093c;\n  border-color: #bc093c;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left .btn:hover,\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left .btn:focus,\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-left .btn:active,\n[data-headerbg=\"color_15\"] .header-left .btn:hover,\n[data-headerbg=\"color_15\"] .header-left .btn:focus,\n[data-headerbg=\"color_15\"] .header-left .btn:active {\n  background-color: #8c062d;\n  border-color: #8c062d;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .dropdown>a,\n[data-headerbg=\"color_15\"] .header-right .dropdown>a {\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .pulse-css,\n[data-headerbg=\"color_15\"] .header-right .pulse-css {\n  background-color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .pulse-css:before,\n[data-headerbg=\"color_15\"] .header-right .pulse-css:after,\n[data-headerbg=\"color_15\"] .header-right .pulse-css:before {\n  background-color: inherit;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link,\n[data-headerbg=\"color_15\"] .header-right .notification_dropdown .nav-link {\n  background-color: #f6356d !important;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .right-sidebar a,\n[data-headerbg=\"color_15\"] .header-right .right-sidebar a {\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong,\n[data-headerbg=\"color_15\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info small,\n[data-headerbg=\"color_15\"] .header-right .header-profile>a.nav-link .header-info span,\n[data-headerbg=\"color_15\"] .header-right .header-profile>a.nav-link .header-info small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-headerbg=\"color_15\"][data-theme-version=\"dark\"] .nav-control,\n[data-headerbg=\"color_15\"] .nav-control {\n  background-color: #f6356d;\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_2\"] .deznav {\n  background-color: #143b64;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_2\"] .deznav .menu-tabs li a.active {\n  color: #143b64;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu>li {\n  border-color: #1d548f;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_2\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_2\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #1d548f;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_2\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_2\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #1d548f;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_2\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_2\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_2\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #1d548f;\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_2\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_2\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_2\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_3\"] .deznav {\n  background-color: #00ADEE;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_3\"] .deznav .menu-tabs li a.active {\n  color: #00ADEE;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu>li {\n  border-color: #a36fe6;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_3\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_3\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #a36fe6;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_3\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_3\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #a36fe6;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_3\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_3\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_3\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #a36fe6;\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_3\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_3\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_3\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_4\"] .deznav {\n  background-color: #4527a0;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_4\"] .deznav .menu-tabs li a.active {\n  color: #4527a0;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu>li {\n  border-color: #5731c9;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_4\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_4\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #5731c9;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_4\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_4\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #5731c9;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_4\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_4\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_4\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #5731c9;\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_4\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_4\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_4\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_5\"] .deznav {\n  background-color: #c62828;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_5\"] .deznav .menu-tabs li a.active {\n  color: #c62828;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu>li {\n  border-color: #da4747;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_5\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_5\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #da4747;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_5\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_5\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #da4747;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_5\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_5\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_5\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #da4747;\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_5\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_5\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_5\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_6\"] .deznav {\n  background-color: #283593;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_6\"] .deznav .menu-tabs li a.active {\n  color: #283593;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu>li {\n  border-color: #3343bb;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_6\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_6\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #3343bb;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_6\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_6\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #3343bb;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_6\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_6\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_6\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #3343bb;\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_6\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_6\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_6\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_7\"] .deznav {\n  background-color: #7356f1;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_7\"] .deznav .menu-tabs li a.active {\n  color: #7356f1;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu>li {\n  border-color: #9a85f5;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_7\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_7\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #9a85f5;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_7\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_7\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #9a85f5;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_7\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_7\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_7\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #9a85f5;\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_7\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_7\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_7\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_8\"] .deznav {\n  background-color: #3695eb;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_8\"] .deznav .menu-tabs li a.active {\n  color: #3695eb;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu>li {\n  border-color: #64adf0;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_8\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_8\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #64adf0;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_8\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_8\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #64adf0;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_8\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_8\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_8\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #64adf0;\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_8\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_8\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_8\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_9\"] .deznav {\n  background-color: #00838f;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_9\"] .deznav .menu-tabs li a.active {\n  color: #00838f;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu>li {\n  border-color: #00b2c2;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_9\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_9\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #00b2c2;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_9\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_9\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #00b2c2;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_9\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_9\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_9\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #00b2c2;\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_9\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_9\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_9\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_10\"] .deznav {\n  background-color: #ff8f16;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_10\"] .deznav .menu-tabs li a.active {\n  color: #ff8f16;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu>li {\n  border-color: #ffa849;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_10\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_10\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #ffa849;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_10\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_10\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #ffa849;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_10\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_10\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_10\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #ffa849;\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_10\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_10\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_10\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_11\"] .deznav {\n  background-color: #6673fd;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_11\"] .deznav .menu-tabs li a.active {\n  color: #6673fd;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu>li {\n  border-color: #98a1fe;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_11\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_11\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #98a1fe;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_11\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_11\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #98a1fe;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_11\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_11\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_11\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #98a1fe;\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_11\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_11\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_11\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_12\"] .deznav {\n  background-color: #558b2f;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_12\"] .deznav .menu-tabs li a.active {\n  color: #558b2f;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu>li {\n  border-color: #6cb13c;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_12\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_12\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #6cb13c;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_12\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_12\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #6cb13c;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_12\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_12\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_12\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #6cb13c;\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_12\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_12\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_12\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_13\"] .deznav {\n  background-color: #2a2a2a;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_13\"] .deznav .menu-tabs li a.active {\n  color: #2a2a2a;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu>li {\n  border-color: #444444;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_13\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_13\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #444444;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_13\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_13\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #444444;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_13\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_13\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_13\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #444444;\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_13\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_13\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_13\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_14\"] .deznav {\n  background-color: #1367c8;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_14\"] .deznav .menu-tabs li a.active {\n  color: #1367c8;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu>li {\n  border-color: #2480ea;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_14\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_14\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #2480ea;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_14\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_14\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #2480ea;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_14\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_14\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_14\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #2480ea;\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_14\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_14\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_14\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav,\n[data-sibebarbg=\"color_15\"] .deznav {\n  background-color: #ed0b4c;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .menu-tabs li a.active,\n[data-sibebarbg=\"color_15\"] .deznav .menu-tabs li a.active {\n  color: #ed0b4c;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu .nav-label,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu .nav-label {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a svg,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li>a svg {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li>a g [fill],\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li>a g [fill] {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li:focus>a,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a g [fill],\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li:hover>a g [fill],\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li:focus>a g [fill],\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li.mm-active>a g [fill] {\n  fill: #fff;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a svg,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li:hover>a svg,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li:focus>a svg,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li.mm-active>a svg {\n  color: #fff;\n}\n\n[data-layout=\"horizontal\"][data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu>li {\n  border-color: #f6356d;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu a,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu a.mm-active,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu a:hover,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu a:focus,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu a.mm-active {\n  color: #fff;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"] .deznav .metismenu ul:after,\n[data-sibebarbg=\"color_15\"] .deznav .metismenu ul:after {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_15\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu li>ul {\n  background-color: #f6356d;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_15\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_15\"][data-sidebar-style=\"mini\"][data-layout=\"vertical\"] .deznav .metismenu>li:hover>a {\n  background-color: #f6356d;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a,\n[data-sibebarbg=\"color_15\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul,\n[data-sibebarbg=\"color_15\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li.mm-active>a,\n[data-sibebarbg=\"color_15\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu>li:hover>a {\n  background-color: #f6356d;\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul,\n[data-sibebarbg=\"color_15\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] .deznav .metismenu ul {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-sibebarbg=\"color_15\"][data-theme-version=\"dark\"][data-layout=\"horizontal\"] .deznav .metismenu>li,\n[data-sibebarbg=\"color_15\"][data-layout=\"horizontal\"] .deznav .metismenu>li {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n[data-headerbg=\"transparent\"] .header {\n  box-shadow: none;\n  background: transparent;\n}\n\n[data-headerbg=\"color_1\"] .nav-header .hamburger.is-active .line,\n[data-headerbg=\"color_1\"] .nav-header .hamburger .line {\n  background: #00ADEE !important;\n}\n\n@media (min-width: 992px) {\n  [data-container=\"boxed\"] #main-wrapper {\n    max-width: 1199px;\n    margin: 0 auto;\n  }\n\n  [direction=\"rtl\"][data-container=\"boxed\"] #main-wrapper {\n    text-align: right;\n  }\n}\n\n@media only screen and (min-width: 1350px) {\n  [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"boxed\"][data-header-position=\"fixed\"] .header {\n    width: 1199px;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1349px) {\n  [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"boxed\"][data-header-position=\"fixed\"] .header {\n    width: 1199px;\n  }\n}\n\n[data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"boxed\"] .deznav {\n  max-width: 1199px;\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"] .header {\n  width: 1199px;\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"mini\"] .header {\n  width: 1199px;\n}\n\n[data-container=\"boxed\"] .metismenu.fixed {\n  left: auto;\n  max-width: 1199px;\n}\n\n[data-container=\"boxed\"] .page-titles {\n  margin-bottom: 3rem;\n  padding: 15px 15px;\n}\n\n[data-container=\"boxed\"] .content-body .container-fluid,\n[data-container=\"boxed\"] .content-body .container-sm,\n[data-container=\"boxed\"] .content-body .container-md,\n[data-container=\"boxed\"] .content-body .container-lg,\n[data-container=\"boxed\"] .content-body .container-xl {\n  padding: 0.9375rem 0.9375rem 0 0.9375rem;\n}\n\n[data-container=\"boxed\"][data-layout=\"vertical\"] .page-titles {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"static\"][data-sidebar-style=\"overlay\"] .nav-header {\n  position: absolute;\n}\n\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"static\"][data-sidebar-style=\"overlay\"] .menu-toggle .deznav {\n  position: absolute;\n}\n\n[data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] .deznav.fixed {\n  left: auto;\n  max-width: 1199px;\n}\n\n@media (min-width: 992px) {\n  [data-container=\"wide-boxed\"] #main-wrapper {\n    max-width: 1480px;\n    margin: 0 auto;\n  }\n}\n\n@media (min-width: 992px) {\n  [data-container=\"wide-boxed\"][data-sidebar-style=\"full\"] .header {\n    width: 100%;\n  }\n\n  [data-container=\"wide-boxed\"][data-sidebar-style=\"full\"] .menu-toggle .header {\n    width: 100%;\n  }\n\n  [data-header-position=\"fixed\"][data-container=\"wide-boxed\"][data-sidebar-style=\"full\"] .header {\n    max-width: 1480px;\n  }\n\n  [data-header-position=\"fixed\"][data-container=\"wide-boxed\"][data-sidebar-style=\"full\"] .menu-toggle .header {\n    max-width: 1480px;\n  }\n}\n\n@media (min-width: 992px) {\n  [data-container=\"wide-boxed\"][data-sidebar-style=\"mini\"] .header {\n    width: 100%;\n  }\n\n  [data-header-position=\"fixed\"][data-container=\"wide-boxed\"][data-sidebar-style=\"mini\"] .header {\n    max-width: 1480px;\n  }\n\n  [data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-sidebar-style=\"mini\"] .header {\n    max-width: 1480px;\n  }\n}\n\n@media (min-width: 992px) {\n  [data-container=\"wide-boxed\"][data-sidebar-style=\"compact\"] .header {\n    width: 100%;\n  }\n\n  [data-header-position=\"fixed\"][data-container=\"wide-boxed\"][data-sidebar-style=\"compact\"] .header {\n    max-width: 1480px;\n  }\n}\n\n@media (min-width: 992px) {\n  [data-container=\"wide-boxed\"][data-sidebar-style=\"overlay\"] .header {\n    width: 100%;\n  }\n\n  [data-header-position=\"fixed\"][data-container=\"wide-boxed\"][data-sidebar-style=\"overlay\"] .header {\n    max-width: 1480px;\n  }\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"] .header {\n  width: 100%;\n}\n\n[data-sidebar-style=\"full\"][data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"wide-boxed\"] .header {\n  max-width: 1480px;\n}\n\n[data-sidebar-style=\"mini\"][data-layout=\"horizontal\"][data-container=\"wide-boxed\"] .header {\n  width: 100%;\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"] .deznav.fixed {\n  max-width: 1480px;\n  transition: none;\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"][direction=\"rtl\"] .deznav.fixed {\n  right: 5%;\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"fixed\"] .deznav {\n  max-width: 1480px;\n  left: 5%;\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"fixed\"][direction=\"rtl\"] .deznav {\n  right: 5%;\n}\n\n[data-primary=\"color_2\"] a:hover,\n[data-primary=\"color_2\"] a:focus,\n[data-primary=\"color_2\"] a.active {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] [data-class=\"bg-primary\"]:before {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .email-left-box .intro-title {\n  background: rgba(20, 59, 100, 0.1);\n}\n\n[data-primary=\"color_2\"] .email-left-box .intro-title i {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .widget-stat .media .media-body h4 {\n  color: #143b64 !important;\n}\n\n[data-primary=\"color_2\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(20, 59, 100, 0.1);\n}\n\n[data-primary=\"color_2\"] .mail-list .list-group-item.active i {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .single-mail.active {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .profile-info h4.text-primary {\n  color: #143b64 !important;\n}\n\n[data-primary=\"color_2\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_2\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #143b64;\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .amChartsInputField {\n  border: 0;\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .amcharts-period-input,\n[data-primary=\"color_2\"] .amcharts-period-input-selected {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .morris-hover {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .custom-select:focus {\n  border-color: #143b64;\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .daterangepicker td.active {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .daterangepicker td.active:hover {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .daterangepicker button.applyBtn {\n  background-color: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .wizard>.steps li.current a {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .wizard .skip-email a {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #2161a4;\n}\n\n[data-primary=\"color_2\"] .datamaps-hoverover {\n  color: #143b64;\n  border: 1px solid rgba(20, 59, 100, 0.3);\n}\n\n[data-primary=\"color_2\"] .jqvmap-zoomin,\n[data-primary=\"color_2\"] .jqvmap-zoomout {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .table .thead-primary th {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .table.primary-table-bg-hover thead th {\n  background-color: #102e4f;\n}\n\n[data-primary=\"color_2\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #184879;\n}\n\n[data-primary=\"color_2\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_2\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #102e4f;\n}\n\n[data-primary=\"color_2\"] table.dataTable tr.selected {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #143b64 !important;\n  background: rgba(20, 59, 100, 0.1);\n}\n\n[data-primary=\"color_2\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #143b64 !important;\n  background: rgba(20, 59, 100, 0.1);\n}\n\n[data-primary=\"color_2\"] .clipboard-btn:hover {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .cd-h-timeline__dates::before {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .cd-h-timeline__dates::after {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .cd-h-timeline__line {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .cd-h-timeline__date:after {\n  border-color: #153d68;\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .cd-h-timeline__navigation {\n  border-color: #153d68;\n}\n\n[data-primary=\"color_2\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #153d68;\n}\n\n[data-primary=\"color_2\"] .dd-handle {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .dd-handle:hover {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .dd3-content:hover {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .noUi-connect {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .noUi-connect.c-3-color {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_2\"] .noUi-vertical .noUi-handle {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] #slider-toggle.off .noUi-handle {\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .pignose-calendar {\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .bootstrap-tagsinput .tag {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .toast-success {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .alert-primary {\n  background: #297ace;\n  border-color: #297ace;\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .alert-alt.alert-primary {\n  border-left: 4px solid #143b64;\n}\n\n[data-primary=\"color_2\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid black !important;\n}\n\n[data-primary=\"color_2\"] .alert.alert-primary.solid {\n  background: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .alert.alert-outline-primary {\n  color: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .badge-outline-primary {\n  border: 1px solid #143b64;\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .badge-primary {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .page-titles h4 {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_2\"] .card-action .dropdown {\n  background: black;\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .card-action .dropdown:hover,\n[data-primary=\"color_2\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_2\"] .card-loader i {\n  background: #0e2946;\n}\n\n[data-primary=\"color_2\"] .dropdown-outline {\n  border: 0.1rem solid #143b64;\n}\n\n[data-primary=\"color_2\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .card-action .custom-dropdown {\n  background: #3a87d8;\n}\n\n[data-primary=\"color_2\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_2\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_2\"] .card-action .custom-dropdown:hover {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .label-primary {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .pagination .page-item .page-link:hover {\n  background: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .pagination .page-item.active .page-link {\n  background-color: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_2\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .progress-bar {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .progress-bar-primary {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .ribbon__four {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .ribbon__four:after,\n[data-primary=\"color_2\"] .ribbon__four:before {\n  background-color: #256db9;\n}\n\n[data-primary=\"color_2\"] .ribbon__five {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .ribbon__five::before {\n  border-color: transparent transparent #143b64 transparent;\n}\n\n[data-primary=\"color_2\"] .ribbon__six {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .multi-steps>li {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .multi-steps>li:after {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .multi-steps>li.is-active:before {\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .timeline-badge.primary {\n  background-color: #143b64 !important;\n}\n\n[data-primary=\"color_2\"] .tooltip-wrapper button:hover {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #143b64;\n  border: 1px solid #143b64;\n}\n\n[data-primary=\"color_2\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #143b64;\n}\n\n[data-primary=\"color_2\"] .social-icon2 a {\n  border: 0.1rem solid #143b64;\n}\n\n[data-primary=\"color_2\"] .social-icon2 i {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .social-icon3 ul li a:hover i {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .bgl-primary {\n  background: #3a87d8;\n  border-color: #3a87d8;\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .footer .copyright a {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .hamburger .line {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_2\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_2\"] svg.pulse-svg .third-circle {\n  fill: #143b64;\n}\n\n[data-primary=\"color_2\"] .pulse-css {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .pulse-css:after,\n[data-primary=\"color_2\"] .pulse-css:before {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_2\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_2\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .header-right .header-profile .profile_title {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #143b64 !important;\n}\n\n[data-primary=\"color_2\"] .deznav .metismenu>li>a svg {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_2\"] .deznav .metismenu>li:focus>a {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .deznav .metismenu>li.mm-active>a {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_2\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_2\"] .deznav .metismenu ul a.mm-active {\n  color: #143b64;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_2\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_2\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_2\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_2\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #8fbae9;\n  }\n}\n\n[data-primary=\"color_2\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .nav-user {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .new-arrival-content .price {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .chart-link a i.text-primary {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] #user-activity .nav-tabs .nav-link.active {\n  background: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] span#counter {\n  color: #143b64;\n}\n\n[data-primary=\"color_2\"] .welcome-content:after {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .timeline-badge {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .page-timeline .timeline-workplan[data-primary=\"color_2\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(20, 59, 100, 0.4);\n}\n\n[data-primary=\"color_2\"] .sk-three-bounce .sk-child {\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .dropdown-item.active,\n[data-primary=\"color_2\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .overlay-box:after {\n  background: #143b64;\n}\n\n[data-primary=\"color_2\"] .btn-primary {\n  background-color: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .bg-primary {\n  background-color: #143b64 !important;\n}\n\n[data-primary=\"color_2\"] .text-primary {\n  color: #143b64 !important;\n}\n\n[data-primary=\"color_2\"] .btn-primary:hover {\n  background-color: #071524;\n  border-color: #071524;\n}\n\n[data-primary=\"color_2\"] .btn-outline-primary {\n  color: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .btn-outline-primary:hover {\n  background-color: #143b64;\n  border-color: #143b64;\n}\n\n[data-primary=\"color_2\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_2\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_2\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_2\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_2\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_2\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #071524;\n  border-color: #071524;\n}\n\n[data-primary=\"color_3\"] a:hover,\n[data-primary=\"color_3\"] a:focus,\n[data-primary=\"color_3\"] a.active {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] [data-class=\"bg-primary\"]:before {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .email-left-box .intro-title {\n  background: rgba(135, 67, 223, 0.1);\n}\n\n[data-primary=\"color_3\"] .email-left-box .intro-title i {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .widget-stat .media .media-body h4 {\n  color: #00ADEE !important;\n}\n\n[data-primary=\"color_3\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(135, 67, 223, 0.1);\n}\n\n[data-primary=\"color_3\"] .mail-list .list-group-item.active i {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .single-mail.active {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .profile-info h4.text-primary {\n  color: #00ADEE !important;\n}\n\n[data-primary=\"color_3\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_3\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #00ADEE;\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .amChartsInputField {\n  border: 0;\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .amcharts-period-input,\n[data-primary=\"color_3\"] .amcharts-period-input-selected {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .morris-hover {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .custom-select:focus {\n  border-color: #00ADEE;\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .daterangepicker td.active {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .daterangepicker td.active:hover {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .daterangepicker button.applyBtn {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .wizard>.steps li.current a {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .wizard .skip-email a {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #b184ea;\n}\n\n[data-primary=\"color_3\"] .datamaps-hoverover {\n  color: #00ADEE;\n  border: 1px solid rgba(135, 67, 223, 0.3);\n}\n\n[data-primary=\"color_3\"] .jqvmap-zoomin,\n[data-primary=\"color_3\"] .jqvmap-zoomout {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .table .thead-primary th {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .table.primary-table-bg-hover thead th {\n  background-color: #792ddb;\n}\n\n[data-primary=\"color_3\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #9559e3;\n}\n\n[data-primary=\"color_3\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_3\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #792ddb;\n}\n\n[data-primary=\"color_3\"] table.dataTable tr.selected {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #00ADEE !important;\n  background: rgba(135, 67, 223, 0.1);\n}\n\n[data-primary=\"color_3\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #00ADEE !important;\n  background: rgba(135, 67, 223, 0.1);\n}\n\n[data-primary=\"color_3\"] .clipboard-btn:hover {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .cd-h-timeline__dates::before {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .cd-h-timeline__dates::after {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .cd-h-timeline__line {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .cd-h-timeline__date:after {\n  border-color: #8a47e0;\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .cd-h-timeline__navigation {\n  border-color: #8a47e0;\n}\n\n[data-primary=\"color_3\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #8a47e0;\n}\n\n[data-primary=\"color_3\"] .dd-handle {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .dd-handle:hover {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .dd3-content:hover {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .noUi-connect {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .noUi-connect.c-3-color {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_3\"] .noUi-vertical .noUi-handle {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] #slider-toggle.off .noUi-handle {\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .pignose-calendar {\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .bootstrap-tagsinput .tag {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .toast-success {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .alert-primary {\n  background: #cdb0f2;\n  border-color: #cdb0f2;\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .alert-alt.alert-primary {\n  border-left: 4px solid #00ADEE;\n}\n\n[data-primary=\"color_3\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #4a188b !important;\n}\n\n[data-primary=\"color_3\"] .alert.alert-primary.solid {\n  background: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .alert.alert-outline-primary {\n  color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .badge-outline-primary {\n  border: 1px solid #00ADEE;\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .badge-primary {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .page-titles h4 {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_3\"] .card-action .dropdown {\n  background: black;\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .card-action .dropdown:hover,\n[data-primary=\"color_3\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_3\"] .card-loader i {\n  background: #7425d9;\n}\n\n[data-primary=\"color_3\"] .dropdown-outline {\n  border: 0.1rem solid #00ADEE;\n}\n\n[data-primary=\"color_3\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .card-action .custom-dropdown {\n  background: #dac6f5;\n}\n\n[data-primary=\"color_3\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_3\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_3\"] .card-action .custom-dropdown:hover {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .label-primary {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .pagination .page-item .page-link:hover {\n  background: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .pagination .page-item.active .page-link {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_3\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .progress-bar {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .progress-bar-primary {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .ribbon__four {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .ribbon__four:after,\n[data-primary=\"color_3\"] .ribbon__four:before {\n  background-color: #bf9aee;\n}\n\n[data-primary=\"color_3\"] .ribbon__five {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .ribbon__five::before {\n  border-color: transparent transparent #00ADEE transparent;\n}\n\n[data-primary=\"color_3\"] .ribbon__six {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .multi-steps>li {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .multi-steps>li:after {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .multi-steps>li.is-active:before {\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .timeline-badge.primary {\n  background-color: #00ADEE !important;\n}\n\n[data-primary=\"color_3\"] .tooltip-wrapper button:hover {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #00ADEE;\n  border: 1px solid #00ADEE;\n}\n\n[data-primary=\"color_3\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #00ADEE;\n}\n\n[data-primary=\"color_3\"] .social-icon2 a {\n  border: 0.1rem solid #00ADEE;\n}\n\n[data-primary=\"color_3\"] .social-icon2 i {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .social-icon3 ul li a:hover i {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .bgl-primary {\n  background: #dac6f5;\n  border-color: #dac6f5;\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .footer .copyright a {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .hamburger .line {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_3\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_3\"] svg.pulse-svg .third-circle {\n  fill: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .pulse-css {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .pulse-css:after,\n[data-primary=\"color_3\"] .pulse-css:before {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_3\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_3\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .header-right .header-profile .profile_title {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #00ADEE !important;\n}\n\n[data-primary=\"color_3\"] .deznav .metismenu>li>a svg {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_3\"] .deznav .metismenu>li:focus>a {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .deznav .metismenu>li.mm-active>a {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_3\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_3\"] .deznav .metismenu ul a.mm-active {\n  color: #00ADEE;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_3\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_3\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_3\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_3\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: white;\n  }\n}\n\n[data-primary=\"color_3\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .nav-user {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .new-arrival-content .price {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .chart-link a i.text-primary {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] #user-activity .nav-tabs .nav-link.active {\n  background: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] span#counter {\n  color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .welcome-content:after {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .timeline-badge {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .page-timeline .timeline-workplan[data-primary=\"color_3\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(135, 67, 223, 0.4);\n}\n\n[data-primary=\"color_3\"] .sk-three-bounce .sk-child {\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .dropdown-item.active,\n[data-primary=\"color_3\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .overlay-box:after {\n  background: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .btn-primary {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .bg-primary {\n  background-color: #00ADEE !important;\n}\n\n[data-primary=\"color_3\"] .text-primary {\n  color: #00ADEE !important;\n}\n\n[data-primary=\"color_3\"] .btn-primary:hover {\n  background-color: #611fb6;\n  border-color: #611fb6;\n}\n\n[data-primary=\"color_3\"] .btn-outline-primary {\n  color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .btn-outline-primary:hover {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-primary=\"color_3\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_3\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_3\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_3\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_3\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_3\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #611fb6;\n  border-color: #611fb6;\n}\n\n[data-primary=\"color_4\"] a:hover,\n[data-primary=\"color_4\"] a:focus,\n[data-primary=\"color_4\"] a.active {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] [data-class=\"bg-primary\"]:before {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .email-left-box .intro-title {\n  background: rgba(69, 39, 160, 0.1);\n}\n\n[data-primary=\"color_4\"] .email-left-box .intro-title i {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .widget-stat .media .media-body h4 {\n  color: #4527a0 !important;\n}\n\n[data-primary=\"color_4\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(69, 39, 160, 0.1);\n}\n\n[data-primary=\"color_4\"] .mail-list .list-group-item.active i {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .single-mail.active {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .profile-info h4.text-primary {\n  color: #4527a0 !important;\n}\n\n[data-primary=\"color_4\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_4\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #4527a0;\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .amChartsInputField {\n  border: 0;\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .amcharts-period-input,\n[data-primary=\"color_4\"] .amcharts-period-input-selected {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .morris-hover {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .custom-select:focus {\n  border-color: #4527a0;\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .daterangepicker td.active {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .daterangepicker td.active:hover {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .daterangepicker button.applyBtn {\n  background-color: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .wizard>.steps li.current a {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .wizard .skip-email a {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #6642d1;\n}\n\n[data-primary=\"color_4\"] .datamaps-hoverover {\n  color: #4527a0;\n  border: 1px solid rgba(69, 39, 160, 0.3);\n}\n\n[data-primary=\"color_4\"] .jqvmap-zoomin,\n[data-primary=\"color_4\"] .jqvmap-zoomout {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .table .thead-primary th {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .table.primary-table-bg-hover thead th {\n  background-color: #3c228b;\n}\n\n[data-primary=\"color_4\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #4e2cb5;\n}\n\n[data-primary=\"color_4\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_4\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #3c228b;\n}\n\n[data-primary=\"color_4\"] table.dataTable tr.selected {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #4527a0 !important;\n  background: rgba(69, 39, 160, 0.1);\n}\n\n[data-primary=\"color_4\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #4527a0 !important;\n  background: rgba(69, 39, 160, 0.1);\n}\n\n[data-primary=\"color_4\"] .clipboard-btn:hover {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .cd-h-timeline__dates::before {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .cd-h-timeline__dates::after {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .cd-h-timeline__line {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .cd-h-timeline__date:after {\n  border-color: #4728a4;\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .cd-h-timeline__navigation {\n  border-color: #4728a4;\n}\n\n[data-primary=\"color_4\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #4728a4;\n}\n\n[data-primary=\"color_4\"] .dd-handle {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .dd-handle:hover {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .dd3-content:hover {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .noUi-connect {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .noUi-connect.c-3-color {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_4\"] .noUi-vertical .noUi-handle {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] #slider-toggle.off .noUi-handle {\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .pignose-calendar {\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .bootstrap-tagsinput .tag {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .toast-success {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .alert-primary {\n  background: #876bdb;\n  border-color: #876bdb;\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .alert-alt.alert-primary {\n  border-left: 4px solid #4527a0;\n}\n\n[data-primary=\"color_4\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #190e39 !important;\n}\n\n[data-primary=\"color_4\"] .alert.alert-primary.solid {\n  background: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .alert.alert-outline-primary {\n  color: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .badge-outline-primary {\n  border: 1px solid #4527a0;\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .badge-primary {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .page-titles h4 {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_4\"] .card-action .dropdown {\n  background: black;\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .card-action .dropdown:hover,\n[data-primary=\"color_4\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_4\"] .card-loader i {\n  background: #392083;\n}\n\n[data-primary=\"color_4\"] .dropdown-outline {\n  border: 0.1rem solid #4527a0;\n}\n\n[data-primary=\"color_4\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .card-action .custom-dropdown {\n  background: #9880e0;\n}\n\n[data-primary=\"color_4\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_4\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_4\"] .card-action .custom-dropdown:hover {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .label-primary {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .pagination .page-item .page-link:hover {\n  background: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .pagination .page-item.active .page-link {\n  background-color: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_4\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .progress-bar {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .progress-bar-primary {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .ribbon__four {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .ribbon__four:after,\n[data-primary=\"color_4\"] .ribbon__four:before {\n  background-color: #7657d6;\n}\n\n[data-primary=\"color_4\"] .ribbon__five {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .ribbon__five::before {\n  border-color: transparent transparent #4527a0 transparent;\n}\n\n[data-primary=\"color_4\"] .ribbon__six {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .multi-steps>li {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .multi-steps>li:after {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .multi-steps>li.is-active:before {\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .timeline-badge.primary {\n  background-color: #4527a0 !important;\n}\n\n[data-primary=\"color_4\"] .tooltip-wrapper button:hover {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #4527a0;\n  border: 1px solid #4527a0;\n}\n\n[data-primary=\"color_4\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #4527a0;\n}\n\n[data-primary=\"color_4\"] .social-icon2 a {\n  border: 0.1rem solid #4527a0;\n}\n\n[data-primary=\"color_4\"] .social-icon2 i {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .social-icon3 ul li a:hover i {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .bgl-primary {\n  background: #9880e0;\n  border-color: #9880e0;\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .footer .copyright a {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .hamburger .line {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_4\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_4\"] svg.pulse-svg .third-circle {\n  fill: #4527a0;\n}\n\n[data-primary=\"color_4\"] .pulse-css {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .pulse-css:after,\n[data-primary=\"color_4\"] .pulse-css:before {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_4\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_4\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .header-right .header-profile .profile_title {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #4527a0 !important;\n}\n\n[data-primary=\"color_4\"] .deznav .metismenu>li>a svg {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_4\"] .deznav .metismenu>li:focus>a {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .deznav .metismenu>li.mm-active>a {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_4\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_4\"] .deznav .metismenu ul a.mm-active {\n  color: #4527a0;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_4\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_4\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_4\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_4\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #dad2f4;\n  }\n}\n\n[data-primary=\"color_4\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .nav-user {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .new-arrival-content .price {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .chart-link a i.text-primary {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] #user-activity .nav-tabs .nav-link.active {\n  background: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] span#counter {\n  color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .welcome-content:after {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .timeline-badge {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .page-timeline .timeline-workplan[data-primary=\"color_4\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(69, 39, 160, 0.4);\n}\n\n[data-primary=\"color_4\"] .sk-three-bounce .sk-child {\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .dropdown-item.active,\n[data-primary=\"color_4\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .overlay-box:after {\n  background: #4527a0;\n}\n\n[data-primary=\"color_4\"] .btn-primary {\n  background-color: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .bg-primary {\n  background-color: #4527a0 !important;\n}\n\n[data-primary=\"color_4\"] .text-primary {\n  color: #4527a0 !important;\n}\n\n[data-primary=\"color_4\"] .btn-primary:hover {\n  background-color: #2a1862;\n  border-color: #2a1862;\n}\n\n[data-primary=\"color_4\"] .btn-outline-primary {\n  color: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .btn-outline-primary:hover {\n  background-color: #4527a0;\n  border-color: #4527a0;\n}\n\n[data-primary=\"color_4\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_4\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_4\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_4\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_4\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_4\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #2a1862;\n  border-color: #2a1862;\n}\n\n[data-primary=\"color_5\"] a:hover,\n[data-primary=\"color_5\"] a:focus,\n[data-primary=\"color_5\"] a.active {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] [data-class=\"bg-primary\"]:before {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .email-left-box .intro-title {\n  background: rgba(198, 40, 40, 0.1);\n}\n\n[data-primary=\"color_5\"] .email-left-box .intro-title i {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .widget-stat .media .media-body h4 {\n  color: #c62828 !important;\n}\n\n[data-primary=\"color_5\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(198, 40, 40, 0.1);\n}\n\n[data-primary=\"color_5\"] .mail-list .list-group-item.active i {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .single-mail.active {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .profile-info h4.text-primary {\n  color: #c62828 !important;\n}\n\n[data-primary=\"color_5\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_5\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #c62828;\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .amChartsInputField {\n  border: 0;\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .amcharts-period-input,\n[data-primary=\"color_5\"] .amcharts-period-input-selected {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .morris-hover {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .custom-select:focus {\n  border-color: #c62828;\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .daterangepicker td.active {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .daterangepicker td.active:hover {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .daterangepicker button.applyBtn {\n  background-color: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .wizard>.steps li.current a {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .wizard .skip-email a {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #de5c5c;\n}\n\n[data-primary=\"color_5\"] .datamaps-hoverover {\n  color: #c62828;\n  border: 1px solid rgba(198, 40, 40, 0.3);\n}\n\n[data-primary=\"color_5\"] .jqvmap-zoomin,\n[data-primary=\"color_5\"] .jqvmap-zoomout {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .table .thead-primary th {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .table.primary-table-bg-hover thead th {\n  background-color: #b12424;\n}\n\n[data-primary=\"color_5\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #d63232;\n}\n\n[data-primary=\"color_5\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_5\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #b12424;\n}\n\n[data-primary=\"color_5\"] table.dataTable tr.selected {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #c62828 !important;\n  background: rgba(198, 40, 40, 0.1);\n}\n\n[data-primary=\"color_5\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #c62828 !important;\n  background: rgba(198, 40, 40, 0.1);\n}\n\n[data-primary=\"color_5\"] .clipboard-btn:hover {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .cd-h-timeline__dates::before {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .cd-h-timeline__dates::after {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .cd-h-timeline__line {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .cd-h-timeline__date:after {\n  border-color: #ca2929;\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .cd-h-timeline__navigation {\n  border-color: #ca2929;\n}\n\n[data-primary=\"color_5\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #ca2929;\n}\n\n[data-primary=\"color_5\"] .dd-handle {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .dd-handle:hover {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .dd3-content:hover {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .noUi-connect {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .noUi-connect.c-3-color {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_5\"] .noUi-vertical .noUi-handle {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] #slider-toggle.off .noUi-handle {\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .pignose-calendar {\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .bootstrap-tagsinput .tag {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .toast-success {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .alert-primary {\n  background: #e78787;\n  border-color: #e78787;\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .alert-alt.alert-primary {\n  border-left: 4px solid #c62828;\n}\n\n[data-primary=\"color_5\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #5c1313 !important;\n}\n\n[data-primary=\"color_5\"] .alert.alert-primary.solid {\n  background: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .alert.alert-outline-primary {\n  color: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .badge-outline-primary {\n  border: 1px solid #c62828;\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .badge-primary {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .page-titles h4 {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_5\"] .card-action .dropdown {\n  background: black;\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .card-action .dropdown:hover,\n[data-primary=\"color_5\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_5\"] .card-loader i {\n  background: #a82222;\n}\n\n[data-primary=\"color_5\"] .dropdown-outline {\n  border: 0.1rem solid #c62828;\n}\n\n[data-primary=\"color_5\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .card-action .custom-dropdown {\n  background: #eb9c9c;\n}\n\n[data-primary=\"color_5\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_5\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_5\"] .card-action .custom-dropdown:hover {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .label-primary {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .pagination .page-item .page-link:hover {\n  background: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .pagination .page-item.active .page-link {\n  background-color: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_5\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .progress-bar {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .progress-bar-primary {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .ribbon__four {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .ribbon__four:after,\n[data-primary=\"color_5\"] .ribbon__four:before {\n  background-color: #e27272;\n}\n\n[data-primary=\"color_5\"] .ribbon__five {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .ribbon__five::before {\n  border-color: transparent transparent #c62828 transparent;\n}\n\n[data-primary=\"color_5\"] .ribbon__six {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .multi-steps>li {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .multi-steps>li:after {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .multi-steps>li.is-active:before {\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .timeline-badge.primary {\n  background-color: #c62828 !important;\n}\n\n[data-primary=\"color_5\"] .tooltip-wrapper button:hover {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #c62828;\n  border: 1px solid #c62828;\n}\n\n[data-primary=\"color_5\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #c62828;\n}\n\n[data-primary=\"color_5\"] .social-icon2 a {\n  border: 0.1rem solid #c62828;\n}\n\n[data-primary=\"color_5\"] .social-icon2 i {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .social-icon3 ul li a:hover i {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .bgl-primary {\n  background: #eb9c9c;\n  border-color: #eb9c9c;\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .footer .copyright a {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .hamburger .line {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_5\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_5\"] svg.pulse-svg .third-circle {\n  fill: #c62828;\n}\n\n[data-primary=\"color_5\"] .pulse-css {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .pulse-css:after,\n[data-primary=\"color_5\"] .pulse-css:before {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_5\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_5\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .header-right .header-profile .profile_title {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #c62828 !important;\n}\n\n[data-primary=\"color_5\"] .deznav .metismenu>li>a svg {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_5\"] .deznav .metismenu>li:focus>a {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .deznav .metismenu>li.mm-active>a {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_5\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_5\"] .deznav .metismenu ul a.mm-active {\n  color: #c62828;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_5\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_5\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_5\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_5\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #fcf1f1;\n  }\n}\n\n[data-primary=\"color_5\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .nav-user {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .new-arrival-content .price {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .chart-link a i.text-primary {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] #user-activity .nav-tabs .nav-link.active {\n  background: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] span#counter {\n  color: #c62828;\n}\n\n[data-primary=\"color_5\"] .welcome-content:after {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .timeline-badge {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .page-timeline .timeline-workplan[data-primary=\"color_5\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(198, 40, 40, 0.4);\n}\n\n[data-primary=\"color_5\"] .sk-three-bounce .sk-child {\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .dropdown-item.active,\n[data-primary=\"color_5\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .overlay-box:after {\n  background: #c62828;\n}\n\n[data-primary=\"color_5\"] .btn-primary {\n  background-color: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .bg-primary {\n  background-color: #c62828 !important;\n}\n\n[data-primary=\"color_5\"] .text-primary {\n  color: #c62828 !important;\n}\n\n[data-primary=\"color_5\"] .btn-primary:hover {\n  background-color: #861b1b;\n  border-color: #861b1b;\n}\n\n[data-primary=\"color_5\"] .btn-outline-primary {\n  color: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .btn-outline-primary:hover {\n  background-color: #c62828;\n  border-color: #c62828;\n}\n\n[data-primary=\"color_5\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_5\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_5\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_5\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_5\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_5\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #861b1b;\n  border-color: #861b1b;\n}\n\n[data-primary=\"color_6\"] a:hover,\n[data-primary=\"color_6\"] a:focus,\n[data-primary=\"color_6\"] a.active {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] [data-class=\"bg-primary\"]:before {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .email-left-box .intro-title {\n  background: rgba(40, 53, 147, 0.1);\n}\n\n[data-primary=\"color_6\"] .email-left-box .intro-title i {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .widget-stat .media .media-body h4 {\n  color: #283593 !important;\n}\n\n[data-primary=\"color_6\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(40, 53, 147, 0.1);\n}\n\n[data-primary=\"color_6\"] .mail-list .list-group-item.active i {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .single-mail.active {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .profile-info h4.text-primary {\n  color: #283593 !important;\n}\n\n[data-primary=\"color_6\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_6\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #283593;\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .amChartsInputField {\n  border: 0;\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .amcharts-period-input,\n[data-primary=\"color_6\"] .amcharts-period-input-selected {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .morris-hover {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .custom-select:focus {\n  border-color: #283593;\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .daterangepicker td.active {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .daterangepicker td.active:hover {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .daterangepicker button.applyBtn {\n  background-color: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .wizard>.steps li.current a {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .wizard .skip-email a {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #3d4eca;\n}\n\n[data-primary=\"color_6\"] .datamaps-hoverover {\n  color: #283593;\n  border: 1px solid rgba(40, 53, 147, 0.3);\n}\n\n[data-primary=\"color_6\"] .jqvmap-zoomin,\n[data-primary=\"color_6\"] .jqvmap-zoomout {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .table .thead-primary th {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .table.primary-table-bg-hover thead th {\n  background-color: #232e7f;\n}\n\n[data-primary=\"color_6\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #2d3ca7;\n}\n\n[data-primary=\"color_6\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_6\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #232e7f;\n}\n\n[data-primary=\"color_6\"] table.dataTable tr.selected {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #283593 !important;\n  background: rgba(40, 53, 147, 0.1);\n}\n\n[data-primary=\"color_6\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #283593 !important;\n  background: rgba(40, 53, 147, 0.1);\n}\n\n[data-primary=\"color_6\"] .clipboard-btn:hover {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .cd-h-timeline__dates::before {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .cd-h-timeline__dates::after {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .cd-h-timeline__line {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .cd-h-timeline__date:after {\n  border-color: #293697;\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .cd-h-timeline__navigation {\n  border-color: #293697;\n}\n\n[data-primary=\"color_6\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #293697;\n}\n\n[data-primary=\"color_6\"] .dd-handle {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .dd-handle:hover {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .dd3-content:hover {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .noUi-connect {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .noUi-connect.c-3-color {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_6\"] .noUi-vertical .noUi-handle {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] #slider-toggle.off .noUi-handle {\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .pignose-calendar {\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .bootstrap-tagsinput .tag {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .toast-success {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .alert-primary {\n  background: #6573d5;\n  border-color: #6573d5;\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .alert-alt.alert-primary {\n  border-left: 4px solid #283593;\n}\n\n[data-primary=\"color_6\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #0d112f !important;\n}\n\n[data-primary=\"color_6\"] .alert.alert-primary.solid {\n  background: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .alert.alert-outline-primary {\n  color: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .badge-outline-primary {\n  border: 1px solid #283593;\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .badge-primary {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .page-titles h4 {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_6\"] .card-action .dropdown {\n  background: black;\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .card-action .dropdown:hover,\n[data-primary=\"color_6\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_6\"] .card-loader i {\n  background: #202b77;\n}\n\n[data-primary=\"color_6\"] .dropdown-outline {\n  border: 0.1rem solid #283593;\n}\n\n[data-primary=\"color_6\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .card-action .custom-dropdown {\n  background: #7985db;\n}\n\n[data-primary=\"color_6\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_6\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_6\"] .card-action .custom-dropdown:hover {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .label-primary {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .pagination .page-item .page-link:hover {\n  background: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .pagination .page-item.active .page-link {\n  background-color: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_6\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .progress-bar {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .progress-bar-primary {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .ribbon__four {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .ribbon__four:after,\n[data-primary=\"color_6\"] .ribbon__four:before {\n  background-color: #5161d0;\n}\n\n[data-primary=\"color_6\"] .ribbon__five {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .ribbon__five::before {\n  border-color: transparent transparent #283593 transparent;\n}\n\n[data-primary=\"color_6\"] .ribbon__six {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .multi-steps>li {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .multi-steps>li:after {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .multi-steps>li.is-active:before {\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .timeline-badge.primary {\n  background-color: #283593 !important;\n}\n\n[data-primary=\"color_6\"] .tooltip-wrapper button:hover {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #283593;\n  border: 1px solid #283593;\n}\n\n[data-primary=\"color_6\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #283593;\n}\n\n[data-primary=\"color_6\"] .social-icon2 a {\n  border: 0.1rem solid #283593;\n}\n\n[data-primary=\"color_6\"] .social-icon2 i {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .social-icon3 ul li a:hover i {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .bgl-primary {\n  background: #7985db;\n  border-color: #7985db;\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .footer .copyright a {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .hamburger .line {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_6\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_6\"] svg.pulse-svg .third-circle {\n  fill: #283593;\n}\n\n[data-primary=\"color_6\"] .pulse-css {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .pulse-css:after,\n[data-primary=\"color_6\"] .pulse-css:before {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_6\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_6\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .header-right .header-profile .profile_title {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #283593 !important;\n}\n\n[data-primary=\"color_6\"] .deznav .metismenu>li>a svg {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_6\"] .deznav .metismenu>li:focus>a {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .deznav .metismenu>li.mm-active>a {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_6\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_6\"] .deznav .metismenu ul a.mm-active {\n  color: #283593;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_6\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_6\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_6\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_6\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #cacef0;\n  }\n}\n\n[data-primary=\"color_6\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .nav-user {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .new-arrival-content .price {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .chart-link a i.text-primary {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] #user-activity .nav-tabs .nav-link.active {\n  background: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] span#counter {\n  color: #283593;\n}\n\n[data-primary=\"color_6\"] .welcome-content:after {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .timeline-badge {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .page-timeline .timeline-workplan[data-primary=\"color_6\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(40, 53, 147, 0.4);\n}\n\n[data-primary=\"color_6\"] .sk-three-bounce .sk-child {\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .dropdown-item.active,\n[data-primary=\"color_6\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #283593;\n}\n\n[data-primary=\"color_6\"] .overlay-box:after {\n  background: #283593;\n}\n\n[data-primary=\"color_6\"] .btn-primary {\n  background-color: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .bg-primary {\n  background-color: #283593 !important;\n}\n\n[data-primary=\"color_6\"] .text-primary {\n  color: #283593 !important;\n}\n\n[data-primary=\"color_6\"] .btn-primary:hover {\n  background-color: #181f57;\n  border-color: #181f57;\n}\n\n[data-primary=\"color_6\"] .btn-outline-primary {\n  color: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .btn-outline-primary:hover {\n  background-color: #283593;\n  border-color: #283593;\n}\n\n[data-primary=\"color_6\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_6\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_6\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_6\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_6\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_6\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #181f57;\n  border-color: #181f57;\n}\n\n[data-primary=\"color_7\"] a:hover,\n[data-primary=\"color_7\"] a:focus,\n[data-primary=\"color_7\"] a.active {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] [data-class=\"bg-primary\"]:before {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .email-left-box .intro-title {\n  background: rgba(115, 86, 241, 0.1);\n}\n\n[data-primary=\"color_7\"] .email-left-box .intro-title i {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .widget-stat .media .media-body h4 {\n  color: #7356f1 !important;\n}\n\n[data-primary=\"color_7\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(115, 86, 241, 0.1);\n}\n\n[data-primary=\"color_7\"] .mail-list .list-group-item.active i {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .single-mail.active {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .profile-info h4.text-primary {\n  color: #7356f1 !important;\n}\n\n[data-primary=\"color_7\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_7\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #7356f1;\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .amChartsInputField {\n  border: 0;\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .amcharts-period-input,\n[data-primary=\"color_7\"] .amcharts-period-input-selected {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .morris-hover {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .custom-select:focus {\n  border-color: #7356f1;\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .daterangepicker td.active {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .daterangepicker td.active:hover {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .daterangepicker button.applyBtn {\n  background-color: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .wizard>.steps li.current a {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .wizard .skip-email a {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #ae9df7;\n}\n\n[data-primary=\"color_7\"] .datamaps-hoverover {\n  color: #7356f1;\n  border: 1px solid rgba(115, 86, 241, 0.3);\n}\n\n[data-primary=\"color_7\"] .jqvmap-zoomin,\n[data-primary=\"color_7\"] .jqvmap-zoomout {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .table .thead-primary th {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .table.primary-table-bg-hover thead th {\n  background-color: #5f3eef;\n}\n\n[data-primary=\"color_7\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #876ef3;\n}\n\n[data-primary=\"color_7\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_7\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #5f3eef;\n}\n\n[data-primary=\"color_7\"] table.dataTable tr.selected {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #7356f1 !important;\n  background: rgba(115, 86, 241, 0.1);\n}\n\n[data-primary=\"color_7\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #7356f1 !important;\n  background: rgba(115, 86, 241, 0.1);\n}\n\n[data-primary=\"color_7\"] .clipboard-btn:hover {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .cd-h-timeline__dates::before {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .cd-h-timeline__dates::after {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .cd-h-timeline__line {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .cd-h-timeline__date:after {\n  border-color: #775af1;\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .cd-h-timeline__navigation {\n  border-color: #775af1;\n}\n\n[data-primary=\"color_7\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #775af1;\n}\n\n[data-primary=\"color_7\"] .dd-handle {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .dd-handle:hover {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .dd3-content:hover {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .noUi-connect {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .noUi-connect.c-3-color {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_7\"] .noUi-vertical .noUi-handle {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] #slider-toggle.off .noUi-handle {\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .pignose-calendar {\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .bootstrap-tagsinput .tag {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .toast-success {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .alert-primary {\n  background: #d5ccfb;\n  border-color: #d5ccfb;\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .alert-alt.alert-primary {\n  border-left: 4px solid #7356f1;\n}\n\n[data-primary=\"color_7\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #2f0fb8 !important;\n}\n\n[data-primary=\"color_7\"] .alert.alert-primary.solid {\n  background: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .alert.alert-outline-primary {\n  color: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .badge-outline-primary {\n  border: 1px solid #7356f1;\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .badge-primary {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .page-titles h4 {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .card-action>a {\n  background: #090322;\n}\n\n[data-primary=\"color_7\"] .card-action .dropdown {\n  background: #090322;\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .card-action .dropdown:hover,\n[data-primary=\"color_7\"] .card-action .dropdown:focus {\n  background: #090322;\n}\n\n[data-primary=\"color_7\"] .card-loader i {\n  background: #5835ee;\n}\n\n[data-primary=\"color_7\"] .dropdown-outline {\n  border: 0.1rem solid #7356f1;\n}\n\n[data-primary=\"color_7\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .card-action .custom-dropdown {\n  background: #e8e3fd;\n}\n\n[data-primary=\"color_7\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_7\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_7\"] .card-action .custom-dropdown:hover {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .label-primary {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .pagination .page-item .page-link:hover {\n  background: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .pagination .page-item.active .page-link {\n  background-color: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_7\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .progress-bar {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .progress-bar-primary {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .ribbon__four {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .ribbon__four:after,\n[data-primary=\"color_7\"] .ribbon__four:before {\n  background-color: #c1b4f9;\n}\n\n[data-primary=\"color_7\"] .ribbon__five {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .ribbon__five::before {\n  border-color: transparent transparent #7356f1 transparent;\n}\n\n[data-primary=\"color_7\"] .ribbon__six {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .multi-steps>li {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .multi-steps>li:after {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .multi-steps>li.is-active:before {\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .timeline-badge.primary {\n  background-color: #7356f1 !important;\n}\n\n[data-primary=\"color_7\"] .tooltip-wrapper button:hover {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #7356f1;\n  border: 1px solid #7356f1;\n}\n\n[data-primary=\"color_7\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #7356f1;\n}\n\n[data-primary=\"color_7\"] .social-icon2 a {\n  border: 0.1rem solid #7356f1;\n}\n\n[data-primary=\"color_7\"] .social-icon2 i {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .social-icon3 ul li a:hover i {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .bgl-primary {\n  background: #e8e3fd;\n  border-color: #e8e3fd;\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .footer .copyright a {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .hamburger .line {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_7\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_7\"] svg.pulse-svg .third-circle {\n  fill: #7356f1;\n}\n\n[data-primary=\"color_7\"] .pulse-css {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .pulse-css:after,\n[data-primary=\"color_7\"] .pulse-css:before {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_7\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_7\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .header-right .header-profile .profile_title {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #7356f1 !important;\n}\n\n[data-primary=\"color_7\"] .deznav .metismenu>li>a svg {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_7\"] .deznav .metismenu>li:focus>a {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .deznav .metismenu>li.mm-active>a {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_7\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_7\"] .deznav .metismenu ul a.mm-active {\n  color: #7356f1;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_7\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_7\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_7\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_7\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: white;\n  }\n}\n\n[data-primary=\"color_7\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .nav-user {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .new-arrival-content .price {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .chart-link a i.text-primary {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] #user-activity .nav-tabs .nav-link.active {\n  background: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] span#counter {\n  color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .welcome-content:after {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .timeline-badge {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .page-timeline .timeline-workplan[data-primary=\"color_7\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(115, 86, 241, 0.4);\n}\n\n[data-primary=\"color_7\"] .sk-three-bounce .sk-child {\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .dropdown-item.active,\n[data-primary=\"color_7\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .overlay-box:after {\n  background: #7356f1;\n}\n\n[data-primary=\"color_7\"] .btn-primary {\n  background-color: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .bg-primary {\n  background-color: #7356f1 !important;\n}\n\n[data-primary=\"color_7\"] .text-primary {\n  color: #7356f1 !important;\n}\n\n[data-primary=\"color_7\"] .btn-primary:hover {\n  background-color: #3b13e7;\n  border-color: #3b13e7;\n}\n\n[data-primary=\"color_7\"] .btn-outline-primary {\n  color: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .btn-outline-primary:hover {\n  background-color: #7356f1;\n  border-color: #7356f1;\n}\n\n[data-primary=\"color_7\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_7\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_7\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_7\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_7\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_7\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #3b13e7;\n  border-color: #3b13e7;\n}\n\n[data-primary=\"color_8\"] a:hover,\n[data-primary=\"color_8\"] a:focus,\n[data-primary=\"color_8\"] a.active {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] [data-class=\"bg-primary\"]:before {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .email-left-box .intro-title {\n  background: rgba(54, 149, 235, 0.1);\n}\n\n[data-primary=\"color_8\"] .email-left-box .intro-title i {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .widget-stat .media .media-body h4 {\n  color: #3695eb !important;\n}\n\n[data-primary=\"color_8\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(54, 149, 235, 0.1);\n}\n\n[data-primary=\"color_8\"] .mail-list .list-group-item.active i {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .single-mail.active {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .profile-info h4.text-primary {\n  color: #3695eb !important;\n}\n\n[data-primary=\"color_8\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_8\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #3695eb;\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .amChartsInputField {\n  border: 0;\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .amcharts-period-input,\n[data-primary=\"color_8\"] .amcharts-period-input-selected {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .morris-hover {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .custom-select:focus {\n  border-color: #3695eb;\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .daterangepicker td.active {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .daterangepicker td.active:hover {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .daterangepicker button.applyBtn {\n  background-color: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .wizard>.steps li.current a {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .wizard .skip-email a {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #7cbaf2;\n}\n\n[data-primary=\"color_8\"] .datamaps-hoverover {\n  color: #3695eb;\n  border: 1px solid rgba(54, 149, 235, 0.3);\n}\n\n[data-primary=\"color_8\"] .jqvmap-zoomin,\n[data-primary=\"color_8\"] .jqvmap-zoomout {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .table .thead-primary th {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .table.primary-table-bg-hover thead th {\n  background-color: #1f89e9;\n}\n\n[data-primary=\"color_8\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #4da1ed;\n}\n\n[data-primary=\"color_8\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_8\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #1f89e9;\n}\n\n[data-primary=\"color_8\"] table.dataTable tr.selected {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #3695eb !important;\n  background: rgba(54, 149, 235, 0.1);\n}\n\n[data-primary=\"color_8\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #3695eb !important;\n  background: rgba(54, 149, 235, 0.1);\n}\n\n[data-primary=\"color_8\"] .clipboard-btn:hover {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .cd-h-timeline__dates::before {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .cd-h-timeline__dates::after {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .cd-h-timeline__line {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .cd-h-timeline__date:after {\n  border-color: #3a97eb;\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .cd-h-timeline__navigation {\n  border-color: #3a97eb;\n}\n\n[data-primary=\"color_8\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #3a97eb;\n}\n\n[data-primary=\"color_8\"] .dd-handle {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .dd-handle:hover {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .dd3-content:hover {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .noUi-connect {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .noUi-connect.c-3-color {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_8\"] .noUi-vertical .noUi-handle {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] #slider-toggle.off .noUi-handle {\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .pignose-calendar {\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .bootstrap-tagsinput .tag {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .toast-success {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .alert-primary {\n  background: #aad2f7;\n  border-color: #aad2f7;\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .alert-alt.alert-primary {\n  border-left: 4px solid #3695eb;\n}\n\n[data-primary=\"color_8\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #0f5493 !important;\n}\n\n[data-primary=\"color_8\"] .alert.alert-primary.solid {\n  background: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .alert.alert-outline-primary {\n  color: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .badge-outline-primary {\n  border: 1px solid #3695eb;\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .badge-primary {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .page-titles h4 {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_8\"] .card-action .dropdown {\n  background: black;\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .card-action .dropdown:hover,\n[data-primary=\"color_8\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_8\"] .card-loader i {\n  background: #1784e6;\n}\n\n[data-primary=\"color_8\"] .dropdown-outline {\n  border: 0.1rem solid #3695eb;\n}\n\n[data-primary=\"color_8\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .card-action .custom-dropdown {\n  background: #c1def9;\n}\n\n[data-primary=\"color_8\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_8\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_8\"] .card-action .custom-dropdown:hover {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .label-primary {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .pagination .page-item .page-link:hover {\n  background: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .pagination .page-item.active .page-link {\n  background-color: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_8\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .progress-bar {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .progress-bar-primary {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .ribbon__four {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .ribbon__four:after,\n[data-primary=\"color_8\"] .ribbon__four:before {\n  background-color: #93c6f4;\n}\n\n[data-primary=\"color_8\"] .ribbon__five {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .ribbon__five::before {\n  border-color: transparent transparent #3695eb transparent;\n}\n\n[data-primary=\"color_8\"] .ribbon__six {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .multi-steps>li {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .multi-steps>li:after {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .multi-steps>li.is-active:before {\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .timeline-badge.primary {\n  background-color: #3695eb !important;\n}\n\n[data-primary=\"color_8\"] .tooltip-wrapper button:hover {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #3695eb;\n  border: 1px solid #3695eb;\n}\n\n[data-primary=\"color_8\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #3695eb;\n}\n\n[data-primary=\"color_8\"] .social-icon2 a {\n  border: 0.1rem solid #3695eb;\n}\n\n[data-primary=\"color_8\"] .social-icon2 i {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .social-icon3 ul li a:hover i {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .bgl-primary {\n  background: #c1def9;\n  border-color: #c1def9;\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .footer .copyright a {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .hamburger .line {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_8\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_8\"] svg.pulse-svg .third-circle {\n  fill: #3695eb;\n}\n\n[data-primary=\"color_8\"] .pulse-css {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .pulse-css:after,\n[data-primary=\"color_8\"] .pulse-css:before {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_8\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_8\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .header-right .header-profile .profile_title {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #3695eb !important;\n}\n\n[data-primary=\"color_8\"] .deznav .metismenu>li>a svg {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_8\"] .deznav .metismenu>li:focus>a {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .deznav .metismenu>li.mm-active>a {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_8\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_8\"] .deznav .metismenu ul a.mm-active {\n  color: #3695eb;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_8\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_8\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_8\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_8\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: white;\n  }\n}\n\n[data-primary=\"color_8\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .nav-user {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .new-arrival-content .price {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .chart-link a i.text-primary {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] #user-activity .nav-tabs .nav-link.active {\n  background: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] span#counter {\n  color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .welcome-content:after {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .timeline-badge {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .page-timeline .timeline-workplan[data-primary=\"color_8\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(54, 149, 235, 0.4);\n}\n\n[data-primary=\"color_8\"] .sk-three-bounce .sk-child {\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .dropdown-item.active,\n[data-primary=\"color_8\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .overlay-box:after {\n  background: #3695eb;\n}\n\n[data-primary=\"color_8\"] .btn-primary {\n  background-color: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .bg-primary {\n  background-color: #3695eb !important;\n}\n\n[data-primary=\"color_8\"] .text-primary {\n  color: #3695eb !important;\n}\n\n[data-primary=\"color_8\"] .btn-primary:hover {\n  background-color: #136fc1;\n  border-color: #136fc1;\n}\n\n[data-primary=\"color_8\"] .btn-outline-primary {\n  color: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .btn-outline-primary:hover {\n  background-color: #3695eb;\n  border-color: #3695eb;\n}\n\n[data-primary=\"color_8\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_8\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_8\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_8\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_8\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_8\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #136fc1;\n  border-color: #136fc1;\n}\n\n[data-primary=\"color_9\"] a:hover,\n[data-primary=\"color_9\"] a:focus,\n[data-primary=\"color_9\"] a.active {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] [data-class=\"bg-primary\"]:before {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .email-left-box .intro-title {\n  background: rgba(0, 131, 143, 0.1);\n}\n\n[data-primary=\"color_9\"] .email-left-box .intro-title i {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .widget-stat .media .media-body h4 {\n  color: #00838f !important;\n}\n\n[data-primary=\"color_9\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(0, 131, 143, 0.1);\n}\n\n[data-primary=\"color_9\"] .mail-list .list-group-item.active i {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .single-mail.active {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .profile-info h4.text-primary {\n  color: #00838f !important;\n}\n\n[data-primary=\"color_9\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_9\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #00838f;\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .amChartsInputField {\n  border: 0;\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .amcharts-period-input,\n[data-primary=\"color_9\"] .amcharts-period-input-selected {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .morris-hover {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .custom-select:focus {\n  border-color: #00838f;\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .daterangepicker td.active {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .daterangepicker td.active:hover {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .daterangepicker button.applyBtn {\n  background-color: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .wizard>.steps li.current a {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .wizard .skip-email a {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #00c9dc;\n}\n\n[data-primary=\"color_9\"] .datamaps-hoverover {\n  color: #00838f;\n  border: 1px solid rgba(0, 131, 143, 0.3);\n}\n\n[data-primary=\"color_9\"] .jqvmap-zoomin,\n[data-primary=\"color_9\"] .jqvmap-zoomout {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .table .thead-primary th {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .table.primary-table-bg-hover thead th {\n  background-color: #006c76;\n}\n\n[data-primary=\"color_9\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #009aa9;\n}\n\n[data-primary=\"color_9\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_9\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #006c76;\n}\n\n[data-primary=\"color_9\"] table.dataTable tr.selected {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #00838f !important;\n  background: rgba(0, 131, 143, 0.1);\n}\n\n[data-primary=\"color_9\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #00838f !important;\n  background: rgba(0, 131, 143, 0.1);\n}\n\n[data-primary=\"color_9\"] .clipboard-btn:hover {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .cd-h-timeline__dates::before {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .cd-h-timeline__dates::after {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .cd-h-timeline__line {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .cd-h-timeline__date:after {\n  border-color: #008794;\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .cd-h-timeline__navigation {\n  border-color: #008794;\n}\n\n[data-primary=\"color_9\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #008794;\n}\n\n[data-primary=\"color_9\"] .dd-handle {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .dd-handle:hover {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .dd3-content:hover {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .noUi-connect {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .noUi-connect.c-3-color {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_9\"] .noUi-vertical .noUi-handle {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] #slider-toggle.off .noUi-handle {\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .pignose-calendar {\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .bootstrap-tagsinput .tag {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .toast-success {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .alert-primary {\n  background: #10ebff;\n  border-color: #10ebff;\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .alert-alt.alert-primary {\n  border-left: 4px solid #00838f;\n}\n\n[data-primary=\"color_9\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #000e10 !important;\n}\n\n[data-primary=\"color_9\"] .alert.alert-primary.solid {\n  background: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .alert.alert-outline-primary {\n  color: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .badge-outline-primary {\n  border: 1px solid #00838f;\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .badge-primary {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .page-titles h4 {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_9\"] .card-action .dropdown {\n  background: black;\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .card-action .dropdown:hover,\n[data-primary=\"color_9\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_9\"] .card-loader i {\n  background: #00626b;\n}\n\n[data-primary=\"color_9\"] .dropdown-outline {\n  border: 0.1rem solid #00838f;\n}\n\n[data-primary=\"color_9\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .card-action .custom-dropdown {\n  background: #29edff;\n}\n\n[data-primary=\"color_9\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_9\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_9\"] .card-action .custom-dropdown:hover {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .label-primary {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .pagination .page-item .page-link:hover {\n  background: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .pagination .page-item.active .page-link {\n  background-color: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_9\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .progress-bar {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .progress-bar-primary {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .ribbon__four {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .ribbon__four:after,\n[data-primary=\"color_9\"] .ribbon__four:before {\n  background-color: #00e0f5;\n}\n\n[data-primary=\"color_9\"] .ribbon__five {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .ribbon__five::before {\n  border-color: transparent transparent #00838f transparent;\n}\n\n[data-primary=\"color_9\"] .ribbon__six {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .multi-steps>li {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .multi-steps>li:after {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .multi-steps>li.is-active:before {\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .timeline-badge.primary {\n  background-color: #00838f !important;\n}\n\n[data-primary=\"color_9\"] .tooltip-wrapper button:hover {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #00838f;\n  border: 1px solid #00838f;\n}\n\n[data-primary=\"color_9\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #00838f;\n}\n\n[data-primary=\"color_9\"] .social-icon2 a {\n  border: 0.1rem solid #00838f;\n}\n\n[data-primary=\"color_9\"] .social-icon2 i {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .social-icon3 ul li a:hover i {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .bgl-primary {\n  background: #29edff;\n  border-color: #29edff;\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .footer .copyright a {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .hamburger .line {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_9\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_9\"] svg.pulse-svg .third-circle {\n  fill: #00838f;\n}\n\n[data-primary=\"color_9\"] .pulse-css {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .pulse-css:after,\n[data-primary=\"color_9\"] .pulse-css:before {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_9\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_9\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .header-right .header-profile .profile_title {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #00838f !important;\n}\n\n[data-primary=\"color_9\"] .deznav .metismenu>li>a svg {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_9\"] .deznav .metismenu>li:focus>a {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .deznav .metismenu>li.mm-active>a {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_9\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_9\"] .deznav .metismenu ul a.mm-active {\n  color: #00838f;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_9\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_9\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_9\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_9\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #8ff6ff;\n  }\n}\n\n[data-primary=\"color_9\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .nav-user {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .new-arrival-content .price {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .chart-link a i.text-primary {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] #user-activity .nav-tabs .nav-link.active {\n  background: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] span#counter {\n  color: #00838f;\n}\n\n[data-primary=\"color_9\"] .welcome-content:after {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .timeline-badge {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .page-timeline .timeline-workplan[data-primary=\"color_9\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(0, 131, 143, 0.4);\n}\n\n[data-primary=\"color_9\"] .sk-three-bounce .sk-child {\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .dropdown-item.active,\n[data-primary=\"color_9\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .overlay-box:after {\n  background: #00838f;\n}\n\n[data-primary=\"color_9\"] .btn-primary {\n  background-color: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .bg-primary {\n  background-color: #00838f !important;\n}\n\n[data-primary=\"color_9\"] .text-primary {\n  color: #00838f !important;\n}\n\n[data-primary=\"color_9\"] .btn-primary:hover {\n  background-color: #003d43;\n  border-color: #003d43;\n}\n\n[data-primary=\"color_9\"] .btn-outline-primary {\n  color: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .btn-outline-primary:hover {\n  background-color: #00838f;\n  border-color: #00838f;\n}\n\n[data-primary=\"color_9\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_9\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_9\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_9\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_9\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_9\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #003d43;\n  border-color: #003d43;\n}\n\n[data-primary=\"color_10\"] a:hover,\n[data-primary=\"color_10\"] a:focus,\n[data-primary=\"color_10\"] a.active {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] [data-class=\"bg-primary\"]:before {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .email-left-box .intro-title {\n  background: rgba(255, 143, 22, 0.1);\n}\n\n[data-primary=\"color_10\"] .email-left-box .intro-title i {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .widget-stat .media .media-body h4 {\n  color: #ff8f16 !important;\n}\n\n[data-primary=\"color_10\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(255, 143, 22, 0.1);\n}\n\n[data-primary=\"color_10\"] .mail-list .list-group-item.active i {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .single-mail.active {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .profile-info h4.text-primary {\n  color: #ff8f16 !important;\n}\n\n[data-primary=\"color_10\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_10\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #ff8f16;\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .amChartsInputField {\n  border: 0;\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .amcharts-period-input,\n[data-primary=\"color_10\"] .amcharts-period-input-selected {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .morris-hover {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .custom-select:focus {\n  border-color: #ff8f16;\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .daterangepicker td.active {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .daterangepicker td.active:hover {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .daterangepicker button.applyBtn {\n  background-color: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .wizard>.steps li.current a {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .wizard .skip-email a {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #ffb463;\n}\n\n[data-primary=\"color_10\"] .datamaps-hoverover {\n  color: #ff8f16;\n  border: 1px solid rgba(255, 143, 22, 0.3);\n}\n\n[data-primary=\"color_10\"] .jqvmap-zoomin,\n[data-primary=\"color_10\"] .jqvmap-zoomout {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .table .thead-primary th {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .table.primary-table-bg-hover thead th {\n  background-color: #fc8300;\n}\n\n[data-primary=\"color_10\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #ff9b30;\n}\n\n[data-primary=\"color_10\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_10\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #fc8300;\n}\n\n[data-primary=\"color_10\"] table.dataTable tr.selected {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #ff8f16 !important;\n  background: rgba(255, 143, 22, 0.1);\n}\n\n[data-primary=\"color_10\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #ff8f16 !important;\n  background: rgba(255, 143, 22, 0.1);\n}\n\n[data-primary=\"color_10\"] .clipboard-btn:hover {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .cd-h-timeline__dates::before {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .cd-h-timeline__dates::after {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .cd-h-timeline__line {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .cd-h-timeline__date:after {\n  border-color: #ff911b;\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .cd-h-timeline__navigation {\n  border-color: #ff911b;\n}\n\n[data-primary=\"color_10\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #ff911b;\n}\n\n[data-primary=\"color_10\"] .dd-handle {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .dd-handle:hover {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .dd3-content:hover {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .noUi-connect {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .noUi-connect.c-3-color {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_10\"] .noUi-vertical .noUi-handle {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] #slider-toggle.off .noUi-handle {\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .pignose-calendar {\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .bootstrap-tagsinput .tag {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .toast-success {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .alert-primary {\n  background: #ffcc96;\n  border-color: #ffcc96;\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .alert-alt.alert-primary {\n  border-left: 4px solid #ff8f16;\n}\n\n[data-primary=\"color_10\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #964e00 !important;\n}\n\n[data-primary=\"color_10\"] .alert.alert-primary.solid {\n  background: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .alert.alert-outline-primary {\n  color: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .badge-outline-primary {\n  border: 1px solid #ff8f16;\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .badge-primary {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .page-titles h4 {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_10\"] .card-action .dropdown {\n  background: black;\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .card-action .dropdown:hover,\n[data-primary=\"color_10\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_10\"] .card-loader i {\n  background: #f17d00;\n}\n\n[data-primary=\"color_10\"] .dropdown-outline {\n  border: 0.1rem solid #ff8f16;\n}\n\n[data-primary=\"color_10\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .card-action .custom-dropdown {\n  background: #ffd9af;\n}\n\n[data-primary=\"color_10\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_10\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_10\"] .card-action .custom-dropdown:hover {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .label-primary {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .pagination .page-item .page-link:hover {\n  background: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .pagination .page-item.active .page-link {\n  background-color: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_10\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .progress-bar {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .progress-bar-primary {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .ribbon__four {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .ribbon__four:after,\n[data-primary=\"color_10\"] .ribbon__four:before {\n  background-color: #ffc07c;\n}\n\n[data-primary=\"color_10\"] .ribbon__five {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .ribbon__five::before {\n  border-color: transparent transparent #ff8f16 transparent;\n}\n\n[data-primary=\"color_10\"] .ribbon__six {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .multi-steps>li {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .multi-steps>li:after {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .multi-steps>li.is-active:before {\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .timeline-badge.primary {\n  background-color: #ff8f16 !important;\n}\n\n[data-primary=\"color_10\"] .tooltip-wrapper button:hover {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #ff8f16;\n  border: 1px solid #ff8f16;\n}\n\n[data-primary=\"color_10\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #ff8f16;\n}\n\n[data-primary=\"color_10\"] .social-icon2 a {\n  border: 0.1rem solid #ff8f16;\n}\n\n[data-primary=\"color_10\"] .social-icon2 i {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .social-icon3 ul li a:hover i {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .bgl-primary {\n  background: #ffd9af;\n  border-color: #ffd9af;\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .footer .copyright a {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .hamburger .line {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_10\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_10\"] svg.pulse-svg .third-circle {\n  fill: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .pulse-css {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .pulse-css:after,\n[data-primary=\"color_10\"] .pulse-css:before {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_10\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_10\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .header-right .header-profile .profile_title {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #ff8f16 !important;\n}\n\n[data-primary=\"color_10\"] .deznav .metismenu>li>a svg {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_10\"] .deznav .metismenu>li:focus>a {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .deznav .metismenu>li.mm-active>a {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_10\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_10\"] .deznav .metismenu ul a.mm-active {\n  color: #ff8f16;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_10\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_10\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_10\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_10\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: white;\n  }\n}\n\n[data-primary=\"color_10\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .nav-user {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .new-arrival-content .price {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .chart-link a i.text-primary {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] #user-activity .nav-tabs .nav-link.active {\n  background: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] span#counter {\n  color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .welcome-content:after {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .timeline-badge {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .page-timeline .timeline-workplan[data-primary=\"color_10\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(255, 143, 22, 0.4);\n}\n\n[data-primary=\"color_10\"] .sk-three-bounce .sk-child {\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .dropdown-item.active,\n[data-primary=\"color_10\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .overlay-box:after {\n  background: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .btn-primary {\n  background-color: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .bg-primary {\n  background-color: #ff8f16 !important;\n}\n\n[data-primary=\"color_10\"] .text-primary {\n  color: #ff8f16 !important;\n}\n\n[data-primary=\"color_10\"] .btn-primary:hover {\n  background-color: #c96800;\n  border-color: #c96800;\n}\n\n[data-primary=\"color_10\"] .btn-outline-primary {\n  color: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .btn-outline-primary:hover {\n  background-color: #ff8f16;\n  border-color: #ff8f16;\n}\n\n[data-primary=\"color_10\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_10\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_10\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_10\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_10\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_10\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #c96800;\n  border-color: #c96800;\n}\n\n[data-primary=\"color_11\"] a:hover,\n[data-primary=\"color_11\"] a:focus,\n[data-primary=\"color_11\"] a.active {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] [data-class=\"bg-primary\"]:before {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .email-left-box .intro-title {\n  background: rgba(102, 115, 253, 0.1);\n}\n\n[data-primary=\"color_11\"] .email-left-box .intro-title i {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .widget-stat .media .media-body h4 {\n  color: #6673fd !important;\n}\n\n[data-primary=\"color_11\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(102, 115, 253, 0.1);\n}\n\n[data-primary=\"color_11\"] .mail-list .list-group-item.active i {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .single-mail.active {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .profile-info h4.text-primary {\n  color: #6673fd !important;\n}\n\n[data-primary=\"color_11\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_11\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #6673fd;\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .amChartsInputField {\n  border: 0;\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .amcharts-period-input,\n[data-primary=\"color_11\"] .amcharts-period-input-selected {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .morris-hover {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .custom-select:focus {\n  border-color: #6673fd;\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .daterangepicker td.active {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .daterangepicker td.active:hover {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .daterangepicker button.applyBtn {\n  background-color: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .wizard>.steps li.current a {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .wizard .skip-email a {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #b2b8fe;\n}\n\n[data-primary=\"color_11\"] .datamaps-hoverover {\n  color: #6673fd;\n  border: 1px solid rgba(102, 115, 253, 0.3);\n}\n\n[data-primary=\"color_11\"] .jqvmap-zoomin,\n[data-primary=\"color_11\"] .jqvmap-zoomout {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .table .thead-primary th {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .table.primary-table-bg-hover thead th {\n  background-color: #4d5cfd;\n}\n\n[data-primary=\"color_11\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #7f8afd;\n}\n\n[data-primary=\"color_11\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_11\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #4d5cfd;\n}\n\n[data-primary=\"color_11\"] table.dataTable tr.selected {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #6673fd !important;\n  background: rgba(102, 115, 253, 0.1);\n}\n\n[data-primary=\"color_11\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #6673fd !important;\n  background: rgba(102, 115, 253, 0.1);\n}\n\n[data-primary=\"color_11\"] .clipboard-btn:hover {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .cd-h-timeline__dates::before {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .cd-h-timeline__dates::after {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .cd-h-timeline__line {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .cd-h-timeline__date:after {\n  border-color: #6b77fd;\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .cd-h-timeline__navigation {\n  border-color: #6b77fd;\n}\n\n[data-primary=\"color_11\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #6b77fd;\n}\n\n[data-primary=\"color_11\"] .dd-handle {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .dd-handle:hover {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .dd3-content:hover {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .noUi-connect {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .noUi-connect.c-3-color {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_11\"] .noUi-vertical .noUi-handle {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] #slider-toggle.off .noUi-handle {\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .pignose-calendar {\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .bootstrap-tagsinput .tag {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .toast-success {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .alert-primary {\n  background: #e4e6ff;\n  border-color: #e4e6ff;\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .alert-alt.alert-primary {\n  border-left: 4px solid #6673fd;\n}\n\n[data-primary=\"color_11\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #0316e1 !important;\n}\n\n[data-primary=\"color_11\"] .alert.alert-primary.solid {\n  background: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .alert.alert-outline-primary {\n  color: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .badge-outline-primary {\n  border: 1px solid #6673fd;\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .badge-primary {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .page-titles h4 {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .card-action>a {\n  background: #01063f;\n}\n\n[data-primary=\"color_11\"] .card-action .dropdown {\n  background: #01063f;\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .card-action .dropdown:hover,\n[data-primary=\"color_11\"] .card-action .dropdown:focus {\n  background: #01063f;\n}\n\n[data-primary=\"color_11\"] .card-loader i {\n  background: #4353fd;\n}\n\n[data-primary=\"color_11\"] .dropdown-outline {\n  border: 0.1rem solid #6673fd;\n}\n\n[data-primary=\"color_11\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .card-action .custom-dropdown {\n  background: #fdfdff;\n}\n\n[data-primary=\"color_11\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_11\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_11\"] .card-action .custom-dropdown:hover {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .label-primary {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .pagination .page-item .page-link:hover {\n  background: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .pagination .page-item.active .page-link {\n  background-color: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_11\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .progress-bar {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .progress-bar-primary {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .ribbon__four {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .ribbon__four:after,\n[data-primary=\"color_11\"] .ribbon__four:before {\n  background-color: #cbcffe;\n}\n\n[data-primary=\"color_11\"] .ribbon__five {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .ribbon__five::before {\n  border-color: transparent transparent #6673fd transparent;\n}\n\n[data-primary=\"color_11\"] .ribbon__six {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .multi-steps>li {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .multi-steps>li:after {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .multi-steps>li.is-active:before {\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .timeline-badge.primary {\n  background-color: #6673fd !important;\n}\n\n[data-primary=\"color_11\"] .tooltip-wrapper button:hover {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #6673fd;\n  border: 1px solid #6673fd;\n}\n\n[data-primary=\"color_11\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #6673fd;\n}\n\n[data-primary=\"color_11\"] .social-icon2 a {\n  border: 0.1rem solid #6673fd;\n}\n\n[data-primary=\"color_11\"] .social-icon2 i {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .social-icon3 ul li a:hover i {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .bgl-primary {\n  background: #fdfdff;\n  border-color: #fdfdff;\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .footer .copyright a {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .hamburger .line {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_11\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_11\"] svg.pulse-svg .third-circle {\n  fill: #6673fd;\n}\n\n[data-primary=\"color_11\"] .pulse-css {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .pulse-css:after,\n[data-primary=\"color_11\"] .pulse-css:before {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_11\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_11\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .header-right .header-profile .profile_title {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #6673fd !important;\n}\n\n[data-primary=\"color_11\"] .deznav .metismenu>li>a svg {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_11\"] .deznav .metismenu>li:focus>a {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .deznav .metismenu>li.mm-active>a {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_11\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_11\"] .deznav .metismenu ul a.mm-active {\n  color: #6673fd;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_11\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_11\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_11\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_11\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: white;\n  }\n}\n\n[data-primary=\"color_11\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .nav-user {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .new-arrival-content .price {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .chart-link a i.text-primary {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] #user-activity .nav-tabs .nav-link.active {\n  background: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] span#counter {\n  color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .welcome-content:after {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .timeline-badge {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .page-timeline .timeline-workplan[data-primary=\"color_11\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(102, 115, 253, 0.4);\n}\n\n[data-primary=\"color_11\"] .sk-three-bounce .sk-child {\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .dropdown-item.active,\n[data-primary=\"color_11\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .overlay-box:after {\n  background: #6673fd;\n}\n\n[data-primary=\"color_11\"] .btn-primary {\n  background-color: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .bg-primary {\n  background-color: #6673fd !important;\n}\n\n[data-primary=\"color_11\"] .text-primary {\n  color: #6673fd !important;\n}\n\n[data-primary=\"color_11\"] .btn-primary:hover {\n  background-color: #1a2efc;\n  border-color: #1a2efc;\n}\n\n[data-primary=\"color_11\"] .btn-outline-primary {\n  color: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .btn-outline-primary:hover {\n  background-color: #6673fd;\n  border-color: #6673fd;\n}\n\n[data-primary=\"color_11\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_11\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_11\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_11\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_11\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_11\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #1a2efc;\n  border-color: #1a2efc;\n}\n\n[data-primary=\"color_12\"] a:hover,\n[data-primary=\"color_12\"] a:focus,\n[data-primary=\"color_12\"] a.active {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] [data-class=\"bg-primary\"]:before {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .email-left-box .intro-title {\n  background: rgba(85, 139, 47, 0.1);\n}\n\n[data-primary=\"color_12\"] .email-left-box .intro-title i {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .widget-stat .media .media-body h4 {\n  color: #558b2f !important;\n}\n\n[data-primary=\"color_12\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(85, 139, 47, 0.1);\n}\n\n[data-primary=\"color_12\"] .mail-list .list-group-item.active i {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .single-mail.active {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .profile-info h4.text-primary {\n  color: #558b2f !important;\n}\n\n[data-primary=\"color_12\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_12\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #558b2f;\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .amChartsInputField {\n  border: 0;\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .amcharts-period-input,\n[data-primary=\"color_12\"] .amcharts-period-input-selected {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .morris-hover {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .custom-select:focus {\n  border-color: #558b2f;\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .daterangepicker td.active {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .daterangepicker td.active:hover {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .daterangepicker button.applyBtn {\n  background-color: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .wizard>.steps li.current a {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .wizard .skip-email a {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #79c046;\n}\n\n[data-primary=\"color_12\"] .datamaps-hoverover {\n  color: #558b2f;\n  border: 1px solid rgba(85, 139, 47, 0.3);\n}\n\n[data-primary=\"color_12\"] .jqvmap-zoomin,\n[data-primary=\"color_12\"] .jqvmap-zoomout {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .table .thead-primary th {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .table.primary-table-bg-hover thead th {\n  background-color: #497829;\n}\n\n[data-primary=\"color_12\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #619e35;\n}\n\n[data-primary=\"color_12\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_12\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #497829;\n}\n\n[data-primary=\"color_12\"] table.dataTable tr.selected {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #558b2f !important;\n  background: rgba(85, 139, 47, 0.1);\n}\n\n[data-primary=\"color_12\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #558b2f !important;\n  background: rgba(85, 139, 47, 0.1);\n}\n\n[data-primary=\"color_12\"] .clipboard-btn:hover {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .cd-h-timeline__dates::before {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .cd-h-timeline__dates::after {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .cd-h-timeline__line {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .cd-h-timeline__date:after {\n  border-color: #578e30;\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .cd-h-timeline__navigation {\n  border-color: #578e30;\n}\n\n[data-primary=\"color_12\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #578e30;\n}\n\n[data-primary=\"color_12\"] .dd-handle {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .dd-handle:hover {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .dd3-content:hover {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .noUi-connect {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .noUi-connect.c-3-color {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_12\"] .noUi-vertical .noUi-handle {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] #slider-toggle.off .noUi-handle {\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .pignose-calendar {\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .bootstrap-tagsinput .tag {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .toast-success {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .alert-primary {\n  background: #94cd6c;\n  border-color: #94cd6c;\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .alert-alt.alert-primary {\n  border-left: 4px solid #558b2f;\n}\n\n[data-primary=\"color_12\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #1b2c0f !important;\n}\n\n[data-primary=\"color_12\"] .alert.alert-primary.solid {\n  background: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .alert.alert-outline-primary {\n  color: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .badge-outline-primary {\n  border: 1px solid #558b2f;\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .badge-primary {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .page-titles h4 {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_12\"] .card-action .dropdown {\n  background: black;\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .card-action .dropdown:hover,\n[data-primary=\"color_12\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_12\"] .card-loader i {\n  background: #457026;\n}\n\n[data-primary=\"color_12\"] .dropdown-outline {\n  border: 0.1rem solid #558b2f;\n}\n\n[data-primary=\"color_12\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .card-action .custom-dropdown {\n  background: #a2d47f;\n}\n\n[data-primary=\"color_12\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_12\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_12\"] .card-action .custom-dropdown:hover {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .label-primary {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .pagination .page-item .page-link:hover {\n  background: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .pagination .page-item.active .page-link {\n  background-color: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_12\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .progress-bar {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .progress-bar-primary {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .ribbon__four {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .ribbon__four:after,\n[data-primary=\"color_12\"] .ribbon__four:before {\n  background-color: #86c759;\n}\n\n[data-primary=\"color_12\"] .ribbon__five {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .ribbon__five::before {\n  border-color: transparent transparent #558b2f transparent;\n}\n\n[data-primary=\"color_12\"] .ribbon__six {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .multi-steps>li {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .multi-steps>li:after {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .multi-steps>li.is-active:before {\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .timeline-badge.primary {\n  background-color: #558b2f !important;\n}\n\n[data-primary=\"color_12\"] .tooltip-wrapper button:hover {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #558b2f;\n  border: 1px solid #558b2f;\n}\n\n[data-primary=\"color_12\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #558b2f;\n}\n\n[data-primary=\"color_12\"] .social-icon2 a {\n  border: 0.1rem solid #558b2f;\n}\n\n[data-primary=\"color_12\"] .social-icon2 i {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .social-icon3 ul li a:hover i {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .bgl-primary {\n  background: #a2d47f;\n  border-color: #a2d47f;\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .footer .copyright a {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .hamburger .line {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_12\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_12\"] svg.pulse-svg .third-circle {\n  fill: #558b2f;\n}\n\n[data-primary=\"color_12\"] .pulse-css {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .pulse-css:after,\n[data-primary=\"color_12\"] .pulse-css:before {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_12\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_12\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .header-right .header-profile .profile_title {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #558b2f !important;\n}\n\n[data-primary=\"color_12\"] .deznav .metismenu>li>a svg {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_12\"] .deznav .metismenu>li:focus>a {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .deznav .metismenu>li.mm-active>a {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_12\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_12\"] .deznav .metismenu ul a.mm-active {\n  color: #558b2f;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_12\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_12\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_12\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_12\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #daeecb;\n  }\n}\n\n[data-primary=\"color_12\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .nav-user {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .new-arrival-content .price {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .chart-link a i.text-primary {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] #user-activity .nav-tabs .nav-link.active {\n  background: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] span#counter {\n  color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .welcome-content:after {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .timeline-badge {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .page-timeline .timeline-workplan[data-primary=\"color_12\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(85, 139, 47, 0.4);\n}\n\n[data-primary=\"color_12\"] .sk-three-bounce .sk-child {\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .dropdown-item.active,\n[data-primary=\"color_12\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .overlay-box:after {\n  background: #558b2f;\n}\n\n[data-primary=\"color_12\"] .btn-primary {\n  background-color: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .bg-primary {\n  background-color: #558b2f !important;\n}\n\n[data-primary=\"color_12\"] .text-primary {\n  color: #558b2f !important;\n}\n\n[data-primary=\"color_12\"] .btn-primary:hover {\n  background-color: #32521c;\n  border-color: #32521c;\n}\n\n[data-primary=\"color_12\"] .btn-outline-primary {\n  color: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .btn-outline-primary:hover {\n  background-color: #558b2f;\n  border-color: #558b2f;\n}\n\n[data-primary=\"color_12\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_12\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_12\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_12\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_12\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_12\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #32521c;\n  border-color: #32521c;\n}\n\n[data-primary=\"color_13\"] a:hover,\n[data-primary=\"color_13\"] a:focus,\n[data-primary=\"color_13\"] a.active {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] [data-class=\"bg-primary\"]:before {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .email-left-box .intro-title {\n  background: rgba(42, 42, 42, 0.1);\n}\n\n[data-primary=\"color_13\"] .email-left-box .intro-title i {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .widget-stat .media .media-body h4 {\n  color: #2a2a2a !important;\n}\n\n[data-primary=\"color_13\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(42, 42, 42, 0.1);\n}\n\n[data-primary=\"color_13\"] .mail-list .list-group-item.active i {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .single-mail.active {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .profile-info h4.text-primary {\n  color: #2a2a2a !important;\n}\n\n[data-primary=\"color_13\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_13\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #2a2a2a;\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .amChartsInputField {\n  border: 0;\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .amcharts-period-input,\n[data-primary=\"color_13\"] .amcharts-period-input-selected {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .morris-hover {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .custom-select:focus {\n  border-color: #2a2a2a;\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .daterangepicker td.active {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .daterangepicker td.active:hover {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .daterangepicker button.applyBtn {\n  background-color: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .wizard>.steps li.current a {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .wizard .skip-email a {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #505050;\n}\n\n[data-primary=\"color_13\"] .datamaps-hoverover {\n  color: #2a2a2a;\n  border: 1px solid rgba(42, 42, 42, 0.3);\n}\n\n[data-primary=\"color_13\"] .jqvmap-zoomin,\n[data-primary=\"color_13\"] .jqvmap-zoomout {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .table .thead-primary th {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .table.primary-table-bg-hover thead th {\n  background-color: #1d1d1d;\n}\n\n[data-primary=\"color_13\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #373737;\n}\n\n[data-primary=\"color_13\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_13\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #1d1d1d;\n}\n\n[data-primary=\"color_13\"] table.dataTable tr.selected {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #2a2a2a !important;\n  background: rgba(42, 42, 42, 0.1);\n}\n\n[data-primary=\"color_13\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #2a2a2a !important;\n  background: rgba(42, 42, 42, 0.1);\n}\n\n[data-primary=\"color_13\"] .clipboard-btn:hover {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .cd-h-timeline__dates::before {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .cd-h-timeline__dates::after {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .cd-h-timeline__line {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .cd-h-timeline__date:after {\n  border-color: #2c2c2c;\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .cd-h-timeline__navigation {\n  border-color: #2c2c2c;\n}\n\n[data-primary=\"color_13\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #2c2c2c;\n}\n\n[data-primary=\"color_13\"] .dd-handle {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .dd-handle:hover {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .dd3-content:hover {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .noUi-connect {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .noUi-connect.c-3-color {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_13\"] .noUi-vertical .noUi-handle {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] #slider-toggle.off .noUi-handle {\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .pignose-calendar {\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .bootstrap-tagsinput .tag {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .toast-success {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .alert-primary {\n  background: #6a6a6a;\n  border-color: #6a6a6a;\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .alert-alt.alert-primary {\n  border-left: 4px solid #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid black !important;\n}\n\n[data-primary=\"color_13\"] .alert.alert-primary.solid {\n  background: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .alert.alert-outline-primary {\n  color: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .badge-outline-primary {\n  border: 1px solid #2a2a2a;\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .badge-primary {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .page-titles h4 {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_13\"] .card-action .dropdown {\n  background: black;\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .card-action .dropdown:hover,\n[data-primary=\"color_13\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_13\"] .card-loader i {\n  background: #181818;\n}\n\n[data-primary=\"color_13\"] .dropdown-outline {\n  border: 0.1rem solid #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .card-action .custom-dropdown {\n  background: #777777;\n}\n\n[data-primary=\"color_13\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_13\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_13\"] .card-action .custom-dropdown:hover {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .label-primary {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .pagination .page-item .page-link:hover {\n  background: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .pagination .page-item.active .page-link {\n  background-color: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_13\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .progress-bar {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .progress-bar-primary {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .ribbon__four {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .ribbon__four:after,\n[data-primary=\"color_13\"] .ribbon__four:before {\n  background-color: #5d5d5d;\n}\n\n[data-primary=\"color_13\"] .ribbon__five {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .ribbon__five::before {\n  border-color: transparent transparent #2a2a2a transparent;\n}\n\n[data-primary=\"color_13\"] .ribbon__six {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .multi-steps>li {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .multi-steps>li:after {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .multi-steps>li.is-active:before {\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .timeline-badge.primary {\n  background-color: #2a2a2a !important;\n}\n\n[data-primary=\"color_13\"] .tooltip-wrapper button:hover {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #2a2a2a;\n  border: 1px solid #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .social-icon2 a {\n  border: 0.1rem solid #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .social-icon2 i {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .social-icon3 ul li a:hover i {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .bgl-primary {\n  background: #777777;\n  border-color: #777777;\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .footer .copyright a {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .hamburger .line {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_13\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_13\"] svg.pulse-svg .third-circle {\n  fill: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .pulse-css {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .pulse-css:after,\n[data-primary=\"color_13\"] .pulse-css:before {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_13\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_13\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .header-right .header-profile .profile_title {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #2a2a2a !important;\n}\n\n[data-primary=\"color_13\"] .deznav .metismenu>li>a svg {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_13\"] .deznav .metismenu>li:focus>a {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .deznav .metismenu>li.mm-active>a {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_13\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_13\"] .deznav .metismenu ul a.mm-active {\n  color: #2a2a2a;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_13\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_13\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_13\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_13\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #aaaaaa;\n  }\n}\n\n[data-primary=\"color_13\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .nav-user {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .new-arrival-content .price {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .chart-link a i.text-primary {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] #user-activity .nav-tabs .nav-link.active {\n  background: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] span#counter {\n  color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .welcome-content:after {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .timeline-badge {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .page-timeline .timeline-workplan[data-primary=\"color_13\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(42, 42, 42, 0.4);\n}\n\n[data-primary=\"color_13\"] .sk-three-bounce .sk-child {\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .dropdown-item.active,\n[data-primary=\"color_13\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .overlay-box:after {\n  background: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .btn-primary {\n  background-color: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .bg-primary {\n  background-color: #2a2a2a !important;\n}\n\n[data-primary=\"color_13\"] .text-primary {\n  color: #2a2a2a !important;\n}\n\n[data-primary=\"color_13\"] .btn-primary:hover {\n  background-color: #040404;\n  border-color: #040404;\n}\n\n[data-primary=\"color_13\"] .btn-outline-primary {\n  color: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .btn-outline-primary:hover {\n  background-color: #2a2a2a;\n  border-color: #2a2a2a;\n}\n\n[data-primary=\"color_13\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_13\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_13\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_13\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_13\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_13\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #040404;\n  border-color: #040404;\n}\n\n[data-primary=\"color_14\"] a:hover,\n[data-primary=\"color_14\"] a:focus,\n[data-primary=\"color_14\"] a.active {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] [data-class=\"bg-primary\"]:before {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .email-left-box .intro-title {\n  background: rgba(19, 103, 200, 0.1);\n}\n\n[data-primary=\"color_14\"] .email-left-box .intro-title i {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .widget-stat .media .media-body h4 {\n  color: #1367c8 !important;\n}\n\n[data-primary=\"color_14\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(19, 103, 200, 0.1);\n}\n\n[data-primary=\"color_14\"] .mail-list .list-group-item.active i {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .single-mail.active {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .profile-info h4.text-primary {\n  color: #1367c8 !important;\n}\n\n[data-primary=\"color_14\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_14\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #1367c8;\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .amChartsInputField {\n  border: 0;\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .amcharts-period-input,\n[data-primary=\"color_14\"] .amcharts-period-input-selected {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .morris-hover {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .custom-select:focus {\n  border-color: #1367c8;\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .daterangepicker td.active {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .daterangepicker td.active:hover {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .daterangepicker button.applyBtn {\n  background-color: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .wizard>.steps li.current a {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .wizard .skip-email a {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #3b8dec;\n}\n\n[data-primary=\"color_14\"] .datamaps-hoverover {\n  color: #1367c8;\n  border: 1px solid rgba(19, 103, 200, 0.3);\n}\n\n[data-primary=\"color_14\"] .jqvmap-zoomin,\n[data-primary=\"color_14\"] .jqvmap-zoomout {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .table .thead-primary th {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .table.primary-table-bg-hover thead th {\n  background-color: #115bb1;\n}\n\n[data-primary=\"color_14\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #1573df;\n}\n\n[data-primary=\"color_14\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_14\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #115bb1;\n}\n\n[data-primary=\"color_14\"] table.dataTable tr.selected {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #1367c8 !important;\n  background: rgba(19, 103, 200, 0.1);\n}\n\n[data-primary=\"color_14\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #1367c8 !important;\n  background: rgba(19, 103, 200, 0.1);\n}\n\n[data-primary=\"color_14\"] .clipboard-btn:hover {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .cd-h-timeline__dates::before {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .cd-h-timeline__dates::after {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .cd-h-timeline__line {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .cd-h-timeline__date:after {\n  border-color: #1369cc;\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .cd-h-timeline__navigation {\n  border-color: #1369cc;\n}\n\n[data-primary=\"color_14\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #1369cc;\n}\n\n[data-primary=\"color_14\"] .dd-handle {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .dd-handle:hover {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .dd3-content:hover {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .noUi-connect {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .noUi-connect.c-3-color {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_14\"] .noUi-vertical .noUi-handle {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] #slider-toggle.off .noUi-handle {\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .pignose-calendar {\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .bootstrap-tagsinput .tag {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .toast-success {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .alert-primary {\n  background: #6aa8f1;\n  border-color: #6aa8f1;\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .alert-alt.alert-primary {\n  border-left: 4px solid #1367c8;\n}\n\n[data-primary=\"color_14\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #082b54 !important;\n}\n\n[data-primary=\"color_14\"] .alert.alert-primary.solid {\n  background: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .alert.alert-outline-primary {\n  color: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .badge-outline-primary {\n  border: 1px solid #1367c8;\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .badge-primary {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .page-titles h4 {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_14\"] .card-action .dropdown {\n  background: black;\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .card-action .dropdown:hover,\n[data-primary=\"color_14\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_14\"] .card-loader i {\n  background: #1056a7;\n}\n\n[data-primary=\"color_14\"] .dropdown-outline {\n  border: 0.1rem solid #1367c8;\n}\n\n[data-primary=\"color_14\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .card-action .custom-dropdown {\n  background: #81b6f3;\n}\n\n[data-primary=\"color_14\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_14\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_14\"] .card-action .custom-dropdown:hover {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .label-primary {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .pagination .page-item .page-link:hover {\n  background: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .pagination .page-item.active .page-link {\n  background-color: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_14\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .progress-bar {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .progress-bar-primary {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .ribbon__four {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .ribbon__four:after,\n[data-primary=\"color_14\"] .ribbon__four:before {\n  background-color: #529bef;\n}\n\n[data-primary=\"color_14\"] .ribbon__five {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .ribbon__five::before {\n  border-color: transparent transparent #1367c8 transparent;\n}\n\n[data-primary=\"color_14\"] .ribbon__six {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .multi-steps>li {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .multi-steps>li:after {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .multi-steps>li.is-active:before {\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .timeline-badge.primary {\n  background-color: #1367c8 !important;\n}\n\n[data-primary=\"color_14\"] .tooltip-wrapper button:hover {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #1367c8;\n  border: 1px solid #1367c8;\n}\n\n[data-primary=\"color_14\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #1367c8;\n}\n\n[data-primary=\"color_14\"] .social-icon2 a {\n  border: 0.1rem solid #1367c8;\n}\n\n[data-primary=\"color_14\"] .social-icon2 i {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .social-icon3 ul li a:hover i {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .bgl-primary {\n  background: #81b6f3;\n  border-color: #81b6f3;\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .footer .copyright a {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .hamburger .line {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_14\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_14\"] svg.pulse-svg .third-circle {\n  fill: #1367c8;\n}\n\n[data-primary=\"color_14\"] .pulse-css {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .pulse-css:after,\n[data-primary=\"color_14\"] .pulse-css:before {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_14\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_14\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .header-right .header-profile .profile_title {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #1367c8 !important;\n}\n\n[data-primary=\"color_14\"] .deznav .metismenu>li>a svg {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_14\"] .deznav .metismenu>li:focus>a {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .deznav .metismenu>li.mm-active>a {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_14\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_14\"] .deznav .metismenu ul a.mm-active {\n  color: #1367c8;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_14\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_14\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_14\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_14\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #deecfc;\n  }\n}\n\n[data-primary=\"color_14\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .nav-user {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .new-arrival-content .price {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .chart-link a i.text-primary {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] #user-activity .nav-tabs .nav-link.active {\n  background: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] span#counter {\n  color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .welcome-content:after {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .timeline-badge {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .page-timeline .timeline-workplan[data-primary=\"color_14\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(19, 103, 200, 0.4);\n}\n\n[data-primary=\"color_14\"] .sk-three-bounce .sk-child {\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .dropdown-item.active,\n[data-primary=\"color_14\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .overlay-box:after {\n  background: #1367c8;\n}\n\n[data-primary=\"color_14\"] .btn-primary {\n  background-color: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .bg-primary {\n  background-color: #1367c8 !important;\n}\n\n[data-primary=\"color_14\"] .text-primary {\n  color: #1367c8 !important;\n}\n\n[data-primary=\"color_14\"] .btn-primary:hover {\n  background-color: #0c4382;\n  border-color: #0c4382;\n}\n\n[data-primary=\"color_14\"] .btn-outline-primary {\n  color: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .btn-outline-primary:hover {\n  background-color: #1367c8;\n  border-color: #1367c8;\n}\n\n[data-primary=\"color_14\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_14\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_14\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_14\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_14\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_14\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #0c4382;\n  border-color: #0c4382;\n}\n\n[data-primary=\"color_15\"] a:hover,\n[data-primary=\"color_15\"] a:focus,\n[data-primary=\"color_15\"] a.active {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] [data-class=\"bg-primary\"]:before {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .email-left-box .intro-title {\n  background: rgba(237, 11, 76, 0.1);\n}\n\n[data-primary=\"color_15\"] .email-left-box .intro-title i {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .widget-stat .media .media-body h4 {\n  color: #ed0b4c !important;\n}\n\n[data-primary=\"color_15\"] .email-right-box .right-box-border {\n  border-right: 2px solid rgba(237, 11, 76, 0.1);\n}\n\n[data-primary=\"color_15\"] .mail-list .list-group-item.active i {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .single-mail.active {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .profile-info h4.text-primary {\n  color: #ed0b4c !important;\n}\n\n[data-primary=\"color_15\"] .profile-tab .nav-item .nav-link:hover,\n[data-primary=\"color_15\"] .profile-tab .nav-item .nav-link.active {\n  border-bottom: 0.2px solid #ed0b4c;\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .amChartsInputField {\n  border: 0;\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .amcharts-period-input,\n[data-primary=\"color_15\"] .amcharts-period-input-selected {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .morris-hover {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .custom-select:focus {\n  border-color: #ed0b4c;\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .daterangepicker td.active {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .daterangepicker td.active:hover {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .daterangepicker button.applyBtn {\n  background-color: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .wizard>.steps li.current a {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .wizard .skip-email a {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .wizard>.actions li:not(.disabled) a {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .step-form-horizontal .wizard .steps li.done a .number {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .step-form-horizontal .wizard .steps li.current a .number {\n  color: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .is-invalid .input-group-prepend .input-group-text i {\n  color: #f74e7e;\n}\n\n[data-primary=\"color_15\"] .datamaps-hoverover {\n  color: #ed0b4c;\n  border: 1px solid rgba(237, 11, 76, 0.3);\n}\n\n[data-primary=\"color_15\"] .jqvmap-zoomin,\n[data-primary=\"color_15\"] .jqvmap-zoomout {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .table .thead-primary th {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .table.primary-table-bg-hover thead th {\n  background-color: #d50a44;\n}\n\n[data-primary=\"color_15\"] .table.primary-table-bg-hover tbody tr {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .table.primary-table-bg-hover tbody tr:hover {\n  background-color: #f51d5b;\n}\n\n[data-primary=\"color_15\"] .table.primary-table-bg-hover tbody tr:not(:last-child) td,\n[data-primary=\"color_15\"] .table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #d50a44;\n}\n\n[data-primary=\"color_15\"] table.dataTable tr.selected {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #ed0b4c !important;\n  background: rgba(237, 11, 76, 0.1);\n}\n\n[data-primary=\"color_15\"] .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  color: #ed0b4c !important;\n  background: rgba(237, 11, 76, 0.1);\n}\n\n[data-primary=\"color_15\"] .clipboard-btn:hover {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .cd-h-timeline__dates::before {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .cd-h-timeline__dates::after {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .cd-h-timeline__line {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .cd-h-timeline__date:after {\n  border-color: #f10b4d;\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .cd-h-timeline__navigation {\n  border-color: #f10b4d;\n}\n\n[data-primary=\"color_15\"] .cd-h-timeline__navigation--inactive:hover {\n  border-color: #f10b4d;\n}\n\n[data-primary=\"color_15\"] .dd-handle {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .dd-handle:hover {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .dd3-content:hover {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .noUi-connect {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .noUi-connect.c-3-color {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .noUi-horizontal .noUi-handle,\n[data-primary=\"color_15\"] .noUi-vertical .noUi-handle {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] #slider-toggle.off .noUi-handle {\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .pignose-calendar {\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .pignose-calendar .pignose-calendar-top-date {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .bootstrap-tagsinput .tag {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .toast-success {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .alert-primary {\n  background: #f97ea2;\n  border-color: #f97ea2;\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .alert-alt.alert-primary {\n  border-left: 4px solid #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .alert-alt.alert-primary.solid {\n  border-left: 4px solid #730525 !important;\n}\n\n[data-primary=\"color_15\"] .alert.alert-primary.solid {\n  background: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .alert.alert-outline-primary {\n  color: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .badge-outline-primary {\n  border: 1px solid #ed0b4c;\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .badge-primary {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .page-titles h4 {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .card-action>a {\n  background: black;\n}\n\n[data-primary=\"color_15\"] .card-action .dropdown {\n  background: black;\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .card-action .dropdown:hover,\n[data-primary=\"color_15\"] .card-action .dropdown:focus {\n  background: black;\n}\n\n[data-primary=\"color_15\"] .card-loader i {\n  background: #cb0941;\n}\n\n[data-primary=\"color_15\"] .dropdown-outline {\n  border: 0.1rem solid #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .custom-dropdown .dropdown-menu .dropdown-item:hover {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .card-action .custom-dropdown {\n  background: #fa97b3;\n}\n\n[data-primary=\"color_15\"] .card-action .custom-dropdown.show,\n[data-primary=\"color_15\"] .card-action .custom-dropdown:focus,\n[data-primary=\"color_15\"] .card-action .custom-dropdown:hover {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .label-primary {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .pagination .page-item .page-link:hover {\n  background: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .pagination .page-item.active .page-link {\n  background-color: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .bootstrap-popover-wrapper .bootstrap-popover button:hover,\n[data-primary=\"color_15\"] .bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .progress-bar {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .progress-bar-primary {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .ribbon__four {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .ribbon__four:after,\n[data-primary=\"color_15\"] .ribbon__four:before {\n  background-color: #f86690;\n}\n\n[data-primary=\"color_15\"] .ribbon__five {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .ribbon__five::before {\n  border-color: transparent transparent #ed0b4c transparent;\n}\n\n[data-primary=\"color_15\"] .ribbon__six {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .multi-steps>li {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .multi-steps>li:after {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .multi-steps>li.is-active:before {\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .timeline-badge.primary {\n  background-color: #ed0b4c !important;\n}\n\n[data-primary=\"color_15\"] .tooltip-wrapper button:hover {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .chart_widget_tab_one .nav-link.active {\n  background-color: #ed0b4c;\n  border: 1px solid #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .social-icon2 a {\n  border: 0.1rem solid #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .social-icon2 i {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .social-icon3 ul li a:hover i {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .bgl-primary {\n  background: #fa97b3;\n  border-color: #fa97b3;\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .tdl-holder input[type=checkbox]:checked+i {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .footer .copyright a {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .hamburger .line {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] svg.pulse-svg .first-circle,\n[data-primary=\"color_15\"] svg.pulse-svg .second-circle,\n[data-primary=\"color_15\"] svg.pulse-svg .third-circle {\n  fill: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .pulse-css {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .pulse-css:after,\n[data-primary=\"color_15\"] .pulse-css:before {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .notification_dropdown .dropdown-menu-right .notification_title {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .header-right .header-profile .dropdown-menu a:hover,\n[data-primary=\"color_15\"] .header-right .header-profile .dropdown-menu a:focus,\n[data-primary=\"color_15\"] .header-right .header-profile .dropdown-menu a.active {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .header-right .header-profile .profile_title {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .nav-header .nav-control .hamburger .line {\n  background-color: #ed0b4c !important;\n}\n\n[data-primary=\"color_15\"] .deznav .metismenu>li>a svg {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .deznav .metismenu>li:hover>a,\n[data-primary=\"color_15\"] .deznav .metismenu>li:focus>a {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .deznav .metismenu>li.mm-active>a {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .deznav .metismenu ul a:hover,\n[data-primary=\"color_15\"] .deznav .metismenu ul a:focus,\n[data-primary=\"color_15\"] .deznav .metismenu ul a.mm-active {\n  color: #ed0b4c;\n}\n\n@media (min-width: 767px) {\n\n  [data-primary=\"color_15\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:hover>a,\n  [data-primary=\"color_15\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:focus>a,\n  [data-primary=\"color_15\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a:active>a,\n  [data-primary=\"color_15\"] [data-sidebar-style=\"modern\"] .deznav .metismenu>li>a.mm-active>a {\n    background-color: #fff8fa;\n  }\n}\n\n[data-primary=\"color_15\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active .line {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .nav-user {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .sidebar-right .sidebar-right .sidebar-right-trigger {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .sidebar-right .sidebar-right .sidebar-right-trigger:hover {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"][data-theme-version=\"dark\"] .pagination .page-item .page-link:hover {\n  background: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"][data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  background: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"][data-theme-version=\"dark\"] .header-left input:focus {\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"][data-theme-version=\"dark\"] .loader__bar {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"][data-theme-version=\"dark\"] .loader__ball {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"][data-theme-version=\"transparent\"] .header-left input:focus {\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .new-arrival-content .price {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .chart-link a i.text-primary {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] #user-activity .nav-tabs .nav-link.active {\n  background: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] span#counter {\n  color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .welcome-content:after {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .timeline-badge {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .page-timeline .timeline-workplan[data-primary=\"color_15\"] .page-timeline .timeline .timeline-badge:after {\n  background-color: rgba(237, 11, 76, 0.4);\n}\n\n[data-primary=\"color_15\"] .sk-three-bounce .sk-child {\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .dropdown-item.active,\n[data-primary=\"color_15\"] .dropdown-item:active {\n  color: #fff;\n  background-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .overlay-box:after {\n  background: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .btn-primary {\n  background-color: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .bg-primary {\n  background-color: #ed0b4c !important;\n}\n\n[data-primary=\"color_15\"] .text-primary {\n  color: #ed0b4c !important;\n}\n\n[data-primary=\"color_15\"] .btn-primary:hover {\n  background-color: #a40835;\n  border-color: #a40835;\n}\n\n[data-primary=\"color_15\"] .btn-outline-primary {\n  color: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .btn-outline-primary:hover {\n  background-color: #ed0b4c;\n  border-color: #ed0b4c;\n}\n\n[data-primary=\"color_15\"] .btn-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_15\"] .btn-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_15\"] .show>.btn-primary.dropdown-toggle,\n[data-primary=\"color_15\"] .btn-outline-primary:not(:disabled):not(.disabled):active,\n[data-primary=\"color_15\"] .btn-outline-primary:not(:disabled):not(.disabled).active,\n[data-primary=\"color_15\"] .show>.btn-outline-primary.dropdown-toggle {\n  background-color: #a40835;\n  border-color: #a40835;\n}\n\n.bg-primary-alt {\n  background-color: rgba(135, 67, 223, 0.1);\n}\n\n.bg-secondary-alt {\n  background-color: rgba(63, 154, 224, 0.1);\n}\n\n.bg-success-alt {\n  background-color: rgba(43, 193, 85, 0.1);\n}\n\n.bg-info-alt {\n  background-color: rgba(45, 40, 255, 0.1);\n}\n\n.bg-warning-alt {\n  background-color: rgba(255, 155, 82, 0.1);\n}\n\n.bg-danger-alt {\n  background-color: rgba(249, 70, 135, 0.1);\n}\n\n.bg-light-alt {\n  background-color: rgba(244, 245, 249, 0.1);\n}\n\n.bg-dark-alt {\n  background-color: rgba(177, 177, 177, 0.1);\n}\n\n[data-typography=\"opensans\"] {\n  font-family: 'Open Sans', sans-serif;\n}\n\n[data-typography=\"poppins\"] {\n  font-family: 'poppins', sans-serif;\n}\n\n[data-typography=\"roboto\"] {\n  font-family: 'Roboto', sans-serif;\n}\n\n[data-typography=\"helvetica\"] {\n  font-family: 'HelveticaNeue';\n}\n\n/*$primary  : #7356f1 !default;*/\n[data-theme-version=\"transparent\"] {\n  /* background: url(\"../images/body/12.jpg\"); */\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] h1,\n[data-theme-version=\"transparent\"] h2,\n[data-theme-version=\"transparent\"] h3,\n[data-theme-version=\"transparent\"] h4,\n[data-theme-version=\"transparent\"] h5,\n[data-theme-version=\"transparent\"] h6 {\n  color: #fff !important;\n}\n\n[data-theme-version=\"transparent\"] a.link {\n  color: #ddd;\n}\n\n[data-theme-version=\"transparent\"] a.link:focus,\n[data-theme-version=\"transparent\"] a.link:hover {\n  color: #2D28FF;\n}\n\n[data-theme-version=\"transparent\"] a {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] a:hover {\n  color: #828690;\n}\n\n[data-theme-version=\"transparent\"] .border-right {\n  border-right: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"transparent\"] .border-left {\n  border-left: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"transparent\"] .border-top {\n  border-top: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"transparent\"] .border-bottom {\n  border-bottom: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"transparent\"] .border {\n  border: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"transparent\"] .dropdown-menu {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"transparent\"] .dropdown-item:hover,\n[data-theme-version=\"transparent\"] .dropdown-item:focus {\n  background-color: #181f39;\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .form-control {\n  background-color: #181f39;\n  border-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .card {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n[data-theme-version=\"transparent\"] .header {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n[data-theme-version=\"transparent\"] .header-left input {\n  border-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .header-left input:focus {\n  box-shadow: none;\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"transparent\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .header-right .dropdown .nav-link:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .header-right .notification_dropdown .dropdown-item a {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .nav-header,\n[data-theme-version=\"transparent\"] .nav-control {\n  background-color: rgba(0, 0, 0, 0.15) !important;\n}\n\n[data-theme-version=\"transparent\"] .nav-control {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .brand-logo {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .brand-logo:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .nav-header,\n[data-theme-version=\"transparent\"] .nav-control {\n  background-color: rgba(0, 0, 0, 0.15) !important;\n}\n\n[data-theme-version=\"transparent\"] .nav-control {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .brand-logo {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .brand-logo:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .deznav {\n  background-color: rgba(0, 0, 0, 0.15) !important;\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu>li>a {\n  color: rgba(0, 0, 0, 0.15);\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu>li:hover>a,\n[data-theme-version=\"transparent\"] .deznav .metismenu>li:focus>a,\n[data-theme-version=\"transparent\"] .deznav .metismenu>li.mm-active>a {\n  background-color: rgba(0, 0, 0, 0.15) !important;\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu>li:hover>a::after,\n[data-theme-version=\"transparent\"] .deznav .metismenu>li:focus>a::after,\n[data-theme-version=\"transparent\"] .deznav .metismenu>li.mm-active>a::after {\n  border-color: transparent transparent #fff transparent;\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu>li.mm-active ul ul {\n  background-color: transparent;\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu ul {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu ul a:hover,\n[data-theme-version=\"transparent\"] .deznav .metismenu ul a:focus,\n[data-theme-version=\"transparent\"] .deznav .metismenu ul a.mm-active {\n  color: #fff;\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu a {\n  color: rgba(0, 0, 0, 0.15);\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu ul {\n  background-color: rgba(0, 0, 0, 0.15) !important;\n}\n\n[data-theme-version=\"transparent\"] .deznav .metismenu .has-arrow:after {\n  border-color: transparent transparent rgba(0, 0, 0, 0.15) transparent;\n}\n\n/*$primary  : #7356f1 !default;*/\n[data-theme-version=\"dark\"] {\n  background: #181f39;\n  color: #828690;\n}\n\n[data-theme-version=\"dark\"] h1,\n[data-theme-version=\"dark\"] h2,\n[data-theme-version=\"dark\"] h3,\n[data-theme-version=\"dark\"] h4,\n[data-theme-version=\"dark\"] h5,\n[data-theme-version=\"dark\"] h6 {\n  color: #fff !important;\n}\n\n[data-theme-version=\"dark\"] a.link {\n  color: #ddd;\n}\n\n[data-theme-version=\"dark\"] a.link:focus,\n[data-theme-version=\"dark\"] a.link:hover {\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] a:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .border-right {\n  border-right: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border-left {\n  border-left: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border-top {\n  border-top: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border-bottom {\n  border-bottom: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border {\n  border: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .dropdown-menu {\n  background-color: #181f39;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item.selected,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item.selected.active,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item.active,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item:hover,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item:focus {\n  background-color: #1e2746;\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .form-control {\n  background-color: #181f39;\n  border-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .card {\n  background-color: #1e2746;\n  box-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .btn-outline-dark:hover {\n  background-color: #181f39;\n  border-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .tdl-holder input[type=text],\n[data-theme-version=\"dark\"] .tdl-holder li {\n  background-color: #1e2746;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .tdl-holder input[type=text]::placeholder {\n  color: #828690;\n}\n\n[data-theme-version=\"dark\"] .tdl-holder label:hover {\n  background-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .text-muted {\n  color: #828690 !important;\n}\n\n[data-theme-version=\"dark\"] .modal-content {\n  background: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .modal-footer,\n[data-theme-version=\"dark\"] .modal-header {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .close {\n  font-weight: 400;\n  color: #fff;\n  text-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .close:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .table strong {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .text-dark {\n  color: #828690 !important;\n}\n\n[data-theme-version=\"dark\"] .star-rating .product-review,\n[data-theme-version=\"dark\"] .new-arrival-content .item {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .custom-dropdown .dropdown-menu {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .widget-stat .media>span {\n  background: #333a54;\n  border-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .plus-minus-input .custom-btn {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .dropdown-divider,\n[data-theme-version=\"dark\"] .size-filter ul li {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .custom-select {\n  border-color: #333a54;\n  color: #828690;\n  background: #181f39;\n}\n\n[data-theme-version=\"dark\"] .nav-tabs {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .mail-list .list-group-item.active i {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] hr {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .grid-col {\n  background: #181f39;\n}\n\n[data-theme-version=\"dark\"] .noUi-target {\n  border-color: #333a54;\n  border-radius: 8px;\n  box-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .noUi-target .noUi-connects {\n  background: #333a54;\n}\n\n[data-theme-version=\"dark\"] .noUi-marker-large,\n[data-theme-version=\"dark\"] .noUi-marker {\n  background: #333a54;\n}\n\n[data-theme-version=\"dark\"] .input-group-text {\n  background: #333a54;\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .note-editor.note-frame {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .note-editor.note-frame .btn {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .note-editor.note-frame .note-editing-area .note-editable {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .widget-media .timeline .timeline-panel {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .notification_dropdown .dropdown-menu-right .all-notification {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] #user-activity .nav-tabs .nav-link {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .list-group-item-action {\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .list-group-item-action:focus,\n[data-theme-version=\"dark\"] .list-group-item-action:hover,\n[data-theme-version=\"dark\"] .list-group-item-action:focus {\n  background-color: #181f39;\n  border-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .list-group-item.active {\n  color: #fff;\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .list-group-item.active:focus,\n[data-theme-version=\"dark\"] .list-group-item.active:hover,\n[data-theme-version=\"dark\"] .list-group-item.active:focus {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .swal2-popup {\n  background: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .header {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .header-left input {\n  background: #181f39 !important;\n  border-color: transparent;\n  color: #fff !important;\n}\n\n[data-theme-version=\"dark\"] .header-left input:focus {\n  box-shadow: none;\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-left .search_icon {\n  background: #181f39 !important;\n}\n\n[data-theme-version=\"dark\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .right-sidebar a {\n  color: #00ADEE;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link {\n  background: #181f39;\n}\n\n[data-theme-version=\"dark\"] .header-right .dropdown .nav-link {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .dropdown .nav-link:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .notification_dropdown .dropdown-item a {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .nav-header,\n[data-theme-version=\"dark\"] .nav-control {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .nav-control {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .nav-header,\n[data-theme-version=\"dark\"] .nav-control {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .nav-control {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"][data-sidebar-style=\"mini\"] .deznav .metismenu li>ul {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .fixed-content-box {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .fixed-content-box .head-name {\n  background: #1e2746;\n  color: #fff;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .fixed-content-box+.header+.deznav {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .deznav {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li>a {\n  color: #b3b3b3;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a::after,\n[data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a::after,\n[data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a::after {\n  border-color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active ul ul {\n  background-color: transparent;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu ul:after {\n  background-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu ul a:hover,\n[data-theme-version=\"dark\"] .deznav .metismenu ul a:focus,\n[data-theme-version=\"dark\"] .deznav .metismenu ul a.mm-active {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu ul a:before {\n  background-color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu a {\n  color: #b3b3b3;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu .has-arrow:after {\n  border-color: #fff;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right {\n  background-color: #1d2544;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .nav-tabs {\n  background-color: #1d2544;\n  border-bottom: 1px solid #181f39;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .nav-tabs .nav-link.active {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .footer {\n  background-color: transparent;\n}\n\n[data-theme-version=\"dark\"] .footer .copyright {\n  background-color: transparent;\n}\n\n[data-theme-version=\"dark\"] .footer .copyright p {\n  color: #fff;\n}\n\n/* =============\n   Calendar\n============= */\n.app-fullcalender button {\n  border-radius: 0px;\n  color: #B1B1B1;\n}\n\n.app-fullcalender td {\n  border-color: #f0f1f5;\n}\n\n.calendar {\n  float: left;\n  margin-bottom: 0;\n}\n\n.fc-view {\n  margin-top: 1.875rem;\n}\n\n.fc-toolbar {\n  margin-bottom: 0.3125rem;\n  margin-top: 0.9375rem;\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar .fc-left {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.625rem;\n    float: none;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar .fc-right {\n    display: flex;\n    justify-content: center;\n    float: none;\n    margin-bottom: 0.3125rem;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar .fc-center {\n    display: flex;\n    justify-content: center;\n  }\n\n  .fc-toolbar .fc-center * {\n    float: none;\n  }\n}\n\n.fc-toolbar h2 {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.875rem;\n  text-transform: uppercase;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar .ui-state-hover,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover {\n  z-index: 0;\n  box-shadow: none;\n}\n\n.fc-widget-header {\n  border: 1px solid #f0f1f5;\n  border-bottom: 0 !important;\n}\n\n.fc th.fc-widget-header {\n  background: #f0f1f5 !important;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  padding: 0.625rem 0;\n  text-transform: uppercase;\n}\n\n.fc-button {\n  border: 1px solid #f0f1f5;\n  text-transform: capitalize;\n}\n\n.fc-button.active {\n  box-shadow: none !important;\n}\n\n.fc-text-arrow {\n  font-family: inherit;\n  font-size: 1rem;\n}\n\n.fc-event {\n  border-radius: 0.125rem;\n  border: none;\n  cursor: move;\n  font-size: 0.8125rem;\n  margin: 0.3125rem 0.4375rem;\n  padding: 0.3125rem;\n  text-align: center;\n}\n\n.external-event {\n  cursor: move;\n  margin: 0.625rem 0;\n  padding: 0.125rem 0;\n}\n\n.fc-basic-view td.fc-week-number span {\n  padding-right: 0.3125rem;\n}\n\n.fc-basic-view td.fc-day-number {\n  padding-right: 0.3125rem;\n}\n\n#drop-remove {\n  margin-right: 8px;\n  top: 0.1875rem;\n}\n\n#add-category .modal-dialog,\n#event-modal .modal-dialog {\n  max-width: 37.5rem;\n}\n\n.fc-content {\n  color: #fff;\n}\n\n.fc th.fc-widget-header {\n  background: transparent !important;\n}\n\n.fc-button {\n  background: #fff;\n}\n\n.fc-state-hover {\n  background: #fff !important;\n}\n\n.fc-state-highlight {\n  background: #f2f4fa !important;\n}\n\n[data-theme-version=\"dark\"] .fc-state-highlight {\n  color: #fff !important;\n}\n\n.fc-cell-overlay {\n  background: #fff !important;\n}\n\n.fc-unthemed .fc-today {\n  background: #f2f4fa !important;\n}\n\n.fc-day-top {\n  color: #B1B1B1 !important;\n}\n\n[data-theme-version=\"dark\"] .fc-day-top {\n  color: #fff !important;\n}\n\n.external-event {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .external-event {\n  color: #fff !important;\n}\n\n.fc-basic-view .fc-body .fc-row {\n  min-height: 1rem;\n}\n\n.fc-scroller.fc-day-grid-container {\n  height: 490px !important;\n}\n\n.fc-row.fc-week.fc-widget-content.fc-rigid {\n  height: 81px !important;\n}\n\n@media only screen and (max-width: 1440px) {\n  .email_left_pane {\n    display: none;\n  }\n}\n\n#external-events .external-event:before {\n  content: \"\";\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  margin-right: .9rem;\n  position: relative;\n  top: 2px;\n}\n\n#external-events [data-class=\"bg-primary\"] {\n  background-color: transparent !important;\n  color: #B1B1B1;\n}\n\n[data-theme-version=\"dark\"] #external-events [data-class=\"bg-primary\"] {\n  color: #fff !important;\n}\n\n#external-events [data-class=\"bg-primary\"]::before {\n  background: #00ADEE;\n}\n\n#external-events [data-class=\"bg-success\"] {\n  background-color: transparent !important;\n  color: #B1B1B1;\n}\n\n#external-events [data-class=\"bg-success\"]::before {\n  background: #2BC155;\n}\n\n#external-events [data-class=\"bg-warning\"] {\n  background-color: transparent !important;\n  color: #B1B1B1;\n}\n\n#external-events [data-class=\"bg-warning\"]::before {\n  background: #FF9B52;\n}\n\n#external-events [data-class=\"bg-dark\"] {\n  background-color: transparent !important;\n  color: #B1B1B1;\n}\n\n#external-events [data-class=\"bg-dark\"]::before {\n  background: #B1B1B1;\n}\n\n#external-events [data-class=\"bg-danger\"] {\n  background-color: transparent !important;\n  color: #B1B1B1;\n}\n\n#external-events [data-class=\"bg-danger\"]::before {\n  background: #F94687;\n}\n\n#external-events [data-class=\"bg-info\"] {\n  background-color: transparent !important;\n  color: #B1B1B1;\n}\n\n#external-events [data-class=\"bg-info\"]::before {\n  background: #2D28FF;\n}\n\n#external-events [data-class=\"bg-pink\"] {\n  background-color: transparent !important;\n  color: #B1B1B1;\n}\n\n#external-events [data-class=\"bg-pink\"]::before {\n  background: #e83e8c;\n}\n\n.fc .fc-row .fc-content-skeleton table,\n.fc .fc-row .fc-content-skeleton td,\n.fc .fc-row .fc-helper-skeleton td {\n  border-color: #f0f1f5;\n}\n\n[data-theme-version=\"dark\"] .fc .fc-row .fc-content-skeleton table,\n[data-theme-version=\"dark\"] .fc .fc-row .fc-content-skeleton td,\n[data-theme-version=\"dark\"] .fc .fc-row .fc-helper-skeleton td {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .fc-unthemed .fc-content,\n[data-theme-version=\"dark\"] .fc-unthemed .fc-divider,\n[data-theme-version=\"dark\"] .fc-unthemed .fc-list-heading td,\n[data-theme-version=\"dark\"] .fc-unthemed .fc-list-view,\n[data-theme-version=\"dark\"] .fc-unthemed .fc-popover,\n[data-theme-version=\"dark\"] .fc-unthemed .fc-row,\n[data-theme-version=\"dark\"] .fc-unthemed tbody,\n[data-theme-version=\"dark\"] .fc-unthemed td,\n[data-theme-version=\"dark\"] .fc-unthemed th,\n[data-theme-version=\"dark\"] .fc-unthemed thead {\n  border-color: #333a54;\n}\n\n.email-left-box {\n  width: 15rem;\n  float: left;\n  padding: 0 1.25rem 1.25rem 1rem;\n  border-top: 0;\n  border-left: 0;\n}\n\n@media (min-width: 576px) and (max-width: 991.98px) {\n  .email-left-box {\n    width: 100%;\n    padding-bottom: 0px !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .email-left-box {\n    width: 100%;\n    float: none;\n    border: none;\n    padding-bottom: 30px !important;\n  }\n}\n\n.email-left-box .intro-title {\n  background: rgba(135, 67, 223, 0.1);\n  padding: 1rem;\n  margin: 1.875rem 0 1.25rem 0;\n}\n\n.email-left-box .intro-title h5 {\n  margin-bottom: 0;\n  color: #6a707e;\n  font-size: 14px;\n}\n\n.email-left-box .intro-title h5 i {\n  font-size: 0.75rem;\n  position: relative;\n  bottom: 1px;\n}\n\n.email-left-box .intro-title i {\n  color: #00ADEE;\n}\n\n.email-right-box {\n  padding-left: 15rem;\n  padding-right: 1rem;\n}\n\n@media (min-width: 576px) and (max-width: 991.98px) {\n  .email-right-box {\n    padding-left: 0;\n    margin-left: 0 !important;\n    clear: both;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .email-right-box {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.email-right-box .right-box-border {\n  border-right: 2px solid rgba(135, 67, 223, 0.1);\n}\n\n@media screen and (min-width: 649px) and (max-width: 1200px) {\n  .email-right-box .right-box-padding {\n    padding-left: 1.25rem;\n  }\n}\n\n@media (min-width: 1700px) {\n  .email-right-box .right-box-padding {\n    padding-left: 0.9375rem;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 991.98px) {\n  .email-right-box .right-box-padding {\n    padding-left: 0;\n  }\n}\n\n.toolbar .btn-group .btn {\n  border: 0;\n}\n\n.toolbar .btn-group input {\n  position: relative;\n  top: 2px;\n}\n\n.read-content textarea {\n  height: 150px;\n  padding: 15px 20px;\n}\n\n.read-content-email {\n  font-size: 0.875rem;\n}\n\n.read-content h5 {\n  color: #6a707e;\n}\n\n.read-content p strong {\n  color: #6a707e;\n}\n\n.read-content-body p {\n  margin-bottom: 1.875rem;\n}\n\n.read-content-attachment {\n  padding: 0.5rem 0;\n}\n\n.read-content-attachment h6 {\n  font-size: 1.125rem;\n  color: #6a707e;\n}\n\n.read-content-attachment h6 i {\n  padding-right: 0.3125rem;\n}\n\n.read-content-attachment .attachment>div:not(:last-child) {\n  border-right: 1px solid #DDDFE1;\n}\n\n.compose-content .wysihtml5-toolbar {\n  border-color: #eaeaea;\n}\n\n.compose-content .dropzone {\n  background: #f2f4fa !important;\n}\n\n.compose-content h5 {\n  font-size: 1.0625rem;\n  color: #6a707e;\n}\n\n.compose-content h5 i {\n  font-size: 1.125rem;\n  transform: rotate(90deg);\n}\n\n.compose-content .dropzone {\n  border: 1px dashed #DDDFE1;\n  min-height: 13.125rem;\n  position: relative;\n}\n\n.compose-content .dropzone .dz-message {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.email-list {\n  display: block;\n  padding-left: 0;\n}\n\n.email-list .message {\n  position: relative;\n  display: block;\n  height: 3.125rem;\n  line-height: 3.125rem;\n  cursor: default;\n  transition-duration: 0.3s;\n}\n\n.email-list .message a {\n  color: #828690;\n}\n\n.email-list .message-single .custom-checkbox {\n  margin-top: 2px;\n}\n\n.email-list .message-single i {\n  color: #89879f;\n  font-size: 1.125rem;\n  padding-left: .4rem;\n}\n\n.email-list .message:hover {\n  transition-duration: 0.05s;\n  background: rgba(152, 166, 173, 0.15);\n}\n\n.email-list .message .col-mail {\n  float: left;\n  position: relative;\n}\n\n.email-list .message .col-mail-1 {\n  width: 5.625rem;\n}\n\n.email-list .message .col-mail-1 .star-toggle {\n  display: block;\n  float: left;\n  margin-top: 1.125rem;\n  font-size: 1rem;\n  margin-left: 0.3125rem;\n}\n\n.email-list .message .col-mail-1 .email-checkbox {\n  display: block;\n  float: left;\n  margin: 0.9375rem 0.625rem 0 1.25rem;\n}\n\n.email-list .message .col-mail-1 .dot {\n  display: block;\n  float: left;\n  border: .4rem solid transparent;\n  border-radius: 6.25rem;\n  margin: 1.375rem 1.625rem 0;\n  height: 0;\n  width: 0;\n  line-height: 0;\n  font-size: 0;\n}\n\n.email-list .message .col-mail-2 {\n  position: absolute;\n  top: 0;\n  left: 5.625rem;\n  right: 0;\n  bottom: 0;\n}\n\n.email-list .message .col-mail-2 .subject {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 5.5rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.email-list .message .col-mail-2 .date {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.email-checkbox {\n  cursor: pointer;\n  height: 0.9375rem;\n  width: 0.9375rem;\n  position: relative;\n  display: inline-block;\n  border-radius: .1rem;\n  position: relative;\n  top: 0.3125rem;\n  box-shadow: inset 0 0 0 0.1rem #828690;\n}\n\n.email-checkbox input {\n  opacity: 0;\n  cursor: pointer;\n}\n\n.email-checkbox input:checked label {\n  opacity: 1;\n}\n\n.email-checkbox label {\n  position: absolute;\n  top: .3rem;\n  left: .3rem;\n  right: .3rem;\n  bottom: .3rem;\n  cursor: pointer;\n  opacity: 0;\n  margin-bottom: 0 !important;\n  transition-duration: 0.05s;\n}\n\n.mail-list a {\n  vertical-align: middle;\n  padding: 0.625rem 0.9375rem;\n  display: block;\n  background: transparent;\n  color: #464a53;\n  font-weight: 600;\n}\n\n.mail-list .list-group-item {\n  color: #6a707e;\n  padding: 0.75rem 1.0625rem;\n}\n\n.mail-list .list-group-item i {\n  font-size: 1rem;\n  padding-right: 0.625rem;\n  color: #cccccc;\n}\n\n.mail-list .list-group-item.active {\n  color: #fff;\n}\n\n.mail-list .list-group-item.active i {\n  color: #fff;\n}\n\n.chat-wrap {\n  padding: 1.0625rem 1.875rem;\n}\n\n.chat-wrap .media .media-body h6 {\n  font-size: 1.0625rem;\n  color: #6a707e;\n}\n\n.chat-wrap .media .media-body p {\n  font-size: 0.875rem;\n}\n\n@media (min-width: 648px) {\n  .email-filter {\n    padding-left: 1.25rem;\n  }\n}\n\n@media (min-width: 1700px) {\n  .email-filter {\n    padding-left: 1.875rem;\n  }\n}\n\n.email-filter .input-group-prepend i {\n  font-size: 0.875rem;\n  color: #89879f;\n}\n\n.email-filter .input-group-prepend .input-group-text {\n  border: 0;\n  border-bottom: 1px solid #DDDFE1 !important;\n  background: transparent;\n}\n\n.email-filter .input-group .form-control {\n  padding: 0 0 0 0.3125rem;\n  border: 0;\n  font-size: 0.875rem;\n  height: 1.875rem;\n  color: #89879f;\n  border-bottom: 1px solid #DDDFE1;\n}\n\n.email-filter .input-group .form-control::placeholder {\n  font-size: 0.875rem;\n  color: #89879f;\n}\n\n.email-filter .input-group>.form-control {\n  min-height: 1.875rem;\n}\n\n.single-mail {\n  display: block;\n  padding: 1.5625rem 0;\n}\n\n.single-mail .media {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n@media (min-width: 1700px) {\n  .single-mail .media {\n    padding-left: 1.875rem;\n    padding-right: 1.875rem;\n  }\n}\n\n.single-mail .media img {\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n  margin-right: 0.9375rem;\n}\n\n@media (min-width: 1700px) {\n  .single-mail .media img {\n    margin-right: 1.875rem;\n  }\n}\n\n.single-mail .media-body h6 {\n  color: #abafb3;\n}\n\n.single-mail .media-body h4 {\n  font-size: 1rem;\n  color: #6a707e;\n}\n\n.single-mail .media-body h4 button i {\n  font-size: 1.125rem;\n  color: #abafb3;\n  font-weight: bold;\n  transform: rotate(90deg);\n}\n\n.single-mail .media-body p {\n  font-size: 0.875rem;\n  color: #abafb3;\n}\n\n.single-mail.active {\n  background: #00ADEE;\n}\n\n.single-mail.active h6,\n.single-mail.active h4,\n.single-mail.active p,\n.single-mail.active i {\n  color: #fff !important;\n}\n\n[direction=\"rtl\"] .email-right-box {\n  padding-left: 1rem;\n  padding-right: 15rem;\n}\n\n@media only screen and (max-width: 991px) {\n  [direction=\"rtl\"] .email-right-box {\n    padding-left: 1rem;\n    padding-right: 12rem;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .email-right-box {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n[direction=\"rtl\"] .email-left-box {\n  float: right;\n}\n\n[direction=\"rtl\"] .email-list .message .col-mail-2 {\n  right: 5.625rem;\n  left: 0;\n  float: right;\n}\n\n[direction=\"rtl\"] .email-list .message .col-mail-2 .date {\n  right: auto;\n  left: 0;\n}\n\n[direction=\"rtl\"] .email-list .message .col-mail-2 .subject {\n  right: 0;\n  left: 5.5rem;\n}\n\n.photo-content {\n  position: relative;\n}\n\n.photo-content .cover-photo {\n  background: url(../images/profile/cover.jpg);\n  background-size: cover;\n  background-position: center;\n  min-height: 250px;\n  width: 100%;\n}\n\n.profile .profile-photo {\n  max-width: 100px;\n  position: relative;\n  z-index: 1;\n  margin-top: -40px;\n  margin-right: 10px;\n}\n\n@media only screen and (max-width: 575px) {\n  .profile .profile-photo {\n    width: 80px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 20px;\n  }\n}\n\n[direction=\"rtl\"] .profile .photo-content .profile-photo {\n  left: auto;\n  right: 50px;\n}\n\n[direction=\"rtl\"] .profile .profile-photo {\n  left: auto;\n  right: 30px;\n}\n\n@media only screen and (max-width: 1199px) {\n  [direction=\"rtl\"] .profile .profile-photo {\n    right: 15px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .profile .profile-photo {\n    width: 80px;\n    right: calc(50% - 40px);\n    top: -100px;\n  }\n}\n\n.profile-info {\n  padding: 15px 20px;\n}\n\n@media only screen and (max-width: 575px) {\n  .profile-info {\n    padding: 0 0 20px;\n    text-align: center;\n  }\n}\n\n.profile-info h4 {\n  color: #464a53 !important;\n}\n\n.profile-info h4.text-primary {\n  color: #00ADEE !important;\n}\n\n.profile-info p {\n  color: #828690;\n}\n\n.profile-info .prf-col {\n  min-width: 250px;\n  padding: 10px 50px 0;\n}\n\n.profile-interest .row {\n  margin: 0 -.70px;\n}\n\n.profile-interest .row .int-col {\n  padding: 0 .70px;\n}\n\n.profile-interest .row .int-col .interest-cat {\n  margin-bottom: 1.40px;\n  position: relative;\n  display: block;\n}\n\n.profile-interest .row .int-col .interest-cat:after {\n  background: #000;\n  bottom: 0;\n  content: \"\";\n  left: 0;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 0;\n}\n\n.profile-interest .row .int-col .interest-cat p {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  padding: 5px;\n  left: 0;\n  margin: 0;\n  z-index: 1;\n  color: white;\n  font-size: 1.20px;\n}\n\n.profile-tab .nav-item .nav-link {\n  font-size: 16px;\n  margin-right: 30px;\n  transition: all 0.5s ease-in-out;\n  border: none;\n  border-bottom: .20px solid transparent;\n  color: #828690;\n}\n\n.profile-tab .nav-item .nav-link:hover,\n.profile-tab .nav-item .nav-link.active {\n  border: 0;\n  background: transparent;\n  background: transparent;\n  border-bottom: 0.2px solid #00ADEE;\n  color: #00ADEE;\n}\n\n@media only screen and (max-width: 575px) {\n  .profile-tab .nav-item .nav-link {\n    margin-right: 0px;\n  }\n}\n\n.profile-info {\n  display: flex;\n}\n\n@media only screen and (max-width: 575px) {\n  .profile-info {\n    display: block;\n  }\n}\n\n.profile-info .profile-details {\n  display: flex;\n  width: 100%;\n}\n\n@media only screen and (max-width: 575px) {\n  .profile-info .profile-details {\n    display: block;\n  }\n\n  .profile-info .profile-details .dropdown {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n  }\n}\n\n.post-input {\n  margin-bottom: 30px;\n}\n\n.post-input .form-control {\n  height: 75px;\n  font-weight: 400;\n  margin: 15px 0;\n}\n\n.profile-uoloaded-post .post-title h3 {\n  font-size: 24px;\n}\n\n@media only screen and (max-width: 575px) {\n  .profile-uoloaded-post .post-title h3 {\n    font-size: 18px;\n  }\n}\n\n.profile-uoloaded-post img {\n  margin-bottom: 20px;\n}\n\n.profile-uoloaded-post a h4 {\n  margin-bottom: 10px;\n  color: #464a53;\n}\n\n.event-chat-ryt .chat-area .chat-reciver,\n.event-chat-ryt .chat-area .chat-sender {\n  margin-bottom: 1.875rem;\n  padding: 0;\n}\n\n.event-chat-ryt .chat-area .chat-reciver img,\n.event-chat-ryt .chat-area .chat-sender img {\n  border-radius: 30px;\n}\n\n.event-chat-ryt .chat-area .media {\n  position: relative;\n}\n\n.event-chat-ryt .chat-area .media-body p {\n  margin: 0;\n  max-width: 100%;\n  display: inline-block;\n  position: relative;\n}\n\n.event-chat-ryt .chat-area .media-body p span {\n  padding: 1rem;\n  display: inline-block;\n  top: 103%;\n  position: relative;\n  border: 1px solid #f0f1f5;\n}\n\n.event-chat-ryt .chat-reciver {\n  padding: .5rem 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.event-chat-ryt .chat-reciver .media {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.event-chat-ryt .chat-reciver .media .media-body {\n  margin-right: 2rem;\n  text-align: right;\n}\n\n[direction=\"rtl\"] .event-chat-ryt .chat-reciver .media .media-body {\n  text-align: left;\n  margin-left: 2rem;\n  margin-right: auto;\n}\n\n.event-chat-ryt .chat-reciver .media .media-body p {\n  background: #fff;\n  margin-bottom: 0;\n  border-radius: 5px 5px 0 5px;\n}\n\n.event-chat-ryt .chat-reciver .media .media-body p span {\n  text-align: left;\n  border: 1px solid #f0f1f5;\n}\n\n.event-chat-ryt .chat-reciver .media .media-body p span::after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  border-bottom: 1px solid #f0f1f5;\n  border-right: 1px solid #f0f1f5;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  -webkit-transform: rotate(-45deg) translateX(15px);\n  transform: rotate(-45deg) translateX(15px);\n}\n\n[direction=\"rtl\"] .event-chat-ryt .chat-reciver .media .media-body p span::after {\n  left: 0;\n  right: auto;\n  -webkit-transform: rotate(135deg) translateY(15px);\n  transform: rotate(135deg) translateY(15px);\n}\n\n.event-chat-ryt .chat-reciver .media .media-body p .time {\n  position: absolute;\n  font-size: 12px;\n  color: #7e7e7e;\n  font-weight: 400;\n  bottom: 0;\n  left: -80px;\n}\n\n[direction=\"rtl\"] .event-chat-ryt .chat-reciver .media .media-body p .time {\n  right: -5rem;\n  left: auto;\n}\n\n.event-chat-ryt .chat-sender {\n  text-align: left;\n  padding: .5rem 1rem;\n}\n\n.event-chat-ryt .chat-sender .media .media-body {\n  margin-left: 2rem;\n}\n\n[direction=\"rtl\"] .event-chat-ryt .chat-sender .media .media-body {\n  text-align: right;\n  margin-right: 2rem;\n  margin-left: auto;\n}\n\n.event-chat-ryt .chat-sender .media .media-body p {\n  background-color: #fff;\n  margin-bottom: 0;\n}\n\n.event-chat-ryt .chat-sender .media .media-body p span::after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  border-bottom: 1px solid #f0f1f5;\n  border-left: 1px solid #f0f1f5;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  background: #fff;\n  -webkit-transform: rotate(45deg) translateX(-15px);\n  transform: rotate(45deg) translateX(-15px);\n}\n\n[direction=\"rtl\"] .event-chat-ryt .chat-sender .media .media-body p span::after {\n  left: auto;\n  right: 0;\n  -webkit-transform: rotate(-135deg) translateY(15px);\n  transform: rotate(-135deg) translateY(15px);\n}\n\n.event-chat-ryt .chat-sender .media .media-body p .time {\n  position: absolute;\n  font-size: 10px;\n  color: #7e7e7e;\n  font-weight: 400;\n  bottom: 0;\n  right: -5rem;\n}\n\n[direction=\"rtl\"] .event-chat-ryt .chat-sender .media .media-body p .time {\n  left: -5rem;\n  right: auto;\n}\n\n.char-type {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n.char-type form .form-control {\n  height: 45px;\n  padding-left: 18px;\n  background: #E5E6E7;\n  border-right: 0;\n}\n\n.char-type form .input-group-append i {\n  color: #898989;\n  font-size: 18px;\n}\n\n.char-type form .input-group-append .input-group-text {\n  padding-left: .7rem;\n  padding-right: .7rem;\n  background: #E5E6E7;\n  border-color: #f0f1f5;\n  border-left: 0;\n}\n\n.char-type form .input-group-append .input-group-text:last-child {\n  padding-right: 1.8rem;\n}\n\n.media-avatar {\n  padding: 25px 0;\n  border-bottom: 1px solid #f0f1f5;\n}\n\n.media-avatar:last-child {\n  border-bottom: 0px;\n}\n\n.media-avatar p {\n  margin-bottom: 0;\n}\n\n.media-avatar .avatar-status {\n  position: relative;\n}\n\n.media-avatar .avatar-status i {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n.ct-golden-section:before {\n  float: none;\n}\n\n.ct-chart {\n  max-height: 15.7rem;\n}\n\n.ct-chart .ct-label {\n  fill: #a3afb7;\n  color: #a3afb7;\n  font-size: 0.75rem;\n  line-height: 1;\n}\n\n.ct-grid {\n  stroke: rgba(49, 58, 70, 0.1);\n}\n\n.ct-chart.simple-pie-chart-chartist .ct-label {\n  color: #ffffff;\n  fill: #ffffff;\n  font-size: 0.625rem;\n}\n\n.ct-chart .ct-series.ct-series-a .ct-bar,\n.ct-chart .ct-series.ct-series-a .ct-line,\n.ct-chart .ct-series.ct-series-a .ct-point,\n.ct-chart .ct-series.ct-series-a .ct-slice-donut {\n  stroke: #00ADEE;\n}\n\n.ct-chart .ct-series.ct-series-b .ct-bar,\n.ct-chart .ct-series.ct-series-b .ct-line,\n.ct-chart .ct-series.ct-series-b .ct-point,\n.ct-chart .ct-series.ct-series-b .ct-slice-donut {\n  stroke: #2BC155;\n}\n\n.ct-chart .ct-series.ct-series-c .ct-bar,\n.ct-chart .ct-series.ct-series-c .ct-line,\n.ct-chart .ct-series.ct-series-c .ct-point,\n.ct-chart .ct-series.ct-series-c .ct-slice-donut {\n  stroke: #FF9B52;\n}\n\n.ct-chart .ct-series.ct-series-d .ct-bar,\n.ct-chart .ct-series.ct-series-d .ct-line,\n.ct-chart .ct-series.ct-series-d .ct-point,\n.ct-chart .ct-series.ct-series-d .ct-slice-donut {\n  stroke: #F94687;\n}\n\n.ct-chart .ct-series.ct-series-e .ct-bar,\n.ct-chart .ct-series.ct-series-e .ct-line,\n.ct-chart .ct-series.ct-series-e .ct-point,\n.ct-chart .ct-series.ct-series-e .ct-slice-donut {\n  stroke: #2D28FF;\n}\n\n.ct-chart .ct-series.ct-series-f .ct-bar,\n.ct-chart .ct-series.ct-series-f .ct-line,\n.ct-chart .ct-series.ct-series-f .ct-point,\n.ct-chart .ct-series.ct-series-f .ct-slice-donut {\n  stroke: #B1B1B1;\n}\n\n.ct-chart .ct-series.ct-series-g .ct-bar,\n.ct-chart .ct-series.ct-series-g .ct-line,\n.ct-chart .ct-series.ct-series-g .ct-point,\n.ct-chart .ct-series.ct-series-g .ct-slice-donut {\n  stroke: #8d6e63;\n}\n\n.ct-series-a .ct-area,\n.ct-series-a .ct-slice-pie {\n  fill: #3F9AE0;\n}\n\n.ct-series-b .ct-area,\n.ct-series-b .ct-slice-pie {\n  fill: #00A2FF;\n}\n\n.ct-series-c .ct-area,\n.ct-series-c .ct-slice-pie {\n  fill: #ff9800;\n}\n\n.ct-series-d .ct-area,\n.ct-series-d .ct-slice-pie {\n  fill: #ff9800;\n}\n\n.chartist-tooltip {\n  position: absolute;\n  display: inline-block;\n  opacity: 0;\n  min-width: 0.625rem;\n  padding: 2px 0.625rem;\n  border-radius: 3px;\n  background: #313a46;\n  color: #ffffff;\n  text-align: center;\n  pointer-events: none;\n  z-index: 1;\n  -webkit-transition: opacity .2s linear;\n  -moz-transition: opacity .2s linear;\n  -o-transition: opacity .2s linear;\n  transition: opacity .2s linear;\n}\n\n.chartist-tooltip.tooltip-show {\n  opacity: 1;\n}\n\n#donught_graph .ct-series.ct-series-a .ct-slice-donut {\n  stroke: #3FC6D4;\n}\n\n#donught_graph .ct-series.ct-series-b .ct-slice-donut {\n  stroke: #333333;\n}\n\n#donught_graph .ct-series.ct-series-c .ct-slice-donut {\n  stroke: #F63465;\n}\n\n@media only screen and (max-width: 767px) {\n  #pie-chart .ct-label {\n    color: #fff;\n    fill: #fff;\n  }\n}\n\n#visitor_graph {\n  height: 253px !important;\n}\n\n#user_rating_graph {\n  height: 280px !important;\n}\n\n#visitorOnline {\n  height: 72px !important;\n}\n\n#trendMeter {\n  height: 72px !important;\n}\n\n#widget-revenue1,\n#widget-revenue2,\n#widget-revenue3 {\n  height: 117px !important;\n}\n\n#widget-profit1,\n#widget-profit2,\n#widget-profit3 {\n  height: 160px !important;\n}\n\n#comparison-rate {\n  height: 230px !important;\n}\n\n#session_day {\n  height: 175px !important;\n  width: auto !important;\n  margin: 0 auto;\n}\n\n#walet-status {\n  height: 140px !important;\n}\n\n#bar1 {\n  height: 150px !important;\n}\n\n#sold-product {\n  height: 230px !important;\n}\n\n#chart-venue-expenses,\n#chart-online-sale,\n#chart-gross-sale {\n  height: 150px !important;\n}\n\n#areaChart_3 {\n  height: 295px !important;\n}\n\n.chart-point {\n  display: flex;\n  align-items: center;\n}\n\n.chart-point .check-point-area {\n  width: 100px;\n  height: 100px;\n  margin-top: -10px;\n  margin-left: -10px;\n}\n\n.chart-point .chart-point-list {\n  margin: 0;\n  padding-left: 5px;\n}\n\n.chart-point .chart-point-list li {\n  list-style: none;\n  font-size: 13px;\n  padding: 2px 0;\n}\n\n.chart-point .chart-point-list li i {\n  margin-right: 5px;\n  font-size: 11px;\n  position: relative;\n  top: -1px;\n}\n\n.c3 {\n  height: 250px;\n}\n\n.c3-legend-item {\n  fill: #9fabb1;\n}\n\n.c3 .c3-axis-x path,\n.c3 .c3-axis-x line,\n.c3 .c3-axis-y path,\n.c3 .c3-axis-y line,\n.tick text {\n  stroke: #fff;\n}\n\n.flot-chart {\n  height: 15.7rem;\n}\n\n.tooltipflot {\n  background-color: transparent;\n  font-size: 1.4rem;\n  padding: .5rem 1rem;\n  color: rgba(255, 255, 255, 0.7);\n  border-radius: .2rem;\n}\n\n.legendColorBox>div {\n  border: 0 !important;\n  padding: 0 !important;\n}\n\n.legendLabel {\n  font-size: 0.825rem;\n  padding-left: .5rem;\n  color: #fff;\n}\n\n.flotTip {\n  background: #000;\n  border: 1px solid #000;\n  color: #fff;\n}\n\n.legend>div {\n  background: transparent !important;\n}\n\n#balance_graph {\n  height: 260px;\n}\n\n.morris-hover {\n  position: absolute;\n  z-index: 1;\n  background: #00ADEE;\n  color: #fff;\n}\n\n.morris-hover .morris-hover-point {\n  color: #fff !important;\n  margin: 3px 0;\n  text-align: center;\n  padding: 0 25px;\n}\n\n.morris-hover .morris-hover-row-label {\n  background-color: #B1B1B1;\n  text-align: center;\n  padding: 5px;\n  margin-bottom: 5px;\n}\n\n.morris-hover.morris-default-style {\n  border-radius: 5px;\n  padding: 0;\n  margin: 0;\n  border: none;\n  overflow: hidden;\n}\n\nsvg text {\n  font-weight: 600 !important;\n}\n\n#morris_donught,\n#morris_donught_2,\n#line_chart_2,\n#morris_bar,\n#morris_bar_stalked,\n#morris_bar_2,\n#morris_area_2,\n#morris_area {\n  height: 240px !important;\n}\n\n#morris_line {\n  height: 278px !important;\n}\n\n#crypto-btc-card,\n#crypto-eth-card,\n#crypto-rpl-card,\n#crypto-ltc-card {\n  height: 9.375rem;\n}\n\n#daily-sales,\n#comparison-rate,\n#usage-chart,\n#walet-status {\n  width: 100%;\n  display: block;\n}\n\n#daily-sales canvas,\n#comparison-rate canvas,\n#usage-chart canvas,\n#walet-status canvas {\n  max-width: 100% !important;\n  width: 100% !important;\n}\n\n#sparkline-composite-chart canvas,\n#composite-bar canvas,\n#sparkline11 canvas,\n#StackedBarChart canvas,\n#spark-bar canvas,\n#tristate canvas {\n  height: 100px !important;\n}\n\n#sparkline11 canvas {\n  width: 100px !important;\n}\n\n.easy-pie-chart {\n  position: relative;\n  text-align: center;\n}\n\n.easy-pie-chart .inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: inline-block;\n}\n\n.easy-pie-chart img {\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n}\n\n.easy-pie-chart canvas {\n  display: block;\n  margin: 0 auto;\n}\n\n#revenue-chart {\n  height: 27.7rem;\n}\n\n#duration-value-axis {\n  height: 27.6rem;\n  width: 100%;\n}\n\n#combined-bullet {\n  height: 28.125rem;\n  width: 100%;\n}\n\n#zoomable-chart {\n  height: 28.125rem;\n  width: 100%;\n}\n\n#chartMap {\n  height: 28.125rem;\n  width: 100%;\n}\n\n#professional-candlesticks {\n  width: 100%;\n  height: 28.125rem;\n}\n\n#comparing-stock-indices {\n  width: 100%;\n  height: 28.125rem;\n}\n\n#multiple-panel-data {\n  width: 100%;\n  height: 28.125rem;\n}\n\n#depth-chart {\n  width: 100%;\n  height: 28.125rem;\n}\n\n.amcharts-export-menu {\n  display: none;\n}\n\n.amcharts-data-set-selector-div {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  width: 16.875rem;\n  margin: 0 auto;\n}\n\n.amcharts-data-set-selector-div select {\n  border: 0;\n  margin-left: 0.625rem;\n  background: #ddd;\n  color: #000;\n}\n\n.amChartsInputField {\n  border: 0;\n  background: #00ADEE;\n  color: #fff;\n  padding: 0.3125rem 0.9375rem;\n  margin: 0 0.9375rem;\n}\n\n.amcharts-data-set-select {\n  border: 0;\n  background: #ddd;\n  color: #000;\n}\n\n.amcharts-period-input,\n.amcharts-period-input-selected {\n  border: 0;\n  margin-left: 0.625rem;\n  background: #00ADEE;\n  color: #fff;\n  padding: 0.3125rem 0.9375rem;\n}\n\n.amcharts-graph-g2 .amcharts-graph-stroke {\n  stroke-dasharray: 3px 3px;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  -webkit-animation: am-moving-dashes 1s linear infinite;\n  animation: am-moving-dashes 1s linear infinite;\n}\n\n@-webkit-keyframes am-moving-dashes {\n  100% {\n    stroke-dashoffset: -1.9375rem;\n  }\n}\n\n@keyframes am-moving-dashes {\n  100% {\n    stroke-dashoffset: -1.9375rem;\n  }\n}\n\n.lastBullet {\n  -webkit-animation: am-pulsating 1s ease-out infinite;\n  animation: am-pulsating 1s ease-out infinite;\n}\n\n@-webkit-keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0px;\n  }\n\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 3.125rem;\n  }\n}\n\n@keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0px;\n  }\n\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 3.125rem;\n  }\n}\n\n.amcharts-graph-column-front {\n  -webkit-transition: all .3s .3s ease-out;\n  transition: all .3s .3s ease-out;\n}\n\n.amcharts-graph-column-front:hover {\n  fill: #496375;\n  stroke: #496375;\n  -webkit-transition: all .3s ease-out;\n  transition: all .3s ease-out;\n}\n\n@-webkit-keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n\n  100% {\n    stroke-dashoffset: 0%;\n  }\n}\n\n@keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n\n  100% {\n    stroke-dashoffset: 0%;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .amChartsPeriodSelector>fieldset>div {\n    float: none !important;\n    display: block !important;\n    margin-bottom: 0.625rem;\n  }\n}\n\n.highcharts-root text {\n  font-weight: 300 !important;\n}\n\n.highcharts-credits {\n  display: none;\n}\n\n#chart_employee_gender,\n#chart_employee_status {\n  width: auto;\n  height: 350px;\n}\n\n.form-control {\n  border-radius: 1.25rem;\n  background: #fff;\n  border: 1px solid #f0f1f5;\n  color: #B1B1B1;\n  height: 56px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .form-control {\n    height: 41px;\n  }\n}\n\n.form-control:hover,\n.form-control:focus,\n.form-control.active {\n  box-shadow: none;\n  background: #fff;\n  color: #B1B1B1;\n}\n\n.input-rounded {\n  border-radius: 100px;\n}\n\n[data-theme-version=\"light\"] .input-primary .form-control,\n[data-theme-version=\"dark\"] .input-primary .form-control {\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"light\"] .input-primary .input-group-text,\n[data-theme-version=\"dark\"] .input-primary .input-group-text {\n  background-color: #00ADEE;\n  color: #fff;\n}\n\n[data-theme-version=\"light\"] .input-danger .form-control,\n[data-theme-version=\"dark\"] .input-danger .form-control {\n  border-color: #F94687;\n}\n\n[data-theme-version=\"light\"] .input-danger .input-group-text,\n[data-theme-version=\"dark\"] .input-danger .input-group-text {\n  background-color: #F94687;\n  color: #fff;\n}\n\n[data-theme-version=\"light\"] .input-info .form-control,\n[data-theme-version=\"dark\"] .input-info .form-control {\n  border-color: #2D28FF;\n}\n\n[data-theme-version=\"light\"] .input-info .input-group-text,\n[data-theme-version=\"dark\"] .input-info .input-group-text {\n  background-color: #2D28FF;\n  color: #fff;\n}\n\n[data-theme-version=\"light\"] .input-success .form-control,\n[data-theme-version=\"dark\"] .input-success .form-control {\n  border-color: #2BC155;\n}\n\n[data-theme-version=\"light\"] .input-success .input-group-text,\n[data-theme-version=\"dark\"] .input-success .input-group-text {\n  background-color: #2BC155;\n  color: #fff;\n}\n\n[data-theme-version=\"light\"] .input-warning .form-control,\n[data-theme-version=\"dark\"] .input-warning .form-control {\n  border-color: #FF9B52;\n}\n\n[data-theme-version=\"light\"] .input-warning .input-group-text,\n[data-theme-version=\"dark\"] .input-warning .input-group-text {\n  background-color: #FF9B52;\n  color: #fff;\n}\n\n[data-theme-version=\"light\"] .input-primary-o .form-control,\n[data-theme-version=\"dark\"] .input-primary-o .form-control {\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"light\"] .input-primary-o .input-group-text,\n[data-theme-version=\"dark\"] .input-primary-o .input-group-text {\n  background-color: transparent;\n  border-color: #00ADEE;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"light\"] .input-danger-o .form-control,\n[data-theme-version=\"dark\"] .input-danger-o .form-control {\n  border-color: #F94687;\n}\n\n[data-theme-version=\"light\"] .input-danger-o .input-group-text,\n[data-theme-version=\"dark\"] .input-danger-o .input-group-text {\n  background-color: transparent;\n  border-color: #F94687;\n  color: #F94687;\n}\n\n[data-theme-version=\"light\"] .input-info-o .form-control,\n[data-theme-version=\"dark\"] .input-info-o .form-control {\n  border-color: #2D28FF;\n}\n\n[data-theme-version=\"light\"] .input-info-o .input-group-text,\n[data-theme-version=\"dark\"] .input-info-o .input-group-text {\n  background-color: transparent;\n  border-color: #2D28FF;\n  color: #2D28FF;\n}\n\n[data-theme-version=\"light\"] .input-success-o .form-control,\n[data-theme-version=\"dark\"] .input-success-o .form-control {\n  border-color: #2BC155;\n}\n\n[data-theme-version=\"light\"] .input-success-o .input-group-text,\n[data-theme-version=\"dark\"] .input-success-o .input-group-text {\n  background-color: transparent;\n  border-color: #2BC155;\n  color: #2BC155;\n}\n\n[data-theme-version=\"light\"] .input-warning-o .form-control,\n[data-theme-version=\"dark\"] .input-warning-o .form-control {\n  border-color: #FF9B52;\n}\n\n[data-theme-version=\"light\"] .input-warning-o .input-group-text,\n[data-theme-version=\"dark\"] .input-warning-o .input-group-text {\n  background-color: transparent;\n  border-color: #FF9B52;\n  color: #FF9B52;\n}\n\n.input-group-text {\n  background: #d7dae3;\n  border: 1px solid transparent;\n  min-width: 50px;\n  display: flex;\n  justify-content: center;\n  padding: 0.532rem 0.75rem;\n  border-radius: 1.25rem;\n}\n\n.input-group-text i {\n  font-size: 16px;\n}\n\n.custom-file-label {\n  height: 40px;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0;\n}\n\n.input-group-prepend .btn,\n.input-group-append .btn {\n  z-index: 0;\n}\n\n.custom-select {\n  background: none;\n  border-color: #f0f1f5;\n  color: #B1B1B1;\n}\n\n.custom-select:focus {\n  box-shadow: none;\n  border-color: #00ADEE;\n  color: #00ADEE;\n}\n\n.custom-file-label:after {\n  background: #656C73;\n  border: 1px solid #f0f1f5;\n  color: #fff;\n  border-radius: 0;\n}\n\n[data-theme-version=\"dark\"] .custom-file-label:after {\n  background: #333a54;\n  border-color: #333a54;\n  color: #7e7e7e;\n}\n\n.custom_file_input .custom-file-label::after {\n  height: 100%;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n  background: #fff;\n  opacity: 1;\n}\n\n.custom-file-label {\n  background: #fff;\n  border-color: #f0f1f5;\n}\n\n[data-theme-version=\"dark\"] .custom-file-label {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n/*$primary  : #7356f1 !default;*/\ninput[type=\"checkbox\"]:after {\n  content: '';\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0px;\n  margin-left: -1px;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  background: #d4d7da;\n  line-height: 1.3;\n}\n\ninput[type=\"checkbox\"]:checked:after {\n  width: 1rem;\n  height: 1rem;\n  display: block;\n  content: \"\\f00c\";\n  font-family: 'FontAwesome';\n  color: #fff;\n  font-weight: 100;\n  font-size: 12px;\n  text-align: center;\n  border-radius: 3px;\n  background: #00ADEE;\n}\n\n.form-check-label {\n  margin-left: 5px;\n  margin-top: 3px;\n}\n\n.form-check-inline .form-check-input {\n  margin-right: 0.625rem;\n}\n\n.custom-control-label:before,\n.custom-control-label:after {\n  top: 2px;\n  width: 1.25rem;\n  height: 1.25rem;\n  border-color: #e7e7e7;\n}\n\n.rtl .custom-control-label:before,\n.rtl .custom-control-label:after {\n  right: -1.5rem !important;\n  left: inherit;\n}\n\n.custom-control {\n  line-height: normal;\n}\n\n.custom-control-input:checked~.custom-control-label::before {\n  color: #fff;\n  border-color: #00ADEE;\n}\n\n.custom-control-input:focus~.custom-control-label::before {\n  box-shadow: none !important;\n}\n\n.custom-control-label::before {\n  background-color: transparent;\n  border-color: #BEBEBE;\n  border-width: 2px;\n  border-radius: 5px !important;\n}\n\n[data-theme-version=\"dark\"] .custom-control-label::before {\n  background-color: transparent;\n  border-color: #333a54;\n}\n\n.check-xs .custom-control-label:before,\n.check-xs .custom-control-label:after {\n  width: 18px;\n  height: 18px;\n}\n\n.check-lg .custom-control-label:before,\n.check-lg .custom-control-label:after {\n  width: 24px;\n  height: 24px;\n}\n\n.check-xl .custom-control-label:before,\n.check-xl .custom-control-label:after {\n  width: 28px;\n  height: 28px;\n}\n\n.checkbox-info .custom-control-label::before {\n  background-color: transparent;\n  border-color: #dbdbff;\n}\n\n[data-theme-version=\"dark\"] .checkbox-info .custom-control-label::before {\n  background-color: rgba(45, 40, 255, 0.1);\n  border-color: transparent;\n}\n\n.checkbox-info .custom-control-input:checked~.custom-control-label::before {\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.checkbox-danger .custom-control-label::before {\n  background-color: transparent;\n  border-color: #fff3f7;\n}\n\n[data-theme-version=\"dark\"] .checkbox-danger .custom-control-label::before {\n  background-color: rgba(249, 70, 135, 0.15);\n  border-color: transparent;\n}\n\n.checkbox-danger .custom-control-input:checked~.custom-control-label::before {\n  background-color: #F94687;\n  border-color: #F94687;\n}\n\n.checkbox-success .custom-control-label::before {\n  background-color: transparent;\n  border-color: #e3f9e9;\n}\n\n[data-theme-version=\"dark\"] .checkbox-success .custom-control-label::before {\n  background-color: rgba(43, 193, 85, 0.1);\n  border-color: transparent;\n}\n\n.checkbox-success .custom-control-input:checked~.custom-control-label::before {\n  background-color: #2BC155;\n  border-color: #2BC155;\n}\n\n.checkbox-warning .custom-control-label::before {\n  background-color: transparent;\n  border-color: #fff3eb;\n}\n\n[data-theme-version=\"dark\"] .checkbox-warning .custom-control-label::before {\n  background-color: rgba(255, 155, 82, 0.1);\n  border-color: transparent;\n}\n\n.checkbox-warning .custom-control-input:checked~.custom-control-label::before {\n  background-color: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.checkbox-secondary .custom-control-label::before {\n  background-color: transparent;\n  border-color: #ddedfa;\n}\n\n[data-theme-version=\"dark\"] .checkbox-secondary .custom-control-label::before {\n  background-color: rgba(63, 154, 224, 0.5);\n  border-color: transparent;\n}\n\n.checkbox-secondary .custom-control-input:checked~.custom-control-label::before {\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n}\n\n.toggle-switch {\n  padding-left: 50px;\n  line-height: 1.25;\n}\n\n.toggle-switch .custom-control-label {\n  font-weight: 500;\n}\n\n.toggle-switch .custom-control-label:after {\n  width: 24px;\n  background: #959595;\n  height: 24px;\n  border-radius: 24px;\n  top: -2px;\n  left: -50px;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.toggle-switch .custom-control-label:before {\n  border: 0;\n  background: #D8D8D8;\n  width: 40px;\n  border-radius: 20px !important;\n  height: 16px;\n  left: -50px;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.toggle-switch .custom-control-input:checked~.custom-control-label:after {\n  left: -43px;\n  background: #00ADEE;\n}\n\n.toggle-switch .custom-control-input:checked~.custom-control-label:before {\n  background: #f6f1fd;\n}\n\n.toggle-switch.text-right {\n  padding-left: 0;\n  padding-right: 50px;\n}\n\n.toggle-switch.text-right .custom-control-label:after {\n  left: auto;\n  right: -30px;\n}\n\n.toggle-switch.text-right .custom-control-label:before {\n  left: auto;\n  right: -50px;\n}\n\n.toggle-switch.text-right .custom-control-input:checked~.custom-control-label:after {\n  left: auto;\n  right: -43px;\n}\n\n.check-switch {\n  padding-left: 40px;\n}\n\n.check-switch .custom-control-label {\n  line-height: 30px;\n  font-weight: 500;\n}\n\n.check-switch .custom-control-label:after,\n.check-switch .custom-control-label:before {\n  height: 1.5rem;\n  width: 1.5rem;\n  left: -2rem;\n  border-radius: 3rem !important;\n  border-color: rgba(135, 67, 223, 0.3);\n}\n\n.js-switch+.switchery {\n  border-radius: 50px;\n  margin-right: 4rem;\n}\n\n@media (max-width: 767.98px) {\n  .js-switch+.switchery {\n    margin-right: 1rem;\n  }\n}\n\n.js-switch+.switchery>small {\n  top: 2px;\n}\n\n.js-switch.js-switch-lg+.switchery {\n  height: 2rem;\n  width: 4.5rem;\n}\n\n.js-switch.js-switch-lg+.switchery>small {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.js-switch.js-switch-md+.switchery {\n  height: 1.5rem;\n  width: 3.5rem;\n}\n\n.js-switch.js-switch-md+.switchery>small {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.js-switch.js-switch-sm+.switchery {\n  height: 1rem;\n  width: 2.2rem;\n}\n\n.js-switch.js-switch-sm+.switchery>small {\n  width: 0.875rem;\n  height: 0.875rem;\n  top: 1px;\n}\n\n.js-switch-square+.switchery {\n  border-radius: 0;\n}\n\n.js-switch-square+.switchery>small {\n  border-radius: 0;\n  top: 2px;\n}\n\n.js-switch-square.js-switch-lg+.switchery {\n  height: 2rem;\n  width: 4.5rem;\n}\n\n.js-switch-square.js-switch-lg+.switchery>small {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.js-switch-square.js-switch-md+.switchery {\n  height: 1.5rem;\n  width: 3.5rem;\n}\n\n.js-switch-square.js-switch-md+.switchery>small {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.js-switch-square.js-switch-sm+.switchery {\n  height: 1rem;\n  width: 2.2rem;\n}\n\n.js-switch-square.js-switch-sm+.switchery>small {\n  width: 0.875rem;\n  height: 0.875rem;\n  top: 1px;\n}\n\n.form-control.is-valid {\n  border-color: #2BC155 !important;\n  border-right: 0px !important;\n}\n\n.form-control.is-valid:focus {\n  box-shadow: none;\n}\n\n.form-control.is-warning {\n  border-color: #FF9B52 !important;\n  border-right: 0px !important;\n}\n\n.form-control.is-warning:focus {\n  box-shadow: none;\n}\n\n.form-control.is-invalid {\n  border-color: #F94687 !important;\n  border-right: 0px !important;\n}\n\n.form-control.is-invalid:focus {\n  box-shadow: none;\n}\n\n.is-valid .input-group-prepend .input-group-text i {\n  color: #2BC155;\n}\n\n.is-invalid .input-group-prepend .input-group-text i {\n  color: #b184ea;\n}\n\n.asColorPicker-dropdown {\n  max-width: 26rem;\n}\n\n.asColorPicker-trigger {\n  border: 0 none;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 2.1875rem;\n}\n\n[direction=\"rtl\"] .asColorPicker-trigger {\n  right: 99%;\n  left: auto;\n}\n\n.asColorPicker-clear {\n  display: none;\n  position: absolute;\n  right: 1rem;\n  text-decoration: none;\n  top: .5rem;\n}\n\n.daterangepicker td.active {\n  background-color: #00ADEE;\n}\n\n.daterangepicker td.active:hover {\n  background-color: #00ADEE;\n}\n\n.daterangepicker button.applyBtn {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.datepicker.datepicker-dropdown {\n  background: #f2f4fa;\n  border-radius: 1px;\n  border: 1px solid #EEEEEE;\n}\n\n.datepicker.datepicker-dropdown td.day,\n.datepicker.datepicker-dropdown th.next,\n.datepicker.datepicker-dropdown th.prev {\n  height: 30px;\n  width: 30px !important;\n  padding: 0;\n  text-align: center;\n  font-weight: 300;\n  border-radius: 50px;\n}\n\n.datepicker.datepicker-dropdown td.day:hover,\n.datepicker.datepicker-dropdown th.next:hover,\n.datepicker.datepicker-dropdown th.prev:hover {\n  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);\n  color: #fff;\n}\n\n.datepicker.datepicker-dropdown th.datepicker-switch,\n.datepicker.datepicker-dropdown th.next,\n.datepicker.datepicker-dropdown th.prev {\n  font-weight: 300;\n  color: #333;\n}\n\n.datepicker.datepicker-dropdown th.dow {\n  font-weight: 300;\n}\n\n.datepicker table tr td.selected,\n.datepicker table tr td.active.active {\n  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);\n  border: 0;\n}\n\n.datepicker table tr td.today {\n  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);\n  color: #ffffff;\n}\n\n.datepicker table tr td.today:hover {\n  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);\n  color: #ffffff;\n}\n\n.datepicker table tr td.today.disabled {\n  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);\n  color: #ffffff;\n}\n\n.datepicker table tr td.today.disabled:hover {\n  box-shadow: 0px 0px 30px 5px rgba(243, 30, 122, 0.3);\n  color: #ffffff;\n}\n\n.picker__select--month,\n.picker__select--year {\n  height: 2.5em;\n}\n\n.picker__input {\n  background-color: transparent !important;\n}\n\n[data-theme-version=\"dark\"] .picker__input {\n  background-color: transparent !important;\n  border: 1px solid #333a54;\n}\n\n.asColorPicker-wrap .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n#image {\n  max-width: 100%;\n}\n\n.docs-options .dropdown-menu {\n  padding: 1.5rem;\n}\n\n.docs-preview {\n  margin-bottom: 3rem;\n}\n\n.docs-preview .img-preview {\n  float: left;\n  margin-right: .5rem;\n  margin-bottom: .5rem;\n  overflow: hidden;\n  max-width: 100% !important;\n}\n\n.docs-preview .img-preview>img {\n  max-width: 100% !important;\n}\n\n.docs-preview .img-preview.preview-lg {\n  width: 16rem;\n  height: 9rem;\n}\n\n.docs-preview .img-preview.preview-md {\n  width: 8rem;\n  height: 4.5rem;\n}\n\n.docs-preview .img-preview.preview-sm {\n  width: 4rem;\n  height: 2.25rem;\n}\n\n.docs-preview .img-preview.preview-xs {\n  width: 2rem;\n  height: 1.125rem;\n  margin-right: 0;\n}\n\n.select2-container {\n  width: 100% !important;\n}\n\n.select2-container--default .select2-selection--single {\n  border-radius: 1.25rem;\n  border: 1px solid #F4F5F9;\n  height: 40px;\n  background: #fff;\n}\n\n[data-theme-version=\"dark\"] .select2-container--default .select2-selection--single {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n.select2-container--default .select2-selection--single:hover,\n.select2-container--default .select2-selection--single:focus,\n.select2-container--default .select2-selection--single.active {\n  box-shadow: none;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n  line-height: 40px;\n  color: #7e7e7e;\n  padding-left: 15px;\n  min-height: 40px;\n}\n\n.select2-container--default .select2-selection--multiple {\n  border-color: #f0f1f5;\n  border-radius: 0;\n}\n\n.select2-dropdown {\n  border-radius: 0;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #00ADEE;\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border-color: #f0f1f5;\n  background: #fff;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  top: 6px;\n  right: 15px;\n}\n\n.select2-container .select2-selection--multiple {\n  min-height: 40px;\n  color: #7e7e7e;\n  border-radius: 1.25rem;\n  border: 1px solid #F4F5F9;\n}\n\n[data-theme-version=\"dark\"] .select2-container .select2-selection--multiple {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .select2-search--dropdown .select2-search__field {\n  background: #1e2746;\n  border-color: #333a54;\n}\n\n.select2-dropdown {\n  border-color: #F4F5F9;\n}\n\n[data-theme-version=\"dark\"] .select2-dropdown {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n.swal2-popup .swal2-content {\n  color: #7e7e7e;\n}\n\n/*$primary  : #7356f1 !default;*/\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n/*  .wizard > .content > .body input.error {\n    position: absolute;\n    top: 100% !important;\n}\n\n.wizard {\n    position: relative;\n\n    &>.steps {\n        width: 100%;\n        // padding-left: 3%;\n\t\tmargin-bottom: 20px;\n\t\n        @media(min-width: 1200px){\n            width: 100%;\n            // margin-left: 3%;\n        }\n\n        li {\n\n            &.current {\n                a {\n                    background-color: $primary;\n                    color: $white;\n                }\n            }\n\n            &.disabled, &.done {\n                a {\n                    background-color: $white;\n                    color: $heading;\n\n                    &:hover {\n                        margin: 0;\n                        background-color: $white;\n                        border-radius: 0;\n                        color: $heading;\n                    }\n                }\n            }\n\n            a {\n                text-align: center;\n                margin: 0;\n                border-radius: 0;\n                background-color: $white;\n\n                &:hover {\n                    margin: 0;\n                    background-color: $white;\n                    border-radius: 0;\n                    color: $heading;\n                }\n\n                @include respond(phone-land) {\n                    padding: 1em 4px;\n                }\n\n                .number {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    .content  {\n        min-height: 32rem;\n        margin: 0;\n\n        @include media-breakpoint-down(md) {\n            min-height: 41rem;\n        }\n\n        & > .body {\n            background-color: transparent;\n            width: 100%;\n            height: 100%;\n            padding: 0;\n            \n            @include respond(phone) {\n                padding: 0;\n            }\n\n            .form-control {\n                // background-color: $l-bg;\n                border: 1px solid $border;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tborder-color: $d-border;\n\t\t\t\t}\n            }\n    \n            input.error {\n                position: relative;\n            }\n    \n            label.error {\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-bottom: 0;\n            }\n        }\n    }\n\n    .emial-setup {\n        label.mailclinet {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-direction: column;\n            width: 10rem;\n            height: 10rem;\n            border-radius: 50%;\n            cursor: pointer;\n            background-color: #EEF5F9;\n\t\t\ttext-align: center;\n\t\t\tmargin: auto;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $d-bg;\n\t\t\t}\n            @include respond(phone) {\n                width: 7rem;\n                height: 7rem;\n            }\n\n            .mail-icon {\n                font-size: 3rem;\n                display: inline-block;\n                line-height: 1;\n                margin-top: -1rem;\n\n                @include respond(phone) {\n                    font-size: 2rem;\n                }\n            }\n\n            .mail-text {\n                font-size: 1rem;\n                text-align: center;\n                margin-top: .5rem;\n\n                @include respond(phone) {\n                    font-size: 16px;\n\t\t\t\t\tline-height: 20px;\n                }\n            }\n\n            input[type=\"radio\"] {\n                display: none;\n            }\n        }\n    }\n\n    .skip-email {\n        margin-top: 6rem;\n\n        p {\n            margin-bottom: 1rem;\n        }\n\n        a {\n            color: $primary;\n            text-decoration: underline;\n        }\n    }\n\n    &>.actions {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        padding: 2rem;\n\n        li:not(.disabled) {\n            a {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n.wizard .actions ul li{\n    &.disabled a{\n        color: #333333 !important;\n        background: #F7FAFC !important;\n        border: 1px solid #EEEEEE;\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg !important;\n            border-color: $d-border;\n\t\t\tcolor:$white !important;\n        }\n    }\n\n    & a{\n        border-radius: 4px;\n        font-size: 14px;\n        font-weight: 600;\n        padding: 0.55em 2em;\n    }\n\n}\n\n.wizard > .actions a, .wizard > .actions a:hover, .wizard > .actions a:active{\n    padding: 0.55em 2em;\n}\n\n// .wizard > .steps > ul > li{\n\n//     @media(max-width: 680px){\n//         width: 100%;\n//         padding-left: 0;\n//     }\n// }\n\n// .wizard > .steps{\n\n//     @media(max-width: 680px){\n//         padding-left: 0;\n//     }\n// }\n\n.wizard > .content{\n    background: transparent;\n    // box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1); \n}\n\n.wizard, .tabcontrol{\n    overflow: visible;\n}\n\n.step-form-horizontal {\n    .wizard {\n        padding-top: 3.5rem;\n        \n        .steps {\n            li {\n                position: relative;\n\n                &.done {\n                    a {\n                        text-align: center;\n                        background-color: $white;\n                        color: $dark;\n\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\tbackground-color: $d-bg;\n\t\t\t\t\t\t\tcolor: $body-color;\n\t\t\t\t\t\t}\n                        &:hover {\n                            text-align: center;\n                            background-color: $white;\n                            color: $dark;\n                        }\n\n                        .number {\n                            color: $white;\n                            background: $primary;\n                            border-color: transparent; \n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\t\tborder-color:$primary;\n\t\t\t\t\t\t\t}\n                        }\n                    }\n                }\n\n                &.current a, &.disabled a {\n                    background-color: transparent;\n                    text-align: center;\n                    color: $white;\n\n                    &:hover, &:active {\n                        background-color: transparent;\n                        color: $white;\n                    }\n                }\n\n                &.current a {\n                    .number {\n                        color: $primary;\n                        background: $white;\n                        border: 2px solid $primary; \n                    }\n                }\n\n                &.disabled a {\n                    .number {\n                        color: $primary;\n                    }\n                }\n\n                a {\n                    position: relative;\n                    z-index: 1;\n\n                    @include media-breakpoint-down(sm) {\n                        padding-left: 0;\n                        padding-right: 0;\n                        margin: 0;\n                    }\n\n                    @include media-breakpoint-down(xs) {\n                        font-size: 0.75rem;\n                        padding-top: 0.9375rem;\n                    }\n\n                    .number {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: -55px;\n\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\ttransform: translateX(-50%);\n\t\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\t\tborder: 3px solid #d7dae3;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\theight: 3rem;\n\t\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\t\twidth: 3rem;\n\n                        // @include respond(phone) {\n                        //     width: 4rem;\n                        //     height: 4rem;\n                        // }\n\t\t\t\t\t\t\n\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\tbackground:$d-bg;\n\t\t\t\t\t\t\tborder-color:$d-border;\n\t\t\t\t\t\t}\n                        @include respond('phone') {\n\t\t\t\t\t\t\ttop: -45px;\n\t\t\t\t\t\t}\n                    }\n                }\n\n                &:not(:last-child) {\n                    z-index: 1;\n\n                    &::after {\n                        position: absolute;\n                        width: 100%;\n                        height: 0.375rem;\n                        content: \"\";\n                        left: 50%;\n                        top: -2.1rem;\n                        background-color: $primary;\n                        z-index: -1;\n\n                        @include media-breakpoint-down(xs) {\n                            height: 0.375rem;\n                            top: -1.3125rem;\n                        }\n                    }\n\n                    &.current {\n                        &::after {\n                            background-color: #F3F3F3;\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\t\tbackground:$d-bg;\n\t\t\t\t\t\t\t}\n                        }\n\n\n                        &~li {\n                            &::after {\n                                background-color: #F3F3F3;\n\t\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\t\t\tbackground:$d-bg;\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .actions {\n            padding: 0;\n\n            @include respond(phone) {\n                padding: 0;\n            }\n        }\n    }\n}\n */\n.form-wizard {\n  border: 0;\n}\n\n.form-wizard .nav-wizard {\n  box-shadow: none !important;\n  margin-bottom: 2rem;\n}\n\n.form-wizard .nav-wizard li .nav-link {\n  position: relative;\n}\n\n.form-wizard .nav-wizard li .nav-link span {\n  border-radius: 50px;\n  width: 3rem;\n  height: 3rem;\n  border: 2px solid #00ADEE;\n  display: block;\n  line-height: 3rem;\n  color: #00ADEE;\n  font-size: 18px;\n  margin: auto;\n  background-color: #fff;\n  position: relative;\n  z-index: 1;\n}\n\n.form-wizard .nav-wizard li .nav-link:after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 3px;\n  transform: translateY(-50%);\n  background: #f1f1f1 !important;\n  z-index: 0;\n  width: 100%;\n}\n\n.form-wizard .nav-wizard li .nav-link.active:after {\n  background: #f1f1f1 !important;\n}\n\n.form-wizard .nav-wizard li .nav-link.done:after {\n  background: #00ADEE !important;\n}\n\n.form-wizard .nav-wizard li .nav-link.done span {\n  background-color: #00ADEE;\n  color: #fff;\n}\n\n.form-wizard .nav-wizard li:last-child .nav-link:after {\n  content: none;\n}\n\n.form-wizard .toolbar-bottom .btn {\n  background-color: #00ADEE;\n  border: 0;\n  padding: 12px 18px;\n}\n\n.form-wizard .tab-content .tab-pane {\n  padding: 0;\n}\n\n.form-wizard .emial-setup label.mailclinet {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 10rem;\n  height: 10rem;\n  border-radius: 50%;\n  cursor: pointer;\n  background-color: #EEF5F9;\n  text-align: center;\n  margin: auto;\n}\n\n[data-theme-version=\"dark\"] .form-wizard .emial-setup label.mailclinet {\n  background-color: #181f39;\n}\n\n@media only screen and (max-width: 575px) {\n  .form-wizard .emial-setup label.mailclinet {\n    width: 7rem;\n    height: 7rem;\n  }\n}\n\n.form-wizard .emial-setup label.mailclinet .mail-icon {\n  font-size: 3rem;\n  display: inline-block;\n  line-height: 1;\n  margin-top: -1rem;\n}\n\n@media only screen and (max-width: 575px) {\n  .form-wizard .emial-setup label.mailclinet .mail-icon {\n    font-size: 2rem;\n  }\n}\n\n.form-wizard .emial-setup label.mailclinet .mail-text {\n  font-size: 1rem;\n  text-align: center;\n  margin-top: .5rem;\n}\n\n@media only screen and (max-width: 575px) {\n  .form-wizard .emial-setup label.mailclinet .mail-text {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.form-wizard .emial-setup label.mailclinet input[type=\"radio\"] {\n  display: none;\n}\n\n.form-wizard .emial-setup label.mailclinet {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 10rem;\n  height: 10rem;\n  border-radius: 50%;\n  cursor: pointer;\n  background-color: #EEF5F9;\n  text-align: center;\n  margin: auto;\n}\n\n[data-theme-version=\"dark\"] .form-wizard .emial-setup label.mailclinet {\n  background-color: #181f39;\n}\n\n@media only screen and (max-width: 575px) {\n  .form-wizard .emial-setup label.mailclinet {\n    width: 7rem;\n    height: 7rem;\n  }\n}\n\n.form-wizard .emial-setup label.mailclinet .mail-icon {\n  font-size: 3rem;\n  display: inline-block;\n  line-height: 1;\n  margin-top: -1rem;\n}\n\n@media only screen and (max-width: 575px) {\n  .form-wizard .emial-setup label.mailclinet .mail-icon {\n    font-size: 2rem;\n  }\n}\n\n.form-wizard .emial-setup label.mailclinet .mail-text {\n  font-size: 1rem;\n  text-align: center;\n  margin-top: .5rem;\n}\n\n@media only screen and (max-width: 575px) {\n  .form-wizard .emial-setup label.mailclinet .mail-text {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.form-wizard .emial-setup label.mailclinet input[type=\"radio\"] {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .form-wizard .nav-wizard {\n    flex-direction: unset !important;\n  }\n\n  .form-wizard .tab-content {\n    height: 100% !important;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .form-wizard .nav-wizard li .nav-link {\n    padding: 0;\n  }\n}\n\n.note-icon-caret,\n.note-popover {\n  display: none;\n}\n\n.note-editor.note-frame .panel-heading {\n  padding: .6rem 1rem 1rem;\n  z-index: 1;\n}\n\n.note-editor.note-frame {\n  border-color: #f0f1f5;\n}\n\n.note-editor.note-frame .note-editing-area .note-editable {\n  background-color: #fff;\n}\n\n[data-theme-version=\"dark\"] .note-editor.note-frame .note-editing-area .note-editable {\n  background-color: #181f39;\n}\n\n.note-editor.note-frame .note-statusbar {\n  background-color: #fff;\n}\n\n.ql-container {\n  height: 25rem;\n}\n\n#world-datamap {\n  padding-bottom: 46% !important;\n}\n\n.datamaps-hoverover {\n  background: #fff;\n  padding: 0.3125rem;\n  border-radius: 0.3125rem;\n  font-family: 'Roboto' !important;\n  color: #00ADEE;\n  border: 1px solid rgba(135, 67, 223, 0.3);\n}\n\n@media only screen and (max-width: 1440px) {\n  .world_map_card ul.list-group {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    margin-top: 35px;\n  }\n}\n\n.jqvmap-zoomin,\n.jqvmap-zoomout {\n  height: 20px;\n  width: 20px;\n  line-height: 14px;\n  background-color: #00ADEE;\n  color: #fff;\n}\n\n.jqvmap-zoomout {\n  top: 35px;\n}\n\n#world-map {\n  height: 400px;\n}\n\n.blockUI.blockMsg.blockPage {\n  border: 0 !important;\n}\n\n#loginForm {\n  cursor: auto;\n}\n\n.blockMsg {\n  border: 0px !important;\n  width: 20% !important;\n}\n\n.blockMsg h1 {\n  font-size: 16px;\n  padding: 8px 0;\n  margin-bottom: 0;\n}\n\n.bootstrap-select {\n  margin-bottom: 0;\n}\n\n.bootstrap-select .btn {\n  border: 1px solid #f0f1f5 !important;\n  background-color: transparent !important;\n  font-weight: 400;\n  color: #7e7e7e !important;\n}\n\n[data-theme-version=\"dark\"] .bootstrap-select .btn {\n  border-color: #333a54 !important;\n}\n\n.bootstrap-select .btn:active,\n.bootstrap-select .btn:focus,\n.bootstrap-select .btn:hover {\n  outline: none !important;\n  outline-offset: 0;\n}\n\n[data-theme-version=\"dark\"] .bootstrap-select .btn:active,\n[data-theme-version=\"dark\"] .bootstrap-select .btn:focus,\n[data-theme-version=\"dark\"] .bootstrap-select .btn:hover {\n  color: #7e7e7e !important;\n}\n\n.bootstrap-select .dropdown-menu {\n  border-color: #f0f1f5 !important;\n  box-shadow: 0px 0Epx 40px 0px rgba(82, 63, 105, 0.1);\n}\n\n.bootstrap-select .dropdown-menu .dropdown-item {\n  padding: 0.25rem 1rem;\n}\n\n[data-theme-version=\"dark\"] .bootstrap-select .dropdown-menu {\n  border-color: #f0f1f5 !important;\n}\n\n.input-group>.bootstrap-select:not(:first-child) .dropdown-toggle {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group>.bootstrap-select:not(:last-child) .dropdown-toggle {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n/*$primary  : #7356f1 !default;*/\n.clipboard-btn {\n  transition: all .1s ease-in-out;\n}\n\n.clipboard-btn:hover {\n  background-color: #00ADEE;\n  color: #fff;\n}\n\n.crypto-ticker {\n  background: rgba(0, 0, 0, 0.5);\n  margin-top: 20px;\n  padding: 10px 20px;\n  border-radius: 3px;\n  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n}\n\n[data-theme-version=\"dark\"] .crypto-ticker {\n  background: #1e2746;\n}\n\n#webticker-big {\n  font: inherit !important;\n  font-size: inherit !important;\n  font-weight: normal !important;\n}\n\n#webticker-big li i {\n  font-size: 18px;\n  margin-right: 7px;\n}\n\n#webticker-big li p {\n  margin-bottom: 0px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n/*$primary  : #7356f1 !default;*/\n.twitter-typeahead {\n  width: 100%;\n}\n\n.twitter-typeahead .tt-dataset.tt-dataset-states {\n  border: 1px solid #f0f1f5;\n}\n\n.twitter-typeahead .tt-menu {\n  width: 100%;\n  background-color: #fff;\n}\n\n.twitter-typeahead .tt-menu .tt-suggestion {\n  padding: 0.625rem;\n  cursor: pointer;\n}\n\n.twitter-typeahead .tt-menu .tt-suggestion:hover {\n  background-color: #00ADEE;\n  color: #fff;\n}\n\n.weather-one i {\n  font-size: 8rem;\n  position: relative;\n  top: .5rem;\n}\n\n.weather-one h2 {\n  display: inline-block;\n  float: right;\n  font-size: 4.8rem;\n}\n\n.weather-one .city {\n  position: relative;\n  text-align: right;\n  top: -2.5rem;\n}\n\n.weather-one .currently {\n  font-size: 1.6rem;\n  font-weight: 400;\n  position: relative;\n  top: 2.5rem;\n}\n\n.weather-one .celcious {\n  text-align: right;\n  font-size: 2rem;\n}\n\n/*$primary  : #7356f1 !default;*/\n.noUi-target {\n  border-color: transparent;\n  border-radius: 0;\n}\n\n.noUi-connect {\n  background-color: #00ADEE;\n}\n\n.noUi-connects {\n  background-color: #D2D6DE;\n}\n\n.noUi-connect.c-1-color {\n  background-color: #2BC155;\n}\n\n.noUi-connect.c-2-color {\n  background-color: #2D28FF;\n}\n\n.noUi-connect.c-3-color {\n  background-color: #00ADEE;\n}\n\n.noUi-connect.c-4-color {\n  background-color: #FF9B52;\n}\n\n.noUi-vertical {\n  width: 0.375rem;\n}\n\n.noUi-horizontal {\n  height: 0.375rem;\n  margin-bottom: 10px;\n}\n\n.noUi-horizontal .noUi-handle,\n.noUi-vertical .noUi-handle {\n  height: 12px;\n  width: 12px;\n  border-radius: 50px;\n  box-shadow: none;\n  border: none;\n  background-color: #00ADEE;\n}\n\n.noUi-horizontal .noUi-handle::after,\n.noUi-horizontal .noUi-handle::before,\n.noUi-vertical .noUi-handle::after,\n.noUi-vertical .noUi-handle::before {\n  display: none;\n}\n\n.noUi-vertical .noUi-handle {\n  left: -4px;\n  top: -6px;\n}\n\n.noUi-horizontal .noUi-handle {\n  top: -4px;\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n  right: -6px;\n}\n\n#slider-toggle {\n  height: 50px;\n}\n\n#slider-toggle.off .noUi-handle {\n  border-color: #00ADEE;\n}\n\n.colorpicker-slider .sliders.noUi-target#red,\n.colorpicker-slider .sliders.noUi-target#green,\n.colorpicker-slider .sliders.noUi-target#blue {\n  margin: 10px;\n  display: inline-block;\n  height: 200px;\n}\n\n.colorpicker-slider .sliders.noUi-target#red .noUi-connect {\n  background: #c0392b;\n}\n\n.colorpicker-slider .sliders.noUi-target#green .noUi-connect {\n  background: #27ae60;\n}\n\n.colorpicker-slider .sliders.noUi-target#blue .noUi-connect {\n  background: #2980b9;\n}\n\n.colorpicker-slider #result {\n  margin: 60px 26px;\n  height: 100px;\n  width: 100px;\n  display: inline-block;\n  vertical-align: top;\n  color: #7f7f7f;\n  background: #7f7f7f;\n  border: 1px solid #fff;\n  box-shadow: 0 0 10px;\n}\n\n.slider-vertical {\n  height: 18rem;\n}\n\n.nestable-cart {\n  overflow: hidden;\n}\n\n.dd-handle {\n  color: #fff;\n  background: #00ADEE;\n  border-radius: 5px;\n  padding: 8px 15px;\n  height: auto;\n  border: 1px solid #f0f1f5;\n}\n\n.dd-handle:hover {\n  color: #fff;\n  background: #00ADEE;\n}\n\n.dd3-content:hover {\n  color: #fff;\n  background: #00ADEE;\n}\n\n.dd3-content {\n  color: #fff;\n}\n\n.dd-item>button {\n  line-height: 28px;\n  color: #fff;\n}\n\n.pignose-calendar {\n  box-shadow: none;\n  width: 100%;\n  max-width: none;\n  border-color: #00ADEE;\n}\n\n.pignose-calendar .pignose-calendar-top-date {\n  background-color: #00ADEE;\n}\n\n.pignose-calendar .pignose-calendar-top-date .pignose-calendar-top-month {\n  color: #fff;\n}\n\n.pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n  background-color: #00ADEE;\n  box-shadow: none;\n}\n\n.pignose-calendar .pignose-calendar-top {\n  box-shadow: none;\n  border-bottom: 0;\n}\n\n.pignose-calendar.pignose-calendar-blue {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.pignose-calendar .pignose-calendar-unit {\n  height: 4.8em;\n}\n\n.cd-h-timeline {\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.cd-h-timeline--loaded {\n  opacity: 1;\n}\n\n.cd-h-timeline__container {\n  position: relative;\n  height: 100px;\n  max-width: 800px;\n}\n\n.cd-h-timeline__dates {\n  position: relative;\n  height: 100%;\n  margin: 0 40px;\n  overflow: hidden;\n}\n\n.cd-h-timeline__dates::after,\n.cd-h-timeline__dates::before {\n  content: '';\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  height: 100%;\n  width: 20px;\n}\n\n.cd-h-timeline__dates::before {\n  left: 0;\n  background: #00ADEE;\n}\n\n.cd-h-timeline__dates::after {\n  right: 0;\n  background: #00ADEE;\n}\n\n.cd-h-timeline__line {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 49px;\n  height: 2px;\n  background-color: #00ADEE;\n  transition: transform 0.4s;\n}\n\n.cd-h-timeline__filling-line {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: #2BC155;\n  transform: scaleX(0);\n  transform-origin: left center;\n  transition: transform 0.3s;\n}\n\n.cd-h-timeline__date {\n  position: absolute;\n  bottom: 0;\n  z-index: 2;\n  text-align: center;\n  font-size: 0.8em;\n  padding-bottom: var(--space-sm);\n  color: var(--cd-color-1);\n  user-select: none;\n  text-decoration: none;\n}\n\n.cd-h-timeline__date::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -5px;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  border-width: 2px;\n  border-style: solid;\n  border-color: #8a47e0;\n  background-color: #00ADEE;\n  transition: background-color 0.3s, border-color .3s;\n}\n\n.cd-h-timeline__date:hover::after {\n  background-color: #2BC155;\n  border-color: #2BC155;\n}\n\n.cd-h-timeline__date--selected {\n  pointer-events: none;\n}\n\n.cd-h-timeline__date--selected::after {\n  background-color: #2BC155;\n  border-color: #2BC155;\n}\n\n.cd-h-timeline__date--older-event::after {\n  border-color: #2BC155;\n}\n\n.cd-h-timeline__navigation {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 34px;\n  width: 34px;\n  border-radius: 50%;\n  border-width: 2px;\n  border-style: solid;\n  border-color: #8a47e0;\n  transition: border-color 0.3s;\n}\n\n.cd-h-timeline__navigation::after {\n  content: '';\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  /* background: url(../images/svg/cd-arrow.svg) no-repeat 0 0;*/\n}\n\n.cd-h-timeline__navigation:hover {\n  border-color: #2BC155;\n}\n\n.cd-h-timeline__navigation--prev {\n  left: 0;\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.cd-h-timeline__navigation--next {\n  right: 0;\n}\n\n.cd-h-timeline__navigation--inactive {\n  cursor: not-allowed;\n}\n\n.cd-h-timeline__navigation--inactive::after {\n  background-position: 0 -16px;\n}\n\n.cd-h-timeline__navigation--inactive:hover {\n  border-color: #8a47e0;\n}\n\n.cd-h-timeline__events {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  transition: height .4s;\n}\n\n.cd-h-timeline__event {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  left: 0;\n  top: 0;\n  transform: translateX(-100%);\n  padding: 1px 5%;\n  opacity: 0;\n  animation-duration: 0.4s;\n  animation-timing-function: ease-in-out;\n}\n\n.cd-h-timeline__event--selected {\n  position: relative;\n  z-index: 2;\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.cd-h-timeline__event--enter-right,\n.cd-h-timeline__event--leave-right {\n  animation-name: cd-enter-right;\n}\n\n.cd-h-timeline__event--enter-left,\n.cd-h-timeline__event--leave-left {\n  animation-name: cd-enter-left;\n}\n\n.cd-h-timeline__event--leave-right,\n.cd-h-timeline__event--leave-left {\n  animation-direction: reverse;\n}\n\n.cd-h-timeline__event-content {\n  max-width: 800px;\n}\n\n.cd-h-timeline__event-title {\n  color: var(--cd-color-1);\n  font-family: var(--font-secondary);\n  font-weight: 700;\n  font-size: var(--text-xxxl);\n}\n\n.cd-h-timeline__event-date {\n  display: block;\n  font-style: italic;\n  margin: var(--space-xs) auto;\n}\n\n.cd-h-timeline__event-date::before {\n  content: '- ';\n}\n\n@keyframes cd-enter-right {\n  0% {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n\n@keyframes cd-enter-left {\n  0% {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n\n/* Light Gallery */\n.lg-actions .lg-next,\n.lg-actions .lg-prev,\n.lg-sub-html,\n.lg-toolbar {\n  background-color: rgba(30, 30, 30, 0.6);\n}\n\n.lg-outer .lg-toogle-thumb,\n.lg-outer .lg-thumb-outer,\n.lg-outer .lg-img-wrap,\n.lg-outer .lg-item {\n  background-color: transparent;\n}\n\n.lg-thumb-outer.lg-grab,\n.lg-toogle-thumb.lg-icon {\n  background-color: rgba(30, 30, 30, 0.6);\n}\n\n.lg-backdrop {\n  background-color: rgba(30, 30, 30, 0.9);\n}\n\n.lg-outer .lg-toogle-thumb,\n.lg-actions .lg-next,\n.lg-actions .lg-prev,\n.lg-toolbar .lg-icon,\n#lg-counter {\n  color: #fff;\n}\n\n.lg-outer .lg-thumb-item.active,\n.lg-outer .lg-thumb-item:hover {\n  border-color: #00ADEE;\n}\n\n.lightimg {\n  cursor: pointer;\n}\n\n.toast-success {\n  background-color: #00ADEE;\n}\n\n.toast-info {\n  background-color: #2D28FF;\n}\n\n.toast-warning {\n  background-color: #FF9B52;\n}\n\n.toast-error {\n  background-color: #F94687;\n}\n\n#toast-container>div {\n  box-shadow: none;\n  border-radius: 0;\n  width: auto;\n  max-width: 250px;\n  opacity: 1;\n}\n\n[direction=\"rtl\"] #toast-container>div {\n  padding: 15px 50px 15px 15px;\n  background-position: calc(100% - 15px);\n  text-align: right;\n}\n\n#toast-container>div:hover {\n  box-shadow: none;\n}\n\n#toast-container .toast-title {\n  margin-bottom: 5px;\n  font-weight: 600;\n}\n\n#toast-container .toast-message {\n  font-size: 12px;\n}\n\n#toast-container .toast-close-button {\n  opacity: 1;\n  font-size: 20px;\n  font-weight: normal;\n  text-shadow: none;\n}\n\n[direction=\"rtl\"] .toast-top-right.demo_rtl_class {\n  left: 12px;\n  right: auto;\n}\n\n.jqvmap-zoomin,\n.jqvmap-zoomout {\n  position: absolute;\n  left: 10px;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n  background: #000000;\n  padding: 3px;\n  color: white;\n  width: 17px;\n  height: 17px;\n  cursor: pointer;\n  line-height: 10px;\n  text-align: center;\n}\n\n.jqvmap-zoomin {\n  top: 10px;\n}\n\n.jqvmap-zoomout {\n  top: 30px;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus,\n.ps__rail-x.ps--clicking,\n.ps__rail-y.ps--clicking {\n  background-color: transparent;\n  opacity: 0.9;\n}\n\n.ps__rail-y:hover>.ps__thumb-y,\n.ps__rail-y:focus>.ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n  background-color: #DAE2F3;\n  width: 4px;\n}\n\n.ps__thumb-y {\n  background-color: #DAE2F3;\n  width: 4px;\n}\n\n.total-average {\n  position: relative;\n  height: 300px;\n}\n\n.widget-chat {\n  position: relative;\n  height: 250px;\n}\n\n.widget-todo {\n  position: relative;\n  height: 210px;\n}\n\n.widget-team {\n  position: relative;\n  height: 285px;\n}\n\n.widget-timeline {\n  position: relative;\n}\n\n.widget-comments {\n  position: relative;\n  height: 400px;\n}\n\n.sidebar-right-inner {\n  position: relative;\n  height: 100%;\n}\n\n.widget-team .ps .ps__rail-x:hover,\n.widget-team .ps .ps__rail-y:hover,\n.widget-team .ps .ps__rail-x:focus,\n.widget-team .ps .ps__rail-y:focus,\n.widget-team .ps .ps__rail-x.ps--clicking,\n.widget-team .ps .ps__rail-y.ps--clicking {\n  background-color: transparent !important;\n  opacity: 0.9;\n}\n\n.accordion-primary .accordion__header {\n  background: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n  box-shadow: 0 15px 20px 0 rgba(135, 67, 223, 0.15);\n}\n\n.accordion-primary .accordion__header.collapsed {\n  background: #f6f1fd;\n  border-color: #f6f1fd;\n  color: #211c37;\n  box-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .accordion-primary .accordion__header.collapsed {\n  background: rgba(135, 67, 223, 0.2);\n  border-color: rgba(135, 67, 223, 0.2);\n  color: #7e7e7e;\n}\n\n.accordion-primary-solid .accordion__header {\n  background: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n  box-shadow: 0 -10px 20px 0 rgba(135, 67, 223, 0.15);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.accordion-primary-solid .accordion__header.collapsed {\n  background: #f6f1fd;\n  border-color: #f6f1fd;\n  color: #211c37;\n  box-shadow: none;\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n[data-theme-version=\"dark\"] .accordion-primary-solid .accordion__header.collapsed {\n  background: rgba(135, 67, 223, 0.2);\n  border-color: rgba(135, 67, 223, 0.2);\n  color: #7e7e7e;\n}\n\n.accordion-primary-solid .accordion__body {\n  border: 2px solid #00ADEE;\n  border-top: none;\n  box-shadow: 0 15px 20px 0 rgba(135, 67, 223, 0.15);\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n.accordion-danger .accordion__header {\n  background: #F94687;\n  border-color: #F94687;\n  color: #fff;\n  box-shadow: 0 15px 20px 0 rgba(249, 70, 135, 0.15);\n}\n\n.accordion-danger .accordion__header.collapsed {\n  background: #fff3f7;\n  border-color: #fff3f7;\n  color: #211c37;\n  box-shadow: none;\n}\n\n.accordion-danger-solid .accordion__header {\n  background: #F94687;\n  border-color: #F94687;\n  color: #fff;\n  box-shadow: 0 -10px 20px 0 rgba(249, 70, 135, 0.15);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.accordion-danger-solid .accordion__header.collapsed {\n  background: #fff3f7;\n  border-color: #fff3f7;\n  color: #211c37;\n  box-shadow: none;\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n[data-theme-version=\"dark\"] .accordion-danger-solid .accordion__header.collapsed {\n  background: rgba(249, 70, 135, 0.15);\n  border-color: rgba(249, 70, 135, 0.15);\n  color: #7e7e7e;\n}\n\n.accordion-danger-solid .accordion__body {\n  border: 2px solid #F94687;\n  border-top: none;\n  box-shadow: 0 15px 20px 0 rgba(249, 70, 135, 0.15);\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n.accordion__item {\n  margin-bottom: 1.25rem;\n}\n\n.accordion__header {\n  padding: 1rem 1.75rem;\n  border: 1px solid #f0f1f5;\n  cursor: pointer;\n  position: relative;\n  color: #333;\n  font-weight: 400;\n  border-radius: 1.25rem;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n[data-theme-version=\"dark\"] .accordion__header {\n  color: #fff;\n  border-color: #333a54;\n}\n\n.accordion__header--indicator {\n  font-family: 'themify';\n  position: absolute;\n  right: 1.5625rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n[direction=\"rtl\"] .accordion__header--indicator {\n  right: auto;\n  left: 1.5625rem;\n}\n\n.accordion__header--indicator.indicator_bordered {\n  display: inline-block;\n  width: 25px;\n  text-align: center;\n  height: 25px;\n  border: 1px solid #f0f1f5;\n  border-radius: 50%;\n  line-height: 25px;\n}\n\n.accordion__header:not(.collapsed) .accordion__header--indicator::before {\n  content: \"\\e622\";\n}\n\n.accordion__header:not(.collapsed) .accordion__header--indicator.style_two::before {\n  content: \"\\e648\";\n}\n\n.accordion__header.collapsed .accordion__header--indicator::before {\n  content: \"\\e61a\";\n}\n\n.accordion__header.collapsed .accordion__header--indicator.style_two::before {\n  content: \"\\e64b\";\n}\n\n.accordion__body--text {\n  padding: 0.875rem 1.25rem;\n}\n\n.accordion-bordered .accordion__body {\n  border: 1px solid #f0f1f5;\n  border-top: none;\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n[data-theme-version=\"dark\"] .accordion-bordered .accordion__body {\n  border-color: #333a54;\n}\n\n.accordion-bordered .accordion__header.collapsed {\n  border-radius: 1.25rem;\n}\n\n.accordion-bordered .accordion__header {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.accordion-no-gutter .accordion__item {\n  margin-bottom: 0;\n}\n\n.accordion-no-gutter .accordion__item .accordion__header.collapsed {\n  border-bottom: none;\n}\n\n.accordion-no-gutter .accordion__item:last-child .accordion__header {\n  border-bottom: 1px solid #f0f1f5;\n}\n\n[data-theme-version=\"dark\"] .accordion-no-gutter .accordion__item:last-child .accordion__header {\n  border-color: #333a54;\n}\n\n.accordion-no-gutter.accordion__bordered .accordion__item:not(:last-child) .accordion__body {\n  border-bottom: none;\n}\n\n.accordion-left-indicator .accordion__header--text {\n  padding-left: 2.5rem;\n}\n\n.accordion-left-indicator .accordion__header--indicator {\n  right: auto;\n  left: 1.5625rem;\n}\n\n.accordion-with-icon .accordion__header--text {\n  padding-left: 2.5rem;\n}\n\n[direction=\"rtl\"] .accordion-with-icon .accordion__header--text {\n  padding-left: 0;\n  padding-right: 2.5rem;\n}\n\n.accordion-with-icon .accordion__header--icon {\n  position: absolute;\n  right: auto;\n  left: 1.5625rem;\n  font-family: 'themify';\n}\n\n[direction=\"rtl\"] .accordion-with-icon .accordion__header--icon {\n  left: auto;\n  right: 1.5625rem;\n}\n\n.accordion-with-icon .accordion__header--icon::before {\n  content: \"\\e645\";\n}\n\n.accordion-header-bg .accordion__header {\n  background-color: #F4F5F9;\n}\n\n[data-theme-version=\"dark\"] .accordion-header-bg .accordion__header {\n  background-color: #181f39;\n  color: #fff;\n}\n\n.accordion-header-bg .accordion__header--primary {\n  background-color: #00ADEE;\n  color: #fff;\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .accordion-header-bg .accordion__header--primary {\n  background-color: #00ADEE;\n}\n\n.accordion-header-bg .accordion__header--info {\n  background-color: #2D28FF;\n  color: #fff;\n  border-color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .accordion-header-bg .accordion__header--info {\n  background-color: #2D28FF;\n}\n\n.accordion-header-bg .accordion__header--success {\n  background-color: #2BC155;\n  color: #fff;\n  border-color: #2BC155;\n}\n\n[data-theme-version=\"dark\"] .accordion-header-bg .accordion__header--success {\n  background-color: #2BC155;\n}\n\n.accordion-header-bg.accordion-no-gutter .accordion__header {\n  border-color: transparent;\n  border-radius: 0;\n}\n\n.accordion-header-bg.accordion-no-gutter .accordion__item:first-child .accordion__header {\n  border-top-left-radius: 1.25rem;\n  border-top-right-radius: 1.25rem;\n}\n\n.accordion-header-bg.accordion-no-gutter .accordion__item:last-child .accordion__header {\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n.accordion.accordion-no-gutter .accordion__header {\n  border-radius: 0;\n}\n\n.accordion.accordion-no-gutter .accordion__header.collapsed {\n  border-radius: 0;\n}\n\n.accordion.accordion-no-gutter .accordion__body {\n  border-radius: 0;\n}\n\n.accordion.accordion-no-gutter .accordion__item:first-child .accordion__header {\n  border-top-left-radius: 1.25rem;\n  border-top-right-radius: 1.25rem;\n}\n\n.accordion.accordion-no-gutter .accordion__item:last-child .accordion__header.collapsed {\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n.accordion.accordion-no-gutter .accordion__item:last-child .accordion__body {\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n.accordion-solid-bg .accordion__header {\n  border-color: transparent;\n  background-color: #f6f1fd;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n[data-theme-version=\"dark\"] .accordion-solid-bg .accordion__header {\n  background-color: #181f39;\n}\n\n.accordion-solid-bg .accordion__header.collapsed {\n  border-radius: 1.25rem;\n}\n\n.accordion-solid-bg .accordion__body {\n  border-color: transparent;\n  background-color: #f6f1fd;\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n[data-theme-version=\"dark\"] .accordion-solid-bg .accordion__body {\n  background-color: #181f39;\n}\n\n.accordion-active-header .accordion__header:not(.collapsed) {\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n  color: #fff;\n}\n\n.accordion-header-shadow .accordion__header {\n  border: none;\n  box-shadow: 0 0 0.9375rem -3px rgba(0, 0, 0, 0.3);\n}\n\n.accordion-rounded-stylish .accordion__header {\n  border-top-left-radius: 0.375rem;\n  border-top-right-radius: 0.375rem;\n}\n\n.accordion-rounded-stylish .accordion__body {\n  border-bottom-left-radius: 0.375rem;\n  border-bottom-right-radius: 0.375rem;\n}\n\n.accordion-rounded .accordion__header {\n  border-radius: 0.3125rem;\n}\n\n.accordion-gradient .accordion__header {\n  color: #fff;\n  background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);\n  border-color: transparent;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.accordion-gradient .accordion__header.collapsed {\n  border-bottom-left-radius: 1.25rem;\n  border-bottom-right-radius: 1.25rem;\n}\n\n.accordion-gradient .accordion__body {\n  color: #fff;\n  background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);\n  border-color: transparent;\n}\n\n.alert {\n  border-radius: 1.25rem;\n  padding: 1rem 3rem 1rem 1.5rem;\n}\n\n.alert p {\n  line-height: 1.5;\n}\n\n.alert-rounded {\n  border-radius: 30px;\n}\n\n.alert-primary {\n  background: #f6f1fd;\n  border-color: #f6f1fd;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .alert-primary {\n  background: rgba(135, 67, 223, 0.2);\n  border-color: rgba(135, 67, 223, 0.2);\n}\n\n.alert-secondary {\n  background: #ddedfa;\n  border-color: #ddedfa;\n  color: #3F9AE0;\n}\n\n[data-theme-version=\"dark\"] .alert-secondary {\n  background: rgba(63, 154, 224, 0.5);\n  border-color: rgba(63, 154, 224, 0.5);\n  color: #7e7e7e;\n}\n\n.alert-success {\n  background: #e3f9e9;\n  border-color: #e3f9e9;\n  color: #2BC155;\n}\n\n[data-theme-version=\"dark\"] .alert-success {\n  background: rgba(43, 193, 85, 0.1);\n  border-color: rgba(43, 193, 85, 0.1);\n}\n\n.alert-warning {\n  background: #fff3eb;\n  border-color: #fff3eb;\n  color: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .alert-warning {\n  background: rgba(255, 155, 82, 0.1);\n  border-color: rgba(255, 155, 82, 0.1);\n}\n\n.alert-danger {\n  background: #fff3f7;\n  border-color: #fff3f7;\n  color: #F94687;\n}\n\n[data-theme-version=\"dark\"] .alert-danger {\n  background: rgba(249, 70, 135, 0.15);\n  border-color: rgba(249, 70, 135, 0.15);\n}\n\n.alert-info {\n  background: #dbdbff;\n  border-color: #dbdbff;\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .alert-info {\n  background: rgba(45, 40, 255, 0.1);\n  border-color: rgba(45, 40, 255, 0.1);\n}\n\n.alert-dark {\n  background: #f1f1f1;\n  border-color: #f1f1f1;\n  color: #B1B1B1;\n}\n\n[data-theme-version=\"dark\"] .alert-dark {\n  background: rgba(177, 177, 177, 0.35);\n  border-color: rgba(177, 177, 177, 0.35);\n  color: #7e7e7e;\n}\n\n.alert-light {\n  background: #F4F5F9;\n  border-color: #F4F5F9;\n  color: #B1B1B1;\n}\n\n.alert-alt.alert-primary {\n  border-left: 4px solid #00ADEE;\n}\n\n.alert-alt.alert-secondary {\n  border-left: 4px solid #3F9AE0;\n}\n\n.alert-alt.alert-success {\n  border-left: 4px solid #2BC155;\n}\n\n.alert-alt.alert-warning {\n  border-left: 4px solid #FF9B52;\n}\n\n.alert-alt.alert-danger {\n  border-left: 4px solid #F94687;\n}\n\n.alert-alt.alert-info {\n  border-left: 4px solid #2D28FF;\n}\n\n.alert-alt.alert-dark {\n  border-left: 4px solid #B1B1B1;\n}\n\n.alert-alt.alert-light {\n  border-left: 4px solid #c3c8de;\n}\n\n.alert-alt.alert-primary.solid {\n  border-left: 4px solid #4a188b !important;\n}\n\n.alert-alt.alert-secondary.solid {\n  border-left: 4px solid #165789 !important;\n}\n\n.alert-alt.alert-success.solid {\n  border-left: 4px solid #145927 !important;\n}\n\n.alert-alt.alert-warning.solid {\n  border-left: 4px solid #d25800 !important;\n}\n\n.alert-alt.alert-danger.solid {\n  border-left: 4px solid #b90647 !important;\n}\n\n.alert-alt.alert-info.solid {\n  border-left: 4px solid #0400a8 !important;\n}\n\n.alert-alt.alert-dark.solid {\n  border-left: 4px solid #717171 !important;\n}\n\n.alert-alt.alert-light.solid {\n  border-left: 4px solid #a2aacc !important;\n}\n\n.alert-dismissible.solid .close:hover {\n  color: #fff;\n  opacity: 1;\n}\n\n.alert.alert-primary.solid {\n  background: #00ADEE;\n  color: #fff;\n  border-color: #00ADEE;\n}\n\n.alert.alert-secondary.solid {\n  background: #3F9AE0;\n  color: #fff;\n  border-color: #3F9AE0;\n}\n\n.alert.alert-success.solid {\n  background: #2BC155;\n  color: #fff;\n  border-color: #2BC155;\n}\n\n.alert.alert-warning.solid {\n  background: #FF9B52;\n  color: #fff;\n  border-color: #FF9B52;\n}\n\n.alert.alert-danger.solid {\n  background: #F94687;\n  color: #fff;\n  border-color: #F94687;\n}\n\n.alert.alert-info.solid {\n  background: #2D28FF;\n  color: #fff;\n  border-color: #2D28FF;\n}\n\n.alert.alert-dark.solid {\n  background: #B1B1B1;\n  color: #fff;\n  border-color: #B1B1B1;\n}\n\n.alert.alert-light.solid {\n  background: #F4F5F9;\n  color: #B1B1B1;\n  border-color: #F4F5F9;\n}\n\n.alert-right-icon>span i {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.alert-right-icon .close i {\n  font-size: 16px;\n}\n\n.alert.alert-outline-primary {\n  background: transparent;\n  color: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.alert.alert-outline-secondary {\n  background: transparent;\n  color: #7e7e7e;\n  border-color: #3F9AE0;\n}\n\n.alert.alert-outline-success {\n  background: transparent;\n  color: #2BC155;\n  border-color: #2BC155;\n}\n\n.alert.alert-outline-info {\n  background: transparent;\n  color: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.alert.alert-outline-warning {\n  background: transparent;\n  color: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.alert.alert-outline-danger {\n  background: transparent;\n  color: #F94687;\n  border-color: #F94687;\n}\n\n.alert.alert-outline-dark {\n  background: transparent;\n  color: #7e7e7e;\n  border-color: #B1B1B1;\n}\n\n.alert.alert-outline-light {\n  background: transparent;\n  color: #B1B1B1;\n  border-color: #F4F5F9;\n}\n\n.alert-social {\n  color: #fff;\n}\n\n.alert-social .alert-social-icon {\n  align-self: center;\n  margin-right: 0.9375rem;\n}\n\n.alert-social .alert-social-icon i {\n  font-size: 42px;\n}\n\n.alert-social.facebook {\n  background-color: #3b5998;\n}\n\n.alert-social.twitter {\n  background-color: #1da1f2;\n}\n\n.alert-social.linkedin {\n  background-color: #007bb6;\n}\n\n.alert-social.google-plus {\n  background-color: #db4439;\n}\n\n.alert-social .close:hover {\n  opacity: 1 !important;\n  color: #fff !important;\n}\n\n.left-icon-big .alert-left-icon-big {\n  align-self: center;\n  margin-right: 0.9375rem;\n}\n\n.left-icon-big .alert-left-icon-big i {\n  font-size: 35px;\n  line-height: 1;\n}\n\n[direction=\"rtl\"] .left-icon-big .alert-left-icon-big,\n[direction=\"rtl\"] .alert-social .alert-social-icon {\n  margin-left: 0;\n  margin-right: 0.9375rem;\n}\n\n.badge {\n  line-height: 1.5;\n  border-radius: 1.25rem;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border: 1px solid transparent;\n}\n\n.badge-rounded {\n  border-radius: 20px;\n  padding: 3px 13px;\n}\n\n.badge-circle {\n  border-radius: 100px;\n  padding: 3px 7px;\n}\n\n.badge-outline-primary {\n  border: 1px solid #00ADEE;\n  color: #00ADEE;\n}\n\n.badge-outline-secondary {\n  border: 1px solid #3F9AE0;\n  color: #3F9AE0;\n}\n\n[data-theme-version=\"dark\"] .badge-outline-secondary {\n  color: #7e7e7e;\n}\n\n.badge-outline-success {\n  border: 1px solid #2BC155;\n  color: #2BC155;\n}\n\n.badge-outline-info {\n  border: 1px solid #2D28FF;\n  color: #2D28FF;\n}\n\n.badge-outline-warning {\n  border: 1px solid #FF9B52;\n  color: #FF9B52;\n}\n\n.badge-outline-danger {\n  border: 1px solid #F94687;\n  color: #F94687;\n}\n\n.badge-outline-light {\n  border: 1px solid #f0f1f5;\n  color: #B1B1B1;\n}\n\n[data-theme-version=\"dark\"] .badge-outline-light {\n  color: #7e7e7e;\n}\n\n.badge-outline-dark {\n  border: 1px solid #B1B1B1;\n  color: #B1B1B1;\n}\n\n[data-theme-version=\"dark\"] .badge-outline-dark {\n  color: #7e7e7e;\n}\n\n.badge-xs {\n  font-size: 10px;\n  padding: 0px 5px;\n  line-height: 18px;\n}\n\n.badge-sm {\n  font-size: 11px;\n  padding: 5px 8px;\n  line-height: 11px;\n}\n\n.badge-lg {\n  font-size: 14px;\n  padding: 0px 10px;\n  line-height: 30px;\n}\n\n.badge-xl {\n  font-size: 15px;\n  padding: 0px 15px;\n  line-height: 35px;\n}\n\n.badge-default {\n  background: #ADB6C7;\n}\n\n.badge-success {\n  background-color: #2BC155;\n}\n\n.badge-info {\n  background-color: #2D28FF;\n}\n\n.badge-primary {\n  background-color: #00ADEE;\n}\n\n.badge-warning {\n  background-color: #FF9B52;\n}\n\n.badge-danger {\n  background-color: #F94687;\n}\n\n.badge-dark {\n  background-color: #B1B1B1;\n}\n\n.badge-light {\n  background-color: #F4F5F9;\n}\n\n.light.badge-default {\n  background: #ADB6C7;\n}\n\n.light.badge-success {\n  background-color: #e3f9e9;\n  color: #2BC155;\n}\n\n[data-theme-version=\"dark\"] .light.badge-success {\n  background-color: rgba(43, 193, 85, 0.1);\n}\n\n.light.badge-info {\n  background-color: #dbdbff;\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .light.badge-info {\n  background-color: rgba(45, 40, 255, 0.1);\n}\n\n.light.badge-primary {\n  background-color: #f6f1fd;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .light.badge-primary {\n  background-color: rgba(135, 67, 223, 0.2);\n}\n\n.light.badge-secondary {\n  background-color: #ddedfa;\n  color: #3F9AE0;\n}\n\n[data-theme-version=\"dark\"] .light.badge-secondary {\n  background-color: rgba(63, 154, 224, 0.5);\n  color: #7e7e7e;\n}\n\n.light.badge-warning {\n  background-color: #fff3eb;\n  color: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .light.badge-warning {\n  background-color: rgba(255, 155, 82, 0.1);\n}\n\n.light.badge-danger {\n  background-color: #fff3f7;\n  color: #F94687;\n}\n\n[data-theme-version=\"dark\"] .light.badge-danger {\n  background-color: rgba(249, 70, 135, 0.15);\n}\n\n.light.badge-dark {\n  background-color: #f1f1f1;\n  color: #B1B1B1;\n}\n\n[data-theme-version=\"dark\"] .light.badge-dark {\n  background-color: rgba(177, 177, 177, 0.35);\n  color: #7e7e7e;\n}\n\n.bootstrap-label .label {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.bootstrap-label .label:last-child {\n  margin-right: 0;\n}\n\n.badge-demo .badge {\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n\n.badge-demo .badge:last-child {\n  margin-right: 0;\n}\n\n.bootstrap-badge-buttons button {\n  margin-right: .2rem;\n  margin-bottom: 1rem;\n}\n\n.bootstrap-badge-buttons button:last-child {\n  margin-right: 0;\n}\n\n.welcome-text span,\n.welcome-text p {\n  display: none;\n}\n\n.page-titles {\n  margin-bottom: 25px;\n  display: block;\n  margin-left: -40px;\n  margin-right: -40px;\n  padding: 20px 40px;\n  margin-top: -15px;\n  background: #E5E6E7;\n  display: block;\n}\n\n.page-titles [class*=\"col-\"] {\n  display: block !important;\n  max-width: 100%;\n  width: 100%;\n  margin: 0;\n}\n\n@media only screen and (max-width: 1600px) {\n  .page-titles {\n    margin-left: -30px;\n    margin-top: 0px;\n    margin-right: -30px;\n    margin-bottom: 30px;\n    padding: 15px 30px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page-titles {\n    margin-left: -15px;\n    margin-top: -15px;\n    margin-right: -15px;\n    margin-bottom: 0px;\n    padding: 15px;\n  }\n}\n\n.page-titles .justify-content-sm-end {\n  align-items: center;\n}\n\n.page-titles h4 {\n  margin-bottom: 10px;\n  margin-top: 0;\n  color: #000;\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n\n.page-titles h4 span {\n  font-size: 1.25rem;\n}\n\n.page-titles .breadcrumb {\n  margin-bottom: 0;\n  padding: 0;\n  background: transparent;\n  /* .breadcrumb-item + .breadcrumb-item {\n        &:before {\n            content: \"\\e606\";\n            font-family: 'simple-line-icons';\n            // font-weight: 4;\n            font-size: 10px;\n        }\n    } */\n}\n\n.page-titles .breadcrumb li {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 18px;\n}\n\n@media only screen and (max-width: 767px) {\n  .page-titles .breadcrumb li {\n    font-size: 15px;\n  }\n}\n\n.page-titles .breadcrumb li a {\n  color: #656773;\n}\n\n.page-titles .breadcrumb li.active a {\n  color: #00ADEE;\n  font-weight: 600;\n}\n\n.page-titles .breadcrumb-datepicker {\n  font-size: 0.75rem;\n  color: #89879f;\n}\n\n.page-titles .breadcrumb-datepicker__icon {\n  font-size: 0.875rem;\n}\n\n.page-titles .breadcrumb-widget .border-dark {\n  border-color: #dee2e6 !important;\n}\n\n.page-titles .breadcrumb-widget h4 {\n  color: #646c9a;\n  font-weight: 600;\n}\n\n@media only screen and (max-width: 575px) {\n  .page-titles .breadcrumb-widget {\n    text-align: left !important;\n    margin-bottom: 0.9375rem;\n  }\n}\n\nbutton {\n  cursor: pointer;\n}\n\nbutton:focus {\n  outline: 0;\n  box-shadow: none;\n}\n\n.btn-primary {\n  color: #fff;\n}\n\n.btn {\n  padding: 0.56rem 1rem;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  font-size: .8rem;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:active,\n.btn.active {\n  outline: 0 !important;\n}\n\n@media only screen and (max-width: 1400px) {\n  .btn {\n    padding: 0.625rem 1rem;\n    font-size: 0.813rem;\n  }\n}\n\n.btn-transparent {\n  background-color: transparent;\n}\n\n.sharp {\n  min-width: 40px;\n  padding: 7px;\n  height: 40px;\n  min-height: 40px;\n}\n\n.sharp.btn-xs {\n  padding: 3px;\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  min-height: 26px;\n}\n\n.light.tp-btn {\n  background-color: transparent;\n}\n\n.light.btn-default {\n  background: #ADB6C7;\n}\n\n.light.btn-success {\n  background-color: #e3f9e9;\n  border-color: #e3f9e9;\n  color: #2BC155;\n}\n\n.light.btn-success g [fill] {\n  fill: #2BC155;\n}\n\n[data-theme-version=\"dark\"] .light.btn-success {\n  background-color: rgba(43, 193, 85, 0.1);\n  border-color: transparent;\n}\n\n.light.btn-success:hover {\n  background-color: #2BC155;\n  border-color: #2BC155;\n  color: #fff;\n}\n\n.light.btn-success:hover g [fill] {\n  fill: #fff;\n}\n\n.light.btn-info {\n  background-color: #dbdbff;\n  border-color: #dbdbff;\n  color: #2D28FF;\n}\n\n.light.btn-info g [fill] {\n  fill: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .light.btn-info {\n  background-color: rgba(45, 40, 255, 0.1);\n  border-color: transparent;\n}\n\n.light.btn-info:hover {\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n  color: #fff;\n}\n\n.light.btn-info:hover g [fill] {\n  fill: #fff;\n}\n\n.light.btn-primary {\n  background-color: #f6f1fd;\n  border-color: #f6f1fd;\n  color: #00ADEE;\n}\n\n.light.btn-primary g [fill] {\n  fill: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .light.btn-primary {\n  background-color: rgba(135, 67, 223, 0.2);\n  border-color: transparent;\n}\n\n.light.btn-primary:hover {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n}\n\n.light.btn-primary:hover g [fill] {\n  fill: #fff;\n}\n\n.light.btn-primary:hover svg path {\n  fill: #fff;\n}\n\n.light.btn-secondary {\n  background-color: #ddedfa;\n  border-color: #ddedfa;\n  color: #3F9AE0;\n}\n\n.light.btn-secondary g [fill] {\n  fill: #3F9AE0;\n}\n\n[data-theme-version=\"dark\"] .light.btn-secondary {\n  background-color: rgba(63, 154, 224, 0.5);\n  border-color: transparent;\n  color: #fff;\n}\n\n.light.btn-secondary:hover {\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n  color: #fff;\n}\n\n.light.btn-secondary:hover g [fill] {\n  fill: #fff;\n}\n\n.light.btn-warning {\n  background-color: #fff3eb;\n  border-color: #fff3eb;\n  color: #FF9B52;\n}\n\n.light.btn-warning g [fill] {\n  fill: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .light.btn-warning {\n  background-color: rgba(255, 155, 82, 0.1);\n  border-color: transparent;\n}\n\n.light.btn-warning:hover {\n  background-color: #FF9B52;\n  border-color: #FF9B52;\n  color: #fff;\n}\n\n.light.btn-warning:hover g [fill] {\n  fill: #fff;\n}\n\n.light.btn-danger {\n  background-color: #fff3f7;\n  border-color: #fff3f7;\n  color: #F94687;\n}\n\n.light.btn-danger g [fill] {\n  fill: #F94687;\n}\n\n[data-theme-version=\"dark\"] .light.btn-danger {\n  background-color: rgba(249, 70, 135, 0.15);\n  border-color: transparent;\n}\n\n.light.btn-danger:hover {\n  background-color: #F94687;\n  border-color: #F94687;\n  color: #fff;\n}\n\n.light.btn-danger:hover g [fill] {\n  fill: #fff;\n}\n\n.light.btn-danger:hover svg path {\n  fill: #fff;\n}\n\n.light.btn-dark {\n  background-color: #f1f1f1;\n  border-color: #f1f1f1;\n  color: #B1B1B1;\n}\n\n.light.btn-dark g [fill] {\n  fill: #B1B1B1;\n}\n\n[data-theme-version=\"dark\"] .light.btn-dark {\n  background-color: rgba(177, 177, 177, 0.35);\n  border-color: transparent;\n  color: #fff;\n}\n\n.light.btn-dark:hover {\n  background-color: #B1B1B1;\n  border-color: #B1B1B1;\n  color: #fff;\n}\n\n.light.btn-dark:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.btn.tp-btn.btn-default {\n  background: #ADB6C7;\n}\n\n.btn.tp-btn.btn-success {\n  color: #2BC155;\n}\n\n.btn.tp-btn.btn-success g [fill] {\n  fill: #2BC155;\n}\n\n.btn.tp-btn.btn-success:hover {\n  background-color: #2BC155;\n  border-color: #2BC155;\n  color: #fff;\n}\n\n.btn.tp-btn.btn-success:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn.btn-info {\n  color: #2D28FF;\n}\n\n.btn.tp-btn.btn-info g [fill] {\n  fill: #2D28FF;\n}\n\n.btn.tp-btn.btn-info:hover {\n  background-color: #2D28FF;\n  border-color: #2D28FF;\n  color: #fff;\n}\n\n.btn.tp-btn.btn-info:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn.btn-primary {\n  color: #00ADEE;\n}\n\n.btn.tp-btn.btn-primary g [fill] {\n  fill: #00ADEE;\n}\n\n.btn.tp-btn.btn-primary:hover {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n}\n\n.btn.tp-btn.btn-primary:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn.btn-secondary {\n  color: #3F9AE0;\n}\n\n.btn.tp-btn.btn-secondary g [fill] {\n  fill: #3F9AE0;\n}\n\n.btn.tp-btn.btn-secondary:hover {\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n  color: #fff;\n}\n\n.btn.tp-btn.btn-secondary:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn.btn-warning {\n  color: #FF9B52;\n}\n\n.btn.tp-btn.btn-warning g [fill] {\n  fill: #FF9B52;\n}\n\n.btn.tp-btn.btn-warning:hover {\n  background-color: #FF9B52;\n  border-color: #FF9B52;\n  color: #fff;\n}\n\n.btn.tp-btn.btn-warning:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn.btn-danger {\n  color: #F94687;\n}\n\n.btn.tp-btn.btn-danger g [fill] {\n  fill: #F94687;\n}\n\n.btn.tp-btn.btn-danger:hover {\n  background-color: #F94687;\n  border-color: #F94687;\n  color: #fff;\n}\n\n.btn.tp-btn.btn-danger:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn.btn-light {\n  color: #B1B1B1;\n}\n\n.btn.tp-btn.btn-light g [fill] {\n  fill: #B1B1B1;\n}\n\n.btn.tp-btn.btn-light:hover {\n  background-color: #F4F5F9;\n  border-color: #F4F5F9;\n  color: #B1B1B1;\n}\n\n.btn.tp-btn.btn-light:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn.btn-dark {\n  color: #B1B1B1;\n}\n\n.btn.tp-btn.btn-dark g [fill] {\n  fill: #B1B1B1;\n}\n\n.btn.tp-btn.btn-dark:hover {\n  background-color: #B1B1B1;\n  border-color: #B1B1B1;\n  color: #fff;\n}\n\n.btn.tp-btn.btn-dark:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn-light {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.btn.tp-btn-light.btn-success {\n  color: #2BC155;\n}\n\n.btn.tp-btn-light.btn-success g [fill] {\n  fill: #2BC155;\n}\n\n.btn.tp-btn-light.btn-success:hover {\n  background-color: #e3f9e9;\n  border-color: #e3f9e9;\n  color: #2BC155;\n}\n\n.btn.tp-btn-light.btn-success:hover g [fill] {\n  fill: #2BC155;\n}\n\n.btn.tp-btn-light.btn-info {\n  color: #2D28FF;\n}\n\n.btn.tp-btn-light.btn-info g [fill] {\n  fill: #2D28FF;\n}\n\n.btn.tp-btn-light.btn-info:hover {\n  background-color: #dbdbff;\n  border-color: #dbdbff;\n  color: #2D28FF;\n}\n\n.btn.tp-btn-light.btn-info:hover g [fill] {\n  fill: #2D28FF;\n}\n\n.btn.tp-btn-light.btn-primary {\n  color: #00ADEE;\n}\n\n.btn.tp-btn-light.btn-primary g [fill] {\n  fill: #00ADEE;\n}\n\n.btn.tp-btn-light.btn-primary:hover {\n  background-color: #f6f1fd;\n  border-color: #f6f1fd;\n  color: #00ADEE;\n}\n\n.btn.tp-btn-light.btn-primary:hover g [fill] {\n  fill: #00ADEE;\n}\n\n.btn.tp-btn-light.btn-secondary {\n  color: #3F9AE0;\n}\n\n.btn.tp-btn-light.btn-secondary g [fill] {\n  fill: #3F9AE0;\n}\n\n.btn.tp-btn-light.btn-secondary:hover {\n  background-color: #ddedfa;\n  border-color: #ddedfa;\n  color: #3F9AE0;\n}\n\n.btn.tp-btn-light.btn-secondary:hover g [fill] {\n  fill: #3F9AE0;\n}\n\n.btn.tp-btn-light.btn-warning {\n  color: #FF9B52;\n}\n\n.btn.tp-btn-light.btn-warning g [fill] {\n  fill: #FF9B52;\n}\n\n.btn.tp-btn-light.btn-warning:hover {\n  background-color: #fff3eb;\n  border-color: #fff3eb;\n  color: #FF9B52;\n}\n\n.btn.tp-btn-light.btn-warning:hover g [fill] {\n  fill: #FF9B52;\n}\n\n.btn.tp-btn-light.btn-danger {\n  color: #F94687;\n}\n\n.btn.tp-btn-light.btn-danger g [fill] {\n  fill: #F94687;\n}\n\n.btn.tp-btn-light.btn-danger:hover {\n  background-color: #fff3f7;\n  border-color: #fff3f7;\n  color: #F94687;\n}\n\n.btn.tp-btn-light.btn-danger:hover g [fill] {\n  fill: #fff;\n}\n\n.btn.tp-btn-light.btn-dark {\n  color: #B1B1B1;\n}\n\n.btn.tp-btn-light.btn-dark g [fill] {\n  fill: #B1B1B1;\n}\n\n.btn.tp-btn-light.btn-dark:hover {\n  background-color: #f1f1f1;\n  border-color: #f1f1f1;\n  color: #B1B1B1;\n}\n\n.btn.tp-btn-light.btn-dark:hover [fill] {\n  fill: #fff;\n}\n\n.shadow.btn-primary {\n  -webkit-box-shadow: 0 5px 15px 0 rgba(135, 67, 223, 0.2) !important;\n  box-shadow: 0 5px 15px 0 rgba(135, 67, 223, 0.2) !important;\n}\n\n.shadow.btn-secondary {\n  -webkit-box-shadow: 0 5px 15px 0 rgba(63, 154, 224, 0.2) !important;\n  box-shadow: 0 5px 15px 0 rgba(63, 154, 224, 0.2) !important;\n}\n\n.shadow.btn-warning {\n  -webkit-box-shadow: 0 5px 15px 0 rgba(255, 155, 82, 0.2) !important;\n  box-shadow: 0 5px 15px 0 rgba(255, 155, 82, 0.2) !important;\n}\n\n.shadow.btn-danger {\n  -webkit-box-shadow: 0 5px 15px 0 rgba(249, 70, 135, 0.2) !important;\n  box-shadow: 0 5px 15px 0 rgba(249, 70, 135, 0.2) !important;\n}\n\n.shadow.btn-info {\n  -webkit-box-shadow: 0 5px 15px 0 rgba(45, 40, 255, 0.2) !important;\n  box-shadow: 0 5px 15px 0 rgba(45, 40, 255, 0.2) !important;\n}\n\n.shadow.btn-success {\n  -webkit-box-shadow: 0 5px 15px 0 rgba(43, 193, 85, 0.2) !important;\n  box-shadow: 0 5px 15px 0 rgba(43, 193, 85, 0.2) !important;\n}\n\n.btn-xxs {\n  padding: 6px 15px;\n  font-size: 11px;\n  line-height: 1.3;\n}\n\n.btn-xs {\n  font-size: 0.75rem;\n  padding: 0.438rem 1rem;\n  font-weight: 600;\n}\n\n@media only screen and (max-width: 1400px) {\n  .btn-xs {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n    font-weight: 500;\n  }\n}\n\n.btn-sm,\n.btn-group-sm>.btn {\n  font-size: 0.813rem !important;\n  padding: 0.625rem 1rem;\n}\n\n@media only screen and (max-width: 1400px) {\n\n  .btn-sm,\n  .btn-group-sm>.btn {\n    padding: 0.375rem 1rem;\n    font-size: 0.75rem;\n  }\n}\n\n.btn-md {\n  font-size: 0.813rem !important;\n  padding: 0.875rem 1.25rem;\n}\n\n@media only screen and (max-width: 1400px) {\n  .btn-md {\n    padding: 0.5rem 1rem;\n    font-size: 0.813rem;\n  }\n}\n\n.btn-lg,\n.btn-group-lg>.btn {\n  padding: 1rem 2rem;\n  font-size: 1.125rem !important;\n}\n\n@media only screen and (max-width: 1400px) {\n\n  .btn-lg,\n  .btn-group-lg>.btn {\n    padding: 0.75rem 1.5rem;\n    font-size: 1rem !important;\n  }\n}\n\n.btn-xl {\n  padding: 0.6rem 1rem;\n}\n\n.btn-xl.btn-default {\n  font-weight: 600;\n}\n\n.btn-square {\n  border-radius: 0;\n}\n\n.btn-rounded {\n  border-radius: 30px !important;\n}\n\n.btn-icon-right {\n  border-left: 1px solid white;\n  display: inline-block;\n  margin: -.8rem 0 -.8rem 1rem;\n  padding: 0.4375rem 0 0.4375rem 1rem;\n  margin: -1rem -0.25rem -1rem 1rem;\n  padding: 1rem 0 1rem 1.25rem;\n}\n\n@media only screen and (max-width: 1400px) {\n  .btn-icon-right {\n    padding: 1rem 0 1rem 0.6rem;\n  }\n}\n\n.btn-icon-left {\n  background: #fff;\n  border-radius: 10rem;\n  display: inline-block;\n  margin: -0.5rem 0.75rem -0.5rem -1.188rem;\n  padding: 0.5rem 0.80rem 0.5rem;\n  float: left;\n}\n\n@media only screen and (max-width: 1199px) {\n  .btn-icon-left {\n    margin: -0.5rem 0.75rem -0.5rem -0.800rem;\n  }\n}\n\n[direction=\"rtl\"] .btn-icon-left {\n  margin: -.5rem -1.5rem -.5rem 1rem;\n}\n\n[direction=\"rtl\"] .btn-icon-right {\n  border-left: 0px solid white;\n  display: inline-block;\n  margin: -.8rem 1rem -.8rem 0;\n  padding: 0.4375rem 1rem 0.4375rem 0;\n  border-right: 1px solid white;\n}\n\n.toggle-dropdown::after {\n  margin-left: 0.755em;\n}\n\n.social-btn-icon .btn {\n  min-width: 7.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.social-icon .btn {\n  padding: .7rem 1.4rem;\n}\n\n.btn-circle {\n  height: 5rem;\n  width: 5rem;\n  border-radius: 50% !important;\n}\n\n.btn-circle-sm {\n  width: 4.5rem;\n  height: 4.5rem;\n  font-size: 1.8rem;\n}\n\n.btn-circle-md {\n  width: 6rem;\n  height: 6rem;\n  font-size: 2.5rem;\n}\n\n.btn-circle-md i {\n  font-size: 2.4rem;\n}\n\n.btn-circle-lg {\n  width: 8rem;\n  height: 8rem;\n  font-size: 3.2rem;\n}\n\n.btn-circle-lg i {\n  font-size: 3.1rem;\n}\n\n.btn-page .btn {\n  min-width: 110px;\n  margin-right: 4px;\n  margin-bottom: 8px;\n}\n\n.size-1 {\n  min-width: 160px !important;\n  font-size: 24px;\n  padding: 0.68rem 0.75rem;\n}\n\n.size-2 {\n  font-size: 20px;\n  min-width: 130px !important;\n  padding: 0.57rem 0.75rem;\n}\n\n.size-3 {\n  font-size: 14px;\n  min-width: 110px !important;\n  padding: 0.536rem 0.75rem;\n}\n\n.size-4 {\n  font-size: 14px;\n  min-width: 100px !important;\n}\n\n.size-5 {\n  font-size: 14px;\n  min-width: 90px !important;\n  padding: .22rem 0.75rem;\n}\n\n.size-6 {\n  font-size: 13px;\n  min-width: 80px !important;\n  padding: 0.097rem 0.75rem;\n}\n\n.size-7 {\n  font-size: 12px;\n  min-width: 60px !important;\n  padding: 0.001rem 0.75rem;\n}\n\n.btn-light {\n  background: #F4F5F9;\n  border-color: #F4F5F9;\n}\n\n.btn-light:active,\n.btn-light:focus,\n.btn-light:hover {\n  background: white;\n  border-color: white;\n}\n\n.btn-outline-primary:hover {\n  color: #fff;\n}\n\n.btn-outline-light {\n  color: #B1B1B1;\n}\n\n[data-theme-version=\"dark\"] .btn-outline-light {\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .btn-outline-secondary {\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .btn-outline-dark {\n  color: #7e7e7e;\n}\n\n.btn-dark {\n  background: #B1B1B1;\n  border-color: #B1B1B1;\n  color: #fff;\n}\n\n.btn-dark:active,\n.btn-dark:focus,\n.btn-dark:hover {\n  background: #989898;\n  color: #fff;\n  border-color: #989898;\n}\n\n.btn-group.btn-rounded .btn:first-child {\n  border-top-left-radius: 30px;\n  border-bottom-left-radius: 30px;\n}\n\n.btn-group.btn-rounded .btn:last-child {\n  border-top-right-radius: 30px;\n  border-bottom-right-radius: 30px;\n}\n\n.btn-facebook {\n  background: #3b5998;\n  border-color: #3b5998;\n  color: #fff;\n}\n\n.btn-facebook:active,\n.btn-facebook:focus,\n.btn-facebook:hover {\n  background: #2d4373;\n  color: #fff;\n  border-color: #2d4373;\n}\n\n.btn-twitter {\n  background: #1da1f2;\n  border-color: #1da1f2;\n  color: #fff;\n}\n\n.btn-twitter:active,\n.btn-twitter:focus,\n.btn-twitter:hover {\n  background: #0c85d0;\n  color: #fff;\n  border-color: #0c85d0;\n}\n\n.btn-youtube {\n  background: #FF0000;\n  border-color: #FF0000;\n  color: #fff;\n}\n\n.btn-youtube:active,\n.btn-youtube:focus,\n.btn-youtube:hover {\n  background: #cc0000;\n  color: #fff;\n  border-color: #cc0000;\n}\n\n.btn-instagram {\n  background: #c32aa3;\n  border-color: #c32aa3;\n  color: #fff;\n}\n\n.btn-instagram:active,\n.btn-instagram:focus,\n.btn-instagram:hover {\n  background: #992180;\n  color: #fff;\n  border-color: #992180;\n}\n\n.btn-pinterest {\n  background: #bd081c;\n  border-color: #bd081c;\n  color: #fff;\n}\n\n.btn-pinterest:active,\n.btn-pinterest:focus,\n.btn-pinterest:hover {\n  background: #8c0615;\n  color: #fff;\n  border-color: #8c0615;\n}\n\n.btn-linkedin {\n  background: #007bb6;\n  border-color: #007bb6;\n  color: #fff;\n}\n\n.btn-linkedin:active,\n.btn-linkedin:focus,\n.btn-linkedin:hover {\n  background: #005983;\n  color: #fff;\n  border-color: #005983;\n}\n\n.btn-google-plus {\n  background: #db4439;\n  border-color: #db4439;\n  color: #fff;\n}\n\n.btn-google-plus:active,\n.btn-google-plus:focus,\n.btn-google-plus:hover {\n  background: #be2d23;\n  color: #fff;\n  border-color: #be2d23;\n}\n\n.btn-google {\n  background: #4285f4;\n  border-color: #4285f4;\n  color: #fff;\n}\n\n.btn-google:active,\n.btn-google:focus,\n.btn-google:hover {\n  background: #1266f1;\n  color: #fff;\n  border-color: #1266f1;\n}\n\n.btn-snapchat {\n  background: #fffc00;\n  border-color: #fffc00;\n  color: #000;\n}\n\n.btn-snapchat:active,\n.btn-snapchat:focus,\n.btn-snapchat:hover {\n  background: #ccca00;\n  color: #000;\n  border-color: #ccca00;\n}\n\n.btn-whatsapp {\n  background: #25d366;\n  border-color: #25d366;\n  color: #fff;\n}\n\n.btn-whatsapp:active,\n.btn-whatsapp:focus,\n.btn-whatsapp:hover {\n  background: #1da851;\n  color: #fff;\n  border-color: #1da851;\n}\n\n.btn-tumblr {\n  background: #35465d;\n  border-color: #35465d;\n  color: #fff;\n}\n\n.btn-tumblr:active,\n.btn-tumblr:focus,\n.btn-tumblr:hover {\n  background: #222e3d;\n  color: #fff;\n  border-color: #222e3d;\n}\n\n.btn-reddit {\n  background: #ff4500;\n  border-color: #ff4500;\n  color: #fff;\n}\n\n.btn-reddit:active,\n.btn-reddit:focus,\n.btn-reddit:hover {\n  background: #cc3700;\n  color: #fff;\n  border-color: #cc3700;\n}\n\n.btn-spotify {\n  background: #1ed760;\n  border-color: #1ed760;\n  color: #fff;\n}\n\n.btn-spotify:active,\n.btn-spotify:focus,\n.btn-spotify:hover {\n  background: #18aa4c;\n  color: #fff;\n  border-color: #18aa4c;\n}\n\n.btn-yahoo {\n  background: #430297;\n  border-color: #430297;\n  color: #fff;\n}\n\n.btn-yahoo:active,\n.btn-yahoo:focus,\n.btn-yahoo:hover {\n  background: #2d0165;\n  color: #fff;\n  border-color: #2d0165;\n}\n\n.btn-dribbble {\n  background: #ea4c89;\n  border-color: #ea4c89;\n  color: #fff;\n}\n\n.btn-dribbble:active,\n.btn-dribbble:focus,\n.btn-dribbble:hover {\n  background: #e51e6b;\n  color: #fff;\n  border-color: #e51e6b;\n}\n\n.btn-skype {\n  background: #00aff0;\n  border-color: #00aff0;\n  color: #fff;\n}\n\n.btn-skype:active,\n.btn-skype:focus,\n.btn-skype:hover {\n  background: #008abd;\n  color: #fff;\n  border-color: #008abd;\n}\n\n.btn-quora {\n  background: #aa2200;\n  border-color: #aa2200;\n  color: #fff;\n}\n\n.btn-quora:active,\n.btn-quora:focus,\n.btn-quora:hover {\n  background: #771800;\n  color: #fff;\n  border-color: #771800;\n}\n\n.btn-vimeo {\n  background: #1ab7ea;\n  border-color: #1ab7ea;\n  color: #fff;\n}\n\n.btn-vimeo:active,\n.btn-vimeo:focus,\n.btn-vimeo:hover {\n  background: #1295bf;\n  color: #fff;\n  border-color: #1295bf;\n}\n\n.card {\n  margin-bottom: 1.875rem;\n  background-color: #fff;\n  transition: all .5s ease-in-out;\n  position: relative;\n  border: 0px solid transparent;\n  border-radius: 0.5rem;\n  box-shadow: 0px 12px 23px 0px rgba(63, 154, 224, 0.04);\n  height: calc(100% - 30px);\n}\n\n@media only screen and (max-width: 575px) {\n  .card {\n    margin-bottom: 0.938rem;\n    height: calc(100% - 0.938rem);\n  }\n}\n\n.card-body {\n  padding: 1.875rem;\n}\n\n@media only screen and (max-width: 575px) {\n  .card-body {\n    padding: 1rem;\n  }\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: 500;\n  color: #000;\n  text-transform: capitalize;\n}\n\n.card-title--large {\n  font-size: 1.5rem;\n}\n\n.card-title--medium {\n  font-size: 1rem;\n}\n\n.card-title--small {\n  font-size: 0.875rem;\n}\n\n.card-header {\n  border-color: #f0f1f5;\n  position: relative;\n  background: transparent;\n  padding: 1.5rem 1.875rem 1.25rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media only screen and (max-width: 575px) {\n  .card-header {\n    padding: 1.25rem 1rem 1.25rem;\n  }\n}\n\n[data-theme-version=\"dark\"] .card-header {\n  border-color: #333a54;\n}\n\n.card-header .card-title {\n  margin-bottom: 0px;\n}\n\n.card-header .subtitle {\n  padding-top: 5px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.card-footer {\n  border-color: #f0f1f5;\n  background: transparent;\n  padding: 1.25rem 1.875rem 1.25rem;\n}\n\n[data-theme-version=\"dark\"] .card-footer {\n  border-color: #333a54;\n}\n\n@media only screen and (max-width: 575px) {\n  .card-footer {\n    padding: 1rem;\n  }\n}\n\n.transparent-card.card {\n  background: transparent;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n\n.card-action>a {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  border-radius: 5px;\n  border-color: transparent;\n  text-align: center;\n  background: black;\n  color: #fff;\n  margin-right: 8px;\n}\n\n[data-theme-version=\"dark\"] .card-action>a {\n  background: #181f39;\n}\n\n.card-action>a:last-child {\n  margin-right: 0;\n}\n\n.card-action>a:hover,\n.card-action>a:focus {\n  background: black;\n}\n\n[data-theme-version=\"dark\"] .card-action>a:hover,\n[data-theme-version=\"dark\"] .card-action>a:focus {\n  background: #181f39;\n}\n\n.card-action>a i,\n.card-action>a span {\n  font-size: 1rem;\n}\n\n.card-action .dropdown {\n  width: 30px;\n  height: 30px;\n  border-radius: 5px;\n  border-color: transparent;\n  text-align: center;\n  margin-right: 8px;\n  top: -2px;\n  position: relative;\n  display: inline-block;\n  background: black;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .card-action .dropdown {\n  background: #181f39;\n}\n\n.card-action .dropdown:hover,\n.card-action .dropdown:focus {\n  background: black;\n}\n\n[data-theme-version=\"dark\"] .card-action .dropdown:hover,\n[data-theme-version=\"dark\"] .card-action .dropdown:focus {\n  background: #181f39;\n}\n\n.card-action .dropdown .btn {\n  padding: 0;\n  line-height: 27px;\n  color: #fff;\n}\n\n.card-action .dropdown .btn:focus {\n  box-shadow: none;\n}\n\n.card-fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999999;\n  overflow: auto;\n}\n\n.card-loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.75);\n  z-index: 999;\n}\n\n.card-loader i {\n  margin: 0 auto;\n  background: #7425d9;\n  padding: 10px;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 1rem;\n}\n\n.rotate-refresh {\n  -webkit-animation: mymove 0.8s infinite linear;\n  animation: mymove 0.8s infinite linear;\n  display: inline-block;\n}\n\n.card-header .date_picker {\n  display: inline-block;\n  padding: 8px;\n  border: 1px solid #f0f1f5;\n  cursor: pointer;\n  border-radius: .375rem;\n}\n\n.card-header .border-0 {\n  padding-bottom: 0;\n}\n\n@-webkit-keyframes mymove {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes mymove {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.carousel-custom-prev,\n.carousel-custom-next {\n  width: 2.5rem;\n  height: 2.5rem;\n  line-height: 2.5rem;\n  display: inline-block;\n  border-radius: 50%;\n  background: #fff;\n  text-align: center;\n}\n\n.carousel-custom-prev i,\n.carousel-custom-next i {\n  font-size: 1rem;\n}\n\n.carousel-custom-prev:hover,\n.carousel-custom-next:hover {\n  background: linear-gradient(to right, rgba(245, 60, 121, 0.99) 0%, rgba(246, 104, 47, 0.99) 100%);\n  color: #fff;\n}\n\n.carousel-custom-next {\n  position: absolute;\n  top: 50%;\n  right: 30px;\n  transform: translateY(-50%);\n}\n\n.carousel-custom-prev {\n  position: absolute;\n  top: 50%;\n  left: 30px;\n  transform: translateY(-50%);\n}\n\n.carousel-caption {\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.78);\n  z-index: 0;\n}\n\n.carousel-caption h5 {\n  color: #fff;\n  font-size: 1.8rem;\n}\n\n.carousel-caption p {\n  margin-bottom: 0;\n}\n\n.dropdown-toggle:focus {\n  box-shadow: none !important;\n}\n\n.dropdown-outline {\n  border: 0.1rem solid #00ADEE;\n}\n\n.dropdown-menu {\n  font-size: inherit;\n  border: 0;\n  box-shadow: 0 10px 40px 0 rgba(32, 28, 69, 0.1);\n  margin-top: 0;\n  border-radius: 0;\n}\n\n.dropdown-menu .dropdown-item {\n  font-size: 16px;\n  color: #7e7e7e;\n  padding: 0.5rem 1.75rem;\n}\n\n@media only screen and (max-width: 1400px) {\n  .dropdown-menu .dropdown-item {\n    padding: 0.375rem 1rem;\n    font-size: 14px;\n  }\n}\n\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus,\n.dropdown-menu .dropdown-item:active,\n.dropdown-menu .dropdown-item.active {\n  color: #00ADEE;\n  background: #F4F5F9;\n}\n\n.dropdown-menu .dropdown-item.active,\n.dropdown-menu .dropdown-item:active {\n  color: #00ADEE !important;\n}\n\n[direction=\"rtl\"] .dropdown-menu {\n  right: auto !important;\n}\n\n.dropdown-toggle-split {\n  padding: 0 10px;\n  opacity: 0.85;\n}\n\n.dropdown-toggle-split:after {\n  margin-left: 0 !important;\n}\n\n.dropdown-toggle-split:active,\n.dropdown-toggle-split:focus,\n.dropdown-toggle-split:hover {\n  opacity: 1;\n}\n\n.dropleft .dropdown-toggle:before,\n.dropright .dropdown-toggle:before,\n.dropup .dropdown-toggle:after,\n.dropdown-toggle:after {\n  content: \"\\f107\";\n  font-family: FontAwesome;\n  border: 0;\n  vertical-align: middle;\n  margin-left: 0.25em;\n  line-height: 1;\n}\n\n.dropup .dropdown-toggle:after {\n  content: \"\\f106\";\n}\n\n.dropleft .dropdown-toggle::before {\n  content: \"\\f104\";\n}\n\n.dropright .dropdown-toggle::before {\n  content: \"\\f105\";\n}\n\n.dropright .dropdown-toggle::after {\n  content: none;\n}\n\n.custom-dropdown {\n  display: inline-block;\n  margin-bottom: 1rem;\n}\n\n.custom-dropdown .dropdown-menu {\n  border: 0px;\n  min-width: 160px;\n}\n\n.card-action .custom-dropdown {\n  margin: 0px;\n  background: #dac6f5;\n}\n\n.card-action .custom-dropdown.show,\n.card-action .custom-dropdown:focus,\n.card-action .custom-dropdown:hover {\n  background: #00ADEE;\n  color: #fff;\n}\n\n.card-action .custom-dropdown i {\n  display: inline-block;\n  padding-top: 9px;\n}\n\n.dropdown .dropdown-dots {\n  position: relative;\n  height: 5px;\n  width: 5px;\n  background: rgba(177, 177, 177, 0.4);\n  border-radius: 5px;\n  display: block;\n}\n\n.dropdown .dropdown-dots:after,\n.dropdown .dropdown-dots:before {\n  content: \"\";\n  height: 5px;\n  width: 5px;\n  background: rgba(177, 177, 177, 0.4);\n  position: absolute;\n  border-radius: 5px;\n}\n\n.dropdown .dropdown-dots:after {\n  right: -8px;\n}\n\n.dropdown .dropdown-dots:before {\n  left: -8px;\n}\n\n.dropdown .dropdown-dots.text-white {\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.dropdown .dropdown-dots.text-white:after,\n.dropdown .dropdown-dots.text-white:before {\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.grid-col {\n  padding: 0.5rem !important;\n  background: #f2f4fa;\n}\n\n.row.grid {\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.row.grid .grid-col:first-child {\n  text-align: left;\n}\n\n.label {\n  display: inline-block;\n  text-align: center;\n  font-size: 0.75rem;\n  padding: .2rem .8rem;\n}\n\n.label-fixed {\n  width: 7.5rem;\n  padding: .6rem 0;\n}\n\n.label-fixed-lg {\n  width: 9.5rem;\n  padding: .6rem 0;\n}\n\n.label-big {\n  width: 16.8rem;\n  font-size: 1.4rem;\n  padding: 1.1rem 0;\n}\n\n.label-xl {\n  width: 10.5rem;\n  padding: 1.1rem 0;\n  font-size: 1.5rem;\n}\n\n.label-lg {\n  width: 9.5rem;\n  padding: 1.1rem 0;\n}\n\n.label-md {\n  width: 8.5rem;\n  padding: 1.1rem 0;\n}\n\n.label-sm {\n  width: 7.5rem;\n  padding: 1.1rem 0;\n}\n\n.label-default {\n  background: #ADB6C7;\n}\n\n.label-primary {\n  background: #00ADEE;\n  color: #fff;\n}\n\n.label-secondary {\n  background: #3F9AE0;\n  color: #fff;\n}\n\n.label-info {\n  background: #2D28FF;\n  color: #fff;\n}\n\n.label-success {\n  background: #2BC155;\n  color: #fff;\n}\n\n.label-warning {\n  background: #FF9B52;\n  color: #fff;\n}\n\n.label-danger {\n  background: #F94687;\n  color: #fff;\n}\n\n.label-light {\n  background: #F4F5F9;\n  color: #000;\n}\n\n.label-dark {\n  background: #B1B1B1;\n  color: #fff;\n}\n\ncode {\n  word-break: break-word;\n  padding: 2px 5px;\n  border-radius: 3px;\n  background: #fee9f1;\n  color: #F94687;\n}\n\n[data-theme-version=\"dark\"] code {\n  background: rgba(249, 70, 135, 0.1);\n}\n\n.heading-labels {\n  color: #333333;\n}\n\n.heading-labels>* {\n  margin-bottom: .8rem;\n}\n\n.heading-labels h1 .label {\n  font-size: 18px;\n  font-weight: normal;\n  padding: .4rem .9rem;\n}\n\n.heading-labels h2 .label {\n  font-size: 16px;\n  font-weight: normal;\n  padding: 0.3rem .9rem;\n}\n\n.heading-labels h3 .label {\n  font-size: 14px;\n  font-weight: normal;\n}\n\n.heading-labels h4 .label {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.heading-labels h5 .label {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.heading-labels h6 .label {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.list-group-item {\n  background-color: rgba(255, 255, 255, 0);\n  border: 1px solid #f0f1f5;\n  padding: 1rem 1.5rem;\n  border-radius: 0;\n}\n\n[data-theme-version=\"dark\"] .list-group-item {\n  border-color: #333a54;\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.list-group-item:last-child {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n  color: #fff;\n  background-color: #3F9AE0;\n  border-color: #3F9AE0;\n}\n\n[class*=\"bg-\"] .list-group-item {\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.bg-warning .list-group-item {\n  border-color: rgba(0, 0, 0, 0.05);\n}\n\n.media img {\n  border-radius: 3px;\n}\n\n.vertical-card__menu:hover {\n  box-shadow: none;\n}\n\n.vertical-card__menu--image {\n  text-align: center;\n}\n\n.vertical-card__menu--image img {\n  width: 100%;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.vertical-card__menu--status.closed {\n  background: #F94687;\n}\n\n.vertical-card__menu--status.closed:after {\n  border-top: 10px solid #F94687;\n}\n\n.vertical-card__menu--status.closed .ribbon-curve {\n  border-top: 11px solid #F94687;\n  border-bottom: 10px solid #F94687;\n}\n\n.vertical-card__menu--desc p {\n  margin-bottom: 0.625rem;\n}\n\n.vertical-card__menu--price {\n  font-size: 1.25rem;\n  margin: 0;\n  font-weight: 700;\n}\n\n.vertical-card__menu--rating {\n  font-size: 0.75rem;\n}\n\n.vertical-card__menu--title {\n  font-weight: 700;\n}\n\n.vertical-card__menu--button button {\n  font-size: 0.75rem;\n}\n\n.vertical-card__menu .card-footer {\n  padding: 15px 20px;\n  background-color: #f0f1f5;\n  border-top: none;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1440px) {\n  .vertical-card__menu .card-footer {\n    padding: 15px;\n  }\n}\n\n.vertical-card__menu .card-footer span {\n  color: #B1B1B1;\n  margin-right: 0.3125rem;\n}\n\n.horizontal-card__menu {\n  box-shadow: 0 0 7px rgba(173, 173, 173, 0.32);\n  display: flex;\n  flex-direction: row;\n}\n\n@media (max-width: 575.98px) {\n  .horizontal-card__menu {\n    display: block;\n  }\n}\n\n.horizontal-card__menu .card-body {\n  padding: 0;\n  padding: 20px 30px;\n}\n\n.horizontal-card__menu--image {\n  flex-basis: 30%;\n  max-width: 30%;\n}\n\n.horizontal-card__menu--image img {\n  height: 100%;\n  width: 100%;\n}\n\n@media (max-width: 575.98px) {\n  .horizontal-card__menu--image {\n    max-width: unset;\n    flex-basis: 100%;\n  }\n}\n\n.horizontal-card__menu--title {\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 0.3125rem;\n}\n\n.horizontal-card__menu--fav {\n  margin-right: 0.5rem;\n}\n\n.horizontal-card__menu--price {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.horizontal-card__menu--rating {\n  font-size: 0.625rem;\n}\n\n.horizontal-card__menu--footer {\n  margin-top: 10px;\n}\n\n.prev_price {\n  text-decoration: line-through;\n  font-size: 80%;\n  opacity: 0.5;\n}\n\n.modal-header {\n  padding: 1rem 1.875rem;\n}\n\n.modal-header .close {\n  padding: 0.875rem 1.815rem;\n  margin: 0;\n  position: absolute;\n  right: 0;\n  float: none;\n  top: 0;\n  font-size: 30px;\n  font-weight: 100;\n}\n\n.modal-body {\n  padding: 1.875rem;\n}\n\n.modal-footer {\n  padding: 1rem 1.875rem;\n}\n\n.modal-content {\n  border-radius: 1.25rem;\n}\n\n.modal-backdrop {\n  z-index: 10 !important;\n}\n\n.pagination .page-item .page-link:hover {\n  background: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n}\n\n.pagination .page-item.active .page-link {\n  background: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n}\n\n.pagination {\n  margin-bottom: 20px;\n}\n\n.pagination .page-item.page-indicator .page-link {\n  padding: .65rem .8rem;\n  font-size: 14px;\n}\n\n.pagination .page-item.page-indicator:hover .page-link {\n  color: #B1B1B1;\n}\n\n.pagination .page-item .page-link {\n  text-align: center;\n  z-index: 2;\n  padding: 0.55rem 1rem;\n  font-size: 1rem;\n  background: rgba(255, 255, 255, 0.15);\n  color: #B1B1B1;\n  border: 1px solid #f0f1f5;\n}\n\n[data-theme-version=\"dark\"] .pagination .page-item .page-link {\n  border-color: #333a54;\n  color: #828690;\n  background: rgba(255, 255, 255, 0);\n}\n\n.pagination .page-item .page-link:hover i,\n.pagination .page-item .page-link span {\n  color: #fff;\n}\n\n.pagination .page-item .page-link:focus {\n  outline: 0;\n  box-shadow: none;\n}\n\n.pagination .page-item .page-link:hover {\n  background: #00ADEE;\n  color: #fff;\n  border-color: #00ADEE;\n}\n\n.pagination .page-item.active .page-link {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n  box-shadow: 0 10px 20px 0px rgba(135, 67, 223, 0.2);\n}\n\n[data-theme-version=\"dark\"] .pagination .page-item.active .page-link {\n  color: #fff;\n}\n\n.pagination .page-item .page-link {\n  color: #B1B1B1;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.pagination .page-item:last-child .page-link {\n  margin-right: 0;\n}\n\n[direction=\"rtl\"] .pagination .page-item:first-child .page-link {\n  margin-right: 0;\n}\n\n.pagination.no-bg li:not(.page-indicator):not(.active) .page-link {\n  background: transparent;\n  border-color: transparent;\n}\n\n.pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {\n  background: #00ADEE;\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {\n  background: #00ADEE;\n  border-color: #00ADEE;\n}\n\n.pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {\n  background: #F94687;\n  border-color: #F94687;\n}\n\n[data-theme-version=\"dark\"] .pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {\n  background: #F94687;\n  border-color: #F94687;\n}\n\n.pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {\n  background: #2D28FF;\n  border-color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {\n  background: #2D28FF;\n  border-color: #2D28FF;\n}\n\n.pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {\n  background: #FF9B52;\n  border-color: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {\n  background: #FF9B52;\n  border-color: #FF9B52;\n}\n\n.pagination-primary .page-item .page-link {\n  background: #f6f1fd;\n  border-color: #f6f1fd;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .pagination-primary .page-item .page-link {\n  background: rgba(135, 67, 223, 0.2);\n  border-color: transparent;\n  color: #00ADEE;\n}\n\n.pagination-primary .page-item:hover .page-link,\n.pagination-primary .page-item.active .page-link {\n  background: #00ADEE;\n  border-color: #00ADEE;\n  box-shadow: 0 10px 20px 0px rgba(135, 67, 223, 0.2);\n}\n\n[data-theme-version=\"dark\"] .pagination-primary .page-item:hover .page-link,\n[data-theme-version=\"dark\"] .pagination-primary .page-item.active .page-link {\n  color: #fff;\n}\n\n.pagination-danger .page-item .page-link {\n  background: #fff3f7;\n  border-color: #fff3f7;\n  color: #F94687;\n}\n\n[data-theme-version=\"dark\"] .pagination-danger .page-item .page-link {\n  background: rgba(249, 70, 135, 0.15);\n  border-color: transparent;\n  color: #F94687;\n}\n\n.pagination-danger .page-item:hover .page-link,\n.pagination-danger .page-item.active .page-link {\n  background: #F94687;\n  border-color: #F94687;\n  box-shadow: 0 10px 20px 0px rgba(249, 70, 135, 0.2);\n}\n\n[data-theme-version=\"dark\"] .pagination-danger .page-item:hover .page-link,\n[data-theme-version=\"dark\"] .pagination-danger .page-item.active .page-link {\n  color: #fff;\n}\n\n.pagination-info .page-item .page-link {\n  background: #dbdbff;\n  border-color: #dbdbff;\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .pagination-info .page-item .page-link {\n  background: rgba(45, 40, 255, 0.1);\n  border-color: transparent;\n  color: #2D28FF;\n}\n\n.pagination-info .page-item:hover .page-link,\n.pagination-info .page-item.active .page-link {\n  background: #2D28FF;\n  border-color: #2D28FF;\n  box-shadow: 0 10px 20px 0px rgba(45, 40, 255, 0.2);\n}\n\n.pagination-warning .page-item .page-link {\n  background: #fff3eb;\n  border-color: #fff3eb;\n  color: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .pagination-warning .page-item .page-link {\n  background: rgba(255, 155, 82, 0.1);\n  border-color: transparent;\n  color: #FF9B52;\n}\n\n.pagination-warning .page-item:hover .page-link,\n.pagination-warning .page-item.active .page-link {\n  background: #FF9B52;\n  border-color: #FF9B52;\n  box-shadow: 0 10px 20px 0px rgba(255, 155, 82, 0.2);\n}\n\n.pagination-gutter .page-item {\n  margin-right: 7px;\n}\n\n.pagination-gutter .page-item .page-link {\n  border-radius: 1.25rem !important;\n}\n\n.pagination-circle .page-item {\n  margin-right: 7px;\n}\n\n.pagination-circle .page-item .page-link,\n.pagination-circle .page-item.page-indicator .page-link {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  line-height: 40px;\n  border-radius: 50% !important;\n  padding: 0;\n}\n\n.pagination.pagination-md .page-item .page-link {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  font-size: 14px;\n}\n\n.pagination.pagination-sm .page-item.page-indicator .page-link {\n  font-size: 12px;\n}\n\n.pagination.pagination-sm .page-item .page-link {\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  font-size: 14px;\n}\n\n.pagination.pagination-xs .page-item.page-indicator .page-link {\n  font-size: 10px;\n}\n\n.pagination.pagination-xs .page-item .page-link {\n  padding: 0;\n  width: 25px;\n  height: 25px;\n  line-height: 25px;\n  font-size: 12px;\n}\n\n.popover {\n  border: 2px solid #3F9AE0;\n  min-width: 210px;\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 0;\n}\n\n[data-theme-version=\"dark\"] .popover {\n  background-color: #181f39;\n}\n\n.popover-header {\n  background: #3F9AE0;\n  color: #fff;\n  font-weight: 300;\n  border-radius: 0;\n}\n\n.popover-header::before {\n  border-bottom: 0 !important;\n}\n\n.popover-body {\n  font-size: 0.75rem;\n}\n\n[data-theme-version=\"dark\"] .popover .popover-header {\n  border-color: #1e2746;\n}\n\n.bootstrap-popover-wrapper .bootstrap-popover:not(:last-child) {\n  margin-right: 8px;\n}\n\n.bootstrap-popover-wrapper .bootstrap-popover {\n  margin-bottom: .5rem;\n}\n\n.bootstrap-popover-wrapper .bootstrap-popover button:hover,\n.bootstrap-popover-wrapper .bootstrap-popover button:focus {\n  background: #00ADEE;\n  color: #fff;\n  box-shadow: none;\n}\n\n.bs-popover-top .arrow::after,\n.bs-popover-auto[x-placement^=\"top\"] .arrow::after,\n.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n  bottom: 0px;\n  border-top-color: #3F9AE0;\n}\n\n.bs-popover-left .arrow::after,\n.bs-popover-auto[x-placement^=\"left\"] .arrow::after,\n.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n  right: 0px;\n  border-left-color: #3F9AE0;\n}\n\n.bs-popover-right .arrow::after,\n.bs-popover-auto[x-placement^=\"right\"] .arrow::after,\n.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n  left: 0px;\n  border-right-color: #3F9AE0;\n}\n\n.bs-popover-bottom .arrow::after,\n.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after,\n.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n  top: 0px;\n  border-bottom-color: #3F9AE0;\n}\n\n.note-popover {\n  display: none;\n}\n\n.progress-bar {\n  background-color: #00ADEE;\n}\n\n.progress-bar-primary {\n  background-color: #00ADEE;\n}\n\n.progress-bar-success {\n  background-color: #2BC155;\n}\n\n.progress-bar-info {\n  background-color: #2D28FF;\n}\n\n.progress-bar-danger {\n  background-color: #F94687;\n}\n\n.progress-bar-warning {\n  background-color: #FF9B52;\n}\n\n.progress-bar-pink {\n  background-color: #e83e8c;\n}\n\n.progress {\n  height: 6px;\n  overflow: hidden;\n  border-radius: 1.25rem;\n}\n\n[data-theme-version=\"dark\"] .progress {\n  background-color: #181f39;\n}\n\n.progress-bar {\n  border-radius: 4px;\n}\n\n.progress-vertical {\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 2rem;\n  min-height: 17rem;\n  position: relative;\n}\n\n@media (max-width: 991.98px) {\n  .progress-vertical {\n    margin-right: 1rem;\n  }\n}\n\n.progress-vertical-bottom {\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 2rem;\n  min-height: 17rem;\n  position: relative;\n  transform: rotate(180deg);\n}\n\n@media (max-width: 991.98px) {\n  .progress-vertical-bottom {\n    margin-right: 1rem;\n  }\n}\n\n.progress-animated {\n  animation-duration: 5s;\n  animation-name: myanimation;\n  transition: all 5s ease 0s;\n}\n\n@keyframes myanimation {\n  0% {\n    width: 0;\n  }\n}\n\n@keyframes myanimation {\n  0% {\n    width: 0;\n  }\n}\n\n.ribbon {\n  position: absolute;\n  z-index: 1;\n  text-transform: uppercase;\n}\n\n.ribbon__one {\n  top: 15px;\n  left: -11px;\n  min-height: 20px;\n  min-width: 52px;\n  text-align: center;\n  padding: 3px 10px;\n  background: #3AB54B;\n  color: #fff;\n  font-size: 0.625rem;\n}\n\n.ribbon__one::after {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #239132;\n  border-left: 11px solid transparent;\n  left: 0;\n  content: \"\";\n  bottom: -10px;\n}\n\n.ribbon__two {\n  width: 50px;\n  height: 50px;\n  display: inline-block;\n  background: #FF9B52;\n  line-height: 50px;\n  text-align: center;\n  font-size: 16px;\n  color: #fff;\n  right: 15px;\n  top: 15px;\n  border-radius: 3px;\n}\n\n.ribbon__three {\n  left: -1.875rem;\n  top: 0.875rem;\n  width: 6.875rem;\n  height: 1.5625rem;\n  background-color: #F94687;\n  clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);\n  transform: rotate(-45deg);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.ribbon__four {\n  left: 8px;\n  top: -8px;\n  width: 110px;\n  height: 50px;\n  background-color: #00ADEE;\n  z-index: auto;\n  color: #fff;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ribbon__four:after {\n  right: -5px;\n}\n\n.ribbon__four:before {\n  left: -5px;\n}\n\n.ribbon__four:after,\n.ribbon__four:before {\n  z-index: -1;\n  background-color: #bf9aee;\n  top: 3px;\n  transform: rotate(45deg);\n  content: \"\";\n  height: 10px;\n  width: 10px;\n  position: absolute;\n}\n\n.ribbon__five {\n  left: -1.875rem;\n  top: 0.625rem;\n  width: 6.875rem;\n  height: 1.875rem;\n  background-color: #00ADEE;\n  transform: rotate(-45deg);\n  font-size: 0.75rem;\n  color: #fff;\n  padding-bottom: 0.3125rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n}\n\n.ribbon__five::before {\n  position: absolute;\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 50px 50px 50px;\n  border-color: transparent transparent #00ADEE transparent;\n  left: 0.25rem;\n  top: -2.8125rem;\n}\n\n.ribbon__six {\n  left: 0;\n  top: 1.125rem;\n  width: 6.875rem;\n  height: 2.375rem;\n  background-color: #00ADEE;\n  -webkit-clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n  clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n  display: flex;\n  font-size: 1.25rem;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.ribbon-curve {\n  position: absolute;\n  top: 0;\n  right: -6px;\n  width: 10px;\n  height: 11px;\n  border-top: 11px solid #3AB54B;\n  border-bottom: 10px solid #3AB54B;\n  border-right: 5px solid transparent;\n}\n\n.jsgrid-grid-body::-webkit-scrollbar,\n.dataTables_scrollBody::-webkit-scrollbar,\n.table-responsive::-webkit-scrollbar {\n  background-color: #F5F5F5;\n  width: 8px;\n  height: 8px;\n}\n\n.jsgrid-grid-body::-webkit-scrollbar-track,\n.dataTables_scrollBody::-webkit-scrollbar-track,\n.table-responsive::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #F5F5F5;\n}\n\n.jsgrid-grid-body::-webkit-scrollbar-thumb,\n.dataTables_scrollBody::-webkit-scrollbar-thumb,\n.table-responsive::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #7e7e7e;\n}\n\n.multi-steps>li.is-active:before,\n.multi-steps>li.is-active~li:before {\n  content: counter(stepNum);\n  font-family: inherit;\n  font-weight: 400;\n}\n\n.multi-steps>li.is-active:after,\n.multi-steps>li.is-active~li:after {\n  background-color: #f0f1f5;\n}\n\n.multi-steps {\n  display: table;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.multi-steps>li {\n  counter-increment: stepNum;\n  text-align: center;\n  display: table-cell;\n  position: relative;\n  color: #00ADEE;\n}\n\n@media (max-width: 575.98px) {\n  .multi-steps>li {\n    font-size: 0.75rem;\n  }\n}\n\n.multi-steps>li:before {\n  content: '\\2713';\n  display: block;\n  margin: 0 auto 4px;\n  background-color: #fff;\n  width: 25px;\n  height: 25px;\n  line-height: 22px;\n  text-align: center;\n  font-weight: bold;\n  position: relative;\n  z-index: 1;\n  border-width: 2px;\n  border-style: solid;\n  border-color: #00ADEE;\n  border-radius: 5px;\n}\n\n@media (max-width: 575.98px) {\n  .multi-steps>li:before {\n    width: 25px;\n    height: 25px;\n    line-height: 21px;\n  }\n}\n\n.multi-steps>li:after {\n  content: '';\n  height: 2px;\n  width: 100%;\n  background-color: #00ADEE;\n  position: absolute;\n  top: 12px;\n  left: 50%;\n}\n\n[direction=\"rtl\"] .multi-steps>li:after {\n  left: auto;\n  right: 50%;\n}\n\n@media (max-width: 575.98px) {\n  .multi-steps>li:after {\n    top: 12px;\n  }\n}\n\n.multi-steps>li:last-child:after {\n  display: none;\n}\n\n.multi-steps>li.is-active:before {\n  background-color: #fff;\n  border-color: #00ADEE;\n}\n\n.multi-steps>li.is-active~li {\n  color: #7e7e7e;\n}\n\n.multi-steps>li.is-active~li:before {\n  background-color: #f0f1f5;\n  border-color: #f0f1f5;\n}\n\n.nav-pills .nav-link {\n  border-radius: 1.25rem;\n  padding: 0.75rem 1.25rem;\n}\n\n.default-tab .nav-link {\n  background: transparent;\n  border-radius: 0px;\n  font-weight: 500;\n}\n\n.default-tab .nav-link i {\n  display: inline-block;\n  transform: scale(1.5);\n  color: #00ADEE;\n}\n\n.default-tab .nav-link:focus,\n.default-tab .nav-link:hover,\n.default-tab .nav-link.active {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff #ebeef6;\n  border-radius: 1.25rem 1.25rem 0 0;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .default-tab .nav-link:focus,\n[data-theme-version=\"dark\"] .default-tab .nav-link:hover,\n[data-theme-version=\"dark\"] .default-tab .nav-link.active {\n  background-color: rgba(135, 67, 223, 0.2);\n  border-color: transparent transparent #333a54 transparent;\n}\n\n.custom-tab-1 .nav-link {\n  background: transparent;\n  border-radius: 0px;\n  font-weight: 500;\n  border-bottom: 3px solid transparent;\n  border-width: 0 0px 3px 0;\n}\n\n.custom-tab-1 .nav-link i {\n  display: inline-block;\n  transform: scale(1.5);\n  color: #00ADEE;\n}\n\n.custom-tab-1 .nav-link:focus,\n.custom-tab-1 .nav-link:hover,\n.custom-tab-1 .nav-link.active {\n  color: #495057;\n  background-color: #fff;\n  border-color: #00ADEE;\n  border-radius: 0;\n  color: #00ADEE;\n  border-width: 0 0px 3px 0;\n}\n\n[data-theme-version=\"dark\"] .custom-tab-1 .nav-link:focus,\n[data-theme-version=\"dark\"] .custom-tab-1 .nav-link:hover,\n[data-theme-version=\"dark\"] .custom-tab-1 .nav-link.active {\n  background-color: rgba(135, 67, 223, 0.2);\n}\n\n.nav-pills.light .nav-link.active,\n.nav-pills.light .show>.nav-link {\n  background: #f6f1fd;\n  color: #00ADEE;\n  box-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .nav-pills.light .nav-link.active,\n[data-theme-version=\"dark\"] .nav-pills.light .show>.nav-link {\n  background: rgba(135, 67, 223, 0.2);\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  box-shadow: 0 0 20px 0 rgba(135, 67, 223, 0.2);\n}\n\n.tooltip-wrapper button:not(:last-child) {\n  margin-right: 8px;\n}\n\n.tooltip-wrapper button:hover {\n  background: #00ADEE;\n  color: #fff;\n}\n\n.tooltip-wrapper button {\n  margin-bottom: .5rem;\n}\n\n.tooltip-wrapper button:focus {\n  box-shadow: none;\n}\n\n.tooltip-inner {\n  border-radius: 0;\n  background: #333333;\n  font-size: 12px;\n  font-weight: 300;\n  padding: 0.35rem 0.7rem;\n}\n\n.bs-tooltip-bottom .arrow::before,\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before,\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n  border-bottom-color: #333333;\n}\n\n.bs-tooltip-right .arrow::before,\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before,\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n  border-right-color: #333333;\n}\n\n.bs-tooltip-left .arrow::before,\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before,\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n  border-left-color: #333333;\n}\n\n.bs-tooltip-top .arrow::before,\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before,\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n  border-top-color: #333333;\n}\n\n.widget-timeline .timeline {\n  list-style: none;\n  position: relative;\n}\n\n.widget-timeline .timeline:before {\n  top: 20px;\n  bottom: 0;\n  position: absolute;\n  content: \" \";\n  width: 3px;\n  left: 9px;\n  margin-right: -1.5px;\n  background: #F4F5F9;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline:before {\n  background: #333a54;\n}\n\n[direction=\"rtl\"] .widget-timeline .timeline:before {\n  left: auto;\n  right: 9px;\n  margin-right: auto;\n  margin-left: -1.5px;\n}\n\n.widget-timeline .timeline>li {\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.widget-timeline .timeline>li:before {\n  content: \" \";\n  display: table;\n}\n\n.widget-timeline .timeline>li:after {\n  content: \" \";\n  display: table;\n  clear: both;\n}\n\n.widget-timeline .timeline>li>.timeline-panel {\n  border-radius: 1.25rem;\n  padding: 15px 20px;\n  position: relative;\n  display: block;\n  margin-left: 40px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.widget-timeline .timeline>li>.timeline-panel span {\n  font-size: 12px;\n  display: block;\n  margin-bottom: 5px;\n  opacity: 0.8;\n  letter-spacing: 1px;\n}\n\n.widget-timeline .timeline>li>.timeline-panel p {\n  font-size: 14px;\n}\n\n.widget-timeline .timeline>li>.timeline-panel:after {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: inherit;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0px 0px 1px 1px;\n  display: block;\n  position: absolute;\n  left: -5px;\n  transform: rotate(45deg);\n  top: 15px;\n}\n\n.widget-timeline .timeline>li>.timeline-badge {\n  border-radius: 50%;\n  height: 22px;\n  left: 0;\n  position: absolute;\n  top: 10px;\n  width: 22px;\n  border-width: 2px;\n  border-style: solid;\n  background: #fff;\n  padding: 4px;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline>li>.timeline-badge {\n  background-color: #1e2746;\n}\n\n.widget-timeline .timeline>li>.timeline-badge:after {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  display: block;\n}\n\n[direction=\"rtl\"] .widget-timeline .timeline>li>.timeline-badge {\n  left: auto;\n  right: 19px;\n}\n\n.widget-timeline .timeline-body>p {\n  font-size: 12px;\n}\n\n.widget-timeline .timeline-badge.primary {\n  border-color: #f6f1fd;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.primary {\n  border-color: rgba(135, 67, 223, 0.2);\n}\n\n.widget-timeline .timeline-badge.primary:after {\n  background-color: #00ADEE !important;\n  box-shadow: 0 5px 10px 0 rgba(135, 67, 223, 0.2);\n}\n\n.widget-timeline .timeline-badge.primary+.timeline-panel {\n  background: #f6f1fd;\n  border-color: #f6f1fd;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.primary+.timeline-panel {\n  border-color: transparent;\n  background-color: rgba(135, 67, 223, 0.2);\n}\n\n.widget-timeline .timeline-badge.success {\n  border-color: #e3f9e9;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.success {\n  border-color: rgba(43, 193, 85, 0.1);\n}\n\n.widget-timeline .timeline-badge.success:after {\n  background-color: #2BC155 !important;\n  box-shadow: 0 5px 10px 0 rgba(43, 193, 85, 0.2);\n}\n\n.widget-timeline .timeline-badge.success+.timeline-panel {\n  background: #e3f9e9;\n  border-color: #e3f9e9;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.success+.timeline-panel {\n  background-color: rgba(43, 193, 85, 0.1);\n  border-color: transparent;\n}\n\n.widget-timeline .timeline-badge.warning {\n  border-color: #fff3eb;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.warning {\n  border-color: rgba(255, 155, 82, 0.1);\n}\n\n.widget-timeline .timeline-badge.warning:after {\n  background-color: #FF9B52 !important;\n  box-shadow: 0 5px 10px 0 rgba(255, 155, 82, 0.2);\n}\n\n.widget-timeline .timeline-badge.warning+.timeline-panel {\n  background: #fff3eb;\n  border-color: #fff3eb;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.warning+.timeline-panel {\n  background-color: rgba(255, 155, 82, 0.1);\n  border-color: transparent;\n}\n\n.widget-timeline .timeline-badge.danger {\n  border-color: #fff3f7;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.danger {\n  border-color: rgba(249, 70, 135, 0.15);\n}\n\n.widget-timeline .timeline-badge.danger:after {\n  background-color: #F94687 !important;\n  box-shadow: 0 5px 10px 0 rgba(249, 70, 135, 0.2);\n}\n\n.widget-timeline .timeline-badge.danger+.timeline-panel {\n  background: #fff3f7;\n  border-color: #fff3f7;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.danger+.timeline-panel {\n  background-color: rgba(249, 70, 135, 0.15);\n  border-color: transparent;\n}\n\n.widget-timeline .timeline-badge.info {\n  border-color: #dbdbff;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.info {\n  border-color: rgba(45, 40, 255, 0.1);\n}\n\n.widget-timeline .timeline-badge.info:after {\n  background-color: #2D28FF !important;\n  box-shadow: 0 5px 10px 0 rgba(45, 40, 255, 0.2);\n}\n\n.widget-timeline .timeline-badge.info+.timeline-panel {\n  background: #dbdbff;\n  border-color: #dbdbff;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.info+.timeline-panel {\n  background-color: rgba(45, 40, 255, 0.1);\n  border-color: transparent;\n}\n\n.widget-timeline .timeline-badge.dark {\n  border-color: #f1f1f1;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.dark {\n  border-color: rgba(177, 177, 177, 0.35);\n}\n\n.widget-timeline .timeline-badge.dark:after {\n  background-color: #B1B1B1 !important;\n  box-shadow: 0 5px 10px 0 rgba(177, 177, 177, 0.2);\n}\n\n.widget-timeline .timeline-badge.dark+.timeline-panel {\n  background: #f1f1f1;\n  border-color: #f1f1f1;\n}\n\n[data-theme-version=\"dark\"] .widget-timeline .timeline-badge.dark+.timeline-panel {\n  background-color: rgba(177, 177, 177, 0.35);\n  border-color: transparent;\n}\n\n.widget-timeline.style-1 .timeline-panel {\n  background: transparent;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge+.timeline-panel {\n  background: transparent !important;\n  border-style: solid;\n  border-width: 0 0 0 5px;\n  border-radius: 0;\n  padding: 5px 10px 5px 15px;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge+.timeline-panel:after {\n  border: 0;\n  left: -9px;\n  width: 7px;\n  height: 7px;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.primary+.timeline-panel {\n  border-color: #00ADEE;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.primary+.timeline-panel:after {\n  background: #00ADEE;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.success+.timeline-panel {\n  border-color: #2BC155;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.success+.timeline-panel:after {\n  background: #2BC155;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.warning+.timeline-panel {\n  border-color: #FF9B52;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.warning+.timeline-panel:after {\n  background: #FF9B52;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.danger+.timeline-panel {\n  border-color: #F94687;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.danger+.timeline-panel:after {\n  background: #F94687;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.info+.timeline-panel {\n  border-color: #2D28FF;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.info+.timeline-panel:after {\n  background: #2D28FF;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.dark+.timeline-panel {\n  border-color: #B1B1B1;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.dark+.timeline-panel:after {\n  background: #B1B1B1;\n}\n\n#chart_widget_4 {\n  height: 255px !important;\n}\n\n#chart_widget_5 .ct-series-a .ct-line,\n#chart_widget_5 .ct-series-a .ct-point {\n  stroke: #46ffc8;\n}\n\n#chart_widget_5 .ct-line {\n  stroke-width: 1px;\n}\n\n#chart_widget_5 .ct-point {\n  stroke-width: 2px;\n}\n\n#chart_widget_5 .ct-series-a .ct-area {\n  fill: #43d66c;\n}\n\n#chart_widget_5 .ct-area {\n  fill-opacity: 1;\n}\n\n#chart_widget_6 .ct-series-a .ct-line,\n#chart_widget_6 .ct-series-a .ct-point {\n  stroke: #2D28FF;\n}\n\n#chart_widget_6 .ct-line {\n  stroke-width: 2px;\n}\n\n#chart_widget_6 .ct-point {\n  stroke-width: 5px;\n}\n\n#chart_widget_6 .ct-series-a .ct-area {\n  fill: #2D28FF;\n}\n\n#chart_widget_6 .ct-area {\n  fill-opacity: .5;\n}\n\n#chart_widget_8 {\n  height: 255px;\n}\n\n#chart_widget_8 .ct-series-a .ct-line,\n#chart_widget_8 .ct-series-a .ct-point {\n  stroke: #2D28FF;\n}\n\n#chart_widget_8 .ct-line {\n  stroke-width: 2px;\n}\n\n#chart_widget_8 .ct-point {\n  stroke-width: 5px;\n}\n\n#chart_widget_8 .ct-series-a .ct-area {\n  fill: #2D28FF;\n}\n\n#chart_widget_8 .ct-area {\n  fill-opacity: .5;\n}\n\n#chart_widget_9,\n#chart_widget_10 {\n  height: 250px !important;\n}\n\n#chart_widget_11 .ct-slice-donut,\n#chart_widget_12 .ct-slice-donut,\n#chart_widget_13 .ct-slice-donut {\n  stroke-width: 25px !important;\n}\n\n#chart_widget_11 {\n  height: 270px !important;\n}\n\n#chart_widget_17 {\n  height: 150px !important;\n}\n\n.chart_widget_tab_one .nav-link {\n  border: 1px solid #ddd;\n}\n\n.chart_widget_tab_one .nav-link.active {\n  background-color: #00ADEE;\n  border: 1px solid #00ADEE;\n  color: #fff;\n}\n\n.chart_widget_tab_one .nav-link.active:hover {\n  border: 1px solid #00ADEE;\n}\n\n.chart_widget_tab_one .nav-link:hover {\n  border: 1px solid #ddd;\n}\n\n[data-theme-version=\"dark\"] .ccc-widget>div {\n  background: #1e2746 !important;\n  border-color: #333a54 !important;\n}\n\n.social-icon {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 4px;\n  text-align: center;\n  background: #E5E6E7;\n  margin-bottom: 0.5rem;\n  font-size: 20px;\n}\n\n.social-icon i {\n  color: #fff;\n}\n\n.social-icon.youtube {\n  background: #FF0000;\n}\n\n.social-icon.facebook {\n  background: #3b5998;\n}\n\n.social-icon.twitter {\n  background: #1da1f2;\n}\n\n.social-icon2 a {\n  border: 0.1rem solid #00ADEE;\n  display: block;\n  padding: 1rem;\n  margin-top: 1.5rem;\n  margin-bottom: .5rem;\n  border-radius: .3rem;\n  font-size: 1.6rem;\n}\n\n.social-icon2 i {\n  font-size: 12px;\n  color: #00ADEE;\n}\n\n.social-icon3 ul li {\n  display: inline-block;\n}\n\n.social-icon3 ul li a {\n  display: block;\n}\n\n.social-icon3 ul li a i {\n  font-size: 1.4rem;\n  padding: 1rem .7rem;\n  color: #464a53;\n}\n\n.social-icon3 ul li a:hover i {\n  color: #00ADEE;\n}\n\n.social-icons-muted ul li a i {\n  color: #89879f;\n}\n\n.social-links a {\n  padding: .5rem;\n}\n\n.widget-stat .media {\n  padding: 0px 0;\n  align-items: center;\n}\n\n.widget-stat .media>span {\n  height: 85px;\n  width: 85px;\n  border-radius: 100%;\n  padding: 10px 12px;\n  font-size: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #464a53;\n}\n\n@media only screen and (max-width: 1400px) {\n  .widget-stat .media>span {\n    height: 70px;\n    width: 70px;\n    min-width: 70px;\n  }\n}\n\n.widget-stat .media .media-body p {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n@media only screen and (max-width: 1400px) {\n  .widget-stat .media .media-body p {\n    font-size: 14px;\n  }\n}\n\n[data-theme-version=\"dark\"] .widget-stat .media .media-body p {\n  color: #c4c9d5;\n}\n\n.widget-stat .media .media-body small,\n.widget-stat .media .media-body .small {\n  font-size: 75%;\n}\n\n.widget-stat .media .media-body h3 {\n  font-size: 30px;\n  font-weight: 600;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.widget-stat .media .media-body h4 {\n  font-size: 24px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.widget-stat .media .media-body span {\n  margin-left: 5px;\n}\n\n.widget-stat[class*=\"bg-\"] .media>span {\n  background-color: rgba(255, 255, 255, 0.25);\n  color: #fff;\n}\n\n.widget-stat[class*=\"bg-\"] .progress {\n  background-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n[direction=\"rtl\"] .widget-stat .media .media-body span {\n  margin-left: 0;\n  margin-right: 10px;\n}\n\n.dez-widget-1 .card {\n  background: #FFE7DB;\n}\n\n.dez-widget-1 .card .card-body p {\n  color: #f87533;\n}\n\n.dez-widget-1 .icon {\n  float: right;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  font-size: 28px;\n}\n\n.bgl-primary {\n  background: #f6f1fd;\n  border-color: #f6f1fd;\n}\n\n[data-theme-version=\"dark\"] .bgl-primary {\n  background-color: rgba(135, 67, 223, 0.2);\n  border-color: rgba(135, 67, 223, 0.2);\n}\n\n.bgl-secondary {\n  background: #ddedfa;\n  border-color: #ddedfa;\n}\n\n[data-theme-version=\"dark\"] .bgl-secondary {\n  background-color: rgba(63, 154, 224, 0.5);\n  border-color: rgba(63, 154, 224, 0.5);\n}\n\n.bgl-success {\n  background: #e3f9e9;\n  border-color: #e3f9e9;\n}\n\n[data-theme-version=\"dark\"] .bgl-success {\n  background-color: rgba(43, 193, 85, 0.1);\n  border-color: rgba(43, 193, 85, 0.1);\n}\n\n.bgl-warning {\n  background: #fff3eb;\n  border-color: #fff3eb;\n}\n\n[data-theme-version=\"dark\"] .bgl-warning {\n  background-color: rgba(255, 155, 82, 0.1);\n  border-color: rgba(255, 155, 82, 0.1);\n}\n\n.bgl-danger {\n  background: #fff3f7;\n  border-color: #fff3f7;\n}\n\n[data-theme-version=\"dark\"] .bgl-danger {\n  background-color: rgba(249, 70, 135, 0.15);\n  border-color: rgba(249, 70, 135, 0.15);\n}\n\n.bgl-info {\n  background: #dbdbff;\n  border-color: #dbdbff;\n}\n\n[data-theme-version=\"dark\"] .bgl-info {\n  background-color: rgba(45, 40, 255, 0.1);\n  border-color: rgba(45, 40, 255, 0.1);\n}\n\n.bg-primary-light {\n  background: rgba(246, 241, 253, 0.5);\n}\n\n[data-theme-version=\"dark\"] .bg-primary-light {\n  background-color: rgba(135, 67, 223, 0.05);\n}\n\n.bg-secondary-light {\n  background: rgba(221, 237, 250, 0.5);\n}\n\n[data-theme-version=\"dark\"] .bg-secondary-light {\n  background-color: rgba(63, 154, 224, 0.05);\n}\n\n.bg-success-light {\n  background: rgba(227, 249, 233, 0.5);\n}\n\n[data-theme-version=\"dark\"] .bg-success-light {\n  background-color: rgba(43, 193, 85, 0.05);\n}\n\n.bg-warning-light {\n  background: rgba(255, 243, 235, 0.5);\n}\n\n[data-theme-version=\"dark\"] .bg-warning-light {\n  background-color: rgba(255, 155, 82, 0.05);\n}\n\n.bg-danger-light {\n  background: rgba(255, 243, 247, 0.5);\n}\n\n[data-theme-version=\"dark\"] .bg-danger-light {\n  background-color: rgba(249, 70, 135, 0.05);\n}\n\n.bg-info-light {\n  background: rgba(219, 219, 255, 0.5);\n}\n\n[data-theme-version=\"dark\"] .bg-info-light {\n  background-color: rgba(45, 40, 255, 0.05);\n}\n\n.bgl-dark {\n  background: #f1f1f1;\n  border-color: #f1f1f1;\n}\n\n.bgl-light {\n  background: #F4F5F9;\n  border-color: #F4F5F9;\n}\n\n.overlay-box {\n  position: relative;\n  z-index: 1;\n}\n\n.overlay-box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  position: absolute;\n  opacity: 0.85;\n  background: #00ADEE;\n  z-index: -1;\n}\n\n.rating-bar {\n  font-size: 13px;\n}\n\n.tdl-holder {\n  margin: 0 auto;\n}\n\n.tdl-holder ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.tdl-holder li {\n  background-color: #fff;\n  border-bottom: 1px solid #f0f1f5;\n  list-style: none none;\n  margin: 0;\n  padding: 0;\n}\n\n.tdl-holder li span {\n  margin-left: 35px;\n  font-size: 1rem;\n  vertical-align: middle;\n  transition: all 0.2s linear;\n}\n\n[direction=\"rtl\"] .tdl-holder li span {\n  margin-left: auto;\n  margin-right: 35px;\n}\n\n.tdl-holder label {\n  cursor: pointer;\n  display: block;\n  line-height: 50px;\n  padding-left: 1.5rem;\n  position: relative;\n  margin: 0 !important;\n}\n\n[direction=\"rtl\"] .tdl-holder label {\n  padding-left: 0;\n  padding-right: 1.5rem;\n}\n\n.tdl-holder label:hover {\n  background-color: #eef1f6;\n  color: #B1B1B1;\n}\n\n.tdl-holder label:hover a {\n  color: #F94687;\n}\n\n.tdl-holder label a {\n  color: #fff;\n  display: inline-block;\n  line-height: normal;\n  height: 100%;\n  text-align: center;\n  text-decoration: none;\n  width: 50px;\n  -webkit-transition: all .2s linear;\n  -moz-transition: all .2s linear;\n  -o-transition: all .2s linear;\n  transition: all 0.2s linear;\n  padding: 18px 0px;\n  font-size: 18px;\n  position: absolute;\n  right: 0;\n}\n\n[direction=\"rtl\"] .tdl-holder label a {\n  right: auto;\n  left: 0;\n}\n\n.tdl-holder input[type=checkbox] {\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n}\n\n.tdl-holder input[type=checkbox]+i {\n  background-color: #fff;\n  border: 1px solid #e7e7e7;\n  display: block;\n  height: 20px;\n  position: absolute;\n  top: 15px;\n  width: 20px;\n  z-index: 1;\n  border-radius: 00px;\n  font-size: 11px;\n  border-radius: 4px;\n}\n\n.tdl-holder input[type=checkbox]:checked+i {\n  background: #00ADEE;\n  border-color: transparent;\n}\n\n.tdl-holder input[type=checkbox]:checked+i::after {\n  content: \"\\f00c\";\n  font-family: 'fontAwesome';\n  display: block;\n  left: 2px;\n  position: absolute;\n  top: -14px;\n  z-index: 2;\n  color: #fff;\n}\n\n.tdl-holder input[type=checkbox]:checked~span {\n  text-decoration: line-through;\n  position: relative;\n}\n\n.tdl-holder input[type=text] {\n  background-color: #fff;\n  height: 50px;\n  margin-top: 29px;\n  border-radius: 3px;\n}\n\n.tdl-holder input[type=text]::placeholder {\n  color: #B1B1B1;\n}\n\n.widget-message p {\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.picker .picker__frame {\n  min-width: 450px !important;\n  max-width: 450px !important;\n}\n\n.picker .picker__frame .picker__box {\n  padding: 20px;\n  border: 0;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n}\n\n.picker .picker__frame .picker__box .picker__header {\n  margin-top: 0;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__year {\n  color: #00ADEE;\n  font-style: inherit;\n  font-size: 20px;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  line-height: 40px;\n  border-radius: 2px;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:before,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:before {\n  content: none !important;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {\n  font-family: fontawesome;\n  border: 0;\n  margin: 0 auto;\n  font-size: 22px;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:hover,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:hover {\n  background-color: #dac6f5 !important;\n  color: #00ADEE !important;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev {\n  left: 0;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after {\n  content: \"\\f0d9\";\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--next {\n  right: 0;\n}\n\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {\n  content: \"\\f0da\";\n}\n\n.picker .picker__frame .picker__box .picker__table .picker__weekday {\n  padding: 10px 0;\n  font-size: 16px;\n}\n\n.picker .picker__frame .picker__box .picker__table .picker__day {\n  width: 40px;\n  height: 40px;\n  border-radius: 50px;\n  padding: 0 !important;\n  font-size: 16px;\n  line-height: 40px;\n  margin: auto;\n  border: 0 !important;\n}\n\n.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--today:before {\n  content: none !important;\n}\n\n.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--highlighted {\n  border: 0 !important;\n  padding: 0;\n  background-color: #dac6f5 !important;\n  color: #fff !important;\n}\n\n.picker .picker__frame .picker__box .picker__table .picker__day:hover {\n  background-color: #dac6f5 !important;\n  color: #fff !important;\n}\n\n.picker .picker__frame .picker__box .picker__footer .picker__button--today {\n  background-color: #dac6f5 !important;\n  color: #fff !important;\n}\n\n.picker .picker__frame .picker__box .picker__footer .picker__button--today:before {\n  content: none !important;\n}\n\n.picker .picker__frame .picker__box .picker__footer .picker__button--clear,\n.picker .picker__frame .picker__box .picker__footer .picker__button--close,\n.picker .picker__frame .picker__box .picker__footer .picker__button--today {\n  border: 0;\n  border-radius: 2px;\n  font-size: 16px;\n}\n\n.picker .picker__frame .picker__box .picker__footer .picker__button--clear:hover,\n.picker .picker__frame .picker__box .picker__footer .picker__button--close:hover,\n.picker .picker__frame .picker__box .picker__footer .picker__button--today:hover {\n  background-color: #dac6f5 !important;\n  color: #fff !important;\n}\n\n@media only screen and (max-width: 575px) {\n  .picker .picker__frame {\n    min-width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  .picker .picker__frame .picker__box {\n    padding: 15px;\n    margin: 0 10px;\n  }\n}\n\n.card-list {\n  overflow: unset;\n  height: calc(100% - 50px);\n}\n\n.card-list .card-header {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.card-list .card-header .photo {\n  overflow: hidden;\n  border-radius: 5px;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1199px) {\n  .card-list {\n    height: calc(100% - 40px);\n  }\n}\n\n.card-list.list-left {\n  margin-top: 15px;\n  margin-left: 15px;\n}\n\n.card-list.list-left .card-header {\n  padding-left: 0;\n}\n\n.card-list.list-left .card-header .photo {\n  margin: -15px 15px 0 -15px;\n}\n\n.card-list.list-right {\n  margin-top: 15px;\n  margin-right: 15px;\n  text-align: right;\n}\n\n.card-list.list-right .card-header {\n  padding-right: 0;\n}\n\n.card-list.list-right .card-header .photo {\n  margin: -15px -15px 0 15px;\n}\n\n.card-list.list-right .card-header .photo img {\n  width: 100%;\n}\n\n.card-list.list-center {\n  margin-top: 15px;\n}\n\n.card-list.list-center .card-header .photo {\n  margin: -15px 0 0 0;\n}\n\n.card-list .photo img {\n  width: 100%;\n}\n\n.card-profile .profile-photo {\n  margin-top: -20px;\n}\n\n.widget-media .timeline .timeline-panel {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #eaeaea;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n}\n\n.widget-media .timeline .timeline-panel .media {\n  width: 50px;\n  height: 50px;\n  background: #eee;\n  border-radius: 1.25rem;\n  overflow: hidden;\n  font-size: 20px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  align-self: start;\n}\n\n.widget-media .timeline .timeline-panel .media-primary {\n  background: #f6f1fd;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .widget-media .timeline .timeline-panel .media-primary {\n  background-color: rgba(135, 67, 223, 0.2);\n}\n\n.widget-media .timeline .timeline-panel .media-info {\n  background: #dbdbff;\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .widget-media .timeline .timeline-panel .media-info {\n  background-color: rgba(45, 40, 255, 0.1);\n}\n\n.widget-media .timeline .timeline-panel .media-warning {\n  background: #fff3eb;\n  color: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .widget-media .timeline .timeline-panel .media-warning {\n  background-color: rgba(255, 155, 82, 0.1);\n}\n\n.widget-media .timeline .timeline-panel .media-danger {\n  background: #fff3f7;\n  color: #F94687;\n}\n\n[data-theme-version=\"dark\"] .widget-media .timeline .timeline-panel .media-danger {\n  background-color: rgba(249, 70, 135, 0.15);\n}\n\n.widget-media .timeline .timeline-panel .media-success {\n  background: #e3f9e9;\n  color: #2BC155;\n}\n\n[data-theme-version=\"dark\"] .widget-media .timeline .timeline-panel .media-success {\n  background-color: rgba(43, 193, 85, 0.1);\n}\n\n.widget-media .timeline .timeline-panel .media-body p {\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.widget-media .timeline .timeline-panel .dropdown {\n  align-self: self-end;\n  margin-top: 5px;\n}\n\n.widget-media .timeline li:last-child .timeline-panel {\n  margin-bottom: 0;\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.card[class*=\"bg-\"] .timeline .timeline-panel {\n  border-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n@media only screen and (max-width: 1199px) {\n  .table {\n    font-size: 0.875rem !important;\n  }\n}\n\n.table strong {\n  color: #B1B1B1;\n}\n\n.table td {\n  border-color: #f0f1f5;\n  padding: 12px 9px;\n}\n\n[data-theme-version=\"dark\"] .table td {\n  border-color: #333a54;\n}\n\n.table.shadow-hover tr:hover {\n  background-color: #fff;\n  box-shadow: 0 0px 30px rgba(135, 67, 223, 0.15);\n}\n\n[data-theme-version=\"dark\"] .table.shadow-hover tr:hover {\n  background-color: #181f39;\n}\n\n.table.bg-secondary-hover th,\n.table.bg-secondary-hover td {\n  border: none;\n  font-weight: 500;\n}\n\n.table.bg-secondary-hover tr:hover {\n  background: #3F9AE0;\n}\n\n.table.bg-secondary-hover tr:hover td,\n.table.bg-secondary-hover tr:hover th {\n  color: #fff !important;\n}\n\n.table.bg-info-hover th,\n.table.bg-info-hover td {\n  border: none;\n  font-weight: 500;\n}\n\n.table.bg-info-hover tr:hover {\n  background: #2D28FF;\n}\n\n.table.bg-info-hover tr:hover td,\n.table.bg-info-hover tr:hover th {\n  color: #fff !important;\n}\n\n.table.bg-warning-hover th,\n.table.bg-warning-hover td {\n  border: none;\n  font-weight: 500;\n}\n\n.table.bg-warning-hover tr:hover {\n  background: #FF9B52;\n}\n\n.table.bg-warning-hover tr:hover td,\n.table.bg-warning-hover tr:hover th {\n  color: #fff !important;\n}\n\n.table thead th {\n  border-bottom-width: 1px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  border-color: #f0f1f5;\n  padding: 5px 20px !important;\n  \n}\n\n[data-theme-version=\"dark\"] .table thead th {\n  border-color: #333a54;\n}\n\n.table tbody tr td {\n  vertical-align: middle;\n  border-color: #f0f1f5;\n}\n\n[data-theme-version=\"dark\"] .table tbody tr td {\n  border-color: #333a54;\n}\n\n.table:not(.table-bordered) thead th {\n  border-top: none;\n  white-space:normal;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.table .thead-primary th {\n  background-color: #00ADEE;\n  color: #fff;\n}\n\n.table .thead-info th {\n  background-color: #2D28FF;\n  color: #fff;\n}\n\n.table .thead-warning th {\n  background-color: #FF9B52;\n  color: #fff;\n}\n\n.table .thead-danger th {\n  background-color: #F94687;\n  color: #fff;\n}\n\n.table .thead-success th {\n  background-color: #2BC155;\n  color: #fff;\n}\n\n.table.primary-table-bordered {\n  border: 1px solid #f0f1f5;\n}\n\n[data-theme-version=\"dark\"] .table.primary-table-bordered {\n  border-color: #333a54;\n}\n\n.table.primary-table-bg-hover thead th {\n  background-color: #792ddb;\n  color: #fff;\n  border-bottom: none;\n}\n\n.table.primary-table-bg-hover tbody tr {\n  background-color: #00ADEE;\n  color: #fff;\n  transition: all .1s ease;\n}\n\n.table.primary-table-bg-hover tbody tr:hover {\n  background-color: #9559e3;\n}\n\n.table.primary-table-bg-hover tbody tr:not(:last-child) td,\n.table.primary-table-bg-hover tbody tr:not(:last-child) th {\n  border-bottom: 1px solid #792ddb;\n}\n\n.table-responsive-tiny {\n  min-width: 18.75rem;\n}\n\n.table-responsive-sm {\n  min-width: 30rem !important;\n}\n\n.table-responsive-md {\n  min-width: 36rem !important;\n}\n\n.table-responsive-lg {\n  min-width: 60.9375rem !important;\n}\n\n.table-responsive-xl {\n  min-width: 70.9375rem !important;\n}\n\n.table-primary,\n.table-primary>th,\n.table-primary>td {\n  background-color: #f6f1fd;\n  color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .table-primary,\n[data-theme-version=\"dark\"] .table-primary>th,\n[data-theme-version=\"dark\"] .table-primary>td {\n  background-color: rgba(135, 67, 223, 0.2);\n}\n\n.table-success,\n.table-success>th,\n.table-success>td {\n  background-color: #e3f9e9;\n  color: #2BC155;\n}\n\n[data-theme-version=\"dark\"] .table-success,\n[data-theme-version=\"dark\"] .table-success>th,\n[data-theme-version=\"dark\"] .table-success>td {\n  background-color: rgba(43, 193, 85, 0.1);\n}\n\n.table-info,\n.table-info>th,\n.table-info>td {\n  background-color: #dbdbff;\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] .table-info,\n[data-theme-version=\"dark\"] .table-info>th,\n[data-theme-version=\"dark\"] .table-info>td {\n  background-color: rgba(45, 40, 255, 0.1);\n}\n\n.table-warning,\n.table-warning>th,\n.table-warning>td {\n  background-color: #fff3eb;\n  color: #FF9B52;\n}\n\n[data-theme-version=\"dark\"] .table-warning,\n[data-theme-version=\"dark\"] .table-warning>th,\n[data-theme-version=\"dark\"] .table-warning>td {\n  background-color: rgba(255, 155, 82, 0.1);\n}\n\n.table-danger,\n.table-danger>th,\n.table-danger>td {\n  background-color: #fff3f7;\n  color: #F94687;\n}\n\n[data-theme-version=\"dark\"] .table-danger,\n[data-theme-version=\"dark\"] .table-danger>th,\n[data-theme-version=\"dark\"] .table-danger>td {\n  background-color: rgba(249, 70, 135, 0.15);\n}\n\n.table-active,\n.table-active>th,\n.table-active>td {\n  background-color: #f2f4fa;\n}\n\n[data-theme-version=\"dark\"] .table-active,\n[data-theme-version=\"dark\"] .table-active>th,\n[data-theme-version=\"dark\"] .table-active>td {\n  background-color: #181f39;\n}\n\n.card-table th:first-child,\n.card-table td:first-child {\n  padding-left: 20px;\n  padding-right: 20px;\n  width: 50px;\n}\n\n@media only screen and (max-width: 575px) {\n\n  .card-table th:first-child,\n  .card-table td:first-child {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}\n\n.card-table th:last-child,\n.card-table td:last-child {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n@media only screen and (max-width: 575px) {\n\n  .card-table th:last-child,\n  .card-table td:last-child {\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n}\n\n.bootgrid-header {\n  padding: 0 !important;\n  margin: 0;\n}\n\n@media only screen and (max-width: 575px) {\n  .bootgrid-header .actionBar {\n    padding: 0;\n  }\n\n  .bootgrid-header .search {\n    margin: 0 0 10px 0;\n  }\n}\n\ntable#example {\n  padding: 0rem 0 2rem 0;\n}\n\ntable.dataTable {\n  color: #000;\n  border-radius: 0.5rem;\n}\n\n#example2_wrapper .dataTables_scrollBody {\n  max-height: 33.25rem !important;\n}\n\n#employees,\n#custommers {\n  padding: .5rem 0 1rem 0;\n}\n\n.dataTables_wrapper .dataTables_paginate {\n  padding: 25px 0;\n}\n\n@media only screen and (max-width: 1400px) {\n  .dataTables_wrapper .dataTables_paginate {\n    padding: 10px 0;\n  }\n}\n\ntable.dataTable thead th,\ntable.dataTable thead td {\n  padding: 20px 15px;\n  border-bottom: 1px solid #f0f1f5;\n}\n\n@media only screen and (max-width: 1400px) {\n\n  table.dataTable thead th,\n  table.dataTable thead td {\n    padding: 8px 15px;\n  }\n}\n\ntable.dataTable tfoot th,\ntable.dataTable tfoot td {\n  border-top: 0;\n}\n\ntable.dataTable tbody td {\n  background: #fff !important;\n}\n\ntable.dataTable thead th {\n  color: #fff;\n  font-size: 12px;\n  white-space: nowrap;\n  font-weight: 600;\n  text-align: center;\n}\n\n[data-theme-version=\"dark\"] table.dataTable thead th {\n  color: #fff;\n}\n\n@media only screen and (max-width: 1400px) {\n  table.dataTable thead th {\n    font-size: 12px;\n  }\n}\n\ntable.dataTable tbody td {\n  font-size: 11px;\n  padding: 2px 4px;\n}\n\n@media only screen and (max-width: 1400px) {\n  table.dataTable tbody td {\n    padding: 2px 4px;\n    font-size: 12px;\n  }\n}\n\ntable.dataTable tr.selected {\n  color: #00ADEE;\n}\n\ntable.dataTable tfoot th {\n  color: #B1B1B1;\n  font-weight: 600;\n}\n\n[data-theme-version=\"dark\"] table.dataTable tfoot th {\n  color: #fff;\n}\n\n.dataTables_wrapper input[type=\"search\"],\n.dataTables_wrapper input[type=\"text\"],\n.dataTables_wrapper select {\n  border: 1px solid #e2e2e2;\n  padding: .3rem 0.5rem;\n  color: #715d5d;\n  border-radius: 5px;\n}\n\n[data-theme-version=\"dark\"] .dataTables_wrapper input[type=\"search\"],\n[data-theme-version=\"dark\"] .dataTables_wrapper input[type=\"text\"],\n[data-theme-version=\"dark\"] .dataTables_wrapper select {\n  background: #181f39;\n  border-color: #333a54;\n  color: #fff;\n}\n\n.dataTables_wrapper .dataTables_length {\n  margin-bottom: 15px;\n}\n\n.dataTables_wrapper .dataTables_length .bootstrap-select {\n  width: 80px !important;\n  margin: 0 5px;\n}\n\ntable.dataTable.no-footer {\n  border-bottom: 0;\n}\n\n.min-w850 {\n  min-width: 850px;\n}\n\n.rounded-lg {\n  min-width: 30px;\n}\n\n.dataTables_scroll {\n  padding: 1rem 0;\n}\n\n.dataTables_scrollFoot {\n  padding-top: 1rem;\n}\n\n@media (max-width: 991.98px) {\n\n  .dataTables_wrapper .dataTables_length,\n  .dataTables_wrapper .dataTables_filter {\n    text-align: left;\n  }\n}\n\n.dataTablesCard {\n  background-color: #3C4B64;\n  box-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);\n  border-radius: 0;\n}\n\n.dataTablesCard tbody {\n  background: #fff;\n}\n\n.dataTablesCard tbody tr:hover {\n  background: #fff;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n}\n\n.dataTablesCard tbody tr:hover td {\n  background: transparent !important;\n}\n\ntable.dataTable.display tbody tr:hover {\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n}\n\ntable.dataTable.display tbody tr:hover td {\n  background: transparent;\n}\n\n.dataTables_wrapper .dataTables_info {\n  padding: 25px 0;\n}\n\n@media only screen and (max-width: 1400px) {\n  .dataTables_wrapper .dataTables_info {\n    padding: 8px 0;\n  }\n}\n\ntable.dataTable.display.white-border td {\n  border-color: #fff;\n}\n\ntable.dataTable.row-border tbody th,\ntable.dataTable.row-border tbody td,\ntable.dataTable.display tbody th,\ntable.dataTable.display tbody td {\n  border-left: #EEEEEE;\n  border-right: 1px solid #EEEEEE;\n  border-left: #EEEEEE;\n  border-left: #EEEEEE;\n  text-align: center;\n}\n\n/* table only column name align */\n.left-Column-align {\n  text-align: left !important;\n  max-width: 150px;\n}\n\n[data-theme-version=\"dark\"] table.dataTable.row-border tbody th,\n[data-theme-version=\"dark\"] table.dataTable.row-border tbody td,\n[data-theme-version=\"dark\"] table.dataTable.display tbody th,\n[data-theme-version=\"dark\"] table.dataTable.display tbody td {\n  border-color: #333a54;\n}\n\ntable.dataTable thead .sorting {\n  background-position: center right 15px;\n}\n\n.dataTables_wrapper .dataTables_paginate {\n  border-radius: 1.25rem;\n}\n\n.dataTables_wrapper .dataTables_paginate span {\n  border-radius: 1.25rem;\n  display: inline-block;\n  background: rgba(135, 67, 223, 0.08);\n  border: 0px solid #00ADEE;\n  margin: 0 0;\n}\n\n.dataTables_wrapper .dataTables_paginate span a {\n  color: #fff;\n  background: transparent !important;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button {\n  border: 0 !important;\n  padding: 15px 24px;\n  background: transparent !important;\n  border-radius: 1.25rem;\n  color: #00ADEE !important;\n  font-size: 16px;\n  margin: 0;\n  display: inline-block;\n}\n\n@media only screen and (max-width: 1400px) {\n  .dataTables_wrapper .dataTables_paginate .paginate_button {\n    padding: 8px 15px;\n    font-size: 14px;\n  }\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  color: #fff !important;\n  background: #00ADEE !important;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next {\n  background: #fff !important;\n  color: #00ADEE !important;\n  margin: 0 10px;\n  border: 0px solid #00ADEE !important;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next:hover {\n  background: #00ADEE !important;\n  color: #fff !important;\n}\n\n.fooicon {\n  font-size: 1.25rem;\n  color: #B1B1B1;\n}\n\n.jsgrid-table .jsgrid-header-row>.jsgrid-header-cell {\n  color: #B1B1B1;\n}\n\n.jsgrid-table>tbody>tr>td {\n  padding: 1.2em;\n}\n\n.jsgrid-table .jsgrid-insert-row input,\n.jsgrid-table .jsgrid-insert-row select,\n.jsgrid-table .jsgrid-edit-row input,\n.jsgrid-table .jsgrid-edit-row select {\n  border: 1px solid #DDDFE1;\n}\n\n.jsgrid .jsgrid-button {\n  border: 0 !important;\n  margin-left: 10px;\n}\n\n.error-page .error-text {\n  font-size: 150px;\n  line-height: 1;\n  color: #3F9AE0;\n}\n\n@media only screen and (max-width: 575px) {\n  .error-page .error-text {\n    font-size: 80px;\n  }\n}\n\n.error-page h4 {\n  font-size: 40px;\n  margin-bottom: 5px;\n  color: #3F9AE0;\n}\n\n@media only screen and (max-width: 575px) {\n  .error-page h4 {\n    font-size: 20px;\n  }\n}\n\n.error-page p {\n  font-size: 16px;\n}\n\n@media only screen and (max-width: 575px) {\n  .error-page p {\n    font-size: 14px;\n  }\n}\n\n.authentication-content {\n  background: #fff;\n  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n  border-radius: 5px;\n  background: rgb(255 255 255/85%);\n}\n\n[data-theme-version=\"dark\"] .authentication-content {\n  background: #1e2746;\n  box-shadow: none;\n}\n\n.welcome-content {\n  background: url(\"./../images/1.jpg\");\n  background-size: cover;\n  background-position: center;\n  height: 100%;\n  padding: 75px 50px;\n  position: relative;\n  z-index: 1;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.welcome-content::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #00ADEE;\n  opacity: 0.75;\n  z-index: -1;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.welcome-content .welcome-title {\n  color: #fff;\n  font-weight: 500;\n  font-size: 20px;\n}\n\n.welcome-content p {\n  color: #fff;\n}\n\n.welcome-content .brand-logo a {\n  display: inline-block;\n  margin-bottom: 20px;\n  font-weight: 700;\n  color: #fff;\n  font-size: 20px;\n}\n\n.welcome-content .brand-logo a img {\n  width: 100px;\n}\n\n.welcome-content .intro-social {\n  position: absolute;\n  bottom: 75px;\n}\n\n.welcome-content .intro-social ul {\n  margin-bottom: 0;\n}\n\n.welcome-content .intro-social ul li {\n  display: inline-block;\n}\n\n.welcome-content .intro-social ul li a {\n  color: #fff;\n  font-size: 14px;\n  padding: 0px 7px;\n}\n\n.auth-form {\n  padding: 50px 50px;\n}\n\n@media only screen and (max-width: 575px) {\n  .auth-form {\n    padding: 30px;\n  }\n}\n\n.auth-form .btn {\n  font-weight: 700;\n}\n\n.auth-form .page-back {\n  display: inline-block;\n  margin-bottom: 15px;\n}\n\n.pricing_table_content {\n  background: #fff;\n  text-align: center;\n  border: 1px solid #e7e7e7;\n  border-radius: 3px;\n  padding: 25px;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n}\n\n.pricing_table_content .package {\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.pricing_table_content .price {\n  font-weight: 700;\n  font-size: 50px;\n  line-height: 100px;\n  color: #B1B1B1;\n}\n\n.pricing_table_content hr {\n  margin: 0;\n}\n\n.pricing_table_content .price_list {\n  padding: 30px 0;\n  text-align: left;\n  max-width: 175px;\n  margin: 0 auto;\n}\n\n.pricing_table_content .price_list li {\n  color: #909093;\n  font-size: 14px;\n  line-height: 25px;\n  padding: 7px 0;\n}\n\n.pricing_table_content .price_list li i {\n  margin-right: 15px;\n}\n\n.pricing_table_content .price-btn {\n  padding: 15px 50px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px solid #eaeaea;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 14px;\n  margin-bottom: 25px;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n}\n\n.pricing_table_content:focus,\n.pricing_table_content:hover {\n  -webkit-transform: scale(1.05);\n  transform: scale(1.05);\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.175);\n}\n\n.pricing_table_content:focus .price-btn,\n.pricing_table_content:hover .price-btn {\n  color: #F94687;\n}\n\n.page-timeline .timeline {\n  list-style: none;\n  padding: 40px 0;\n  position: relative;\n}\n\n.page-timeline .timeline-workplan.page-timeline .timeline {\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n\n.page-timeline .timeline-workplan.page-timeline .timeline.timeline>li>.timeline-badge {\n  top: 4.5rem;\n}\n\n.page-timeline .timeline-workplan.page-timeline .timeline>li {\n  margin-bottom: 2.6rem;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1650px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline li>p {\n    max-width: 8rem;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline li>p {\n    max-width: 7rem;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline li>p {\n    max-width: 100%;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline li>p {\n    max-width: 7rem;\n  }\n}\n\n.page-timeline .timeline-workplan.page-timeline .timeline::before {\n  left: 20%;\n  top: 6rem;\n}\n\n[direction=\"rtl\"] .page-timeline .timeline-workplan.page-timeline .timeline::before {\n  right: 22%;\n  left: auto;\n}\n\n@media only screen and (max-width: 575px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline::before {\n    left: 22%;\n  }\n}\n\n.page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {\n  left: 21.4%;\n  height: 0.9rem;\n  width: 0.9rem;\n  background-color: #00ADEE;\n}\n\n[direction=\"rtl\"] .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {\n  right: 19.2%;\n  left: auto;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1650px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {\n    left: 22.4%;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {\n    left: 22.4%;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {\n    left: 21.7%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {\n    left: 19.5%;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge {\n    left: 21.4%;\n  }\n}\n\n.page-timeline .timeline-workplan.page-timeline .timeline .timeline-badge::after {\n  position: absolute;\n  width: 1.9rem;\n  height: 1.9rem;\n  background-color: rgba(135, 67, 223, 0.4);\n  content: \"\";\n  border-radius: 50%;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.page-timeline .timeline-workplan.page-timeline .timeline .timeline-panel {\n  width: 70%;\n}\n\n.page-timeline .timeline:before {\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  content: \" \";\n  width: 2px;\n  background-color: #ECEFF2;\n  left: 50%;\n  margin-left: -1.5px;\n}\n\n.page-timeline .timeline>li {\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.page-timeline .timeline>li:after,\n.page-timeline .timeline>li:before {\n  content: \" \";\n  display: table;\n}\n\n.page-timeline .timeline>li:after {\n  clear: both;\n}\n\n.page-timeline .timeline>li:after,\n.page-timeline .timeline>li:before {\n  content: \" \";\n  display: table;\n}\n\n.page-timeline .timeline>li:after {\n  clear: both;\n}\n\n.page-timeline .timeline>li>.timeline-panel {\n  width: 46%;\n  float: left;\n  border-radius: 2px;\n  position: relative;\n}\n\n.page-timeline .timeline>li>.timeline-badge {\n  background-color: #f2f4fa;\n  border: 1px solid #DDDFE1;\n  border-radius: 50%;\n  color: #B1B1B1;\n  height: 40px;\n  left: 50%;\n  line-height: 40px;\n  margin-left: -13px;\n  position: absolute;\n  text-align: center;\n  top: 30px;\n  width: 40px;\n  z-index: 1;\n  transform: translate(-25%, -3rem);\n}\n\n@media (min-width: 576px) {\n  .page-timeline .timeline>li>.timeline-badge {\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n  }\n}\n\n.page-timeline .timeline>li.timeline-inverted>.timeline-panel {\n  float: right;\n}\n\n.page-timeline .timeline>li.timeline-inverted>.timeline-panel:before {\n  border-left-width: 0;\n  border-right-width: 15px;\n  left: -15px;\n  right: auto;\n}\n\n.page-timeline .timeline>li.timeline-inverted>.timeline-panel:after {\n  border-left-width: 0;\n  border-right-width: 14px;\n  left: -14px;\n  right: auto;\n}\n\n.page-timeline .timeline-title {\n  margin-top: 0;\n  color: inherit;\n}\n\n.page-timeline .event_time {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.page-timeline .event_vanue {\n  font-size: 14px;\n  margin: 5px 0;\n  font-weight: 600;\n}\n\n.page-timeline .timeline_img {\n  height: 100px;\n  width: 100px;\n}\n\n.page-timeline .timeline-body>p,\n.page-timeline .timeline-body>ul {\n  margin-bottom: 0;\n}\n\n@media (max-width: 767px) {\n  .page-timeline ul.timeline:before {\n    left: 40px;\n  }\n\n  .page-timeline ul.timeline>li>.timeline-panel {\n    width: calc(100% - 90px);\n    width: -webkit-calc(100% - 90px);\n  }\n\n  .page-timeline ul.timeline>li>.timeline-badge {\n    left: 28px;\n    margin-left: 0;\n    top: 16px;\n  }\n\n  .page-timeline ul.timeline>li>.timeline-panel {\n    float: right;\n  }\n\n  .page-timeline ul.timeline>li>.timeline-panel:before {\n    border-left-width: 0;\n    border-right-width: 15px;\n    left: -15px;\n    right: auto;\n  }\n\n  .page-timeline ul.timeline>li>.timeline-panel:after {\n    border-left-width: 0;\n    border-right-width: 14px;\n    left: -14px;\n    right: auto;\n  }\n\n  .page-timeline .timeline_img {\n    height: 30%;\n    width: 30%;\n  }\n}\n\n.page-timeline .timeline-timestamp {\n  text-align: center;\n}\n\n.page-timeline .timeline-timestamp .badge {\n  padding: .8rem 2rem;\n  border-radius: 50px;\n  font-size: 0.8125rem;\n}\n\n.full-map-area {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.full-map-area a {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n}\n\n.full-map-area i {\n  background: #3e4954;\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  width: 56px;\n  height: 56px;\n  text-align: center;\n  line-height: 56px;\n  font-size: 24px;\n  color: #fff;\n  border-radius: 56px;\n}\n\n.full-map-area img {\n  width: 100%;\n}\n\n.iconbox {\n  position: relative;\n  padding-left: 70px;\n}\n\n.iconbox i {\n  background: #00ADEE;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  border-radius: 50px;\n  text-align: center;\n  font-size: 28px;\n  color: #fff;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.iconbox p {\n  margin: 0;\n  color: #484848;\n  font-size: 18px;\n  line-height: 1.3;\n  font-weight: 500;\n}\n\n.iconbox small {\n  margin-bottom: 5px;\n  font-size: 16px;\n  display: block;\n}\n\n.widget-timeline-icon li {\n  padding-left: 25px;\n  position: relative;\n  margin-left: 11px;\n  border-left: 3px solid #00ADEE;\n  min-height: 80px;\n  padding-top: 1px;\n}\n\n.widget-timeline-icon li .icon {\n  position: absolute;\n  width: 22px;\n  height: 22px;\n  font-size: 24px;\n  color: #fff;\n  text-align: center;\n  line-height: 22px;\n  border-radius: 22px;\n  left: -13px;\n  top: 0;\n}\n\n.widget-timeline-icon li:last-child {\n  border-left: 3px solid transparent;\n}\n\n.contact-icon {\n  height: 50px;\n  width: 50px;\n  min-width: 50px;\n  background: rgba(135, 67, 223, 0.2);\n  color: #00ADEE;\n  font-size: 28px;\n  border-radius: 1.25rem;\n  line-height: 50px;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n  text-align: center;\n}\n\n.contact-icon:hover {\n  color: #fff;\n  background: #00ADEE;\n}\n\n@media only screen and (max-width: 1400px) {\n  .contact-icon {\n    height: 40px;\n    width: 40px;\n    min-width: 40px;\n    line-height: 42px;\n    font-size: 25px;\n  }\n}\n\n.review-table {\n  padding: 25px;\n  box-shadow: none;\n  border-radius: 0;\n  border-bottom: 1px solid #eee;\n  height: auto;\n  margin-bottom: 0;\n}\n\n.review-table .star-review i {\n  font-size: 20px;\n}\n\n.review-table .media-body p {\n  color: #3e4954;\n  font-size: 18px;\n  line-height: 1.5;\n}\n\n.review-table .disease {\n  border-left: 1px solid #EEEEEE;\n  padding-left: 20px;\n}\n\n.review-table .media-footer {\n  min-width: 500px;\n  margin-left: 10px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .review-table .media-footer {\n    min-width: 273px;\n    margin-left: 10px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .review-table .star-review i {\n    font-size: 16px;\n  }\n\n  .review-table .custom-control {\n    float: right;\n    right: -20px;\n  }\n\n  .review-table .media {\n    display: block !important;\n  }\n\n  .review-table .media-body p {\n    font-size: 14px;\n  }\n\n  .review-table img {\n    float: left;\n    width: 80px;\n  }\n\n  .review-table .media-footer {\n    margin-left: 0;\n    margin-top: 25px;\n  }\n\n  .review-table .disease {\n    border-left: 0;\n    padding-left: 0;\n    margin-right: 10px !important;\n    margin-left: 0;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .review-table .media-footer {\n    flex-flow: wrap;\n  }\n\n  .review-table .media-footer .disease {\n    margin-right: auto !important;\n  }\n\n  .review-table .media-footer .edit {\n    margin-left: 0 !important;\n  }\n}\n\n.review-tab .nav-link {\n  border-radius: 0;\n  font-weight: 600;\n  border-bottom: 2px solid #D9D9D9;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.review-tab .nav-link.active {\n  background: transparent;\n  color: #00ADEE;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n  box-shadow: none;\n  border-color: #00ADEE;\n}\n\n@media only screen and (max-width: 575px) {\n  .review-tab .nav-link {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n}\n\n.search-job .form-control {\n  width: 50%;\n}\n\n@media only screen and (max-width: 767px) {\n  .search-job .form-control {\n    width: 100%;\n  }\n}\n\n.sharp-lg {\n  min-width: 50px;\n  height: 50px;\n  line-height: 48px;\n  min-height: 50px;\n  text-align: center;\n}\n\n@media only screen and (max-width: 1400px) {\n  .sharp-lg {\n    min-height: 40px;\n    height: 40px;\n    min-width: 40px;\n    line-height: 38px;\n  }\n}\n\n.search-row .title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.search-row .sub-title {\n  font-size: 18px;\n}\n\n.search-row:hover {\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n}\n\n@media only screen and (max-width: 1400px) {\n  .search-row .title {\n    font-size: 17px;\n  }\n\n  .search-row .sub-title {\n    font-size: 16px;\n  }\n}\n\n.aroundYou {\n  border-right: 1px solid #EEEEEE;\n}\n\n@media only screen and (max-width: 991px) {\n  .aroundYou {\n    border-right: 0;\n  }\n}\n\n.like-btn {\n  display: inline-block;\n  padding-left: 0;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-family: FontAwesome;\n}\n\n.like-btn input {\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  display: block;\n}\n\n.checkmark {\n  height: 40px;\n  text-align: center;\n  line-height: 38px;\n  width: 40px;\n  display: block;\n  border: 1px solid #00ADEE;\n  border-radius: 20px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .checkmark {\n    height: 32px;\n    width: 32px;\n    line-height: 29px;\n  }\n}\n\n.like-btn .checkmark:before {\n  content: \"\\f097\";\n  font-size: 20px;\n  font-weight: 400;\n  color: #00ADEE;\n}\n\n@media only screen and (max-width: 1400px) {\n  .like-btn .checkmark:before {\n    font-size: 17px;\n  }\n}\n\n.like-btn input:checked~.checkmark {\n  background-color: #00ADEE;\n}\n\n.like-btn input:checked~.checkmark:before {\n  width: 100%;\n  height: 100%;\n  background-color: #00ADEE;\n  left: 0;\n  top: 0;\n  border-radius: 20px;\n  color: #fff;\n  padding: 3px 6px;\n}\n\n.profile-card .title {\n  position: relative;\n}\n\n.profile-card .title span {\n  display: inline-block;\n  text-transform: uppercase;\n  background: #fff;\n  position: relative;\n  z-index: 1;\n  padding-right: 30px;\n}\n\n.profile-card .title:after {\n  width: 100%;\n  height: 1px;\n  background: #E7E7E7;\n  position: absolute;\n  top: 50%;\n  transform: translatey(-50%);\n  left: 0;\n  content: \"\";\n}\n\n.profile-card .form-group {\n  margin-bottom: 30px;\n}\n\n.profile-card .form-group label {\n  font-weight: 500;\n}\n\n.profile-card .form-group .input-icon .form-control {\n  padding-left: 70px;\n  z-index: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .profile-card .form-group .input-icon .form-control {\n    padding-left: 50px;\n  }\n}\n\n.profile-card .form-group .input-group-prepend {\n  position: absolute;\n  top: 50%;\n  left: 10px;\n  z-index: 1;\n  transform: translatey(-50%);\n}\n\n.profile-card .form-group .input-group-prepend .input-group-text {\n  background: transparent;\n}\n\n.profile-card .form-group .input-group-prepend .input-group-text i {\n  font-size: 30px;\n  color: #00ADEE;\n}\n\n@media only screen and (max-width: 767px) {\n  .profile-card .form-group .input-group-prepend .input-group-text i {\n    font-size: 20px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .profile-card .form-group .input-group-prepend {\n    left: 0;\n  }\n}\n\n.profile-card .form-group .bootstrap-select.form-control {\n  padding: 0;\n}\n\n.profile-card .form-group .bootstrap-select.form-control button {\n  padding: 10px 20px;\n  height: 70px;\n  font-size: 18px;\n  line-height: 45px;\n  background: #FBFBFB;\n  border-color: #C2C2C2 !important;\n  color: #000;\n  border-radius: 1.25rem;\n}\n\n@media only screen and (max-width: 767px) {\n  .profile-card .form-group .bootstrap-select.form-control button {\n    height: 45px;\n    font-size: 14px;\n    padding: 0 10px;\n  }\n}\n\n.profile-card .form-group .bootstrap-select.form-control .dropdown-toggle:after {\n  color: #00ADEE;\n  font-size: 30px;\n}\n\n@media only screen and (max-width: 575px) {\n  .profile-card .form-group .bootstrap-select.form-control .dropdown-toggle:after {\n    font-size: 20px;\n  }\n}\n\n.profile-card .form-group .form-control {\n  height: 70px;\n  font-size: 18px;\n  padding: 0 20px;\n  border-color: #C2C2C2 !important;\n  background: #FBFBFB;\n  color: #000;\n  border-radius: 1.25rem;\n}\n\n.profile-card .form-group .form-control::placeholder {\n  color: #BBBBBB;\n}\n\n@media only screen and (max-width: 767px) {\n  .profile-card .form-group .form-control {\n    height: 45px;\n    font-size: 14px;\n  }\n}\n\n.profile-card .form-group textarea.form-control {\n  height: unset !important;\n  border: 1px solid;\n  border-color: #C2C2C2;\n  border-radius: 1.25rem;\n  color: rgba(0, 0, 0, 0.7);\n  background: #FBFBFB;\n  border-width: 1px !important;\n  font-size: 16px !important;\n  padding: 15px 20px !important;\n}\n\n.progress-icon {\n  height: 62px;\n  width: 62px;\n  display: block;\n  font-weight: 600;\n  border-radius: 1.25rem;\n  line-height: 62px;\n  text-align: center;\n  background: rgba(135, 67, 223, 0.1);\n  color: #00ADEE;\n}\n\n@media only screen and (max-width: 575px) {\n  .progress-icon {\n    height: 50px;\n    width: 50px;\n    line-height: 50px;\n  }\n}\n\n.skill-progress {\n  overflow: visible;\n}\n\n.skill-progress .progress-bar {\n  position: relative;\n  border-radius: 10px;\n  overflow: visible;\n}\n\n.skill-progress .progress-bar:after {\n  content: \"\";\n  position: absolute;\n  height: 26px;\n  width: 26px;\n  top: 50%;\n  transform: translatey(-50%);\n  right: 0;\n  border-radius: 5px;\n  background: #00ADEE;\n}\n\n@media only screen and (max-width: 575px) {\n  .skill-progress .progress-bar:after {\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.network-chart {\n  margin-top: -90px;\n  margin-bottom: -40px;\n}\n\n@media only screen and (max-width: 1600px) {\n  .network-chart {\n    margin-top: 0;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .network-chart {\n    margin-top: -90px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .network-chart {\n    margin-top: -30px;\n    margin-bottom: -40px;\n  }\n}\n\n.network-header {\n  position: relative;\n  z-index: 3;\n}\n\n.items-table tbody tr {\n  padding: 0;\n  border-radius: 1.25rem;\n  position: relative;\n  box-shadow: 0 1px 0 0 #f8f8f8;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.items-table tbody tr .dropdown {\n  opacity: 0;\n}\n\n.items-table tbody tr.active,\n.items-table tbody tr:hover {\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);\n  z-index: 1;\n}\n\n.items-table tbody tr.active .dropdown,\n.items-table tbody tr:hover .dropdown {\n  opacity: 1;\n}\n\n.items-table tbody tr th,\n.items-table tbody tr td {\n  border: 0;\n  padding: 18px 8px;\n}\n\n@media only screen and (max-width: 575px) {\n  .items-table {\n    width: 500px;\n  }\n}\n\n.star-review i {\n  font-size: 16px;\n}\n\n.star-review i.text-gray {\n  color: #d9d9d9;\n}\n\n.star-review span {\n  color: #000;\n}\n\n.form-head {\n  /* .btn i{\n  \tline-height: 1;\n  \ttransform: scale(1.3);\n  \tdisplay: inline-block;\n  \tmargin-right: 5px;\n  } */\n  /* .btn-outline-primary{\n  \tborder-color:#eee;\n  \t&:hover{\n  \t\tborder-color:$primary;\n  \t}\n  } */\n}\n\n.form-head .breadcrumb {\n  background: transparent;\n  padding: 0;\n}\n\n.form-head .search-area {\n  max-width: 300px;\n  border-radius: 0;\n}\n\n@media only screen and (max-width: 1400px) {\n  .form-head .search-area {\n    max-width: 250px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .form-head .search-area {\n    max-width: 250px;\n  }\n}\n\n.form-head .search-area .form-control {\n  border: 0;\n  height: 45px;\n  padding: 10px 15px;\n  font-size: 16px;\n  background: #f1f1f1;\n  border-radius: 0;\n}\n\n@media only screen and (max-width: 1400px) {\n  .form-head .search-area .form-control {\n    height: 41px;\n    padding: 10px 15px;\n    font-size: 13px;\n  }\n}\n\n.form-head .search-area .input-group-append .input-group-text {\n  background: #f1f1f1;\n  padding: 0 5px 0 30px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .form-head .search-area .input-group-append .input-group-text {\n    padding: 0 5px 0 30px;\n  }\n}\n\n.form-head .search-area .input-group-append .input-group-text i {\n  font-size: 20px;\n  color: #7e7e7e;\n}\n\n@media only screen and (max-width: 1400px) {\n  .form-head .search-area .input-group-append .input-group-text i {\n    font-size: 18px;\n  }\n}\n\n.form-head .dropdown .btn i {\n  transform: scale(1.3);\n  -moz-transform: scale(1.3);\n  -webkit-transform: scale(1.3);\n  -ms-transform: scale(1.3);\n  -o-transform: scale(1.3);\n  display: inline-block;\n}\n\n.form-head .dropdown:after {\n  color: #00ADEE;\n  font-size: 25px;\n}\n\n@media only screen and (max-width: 767px) {\n  .form-head>* {\n    margin-right: 5px !important;\n    margin-bottom: 10px;\n    vertical-align: baseline;\n    margin-left: 0 !important;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .form-head {\n    display: block !important;\n  }\n}\n\n.rounded {\n  border-radius: 1.25rem !important;\n}\n\n.btn-link {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .btn-link {\n    font-size: 14px;\n  }\n}\n\n.deznav .copyright {\n  font-size: 14px;\n  padding: 0 45px 60px;\n  margin-top: 40px;\n  color: #969BA0;\n  margin-bottom: 40px;\n}\n\n.deznav .copyright p {\n  margin-bottom: 10px;\n}\n\n.deznav .copyright strong {\n  display: block;\n}\n\n@media only screen and (max-width: 1400px) {\n  .deznav .copyright {\n    padding: 0 25px 60px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .deznav .copyright {\n    padding-bottom: 60px;\n  }\n}\n\n.widget-buyer .media img {\n  width: 30px;\n}\n\n.widget-buyer .media .media-body h5 {\n  font-size: 14px;\n  margin-bottom: 0px;\n}\n\n.widget-buyer .media .media-body p {\n  font-size: 13px;\n}\n\n.recentOrderTable table {\n  margin-bottom: 0;\n  overflow: hidden;\n}\n\n.recentOrderTable table thead th {\n  font-size: 12px;\n}\n\n.recentOrderTable table tbody td {\n  color: #B1B1B1;\n  font-weight: 500;\n  line-height: 40px;\n}\n\n[data-theme-version=\"dark\"] .recentOrderTable table tbody td {\n  color: #828690;\n}\n\n.recentOrderTable table tbody td img {\n  border-radius: 50px;\n}\n\n.recentOrderTable table tbody td .custom-dropdown i {\n  padding: 0 10px;\n  cursor: pointer;\n}\n\n.activity_overview .nav-tabs {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;\n}\n\n.activity_overview .custom-tab-1 .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n  padding-left: 0;\n  padding-right: 0;\n  margin-right: 30px;\n}\n\n.activity_overview .custom-tab-1 .nav-link:hover,\n.activity_overview .custom-tab-1 .nav-link.active {\n  background: transparent;\n  color: #fff;\n  border-color: #fff;\n}\n\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n  background-color: transparent !important;\n  opacity: 0.9;\n}\n\n@media only screen and (max-width: 575px) {\n  .chart-link {\n    display: flex;\n    align-items: center;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .chart-link {\n    display: flex;\n    align-items: center;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  .chart-link {\n    display: flex;\n    align-items: center;\n  }\n}\n\n.chart-link .week-link {\n  display: inline-block;\n}\n\n.chart-link a {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 500;\n  margin-right: 10px;\n}\n\n.chart-link a i {\n  font-size: 13px;\n}\n\n.chart-link a i.text-primary {\n  color: #00ADEE;\n}\n\n.chart-link a i.text-muted {\n  color: #DAE2F3 !important;\n}\n\n.chart-link .form-control {\n  max-width: 97px;\n  display: inline-block;\n}\n\n.input-group.input-group-lg .form-control,\n.input-group.input-group-lg .input-group-text {\n  height: 80px;\n  padding: 10px 30px;\n}\n\n@media only screen and (max-width: 575px) {\n\n  .input-group.input-group-lg .form-control,\n  .input-group.input-group-lg .input-group-text {\n    height: 50px;\n    padding: 10px 15px;\n    font-size: 14px;\n  }\n}\n\n.input-group.input-group-lg .input-group-text {\n  width: 200px;\n  text-align: left;\n}\n\n@media only screen and (max-width: 575px) {\n  .input-group.input-group-lg .input-group-text {\n    width: 120px;\n    padding: 10px 15px;\n    height: 50px;\n    font-size: 14px;\n  }\n}\n\n.card-tabs .nav-tabs {\n  border-bottom: 0px;\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n  flex-wrap: unset;\n}\n\n.card-tabs .nav-tabs .nav-link {\n  border-radius: 0;\n  padding: 12px 20px;\n  font-weight: 500;\n  font-size: 14px;\n  border: 1px solid #EEEEEE;\n  color: #00ADEE;\n}\n\n.card-tabs .nav-tabs .nav-link.active {\n  background: #F4F5F9;\n}\n\n@media only screen and (max-width: 1400px) {\n  .card-tabs .nav-tabs .nav-link {\n    padding: 8px 15px;\n    font-weight: 400;\n    font-size: 13px;\n  }\n}\n\n.card-tabs .nav-tabs.tabs-lg .nav-link {\n  padding: 23px 30px;\n  font-size: 16px;\n}\n\n@media only screen and (max-width: 767px) {\n  .card-tabs .nav-tabs.tabs-lg .nav-link {\n    padding: 10px 15px;\n    font-size: 14px;\n  }\n}\n\n.card-tabs.icontabs .nav-tabs {\n  background: transparent;\n}\n\n.card-tabs.icontabs .nav-tabs .nav-item .nav-link {\n  height: 42px;\n  width: 42px;\n  line-height: 42px;\n  text-align: center;\n  background: rgba(137, 137, 137, 0.6);\n  color: #fff;\n  margin-right: 15px;\n  border-radius: 50px;\n  padding: 0;\n}\n\n.card-tabs.icontabs .nav-tabs .nav-item .nav-link.active {\n  background: #FF9B52;\n}\n\n.card-tabs.icontabs .nav-tabs .nav-item .nav-link i {\n  font-size: 25px;\n  line-height: 42px;\n}\n\n.revenue-chart .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {\n  display: flex !important;\n  margin-right: 30px !important;\n  margin-bottom: 30px !important;\n}\n\n.revenue-chart-bar {\n  margin-bottom: -30px;\n}\n\n@media only screen and (max-width: 575px) {\n  .revenue-chart-bar {\n    margin-bottom: 20px;\n    float: none;\n    padding-left: 20px;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n  .revenue-chart-bar {\n    margin-bottom: 20px;\n    float: none;\n    padding-left: 20px;\n  }\n}\n\n#activeUser {\n  height: 215px !important;\n}\n\n#activeUser {\n  height: 180px !important;\n}\n\nspan#counter {\n  font-size: 30px;\n  font-weight: 700;\n  color: #00ADEE;\n}\n\n.social-graph-wrapper {\n  text-align: center;\n  padding: 20px;\n  position: relative;\n  color: #fff;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.social-graph-wrapper.widget-facebook {\n  background-color: #3b5998;\n}\n\n.social-graph-wrapper.widget-twitter {\n  background-color: #1da1f2;\n}\n\n.social-graph-wrapper.widget-linkedin {\n  background-color: #007bb6;\n}\n\n.social-graph-wrapper.widget-googleplus {\n  background-color: #db4439;\n}\n\n.social-graph-wrapper .s-icon {\n  font-size: 24px;\n  position: relative;\n  padding: 0 10px;\n}\n\n.recent-stats i {\n  font-size: 11px;\n  position: relative;\n  top: -1px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n  #lineChart_3Kk {\n    height: 140px !important;\n  }\n}\n\n/* add menu sidebar */\n.add-menu-sidebar {\n  background: #00ADEE;\n  padding: 40px 20px 20px;\n  border-radius: 0;\n  position: relative;\n  margin: 50px 50px 30px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .add-menu-sidebar {\n    margin: 50px 25px 30px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .add-menu-sidebar {\n    margin: 20px 25px 30px;\n  }\n}\n\n.add-menu-sidebar p {\n  font-size: 16px;\n  line-height: 1.4;\n  font-weight: 300;\n  color: #fff;\n}\n\n.add-menu-sidebar:after {\n  position: absolute;\n  background-image: url(\"../images/dots.svg\");\n  background-repeat: no-repeat;\n  bottom: 10px;\n  right: 20px;\n  content: \"\";\n  height: 30px;\n  width: 25px;\n}\n\n.donut-chart-sale {\n  position: relative;\n}\n\n.donut-chart-sale small {\n  font-size: 16px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  display: flex;\n  align-items: center;\n  top: 0;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.profile-bx .profile-image {\n  background-image: url(\"../images/circle.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n}\n\n.profile-bx .profile-image img {\n  margin: 18px;\n  width: 118px;\n}\n\n.search-area {\n  width: 300px;\n}\n\n\n\n.search-area .form-control {\n  background: #EFEFEF !important;\n  border-width: 0px;\n  padding-left: 20px;\n  min-height: 45px;\n  max-height: 45px;\n  border-radius: 0.5rem;\n  /* border-top-left-radius: 60px;\n  border-bottom-left-radius: 60px; */\n}\n\n.search-area .form-control::placeholder {\n  color: #757575;\n}\n\n.search-area .input-group-text {\n  background: #EFEFEF;\n  border-width: 0px;\n  border-top-right-radius: 60px;\n  border-bottom-right-radius: 60px;\n  padding-left: 0;\n  padding-right: 20px;\n}\n\n.search-area .input-group-text i {\n  font-size: 25px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .search-area .form-control {\n    min-height: 45px;\n    max-height: 45px;\n  }\n\n  .search-area .input-group-text i {\n    font-size: 18px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .search-area .form-control {\n    min-height: 45px;\n    max-height: 45px;\n    max-width: 200px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .search-area .form-control {\n    min-height: 45px;\n    max-height: 45px;\n    max-width: 200px;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .search-area .form-control {\n    min-height: 45px;\n    max-width: 200px;\n  }\n}\n\n.donut-chart-sale {\n  z-index: 1;\n}\n\n.donut-chart-sale .circle {\n  height: 50px;\n  width: 50px;\n  z-index: -1;\n  content: \"\";\n  position: absolute;\n  border-radius: 100%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.donut-chart-sale small {\n  font-size: 14px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  display: flex;\n  align-items: center;\n  top: 0;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.min-w24 {\n  min-width: 24px;\n}\n\n.min-w30 {\n  min-width: 30px;\n}\n\n.min-w32 {\n  min-width: 32px;\n}\n\n.min-w42 {\n  min-width: 42px;\n}\n\n.min-w46 {\n  min-width: 46px;\n}\n\n.min-w50 {\n  min-width: 50px;\n}\n\n.form-group.style-1 .form-control {\n  border-color: transparent;\n  margin-right: -45px;\n  z-index: 0;\n  color: #000;\n  background: #F0F0F0;\n  border-radius: 1.25rem;\n}\n\n.previous-transactions tbody tr td:first-child {\n  width: 100px;\n}\n\n.rating-widget .rating-stars ul li i {\n  font-size: 25px !important;\n}\n\n.border-card h2 {\n  font-size: 54px;\n}\n\n@media only screen and (max-width: 1199px) {\n  .border-card h2 {\n    font-size: 42px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .border-card h2 {\n    font-size: 35px;\n  }\n}\n\n.border-card .position {\n  font-size: 18px;\n}\n\n@media only screen and (max-width: 1199px) {\n  .border-card .position {\n    font-size: 14px;\n  }\n}\n\n.border-card .cd-icon {\n  height: 70px;\n  width: 70px;\n  line-height: 70px;\n  min-width: 70px;\n  text-align: center;\n  border-radius: 1.25rem;\n}\n\n@media only screen and (max-width: 1199px) {\n  .border-card .cd-icon {\n    height: 50px;\n    width: 50px;\n    min-height: 50px;\n    line-height: 46px;\n    min-width: 50px;\n  }\n\n  .border-card .cd-icon svg {\n    width: 25px;\n    height: 25px;\n  }\n}\n\n.border-card .line {\n  height: 4px;\n  border-radius: 1.25rem;\n  width: 95%;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.heart {\n  width: 60px;\n  height: 60px;\n  display: inline-block;\n  background: url(\"../images/like.png\");\n  cursor: pointer;\n  margin: -25px -15px;\n}\n\n.heart-blast {\n  background-position: -1680px 0;\n  transition: background 1s steps(28);\n}\n\n@media only screen and (max-width: 1199px) {\n  .profile-bx {\n    border-right: 1px solid #EEEEEE;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .profile-bx {\n    border-right: 0;\n  }\n}\n\n/*\n===================================\n    Product detail\n===================================*/\n.produtct-detail-tag {\n  display: inline-block;\n}\n\n.produtct-detail-tag a {\n  font-style: 13px;\n  color: #B1B1B1;\n}\n\n.product-detail-content .item-tag {\n  background: #828690;\n  border-radius: 6px;\n  display: inline-block;\n  font-size: 12px;\n  margin-right: 4px;\n  padding: 2px 12px;\n  color: #fff;\n}\n\n.filtaring-area h4 {\n  color: #1d1d1d;\n  font-size: 16px;\n  font-weight: 400;\n  text-transform: lowercase;\n}\n\n.plus-minus-input .input-icon {\n  font-size: 13px;\n  color: #B1B1B1;\n}\n\n.plus-minus-input {\n  display: flex;\n  width: 120px;\n}\n\n.plus-minus-input .custom-btn {\n  border-radius: 0;\n  height: 40px;\n  padding: 12px 8px;\n  background: #fff;\n  border: 1px solid #f0f1f5;\n}\n\n.plus-minus-input .form-control:hover,\n.plus-minus-input .form-control:focus,\n.plus-minus-input .form-control:active {\n  border: 1px solid #f0f1f5;\n}\n\n.btn-reveal-trigger .avatar-xl {\n  min-width: 30px;\n}\n\n.share-view {\n  display: inline-block;\n}\n\n.share-view ul li {\n  display: inline-block;\n}\n\n.share-view .share-icon {\n  width: 40px;\n  height: 40px;\n  display: inline-block;\n  border: 1px solid #f0f1f5;\n  text-align: center;\n  line-height: 40px;\n  font-style: 16px;\n  color: #f0f1f5;\n  margin-right: 8px;\n}\n\n/*--------tab----------*/\n.veritical-line {\n  padding: 20px 30px;\n  border-top: 1px solid #f0f1f5;\n  border-right: 1px solid #f0f1f5;\n  border-bottom: 1px solid #f0f1f5;\n  position: relative;\n}\n\n.veritical-line:before {\n  background: #f0f1f5;\n  bottom: 0;\n  content: \"\";\n  height: 100%;\n  left: -1px;\n  max-height: 40%;\n  position: absolute;\n  width: 1px;\n}\n\n.tab-content-text p {\n  color: #B1B1B1;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 24px;\n  margin-bottom: 25px;\n}\n\n.tab-item-list li a {\n  background: #fff;\n  border-top: 1px solid #f0f1f5;\n  border-left: 1px solid #f0f1f5;\n  border-right: 1px solid #f0f1f5;\n  color: #B1B1B1;\n  display: block;\n  font-size: 16px;\n  padding: 16px;\n  text-transform: uppercase;\n}\n\n.tab-item-list li a:hover,\n.tab-item-list li a:focus {\n  background: #fff;\n  color: #B1B1B1;\n  border-right: 0px;\n}\n\n.tab-item-list li:last-child {\n  border-bottom: 1px solid #f0f1f5;\n}\n\n.tab-list li {\n  margin-bottom: 7px;\n  font-size: 13px;\n}\n\n.tab-list li i {\n  font-size: 13px;\n  margin-right: 14px;\n}\n\n.slide-item-list {\n  text-align: center;\n  margin: 0 -5px;\n}\n\n.slide-item-list li {\n  display: inline-block;\n  flex: 0 0 25%;\n  width: 25%;\n  padding: 0 5px;\n}\n\n.slide-item-list li a {\n  display: inline-block;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  background: transparent;\n  padding-bottom: 0px;\n}\n\n.slide-item-list li a:hover,\n.slide-item-list li a:focus {\n  background: transparent;\n}\n\n.slide-item-list li a img {\n  width: 100%;\n}\n\n.product-detail-text {\n  padding-top: 28px;\n  padding-left: 30px;\n  padding-right: 30px;\n  padding-bottom: 70px;\n}\n\n.star-rating .product-review {\n  font-style: 13px;\n  color: #B1B1B1;\n  font-weight: 400;\n  text-decoration: underline !important;\n}\n\n.product-detail .tab-content img {\n  display: inline-block;\n  width: 100%;\n}\n\n.popular-tag ul {\n  margin: 0px;\n  padding: 0px;\n}\n\n.popular-tag ul li {\n  display: inline-block;\n  padding: 8px 15px;\n  background: #f8f8f8;\n  font-size: 13px;\n  color: #fff;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.size-filter ul li {\n  display: inline-block;\n}\n\n.intro {\n  border: 1px solid red;\n  color: #1d1d1d;\n}\n\n#listResults .slider {\n  margin: 25px 0;\n}\n\n#listResults .slider-box {\n  width: 90%;\n  margin: 25px auto;\n}\n\n#listResults input {\n  width: 10%;\n}\n\n#listResults label {\n  border: none;\n  display: inline-block;\n  margin-right: -4px;\n  vertical-align: top;\n  width: 30%;\n}\n\n.plus-minus-input .input-icon {\n  font-size: 13px;\n  color: #aaaaaa;\n}\n\n.plus-minus-input .custom-btn {\n  border-radius: 0;\n  height: 40px;\n  padding: 8px 12px;\n  background: #ffffff;\n  border: 1px solid #c8c8c8;\n}\n\n.plus-minus-input .custom-btn:hover,\n.plus-minus-input .custom-btn:focus,\n.plus-minus-input .custom-btn.active {\n  box-shadow: none;\n  outline: none;\n}\n\n.plus-minus-input .form-control {\n  height: 40px;\n  border-top: 1px solid #c8c8c8;\n  border-bottom: 1px solid #c8c8c8;\n  border-left: 0px solid #c8c8c8;\n  border-right: 1px solid #c8c8c8;\n}\n\n.plus-minus-input .form-control:hover,\n.plus-minus-input .form-control:focus,\n.plus-minus-input .form-control:active {\n  border-top: 1px solid #c8c8c8;\n  border-bottom: 1px solid #c8c8c8;\n  border-left: 0px solid #c8c8c8;\n  border-right: 0px solid #c8c8c8;\n}\n\n.new-arrival-product .new-arrivals-img-contnent {\n  overflow: hidden;\n}\n\n.new-arrival-product .new-arrivals-img-contnent img {\n  width: 100%;\n  -webkit-transition: all 0.5s;\n  -ms-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.new-arrival-product:hover .new-arrivals-img-contnent img {\n  transform: scale(1.5) translateY(12%);\n  -moz-transform: scale(1.5) translateY(12%);\n  -webkit-transform: scale(1.5) translateY(12%);\n  -ms-transform: scale(1.5) translateY(12%);\n  -o-transform: scale(1.5) translateY(12%);\n}\n\n/*\n===================================\n    list view\n===================================*/\n.new-arrival-content .item {\n  font-size: 12px;\n  color: #B1B1B1;\n}\n\n.new-arrival-content h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.new-arrival-content h4 a {\n  color: #000;\n}\n\n.new-arrival-content .price {\n  font-weight: 600;\n  color: #00ADEE;\n  font-size: 24px;\n  margin-bottom: 0;\n  float: right;\n}\n\n@media only screen and (max-width: 575px) {\n  .new-arrival-content .price {\n    float: none;\n    margin-top: 10px;\n  }\n}\n\n.new-arrival-content p {\n  font-size: 14px;\n  color: #828690;\n  margin-bottom: 6px;\n  line-height: 24px;\n}\n\n.new-arrival-content .text-content {\n  margin-top: 18px;\n}\n\n.new-arrival-content.text-center .price {\n  float: unset;\n}\n\n.success-icon {\n  color: #2BC155;\n  font-size: 16px;\n}\n\n.comment-review {\n  margin-bottom: 15px;\n  display: table;\n  width: 100%;\n}\n\n.comment-review .client-review {\n  color: #828690;\n  padding-right: 20px;\n  text-decoration: underline !important;\n  font-size: 14px;\n}\n\n.comment-review .span {\n  color: #828690;\n  font-size: 14px;\n}\n\n@media only screen and (max-width: 575px) {\n  .comment-review {\n    margin-bottom: 0;\n  }\n}\n\n.star-rating li {\n  display: inline-block;\n}\n\n.star-rating li i {\n  color: gold;\n}\n\n.rtl {\n  text-align: right;\n  direction: rtl;\n}\n\n.rtl .nav {\n  padding-right: 0;\n}\n\n.rtl .navbar-nav .nav-item {\n  float: right;\n}\n\n.rtl .navbar-nav .nav-item+.nav-item {\n  margin-right: 1rem;\n  margin-left: inherit;\n}\n\n.rtl th {\n  text-align: right;\n}\n\n.rtl .alert-dismissible {\n  padding-right: 1.25rem;\n  padding-left: 4rem;\n}\n\n.rtl .dropdown-menu {\n  right: 0;\n  text-align: right;\n}\n\n.rtl .checkbox label {\n  padding-right: 1.25rem;\n  padding-left: inherit;\n}\n\n.rtl .btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.rtl .btn-group>.btn:last-child:not(:first-child),\n.rtl .btn-group>.dropdown-toggle:not(:first-child) {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .custom-control-label::after,\n.rtl .custom-control-label::before {\n  right: 0;\n  left: inherit;\n}\n\n.rtl .custom-select {\n  padding: 0.375rem 0.75rem 0.375rem 1.75rem;\n  background: #fff url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") no-repeat left 0.75rem center;\n  background-size: 8px 10px;\n}\n\n.rtl .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),\n.rtl .input-group>.input-group-append:last-child>.input-group-text:not(:last-child),\n.rtl .input-group>.input-group-append:not(:last-child)>.btn,\n.rtl .input-group>.input-group-append:not(:last-child)>.input-group-text,\n.rtl .input-group>.input-group-prepend>.btn,\n.rtl .input-group>.input-group-prepend>.input-group-text {\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.rtl .input-group>.input-group-append>.btn,\n.rtl .input-group>.input-group-append>.input-group-text,\n.rtl .input-group>.input-group-prepend:first-child>.btn:not(:first-child),\n.rtl .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),\n.rtl .input-group>.input-group-prepend:not(:first-child)>.btn,\n.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .input-group>.custom-select:not(:first-child),\n.rtl .input-group>.form-control:not(:first-child) {\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.rtl .input-group>.custom-select:not(:last-child),\n.rtl .input-group>.form-control:not(:last-child) {\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.rtl .input-group>.custom-select:not(:last-child):not(:first-child),\n.rtl .input-group>.form-control:not(:last-child):not(:first-child) {\n  border-radius: 0;\n}\n\n.rtl .custom-control {\n  padding-right: 1.5rem;\n  padding-left: inherit;\n  margin-right: inherit;\n  margin-left: 1rem;\n}\n\n.rtl .custom-control-indicator {\n  right: 0;\n  left: inherit;\n}\n\n.rtl .custom-file-label::after {\n  right: initial;\n  left: -1px;\n  border-radius: .25rem 0 0 .25rem;\n}\n\n.rtl .radio input,\n.rtl .radio-inline,\n.rtl .checkbox input,\n.rtl .checkbox-inline input {\n  margin-right: -1.25rem;\n  margin-left: inherit;\n}\n\n.rtl .list-group {\n  padding-right: 0;\n  padding-left: 40px;\n}\n\n.rtl .close {\n  float: left;\n}\n\n.rtl .modal-header .close {\n  margin: -15px auto -15px -15px;\n}\n\n.rtl .modal-footer> :not(:first-child) {\n  margin-right: .25rem;\n}\n\n.rtl .alert-dismissible .close {\n  right: inherit;\n  left: 0;\n}\n\n.rtl .dropdown-toggle::after {\n  margin-right: .255em;\n  margin-left: 0;\n}\n\n.rtl .form-check-input {\n  margin-right: -1.25rem;\n  margin-left: inherit;\n}\n\n.rtl .form-check-label {\n  padding-right: 1.25rem;\n  padding-left: inherit;\n}\n\n.rtl .offset-1 {\n  margin-right: 8.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-2 {\n  margin-right: 16.6666666667%;\n  margin-left: 0;\n}\n\n.rtl .offset-3 {\n  margin-right: 25%;\n  margin-left: 0;\n}\n\n.rtl .offset-4 {\n  margin-right: 33.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-5 {\n  margin-right: 41.6666666667%;\n  margin-left: 0;\n}\n\n.rtl .offset-6 {\n  margin-right: 50%;\n  margin-left: 0;\n}\n\n.rtl .offset-7 {\n  margin-right: 58.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-8 {\n  margin-right: 66.6666666667%;\n  margin-left: 0;\n}\n\n.rtl .offset-9 {\n  margin-right: 75%;\n  margin-left: 0;\n}\n\n.rtl .offset-10 {\n  margin-right: 83.3333333333%;\n  margin-left: 0;\n}\n\n.rtl .offset-11 {\n  margin-right: 91.6666666667%;\n  margin-left: 0;\n}\n\n@media (min-width: 576px) {\n  .rtl .offset-sm-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-sm-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .offset-md-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-md-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .offset-lg-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-lg-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .offset-xl-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xl-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .offset-xxl-0 {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-1 {\n    margin-right: 8.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-2 {\n    margin-right: 16.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-3 {\n    margin-right: 25%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-4 {\n    margin-right: 33.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-5 {\n    margin-right: 41.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-6 {\n    margin-right: 50%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-7 {\n    margin-right: 58.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-8 {\n    margin-right: 66.6666666667%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-9 {\n    margin-right: 75%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-10 {\n    margin-right: 83.3333333333%;\n    margin-left: 0;\n  }\n\n  .rtl .offset-xxl-11 {\n    margin-right: 91.6666666667%;\n    margin-left: 0;\n  }\n}\n\n.rtl .mr-0,\n.rtl .mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.rtl .ml-0,\n.rtl .mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.rtl .mr-1,\n.rtl .mx-1 {\n  margin-right: 0 !important;\n  margin-left: 0.25rem !important;\n}\n\n.rtl .ml-1,\n.rtl .mx-1 {\n  margin-left: 0 !important;\n  margin-right: 0.25rem !important;\n}\n\n.rtl .mr-2,\n.rtl .mx-2 {\n  margin-right: 0 !important;\n  margin-left: 0.5rem !important;\n}\n\n.rtl .ml-2,\n.rtl .mx-2 {\n  margin-left: 0 !important;\n  margin-right: 0.5rem !important;\n}\n\n.rtl .mr-3,\n.rtl .mx-3 {\n  margin-right: 0 !important;\n  margin-left: 1rem !important;\n}\n\n.rtl .ml-3,\n.rtl .mx-3 {\n  margin-left: 0 !important;\n  margin-right: 1rem !important;\n}\n\n.rtl .mr-4,\n.rtl .mx-4 {\n  margin-right: 0 !important;\n  margin-left: 1.5rem !important;\n}\n\n.rtl .ml-4,\n.rtl .mx-4 {\n  margin-left: 0 !important;\n  margin-right: 1.5rem !important;\n}\n\n.rtl .mr-5,\n.rtl .mx-5 {\n  margin-right: 0 !important;\n  margin-left: 3rem !important;\n}\n\n.rtl .ml-5,\n.rtl .mx-5 {\n  margin-left: 0 !important;\n  margin-right: 3rem !important;\n}\n\n.rtl .pr-0,\n.rtl .px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.rtl .pl-0,\n.rtl .px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.rtl .pr-1,\n.rtl .px-1 {\n  padding-right: 0 !important;\n  padding-left: 0.25rem !important;\n}\n\n.rtl .pl-1,\n.rtl .px-1 {\n  padding-left: 0 !important;\n  padding-right: 0.25rem !important;\n}\n\n.rtl .pr-2,\n.rtl .px-2 {\n  padding-right: 0 !important;\n  padding-left: 0.5rem !important;\n}\n\n.rtl .pl-2,\n.rtl .px-2 {\n  padding-left: 0 !important;\n  padding-right: 0.5rem !important;\n}\n\n.rtl .pr-3,\n.rtl .px-3 {\n  padding-right: 0 !important;\n  padding-left: 1rem !important;\n}\n\n.rtl .pl-3,\n.rtl .px-3 {\n  padding-left: 0 !important;\n  padding-right: 1rem !important;\n}\n\n.rtl .pr-4,\n.rtl .px-4 {\n  padding-right: 0 !important;\n  padding-left: 1.5rem !important;\n}\n\n.rtl .pl-4,\n.rtl .px-4 {\n  padding-left: 0 !important;\n  padding-right: 1.5rem !important;\n}\n\n.rtl .pr-5,\n.rtl .px-5 {\n  padding-right: 0 !important;\n  padding-left: 3rem !important;\n}\n\n.rtl .pl-5,\n.rtl .px-5 {\n  padding-left: 0 !important;\n  padding-right: 3rem !important;\n}\n\n.rtl .mr-auto {\n  margin-right: 0 !important;\n  margin-left: auto !important;\n}\n\n.rtl .ml-auto {\n  margin-right: auto !important;\n  margin-left: 0 !important;\n}\n\n.rtl .mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n\n  .rtl .mr-sm-0,\n  .rtl .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-sm-0,\n  .rtl .mx-sm-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-sm-1,\n  .rtl .mx-sm-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-sm-1,\n  .rtl .mx-sm-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-sm-2,\n  .rtl .mx-sm-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-sm-2,\n  .rtl .mx-sm-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-sm-3,\n  .rtl .mx-sm-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-sm-3,\n  .rtl .mx-sm-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-sm-4,\n  .rtl .mx-sm-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-sm-4,\n  .rtl .mx-sm-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-sm-5,\n  .rtl .mx-sm-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-sm-5,\n  .rtl .mx-sm-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-sm-0,\n  .rtl .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-sm-0,\n  .rtl .px-sm-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-sm-1,\n  .rtl .px-sm-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-sm-1,\n  .rtl .px-sm-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-sm-2,\n  .rtl .px-sm-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-sm-2,\n  .rtl .px-sm-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-sm-3,\n  .rtl .px-sm-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-sm-3,\n  .rtl .px-sm-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-sm-4,\n  .rtl .px-sm-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-sm-4,\n  .rtl .px-sm-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-sm-5,\n  .rtl .px-sm-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-sm-5,\n  .rtl .px-sm-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-sm-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-sm-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .rtl .mr-md-0,\n  .rtl .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-md-0,\n  .rtl .mx-md-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-md-1,\n  .rtl .mx-md-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-md-1,\n  .rtl .mx-md-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-md-2,\n  .rtl .mx-md-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-md-2,\n  .rtl .mx-md-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-md-3,\n  .rtl .mx-md-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-md-3,\n  .rtl .mx-md-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-md-4,\n  .rtl .mx-md-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-md-4,\n  .rtl .mx-md-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-md-5,\n  .rtl .mx-md-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-md-5,\n  .rtl .mx-md-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-md-0,\n  .rtl .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-md-0,\n  .rtl .px-md-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-md-1,\n  .rtl .px-md-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-md-1,\n  .rtl .px-md-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-md-2,\n  .rtl .px-md-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-md-2,\n  .rtl .px-md-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-md-3,\n  .rtl .px-md-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-md-3,\n  .rtl .px-md-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-md-4,\n  .rtl .px-md-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-md-4,\n  .rtl .px-md-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-md-5,\n  .rtl .px-md-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-md-5,\n  .rtl .px-md-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-md-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-md-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .rtl .mr-lg-0,\n  .rtl .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-lg-0,\n  .rtl .mx-lg-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-lg-1,\n  .rtl .mx-lg-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-lg-1,\n  .rtl .mx-lg-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-lg-2,\n  .rtl .mx-lg-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-lg-2,\n  .rtl .mx-lg-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-lg-3,\n  .rtl .mx-lg-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-lg-3,\n  .rtl .mx-lg-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-lg-4,\n  .rtl .mx-lg-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-lg-4,\n  .rtl .mx-lg-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-lg-5,\n  .rtl .mx-lg-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-lg-5,\n  .rtl .mx-lg-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-lg-0,\n  .rtl .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-lg-0,\n  .rtl .px-lg-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-lg-1,\n  .rtl .px-lg-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-lg-1,\n  .rtl .px-lg-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-lg-2,\n  .rtl .px-lg-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-lg-2,\n  .rtl .px-lg-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-lg-3,\n  .rtl .px-lg-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-lg-3,\n  .rtl .px-lg-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-lg-4,\n  .rtl .px-lg-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-lg-4,\n  .rtl .px-lg-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-lg-5,\n  .rtl .px-lg-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-lg-5,\n  .rtl .px-lg-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-lg-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-lg-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .rtl .mr-xl-0,\n  .rtl .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-xl-0,\n  .rtl .mx-xl-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-xl-1,\n  .rtl .mx-xl-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-xl-1,\n  .rtl .mx-xl-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-xl-2,\n  .rtl .mx-xl-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-xl-2,\n  .rtl .mx-xl-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-xl-3,\n  .rtl .mx-xl-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-xl-3,\n  .rtl .mx-xl-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-xl-4,\n  .rtl .mx-xl-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-xl-4,\n  .rtl .mx-xl-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-xl-5,\n  .rtl .mx-xl-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-xl-5,\n  .rtl .mx-xl-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-xl-0,\n  .rtl .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-xl-0,\n  .rtl .px-xl-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-xl-1,\n  .rtl .px-xl-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-xl-1,\n  .rtl .px-xl-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-xl-2,\n  .rtl .px-xl-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-xl-2,\n  .rtl .px-xl-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-xl-3,\n  .rtl .px-xl-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-xl-3,\n  .rtl .px-xl-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-xl-4,\n  .rtl .px-xl-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-xl-4,\n  .rtl .px-xl-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-xl-5,\n  .rtl .px-xl-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-xl-5,\n  .rtl .px-xl-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1440) {\n\n  .rtl .mr-xxl-0,\n  .rtl .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .ml-xxl-0,\n  .rtl .mx-xxl-0 {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mr-xxl-1,\n  .rtl .mx-xxl-1 {\n    margin-right: 0 !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .ml-xxl-1,\n  .rtl .mx-xxl-1 {\n    margin-left: 0 !important;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mr-xxl-2,\n  .rtl .mx-xxl-2 {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .ml-xxl-2,\n  .rtl .mx-xxl-2 {\n    margin-left: 0 !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mr-xxl-3,\n  .rtl .mx-xxl-3 {\n    margin-right: 0 !important;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .ml-xxl-3,\n  .rtl .mx-xxl-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mr-xxl-4,\n  .rtl .mx-xxl-4 {\n    margin-right: 0 !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .ml-xxl-4,\n  .rtl .mx-xxl-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mr-xxl-5,\n  .rtl .mx-xxl-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .ml-xxl-5,\n  .rtl .mx-xxl-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .pr-xxl-0,\n  .rtl .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .rtl .pl-xxl-0,\n  .rtl .px-xxl-0 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .rtl .pr-xxl-1,\n  .rtl .px-xxl-1 {\n    padding-right: 0 !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .pl-xxl-1,\n  .rtl .px-xxl-1 {\n    padding-left: 0 !important;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .pr-xxl-2,\n  .rtl .px-xxl-2 {\n    padding-right: 0 !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .pl-xxl-2,\n  .rtl .px-xxl-2 {\n    padding-left: 0 !important;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .pr-xxl-3,\n  .rtl .px-xxl-3 {\n    padding-right: 0 !important;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .pl-xxl-3,\n  .rtl .px-xxl-3 {\n    padding-left: 0 !important;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .pr-xxl-4,\n  .rtl .px-xxl-4 {\n    padding-right: 0 !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .pl-xxl-4,\n  .rtl .px-xxl-4 {\n    padding-left: 0 !important;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .pr-xxl-5,\n  .rtl .px-xxl-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .pl-xxl-5,\n  .rtl .px-xxl-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xxl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xxl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n.rtl .text-right {\n  text-align: left !important;\n}\n\n.rtl .text-left {\n  text-align: right !important;\n}\n\n@media (min-width: 576px) {\n  .rtl .text-sm-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-sm-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .text-md-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-md-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .text-lg-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-lg-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .text-xl-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-xl-left {\n    text-align: right !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .text-xxl-right {\n    text-align: left !important;\n  }\n\n  .rtl .text-xxl-left {\n    text-align: right !important;\n  }\n}\n\n.rtl .mx-0 {\n  margin-right: auto;\n  margin-left: 0 !important;\n}\n\n.rtl .mx-0 {\n  margin-left: auto;\n  margin-right: 0 !important;\n}\n\n.rtl .mx-1 {\n  margin-right: auto;\n  margin-left: 0.25rem !important;\n}\n\n.rtl .mx-1 {\n  margin-left: auto;\n  margin-right: 0.25rem !important;\n}\n\n.rtl .mx-2 {\n  margin-right: auto;\n  margin-left: 0.5rem !important;\n}\n\n.rtl .mx-2 {\n  margin-left: auto;\n  margin-right: 0.5rem !important;\n}\n\n.rtl .mx-3 {\n  margin-right: auto;\n  margin-left: 1rem !important;\n}\n\n.rtl .mx-3 {\n  margin-left: auto;\n  margin-right: 1rem !important;\n}\n\n.rtl .mx-4 {\n  margin-right: auto;\n  margin-left: 1.5rem !important;\n}\n\n.rtl .mx-4 {\n  margin-left: auto;\n  margin-right: 1.5rem !important;\n}\n\n.rtl .mx-5 {\n  margin-right: auto;\n  margin-left: 3rem !important;\n}\n\n.rtl .mx-5 {\n  margin-left: auto;\n  margin-right: 3rem !important;\n}\n\n.rtl .px-0 {\n  padding-right: auto;\n  padding-left: 0 !important;\n}\n\n.rtl .px-0 {\n  padding-left: auto;\n  padding-right: 0 !important;\n}\n\n.rtl .px-1 {\n  padding-right: auto;\n  padding-left: 0.25rem !important;\n}\n\n.rtl .px-1 {\n  padding-left: auto;\n  padding-right: 0.25rem !important;\n}\n\n.rtl .px-2 {\n  padding-right: auto;\n  padding-left: 0.5rem !important;\n}\n\n.rtl .px-2 {\n  padding-left: auto;\n  padding-right: 0.5rem !important;\n}\n\n.rtl .px-3 {\n  padding-right: auto;\n  padding-left: 1rem !important;\n}\n\n.rtl .px-3 {\n  padding-left: auto;\n  padding-right: 1rem !important;\n}\n\n.rtl .px-4 {\n  padding-right: auto;\n  padding-left: 1.5rem !important;\n}\n\n.rtl .px-4 {\n  padding-left: auto;\n  padding-right: 1.5rem !important;\n}\n\n.rtl .px-5 {\n  padding-right: auto;\n  padding-left: 3rem !important;\n}\n\n.rtl .px-5 {\n  padding-left: auto;\n  padding-right: 3rem !important;\n}\n\n.rtl .mr-auto {\n  margin-right: 0 !important;\n  margin-left: auto !important;\n}\n\n.rtl .mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.rtl .ml-auto {\n  margin-right: auto !important;\n  margin-left: 0 !important;\n}\n\n.rtl .mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .rtl .mx-sm-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-sm-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-sm-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-sm-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-sm-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-sm-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-sm-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-sm-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-sm-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-sm-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-sm-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-sm-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-sm-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-sm-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-sm-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-sm-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-sm-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-sm-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-sm-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-sm-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-sm-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-sm-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-sm-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-sm-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-sm-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-sm-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .mx-md-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-md-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-md-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-md-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-md-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-md-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-md-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-md-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-md-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-md-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-md-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-md-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-md-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-md-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-md-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-md-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-md-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-md-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-md-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-md-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-md-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-md-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-md-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-md-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-md-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-md-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .mx-lg-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-lg-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-lg-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-lg-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-lg-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-lg-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-lg-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-lg-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-lg-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-lg-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-lg-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-lg-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-lg-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-lg-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-lg-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-lg-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-lg-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-lg-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-lg-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-lg-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-lg-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-lg-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-lg-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-lg-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-lg-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-lg-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .mx-xl-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xl-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-xl-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-xl-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-xl-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-xl-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-xl-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-xl-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-xl-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-xl-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-xl-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-xl-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-xl-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-xl-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-xl-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-xl-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-xl-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-xl-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-xl-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-xl-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-xl-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-xl-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-xl-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-xl-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .mx-xxl-0 {\n    margin-right: auto;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xxl-0 {\n    margin-left: auto;\n    margin-right: 0 !important;\n  }\n\n  .rtl .mx-xxl-1 {\n    margin-right: auto;\n    margin-left: 0.25rem !important;\n  }\n\n  .rtl .mx-xxl-1 {\n    margin-left: auto;\n    margin-right: 0.25rem !important;\n  }\n\n  .rtl .mx-xxl-2 {\n    margin-right: auto;\n    margin-left: 0.5rem !important;\n  }\n\n  .rtl .mx-xxl-2 {\n    margin-left: auto;\n    margin-right: 0.5rem !important;\n  }\n\n  .rtl .mx-xxl-3 {\n    margin-right: auto;\n    margin-left: 1rem !important;\n  }\n\n  .rtl .mx-xxl-3 {\n    margin-left: auto;\n    margin-right: 1rem !important;\n  }\n\n  .rtl .mx-xxl-4 {\n    margin-right: auto;\n    margin-left: 1.5rem !important;\n  }\n\n  .rtl .mx-xxl-4 {\n    margin-left: auto;\n    margin-right: 1.5rem !important;\n  }\n\n  .rtl .mx-xxl-5 {\n    margin-right: auto;\n    margin-left: 3rem !important;\n  }\n\n  .rtl .mx-xxl-5 {\n    margin-left: auto;\n    margin-right: 3rem !important;\n  }\n\n  .rtl .px-xxl-0 {\n    padding-right: auto;\n    padding-left: 0 !important;\n  }\n\n  .rtl .px-xxl-0 {\n    padding-left: auto;\n    padding-right: 0 !important;\n  }\n\n  .rtl .px-xxl-1 {\n    padding-right: auto;\n    padding-left: 0.25rem !important;\n  }\n\n  .rtl .px-xxl-1 {\n    padding-left: auto;\n    padding-right: 0.25rem !important;\n  }\n\n  .rtl .px-xxl-2 {\n    padding-right: auto;\n    padding-left: 0.5rem !important;\n  }\n\n  .rtl .px-xxl-2 {\n    padding-left: auto;\n    padding-right: 0.5rem !important;\n  }\n\n  .rtl .px-xxl-3 {\n    padding-right: auto;\n    padding-left: 1rem !important;\n  }\n\n  .rtl .px-xxl-3 {\n    padding-left: auto;\n    padding-right: 1rem !important;\n  }\n\n  .rtl .px-xxl-4 {\n    padding-right: auto;\n    padding-left: 1.5rem !important;\n  }\n\n  .rtl .px-xxl-4 {\n    padding-left: auto;\n    padding-right: 1.5rem !important;\n  }\n\n  .rtl .px-xxl-5 {\n    padding-right: auto;\n    padding-left: 3rem !important;\n  }\n\n  .rtl .px-xxl-5 {\n    padding-left: auto;\n    padding-right: 3rem !important;\n  }\n\n  .rtl .mr-xxl-auto {\n    margin-right: 0 !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .rtl .ml-xxl-auto {\n    margin-right: auto !important;\n    margin-left: 0 !important;\n  }\n\n  .rtl .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n}\n\n.rtl .float-left {\n  float: right !important;\n}\n\n.rtl .float-right {\n  float: left !important;\n}\n\n.rtl .float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .rtl .float-sm-left {\n    float: right !important;\n  }\n\n  .rtl .float-sm-right {\n    float: left !important;\n  }\n\n  .rtl .float-sm-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .rtl .float-md-left {\n    float: right !important;\n  }\n\n  .rtl .float-md-right {\n    float: left !important;\n  }\n\n  .rtl .float-md-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .rtl .float-lg-left {\n    float: right !important;\n  }\n\n  .rtl .float-lg-right {\n    float: left !important;\n  }\n\n  .rtl .float-lg-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .rtl .float-xl-left {\n    float: right !important;\n  }\n\n  .rtl .float-xl-right {\n    float: left !important;\n  }\n\n  .rtl .float-xl-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1440) {\n  .rtl .float-xxl-left {\n    float: right !important;\n  }\n\n  .rtl .float-xxl-right {\n    float: left !important;\n  }\n\n  .rtl .float-xxl-none {\n    float: none !important;\n  }\n}\n\n[direction=\"rtl\"][data-theme-version=\"dark\"] .border,\n[direction=\"rtl\"][data-theme-version=\"dark\"] .border-left,\n[direction=\"rtl\"][data-theme-version=\"dark\"] .border-right {\n  border-color: #333a54 !important;\n}\n\n[direction=\"rtl\"] .text-right {\n  text-align: left !important;\n}\n\n[direction=\"rtl\"] .text-left {\n  text-align: right !important;\n}\n\n[direction=\"rtl\"] .border-right {\n  border-left: 1px solid #f0f1f5 !important;\n  border-right: 0 !important;\n}\n\n[direction=\"rtl\"] .border-left {\n  border-right: 1px solid #f0f1f5 !important;\n  border-left: 0 !important;\n}\n\n[direction=\"rtl\"] .dropdown-menu {\n  left: auto;\n}\n\n[direction=\"rtl\"] .dropdown-menu-right {\n  left: 0;\n  right: auto;\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .dropdown-menu-right {\n    left: 15px;\n  }\n}\n\n[direction=\"rtl\"] .notification_dropdown .dropdown-menu-right .media>span {\n  margin-left: 10px;\n  margin-right: 0;\n}\n\n[direction=\"rtl\"]:not([data-container=\"boxed\"]) .nav-header {\n  left: auto;\n  right: 0;\n}\n\n[direction=\"rtl\"][data-container=\"wide-boxed\"] .nav-header {\n  left: auto;\n  right: 0;\n}\n\n[direction=\"rtl\"] .nav-header {\n  text-align: right;\n  right: auto;\n}\n\n[direction=\"rtl\"] .nav-header .brand-title {\n  margin-left: 0;\n  margin-right: 15px;\n}\n\n[direction=\"rtl\"] .nav-header .brand-logo {\n  padding-left: 0;\n  padding-right: 1.75rem;\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 0;\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .nav-header .brand-logo[data-layout=\"horizontal\"] {\n  padding-right: 30px;\n}\n\n[data-sidebar-style=\"mini\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 0;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 0;\n}\n\n[data-layout=\"horizontal\"][data-sidebar-style=\"modern\"][direction=\"rtl\"] .nav-header .brand-logo {\n  padding-right: 30px;\n}\n\n@media (max-width: 767.98px) {\n  [direction=\"rtl\"] .nav-header .brand-logo {\n    padding-right: 0;\n  }\n}\n\n[direction=\"rtl\"] .nav-control {\n  right: auto;\n  left: -4.0625rem;\n}\n\n@media (max-width: 767.98px) {\n  [direction=\"rtl\"] .nav-control {\n    left: -4.0625rem;\n  }\n}\n\n@media (max-width: 575.98px) {\n  [direction=\"rtl\"] .nav-control {\n    left: -4.0625rem;\n  }\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"overlay\"] .nav-header .hamburger.is-active {\n  right: 0;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"][data-layout=\"horizontal\"] .nav-header .brand-logo {\n  padding-right: 30px;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .nav-header {\n  width: 16rem;\n}\n\n[direction=\"rtl\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 17.1875rem;\n}\n\n@media (max-width: 767.98px) {\n  [direction=\"rtl\"] .header {\n    padding-right: 3.75rem;\n    padding-left: 0;\n  }\n}\n\n[direction=\"rtl\"] .header .header-content {\n  padding-left: 0;\n  padding-right: 5.3125rem;\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .header .header-content {\n    padding-right: 4.5rem;\n  }\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .header .header-content {\n  padding-right: 1.875rem;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .header .header-content {\n  padding-right: 5.3125rem;\n}\n\n[data-sidebar-style=\"overlay\"][direction=\"rtl\"] .header .header-content {\n  padding-right: 5.3125rem;\n}\n\n[direction=\"rtl\"] .header .nav-control {\n  right: 0.4375rem;\n  left: auto;\n}\n\n[direction=\"rtl\"] .header-left .search_bar .dropdown-menu,\n[direction=\"rtl\"] .header-left .search_bar .dropdown-menu.show {\n  right: 40px !important;\n}\n\n@media only screen and (max-width: 575px) {\n\n  [direction=\"rtl\"] .header-left .search_bar .dropdown-menu,\n  [direction=\"rtl\"] .header-left .search_bar .dropdown-menu.show {\n    right: -100px !important;\n  }\n}\n\n[direction=\"rtl\"] .header-left .search_bar .search_icon {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 5rem;\n  border-bottom-right-radius: 5rem;\n}\n\n@media only screen and (max-width: 575px) {\n  [direction=\"rtl\"] .header-left .search_bar .search_icon {\n    border-radius: 5rem;\n  }\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .header {\n  padding: 0;\n  padding-right: 16rem;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .header .header-content {\n  padding-right: 1.875rem;\n  padding-left: 1.875rem;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"][data-sidebar-style=\"mini\"] .header {\n  padding-right: 6rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"mini\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 3.75rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 9.375rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"][data-layout=\"horizontal\"] .header {\n  padding: 0;\n  padding-right: 16rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"modern\"] .header {\n  padding: 0 0.9375rem;\n  padding-right: 9.375rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] .header {\n  padding: 0;\n  padding-right: 16rem;\n}\n\n[direction=\"rtl\"] {\n  text-align: right;\n}\n\n[direction=\"rtl\"] .deznav {\n  text-align: right;\n}\n\n[direction=\"rtl\"] .deznav .metismenu ul {\n  padding: 0 25px 0 0;\n}\n\n[direction=\"rtl\"] .deznav .metismenu ul:after {\n  left: auto;\n  right: 25px;\n}\n\n[direction=\"rtl\"] .deznav .metismenu ul a:before {\n  left: auto;\n  right: -5px;\n}\n\n[direction=\"rtl\"] .deznav .metismenu li>a svg {\n  margin-left: 5px;\n  margin-right: 0;\n}\n\n[data-sidebar-style=\"compact\"][direction=\"rtl\"] .deznav .metismenu li>a svg {\n  left: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n[data-sidebar-style=\"icon-hover\"][direction=\"rtl\"] .deznav .metismenu li>a svg {\n  margin-left: 0;\n}\n\n[direction=\"rtl\"] .deznav .metismenu li.active>.has-arrow:after {\n  transform: rotate(45deg) translateY(-50%);\n}\n\n[direction=\"rtl\"] .deznav .metismenu .has-arrow:after {\n  left: 1.5625rem;\n  right: auto;\n}\n\n[data-layout=\"horizontal\"][direction=\"rtl\"] .deznav .metismenu .has-arrow:after {\n  left: 1.125rem;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .deznav .metismenu .has-arrow:after {\n  -webkit-transform: rotate(-45deg) translateY(-50%);\n  transform: rotate(-45deg) translateY(-50%);\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle .deznav .metismenu li>ul li:hover ul {\n  right: 11.8125rem;\n  left: 0;\n}\n\n[direction=\"rtl\"] .list-group {\n  padding-left: 0;\n}\n\n[direction=\"rtl\"] .form-check-input {\n  margin-left: -1.25rem;\n  margin-right: inherit;\n}\n\n[direction=\"rtl\"] .form-check-inline .form-check-input {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n[direction=\"rtl\"] .radio input,\n[direction=\"rtl\"] .radio-inline,\n[direction=\"rtl\"] .checkbox input,\n[direction=\"rtl\"] .checkbox-inline input {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n[direction=\"rtl\"] .content-body {\n  margin-right: 17.1875rem;\n  margin-left: auto;\n}\n\n[data-sidebar-style=\"modern\"][direction=\"rtl\"] .content-body {\n  margin-right: 9.375rem;\n}\n\n[direction=\"rtl\"] .content-body .page-titles {\n  text-align: right;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .content-body {\n  margin-right: 0;\n}\n\n[direction=\"rtl\"][data-layout=\"horizontal\"] .deznav .metismenu li li .has-arrow:after {\n  -webkit-transform: rotate(-4deg) translateY(-50%);\n  transform: rotate(-45deg) translateY(-50%);\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"mini\"]:not([data-layout=\"horizontal\"]) .content-body {\n  margin-right: 3.75rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"compact\"]:not([data-layout=\"horizontal\"]) .content-body {\n  margin-right: 9.375rem;\n}\n\n[direction=\"rtl\"][data-sidebar-style=\"overlay\"] .content-body {\n  margin-right: 0;\n}\n\n[direction=\"rtl\"] #external-events .external-event:before {\n  margin-right: 0;\n  margin-left: .9rem;\n}\n\n[direction=\"rtl\"] .post-input a i {\n  margin-left: 15px;\n  margin-right: 0;\n}\n\n@media only screen and (max-width: 1350px) and (min-width: 1200px) {\n  [direction=\"rtl\"] .content-body {\n    margin-right: 14.375rem;\n  }\n}\n\n[direction=\"rtl\"] .sidebar-right {\n  left: -15.625rem;\n  right: auto;\n  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n}\n\n[direction=\"rtl\"] .sidebar-right.show {\n  left: 0;\n  right: auto;\n}\n\n[direction=\"rtl\"] .sidebar-right .sidebar-right-trigger {\n  left: 100%;\n  right: auto;\n  border-radius: 0 5px 5px 0;\n  box-shadow: 5px 3px 5px 0px rgba(119, 119, 119, 0.15);\n}\n\n[direction=\"rtl\"] .bootstrap-select .dropdown-toggle .filter-option {\n  text-align: right;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"] .footer {\n  padding-right: 17.1875rem;\n  padding-left: 0;\n}\n\n@media (max-width: 767.98px) {\n  html[dir=\"rtl\"] [direction=\"rtl\"] .footer {\n    padding-right: 0;\n  }\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-sidebar-style=\"overlay\"] .footer {\n  padding-right: 0;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"] .menu-toggle .footer {\n  padding-right: 3.75rem;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-container=\"boxed\"] .footer {\n  padding-right: 0;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-sidebar-style=\"mini\"]:not([data-layout=\"horizontal\"]) .footer {\n  padding-right: 3.75rem;\n}\n\nhtml[dir=\"rtl\"] [direction=\"rtl\"][data-sidebar-style=\"compact\"]:not([data-layout=\"horizontal\"]) .footer {\n  padding-right: 9.375rem;\n}\n\n/*$primary  : #7356f1 !default;*/\n[data-theme-version=\"dark\"] {\n  background: #181f39;\n  color: #828690;\n}\n\n[data-theme-version=\"dark\"] h1,\n[data-theme-version=\"dark\"] h2,\n[data-theme-version=\"dark\"] h3,\n[data-theme-version=\"dark\"] h4,\n[data-theme-version=\"dark\"] h5,\n[data-theme-version=\"dark\"] h6 {\n  color: #fff !important;\n}\n\n[data-theme-version=\"dark\"] a.link {\n  color: #ddd;\n}\n\n[data-theme-version=\"dark\"] a.link:focus,\n[data-theme-version=\"dark\"] a.link:hover {\n  color: #2D28FF;\n}\n\n[data-theme-version=\"dark\"] a:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .border-right {\n  border-right: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border-left {\n  border-left: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border-top {\n  border-top: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border-bottom {\n  border-bottom: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .border {\n  border: 1px solid #333a54 !important;\n}\n\n[data-theme-version=\"dark\"] .dropdown-menu {\n  background-color: #181f39;\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item.selected,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item.selected.active,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item.active,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item:hover,\n[data-theme-version=\"dark\"] .dropdown-menu .dropdown-item:focus {\n  background-color: #1e2746;\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .form-control {\n  background-color: #181f39;\n  border-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .card {\n  background-color: #1e2746;\n  box-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .btn-outline-dark:hover {\n  background-color: #181f39;\n  border-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .tdl-holder input[type=text],\n[data-theme-version=\"dark\"] .tdl-holder li {\n  background-color: #1e2746;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .tdl-holder input[type=text]::placeholder {\n  color: #828690;\n}\n\n[data-theme-version=\"dark\"] .tdl-holder label:hover {\n  background-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .text-muted {\n  color: #828690 !important;\n}\n\n[data-theme-version=\"dark\"] .modal-content {\n  background: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .modal-footer,\n[data-theme-version=\"dark\"] .modal-header {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .close {\n  font-weight: 400;\n  color: #fff;\n  text-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .close:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .table strong {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .text-dark {\n  color: #828690 !important;\n}\n\n[data-theme-version=\"dark\"] .star-rating .product-review,\n[data-theme-version=\"dark\"] .new-arrival-content .item {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .custom-dropdown .dropdown-menu {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .widget-stat .media>span {\n  background: #333a54;\n  border-color: #333a54;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .plus-minus-input .custom-btn {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .dropdown-divider,\n[data-theme-version=\"dark\"] .size-filter ul li {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .custom-select {\n  border-color: #333a54;\n  color: #828690;\n  background: #181f39;\n}\n\n[data-theme-version=\"dark\"] .nav-tabs {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .mail-list .list-group-item.active i {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] hr {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .grid-col {\n  background: #181f39;\n}\n\n[data-theme-version=\"dark\"] .noUi-target {\n  border-color: #333a54;\n  border-radius: 8px;\n  box-shadow: none;\n}\n\n[data-theme-version=\"dark\"] .noUi-target .noUi-connects {\n  background: #333a54;\n}\n\n[data-theme-version=\"dark\"] .noUi-marker-large,\n[data-theme-version=\"dark\"] .noUi-marker {\n  background: #333a54;\n}\n\n[data-theme-version=\"dark\"] .input-group-text {\n  background: #333a54;\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .note-editor.note-frame {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .note-editor.note-frame .btn {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .note-editor.note-frame .note-editing-area .note-editable {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .widget-media .timeline .timeline-panel {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .notification_dropdown .dropdown-menu-right .all-notification {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] #user-activity .nav-tabs .nav-link {\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .list-group-item-action {\n  color: #7e7e7e;\n}\n\n[data-theme-version=\"dark\"] .list-group-item-action:focus,\n[data-theme-version=\"dark\"] .list-group-item-action:hover,\n[data-theme-version=\"dark\"] .list-group-item-action:focus {\n  background-color: #181f39;\n  border-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .list-group-item.active {\n  color: #fff;\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .list-group-item.active:focus,\n[data-theme-version=\"dark\"] .list-group-item.active:hover,\n[data-theme-version=\"dark\"] .list-group-item.active:focus {\n  background-color: #00ADEE;\n  border-color: #00ADEE;\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .swal2-popup {\n  background: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .header {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .header-left input {\n  background: #181f39 !important;\n  border-color: transparent;\n  color: #fff !important;\n}\n\n[data-theme-version=\"dark\"] .header-left input:focus {\n  box-shadow: none;\n  border-color: #00ADEE;\n}\n\n[data-theme-version=\"dark\"] .header-left input::placeholder {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-left .search_icon {\n  background: #181f39 !important;\n}\n\n[data-theme-version=\"dark\"] .header-left .search_icon i {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .right-sidebar a {\n  color: #00ADEE;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .header-right .header-profile>a.nav-link .header-info strong {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .notification_dropdown .nav-link {\n  background: #181f39;\n}\n\n[data-theme-version=\"dark\"] .header-right .dropdown .nav-link {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .dropdown .nav-link:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .header-right .notification_dropdown .dropdown-item a {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .nav-header,\n[data-theme-version=\"dark\"] .nav-control {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .nav-control {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .nav-header,\n[data-theme-version=\"dark\"] .nav-control {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .nav-control {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .brand-logo:hover {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"][data-sidebar-style=\"mini\"] .deznav .metismenu li>ul {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .fixed-content-box {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .fixed-content-box .head-name {\n  background: #1e2746;\n  color: #fff;\n  border-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .fixed-content-box+.header+.deznav {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .deznav {\n  background-color: #1e2746;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li>a {\n  color: #b3b3b3;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a,\n[data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a,\n[data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li:hover>a::after,\n[data-theme-version=\"dark\"] .deznav .metismenu>li:focus>a::after,\n[data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active>a::after {\n  border-color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu>li.mm-active ul ul {\n  background-color: transparent;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu ul:after {\n  background-color: #333a54;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu ul a:hover,\n[data-theme-version=\"dark\"] .deznav .metismenu ul a:focus,\n[data-theme-version=\"dark\"] .deznav .metismenu ul a.mm-active {\n  color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu ul a:before {\n  background-color: #fff;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu a {\n  color: #b3b3b3;\n}\n\n[data-theme-version=\"dark\"] .deznav .metismenu .has-arrow:after {\n  border-color: #fff;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right {\n  background-color: #1d2544;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .nav-tabs {\n  background-color: #1d2544;\n  border-bottom: 1px solid #181f39;\n}\n\n[data-theme-version=\"dark\"] .sidebar-right .nav-tabs .nav-link.active {\n  background-color: #181f39;\n}\n\n[data-theme-version=\"dark\"] .footer {\n  background-color: transparent;\n}\n\n[data-theme-version=\"dark\"] .footer .copyright {\n  background-color: transparent;\n}\n\n[data-theme-version=\"dark\"] .footer .copyright p {\n  color: #fff;\n}\n\n.Color-box {\n  /* background-color: #00ADEE;  border: 1px solid #00ADEE;  color: #00ADEE; */\n  border: 1px solid #00ADEE;\n  color: #00ADEE;\n}\n\n.form-control.Color-box:focus {\n  border: 1px solid #00ADEE;\n}\n\n.Color-box {\n  border: 1px solid #00ADEE;\n  color: grey !important;\n  padding: 10px !important;\n  border-radius: 25px !important;\n}\n\n.suggestions-div {\n  border-bottom: 1px solid #00ADEE;\n  text-align: center;\n  border-radius: 0;\n  position: relative;\n  color: white;\n  background-color: #3C4B67;\n  height: auto;\n  cursor: pointer;\n  z-index: 3\n}\n\n.suggestions-div:hover {\n  background-color: #00ADEE;\n}\n\n.deznav .metismenu>li.mm-active>a {\n  color: #fff !important;\n}\n\n.light.badge-success {\n  background-color: #00ADEE !important;\n  color: white !important;\n}\n\na:hover {\n  color: #00ADEE;\n  text-decoration: underline;\n}\n\n.tox-statusbar__branding {\n  display: none !important;\n}\n\n.Description-Label {\n  color: black;\n  font-weight: 500\n}\n\n.textAlign-Right {\n  text-align: right;\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #00ADEE !important;\n  border-color: #00ADEE !important;\n}\n\n.btn-success:hover {\n  color: #fff;\n  background-color: #00ADEE !important;\n  border-color: #00ADEE !important;\n}\n\n.btn-close {\n  content: \"✖\";\n  /* content: \"&#9587\";  */\n  border: 1px solid #00ADEE;\n  background-color: white;\n  padding: 0.7em;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n/* for type equal to number */\n\n.remove-spin::-webkit-inner-spin-button,\n.remove-spin::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.show-desktop-animation {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.show-desktop-animation2 {\n\n  display: flex;\n  flex-direction: column;\n\n}\n\n.background-image-login {\n  background-image: url('../images/login_bg/bg.png');\n  /* height: 100vh;\n  text-align: center;\n  background-size: cover; */\n  background-repeat: no-repeat;\n}\n\n@media (max-width:991.98px) {\n  .show-results {\n    display: none;\n  }\n\n  .search-area {\n    max-width: 250px;\n  }\n\n  .background-image-login {\n    background-image: url('../images/login_bg/handShake.png');\n  }\n\n  /* .background-image-register{\n    background-image: url('../images/login_bg/regImg.jpeg');\n  } */\n}\n\n/* css animation for background images */\n.search-image {\n\n  animation: searchh 2s linear 4s infinite;\n}\n\n@keyframes searchh {\n  0% {\n    left: -10px;\n    top: -150px;\n  }\n\n  15% {\n    left: -25px;\n    top: -150px;\n  }\n\n  20% {\n    left: -10px;\n    top: -120px;\n  }\n\n  36% {\n    left: 10px;\n    top: -130px;\n  }\n\n  45% {\n    left: 3px;\n    top: -135px;\n  }\n\n  60% {\n    left: 5px;\n    top: -140px;\n  }\n\n  70% {\n    left: -10px;\n    top: -150px;\n  }\n\n  100% {\n    left: -10px;\n    top: -150px;\n  }\n}\n.view-profile{\n  background-color: rgb(0, 173, 238);\n    border: none;\n    font-size: 10px !important;\n    padding: 6px 10px;\n    border-radius: 9px;\n}\n.alignCenter{\n  justify-content: center;\n}\n\n.deznav {\n  width: 21.563rem;\n  max-width: 230px;\n  padding-bottom: 0;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  padding-top: 5rem;\n  z-index: 3;\n  background-color: #3C4B64;\n  transition: all .2s ease;\n}","//to ignore cli warning about deprecated mixin\n$enable-deprecation-messages: false;\n$ignore-warning             : true;\n\n// Custom class not bootstrap\n$fn:'HelveticaNeue'; // fn = font normal \n$fm:'HelveticaNeueMed'; // fm = font Medium \n$border-radius: 0.75rem;\n// Body\n$body-bg   : #E5E6E7;\n$body-color: #7e7e7e;\n\n// Typography\n$font-family-base: 'Roboto',\nsans-serif;\n$headings-font-weight   : 500;\n// $headings-font-family:        $fm;\n\n\n\n\n$font-size-base     : 0.875rem !default;\n$font-weight-base   : 400 !default;\n// $line-height-base: 1.6;\n$h1-font-size       : 2.25rem;\n$h2-font-size       : 1.875rem;\n$h3-font-size       : 1.5rem;\n$h4-font-size       : 1.125rem;\n$h5-font-size       : 1rem;\n$h6-font-size       : 0.938rem;\n\n\n//\n// Color system\n//\n$white   : #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black   : #000 !default;\n\n\n$blue  : #5e72e4;\n$indigo: #6610f2 !default;\n$purple: #6f42c1 !default;\n$pink  : #e83e8c !default;\n$red   : #EE3232;\n$orange: #ff9900 !default;\n$yellow: #FFFA6F;\n$green : #297F00;\n$teal  : #20c997 !default;\n$cyan  : #3065D0;\n\n\n\n$grays: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$grays: map-merge((\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900),\n  $grays);\n\n\n$muted     : #89879f;\n$text-muted: #89879f;\n$mine-shaft: #262626;\n$ebony-clay: #232833;\n\n$colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$colors: map-merge((\n\t\"blue\": $blue,\n    \"indigo\": $indigo,\n    \"purple\": $purple,\n    \"pink\": $pink,\n    \"red\": $red,\n    \"orange\": $orange,\n    \"yellow\": $yellow,\n    \"green\": $green,\n    \"teal\": $teal,\n    \"cyan\": $cyan,\n    \"white\": $white,\n    \"gray\": $gray-600,\n    \"gray-dark\": $gray-800),\n  $colors);\n\n\n  \n$primary  : #00ADEE !default;\n/*$primary  : #7356f1 !default;*/\n$secondary: #3F9AE0 !default;\n$success  : #2BC155 !default;\n$info     : #2D28FF !default;\n$warning  : #FF9B52 !default;\n$danger   : #F94687 !default;\n$light    : #F4F5F9 !default;\n$dark     : #B1B1B1;\n\n$theme-colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$theme-colors: map-merge((\"primary\": $primary,\n    \"secondary\": $secondary,\n    \"success\": $success,\n    \"info\": $info,\n    \"warning\": $warning,\n    \"danger\": $danger,\n    \"light\": $light,\n    \"dark\": $dark),\n  $theme-colors);\n\n\n// $base-font-size   : 0.8125rem !default;\n$heading-primary-size: 1.8rem;\n$sub-heading-size    : 1.6rem !default;\n\n$grid-gutter-width: 30px;\n\n$dropdown-lik-color: $body-color;\n\n\n$border-color  : #EEEEEE;\n$headings-color:#3d4465 !default;\n$rounded : 0.75rem ;\n\n\n\n$grid-breakpoints: (xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1440);","%gradient_one {\n    background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%,rgba(103, 25, 255, .85) 100%);\n}\n\n%gradient-1 {\n    background: #f0a907;\n    background: -moz-linear-gradient(top, #f0a907 0%, #f53c79 100%);\n    background: -webkit-linear-gradient(top, #f0a907 0%,#f53c79 100%);\n    background: linear-gradient(to bottom, #f0a907 0%,#f53c79 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f0a907', endColorstr='#f53c79',GradientType=0 );\n}\n\n%gradient-2 {\n    background: #4dedf5;\n    background: -moz-linear-gradient(top, #4dedf5 0%, #480ceb 100%);\n    background: -webkit-linear-gradient(top, #4dedf5 0%,#480ceb 100%);\n    background: linear-gradient(to bottom, #4dedf5 0%,#480ceb 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4dedf5', endColorstr='#480ceb',GradientType=0 );\n}\n\n%gradient-3 {\n    background: #51f5ae;\n    background: -moz-linear-gradient(top, #51f5ae 0%, #3fbcda 100%);\n    background: -webkit-linear-gradient(top, #51f5ae 0%,#3fbcda 100%);\n    background: linear-gradient(to bottom, #51f5ae 0%,#3fbcda 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#51f5ae', endColorstr='#3fbcda',GradientType=0 );\n}\n\n%gradient-4 {\n    background: #f25521;\n    background: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n    background: -webkit-linear-gradient(left, #f25521 0%,#f9c70a 100%);\n    background: linear-gradient(to right, #f25521 0%,#f9c70a 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );\n}\n\n%gradient-5 {\n    background: #f53c79;\n    background: -moz-linear-gradient(left, #f53c79 0%, #f0a907 100%);\n    background: -webkit-linear-gradient(left, #f53c79 0%,#f0a907 100%);\n    background: linear-gradient(to right, #f53c79 0%,#f0a907 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f53c79', endColorstr='#f0a907',GradientType=1 );\n}\n\n%gradient-6 {\n    background: #36b9d8;\n    background: -moz-linear-gradient(left, #36b9d8 0%, #4bffa2 100%);\n    background: -webkit-linear-gradient(left, #36b9d8 0%,#4bffa2 100%);\n    background: linear-gradient(to right, #36b9d8 0%,#4bffa2 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36b9d8', endColorstr='#4bffa2',GradientType=1 );\n}\n\n%gradient-7 {\n    background: #4400eb;\n    background: -moz-linear-gradient(left, #4400eb 0%, #44e7f5 100%);\n    background: -webkit-linear-gradient(left, #4400eb 0%,#44e7f5 100%);\n    background: linear-gradient(to right, #4400eb 0%,#44e7f5 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4400eb', endColorstr='#44e7f5',GradientType=1 );\n}\n\n%gradient-8 {\n    background: #F7B00F;\n    background: -moz-linear-gradient(top, #F7B00F 0%, #F25521 100%);\n    background: -webkit-linear-gradient(top, #F7B00F 0%,#F25521 100%);\n    background: linear-gradient(to bottom, #F7B00F 0%,#F25521 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#F7B00F', endColorstr='#F25521',GradientType=1 );\n\n    // background: linear-gradient(top, #f25521 0%, #f9c70a 100%);\n}\n\n%gradient-9 {\n    background: #f31e7a !important;\n    background: -moz-linear-gradient(left, #f31e7a 0%, #fd712c 100%);\n    background: -webkit-linear-gradient(left, #f31e7a 0%,#fd712c 100%);\n    background: linear-gradient(to right, #f31e7a 0%,#fd712c 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f31e7a', endColorstr='#fd712c',GradientType=1 );\n}\n\n%gradient-10 {\n    background: #f25521 !important;\n    background: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n    background: -webkit-linear-gradient(left, #f25521 0%,#f9c70a 100%);\n    background: linear-gradient(to top, #f25521 0%,#f9c70a 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );\n}\n\n%gradient-11 {\n    background: #3398fb;\n    background: -moz-linear-gradient(left, #3398fb 0%, #8553ee 100%);\n    background: -webkit-linear-gradient(left, #3398fb 0%,#8553ee 100%);\n    background: linear-gradient(to right, #3398fb 0%,#8553ee 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3398fb', endColorstr='#8553ee',GradientType=1 );\n}\n\n%gradient-12 {\n    background: #36e1b4;\n    background: -moz-linear-gradient(left, #36e1b4 0%, #11cae7 100%);\n    background: -webkit-linear-gradient(left, #36e1b4 0%,#11cae7 100%);\n    background: linear-gradient(to right, #36e1b4 0%,#11cae7 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36e1b4', endColorstr='#11cae7',GradientType=1 );\n}\n\n%gradient-13 {\n    background: #ffbf31;\n    background: -moz-linear-gradient(left, #ffbf31 0%, #ff890e 100%);\n    background: -webkit-linear-gradient(left, #ffbf31 0%,#ff890e 100%);\n    background: linear-gradient(to right, #ffbf31 0%,#ff890e 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffbf31', endColorstr='#ff890e',GradientType=1 );\n}\n\n%gradient-14 {\n    background: #23bdb8;\n    background: -moz-linear-gradient(-45deg, #23bdb8 0%, #43e794 100%);\n    background: -webkit-linear-gradient(-45deg, #23bdb8 0%,#43e794 100%);\n    background: linear-gradient(135deg, #23bdb8 0%,#43e794 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#23bdb8', endColorstr='#43e794',GradientType=1 );\n}\n\n%gradient-15 {\n    background: #9a56ff;\n    background: -moz-linear-gradient(-45deg, #9a56ff 0%, #e36cd9 100%);\n    background: -webkit-linear-gradient(-45deg, #9a56ff 0%,#e36cd9 100%);\n    background: linear-gradient(135deg, #9a56ff 0%,#e36cd9 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9a56ff', endColorstr='#e36cd9',GradientType=1 );\n}\n\n%gradient-16 {\n    background: #f48665;\n    background: -moz-linear-gradient(-45deg, #f48665 0%, #fda23f 100%);\n    background: -webkit-linear-gradient(-45deg, #f48665 0%,#fda23f 100%);\n    background: linear-gradient(135deg, #f48665 0%,#fda23f 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f48665', endColorstr='#fda23f',GradientType=1 );\n}\n\n%gradient-17 {\n    background: #e36cd9;\n    background: -moz-linear-gradient(-45deg, #e36cd9 0%, #fe60ae 100%);\n    background: -webkit-linear-gradient(-45deg, #e36cd9 0%,#fe60ae 100%);\n    background: linear-gradient(135deg, #e36cd9 0%,#fe60ae 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e36cd9', endColorstr='#fe60ae',GradientType=1 );\n}\n\n%gradient-18 {\n    background: #a15cff;\n    background: -moz-linear-gradient(left, #a15cff 0%, #ce82fd 100%);\n    background: -webkit-linear-gradient(left, #a15cff 0%,#ce82fd 100%);\n    background: linear-gradient(to right, #a15cff 0%,#ce82fd 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a15cff', endColorstr='#ce82fd',GradientType=1 );\n}\n\n%text-gradient {\n    -webkit-background-clip: text !important;\n    -webkit-text-fill-color: transparent !important;\n}\n","//MEDIA QUERY MANAGER\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n\n@mixin respond($breakpoint) {\n\n\t@if($breakpoint == \"phone\") { \n\n\t\t@media only screen and (max-width: 575px) { @content; } \n    } \n    \n    @if($breakpoint == \"phone-land\") {\n\n        @media only screen and (max-width: 767px) { @content; }\n    }\n\n\t@if($breakpoint == \"tab-port\") {\n\n\t\t@media only screen and (max-width: 991px) { @content; } \n\t}\n\n\t@if($breakpoint == \"tab-land\") {\n\n\t\t@media only screen and (max-width: 1199px) { @content; } \n    }\n    \n\t@if ($breakpoint == \"laptop\") {\n        @media only screen and (max-width: 1400px) { @content; }\n    }\n\t\n    @if ($breakpoint == \"desktop\") {\n        \n        @media only screen and (min-width: 1200px) { @content; }\n    }\n\t@if($breakpoint == \"mid-desktop\") {\n\n\t\t@media only screen and (max-width: 1600px) { @content; } \n\t}\n\t@if($breakpoint == \"big-desktop\") {\n\n\t\t@media only screen and (min-width: 1800px) { @content; } \n\t}\n\n}\n\n\n\n//don't use it untill you need this too much\n@mixin custommq($min: null, $max: null) {\n    @if ($min != null and $max != null) {\n        @media only screen and (min-width: $min) and (max-width: $max) { @content; }\n    }\n\n    @if ($min == null and $max != null) {\n        @media only screen and (max-width: $max) { @content; }\n    }\n\n    @if ($min != null and $max == null) {\n        @media only screen and (min-width: $min) { @content; }\n    }\n}\n\n// transition\n@mixin transitionSlow{\n\t-webkit-transition: all 0.8s;\n\t-ms-transition: all 0.8s;\n\ttransition: all 0.8s;\n}\n@mixin transitionMedium{\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n@mixin transitionFast{\n\t-webkit-transition: all 0.2s;\n\t-ms-transition: all 0.2s;\n\ttransition: all 0.2s;\n}\n@mixin transformScale{\n\ttransform:scale(1);\n\t-moz-transform:scale(1);\n\t-webkit-transform:scale(1);\n\t-ms-transform:scale(1);\n\t-o-transform:scale(1);\n}\n@mixin transformScaleXS{\n\ttransform:scale(0.8);\n\t-moz-transform:scale(0.8);\n\t-webkit-transform:scale(0.8);\n\t-ms-transform:scale(0.8);\n\t-o-transform:scale(0.8);\n}\n@mixin transformScaleSM{\n\ttransform:scale(1.2);\n\t-moz-transform:scale(1.2);\n\t-webkit-transform:scale(1.2);\n\t-ms-transform:scale(1.2);\n\t-o-transform:scale(1.2);\n}\n@mixin transformScaleMD{\n\ttransform:scale(1.5);\n\t-moz-transform:scale(1.5);\n\t-webkit-transform:scale(1.5);\n\t-ms-transform:scale(1.5);\n\t-o-transform:scale(1.5);\n}\n","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","",".c-pointer {\n    cursor: pointer;\n}\n","@import \"../abstracts/maps\";\n@import \"./../vendor/animate/animate.min.css\";\n@import \"./../vendor/aos/css/aos.min.css\";\n@import \"./../vendor/perfect-scrollbar/css/perfect-scrollbar.css\";\n@import \"./../vendor/metismenu/css/metisMenu.min.css\";\n* {\n    outline: none;\n    padding: 0;\n    &::after {\n        margin: 0;\n        padding: 0;\n    }\n    &::before {\n        margin: 0;\n        padding: 0;\n    }\n}\n::selection {\n\tcolor: #fff;\n\tbackground: $primary;\n}\nbody {\n    overflow-x: hidden;\n    height: 100%;\n    position: relative;\n    max-width: 100%;\n\tfont-size:1rem;\n\t@include respond('tab-port') {\n\t\tfont-size:0.875rem;\n\t}\n}\n@include respond('laptop') {\n\th2{\n\t\tfont-size:1.5rem;\n\t}\n}\np {\n    line-height: 1.8;\n}\n\n.box-shadow-none {\n    box-shadow: none!important;\n}\n\n#main-wrapper {\n    opacity: 0;\n    transition: all 0.25s ease-in;\n    overflow: hidden;\n    position: relative;\n    // background: $body-bg;\n    &.show {\n        opacity: 1;\n    }\n}\n.rounded-lg{\n\tborder-radius:$radius;\n}\n.rounded-xl{\n\tborder-radius:12px !important;\n}\nul {\n    padding: 0;\n    margin: 0;\n}\n\nli {\n    list-style: none;\n}\n\na {\n    color: $body-color;\n    &:hover,\n    &:focus,\n    &.active {\n        text-decoration: none;\n    }\n}\n.btn-link{\n\t&:hover,\n    &:focus,\n    &.active{\n\t\ttext-decoration:none;\n\t}\n}\n.w-space-no{\n\twhite-space:nowrap;\n}\n// .content-body {\n//     .container-fluid {\n//         padding: 0 30px 0;\n//         @include media-breakpoint-down(sm) {\n//             padding: 0 1.5rem 0;\n//             padding: 0 0.9375rem 0;\n//         }\n//     }\n// }\n.content-body {\n    .container {\n        margin-top: 40px;\n    }\n    .container-fluid {\n        padding-top: 40px;\n        padding-right: 40px;\n        padding-left: 40px;\n\t\t@include custommq($max: 1600px) {\n\t\t\tpadding-top: 30px;\n\t\t\tpadding-right: 30px;\n\t\t\tpadding-left: 30px;\n\t\t}\n\t\t@include custommq($max: 767px) {\n\t\t\tpadding-top: 20px;\n\t\t\tpadding-right: 20px;\n\t\t\tpadding-left: 20px;\n\t\t}\n\t\t@include custommq($max: 575px) {\n\t\t\tpadding-top: 15px;\n\t\t\tpadding-right: 15px;\n\t\t\tpadding-left: 15px;\n\t\t}\n    }\n}\n/* sp */\n.row.sp80,\n.sp80{\n\tmargin-left:-40px;\n\tmargin-right:-40px;\n\t[class*=\"col-\"]{\n\t\tpadding-left:40px;\n\t\tpadding-right:40px;\n\t}\n}\n.row.sp60,\n.sp60{\n\tmargin-left:-30px;\n\tmargin-right:-30px;\n\t[class*=\"col-\"]{\n\t\tpadding-left:30px;\n\t\tpadding-right:30px;\n\t}\n}\n.row.sp40,\n.sp40{\n\tmargin-left:-20px;\n\tmargin-right:-20px;\n\t[class*=\"col-\"]{\n\t\tpadding-left:20px;\n\t\tpadding-right:20px;\n\t}\n}\n.row.sp20,\n.sp20{\n\tmargin-left:-10px;\n\tmargin-right:-10px;\n\t[class*=\"col-\"]{\n\t\tpadding-left:10px;\n\t\tpadding-right:10px;\n\t}\n}\n.row.sp16,\n.sp16{\n\tmargin-left:-8px;\n\tmargin-right:-8px;\n\t[class*=\"col-\"]{\n\t\tpadding-left:8px;\n\t\tpadding-right:8px;\n\t}\n}\n.row.sp10,\n.sp10{\n\tmargin-left:-5px;\n\tmargin-right:-5px;\n\t[class*=\"col-\"]{\n\t\tpadding-left:5px;\n\t\tpadding-right:5px;\n\t}\n}\n.row.sp4,\n.sp4{\n\tmargin-left:-2px;\n\tmargin-right:-2px;\n\t[class*=\"col-\"]{\n\t\tpadding-left:2px;\n\t\tpadding-right:2px;\n\t}\n}\n.row.spno,\n.spno{\n\tmargin-left:0;\n\tmargin-right:0;\n\t[class*=\"col-\"]{\n\t\tpadding-left:0;\n\t\tpadding-right:0;\n\t}\n}\n.content-heading {\n    font-size: 16px;\n    margin-bottom: 1.875rem;\n    margin-top: 3.125rem;\n    border-bottom: 1px solid $border;\n    padding-bottom: 10px;\n    @at-root [direction=\"rtl\"] #{&} {\n        text-align: right;\n    }\n}\n\n\n.text-ov {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n\n//change bootstrap default button behaviour on :focus:active 😢\n.btn {\n    &-primary {\n        &:not(:disabled):not(.disabled) {\n            &:active,\n            &.active {\n                &:focus {\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n}\n.op1{opacity:0.1;}\n.op2{opacity:0.2;}\n.op3{opacity:0.3;}\n.op4{opacity:0.4;}\n.op5{opacity:0.5;}\n.op6{opacity:0.6;}\n.op7{opacity:0.7;}\n.op8{opacity:0.8;}\n.op9{opacity:0.9;}\n.wspace-no{\n\twhite-space:nowrap;\n}\n// Support ticket btn\n.support-ticket {\n    position: fixed;\n    bottom: 30px;\n    right: 15px;\n    z-index: 999999;\n}\n\n.support-ticket-btn {\n    width: 100px;\n    background: #7CB442;\n    animation: 0.7s ease-in-out 0s infinite alternate none running crescendo;\n    border-radius: 50px;\n    color: #fff;\n    font-size: 8px;\n    font-size: 16px;\n    padding: 5px 10px 7px;\n    text-align: center;\n    display: inline-block;\n    box-shadow: rgba(124, 180, 66, 0.7) 0px 8px 35px 0px;\n    &:hover,\n    &:focus {\n        color: #fff;\n    }\n}\n.text-blue  { color:$blue  ;}\n.text-indigo{ color:$indigo;}\n.text-purple{ color:$purple;}\n.text-pink  { color:$pink  ;}\n.text-red   { color:$red   ;}\n.text-orange{ color:$orange;}\n.text-yellow{ color:$yellow;}\n.text-green { color:$green ;}\n.text-teal  { color:$teal  ;}\n.text-cyan  { color:$cyan  ;}\n\n.bg-gray-dark{\n\tbackground:$color_pallate_2 !important;\n}\n.bg-purpal{\n\tbackground:$color_pallate_4 !important;\n}\n.bg-red{\n\tbackground:$color_pallate_5 !important;\n}\n.bg-blue-dark{\n\tbackground:$color_pallate_6 !important;\n}\n.bg-blue{\n\tbackground:$color_pallate_7 !important;\n}\n.bg-blue-light{\n\tbackground:$color_pallate_8 !important;\n}\n.bg-green-light{\n\tbackground:$color_pallate_9 !important;\n}\n.bg-green{\n\tbackground:$color_pallate_10 !important;\n}\n.bg-black{\n\tbackground:$black;\n}\n.text-black{\n\tcolor:$black !important;\n}\n.dz-scroll{\n\tposition:relative;\n}\n.h-auto{\n\theight:auto !important;\n}\n.list-inline li{\n\tdisplay:inline-block;\n}\n.fs-12{font-size:12px !important; line-height:1.3; }\n.fs-13{font-size:13px !important; line-height:1.4; }\n.fs-14{font-size:14px !important; line-height:1.5; }\n.fs-15{font-size:14px !important; line-height:1.5; }\n.fs-16{font-size:16px !important; line-height:1.5; }\n.fs-18{font-size:18px !important; line-height:1.5; }\n.fs-20{font-size:20px !important; line-height:1.5; }\n.fs-22{font-size:22px !important; line-height:1.5; }\n.fs-24{font-size:24px !important; line-height:1.4; }\n.fs-26{font-size:26px !important; line-height:1.4; }\n.fs-28{font-size:28px !important; line-height:1.4; }\n.fs-30{font-size:30px !important; line-height:1.4; }\n.fs-32{font-size:32px !important; line-height:1.25; }\n.fs-34{font-size:34px !important; line-height:1.25; }\n.fs-35{font-size:35px !important; line-height:1.25; }\n.fs-36{font-size:36px !important; line-height:1.25; }\n.fs-38{font-size:38px !important; line-height:1.25; }\n.fs-46{font-size:46px !important; line-height:1.25; }\n.fs-48{font-size:48px !important; line-height:1.25; }\n.font-w100{font-weight:100;}\n.font-w200{font-weight:200;}\n.font-w300{font-weight:300;}\n.font-w400{font-weight:400;}\n.font-w500{font-weight:500;}\n.font-w600{font-weight:600;}\n.font-w700{font-weight:700;}\n.font-w800{font-weight:800;}\n.font-w900{font-weight:900;}\n.scale1{\n\ttransform:scale(1.1);\n\t-moz-transform:scale(1.1);\n\t-webkit-transform:scale(1.1);\n\t-ms-transform:scale(1.1);\n\t-o-transform:scale(1.1);\n\tdisplay:inline-block;\n}\n.scale2{\n\ttransform:scale(1.2);\n\t-moz-transform:scale(1.2);\n\t-webkit-transform:scale(1.2);\n\t-ms-transform:scale(1.2);\n\t-o-transform:scale(1.2);\n\tdisplay:inline-block;\n}\n.scale3{\n\ttransform:scale(1.3);\n\t-moz-transform:scale(1.3);\n\t-webkit-transform:scale(1.3);\n\t-ms-transform:scale(1.3);\n\t-o-transform:scale(1.3);\n\tdisplay:inline-block;\n}\n.scale4{\n\ttransform:scale(1.4);\n\t-moz-transform:scale(1.4);\n\t-webkit-transform:scale(1.4);\n\t-ms-transform:scale(1.4);\n\t-o-transform:scale(1.4);\n\tdisplay:inline-block;\n}\n.scale5{\n\ttransform:scale(1.5);\n\t-moz-transform:scale(1.5);\n\t-webkit-transform:scale(1.5);\n\t-ms-transform:scale(1.5);\n\t-o-transform:scale(1.5);\n\tdisplay:inline-block;\n}\n.scale21{\n\ttransform:scale(2);\n\t-moz-transform:scale(2);\n\t-webkit-transform:scale(2);\n\t-ms-transform:scale(2);\n\t-o-transform:scale(2);\n\tdisplay:inline-block;\n}\n//   @keyframes crescendo {\n//     0%   {transform: scale(.8);}\n//     50% {transform: scale(1);}\n//   }\n.height10 { height:10px; }\n.height20 { height:20px; }\n.height30 { height:30px; }\n.height40 { height:40px; }\n.height50 { height:50px; }\n.height60 { height:60px; }\n.height70 { height:70px; }\n.height80 { height:80px; }\n.height90 { height:90px; }\n.height100{ height:100px; }\n.height110 { height:110px; }\n.height120 { height:120px; }\n.height130 { height:130px; }\n.height140 { height:140px; }\n.height150 { height:150px; }\n.height160 { height:160px; }\n.height170 { height:170px; }\n.height180 { height:180px; }\n.height190 { height:190px; }\n.height200{ height:200px; }\n.height210 { height:210px; }\n.height220 { height:220px; }\n.height230 { height:230px; }\n.height240 { height:240px; }\n.height250 { height:250px; }\n.height260 { height:260px; }\n.height270 { height:270px; }\n.height280 { height:280px; }\n.height290 { height:290px; }\n.height300{ height:300px; }\n.height310 { height:310px; }\n.height320 { height:320px; }\n.height330 { height:330px; }\n.height340 { height:340px; }\n.height350 { height:350px; }\n.height360 { height:360px; }\n.height370 { height:370px; }\n.height380 { height:380px; }\n.height390 { height:390px; }\n.height400{ height:400px; }\n.height415{ height:415px; }\n.height720{ height:720px; }\n.height800{ height:800px; }\n.width10  { width:10px; }\n.width20  { width:20px; }\n.width30  { width:30px; }\n.width40  { width:40px; }\n.width50  { width:50px; }\n.width60  { width:60px; }\n.width70  { width:70px; }\n.width80  { width:80px; }\n.width90  { width:90px; }\n.width100 { width:100px; }\n.width110 { width:110px; }\n.width120 { width:120px; }\n.width130 { width:130px; }\n.width140 { width:140px; }\n.width150 { width:150px; }\n.width160 { width:160px; }\n.width170 { width:170px; }\n.width180 { width:180px; }\n.width190 { width:190px; }\n.width200 { width:200px; }\n.width210 { width:210px; }\n.width220 { width:220px; }\n.width230 { width:230px; }\n.width240 { width:240px; }\n.width250 { width:250px; }\n.width260 { width:260px; }\n.width270 { width:270px; }\n.width280 { width:280px; }\n.width290 { width:290px; }\n.width300 { width:300px; }\n.width310 { width:310px; }\n.width320 { width:320px; }\n.width330 { width:330px; }\n.width340 { width:340px; }\n.width350 { width:350px; }\n.width360 { width:360px; }\n.width370 { width:370px; }\n.width380 { width:380px; }\n.width390 { width:390px; }\n.width400 { width:400px; }\n@-webkit-keyframes crescendo {\n    from {\n        -webkit-transform: translateY(5px) scale(.8);\n        -ms-transform: translateY(5px) scale(.8);\n        transform: translateY(5px) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0px) scale(1);\n        -ms-transform: translateY(0px) scale(1);\n        transform: translateY(0px) scale(1);\n    }\n}\n\n@keyframes gXGDoR {\n    from {\n        -webkit-transform: translateY(5px) scale(.8);\n        -ms-transform: translateY(5px) scale(.8);\n        transform: translateY(5px) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0px) scale(1);\n        -ms-transform: translateY(0px) scale(1);\n        transform: translateY(0px) scale(1);\n    }\n}\n\n@keyframes crescendo {\n    from {\n        -webkit-transform: translateY(5px) scale(.8);\n        -ms-transform: translateY(5px) scale(.8);\n        transform: translateY(5px) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0px) scale(1);\n        -ms-transform: translateY(0px) scale(1);\n        transform: translateY(0px) scale(1);\n    }\n}\n\n@keyframes gXGDoR {\n    from {\n        -webkit-transform: translateY(5px) scale(.8);\n        -ms-transform: translateY(5px) scale(.8);\n        transform: translateY(5px) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0px) scale(1);\n        -ms-transform: translateY(0px) scale(1);\n        transform: translateY(0px) scale(1);\n    }\n}\n\n\n\n\n\n\n\n.border-2{\n\tborder-width:2px!important;\n} ","$grid-columns: 12;\n\n\n@mixin make-col($size, $columns: $grid-columns) {\n    flex: 0 0 percentage($size / $columns);\n    // Add a `max-width` to ensure content within each column does not blow out\n    // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n    // do not appear to require this.\n    max-width: percentage($size / $columns);\n}\n\n\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n    @for $i from 1 through $grid-columns {\n        .col-xxl-#{$i} {\n            flex: 0 0 percentage($i / $grid-columns);\n            max-width: percentage($i / $grid-columns);\n        }\n    }\n\t.mb-xxl-4{\n\t\tmargin-bottom: 1.5rem !important;\n\t}\n    \n}\n\n\n\n","/* Editable */\n\n#preloader {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background-color: $white;\n}\n\n.sk-three-bounce {\n    margin: 0;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    background-color: white;\n}\n\n.sk-three-bounce .sk-child {\n    position: relative;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n    background-color: $primary;\n    border-radius: 100%;\n    display: inline-block;\n    -webkit-animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;\n    animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;\n}\n\n.sk-three-bounce .sk-bounce1 {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n}\n\n.sk-three-bounce .sk-bounce2 {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-three-bounce {\n    0%,\n    80%,\n    100% {\n        -webkit-transform: scale(0);\n        transform: scale(0);\n    }\n    40% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n}\n\n@keyframes sk-three-bounce {\n    0%,\n    80%,\n    100% {\n        -webkit-transform: scale(0);\n        transform: scale(0);\n    }\n    40% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n}","\n\n\n.footer {\n    padding-left: 21.563rem;\n    background-color: $body-bg;\n    @include respond('laptop'){\n\t\tpadding-left: 17rem;\n\t}\n    .copyright {\n        padding: 0.9375rem;\n\t\t\n        p {\n            text-align: center;\n            margin: 0;\n        }\n\n        a{\n            color: $primary;\n        }\n\t\t@include custommq($min: 991px) {\n\t\t\tborder-radius:0 0 0 50px;\n\t\t}\n    }\n}\n\n\n","[data-sidebar-style=\"mini\"],\n[data-layout=\"horizontal\"] {\n    .nav-control {\n        display: none;\n    }\n}\n\n[data-sidebar-style=\"overlay\"] {\n    @include respond('phone-land') {\n        .nav-header .logo-abbr {\n            display: block;\n        }\n    }\n}\n\n[data-header-position=\"fixed\"] {\n    .nav-header {\n        position: fixed;\n        left: auto;\n        // @include respond('big-desktop') {\n        //     left: 6rem;\n        // }\n    }\n}\n\n.nav-header {\n    height: 7.5rem;\n    width: 21.563rem;\n    display: inline-block;\n    text-align: left;\n    position: absolute;\n    left: 0;\n    top: 0;\n    background-color: $white;\n    transition: all .2s ease;\n    z-index: 5;\n    // border-bottom: 1px solid $border;\n\n    .logo-abbr {\n        max-width: 52px;\n\t\t@include respond('phone') {\n\t\t\tmax-width: 40px;\n\t\t}\n\t\t\n    }\n    .logo-compact {\n        display: none;\n    }\n    // @include respond('big-desktop') {\n    //     left: 3.125rem;\n    // }\n    @include custommq($min: 1200px, $max: 1400px) {\n        width: 17rem;\n    }\n    .brand-logo {\n        display: flex;\n        height: 100%;\n        width: 100%;\n        justify-content: flex-start;\n        align-items: center;\n        font-size: 1.125rem;\n        color: $white;\n        text-decoration: none;\n        padding-left: 50px;\n        padding-right: 50px;\n        font-weight: 700;\n\t\t@include respond('laptop') {\n\t\t\tpadding-left: 25px;\n\t\t\tpadding-right: 25px;\n\t\t}\n\t\t\n        // &:hover {\n        //     color: $primary;\n        // }\n\t\t\n\t\t\n        [data-sidebar-style=\"compact\"] &,\n        [data-sidebar-style=\"mini\"] & {\n            padding-left: 0;\n            padding-right: 0;\n            justify-content: center;\n        }\n        @include respond('phone-land') {\n            padding-left: 0;\n            padding-right: 0;\n            justify-content: center;\n        }\n    }\n    .brand-title {\n\t\tmargin-left: 10px;\n\t\tmax-width: 120px;\n\t\tmargin-top: 0px;\n        // &::first-letter{\n        //     background: $white;\n        //     color: $primary;\n        //     padding: 1px 10px;\n        //     margin-right: 5px;\n        //     border-radius: 3px;\n        // }\n        @at-root [data-theme-version=\"dark\"] & {\n            background-position: 0 120%;\n        }\n    }\n}\n\n@include respond('tab-land') {\n    .nav-header {\n        width: 5rem;\n\t\theight:5rem;\n        .brand-title {\n            display: none;\n        }\n    }\n}\n\n.nav-control {\n    cursor: pointer;\n    position: absolute;\n    right: -4.0625rem;\n    text-align: center;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 9999;\n    // color: $primary;\n    font-size: 1.4rem;\n    // line-height: 2rem;\n    padding: 2px 0.5rem 0;\n    // margin-top: 5px;\n    border-radius: 2px;\n    @include respond('phone-land') {\n        right: -2.75rem;\n    }\n\t@include respond('phone') {\n        right: -2.75rem;\n    }\n    // @include respond('desktop') {\n    //     right: -3.125rem;\n    // }\n    @include custommq($min: 1200px, $max: 1500px) {\n        // right: 0;\n    }\n}\n\n////////////////////\n// Humbuger Icon\n////////////////////\n.hamburger {\n    // background-color: $white;\n    display: inline-block;\n    left: 0px;\n    position: relative;\n    top: 3px;\n    -webkit-transition: all 0.3s ease-in-out 0s;\n    transition: all 0.3s ease-in-out 0s;\n    width: 26px;\n    z-index: 999;\n}\n\n.hamburger .line {\n    background: $primary;\n    display: block;\n    height: 3px;\n    border-radius: 3px;;\n    margin-top: 6px;\n    margin-bottom: 6px;\n    margin-left: auto;\n    // width: 22px;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n\n.hamburger .line:nth-child(1) {\n    width: 20px;\n}\n\n.hamburger .line:nth-child(2) {\n    width: 26px;\n}\n\n.hamburger .line:nth-child(3) {\n    width: 22px;\n}\n\n.hamburger:hover {\n    cursor: pointer;\n}\n\n.hamburger:hover .line {\n    width: 26px;\n}\n\n\n/*\n    .hamburger.is-active {\n      left: 60px;\n    }\n    */\n\n.hamburger.is-active .line:nth-child(1),\n.hamburger.is-active .line:nth-child(3) {\n    width: 10px;\n    height: 2px;\n}\n\n.hamburger.is-active .line:nth-child(2) {\n    -webkit-transform: translateX(-0px);\n    transform: translateX(-0px);\n    width: 22px;\n    height: 2px;\n}\n\n.hamburger.is-active .line:nth-child(1) {\n    -webkit-transform: translateY(4px) rotate(45deg);\n    transform: translateY(4px) rotate(45deg);\n}\n\n.hamburger.is-active .line:nth-child(3) {\n    -webkit-transform: translateY(-4px) rotate(-45deg);\n    transform: translateY(-4px) rotate(-45deg);\n}\n\n@media (min-width:767px) {\n\t\n    [data-sidebar-style=\"compact\"] {\n        .nav-control {\n            display: none;\n        }\n        .nav-header {\n            width: 15rem;\n        }\n    }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] {\n    .menu-toggle {\n        .brand-title {\n            display: none;\n        }\n        .nav-header {\n            .logo-abbr {\n                display: block;\n            }\n        }\n    }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"horizontal\"] {\n    .logo-compact {\n        display: none;\n    }\n}\n\n[data-sidebar-style=\"mini\"] {\n    .nav-header {\n        .logo-abbr {\n            display: block;\n        }\n    }\n}\n\n[data-sidebar-style=\"compact\"][data-layout=\"vertical\"] {\n    .nav-header {\n        .brand-title {\n            /* display: none; */\n        }\n        .logo-compact {\n            max-width: 75px;\n        }\n    }\n}\n[data-sidebar-style=\"compact\"][data-layout=\"horizontal\"] {\n    .nav-header .brand-logo {\n        padding-left: 30px;\n\t\tpadding-right: 30px;\n\t\tjustify-content: start;\n    }\n}\n[data-sidebar-style=\"modern\"][data-layout=\"vertical\"] {\n    .nav-header {\n        width: 9.375rem;\n        .brand-title {\n            display: none;\n        }\n        .logo-compact {\n            display: none;\n        }\n    }\n}","/////////////////\n// Header\n/////////////////\n.header {\n    // width: 100%;\n    height: 7.5rem;\n    z-index: 1;\n    position: relative;\n    padding: 0rem;\n    background-color: $white;\n    z-index: 4;\n    // box-shadow: 0 0 1rem $l-border;\n    padding-left: 21.563rem;\n    transition: all .2s ease;\n\t@include respond('laptop'){\n\t\tpadding-left: 17rem;\n\t}\n    // &::before {\n    //     content: \"\";\n    //     height: 168px;\n    //     top: 0;\n    //     left: 0;\n    //     width: 100%;\n    //     position: absolute;\n    //     z-index: 997;\n    //     background: rgba(116, 104, 240,0.85)\n    // }\n    .header-content {\n        height: 100%;\n        padding-left: 5.3125rem;\n        padding-right: 2.4rem;\n        align-items: center;\n        display: flex;\n\t\t\n        // box-shadow: $shadow;\n        // @include respond('desktop') {\n        //     padding-left: 15px;\n        //     padding-right:15px;\n        //     max-width: 1140px;\n        //     margin: 0 auto;\n        // }\n        // @include respond('tab-land') {\n        //     padding-left: 15px;\n        //     padding-right:15px;\n        //     max-width: 960px;\n        //     margin: 0 auto;\n        // }\n        // @include respond('tab-port') {\n        //     padding-left: 15px;\n        //     padding-right:15px;\n        //     max-width: 720px;\n        //     margin: 0 auto;\n        // }\n        // @include respond('phone-land') {\n        //     padding-left: 60px;\n        //     padding-right:15px;\n        // }\n        @include custommq($max: 767px) {\n            padding-left: 3.75rem;\n\t\t\tpadding-right: 0.938rem;\n\t\t\tborder-radius: 0;\n        }\n\t\t\n    }\n    .navbar {\n        padding: 0;\n        height: 100%;\n        width: 100%;\n        .navbar-collapse {\n            height: 100%;\n            width: 100%;\n        }\n    }\n\t@include respond('tab-land'){\n\t\theight:5rem;\n\t}\n}\n\n////////////////////////\n// CSS Pulse Effect\n////////////////////////\n@mixin circle($circleSize) {\n    width: $circleSize;\n    height: $circleSize;\n    border-radius: $circleSize/2;\n}\n\n\n/* pulse in SVG */\n\nsvg.pulse-svg {\n    overflow: visible;\n    .first-circle {\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        -webkit-transform-origin: center center;\n        transform-origin: center center;\n        -webkit-animation: pulse-me 3s linear infinite;\n        animation: pulse-me 3s linear infinite;\n        fill: $primary;\n    }\n    .second-circle {\n        @extend .first-circle;\n        -webkit-animation-delay: 1s;\n        animation-delay: 1s;\n    }\n    .third-circle {\n        @extend .first-circle;\n        -webkit-animation-delay: 2s;\n        animation-delay: 2s;\n    }\n}\n\n\n/* pulse in CSS */\n\n.pulse-css {\n    @include circle(1rem);\n    border-radius: 3.5rem;\n    height: 1rem;\n    position: absolute;\n    background: #FF507A;\n    right: 5px;\n    top: 5px;\n    width: 1rem;\n    &:after,\n    &:before {\n        content: '';\n        @include circle(1rem);\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: -.2rem;\n        background-color: #FF507A;\n        margin: auto;\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        -webkit-transform-origin: center center;\n        transform-origin: center center;\n        -webkit-animation: pulse-me 3s linear infinite;\n        animation: pulse-me 3s linear infinite;\n        @at-root [direction=\"rtl\"] & {\n            left: auto;\n            right: -.2rem;\n        }\n    }\n\t@include respond ('laptop'){\n\t\theight:0.5rem;\n\t\twidth:0.5rem;\n\t}\n\t\n}\n\n@-webkit-keyframes pulse-me {\n    0% {\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        opacity: 0;\n    }\n    50% {\n        opacity: 0.1;\n    }\n    70% {\n        opacity: 0.09;\n    }\n    100% {\n        -webkit-transform: scale(3);\n        transform: scale(3);\n        opacity: 0;\n    }\n}\n\n@keyframes pulse-me {\n    0% {\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        opacity: 0;\n    }\n    50% {\n        opacity: 0.1;\n    }\n    70% {\n        opacity: 0.09;\n    }\n    100% {\n        -webkit-transform: scale(3);\n        transform: scale(3);\n        opacity: 0;\n    }\n}\n\n[data-sidebar-style=\"full\"],\n[data-sidebar-style=\"overlay\"] {\n    .header {\n        width: 100%;\n        @include custommq($min: 1200px, $max: 1350px) {\n            width: 100%;\n            padding-left: 17rem;\n        }\n        @include respond('tab-land') {\n            width: 100%;\n            padding-left: 5rem;\n        }\n    }\n}\n\n[data-sidebar-style=\"mini\"] {\n    .header {\n        width: 100%;\n        padding-left: 5rem;\n    }\n}\n\n[data-sidebar-style=\"compact\"] {\n    .header {\n        width: 100%;\n        padding-left: 15rem;\n\t\t.header-content{\n\t\t\tpadding-left: 2.4rem;\n\t\t}\n    }\n}\n\n[data-header-position=\"fixed\"] {\n    .header {\n        position: fixed;\n        top: 0;\n        width: 100%;\n    }\n    .content-body {\n        padding-top: 7.5rem;\n\t\t@include respond('tab-land'){\n\t\t\tpadding-top: 5rem;\n\t\t}\n    }\n    .deznav {\n        margin-top: 0;\n    }\n}\n[data-sidebar-style=\"compact\"][data-header-position=\"fixed\"][data-container=\"boxed\"][data-layout=\"vertical\"] {\n    .header {\n        width: 1199px;\n    }\n}\n[data-sidebar-style=\"modern\"] {\n    .header {\n\t\twidth: 100%;\n\t\tpadding-left: 9.375rem;\n    \n\n    }\n\t&[data-layout=\"horizontal\"] {\n\t\t.nav-header .brand-logo{\n\t\t    justify-content: start;\n\t\t}\n\t\t.header .header-content{\n            padding-left: 30px;\n\t\t\t\n        }\n\t}\n}",".header-left {\n    height: 100%;\n    display: flex;\n    align-items: center;\n\t\n\t.dashboard_bar {\n\t\tfont-size: 28px;\n\t\tfont-weight: 600;\n\t\tcolor:$black;\n\t\t@include respond('laptop') {\n\t\t\tfont-size: 24px;\n\t\t}\n\t\t@include respond('phone-land') {\n\t\t\tdisplay:none;\n\t\t}\n\t}\n\t\n    input {\n        background: $body-bg !important;\n        min-width: 170px;\n        min-height: 40px;\n        color: $dark!important;\n        border-top-left-radius: $radius;\n        border-bottom-left-radius: $radius;\n\t\tborder-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        box-shadow: none;\n\t\tpadding: 10px 20px;\n\t\tfont-size: 16px;\n\t\tborder-right-width:0!important;\n\t\tborder: 1px solid #ebebeb;\n\t\tborder-width: 1px;\n\t\tfont-weight: 300;\n\t\t\t\n        @include respond('desktop') {\n            // margin-top: 3px;\n        }\n        @at-root [direction=\"rtl\"] & {\n            border-top-right-radius: $radius;\n            border-bottom-right-radius: $radius;\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n        &:focus,\n        &:active,\n        &.active {\n            border-color: #ebebeb;\n            box-shadow: none;\n        }\n        &::-webkit-input-placeholder {\n            /* Edge */\n            color: $dark;\n        }\n        &:-ms-input-placeholder {\n            /* Internet Explorer */\n            color: $dark;\n        }\n        &::placeholder {\n            color: $dark;\n        }\n    }\n    // .btn {\n    //     border-top-left-radius: 0;\n    //     border-bottom-left-radius: 0;\n    //     height: 45px;\n    //     @at-root [direction=\"rtl\"] & {\n    //         border-top-right-radius: 0;\n    //         border-bottom-right-radius: 0; \n    //         border-top-left-radius: .25rem;\n    //         border-bottom-left-radius: .25rem;\n    //     }\n    // }\n    .search_bar {\n        display: flex;\n        align-items: center;\n        height: 100%;\n\t\t@include respond('phone-land') {\n\t\t\tdisplay:none;\n\t\t}\n        .dropdown-menu {\n            box-shadow: none;\n           \n\t\t\t\n        }\n        .search_icon {\n            background: $body-bg !important;\n            height: 56px;\n\t\t\tline-height:22px;\n            padding: 15px 20px 15px 0 !important;\n            border-top-right-radius: $radius;\n            border-bottom-right-radius: $radius;\n\t\t\tborder: 1px solid #ebebeb;\n\t\t\tborder-width: 1px;\n\t\t\tborder-left-width:0;\n\t\t\t\n            i {\n                font-size: 24px;\n                color: $dark;\n\t\t\t\tline-height: 1;\n            }\n\t\t\t@include respond('laptop') {\n\t\t\t\theight: 41px;\n\t\t\t\tpadding: 8px 15px 8px 0 !important;\n\t\t\t\tsvg{\n\t\t\t\t\twidth:18px;\n\t\t\t\t\theight:18px;\n\t\t\t\t}\n\t\t\t}\n        }\n        @include custommq($max: 767px) {\n            position: static;\n            .dropdown-menu {\n                width: 300px;\n\t\t\t\tleft: -15vw;\n\t\t\t\tbox-shadow: 0px 5px 10px 0 rgba(0,0,0,0.1);\n\t\t\t\tborder-radius: 4px !important;\n\t\t\t\t@include respond('phone') {\n\t\t\t\t\twidth: 250px;\n\t\t\t\t\tleft: -25vw;\n\t\t\t\t}\t\n\t\t\t\t.form-control{\n\t\t\t\t\tborder-radius: 4px !important;\n\t\t\t\t\twidth:100%;\n\t\t\t\t}\n                @at-root [direction=\"rtl\"] & {\n                    right: -98px;\n                }\n            }\n        }\n\t\t\n        // .form-inline {\n        //     flex-flow: row nowrap;\n        // }\n        .dropdown-menu,\n        .dropdown-menu.show {\n            // box-shadow: 0px 0px 10px rgba(120, 130, 140, 0.13);\n            border: 0px;\n            background-color: transparent;\n            border-top-right-radius: 5rem;\n            border-bottom-right-radius: 5rem;\n            @include custommq($min: 768px) {\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 0;\n\t\t\t\ttransform: none;\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: unset;\n            }\n        }\n    }\n}\n\n[data-sidebar-style=\"compact\"] {\n    .header-left {\n        margin-left: 0;\n    }\n}",".header-right {\n    height: 100%;\n\t\n\t\n\t\n    .nav-item {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        .nav-link {\n            color: $l-ctd;\n            font-size: 18px;\n        }\n    }\n\t.right-sidebar{\n\t\tmargin-right:-30px;\n\t\ta{\n\t\t\theight: 80px;\n\t\t\twidth: 80px;\n\t\t\ttext-align: center;\n\t\t\tjustify-content: center;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tborder-left: 1px solid $light;\n\t\t}\n\t}\n    &>li {\n        &:not(:first-child) {\n            padding-left:2rem;\n\t\t\t@include respond('laptop') {\n\t\t\t\tpadding-left:1rem;\n\t\t\t}\n\t\t\t@include respond('phone') {\n\t\t\t\tpadding-left:0.5rem;\n\t\t\t}\n        }\n    }\n    .notification_dropdown {\n        @include respond('phone-land') {\n            position: static;\n        }\n        .nav-link {\n            position: relative;\n            color: $primary;\n\t\t\tbackground: transparent;\n\t\t\tborder-radius: 0;\n\t\t\tpadding: 12px;\n\t\t\t//border:1px solid $primary;\n\t\t\tline-height: 1;\n\t\t\t@include respond('laptop') {\n\t\t\t\tpadding: 10px;\n\t\t\t}\n\t\t\t\n\t\t\t&.secondary{\n\t\t\t\tbackground:$secondary-light;\n\t\t\t\tcolor: $secondary;\n\t\t\t\t[fill] {\n\t\t\t\t\tfill: $secondary;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\t&.primary{\n\t\t\t\tbackground:$primary-light;\n\t\t\t\tcolor: $primary;\n\t\t\t\t[fill] {\n\t\t\t\t\tfill: $primary;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.warning{\n\t\t\t\tbackground:$warning-light;\n\t\t\t\tcolor: $warning;\n\t\t\t\t[fill] {\n\t\t\t\t\tfill: $warning;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.success{\n\t\t\t\tbackground:$success-light;\n\t\t\t\tcolor: $success;\n\t\t\t\t[fill] {\n\t\t\t\t\tfill: $success;\n\t\t\t\t}\n\t\t\t}\n            i {\n                font-size: 24px;\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t}\n\t\t\t\t\n            }\n\t\t\tsvg{\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\twidth:24px;\n\t\t\t\t\theight:24px;\n\t\t\t\t}\n\t\t\t}\n            .badge {\n                position: absolute;\n                font-size: 14px;\n                border-radius: 40px;\n                right: -1px;\n\t\t\t\ttop: 3px;\n\t\t\t\tbox-shadow:0px 0px 10px 3px rgba($primary,0.2);\n                font-weight: normal;\n                height: 26px;\n                width: 26px;\n                line-height: 26px;\n                text-align: center;\n                padding: 0px;\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\tright: 3px;\n\t\t\t\t\ttop: 3px;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\theight: 18px;\n\t\t\t\t\twidth: 18px;\n\t\t\t\t\tline-height: 18px;\n\t\t\t\t}\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\tright:-1px;\n\t\t\t\t\theight:15px;\n\t\t\t\t\twidth:15px;\n\t\t\t\t\tfont-size:10px;\n\t\t\t\t\tline-height:15px;\n\t\t\t\t}\n            }\n        }\n        .dropdown-item {\n            &:focus,\n            &:active {\n                a {\n                    color: $white;\n                }\n            }\n            a {\n                color: $dark;\n                &:hover {\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n    .dropdown-menu {\n        border-width:0;\n        box-shadow: 0 0 37px rgba(8,21,66,0.05);\n        @at-root [data-theme-version=\"dark\"] & {\n            box-shadow: none;\n        }\n    }\n    .header-profile {\n        &>a.nav-link {\n\t\t\tpadding: 0 0 0 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tborder-radius: $radius 28px 28px $radius;\n\t\t\t@include respond('phone') {\n\t\t\t\tbackground: transparent;\n\t\t\t\tpadding: 0 ;\n\t\t\t}\t\n            i {\n                font-weight: 700;\n            }\n\t\t\t.header-info{\n\t\t\t\ttext-align: right;\n\t\t\t\tpadding-right:30px;\n\t\t\t\t@include respond('tab-land') {\n\t\t\t\t\tpadding-left:15px;\n\t\t\t\t}\n\t\t\t\t@include respond('phone') {\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t\tspan{\n\t\t\t\t\tfont-size:16px;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t}\n\t\t\t\tstrong{\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\t\t\t\tsmall{\n\t\t\t\t\tdisplay:block;\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tcolor:$muted;\n\t\t\t\t\tfont-weight:400;\n\t\t\t\t\tline-height: 1.2;\n\t\t\t\t}\n\t\t\t}\n        }\n        .dropdown-menu {\n            padding: 15px 0;\n            min-width: 12.5rem;\n            a {\n                &:hover,\n                &:focus,\n                &.active {\n                    color: $primary;\n                }\n            }\n        }\n        img {\n            width: 57px;\n            height: 57px;\n            border-radius: 60px;\n\t\t\t\t\n\t\t\t@include respond('laptop') {\n\t\t\t\t width: 39px;\n\t\t\t\theight: 39px;\n\t\t\t}\n        }\n        .dropdown-toggle {\n            i {\n                font-size: 1.25rem;\n            }\n            span {\n                @include respond('phone') {\n                    display: none;\n                }\n            }\n        }\n        .profile_title {\n            background: $primary;\n            color: $white;\n            padding: 10px 20px;\n            h5 {\n                color: $white;\n                margin-bottom: 3px;\n            }\n        }\n        // .dropdown-toggle::after{\n        //     display: none;\n        // }\n        .dropdown-item {\n            padding: 8px 24px;\n        }\n    }\n\t\n}\n.dz-fullscreen{\n\t#icon-minimize{\n\t\tdisplay:none;\n\t}\n\t&.active{\n\t\t#icon-full{\n\t\t\tdisplay:none;\n\t\t}\n\t\t#icon-minimize{\n\t\t\tdisplay:inline-block;\n\t\t}\n\t}\n}\n.notification_dropdown {\n    .dropdown-menu-right {\n        min-width: 310px;\n        padding: 0rem 0 1rem;\n        top: 100%;\n\t\t\n        .notification_title {\n            background: $primary;\n            color: $white;\n            padding: 10px 20px;\n            h5 {\n                color: $white;\n                margin-bottom: 3px;\n            }\n        }\n        .media {\n\t\t\twidth: 45px !important;\n\t\t\theight: 45px !important;\n\t\t\tfont-size: 18px !important;\n\t\t\t\n            // &:last-child{\n            //     border-bottom: 0px;\n            // }\n            @at-root [data-theme-version=\"dark\"] & {\n                border-color: $d-border;\n            }\n            &>span {\n                width: 35px;\n                height: 35px;\n                border-radius: 50px;\n                display: inline-block;\n                padding: 7px 9px;\n                margin-right: 10px;\n\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t margin-right: 0;\n\t\t\t\t\t margin-left: 10px\n\t\t\t\t}\n                &.success {\n                    background: $success-light;\n                    color: $success;\n\t\t\t\t\t[fill] {\n\t\t\t\t\t\tfill: $success;\n\t\t\t\t\t}\n                }\n                &.primary {\n                    background: $primary-light;\n                    color: $primary;\n\t\t\t\t\tsvg [fill] {\n\t\t\t\t\t\tfill: $primary;\n\t\t\t\t\t}\n                }\n                &.danger {\n                    background: $danger-light;\n                    color: $danger;\n\t\t\t\t\t[fill] {\n\t\t\t\t\t\tfill: $danger;\n\t\t\t\t\t}\n                }\n\t\t\t\t[fill] {\n\t\t\t\t\tfill: $primary;\n\t\t\t\t}\n            }\n            .notify-time {\n                width: 100%!important;\n                margin-right: 0!important;\n                color: $l-ctl;\n            }\n            p {\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n                max-width: 200px;\n                margin-bottom: 0;\n                margin-top: 5px;\n\t\t\t\t@include respond('phone') {\n\t\t\t\t    max-width: 100px;\n\t\t\t\t}\n            }\n        }\n        .all-notification {\n            display: block;\n            padding: 15px 30px 0;\n            // color: $dark;\n            text-align: center;\n\t\t\tborder-top: 1px solid $light;\n\t\t\t\t\n            i {\n                margin-left: 10px;\n            }\n        }\n    }\n}","//customize bootstrap\n@import './bs-custom';\n\n$strong:#646c9a;\n$border: #f0f1f5;\n$shadow: 0px 0Epx 40px 0px rgba(82,63,105,0.1);\n$body-bg: #E5E6E7;\n\n\n///////////////\n// Solid Color\n///////////////\n$white: #fff;\n$black: #000;\n$charade: #23252F;\n\n/////////////////////////\n// Dark Version Color\n/////////////////////////\n$d-ctd: #ddd;\n$d-ctl: #828690;\n$d-border: #333a54;\n$d-bg: #181f39;\n$dark-card: #1e2746;\n$dark_bg_lighter: #1E2A4A;\n\n/////////////////////////\n// Primary Light\n/////////////////////////\n$primary-light: lighten($primary, 40%);\n$secondary-light: lighten($secondary, 36%);\n$success-light: lighten($success, 47%);\n$warning-light: lighten($warning, 30%);\n$danger-light: lighten($danger, 35%);\n$info-light: lighten($info, 35%);\n$dark-light: lighten($dark, 25%);\n\n/////////////////////////\n// Opacity \n/////////////////////////\n$primary-opacity: rgba($primary, 0.2);\n$secondary-opacity: rgba($secondary, 0.5);\n$success-opacity: rgba($success, 0.1);\n$warning-opacity: rgba($warning, 0.1);\n$danger-opacity: rgba($danger, 0.15);\n$info-opacity: rgba($info, 0.1);\n$dark-opacity: rgba($dark, 0.35);\n\n////////////////////////\n// Light Version Color\n////////////////////////\n$l-ctd: #464a53;\n$l-ctl: #828690;\n$l-border: #eaeaea;\n$l-bg: #f2f4fa;\n$heading: #333;\n\n///////////////////\n// Material Colors\n///////////////////\n$dusty-gray: #999999;\n$gallery: #EEEEEE;\n$gray: #898989;\n$input-border-color: $border;\n\n\n///////////////////\n// Social Colors\n///////////////////\n$facebook: #3b5998;\n$twitter: #1da1f2;\n$youtube: #FF0000;\n$google-plus: #db4439;\n$linkedin: #007bb6;\n$instagram: #c32aa3;\n$pinterest: #bd081c;\n$google: #4285f4;\n$snapchat: #fffc00;\n$whatsapp: #25d366;\n$tumblr: #35465d;\n$reddit: #ff4500;\n$spotify: #1ed760;\n$yahoo: #430297;\n$dribbble: #ea4c89;\n$skype: #00aff0;\n$quora: #aa2200;\n$riverBed: #4C585C;\n$vimeo: #1ab7ea;\n\n\n///////////////////\n// Misc Colors\n///////////////////\n$iron: #DDDFE1;\n$grey: #D2D6DE;\n$pale-sky: #6a707e;\n$athensGray: #F0F0F2;\n$sky: #2290FF;\n\n\n//color for coller pallate\n$color_pallate_1: $white;\n$color_pallate_2: #143b64;\n$color_pallate_3: $primary;\n$color_pallate_4: #4527a0;\n$color_pallate_5: #c62828;\n$color_pallate_6: #283593;\n$color_pallate_7: #7356f1;\n$color_pallate_8: #3695eb;\n$color_pallate_9: #00838f;\n$color_pallate_10: #ff8f16;\n$color_pallate_11: #6673fd;\n$color_pallate_12: #558b2f;\n$color_pallate_13: #2a2a2a;\n$color_pallate_14: #1367c8;\n$color_pallate_15: #ed0b4c;\n\n//utility variables\n$radius: 1.25rem; \n\n\n\n","","","\n@import \"../../../vendor/bootstrap-v4-rtl/scss/functions\";\n@import \"../../../vendor/bootstrap-v4-rtl/scss/variables\";\n@import \"../../../vendor/bootstrap-v4-rtl/scss/mixins\";\n@import \"../../../vendor/bootstrap-v4-rtl/scss/rtl\";\n\n.rtl {\n    \n\t\n  // stylelint-disable declaration-no-important\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n      $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n      @each $prop, $abbrev in (margin: m, padding: p) {\n        @each $size, $length in $spacers {\n\n        //   .#{$abbrev}r#{$infix}-#{$size} {\n        //     #{$prop}-right: 0!important;\n        //     #{$prop}-left: $length !important;\n        //   }\n\n          .#{$abbrev}x#{$infix}-#{$size} {\n            #{$prop}-right: auto;\n            #{$prop}-left: $length !important;\n          }\n\n        //   .#{$abbrev}l#{$infix}-#{$size} {\n        //     #{$prop}-left: 0!important;\n        //     #{$prop}-right: $length !important;\n        //   }\n\n          .#{$abbrev}x#{$infix}-#{$size} {\n            #{$prop}-left: auto;\n            #{$prop}-right: $length !important;\n          }\n        }\n      }\n\n      .mr#{$infix}-auto {\n        margin-right: 0!important;\n        margin-left: auto !important;\n      }\n      .mx#{$infix}-auto {\n        margin-right: auto!important;\n        margin-left: auto !important;\n      }\n      .ml#{$infix}-auto {\n        margin-right: auto !important;\n        margin-left: 0 !important;\n      }\n      .mx#{$infix}-auto {\n        margin-right: auto !important;\n        margin-left: auto!important;\n      }\n    }\n  }\n\n\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n      $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  \n      .float#{$infix}-left  { @include float-right; }\n      .float#{$infix}-right { @include float-left; }\n      .float#{$infix}-none  { @include float-none; }\n    }\n  }\n\n}\n\n\n\n\n  //global styles\n  [direction=\"rtl\"] {\n\n      &[data-theme-version=\"dark\"] {\n          .border, .border-left, .border-right {\n              border-color: $d-border !important;\n          }\n      }\n\n      .text-right {\n          text-align: left !important;\n      }\n\n      .text-left {\n          text-align: right !important;\n      }\n\n      .border-right {\n          border-left: 1px solid $border !important;\n          border-right: 0 !important;\n\n      }\n\n      .border-left {\n          border-right: 1px solid $border !important; \n          border-left: 0 !important;\n      }\n\n      .dropdown-menu {\n          left: auto;\n      }\n\n      .dropdown-menu-right {\n\t\t\tleft: 0;\n\t\t\tright: auto;\n\t\t\t@include respond('phone') {\n\t\t\t\tleft: 15px;\n\t\t\t}\n      }\n\t  .notification_dropdown .dropdown-menu-right .media > span{\n\t      margin-left: 10px;\n\t      margin-right: 0;\n\t  }\n  }\n","","\n\n//nav header styles\n[direction=\"rtl\"] {\n\n    &:not([data-container=\"boxed\"]) {\n        .nav-header {\n            left: auto;\n            right: 0;\n        }\n    }\n\n    &[data-container=\"wide-boxed\"] {\n        .nav-header {\n            left: auto;\n            right: 0;\n        }\n    }\n\t\n    .nav-header {\n        text-align: right;\n        right: auto;\n\t\t.brand-title{\n\t\t\tmargin-left: 0;\n\t\t\tmargin-right: 15px;\n\t\t}\n        .brand-logo {\n            padding-left: 0;\n            padding-right: 1.75rem;\n\t\t\t\n\t\t\t@at-root [data-sidebar-style=\"compact\"]#{&}{\n\t\t\t\t\tpadding-right: 0;\n            } \n            @at-root [data-sidebar-style=\"compact\"]#{&}[data-layout=\"horizontal\"]{\n\t\t\t\tpadding-right: 30px;\n            }\n            @at-root [data-sidebar-style=\"mini\"]#{&}{\n                padding-right: 0;\n            }\n\t\t\t@at-root [data-sidebar-style=\"modern\"]#{&}{\n                padding-right: 0;\n\t\t\t\t@at-root [data-layout=\"horizontal\"]#{&}{\n\t\t\t\t\tpadding-right: 30px;\n\t\t\t\t}\n            }\n            @include media-breakpoint-down(sm) {\n                // padding-left: 0;\n                padding-right: 0;\n                // justify-content: center;\n            }\n        }\n    }\n\t\n    .nav-control {\n        right: auto;\n        left: -4.0625rem;\n\n        @include media-breakpoint-down(sm) {\n            left: -4.0625rem;\n        }\n    \n        @include media-breakpoint-down(xs) {\n            left:-4.0625rem;\n        }\n    }\n\n    &[data-sidebar-style=\"overlay\"] {\n        .nav-header {\n            .hamburger {\n                &.is-active {\n                    right: 0;\n\n                   // .line:nth-child(1) {\n                   //     transform: translateY(0.4rem) rotate(-45deg);\n                   // }\n                   // \n                   // .line:nth-child(3) {\n                   //     transform: translateY(-0.4rem) rotate(45deg);\n                   // }\n                }\n            }\n        }\n    }\n}\n[direction=\"rtl\"][data-sidebar-style=\"compact\"][data-layout=\"horizontal\"]{\n\t.nav-header .brand-logo{\n\t\tpadding-right: 30px;\n\t}\n}\n[direction=\"rtl\"][data-sidebar-style=\"modern\"][data-layout=\"horizontal\"]{\n\t.nav-header{\n\t\twidth: 16rem;\n\t}\n}\n\n\n\n\n\n\n\n\n\n\n\n","\n\n//header styles\n[direction=\"rtl\"] {\n    .header {\n        padding: 0 0.9375rem;\n        padding-right: 17.1875rem;\n\n        @include media-breakpoint-down(sm) {\n            padding-right: 3.75rem;\n            padding-left: 0;\n        }\n\t\t\n        .header-content {\n            padding-left: 0;\n            padding-right: 5.3125rem;\n\n            @include custommq($max: 575px) {\n                padding-right: 4.5rem;\n            }\n\t\t\t@at-root [data-sidebar-style=\"compact\"]#{&}{\n\t\t\t\tpadding-right: 1.875rem;\n            } \n\t\t\t@at-root [data-sidebar-style=\"modern\"]#{&}{\n\t\t\t\tpadding-right: 5.3125rem;\n            } \n\t\t\t@at-root [data-sidebar-style=\"overlay\"]#{&}{\n\t\t\t\tpadding-right: 5.3125rem;\n            } \n        }\n\n        .nav-control {\n            right: 0.4375rem;\n            left: auto;\n        }\n    }\n\t.header-left{\n\t\n\t\t\n\t\t.search_bar{ \n\t\t\t.dropdown-menu,\n\t\t\t.dropdown-menu.show{\n\t\t\t    right: 40px !important;\n\t\t\t\t@include respond('phone') {\n\t\t\t\t\tright: -100px !important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.search_icon{\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 5rem;\n\t\t\t\tborder-bottom-right-radius: 5rem;\n\t\t\t\t@include respond('phone') {\n\t\t\t\t\tborder-radius: 5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\n\t}\n\t\n    &[data-layout=\"horizontal\"] {\n        .header {\n            padding: 0;\n            padding-right: 16rem;\n\t\t\t\n\t\t\t.header-content{\n\t\t\t\tpadding-right: 1.875rem;\n\t\t\t\tpadding-left: 1.875rem;\n\t\t\t}\n        }\n    }\n\t&[data-layout=\"horizontal\"][data-sidebar-style=\"mini\"] {\n\t\t.header {\n\t\t\t padding-right: 6rem;\n\t\t}\n\t}\n    &[data-sidebar-style=\"mini\"] {\n        .header {\n            padding: 0 0.9375rem;\n            padding-right: 3.75rem;\n        }\n    }\n\n    &[data-sidebar-style=\"compact\"] {\n        .header {\n            padding: 0 0.9375rem;\n            padding-right: 9.375rem;\n        }\n\t\t&[data-layout=\"horizontal\"]{\n\t\t\t.header{\n\t\t\t\tpadding:0;\n\t\t\t\tpadding-right: 16rem;\n\t\t\t}\n\t\t}\n    }\n\t&[data-sidebar-style=\"modern\"] {\n        .header {\n            padding: 0 0.9375rem;\n            padding-right: 9.375rem;\n        }\n\t\t&[data-layout=\"horizontal\"]{\n\t\t\t.header{\n\t\t\t\tpadding:0;\n\t\t\t\tpadding-right: 16rem;\n\t\t\t}\n\t\t}\n    }\n}\n\n","\n\n//sidebar styles\n[direction=\"rtl\"] {\n\ttext-align: right;\n\t\n    .deznav {\n        text-align: right;\n        \n        .metismenu {\n\t\t\tul{\n\t\t\t\tpadding: 0 25px 0 0;\n\t\t\t\t&:after{\n\t\t\t\t\tleft:auto;\n\t\t\t\t\tright:25px;\n\t\t\t\t}\n\t\t\t\ta:before{\n\t\t\t\t\tleft:auto;\n\t\t\t\t\tright: -5px;\n\t\t\t\t}\n\t\t\t}\n\t\t\tli{\n\t\t\t\t& > a svg{\n\t\t\t\t\tmargin-left:5px;\n\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t@at-root [data-sidebar-style=\"compact\"]#{&} {\n\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\t}\n\t\t\t\t\t@at-root [data-sidebar-style=\"icon-hover\"]#{&} {\n\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n            li.active {\n\n                &>.has-arrow {\n                    &:after {\n                        transform: rotate(45deg) translateY(-50%);\n                    }\n                }\n\n            }\n\n            .has-arrow {\n                &:after {\n                    left: 1.5625rem;\n                    right: auto;\n\t\t\t\t\t\n\t\t\t\t\t@at-root [data-layout=\"horizontal\"]#{&} {\n\t\t\t\t\t\tleft: 1.125rem;\n\t\t\t\t\t}\n\t\t\t\t\t@at-root [data-sidebar-style=\"modern\"]#{&} {\n\t\t\t\t\t\t-webkit-transform: rotate(-45deg) translateY(-50%);\n\t\t\t\t\t\ttransform: rotate(-45deg) translateY(-50%);\n\t\t\t\t\t}\n                }\n            }\n\n        }\n    }\n\n    &[data-sidebar-style=\"full\"][data-layout=\"vertical\"] {\n        .menu-toggle {\n            .deznav {\n                .metismenu {\n                    li {\n                        &>ul {\n    \n                            li:hover {\n                                ul {\n                                    right: 11.8125rem;\n                                    left: 0;\n\t\t\t\t\t\t\t\t\t\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n","// html[dir=\"rtl\"] {\n\n    //content body\n    [direction=\"rtl\"] {\n\t\t.list-group{\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t.form-check-input{\n\t\t    margin-left: -1.25rem;\n\t\t\tmargin-right: inherit;\n\t\t}\n\t\t.form-check-inline .form-check-input{\n\t\t\tmargin-right: 0;\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t.radio input, \n\t\t.radio-inline, \n\t\t.checkbox input, \n\t\t.checkbox-inline input{\n\t\t    margin-left: 0;\n\t\t\tmargin-right: 0;\n\t\t}\n        .content-body {\n            margin-right: 17.1875rem;\n            margin-left: auto;\n\t\t\t@at-root [data-sidebar-style=\"modern\"]#{&} {\n\t\t\t\tmargin-right: 9.375rem;\n\t\t\t}\n            .page-titles {\n                text-align: right;\n            }\n        }\n\n        &[data-layout=\"horizontal\"] {\n            .content-body {\n                margin-right: 0;\n            }\n\t\t\t.deznav .metismenu li li .has-arrow:after{\n\t\t\t\t-webkit-transform: rotate(-4deg) translateY(-50%);\n\t\t\t\ttransform: rotate(-45deg) translateY(-50%);\n\t\t\t}\n        }\n\n        &[data-sidebar-style=\"mini\"]:not([data-layout=\"horizontal\"]) {\n            .content-body {\n                margin-right: 3.75rem;\n            }\n        }\n\n        &[data-sidebar-style=\"compact\"]:not([data-layout=\"horizontal\"]) {\n            .content-body {\n                margin-right: 9.375rem;\n            }\n        }\n\n        &[data-sidebar-style=\"overlay\"] {\n            .content-body {\n                margin-right: 0;\n            }\n        }\n\t\t#external-events .external-event:before{\n\t\t\tmargin-right: 0;\n\t\t\tmargin-left: .9rem;\n\t\t}\n\t\t.post-input a i{\n\t\t    margin-left: 15px;\n\t\t    margin-right: 0;\n\t\t}\n    }\n\n// }\n@media only screen and (max-width: 1350px) and (min-width: 1200px){\n    [direction=\"rtl\"] {\n\t\t.content-body {\n\t\t\tmargin-right: 14.375rem;\n\t\t}\n\t}\n}","\n\n//sidebar right\n[direction=\"rtl\"] {\n    .sidebar-right {\n        left: -15.625rem;\n        right: auto;\n\t\tbox-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n\t\t\t\n        &.show {\n            left: 0;\n            right: auto;\n        }\n\n        .sidebar-right-trigger {\n            left: 100%;\n            right: auto;\n\t\t\tborder-radius: 0 5px 5px 0;\n\t\t\tbox-shadow: 5px 3px 5px 0px rgba(119, 119, 119, 0.15);\n        }\n    }\n\t.bootstrap-select .dropdown-toggle .filter-option{\n\t\ttext-align:right;\n\t}\n}\n\n","html[dir=\"rtl\"] {\n    \n    //footer\n    [direction=\"rtl\"] {\n        .footer{\n            padding-right: 17.1875rem;\n            padding-left: 0;\n\n            @include media-breakpoint-down(sm) {\n                padding-right: 0;\n            }\n        }\n\n        &[data-sidebar-style=\"overlay\"] {\n            .footer {\n                padding-right: 0;\n            }\n        }\n\n        .menu-toggle {\n            .footer {\n                padding-right: 3.75rem;\n            }\n        }\n\n        &[data-container=\"boxed\"] {\n            .footer {\n                padding-right: 0;\n            }\n        }\n\n        &[data-sidebar-style=\"mini\"]:not([data-layout=\"horizontal\"]) {\n            .footer {\n                padding-right: 3.75rem;\n            }\n        }\n\n        &[data-sidebar-style=\"compact\"]:not([data-layout=\"horizontal\"]) {\n            .footer {\n                padding-right: 9.375rem;\n            }\n        }\n    }\n}","///////////////////////////\n// Nav Profile\n///////////////////////////\n.nav-label {\n    margin: 10px 30px 0;\n    padding: 1.5625rem 0 10px;\n    text-transform: uppercase;\n    font-size: 0.75rem;\n    letter-spacing: 0.05rem;\n    border-top: 1px solid $l-border;\n\tcolor:$dusty-gray;\n\t\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n    &.first {\n        border: 0px;\n        margin-top: 0px;\n    }\n}\n\n.nav-badge {\n    position: absolute;\n    right: 2.8125rem;\n    top: 0.625rem;\n}\n\n.content-body {\n    margin-left: 21.563rem;\n    z-index: 0;\n    transition: all .2s ease;\n    @include custommq($min: 1200px, $max: 1400px) {\n        margin-left: 17rem;\n    }\n}\n// Bell //\n.bell img{\n\t-webkit-animation: ring 8s .7s ease-in-out infinite;\n\t-webkit-transform-origin: 50% 4px;\n\t-moz-animation: ring 8s .7s ease-in-out infinite;\n\t-moz-transform-origin: 50% 4px;\n\tanimation: ring 8s .7s ease-in-out infinite;\n}\n// bell //\n@-webkit-keyframes ring {\n  0% { -webkit-transform: rotateZ(0); }\n  1% { -webkit-transform: rotateZ(30deg); }\n  3% { -webkit-transform: rotateZ(-28deg); }\n  5% { -webkit-transform: rotateZ(34deg); }\n  7% { -webkit-transform: rotateZ(-32deg); }\n  9% { -webkit-transform: rotateZ(30deg); }\n  11% { -webkit-transform: rotateZ(-28deg); }\n  13% { -webkit-transform: rotateZ(26deg); }\n  15% { -webkit-transform: rotateZ(-24deg); }\n  17% { -webkit-transform: rotateZ(22deg); }\n  19% { -webkit-transform: rotateZ(-20deg); }\n  21% { -webkit-transform: rotateZ(18deg); }\n  23% { -webkit-transform: rotateZ(-16deg); }\n  25% { -webkit-transform: rotateZ(14deg); }\n  27% { -webkit-transform: rotateZ(-12deg); }\n  29% { -webkit-transform: rotateZ(10deg); }\n  31% { -webkit-transform: rotateZ(-8deg); }\n  33% { -webkit-transform: rotateZ(6deg); }\n  35% { -webkit-transform: rotateZ(-4deg); }\n  37% { -webkit-transform: rotateZ(2deg); }\n  39% { -webkit-transform: rotateZ(-1deg); }\n  41% { -webkit-transform: rotateZ(1deg); }\n  43% { -webkit-transform: rotateZ(0); }\n  100% { -webkit-transform: rotateZ(0); }\n}\n@-moz-keyframes ring {\n  0% { -moz-transform: rotate(0); }\n  1% { -moz-transform: rotate(30deg); }\n  3% { -moz-transform: rotate(-28deg); }\n  5% { -moz-transform: rotate(34deg); }\n  7% { -moz-transform: rotate(-32deg); }\n  9% { -moz-transform: rotate(30deg); }\n  11% { -moz-transform: rotate(-28deg); }\n  13% { -moz-transform: rotate(26deg); }\n  15% { -moz-transform: rotate(-24deg); }\n  17% { -moz-transform: rotate(22deg); }\n  19% { -moz-transform: rotate(-20deg); }\n  21% { -moz-transform: rotate(18deg); }\n  23% { -moz-transform: rotate(-16deg); }\n  25% { -moz-transform: rotate(14deg); }\n  27% { -moz-transform: rotate(-12deg); }\n  29% { -moz-transform: rotate(10deg); }\n  31% { -moz-transform: rotate(-8deg); }\n  33% { -moz-transform: rotate(6deg); }\n  35% { -moz-transform: rotate(-4deg); }\n  37% { -moz-transform: rotate(2deg); }\n  39% { -moz-transform: rotate(-1deg); }\n  41% { -moz-transform: rotate(1deg); }\n  43% { -moz-transform: rotate(0); }\n  100% { -moz-transform: rotate(0); }\n}\n@keyframes ring {\n  0% { transform: rotate(0); }\n  1% { transform: rotate(30deg); }\n  3% { transform: rotate(-28deg); }\n  5% { transform: rotate(34deg); }\n  7% { transform: rotate(-32deg); }\n  9% { transform: rotate(30deg); }\n  11% { transform: rotate(-28deg); }\n  13% { transform: rotate(26deg); }\n  15% { transform: rotate(-24deg); }\n  17% { transform: rotate(22deg); }\n  19% { transform: rotate(-20deg); }\n  21% { transform: rotate(18deg); }\n  23% { transform: rotate(-16deg); }\n  25% { transform: rotate(14deg); }\n  27% { transform: rotate(-12deg); }\n  29% { transform: rotate(10deg); }\n  31% { transform: rotate(-8deg); }\n  33% { transform: rotate(6deg); }\n  35% { transform: rotate(-4deg); }\n  37% { transform: rotate(2deg); }\n  39% { transform: rotate(-1deg); }\n  41% { transform: rotate(1deg); }\n  43% { transform: rotate(0); }\n  100% { transform: rotate(0); }\n}\n\n// 38px + 60px\n///////////////\n// Sidebar\n//////////////\n.deznav {\n    width: 21.563rem;\n    padding-bottom: 0;\n    height:100%;\n    position: absolute;\n    top: 0;\n    padding-top: 120px;\n    z-index: 3;\n    background-color: $white;\n    // box-shadow: 0px 0px 10px rgba(120, 130, 140, 0.13);\n    transition: all .2s ease;\n    // border-top-left-radius: 5px;\n    // border-top-right-radius: 5px;\n\t//box-shadow: 18px 0px 35px 0px rgba(0, 0, 0, 0.02);\n\t\n    @include respond('tab-land') {\n\t\tpadding-top:80px;\n    }\n\t@include respond('phone-land') {\n         width: 18rem;\n    }\n    // @include respond('big-desktop') {\n    //     left: 6rem;\n    // }\n    .deznav-scroll {\n        position: relative;\n        height: 100%;\n\t\t\n        // overflow: visible!important;\n        // border-top-left-radius: 5px;\n        // border-top-right-radius: 5px;\n    }\n    @include custommq($min: 1200px, $max: 1400px) {\n        width: 17rem;\n    }\n    ul {\n        padding: 0;\n        margin: 0;\n        list-style: none;\n    }\n    .metismenu {\n        display: flex;\n        flex-direction: column;\n\t\tpadding-top: 15px;\n\t\t\t\n\t\t@include respond('phone-land') {\n\t\t\tpadding-top: 0;\n\t\t}\t\n        &.fixed {\n            position: fixed;\n            top: 0;\n            width: 100%;\n            left: 0;\n        }\n        &>li {\n            display: flex;\n            flex-direction: column;\n            a {\n                &>i {\n                    //icon will get color from parent \"a\"\n                    font-size: 1.4rem;\n                    display: inline-block;\n                    vertical-align: middle;\n                    //padding: 0 1.5rem 0 0;\n                    position: relative;\n                    top: 0;\n\t\t\t\t\theight:60px;\n\t\t\t\t\twidth:60px;\n\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\tline-height: 60px;\n\t\t\t\t\ttext-align:center;\n\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\tmargin-right: 15px;\n\t\t\t\t\t\n\t\t\t\t\t@at-root [data-sidebar-style=\"compact\"] & {\n\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t}\n\t\t\t\t\t@include custommq($max:1300px){\n\t\t\t\t\t\theight:auto;\n\t\t\t\t\t\twidth:auto;\n\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\tline-height:1;\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t}\n\t\t\t\t\t@include respond('phone-land') {\n\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\tpadding: 0 .75rem 0 0;\n\t\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t\t}\n                }\n            }\n            &>a {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tfont-size: 15px;\n\t\t\t\t\t\n\t\t\t\tsvg {\n\t\t\t\t\tmax-width: 24px;\n\t\t\t\t\tmax-height: 24px;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tmargin-right:5px;\n\t\t\t\t\tmargin-top: -3px;\n\t\t\t\t\tcolor: $primary;\n\t\t\t\t}\n\t\t\t\tg [fill] {\n\t\t\t\t\tfill: $primary;\n\t\t\t\t}\n            }\n            &:hover,\n\t\t\t&:focus {\n\t\t\t\t\n                &>a {\n                  //  background-color: lighten($color: $primary, $amount: 40%);\n                    color: $primary;\n\t\t\t\t\tg [fill] {\n\t\t\t\t\t\tfill: $primary;\n\t\t\t\t\t}\n                    // &::after {\n                    //     border-color: blue;\n                    // }\n                }\n            }\n            &.mm-active {\n\t\t\t\t&>a {\n                    color: $primary;\n\t\t\t\t\tg [fill] {\n\t\t\t\t\t\tfill: $primary;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n            }\n\t\t\t\n        }\n        li {\n            position: relative;\n        }\n\t\t\n        //one step dropdown\n        ul {\n            //background-color: darken($color: $white, $amount: 2%);\n            transition: all .2s ease-in-out;\n\t\t\tposition:relative;\n\t\t\tz-index: 1;\n\t\t\tpadding: 0 0;\n\t\t\t\t\n            a {\n\t\t\t\tpadding-top: .5rem;\n\t\t\t\tpadding-bottom: .5rem;\n\t\t\t\tposition: relative;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tpadding-left: 6rem;\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\tpadding-left: 6rem;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n\t\t\t\t@include respond('phone-land') {\n\t\t\t\t\tpadding-left: 3.5rem;\n\t\t\t\t}\n                &:hover,\n                &:focus,\n                &.mm-active {\n                    text-decoration: none;\n                    color: $primary;\n                }\n            }\n            \n        }\n        a {\n            position: relative;\n            display: block;\n            padding: 0.625rem 1.875rem;\n            outline-width: 0;\n            color: rgba($color: $body-color, $alpha: 1);\n            text-decoration: none;\n\t\t\t@include respond('phone-land') {\n\t\t\t\tpadding: 0.625rem 1.25rem;\n\t\t\t}\n        }\n        .has-arrow {\n            &:after {\n                width:  .5rem;\n                height: .5rem;\n                right: 1.875rem;\n                top: 48%;\n                border-color: inherit;\n                -webkit-transform: rotate(-225deg) translateY(-50%);\n                transform: rotate(-225deg) translateY(-50%);\n\t\t\t\t\n            }\n        }\n        .has-arrow[aria-expanded=true]:after,\n        .mm-active>.has-arrow:after {\n            -webkit-transform: rotate(-135deg) translateY(-50%);\n            transform: rotate(-135deg) translateY(-50%);\n        }\n    }\n}\n\n// .metismenu .mm-active>.has-arrow:after, .metismenu .has-arrow[aria-expanded=true]:after {\n//     transform: rotate(45deg) translateY(-50%);\n// }\n\n.nav-header {\n\t@include respond('tab-land'){\n\t\twidth: 5rem;\n\t}\n}\n@media (max-width:767px) {\n\n\t.brand-title {\n\t\tdisplay: none;\n\t}\n    .footer {\n        padding-left: 0;\n    }\n    .deznav {\n        left: 0;\n\t\ttop: 5rem;\n\t\tpadding-top: 1rem;\n    }\n}","//common mega-menu styles\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle, \n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] {\n\n    .deznav {\n        .metismenu {\n            &>li {\n                &.mega-menu {\n\n                    &> ul.collapse:not(.in) {\n                        height: 252px !important;\n                    }\n\n                    &:hover {\n                        &>a {\n                            width: calc(70vw + 3.75rem);\n                        }\n\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                            max-height: 13.75rem;\n                            width: 70vw;\n\n                            ul a {\n                                width: 101%;\n                            }\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>a {\n                                width: calc(70vw + 3rem);\n                            }\n\n                            &>ul {\n                                max-height: 200px;\n                                width: 70vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n                            &>a {\n                                width: calc(55vw + 3rem);\n                            }\n\n                            &>ul {\n                                max-height:200px;\n                                width: 55vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>a {\n                                width: calc(45vw + 3);\n                            }\n                            &>ul {\n                                max-height: 18.75rem;\n                                width: 45vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>a {\n                                width: calc(30vw + 3);\n                            }\n                            &>ul {\n                                max-height: 18.125rem;\n                                width: 30vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] {\n    .deznav {\n        .metismenu {\n\n            &>li {\n                &.mega-menu {\n\n                    &:hover {\n                        &>a {\n                            width: calc(60vw + 3.75rem);\n                        }\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                            max-height: 25rem;\n                            width: 60vw;\n\n                            ul a {\n                                width: 101%;\n                            }\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>a {\n                                width: calc(60vw + 3.75rem);\n                            }\n                            &>ul {\n                                max-height: 25.625rem;\n                                width: 60vw;\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n                            &>a {\n                                width: calc(50vw + 3.75rem);\n                            }\n\n                            &>ul {\n                                max-height: 16.25rem;\n                                width: 50vw;\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>a {\n                                width: calc(40vw + 3.75rem);\n                            }\n                            &>ul {\n                                max-height: 18.75rem;\n                                width: 40vw;\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>a {\n                                width: calc(22vw + 3.75rem);\n                            }\n                            &>ul {\n                                max-height: 18.125rem;\n                                width: 22vw;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n//mega menu for horizontal layout\n[data-layout=\"horizontal\"] {\n\n    .deznav {\n\n        .metismenu {\n\n            &>li {\n\n                &.mega-menu {\n                    &:not(:last-child) {\n                        position: static;\n                    }\n\n                    ul {\n                        left: 0;\n                        right: 0;\n\t\t\t\t\t\t\n\n                        li {\n                            \n                            @at-root [data-theme-version=\"dark\"]#{&} {\n                                border-color: $d-border;\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_2\"]#{&} {\n                                border-color: darken($color_pallate_2, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_3\"]#{&} {\n                                border-color: darken($color_pallate_3, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_4\"]#{&} {\n                                border-color: darken($color_pallate_4, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_5\"]#{&} {\n                                border-color: darken($color_pallate_5, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_6\"]#{&} {\n                                border-color: darken($color_pallate_6, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_7\"]#{&} {\n                                border-color: darken($color_pallate_7, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_8\"]#{&} {\n                                border-color: darken($color_pallate_8, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_9\"]#{&} {\n                                border-color: darken($color_pallate_9, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_10\"]#{&} {\n                                border-color: darken($color_pallate_10, 20%);\n                            }\n\n                            a {\n                                transition: all .4s ease-in-out;\n\n                                &:hover {\n                                    border-radius: 0.25rem;\n                                }\n                            }\n                        }\n                    }\n\n                    &:hover {\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                            max-height: 13.75rem;\n                            width: 70vw;\n                            z-index: 99;\n\n                            &::after {\n                                content: \"\";\n                                height: 100%;\n                                width: 1px;\n                                position: absolute;\n                                background-color: $white;\n                                right: 2.8125rem;\n                                top: 0;\n\n                                @at-root [data-theme-version=\"dark\"]#{&} {\n                                    background-color: lighten($color: $d-bg, $amount: 3.2%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_2\"]#{&} {\n                                    background-color: darken($color_pallate_2, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_3\"]#{&} {\n                                    background-color: darken($color_pallate_3, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_4\"]#{&} {\n                                    background-color: darken($color_pallate_4, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_5\"]#{&} {\n                                    background-color: darken($color_pallate_5, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_6\"]#{&} {\n                                    background-color: darken($color_pallate_6, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_7\"]#{&} {\n                                    background-color: darken($color_pallate_7, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_8\"]#{&} {\n                                    background-color: darken($color_pallate_8, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_9\"]#{&} {\n                                    background-color: darken($color_pallate_9, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_10\"]#{&} {\n                                    background-color: darken($color_pallate_10, 10%);\n                                }\n                            }\n\n                            ul a {\n                                width: 101%;\n                            }\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>ul {\n                                max-height: 210px;\n                                width: 70vw;\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n\n                            &>ul {\n\t\t\t\t\t\t\t\tmax-height: 210px;\n\t\t\t\t\t\t\t\twidth: 700px;\n\t\t\t\t\t\t\t\theight: 210px !important;\n\t\t\t\t\t\t\t\t\n                                @include custommq($min: 1200px, $max: 1500px) {\n                                    width: 700px;\n                                }\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>ul {\n                                max-height: 20rem;\n                                width: 54vw;\n\n                                @include custommq($min: 1200px, $max: 1500px) {\n                                    width: 60vw;\n                                }\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>ul {\n                                max-height: 20rem;\n                                width: 25vw;\n\n                                @include custommq($min: 1200px, $max: 1500px) {\n                                    width: 35vw;\n                                }\n                            }\n                        }\n                    }\n                }\n\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"] {\n    .deznav {\n        .metismenu {\n            &>li {\n                &.mega-menu {\n                    &:hover {\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>ul {\n                                max-height: 21.875rem;\n                                width: 100%;\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n\n                            &>ul {\n                                max-height: 21.875rem;\n                                width: 55vw;\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>ul {\n                                max-height: 18.75rem;\n                                width: 45vw;\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>ul {\n                                max-height: 18.125rem;\n                                width: 50vw;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","@import \"../../abstracts/variable\";\n@import \"../../abstracts/mixin\";\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] {\n    .deznav{\n\t\t\n\t\t.metismenu{\n\n\t\t\t& > li{\n\t\t\t\tpadding: 0 0 0 40px;\n\t\t\t\t\n\t\t\t\t& > a{\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tpadding: 10px 15px;\n\t\t\t\t\tborder-top-left-radius: $radius;\n\t\t\t\t\tborder-bottom-left-radius: $radius;\n\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\tposition:relative;\n\t\t\t\t\t@include respond('laptop') {\n\t\t\t\t\t\tpadding: 8px 15px;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.mm-active{\n\n\t\t\t\t\t& > a{\n\t\t\t\t\t\tcolor:$black;\n\t\t\t\t\t\tbackground:$body-bg;\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\t\tbackground:$white;\n\t\t\t\t\t\t\tbox-shadow: 0px 0px 10px 3px rgba($primary, 0.2);\n\t\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.has-arrow:after{\n\t\t\t\t\tright: 2.5rem;\n\t\t\t\t\t@include respond('laptop') {\n\t\t\t\t\t\tright: 1.5rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t@include respond ('laptop'){\n\t\t\t\t\tpadding:0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t}\n\t\t\n\t}\n\t.menu-toggle {\n        .nav-header {\n            width: 5rem;\n            z-index: 999;\n            .brand-logo {\n                padding-left: 0;\n                padding-right: 0;\n                justify-content: center;\n            }\n            .nav-control {\n                .hamburger {\n                    .line {\n                        background-color: $primary!important;\n                    }\n                }\n            }\n        }\n\t\t.copyright,\n\t\t.add-menu-sidebar{\n\t\t\tdisplay:none;\n\t\t}\n        .header {\n            padding-left: 6rem;\n            width: 100%;\n            @at-root [direction=\"rtl\"]#{&} {\n                padding: 0 0.9375rem;\n                padding-right: 5rem;\n            }\n        }\n        .deznav {\n            width: 5rem;\n            overflow: visible;\n            position: absolute;\n            .nav-text {\n                display: none;\n            }\n            .slimScrollDiv,\n            .deznav-scroll {\n                overflow: visible !important;\n            }\n            .metismenu {\n\t\t\t\n\t\t\t\t\n                li {\n                    position: relative;\n\t\t\t\t\t\n                    a {\n                        padding: 13px;\n\t\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\t\tmargin:2px 0;\n\t\t\t\t\t\t\n\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t    max-width: 24px;\n\t\t\t\t\t\t\tmax-height: 24px;\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t}\n                    }\n                    &>ul {\n                        position: absolute;\n\t\t\t\t\t\tleft: 5rem;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\twidth: 12rem;\n\t\t\t\t\t\tz-index: 1001;\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\tpadding-left: 1px;\n\t\t\t\t\t\theight: auto !important;\n\t\t\t\t\t\tbox-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);\n\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\tbackground:$white;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tbackground: inherit;\n\t\t\t\t\t\t\twidth: 10px;\n\t\t\t\t\t\t\theight: 10px;\n\t\t\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t\t\t-webkit-transform: rotate(45deg);\n\t\t\t\t\t\t\t-ms-transform: rotate(45deg);\n\t\t\t\t\t\t\t-moz-transform: rotate(45deg);\n\t\t\t\t\t\t\tleft: -5px;\n\t\t\t\t\t\t\ttop: 20px;\n\t\t\t\t\t\t}\n                        @at-root [direction=\"rtl\"]#{&} {\n                            left: auto;\n                            right: 3rem;\n                            // box-shadow: -6px 6px 10px rgba(0, 0, 0, 0.15);\n                        }\n                        li:hover {\n                            ul {\n                                // display: block;\n                                left: 11.8125rem;\n                                top: 0;\n\t\t\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                    &:hover>ul {\n                        display: block;\n                        height: auto;\n                        overflow: visible;\n                    }\n                }\n                &>li {\n                    transition: all 0.4s ease-in-out;\n\t\t\t\t\tpadding: 0 13px;\n\t\t\t\t\t\n                    &>a {\n\t\t\t\t\t\ttext-align: center;\n                        &.has-arrow {\n                            &:after {\n                                display: none;\n                            }\n                        }\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t}\n                    }\n                    &.mm-active > a{\n\t\t\t\t\t\tbackground:$primary;\n\t\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    &:hover{\n                        &:nth-last-child(-n + 1) {\n                            &>ul {\n                                bottom: 0;\n                                top: auto;\n                            }\n                        }\n                        &>a {\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\tbackground:$primary;\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbackground:$dark-card;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\t}\n                        }\n                        &>ul {\n                            height: auto !important;\n\t\t\t\t\t\t\tpadding: 10px 0;\t\t\t\t\t\t\n\t\t\t\t\t\t\t\n                            a {\n                                padding: 6px 20px 6px 20px;\n                                margin-left: -.1rem;\n                            }\n                            ul{\n\t\t\t\t\t\t\t\tpadding: 10px 0;\n\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\tpadding: 6px 20px 6px 20px;\n\t\t\t\t\t\t\t\t\tmargin-left: -.1rem;\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                }\n                .nav-label,\n                .nav-badge {\n                    display: none;\n\t\t\t\t\t\n                }\n            }\n        }\n        .content-body {\n            margin-left: 5rem;\n            @at-root [direction=\"rtl\"]#{&} {\n                margin-right: 5rem;\n                margin-left: auto;\n\t\t\t\tborder: 0;\n            }\n        }\n        &+.footer {\n            padding-left: 5rem;\n            @at-root [direction=\"rtl\"]#{&} {\n                padding-left: 0;\n                padding-right: 5rem;\n            }\n        }\n    }\n}\n[data-sidebar-style=\"full\"][data-layout=\"horizontal\"] {\n\t.deznav .metismenu{\n\t    padding: 0 30px;\n\t}\n\t.header .header-content{\n\t\tpadding-left: 1.875rem;\n\t}\n}\n","@import \"../../abstracts/_mixin\";\n@import \"../../abstracts/_variable\";\n\n@include custommq($min: 768px) {\n\n    [data-sidebar-style=\"mini\"] {\n        \n        .nav-header {\n            width: 5rem;\n\n            .nav-control {\n                z-index: -1;\n                .hamburger{\n                    left: 5rem!important;\n                    .line{\n                        background-color: $dark!important;\n                    }\n                }\n            }\n            .brand-title {\n                display: none;\n            }\n            .hamburger {\n                display: none;\n            }\n        }\n\t\t.header .header-content{\n\t\t\tpadding-left: 1.875rem;\n\t\t\t@at-root [direction=\"rtl\"]#{&}{\n\t\t\t\tpadding-right: 1.875rem;\n\t\t\t}\n\t\t}\n        .deznav {\n            width: 5rem;\n            overflow: visible;\n            position: absolute!important;\n\t\t\t.copyright,\n\t\t\t.add-menu-sidebar{\n\t\t\t\tdisplay:none;\n\t\t\t}\n            .nav-text {\n                display: none;\n            }\n\n            .slimScrollDiv,\n            .deznav-scroll {\n                overflow: visible !important;\n            }\n            .nav-user{\n                padding: 11px;\n                .media-body{\n                    display: none;\n                }\n            }\n\n            .metismenu {\n               li {\n\t\t\t   \n                    a {\n                        padding: 0.813rem 0.875rem;\n\t\t\t\t\t\t svg{\n\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t }\n                    }\n\n                    &>ul {\n                        position: absolute;\n                        left: 5rem;\n                        top: 2.9375rem;\n                        width: 11.875rem;\n                        z-index: 1001;\n                        display: none;\n                        padding-left: 1px;\n                        box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);\n                        height: auto !important;\n\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\tbackground: #fff;\n\n                        @at-root [direction=\"rtl\"]:not([data-layout=\"horizontal\"])#{&} {\n                            left: auto;\n                            right: 5rem;\n                            box-shadow: -6px 6px 10px rgba(0, 0, 0, 0.15);\n                        }\n                    }\n                }\n                &>li {\n\t\t\t\t\tpadding: 2px 15px;\n                    &>a {\n                        \n                        &.has-arrow {\n                            &:after {\n                                display: none;\n                            }\n                        }\n                    }\n                }\n                .nav-label,\n                .nav-badge {\n                    display: none;\n                }\n            }\n        }\n\n        .content-body {\n            margin-left: 5rem;\n        }\n\n        .footer {\n            padding-left: 5rem;\n        }\n\n\n    }\n\n    [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] {\n        .deznav {\n            .metismenu {\n\n                li {\n                    &:hover>ul {\n                        display: block;\n                    }\n                }\n\n                &>li {\n\n                    &:nth-last-child(-n + 1) {\n                        &>ul {\n                            bottom:0;\n                            top: auto !important;\n\t\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t\ttop:auto;\n\t\t\t\t\t\t\t\tbottom:20px;\n\t\t\t\t\t\t\t}\n                        }\n                    }\n\n                    @include respond('tab-land') {\n                        &:nth-last-child(-n + 1) {\n                            &>ul {\n                                bottom: 0;\n                                top: auto !important;\n                            }\n                        }\n                    }\n\n                    &>ul {\n                        overflow: visible;\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t}\n\n                        li:hover {\n                            ul {\n                                padding: 10px 0;\n\t\t\t\t\t\t\t\twidth: 13rem;\n\t\t\t\t\t\t\t\tleft: 13rem;\n\t\t\t\t\t\t\t\ttop: -10px;\n\t\t\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t}\t\t\t\n\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&}{\n\t\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\t\tright: 13rem;\n\t\t\t\t\t\t\t\t}\t\t\t\n                            }\n                        }\n                    }\n\t\t\t\t\t&.mm-active {\n\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\tbackground: $primary;\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbackground: $dark-card;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    &:hover {\n\n\n                        &>a {\n                            background: $primary;\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\tposition: unset;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbackground: $dark-card;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n                            .nav-text {\n\t\t\t\t\t\t\t\t\n                                @at-root [direction=\"rtl\"]#{&} {\n                                    padding-left: auto;\n                                    padding-right: 1.6875rem;\n                                }\n                            }\n                        }\n                        &>ul {\n                            height: auto !important;\n                            overflow: visible;\n\t\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\tleft: 5rem;\n\t\t\t\t\t\t\twidth: 13rem;\n\t\t\t\t\t\t\tborder-radius:12px;\n\t\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\t\tpadding: 10px 0;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\tbackground: inherit;\n\t\t\t\t\t\t\t\twidth: 10px;\n\t\t\t\t\t\t\t\theight: 10px;\n\t\t\t\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t\t\t\t-webkit-transform: rotate(45deg);\n\t\t\t\t\t\t\t\t-ms-transform: rotate(45deg);\n\t\t\t\t\t\t\t\t-moz-transform: rotate(45deg);\n\t\t\t\t\t\t\t\tleft: -5px;\n\t\t\t\t\t\t\t\ttop: 20px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbox-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.1);;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\tright: 5rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\ta {\n                                padding: 6px 20px 6px 20px;\n                               \n\t\t\t\t\t\t\t    &:before{\n\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.has-arrow:after{\n\t\t\t\t\t\t\t\t\tright: 1.25rem\n\t\t\t\t\t\t\t\t}\n                            }\n\t\t\t\t\t\t\t\n                            ul {\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\tpadding: 6px 20px 6px 20px;\n\t\t\t\t\t\t\t\t\tmargin-left: -1.6px;\n\t\t\t\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    [data-sidebar-style=\"mini\"][data-header-position=\"fixed\"][data-container=\"boxed\"][data-layout=\"vertical\"] {\n        .header {\n            width: 1199px;\n        }\n    }\n\t\n\t[data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] {\n\t\t.deznav .metismenu {\n\t\t\tpadding: 0 30px;\n\t\t}\n\t\t.deznav .metismenu > li > a {\n\t\t\tpadding: 15px 20px;\n\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\tpadding: 15px 20px;\n\t\t\t\tsvg {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\tsvg{\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n@include respond('tab-land') {\n    [data-sidebar-style=\"mini\"] {\n        .deznav {\n\n            li {\n                &.mm-active {\n                    ul {\n                        height: auto !important;\n                    }\n                }\n\n                a.has-arrow {\n                    &::after {\n                        transform: rotate(-45deg) translateY(-50%);\n                    }\n                }\n            }\n        }\n    }\n}","@import \"../../abstracts/variable\";\n\n////////////////////\n// Horizontal Nav\n////////////////////\n@media (min-width: 1199px) {\n    [data-layout=\"horizontal\"] {\n        \n        .nav-header {\n            width: 16rem;\n            \n            .nav-control {\n                display: none;\n            }\n\n            .brand-logo {\n               /*  padding-left: 0;\n                justify-content: center; */\n            }\n        }\n\n        .header {\n            width: 100%;\n            padding-left: 16rem;\n        }\n\n        .deznav {\n            width: 100%;\n            position: relative;\n            height: auto;\n            padding-bottom: 0;\n            top: 0;\n            z-index: 2;\n\t\t\t\n\t\t\t\n            .slimScrollDiv {\n                overflow: visible!important;\n\n                .deznav-scroll {\n                    overflow: visible!important;\n                }\n            }\n\t\t\t.deznav-scroll {\n\t\t\t\toverflow: visible!important;\n\t\t\t}\n            .slimScrollBar {\n                display: none !important;\n            }\n\n            .nav-user,\n            .nav-label {\n                display: none;\n            }\n\t\t\t\n            .metismenu {\n                flex-direction: row;\n\t\t\t\t\n                .collapse.in {\n                    display: none;\n                }\n\t\t\t\tul{\n\t\t\t\t\tborder-left:0;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t   box-shadow: 0px 10px 13px 0px rgba(0, 0, 0, 0.1);\n\t\t\t\t\t}\n\t\t\t\t}\n                li {\n                    flex-direction: column;\n                    position: relative;\n\n                    &:hover {\n                        &>ul {\n                            display: block;\n                        }\n                    }\n                    \n                    &>ul {\n                        position: absolute;\n                        height: auto !important;\n                        top: 3.25rem;\n                        width: 100%;\n                        min-width: 13.75rem;\n                        z-index: 999;\n                        left: auto;\n                        right: auto;\n                        padding: 0.5rem 0;\n                        display: none;\n                        box-shadow: 0px 0px 40px 0px rgba(82, 63, 105, 0.1);\n\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\tbackground:$white;\n                        \n                        @at-root [data-theme-version=\"dark\"]#{&} {\n                           box-shadow: 0px 10px 13px 0px rgba(0, 0, 0, 0.1);\n                        }\n\n                        li {\n                            padding: 0;\n    \n                            a {\n                                transition: all .4s ease-in-out;\n                                padding: 8px 20px 8px 45px;\n                                margin-left: -.1rem;\n\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\t\tpadding: 8px 45px 8px 20px;\n\t\t\t\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t\t\t\t}\n                                &:hover {\n                                    border-radius: .4rem;\n                                }\n\t\t\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\t\t\tleft: 22px;\n\t\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\t\t\tright: 21px;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                        \n                        ul {\n                            left: 100%;\n                            top: 0;\n\t\t\t\t\t\t\tbox-shadow: 0px 10px 13px 0px rgba(82, 63, 105, 0.05);\n\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\tright: 100%;\n\t\t\t\t\t\t\t}\n                        }\n                    }\n                }\n\n                &>li {\n                    flex: 0 0 auto;\n                    position: relative;\n                    \n\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\tborder-color: rgba(255,255,255,0.07);\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\tpadding:0;\t\t\t\n\t\t\t\t\t\t& > a{\n\t\t\t\t\t\t\tbackground: #fff;\n\t\t\t\t\t\t\tbox-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    @at-root [direction=\"rtl\"]#{&} {\n                        //&:not(:first-child) {\n                        //    border-right: lighten($color: $color-pallate-2, $amount: 10%);\n                        //}\n\n                        &:first-child {\n                            border-right: 0;\n                        }\n\n                        \n\n                        @at-root [data-theme-version=\"dark\"]#{&} {\n                            border-color: $d-border;\n                        }\n                    }\n                    &>a {\n                        padding: 15px 40px 15px 15px;\n                        @at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\tpadding: 15px 15px 15px 40px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n                        i{\n                            padding: 0 0.4375rem 0 0;\n\n                            @at-root [direction=\"rtl\"]#{&} {\n                                padding: 0 0 0 0.4375rem;\n                            }\n                        }\n                        .nav-badge {\n                            display: none;\n                        }\n                        &:after {\n                            right: 20px;\n                            transform: rotate(-135deg) translateY(-50%);\n                        }\n                    }\n                    &:hover {\n\t\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\t\t\n                        &>ul {\n                            display: flex !important;\n                            flex-direction: column;\n                            flex-wrap: wrap;\n                            height: auto !important;\n\t\t\t\t\t\t\tbox-shadow: 0px 10px 13px 0px rgba(82, 63, 105, 0.05);\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbox-shadow: 0px 0 13px 0px rgba(0, 0, 0, 0.1);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n                        }\n                    }\n                    &>ul {\n                        &>li {\n                            &:hover {\n                                ul.collapse {\n                                    display: block!important;\n                                    position: absolute;\n                                    left: auto!important;\n                                    right: -100%!important;\n                                    top: 0!important;\n                                }\n                            }\n                        }\n                    }\n                    &:nth-last-child(-n + 5) {\n                        &>ul {\n                        left: auto;\n                        right: 0;\n                            &>li {\n                                &:hover {\n                                    ul.collapse {\n                                        right: auto!important;\n                                        left: -100%!important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    &:last-child {\n                        &>ul {\n                            ul {\n                                left: -100%;\n                            }\n                        }\n                    }\n                    @at-root [direction=\"rtl\"]#{&} {\n\n                        &:nth-last-child(-n + 3) {\n                            &>ul {\n                            left: 0;\n                            right: auto;\n                                &>li {\n                                    &:hover {\n                                        ul.collapse {\n                                            right: -100% !important;\n                                            left: auto !important;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .content-body {\n            margin-left: 0;\n            .page-titles {\n                margin-left: 0;\n                margin-right: 0;\n                margin-bottom: 1.875rem;\n            }\n        }\n\n        .footer {\n            margin-left: 0;\n            margin: 0 auto;\n            padding-left: 0;\n        }\n\n        .sidebar-right {\n            z-index: 1;\n        }\n    }\n\n    [data-header-position=\"fixed\"][data-layout=\"horizontal\"] {\n        .deznav {\n            top: 5rem;\n        }\n    } //ok\n\n    [data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"] {\n        .deznav {\n            position: fixed;\n        }\n    } //ok\n\n    [data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-sidebar-position=\"fixed\"] {\n        .content-body {\n            padding-top: 8.3rem;\n        }\n    } //ok\n\n    [data-layout=\"horizontal\"][data-container=\"boxed\"] {\n\n        .footer {\n            margin-left: 0;\n            max-width: 1199px;\n            margin: 0 auto;\n        }\n    }\n\n    [data-layout=\"horizontal\"][data-container=\"wide\"] {\n        .page-titles {\n            margin-left: -30px;\n            margin-right: -30px;\n        }\n    }\n\n    [data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] {\n        .page-titles {\n            margin-top: 0;\n        }\n        \n        .deznav {\n            .metismenu {\n\n                &>li {\n                    &>ul {\n                        top: 4.315rem;\n                    }\n                    &>a {\n                        padding: 0.8125rem 2.1rem;\n\n                        &::after {\n                            display: none;\n                        }\n                    }\n\n                    li {\n                        text-align: left;\n                    }\n                }\n            }\n        }\n    }\n\n    [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] {\n        .nav-header {\n            width: 6rem;\n\t\t\tpadding-left: 30px;\n\t\t\tpadding-right: 30px;\n\t\t\t    .brand-logo {\n\t\t\t\t    justify-content: start;\n\t\t\t\t}\n        }\n    \n        .header {\n            width: 100%;\n            padding-left: 6rem;\n        }\n\n        .metismenu {\n            &>li {\n                &:hover {\n                    a {\n                        width: auto;\n                        .nav-text {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    [data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"compact\"] {\n        .content-body {\n            padding-top: 8.75rem;\n        }\n    }\n\n    [data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] {\n        .deznav.fixed {\n            position: fixed;\n            left: 0;\n            top: 0;\n        }\n    }\n\n}\n","////////////////\n// Compact Nav\n////////////////\n\n@media (min-width:767px) {\n    [data-sidebar-style=\"compact\"] {\n\n        .deznav {\n            \n            .nav-user{\n                display: none;\n            }\n        \n            .metismenu {\n\t\t\t\t& > li{\n\t\t\t\t\n\t\t\t\t\t& > a{\n\t\t\t\t\t\tpadding:1.5rem 1.625rem 1.5rem 1.5rem;\n\t\t\t\t\t}\n\t\t\t\t\tul{\n\t\t\t\t\t\tpadding:1rem 0;\n\t\t\t\t\t\t\n\t\t\t\t\t\tli > a{\n\t\t\t\t\t\t\tpadding:0.5rem 1rem;\n\t\t\t\t\t\t\t&.has-arrow:after{\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n                li {\n                    text-align: center;\n                    a {\n                        \n\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\n\t\t\t\t\t\t\tmax-width: 21px;\n\t\t\t\t\t\t\tmax-height: 21px;\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\tmargin-right: auto;\t\n\t\t\t\t\t\t}\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tfont-size:2.2rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\theight: 75px;\n\t\t\t\t\t\t\twidth: 0;\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\ttransform:translatey(-50%);\n\t\t\t\t\t\t\tbackground: $primary;\n\t\t\t\t\t\t\tborder-radius:0 $radius $radius 0;\n\t\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t\t}\n                    }\n\t\t\t\t\t\n\t\t\t\t\tul:after{\n\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t}\n\t\t\t\t\t&.mm-active,\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\t& > a{\n\t\t\t\t\t\t\tbackground: -moz-linear-gradient(left,  rgba(224,224,228,1) 0%, rgba(125,185,232,0) 100%); \n\t\t\t\t\t\t\tbackground: -webkit-linear-gradient(left,  rgba(224,224,228,1) 0%,rgba(125,185,232,0) 100%); \n\t\t\t\t\t\t\tbackground: linear-gradient(to right,  rgba(224,224,228,1) 0%,rgba(125,185,232,0) 100%); \n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\t\twidth:10px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                }\n            }\n        }\n\n        .nav-text {\n            display: inline-block;\n\t\t\tmargin-top: 0.7125rem;\n        }\n\n        .nav-label {\n            &.first{\n                display: none;\n            }\n        }\n\n        .nav-badge {\n            display: none;\n        }\n\n        .footer {\n            padding-left: 9.375rem;\n        }\n\n        .content-body {\n            margin-left: 15rem;\n        }\n    }\n}\n[data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] {\n\t.footer {\n\t\tpadding-left: 0;\n\t}\n\t.content-body {\n\t\tmargin-left:0;\n\t}\n\t.deznav .metismenu{\n\t    padding: 0 30px;\n\t}\n}\n[data-layout=\"vertical\"][data-sidebar-style=\"compact\"] {\n    .deznav {\n        width: 15rem;\n        \n        .metismenu {\n\t\t\n            ul{\n\t\t\t\tbackground: rgba(0,0,0,0.02);\n\t\t\t\t\n\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\tbackground:(255, 255, 255, 0.05);\n\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\ta{\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\tul a {\n\t\t\t\t\tpadding: 0.625rem 0.9375rem;\n\t\t\t\t\t\n\t\t\t\t}\n            }\n\n            &>li {\n                &>a.has-arrow::after {\n                    top: 1px;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tright: auto;\n\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\twidth: 7px;\n\t\t\t\t\theight: 7px;\n\t\t\t\t\tborder-width: 2px 0px 0px 2px;\n\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t\t}\n                }\n            }\n        }\n\n    }\n}","@media (min-width: 767px) {\n\n    [data-sidebar-style=\"icon-hover\"][data-layout=\"horizontal\"] {\n\t\t.metismenu {\n\t\t\tpadding: 0 30px;\n\t\t}\n\t\t.header .header-content {\n\t\t    padding-left: 1.875rem;\t\n\t\t}\n\t}\n    [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] {\n        .nav-header {\n            width: 5.063rem;\n\n            .brand-logo {\n                padding-left: 20px;\n\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\tpadding-left:1.25rem;\n\t\t\t\t\tpadding-right:1.25rem;\n\t\t\t\t}\n                .logo-abbr {\n                    display: block;\n                }\n\n                .brand-title {\n                    display: none;\n                }\n            }\n\n            .nav-control {\n                display: none;\n            }\n        }\n\n        .header {\n            padding-left: 5.063rem;\n\n            @at-root [direction=\"rtl\"]#{&} {\n                padding-right: 4.38rem;\n                padding-left: 0.9375rem;\n            }\n\n            .header-content {\n                padding-left: 1.375rem;\n\n                @at-root [direction=\"rtl\"]#{&} {\n                    padding-right: 1.375rem;\n                    padding-left: 0;\n                }\n            }\n        }\n\n        .deznav {\n            overflow: visible;\n            position: absolute;\n            left: -12.125rem;\n            // z-index: 1;\n\t\t\t\n\t\t\t@include custommq($min: 1200px, $max: 1350px) {\n                left: -10rem;\n            }\n\n            @at-root [direction=\"rtl\"]#{&} {\n                left: auto;\n                right: -12.125rem;\n            }\n\n            .nav-label {\n                display: none;\n            }\n\n            .metismenu {\n                &>li {\n                    &>a {\n                        display: flex;\n                        justify-content: space-between;\n    \n                        &>svg,\n                        &>i {\n                            order: 1;\n\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\tmargin-top:0;\n                        }\n                    }\n                }\n\n                ul {\n\t\t\t\t\tborder-left: 0;\n\t\t\t\t\tpadding-left:0;\n\t\t\t\t\tpadding-right:28px;\n\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\tpadding-right:0;\n\t\t\t\t\t\tpadding-left:28px;\n\t\t\t\t\t}\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\tborder-color:$d-border;\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tleft:auto;\n\t\t\t\t\t\tright:28px;\n\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\tleft:28px;\n\t\t\t\t\t\t\tright:auto;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    a {\n                        position: relative;\n\n                        &::before {\n\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\tright: -5px;\n\t\t\t\t\t\t\n                            @at-root [direction=\"rtl\"]#{&} {\n                                right: auto;\n                                left:-5px;\n                            }\n                        }\n                    }\n                }\n\n                .has-arrow {\n                    &::after {\n                        right: 5rem;\n\n                        @at-root [direction=\"rtl\"]#{&} {\n                            right: auto;\n                            left: 5rem;\n                        }\n                    }\n                }\n            }\n        }\n\n        .icon-hover-toggle {\n\n            .nav-header {\n                width: 17.1875rem;\n    \n                .brand-logo {\n                    padding-left: 1.6rem;\n    \n    \n                    .brand-title {\n                        display: block;\n                    }\n                }\n            }\n    \n            .header {\n                padding-left: 4.38rem;\n\n                @at-root [direction=\"rtl\"]#{&} {\n                    padding-right: 4.38rem;\n                    padding-left: 0.9375rem;\n                }\n            }\n\n            .deznav {\n                left: 0;\n\n                @at-root [direction=\"rtl\"]#{&} {\n                    left: auto;\n                    right: 0;\n                }\n            }\n        }\n\n        .content-body {\n            margin-left: 5rem;\n\n            @at-root [direction=\"rtl\"]#{&} {\n                margin-left: 0;\n                margin-right: 5rem;\n            }\n        }\n\n        .footer {\n            padding-left: 4.375rem;\n\n            @at-root [direction=\"rtl\"]#{&} {\n                margin-left: 0;\n                margin-right: 4.375rem;\n            }\n        }\n    }\n\n\n\n}","@media (min-width:767px) {\n    [data-sidebar-style=\"modern\"] {\n\n        .nav-header {\n            width: 9.375rem;\n\t\t\t.brand-logo{\n\t\t\t\t    justify-content: center;\n\t\t\t}\n        }\n        .deznav {\n        \n            .metismenu {\n\t\t\t\t\n                &>li {\n                    text-align: center;\n\t\t\t\t\t\n\t\t\t\t\t\n                    &>a {\n                        padding: 20px 15px 20px 15px!important;\n                        // font-weight: 500;\n\n                        &::after {\n                            display: none;\n                        }\n\n                        &:hover, \n                        &:focus, \n                        &:active, \n                        &.mm-active {\n                            &>a {\n                                background-color: lighten($color: $primary, $amount: 50%);\n                            }\n                        }\n                    }\n\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t}\n                    li {\n                        text-align: left;\n\n                        @at-root [direction=\"rtl\"]#{&} {\n                            text-align: right;\n                        }\n                    }\n                }\n\n                li {\n\n                    a {\n                        padding: 0.625rem 0.9375rem 0.625rem 0.9375rem;\n                    }\n\t\t\t\t\tul:after{\n\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t}\n\n                    &>ul {\n                        height: auto !important;\n                    }\n                }\n                .nav-label{\n                    display: none;\n                }\n            }\n\n            .nav-label {\n                display: none;\n            }\n            \n\n            .nav-text {\n                display: block;\n                margin-top: 0.3125rem;\n            }\n        }\n\n        .footer {\n            padding-left: 9.375rem;\n        }\n        .content-body {\n            margin-left: 9.375rem;\n        }\n    }\n\n    [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] {\n\n        .deznav {\n            width: 9.375rem;\n            left: 0;\n\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\tleft: auto;\n\t\t\t\tright: 0;\n\t\t\t}  \n\t\t\t\n            .slimScrollDiv, \n            .deznav-scroll {\n                overflow: visible !important;\n            }\n        \n            .metismenu {\n                &>li {\n                    &>a{\n                        i{\n                            font-size: 20px;\n                            // height: 35px;\n                        }\n                    }\n\n                    &>ul {\n                        display: none;\n                        padding: 1.875rem 0.9375rem;\n                    }\n                }\n\n                li {\n                    position: relative;\n\n                    a {\n                        padding:0.625rem 1.5rem;\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t}\n                    }\n\n                    ul {\n                        position: absolute;\n                        left: 105%;\n                        top: 0;\n                        bottom: auto;\n                        background-color: $white;\n                        border: 1px solid $border;\n                        width: 200px;\n                        // box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n\t\t\t\t\t\t\n\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\tbackground:$dark-card;\n\t\t\t\t\t\t\tbox-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.1);\n\t\t\t\t\t\t}\n\n                        @at-root [direction=\"rtl\"]#{&} {\n                            left: auto;\n                            right: 105%;\n                        }\n                    }\n\n                    &:hover {\n                        &>ul {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tleft: 100%;\n\t\t\t\t\t\t\tpadding: 1rem 0;\n\t\t\t\t\t\t\tmargin-left: -10px;\n\t\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\t\tbox-shadow: 5px 0px 13px 0px rgba(82, 63, 105, 0.05);\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbox-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.1);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\n                            @at-root [direction=\"rtl\"]#{&} {\n                                left: auto;\n                                right: 100%;\n\t\t\t\t\t\t\t\tbox-shadow: -5px 0px 13px 0px rgba(82, 63, 105, 0.05);\n                            }  \n                        }\n                    }\n                }\n            }\n            \n\n            .nav-label {\n                display: none;\n            }\n\n            .nav-text {\n                display: block;\n                margin-top: 0;\n            }\n        }\n\n\n        .menu-toggle {\n            .deznav {\n                left: -9.375rem;\n\n                @at-root [direction=\"rtl\"]#{&} {\n                    left: auto;\n                    right: -9.375rem;\n                }\n            }\n\n            .content-body {\n                margin-left: 0;\n\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n\n    [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] {\n\t\t.footer,\n\t\t.content-body {\n\t\t\tmargin-left:0;\n\t\t}\n        .deznav {\n            .metismenu {\n\t\t\t\tpadding: 0 30px;\n\t\t\t\t\n                &>li {\n                    &>a {\n                        padding: 0.8125rem 2.25rem;\n                    }\n\n                    &>ul {\n                        top: 4.5625rem;\n                    }\n                }\n            }\n        }\n\t\t\n        &[data-container=\"boxed\"] {\n            .deznav {\n                .metismenu {\n    \n                    &>li {\n                        &>a {\n                            padding: 0.8125rem 1.25rem;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","[data-sidebar-style=\"overlay\"] {\n    .deznav {\n        left: -100%;\n        @at-root [direction=\"rtl\"]#{&} {\n            left: auto;\n            right: -100%;\n        }\n    }\n    .content-body {\n        margin-left: 0;\n    }\n    .nav-header {\n        position: absolute;\n        .hamburger.is-active {\n            left: 0;\n            .line {\n                background-color: $primary;\n            }\n        }\n    }\n    .menu-toggle {\n        .nav-header {\n            position: absolute;\n            left: auto;\n        }\n        .deznav {\n            left: 0;\n            @at-root [direction=\"rtl\"]#{&} {\n                left: auto;\n                right: 0;\n            }\n        }\n    }\n    .footer {\n        padding-left: 0;\n    }\n}\n\n[data-sidebar-style=\"overlay\"][data-header-position=\"fixed\"] {\n    .nav-header {\n        position: fixed;\n    }\n}\n\n[data-sidebar-position=\"fixed\"][data-header-position=\"fixed\"] {\n    .nav-header {\n        position: fixed;\n    }\n}","[data-sidebar-position=\"fixed\"][data-layout=\"vertical\"] {\n    .nav-header {\n        position: fixed;\n        // left: auto;\n        border-top-left-radius: 0px;\n        border-top-right-radius: 0px;\n    }\n\n    .deznav {\n        position: fixed;\n        // z-index: 0;\n        .deznav-scroll {\n            border-top-left-radius: 0px;\n            border-top-right-radius: 0px;\n        }\n    }\n\n    .menu-toggle {\n        .deznav {\n            position: fixed;\n        }\n    }\n}\n[data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"overlay\"][data-layout=\"vertical\"][data-container=\"boxed\"] {\n    .deznav {\n        position: absolute;\n    }\n}\n\n\n","// @import \"../../abstracts/variable\";\n\n.sidebar-right {\n    // display: none;\n    right: -15.625rem;\n    position: fixed;\n    top: 0;\n    width: 15.625rem;\n    background-color: $white;\n    height: calc(100% - 7.0625rem);\n    margin-top: 5rem;\n    transition: all .5s ease-in-out;\n    padding-bottom: 1.875rem;\n    box-shadow: -2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n\n    .slimScrollDiv {\n        @at-root [direction=\"rtl\"] #{&} {\n            overflow: visible !important;\n        }\n    }\n    .sidebar-right-trigger {\n\t\n        position: absolute;\n        z-index: 9;\n        top: 4.75rem;\n        right: 100%;\n        background-color: $white;\n        color: $primary;\n        display: inline-block;\n        height: 3rem;\n        width: 3rem;\n        text-align: center;\n        font-size: 1.75rem;\n        line-height: 3rem;\n\t\tborder-radius: 5px 0 0 5px;\n\t\tbox-shadow: -5px 3px 5px 0px rgba(119, 119, 119, 0.15);\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] #{&} {\n\t\t\tbackground-color: #31343b;\n\t\t\tcolor: $white;\n        }\n        &:hover {\n            color: $primary;\n        }\n    }\n\n    &.show {\n        right: 0;\n        z-index: 999;\n    }\n\n    .nav-tabs {\n        justify-content: space-between;\n        position: sticky;\n        top: 0;\n        background-color: $white;\n        z-index: 2;\n                    \n        @at-root [data-theme-version=\"dark\"] #{&} {\n            background-color: $d-bg;\n        }\n        \n\n        .nav-item {\n            margin-bottom: 0;\n            flex: 1;\n\n            .nav-link {\n                border: 0;\n                font-size: 1.125rem;\n                position: relative;\n                text-align: center;\n                background-color: $white;\n\n                &::after {\n                    position: absolute;\n                    left: 0;\n                    bottom: 0;\n                    width: 100%;\n                    height: 2px;\n                    content: \"\";\n                    background: transparent;\n                }\n                    \n                @at-root [data-theme-version=\"dark\"] #{&} {\n                    background-color: $d-bg;\n                }\n\n                &.active {\n                    \n                    @at-root [data-theme-version=\"dark\"] #{&} {\n                        border-right: none;\n                        border-left: none;\n                        border-top: none;\n                    }\n                }\n            }\n        }\n    }\n\n    .tab-content {\n        padding: 1.25rem;\n\n        .tab-pane {\n\n            .admin-settings {\n\t\t\t\t& > div {\n\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t}\n                p {\n                    margin-bottom: 0.125rem;\n                }\n\n                //All color switcher scss goes here\n                input[type=\"radio\"] {\n                    display: none;\n\n                    + label {\n                        display: inline-block;\n                        width: 25px;    \n                        height: 25px;\n                        cursor: pointer;\n                        transition: all .1s ease;\n\t\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t\t\tmargin-bottom: 3px;\n                    }\n\n                    &:checked {\n                        + label {\n                            position: relative;\n\n                            &::after {\n                                height: 33px;\n                                width: 33px;\n                                left: -4px;\n                                top: -4px;\n                                content: \"\";\n                                position: absolute;\n                                background-color: inherit;\n\t\t\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\t\t\topacity: 0.4;\n                            }\n                        }\n                    }\n                }\n            }\n\n        }\n    }\n\n   \n    #nav_header, \n    #header, \n    #sidebar,\n\t#primary{\n\n\n        @each $name, $color in $theme_backgrounds {\n            &_#{$name} {\n                + label {\n                    background-color: $color;            \n                }\n            }\n        }\n\n        &_color_1 {\n            + label {\n                border: 1px solid $muted;\n            }\n        }\n    }\n\n}\n\n@keyframes bounce {\n\t0% {\n        transform: translateX(-8%);;\n        -webkit-transform: translateX(-8%);; \n        }\n\t50% {\n        transform: translateX(8%);;\n        -webkit-transform: translateX(8%);; \n        }\n\t100% {\n        transform: translateX(-8%);; \n        -webkit-transform: translateX(-8%);; \n        }\n}\n\n@-webkit-keyframes bounce {\n\t0% {\n        transform: translateX(-8%);;\n        -webkit-transform: translateX(-8%);; \n        }\n\t50% {\n        transform: translateX(8%);;\n        -webkit-transform: translateX(8%);; \n        }\n\t100% {\n        transform: translateY(-8%);; \n        -webkit-transform: translateY(-8%);; \n        }\n}","///////////////////////////\n// Sidebar profile\n///////////////////////////\n.nav-user {\n    // text-align: center;\n    background: $primary;\n    margin-bottom: 10px;\n    padding: 20px 25px 15px;\n    @include custommq($min: 768px, $max: 1199px) {\n        padding: 20px 15px 15px;\n    }\n    img {\n        width: 35px;\n        height: 35px; \n        @include custommq($min: 768px, $max: 1199px) {\n            width: 35px;\n            height: 35px;\n            margin-bottom: 10px;\n        }\n    }\n    h5 {\n        margin-left: 10px;\n        margin-bottom: 3px;\n        color: $white;\n        @include custommq($min: 768px, $max: 1199px) {\n            display: none;\n        }\n        @at-root [data-sibebarbg=\"color_2\"] & {\n            color: $white;\n        }\n    } \n    p{\n        margin-left: 10px;\n        margin-bottom: 8px;\n        color: #afcff7;\n        @include custommq($min: 768px, $max: 1199px) {\n            display: none;\n        }\n    }\n\n    @include custommq($min: 768px, $max: 1199px) {\n        i{\n            margin-top: 15px;\n            display: block\n        }\n    }    \n}\n\n\n\n\n\n.menu-toggle{\n    .nav-user {\n        padding: 20px 15px 15px;\n        img {\n            width: 35px;\n            height: 35px;\n            margin-bottom: 10px;\n        }\n        h5,\n        p {\n            display: none;\n        }\n        i {\n            margin-top: 15px;\n            display: block\n        }\n        .dropdown-menu {\n            left: 45px !important;\n            top: 22px !important;\n        }\n    }\n}\n\n",".chatbox{\n\twidth:340px;\n\theight:100vh;\n\tposition:fixed;\n\tright:-500px;\n\ttop:0;\n\tz-index:999;\n\tbackground:#fff;\n\tbox-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.15) ;\n\t@include transitionSlow;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground:$dark-card;\n\t}\t\n\t.chatbox-close{\n\t\tposition: absolute;\n\t\t@include transitionFast;\n\t\twidth: 0;\n\t\theight: 100%;\n\t\tright: 340px;\n\t\tbackground: #000;\n\t\tz-index: 1;\n\t\topacity: 0.1;\n\t\tcursor:pointer;\n\t}\n\t.card-fotter {\n\t\tpadding: 0.75rem 1rem;\t\n\t}\n\t.card-body {\n\t\tpadding: 1rem;\n\t}\n\t&.active{\n\t\tright:0;\n\t\t\n\t\t.chatbox-close{\n\t\t\twidth: 100vw;\n\t\t}\n\t}\n\t.type_msg {\n\t\tpadding-top: 10px;\n\t}\n\t.nav{\n\t    padding: 1rem 1rem 0 1rem;\n\t\tbackground:$primary;\n\t\tborder: 0;\n\t\tjustify-content: space-between;\n\t\t\t\n\t\t.nav-link{\n\t\t\tcolor: #fff;\n\t\t\topacity: 0.7;\n\t\t\ttext-transform: uppercase;\n\t\t\t\t\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\tbackground:transparent;\n\t\t\t\tcolor: #fff;\n\t\t\t\topacity: 1;\n\t\t\t\tborder-color: #fff;\n\t\t\t}\n\t\t}\n\t}\n\t.img_cont{\n\t\twidth: 40px;\n\t\tborder-radius: 40px;\n\t\tmargin-right: 10px;\n\t\tposition: relative;\n\t\theight: 40px;\n\t\tbackground: #eee;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t\tmin-width: 40px;\n\t\tmin-height: 40px;\n\t\t\n\t\t.icon{\n\t\t\tcolor:#fff;\n\t\t}\n\t\t&.primary{\n\t\t\tbackground:$primary-light;\n\t\t\tcolor:$primary;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$primary-opacity;\n\t\t\t}\t\n\t\t}\n\t\t&.warning{\n\t\t\tbackground:$warning-light;\n\t\t\tcolor:$warning;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$warning-opacity;\n\t\t\t}\t\n\t\t}\n\t\t&.success{\n\t\t\tbackground:$success-light;\n\t\t\tcolor:$success;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$success-opacity;\n\t\t\t}\t\n\t\t}\n\t\t&.info{\n\t\t\tbackground:$info-light;\n\t\t\tcolor:$info;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$info-opacity;\n\t\t\t}\t\n\t\t}\n\t\t\n\t\timg{\n\t\t\twidth:100%;\n\t\t}\n\t\t.online_icon{\n\t\t\t    background: $success;\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 12px;\n\t\t\t\theight: 12px;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\tright: -1px;\n\t\t\t\tbottom: 0px;\n\t\t\t\tborder: 2px solid #fff;\n\t\t\t\t//box-shadow: 5px 5px 10px 0px rgba($success, 0.3);\n\t\t\t\n\t\t\t&.offline{\n\t\t\t\tbackground:$danger;\n\t\t\t\t//box-shadow: 5px 5px 10px 0px rgba($danger, 0.3);\n\t\t\t}\n\t\t}\n\t\t.online_icon{\n\t\t\n\t\t\t\n\t\t\n\t\t}\n\t}\n\t.card{\n\t\tbox-shadow:none;\n\t}\n\t.search{\n\t\theight:40px;\n\t}\n\t.user_info{\n\t\tspan{\n\t\t\tfont-size: 15px;\n\t\t\tcolor: #000;\n\t\t\tdisplay: block;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 1;\n\t\t\tmargin-bottom: 5px;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\tdisplay: block;\n\t\t\tmax-width: 170px;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\t\n\t\tp{\n\t\t\tfont-size:13px;\n\t\t\tmargin-bottom:0;\n\t\t\tline-height: 1;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\tdisplay: block;\n\t\t\tmax-width: 170px;\n\t\t}\n\t}\n\t.contacts{\n\t\tli{\n\t\t\tpadding: 7px 1rem;\n\t\t\tborder-bottom: 1px solid #eee;\n\t\t\tcursor: pointer;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-color: $d-border;\n\t\t\t}\n\t\t\t& > div{\n\t\t\t\tdisplay:flex;\n\t\t\t\talign-items:center;\n\t\t\t}\n\t\t\t&:hover{\n\t\t\t\tbackground:#f4f7ff;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground-color: $d-bg;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.name-first-letter{\n\t\t\tbackground: $body-bg;\n\t\t\tpadding: 4px 1rem;\n\t\t\tfont-weight: 700;\n\t\t\tcolor: #000;\n\t\t\tposition: sticky;\n\t\t\ttop: 0;\n\t\t\tz-index: 1;\n\t\t\t\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground:$d-bg;\n\t\t\t}\n\t\t}\n\t}\n\t\n\t.msg_card_body{\n\t\theight: calc(100vh - 195px);\n\t}\n\t.contacts_body{\n\t\theight: calc(100vh - 120px);\n\t}\n\t.card-header{\n\t\tbackground:#f4f7ff;\n\t\tpadding: 15px 20px;\n\t\tjustify-content: center;\n\t\th6{\n\t\t\tfont-size:15px;\n\t\t}\n\t\tp{\n\t\t\tline-height:1.2;\n\t\t\tfont-size:12px;\n\t\t\tcolor: $body-color;\n\t\t}\n\t}\n\t.chat-list-header{\n\t\tjustify-content: space-between;\n\t\tbackground: #fff;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground: $dark-card;\n\t\t}\t\t\t\t\t\n\t\ta{\n\t\t\ttext-align: center;\n\t\t\twidth: 30px;\n\t\t\theight: 30px;\n\t\t\tbackground: $body-bg;\n\t\t\tborder-radius: 6px;\n\t\t\tline-height: 30px;\n\t\t\tdisplay: block;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$primary-opacity;\n\t\t\t\tsvg g [fill]{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\n\t}\n\t.img_cont_msg {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tdisplay: block;\n\t\tmax-width: 30px;\n\t\tmin-width: 30px;\n\t\t\n\t\timg{\n\t\t\twidth:100%;\n\t\t}\n\t}\n\t.msg_cotainer {\n\t\tbackground: $primary;\n\t\tmargin-left: 10px;\n\t\tborder-radius: 0 $radius $radius $radius;\n\t\tpadding: 10px 15px;\n\t\tcolor:#fff;\n\t\tposition:relative;\n\t\t.msg_time{\n\t\t\tdisplay: block;\n\t\t\tfont-size: 11px;\n\t\t\tcolor: #fff;\n\t\t\tmargin-top: 5px;\n\t\t\topacity: 0.5;\n\t\t}\n\t\t&:after{\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: -10px;\n\t\t\tborder-right: 10px solid $primary;\n\t\t\tborder-bottom: 10px solid transparent;\n\t\t\tborder-top: 0px solid;\n\t\t\ttop: 0;\n\t\t}\n\t}\n\t.msg_cotainer_send {\n\t\tbackground: $body-bg;\n\t\tpadding: 10px 15px;\n\t\tborder-radius: 6px 0px 6px 6px;\n\t\tmargin-right: 10px;\n\t\tcolor: #222;\n\t\tposition: relative;\n\t\ttext-align: right;\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground:$d-bg;\n\t\t\tcolor:$white;\n\t\t}\t\n\t\t\n\t\t.msg_time_send {\n\t\t\tdisplay: block;\n\t\t\tfont-size: 11px;\n\t\t\ttext-align: right;\n\t\t\tmargin-top: 5px;\n\t\t\topacity: 0.6;\n\t\t}\n\t\t&:after{\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tright: -10px;\n\t\t\tborder-left: 10px solid $body-bg;\n\t\t\tborder-bottom: 10px solid transparent;\n\t\t\tborder-top: 0px solid;\n\t\t\ttop: 0;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-left: 10px solid $d-bg;\n\t\t\t}\t\n\t\t}\n\t}\n\t.type_msg{\n\t\t.form-control{\n\t\t\tpadding: 10px 0;\n\t\t\theight: 50px;\n\t\t\tborder: 0;\n\t\t\tresize: none;\n\t\t}\n\t\t.btn{\n\t\t\tfont-size: 18px;\n\t\t\tborder-radius: 38px !important;\n\t\t\twidth: 38px;\n\t\t\theight: 38px;\n\t\t\tpadding: 0;\n\t\t\tmargin-top: 6px;\n\t\t}\n\t} \n\t.video_cam{\n\t\tmargin-left:15px;\n\t\tspan{\n\t\t\twidth: 35px;\n\t\t\theight: 35px;\n\t\t\tbackground: #10ca93;\n\t\t\ttext-align: center;\n\t\t\tline-height: 35px;\n\t\t\tborder-radius: 35px;\n\t\t\tcolor: #fff;\n\t\t\tmargin-right: 5px;\n\t\t\talign-self: center;\n\t\t\tfont-size: 16px;\n\t\t\tpadding: 0 3px;\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\t.note_card{\n\t\t.contacts li{\n\t\t\tpadding: 12px 1rem;\n\t\t}\n\t}\n}\n@include custommq($max: 576px) {\n\t.chatbox{\n\t\twidth: 280px;\n\t\t.chatbox-close{\n\t\t\tright: 280px\n\t\t}\n\t}\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","//background for nav header\n@each $name, $color in $theme_backgrounds {\n    [data-nav-headerbg=\"#{$name}\"][data-theme-version=\"dark\"],\n    [data-nav-headerbg=\"#{$name}\"] {\n        @if $name != \"color_1\"  {\n            .nav-header {\n                background-color: $color;\n\n                .brand-logo {\n                    color: $white;\n\n                    &:hover {\n                        color: $white;\n                    }\n                }\n\t\t\t\t.hamburger .line{\n\t\t\t\t\tbackground:#fff;\n\t\t\t\t}\n\t\t\t\t\n            }\n\t\t\t&[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.menu-toggle .nav-header .nav-control .hamburger .line{\n\t\t\t\t\tbackground:#fff ;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n        }\n\t\t\n\t}\n}\n\n\n\n//background for header \n@each $name, $color in $theme_backgrounds {\n    [data-headerbg=\"#{$name}\"][data-theme-version=\"dark\"],\n    [data-headerbg=\"#{$name}\"] {\n\n        @if $name != \"color_1\"  {\n            .header {\n                background-color: $color;\n                color: $white;\n            }\n\t\t\t.header-left {\n                input {\n                    border-color: lighten($color: $color, $amount: 10%);\n                    background-color: lighten($color: $color, $amount: 10%) !important;\n                    color: $white;\n                    // border-right-color: transparent;\n\n                    &::placeholder {\n                        color: $white;\n                    }\n\n                    &:focus {\n                        border-color: darken($color: $color, $amount: 10%);\n                    }\n                }\n\t\t\t\t.search_icon{\n\t\t\t\t    background-color: lighten($color: $color, $amount: 10%)  !important;\n\t\t\t\t\ti{\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t}\n\t\t\t\t}\n\n                .btn {\n                    background-color: darken($color: $color, $amount: 10%);\n                    border-color: darken($color: $color, $amount: 10%);\n\n                    &:hover, \n                    &:focus, \n                    &:active {\n                        background-color: darken($color: $color, $amount: 20%);\n                        border-color: darken($color: $color, $amount: 20%);\n                    }\n                }\n            }\n\n            .header-right {\n                .dropdown {\n                    &>a {\n                        color: $white;\n                    }\n                }\n\t\t\t\t.pulse-css{\n\t\t\t\t\tbackground-color:$white;\n\t\t\t\t\t&:after,\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tbackground-color:inherit;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.notification_dropdown .nav-link{\n\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 10%) !important;\n\t\t\t\t}\n\t\t\t\t.right-sidebar a{\n\t\t\t\t\tborder-color:rgba(255,255,255,0.1);\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\n\t\t\t\t.header-profile > a.nav-link .header-info {\n\t\t\t\t\tstrong{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t\tspan,\n\t\t\t\t\tsmall{\n\t\t\t\t\t\tcolor:rgba(255,255,255,0.7);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n            .nav-control {\n                background-color: lighten($color: $color, $amount: 10%);\n                color: $white;\n            }\n\t\t\t\n        }\n    }\n}\n\n//styles for sidebar\n@each $name, $color in $theme_backgrounds {\n//:not([data-sidebar-style=\"modern\"])\n    [data-sibebarbg=\"#{$name}\"][data-theme-version=\"dark\"],\n    [data-sibebarbg=\"#{$name}\"] {\n        @if $name != \"color_1\" {\n\t\t\t\n\t\t\t.deznav {\n                background-color: $color;\n\t\t\t\t.menu-tabs li a.active{\n\t\t\t\t\tcolor: $color;\n\t\t\t\t}\n                .metismenu {\n\t\t\t\t\t.nav-label{\n\t\t\t\t\t\tcolor:rgba(255,255,255,0.7);\n\t\t\t\t\t\tborder-color:rgba(255,255,255,0.2);\n\t\t\t\t\t}\n                    &>li {\n                        &>a {\n                            color:  rgba(255,255,255,0.7); //darken($color: $white, $amount: 0%);\n\t\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\t\tcolor:rgba(255,255,255,0.7);\n\t\t\t\t\t\t\t}\t\t\n\t\t\t\t\t\t\tg [fill] {\n\t\t\t\t\t\t\t\tfill: rgba(255,255,255,0.7);\n\t\t\t\t\t\t\t}\t\t\n                        }\n\n                        &:hover, \n                        &:focus, \n                        &.mm-active {\n            \n                            &>a {\n                                color: $white;\n\t\t\t\t\t\t\t\tg [fill] {\n\t\t\t\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t}\t\n                                // &::after {\n                                //     border-color: transparent transparent $white transparent;\n                                // }\n                            }\n                        }\n\t\t\t\t\t\t@at-root [data-layout=\"horizontal\"]#{&} {\n                            // &:not(:last-child) {\n                                border-color: lighten($color: $color, $amount: 10%);\n                            // }\n                        }\n                    }\n\n                    a {\n                        color: rgba(255,255,255,0.7);\n\n                        &:hover, \n                        &:focus, \n                        &.mm-active {\n                            color: $white;\n                        }\n                    }\n\n                    ul {\n                        border-color: rgba(255,255,255,0.2);\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground-color: rgba(255,255,255,0.2);\n\t\t\t\t\t\t}\n                    }\n\n                    // .has-arrow {\n                    //     &:after {\n                    //         border-color: transparent transparent darken($color: $white, $amount: 30%) transparent;\n                    //     }\n                    // }\n                }\n            }\n\t\t\t&[data-sidebar-style=\"mini\"][data-layout=\"vertical\"]{\n\t\t\t\t.deznav .metismenu li > ul{\n\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 10%);\n\t\t\t\t}\n\t\t\t\t.deznav .metismenu > li.mm-active > a,\n\t\t\t\t.deznav .metismenu > li:hover > a{\n\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 10%);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.menu-toggle .deznav .metismenu li > ul,\n\t\t\t\t.menu-toggle .deznav .metismenu > li.mm-active > a,\n\t\t\t\t.menu-toggle .deznav .metismenu > li:hover > a{\n\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 10%);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"]{\n\t\t\t\t.deznav .metismenu ul{\n\t\t\t\t\tborder-color: rgba(255,255,255,0.2);\n\t\t\t\t}\t\n\t\t\t}\n\t\t\t&[data-layout=\"horizontal\"]{\n\t\t\t\t.deznav .metismenu > li{\n\t\t\t\t\tborder-color: rgba(255,255,255,0.2);\n\t\t\t\t}\n\t\t\t}\n        } \n    }\n}\n\n[data-headerbg=\"transparent\"]{\n    .header{\n\t\tbox-shadow: none;\n        background: transparent;\n    }\n}\n[data-headerbg=\"color_1\"]{\n\t.nav-header .hamburger.is-active .line,\n\t.nav-header .hamburger .line{\n\t\tbackground:$primary !important;\n\t}\n}\n","@media (min-width: 992px) {\n    [data-container=\"boxed\"] {\n        #main-wrapper {\n            max-width: 1199px;\n            margin: 0 auto;\n\n            @at-root [direction=\"rtl\"]#{&} {\n                text-align: right;\n            }\n        }\n    }\n}\n\n    \n    \n@include custommq($min: 1350px) {\n    [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"boxed\"][data-header-position=\"fixed\"] {\n        .header {\n            width: 1199px;\n        }\n    }\n}\n\n@include custommq($min: 1200px, $max: 1349px) {\n    [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"boxed\"][data-header-position=\"fixed\"] {\n        .header {\n            width: 1199px;\n        }\n    }\n}\n\n\n[data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"boxed\"] {\n    .deznav {\n        max-width: 1199px;\n    }\n} //ok\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"] {\n    .header {\n        width: 1199px;\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"mini\"] {\n    .header {\n        width: 1199px;\n    }\n}\n\n\n[data-container=\"boxed\"] {\n    .metismenu.fixed {\n        left: auto;\n        max-width: 1199px;\n    }\n\n    .page-titles {\n        margin-bottom: 3rem;\n        padding: 15px 15px;\n    }\n\n    .content-body .container-fluid {\n        padding: 0.9375rem 0.9375rem 0 0.9375rem;\n    }\n}\n\n[data-container=\"boxed\"][data-layout=\"vertical\"] {\n    .page-titles {\n        margin-left: 0;\n        margin-right: 0;\n    }\n}\n\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"static\"][data-sidebar-style=\"overlay\"] {\n    .nav-header {\n        position: absolute;\n    }\n\n    .menu-toggle {\n        .deznav {\n            position: absolute;\n        }\n    }\n}\n\n[data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] {\n    .deznav.fixed {\n        left: auto;\n        max-width: 1199px;\n    }\n}","[data-container=\"wide-boxed\"] {\n    @media (min-width: 992px) {\n        #main-wrapper {\n            max-width: 1480px;\n            margin: 0 auto;\n        }\n    }\n}\n\n[data-container=\"wide-boxed\"][data-sidebar-style=\"full\"] {\n    @media (min-width: 992px) {\n        .header {\n            width: 100%;\n        }\n        .menu-toggle {\n            .header {\n                width: 100%;\n            }\n        }\n        @at-root [data-header-position=\"fixed\"]#{&} {\n            .header {\n                max-width: 1480px;\n            }\n            .menu-toggle {\n                .header {\n                    max-width: 1480px;\n                }\n            }\n        }\n    }\n}\n\n[data-container=\"wide-boxed\"][data-sidebar-style=\"mini\"] {\n    @media (min-width: 992px) {\n        .header {\n            width: 100%;\n        }\n        @at-root [data-header-position=\"fixed\"]#{&} {\n            .header {\n                max-width: 1480px;\n            }\n        }\n        @at-root [data-header-position=\"fixed\"][data-layout=\"horizontal\"]#{&} {\n            .header {\n                max-width: 1480px;\n            }\n        }\n    }\n}\n\n[data-container=\"wide-boxed\"][data-sidebar-style=\"compact\"] {\n    @media (min-width: 992px) {\n        .header {\n            width: 100%;\n        }\n        @at-root [data-header-position=\"fixed\"]#{&} {\n            .header {\n                max-width: 1480px;\n            }\n        }\n    }\n}\n\n[data-container=\"wide-boxed\"][data-sidebar-style=\"overlay\"] {\n    @media (min-width: 992px) {\n        .header {\n            width: 100%;\n        }\n        @at-root [data-header-position=\"fixed\"]#{&} {\n            .header {\n                max-width: 1480px;\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"] {\n    .header {\n        width: 100%;\n    }\n    @at-root [data-sidebar-style=\"full\"][data-header-position=\"fixed\"]#{&} {\n        .header {\n            max-width: 1480px;\n        }\n    }\n    @at-root [data-sidebar-style=\"mini\"]#{&} {\n        .header {\n            width: 100%;\n        }\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"] {\n    .deznav.fixed {\n        max-width: 1480px;\n        transition: none;\n    }\n    &[direction=\"rtl\"] {\n        .deznav.fixed {\n            right: 5%;\n        }\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"fixed\"] {\n    .deznav {\n        max-width: 1480px;\n        left: 5%;\n    }\n    &[direction=\"rtl\"] {\n        .deznav {\n            right: 5%;\n        }\n    }\n}","//Theme color for Primary Variable\n@each $name, $color in $theme_backgrounds {\n    [data-primary=\"#{$name}\"] {\n        @if $name != \"color_1\"  {\n\t\t\n\t\t\ta {\n\t\t\t\t&:hover,\n\t\t\t\t&:focus,\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t[data-class=\"bg-primary\"]:before{\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.email-left-box .intro-title{\n\t\t\t\tbackground: rgba($color, .1);\n\t\t\t\ti{\n\t\t\t\t\tcolor: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.widget-stat .media .media-body h4{\n\t\t\t    color: $color !important;\n\t\t\t}\n\t\t\t.email-right-box .right-box-border{\n\t\t\t\tborder-right: 2px solid rgba($color, .1);\n\t\t\t}\n\t\t\t.mail-list .list-group-item.active i{\n                color: $color;\n\t\t\t}\n\t\t\t.single-mail.active{\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.profile-info h4.text-primary {\n\t\t\t\tcolor: $color!important;\n\t\t\t}\n\t\t\t.profile-tab .nav-item .nav-link{\n\t\t\t\t&:hover,\n\t\t\t\t&.active{\n\t\t\t\t\tborder-bottom: .20px solid $color;\n\t\t\t\t\tcolor: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.amChartsInputField {\n\t\t\t\tborder: 0;\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.amcharts-period-input,\n\t\t\t.amcharts-period-input-selected {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.morris-hover {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.select2-container--default .select2-results__option--highlighted[aria-selected] {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.custom-select:focus{\n\t\t\t\tborder-color: $color;\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.daterangepicker {\n\t\t\t\ttd.active {\n\t\t\t\t\tbackground-color: $color;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tbutton.applyBtn {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\tborder-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.wizard {\n\t\t\t\t&>.steps li.current a { \n\t\t\t\t\tbackground-color: $color; \n\t\t\t\t}\n\t\t\t\t.skip-email a {\n\t\t\t\t\tcolor: $color;\n\t\t\t\t}\n\t\t\t\t&>.actions li:not(.disabled) a {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.step-form-horizontal {\n\t\t\t\t.wizard {\n\t\t\t\t\t.steps {\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t&.done {\n\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\t.number {\n\t\t\t\t\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.current a {\n\t\t\t\t\t\t\t\t.number {\n\t\t\t\t\t\t\t\t\tcolor: $color;\n\t\t\t\t\t\t\t\t\tborder-color: $color; \n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.disabled a {\n\t\t\t\t\t\t\t\t.number {\n\t\t\t\t\t\t\t\t\tcolor: $color;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:not(:last-child) {\n\t\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}        \n\t\t\t.is-invalid .input-group-prepend .input-group-text i {\n\t\t\t\tcolor: lighten($color, 15%);\n\t\t\t}\t\n\t\t\t.datamaps-hoverover {\n\t\t\t\tcolor: $color;\n\t\t\t\tborder: 1px solid rgba($color, .3);\n\t\t\t}\n\t\t\t.jqvmap-zoomin,\n\t\t\t.jqvmap-zoomout {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.table {\n\t\t\t\t.thead-primary th {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t\t&.primary-table-bg-hover {\n\t\t\t\t\tthead th {\n\t\t\t\t\t\tbackground-color: darken($color: $color, $amount: 5%);\n\t\t\t\t\t}\n\t\t\t\t\ttbody tr {\n\t\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 5%);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&:not(:last-child) {\n\t\t\t\t\t\t\ttd, th {\n\t\t\t\t\t\t\t\tborder-bottom: 1px solid darken($color: $color, $amount: 5%);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\ttable.dataTable tr.selected{\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.dataTables_wrapper .dataTables_paginate .paginate_button.current{\n\t\t\t\tcolor: $color !important;\n\t\t\t\tbackground: rgba($color, .1);\n\t\t\t}\n\t\t\t.dataTables_wrapper .dataTables_paginate .paginate_button:hover{\n\t\t\t\tcolor: $color !important;\n\t\t\t\tbackground: rgba($color, .1);\n\t\t\t}\n\t\t\t.clipboard-btn:hover {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.cd-h-timeline__dates {\n\t\t\t\t&::before {\n\t\t\t\t\tbackground: $color;\n\t\t\t\t}\n\t\t\t\t&::after {\n\t\t\t\t\tbackground: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.cd-h-timeline__line {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.cd-h-timeline__date:after {\n\t\t\t\tborder-color: lighten($color, 0.9);\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.cd-h-timeline__navigation {\n\t\t\t\tborder-color: lighten($color, 0.9);\n\t\t\t}\n\t\t\t.cd-h-timeline__navigation--inactive:hover {\n\t\t\t\tborder-color: lighten($color, 0.9);\n\t\t\t}\n\t\t\t.dd-handle {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.dd-handle:hover {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.dd3-content:hover {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.noUi-connect {\n\t\t\t\tbackground-color: $color;\n\t\t\t\t&.c-3-color {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.noUi-horizontal .noUi-handle, .noUi-vertical .noUi-handle {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t#slider-toggle.off .noUi-handle {\n\t\t\t\tborder-color: $color;\n\t\t\t}\n\t\t\t.pignose-calendar {\n\t\t\t\tborder-color: $color;\n\t\t\t\t\n\t\t\t\t.pignose-calendar-top-date {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.bootstrap-tagsinput .tag {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.toast {\n\t\t\t\t&-success {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.twitter-typeahead .tt-menu .tt-suggestion:hover {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.accordion {\n\t\t\t\t&-header-bg {\n\t\t\t\t\t.accordion__header {\n\t\t\t\t\t\t&--primary {\n\t\t\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.alert-primary{\n\t\t\t\tbackground: lighten($color, 25%);\n\t\t\t\tborder-color: lighten($color, 25%);\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.alert-alt.alert-primary{\n\t\t\t\tborder-left: 4px solid $color;\n\t\t\t}\n\t\t\t.alert-alt.alert-primary.solid{\n\t\t\t\tborder-left: 4px solid darken($color,25%)!important;\n\t\t\t}\n\t\t\t.alert.alert-primary.solid{\n\t\t\t\tbackground: $color;\n\t\t\t\tborder-color: $color;\n\t\t\t}\n\t\t\t.alert.alert-outline-primary{\n\t\t\t\tcolor: $color;\n\t\t\t\tborder-color: $color;\n\t\t\t}\n\t\t\t.badge-outline-primary{\n\t\t\t\tborder: 1px solid $color;\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.badge-primary {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.page-titles h4 {\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.card-action{\n\t\t\t\t&>a{\n\t\t\t\t\tbackground: darken($color,57%);\n\t\t\t\t}\n\t\t\t\t//&:hover,&:focus{\n\t\t\t\t//\tbackground: darken($color,57%);\n\t\t\t\t//}\n\t\t\t\t.dropdown{\n\t\t\t\t\tbackground: darken($color,57%);\n\t\t\t\t\tcolor: $color;\n\t\t\t\t\t&:hover,&:focus{\n\t\t\t\t\t\tbackground: darken($color,57%);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.card-loader i {\n\t\t\t\tbackground: darken($color,7%);\n\t\t\t}\n\t\t\t\n\t\t\t.dropdown-outline{\n\t\t\t\tborder: .1rem solid $color;\n\t\t\t}\n\t\t\t.custom-dropdown .dropdown-menu .dropdown-item:hover{\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.card-action .custom-dropdown{\n\t\t\t\tbackground: lighten($color, 30%);\n\t\t\t\t &.show,&:focus,&:hover{\n\t\t\t\t\tbackground: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.label-primary{\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.pagination {\n\t\t\t\t.page-item {\n\t\t\t\t\t.page-link {\n\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t\t\tborder-color: $color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.active .page-link {\n\t\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t\tborder-color: $color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.bootstrap-popover-wrapper .bootstrap-popover{\n\t\t\t\tbutton:hover,\n\t\t\t\tbutton:focus{\n\t\t\t\t\tbackground: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.progress-bar {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.progress-bar-primary {\n\t\t\t\t background-color: $color;\n\t\t\t}\n\t\t\t.ribbon {\n\t\t\t\t&__four {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t&:after, &:before {\n\t\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 20%);\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t&__five {\n\t\t\t\t\tbackground-color: $color;\n\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tborder-color: transparent transparent $color transparent;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&__six {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.multi-steps{\n\t\t\t\t& > li {\n\t\t\t\t\tcolor: $color;\t\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t}\n\t\t\t\t\t&.is-active:before {\n\t\t\t\t\t\t\tborder-color: $color;\n\t\t\t\t\t}\n\t\t\t\t}\t\t\t\n\t\t\t}\t\t\t\n\t\t\t.timeline-badge.primary {\n\t\t\t\tbackground-color: $color !important;\n\t\t\t}\n\t\t\t.tooltip{\n\t\t\t\t&-wrapper{\n\t\t\t\t\tbutton:hover{\n\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.chart_widget_tab_one {\n\t\t\t\t.nav-link {\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tbackground-color: $color;\n\t\t\t\t\t\tborder: 1px solid $color;\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tborder: 1px solid $color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.social-icon2{\n\t\t\t\ta{\n\t\t\t\t\tborder: .1rem solid $color;\n\t\t\t\t}\n\t\t\t\ti{\n\t\t\t\t\tcolor: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.social-icon3 ul li a:hover i{\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.bgl-primary{\n\t\t\t\tbackground: lighten($color, 30%);\n\t\t\t\tborder-color: lighten($color, 30%);\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.tdl-holder input[type=checkbox]:checked  + i {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.footer .copyright a{\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.hamburger .line {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\tsvg.pulse-svg .first-circle {\n\t\t\t\tfill: $color;\n\t\t\t}\n\t\t\t.pulse-css {\n\t\t\t\tbackground: $color;\n\t\t\t\t&:after,\n\t\t\t\t&:before {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.notification_dropdown .dropdown-menu-right .notification_title {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.header-right {\n\t\t\t\t.header-profile {\n\t\t\t\t\t.dropdown-menu {\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t&:focus,\n\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\tcolor: $color;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.profile_title {\n\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-sidebar-style=\"full\"][data-layout=\"vertical\"] {\n\t\t\t\t.menu-toggle .nav-header .nav-control .hamburger .line {\n\t\t\t\t\tbackground-color: $color!important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.deznav .metismenu{\n\t\t\t\t& > li{\n\t\t\t\t\t& > a svg {\n\t\t\t\t\t\tcolor: $color;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\tcolor: $color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.mm-active {\n\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\tcolor: $color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tul a {\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus,\n\t\t\t\t\t&.mm-active {\n\t\t\t\t\t\tcolor: $color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t@media (min-width:767px) {\n\t\t\t\t[data-sidebar-style=\"modern\"] {\n\t\t\t\t\t.deznav {\n\t\t\t\t\t\t.metismenu {\n\t\t\t\t\t\t\t&>li {\n\t\t\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\t\t\t&:hover, \n\t\t\t\t\t\t\t\t\t&:focus, \n\t\t\t\t\t\t\t\t\t&:active, \n\t\t\t\t\t\t\t\t\t&.mm-active {\n\t\t\t\t\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 50%);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-sidebar-style=\"overlay\"] {\n\t\t\t\t.nav-header .hamburger.is-active .line {\n\t\t\t\t\tbackground-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.nav-user {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.sidebar-right .sidebar-right  .sidebar-right-trigger {\n\t\t\t\tcolor: $color;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: $color;\n\t\t\t\t}\n\t\t\t}\t\n\t\t\t&[data-theme-version=\"dark\"] {\n\t\t\t\t.pagination .page-item{\n\t\t\t\t\t.page-link:hover{\n\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t\tborder-color: $color;\n\t\t\t\t\t}\n\t\t\t\t\t&.active .page-link{\n\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t\tborder-color: $color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.header-left input:focus {\n\t\t\t\t\tborder-color: $color;\n\t\t\t\t}\n\t\t\t\t.loader {\n\t\t\t\t\t&__bar {\n\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t}\n\t\t\t\t\t&__ball {\n\t\t\t\t\t\tbackground: $color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-theme-version=\"transparent\"] {\n\t\t\t\t.header-left input:focus {\n\t\t\t\t\tborder-color: $color;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.new-arrival-content .price {\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t.chart-link a i.text-primary {\n\t\t\t\tcolor: $color;\n\t\t\t}\n\t\t\t#user-activity .nav-tabs .nav-link.active {\n\t\t\t\tbackground: $color;\n\t\t\t\tborder-color: $color;\n\t\t\t}\n\t\t\tspan#counter {\n\t\t\t\tcolor: $color;\n\t\t\t}\n\n\t\t\t.welcome-content:after{\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.timeline-badge {\n                background-color: $color;\n\t\t\t}\t\n\t\t\t.page-timeline{\n\t\t\t\t.timeline {\n\t\t\t\t\t&-workplan#{&} {\n\t\t\t\t\t\t.timeline-badge:after {\n\t\t\t\t\t\t\tbackground-color: rgba($color: $color, $alpha: .4);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.sk-three-bounce .sk-child {\n\t\t\t\tbackground-color: $color;\n\t\t\t}\n\t\t\t.dropdown-item.active, \n\t\t\t.dropdown-item:active{\n\t\t\t\tcolor: #fff;\n\t\t\t\tbackground-color:$color;\n\t\t\t}\n\t\t\t.overlay-box:after {\n\t\t\t\tbackground: $color;\n\t\t\t}\n\t\t\t.btn-primary{\n\t\t\t    background-color: $color;\n\t\t\t\tborder-color: $color;\n\t\t\t}\n\t\t\t.bg-primary{\n\t\t\t\tbackground-color: $color !important;\n\t\t\t}\n\t\t\t.text-primary{\n\t\t\t\tcolor:$color  !important;\n\t\t\t}\n\t\t\t.btn-primary:hover {\n\t\t\t\tbackground-color:darken($color, 15);\n\t\t\t\tborder-color: darken($color, 15);\n\t\t\t}\n\t\t\t.btn-outline-primary {\n\t\t\t\tcolor:$color;\n\t\t\t\tborder-color: $color;\n\t\t\t}\n\t\t\t.btn-outline-primary:hover {\n\t\t\t\tbackground-color: $color;\n\t\t\t\tborder-color: $color;\n\t\t\t}\n\t\t\t.btn-primary:not(:disabled):not(.disabled):active, \n\t\t\t.btn-primary:not(:disabled):not(.disabled).active, \n\t\t\t.show > .btn-primary.dropdown-toggle,\n\t\t\t.btn-outline-primary:not(:disabled):not(.disabled):active, \n\t\t\t.btn-outline-primary:not(:disabled):not(.disabled).active, \n\t\t\t.show > .btn-outline-primary.dropdown-toggle{\n\t\t\t\tbackground-color:darken($color, 15);\n\t\t\t\tborder-color: darken($color, 15);\n\t\t\t}\n\t\t// End Css\t\n        }\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .bg-#{$color}-alt {\n        background-color: rgba($value, .1);\n    }\n}\n","[data-typography=\"opensans\"] {\n    font-family: 'Open Sans', sans-serif;\n  }\n  \n\n\n  \n","[data-typography=\"poppins\"] {\n    font-family: 'poppins', sans-serif;\n  }\n\n\n  \n","[data-typography=\"helvetica\"] {\n    font-family: 'HelveticaNeue';\n  }\n\n\n  \n\n  ","@import \"./../../abstracts/variable\";\n\n\n\n[data-theme-version=\"transparent\"] {\n\n    \n    background: url('../images/body/12.jpg');\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    // background: $d-bg;s\n    color: $white;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        color: $white !important;\n    }\n    a.link {\n        color: $d-ctd;\n    }\n    a.link:focus,\n    a.link:hover {\n        color: $info;\n    }\n\n    a {\n        color: $white;\n\n        &:hover {\n            color: $d-ctl;\n        }\n    }\n\n    \n    //Generating border classess\n    @each $value in $borders {\n        @if $value == \"\" {\n            .border {\n                border: 1px solid $d-border !important;\n            }\n        } @else {\n            .border-#{$value} {\n                border-#{$value}: 1px solid $d-border !important;\n            }\n        }\n    }\n\n\n}","\n[data-theme-version=\"transparent\"] {\n    .dropdown-menu {\n        background-color: $dark-card;\n    }\n\n    .dropdown-item {\n        &:hover, &:focus {\n            background-color: $d-bg;\n            color: $white;\n        }\n    }\n\n    .form-control {\n        background-color: $d-bg;\n        border-color: $d-border;\n        color: $white;\n    }\n    \n    .card {\n        background-color: rgba(0,0,0,0.15);\n    }\n\n}","[data-theme-version=\"transparent\"] {\n    \n    .header {\n        background-color: rgba(0,0,0,0.15);\n    }\n    \n\n    .header-left {\n        input {\n            border-color: $d-border;\n            color: $white;\n\n            &:focus {\n                box-shadow: none;\n                border-color: $primary;\n            }\n\n            &::placeholder {\n                color: $white;\n            }\n        }\n    }\n\n\n    .header-right {\n        .dropdown {\n            .nav-link {\n                &:hover {\n                    color: $white;\n                }\n            }\n        }\n\n        .notification_dropdown {\n            .dropdown-item {\n                a {\n                    color: $white;\n                }\n            }\n        }\n    }\n\n}","[data-theme-version=\"transparent\"] {\n    .nav-header, \n    .nav-control {\n        background-color: rgba(0,0,0,0.15)!important;\n    }\n\n    .nav-control {\n        color: $white;\n    }\n\n    .brand-logo {\n        color: $white;\n\n        &:hover {\n            color: $white;\n        }\n    }\n}","[data-theme-version=\"transparent\"] {\n    \n    .deznav {\n        background-color: rgba(0,0,0,0.15)!important;\n    \n        .metismenu {\n    \n    \n            &>li {\n    \n                &>a {\n                    color: rgba(0,0,0,0.15);\n                }\n    \n                &:hover, \n                &:focus, \n                &.mm-active {\n    \n                    &>a {\n                        background-color: rgba(0,0,0,0.15)!important;\n                        color: $white;\n    \n                        &::after {\n                            border-color: transparent transparent $white transparent;\n                        }\n                    }\n                }\n    \n                &.mm-active {\n                    ul {\n    \n                        ul {\n                            background-color: transparent;\n                        }\n                    }\n                }\n            }\n    \n            //one step dropdown\n            ul  {\n                background-color: rgba(0,0,0,0.15);\n    \n                a {\n    \n                    &:hover,\n                    &:focus, \n                    &.mm-active {\n                        color: $white;\n                    } \n                }\n            }\n            \n            a {\n                color: rgba(0,0,0,0.15);\n            }\n            ul {\n                background-color: rgba(0,0,0,0.15)!important;\n            }\n    \n            .has-arrow {\n                &:after {\n                    border-color: transparent transparent rgba(0,0,0,0.15) transparent;\n                }\n            }\n        }\n    }\n    \n    \n\n}","@import \"./../../abstracts/variable\";\n\n\n\n[data-theme-version=\"dark\"] {\n    background: $d-bg;\n    color: $d-ctl;\n\t\n\t\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        color: $white !important;\n    }\n    a.link {\n        color: $d-ctd;\n    }\n    a.link:focus,\n    a.link:hover {\n        color: $info;\n    }\n\n    a {\n        &:hover {\n            color: $white;\n        }\n    }\n\t\n    //Generating border classess\n    @each $value in $borders {\n        @if $value == \"\" {\n            .border {\n                border: 1px solid $d-border !important;\n            }\n        } @else {\n            .border-#{$value} {\n                border-#{$value}: 1px solid $d-border !important;\n            }\n        }\n    }\n\n\n}","\n[data-theme-version=\"dark\"] {\n    .dropdown-menu {\n        background-color: $d-bg;\n\t\tbox-shadow: 0px 0px 0px 1px rgba(255, 255, 255,0.1);\n\t\t\n\t\t.dropdown-item {\n\t\t\t&.selected,\n\t\t\t&.selected.active,\n\t\t\t&.active,\n\t\t\t&:hover, \n\t\t\t&:focus {\n\t\t\t\tbackground-color: $dark-card;\n\t\t\t\tcolor: $body-color;\n\t\t\t}\n\t\t}\n    }\n\n    .form-control {\n        background-color: $d-bg;\n        border-color: $d-border;\n        color: $white;\n    }\n    \n    .card {\n        background-color: $dark-card;\n\t\tbox-shadow:none;\n    }\n\t.btn-outline-dark:hover{\n\t\tbackground-color: $d-bg;\n\t\tborder-color: $d-bg;\n\t}\n\t.tdl-holder input[type=text],\n\t.tdl-holder li{\n\t    background-color: $dark-card;\n\t\tborder-color:$d-border;\n\t}\n\t.tdl-holder input[type=text]{\n\t\t&::placeholder {\n\t\t\tcolor: $d-ctl;\n\t\t}\n\t}\n    .tdl-holder label:hover {\n\t\tbackground-color: $d-border;\n\t\tcolor: $white;\n\t}\n\t.text-muted {\n\t\tcolor: $d-ctl !important;\n\t}\n\t.modal-content{\n\t\tbackground:$dark-card;\n\t}\n\t.modal-footer,\n\t.modal-header{\n\t\tborder-color: $d-border;\n\t}\n\t.close{\n\t    font-weight: 400;\n\t\tcolor: $white;\n\t\ttext-shadow: none;\n\t\t\n\t\t&:hover{\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.table strong {\n\t\tcolor: #fff;\n\t}\n\t.text-dark {\n\t\tcolor: $d-ctl !important;\n\t}\n\t.star-rating .product-review,\n\t.new-arrival-content .item{\n\t\tcolor: $white;\n\t}\n\t.custom-dropdown .dropdown-menu{\n\t\tborder-color: $d-border;\n\t}\n\t.widget-stat .media > span{\n\t    background: $d-border;\n\t    border-color: $d-border;\n\t\tcolor:$white;\n\t}\n\t.plus-minus-input .custom-btn{\n\t\tbackground: $d-bg;\n\t    border-color: $d-border;\n\t}\n\t.dropdown-divider,\n\t.size-filter ul li{\n\t\tborder-color: $d-border;\n\t}\n\t.custom-select{\n\t    border-color: $d-border;\n\t\tcolor: $d-ctl;\n\t\tbackground:$d-bg;\n\t}\n\t.nav-tabs{\n\t\tborder-color: $d-border;\n\t}\n\t.mail-list .list-group-item.active i {\n\t\tcolor: $white;\n\t}\n\thr{\n\t\tborder-color: $d-border;\n\t}\n\t\n\t.grid-col{\n\t\tbackground:$d-bg;\n\t}\n\t\n\t.noUi-target{\n\t\tborder-color:$d-border;\n\t\tborder-radius: 8px;\n\t\tbox-shadow: none;\n\t\t\n\t\t.noUi-connects{\n\t\t\tbackground:$d-border;\n\t\t}\n\t}\n\t.noUi-marker-large,\n\t.noUi-marker{\n\t\tbackground:$d-border;\n\t}\n\t.input-group-text{\n\t\tbackground:$d-border;\n\t\tcolor:$body-color;\n\t}\n\t.note-editor.note-frame{\n\t\tborder-color:$d-border;\n\t\t.btn{\n\t\t\tcolor:$white;\n\t\t}\n\t\t.note-editing-area .note-editable{\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.widget-media .timeline .timeline-panel{\n\t\tborder-color:$d-border; \n\t}\n\t.notification_dropdown .dropdown-menu-right .all-notification{\n\t\tborder-color:$d-border; \n\t}\n\t#user-activity .nav-tabs .nav-link{\n\t\tborder-color:$d-border; \n\t}\n\t.list-group-item-action{\n\t\tcolor:$body-color;\n\t}\n\t.list-group-item-action:focus, \n\t.list-group-item-action:hover, \n\t.list-group-item-action:focus{\n\t\tbackground-color:$d-bg; \n\t\tborder-color:$d-bg; \n\t}\n\t.list-group-item.active{\n\t\tcolor:$white;\n\t\tborder-color:$primary;\n\t\t&:focus, \n\t\t&:hover, \n\t\t&:focus{\n\t\t\tbackground-color:$primary; \n\t\t\tborder-color:$primary; \n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.swal2-popup{\n\t\tbackground:$dark-card;\n\t}\n\t\n\t\n}","[data-theme-version=\"dark\"] {\n    \n    .header {\n        background-color: $dark-card;\n    }\n\n    .header-left {\n        input {\n            background: $d-bg !important;\n            border-color: transparent ;\n            color: $white !important;\n\n            &:focus {\n                box-shadow: none;\n                border-color: $primary;\n            }\n\n            &::placeholder {\n                color: $white;\n            }\n        }\n\t\t.search_icon{\n\t\t    background: $d-bg !important;\n\t\t\t\n\t\t\ti{\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n    }\n\n    .header-right {\n\t\t.right-sidebar a{\n\t\t\tcolor:$primary;\n\t\t\tborder-color:$d-border;\n\t\t}\n\t\t.header-profile > a.nav-link .header-info strong{\n\t\t\tcolor:$white;\n\t\t}\n\t\t.notification_dropdown .nav-link{\n\t\t\tbackground: $d-bg;\n\t\t}\n        .dropdown {\n            .nav-link {\n\t\t\t\tcolor: $white;\n                &:hover {\n                    color: $white;\n                }\n            }\n        }\n\t\t.nav-link {\n\t\t\n\t\t}\t\n        .notification_dropdown {\n            .dropdown-item {\n                a {\n                    color: $white;\n                }\n            }\n        }\n    }\n\n}","[data-theme-version=\"dark\"] {\n    .nav-header, \n    .nav-control {\n        background-color:$d-bg;\n    }\n\n    .nav-control {\n        color: $white;\n    }\n\n    .brand-logo {\n        color: $white;\n\n        &:hover {\n            color: $white;\n        }\n    }\n}","[data-theme-version=\"dark\"] {\n\n    &[data-sidebar-style=\"mini\"] {\n\t\t.deznav .metismenu li > ul{\n\t\t\tbackground-color: $dark-card;\n\t\t}\n\t}\n\t\n\t.fixed-content-box{\n\t\tbackground-color: $dark-card;\n\t\t.head-name{\n\t\t\tbackground:$dark-card;\n\t\t\tcolor: $white;\n\t\t\tborder-color:$d-border; \n\t\t}\n\t\t& + .header + .deznav{\n\t\t\tbackground-color: $d-bg;\n\t\t}\n\t}\n\t\n    .deznav {\n        background-color: $dark-card;\n\t\t\n        .metismenu {\n    \n    \n            &>li {\n\t\t\n                &>a {\n                    color: darken($color: $white, $amount: 30%);\n                }\n    \n                &:hover, \n                &:focus, \n                &.mm-active {\n    \n                    &>a {\n                        color: $white;\n    \n                        &::after {\n                            border-color: $white;\n                        }\n                    }\n                }\n    \n                &.mm-active {\n\t\t\t\t\t\n                    ul {\n\t\t\t\t\t\t\n                        ul {\n                            background-color: transparent;\n                        }\n                    }\n                }\n            }\n    \n            //one step dropdown\n            ul  {\n                \n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color:$d-border;\n\t\t\t\t}\n\t\t\t\t\n                a {\n    \n                    &:hover,\n                    &:focus, \n                    &.mm-active {\n                        color: $white;\n                    } \n\t\t\t\t\t&:before{\n\t\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\t}\n\t\t\t\t\t\n                }\n            }\n            \n            a {\n                color: darken($color: $white, $amount: 30%);\n            }\n    \n            .has-arrow {\n                &:after {\n                    border-color: $white;\n                }\n            }\n        }\n    }\n    \n    \n\n}","[data-theme-version=\"dark\"] {\n    .sidebar-right {\n        background-color: lighten($d-bg, 3.2%);\n\n        .nav-tabs {\n            background-color: lighten($d-bg, 3.2%);\n            border-bottom: 1px solid $d-bg;\n\n            .nav-link {\n                &.active {\n                    background-color: $d-bg;\n                }\n            }\n        }\n    }\n}","[data-theme-version=\"dark\"] {\n    .footer {\n        background-color: transparent;\n\n        .copyright {\n            background-color: transparent;\n\n            p {\n                color: $white;\n            }\n        }\n    }\n}","/* =============\n   Calendar\n============= */\n\n.app-fullcalender {\n    button {\n        border-radius: 0px;\n        color: $dark;\n    }\n    td{\n        border-color: $border;\n    }\n}\n\n.calendar {\n    float        : left;\n    margin-bottom: 0;\n}\n\n.fc-view {\n    margin-top: 1.875rem;\n}\n\n.fc-toolbar {\n    margin-bottom: 0.3125rem;\n    margin-top   : 0.9375rem;\n\n    & .fc-left {\n        @include media-breakpoint-down(xs) {\n            display: flex;\n            justify-content: space-between;\n            margin-bottom: 0.625rem;\n            float: none;\n        }\n    }\n\n    & .fc-right {\n        @include media-breakpoint-down(xs) {\n            display: flex;\n            justify-content: center;\n            float: none;\n            margin-bottom: 0.3125rem;\n        }\n    }\n\n    & .fc-center {\n        @include media-breakpoint-down(xs) {\n            display: flex;\n            justify-content: center;\n            * {\n                float: none;\n            }\n        }\n    }\n}\n\n.fc-toolbar h2 {\n    font-size     : 1rem;\n    font-weight   : 600;\n    line-height   : 1.875rem;\n    text-transform: uppercase;\n}\n\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar .ui-state-hover,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover {\n    z-index: 0;\n    box-shadow: none;\n}\n\n.fc-widget-header {\n    border: 1px solid $border;\n    border-bottom: 0 !important;\n}\n\n\n\n// .fc-widget-content {\n//     border: 1px solid #E5E5E5 !important;\n// }\n\n.fc th.fc-widget-header {\n    background    : $border!important;\n    font-size     : 0.875rem;\n    line-height   : 1.25rem;\n    padding       : 0.625rem 0;\n    text-transform: uppercase;\n}\n\n.fc-button {\n    border        : 1px solid $border;\n    text-transform: capitalize;\n    &.active{\n        box-shadow: none!important;\n    }\n}\n\n.fc-text-arrow {\n    font-family: inherit;\n    font-size  : 1rem;\n}\n\n\n\n.fc-event {\n    border-radius: 0.125rem;\n    border       : none;\n    cursor       : move;\n    font-size    : 0.8125rem;\n    margin       : 0.3125rem 0.4375rem;\n    padding      : 0.3125rem;\n    text-align   : center;\n}\n\n.external-event {\n    cursor : move;\n    margin : 0.625rem 0;\n    padding: 0.125rem 0;\n}\n\n.fc-basic-view td.fc-week-number span {\n    padding-right: 0.3125rem;\n}\n\n.fc-basic-view td.fc-day-number {\n    padding-right: 0.3125rem;\n}\n\n#drop-remove {\n    margin-right: 8px;\n    top   : 0.1875rem;\n}\n\n#add-category,\n#event-modal {\n\n    .modal-dialog {\n        max-width: 37.5rem;\n    }\n}\n\n.fc-content {\n    color: $white;\n}\n// .fc-widget-content {\n//     border: 1px solid $l-border!important;\n// }\n.fc th.fc-widget-header {\n    // background: $l-border!important;\n    background: transparent !important;\n}\n.fc-button {\n    background: $white;\n    // color: $l-ctl;\n}\n.fc-state-hover {\n    background: $white!important;\n}\n.fc-state-highlight {\n    background: $l-bg!important;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white!important;\n    }\n}\n.fc-cell-overlay {\n    background: $white!important;\n}\n.fc-unthemed .fc-today {\n    background: $l-bg!important;\n}\n\n.fc-day-top{\n    color: $dark !important;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white!important;\n    }\n}\n\n.external-event {\n    color: $white;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white!important;\n    }\n}\n.fc-basic-view .fc-body .fc-row {\n    min-height: 1rem;\n}\n\n.fc-scroller.fc-day-grid-container {\n    height: 490px !important;\n}\n\n.fc-row.fc-week.fc-widget-content.fc-rigid {\n    height: 81px !important;\n}\n\n.email_left_pane {\n    @include custommq($max: 1440px) {\n        display: none;\n    }\n}\n\n\n\n#external-events{\n    \n\t.external-event:before{\n\t\tcontent: \"\";\n\t\tdisplay: inline-block;\n\t\twidth: 14px;\n\t\theight: 14px;\n\t\tborder-radius: 50%;\n\t\tmargin-right: .9rem;\n\t\tposition: relative;\n\t\ttop: 2px;\n\t}\n    [data-class=\"bg-primary\"]{\n        background-color: transparent !important;\n        color: $dark;\n        @at-root [data-theme-version=\"dark\"] & {\n            color: $white!important;\n        }\n        &::before{\n            background: $primary;\n        }\n    }\n    [data-class=\"bg-success\"]{\n        background-color: transparent !important;\n        color: $dark;\n\n        &::before{\n            background: $success;\n        }\n    }\n    [data-class=\"bg-warning\"]{\n        background-color: transparent !important;\n        color: $dark;\n\n        &::before{\n            background: $warning;\n        }\n    }\n    [data-class=\"bg-dark\"]{\n        background-color: transparent !important;\n        color: $dark;\n\n        &::before{\n            background: $dark;\n        }\n    }\n    [data-class=\"bg-danger\"]{\n        background-color: transparent !important;\n        color: $dark;\n\n        &::before{\n            background: $danger;\n        }\n    }\n    [data-class=\"bg-info\"]{\n        background-color: transparent !important;\n        color: $dark;\n\n        &::before{\n            background: $info;\n        }\n    }\n    [data-class=\"bg-pink\"]{\n        background-color: transparent !important;\n        color: $dark;\n\n        &::before{\n            background: $pink;\n        }\n    }\n}\n\n\n.fc .fc-row .fc-content-skeleton table, \n.fc .fc-row .fc-content-skeleton td, \n.fc .fc-row .fc-helper-skeleton td {\n    border-color: $border;\n    \n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n}\n\n.fc-unthemed .fc-content, .fc-unthemed .fc-divider, .fc-unthemed .fc-list-heading td, .fc-unthemed .fc-list-view, .fc-unthemed .fc-popover, .fc-unthemed .fc-row, .fc-unthemed tbody, .fc-unthemed td, .fc-unthemed th, .fc-unthemed thead {\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n}",".email-left-box {\n    width: 15rem;\n    float: left;\n    padding: 0 1.25rem 1.25rem 1rem;\n    // border: 1px solid rgba(0, 0, 0, 0.125);\n    border-top: 0;\n    border-left: 0;\n\n    @include media-breakpoint-between(sm, md) {\n        width: 100%;\n\t\tpadding-bottom: 0px !important;\n    }\n\n    @include media-breakpoint-down(xs) {\n        width: 100%;\n        float: none;\n        border: none;\n\t\tpadding-bottom: 30px !important;\n    }\n\n    // &.generic-width{\n    //     @media screen and (min-width: 649px) and (max-width: 1700px){\n    //         width: 15rem;\n    //     }\n    // }\n\n    .intro-title{\n        background: rgba($primary, .1);\n        padding: 1rem;\n        margin: 1.875rem 0 1.25rem 0;\n\n        h5{\n            margin-bottom: 0;\n            color: #6a707e;\n            font-size: 14px;\n\n            i{\n                font-size: 0.75rem;\n                position: relative;\n                bottom: 1px;\n            }\n        }\n\n        i{\n            // font-size: 1.0625rem;\n            color: $primary;\n\n        }\n    }\n}\n\n.email-right-box {\n    // padding-top: 1.875rem;\n    padding-left: 15rem;\n    padding-right: 1rem;\n\n    @include media-breakpoint-between(sm, md) {\n        padding-left: 0;\n\t\tmargin-left: 0!important;\n\t\tclear:both;\n\t}\n\n    @include media-breakpoint-down(xs) {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    // &.generic-position{\n    //     padding-left: 15rem;\n\n    //     @media(min-width: 1700px){\n    //         padding-left: 18.75rem;\n    //     }\n    // }\n\n    .right-box-border{\n        border-right: 2px solid rgba($primary, .1);\n    }\n\n    .right-box-padding{\n\n        @media screen and (min-width: 649px) and (max-width: 1200px){\n            padding-left: 1.25rem;\n        }\n\n        @media(min-width: 1700px){\n            padding-left: 0.9375rem;\n        }\n\t\t@include media-breakpoint-between(sm, md) {\n\t\t\tpadding-left: 0;\t\t\t\n\t\t}\n    }\n}\n\n.toolbar {\n    .btn-group {\n        .btn {\n            // background: $dark;\n            border: 0;\n            // color: $white;\n            // i {\n            //     color: $white!important;\n            // }\n        }\n        input{\n            position: relative;\n            top: 2px;\n        }\n    }\n}\n\n.read-content {\n    textarea {\n        height:150px;\n\t\tpadding: 15px 20px;\n    }\n\n    &-email{\n        font-size: 0.875rem;\n    }\n\n    h5{\n        color: #6a707e;\n    }\n\n    p{\n\n        strong{\n            color: #6a707e;\n        }\n    }\n\n    &-body{\n\n        p{\n            margin-bottom: 1.875rem;\n        }\n    }\n\n    &-attachment{\n        padding: 0.5rem 0;\n\n        h6{\n            font-size: 1.125rem;\n            color: #6a707e;\n\n            i{\n                padding-right: 0.3125rem;\n            }\n        }\n\n        .attachment{\n\n            & > div:not(:last-child){\n                border-right: 1px solid #DDDFE1;\n            }\n        }\n    }\n}  \n\n.compose-content {\n    .wysihtml5-toolbar {\n        border-color: $l-border;\n    }\n    // .textarea_editor {\n    //     background: $l-bg!important;\n    // }\n    .dropzone {\n        background: $l-bg!important;\n    }\n\n    h5{\n        font-size: 1.0625rem;\n        color: #6a707e;\n\n        i{\n            font-size: 1.125rem;\n            transform: rotate(90deg);\n        }\n    }\n\n    .dropzone{\n        border: 1px dashed #DDDFE1;\n        min-height: 13.125rem;\n        position: relative;\n\n        .dz-message{\n            margin: 0;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n        }\n    }\n}\n\n.email-list {\n    display: block;\n    padding-left: 0;\n\n    .message {\n        position: relative;\n        display: block;\n        height: 3.125rem;\n        line-height: 3.125rem;\n        cursor: default;\n        transition-duration: 0.3s;\n        a {\n            color: $l-ctl;\n        }\n\n        &-single{\n            .custom-checkbox{\n                margin-top: 2px;\n            }\n\n            i{\n                color: $muted;\n                font-size: 1.125rem;\n                padding-left: .4rem;\n            }\n\n\n        }\n\n\n        &:hover {\n            transition-duration: 0.05s;\n            background: rgba(152, 166, 173, 0.15);\n        }\n\n        .col-mail {\n            float: left;\n            position: relative;\n        }\n\n        .col-mail-1 {\n            width: 5.625rem;\n\n            .star-toggle {\n                display: block;\n                float: left;\n                margin-top: 1.125rem;\n                font-size: 1rem;\n                margin-left: 0.3125rem;\n            }\n\n            .email-checkbox {\n                display: block;\n                float: left;\n                margin: 0.9375rem 0.625rem 0 1.25rem;\n            }\n\n            .dot {\n                display: block;\n                float: left;\n                border: .4rem solid transparent;\n                border-radius: 6.25rem;\n                margin: 1.375rem 1.625rem 0;\n                height: 0;\n                width: 0;\n                line-height: 0;\n                font-size: 0;\n            }\n        }\n\n        .col-mail-2 {\n            position: absolute;\n            top: 0;\n            left: 5.625rem;\n            right: 0;\n            bottom: 0;\n\n            .subject {\n                position: absolute;\n                top: 0;\n                left: 0;\n                right: 5.5rem;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n            }\n\n            .date {\n                position: absolute;\n                top: 0;\n                right: 0;\n                // width: 4rem;\n                // padding-left: 5rem;\n            }\n        }\n    }\n}\n\n.email-checkbox {\n    cursor: pointer;\n    height: 0.9375rem;\n    width: 0.9375rem;\n    position: relative;\n    display: inline-block;\n    border-radius: .1rem;\n    position: relative;\n    top: 0.3125rem;\n    box-shadow: inset 0 0 0 .1rem $l-ctl;\n\n    input {\n        opacity: 0;\n        cursor: pointer;\n\n        &:checked {\n            label {\n                opacity: 1;\n            }\n        }\n    }\n\n    label {\n        position: absolute;\n        top: .3rem;\n        left: .3rem;\n        right: .3rem;\n        bottom: .3rem;\n        cursor: pointer;\n        opacity: 0;\n        margin-bottom: 0 !important;\n        transition-duration: 0.05s;\n    }\n}\n\n.mail-list {\n\n    a {\n        vertical-align: middle;\n        padding: 0.625rem 0.9375rem;\n        display: block;\n        background: transparent;\n        color: $l-ctd;\n        // font-size: 1.0625rem;\n        font-weight: 600;\n    }\n\n    .list-group-item{\n        color: #6a707e;\n        padding: 0.75rem 1.0625rem;\n\n        i{\n            font-size: 1rem;\n            padding-right: 0.625rem;\n            color: #cccccc;\n        }\n\n        &.active{\n            color: $white;\n\n            i{\n                color: $white;\n            }\n        }\n    }\n}\n\n.chat-wrap{\n    padding: 1.0625rem 1.875rem;\n\n    .media{\n\n        .media-body{\n\n            h6{\n                font-size: 1.0625rem;\n                color: #6a707e;\n            }\n\n            p{\n                font-size: 0.875rem;\n            }\n        }\n    }\n}\n\n.email-filter{\n\n    @media (min-width: 648px){\n        padding-left: 1.25rem;\n    }\n\n    @media(min-width: 1700px){\n        padding-left: 1.875rem;\n    }\n\n    .input-group{\n\n        &-prepend{\n            \n            i{\n                font-size: 0.875rem;\n                color: $muted;\n            }\n\n            .input-group-text{\n                border: 0;\n                border-bottom: 1px solid #DDDFE1 !important;\n                background: transparent;\n            }\n        }\n\n        .form-control{\n            padding: 0 0 0 0.3125rem;\n            border: 0;\n            font-size: 0.875rem;\n            height: 1.875rem;\n            color: $muted;\n            border-bottom: 1px solid #DDDFE1;\n\n            &::placeholder{\n                font-size: 0.875rem;\n                color: $muted;\n            }\n        }\n\n        & > .form-control{\n            min-height: 1.875rem;\n        }\n    }\n}\n\n.single-mail{\n    display: block;\n    padding: 1.5625rem 0;\n\n    .media{\n        padding-left: 1.25rem;\n        padding-right: 1.25rem;\n\n        @media(min-width: 1700px){\n            padding-left: 1.875rem;\n            padding-right: 1.875rem;\n        }\n\n        img{\n            width: 55px;\n            height: 55px;\n            border-radius: 50%;\n            margin-right: 0.9375rem;\n\n            @media(min-width: 1700px){\n                margin-right: 1.875rem;\n            }\n        }\n\n        &-body{\n\n            h6{\n                color: #abafb3;\n            }\n\n            h4{\n                font-size: 1rem;\n                color: #6a707e;\n\n                button{\n\n                    i{\n                        font-size: 1.125rem;\n                        color: #abafb3;\n                        font-weight: bold;\n                        transform: rotate(90deg);\n                    }\n                }\n            }\n\n            p{\n                font-size: 0.875rem;\n                color: #abafb3;\n            }\n        }\n    }\n\n    &.active{\n        background: $primary;\n\n        h6,h4,p,i{\n            color: $white !important;\n        }\n    }\n}\n[direction=\"rtl\"]{\n\t.email-right-box {\n\t\tpadding-left: 1rem;\n\t\tpadding-right: 15rem;\n\t\t@include respond('tab-port') {\n\t\t\tpadding-left: 1rem;\n\t\t\tpadding-right: 12rem;\n\t\t}\n\t\t@include respond('phone') {\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\t.email-left-box{\n\t\tfloat:right;\n\t}\n\t.email-list .message .col-mail-2{\n\t\tright: 5.625rem;\n\t\tleft: 0;\n\t\tfloat: right;\n\t\t.date{\n\t\t\tright:auto;\n\t\t\tleft:0;\n\t\t}\n\t\t.subject{\n\t\t\tright: 0;\n\t\t\tleft: 5.5rem;\n\t\t}\n\t}\n\t\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",".photo-content{\n    position: relative;\n    .cover-photo{\n        background: url(../images/profile/cover.jpg);\n        background-size: cover;\n        background-position: center;\n        min-height: 250px;\n        width: 100%;\n\n    }\n\n}\n.profile .profile-photo {\n\tmax-width: 100px;\n\tposition: relative;\n\tz-index: 1;\n\tmargin-top: -40px;\n\tmargin-right: 10px;\n\t\n\t@include respond('tab-land') {\n\t\t\n\t}\n\t@include respond('phone') {\n\t\twidth: 80px;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tmargin-bottom:20px;\n\t}\n}\n[direction=\"rtl\"]{\n    .profile .photo-content .profile-photo {\n\t\tleft: auto;\n\t\tright: 50px;\n\t}\n\t.profile .profile-photo {\n\t\tleft:auto;\n\t\tright: 30px;\n\t\t@include respond('tab-land') {\n\t\t\tright: 15px;\n\t\t}\n\t\t@include respond('phone') {\n\t\t\twidth: 80px;\n\t\t\tright: calc(50% - 40px);\n\t\t\ttop: -100px;\n\t\t\t\n\t\t\t\n\t\t}\n\t}\n}\n.profile-info{\n    padding: 15px 20px;\n    // margin-bottom: 30px;\n\t@include respond('phone') {\n\t\tpadding: 0 0 20px;\n\t\ttext-align:center;\n\t}\n    h4 {\n        color: $l-ctd!important;\n    }\n\n    h4.text-primary {\n        color: $primary!important;\n    }\n\n    p {\n        color: $l-ctl;\n    }\n\n    .prf-col{\n        min-width: 250px;\n        padding: 10px 50px 0;\n    }\n}\n.profile-interest{\n    .row{\n        margin: 0 -.70px;\n        .int-col{\n            padding: 0 .70px;\n            .interest-cat{\n                margin-bottom: 1.40px;\n                position: relative;\n                display: block;\n                &:after{\n                    background: $black;\n                    bottom: 0;\n                    content: \"\";\n                    left: 0;\n                    opacity: 0.5;\n                    position: absolute;\n                    right: 0;\n                    top: 0;\n                    z-index: 0;\n                }\n                img{\n                    // margin-bottom: 1.20px;\n                }\n                p{\n                    position: absolute;\n                    top: 0;\n                    width: 100%;\n                    height: 100%;\n                    padding: 5px;\n                    left: 0;\n                    margin: 0;\n                    z-index: 1;\n                    color:white;\n                    font-size: 1.20px;\n                }\n            }\n            \n        }\n    }\n}\n.profile-tab{\n    .nav-item{\n        .nav-link{\n            font-size: 16px;\n            margin-right: 30px;\n            transition: all 0.5s ease-in-out;\n            border: none;\n            border-bottom: .20px solid transparent;\n            color: $l-ctl;\n            &:hover, &.active{\n                border: 0;\n                background: transparent;\n                background: transparent;\n                border-bottom: .20px solid $primary;\n                color: $primary;\n            }\n\t\t\t@include respond ('phone'){\n\t\t\t\tmargin-right: 0px;\n\t\t\t}\n\n        }\n        \n    }\n}\n.profile-info{\n\tdisplay:flex;\n\t@include respond('phone') {\n\t\tdisplay:block;\n\t}\n\t.profile-details {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\t@include respond('phone') {\n\t\t\tdisplay:block;\n\t\t\t.dropdown{\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 30px;\n\t\t\t\tright: 30px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.post-input{\n    margin-bottom: 30px;\n    .form-control{\n        height: 75px;\n        font-weight: 400;\n        margin: 15px 0;\n    }\n    \n}  \n.profile-uoloaded-post{\n    \n\t.post-title{\n\t\th3{\n\t\t\tfont-size: 24px;\n\t\t\t@include respond ('phone'){\n\t\t\t\tfont-size:18px;\n\t\t\t}\n\t\t}\n\t}\n    img{\n        margin-bottom: 20px;\n    }\n    a{\n        h4{\n            margin-bottom: 10px;\n            color: $l-ctd;\n        }\n    }\n}\n","\n.event-chat-ryt{\n\n    .chat-area{\n        .chat-reciver, \n        .chat-sender {\n            margin-bottom: 1.875rem;\n            padding: 0;\n            img{\n                border-radius: 30px;\n            }\n        }\n\n        .media {\n            position: relative;\n\n            &-body {\n\n                p {\n                    margin: 0;\n                    max-width: 100%;\n                    display: inline-block;\n                    position: relative;\n\n                    @include media-breakpoint-up(sm) {\n                        // max-width: 60%;\n                    }\n\n                    span {\n                        padding: 1rem;\n                        display: inline-block;\n                        top: 103%;\n                        position: relative;\n                        border: 1px solid $border;\n                    }\n                }\n            }\n        }\n    }\n\n    .chat-reciver{\n        padding: .5rem 1rem;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: end;\n            -ms-flex-pack: end;\n                justify-content: flex-end;\n\n        .media {\n            -webkit-box-flex: 1;\n                -ms-flex: 1;\n                    flex: 1;\n\n            .media-body {\n                margin-right: 2rem;\n                text-align: right;\n\n                @at-root [direction=\"rtl\"] & {\n                    text-align: left;\n                    margin-left: 2rem;\n                    margin-right: auto;\n                }\n\n                p {\n                    background: $white;\n                    margin-bottom: 0;\n                    border-radius: 5px 5px 0 5px;\n\n                    span {\n                        text-align: left;\n                        border: 1px solid $border;\n                        \n                        &::after{\n                            content: \"\";\n                            width: 20px;\n                            height: 20px;\n                            border-bottom: 1px solid $border;\n                            border-right: 1px solid $border;\n                            position: absolute;\n                            right: 0;\n                            bottom: 0;\n                            background: $white;\n                            -webkit-transform: rotate(-45deg) translateX(15px);\n                                    transform: rotate(-45deg) translateX(15px);\n\n                            @at-root [direction=\"rtl\"] & {\n                                left: 0;\n                                right: auto;\n                                -webkit-transform: rotate(135deg) translateY(15px);\n                                        transform: rotate(135deg) translateY(15px);\n                            }\n                        }\n                        \n                    }\n                    \n                    .time {\n                        position: absolute;\n                        font-size: 12px;\n                        color: $body-color;\n                        font-weight: 400;\n                        bottom: 0;\n                        left: -80px;\n\n                        @at-root [direction=\"rtl\"] & {\n                            right: -5rem;\n                            left: auto;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .chat-sender{\n        text-align: left;\n        padding: .5rem 1rem;\n\n        .media {\n\n            .media-body {\n                margin-left: 2rem;\n\n                @at-root [direction=\"rtl\"] & {\n                    text-align: right;\n                    margin-right: 2rem;\n                    margin-left: auto;\n                }\n\n                p {\n                    background-color: $white;\n                    margin-bottom: 0;\n                    span {\n                        \n                        &::after {\n                            content: \"\";\n                            width: 20px;\n                            height: 20px;\n                            border-bottom: 1px solid $border;\n                            border-left: 1px solid $border;\n                            position: absolute;\n                            left: 0;\n                            bottom: 0;\n                            background: $white;\n                            -webkit-transform: rotate(45deg) translateX(-15px);\n                                    transform: rotate(45deg) translateX(-15px);\n\n                            @at-root [direction=\"rtl\"] & {\n                                left: auto;\n                                right: 0;\n                                -webkit-transform: rotate(-135deg) translateY(15px);\n                                        transform: rotate(-135deg) translateY(15px);\n                            }\n                        }\n                    }\n\n                    .time {\n                        position: absolute;\n                        font-size: 10px;\n                        color: $body-color;\n                        font-weight: 400;\n                        bottom: 0;\n                        right: -5rem;\n\n                        @at-root [direction=\"rtl\"] & {\n                            left: -5rem;\n                            right: auto;\n                        }\n                    }\n\n                }\n            }\n        }\n\n    }\n}\n\n.char-type{\n    padding-top: 30px;\n    padding-bottom: 30px;\n\n    form{\n        \n        .form-control{\n            height: 45px;\n            // border-radius: 30px;\n            padding-left: 18px;\n            background: $body-bg;\n            border-right: 0;\n        }\n\n        .input-group{\n\n            &-append{\n                i{\n                    color: $gray;\n                    font-size: 18px;\n                }\n                .input-group-text{\n                    padding-left: .7rem;\n                    padding-right: .7rem;\n                    background: $body-bg;\n                    border-color: $border;\n                    border-left: 0;\n\n                    &:last-child{\n                        // border-top-right-radius: 30px;\n                        // border-bottom-right-radius: 30px;\n                        padding-right: 1.8rem;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.media-avatar{\n    padding: 25px 0;\n    border-bottom: 1px solid $border;\n    &:last-child{\n        border-bottom: 0px;\n    }\n    p{\n        margin-bottom: 0;\n    }\n    .avatar-status{\n        position: relative;\n        i{\n            position: absolute;\n            right: 0;\n            bottom: 0;\n        }\n    }\n}","\n\n\n.ct-golden-section:before {\n    float: none;\n  }\n  .ct-chart {\n    max-height: 15.7rem;\n  }\n  .ct-chart .ct-label {\n    fill: #a3afb7;\n    color: #a3afb7;\n    font-size: 0.75rem;\n    line-height: 1;\n }\n  .ct-grid {\n    stroke: rgba(49, 58, 70, 0.1);\n  }\n  .ct-chart.simple-pie-chart-chartist .ct-label {\n    color: #ffffff;\n    fill: #ffffff;\n    font-size: 0.625rem;\n  }\n  .ct-chart .ct-series.ct-series-a .ct-bar,\n  .ct-chart .ct-series.ct-series-a .ct-line,\n  .ct-chart .ct-series.ct-series-a .ct-point,\n  .ct-chart .ct-series.ct-series-a .ct-slice-donut {\n    stroke: $primary;\n  }\n  .ct-chart .ct-series.ct-series-b .ct-bar,\n  .ct-chart .ct-series.ct-series-b .ct-line,\n  .ct-chart .ct-series.ct-series-b .ct-point,\n  .ct-chart .ct-series.ct-series-b .ct-slice-donut {\n    stroke: $success;\n  }\n  .ct-chart .ct-series.ct-series-c .ct-bar,\n  .ct-chart .ct-series.ct-series-c .ct-line,\n  .ct-chart .ct-series.ct-series-c .ct-point,\n  .ct-chart .ct-series.ct-series-c .ct-slice-donut {\n    stroke: $warning;\n  }\n  .ct-chart .ct-series.ct-series-d .ct-bar,\n  .ct-chart .ct-series.ct-series-d .ct-line,\n  .ct-chart .ct-series.ct-series-d .ct-point,\n  .ct-chart .ct-series.ct-series-d .ct-slice-donut {\n    stroke: $danger;\n  }\n  .ct-chart .ct-series.ct-series-e .ct-bar,\n  .ct-chart .ct-series.ct-series-e .ct-line,\n  .ct-chart .ct-series.ct-series-e .ct-point,\n  .ct-chart .ct-series.ct-series-e .ct-slice-donut {\n    stroke: $info;\n  }\n  .ct-chart .ct-series.ct-series-f .ct-bar,\n  .ct-chart .ct-series.ct-series-f .ct-line,\n  .ct-chart .ct-series.ct-series-f .ct-point,\n  .ct-chart .ct-series.ct-series-f .ct-slice-donut {\n    stroke: $dark;\n  }\n  .ct-chart .ct-series.ct-series-g .ct-bar,\n  .ct-chart .ct-series.ct-series-g .ct-line,\n  .ct-chart .ct-series.ct-series-g .ct-point,\n  .ct-chart .ct-series.ct-series-g .ct-slice-donut {\n    stroke: #8d6e63;\n  }\n  .ct-series-a .ct-area,\n  .ct-series-a .ct-slice-pie {\n    fill: $secondary;\n  }\n  .ct-series-b .ct-area,\n  .ct-series-b .ct-slice-pie {\n    fill: #00A2FF;\n  }\n  .ct-series-c .ct-area,\n  .ct-series-c .ct-slice-pie {\n    fill: #ff9800;\n  }\n  .ct-series-d .ct-area,\n  .ct-series-d .ct-slice-pie {\n    fill: #ff9800;\n  }\n  .chartist-tooltip {\n    position: absolute;\n    display: inline-block;\n    opacity: 0;\n    min-width: 0.625rem;\n    padding: 2px 0.625rem;\n    border-radius: 3px;\n    background: #313a46;\n    color: #ffffff;\n    text-align: center;\n    pointer-events: none;\n    z-index: 1;\n    -webkit-transition: opacity .2s linear;\n    -moz-transition: opacity .2s linear;\n    -o-transition: opacity .2s linear;\n    transition: opacity .2s linear;\n  }\n  .chartist-tooltip.tooltip-show {\n    opacity: 1;\n  }\n\n\n\n\n\n  #donught_graph {\n    .ct-series.ct-series-a .ct-slice-donut {\n      stroke: #3FC6D4;\n    }\n    \n    .ct-series.ct-series-b .ct-slice-donut {\n      stroke: #333333;\n    }\n\n    .ct-series.ct-series-c .ct-slice-donut {\n      stroke: #F63465;\n    }\n  }\n\n\n#pie-chart .ct-label{\n\t@include respond ('phone-land'){\n\t\tcolor: #fff;\n\t\tfill: #fff;\n\t}\n}","\n#visitor_graph {\n    height: 253px !important;\n}\n\n#user_rating_graph {\n    height: 280px !important;\n}\n\n#radar_chart, \n#pie_chart, \n#doughnut_chart, \n#polar_chart {\n    // height: 10.875rem!important;\n}\n#visitorOnline{\n    height: 72px !important;\n}\n#trendMeter{\n    height: 72px !important;\n}\n#widget-revenue1,\n#widget-revenue2,\n#widget-revenue3{\n    height: 117px !important;\n}\n#widget-profit1,\n#widget-profit2,\n#widget-profit3{\n    height: 160px !important;\n}\n\n#comparison-rate{\n    height: 230px!important;\n}\n#session_day{\n    height: 175px!important;\n    width: auto!important;\n    margin: 0 auto;\n}\n\n#walet-status {\n    height: 140px!important;\n}\n#bar1 {\n    height: 150px!important;\n}\n#sold-product {\n    height: 230px!important;\n}\n\n\n#chart-venue-expenses,\n#chart-online-sale,\n#chart-gross-sale{\n    height: 150px !important;\n}\n\n\n#areaChart_3{\n    height: 295px !important;\n}\n.chart-point{\n\tdisplay:flex;\n\talign-items: center;\n\t\n\t.check-point-area{\n\t\twidth:100px;\n\t\theight: 100px;\n\t\tmargin-top: -10px;\n\t\tmargin-left: -10px;\n\t}\n\t.chart-point-list{\n\t\tmargin:0;\n\t\tpadding-left: 5px;\n\t\t\t\n\t\tli{\n\t\t\tlist-style:none;\n\t\t\tfont-size: 13px;\n\t\t\tpadding: 2px 0;\n\t\t\t\n\t\t\ti{\n\t\t\t\tmargin-right: 5px;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tposition: relative;\n\t\t\t\ttop: -1px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n","\n.c3{\n    height: 250px;\n}\n.c3-legend-item {\n    fill: #9fabb1;\n }\n\n .c3 .c3-axis-x path, \n .c3 .c3-axis-x line, \n .c3 .c3-axis-y path, \n.c3 .c3-axis-y line, \n.tick text { stroke: $white; }\n","\n\n.flot-chart{\n    height: 15.7rem;\n}\n\n.tooltipflot {\n    background-color: transparent;\n    font-size: 1.4rem;\n    padding: .5rem 1rem;\n    color: rgba(255, 255, 255, 0.7);\n    border-radius: .2rem; }\n  \n  .legendColorBox > div {\n    border: 0 !important;\n    padding: 0 !important; }\n  \n  .legendLabel {\n    font-size: 0.825rem;\n    padding-left: .5rem; \n    color: $white;\n  }\n    \n.flotTip {\n  background: $black;\n  border: 1px solid $black;\n  color: $white;\n}\n\n.legend > div{\n  background: transparent!important;\n}\n\n#balance_graph {\n  height: 260px;\n}",".morris-hover {\n\tposition: absolute;\n\tz-index : 1;\n\tbackground: $primary;\n\tcolor: $white;\n}\n\n.morris-hover .morris-hover-point {\n\tcolor: $white !important;\n\tmargin: 3px 0;\n\ttext-align: center;\n\tpadding: 0 25px;\n}\n\n.morris-hover .morris-hover-row-label {\n\tbackground-color: $dark;\n\ttext-align: center;\n\tpadding: 5px;\n\tmargin-bottom: 5px;\n}\n\n.morris-hover.morris-default-style {\n\tborder-radius: 5px;\n\tpadding      : 0;\n\tmargin: 0;\n\tborder       : none;\n\toverflow: hidden;\n}\n\nsvg text {\n    font-weight: 600 !important;\n}\n\n\n#morris_donught, \n#morris_donught_2, \n#line_chart_2, \n#morris_bar, \n#morris_bar_stalked, \n#morris_bar_2, \n#morris_area_2, \n#morris_area {\n    height: 240px !important;\n}\n\n#morris_line {\n\theight: 278px !important;\n}\n\n\n#crypto-btc-card, \n#crypto-eth-card, \n#crypto-rpl-card, \n#crypto-ltc-card {\n    height: 9.375rem;\n}\n\n\n","#daily-sales, #comparison-rate, #usage-chart, #walet-status {\n    width: 100%;\n    display: block;\n\n    canvas {\n        max-width: 100% !important;\n        width: 100% !important;\n    }\n}\n\n\n#sparkline-composite-chart, \n#composite-bar, \n#sparkline11, \n#StackedBarChart, \n#spark-bar, \n#tristate {\n    canvas {\n        height: 100px !important;\n    }\n}\n\n#sparkline11 canvas {\n    width: 100px !important;\n}",".easy-pie-chart {\n    position: relative;\n    text-align: center;\n\n    .inner {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        display: inline-block;\n    }\n\n    img {\n        width: 75px;\n        height: 75px;\n        border-radius: 50%;\n    }\n\n    canvas {\n        display: block;\n        margin: 0 auto;\n    }\n}","#revenue-chart {\n    height: 27.7rem;\n}\n\n// #finance_graph, #revenue_graph {\n//     height: 29.625rem;\n// }\n\n#duration-value-axis {\n    height: 27.6rem;\n    width: 100%;\n}\n\n#combined-bullet { \n    height: 28.125rem;\n    width: 100%;\n}\n\n#zoomable-chart {\n    height: 28.125rem;\n    width: 100%;\n}\n\n#chartMap {\n    height: 28.125rem;\n    width: 100%;\n}\n\n#professional-candlesticks {\n    width: 100%;\n    height: 28.125rem;\n}\n\n#comparing-stock-indices {\n    width: 100%;\n    height: 28.125rem;\n}\n\n#multiple-panel-data {\n    width: 100%;\n    height: 28.125rem;\n}\n\n#depth-chart {\n    width: 100%;\n    height: 28.125rem;\n}\n\n// #btc1 {\n//     width: 100%;\n//     height: 31.25rem;\n\n//     @include respond('phone') {\n//         margin-bottom: 5.625rem;\n//         padding-bottom: 2.5rem;\n//         height: 25rem;\n\n//         fieldset {\n\n//             div {\n//                 display: block !important;\n//                 margin-bottom: 0.625rem;\n\n//                 input {\n//                     display: block;\n//                     margin-bottom: 0.3125rem;\n//                 }\n//             }\n    \n//             div:last-child {\n//                 float: none !important;\n//             }\n//         }\n//     }\n// }\n\n.amcharts-export-menu {\n    display: none;\n}\n\n.amcharts-data-set-selector-div {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    width: 16.875rem;\n    margin: 0 auto;\n    select {\n        border: 0;\n        margin-left: 0.625rem;\n        background: #ddd;\n        color: $black;\n    }\n}\n\n.amChartsInputField {\n    border: 0;\n    background: $primary;\n    color: $white;\n    padding: 0.3125rem 0.9375rem;\n    margin: 0 0.9375rem;\n}\n\n.amcharts-data-set-select {\n    border: 0;\n    background: #ddd;\n    color: $black;\n}\n\n.amcharts-period-input,\n.amcharts-period-input-selected {\n    border: 0;\n    margin-left: 0.625rem;\n    background: $primary;\n    color: $white;\n    padding: 0.3125rem 0.9375rem;\n}\n\n/////////////////////\n// CSS Animation\n///////////////////\n.amcharts-graph-g2 .amcharts-graph-stroke {\n    stroke-dasharray: 3px 3px;\n    stroke-linejoin: round;\n    stroke-linecap: round;\n    -webkit-animation: am-moving-dashes 1s linear infinite;\n    animation: am-moving-dashes 1s linear infinite;\n}\n\n@-webkit-keyframes am-moving-dashes {\n    100% {\n        stroke-dashoffset: -1.9375rem;\n    }\n}\n\n@keyframes am-moving-dashes {\n    100% {\n        stroke-dashoffset: -1.9375rem;\n    }\n}\n\n.lastBullet {\n    -webkit-animation: am-pulsating 1s ease-out infinite;\n    animation: am-pulsating 1s ease-out infinite;\n}\n\n@-webkit-keyframes am-pulsating {\n    0% {\n        stroke-opacity: 1;\n        stroke-width: 0px;\n    }\n    100% {\n        stroke-opacity: 0;\n        stroke-width: 3.125rem;\n    }\n}\n\n@keyframes am-pulsating {\n    0% {\n        stroke-opacity: 1;\n        stroke-width: 0px;\n    }\n    100% {\n        stroke-opacity: 0;\n        stroke-width: 3.125rem;\n    }\n}\n\n.amcharts-graph-column-front {\n    -webkit-transition: all .3s .3s ease-out;\n    transition: all .3s .3s ease-out;\n}\n\n.amcharts-graph-column-front:hover {\n    fill: #496375;\n    stroke: #496375;\n    -webkit-transition: all .3s ease-out;\n    transition: all .3s ease-out;\n}\n\n@-webkit-keyframes am-draw {\n    0% {\n        stroke-dashoffset: 500%;\n    }\n    100% {\n        stroke-dashoffset: 0%;\n    }\n}\n\n@keyframes am-draw {\n    0% {\n        stroke-dashoffset: 500%;\n    }\n    100% {\n        stroke-dashoffset: 0%;\n    }\n}\n\n.amChartsPeriodSelector {\n    &>fieldset>div {\n        @include respond('tab-port') {\n            float: none !important;\n            display: block !important;\n            margin-bottom: 0.625rem;\n        }\n    }\n}",".highcharts-root {\n    text {\n        font-weight: 300 !important;\n    }\n}\n\n\n.highcharts-credits {\n    display: none;\n}\n\n","#chart_employee_gender, #chart_employee_status {\n    width: auto;\n    height: 350px;\n}","\n// Basic Input\n\n.form-control{\n    border-radius: $radius;\n    background: $white;\n    border: 1px solid $border;\n    // height: 45px;\n    color: $dark;\n\theight: 56px;\n\t@include respond('laptop') {\n\t\theight: 41px;\n\t}\n    &:hover,&:focus,&.active{\n        box-shadow: none;\n        background: $white;\n        color: $dark;\n    }\n}\n\n\n.input-rounded {\n    border-radius: 100px;\n}\n\n\n// Input Color\n[data-theme-version=\"light\"],\n[data-theme-version=\"dark\"] {\n\t.input-primary{\n\t\t.form-control{\n\t\t\tborder-color:$primary;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$primary;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-danger{\n\t\t.form-control{\n\t\t\tborder-color:$danger;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$danger;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-info{\n\t\t.form-control{\n\t\t\tborder-color:$info;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$info;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-success{\n\t\t.form-control{\n\t\t\tborder-color:$success;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$success;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-warning{\n\t\t.form-control{\n\t\t\tborder-color:$warning;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$warning;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n}\n// Input Outline\n[data-theme-version=\"light\"],\n[data-theme-version=\"dark\"] {\n\t.input-primary-o{\n\t\t.form-control{\n\t\t\tborder-color:$primary;\n\t\t\t\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$primary;\n\t\t\tcolor:$primary;\n\t\t}\n\t}\n\t.input-danger-o{\n\t\t.form-control{\n\t\t\tborder-color:$danger;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$danger;\n\t\t\tcolor:$danger;\n\t\t}\n\t}\n\t.input-info-o{\n\t\t.form-control{\n\t\t\tborder-color:$info;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$info;\n\t\t\tcolor:$info;\n\t\t}\n\t}\n\t.input-success-o{\n\t\t.form-control{\n\t\t\tborder-color:$success;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$success;\n\t\t\tcolor:$success;\n\t\t}\n\t}\n\t.input-warning-o{\n\t\t.form-control{\n\t\t\tborder-color:$warning;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$warning;\n\t\t\tcolor:$warning;\n\t\t}\n\t}\n}\n\n// Input Size/\n// .form-control{\n    // min-height: 40px;\n// }\n// .form-control-sm{\n//     min-height: 36px;\n// }\n// .form-control-lg{\n//     min-height: 52px;\n// }\n\n\n\n// Input Group\n.input-group-text{\n    background: #d7dae3;\n    border: 1px solid transparent;\n    min-width: 50px;\n    display: flex;\n    justify-content: center;\n\tpadding: 0.532rem 0.75rem;\n\tborder-radius: $radius;\n\t\t\n    i{\n        font-size: 16px;\n    }\n}\n.custom-file-label{\n    height: 40px;\n\tpadding: 0.5rem 0.75rem;\n\tborder-radius: 0;\n}\n.input-group-prepend .btn,\n.input-group-append .btn {\n    z-index: 0;\n}\n.custom-select{\n    background: none;\n    // height: 45px;\n    border-color: $border;\n    color: $dark;\n    // border-radius: 0px!important;\n    &:focus{\n        box-shadow: none;\n        border-color: $primary;\n        color: $primary;\n    }\n}\n.custom-file-label{\n    // height: 45px;\n    // border-radius: 0px!important;\n\t\n    &:after{\n        background: #656C73;\n        border: 1px solid $border;\n        color: $white;\n\t\tborder-radius: 0;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground: $d-border;\n\t\t\tborder-color: $d-border;\n\t\t\tcolor: $body-color;\n\t\t}\n    }\n}\n\n.custom_file_input {\n    .input-group-prepend, \n    .input-group-append {\n        // height: 45px;\n    }\n\n    .custom-file-label::after {\n        height: 100%;\n        // line-height: 2.4;\n    }\n}\n\n\n.form-control:disabled,\n .form-control[readonly] {\n    background: $white;\n    opacity: 1;\n}\n\n.custom-file-label{\n    background: $white;\n    border-color: $border;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background: $d-bg;\n\t\tborder-color: $d-border;\n    }\n}","@import \"../../abstracts/variable\";\n\ninput[type=\"checkbox\"] {\n    &:after{\n        content: '';\n        display: block;\n        width: 1rem;\n        height: 1rem;\n        margin-top: 0px;\n        margin-left: -1px;\n        border: 1px solid transparent;\n        border-radius: 3px;\n        background: #d4d7da;\n        line-height: 1.3;\n    }\n\n    &:checked:after{\n        width: 1rem;\n        height: 1rem;\n        display: block;\n        content: \"\\f00c\";\n        font-family: 'FontAwesome';\n        color: $white;\n        font-weight: 100;\n        font-size: 12px;\n        text-align: center;\n        border-radius: 3px;\n        background: $primary;\n    }\n\n}\n.form-check-label{\n    margin-left: 5px;\n    margin-top: 3px;\n}\n\n\n.form-check-inline {\n    .form-check-input {\n        margin-right: 0.625rem;\n    }\n}\n.custom-control-label{\n\t&:before,\n\t&:after{\n\t\ttop:2px;\n\t\twidth: 1.25rem;\n\t\theight: 1.25rem;\n\t\tborder-color: #e7e7e7;\n\t}\n}\n.rtl .custom-control-label{\n\t&:before,\n\t&:after{\n\t\tright: -1.5rem !important;\n\t\tleft: inherit;\n\t}\n}\n.custom-control {\n    line-height: normal;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before {\n    color: #fff;\n    border-color: $primary;\n}\n\n// CheckBox\n.custom-control-input:focus ~ .custom-control-label::before{\n\tbox-shadow:none !important;\n}\n.custom-control-label::before{\n    background-color: transparent;\n    border-color: #BEBEBE;\n\tborder-width: 2px;\n\tborder-radius: 5px !important;\n\t\t\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: transparent;\n\t\tborder-color: $d-border;\n\t}\n}\n.check-xs{\n\t.custom-control-label:before, \n\t.custom-control-label:after{\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n}\n.check-lg{\n\t.custom-control-label:before, \n\t.custom-control-label:after{\n\t\twidth: 24px;\n\t\theight: 24px;\n\t}\n}\n.check-xl{\n\t.custom-control-label:before, \n\t.custom-control-label:after{\n\t\twidth: 28px;\n\t\theight: 28px;\n\t}\n}\n.checkbox{\n\t&-info{\n\t\t.custom-control-label::before{\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: $info-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $info-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n\t\t.custom-control-input:checked ~ .custom-control-label::before{\n\t\t\tbackground-color: $info;\n\t\t\tborder-color: $info;\n\t\t}\n\t}\n\t&-danger {\n\t\t.custom-control-label::before{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color: $danger-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $danger-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n\t\t.custom-control-input:checked ~ .custom-control-label::before{\n\t\t\tbackground-color: $danger;\n\t\t\tborder-color: $danger;\n\t\t}\n\t}\n\t&-success{\n\t\t.custom-control-label::before{\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: $success-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $success-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n\t\t.custom-control-input:checked ~ .custom-control-label::before{\n\t\t\tbackground-color: $success;\n\t\t\tborder-color: $success;\n\t\t}\n\t}\n\t&-warning{\n\t\t.custom-control-label::before{\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: $warning-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $warning-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n\t\t.custom-control-input:checked ~ .custom-control-label::before{\n\t\t\tbackground-color: $warning;\n\t\t\tborder-color: $warning;\n\t\t}\n\t}\n\t&-secondary{\n\t\t.custom-control-label::before{\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: $secondary-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $secondary-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n\t\t.custom-control-input:checked ~ .custom-control-label::before{\n\t\t\tbackground-color: $secondary;\n\t\t\tborder-color: $secondary;\n\t\t}\n\t}\n}\n// Toggle Switch\n.toggle-switch{\n\tpadding-left:50px;\n\tline-height: 1.25;\n\t.custom-control-label{\n\t\t\n\t\tfont-weight: 500;\n\t\t&:after{\n\t\t\twidth: 24px;\n\t\t\tbackground:#959595;\n\t\t\theight: 24px;\n\t\t\tborder-radius: 24px;\n\t\t\ttop: -2px;\n\t\t\tleft: -50px;\n\t\t\t@include transitionMedium;\n\t\t}\n\t\t&:before{\n\t\t\tborder: 0;\n\t\t\tbackground: #D8D8D8;\n\t\t\twidth: 40px;\n\t\t\tborder-radius: 20px !important;\n\t\t\theight: 16px;\n\t\t\tleft: -50px;\n\t\t\t@include transitionMedium\n\t\t}\n\t}\n\t.custom-control-input:checked ~ .custom-control-label{\n\t\t&:after{\n\t\t\tleft: -43px;\n\t\t\tbackground:$primary;\n\t\t}\n\t\t&:before{\n\t\t\tbackground: $primary-light;\n\t\t}\n\t}\n\t&.text-right{\n\t\tpadding-left:0;\n\t\tpadding-right:50px;\n\t\t.custom-control-label{\n\t\t\t&:after{\n\t\t\t\tleft: auto;\n\t\t\t\tright: -30px;\n\t\t\t}\n\t\t\t&:before{\n\t\t\t\tleft: auto;\n\t\t\t\tright: -50px;\t\n\t\t\t}\n\t\t}\n\t\t.custom-control-input:checked ~ .custom-control-label{\n\t\t\t&:after{\n\t\t\t\tleft: auto;\n\t\t\t\tright: -43px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n//Check Switch\n.check-switch{\n\tpadding-left: 40px;\n\t.custom-control-label{\n\t\tline-height: 30px;\n\t\tfont-weight: 500;\n\t\t&:after,&:before{\n\t\t\theight:1.5rem;\n\t\t\twidth:1.5rem;\n\t\t\tleft: -2rem;\n\t\t\tborder-radius: 3rem!important;\n\t\t\tborder-color:rgba($primary,0.3);\n\t\t}\n\t}\n\t\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",".js-switch {\n\n    & + .switchery {\n        border-radius: 50px;\n        margin-right: 4rem;\n\n        @include media-breakpoint-down(sm) {\n            margin-right: 1rem;\n        }\n\n        &>small {\n            top: 2px;\n        }\n    }\n\n    &.js-switch-lg  {\n        & + .switchery {\n            height: 2rem;\n            width: 4.5rem;\n\n            &>small {\n                width: 1.75rem;\n                height: 1.75rem;\n            }\n        }\n    }\n\n    &.js-switch-md  {\n        & + .switchery {\n            height: 1.5rem;\n            width: 3.5rem;\n\n            &>small {\n                width: 1.25rem;\n                height: 1.25rem;\n            }\n        }\n    }\n\n    &.js-switch-sm  {\n        & + .switchery {\n            height: 1rem;\n            width: 2.2rem;\n\n            &>small {\n                width: 0.875rem;\n                height: 0.875rem;\n                top: 1px;\n            }\n        }\n    }\n\n    &-square {\n\n        & + .switchery {\n            border-radius: 0;\n    \n            &>small {\n                border-radius: 0;\n                top: 2px;\n            }\n        }\n\n        &.js-switch-lg  {\n            & + .switchery {\n                height: 2rem;\n                width: 4.5rem;\n    \n                &>small {\n                    width: 1.75rem;\n                    height: 1.75rem;\n                }\n            }\n        }\n\n        &.js-switch-md  {\n            & + .switchery {\n                height: 1.5rem;\n                width: 3.5rem;\n    \n                &>small {\n                    width: 1.25rem;\n                    height: 1.25rem;\n                }\n            }\n        }\n\n        &.js-switch-sm  {\n            & + .switchery {\n                height: 1rem;\n                width: 2.2rem;\n    \n                &>small {\n                    width: 0.875rem;\n                    height: 0.875rem;\n                    top: 1px;\n                }\n            }\n        }\n    }\n    \n}","/////////////////////////////\n// Bootstrap validation\n/////////////////////////////\n.form-control.is-valid {\n    border-color: $success !important;\n    border-right: 0px !important;\n    &:focus {\n        box-shadow: none;\n    }\n}\n\n.form-control.is-warning {\n    border-color: $warning !important;\n    border-right: 0px !important;\n    &:focus {\n        box-shadow: none;\n    }\n}\n\n.form-control.is-invalid {\n    border-color: $danger !important;\n    border-right: 0px !important;\n    &:focus {\n        box-shadow: none;\n    }\n}\n\n////////////////////////\n// Jquery Validation \n////////////////////////\n.is-valid {\n    .input-group-prepend {\n        .input-group-text {\n            i {\n                color: $success;\n            }\n        }\n    }\n}\n\n.is-invalid {\n    .input-group-prepend {\n        .input-group-text {\n            i {\n                color: lighten($primary, 15%)\n            }\n        }\n    }\n}","\n\n.asColorPicker-dropdown {\n    max-width: 26rem;\n}\n\n.asColorPicker-trigger {\n    border  : 0 none;\n    height  : 100%;\n    position: absolute;\n    right: 0;\n    top     : 0;\n    width   : 2.1875rem;\n}\n[direction=\"rtl\"] .asColorPicker-trigger{\n\tright: 99%;\n\tleft: auto;\n}\n.asColorPicker-clear {\n    display        : none;\n    position       : absolute;\n    right          : 1rem;\n    text-decoration: none;\n    top            : .5rem;\n}\n\n\n\n.daterangepicker {\n    td.active {\n        background-color: $primary;\n\n        &:hover {\n            background-color: $primary;\n        }\n    }\n\n    button.applyBtn {\n        background-color: $primary;\n        border-color: $primary;\n    }\n}\n\n.datepicker {\n\n    &.datepicker-dropdown {\n        background: $l-bg;\n        border-radius: 1px;\n        border: 1px solid $gallery;\n\n        td.day, th.next, th.prev {\n            height: 30px;\n            width: 30px !important;\n            padding: 0;\n            text-align: center;\n            font-weight: 300;\n            border-radius: 50px;\n\n            &:hover {\n                @extend %gradient-9;\n                box-shadow: 0px 0px 30px 5px rgba(243,30,122,0.3);\n                color: $white;\n            }\n        }\n\n        th.datepicker-switch, th.next, th.prev {\n            font-weight: 300;\n            color: $heading;\n        }\n\n        th.dow {\n            font-weight: 300;\n        }\n    }\n    table {\n\n        \n\n        tr td.selected, tr td.active.active {\n            @extend %gradient-9;\n            box-shadow: 0px 0px 30px 5px rgba(243,30,122,0.3);\n            border: 0;\n        }\n\n        tr {\n            td.today {\n                @extend %gradient-9;\n                box-shadow: 0px 0px 30px 5px rgba(243,30,122,0.3);\n                color     : #ffffff;\n\n                &:hover {\n                    @extend %gradient-9;\n                    box-shadow: 0px 0px 30px 5px rgba(243,30,122,0.3);\n                    color     : #ffffff;\n                }\n            }\n\n            td.today.disabled {\n                @extend %gradient-9;\n                box-shadow: 0px 0px 30px 5px rgba(243,30,122,0.3);\n                color     : #ffffff;\n\n                &:hover {\n                    @extend %gradient-9;\n                    box-shadow: 0px 0px 30px 5px rgba(243,30,122,0.3);\n                    color     : #ffffff;\n                }\n            }\n        }\n    }\n}\n\n\n.picker {\n    &__select--month, &__select--year {\n        height: 2.5em;\n    }\n\n    &__input {\n        background-color: transparent !important;\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background-color: transparent !important;\n            border: 1px solid $d-border;\n        }\n    }\n}\n\n.asColorPicker-wrap{\n\t.form-control{\n\t\tborder-top-right-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\t}\n}","#image {\n  max-width: 100%;\n}\n\n.docs-options {\n  .dropdown-menu {\n    padding: 1.5rem;\n  }\n}\n\n.docs-preview {\n  margin-bottom: 3rem;\n\n  .img-preview {\n    float: left;\n    margin-right: .5rem;\n    margin-bottom: .5rem;\n    overflow: hidden;\n    max-width: 100% !important;\n\n    &>img {\n      max-width: 100% !important;\n    }\n\n    &.preview-lg {\n      width: 16rem;\n      height: 9rem;\n    }\n\n    &.preview-md {\n      width: 8rem;\n      height: 4.5rem;\n    }\n\n    &.preview-sm {\n      width: 4rem;\n      height: 2.25rem;\n    }\n\n    &.preview-xs {\n      width: 2rem;\n      height: 1.125rem;\n      margin-right: 0;\n    }\n  }\n}","\n.select2-container {\n    width: 100% !important;\n}\n\n.select2-container--default .select2-selection--single {\n    border-radius: $radius;\n    border: 1px solid $light;\n    height: 40px;\n    background: $white;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$d-bg;\n\t\tborder-color:$d-border;\n    }\n\t\t\n\t\t\n    &:hover,&:focus,&.active{\n        box-shadow: none;\n    }\n}\n\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n    line-height: 40px;\n\tcolor:$body-color;\n\tpadding-left: 15px;\n\tmin-height: 40px;\n}\n\n.select2-container--default .select2-selection--multiple {\n    border-color: $border;\n    border-radius: 0;\n\t\n}\n\n.select2-dropdown {\n    border-radius: 0;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background-color: $primary;\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n    border-color: $border;\n    background: $white;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n    top: 6px;\n    right: 15px;\n}\n.select2-container .select2-selection--multiple{\n\tmin-height: 40px;\n\tcolor:$body-color;\n\tborder-radius: $radius;\n\tborder: 1px solid $light;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$d-bg;\n\t\tborder-color:$d-border;\n    }\n}\n.select2-search--dropdown .select2-search__field{\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$dark-card;\n\t\tborder-color:$d-border;\n    }\n}\n.select2-dropdown{\n\tborder-color: $light;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$d-bg;\n\t\tborder-color:$d-border;\n    }\n}\n.swal2-popup .swal2-content{\n\tcolor:$body-color;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","@import \"../../abstracts/variable\";\n@import \"../../abstracts/mixin\";\n\n\n/*  .wizard > .content > .body input.error {\n    position: absolute;\n    top: 100% !important;\n}\n\n.wizard {\n    position: relative;\n\n    &>.steps {\n        width: 100%;\n        // padding-left: 3%;\n\t\tmargin-bottom: 20px;\n\t\n        @media(min-width: 1200px){\n            width: 100%;\n            // margin-left: 3%;\n        }\n\n        li {\n\n            &.current {\n                a {\n                    background-color: $primary;\n                    color: $white;\n                }\n            }\n\n            &.disabled, &.done {\n                a {\n                    background-color: $white;\n                    color: $heading;\n\n                    &:hover {\n                        margin: 0;\n                        background-color: $white;\n                        border-radius: 0;\n                        color: $heading;\n                    }\n                }\n            }\n\n            a {\n                text-align: center;\n                margin: 0;\n                border-radius: 0;\n                background-color: $white;\n\n                &:hover {\n                    margin: 0;\n                    background-color: $white;\n                    border-radius: 0;\n                    color: $heading;\n                }\n\n                @include respond(phone-land) {\n                    padding: 1em 4px;\n                }\n\n                .number {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    .content  {\n        min-height: 32rem;\n        margin: 0;\n\n        @include media-breakpoint-down(md) {\n            min-height: 41rem;\n        }\n\n        & > .body {\n            background-color: transparent;\n            width: 100%;\n            height: 100%;\n            padding: 0;\n            \n            @include respond(phone) {\n                padding: 0;\n            }\n\n            .form-control {\n                // background-color: $l-bg;\n                border: 1px solid $border;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tborder-color: $d-border;\n\t\t\t\t}\n            }\n    \n            input.error {\n                position: relative;\n            }\n    \n            label.error {\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-bottom: 0;\n            }\n        }\n    }\n\n    .emial-setup {\n        label.mailclinet {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-direction: column;\n            width: 10rem;\n            height: 10rem;\n            border-radius: 50%;\n            cursor: pointer;\n            background-color: #EEF5F9;\n\t\t\ttext-align: center;\n\t\t\tmargin: auto;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $d-bg;\n\t\t\t}\n            @include respond(phone) {\n                width: 7rem;\n                height: 7rem;\n            }\n\n            .mail-icon {\n                font-size: 3rem;\n                display: inline-block;\n                line-height: 1;\n                margin-top: -1rem;\n\n                @include respond(phone) {\n                    font-size: 2rem;\n                }\n            }\n\n            .mail-text {\n                font-size: 1rem;\n                text-align: center;\n                margin-top: .5rem;\n\n                @include respond(phone) {\n                    font-size: 16px;\n\t\t\t\t\tline-height: 20px;\n                }\n            }\n\n            input[type=\"radio\"] {\n                display: none;\n            }\n        }\n    }\n\n    .skip-email {\n        margin-top: 6rem;\n\n        p {\n            margin-bottom: 1rem;\n        }\n\n        a {\n            color: $primary;\n            text-decoration: underline;\n        }\n    }\n\n    &>.actions {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        padding: 2rem;\n\n        li:not(.disabled) {\n            a {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n.wizard .actions ul li{\n    &.disabled a{\n        color: #333333 !important;\n        background: #F7FAFC !important;\n        border: 1px solid #EEEEEE;\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg !important;\n            border-color: $d-border;\n\t\t\tcolor:$white !important;\n        }\n    }\n\n    & a{\n        border-radius: 4px;\n        font-size: 14px;\n        font-weight: 600;\n        padding: 0.55em 2em;\n    }\n\n}\n\n.wizard > .actions a, .wizard > .actions a:hover, .wizard > .actions a:active{\n    padding: 0.55em 2em;\n}\n\n// .wizard > .steps > ul > li{\n\n//     @media(max-width: 680px){\n//         width: 100%;\n//         padding-left: 0;\n//     }\n// }\n\n// .wizard > .steps{\n\n//     @media(max-width: 680px){\n//         padding-left: 0;\n//     }\n// }\n\n.wizard > .content{\n    background: transparent;\n    // box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1); \n}\n\n.wizard, .tabcontrol{\n    overflow: visible;\n}\n\n.step-form-horizontal {\n    .wizard {\n        padding-top: 3.5rem;\n        \n        .steps {\n            li {\n                position: relative;\n\n                &.done {\n                    a {\n                        text-align: center;\n                        background-color: $white;\n                        color: $dark;\n\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\tbackground-color: $d-bg;\n\t\t\t\t\t\t\tcolor: $body-color;\n\t\t\t\t\t\t}\n                        &:hover {\n                            text-align: center;\n                            background-color: $white;\n                            color: $dark;\n                        }\n\n                        .number {\n                            color: $white;\n                            background: $primary;\n                            border-color: transparent; \n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\t\tborder-color:$primary;\n\t\t\t\t\t\t\t}\n                        }\n                    }\n                }\n\n                &.current a, &.disabled a {\n                    background-color: transparent;\n                    text-align: center;\n                    color: $white;\n\n                    &:hover, &:active {\n                        background-color: transparent;\n                        color: $white;\n                    }\n                }\n\n                &.current a {\n                    .number {\n                        color: $primary;\n                        background: $white;\n                        border: 2px solid $primary; \n                    }\n                }\n\n                &.disabled a {\n                    .number {\n                        color: $primary;\n                    }\n                }\n\n                a {\n                    position: relative;\n                    z-index: 1;\n\n                    @include media-breakpoint-down(sm) {\n                        padding-left: 0;\n                        padding-right: 0;\n                        margin: 0;\n                    }\n\n                    @include media-breakpoint-down(xs) {\n                        font-size: 0.75rem;\n                        padding-top: 0.9375rem;\n                    }\n\n                    .number {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: -55px;\n\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\ttransform: translateX(-50%);\n\t\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\t\tborder: 3px solid #d7dae3;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\theight: 3rem;\n\t\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\t\twidth: 3rem;\n\n                        // @include respond(phone) {\n                        //     width: 4rem;\n                        //     height: 4rem;\n                        // }\n\t\t\t\t\t\t\n\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\tbackground:$d-bg;\n\t\t\t\t\t\t\tborder-color:$d-border;\n\t\t\t\t\t\t}\n                        @include respond('phone') {\n\t\t\t\t\t\t\ttop: -45px;\n\t\t\t\t\t\t}\n                    }\n                }\n\n                &:not(:last-child) {\n                    z-index: 1;\n\n                    &::after {\n                        position: absolute;\n                        width: 100%;\n                        height: 0.375rem;\n                        content: \"\";\n                        left: 50%;\n                        top: -2.1rem;\n                        background-color: $primary;\n                        z-index: -1;\n\n                        @include media-breakpoint-down(xs) {\n                            height: 0.375rem;\n                            top: -1.3125rem;\n                        }\n                    }\n\n                    &.current {\n                        &::after {\n                            background-color: #F3F3F3;\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\t\tbackground:$d-bg;\n\t\t\t\t\t\t\t}\n                        }\n\n\n                        &~li {\n                            &::after {\n                                background-color: #F3F3F3;\n\t\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\t\t\t\tbackground:$d-bg;\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .actions {\n            padding: 0;\n\n            @include respond(phone) {\n                padding: 0;\n            }\n        }\n    }\n}\n */\n \n // form-wizard\n.form-wizard{\n\tborder: 0;\n\t.nav-wizard{\n\t\tbox-shadow: none!important;\n\t\tmargin-bottom: 2rem;\n\t\tli{\n\t\t\t.nav-link{\n\t\t\t\tposition: relative;\n\t\t\t\tspan{\n\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\twidth: 3rem;\n\t\t\t\t\theight: 3rem;\n\t\t\t\t\tborder: 2px solid $primary;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tline-height: 3rem;\n\t\t\t\t\tcolor: $primary;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tmargin: auto;\n\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 1;\n\t\t\t\t}\n\t\t\t\t&:after{\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\theight: 3px;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\tbackground: $dark-light!important;\n\t\t\t\t\tz-index: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t\t&.active{\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tbackground: $dark-light!important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.done{\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tbackground: $primary!important;\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\tspan{\n\t\t\t\t\t\tbackground-color: $primary;\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child{\n\t\t\t\t.nav-link{\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t}\n\t.toolbar-bottom{\n\t\t.btn{\n\t\t\tbackground-color: $primary;\n\t\t\tborder: 0;\n\t\t\tpadding: 12px 18px;\n\t\t}\n\t}\n\t.tab-content{\n\t\t.tab-pane{\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\t.emial-setup {\n        label.mailclinet {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-direction: column;\n            width: 10rem;\n            height: 10rem;\n            border-radius: 50%;\n            cursor: pointer;\n            background-color: #EEF5F9;\n\t\t\ttext-align: center;\n\t\t\tmargin: auto;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $d-bg;\n\t\t\t}\n            @include respond(phone) {\n                width: 7rem;\n                height: 7rem;\n            }\n\n            .mail-icon {\n                font-size: 3rem;\n                display: inline-block;\n                line-height: 1;\n                margin-top: -1rem;\n\n                @include respond(phone) {\n                    font-size: 2rem;\n                }\n            }\n\n            .mail-text {\n                font-size: 1rem;\n                text-align: center;\n                margin-top: .5rem;\n\n                @include respond(phone) {\n                    font-size: 16px;\n\t\t\t\t\tline-height: 20px;\n                }\n            }\n\n            input[type=\"radio\"] {\n                display: none;\n            }\n        }\n    }\n\t\n\t// emial-setup\n\t.emial-setup {\n        label.mailclinet {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-direction: column;\n            width: 10rem;\n            height: 10rem;\n            border-radius: 50%;\n            cursor: pointer;\n            background-color: #EEF5F9;\n\t\t\ttext-align: center;\n\t\t\tmargin: auto;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $d-bg;\n\t\t\t}\n            @include respond(phone) {\n                width: 7rem;\n                height: 7rem;\n            }\n\n            .mail-icon {\n                font-size: 3rem;\n                display: inline-block;\n                line-height: 1;\n                margin-top: -1rem;\n\n                @include respond(phone) {\n                    font-size: 2rem;\n                }\n            }\n\n            .mail-text {\n                font-size: 1rem;\n                text-align: center;\n                margin-top: .5rem;\n\n                @include respond(phone) {\n                    font-size: 16px;\n\t\t\t\t\tline-height: 20px;\n                }\n            }\n\n            input[type=\"radio\"] {\n                display: none;\n            }\n        }\n    }\n\t@include respond('phone-land') {\n\t\t.nav-wizard{\n\t\t\tflex-direction: unset!important;\n\t\t}\n\t\t.tab-content{\n\t\t\theight: 100%!important;\n\t\t}\n\t}\n\t@include respond('phone') {\n\t\t.nav-wizard{\n\t\t\tli{\n\t\t\t\t.nav-link{\n\t\t\t\t\tpadding: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","\n\n.note-icon-caret,\n.note-popover {\n    display: none;\n}\n\n\n.note-editor.note-frame .panel-heading {\n    padding      : .6rem 1rem 1rem;\n\tz-index: 1;\n}\n\n.note-editor.note-frame {\n    border-color: $border;\n}\n\n.note-editor.note-frame .note-editing-area .note-editable {\n    background-color: $white;\n    @at-root [data-theme-version=\"dark\"] & {\n        background-color: $d-bg;\n    }\n}\n\n.note-editor.note-frame .note-statusbar {\n    background-color: $white;\n}\n\n\n\n",".ql-container{\n    height: 25rem;\n}","#world-datamap {\n    padding-bottom: 46% !important;\n}\n\n.datamaps-hoverover {\n    background: $white;\n    padding: 0.3125rem;\n    border-radius: 0.3125rem;\n    font-family: 'Roboto' !important;\n    color: $primary;\n    border: 1px solid rgba($primary, .3);\n}\n\n.world_map_card {\n    ul.list-group {\n        @include custommq($max: 1440px) {\n            display: flex;\n            flex-wrap: wrap;\n            flex-direction: row;\n            margin-top: 35px;\n        }\n\n        // li {\n        //     @include custommq($min: 1200px, $max: 1440px) {\n        //         flex: 1;\n        //     }\n        // }\n    }\n}",".jqvmap-zoomin,\n.jqvmap-zoomout {\n    height: 20px;\n    width: 20px;\n    line-height: 14px;\n    background-color: $primary;\n    color: $white;\n}\n\n.jqvmap-zoomout {\n    top: 35px;\n}\n\n#world-map {\n    height: 400px;\n}",".blockUI.blockMsg.blockPage {\n    border: 0 !important;\n}\n\n#loginForm {\n    cursor: auto;\n}\n\n.blockMsg {\n    border: 0px!important;\n    width: 20%!important;\n    h1{\n        font-size: 16px;\n        padding: 8px 0;\n        margin-bottom: 0;\n    }\n}",".bootstrap-select{\n    margin-bottom: 0;\n\n   .btn {\n\t\tborder: 1px solid $border !important;\n\t\tbackground-color: transparent !important;\n\t\tfont-weight:400;\n\t\tcolor: $body-color !important;\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color:$d-border !important;\n\t\t}\n       \n       &:active,\n       &:focus,\n       &:hover {\n\t\t\toutline: none !important;\n\t\t\toutline-offset: 0;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor: $body-color !important;\n\t\t\t}\n       }\n   }\n    .dropdown-menu{\n\t\tborder-color: $border !important;\n\t\tbox-shadow:$shadow;\n\t\t\n\t\t.dropdown-item{\n\t\t\tpadding: 0.25rem 1rem;\n\t\t}\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $border !important;\n\t\t}\n\t}\n   \n}\n.input-group > .bootstrap-select:not(:first-child) .dropdown-toggle{\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.input-group > .bootstrap-select:not(:last-child) .dropdown-toggle{\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}","\n\n\n\n.crypto-ticker{\n    background: rgba(0, 0, 0, 0.5);\n    margin-top: 20px;\n    padding: 10px 20px;\n    border-radius: 3px;\n    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n\n    @at-root [data-theme-version=\"dark\"] & {\n        background: $dark-card;\n    }\n    \n}\n\n#webticker-big {\n    font: inherit !important;\n    font-size: inherit !important;\n    font-weight: normal !important;\n    li{\n        i{\n            font-size: 18px;\n            margin-right: 7px;\n        }\n        p{\n            margin-bottom: 0px;\n            font-size: 12px;\n            font-weight: 700;\n            // margin-left: 30px;\n        }\n    }\n}\n\n","@import \"../../abstracts/variable\";\n\n.twitter-typeahead {\n    width: 100%;\n\n    // .form-control {\n    //     background-color: $l-bg !important;\n    // }\n\n    .tt-dataset.tt-dataset-states {\n        border: 1px solid $border;\n    }\n\n    .tt-menu {\n        width: 100%;\n        background-color: $white;\n\n        .tt-suggestion {\n            padding: 0.625rem;\n            cursor: pointer;\n\n            &:hover {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n"," // Variable.scss\n\n.weather-one {\n    i {\n        font-size: 8rem;\n        position : relative;\n        top      : .5rem;\n    }\n\n    h2 {\n        display  : inline-block;\n        float    : right;\n        font-size: 4.8rem;\n    }\n\n    .city {\n        position  : relative;\n        text-align: right;\n        top       : -2.5rem;\n    }\n\n    .currently {\n        font-size  : 1.6rem;\n        font-weight: 400;\n        position   : relative;\n        top        : 2.5rem;\n    }\n\n    .celcious {\n        text-align: right;\n        font-size : 2rem;\n    }\n}","@import \"../../abstracts/variable\";\n\n\n\n.noUi-target {\n    border-color: transparent; \n    border-radius: 0;\n}\n\n.noUi-connect {\n    background-color: $primary;\n\n    &s {\n        background-color: $grey;\n    }\n\n    &.c-1-color {\n        background-color: $success;\n    }\n\n    &.c-2-color {\n        background-color: $info;\n    }\n\n    &.c-3-color {\n        background-color: $primary;\n    }\n\n    &.c-4-color {\n        background-color: $warning;\n    }\n}\n\n.noUi-vertical {\n    width: 0.375rem;\n}\n\n.noUi-horizontal {\n    height: 0.375rem;\n    margin-bottom: 10px;\n}\n\n.noUi-horizontal .noUi-handle, .noUi-vertical .noUi-handle {\n    height: 12px;\n    width: 12px;\n    border-radius: 50px;\n    box-shadow: none;\n    border: none;\n    background-color: $primary;\n\n    &::after, &::before {\n        display: none;\n    }\n}\n.noUi-vertical .noUi-handle {\n    left: -4px;\n    top: -6px;\n}\n.noUi-horizontal .noUi-handle {\n    top: -4px;\n}\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n    right: -6px;\n}\n#slider-toggle {\n\theight: 50px;\n}\n#slider-toggle.off .noUi-handle {\n\tborder-color: $primary;\n}\n\n\n.colorpicker-slider {\n    .sliders.noUi-target {\n\n\n        &#red, &#green, &#blue {\n            margin: 10px;\n            display: inline-block;\n            height: 200px;\n        }\n\n        &#red .noUi-connect {\n            background: #c0392b;\n        }\n\n        &#green .noUi-connect {\n            background: #27ae60;\n        }\n\n        &#blue .noUi-connect {\n            background: #2980b9;\n        }\n    }\n\n\n    #result {\n        margin: 60px 26px;\n        height: 100px;\n        width: 100px;\n        display: inline-block;\n        vertical-align: top;\n        color: rgb(127, 127, 127);\n        background: rgb(127, 127, 127);\n        border: 1px solid #fff;\n        box-shadow: 0 0 10px;\n    }\n}\n\n.slider-vertical {\n    height: 18rem;\n}"," // Variable.scss\n\n.nestable-cart {\n    overflow: hidden;\n}\n\n// .dd-item > button {\n//     height: 2.1rem;\n// }\n.dd-handle {\n    color: $white;\n    background: $primary;\n    border-radius: 5px;\n\tpadding: 8px 15px;\n\theight:auto;\n    border: 1px solid $border;\n}\n.dd-handle:hover {\n    color: $white;\n    background: $primary;\n}\n// #nestable2 .dd-handle {\n    // color: $white;\n    // border: 1px solid $border;\n    // background: $primary;\n// }\n// #nestable2 .dd-handle:hover {\n//     background: $primary;\n// }\n// #nestable2 .dd-item>button:before {\n//     color: $white;\n// }\n.dd3-content:hover {\n    color: $white;\n    background: $primary;\n}\n.dd3-content {\n    color: $white;\n}\n.dd-item>button{\n\tline-height:28px;\n\tcolor:$white;\n}",".pignose-calendar {\n    box-shadow: none;\n    width: 100%;\n    max-width: none;\n    border-color: $primary;\n\n    .pignose-calendar-top-date {\n        background-color: $primary;\n\n        .pignose-calendar-top-month {\n            color: $white;\n        }\n    }\n}\n\n.pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n    background-color: $primary;\n    box-shadow: none;\n}\n\n.pignose-calendar .pignose-calendar-top {\n    box-shadow: none;\n    border-bottom: 0;\n}\n\n.pignose-calendar.pignose-calendar-blue {\n    background-color: rgba(0, 0, 0, 0.15);\n}\n\n.pignose-calendar .pignose-calendar-unit {\n    height: 4.8em;\n}\n",".cd-h-timeline {\n    opacity: 0;\n    transition: opacity 0.2s;\n  }\n\n  .cd-h-timeline--loaded { // show the timeline after dates position has been set (using JavaScript)\n    opacity: 1;\n  }\n\n  .cd-h-timeline__container {\n    position: relative;\n    height: 100px;\n    max-width: 800px;\n  }\n\n  .cd-h-timeline__dates {\n    position: relative;\n    height: 100%;\n    margin: 0 40px;\n    overflow: hidden;\n\n    &::after, &::before { // these are used to create a shadow effect at the sides of the timeline\n      content: '';\n      position: absolute;\n      z-index: 2;\n      top: 0;\n      height: 100%;\n      width: 20px;\n    }\n\n    &::before {\n      left: 0;\n      background: $primary;\n    }\n\n    &::after {\n      right: 0;\n      background: $primary;\n    }\n  }\n\n  .cd-h-timeline__line { // grey line\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 49px;\n    height: 2px; // width will be set using JavaScript\n    background-color: $primary;\n    transition: transform 0.4s;\n  }\n\n  .cd-h-timeline__filling-line { // green filling line\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: $success;\n    transform: scaleX(0);\n    transform-origin: left center;\n    transition: transform 0.3s;\n  }\n\n  .cd-h-timeline__date {\n    position: absolute;\n    bottom: 0; // left position will be set using JavaScript\n    z-index: 2;\n    text-align: center;\n    font-size: 0.8em;\n    padding-bottom: var(--space-sm);\n    color: var(--cd-color-1);\n    user-select: none; // improve swipe\n    text-decoration: none;\n\n    &::after { // this is used to create the event spot\n      content: '';\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      bottom: -5px;\n      height: 12px;\n      width: 12px;\n      border-radius: 50%;\n      border-width: 2px;\n      border-style: solid;\n      border-color: lighten($primary, 0.9);\n      background-color: $primary;\n      transition: background-color 0.3s, border-color .3s;\n    }\n\n    &:hover::after {\n      background-color: $success;\n      border-color: $success;\n    }\n\n    // @include breakpoint(md) {\n    //   font-size: 0.7em;\n    // }\n  }\n\n\n\n  .cd-h-timeline__date--selected {\n    pointer-events: none;\n\n    &::after {\n      background-color: $success;\n      border-color: $success;\n    }\n  }\n\n  .cd-h-timeline__date--older-event::after {\n    border-color: $success;\n  }\n\n  .cd-h-timeline__navigation { // arrows to navigate the timeline\n    position: absolute;\n    z-index: 1;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 34px;\n    width: 34px;\n    border-radius: 50%;\n    border-width: 2px;\n    border-style: solid;\n    border-color: lighten($primary, 0.9);\n    transition: border-color 0.3s;\n    \n    &::after { // arrow icon\n      content: '';\n      position: absolute;\n      height: 16px;\n      width: 16px;\n      top: 50%;\n      left: 50%;\n      transform: translateX(-50%) translateY(-50%);\n      background: url(../images/svg/cd-arrow.svg) no-repeat 0 0;\n    }\n\n    &:hover {\n      border-color: $success;\n    }\n  }\n\n  .cd-h-timeline__navigation--prev {\n    left: 0;\n    transform: translateY(-50%) rotate(180deg);\n  }\n\n  .cd-h-timeline__navigation--next {\n    right: 0;\n  }\n\n  .cd-h-timeline__navigation--inactive {\n    cursor: not-allowed;\n\n    &::after {\n      background-position: 0 -16px;\n    }\n\n    &:hover {\n      border-color: lighten($primary, 0.9);\n    }\n  }\n\n  .cd-h-timeline__events { // container of events info\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    transition: height .4s;\n  }\n\n  .cd-h-timeline__event { // single event info\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    left: 0;\n    top: 0;\n    transform: translateX(-100%);\n    padding: 1px 5%;\n    opacity: 0;\n    animation-duration: 0.4s;\n    animation-timing-function: ease-in-out;\n  }\n\n  .cd-h-timeline__event--selected { // selected event info\n    position: relative;\n    z-index: 2;\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  .cd-h-timeline__event--enter-right, \n  .cd-h-timeline__event--leave-right { // animate event info\n    animation-name: cd-enter-right;\n  }\n\n  .cd-h-timeline__event--enter-left,  \n  .cd-h-timeline__event--leave-left { // animate event info\n    animation-name: cd-enter-left;\n  }\n\n  .cd-h-timeline__event--leave-right, \n  .cd-h-timeline__event--leave-left {\n    animation-direction: reverse;\n  }\n\n  .cd-h-timeline__event-content {\n    max-width: 800px;\n  }\n\n  .cd-h-timeline__event-title {\n    color: var(--cd-color-1);\n    font-family: var(--font-secondary);\n    font-weight: 700;\n    font-size: var(--text-xxxl);\n  }\n\n  .cd-h-timeline__event-date {\n    display: block;\n    font-style: italic;\n    margin: var(--space-xs) auto;\n\n    &::before {\n      content: '- ';\n    }\n  }\n\n  @keyframes cd-enter-right {\n    0% {\n      opacity: 0;\n      transform: translateX(100%);\n    }\n  \n    100% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n  }\n  \n  @keyframes cd-enter-left {\n    0% {\n      opacity: 0;\n      transform: translateX(-100%);\n    }\n  \n    100% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n  }\n\n\n","/* Light Gallery */\n.lg-actions .lg-next, \n.lg-actions .lg-prev, \n.lg-sub-html, \n.lg-toolbar{\n    background-color: rgba(30, 30, 30, .6);\n}\n.lg-outer{\n\t.lg-toogle-thumb, \n\t.lg-thumb-outer,\n\t.lg-img-wrap, \n\t.lg-item{\n\t\tbackground-color: transparent;\n\t}\n}\n.lg-thumb-outer.lg-grab,\n.lg-toogle-thumb.lg-icon{\n\tbackground-color: rgba(30, 30, 30, .6);\n}\n.lg-backdrop {\n    background-color: rgba(30, 30, 30, 0.9);\n}\n.lg-outer .lg-toogle-thumb, \n.lg-actions .lg-next, \n.lg-actions .lg-prev, \n.lg-toolbar .lg-icon,\n#lg-counter{\n    color: $white;\n}\n.lg-outer{\n\t.lg-thumb-item{\n\t\t&.active,\n\t\t&:hover{\n\t\t\tborder-color: $primary;\t\t\t\n\t\t}\n\t}\n}\n.lightimg{\n\tcursor: pointer;\n}",".toast {\n    &-success {\n        background-color: $primary;\n    }\n\n    &-info {\n        background-color: $info;\n    }\n\n    &-warning {\n        background-color: $warning;\n    }\n\n    &-error {\n        background-color: $danger;\n    }\n}\n\n#toast-container {\n\n    &>div {\n        box-shadow: none;\n        border-radius: 0;\n        width: auto;\n        max-width: 250px;\n        opacity: 1;\n\n        @at-root [direction=\"rtl\"] & {\n            padding: 15px 50px 15px 15px;\n            background-position: calc(100% - 15px);\n            text-align: right;\n        }\n\n        &:hover {\n            box-shadow: none;\n        }\n    }\n\n    .toast-title {\n        margin-bottom: 5px;\n        font-weight: 600;\n    }\n\n    .toast-message {\n        font-size: 12px;\n    }\n\n    .toast-close-button {\n        opacity: 1;\n        font-size: 20px;\n        font-weight: normal;\n        text-shadow: none;\n    }\n\n\n}\n\n[direction=\"rtl\"] {\n    .toast-top-right.demo_rtl_class {\n        left: 12px;\n        right: auto;\n    }\n}","\n.jqvmap-zoomin, .jqvmap-zoomout\n{\n\tposition: absolute;\n\tleft: 10px;\n\t-webkit-border-radius: 3px;\n\t-moz-border-radius: 3px;\n\tborder-radius: 3px;\n\tbackground: #000000;\n\tpadding: 3px;\n\tcolor: white;\n\twidth: 17px;\n\theight: 17px;\n\tcursor: pointer;\n\tline-height: 10px;\n\ttext-align: center;\n}\n.jqvmap-zoomin\n{\n\ttop: 10px;\n}\n.jqvmap-zoomout\n{\n\ttop: 30px;\n}\n\n\n","// .deznav-scroll{\n//     .ps__rail-x:hover,\n//     .ps__rail-y:hover,\n//     .ps__rail-x:focus,\n//     .ps__rail-y:focus,\n//     .ps__rail-x.ps--clicking,\n//     .ps__rail-y.ps--clicking {\n//         background-color: #f00;\n//         opacity: 0.9;\n//     }\n//     .ps__rail-y:hover > .ps__thumb-y,\n//     .ps__rail-y:focus > .ps__thumb-y,\n//     .ps__rail-y.ps--clicking .ps__thumb-y {\n//         background-color: #f00;\n//         width: 4px;\n//     }\n//     .ps__thumb-y {\n//         background-color: #f00;\n//         width: 4px;\n//     }\n// }\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus,\n.ps__rail-x.ps--clicking,\n.ps__rail-y.ps--clicking {\n    background-color: transparent;\n    opacity: 0.9;\n}\n\n.ps__rail-y:hover>.ps__thumb-y,\n.ps__rail-y:focus>.ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n    background-color: #DAE2F3;\n    width: 4px;\n}\n\n.ps__thumb-y {\n    background-color: #DAE2F3;\n    width: 4px;\n}\n\n.total-average {\n    position: relative;\n    height: 300px;\n}\n\n.widget-chat {\n    position: relative;\n    height: 250px;\n}\n\n.widget-todo {\n    position: relative;\n    height: 210px;\n}\n\n.widget-team {\n    position: relative;\n    height: 285px;\n}\n\n.widget-timeline {\n    position: relative;\n}\n\n.widget-comments {\n    position: relative;\n    height: 400px;\n}\n\n.sidebar-right-inner {\n    position: relative;\n    height: 100%;\n}\n\n.widget-team {\n    .ps .ps__rail-x:hover,\n    .ps .ps__rail-y:hover,\n    .ps .ps__rail-x:focus,\n    .ps .ps__rail-y:focus,\n    .ps .ps__rail-x.ps--clicking,\n    .ps .ps__rail-y.ps--clicking {\n        background-color: transparent!important;\n        opacity: 0.9;\n    }\n}",".accordion {\n\t// accordion primary\n\t&-primary{\n\t\t.accordion__header {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: $primary-light;\n\t\t\t\tborder-color: $primary-light;\n\t\t\t\tcolor: #211c37;\n\t\t\t\tbox-shadow:none;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground: $primary-opacity;\n\t\t\t\t\tborder-color: $primary-opacity;\n\t\t\t\t\tcolor:$body-color;\n\t\t\t\t}\n\t\t\t}\n\t\t\tbackground:$primary;\n\t\t\tborder-color:$primary;\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 15px 20px 0 rgba($primary, 0.15);\n\t\t}\n\t}\n\t&-primary-solid{\n\t\t.accordion__header {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: $primary-light;\n\t\t\t\tborder-color: $primary-light;\n\t\t\t\tcolor: #211c37;\n\t\t\t\tbox-shadow:none;\n\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground: $primary-opacity;\n\t\t\t\t\tborder-color: $primary-opacity;\n\t\t\t\t\tcolor:$body-color;\n\t\t\t\t}\n\t\t\t}\n\t\t\tbackground:$primary;\n\t\t\tborder-color:$primary;\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 -10px 20px 0 rgba($primary, 0.15);\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t}\n\t\t.accordion__body {\n            border: 2px solid $primary;\n            border-top: none;\n\t\t\tbox-shadow:0 15px 20px 0 rgba($primary, 0.15);\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n\t\t}\n\t}\n\n\t&-danger{\n\t\t.accordion__header {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: $danger-light;\n\t\t\t\tborder-color: $danger-light;\n\t\t\t\tcolor: #211c37;\n\t\t\t\tbox-shadow:none;\n\t\t\t}\n\t\t\tbackground:$danger;\n\t\t\tborder-color:$danger;\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 15px 20px 0 rgba($danger, 0.15);\n\t\t}\n\t}\n\t&-danger-solid{\n\t\t.accordion__header {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: $danger-light;\n\t\t\t\tborder-color: $danger-light;\n\t\t\t\tcolor: #211c37;\n\t\t\t\tbox-shadow:none;\n\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground: $danger-opacity;\n\t\t\t\t\tborder-color: $danger-opacity;\n\t\t\t\t\tcolor:$body-color;\n\t\t\t\t}\n\t\t\t}\n\t\t\tbackground:$danger;\n\t\t\tborder-color:$danger;\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 -10px 20px 0 rgba($danger, 0.15);\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t}\n\t\t.accordion__body {\n            border: 2px solid $danger;\n            border-top: none;\n\t\t\tbox-shadow:0 15px 20px 0 rgba($danger, 0.15);\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n\t\t}\n\t}\n\n\n    //a single accrodion\n    &__item {\n        margin-bottom: 1.25rem;\n    }\n\n    //accrodion header styles\n    &__header {\n        padding:1rem 1.75rem;\n        border: 1px solid $border;\n        cursor: pointer;\n        position: relative;\n        color: $heading;\n        font-weight: 400;\n\t\tborder-radius:$radius;\n\t\t@include transitionMedium;\n        @at-root [data-theme-version=\"dark\"] & {\n            color: $white;\n            border-color: $d-border;\n        }\n        \n        \n\n        //set the indicator font family\n        &--indicator {\n            font-family: 'themify';\n            position: absolute;\n            right: 1.5625rem;\n            top: 50%;\n            transform: translateY(-50%);\n\t\t\t@at-root [direction=\"rtl\"] & {\n\t\t\t\t right:auto;\n\t\t\t\t left: 1.5625rem;\n\t\t\t}\n            &.indicator_bordered {\n                display: inline-block;\n                width: 25px;\n                text-align: center;\n                height: 25px;\n                border: 1px solid $border;\n                border-radius: 50%;\n                line-height: 25px;\n            }\n        }\n\n        &:not(.collapsed) {\n            .accordion__header--indicator {\n                &::before {\n                    content: \"\\e622\";\n                }\n\n                //icon style\n                &.style_two {\n                    &::before {\n                        content: \"\\e648\";\n                    }\n                }\n            }\n        }\n\n        &.collapsed {\n            .accordion__header--indicator {\n                &::before {\n                    content: \"\\e61a\";\n                }\n\n                //icon style\n                &.style_two {\n                    &::before {\n                        content: \"\\e64b\";\n                    }\n                }\n            }\n        }\n    }\n\n    //accordion body styles\n    &__body {\n        &--text {\n            padding: 0.875rem 1.25rem;\n        }\n        \n    }\n\n    //accrodion with border\n    &-bordered {\n        .accordion__body {\n            border: 1px solid $border;\n            border-top: none;\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n            @at-root [data-theme-version=\"dark\"] & {\n                border-color: $d-border;\n            }\n        }\n\t\t.accordion__header.collapsed{\n\t\t\tborder-radius:$radius;\n\t\t}\n\t\t.accordion__header{\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t}\n\t\t\n    }\n\n    //accrodion without space\n    &-no-gutter {\n        .accordion__item {\n            margin-bottom: 0;\n\n            .accordion__header {\n                &.collapsed {\n                    border-bottom: none;\n                }\n            }\n\n            &:last-child {\n                .accordion__header {\n                    border-bottom: 1px solid $border;\n                    @at-root [data-theme-version=\"dark\"] & {\n                        border-color: $d-border;\n                    }\n                }\n            }\n            \n        }\n    }\n\n    //not gutter and bordered\n    &-no-gutter.accordion__bordered {\n        .accordion__item {\n            &:not(:last-child) {\n                .accordion__body {\n                    border-bottom: none;\n                }\n            }\n        }\n    }\n\n    //indicator in left positon\n    &-left-indicator {\n        .accordion__header {\n            &--text {\n                padding-left: 2.5rem;\n            }\n\n            &--indicator {\n                right: auto;\n                left: 1.5625rem;\n            }\n        }\n    }\n\n    //with icon\n    &-with-icon {\n        .accordion__header {\n            &--text {\n                padding-left: 2.5rem;\n\t\t\t\t@at-root [direction=\"rtl\"] & {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tpadding-right: 2.5rem;\n\t\t\t\t}\n            }\n\n            &--icon {\n                position: absolute;\n                right: auto;\n                left: 1.5625rem;\n                font-family: 'themify';\n\t\t\t\t@at-root [direction=\"rtl\"] & {\n\t\t\t\t\tleft: auto;\n\t\t\t\t\tright: 1.5625rem;\n\t\t\t\t}\n                &::before {\n                    content: \"\\e645\";\n                }\n            }\n        }\n\n    }\n\n    //with header background\n    &-header-bg {\n        .accordion__header {\n            background-color: $light;\n            @at-root [data-theme-version=\"dark\"] & {\n                background-color: $d-bg;\n                color: $white;\n            }\n            \n            &--primary {\n                background-color: $primary;\n                color: $white;\n\t\t\t\tborder-color:$primary;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground-color: $primary;\n\t\t\t\t}\n            }\n            \n            &--info {\n                background-color: $info;\n                color: $white;\n\t\t\t\tborder-color:$info;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground-color: $info;\n\t\t\t\t}\n            }\n\n            &--success {\n                background-color: $success;\n                color: $white;\n\t\t\t\tborder-color:$success;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground-color: $success;\n\t\t\t\t}\n            }\n        }\n    }\n\n    //with header background and no space\n    &-header-bg.accordion-no-gutter {\n        .accordion__header {\n            border-color: transparent;\n\t\t\tborder-radius: 0;\n        }\n\t\t.accordion__item{\n\t\t\t&:first-child{\n\t\t\t\t.accordion__header{\n\t\t\t\t\tborder-top-left-radius:$radius;\n\t\t\t\t\tborder-top-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child{\n\t\t\t\t.accordion__header{\n\t\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n    }\n\t&.accordion-no-gutter {\n        .accordion__header {\n            border-radius: 0;\n        }\n\t\t.accordion__header.collapsed {\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t.accordion__body{\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t.accordion__item{\n\t\t\t&:first-child{\n\t\t\t\t.accordion__header{\n\t\t\t\t\tborder-top-left-radius:$radius;\n\t\t\t\t\tborder-top-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child{\n\t\t\t\t.accordion__header.collapsed{\n\t\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t}\n\t\t\t\t.accordion__body{\n\t\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n    }\n    //with solid background\n    &-solid-bg {\n        .accordion__header {\n            border-color: transparent;\n            background-color: $primary-light;\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t\t\n            @at-root [data-theme-version=\"dark\"] & {\n                background-color: $d-bg;\n            }\n\t\t\t&.collapsed{\n\t\t\t\tborder-radius:$radius;\n\t\t\t}\n        }\n\t\t\n        .accordion__body {\n            border-color: transparent;\n            background-color: $primary-light;\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n            @at-root [data-theme-version=\"dark\"] & {\n                background-color: $d-bg;\n            }\n        }\n    }\n\n    //active header styles\n    &-active-header {\n        .accordion__header {\n            &:not(.collapsed) {\n                background-color: $info;\n                border-color: $info;\n                color: $white;\n            }\n        }\n    }\n\n    //shadow in header\n    &-header-shadow {\n        .accordion__header {\n            border: none;\n            box-shadow: 0 0 0.9375rem -3px rgba($color: $black, $alpha: .3);\n        }\n    }\n\n    //stylishly rounded borders\n    &-rounded-stylish {\n        .accordion__header {\n            border-top-left-radius: 0.375rem;\n            border-top-right-radius: 0.375rem;\n        }\n\n        .accordion__body {\n            border-bottom-left-radius: 0.375rem;\n            border-bottom-right-radius: 0.375rem;\n        }\n    }\n\n    //smothly rounded accrodion header\n    &-rounded {\n        .accordion__header {\n            border-radius: 0.3125rem;\n        }\n    }\n\n    //accordion gradient\n    &-gradient {\n        .accordion__header {\n            color: $white;\n            background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%,rgba(103, 25, 255, .85) 100%);\n            border-color: transparent;\n\t\t\tborder-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n\t\t\t&.collapsed{\n\t\t\t\tborder-bottom-left-radius: $radius;\n\t\t\t\tborder-bottom-right-radius: $radius;\n\t\t\t}\n        }\n\n        .accordion__body {\n            color: $white;\n            background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%,rgba(103, 25, 255, .85) 100%);\n            border-color: transparent;\n        }\n    }\n\t\n} ","\n\n.alert{\n    border-radius: $radius;\n\tpadding:1rem 3rem 1rem 1.5rem;\n\tp{\n\t\tline-height:1.5;\n\t}\n}\n.alert-square{\n\n}\n\n.alert-rounded{\n    border-radius: 30px;\n}\n\n// Basic Alert\n\n\n.alert-primary{\n    background: $primary-light;\n    border-color: $primary-light;\n    color: $primary;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $primary-opacity;\n\t\tborder-color: $primary-opacity;\n\t}\n}\n\n.alert-secondary{\n    background: $secondary-light;\n    border-color: $secondary-light;\n    color: $secondary;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $secondary-opacity;\n\t\tborder-color: $secondary-opacity;\n\t\tcolor:$body-color;\n\t}\n}\n\n\n.alert-success{\n    background: $success-light;\n    border-color: $success-light;\n    color: $success;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $success-opacity;\n\t\tborder-color: $success-opacity;\n\t}\n}\n\n.alert-warning{\n    background: $warning-light;\n    border-color: $warning-light;\n    color: $warning;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $warning-opacity;\n\t\tborder-color: $warning-opacity;\n\t}\n}\n\n.alert-danger{\n    background: $danger-light;\n    border-color: $danger-light;\n    color: $danger;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $danger-opacity;\n\t\tborder-color: $danger-opacity;\n\t}\n}\n\n.alert-info{\n    background: $info-light;\n    border-color:  $info-light;\n    color: $info;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $info-opacity;\n\t\tborder-color: $info-opacity;\n\t}\n}\n\n.alert-dark{\n    background:  $dark-light;\n    border-color:  $dark-light;\n    color: $dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $dark-opacity;\n\t\tborder-color: $dark-opacity;\n\t\tcolor:$body-color;\n\t}\n}\n.alert-light{\n    background: $light;\n    border-color: $light;\n    color: $dark;\n\t\n}\n\n\n// Alert alt\n\n.alert-alt.alert-primary{\n    border-left: 4px solid $primary;\n}\n\n.alert-alt.alert-secondary{\n    border-left: 4px solid $secondary;\n}\n\n\n.alert-alt.alert-success{\n    border-left: 4px solid $success\n}\n\n.alert-alt.alert-warning{\n    border-left: 4px solid $warning;\n}\n\n.alert-alt.alert-danger{\n    border-left: 4px solid $danger;\n}\n\n.alert-alt.alert-info{\n    border-left: 4px solid $info;\n}\n\n.alert-alt.alert-dark{\n    border-left: 4px solid $dark;\n}\n.alert-alt.alert-light{\n    border-left: 4px solid darken($light,15%);\n}\n\n\n\n// Alert alt with solid color\n\n.alert-alt.alert-primary.solid{\n    border-left: 4px solid darken($primary,25%)!important;\n}\n\n.alert-alt.alert-secondary.solid{\n    border-left: 4px solid darken($secondary,25%)!important;\n}\n\n\n.alert-alt.alert-success.solid{\n    border-left: 4px solid darken($success, 25%)!important;\n}\n\n.alert-alt.alert-warning.solid{\n    border-left: 4px solid darken($warning,25%)!important;\n}\n\n.alert-alt.alert-danger.solid{\n    border-left: 4px solid darken($danger,25%)!important;\n}\n\n.alert-alt.alert-info.solid{\n    border-left: 4px solid darken($info,25%)!important;\n}\n\n.alert-alt.alert-dark.solid{\n    border-left: 4px solid darken($dark,25%)!important;\n}\n.alert-alt.alert-light.solid{\n    border-left: 4px solid darken($light,25%)!important;\n}\n\n\n//Alert dismissable with solid color\n.alert-dismissible.solid{\n    .close{\n        &:hover{\n            color: $white;\n            opacity: 1;\n        }\n    }\n}\n\n\n\n\n\n\n// Alert Solid \n.alert.alert-primary.solid{\n    background: $primary;\n    color: $white;\n    border-color: $primary;\n}\n\n.alert.alert-secondary.solid{\n    background: $secondary;\n    color: $white;\n    border-color: $secondary;\n}\n.alert.alert-success.solid{\n    background: $success;\n    color: $white;\n    border-color: $success;\n}\n\n.alert.alert-warning.solid{\n    background: $warning;\n    color: $white;\n    border-color: $warning;\n}\n\n.alert.alert-danger.solid{\n    background: $danger;\n    color: $white;\n    border-color: $danger;\n}\n\n.alert.alert-info.solid{\n    background: $info;\n    color: $white;\n    border-color: $info;\n}\n\n\n.alert.alert-dark.solid{\n    background: $dark;\n    color: $white;\n    border-color: $dark;\n}\n\n\n.alert.alert-light.solid{\n    background: $light;\n    color: $dark;\n    border-color: $light;\n}\n\n\n\n\n// Alert right icon\n\n.alert-right-icon{\n    &>span i{\n        font-size: 18px;\n        margin-right: 5px;;\n    }\n    .close{\n        i{\n            font-size: 16px;\n        }\n    }\n}\n\n// Alert Outline\n.alert.alert-outline-primary{\n    background: transparent;\n    color: $primary;\n    border-color: $primary;\n}\n\n\n.alert.alert-outline-secondary{\n    background: transparent;\n    color: $body-color;\n    border-color: $secondary;\n}\n\n\n.alert.alert-outline-success{\n    background: transparent;\n    color: $success;\n    border-color: $success;\n}\n\n\n.alert.alert-outline-info{\n    background: transparent;\n    color: $info;\n    border-color: $info;\n}\n\n\n.alert.alert-outline-warning{\n    background: transparent;\n    color: $warning;\n    border-color: $warning;\n}\n\n.alert.alert-outline-danger{\n    background: transparent;\n    color: $danger;\n    border-color: $danger;\n}\n\n.alert.alert-outline-dark{\n    background: transparent;\n    color: $body-color;\n    border-color: $dark;\n}\n\n.alert.alert-outline-light{\n    background: transparent;\n    color: $dark;\n    border-color: $light;\n}\n\n\n\n// Alert Social\n.alert-social{\n    color: $white;\n    .alert-social-icon{\n        align-self: center;\n        margin-right: 0.9375rem;\n        i{\n            font-size: 42px;\n        }\n    }\n    &.facebook{\n        background-color: $facebook;\n    }\n    &.twitter{\n        background-color: $twitter;\n    }\n    &.linkedin{\n        background-color: $linkedin;\n    }\n    &.google-plus{\n        background-color: $google-plus;\n    }\n    .close{\n        &:hover{\n            opacity: 1!important;\n            color: $white!important;\n        }\n    }\n}\n\n\n// Alert left icon\n\n.left-icon-big{\n    .alert-left-icon-big{\n        align-self: center;\n        margin-right: 0.9375rem;\n        i{\n            font-size: 35px;   \n\t\t\tline-height: 1;\n        }\n\t\t\n        // &.primary{\n        //     background: $primary;\n        //     color: $white;\n        // }\n    }\n    .media-body{\n        // margin-left: 100px;\n    }\n}\n[direction=\"rtl\"]{\n\t.left-icon-big .alert-left-icon-big,\n\t.alert-social .alert-social-icon{\n\t\tmargin-left: 0;\n\t\tmargin-right: 0.9375rem;\n\t}\n}\n\n\n\n\n\n","\n\n\n.badge{\n    line-height: 1.5;\n    border-radius: $radius;\n     font-size: 14px;\n    font-weight: 600;\n    padding: 4px 10px;\n\tborder:1px solid transparent;\n}\n\n.badge-rounded{\n    border-radius: 20px;\n    padding:3px 13px ;\n}\n.badge-circle{\n    border-radius: 100px;\n    padding: 3px 7px;\n}\n\n\n\n\n\n.badge-outline-primary{\n    border: 1px solid $primary;\n    color: $primary;\n}\n.badge-outline-secondary{\n    border: 1px solid $secondary;\n    color: $secondary;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n.badge-outline-success{\n    border: 1px solid $success;\n    color: $success;\n}\n.badge-outline-info{\n    border: 1px solid $info;\n    color: $info;\n}\n.badge-outline-warning{\n    border: 1px solid $warning;\n    color: $warning;\n}\n.badge-outline-danger{\n    border: 1px solid $danger;\n    color: $danger;\n}\n.badge-outline-light{\n    border: 1px solid $border;\n    color: $dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n.badge-outline-dark{\n    border: 1px solid $dark;\n    color: $dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n\n\n\n.badge-xs {\n    font-size: 10px;\n    padding: 0px 5px;\n    line-height: 18px;\n}\n.badge-sm {\n\tfont-size: 11px;\n    padding: 5px 8px;\n    line-height: 11px;\n}\n//.badge-md {\n//    font-size: 13px;\n//    padding: 0px 9px;\n//    line-height: 25px;\n//}\n.badge-lg {\n    font-size: 14px;\n    padding: 0px 10px;\n    line-height: 30px;\n}\n\n\n.badge-xl {\n    font-size: 15px;\n    padding: 0px 15px;\n    line-height: 35px;\n}\n.badge-default{\n    background: #ADB6C7;\n}\n.badge-success {\n    background-color: $success;\n}\n.badge-info {\n    background-color: $info;\n}\n.badge-primary {\n    background-color: $primary;\n}\n.badge-warning {\n    background-color: $warning;\n}\n.badge-danger {\n    background-color: $danger;\n}\n.badge-dark {\n    background-color: $dark;\n}\n.badge-light {\n    background-color: $light;\n}\n\n\n\n.light.badge-default{\n    background: #ADB6C7;\n}\n.light.badge-success {\n    background-color: $success-light;\n\tcolor:$success;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $success-opacity;\n\t}\n}\n.light.badge-info {\n    background-color: $info-light;\n\tcolor:$info;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $info-opacity;\n\t}\n}\n.light.badge-primary {\n    background-color: $primary-light;\n\tcolor:$primary;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $primary-opacity;\n\t}\n}\n.light.badge-secondary {\n    background-color: $secondary-light;\n\tcolor:$secondary;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $secondary-opacity;\n\t\tcolor:$body-color;\n\t}\n}\n.light.badge-warning {\n    background-color: $warning-light;\n\tcolor:$warning;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $warning-opacity;\n\t}\n}\n.light.badge-danger {\n    background-color: $danger-light;\n\tcolor:$danger;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $danger-opacity;\n\t}\n}\n.light.badge-dark {\n    background-color: $dark-light;\n\tcolor:$dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $dark-opacity;\n\t\tcolor:$body-color;\n\t}\n}\n\n\n\n\n\n//\n\n.bootstrap-label{\n    .label{\n        display: inline-block;\n        margin-right: 1rem;\n\n        &:last-child{\n            margin-right: 0;\n        }\n    }\n}\n\n.badge-demo{\n\n    .badge{\n        margin-right: 5px;\n        margin-bottom: 5px;\n\n        &:last-child{\n            margin-right: 0;\n        }\n    }\n}\n\n.bootstrap-badge-buttons{\n\n    button{\n        margin-right: .2rem;\n        margin-bottom: 1rem;\n\n        &:last-child{\n            margin-right: 0;\n        }\n    }\n}","\n.welcome-text{\n\tspan,\n\tp{\n\t\tdisplay:none;\n\t}\n}\n.page-titles {\n    margin-bottom: 25px;\n    display: block;\n    margin-left: -40px;\n    margin-right: -40px;\n    padding: 20px 40px;\n    margin-top: -15px;\n    background: $body-bg;\n    display: block;\n\t\n\t\n\t\n\t\n\t[class*=\"col-\"]{\n\t\tdisplay: block !important;\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t\tmargin: 0;\n\t}\n\t@include custommq($max: 1600px) {\n\t\tmargin-left: -30px;\n\t\tmargin-top: 0px;\n\t\tmargin-right: -30px;\n\t\tmargin-bottom: 30px;\n\t\tpadding: 15px 30px;\n\t}\n    @include respond('phone-land') {\n        margin-left: -15px;\n\t\tmargin-top: -15px;\n\t\tmargin-right: -15px;\n\t\tmargin-bottom: 0px;\n\t\tpadding: 15px;\n    }\n\n    .justify-content-sm-end{\n        align-items: center;\n    }\n\n    h4 {\n        margin-bottom: 10px;\n\t\tmargin-top: 0;\n\t\tcolor: #000;\n\t\tfont-size: 1.75rem;\n\t\tfont-weight: 600;\n\t\t\n        span {\n            font-size: 1.25rem;\n        }\n    }\n    .breadcrumb {\n        margin-bottom: 0;\n        padding: 0;\n        background: transparent;\n        // font-size: 0.875rem;\n        li {\n            margin-top: 0;\n            margin-bottom: 0;\n\t\t\tfont-size: 18px;\n\t\t\t@include respond('phone-land') {\n\t\t\t\tfont-size: 15px;\n\t\t\t}\n            a{\n               color: #656773; \n\n            }\n\n            &.active a{\n                color: $primary;\n\t\t\t\tfont-weight:600;\n            }\n        }\n        \n        /* .breadcrumb-item + .breadcrumb-item {\n            &:before {\n                content: \"\\e606\";\n                font-family: 'simple-line-icons';\n                // font-weight: 4;\n                font-size: 10px;\n            }\n        } */\n\n        &-datepicker{\n            font-size: 0.75rem;\n            color: $muted;\n\n            &__icon{\n                font-size: 0.875rem;\n            }\n        }\n    }\n\n    .breadcrumb-widget{\n        .border-dark{\n            border-color: $gray-300!important;\n        }\n        h4{\n            color: $strong;\n            font-weight: 600;\n        }\n        @include respond('phone') {\n            text-align: left!important;\n            margin-bottom: 0.9375rem;\n        }\n    }\n    \n}\n\n","// .qx_btn{\n//     min-height: 50px;\n//     min-width: 100px;\n//     // font-weight: 700;\n//     font-size: 16px;\n// }\n\n\nbutton{\n    cursor: pointer;\n\n    &:focus{\n        outline: 0;\n        box-shadow: none;\n    }\n}\n\n.btn-primary{\n\tcolor:$white;\n}\n\n\n.btn {\n\tpadding:0.938rem 1.5rem;\n\tborder-radius: $radius;\n\tfont-weight:500;\n\tfont-size:1rem;\n    // border-radius: 0px;\n    // box-shadow: 0 4px 6px rgba(50,50,93,.05), 0 1px 3px rgba(0,0,0,.08);\n    &:hover, &:focus, &:active, &.active{\n        outline: 0!important;\n        // box-shadow: 0 4px 05x rgba(50,50,93,.05), 0 1px 3px rgba(0,0,0,.08);\n    }\n\t\n\t@include respond('laptop') {\n\t\tpadding: 0.625rem 1rem;\n\t\tfont-size: 0.813rem;\n\t}\n\t\n    &-transparent {\n        background-color: transparent;\n    }\n\n\n}\n\n.sharp {\n\tmin-width: 40px;\n    padding: 7px;\n    height: 40px;\n    min-height: 40px;\n}\n.sharp.btn-xs{\n    padding: 3px;\n    width: 26px;\n    height: 26px;\n    min-width: 26px;\n    min-height: 26px;\n}\n.light{\n\n\t&.tp-btn{\n\t\tbackground-color:transparent;\n\t}\n\t&.btn-default{\n\t\tbackground: #ADB6C7;\n\t}\n\t&.btn-success {\n\t\tbackground-color: $success-light;\n\t\tborder-color: $success-light;\n\t\tcolor:$success;\n\t\tg [fill]{\n\t\t\tfill:$success;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $success-opacity;\n\t\t\tborder-color: transparent;\n\t\t}\n\n\t\t&:hover{\n\t\t\tbackground-color: $success;\n\t\t\tborder-color: $success;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-info {\n\t\tbackground-color: $info-light;\n\t\tborder-color: $info-light;\n\t\tcolor:$info;\n\t\tg [fill]{\n\t\t\tfill:$info;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $info-opacity;\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $info;\n\t\t\tborder-color: $info;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-primary {\n\t\tbackground-color: $primary-light;\n\t\tborder-color: $primary-light;\n\t\tcolor:$primary;\n\t\tg [fill]{\n\t\t\tfill:$primary;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $primary-opacity;\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $primary;\n\t\t\tborder-color: $primary;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-secondary {\n\t\tbackground-color: $secondary-light;\n\t\tborder-color: $secondary-light;\n\t\tcolor:$secondary;\n\t\tg [fill]{\n\t\t\tfill:$secondary;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $secondary-opacity;\n\t\t\tborder-color:transparent;\n\t\t\tcolor:$white;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $secondary;\n\t\t\tborder-color: $secondary;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-warning {\n\t\tbackground-color: $warning-light;\n\t\tborder-color: $warning-light;\n\t\tcolor:$warning;\n\t\tg [fill]{\n\t\t\tfill:$warning;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $warning-opacity;\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $warning;\n\t\t\tborder-color: $warning;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-danger {\n\t\tbackground-color: $danger-light;\n\t\tborder-color: $danger-light;\n\t\tcolor:$danger;\n\t\tg [fill]{\n\t\t\tfill:$danger;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $danger-opacity;\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $danger;\n\t\t\tborder-color: $danger;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t\tsvg path{\n\t\t\t\tfill:$white;\n\t\t\t}\t\n\t\t}\n\t}\n\t&.btn-dark {\n\t\tbackground-color: $dark-light;\n\t\tborder-color: $dark-light;\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $dark-opacity;\n\t\t\tborder-color:transparent;\n\t\t\tcolor:$white;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $dark;\n\t\t\tborder-color: $dark;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n.btn.tp-btn{\n\tbackground-color:transparent;\n\tborder-color: transparent;\n\t&.btn-default{\n\t\tbackground: #ADB6C7;\n\t}\n\t&.btn-success {\n\t\tcolor:$success;\n\t\tg [fill]{\n\t\t\tfill:$success;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $success;\n\t\t\tborder-color: $success;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-info {\n\t\tcolor:$info;\n\t\tg [fill]{\n\t\t\tfill:$info;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $info;\n\t\t\tborder-color: $info;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-primary {\n\t\tcolor:$primary;\n\t\tg [fill]{\n\t\t\tfill:$primary;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $primary;\n\t\t\tborder-color: $primary;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-secondary {\n\t\tcolor:$secondary;\n\t\tg [fill]{\n\t\t\tfill:$secondary;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $secondary;\n\t\t\tborder-color: $secondary;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-warning {\n\t\tcolor:$warning;\n\t\tg [fill]{\n\t\t\tfill:$warning;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $warning;\n\t\t\tborder-color: $warning;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-danger {\n\t\tcolor:$danger;\n\t\tg [fill]{\n\t\t\tfill:$danger;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $danger;\n\t\t\tborder-color: $danger;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-light {\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $light;\n\t\t\tborder-color: $light;\n\t\t\tcolor: $dark;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-dark {\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $dark;\n\t\t\tborder-color: $dark;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n.btn.tp-btn-light{\n\tbackground-color:transparent;\n\tborder-color: transparent;\n\t\n\t&.btn-success {\n\t\tcolor:$success;\n\t\tg [fill]{\n\t\t\tfill:$success;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $success-light;\n\t\t\tborder-color: $success-light;\n\t\t\tcolor:$success;\n\t\t\tg [fill]{\n\t\t\t\tfill:$success;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-info {\n\t\tcolor:$info;\n\t\tg [fill]{\n\t\t\tfill:$info;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $info-light;\n\t\t\tborder-color: $info-light;\n\t\t\tcolor:$info;\n\t\t\tg [fill]{\n\t\t\t\tfill:$info;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-primary {\n\t\tcolor:$primary;\n\t\tg [fill]{\n\t\t\tfill:$primary;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $primary-light;\n\t\t\tborder-color: $primary-light;\n\t\t\tcolor:$primary;\n\t\t\tg [fill]{\n\t\t\t\tfill:$primary;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-secondary {\n\t\tcolor:$secondary;\n\t\tg [fill]{\n\t\t\tfill:$secondary;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $secondary-light;\n\t\t\tborder-color: $secondary-light;\n\t\t\tcolor:$secondary;\n\t\t\tg [fill]{\n\t\t\t\tfill:$secondary;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-warning {\n\t\tcolor:$warning;\n\t\tg [fill]{\n\t\t\tfill:$warning;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $warning-light;\n\t\t\tborder-color: $warning-light;\n\t\t\tcolor:$warning;\n\t\t\tg [fill]{\n\t\t\t\tfill:$warning;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-danger {\n\t\tcolor:$danger;\n\t\tg [fill]{\n\t\t\tfill:$danger;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $danger-light;\n\t\t\tborder-color: $danger-light;\n\t\t\tcolor:$danger;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-dark {\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $dark-light;\n\t\t\tborder-color: $dark-light;\n\t\t\tcolor: $dark;\n\t\t\t[fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.shadow.btn-primary {\n    -webkit-box-shadow: 0 5px 15px 0 rgba($primary,0.2) !important;\n    box-shadow: 0 5px 15px 0 rgba($primary,0.2) !important;\n}\n.shadow.btn-secondary {\n    -webkit-box-shadow: 0 5px 15px 0 rgba($secondary,0.2) !important;\n    box-shadow: 0 5px 15px 0 rgba($secondary,0.2) !important;\n}\n.shadow.btn-warning {\n    -webkit-box-shadow: 0 5px 15px 0 rgba($warning,0.2) !important;\n    box-shadow: 0 5px 15px 0 rgba($warning,0.2) !important;\n}\n.shadow.btn-danger {\n    -webkit-box-shadow: 0 5px 15px 0 rgba($danger,0.2) !important;\n    box-shadow: 0 5px 15px 0 rgba($danger,0.2) !important;\n}\n.shadow.btn-info {\n    -webkit-box-shadow: 0 5px 15px 0 rgba($info,0.2) !important;\n    box-shadow: 0 5px 15px 0 rgba($info,0.2) !important;\n}\n.shadow.btn-success {\n    -webkit-box-shadow: 0 5px 15px 0 rgba($success,0.2) !important;\n    box-shadow: 0 5px 15px 0 rgba($success,0.2) !important;\n}\n\n\n\n.btn-xxs {\n    padding: 6px 15px;\n    font-size: 11px;\n    line-height: 1.3;\n}\n.btn-xs {\n    font-size: 0.75rem;\n    padding: 0.438rem 1rem;\n    // padding  : 0.5 2.5rem !important;\n\tfont-weight: 600;\n\t@include respond('laptop') {\n\t\tfont-size: 0.75rem;\n\t\tpadding: 0.25rem 0.5rem;\n\t\tfont-weight: 500;\n\t}\n}\n\n.btn-sm {\n    font-size: 0.813rem  !important;\n\tpadding:0.625rem 1rem;\n\t@include respond('laptop') {\n\t\tpadding: 0.375rem 1rem;\n\t\tfont-size: 0.75rem;\n\t}\n}\n.btn-md {\n    font-size: 0.813rem  !important;\n\tpadding: 0.875rem 1.25rem;\n\t@include respond('laptop') {\n\t\tpadding: 0.5rem 1rem;\n\t\tfont-size: 0.813rem;\n\t}\n}\n.btn-lg{\n    padding: 1rem 2rem;\n    font-size: 1.125rem !important;\n\t@include respond('laptop') {\n\t\tpadding: 0.75rem 1.5rem;\n\t\tfont-size: 1rem !important;\n\t}\n}\n\n.btn-xl{\n    padding: 0.6rem 1rem;\n\n    &.btn-default{\n        font-weight: 600;\n    }\n}\n\n.btn-square {\n    border-radius: 0;\n}\n\n.btn-rounded {\n    border-radius: 30px !important;\n}\n\n.btn-icon-right {\n\tborder-left: 1px solid white;\n    display: inline-block;\n    margin: -.8rem 0 -.8rem 1rem;\n    padding: 0.4375rem 0 0.4375rem 1rem;\n    margin: -1rem -0.25rem -1rem 1rem;\n    padding: 1rem 0 1rem 1.25rem;\n\t@include respond ('laptop'){\n\t\tpadding: 1rem 0 1rem 0.6rem;\n\t}\n}\n\n.btn-icon-left {\n    background: #fff;\n    border-radius: 10rem;\n    display: inline-block;\n    margin: -0.5rem 0.75rem -0.5rem -1.188rem;\n    padding: 0.5rem 0.80rem 0.5rem;\n    float: left;\n\t@include respond('tab-land') {\n\t\tmargin: -0.5rem 0.75rem -0.5rem -0.800rem;\n\t}\n}\n[direction=\"rtl\"]{\n\t.btn-icon-left {\n\t\tmargin: -.5rem -1.5rem -.5rem 1rem;\n\t}\n\t.btn-icon-right {\n\t\tborder-left: 0px solid white;\n\t\tdisplay: inline-block;\n\t\tmargin: -.8rem 1rem -.8rem 0;\n\t\tpadding: 0.4375rem 1rem 0.4375rem 0;\n\t\tborder-right: 1px solid white;\n\t}\n}\n.toggle-dropdown::after {\n    margin-left: 0.755em;\n}\n\n.social-btn-icon {\n    .btn {\n        min-width    : 7.5rem;\n        margin-bottom: 1.5rem;\n    }\n}\n\n.social-icon {\n    .btn {\n        padding: .7rem 1.4rem;\n    }\n}\n\n.btn-circle {\n    height       : 5rem;\n    width        : 5rem;\n    border-radius: 50% !important;\n\n    &-sm {\n        width: 4.5rem;\n        height: 4.5rem;\n        font-size: 1.8rem;\n    }\n\n    &-md {\n        width: 6rem;\n        height: 6rem;\n        font-size: 2.5rem;\n\n        i{\n            font-size: 2.4rem;\n        }\n    }\n\n    &-lg {\n        width: 8rem;\n        height: 8rem;\n        font-size: 3.2rem;\n\n        i{\n            font-size: 3.1rem;\n        }\n    }\n}\n\n.btn-page{\n    .btn{\n        min-width: 110px;\n        margin-right: 4px;\n        margin-bottom: 8px;\n\n    }\n\n}\n\n\n\n// btn sizes\n.size-1{\n    min-width: 160px !important;\n    font-size: 24px;\n    padding: 0.68rem 0.75rem;\n}\n\n.size-2{\n    font-size: 20px;\n    min-width: 130px !important;\n    padding: 0.57rem 0.75rem;\n}\n\n.size-3{\n    font-size: 14px;\n    min-width: 110px !important;\n    padding: 0.536rem 0.75rem;\n}\n.size-4{\n    font-size: 14px;\n    min-width: 100px !important;\n}\n.size-5{\n    font-size: 14px;\n    min-width: 90px !important;\n    padding: .22rem 0.75rem;\n}\n.size-6{\n    font-size: 13px;\n    min-width: 80px !important;\n    padding: 0.097rem 0.75rem;\n}\n.size-7{\n    font-size: 12px;\n    min-width: 60px !important;\n    padding: 0.001rem 0.75rem;\n}\n\n\n\n\n\n.btn-light {\n    background  : $light;\n    border-color: $light;\n    \n    \n    &:active,\n    &:focus,\n    &:hover {\n        background  : lighten($light, 25%);\n        border-color: lighten($light, 25%);\n    }\n}\n.btn-outline-primary{\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.btn-outline-light{\n    color: $dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n.btn-outline-secondary{\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n.btn-outline-dark{\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n\n\n.btn-dark {\n    background  : $dark;\n    border-color: $dark;\n    color       : $white;\n    \n    \n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($dark, 10%);\n        color       : $white;\n        border-color: darken($dark, 10%);\n    }\n}\n\n.btn-group{\n\n    &.btn-rounded{\n\n        .btn:first-child{\n            border-top-left-radius: 30px;\n            border-bottom-left-radius: 30px;\n        }\n\n        .btn:last-child{\n            border-top-right-radius: 30px;\n            border-bottom-right-radius: 30px;\n        }\n    }\n}\n\n\n\n///////////////////\n// Social Buttons\n///////////////////\n\n.btn-facebook {\n    background  : $facebook;\n    border-color: $facebook;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($facebook, 10%);\n        color       : $white;\n        border-color: darken($facebook, 10%);\n    }\n}\n\n.btn-twitter {\n    background  : $twitter;\n    border-color: $twitter;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($twitter, 10%);\n        color       : $white;\n        border-color: darken($twitter, 10%);\n    }\n}\n\n.btn-youtube {\n    background  : $youtube;\n    border-color: $youtube;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($youtube, 10%);\n        color       : $white;\n        border-color: darken($youtube, 10%);\n    }\n}\n\n.btn-instagram {\n    background  : $instagram;\n    border-color: $instagram;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($instagram, 10%);\n        color       : $white;\n        border-color: darken($instagram, 10%);\n    }\n}\n\n.btn-pinterest {\n    background  : $pinterest;\n    border-color: $pinterest;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($pinterest, 10%);\n        color       : $white;\n        border-color: darken($pinterest, 10%);\n    }\n}\n\n.btn-linkedin {\n    background  : $linkedin;\n    border-color: $linkedin;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($linkedin, 10%);\n        color       : $white;\n        border-color: darken($linkedin, 10%);\n    }\n}\n\n.btn-google-plus {\n    background  : $google-plus;\n    border-color: $google-plus;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($google-plus, 10%);\n        color       : $white;\n        border-color: darken($google-plus, 10%);\n    }\n}\n\n.btn-google {\n    background  : $google;\n    border-color: $google;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($google, 10%);\n        color       : $white;\n        border-color: darken($google, 10%);\n    }\n}\n\n.btn-snapchat {\n    background  : $snapchat;\n    border-color: $snapchat;\n    color       : $black;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($snapchat, 10%);\n        color       : $black;\n        border-color: darken($snapchat, 10%);\n    }\n}\n\n.btn-whatsapp {\n    background  : $whatsapp;\n    border-color: $whatsapp;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($whatsapp, 10%);\n        color       : $white;\n        border-color: darken($whatsapp, 10%);\n    }\n}\n\n.btn-tumblr {\n    background  : $tumblr;\n    border-color: $tumblr;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($tumblr, 10%);\n        color       : $white;\n        border-color: darken($tumblr, 10%);\n    }\n}\n\n.btn-reddit {\n    background  : $reddit;\n    border-color: $reddit;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($reddit, 10%);\n        color       : $white;\n        border-color: darken($reddit, 10%);\n    }\n}\n\n.btn-spotify {\n    background  : $spotify;\n    border-color: $spotify;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($spotify, 10%);\n        color       : $white;\n        border-color: darken($spotify, 10%);\n    }\n}\n\n.btn-yahoo {\n    background  : $yahoo;\n    border-color: $yahoo;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($yahoo, 10%);\n        color       : $white;\n        border-color: darken($yahoo, 10%);\n    }\n}\n\n.btn-dribbble {\n    background  : $dribbble;\n    border-color: $dribbble;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($dribbble, 10%);\n        color       : $white;\n        border-color: darken($dribbble, 10%);\n    }\n}\n\n.btn-skype {\n    background  : $skype;\n    border-color: $skype;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($skype, 10%);\n        color       : $white;\n        border-color: darken($skype, 10%);\n    }\n}\n\n.btn-quora {\n    background  : $quora;\n    border-color: $quora;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($quora, 10%);\n        color       : $white;\n        border-color: darken($quora, 10%);\n    }\n}\n\n.btn-vimeo {\n    background  : $vimeo;\n    border-color: $vimeo;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($vimeo, 10%);\n        color       : $white;\n        border-color: darken($vimeo, 10%);\n    }\n}",".card {\n    margin-bottom: 1.875rem;\n    background-color: $white;\n    transition: all .5s ease-in-out;\n    position: relative;\n    border: 0px solid transparent;\n    border-radius:$radius;\n    box-shadow: 0px 12px 23px 0px rgba($secondary,0.04);\n\theight: calc(100% - 30px);\n\t\n\t// z-index: 0;\n\t@include custommq($max: 575px) {\n\t\tmargin-bottom:0.938rem;\n\t\theight: calc(100% - 0.938rem);\n\t}\n\n    &-body {\n        padding: 1.875rem;\n\t\t@include respond('phone') {\n\t\t\tpadding: 1rem;\n\t\t}\n    }\n\n    &-title {\n        font-size: 20px;\n        font-weight: 500;\n        // line-height: 2.2rem;\n        color: #000;\n        text-transform: capitalize;\n        // margin-bottom: 1.5rem;\n    \n        &--large{\n            font-size: 1.5rem;\n        }\n    \n        &--medium{\n            font-size: 1rem;\n        }\n    \n        &--small{\n            font-size: 0.875rem;\n        }\n    }\n\n    &-header {\n        border-color: $border;\n        position: relative;\n        background: transparent;\n        padding:1.5rem 1.875rem 1.25rem;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        // min-height: 65px;\n\t\t@include respond('phone') {\n\t\t\tpadding: 1.25rem 1rem 1.25rem;\n\t\t}\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n\n        .card-title{\n            margin-bottom: 0px;\n        }\n        .subtitle{\n            padding-top: 5px;\n            font-size: 14px;\n\t\t\tline-height: 1.5;\n        }\n    }\n\n    &-footer {\n        border-color: $border;\n        background: transparent;\n        padding: 1.25rem 1.875rem 1.25rem;\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n\t\t@include respond('phone') {\n\t\t\tpadding: 1rem;\n\t\t}\n    }    \n}\n\n.transparent-card{\n    &.card{\n        background: transparent;\n        border: 1px solid transparent;\n        box-shadow: none;\n    }\n}\n\n\n\n\n///////////////////\n//  Card action\n///////////////////\n.card-action {\n    > a {\n        display: inline-block;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        border-radius: 5px;\n        border-color: transparent;\n        text-align: center;\n        background: darken($primary,57%);\n        color: $white;\n        margin-right: 8px;\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg;\n        }\n\n        &:last-child{\n            margin-right: 0;\n        }\n        &:hover,&:focus{\n            background: darken($primary,57%);\n\n            @at-root [data-theme-version=\"dark\"] & {\n                background: $d-bg;\n            }\n        }\n\n\n        i,span{\n            font-size: 1rem;\n            // color: #333333;\n        }\n        // padding: 0 .5rem;\n    }\n\n    .dropdown{\n        width: 30px;\n        height: 30px;\n        border-radius: 5px;\n        border-color: transparent;\n        text-align: center;\n        margin-right: 8px;\n        top: -2px;\n        position: relative;\n        display: inline-block;\n        background: darken($primary,57%);\n        color: $primary;\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg;\n        }\n        \n        &:hover,&:focus{\n            background: darken($primary,57%);\n\n            @at-root [data-theme-version=\"dark\"] & {\n                background: $d-bg;\n            }\n        }\n\n        .btn{\n            padding: 0;\n            line-height: 27px;\n            color: $white;\n\n            &:focus{\n                box-shadow: none;\n            }\n        }\n    }\n}\n\n.card-fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 99999999;\n    overflow: auto;\n}\n\n.card-loader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.75);\n    z-index: 999\n}\n\n.card-loader i {\n    margin: 0 auto;\n    background: darken($primary,7%);\n    padding: 10px;\n    border-radius: 50%;\n    color: $white;\n    font-size: 1rem\n}\n\n.rotate-refresh {\n    -webkit-animation: mymove 0.8s infinite linear;\n    animation: mymove 0.8s infinite linear;\n    display: inline-block\n}\n\n.card-header {\n    .date_picker {\n        display: inline-block;\n        padding: 8px;\n        border: 1px solid $border;\n        cursor: pointer;\n        border-radius: .375rem;\n    }\n\t.border-0{\n\t\tpadding-bottom:0;\n\t}\n}\n\n\n@-webkit-keyframes mymove {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes mymove {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg)\n    }\n}",".carousel-custom{\n\n    &-prev, &-next{\n        width: 2.5rem;\n        height: 2.5rem;\n        line-height: 2.5rem;\n        display: inline-block;\n        border-radius: 50%;\n        background: $white;\n        text-align: center;\n\n        i{\n            font-size: 1rem;\n        }\n\n        &:hover{\n            background: linear-gradient(to right, rgba(245, 60, 121, 0.99) 0%, rgba(246, 104, 47, 0.99) 100%);\n            color: $white;\n        }\n    }\n\n    &-next{\n        position: absolute;\n        top: 50%;\n        right: 30px;\n        transform: translateY(-50%);\n    }\n\n    &-prev{\n        position: absolute;\n        top: 50%;\n        left: 30px;\n        transform: translateY(-50%);\n    }\n}\n\n\n.carousel-caption{\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.78);\n\tz-index:0;\n\n    h5{\n        color: $white;\n        font-size: 1.8rem;\n    }\n\n    p{\n        margin-bottom: 0;\n    }\n}",".dropdown-toggle:focus {\n    box-shadow: none!important;\n  }\n\n  .dropdown-outline{\n      border: .1rem solid $primary;\n  }\n\n.dropdown-menu{\n\tfont-size: inherit;\n\tborder: 0;\n\tbox-shadow: 0 10px 40px 0 rgba(32,28,69,0.1);\n\tmargin-top:0;\n\tborder-radius: 0;\n\t\t\n\t.dropdown-item{\n\t\tfont-size: 16px;\n\t\tcolor:$body-color;\n\t\tpadding: 0.5rem 1.75rem;\n\t\t\n\t\t@include respond('laptop') {\n\t\t\tpadding: 0.375rem 1rem;\n\t\t\tfont-size: 14px;\n\t\t}\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active,\n\t\t&.active{\n\t\t\tcolor: $primary;\n\t\t\tbackground:#F4F5F9;\n\t\t}\n\t\t&.active, \n\t\t&:active{\n\t\t\tcolor: $primary  !important;\n\t\t}\n\t}\n\t\n\t@at-root [direction=\"rtl\"] #{&} {\n\t\tright: auto !important;\n\t}\n}\n\n////////////////////\n// Custom Dropdown\n///////////////////\n.dropdown-toggle-split {\n    padding: 0 10px;\n    opacity: 0.85;\n\t&:after{\n\t\tmargin-left:0 !important;\n\t}\n\t&:active,\n\t&:focus,\n\t&:hover{\n\t\topacity:1;\n\t}\n}\n.dropleft .dropdown-toggle:before,\n.dropright .dropdown-toggle:before,\n.dropup .dropdown-toggle:after,\n.dropdown-toggle:after {\n\tcontent:\"\\f107\";\n\tfont-family:FontAwesome;\n\tborder: 0;\n    vertical-align: middle;\n    margin-left: 0.25em;\n\tline-height: 1;\n}\n.dropup .dropdown-toggle:after{\n\tcontent:\"\\f106\";\n}\n.dropleft .dropdown-toggle::before {\n\tcontent:\"\\f104\";\n}\n.dropright .dropdown-toggle::before {\n\tcontent:\"\\f105\";\n}\n.dropright .dropdown-toggle::after {\n\tcontent:none;\n}\n.custom-dropdown{\n    display: inline-block;\n    margin-bottom: 1rem;\n\n    .dropdown-menu{\n        border: 0px;\n        min-width: 160px;\n        // padding: 1rem;\n\t\t\n    }\n}\n.card-action{\n    .custom-dropdown{\n        // padding: 15px;\n        margin: 0px;\n        background: lighten($primary, 30%);\n        &.show,&:focus,&:hover{\n            background: $primary;\n            color: $white;\n        }\n\n        i{\n            display: inline-block;\n            padding-top: 9px;\n        }\n    }\n}\n\n.dropdown{\n\t.dropdown-dots{\n\t\tposition: relative;\n\t\theight: 5px;\n\t\twidth: 5px;\n\t\tbackground: rgba($dark, 0.4);\n\t\tborder-radius: 5px;\n\t\tdisplay: block;\t\n\t\t&:after,\n\t\t&:before{\n\t\t\tcontent: \"\";\n\t\t\theight: 5px;\n\t\t\twidth: 5px;\n\t\t\tbackground: rgba($dark, 0.4);\n\t\t\tposition: absolute;\n\t\t\tborder-radius: 5px;\n\t\t}\n\t\t&:after{\n\t\t\tright: -8px;\n\t\t}\n\t\t&:before{\n\t\t\tleft: -8px;\t\t\t\n\t\t}\n\t\t\n\t\t&.text-white{\n\t\t\tbackground: rgba($white, 0.7);\n\t\t\t&:after,\n\t\t\t&:before{\n\t\t\t\tbackground: rgba($white, 0.7);\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n}",".grid-col {\n    padding: 0.5rem !important;\n    background:$l-bg;\n    // box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1); \n\n \n}\n\n.row.grid {\n    margin-bottom: 1.5rem;\n    text-align: center;\n}\n\n.row.grid .grid-col:first-child{\n    text-align: left;\n}\n\n\n\n\n",".label {\n    display: inline-block;\n    text-align: center;\n    font-size: 0.75rem;\n    padding: .2rem .8rem;\n\n    &-fixed {\n        width: 7.5rem;\n        padding: .6rem 0;\n\n        &-lg {\n            width: 9.5rem;\n            padding: .6rem 0;\n        }\n    }\n\n    &-big {\n        width: 16.8rem;\n        font-size: 1.4rem;\n        padding: 1.1rem 0;\n    }\n\n    &-xl {\n        width: 10.5rem;\n        padding: 1.1rem 0;\n        font-size: 1.5rem;\n    }\n\n    &-lg {\n        width: 9.5rem;\n        padding: 1.1rem 0;\n    }\n\n    &-md {\n        width: 8.5rem;\n        padding: 1.1rem 0;\n    }\n\n    &-sm {\n        width: 7.5rem;\n        padding: 1.1rem 0;\n    }\n}\n\n.label-default{\n    background: #ADB6C7;\n}\n\n.label-primary{\n    background: $primary;\n    color: $white;\n}\n\n.label-secondary{\n    background: $secondary;\n    color: $white;\n}\n\n.label-info{\n    background: $info;\n    color: $white;\n}\n\n.label-success{\n    background: $success;\n    color: $white;\n}\n\n.label-warning{\n    background: $warning;\n    color: $white;\n}\n\n.label-danger{\n    background: $danger;\n    color: $white;\n}\n\n\n.label-light{\n    background: $light;\n    color: $black;\n}\n\n\n.label-dark{\n    background: $dark;\n    color: $white;\n}\n\n\n\ncode{\n    word-break: break-word;\n    padding: 2px 5px;\n    border-radius: 3px;\n\tbackground: lighten($danger, 33%);\n    color: $danger;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: rgba($danger, 0.1);\n\t}\n}\n\n.heading-labels{\n    color: #333333;\n\n    & > *{\n        margin-bottom: .8rem;\n    }\n\n    h1{\n        .label{\n            font-size: 18px;\n            font-weight: normal;\n            padding: .4rem .9rem;\n        }\n    }\n\n    h2{\n        .label{\n            font-size: 16px;\n            font-weight: normal;\n            padding: 0.3rem .9rem;\n        }\n    }\n\n    h3{\n        .label{\n            font-size: 14px;\n            font-weight: normal;\n        }\n    }\n\n    h4{\n        .label{\n            font-size: 12px;\n            font-weight: normal;\n        }\n    }\n\n    h5{\n        .label{\n            font-size: 12px;\n            font-weight: normal;\n        }\n    }\n\n    h6{\n        .label{\n            font-size: 12px;\n            font-weight: normal;\n        }\n    }\n}",".list-group-item {\n    background-color: rgba(255,255,255,0);\n    border: 1px solid $border;\n\tpadding: 1rem 1.5rem;\n\t    border-radius: 0;\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n\t&:first-child {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\t&:last-child {\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n\n.list-group-item.disabled, .list-group-item:disabled {\n    color: #fff;\n    background-color: $secondary;\n    border-color: $secondary;\n}\n[class*=\"bg-\"]{\n\t.list-group-item{\n\t\tborder-color:rgba($white, 0.05);\n\t}\n}\n.bg-warning{\n\t.list-group-item{\n\t\tborder-color:rgba($black, 0.05);\n\t}\n}\n// .list-group-item-action {\n//     color: #fff;\n// }",".media{\n    img{\n        border-radius: 3px;\n    }\n}",".vertical-card__menu {\n    // box-shadow: none;\n\n    &:hover {\n        box-shadow: none;\n    }\n\n    &--image {\n        text-align: center;\n\n        img {\n            width: 100%;\n            border-top-left-radius: 0.25rem;\n            border-top-right-radius: 0.25rem;\n        }\n    }\n\n    &--status {\n        &.closed {\n            background: $danger;\n\n            &:after {\n                border-top: 10px solid $danger;\n            }\n\n            .ribbon-curve {\n                border-top: 11px solid $danger;\n                border-bottom: 10px solid $danger;\n            }\n        }\n    }\n\n    &--desc {\n        // padding: 0.9375rem 1.25rem;\n        // border-left: 1px solid #e5e5e5;\n        // border-right: 1px solid #e5e5e5;\n\n        p {\n            margin-bottom: 0.625rem;\n        }\n    }\n\n    &--price {\n        font-size: 1.25rem;\n        margin: 0;\n        font-weight: 700;\n    }\n\n    &--rating {\n        font-size: 0.75rem;\n    }\n\n    &--title {\n        // margin-bottom: 0.625rem;\n        font-weight: 700;\n    }\n\n    &--button {\n        button {\n            font-size: 0.75rem;\n        }\n    }\n\n    &--location {\n        // font-size: 0.75rem;\n    }\n\n    .card-footer {\n        padding: 15px 20px;\n        background-color: $border;\n        // border: 1px solid #e5e5e5;\n        border-top: none;\n\n        @include custommq($min: 1200px, $max: 1440px) {\n            padding: 15px;\n        }\n\n        span{\n            color: $dark;\n            margin-right: 0.3125rem;\n        }\n    }\n}\n\n.horizontal-card__menu {\n    box-shadow: 0 0 7px rgba(173, 173, 173, 0.32);\n    display: flex;\n    flex-direction: row;\n\n    @include media-breakpoint-down(xs) {\n        display: block;\n    }\n\n    .card-body {\n        padding: 0;\n        padding: 20px 30px;\n    }\n\n\n\n    &--image {\n        flex-basis: 30%;\n        max-width: 30%;\n\n        img {\n            height: 100%;\n            width: 100%;\n        }\n\n        @include media-breakpoint-down(xs) {\n            max-width: unset;\n            flex-basis: 100%;\n        }\n    }\n\n    &--title {\n        font-size: 1rem;\n        font-weight: 700;\n        margin-bottom: 0.3125rem;\n    }\n\n    &--fav {\n        margin-right: 0.5rem;\n    }\n\n    &--price {\n        margin: 0;\n        font-size: 1rem;\n        font-weight: 700;\n    }\n\n    &--rating {\n        font-size: 0.625rem;\n    }\n\n    &--footer {\n        margin-top: 10px;\n    }\n}\n\n.prev_price {\n    text-decoration: line-through;\n    // color: $muted;\n    font-size: 80%;\n    opacity: 0.5;\n}","// .modal{\n//     border: 0;\n//     z-index: 9999999999;\n    \n//     &-content{\n//         border: 0;\n//         box-shadow: 0px 2px 21px 6px rgba(70, 66, 66, 0.26);\n//     }\n// }\n\n// // primary modal rule\n// #primaryModal{\n\n//     .modal-header{\n//         background: $primary;\n\n//         .modal-title,button{\n//             color: #fff;\n//             opacity: 1;\n//         }\n//     }\n// }\n// //danger modal rule\n// #dangerModal{\n\n//     .modal-header{\n//         background: $danger;\n\n//         .modal-title,button{\n//             color: #fff;\n//             opacity: 1;\n//         }\n//     }\n// }\n\n// //warning modal rule\n// #warningModal{\n\n//     .modal-header{\n//         background: $warning;\n\n//         .modal-title,button{\n//             color: #a39e06 ;\n//             opacity: 1;\n//         }\n//     }\n// }\n\n// //success modal rule\n// #successModal{\n\n//     .modal-header{\n//         background: $success;\n\n//         .modal-title,button{\n//             color: #fff;\n//             opacity: 1;\n//         }\n//     }\n// }\n\n\n\n\n\n\n\n// .bootstrap-modal-wrapper{\n\n//     button:not(:last-child){\n//         margin-right: 7px;\n//     }\n\n//     button{\n//         margin-bottom: .5rem;\n\n//         &:focus{\n//             box-shadow: none;\n//         }\n//     }\n// }\n\n.modal-header{\n\tpadding: 1rem 1.875rem;\n\n\t.close{\n\t\tpadding: 0.875rem 1.815rem;\n\t\tmargin: 0;\n\t\tposition: absolute;\n\t\tright: 0;\n\t\tfloat: none;\n\t\ttop: 0;\n\t\tfont-size: 30px;\n\t\tfont-weight: 100;\n\t}\n}\n.modal-body{\n\tpadding: 1.875rem;\n}\n.modal-footer{\n\tpadding: 1rem 1.875rem;\n}\n.modal-content{\n\tborder-radius:$radius;\n}\n.modal-backdrop{\n    z-index: 10!important;\n}",".pagination .page-item{\n\t\n\t\t.page-link{\n\t\t\t\n\t\t\t\t\n\t\t\t&:hover{\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder-color: $primary;\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n\t\t&.active .page-link{\n\t\t\tbackground: $primary;\n\t\t\tborder-color: $primary;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n.pagination {\n    margin-bottom: 20px;\n\n    .page-item {\n\n        &.page-indicator .page-link {\n            padding: .65rem .8rem;\n            font-size: 14px;\n        }\n\n        &.page-indicator:hover{\n            .page-link{\n                color: $dark;\n            }\n        }\n\n        .page-link {\n            // height: 3.125rem;\n            text-align: center;\n\t\t\tz-index:2;\n            padding: 0.55rem 1rem;\n            font-size: 1rem;\n            background: rgba(255, 255, 255, 0.15);\n            color: $dark;\n            // line-height: 2.375rem;\n            border: 1px solid $border;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-color: $d-border;\n\t\t\t\tcolor: $d-ctl;\n\t\t\t\tbackground: rgba(255, 255, 255, 0);\n\t\t\t}\n            &:hover i,span{\n                color: $white;\n            }\n\n            &:focus{\n                outline: 0;\n                box-shadow: none;\n            }\n\n            &:hover{\n                background: $primary;\n                color: $white;\n                border-color: $primary;\n            }\n        }\n\n        &.active .page-link {\n            background-color: $primary;\n            border-color: $primary;\n            color: $white;\n\t\t\tbox-shadow:0 10px 20px 0px rgba($primary, 0.2);\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor:$white;\n\t\t\t}\n        }\n\n        .page-link {\n            // width: 4.0625rem;\n            color: $dark;\n\t\t\t@include transitionMedium;\n        }\n\n        &:last-child .page-link{\n            margin-right: 0;\n        }\n\n        &:first-child .page-link{\n\n            @at-root [direction=\"rtl\"] #{&} {\n                margin-right: 0;\n            }\n        }\n    }\n\t&.no-bg{\n\t\tli:not(.page-indicator):not(.active) .page-link{\n\t\t \tbackground:transparent;\n\t\t \tborder-color:transparent;\n\t\t\t\n\t\t}\n\t\t&.pagination-primary{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:$primary;\n\t\t\t\tborder-color:$primary;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t\tborder-color:$primary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.pagination-danger{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:$danger;\n\t\t\t\tborder-color:$danger;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$danger;\n\t\t\t\t\tborder-color:$danger;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.pagination-info{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:$info;\n\t\t\t\tborder-color:$info;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$info;\n\t\t\t\t\tborder-color:$info;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.pagination-warning{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:$warning;\n\t\t\t\tborder-color:$warning;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$warning;\n\t\t\t\t\tborder-color:$warning;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-primary{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:$primary-light;\n\t\t\t\tborder-color:$primary-light;\n\t\t\t\tcolor:$primary;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$primary-opacity;\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:$primary;\n\t\t\t\t\tborder-color:$primary;\n\t\t\t\t\tbox-shadow:0 10px 20px 0px rgba($primary, 0.2);\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-danger{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:$danger-light;\n\t\t\t\tborder-color:$danger-light;\n\t\t\t\tcolor:$danger;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$danger-opacity;\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:$danger;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:$danger;\n\t\t\t\t\tborder-color:$danger;\n\t\t\t\t\tbox-shadow:0 10px 20px 0px rgba($danger, 0.2);\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-info{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:$info-light;\n\t\t\t\tborder-color:$info-light;\n\t\t\t\tcolor:$info;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$info-opacity;\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:$info;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:$info;\n\t\t\t\t\tborder-color:$info;\n\t\t\t\t\tbox-shadow:0 10px 20px 0px rgba($info, 0.2);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-warning{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:$warning-light;\n\t\t\t\tborder-color:$warning-light;\n\t\t\t\tcolor:$warning;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$warning-opacity;\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:$warning;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:$warning;\n\t\t\t\t\tborder-color:$warning;\n\t\t\t\t\tbox-shadow:0 10px 20px 0px rgba($warning, 0.2);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n    &-gutter{\n\n        .page-item{\n            margin-right: 7px;\n            \n            .page-link{\n                border-radius: $radius !important;\n            }\n        }\n    }\n\n    &-circle{\n        .page-item{\n            margin-right: 7px;\n            \n            .page-link, &.page-indicator .page-link{\n                width: 40px;\n                height: 40px;\n                padding: 0;\n                line-height: 40px;\n                border-radius: 50% !important;\n                padding: 0;\n            }\n        }\n    }\n\n    &.pagination-md{\n\n        .page-item{\n\n            .page-link{\n                width: 30px;\n                height: 30px;\n                line-height: 30px;\n                font-size: 14px;\n            }\n        }\n    }\n\n    &.pagination-sm{\n\n        .page-item{\n\n            &.page-indicator .page-link {\n                font-size: 12px;\n            }\n\n            .page-link{\n                padding: 0;\n                width: 30px;\n                height: 30px;\n                line-height: 30px;\n                font-size: 14px;\n            }\n        }\n    }\n\n    &.pagination-xs{\n\n        .page-item{\n\n            &.page-indicator .page-link {\n                font-size: 10px;\n            }\n\n            .page-link{\n                padding: 0;\n                width: 25px;\n                height: 25px;\n                line-height: 25px;\n                font-size: 12px;\n            }\n        }\n    }\n\n    \n}\n\n\n\n\n\n\n\n\n\n\n",".popover{\n    border: 2px solid $secondary;\n    min-width: 210px;\n    box-shadow: 0 0 30px 0 rgba(0,0,0,0.1);\n\tborder-radius:0;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $d-bg;\n    }\n    &-header{\n        background: $secondary;\n        color: $white;\n        font-weight: 300;\n\t\tborder-radius:0;\n        &::before{\n            border-bottom: 0 !important;\n        }\n    }\n\n    &-body{\n        font-size: 0.75rem;\n\t\t\n    }\n\t.popover-header{\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $dark-card;\n\t\t}\n    }\n}\n\n.bootstrap-popover-wrapper{\n    .bootstrap-popover:not(:last-child){\n        margin-right: 8px;\n    }\n\n    .bootstrap-popover{\n        margin-bottom: .5rem;\n\n        button:hover,button:focus{\n            background: $primary;\n            color: $white;\n            box-shadow: none;\n        }\n    }\n}\n\n// .tooltip {\n//     font-size: 15px;\n// }\n\n\n.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    bottom: 0px;\n    border-top-color: $secondary;\n}\n\n.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    right: 0px;\n    border-left-color: $secondary;\n}\n\n.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    left: 0px;\n    border-right-color: $secondary;\n}\n\n.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    top: 0px;\n    border-bottom-color: $secondary;\n}\n\n.note-popover{\n    display: none;\n}"," // Variable.scss\n .progress-bar {\n    background-color: $primary;\n }\n \n .progress-bar-primary {\n     background-color: $primary;\n }\n \n .progress-bar-success {\n     background-color: $success;\n }\n \n .progress-bar-info {\n     background-color: $info;\n }\n \n .progress-bar-danger {\n     background-color: $danger;\n }\n \n .progress-bar-warning {\n     background-color: $warning;\n }\n \n .progress-bar-pink {\n     background-color: $pink;\n }\n \n.progress {\n    height: 6px;\n    overflow: hidden;\n    // box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.13);\n\tborder-radius: $radius;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $d-bg;\n\t}\n     &-bar{\n        // outline: 1px solid #fff;\n        border-radius: 4px;\n    }\n}\n \n .progress-vertical {\n     display: inline-block;\n     margin-bottom: 0;\n     margin-right: 2rem;\n     min-height: 17rem;\n     position: relative;\n\n     @include media-breakpoint-down(md) {\n        margin-right: 1rem;\n     }\n }\n \n .progress-vertical-bottom {\n     display: inline-block;\n     margin-bottom: 0;\n     margin-right: 2rem;\n     min-height: 17rem;\n     position: relative;\n     transform: rotate(180deg);\n     \n     @include media-breakpoint-down(md) {\n        margin-right: 1rem;\n     }\n }\n \n .progress-animated {\n     animation-duration: 5s;\n     animation-name: myanimation;\n     transition: all 5s ease 0s;\n }\n \n @keyframes myanimation {\n     0% {\n         width: 0;\n     }\n }\n \n @keyframes myanimation {\n     0% {\n         width: 0;\n     }\n }\n \n",".ribbon {\n    position: absolute;\n    z-index: 1;\n    text-transform: uppercase;\n\n    &__one {\n        top: 15px;\n        left: -11px;\n        min-height: 20px;\n        min-width: 52px;\n        text-align: center;\n        padding: 3px 10px;\n        background: #3AB54B;\n        color: #fff;\n        font-size: 0.625rem;\n\n        &::after {\n            position: absolute;\n            width: 0;\n            height: 0;\n            border-top: 10px solid #239132;\n            border-left: 11px solid transparent;\n            left: 0;\n            content: \"\";\n            bottom: -10px;\n        }\n    }\n\n    &__two {\n        width: 50px;\n        height: 50px;\n        display: inline-block;\n        background: $warning;\n        line-height: 50px;\n        text-align: center;\n        font-size: 16px;\n        color: $white;\n        right: 15px;\n        top: 15px;\n        border-radius: 3px;\n\n        // &::after {\n        //     position: absolute;\n        //     content: \"\";\n        //     -webkit-clip-path: polygon(90% 0, 100% 100%, 50% 75%, 0 100%, 10% 0, 50% 0);\n        //     clip-path: polygon(90% 0, 100% 100%, 50% 75%, 0 100%, 10% 0, 50% 0);\n        //     height: 22px;\n        //     width: 40px;\n        //     left: 50%;\n        //     top: 75%;\n        //     background: $primary;\n        //     transform: translateX(-50%);\n        // }\n    }\n\n    &__three {\n        left: -1.875rem;\n        top: 0.875rem;\n        width: 6.875rem;\n        height: 1.5625rem;\n        background-color: $danger;\n        clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);\n        transform: rotate(-45deg);\n        color: $white;    \n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n    }\n\n    &__four {\n        left: 8px;\n        top: -8px;\n        width: 110px;\n        height: 50px;\n        background-color: $primary;\n        z-index: auto;\n        color: $white;\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        \n        &:after {\n            right: -5px;\n        }\n\n        &:before {\n            left: -5px;\n        }\n\n        // &:after, &:before {\n\n        // }\n\n        &:after, &:before {\n            z-index: -1;\n            background-color: lighten($color: $primary, $amount: 20%);\n            top: 3px;\n            transform: rotate(45deg);\n            content: \"\";\n            height: 10px;\n            width: 10px;\n            position: absolute;\n        }\n    }\n\n    &__five {\n        left: -1.875rem;\n        top: 0.625rem;\n        width: 6.875rem;\n        height: 1.875rem;\n        background-color: $primary;\n        transform: rotate(-45deg);\n        font-size: 0.75rem;\n        color: $white;\n        padding-bottom: 0.3125rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 1rem;\n\n        &::before {\n            position: absolute;\n            content: \"\";\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 0 50px 50px 50px;\n            border-color: transparent transparent $primary transparent;\n            left: 0.25rem;\n            top: -2.8125rem;\n        }\n    }\n\n    &__six {\n        left: 0;\n        top: 1.125rem;\n        width: 6.875rem;\n        height: 2.375rem;\n        background-color: $primary;\n        -webkit-clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n        clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n        display: flex;\n        font-size: 1.25rem;\n        align-items: center;\n        justify-content: center;\n        color: $white;\n    }\n\n    &-curve {\n        position: absolute;\n        top: 0;\n        right: -6px;\n        width: 10px;\n        height: 11px;\n        border-top: 11px solid #3AB54B;\n        border-bottom: 10px solid #3AB54B;\n        border-right: 5px solid transparent;\n    }\n}",".jsgrid-grid-body, \n.dataTables_scrollBody, \n.table-responsive {\n    &::-webkit-scrollbar {\n        background-color: #F5F5F5;\n        width: 8px;\n        height: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n        border-radius: 10px;\n        background-color: #F5F5F5;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        border-radius: 10px;\n        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n        background-color: $body-color;\n    }\n}","\n\n\n%remain-steps {\n    &:before {\n        content: counter(stepNum);\n        font-family: inherit;\n        font-weight: 400;\n    }\n\n    &:after {\n        background-color: $border;\n    }\n}\n\n.multi-steps {\n    display: table;\n    table-layout: fixed;\n    width: 100%;\n\n    >li {\n        counter-increment: stepNum;\n        text-align: center;\n        display: table-cell;\n        position: relative;\n        color: $primary;\n\n        @include media-breakpoint-down(xs) {\n            font-size: 0.75rem;\n        }\n\n        &:before {\n            content: '\\2713';\n            display: block;\n            margin: 0 auto 4px;\n            background-color: $white;\n            width: 25px;\n            height: 25px;\n            line-height: 22px;\n            text-align: center;\n            font-weight: bold;\n            position: relative;\n            z-index: 1;\n\n            @include media-breakpoint-down(xs) {\n                width: 25px;\n                height: 25px;\n                line-height: 21px;\n            }\n\n            border: {\n                width: 2px;\n                style: solid;\n                color: $primary;\n                radius: 5px;\n            }\n        }\n\n        &:after {\n            content: '';\n            height: 2px;\n            width: 100%;\n            background-color: $primary;\n            position: absolute;\n            top: 12px;\n            left: 50%;\n\n            @at-root [direction=\"rtl\"] #{&} {\n              left: auto;\n              right: 50%;\n            }\n\n            @include media-breakpoint-down(xs) {\n                top: 12px;\n            }\n        }\n\n        &:last-child {\n            &:after {\n                display: none;\n            }\n        }\n\n        &.is-active {\n            @extend %remain-steps;\n\n            &:before {\n                background-color: $white;\n                border-color: $primary;\n            }\n\n            ~li {\n                color: $body-color;\n                @extend %remain-steps;\n\n                &:before {\n                    background-color: $border;\n                    border-color: $border;\n                }\n            }\n        }\n    }\n}",".nav-pills {\n    .nav-link {\n\t\tborder-radius: $radius;\n\t    padding: 0.75rem 1.25rem;\n\t}\n}\n\n.default-tab{\n    .nav-link{\n        background: transparent;\n        border-radius: 0px;\n        font-weight: 500;\n\t\ti{\n\t\t\tdisplay:inline-block;\n\t\t\ttransform:scale(1.5);\n\t\t\tcolor:$primary;\n\t\t\t\n\t\t}\n\t\t\n\t\t&:focus,\n\t\t&:hover,\n\t\t&.active{\n\t\t\tcolor: #495057;\n\t\t\tbackground-color: #fff;\n\t\t\tborder-color: #dee2e6 #dee2e6 #fff #ebeef6;\n\t\t\tborder-radius: $radius $radius 0 0;\n\t\t\tcolor:$primary;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $primary-opacity;\n\t\t\t\tborder-color: transparent transparent $d-border transparent;\n\t\t\t}\n\t\t}\n    }\n}\n\n.custom-tab-1{\n    .nav-link{\n        background: transparent;\n        border-radius: 0px;\n        font-weight: 500;\n\t\tborder-bottom:3px solid transparent;\n\t\tborder-width: 0 0px 3px 0;\n\t\t\n\t\ti{\n\t\t\tdisplay:inline-block;\n\t\t\ttransform:scale(1.5);\n\t\t\tcolor:$primary;\n\t\t}\n\t\t&:focus,\n\t\t&:hover,\n\t\t&.active{\n\t\t\tcolor: #495057;\n\t\t\tbackground-color: #fff;\n\t\t\tborder-color:$primary ;\n\t\t\tborder-radius:0;\n\t\t\tcolor: $primary;\n\t\t\tborder-width: 0 0px 3px 0;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $primary-opacity;\n\t\t\t}\n\t\t}\n    }\n\t\n}\n.nav-pills{\n\t\n\t&.light{\n\t\n\t\t.nav-link.active, \n\t\t.show > .nav-link{\n\t\t\tbackground:$primary-light;\n\t\t\tcolor:$primary;\n\t\t\tbox-shadow:none;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$primary-opacity;\n\t\t\t}\n\t\t}\t\n\t\n\t}\n\t.nav-link.active, \n\t.show > .nav-link{\n\t\tbox-shadow:0 0 20px 0 rgba($primary, 0.2);\n\t}\n}\n\n",".tooltip{\n\n    &-wrapper{\n\n        button:not(:last-child){\n            margin-right: 8px;\n        }\n\n        button:hover{\n            background: $primary;\n            color: $white;\n        }\n\n        button{\n            margin-bottom: .5rem;\n\n            &:focus{\n                box-shadow: none;\n            }\n        }\n    }\n\n    &-inner{\n        border-radius: 0;\n        background: #333333;\n        font-size: 12px;\n        font-weight: 300;\n        padding: 0.35rem 0.7rem;\n    }\n\n    \n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before{\n    // border-width: 0 0.6rem 0.6rem;\n    border-bottom-color: #333333;\n}\n\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before{\n    border-right-color: #333333;\n}\n\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before{\n    border-left-color: #333333;\n}\n\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before{\n    border-top-color: #333333;\n}","\n.widget-timeline{\n\n\t.timeline {\n\t\tlist-style: none;\n\t\tposition: relative;\n\t\t&:before {\n\t\t\ttop: 20px;\n\t\t\tbottom: 0;\n\t\t\tposition: absolute;\n\t\t\tcontent: \" \";\n\t\t\twidth: 3px;\n\t\t\tleft: 9px;\n\t\t\tmargin-right: -1.5px;\n\t\t\tbackground: $light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground: $d-border;\n\t\t\t}\n\t\t\t@at-root [direction=\"rtl\"] #{&} {\n\t\t\t\tleft: auto;\n\t\t\t\tright: 9px;\n\t\t\t\tmargin-right: auto;\n\t\t\t\tmargin-left: -1.5px;\n\t\t\t}\n\t\t\t\n\t\t}\n\t\t> li {\n\t\t\tmargin-bottom: 15px;\n\t\t\tposition: relative;\n\t\t\t&:before {\n\t\t\t\tcontent: \" \";\n\t\t\t\tdisplay: table;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tcontent: \" \";\n\t\t\t\tdisplay: table;\n\t\t\t\tclear: both;\n\t\t\t}\n\t\t\t> {\n\t\t\t\t.timeline-panel {\n\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\tpadding: 15px 20px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay:block;\n\t\t\t\t\tmargin-left: 40px;\n\t\t\t\t\tborder-width:1px;\n\t\t\t\t\tborder-style:solid;\n\t\t\t\t\tspan{\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t\t\topacity: 0.8;\n\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t}\n\t\t\t\t\tp{\n\t\t\t\t\t\tfont-size:14px;\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\twidth: 10px;\n\t\t\t\t\t\theight: 10px;\n\t\t\t\t\t\tbackground: inherit;\n\t\t\t\t\t\tborder-color: inherit;\n\t\t\t\t\t\tborder-style: solid;\n\t\t\t\t\t\tborder-width: 0px 0px 1px 1px;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: -5px;\n\t\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t\ttop: 15px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.timeline-badge {\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\theight: 22px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t\twidth: 22px;\n\t\t\t\t\tborder-width: 2px;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tbackground:$white;\n\t\t\t\t\tpadding:4px;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $dark-card;\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent:\"\";\n\t\t\t\t\t\twidth:10px;\n\t\t\t\t\t\theight:10px;\n\t\t\t\t\t\tborder-radius:100%;\n\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t@at-root [direction=\"rtl\"] #{&} {\n\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\tright: 19px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t.timeline-body > p {\n\t\tfont-size: 12px;\n\t}\n  \n  .timeline-badge {\n    &.primary{\n\t\tborder-color:$primary-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $primary-opacity;\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: $primary !important;\n\t\t\tbox-shadow:0 5px 10px 0 rgba($primary, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$primary-light;\n\t\t\tborder-color:$primary-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-color: transparent;\n\t\t\t\tbackground-color: $primary-opacity;\n\t\t\t}\n\t\t}\n    }\n    &.success{\n\t\tborder-color:$success-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $success-opacity;\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: $success !important;\n\t\t\tbox-shadow:0 5px 10px 0 rgba($success, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$success-light;\n\t\t\tborder-color:$success-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $success-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n    &.warning{\n\t\tborder-color:$warning-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $warning-opacity;\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: $warning !important;\n\t\t\tbox-shadow:0 5px 10px 0 rgba($warning, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$warning-light;\n\t\t\tborder-color:$warning-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $warning-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n    &.danger{\n\t\tborder-color:$danger-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $danger-opacity;\n\t\t}\n\t\t&:after{\n\t\t  background-color: $danger !important;\n\t\t  box-shadow:0 5px 10px 0 rgba($danger, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$danger-light;\n\t\t\tborder-color:$danger-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $danger-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n\t\n    &.info{\n\t\tborder-color:$info-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $info-opacity;\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: $info !important;\n\t\t\tbox-shadow:0 5px 10px 0 rgba($info, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$info-light;\n\t\t\tborder-color:$info-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $info-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n    &.dark{\n\t\tborder-color:$dark-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $dark-opacity;\n\t\t}\n\t\t&:after{\n\t\t  background-color: $dark !important;\n\t\t  box-shadow:0 5px 10px 0 rgba($dark, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$dark-light;\n\t\t\tborder-color:$dark-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $dark-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n  }\n\t\n\t&.style-1{\n\t\t.timeline-panel{\n\t\t\tbackground:transparent;\n\t\t}\n\t\t.timeline {\n\t\t\t.timeline-badge {\n\t\t\t\t&.timeline-badge{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tbackground: transparent !important;\n\t\t\t\t\t\tborder-style:solid;\n\t\t\t\t\t\tborder-width: 0 0 0 5px;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tpadding: 5px 10px 5px 15px;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\t\tleft: -9px;\n\t\t\t\t\t\t\twidth: 7px;\n\t\t\t\t\t\t\theight: 7px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.primary{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$primary;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$primary;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.success{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$success;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$success;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.warning{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$warning;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$warning;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.danger{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$danger;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$danger;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.info{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$info;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$info;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.dark{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$dark;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$dark;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\n\t}  \n  \n}\n\n  \n  ","#chart_widget_4 {\n    height: 255px !important;\n}\n\n#chart_widget_5 {\n    .ct-series-a .ct-line, \n    .ct-series-a .ct-point {\n        stroke: #46ffc8;\n    }\n\n    .ct-line {\n        stroke-width: 1px;\n    }\n\n    .ct-point {\n        stroke-width: 2px;\n    }\n\n    .ct-series-a .ct-area {\n        fill: #43d66c;\n    }\n\n    .ct-area {\n        fill-opacity: 1;\n    }\n}\n\n#chart_widget_6 {\n    .ct-series-a .ct-line, \n    .ct-series-a .ct-point {\n        stroke: $info;\n    }\n\n    .ct-line {\n        stroke-width: 2px;\n    }\n\n    .ct-point {\n        stroke-width: 5px;\n    }\n\n    .ct-series-a .ct-area {\n        fill: $info;\n    }\n\n    .ct-area {\n        fill-opacity: .5;\n    }\n}\n\n#chart_widget_8 {\n    height: 255px;\n\n    .ct-series-a .ct-line, \n    .ct-series-a .ct-point {\n        stroke: $info;\n    }\n\n    .ct-line {\n        stroke-width: 2px;\n    }\n\n    .ct-point {\n        stroke-width: 5px;\n    }\n\n    .ct-series-a .ct-area {\n        fill: $info;\n    }\n\n    .ct-area {\n        fill-opacity: .5;\n    }\n}\n\n#chart_widget_9, #chart_widget_10 {\n    height: 250px !important;\n}\n\n#chart_widget_11, #chart_widget_12, #chart_widget_13 {\n    .ct-slice-donut {\n        stroke-width: 25px !important;\n    }\n}\n\n\n#chart_widget_11 {\n    height: 270px !important;\n}\n\n#chart_widget_17 {\n    height: 150px !important;\n}\n\n\n.chart_widget_tab_one {\n    .nav-link {\n        border: 1px solid #ddd;\n\n        &.active {\n            background-color: $primary;\n            border: 1px solid $primary;\n            color: $white;\n\n            &:hover {\n                border: 1px solid $primary;\n            }\n        }\n\n        &:hover {\n            border: 1px solid #ddd;\n        }\n    }\n}\n\n.ccc-widget {\n    &>div {\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $dark-card !important;\n            border-color: $d-border !important;\n        }\n    }\n}",".social-icon{\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    border-radius: 4px;\n    text-align: center;\n    background: $body-bg;\n    margin-bottom: 0.5rem;\n    font-size: 20px;\n\n    i{\n        // font-size: 0.875rem; \n        color: $white\n    }\n    &.youtube{\n        background: $youtube;\n    }\n    &.facebook{\n        background: $facebook;\n    }\n    &.twitter{\n        background: $twitter;\n    }\n}\n\n\n.social-icon2{\n    a{\n        border: .1rem solid $primary;\n        display: block;\n        padding: 1rem;\n        margin-top: 1.5rem;\n        margin-bottom: .5rem;\n        border-radius: .3rem;\n        font-size: 1.6rem;\n    }\n\n    i{\n        font-size: 12px;\n        color: $primary;\n    }\n}\n\n.social-icon3{\n    ul{\n        li{\n            display: inline-block;\n            a{\n                display: block;\n                i{\n                    font-size: 1.4rem;\n                    padding: 1rem .7rem;\n                    color: $l-ctd;\n                }\n                &:hover{\n                    i{\n                        color: $primary;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.social-icons-muted{\n    ul li a i{\n        color: $muted;\n    }\n}\n\n.social-links {\n    a {\n        padding: .5rem;\n    }\n}",".widget-stat {\n    .media {\n        padding: 0px 0;\n        align-items: center;\n        &>span {\n            height: 85px;\n            width: 85px;\n            border-radius: 100%;\n            padding: 10px 12px;\n            font-size: 32px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            color: $l-ctd;\n            \n\t\t\t@include respond('laptop') {\n\t\t\t\theight: 70px;\n\t\t\t\twidth: 70px;\n\t\t\t\tmin-width:70px;\n\t\t\t}\n        }\n        @include custommq($min: 576px) {}\n        .media-body {\n            p {\n                font-weight: 500;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 1.5;\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n                @at-root [data-theme-version=\"dark\"] & {\n                    color: #c4c9d5;\n                }\n            }\n\t\t\tsmall, \n\t\t\t.small {\n\t\t\t\tfont-size: 75%;\n\t\t\t}\n            h3{\n\t\t\t\tfont-size: 30px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 1.2;\n\t\t\t}\n            h4 {\n                font-size: 24px;\n                display: inline-block;\n\t\t\t\tvertical-align: middle;\n            }\n            span {\n                margin-left: 5px;\n                \n            }\n        }\n    }\n\t&[class*=\"bg-\"] .media > span{\n\t\tbackground-color:rgba(255,255,255,0.25);\n\t\tcolor:$white;\n\t}\n\t&[class*=\"bg-\"] .progress{\n\t\tbackground-color:rgba(255,255,255,0.25) !important;\n\t}\n\t\n}\n[direction=\"rtl\"] {\n\t.widget-stat .media .media-body span{\n\t\tmargin-left: 0;\n\t\tmargin-right: 10px;\n\t}\n}\n.dez-widget-1{\n    .card {\n        background: #FFE7DB;\n        .card-body {\n            p {\n                color: #f87533;\n            }\n        }\n    }\n\t.progress {\n\t\n\t}\n\t.icon{\n\t\tfloat: right;\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tdisplay: flex;\n\t\talign-items:center;\n\t\tjustify-content:center;\n\t\tborder-radius: 6px;\n\t\tfont-size: 28px;\n\t}\n}\n.bgl-primary{\n    background: $primary-light;\n    border-color: $primary-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $primary-opacity;\n\t\tborder-color: $primary-opacity;\n\t}\n}\n.bgl-secondary{\n    background: $secondary-light;\n    border-color: $secondary-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $secondary-opacity;\n\t\tborder-color: $secondary-opacity;\n\t}\n\n}\n.bgl-success{\n    background: $success-light;\n    border-color: $success-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $success-opacity;\n\t\tborder-color: $success-opacity;\n\t}\n\n}\n.bgl-warning{\n    background: $warning-light;\n    border-color: $warning-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $warning-opacity;\n\t\tborder-color: $warning-opacity;\n\t}\n\n}\n.bgl-danger{\n    background: $danger-light;\n    border-color: $danger-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $danger-opacity;\n\t\tborder-color: $danger-opacity;\n\t}\n\n}\n.bgl-info{\n    background: $info-light;\n    border-color: $info-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $info-opacity;\n\t\tborder-color: $info-opacity;\n\t}\n\n}\n.bg-primary-light{\n    background: rgba($primary-light, 0.5);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($primary, 0.05);\n\t}\n}\n.bg-secondary-light{\n   background: rgba($secondary-light, 0.5);\n   @at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($secondary, 0.05);\n\t}\n}\n.bg-success-light{\n   background:  rgba($success-light, 0.5);\n   @at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($success, 0.05);\n\t}\n}\n.bg-warning-light{\n   background:  rgba($warning-light, 0.5);\n   @at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($warning, 0.05);\n\t}\n}\n.bg-danger-light{\n   background:  rgba($danger-light, 0.5);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($danger, 0.05);\n\t}\n}\n.bg-info-light{\n    background:  rgba($info-light, 0.5);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($info, 0.05);\n\t}\n}\n\n\n.bgl-dark{\n    background: $dark-light;\n    border-color: $dark-light;\n}\n.bgl-light{\n    background: $light;\n    border-color: $light;\n}\n.overlay-box{\n\tposition:relative;\n\tz-index:1;\n\t&:after{\n\t\tcontent:\"\";\n\t\twidth:100%;\n\t\theight:100%;\n\t\tleft:0;\n\t\ttop:0;;\n\t\tposition:absolute;\n\t\topacity:0.85;\n\t\tbackground:$primary;\n\t\tz-index: -1;\n\t}\n}\n.rating-bar{\n    font-size: 13px;\n}",".tdl-holder {\n  margin: 0 auto;\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n  li {\n    background-color: $white;\n    border-bottom: 1px solid $border;\n    // color: #252525;\n    list-style: none none;\n    margin: 0;\n    padding: 0;\n    span {\n      margin-left: 35px;\n      // color: $l-ctd;\n      font-size: 1rem;\n      // font-weight: 600;\n      vertical-align: middle;\n      transition: all 0.2s linear;\n\n      @at-root [direction=\"rtl\"] #{&} {\n        margin-left: auto;\n        margin-right: 35px;\n      }\n    }\n  }\n  label {\n    cursor: pointer;\n    display: block;\n    line-height: 50px;\n    padding-left: 1.5rem;\n    position: relative;\n    margin: 0 !important;\n\n    @at-root [direction=\"rtl\"] #{&} {\n      padding-left: 0;\n      padding-right: 1.5rem;\n    }\n\n    &:hover {\n      background-color: #eef1f6;\n      color: $dark;\n\n      \n\n      a {\n        color: $danger;\n      }\n      \n    }\n\n    a {\n      color: $white;\n      display: inline-block;\n      line-height: normal;\n      height: 100%;\n      text-align: center;\n      text-decoration: none;\n      width: 50px;\n      -webkit-transition: all .2s linear;\n      -moz-transition: all .2s linear;\n      -o-transition: all .2s linear;\n      transition: all 0.2s linear;\n      padding: 18px 0px;\n      font-size: 18px;\n      position: absolute;\n      right: 0;\n\n      @at-root [direction=\"rtl\"] #{&} {\n        right: auto;\n        left: 0;\n      }\n    }\n  }\n  input {\n    &[type=checkbox] {\n      cursor: pointer;\n      opacity: 0;\n      position: absolute;\n      + i {\n        background-color: #fff;\n        border: 1px solid #e7e7e7;\n        display: block;\n        height: 20px;\n        position: absolute;\n        top: 15px;\n        width: 20px;\n        z-index: 1;\n        border-radius: 00px;\n\t\tfont-size: 11px;\n\t\tborder-radius: 4px;\n      }\n      &:checked {\n\n        + i {\n          background: $primary;\n          border-color: transparent;\n\t\t  \n        }\n\n        + i::after {\n          content: \"\\f00c\";\n          font-family: 'fontAwesome';\n          display: block;\n          left: 2px;\n          position: absolute;\n          top: -14px;\n          z-index: 2;\n          color: $white;\n        }\n        ~ span {\n          text-decoration: line-through;\n          position: relative;\n        }\n      }\n    }\n    &[type=text] {\n      background-color: $white;\n      height: 50px;\n      margin-top: 29px;\n      border-radius: 3px;\n\n      &::placeholder {\n        color: $dark;\n       }\n    }\n  }\n}",".widget-message {\n\tp{\n\t\tfont-size: 14px;\n\t\tline-height: 1.5;\n\t}\n}",".picker{\n\t.picker__frame {\n\t\tmin-width: 450px!important;\n\t\tmax-width: 450px!important;\n\t\t\n\t\t.picker__box{\n\t\t\tpadding: 20px;\n\t\t\tborder: 0;\n\t\t\tbox-shadow: 0 5px 10px rgba(0,0,0,0.1);\n\t\t\t\n\t\t\t.picker__header{\n\t\t\t\tmargin-top: 0;\n\t\t\t\t\n\t\t\t\t.picker__year{\n\t\t\t\t\tcolor: $primary;\n\t\t\t\t\tfont-style: inherit;\n\t\t\t\t\tfont-size: 20px;\n\t\t\t\t}\n\t\t\t\n\t\t\t\t.picker__nav--prev,\n\t\t\t\t.picker__nav--next{\n\t\t\t\t\twidth: 40px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tline-height: 40px;\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent: none!important\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tfont-family: fontawesome;\n\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\t\tfont-size: 22px;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground-color: lighten($primary, 30)!important;\n\t\t\t\t\t\tcolor: $primary!important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.picker__nav--prev{\n\t\t\t\t\tleft: 0;\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent: \"\\f0d9\";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.picker__nav--next{\n\t\t\t\t\tright: 0;\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent: \"\\f0da\";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.picker__table{\n\t\t\t\t.picker__weekday {\n\t\t\t\t\tpadding: 10px 0;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t}\n\t\t\t\t.picker__day {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\tpadding: 0!important;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 40px;\n\t\t\t\t\tmargin: auto;\n\t\t\t\t\tborder: 0!important;\n\t\t\t\t\t\n\t\t\t\t\t&.picker__day--today{\n\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\tcontent: none !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t&.picker__day--highlighted {\n\t\t\t\t\t\tborder: 0!important;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tbackground-color: lighten($primary, 30)!important;\n\t\t\t\t\t\tcolor: $white!important;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground-color: lighten($primary, 30)!important;\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.picker__footer{\n\t\t\t\t.picker__button--today{\n\t\t\t\t\tbackground-color: lighten($primary, 30)!important;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent: none!important\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t.picker__button--clear, \n\t\t\t\t.picker__button--close, \n\t\t\t\t.picker__button--today{\n\t\t\t\t\tborder: 0;\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground-color: lighten($primary, 30)!important;\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t}\n\t\t\t\t\n\t\t@include respond('phone') {\n\t\t\tmin-width: 100%!important;\n\t\t\tmax-width: 100%!important;\n\t\t\t\n\t\t\t.picker__box{\n\t\t\t\tpadding: 15px;\n\t\t\t\tmargin: 0 10px;\n\t\t\t}\n\t\t}\n\t}\n\t\n}\n\n",".card-list{\n\toverflow: unset;\n\theight: calc(100% - 50px);\n\t\n\t.card-header{\n\t\tpadding-top: 0;\t\t\n\t\tpadding-bottom: 0;\n\t\t\n\t\t.photo{\n\t\t\toverflow: hidden;\n\t\t\tborder-radius: 5px;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t\n\t@include respond('tab-land') {\n\t\theight: calc(100% - 40px);\n\t}\n\n\t&.list-left{\n\t\tmargin-top: 15px;\n\t\tmargin-left: 15px;\n\t\t\n\t\t.card-header{\n\t\t\tpadding-left: 0;\n\t\t\t\n\t\t\t.photo{\n\t\t\t\tmargin: -15px 15px 0 -15px;\n\t\t\t}\n\t\t}\n\t}\n\t\n\t&.list-right{\n\t\tmargin-top: 15px;\n\t\tmargin-right: 15px;\n\t\ttext-align: right;\n\t\t\n\t\t.card-header{\n\t\t\tpadding-right: 0;\n\t\t\t\n\t\t\t.photo{\n\t\t\t\tmargin: -15px -15px 0 15px;\n\t\t\t\timg{\n\t\t\t\t\twidth:100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t&.list-center{\n\t\tmargin-top: 15px;\n\t\t\n\t\t.card-header{\n\t\t\t\n\t\t\t.photo{\n\t\t\t\tmargin: -15px 0 0 0;\n\t\t\t}\n\t\t}\n\t}\n\t.photo img{\n\t\twidth:100%;\n\t}\n}\n.card-profile{\n\t.profile-photo{\n\t\tmargin-top: -20px;\n\t}\n}",".widget-media{\n\t.timeline{\n\t\t.timeline-panel{\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tborder-bottom:1px solid $l-border;\n\t\t\tpadding-bottom: 15px;\n\t\t\tmargin-bottom: 15px;\n\t\t\t\n\t\t\t.media{\n\t\t\t\twidth: 50px;\n\t\t\t\theight: 50px;\n\t\t\t\tbackground: #eee;\n\t\t\t\tborder-radius: $radius;\n\t\t\t\toverflow: hidden;\n\t\t\t\tfont-size: 20px;\n\t\t\t\ttext-align: center;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tfont-weight: 700;\n\t\t\t\talign-self: start;\n\t\t\t\t\t\n\t\t\t\t&-primary{\n\t\t\t\t\tbackground:$primary-light;\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $primary-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-info{\n\t\t\t\t\tbackground:$info-light;\n\t\t\t\t\tcolor:$info;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $info-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-warning{\n\t\t\t\t\tbackground:$warning-light;\n\t\t\t\t\tcolor:$warning;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $warning-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-danger{\n\t\t\t\t\tbackground:$danger-light;\n\t\t\t\t\tcolor:$danger;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $danger-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-success{\n\t\t\t\t\tbackground:$success-light;\n\t\t\t\t\tcolor:$success;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $success-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.media-body{\n\t\t\t\tp{\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height:1.5;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.dropdown {\n\t\t\t\talign-self: self-end;\n\t\t\t\tmargin-top: 5px;\n\t\t\t}\n\t\t}\n\t\tli:last-child {\n\t\t\t.timeline-panel{\n\t\t\t\tmargin-bottom:0;\n\t\t\t\tborder-bottom:0;\n\t\t\t\tpadding-bottom:0;\n\t\t\t}\n\t\t}\n\t}\n}\n.card[class*=\"bg-\"]{\n\t.timeline{\n\t\t.timeline-panel{\n\t\t\tborder-color:rgba(255,255,255,0.2) !important;\n\t\t}\n\t}\n}","//style for all basic tables\n.table {\n\t\n\t@include respond('tab-land') {\n\t\tfont-size: 0.875rem !important;\n\t}\n\tstrong{\n\t\tcolor:$dark;\n\t}\n    td {\n        border-color: $border;\n\t\tpadding: 12px 9px;\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n    }\n\t&.shadow-hover tr:hover{\n\t    background-color:$white;\n\t\tbox-shadow: 0 0px 30px rgba($primary, 0.15);\n\t\t@at-root [data-theme-version=\"dark\"] & {\n            background-color: $d-bg;\n        }\n\t}\n\t&.bg-secondary-hover{\n\t\tth,td{\n\t\t\tborder:none;\n\t\t\tfont-weight:500;\n\t\t}\n\t\ttr:hover{\n\t\t\tbackground:$secondary;\n\t\t\ttd,th{\n\t\t\t\tcolor:$white!important;\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-info-hover{\n\t\tth,td{\n\t\t\tborder:none;\n\t\t\tfont-weight:500;\n\t\t}\n\t\ttr:hover{\n\t\t\tbackground:$info;\n\t\t\ttd,th{\n\t\t\t\tcolor:$white!important;\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-warning-hover{\n\t\tth,td{\n\t\t\tborder:none;\n\t\t\tfont-weight:500;\n\t\t}\n\t\ttr:hover{\n\t\t\tbackground:$warning;\n\t\t\ttd,th{\n\t\t\t\tcolor:$white!important;\n\t\t\t}\n\t\t}\t\n\t}\t\n\n    thead th {\n        border-bottom-width: 1px;\n        // color: $dark ;\n        font-size: 14px;\n        font-weight: 600;\n        letter-spacing: 0.5px;\n        border-color: $border;\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n    }\n    tbody  tr td {\n        // color: $l-ctd;\n        // line-height: 2.5rem;\n        vertical-align: middle;\n        border-color: $border;\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n    }\n\t\n\t//delete header borders without '.borders tables'\n    &:not(.table-bordered) {\n        thead th {\n            border-top: none;\n        }\n    }\n\n    //heading background\n    .thead-primary th {\n        background-color: $primary;\n        color: $white;\n    }\n\t.thead-info th {\n        background-color: $info;\n        color: $white;\n    }\n\t.thead-warning th {\n        background-color: $warning;\n        color: $white;\n    }\n\t.thead-danger th {\n        background-color: $danger;\n        color: $white;\n    }\n\t.thead-success th {\n        background-color: $success;\n        color: $white;\n    }\n\n    //table border\n    &.primary-table-bordered {\n        border: 1px solid $border;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n    }\n\n    //table hover\n    &.primary-table-bg-hover {\n        thead th {\n            background-color: darken($color: $primary, $amount: 5%);\n            color: $white;\n            border-bottom: none;\n        }\n\n        tbody tr {\n            background-color: $primary;\n            color: $white;\n            transition: all .1s ease;\n\n            &:hover {\n                background-color: lighten($color: $primary, $amount: 5%);\n            }\n\n            &:not(:last-child) {\n                td, th {\n                    border-bottom: 1px solid darken($color: $primary, $amount: 5%);\n                }\n            }\n        }\n    }\n\n    //responsive table width\n    &-responsive {\n        &-tiny {\n            // @include media-breakpoint-down(xs) {\n                min-width: 18.75rem;\n            // }\n        }\n\n        &-sm {\n            // @include media-breakpoint-down(sm) {\n                min-width: 30rem !important;\n            // }\n        }\n\n        &-md {\n            // @include media-breakpoint-down(sm) {\n                min-width: 36rem !important;\n            // }\n        }\n\n        &-lg {\n            min-width: 60.9375rem !important;\n        }\n\n        &-xl {\n            min-width: 70.9375rem !important;\n        }\n    }\n}\n.table-primary, \n.table-primary > th, \n.table-primary > td {\n\tbackground-color: $primary-light;\n\tcolor: $primary;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $primary-opacity;\n    }\n}\n.table-success, \n.table-success > th, \n.table-success > td {\n\tbackground-color: $success-light;\n\tcolor: $success;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $success-opacity;\n    }\n}\n.table-info, \n.table-info > th, \n.table-info > td {\n\tbackground-color: $info-light;\n\tcolor: $info;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $info-opacity;\n    }\n}\n.table-warning, \n.table-warning > th, \n.table-warning > td {\n\tbackground-color: $warning-light;\n\tcolor: $warning;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $warning-opacity;\n    }\n}\n.table-danger, \n.table-danger > th, \n.table-danger > td {\n\tbackground-color: $danger-light;\n\tcolor: $danger;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $danger-opacity;\n    }\n}\n.table-active, \n.table-active > th, \n.table-active > td {\n    background-color: $l-bg;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $d-bg;\n    }\n}\n\n.card-table{\n\tth, td{\n        &:first-child{\n\t\t\tpadding-left: 30px;\n\t\t\t@include respond('phone') {\n\t\t\t\tpadding-left: 15px;\n\t\t\t}\n\t\t}\n\t\t&:last-child{\n\t\t\tpadding-right:30px;\n\t\t\t@include respond('phone') {\n\t\t\t\tpadding-right: 15px;\n\t\t\t}\n\t\t}\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",".bootgrid-header {\n    padding: 0 !important;\n    margin: 0;\n\n    @include respond(phone) {\n        .actionBar {\n            padding: 0;\n        }\n    \n        .search {\n            margin: 0 0 10px 0;\n        }\n    }\n}","//demo styles\ntable#example{\n    padding: 0rem 0 2rem 0;\n}\ntable.dataTable{\n\tcolor:$black;\n\tborder-radius:$radius;\n}\n#example2_wrapper {\n    .dataTables_scrollBody {\n        max-height: 33.25rem !important;\n    }\n}\n\n#employees, #custommers {\n    padding: .5rem 0 1rem 0;\n}\n//////////\n.dataTables_wrapper .dataTables_paginate{\n    padding:25px 0;\n\t@include respond('laptop') {\n\t\tpadding:10px 0;\n\t}\n}\ntable.dataTable thead th, \ntable.dataTable thead td {\n   \tpadding: 20px 15px;\n    border-bottom: 1px solid $border;\n    @include respond('laptop') {\n\t\tpadding:8px 15px;\n\t}\n}\n\ntable.dataTable tfoot th,\ntable.dataTable tfoot td{\n    border-top: 0;\n}\n\ntable.dataTable tbody td{\n    background: #fff!important;\n}\n\ntable.dataTable thead th{\n    color: $black;\n\tfont-size:16px;\n\twhite-space: nowrap;\n    font-weight: 600;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white;\n    }\n\t@include respond('laptop') {\n\t\tfont-size:14px;\n\t}\n}\n\ntable.dataTable tbody td{\n\tfont-size: 16px;\n    padding: 15px 10px;\n\t@include respond('laptop') {\n\t\tpadding:8px 10px;\n\t\tfont-size:14px;\n\t}\n}\n\ntable.dataTable tr.selected{\n    color: $primary;\n}\n\ntable.dataTable tfoot th{\n    color: $dark;\n    font-weight: 600;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white;\n    }\n}\n.dataTables_wrapper {\n    input[type=\"search\"], input[type=\"text\"], select {\n        border: 1px solid #e2e2e2;\n        padding: .3rem 0.5rem;\n        color: rgba(113, 93, 93, 1);\n        border-radius: 5px;\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg;\n            border-color: $d-border;\n            color: $white;\n        }\n    }\n\t.dataTables_length{\n\t\tmargin-bottom: 15px;\n\t\t.bootstrap-select{\n\t\t\twidth: 80px!important;\n\t\t\tmargin: 0 5px;\n\t\t}\n\t}\n}\ntable.dataTable.no-footer{\n    border-bottom: 0;\n}\n.min-w850{\n\tmin-width:850px;\n}\n\n.rounded-lg{\n\tmin-width:30px;\n}\n.dataTables_scroll{\n    padding: 1rem 0;\n\n    &Foot{\n        padding-top: 1rem;\n    }\n}\n.dataTables_wrapper .dataTables_length, \n.dataTables_wrapper .dataTables_filter {\n    @include media-breakpoint-down(md) {\n        text-align: left;\n    }\n}\n.dataTablesCard{\n\tbackground-color: #fff;\n\tbox-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);\n\tborder-radius: 0;\n\t\n\ttbody tr:hover{\n\t\tbackground:$white!important;\n\t\tbox-shadow: 0px 0px 10px rgba(0,0,0,0.1);\n\t\ttd{\n\t\t\tbackground:transparent!important;\n\t\t}\n\t}\n}\ntable.dataTable.display tbody tr:hover{\n\tbox-shadow: 0px 0px 10px rgba(0,0,0,0.1);\n\ttd{\n\t\tbackground:transparent!important;\n\t}\n}\n.dataTables_wrapper .dataTables_info {\n    padding:25px 0;\n\t@include respond('laptop') {\n\t\tpadding:8px 0;\n\t}\n}\ntable.dataTable.display.white-border td{\n\tborder-color:$white;\n}\ntable.dataTable.row-border tbody th, \ntable.dataTable.row-border tbody td, \ntable.dataTable.display tbody th, \ntable.dataTable.display tbody td {\n    border-color: $border-color;\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n}\ntable.dataTable thead .sorting{\n\tbackground-position: center right 15px;\n}\n\n.dataTables_wrapper .dataTables_paginate{\n\tborder-radius:$radius;\n\tspan{\n\t\tborder-radius:$radius;\n\t\tdisplay: inline-block;\n\t\tbackground:rgba($primary,0.08);\n\t\tborder:0px solid $primary;\n\t\tmargin: 0 0;\n\t\t\t\n\t\ta{\n\t\t\tcolor:$white;\n\t\t\tbackground: transparent !important;\n\t\t}\n\t}\n\t.paginate_button{\n\t\tborder: 0 !important;\n\t\tpadding: 15px 24px;\n\t\tbackground: transparent !important;\n\t\tborder-radius: $radius;\n\t\tcolor:$primary !important;\n\t\tfont-size:16px;\n\t\tmargin:0;\n\t\tdisplay:inline-block;\n\t\t@include respond('laptop') {\n\t\t\tpadding: 8px 15px;\n\t\t\tfont-size:14px;\n\t\t}\n\t\t&:hover,\n\t\t&.current:hover,\n\t\t&.current{\n\t\t\tcolor:$white !important;\n\t\t\tbackground:$primary !important;\n\t\t}\n\t\t\n\t\t&.previous,\n\t\t&.next{\n\t\t\tbackground:$white!important;\n\t\t\tcolor:$primary !important;\n\t\t\tmargin: 0 10px;\n\t\t\tborder:0px solid $primary!important;\n\t\t\t&:hover{\n\t\t\t\tbackground:$primary!important;\n\t\t\t\tcolor:$white !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",".fooicon {\n    font-size: 1.25rem;\n    color: $dark;\n}",".jsgrid-table{\n\n    .jsgrid-header-row{\n\n        & > .jsgrid-header-cell{\n            color: $dark;\n        }\n    }\n\n    & > tbody > tr > td{\n        padding: 1.2em;\n    }\n\n    .jsgrid-insert-row, .jsgrid-edit-row{\n\n        input, select{\n            border: 1px solid #DDDFE1;\n        }\n    }\n}\n\n.jsgrid .jsgrid-button{\n    border: 0 !important;\n    margin-left: 10px;\n}\n",".error-page{\n\t.error-text {\n\t\tfont-size: 150px;\n\t\tline-height: 1;\n\t\tcolor:$secondary;\n\t\t@include respond('phone') {\n\t\t\tfont-size: 80px;\n\t\t}\n\t}\n\th4{\n\t\tfont-size: 40px;\n\t\tmargin-bottom: 5px;\n\t\tcolor:$secondary;\n\t\t@include respond('phone') {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\tp{\n\t\tfont-size: 16px;\n\t\t@include respond('phone') {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}",".authincation-content{\n    background: $primary;\n    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n    border-radius: 5px;\n    @at-root [data-theme-version=\"dark\"] & {\n        background: $dark-card;\n        box-shadow: none;\n    }\n\n}\n.welcome-content{\n    background: url('./../images/1.jpg');\n    background-size: cover;\n    background-position: center;\n    height: 100%;\n    padding: 75px 50px;\n    position: relative;\n    z-index: 1;\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n    &::after{\n        content: '';\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        background: $primary;\n        opacity: 0.75;\n        z-index: -1;\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px;\n    }\n    .welcome-title{\n        color: $white;\n        font-weight: 500;\n        font-size: 20px;\n    }\n    p{\n        color: $white;\n    }\n\n    .brand-logo{\n        a{\n            display: inline-block;\n            margin-bottom: 20px;\n            font-weight: 700;\n            color: $white;\n            font-size: 20px;\n        img{\n            width: 100px;\n        }\n        }\n    }\n\n    .intro-social{\n        position: absolute;\n        bottom: 75px;\n        ul{\n            margin-bottom: 0;\n            li{\n                display: inline-block;\n                a{\n                    color: $white;\n                    font-size: 14px;\n                    padding: 0px 7px;\n                }\n            }\n        }\n    }\n}\n.auth-form{\n    padding: 50px 50px;\n\t@include respond('phone') {\n\t\tpadding: 30px;\n\t}\t\n    .btn{\n        font-weight: 700;\n    }\n    .page-back{\n        display: inline-block;\n        margin-bottom: 15px;\n    }\n}",".pricing_table_content {\n    background        : $white;\n    text-align        : center;\n    border            : 1px solid #e7e7e7;\n    border-radius     : 3px;\n    padding           : 25px;\n    -webkit-transition: all 0.25s ease-in-out;\n    transition        : all 0.25s ease-in-out;\n\n    .package {\n        font-weight: 700;\n        font-size  : 18px;\n        // font-family: $p_hf;\n    }\n\n    .price {\n        font-weight: 700;\n        font-size  : 50px;\n        // font-family: $p_hf;\n        line-height: 100px;\n        color      : $dark;\n    }\n\n    hr {\n        margin: 0;\n    }\n\n    .price_list {\n        padding   : 30px 0;\n        text-align: left;\n        max-width : 175px;\n        margin    : 0 auto;\n\n        li {\n            // font-family: $p_op;\n            color      : #909093;\n            font-size  : 14px;\n            line-height: 25px;\n            padding    : 7px 0;\n\n            i {\n                margin-right: 15px;\n                // color       : $p_bc;\n            }\n        }\n    }\n\n    .price-btn {\n        padding           : 15px 50px;\n        -webkit-box-shadow: none;\n        box-shadow        : none;\n        border            : 1px solid $l-border;\n        // color             : $p_bc;\n        border-radius     : 5px;\n        font-weight       : 700;\n        font-size         : 14px;\n        // font-family       : $p_hf;\n        margin-bottom     : 25px;\n        -webkit-transition: all 0.25s ease-in-out;\n        transition        : all 0.25s ease-in-out;\n    }\n\n    &:focus,\n    &:hover {\n        -webkit-transform : scale(1.05);\n        transform         : scale(1.05);\n        -webkit-box-shadow: 0 0 10px rgba(0,0,0,0.175);\n        box-shadow        : 0 0 10px rgba(0,0,0,0.175);\n\n        .price-btn {\n            // background: $p_bc;\n            color     : $danger;\n        }\n    }\n}\n\n\n",".page-timeline{\n    .timeline {\n        list-style: none;\n        padding   : 40px 0;\n        position  : relative;\n    \n        &-workplan#{&} {\n            padding-bottom: 0;\n            margin-bottom: 0;\n    \n            &.timeline > li > .timeline-badge {\n                top: 4.5rem;\n            }\n    \n            &>li {\n                margin-bottom: 2.6rem;\n            }\n    \n            li {\n                >p{\n    \n                    @include custommq($min: 1200px, $max: 1650px) {\n                        max-width: 8rem;\n                    }\n    \n                    @include respond('tab-land') {\n                        max-width: 7rem;\n                    }\n    \n                    @include respond('tab-port') {\n                        max-width: 100%;\n                    }\n    \n                    @include respond('phone') {\n                        max-width: 7rem;\n                    }\n                }\n            }\n    \n            &::before {\n                left: 20%;\n                top: 6rem;\n    \n                @at-root [direction=\"rtl\"] #{&} {\n                    right: 22%;\n                    left: auto;\n                }\n    \n                @include respond('phone') {\n                    left: 22%;\n                }\n            }\n    \n            .timeline-badge {\n                left: 21.4%;\n                height: 0.9rem;\n                width: 0.9rem;\n                background-color: $primary;\n    \n                @at-root [direction=\"rtl\"] #{&} {\n                    right: 19.2%;\n                    left: auto;\n                }\n    \n                @include custommq($min: 1200px, $max: 1650px) {\n                    left: 22.4%;\n                }\n    \n                @include respond('tab-land') {\n                    left: 22.4%;\n                }\n    \n                @include respond('tab-port') {\n                    left: 21.7%;\n                }\n    \n                @include respond('phone-land') {\n                    left: 19.5%;\n                }\n    \n                @include respond('phone') {\n                    left: 21.4%;\n                }\n    \n                &::after {\n                    position: absolute;\n                    width: 1.9rem;\n                    height: 1.9rem;\n                    background-color: rgba($color: $primary, $alpha: .4);\n                    content: \"\";\n                    border-radius: 50%;\n                    left: 50%;\n                    top: 50%;\n                    transform: translate(-50%, -50%);\n                }\n            }\n            .timeline-panel {\n                width: 70%;\n            }\n        }\n    }\n    \n    .timeline:before {\n        top             : 0;\n        bottom          : 0;\n        position        : absolute;\n        content         : \" \";\n        width           : 2px;\n        background-color: #ECEFF2;\n        left            : 50%;\n        margin-left     : -1.5px;\n    }\n    \n    .timeline > li {\n        margin-bottom: 20px;\n        position     : relative;\n    }\n    \n    .timeline > li:after,\n    .timeline > li:before {\n        content: \" \";\n        display: table;\n    }\n    \n    .timeline > li:after {\n        clear: both;\n    }\n    \n    .timeline > li:after,\n    .timeline > li:before {\n        content: \" \";\n        display: table;\n    }\n    \n    .timeline > li:after {\n        clear: both;\n    }\n    \n    .timeline > li > .timeline-panel {\n        width             : 46%;\n        float             : left;\n        // border            : 1px solid #d4d4d4;\n        border-radius     : 2px;\n        // padding           : 20px;\n        position          : relative;\n        // -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);\n        // box-shadow        : 0 0 4px rgba(0, 0, 0, 0.3);\n    }\n    \n    .timeline > li > .timeline-badge {\n        background-color: $l-bg;\n        border: 1px solid $iron;\n        border-radius   : 50%;\n        color           : $dark;\n        // font-size       : 1.4em;\n        height          : 40px;\n        left            : 50%;\n        line-height     : 40px;\n        margin-left     : -13px;\n        position        : absolute;\n        text-align      : center;\n        top             : 30px;\n        width           : 40px;\n        z-index         : 1;\n        transform: translate(-25%, -3rem);\n    \n        @include media-breakpoint-up(sm){\n            width: 50px;\n            height: 50px;\n            line-height: 50px;\n        }\n    \n        // i{\n        //     color: $pale-sky;\n        // }\n    \n    \n    }\n    \n    .timeline > li.timeline-inverted > .timeline-panel {\n        float: right;\n    \n        // @at-root [direction=\"rtl\"] #{&} {\n        //     float: left;\n        // }\n    }\n    \n    .timeline > li.timeline-inverted > .timeline-panel:before {\n        border-left-width : 0;\n        border-right-width: 15px;\n        left              : -15px;\n        right             : auto;\n    }\n    \n    .timeline > li.timeline-inverted > .timeline-panel:after {\n        border-left-width : 0;\n        border-right-width: 14px;\n        left              : -14px;\n        right             : auto;\n    }\n    \n    .timeline-title {\n        margin-top: 0;\n        color     : inherit;\n    }\n    \n    .event_time {\n        // color         : $bc;\n        font-size  : 14px;\n        // text-transform: uppercase;\n        font-weight: 600;\n    }\n    \n    .event_vanue {\n        // color         : $bc;\n        font-size  : 14px;\n        margin     : 5px 0;\n        // text-transform: uppercase;\n        font-weight: 600;\n    }\n    \n    .timeline_img {\n        height: 100px;\n        width : 100px;\n    }\n    \n    .timeline-body > p,\n    .timeline-body > ul {\n        margin-bottom: 0;\n    }\n    @media (max-width: 767px) {\n        ul.timeline:before {\n            left: 40px;\n        }\n    \n        ul.timeline > li > .timeline-panel {\n            width: calc(100% - 90px);\n            width: -webkit-calc(100% - 90px);\n        }\n    \n        ul.timeline > li > .timeline-badge {\n            left: 28px;\n            margin-left: 0;\n            top        : 16px;\n    \n            // @include media-breakpoint-up(sm){\n            //     left: 15px;\n            // }\n        }\n    \n        ul.timeline > li > .timeline-panel {\n            float: right;\n        }\n    \n        ul.timeline > li > .timeline-panel:before {\n            border-left-width : 0;\n            border-right-width: 15px;\n            left              : -15px;\n            right             : auto;\n        }\n    \n        ul.timeline > li > .timeline-panel:after {\n            border-left-width : 0;\n            border-right-width: 14px;\n            left              : -14px;\n            right             : auto;\n        }\n    \n        .timeline_img {\n            height: 30%;\n            width : 30%;\n        }\n    }\n    \n    \n    \n    .timeline-timestamp {\n        text-align: center;\n            \n        .badge {\n            padding: .8rem 2rem;\n            border-radius: 50px;\n            font-size: 0.8125rem;\n        }\n    }    \n}",".full-map-area{\n\tposition:relative;\n\tborder-radius: 12px;\n    overflow: hidden;\n\t\n\ta{\n\t\tposition:absolute;\n\t\tbottom:30px;\n\t\tleft:30px;\n\t}\n\ti{\n\t\tbackground: #3e4954;\n\t\tposition: absolute;\n\t\ttop: 30px;\n\t\tright: 30px;\n\t\twidth: 56px;\n\t\theight: 56px;\n\t\ttext-align: center;\n\t\tline-height: 56px;\n\t\tfont-size: 24px;\n\t\tcolor: #fff;\n\t\tborder-radius: 56px;\n\t}\n\timg\n\t{\n\t\twidth:100%;\n\t}\n}\n.iconbox{\n    position: relative;\n    padding-left: 70px;\n\t\n\ti{\n\t\tbackground:$primary;\n\t\twidth:50px;\n\t\theight:50px;\n\t\tline-height:50px;\n\t\tborder-radius:50px;\n\t\ttext-align:center;\n\t\tfont-size:28px;\n\t\tcolor:$white;\n\t\tposition:absolute;\n\t\tleft:0;\n\t\ttop:0;\n\t}\n\tp{\n\t\tmargin: 0;\n\t\tcolor: #484848;\n\t\tfont-size: 18px;\n\t\tline-height: 1.3;\n\t\tfont-weight: 500;\n\t}\n\tsmall{\n\t\tmargin-bottom: 5px;\n\t\tfont-size: 16px;\n\t\tdisplay: block;\n\t}\n}\n.widget-timeline-icon{\n\tli{\n\t\tpadding-left: 25px;\n\t\tposition: relative;\n\t\tmargin-left: 11px;\n\t\tborder-left: 3px solid $primary;\n\t\tmin-height: 80px;\n\t\tpadding-top: 1px;\n\t\n\t\t.icon{\n\t\t\tposition: absolute;\n\t\t\twidth: 22px;\n\t\t\theight: 22px;\n\t\t\tfont-size: 24px;\n\t\t\tcolor: #fff;\n\t\t\ttext-align: center;\n\t\t\tline-height: 22px;\n\t\t\tborder-radius: 22px;\n\t\t\tleft:-13px;\n\t\t\ttop: 0;\n\t\t}\n\t\t.timeline-panel{\n\t\t\n\t\t}\n\t\t&:last-child{\n\t\t\tborder-left: 3px solid transparent;\n\t\t}\n\t}\n}",".contact-icon {\n    height: 50px;\n    width: 50px;\n    min-width: 50px;\n    background:rgba($primary,0.2);\n    color: $primary;\n    font-size: 28px;\n    border-radius: $radius;\n    line-height: 50px;\n\t@include transitionMedium;\t\n    text-align: center;\n\t&:hover{\n\t\tcolor:$white;\n\t\tbackground:$primary;\n\t}\n\t@include respond ('laptop'){\n\t\theight: 40px;\n\t\twidth: 40px;\n\t\tmin-width: 40px;\n\t\tline-height:42px;\n\t\tfont-size:25px;\n\t}\n}",".review-table {\n    padding: 25px;\n    box-shadow: none;\n    border-radius: 0;\n    border-bottom: 1px solid #eee;\n    height: auto;\n    margin-bottom: 0;\n\t.star-review i {\n\t\tfont-size: 20px;\n\t}\n\t.media-body{\n\t\tp{\n\t\t\tcolor: #3e4954;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 1.5;\n\t\t}\n\t}\n\t.disease {\n\t\tborder-left: 1px solid $border-color;\n\t\tpadding-left: 20px;\n\t}\n\t.media-footer {\n\t\tmin-width: 500px;\n\t\tmargin-left: 10px;\n\t}\n\t@include respond ('laptop'){\n\t\t.media-footer{\n\t\t\tmin-width: 273px;\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n\t@include respond ('tab-port'){\n\t\t.star-review i {\n\t\t\tfont-size: 16px;\n\t\t}\n\t\t.custom-control {\n\t\t\tfloat: right;\n\t\t\tright:-20px;\n\t\t}\n\t\t.media{\n\t\t\tdisplay: block !important;\n\t\t}\n\t\t.media-body{\n\t\t\tp {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t}\n\t\timg {\n\t\t\tfloat: left;\n\t\t\twidth: 80px;\n\t\t}\n\t\t.media-footer {\n\t\t\tmargin-left: 0;\n\t\t\tmargin-top: 25px;\n\t\t}\n\t\t.disease {\n\t\t\tborder-left: 0;\n\t\t\tpadding-left: 0;\n\t\t\tmargin-right: 10px !important;\n\t\t\tmargin-left: 0;\n\t\t}\n\t}\n\t@include respond ('phone'){\n\t\t.media-footer{\n\t\t\tflex-flow:wrap;\n\t\t\t.disease{\n\t\t\t\tmargin-right:auto!important;\n\t\t\t}\n\t\t\t.edit{\n\t\t\t\tmargin-left:0!important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n//review-tab\n.review-tab{\n\t.nav-link{\n\t\tborder-radius:0;\n\t\tfont-weight:600;\n\t\tborder-bottom:2px solid #D9D9D9;\n\t\t@include transitionMedium;\n\t\t&.active{\n\t\t\tbackground:transparent;\n\t\t\tcolor:$primary;\n\t\t\t@include transitionMedium;\n\t\t\tbox-shadow:none;\n\t\t\tborder-color:$primary;\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\tpadding: 10px 16px;\n\t\t\tfont-size: 13px;\n\t\t}\n\t}\n}",".search-job{\n\t.form-control {\n\t\twidth: 50%;\n\t\t@include respond ('phone-land'){\n\t\t\twidth:100%;\n\t\t}\n\t}\n}\n.sharp-lg {\n    min-width: 50px;\n    height: 50px;\n\tline-height:48px;\n    min-height: 50px;\n    text-align: center;\n\t@include respond ('laptop'){\n\t\tmin-height: 40px;\n\t\theight: 40px;\n\t\tmin-width: 40px;\n\t\tline-height: 38px;\n\t}\n}\n.search-row{\n\t.title{\n\t\tfont-size:20px;\n\t\tfont-weight:600;\n\t}\n\t.sub-title{\n\t\tfont-size:18px;\n\t}\n\t&:hover{\n\t\tbox-shadow: 0px 0px 20px rgba(0,0,0,0.1);\n\t}\n\t@include respond ('laptop'){\n\t\t.title{\n\t\t\tfont-size:17px;\n\t\t}\n\t\t.sub-title{\n\t\t\tfont-size:16px;\n\t\t}\n\t}\n}\n.aroundYou{\n\tborder-right:1px solid $border-color;\n\t@include respond ('tab-port'){\n\t\tborder-right:0;\n\t}\n}\n.like-btn {\n    display: inline-block;\n    padding-left: 0;\n    margin-bottom: 12px;\n    cursor: pointer;\n    font-size: 22px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    font-family: FontAwesome;\n}\n.like-btn input {\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n\tdisplay:block;\n}\n.checkmark {\n    height: 40px;\n\ttext-align: center;\n\tline-height:38px;\n    width: 40px;\n\tdisplay: block;\n    border: 1px solid $primary;\n    border-radius: 20px;\n\t@include respond ('laptop'){\n\t\theight:32px;\n\t\twidth:32px;\n\t\tline-height:29px;\n\t}\n}\n.like-btn .checkmark:before {\n    content: \"\\f097\";\n    font-size: 20px;\n    font-weight: 400;\n    color: $primary;\n\t@include respond ('laptop'){\n\t\tfont-size: 17px;\n\t}\n}\n\n.like-btn input:checked~.checkmark {\n    background-color: $primary;\n}\n\n.like-btn input:checked~.checkmark:before {\n    width: 100%;\n    height: 100%;\n    background-color: $primary;\n    left: 0;\n    top: 0;\n    border-radius: 20px;\n    color: #fff;\n    padding: 3px 6px;\n}",".profile-card{\n\t.title{\n\t\tposition:relative;\n\t\tspan{\n\t\t\tdisplay:inline-block;\n\t\t\ttext-transform:uppercase;\n\t\t\tbackground:$white;\n\t\t\tposition:relative;\n\t\t\tz-index:1;\t\n\t\t\tpadding-right:30px;\n\t\t}\n\t\t&:after{\n\t\t\twidth:100%;\n\t\t\theight:1px;\n\t\t\tbackground:#E7E7E7;\n\t\t\tposition:absolute;\n\t\t\ttop:50%;\n\t\t\ttransform:translatey(-50%);\n\t\t\tleft:0;\n\t\t\tcontent:\"\";\n\t\t}\n\t}\n\t.form-group{\t\n\t\tmargin-bottom: 30px;\n\t\tlabel{\n\t\t\tfont-weight:500;\n\t\t}\n\t\t.input-icon{\n\t\t\t.form-control{\n\t\t\t\tpadding-left: 70px;\n\t\t\t\tz-index:0;\n\t\t\t\t@include respond('phone-land') {\n\t\t\t\t\tpadding-left: 50px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.input-group-prepend{\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 10px;\n\t\t\tz-index: 1;\n\t\t\ttransform: translatey(-50%);\n\t\t\t.input-group-text{\n\t\t\t\tbackground:transparent;\n\t\t\t\ti{\n\t\t\t\t\tfont-size:30px;\n\t\t\t\t\tcolor:$primary;\n\t\t\t\t\t@include respond('phone-land') {\n\t\t\t\t\t\tfont-size:20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t@include respond ('phone-land'){\n\t\t\t\tleft:0;\n\t\t\t}\n\t\t}\n\t\t.bootstrap-select.form-control{\n\t\t\tpadding:0;\n\t\t\tbutton{\n\t\t\t\tpadding: 10px 20px;\n\t\t\t\theight: 70px;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 45px;\n\t\t\t\tbackground:#FBFBFB;\n\t\t\t\tborder-color:#C2C2C2!important;\n\t\t\t\tcolor:$black;\n\t\t\t\tborder-radius:$radius;\n\t\t\t\t@include respond('phone-land') {\n\t\t\t\t\theight: 45px;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tpadding: 0 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.dropdown-toggle:after{\n\t\t\t\tcolor:$primary;\n\t\t\t\tfont-size:30px;\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\tfont-size:20px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.form-control{\n\t\t\theight: 70px;\n\t\t\tfont-size: 18px;\n\t\t\tpadding: 0 20px;\n\t\t\tborder-color:#C2C2C2!important;\n\t\t\tbackground:#FBFBFB;\n\t\t\tcolor:$black;\n\t\t\tborder-radius:$radius;\n\t\t\t&::placeholder{\n\t\t\t\tcolor:#BBBBBB;\n\t\t\t}\n\t\t\t@include respond('phone-land') {\n\t\t\t\theight: 45px;\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t}\n\t\ttextarea.form-control{\n\t\t\theight: unset!important;\n\t\t\tborder: 1px solid;\n\t\t\tborder-color:#C2C2C2;\n\t\t\tborder-radius:$radius;\n\t\t\tcolor:rgba($black,0.7);\n\t\t\tbackground:#FBFBFB;\n\t\t\tborder-width: 1px!important;\n\t\t\tfont-size: 16px!important;\n\t\t\tpadding: 15px 20px!important;\n\t\t}\n\t\t\n\t}\n}\n.progress-icon{\n\theight:62px;\n\twidth:62px;\n\tdisplay:block;\n\tfont-weight:600;\n\tborder-radius:$radius;\n\tline-height:62px;\n\ttext-align:center;\n\tbackground:rgba($primary,0.1);\n\tcolor:$primary;\n\t@include respond ('phone'){\n\t\theight:50px;\n\t\twidth:50px;\n\t\tline-height:50px;\n\t}\n}\n.skill-progress{\n\toverflow: visible;\n\t.progress-bar{\n\t\tposition:relative;\n\t\tborder-radius: 10px;\n\t\toverflow: visible;\n\t\t&:after{\n\t\t\tcontent:\"\";\n\t\t\tposition:absolute;\n\t\t\theight:26px;\n\t\t\twidth:26px;\n\t\t\ttop:50%;\n\t\t\ttransform:translatey(-50%);\n\t\t\tright:0;\n\t\t\tborder-radius:5px;\n\t\t\tbackground:$primary;\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\t&:after{\n\t\t\t\theight: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t}\n\t\t}\n\t}\n}\t",".network-chart{\n\tmargin-top:-90px;\n\tmargin-bottom:-40px;\n\t@include respond ('mid-desktop'){\n\t\tmargin-top:0;\n\t}\n\t@include respond ('tab-land'){\n\t\tmargin-top:-90px;\n\t}\n\t@include respond ('phone'){\n\t\tmargin-top: -30px;\n\t\tmargin-bottom: -40px;\n\t}\n}\n.network-header{\n\tposition:relative;\n\tz-index:3;\n}",".items-table{\n\n\t tbody{\n\t\t\n\t\ttr{\n\t\t\tpadding:0;\n\t\t\tborder-radius: $radius;\n\t\t\tposition: relative;\n\t\t\tbox-shadow: 0 1px 0 0 #f8f8f8;\n\t\t\t@include transitionMedium;\n\t\t\t.dropdown{\n\t\t\t\topacity:0;\n\t\t\t}\n\t\t\t&.active,\n\t\t\t&:hover{\n\t\t\t\tbox-shadow: 0 4px 4px 0 rgba(0,0,0,0.25);\n\t\t\t\tz-index: 1;\n\t\t\t\t.dropdown{\n\t\t\t\t\topacity:1;\n\t\t\t\t}\t\n\t\t\t}\n\t\t\tth,\n\t\t\ttd{\n\t\t\t\tborder: 0;\n\t\t\t\tpadding:18px 8px;\n\t\t\t}\n\t\t}\n\t}\n\t@include respond('phone') {\n\t\twidth:500px;\n\t}\t\n}\n\n.star-review{\n\ti{\n\t\tfont-size:16px;\n\t\t&.text-gray{\n\t\t\tcolor:#d9d9d9;\n\t\t}\n\t}\n\tspan{\n\t\tcolor:$black;\n\t}\n}\n\n\n// Form Head\n.form-head{\n\n\t.breadcrumb{\n\t\tbackground:transparent;\n\t\tpadding:0;\n\t}\n\t.search-area{\n\t\tmax-width:300px;\n\t\tborder-radius: 0;\n\t\t@include respond('laptop') {\n\t\t\tmax-width:250px;\n\t\t}\n\t\t@include respond('phone') {\n\t\t\tmax-width:250px;\n\t\t}\n\t\t.form-control{\n\t\t\tborder: 0;\n\t\t\theight: 56px;\n\t\t\tpadding: 10px 15px;\n\t\t\tfont-size: 16px;\n\t\t\tbackground:#f1f1f1;\n\t\t\tborder-radius:0;\n\t\t\t@include respond('laptop') {\n\t\t\t\theight: 41px;\n\t\t\t\tpadding: 10px 15px;\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\t\t}\n\t\t.input-group-append .input-group-text{\n\t\t\tbackground:#f1f1f1;\n\t\t\tpadding: 0 5px  0 30px;\n\t\t\t@include respond('laptop') {\n\t\t\t\tpadding: 0 5px  0 30px;\n\t\t\t}\n\t\t\ti {\n\t\t\t\tfont-size: 20px;\n\t\t\t\tcolor:$body-color;\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.dropdown {\n\t\t.btn{\n\t\t\t\n\t\t\ti{\n\t\t\t\ttransform: scale(1.3);\n\t\t\t\t-moz-transform: scale(1.3);\n\t\t\t\t-webkit-transform: scale(1.3);\n\t\t\t\t-ms-transform: scale(1.3);\n\t\t\t\t-o-transform: scale(1.3);\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\t\t}\n\t\t&:after{\n\t\t\tcolor:$primary;\n\t\t\tfont-size:25px;\n\t\t}\n\t}\n\t/* .btn i{\n\t\tline-height: 1;\n\t\ttransform: scale(1.3);\n\t\tdisplay: inline-block;\n\t\tmargin-right: 5px;\n\t} */\n\t/* .btn-outline-primary{\n\t\tborder-color:#eee;\n\t\t&:hover{\n\t\t\tborder-color:$primary;\n\t\t}\n\t} */\n\t& > *{\n\t\t@include respond('phone-land') {\n\t\t\tmargin-right:5px !important;\n\t\t\tmargin-bottom:10px;\t\n\t\t\tvertical-align: baseline;\n\t\t\tmargin-left:0 !important;\n\t\t}\n\t}\n\t@include respond('phone-land') {\n\t\tdisplay:block !important;\n\t}\n}\n.rounded{\n\tborder-radius:$radius !important;\n}\n.btn-link{\n    font-weight: 500;\n    font-size: 16px;\n\t@include respond('laptop') {\n\t\tfont-size: 14px;\n\t}\n}\n.deznav .copyright{\n\tfont-size:14px;\n\tpadding: 0 45px 60px;\n\tmargin-top: 40px;\n\tcolor: #969BA0;\n\tmargin-bottom: 40px;\n\t\n\tp{\n\t\tmargin-bottom:10px;\n\t}\n\tstrong{\n\t\tdisplay:block;\n\t}\n\t\n\t@include respond('laptop') {\n\t\tpadding:0 25px 60px;\n\t}\n\t@include respond ('phone-land'){\n\t\tpadding-bottom: 60px;\n\t}\n}\n.widget-buyer {\n    .media {\n        img {\n            width: 30px;\n        }\n        .media-body {\n            h5 {\n                font-size: 14px;\n                margin-bottom: 0px;\n            }\n            p {\n                font-size: 13px;\n            }\n        }\n    }\n}\n\n.recentOrderTable {\n    table {\n        margin-bottom: 0;\n        overflow: hidden;\n        thead {\n            th {\n                font-size: 12px;\n            }\n        }\n        tbody {\n            td {\n                color: $dark;\n                font-weight: 500;\n                line-height: 40px;\n                @at-root [data-theme-version=\"dark\"] & {\n                    color: $d-ctl;\n                }\n                img {\n                    border-radius: 50px;\n                }\n                .custom-dropdown {\n                    i {\n                        padding: 0 10px;\n                        cursor: pointer;\n                    }\n                }\n            }\n        }\n    }\n}\n.activity_overview{\n\t.nav-tabs{\n\t\tborder-bottom:1px solid rgba(255,255,255,0.2) !important;\n\t}\n\t.custom-tab-1 .nav-link{\n\t\tcolor:rgba(255,255,255,0.5);\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-right: 30px;\n\t\t\n\t\t&:hover,\n\t\t&.active{\n\t\t\tbackground:transparent;\n\t\t\tcolor:#fff;\n\t\t\tborder-color: #fff;\n\t\t}\n\t}\n}\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n    background-color: transparent!important;\n    opacity: 0.9;\n}\n\n.chart-link {\n    @include respond('phone') {\n        display: flex;\n        align-items: center;\n    }\n    @include respond('tab-land') {\n        display: flex;\n        align-items: center;\n    }\n    @include respond('desktop') {\n        display: flex;\n        align-items: center;\n    }\n    .week-link {\n        display: inline-block;\n        // @include respond('tab-land'){\n        //     display: flex;\n        // }\n    }\n    a {\n        display: inline-block;\n        font-size: 12px;\n        font-weight: 500;\n        margin-right: 10px;\n        i {\n            font-size: 13px;\n            &.text-primary {\n                color: $primary;\n            }\n            &.text-muted {\n                color: #DAE2F3!important;\n            }\n        }\n    }\n    .form-control {\n        max-width: 97px;\n        display: inline-block;\n    }\n}\n.input-group {\n\t&.input-group-lg{\n\t\t.form-control,.input-group-text{\n\t\t\theight:80px;\n\t\t\tpadding:10px 30px;\n\t\t\t@include respond('phone') {\n\t\t\t\theight:50px;\n\t\t\t\tpadding: 10px 15px;\n\t\t\t\tfont-size:14px;\n\t\t\t}\n\t\t}\n\t\t.input-group-text{\n\t\t\twidth:200px;\n\t\t\ttext-align:left;\n\t\t\t@include respond('phone') {\n\t\t\t\twidth:120px;\n\t\t\t\tpadding: 10px 15px;\n\t\t\t\theight:50px;\n\t\t\t\tfont-size:14px;\n\t\t\t}\n\t\t}\n\t}\n}\n.card-tabs {\n    .nav-tabs {\n\t\tborder-bottom: 0px;\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t\tborder-radius: 0;\n\t\tflex-wrap: unset;\n\t\t\t\n        .nav-link {\n            border-radius:0;\n\t\t    padding: 12px 20px;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size:14px;\n\t\t\tborder:1px solid $border-color;\n\t\t\tcolor:$primary;\n            &.active {\n                background: $light;\n            }\n\t\t\t@include respond('laptop') {\n\t\t\t\tpadding: 8px 15px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n        }\n\t\t&.tabs-lg{\n\t\t\t.nav-link {\n\t\t\t\tpadding:23px 30px;\n\t\t\t\tfont-size:16px;\n\t\t\t\t@include respond('phone-land') {\n\t\t\t\t\tpadding:10px 15px;\n\t\t\t\t\tfont-size:14px;\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\t\n    }\n\t&.icontabs{\n\t\t.nav-tabs{\n\t\t\tbackground:transparent;\n\t\t\t.nav-item{\n\t\t\t\t.nav-link{\n\t\t\t\t\theight:42px;\n\t\t\t\t\twidth:42px;\n\t\t\t\t\tline-height:42px;\n\t\t\t\t\ttext-align:center;\n\t\t\t\t\tbackground:rgba($gray,0.6);\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\tmargin-right:15px;\n\t\t\t\t\tborder-radius:\t50px;\n\t\t\t\t\tpadding:0;\n\t\t\t\t\t&.active{\n\t\t\t\t\t\tbackground:$warning;\n\t\t\t\t\t}\n\t\t\t\t\ti{\n\t\t\t\t\t\tfont-size:25px;\n\t\t\t\t\t\tline-height:42px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.revenue-chart .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{\n\tdisplay:flex !important;\n\tmargin-right: 30px !important;\n\tmargin-bottom: 30px !important;\n}\n.revenue-chart-bar{\n\tmargin-bottom:-30px;\n\t\n\t@include respond('phone') {\n\t\tmargin-bottom: 20px;\n\t\tfloat: none;\n\t\tpadding-left: 20px;\n\t}\n}\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n\t.revenue-chart-bar{\n\t\tmargin-bottom: 20px;\n\t\tfloat: none;\n\t\tpadding-left: 20px;\n\t}\n}\n#activeUser {\n    height: 215px!important;\n}\n#activeUser {\n    height: 180px!important;\n}\nspan#counter {\n    font-size: 30px;\n    font-weight: 700;\n    color: $primary;\n}\n.social-graph-wrapper {\n    text-align: center;\n    padding: 20px;\n    position: relative;\n    color: $white;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n\t\n    &.widget-facebook {\n        background-color: $facebook;\n    }\n    &.widget-twitter {\n        background-color: $twitter;\n    }\n    &.widget-linkedin {\n        background-color: $linkedin;\n    }\n    &.widget-googleplus {\n        background-color: $google-plus;\n    }\n    .s-icon {\n        font-size: 24px;\n        position: relative;\n        // top: 0.625rem;\n        padding: 0 10px;\n    }\n}\n.recent-stats i{\n    font-size: 11px;\n    position: relative;\n    top: -1px;\n}\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n\t#lineChart_3Kk{\n\t\theight: 140px !important;\n\t}\n}\n/* add menu sidebar */\n.add-menu-sidebar{\n\tbackground: $primary; \n\tpadding: 40px 20px 20px;\n    border-radius: 0;\n\tposition:relative;\n    margin: 50px 50px 30px;\n\t@include respond('laptop') {\n\t\t margin: 50px 25px 30px;\n\t}\n\t@include respond('phone') {\n\t\t margin: 20px 25px 30px;\n\t}\n\t\n\tp{\n\t\tfont-size:16px;\n\t\tline-height:1.4;\n\t\tfont-weight:300;\n\t\tcolor:#fff;\n\t}\n\t&:after{\n\t\tposition:absolute;\n\t\tbackground-image:url('../images/dots.svg');\n\t\tbackground-repeat:no-repeat;\n\t\tbottom:10px;\n\t\tright:20px;\n\t\tcontent:\"\";\n\t\theight:30px;\n\t\twidth:25px;\n\t}\n}\n\n.donut-chart-sale {\n\tposition:relative;\n\tsmall {\n\t\tfont-size: 16px;\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\ttop: 0;\n\t\tjustify-content: center;\n\t\tfont-weight: 600;\n\t}\n}\n .profile-bx{\n\t.profile-image{\n\t\tbackground-image:url('../images/circle.png');\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: contain;\n\t\tbackground-position: center;\n\t\timg{\n\t\t\tmargin: 18px;\n\t\t\twidth: 118px;\n\t\t}\n\t}\n }\n \n //search-area\n .search-area{\n\twidth: 300px;\n\t.form-control{\n\t\tbackground:#EFEFEF!important;\n\t\tborder-width:0px;\n\t\tpadding-left: 20px;\n\t\tmin-height: 55px;\n\t\tborder-radius:0;\n\t\tborder-top-left-radius: 60px;\n\t\tborder-bottom-left-radius: 60px;\n\t\t&::placeholder{\n\t\t\tcolor:#757575;\n\t\t}\n\t}\n\t.input-group-text{\n\t\tbackground:#EFEFEF;\n\t\tborder-width:0px;\n\t\tborder-top-right-radius: 60px;\n\t\tborder-bottom-right-radius: 60px;\n\t\tpadding-left: 0;\t\t\n\t\tpadding-right: 20px;\n\t\ti{\n\t\t\tfont-size:25px;\n\t\t}\n\t\t\n\t}\n\t@include respond('laptop'){\n\t\t.form-control{\n\t\t\tmin-height:45px;\n\t\t}\n\t\t.input-group-text i{\n\t\t\tfont-size:18px;\n\t\t}\n\t}\n\t@include respond('tab-port'){\n\t\twidth:200px;\n\t}\n }\n \n //donut chart\n .donut-chart-sale{\n\tz-index: 1;\n\t.circle {\n\t\theight: 50px;\n\t\twidth: 50px;\n\t\tz-index: -1;\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tborder-radius: 100%;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t}\n\tsmall {\n\t\tfont-size: 14px;\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\ttop: 0;\n\t\tjustify-content: center;\n\t\tfont-weight: 600;\n\t}\t\n}\n \n .min-w24{\n\tmin-width:24px;\n } .min-w30{\n\tmin-width:30px;\n }\n .min-w32{\n\tmin-width:32px;\n }\n .min-w42{\n\tmin-width:42px;\n }\n .min-w46{\n\tmin-width:46px;\n }\n .min-w50{\n\tmin-width:50px;\n }\n.line-chart-demo{\n\n} \n\n.form-group.style-1{\n\t.form-control{\n\t\tborder-color:transparent;\n\t\tmargin-right: -45px;\n\t\tz-index: 0;\n\t\tcolor:$black;\n\t\tbackground:#F0F0F0;\n\t\tborder-radius:$radius;\n\t}\n}\n\n.previous-transactions{\n\ttbody{\n\t\ttr{\n\t\t\ttd:first-child{\n\t\t\t\twidth:100px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n//star rating\n.rating-widget .rating-stars ul li i {\n    font-size: 25px !important;\n}\n\n\n//border-card\n.border-card{\n\th2{\n\t\tfont-size:54px;\n\t\t@include respond ('tab-land'){\n\t\t\tfont-size:42px;\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\tfont-size:35px;\n\t\t}\n\t}\n\t.position{\n\t\tfont-size:18px;\n\t\t@include respond ('tab-land'){\n\t\t\tfont-size:14px;\n\t\t}\n\t}\n\t.cd-icon{\n\t\theight:70px;\n\t\twidth:70px;\n\t\tline-height:70px;\n\t\tmin-width:70px;\n\t\ttext-align:center;\n\t\tborder-radius:$radius;\n\t\t@include respond ('tab-land'){\n\t\t\theight: 50px;\n\t\t\twidth: 50px;\n\t\t\tmin-height:50px;\n\t\t\tline-height: 46px;\n\t\t\tmin-width: 50px;\n\t\t\tsvg{\n\t\t\t\twidth: 25px;\n\t\t\t\theight:25px;\n\t\t\t}\n\t\t}\n\t}\n\t.line{\n\t\theight:4px;\n\t\tborder-radius:$radius;\n\t\twidth:95%;\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t}\n}\n\n\n.heart {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n    background: url('../images/like.png');\n    cursor: pointer;\n    margin: -25px -15px;\n}\n.heart-blast {\n    background-position: -1680px 0;\n    transition: background 1s steps(28);\n}\n\n\n.profile-bx{\n\t@include respond ('tab-land'){\n\t\tborder-right:1px solid $border-color;\n\t}\n\t@include respond ('phone-land'){\n\t\tborder-right: 0;\n\t}\n}","/*\n===================================\n    Product detail\n===================================*/\n\n.produtct-detail-tag {\n    display: inline-block;\n    a {\n        font-style: 13px;\n        color: $dark;\n    }\n}\n\n.product-detail-content {\n    .item-tag {\n        background: $l-ctl;\n        border-radius: 6px;\n        display: inline-block;\n        font-size: 12px;\n        margin-right: 4px;\n        padding: 2px 12px;\n        color: #fff;\n    }\n}\n\n.filtaring-area {\n    h4 {\n        color: #1d1d1d;\n        font-size: 16px;\n        font-weight: 400;\n        text-transform: lowercase;\n    }\n}\n\n.plus-minus-input {\n    .input-icon {\n        font-size: 13px;\n        color: $dark;\n    }\n}\n\n.plus-minus-input {\n    display: flex;\n    width: 120px;\n    .custom-btn {\n        border-radius: 0;\n        height: 40px;\n        padding: 12px 8px;\n        background: $white;\n        border: 1px solid $border;\n    }\n    .form-control {\n        &:hover,\n        &:focus,\n        &:active {\n            border: 1px solid $border;\n        }\n    }\n}\n.btn-reveal-trigger .avatar-xl {\n    min-width: 30px;\n}\n.share-view {\n    display: inline-block;\n    ul {\n        li {\n            display: inline-block;\n            a {}\n        }\n    }\n    .share-icon {\n        width: 40px;\n        height: 40px;\n        display: inline-block;\n        border: 1px solid $border;\n        text-align: center;\n        line-height: 40px;\n        font-style: 16px;\n        color: $border;\n        margin-right: 8px;\n    }\n}\n\n\n/*--------tab----------*/\n\n.veritical-line {\n    padding: 20px 30px;\n    border-top: 1px solid $border;\n    border-right: 1px solid $border;\n    border-bottom: 1px solid $border;\n    position: relative;\n    &:before {\n        background: $border;\n        bottom: 0;\n        content: \"\";\n        height: 100%;\n        left: -1px;\n        max-height: 40%;\n        position: absolute;\n        width: 1px;\n    }\n}\n\n.tab-content-text {\n    p {\n        color: $dark;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 24px;\n        margin-bottom: 25px;\n    }\n}\n\n.tab-item-list {\n    li {\n        a {\n            background: $white;\n            border-top: 1px solid $border;\n            border-left: 1px solid $border;\n            border-right: 1px solid $border;\n            color: $dark;\n            display: block;\n            font-size: 16px;\n            padding: 16px;\n            text-transform: uppercase;\n            &:hover,\n            &:focus {\n                background: $white;\n                color: $dark;\n                border-right: 0px;\n            }\n        }\n        &:last-child {\n            border-bottom: 1px solid $border;\n        }\n    }\n}\n\n.tab-list {\n    li {\n        margin-bottom: 7px;\n        font-size: 13px;\n        i {\n            font-size: 13px;\n            margin-right: 14px;\n        }\n    }\n}\n\n.slide-item-list {\n    text-align: center;\n\tmargin: 0 -5px;\n\t\n    li {\n        display: inline-block;\n\t\tflex: 0 0 25%;\n\t\twidth: 25%;\n\t\tpadding: 0 5px;\n\t\t\n        a {\n            display: inline-block;\n            //      float: left;\n            padding-left: 0;\n            padding-right: 0;\n            padding-top: 0;\n            background: transparent;\n            padding-bottom: 0px;\n            &:hover,\n            &:focus {\n                background: transparent;\n            }\n            img {\n                width: 100%;\n            }\n        }\n    }\n}\n\n.product-detail-text {\n    padding-top: 28px;\n    padding-left: 30px;\n    padding-right: 30px;\n    padding-bottom: 70px;\n}\n\n.star-rating {\n    .product-review {\n        font-style: 13px;\n        color: $dark;\n        font-weight: 400;\n        text-decoration: underline !important;\n    }\n}\n\n.product-detail {\n    .tab-content {\n        img {\n            display: inline-block;\n            width: 100%;\n        }\n    }\n}\n\n.popular-tag ul {\n    margin: 0px;\n    padding: 0px;\n    li {\n        display: inline-block;\n        padding: 8px 15px;\n        background: #f8f8f8;\n        font-size: 13px;\n        color: #fff;\n        margin-right: 10px;\n        margin-bottom: 10px;\n    }\n}\n\n.size-filter ul li {\n    display: inline-block;\n}\n\n.intro {\n    border: 1px solid red;\n    color: #1d1d1d;\n}\n\n#listResults {\n    .slider {\n        margin: 25px 0;\n    }\n    .slider-box {\n        width: 90%;\n        margin: 25px auto;\n    }\n    input {\n        width: 10%;\n    }\n    label {\n        border: none;\n        display: inline-block;\n        margin-right: -4px;\n        vertical-align: top;\n        width: 30%;\n    }\n}\n\n// input {\n//     border: none;\n//     display: inline-block;\n//     margin-right: -4px;\n//     vertical-align: top;\n//     width: 30%;\n// }\n.plus-minus-input {\n    .input-icon {\n        font-size: 13px;\n        color: #aaaaaa;\n    }\n    .custom-btn {\n        border-radius: 0;\n        height: 40px;\n        padding: 8px 12px;\n        background: #ffffff;\n        border: 1px solid #c8c8c8;\n        &:hover,\n        &:focus,\n        &.active {\n            box-shadow: none;\n            outline: none;\n        }\n    }\n    .form-control {\n        height: 40px;\n        border-top: 1px solid #c8c8c8;\n        border-bottom: 1px solid #c8c8c8;\n        border-left: 0px solid #c8c8c8;\n        border-right: 1px solid #c8c8c8;\n        &:hover,\n        &:focus,\n        &:active {\n            border-top: 1px solid #c8c8c8;\n            border-bottom: 1px solid #c8c8c8;\n            border-left: 0px solid #c8c8c8;\n            border-right: 0px solid #c8c8c8;\n        }\n    }\n}",".new-arrival-product{\n\t.new-arrivals-img-contnent{\n\t\toverflow:hidden;\n\t\t\n\t\timg{\n\t\t\twidth:100%;\n\t\t\t@include transitionMedium;\n\t\t}\n\t}\n\t&:hover .new-arrivals-img-contnent img{\n\t\ttransform: scale(1.5) translateY(12%);\n\t\t-moz-transform: scale(1.5) translateY(12%);\n\t\t-webkit-transform: scale(1.5) translateY(12%);\n\t\t-ms-transform: scale(1.5) translateY(12%);\n\t\t-o-transform: scale(1.5) translateY(12%);\n\t}\n}","/*\n===================================\n    list view\n===================================*/\n\n.new-arrival-content {\n    .item {\n        font-size: 12px;\n        color: $dark;\n    }\n    h4 {\n        font-size: 16px;\n        font-weight: 600;\n        margin-bottom: 10px;\n\t\ta{\n\t\t\tcolor:$black;\n\t\t}\n    }\n    .price {\n        font-weight: 600;\n\t\tcolor: $primary;\n\t\tfont-size: 24px;\n\t\tmargin-bottom: 0;\n\t\tfloat: right;\n\t\t@include respond ('phone'){\n\t\t\tfloat:none;\n\t\t\tmargin-top:10px;\n\t\t}\n    }\n    p {\n        font-size: 14px;\n        color: $d-ctl;\n        margin-bottom: 6px;\n        line-height: 24px;\n    }\n    .text-content {\n        margin-top: 18px;\n    }\n}\n.new-arrival-content.text-center .price {\n\tfloat: unset;\n}\n\n.success-icon {\n    color: $success;\n    font-size: 16px;\n}\n\n.comment-review {\n    margin-bottom: 15px;\n    display: table;\n    width: 100%;\n    .client-review {\n        color: $d-ctl;\n        padding-right: 20px;\n        text-decoration: underline !important;\n        font-size: 14px;\n    }\n    .span {\n        color: $d-ctl;\n        font-size: 14px;\n    }\n\t@include respond ('phone'){\n\t\tmargin-bottom:0;\n\t}\n}\n\n.star-rating li {\n    display: inline-block;\n    i {\n        color: gold;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
